webpackJsonp([1],{

/***/ "+9Dv":
/***/ (function(module, exports, __webpack_require__) {

var BillingMixins = __webpack_require__("uUaF");
var BackendController = __webpack_require__("QI8C");
var Buf = __webpack_require__("t9zO");
var BufferList = __webpack_require__("o4N7");
var PinnedBufferList = __webpack_require__("xUqH");
var Connection = __webpack_require__("LLdI");
var ConnectionList = __webpack_require__("8Gq8");
var OrgList = __webpack_require__("N7yu");
var FileList = __webpack_require__("66sV");
var PastebinList = __webpack_require__("ZRaQ");
var User = __webpack_require__("Xgjh");
var ViewState = __webpack_require__("rEXR");
var perf = __webpack_require__("fJd+");


var Session = Backbone.Model.extend($.extend(true, {}, BillingMixins, {
    hardZombie: null,
    softZombie: null,
    prefs: {},
    plans: {},
    timing: {},
    postMessages: [],
    streamConnected: false,
    initialize: function () {
        _.bindAll(this, 'addNetwork');
        
        this.session = this;
        
        this.bind('change:prefs', this.parsePrefs, this);
        this.bind('change:verified', this.setUser, this);
        this.bind('change:name', this.setUser, this);
        this.bind('change:email', this.setUser, this);
        this.bind('change:avatar', this.setUser, this);
        this.bind('change:avatar_url', this.setUser, this);
        this.bind('change:orgs', this.processOrgs, this);
        
        this.supported = true;
        this.backend = new BackendController(this);
        this.backend.bind('streamAuthError', this.doLogout, this);
        this.backend.bind('setShard', this.setShard, this);
        this.backend.bind('unsupported', this.unsupported, this);
        this.backend.bind('xhrFallback', this.setXhrFallback, this);
        
        this.backend.bind('oobLoading', function sessionOOBLoading () {
            var key = 'oob' + (this.isInitialized() ? 'Re' : '') + 'Load';
            debug.timeStamp(key);
            perf.mark(key);
        }, this);
        this.backend.bind('oobFailed', function sessionOOBFailed () {
            // Just clear the key
            var key = 'oob' + (this.isInitialized() ? 'Re' : '') + 'Load';
            perf.clear(key);
        }, this);
        this.backend.bind('oobLoaded', function sessionOOBLoaded (messages) {
            var prefix = this.isInitialized() ? 'Re' : '';
            var key = 'oob' + prefix + 'Load';
            var m = this.perfMeasure(key, null, {
                messages: messages.length
            });
            debug.log(key, m + 'ms');
            key = 'oob' + prefix + 'Process';
            debug.timeStamp(key);
            // debug.profile();
            perf.mark(key);
        }, this);
        this.bind('doneLoading', function sessionDoneLoading (inited) {
            var key = 'oob' + (inited ? 'Re' : '') + 'Process';
            var m = this.perfMeasure(key, null, {
                buffers: this.buffers.length
            });
            debug.log(key, m + 'ms');
            // debug.profileEnd();
            debug.timeStamp('backlog_complete');
        }, this);
        
        this.backend.bind('message', function sessionBackendMessage (message) {
            if (message.type && this.messageHandlers[message.type]) {
                this.messageHandlers[message.type].call(this, message);
            }
            if (message.cid) {
                this.trigger('connectionMessage:' + message.cid, message);
            }
            if (message.eid) {
                this.backend.setMaxEid(message.eid, this.isInitialized());
            }
        }, this);
        this.backend.bind('response', function sessionBackendResponse (response, reqest) {
            if (response.cid) {
                this.trigger('connectionResponse:' + response.cid, response, reqest);
            }
        }, this);
        this.backend.bind('connected', this.connected, this);
        this.backend.bind('offline', this.disconnected, this);
        this.backend.bind('streamError', this.disconnected, this);
        this.backend.bind('disconnect', this.disconnected, this);
        this.backend.bind('stream:stopped', this.disconnected, this);

        this.viewState = new ViewState(null, {
            session: this
        });
        
        this.orgs = new OrgList();
        this.orgs.on('change', this.orgsChange, this);
        this.orgs.on('remove', this.orgRemoved, this);
        
        this.files = new FileList(null, {
            session: this
        });
        this.pastebins = new PastebinList(null, {
            session: this
        });

        this.connections = new ConnectionList(null, {
            session: this
        });
        this.connections.bind('add', this.onAddConnection, this);
        this.connections.bind('remove', this.onRemoveConnection, this);
        this.connections.bind('urlPropChange', this.onChangeConnectionUrlProp, this);
        
        // Fuzzy connection map that will allow us to find a result for
        // connections supplied without disambiguation or port
        this.connectionIds = {};
        
        this.buffers = new BufferList();
        this.buffers.bind('change:last_seen_eid', this.updateSeenEidState, this);
        
        this.pinnedBuffers = new PinnedBufferList();

        this.unseenBuffers = new BufferList();
        this.buffers.bind('unseenChange unseenHighlightChange prefChange:disableTrackUnread', function (buffer) {
            if (buffer.hasUnseen() && (buffer.isTrackingUnread() || buffer.hasUnseenHighlights())) {
                this.unseenBuffers.add(buffer, {silent: true});
            } else {
                this.unseenBuffers.remove(buffer, {silent: true});
            }
            this.trigger('unseenChange');
        }, this);
        this.buffers.bind('remove', function (buffer) {
            buffer.stopListening();
            this.unseenBuffers.remove(buffer, {silent: true});
            this.trigger('unseenChange');
        }, this);
        
        this.previousBuffer = null;
        this.currentBuffer = null;
        
        this.focused = false;
        
        this.initialized = null;
        this.loading = null;
        this.backlogComplete = null;
        this.statUser = null;
    },
    perfMeasure: function (name, key, metadata, m) {
        m = m || perf.measure(name);
        var vals;
        var initial = metadata ? {vals: []} : [];
        if (key) {
            if (!this.timing[name]) {
                this.timing[name] = {};
            }
            if (!this.timing[name][key]) {
                this.timing[name][key] = initial;
            }
            vals = this.timing[name][key];
        } else {
            if (!this.timing[name]) {
                this.timing[name] = initial;
            }
            vals = this.timing[name];
        }
        if (metadata) {
            vals.vals.push(m);
            for (var k in metadata) {
                if (!vals[k]) {
                    vals[k] = [];
                }
                vals[k].push(metadata[k]);
            }
        } else {
            vals.push(m);
        }
        return m;
    },
    initiTimingStats: function () {
        if ('performance' in window) {
            if ('timing' in window.performance) {
                this.timing.timing = {
                    dns: window.performance.timing.domainLookupEnd - window.performance.timing.domainLookupStart,
                    connect: window.performance.timing.requestStart - window.performance.timing.connectStart,
                    response: window.performance.timing.responseEnd - window.performance.timing.requestStart,
                    dom: window.performance.timing.loadEventStart - window.performance.timing.domLoading,
                    setup: Date.now() - window.performance.timing.loadEventStart
                };
            }
            if ('navigation' in window.performance) {
                this.timing.navigation = {
                    redir: window.performance.navigation.redirectCount,
                    type: window.performance.navigation.type
                };
            }
        }
    },
    startClientStats: function () {
        this.perfEpoch = perf.ts();
        var initialWait = 5*60*1000;
        var interval = 30*60*1000;
        this.initiTimingStats();
        setTimeout(_.bind(function () {
            this.reportClientStats();
            this.reportClientStatsInterval = setInterval(_.bind(this.reportClientStats, this), interval);
        }, this), initialWait);
    },
    reportClientStats: function () {
        if ('performance' in window && 'memory' in window.performance) {
            this.timing.memory = _.clone(window.performance.memory);
            this.timing.memory.time = this.perfTs();
            var lastMemory = _.clone(this.timing.memory);
            if (this.lastMemory) {
                this.timing.memoryDelta = {};
                for (var k in this.lastMemory) {
                    this.timing.memoryDelta[k] = this.timing.memory[k] - this.lastMemory[k];
                }
            }
            this.lastMemory = lastMemory;
        }
        if (_.size(this.timing)) {
            var json = JSON.stringify(this.timing);
            if (this.featureCheck('clientStats')) {
                this.post("client-stats", {
                    ua: window.navigator.userAgent,
                    data: json
                });
            }
            this.timing = {};
        }
    },
    perfTs: function () {
        return perf.ts() - this.perfEpoch;
    },
    perfTime: function (name, key) {
        var vals = key ? this.timing[name][key] : this.timing[name];
        vals = vals.vals || vals;
        var sum = _.reduce(vals, function (memo, num) {
            return memo + num;
        }, 0);
        return sum / vals.length;
    },
    perfData: function (name, key, dataKey) {
        var vals = key ? this.timing[name][key] : this.timing[name];
        if (dataKey) {
            return vals[dataKey];
        } else {
            return vals;
        }
    },
    ent: function (prop) {
        if (window.Enterprise) {
            if (prop) {
                return window.Enterprise[prop];
            }
            return true;
        }
    },
    hasAutojoin: function () {
        if (!this.ent()) {
            return false;
        }
        if (this.get('autojoin_prattle') || this.get('autojoin_custom')) {
            return true;
        }
        return false;
    },
    getUser: function () {
        return this.user;
    },
    getAvatars: function (current) {
        var avatars = [];
        var avatars_seen = {};
        this.connections.each(function (c) {
            var a = c.getUser().getAvatar({strict: true});
            if (a && !a.external) {
                var seenIndex = avatars_seen[a.id];
                if (seenIndex !== undefined) {
                    avatars[seenIndex].connections.push(c);
                } else {
                    avatars_seen[a.id] = avatars.length;
                    avatars.push({
                        id: a.id,
                        template: a.src,
                        connections: [c]
                    });
                }
            }
        });
        // Add primary to the front of the list, but retain existing connections if shared
        var primary = this.getUser().getAvatar();
        if (primary) {
            var primary_a = {
                id: primary.id,
                template: primary.src,
                connections: []
            };
            if (avatars_seen[primary.id] !== undefined) {
                primary_a = avatars.splice(avatars_seen[primary.id], 1)[0];
            }
            primary_a.primary = true;
            avatars.unshift(primary_a);
        }
        // Move cid to the start
        if (current) {
            var idx = _.findIndex(avatars, function (a) {
                return a.id === current;
            });
            
            if (idx !== -1) {
                var currentA = avatars.splice(idx, 1)[0];
                avatars.unshift(currentA);
            }
        }
        return avatars;
    },
    getNick: function () {
        if (this.hasConnections()) {
            if (this.currentBuffer) {
                return this.currentBuffer.getNick();
            } else if (this.previousBuffer) {
                return this.previousBuffer.getNick();
            } else {
                return this.connections.at(0).getNick();
            }
        } else {
            if (this.get('name')) {
                return this.get('name').split(' ')[0].toLowerCase();
            } else {
                return this.get('email').split('@')[0].toLowerCase();
            }
        }
    },
    isSSBFluid: function () {
        return !!window.fluid;
    },
    isDesktop: function () {
        return !!window.IRCCLOUD_DESKTOP_VERSION || !!window.IRCCLOUD_ELECTRON;
    },
    isFocused: function () {
        return this.focused;
    },
    setFocused: function (value) {
        this.focused = value;
        this.trigger('focusChange');
    },
    tempPostMessageWhitelist: {},
    tempPostMessageWhitelistId: 1,
    postMessageTempWhitelist: function (whitelistOrigin) {
        var tempId = this.tempPostMessageWhitelistId++;
        this.tempPostMessageWhitelist[tempId] = whitelistOrigin;
        return tempId;
    },
    cleanMessageTempWhitelist: function (whitelistOriginId) {
        if (whitelistOriginId) {
            delete this.tempPostMessageWhitelist[whitelistOriginId];
        }
    },
    addPostMessage: function (event) {
        var whitelist = [
            this.getOrigin(),
            window.API_HOST,
            'https://www.instagram.com',
            'https://imgur.com',
            'https://platform.twitter.com',
            'https://gfycat.com',
            'https://embed.reddit.com',
            'https://embed.bsky.app'
        ].concat(Object.values(this.tempPostMessageWhitelist));
        if (!_.contains(whitelist, event.origin)) {
            return;
        }
        // Skip certain events we don't care about
        if (
            event.origin === 'https://platform.twitter.com' &&
            _.isString(event.data) &&
            event.data.indexOf('{"settings":') === 0
        ) {
            return;
        }
        this.postMessages.push(event);
        this.trigger('postMessage', event);
    },
    findMessage: function (filter, timeout, whitelistOriginId) {
        var complete = $.Deferred();
        var m = this._findMessage(filter);
        var cleanup;
        if (m) {
            complete.resolve(m);
            this.cleanMessageTempWhitelist(whitelistOriginId);
        } else {
            var onPostMessage = _.bind(function () {
                var m = this._findMessage(filter);
                if (m) {
                    complete.resolve(m);
                }
            }, this);
            cleanup = _.bind(function () {
                this.unbind('postMessage', onPostMessage);
                this.cleanMessageTempWhitelist(whitelistOriginId);
            }, this);
            complete.always(cleanup);
            this.bind('postMessage', onPostMessage);
            if (timeout) {
                setTimeout(_.bind(function () {
                    complete.reject();
                }, this), timeout);
            }
        }
        var promise = complete.promise();
        promise.cleanup = cleanup;
        return complete.promise();
    },
    _findMessage: function (filter) {
        var match;
        var toDelete = [];
        _.find(this.postMessages, function (m, i) {
            var ret = filter(m);
            if (ret) {
                match = (ret === true) ? m : ret;
                toDelete.push(i);
                return true;
            }
            if (ret === null) {
                toDelete.push(i);
            }
            return false;
        }, this);
        _.each(toDelete, function (i, ii) {
            this.postMessages.splice(i - ii, 1);
        }, this);
        return match;
    },
    getLastSelectedBuffer: function () {
        return this.buffers.get(this.get('last_selected_bid'));
    },
    selectPreviousBuffer: function (options) {
        if (this.previousBuffer) {
            this.previousBuffer.select(options);
            return true;
        }
        return false;
    },
    markAllAsRead: function () {
        this.buffers.invoke('read');
    },
    clearCurrentBuffer: function (silent) {
        this.setCurrentBuffer(null, {
            silent: silent,
            cleared: true
        });
    },
    setThreadId: function (threadId, options) {
        options = options || {};
        this.threadId = threadId;
        if (!options.silent) {
            this.trigger('threadChange');
        }
    },
    clearThreadId: function () {
        this.setThreadId(null);
    },
    setCurrentBuffer: function (buffer, options) {
        options = options || {};
        if (this.currentBuffer != buffer) {
            this.previousBuffer = this.currentBuffer;
            
            if (this.previousBuffer) {
                this.previousBuffer.deselect();
            }
            
            if (buffer) {
                this.currentBuffer = buffer;
                this.set({'last_selected_bid': this.currentBuffer.bid()});
            } else {
                this.currentBuffer = null;
            }
            
            if (!options.silent) {
                this.trigger('currentBufferChange', {
                    cleared: options.cleared,
                    replace: options.replace
                });
            }
        }
    },
    updateSeenEidState: function (buffer) {
        this.viewState.updateSeenEid(buffer);
    },
    bufferSelectedChange: function (buffer, options) {
        this.setCurrentBuffer(buffer, options);
    },
    addBuffer: function (buffer) {
        if (this.isReloading()) {
            delete this.buffersToDeactivate[buffer.bid()];
        }
        
        this.buffers.add(buffer);
        buffer.connection.buffers.bind('remove', function (buf) {
            if (buf == buffer) {
                if (this.previousBuffer == buffer) {
                    this.previousBuffer = null;
                }
                this.buffers.remove(buffer);
                this.pinnedBuffers.unpin(buffer);
            }
        }, this);
        // Remove when connection is removed
        buffer.connection.bind('remove', function () {
            if (this.previousBuffer == buffer) {
                this.previousBuffer = null;
            }
            this.buffers.remove(buffer);
            this.pinnedBuffers.unpin(buffer);
        }, this);
    },
    getConnectionById: function (connectionId) {
        return this.connectionIds[connectionId.toLowerCase()];
    },
    setConnectionIds: function (connection) {
        // Disambiguate
        var disambiguation = 0;
        while (this.connectionIds[connection.testId(disambiguation)]) {
            disambiguation++;
        }
        connection.setDisambiguation(disambiguation);
        
        // Set some fuzzy shortcuts
        var keys = connection.getIdKeys();
        _.each(keys, function (key, i) {
            // Only if this shortcut isn't already taken
            if (!this.connectionIds[key]) {
                this.connectionIds[key] = connection;
            }
        }, this);
        if (connection.isSelected()) {
            this.trigger('currentConnectionUrlChange');
        }
    },
    removeConnectionIds: function (connection) {
        // Remove fuzzy shortcuts
        for (var key in this.connectionIds) {
            if (this.connectionIds[key] == connection) {
                delete this.connectionIds[key];
            }
        }
    },
    onAddConnection: function (connection) {
        // Bind message events by cid
        connection.bindMessages();

        // Maintain separate this.buffers list
        connection.buffers.bind('add', this.addBuffer, this);
        this.setConnectionIds(connection);
    },
    onRemoveConnection: function (connection) {
        this.removeConnectionIds(connection);
    },
    onChangeConnectionUrlProp: function (connection) {
        this.removeConnectionIds(connection);
        this.setConnectionIds(connection);
    },
    isLoading: function () {
        return this.loading;
    },
    numActiveConnections: function () {
        return this.connections.filter(function (c) {
            if (!c.isWhitelisted() && c.isActive()) {
                return true;
            }
        }).length;
    },
    clearFocusOnMakes: function () {
        this.connections.each(function (c) {
            c.setFocusOnMakeBuffer(null);
        });
        this.setFocusOnMakeServer(null);
    },
    setFocusOnMakeServer: function (cid) {
        this.focusOnMakeServer = cid;
        var connection = this.getConnection(cid);
        if (connection) {
            this.checkFocusOnMakeServer(connection);
        }
    },
    checkFocusOnMakeServer: function (connection) {
        if (this.focusOnMakeServer == connection.getCid()) {
            this.setFocusOnMakeServer(null);
            connection.setFocusOnMakeBuffer('*');
        }
    },
    addConnection: function (data) {
        var connection = new Connection(data, {
            session: this
        });
        this.connections.add(connection);
        return connection;
    },
    logout: function () {
        this.loggingOut = true;
        var form = $('<form action="" method="post">').attr('action', this.backend.buildUrl("/logout"));
        form.append($('<input type="hidden">').attr({
            name: 'session',
            value: this.getAuthCookie()
        }));
        $('body').append(form);
        form.submit();
    },
    messageHandlers: {
        global_system_message: function (message) {
            if (this.isBacklogLoaded()) {
                if (message.system_message_type == 'eval') {
                    eval(message.msg);
                } else {
                    this.trigger('systemMessage', message);
                }
            }
        },
        database_status: function (message) {
            this.set('database_status', message.status);
        },
        // Happens on logout in another tab
        session_deleted: function (message) {
            if (!this.loggingOut) {
                this.doLogout();
            }
        },
        // Can happen if we have too many streams open and the server
        // wants us to disconnect without auto-retrying
        shutdown: function (message) {
            debug.info("Server told us to shutdown: " + message.msg);
            this.stopBackend();
        },
        stat_user: function (message) {
            this.set(message);
            this.trigger('stat');
            if (this.backlogComplete && !this.statUser) {
                // Only happens the first time, if stat_user arrives after backlog_complete
                this.init();
            }

            if (this.postStatUrl) {
                this.trigger('navigate', this.postStatUrl);
                this.postStatUrl = null;
            }
            this.statUser = true;
        },
        num_invites: function (message) {
            this.set({num_invites: message.num_invites});
        },
        sys_msgs: function (message) {
            this.setZombie(message);
        },
        heartbeat_echo: function (message) {
            var cid, bid, connection, buffer;
            var seenEids = message.seenEids;
            // Update seenEids
            for (cid in seenEids) {
                connection = this.getConnection(cid);
                if (!connection) {
                    // Connection may have been deleted
                    continue;
                }
                for (bid in seenEids[cid]) {
                    buffer = connection.getBuffer(bid);
                    if (!buffer) {
                        // Buffer may have been deleted
                        continue;
                    }
                    if (buffer.isMessageUnseen(seenEids[cid][bid])) {
                        buffer.setLastSeen(seenEids[cid][bid]);
                    }
                }
            }
        },
        makeserver: function (message) {
            var connection = this.getConnection(message.cid);
            if (connection) {
                connection.reload(message);
            } else {
                connection = this.addConnection(message);
                this.checkFocusOnMakeServer(connection);
            }
            // Track recreated/active servers, so we can delete/deactivate remainders after the backlog completes
            if (this.isReloading()) {
                delete this.connectionsToDelete[connection.getCid()];
            }
        },
        makebuffer: function (message) {
            // Track recreated buffers, so we can delete remainders after the backlog completes
            if (this.isReloading() && this.buffersToDelete[message.cid]) {
                delete this.buffersToDelete[message.cid][message.bid];
            }
        },
        connection_deleted: function (message) {
            this.removeConnection(message.cid);
        },
        reorder_connections: function (message) {
            this.connections.orderChanged(message.order);
        },
        export_finished: function (message) {
            this.trigger('exportFinished', message);
        },
        backlog_complete: function (message) {
            var inited = this.isInitialized();
            if (inited) {
                // Happens every subsequent time a stream reconnects
                // only diff/remove buffers if we got an entirely fresh
                // set of backlog (not if we resumed via streamid)
                if (!message.resumed) {
                    this.updateRemainderBufferState();
                }
            } else {
                // Only happens the first time
                if (this.statUser && !this.backlogComplete) {
                    this.init();
                    // Start heartbeat and client stats
                    this.viewState.startHeartbeat();
                    this.startClientStats();
                }
                this.backlogComplete = true;
            }
            this.loading = false;
            this.trigger('doneLoading', inited);
        }
    },
    getStreamId: function () {
        return this.backend.streamId;
    },
    init: function () {
        this.setRavenContext();
        this.initialized = true;
        if (!this.ent()) {
            this.getPlans();
        }
        this.pinnedBuffers.onChange();
        this.bind('prefChange:pinnedBuffers', this.onPinnedBufferChange, this);
        this.trigger('init');
    },
    setRavenContext: function () {
        if (!this.ent() && window._Raven) {
            window._Raven.ready('setUserContext', [{
                email: this.get('email'),
                id: this.id
            }]);
        }
    },
    removeConnection: function (cid) {
        var connection = this.getConnection(cid);
        // We can get these again in the case of resuming a buffer after no message
        // has arrived after it to bump the since_id past it.
        if (connection) {
            connection.set({removing: true}, {silent: true});
            connection.removeChildren();
            this.trigger('beforeConnectionRemove', connection);
            this.connections.remove(cid);
            connection.stopListening();
        }
    },
    getConnection: function (cid) {
        return this.connections.get(cid);
    },
    findOrgConn: function (orgId) {
        return this.connections.find(function (c) {
            return c.get('orgid') == orgId && !c.get('removing');
        });
    },
    findTeamConn: function (orgId) {
        return this.connections.find(function (c) {
            return c.get('team_server') === true && !c.get('removing');
        });
    },
    findMatchingConnections: function (hostname) {
        return this.connections.filter(function (c) {
            return c.getHostname() == hostname.toLowerCase() && !c.get('removing');
        });
    },
    isInitialized: function () {
        return !!this.initialized;
    },
    isDbDown: function () {
        return this.get('database_status') == 'down';
    },
    setXhrFallback: function () {
        this.xhrFallback = true;
    },
    isXhrFallback: function () {
        return !!this.xhrFallback;
    },
    isBacklogLoaded: function () {
        return this.isInitialized() && !this.isLoading();
    },
    isReloading: function () {
        return this.isInitialized() && this.isLoading();
    },
    connected: function () {
        this.loading = true;
        if (this.isInitialized()) {
            this.trackBufferState();
        }
        this.setStreamConnected(true);
    },
    disconnected: function () {
        this.setStreamConnected(false);
    },
    setStreamConnected: function (value) {
        if (this.streamConnected != value) {
            this.streamConnected = value;
            this.trigger('streamConnectedChange');
        }
    },
    isStreamConnected: function () {
        return this.streamConnected;
    },
    trackBufferState: function () {
        // Start tracking the buffers that get created so we can delete any remainders
        // that might have been removed while we were disconnected from the sctream
        // this happens in updateRemainderBufferState at backlog_complete
        this.buffersToDelete = {};
        this.buffersToDeactivate = {};
        this.connectionsToDelete = {};
        this.connections.each(function (connection) {
            this.connectionsToDelete[connection.getCid()] = connection;
            this.buffersToDelete[connection.getCid()] = {};
            this.buffersToDeactivate[connection.getCid()] = {};
        }, this);
        this.buffers.each(function (buffer) {
            this.buffersToDelete[buffer.getCid()][buffer.bid()] = buffer;
            this.buffersToDeactivate[buffer.getCid()][buffer.bid()] = buffer;
        }, this);
    },
    updateRemainderBufferState: function () {
        // Connections/buffers have now had the chance to remove themselves from the
        // ToDelete/Deactivate lists, so we can process those now
        var cid, bid;
        for (cid in this.connectionsToDelete) {
            this.removeConnection(this.connectionsToDelete[cid]);
            // We won't need to deactivate this connection
            // or delete/deactivate its buffers
            delete this.buffersToDelete[cid];
            delete this.buffersToDeactivate[cid];
        }
        
        for (cid in this.buffersToDelete) {
            for (bid in this.buffersToDelete[cid]) {
                var connection = this.getConnection(cid);
                if (connection) {
                    connection.removeBuffer(bid);
                }
                // We won't need to deactivate this buffer
                if (this.buffersToDeactivate[cid]) {
                    delete this.buffersToDeactivate[cid][bid];
                }
            }
        }
        for (cid in this.buffersToDeactivate) {
            for (bid in this.buffersToDeactivate[cid][bid]) {
                this.buffersToDeactivate[cid][bid].deactivate();
            }
        }
    },
    doSetPinnedBuffer: function (buffer, enable, idx) {
        if (enable) {
            if (!this.isPinnedBuffer(buffer)) {
                buffer.trigger('beforePinnedChange', buffer);
                if (idx === undefined) {
                    this.pinnedBuffers.addAtEnd(buffer);
                } else {
                    this.pinnedBuffers.addAt(buffer, idx);
                }
                buffer.trigger('pinnedChange', buffer);
            }
        } else {
            if (this.isPinnedBuffer(buffer)) {
                buffer.trigger('beforePinnedChange', buffer);
                this.pinnedBuffers.unpin(buffer);
                buffer.trigger('pinnedChange', buffer);
            }
        }
    },
    setPinnedBuffer: function (buffer, enable) {
        this.doSetPinnedBuffer(buffer, enable);
        this.pinnedBuffers.onChange();
        this.setPref('pinnedBuffers', this.pinnedBuffers.bids());
    },
    onPinnedBufferChange: function () {
        var bids = this.getPref('pinnedBuffers') || [];
        this.resetPinnedBuffers(bids);

    },
    resetPinnedBuffers: function (bids) {
        var oldPinnedBuffers = this.pinnedBuffers.clone();
        oldPinnedBuffers.each(function (b) {
            var newIdx = _.indexOf(b.id, bids);
            if (newIdx !== b.pinned) {
                this.doSetPinnedBuffer(b, false);
            }
        }, this);
        _.each(bids, function (bid, idx) {
            var buffer = this.buffers.get(bid);
            if (buffer && !this.isPinnedBuffer(buffer)) {
                this.doSetPinnedBuffer(buffer, true, idx);
            }
        }, this);
        this.pinnedBuffers.onChange();
    },
    setPinnedOrder: function (bids) {
        this.setPref('pinnedBuffers', bids);
    },
    getPinnedIdx: function (bid) {
        return _.indexOf(this.getPref('pinnedBuffers') || [], bid);
    },
    addPinnedBuffer: function (buffer) {
        var pinnedIdx = this.getPinnedIdx(buffer.id);
        if (pinnedIdx !== -1) {
            this.pinnedBuffers.addAt(buffer, pinnedIdx);
        }
    },
    isPinnedBuffer: function (buffer) {
        return this.pinnedBuffers.isPinned(buffer);
    },
    isPinnedBufferAmbiguous: function (buffer) {
        if (this.isPinnedBuffer(buffer) && this.pinnedBuffers.isAmbiguous(buffer)) {
            return true;
        }
        return false;
    },
    hasPinnedBuffers: function () {
        return !this.pinnedBuffers.isEmpty();
    },
    
    getAuthCookie: function () {
        return this.getCookie('session');
    },
    getAuth: function () {
        return this.get('session');
    },
    getHighlights: function () {
        return this.get('highlights') || [];
    },
    unsupported: function () {
        this.supported = false;
        this.setStreamConnected(false);
    },
    isSupported: function () {
        return this.supported;
    },
    isAuthed: function () {
        return !!this.getAuth();
    },
    setUser: function () {
        this.user = new User({
            email: this.get('email'),
            realname: this.get('name'),
            avatar: this.get('avatar')
        }, {
            session: this
        });
    },
    
    // Cookie helpers
    setCookie: function (name, value, days, deleting) {
        var expires;
        if (days) {
            var date = new Date();
            var seconds = days*24*60*60;
            date.setTime(date.getTime() + (seconds*1000));
            expires = "; Expires=" + date.toGMTString() + '; Max-Age=' + seconds;
        } else {
            expires = "";
        }
        var cook = name + "=" + value + "; Version=1" + expires + "; Path=/";
        if (this.isSecure()) {
            cook += "; Secure";
        }
        cook += "; SameSite=Lax";
        var domain = this.getHost();
        var domainCook = cook + "; Domain=" + domain;
        if (deleting) {
            document.cookie = cook;
            var rootDomain = domain.split('.').slice(-2).join('.');
            if (rootDomain != domain) {
                var rootDomainCook = cook + "; Domain=" + rootDomain;
                document.cookie = rootDomainCook;
            }
        }
        document.cookie = domainCook;

    },
    getCookie: function (name) {
        var namekey = name + "=";
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length;i++) {
            var c = cookies[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(namekey) === 0) {
                return c.substring(namekey.length, c.length);
            }
        }
        return null;
    },
    deleteCookie: function (name) {
        this.setCookie(name, "", -1, true);
    },
    
    // Backend control
    startBackend: function () {
        this.backend.start();
    },
    stopBackend: function () {
        this.backend.stop();
    },
    doLogout: function () {
        this.loggingOut = true;
        this.deleteCookie('session');
        this.deleteCookie('invite');
        this.refresh();
    },
    noAuth: function () {
        if (window.IRCConfig.disable_signups) {
            this.doLogout();
        } else {
            this.deleteCookie('session');
            this.trigger('noAuth');
        }
    },
    setShard: function (message) {
        this.set({
            shard_id: message.shard_id,
            shard_name: message.shard_name
        });
        window.WS_SOCKET_HOST = message.websocket_host;
        window.WS_SOCKET_PATH = message.websocket_path;
        window.API_HOST = message.api_host;
        // Cookie is updated already by Set-Cookie header if not using a cross domain
        // web socket
        if (this.backend.isXDSocket()) {
            this.setAuthCookie(message.cookie);
        }
        this.startCookie();
    },
    
    // Host helpers
    getHost: function () {
        return window.location.hostname;
    },
    getLocation: function () {
        return window.location;
    },
    getOrigin: function () {
        return window.location.origin;
    },
    isSecure: function () {
        return window.location.protocol === 'https:';
    },
    redirect: function (url) {
        Backbone.history.stop();
        window.location = url;
        window.location.reload();
    },
    refresh: function () {
        Backbone.history.stop();
        if (/^\/((irc\/)|$)/.test(window.location.pathname)) {
            window.location.reload();
        } else {
            window.location.pathname = '/';
        }
    },
    
    processOrgs: function () {
        this.orgs.set(this.get('orgs'), {
            session: this,
            silent: true
        });
        this.orgs.invoke('parseConnections');
        this.orgsChange();
    },
    orgsChange: function () {
        this.trigger('orgsChange');
    },
    orgRemoved: function (org) {
        org.stopListening();
    },
    // Prefs
    parsePrefs: function () {
        var previousPrefs = $.extend(true, {}, this.prefs);
        this.prefs = {};
        if (this.get('prefs')) {
            try {
                // Extend this.prefs in place
                var prefs = JSON.parse(this.get('prefs'));
                $.extend(true, this.prefs, prefs);
            } catch (e) {
                debug.warn('invalid prefs blob', this.get('prefs'));
            }
        }
        var changes = {};
        for (var k in $.extend(true, {}, previousPrefs, this.prefs)) {
            if (!_.isEqual(this.prefs[k], previousPrefs[k])) {
                this.trigger('prefChange:' + k, previousPrefs[k]);
                changes[k] = previousPrefs[k];
            }
        }
        if (!$.isEmptyObject(changes)) {
            this.trigger('prefChange', changes);
        }
    },
    getPref: function (key, defaultValue) {
        return this.prefs[key] || defaultValue;
    },
    setPref: function (key, value) {
        var prefs;
        // Single arg means full pref object
        if (arguments.length === 2) {
            prefs = {};
            prefs[key] = value;
        } else {
            prefs = key;
        }
        var previousValue;
        var v;
        var newPrefs = $.extend(true, {}, this.prefs);
        for (var k in prefs) {
            v = prefs[k];
            previousValue = newPrefs[k];
            if (v) {
                if (!_.isEqual(v, previousValue)) {
                    newPrefs[k] = v;
                }
            } else {
                if (previousValue) {
                    delete newPrefs[k];
                }
            }
        }
        this.savePrefs(newPrefs);
    },
    savePrefs: function (prefs) {
        this.set({prefs: JSON.stringify(prefs)});
        this.post('set-prefs', {
            prefs: this.get('prefs')
        });
    },

    modifierMeEnabled: function () {
        return !this.getPref('keyboard-disable-modifier-me');
    },
    setModifierMe: function (value) {
        this.setPref('keyboard-disable-modifier-me', !value);
    },
    setPastebinPrompts: function (value) {
        this.setPref('pastebin-disableprompt', !value);
    },
    shouldPromptPastebins: function () {
        return !this.getPref('pastebin-disableprompt');
    },
    avatarsEnabled: function () {
        return !this.getPref('avatars-off');
    },
    imageAvatarsEnabled: function () {
        return this.avatarsEnabled() && !this.getPref('avatars-image-off');
    },
    embedExternalAvatars: function () {
        return this.imageAvatarsEnabled() && this.getPref('inlineimages');
    },
    
    // Actions
    start: function () {
        if (this.started) {
            debug.warn('Trying to start Session again');
        } else {
            this.started = true;
            this.trigger('start');
            this.backend.init();
            if (this.isSupported()) {
                this.startCookie();
            }
        }
    },
    registerServiceWorker: function () {
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', function() {
                navigator.serviceWorker.register('/sw.js').then(function(registration) {
                    // Registration was successful
                }, function(err) {
                    debug.warn('ServiceWorker registration failed: ', err);
                });
            });
        }
    },
    startCookie: function () {
        this.startSession(this.getAuthCookie());
    },
    startRefresh: function (session, url) {
        // Cookie is updated already by Set-Cookie header if not
        // using a cross domain API domain
        if (this.backend.isXDAPI()) {
            this.setAuthCookie(session);
        }
        if (url) {
            this.redirect(url);
        } else {
            this.refresh();
        }
    },
    setAuthCookie: function (session) {
        this.setCookie('session', session, 100);
    },
    startSession: function (session, url) {
        if (session) {
            // Cookie is updated already by Set-Cookie header if not
            // using a cross domain API domain
            if (this.backend.isXDAPI()) {
                this.setAuthCookie(session);
            }
            this.set({session: session});
            this.startBackend();
            this.postStatUrl = url;
        } else {
            this.noAuth();
        }
    },
    resendVerifyEmail: function (callback) {
        this.post("resend-verify-email", {}, callback);
    },
    authFormToken: function (method, data, callback, options) {
        this.backend.post("auth-formtoken", {}, _.bind(function (response) {
            if (response.success) {
                data.token = response.token;
                this.backend.post(method, data, callback, {
                    headers: {
                        'x-auth-formtoken': response.token
                    }
                }, options);
            } else {
                callback(response);
            }
        }, this));
    },
    forgotPassword: function (email, callback) {
        this.authFormToken("request-password-reset", {
            email: email
        }, callback, {
            urlHost: this.getOrigin()
        });
    },
    signin: function (data, callback) {
        this.authFormToken("login", data, callback, {
            urlHost: this.getOrigin()
        });
    },
    signup: function (data, callback) {
        this.authFormToken("signup", data, callback, {
            urlHost: this.getOrigin()
        });
    },
    changeCredentials: function (oldpassword, newpassword, email, callback) {
        this.post("change-password", {
            password: oldpassword,
            newpassword: newpassword,
            email: email
        }, callback);
    },
    deleteAccount: function (password, callback) {
        this.loggingOut = true;
        this.post("delete-account", {
            password: password
        }, _.bind(function (response) {
            if (response.success) {
                this.trigger('navigate', '?/account-deleted');
                this.doLogout();
            } else {
                this.loggingOut = false;
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    userSettings: function (realname, hwords, autoaway, callback) {
        var data = {
            realname: realname,
            hwords: hwords
        };
        if (autoaway) {
            data['autoaway'] = '1';
        }
        this.post("user-settings", data, callback);
    },
    exportLogs: function (options, callback) {
        options = options || {};
        var model = options.model;
        var data = {
            timezone: options.timezone
        };

        if (model instanceof Buf) {
            data.bid = model.bid();
            data.cid = model.getCid();
        } else if (model instanceof Connection) {
            data.cid = model.getCid();
        }

        this.post("export-log", data, callback);
    },
    sendInvite: function (emails, callback) {
        this.post("send-invite", {
            emails: emails
        }, callback);
    },
    hasConnections: function () {
        return !!this.connections.reject(function (c) {
            return !!c.get('removing');
        }).length;
    },
    hasActiveOrgs: function () {
        if (!this.orgs.length) {
            return false;
        }
        return !!this.orgs.find(function (o) {
            return o.hasActiveSubscription();
        });
    },
    hasOneOrg: function () {
        return this.orgs.length == 1;
    },
    createOrg: function (data, callback) {
        this.post('create-org', data, callback);
    },
    removeOrg: function (org, callback) {
        this.post('delete-org', {
            org: org.id
        }, callback);
    },
    leaveOrg: function (org, callback) {
        this.post('leave-org', {
            org: org.id
        }, callback);
    },
    joinOrg: function (data, callback) {
        this.post('join-org', data, callback);
    },
    joinDefaultConnections: function (data, callback) {
        this.post('join-default-connections', data, callback);
    },
    previousRoute: null,
    currentRoute: null,
    onRoute: function (route, args) {
        this.previousRoute = this.currentRoute;
        this.currentRoute = [route, args];
    },
    back: function () {
        if (this.previousRoute) {
            Backbone.history.history.back();
        } else {
            this.trigger('navigate', '', {replace: true});
        }
    },
    addNetwork: function (data, callback) {
        this.post("add-server", data, callback);
    },
    joinDefault: function (nickname, realname, callback) {
        this.post("add-default-server", {
            nickname: nickname,
            realname: realname
        }, callback);
    },
    getBackoff: function (endpoint, data, delay, failCount, complete) {
        complete = complete || $.Deferred();
        data = data || {};
        this.backend.get(endpoint, data, _.bind(function (response) {
            if (response.error || response.success === false) {
                if (
                    failCount >= 10 ||
                    response.message == 'not_found' ||
                    response.message == 'auth' ||
                    response.message == 'database_down' ||
                    complete.state() == 'rejected'
                ) {
                    complete.reject(response, {
                        failCount: failCount,
                        gave_up: true
                    });
                } else {
                    if (delay) {
                        delay *= 2;
                        if (delay > 5000) {
                            delay = 5000;
                        }
                    } else {
                        delay = 500;
                    }
                    if (failCount) {
                        failCount++;
                    } else {
                        failCount = 1;
                    }
                    complete.notify(response, {
                        failCount: failCount,
                        retry_delay: delay
                    });
                    setTimeout(_.bind(function () {
                        this.getBackoff(endpoint, data, delay, failCount, complete);
                    }, this), delay);
                }
            } else {
                complete.resolve(response);
            }
        }, this));
        return complete;
    },
    getExports: function (callback) {
        return this.backend.get('log-exports', {}, _.bind(function (response) {
            callback(response);
        }, this));
    },
    getSessions: function (callback) {
        return this.backend.get('sessions', {}, _.bind(function (response) {
            callback(response);
        }, this));
    },
    getStreams: function (callback) {
        return this.backend.get('streams', {
            stream_id: this.getStreamId()
        }, _.bind(function (response) {
            callback(response);
        }, this));
    },
    getPlans: function () {
        var complete = this.getBackoff('plans');
        return complete.promise().done(_.bind(function (response) {
            this.plans = response;
            this.trigger('plansChange');
        }, this));
    },
    getCurrency: function () {
        return this.plans.currency || 'usd';
    },
    getNetworks: function (callback) {
        $.getJSON('/static/networks.json', callback);
    },
    getOrgInviteConnections: function (inviteKey, callback) {
        this.backend.get('org-invite-connections', {
            org_invite: inviteKey
        }, callback);
    },
    
    // Feature flags
    featureOn: function (feature) {
        this.setFeature(feature, true);
    },
    featureOff: function (feature) {
        this.setFeature(feature, false);
    },
    setFeature: function (feature, value) {
        if (!window['FEATURES']) {
            window.FEATURES = {};
        }
        if (!_.isEqual(!!window.FEATURES[feature], value)) {
            window.FEATURES[feature] = value;
            this.trigger('featureChange');
            this.trigger('featureChange:' + feature);
        }
    },
    featureCheck: function (feature) {
        if (!window['FEATURES']) {
            return false;
        }
        return window.FEATURES[feature] || false;
    },
    
    checkSubPref: function (subPrefKey, key) {
        var subPref = this.getPref(subPrefKey);
        if (!_.isObject(subPref)) {
            subPref = {};
        }
        return subPref[key] || false;
    },
    setSubPref: function (subPrefKey, key, value) {
        var subPref = $.extend(true, {}, this.getPref(subPrefKey));
        if (value) {
            subPref[key] = value;
        } else {
            delete subPref[key];
        }
        if ($.isEmptyObject(subPref)) {
            subPref = false;
        }
        this.setPref(subPrefKey, subPref);
    },
    
    hasBeenPrompted: function (prompt) {
        return this.checkSubPref('prompts', prompt);
    },
    setPrompted: function (prompt) {
        this.setSubPref('prompts', prompt, true);
    },
    
    bncEnabled: function () {
        return this.featureCheck('bnc');
    },

    labCheck: function (lab) {
        return this.checkSubPref('labs', lab);
    },
    setLabs: function (labs) {
        for (var lab in labs) {
            this.setLab(lab, labs[lab]);
        }
    },
    setLab: function (lab, value) {
        this.setSubPref('labs', lab, value);
    },
    enableLab: function (lab) {
        this.setLab(lab, true);
    },
    disableLab: function (lab) {
        this.setLab(lab, false);
    },
    
    isAdmin: function () {
        return !!this.get('admin');
    },
    uploadsEnabled: function() {
        return !window.IRCConfig.file_uploads_disabled;
    },
    getJoinDate: function () {
        return this.get('join_date') && new Date(this.get('join_date') * 1000);
    },
    isLightTheme: function () {
        return this.getTheme() === 'dawn';
    },
    getTheme: function (defaultValue) {
        var theme = this.getPref('theme') || defaultValue || 'dawn';
        if (this.getPref('theme-auto')) {
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return this.getDefaultDarkTheme();
            } else {
                return 'dawn';
            }
        }
        return theme;
    },
    getDefaultDarkTheme: function () {
        var theme = this.getPref('theme') || 'dawn';
        if (theme == 'dawn') {
            return 'dusk';
        } else {
            return theme;
        }
    },
    getFont: function () {
        return this.getPref('font') || 'sans';
    },
    joinedBeforeDate: function (date) {
        var joinDate = this.getJoinDate();
        if (!joinDate) {
            return null;
        }
        return joinDate.isBefore(date);
    },
    joinedAfterDate: function (date) {
        var joinDate = this.getJoinDate();
        if (!joinDate) {
            return null;
        }
        return joinDate.isAfter(date);
    },
    joinedBeforeDays: function (days) {
        var joinDate = this.getJoinDate();
        if (!joinDate) {
            return null;
        }
        return joinDate.isBefore(new Date().addDays(-days));
    },
    trialEnds: function () {
        // Make everyone's trial join date the release date
        var releaseDate = 1383580911; // Mon Nov 04 2013 16:01:51 GMT+0000 (GMT)
        var joinDate = new Date(Math.max(this.get('join_date') || 0, releaseDate) * 1000);
        return joinDate.addDays(this.get('trial_length'));
    },
    isVerified: function () {
        return this.get('verified');
    },
    post: function (method, data, callback) {
        return this.backend.streamPost(method, data, callback);
    },
    ajax: function (options, successTest, errorTest) {
        var httpMethod = options.type || 'get';
        var outLogLine = '-> [' + httpMethod.toUpperCase() + ']';
        var inLogLine = '<- [' + httpMethod.toUpperCase() + ']';
        if (!options.silent) {
            debug.log(outLogLine, options.url, options.data);
        }
        var inArgs = [options.url];
        if (options.data) {
            if (!(options.data instanceof FormData)) {
                inArgs.push($.param(options.data));
            }
            inArgs.push(options.data);
        }
        var filter = $.Deferred();
        options.xhr = options.xhr || function () {
            var xhr = $.ajaxSettings.xhr();
            if (xhr.upload) {
                xhr.upload.onprogress = function (e) {
                    filter.notify('upload', e);
                };
            }
            xhr.onprogress = function (e) {
                filter.notify('download', e);
            };
            return xhr;
        };
        var ajax = $.ajax(options);
        ajax.then(function(response, status, jqXHR) {
            if (!successTest) {
                filter.resolve(response, status, jqXHR);
            } else {
                var result = successTest(response, status, jqXHR);
                if (result === true) {
                    filter.resolve(response, status, jqXHR);
                } else if (result) {
                    filter.resolve(result, status, jqXHR);
                } else {
                    filter.reject(jqXHR, jqXHR.status, response);
                }
            }
            return filter.promise();
        }, function (jqXHR, errorString, errorThrown) {
            var response = options.dataType === 'json' ? jqXHR.responseJSON : jqXHR.responseText;
            if (!errorTest || errorTest(jqXHR, errorString, errorThrown)) {
                filter.reject(jqXHR, errorString, response, errorThrown);
            } else {
                filter.resolve(response, jqXHR.status, jqXHR);
            }
            return filter.promise();
        }).done(function (response, status, jqXHR) {
            if (status == 'success') {
                if (!options.silent) {
                    debug.log(inLogLine, inArgs, response);
                }
            } else {
                debug.log(inLogLine, inArgs, status, response);
            }
        }).fail(function (jqXHR, errorString, response, errorThrown) {
            debug.log(inLogLine, inArgs, errorString, errorThrown, jqXHR.status, response);
        }).catch(function (jqXHR, errorString, response, errorThrown) {
            debug.log(inLogLine, inArgs, errorString, errorThrown, jqXHR.status, response);
        });
        var promise = filter.promise();
        promise.ajax = ajax;
        return promise;
    },

    // BillingMixins
    subscribeUrl: 'subscribe-solo-stripe',
    billingInfoUrl: 'solo-billing',
    billingInfoParams: function () {
        return {};
    },
    updateCustomerUrl: 'update-solo-stripe-customer',
    reinstateSubscriptionUrl: 'reinstate-solo-subscription',
    cancelStripeSubscriptionUrl: 'cancel-solo-subscription',
    cancelPaypalSubscriptionUrl: 'cancel-solo-paypal-subscription',
    
    subscribeOneOff: function (data, callback) {
        return this.post('subscribe-solo-stripe-oneoff', data, _.bind(function (response) {
            if (response.success) {
                this.set({'subscription_oneoff': response.subscription_oneoff}, {silent: true});
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    completePayPalSubscription: function (data, callback) {
        return this.post('subscribe-solo-paypal-complete', data, callback);
    },
    getReceiptUrl: function (chargeId) {
        return "/receipt/s/" + chargeId;
    },
    getInvoiceUrl: function (invoiceId) {
        return "/invoice/s/" + invoiceId;
    },
    getHostedInvoiceUrl: function (invoiceId) {
        return "/invoice/s-auth/" + invoiceId;
    },
    getPayPalReceiptUrl: function (txnId) {
        return "/receipt/p/" + txnId;
    },
    isUnlimited: function () {
        if (!this.featureCheck('upgrades')) {
            return true;
        }
        return this.hasActiveOrgs() || this.get('limits_name') == 'unlimited';
    },
    isSlackOauthAllowed: function () {
        return this.featureCheck('slack') && this.isUnlimited();
    },
    isBncAllowed: function () {
        return this.bncEnabled() && this.isUnlimited();
    },
    isTrialLimited: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return !this.hasActiveOrgs() &&  this.get('limits_name') == 'free';
    },
    isTrial: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return !this.hasActiveOrgs() && this.get('limits_name') == 'trial';
    },
    canSeeSubscription: function () {
        return true;
    },
    getLimit: function (limit) {
        var limits = this.get('limits');
        if (limits) {
            return limits[limit];
        }
    },
    isZombieLimited: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return this.getLimit('zombiehours') !== -1;
    },
    arePasswordedServersAllowed: function () {
        if (!this.featureCheck('upgrades')) {
            return true;
        }
        return this.getLimit('passworded_servers');
    },
    setZombie: function (message) {
        if (message.hardzombie) {
            this.hardZombie = message.hardzombie * 1000;
        } else if (message.softzombie) {
            this.softZombie = message.softzombie * 1000;
        }
        this.trigger('setZombie');
    },
    isZombied: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return (this.hardZombie || this.softZombie || false) && true;
    },
    getZombieDate: function () {
        if (this.isZombied()) {
            return new Date(this.hardZombie || this.softZombie);
        }
    },
    areConnectionsLimited: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        if (this.getLimit('networks') === -1) {
            return false;
        }
        return true;
    },
    getRemainingConnectionQuota: function () {
        if (this.areConnectionsLimited()) {
            return this.getLimit('networks') - this.numActiveConnections();
        }
    },
    isOverQuota: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return this.getRemainingConnectionQuota() < 0;
    }
}));


module.exports = Session;


/***/ }),

/***/ "+9gY":
/***/ (function(module, exports, __webpack_require__) {

var urlUtil = __webpack_require__("Dn1P");
var gravatarUrl = __webpack_require__("a5o3");

var IRCCLOUD_UID_HOST_RE = /(?:(.+\.)|\/|(?:^))irccloud\.com(?:\/|$)/;

var UserMixins = {
    // Depends
    // getRawHostmask
    // getRawIdent
    // getRawHost
    // getAccount
    // getRealname
    getMaskParts: function () {
        var mask = this.getRawHostmask();
        if (mask) {
            var parts = mask.split('@');
            if (parts.length === 2 && parts[0] && parts[1]) {
                return parts;
            }
        }
    },
    getIdent: function () {
        var ident = this.getRawIdent() || '';
        if (ident && ident[0] != '~' && this.get('ident_prefix')) {
            ident = this.get('ident_prefix') + ident;
        }
        if (!ident) {
            var parts = this.getMaskParts();
            if (parts) {
                ident = parts[0];
            }
        }
        return ident;
    },
    getHost: function () {
        var host = this.getRawHost() || '';
        if (!host) {
            var parts = this.getMaskParts();
            if (parts) {
                host = parts[1];
            }
        }
        return host;
    },
    getHostMask: function () {
        var hostmask = this.getRawHostmask() || '';
        if (!hostmask) {
            hostmask = this.getHost();
            if (hostmask) {
                var ident = this.getIdent();
                if (ident) {
                    hostmask = ident + '@' + hostmask;
                }
            }
        }
        return hostmask;
    },
    getSensibleRealname: function () {
        var realname = this.getRealname() || '';
        if (realname && (realname.toLowerCase() == 'realname' || realname.toLowerCase() == 'unknown')) {
            realname = '';
        }
        return realname;
    },
    realnameEmail: function () {
        var realname = this.getSensibleRealname();
        return urlUtil.matchEmail(realname);
    },
    irccloudUid: function (options) {
        options = options || {};
        var uid, uidMatch;
        var ident = this.getIdent();
        if (ident) {
            uidMatch = ident.match(/^~?[su]id(\d+)/);
            if (uidMatch) {
                uid = uidMatch[1] - 0;
            }
        }
        var host = this.getHost();
        if (uid && !options.strict) {
            if (host && options.filter_enterprise) {
                // If we have a host, make sure it's either from irccloud
                // or not from mozilla
                // ya: moz-blah.charlton.irccloud.com (irccloud user on moznet)
                // ya: gateway/web/irccloud.com/x-blah (irccloud user on freenode)
                // ya: charlton.irccloud.com (irccloud)
                // ya: blah-cloak (unknown cloak)
                // no: moz-blah-blah.IP (non-irccloud user on moznet)
                // no: gateway/web/mozilla/x-blah (mozilla user on freenode)
                if (host.match(IRCCLOUD_UID_HOST_RE) || (
                    !host.match(/^moz-/) && !host.match(/mozilla/)
                )) {
                    return uid;
                }
            } else {
                return uid;
            }
        } else {
            if (host) {
                var hostmatches = host.match(IRCCLOUD_UID_HOST_RE);
                if (hostmatches) {
                    if (uid) {
                        return uid;
                    } else if (hostmatches[1]) {
                        uidMatch = hostmatches[1].match(/id-(\d+)\..+/);
                        if (uidMatch) {
                            uid = uidMatch[1] - 0;
                            return uid;
                        }
                    }
                }
            }
        }
        if (!uid && !options.numeric && this.connection && this.connection.isTeamServer()) {
            return this.getAccount() || undefined;
        }
    },
    getAvatar: function (options) {
        options = options || {};
        var buffer = this.buffer || options.buffer;
        var Avatar = __webpack_require__("lKP6");
        var avatarId = options.avatar_id;
        var avatarUrl = options.avatar_url;
        if (!avatarId && !avatarUrl) {
            var prefix = '';
            if (this.has('target_avatar')) {
                prefix = 'target_';
            }
            avatarId = this.get(prefix + 'avatar');
            avatarUrl = this.get(prefix + 'avatar_url');
        }
        var urlSecure = false;
        if (avatarId && _.isString(avatarId)) {
            if (Avatar.isExternalSecure(avatarId)) {
                avatarUrl = avatarId;
                urlSecure = true;
            } else {
                return {
                    id: avatarId,
                    src: Avatar.idToTemplate(avatarId),
                    external: false
                };
            }
        }
        if (urlSecure || (avatarUrl && _.isString(avatarUrl) && Avatar.isExternalSecure(avatarUrl))) {
            if (this.connection.isSlackOAuth() || options.forceExternal || (buffer && buffer.embedExternalAvatars())) {
                return {
                    id: avatarUrl,
                    src: avatarUrl,
                    external: true
                };
            } else {
                return;
            }
        }

        if (!options.strict && this.connection && this.connection.shouldGuessAvatar()) {
            var uid = this.irccloudUid({
                strict: false,
                numeric: true,
                filter_enterprise: true
            });

            if (uid) {
                var redirectUrl = Avatar.redirectTemplate(uid);
                if (this.connection.session && this.connection.session.id == uid) {
                    return this.connection.session.getUser().getAvatar(options);
                } else {
                    return {
                        id: redirectUrl,
                        src: redirectUrl,
                        external: false,
                        guess: true
                    };
                }
            }

            if (!options.noGravatar) {
                var emailRealname = this.realnameEmail();
                if (emailRealname) {
                    var gravatar = gravatarUrl(emailRealname[0]) + '?size={size}&default=404';
                    return {
                        id: gravatar,
                        src: gravatar,
                        external: true,
                        gravatar: true,
                        guess: true
                    };
                }
            }
        }
    }
};


module.exports = UserMixins;


/***/ }),

/***/ "+E2x":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"topMessage__text\">\n    <p><i class=\"fa fa-arrow-right\"></i> "
    + alias4(((helper = (helper = lookupProperty(helpers,"messagePrompt") || (depth0 != null ? lookupProperty(depth0,"messagePrompt") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"messagePrompt","hash":{},"data":data,"loc":{"start":{"line":2,"column":41},"end":{"line":2,"column":60}}}) : helper)))
    + "</p>\n</div>\n<div class=\"topMessage__buttons\">\n    <button type=\"button\" class=\"action topMessage__confirm\"><span>"
    + alias4(((helper = (helper = lookupProperty(helpers,"confirmText") || (depth0 != null ? lookupProperty(depth0,"confirmText") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"confirmText","hash":{},"data":data,"loc":{"start":{"line":5,"column":67},"end":{"line":5,"column":84}}}) : helper)))
    + "</span></button>\n    <button type=\"button\" class=\"topMessage__dismiss\"><span>"
    + alias4(((helper = (helper = lookupProperty(helpers,"dismissText") || (depth0 != null ? lookupProperty(depth0,"dismissText") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dismissText","hash":{},"data":data,"loc":{"start":{"line":6,"column":60},"end":{"line":6,"column":77}}}) : helper)))
    + "</span></button>\n</div>\n";
},"useData":true});

/***/ }),

/***/ "+laS":
/***/ (function(module, exports, __webpack_require__) {

var Autogrow = __webpack_require__("ZGvr");
var DialogView = __webpack_require__("EjYC");
var HistoryCompletion = __webpack_require__("J6S1");
var TabCompletion = __webpack_require__("TT07");
var FileWrapper = __webpack_require__("JHsc");
var PastebinView = __webpack_require__("0bCg");
var Keyboard = __webpack_require__("fDhS").default;
var urlUtil = __webpack_require__("Dn1P");
var utils = __webpack_require__("GmLC");
var BufferFormatter = __webpack_require__("gfb+");


var BufferInputView = Backbone.View.extend({
    tagName: 'form',
    className: 'input',
    input: null,
    events: {
        'submit': 'submit',
        'keydown textarea': 'keyDown',
        'focus textarea': 'onFocus',
        'blur textarea': 'onBlur',
        'input textarea': 'onInput',
        'keyup textarea': 'onInput',
        'update textarea': 'onInput',
        'paste textarea': 'onPaste'
    },
    initialize: function (options) {
        this.focused = false;
        this.formatter = new BufferFormatter(this.model);
        this.model.bind('pastePrompt', this.pastePrompt, this);
    },
    onFocus: function () {
        this.focused = true;
        this.trigger('focus');
    },
    onBlur: function () {
        this.focused = false;
        this.trigger('blur');
    },
    isFocused: function () {
        return this.focused;
    },
    closeDialog: function (dialog) {
        var visibleInputs = $('input:focus, textarea:focus').filter(':visible');
        if (this.model.isSelected() && !visibleInputs.length) {
            this.focus();
        }
    },
    focusOnSelect: function () {
        if (this.model.isSelected()) {
            this.focus();
        } else {
            this.blur();
        }
    },
    submit: function (e) {
        try {
            this.say(this.val());
        } catch (exc) {
            // Catch errors so the form never submits
            debug.warn(exc);
        }
        return false;
    },
    keyDown: function (e) {
        return this.onKey(e);
    },
    onInput: function (e) {
        this.trigger('input', e);
        this.autogrow.resize();
    },
    collectPasteData: function (e) {
        var data = e.originalEvent.clipboardData || window.clipboardData;
        var files = [];
        var strings = [];
        var blobs = [];
        var complete = $.Deferred();
        if (data && data.items) {
            var itemLength = data.items.length;
            var checkResolve = function () {
                if (--itemLength === 0) {
                    if (!files.length) {
                        files = blobs;
                    }
                    complete.resolve(e, strings, files);
                }
            };
            _.each(data.items, function (item) {
                if (item.kind == 'string' && item.type == 'text/plain') {
                    item.getAsString(_.bind(function (value) {
                        if (value) {
                            var stringBlob = FileWrapper.blobFromDataURI(value);
                            if (stringBlob) {
                                blobs.push(stringBlob);
                            } else {
                                if (!urlUtil.urlParts(value)) {
                                    strings.push(value);
                                }
                            }
                        }
                        checkResolve();
                    }, this));
                } else if (item.kind == 'file') {
                    var blob = item.getAsFile();
                    if (blob) {
                        files.push(blob);
                    }
                    checkResolve();
                } else {
                    checkResolve();
                }
            }, this);
        } else {
            complete.reject();
        }
        return complete.promise();
    },
    pastePrompt: function () {
        this.sayPaste(this.val(), {manual: true});
    },
    onPaste: function (e) {
        this.collectPasteData(e).done(_.bind(this.handlePasteData, this));
    },
    handlePasteData: function (e, strings, files) {
        _.each(strings, function (value) {
            if ($(e.target).is(this.input)) {
                // value pasted already, suppress
            } else {
                this.insertAtCursor(value, true);
            }
        }, this);
        if (files.length) {
            var options = {
                files: files
            };
            this.model.trigger('upload', options);
        }
    },
    parseCommand: function (val) {
        return val.toLowerCase().match(/^\/(\w+)(?:$| (.*))/);
    },
    calculateLineLengthRemaining: function (val) {
        if (val === undefined) {
            val = this.val();
        }
        var parseCommand = this.parseCommand(val);

        var commandLen = 9;
        var textLen = utils.lengthInUtf8Bytes(val);
        if (parseCommand) {
            textLen = parseCommand[2] ? parseCommand[2].length : 0;
            switch (parseCommand[1]) {
            case 'me':
                commandLen = 18;
                break;
            case 'notice':
                commandLen = 8;
                break;
            default:
                return;
            }
        }
        var syntaxLen = 13;
        var totalLen = 512;
        var user = this.model.getUser();
        var nickLen = user.getNick().length;
        var maskLen = user.getHostMask().length;
        var targetLen = this.model.getName().length;
        var allowed = totalLen - syntaxLen - commandLen - nickLen - maskLen - targetLen;
        return allowed - textLen;
    },
    onKey: function (e) {
        this.trigger('key', e);
    },
    onEnter: function (e) {
        var val = this.val();
        if (Keyboard.isModifier(e)) {
            if (this.model.session.modifierMeEnabled()) {
                // cmd/ctrl-return
                if (val[0] == '/') {
                    // send as is if the first character's a slash
                    this.say('/' + val);
                } else {
                    // /me it
                    this.me(val);
                }
            } else {
                // add a new line
                this.insertAtCursor('\n');
            }
        } else if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) {
            // any other modifier key: add a new line
            this.insertAtCursor('\n');
        } else {
            // bare return
            var parseCommand = this.parseCommand(val);
            if (parseCommand && parseCommand[1] == 'paste') {
                this.sayPaste(parseCommand[2], {
                    orig: val,
                    manual: true
                });
            } else if (parseCommand && parseCommand[1] == 'clear') {
                this.clear();
                this.model.trigger('clear');
            } else {
                var blob = FileWrapper.blobFromDataURI(val);
                if (blob) {
                    var options = {
                        dataURI: val,
                        files: [blob]
                    };
                    this.clear();
                    this.model.trigger('upload', options);
                } else {
                    // default: /say it
                    this.say(val);
                }
            }
        }
    },
    render: function () {
        var labelId = 'bufferInputView' + this.model.bid();
        if (this.model.isThread()) {
            labelId += 'Thead';
        }
        this.label = $('<label class="g">').text('New message input').attr('for', labelId);
        this.input = $('<textarea name="msg" rows="1"></textarea>').attr('id', labelId);
        $(this.el).append(this.label);
        $(this.el).append(this.input);

        // Autogrow
        this.autogrow = new Autogrow({
            el: this.input,
            minHeight: 20,
            manualDetect: true,
            manualTrigger: true
        });

        // History completion
        this.history = new HistoryCompletion({
            el: this.input,
            input: this,
            model: this.model,
        });

        // Tab completion
        this.tabComplete = new TabCompletion({
            el: this.input,
            model: this.model
        });
        this.tabComplete.bubble('completeCandidates', this);

        this.model.bind('selectedChange', this.focusOnSelect, this);
        this.model.bind('setInputText', this.setVal, this);
        this.model.bind('insertAtCursor', this.insertAtCursor, this);
        this.listenTo(this.model.session, 'buffersShown', this.focusOnSelect);
        this.focusOnSelect();

        this.model.bind('remove', this.remove, this);

        DialogView.bind('close', this.closeDialog, this);

        return this;
    },
    isValueSingleEmoji: function (value) {
        return emoji.strip_unified(emoji.replace_colons(value, true), true) === '';
    },
    say: function (message) {
        if (message) {
            if (this.shouldPaste(message)) {
                this.sayPaste(message);
            } else {
                var convertedMessage = message;
                var urlSplitParts = this.formatter.linker.splitTextOnUrls(message);
                var skinTone = this.model.session.getPref('skin-tone');
                var parts = _.map(urlSplitParts, function (part, index) {
                    if (part.url) {
                        var bits = this.formatter.linker.renderUrl(part.url);
                        if (bits) {
                            // Don't emojify urls
                            // Filter tracker params on http urls
                            if (
                                this.model.session.getPref('strip-url-trackers') &&
                                !this.formatter.linker.isCurrentUrl(bits.parts) &&
                                urlUtil.isLooseHttp(part.value)
                            ) {
                                var blockedQs = [
                                    // google analytics, filter globally
                                    'utm_source',
                                    'utm_medium',
                                    'utm_campaign',
                                    'utm_term',
                                    'utm_content',
                                    'utm_name',
                                    
                                    // domain specific but unique enough to
                                    // filter globally

                                    // ebay
                                    '_trkparms',
                                    '_trksid',
                                    // facebook
                                    'hc_ref',
                                    // bbc
                                    'ns_mchannel',
                                    'ns_source',
                                    'ns_campaign',
                                    'ns_linkname'
                                ];
                                // domain specific and could have false positives
                                if (urlUtil.matchYouTube(bits.parts)) {
                                    blockedQs = blockedQs.concat([
                                        'feature',
                                        'attr_tag'
                                    ]);
                                } else if (urlUtil.matchTwitter(bits.parts)) {
                                    blockedQs = blockedQs.concat([
                                        's',
                                        'ref_src',
                                        'ref_url'
                                    ]);
                                } else if (urlUtil.matchInstagram(bits.parts)) {
                                    blockedQs = blockedQs.concat([
                                        'igshid'
                                    ]);
                                }
                                // TODO more domain specific filters?
                                // amazon.com?ref (amazon.co.uk)
                                //           ?s
                                //           ?ie
                                //           ?qid
                                //           ?sr
                                //           ?keywords


                                var filteredUrlParts = urlUtil.filterSearchParams(
                                    urlUtil.urlParts(bits.parts.href), blockedQs
                                );
                                var filtered = false;
                                if (bits.parts.search != filteredUrlParts.search) {
                                    filtered = true;
                                }
                                var isAmp = urlUtil.isAmp(filteredUrlParts);
                                if (isAmp) {
                                    // Return cleaned + filtered
                                    var cleanedUrlParts = urlUtil.cleanAmpUrl(filteredUrlParts, true);
                                    return cleanedUrlParts.href;
                                } else if (filtered) {
                                    // Return filtered
                                    return filteredUrlParts.href;
                                } else {
                                    // Return unmodified
                                    return part.value;
                                }
                            } else {
                                return part.value;
                            }
                        }
                    }
                    if (this.model.session.getPref('emoji-disableconvert')) {
                        return part.value;
                    } else {
                        // Emojify plain text
                        return emoji.replace_colons(
                            part.value, true, skinTone
                        );
                    }
                }, this);
                convertedMessage = parts.join('');
                var replyMsgId, replyId;
                if (this.replyTarget) {
                    replyMsgId = this.replyTarget.getMsgId();
                    replyId = this.replyTarget.getReplyId();
                }
                if (this.model.isThread()) {
                    replyId = this.model.id;
                }
                if (replyMsgId && this.isValueReactionShortcut(message)) {
                    var substr = convertedMessage.substr(1);
                    if (this.isValueSingleEmoji(substr)) {
                        this.model.react(replyMsgId, substr);
                        this.model.pushInputHistory(convertedMessage, this.replyTarget);
                    } else {
                        return;
                    }
                } else if (replyId) {
                    this.model.reply(replyId, convertedMessage);
                    this.model.pushInputHistory(convertedMessage, this.replyTarget);
                } else {
                    this.model.say(convertedMessage, {
                        onCancel: _.bind(function () {
                            this.setVal(convertedMessage);
                        }, this)
                    });
                }
                this.clear();
            }
        }
    },
    shouldPaste: function (message) {
        var m = message.trim();
        return this.model.session.shouldPromptPastebins() && (
            m.indexOf('\n') !== -1 ||
            m.length > PastebinView.MESSAGE_LENGTH_TRIGGER
        );
    },
    sayPaste: function (message, options) {
        options = options || {};
        this.clear();
        this.model.session.trigger(
            'pasteConfirm', this.model, {
                contents: message,
                manual: options.manual
            }, _.bind(function () {
                this.setVal(options.orig || message);
            }, this)
        );
    },
    clear: function () {
        this.model.trigger('clearReplyHighlight');
        this.setVal('');
        this.tabComplete.clear();
    },
    me: function (message) {
        if (message) {
            if (this.shouldPaste(message)) {
                this.sayPaste(message);
            } else {
                this.say('/me ' + message);
            }
        }
    },
    insertAtCursor: function (value, focus) {
        var currentValue = this.val();
        var cursorRange = this.input.cursorRange();
        var chars = currentValue.split('');
        chars.splice(cursorRange.start, cursorRange.end - cursorRange.start, value);
        this.setVal(chars.join(''));
        this.input.cursorRange(cursorRange.start + value.length);
        if (focus) {
            this.focus();
        }
        return this;
    },
    isGrown: function () {
        return this.autogrow.isGrown();
    },
    val: function () {
        return this.input.val();
    },
    setVal: function (value) {
        this.input.val(value);
        this.onInput();
    },
    isSlashCommand: function (val) {
        if (val === undefined) {
            val = this.val();
        }
        return val.indexOf('/') === 0;
    },
    isValueReactionShortcut: function (value) {
        var reactionShortcut = '+:';
        return value.indexOf(reactionShortcut) === 0;
    },
    isReactionShortcut: function () {
        return this.isValueReactionShortcut(this.val());
    },
    blur: function () {
        if (this.isFocused()) {
            this.input.blur();
        }
    },
    focus: function () {
        if (!this.isFocused() && this.input.is(':visible')) {
            this.input.focus();
        }
    }
});


module.exports = BufferInputView;


/***/ }),

/***/ "/1Z1":
/***/ (function(module, exports) {

var PrefMixins = {
    initialize: function () {
        this.overridePrefKeys = {};
        _.each(this.prefKeys, function (prefSpec, basePref) {
            var overridePref = prefSpec[0];
            this.overridePrefKeys[overridePref] = basePref;
            _.each([basePref, overridePref], function (pref, i) {
                var prefKey = this.getPrefKey(pref);
                this.listenTo(this.session, 'prefChange:' + prefKey, function (previousValues) {
                    var prev;
                    if (previousValues) {
                        prev = previousValues[this.id];
                    }
                    if (!_.isEqual(this.getPref(pref), prev)) {
                        this.trigger('prefChange:' + basePref, this, prefKey, prev);
                    }
                });
            }, this);
            this.listenTo(this.session, 'prefChange:' + basePref, function (previousValue) {
                this.trigger('prefChange:' + basePref, this, basePref, previousValue);
            });
        }, this);
    },
    toBasePref: function (pref) {
        return this.overridePrefKeys[pref] || pref;
    },
    prefKeys: {},
    getPrefObject: function (key) {
        return this.session.getPref(this.getPrefKey(key), {});
    },
    getPref: function (key) {
        var pref = this.getPrefObject(key);
        return pref[this.id];
    },
    setPref: function (k, v) {
        var kv;
        // Single arg means full pref object
        if (arguments.length === 2) {
            kv = {};
            kv[k] = v;
        } else {
            kv = k;
        }
        var changes = {};
        _.each(kv, function (value, key) {
            var pref = this.getPrefObject(key);
            var previousValue = pref[this.id];
            if (value) {
                if (!_.isEqual(previousValue, value)) {
                    pref[this.id] = value;
                    changes[key] = [pref, previousValue];
                }
            } else {
                if (previousValue) {
                    delete pref[this.id];
                    changes[key] = [pref, previousValue];
                }
            }
        }, this);
        if (!$.isEmptyObject(changes)) {
            var updates = {};
            _.each(changes, function (prefPair, key) {
                var pref = prefPair[0];
                var previousValue = prefPair[1];
                var basePref = this.toBasePref(key);
                var prefKey = this.getPrefKey(key);
                updates[prefKey] = pref;
                this.trigger('prefChange:' + basePref, this, prefKey, previousValue);
            }, this);
            this.session.setPref(updates);
        }
    },
    setOverridePref: function (enable, basePref) {
        var prefSpec = this.prefKeys[basePref];
        var overridePref = prefSpec[0];
        var defaultValue = prefSpec[1];
        var updates = {};
        if (this.session.getPref(basePref)) {
            // Base pref is globally set
            updates[basePref] = false; // unneeded
            updates[overridePref] = defaultValue ? enable : !enable;
        } else {
            // (Default) not globally set
            updates[basePref] = defaultValue ? !enable : enable;
            updates[overridePref] = false; // unneeded
        }
        this.setPref(updates);
    },
    checkPref: function (basePref) {
        var prefSpec = this.prefKeys[basePref];
        var overridePref = prefSpec[0];
        var defaultValue = prefSpec[1];
        if (this.getPref(basePref)) {
            return !defaultValue;
        } else if (this.session.getPref(basePref)) {
            if (defaultValue) {
                return !!this.getPref(overridePref);
            } else {
                return !this.getPref(overridePref);
            }
        } else {
            return defaultValue;
        }
    }
};


module.exports = PrefMixins;


/***/ }),

/***/ "/7tV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.numDefaultAvatars = numDefaultAvatars;
exports.defaultAvatar = defaultAvatar;
exports.usernamesToIds = usernamesToIds;
exports.bitsAction = bitsAction;
exports.channelsToInfo = channelsToInfo;
exports.popupStream = popupStream;
exports.parseBadgeTag = parseBadgeTag;
exports.channelBadgeUrl = channelBadgeUrl;
exports.splitCheerParts = splitCheerParts;
exports.cheerUrl = cheerUrl;
exports.cheerValue = cheerValue;
exports.fetchChannelInfo = fetchChannelInfo;
exports.fetchStreamInfo = fetchStreamInfo;
exports.fetchChannelRooms = fetchChannelRooms;
exports.roomChannel = roomChannel;
exports.roomType = roomType;
exports.loadBadges = loadBadges;

var _uriTemplates = __webpack_require__("0a14");

var _uriTemplates2 = _interopRequireDefault(_uriTemplates);

var _util = __webpack_require__("GmLC");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://dev.twitch.tv/docs/v5/guides/irc/
// https://github.com/justintv/Twitch-API/blob/master/IRC.md

/* eslint-env es6 */
var API_BASE = 'https://api.twitch.tv/kraken';
var CLIENT_ID = '2ukwwky442jlp85of7gtonyht8r8awc';
var API_VERSION_TYPE = 'application/vnd.twitchtv.v5+json';

var USERID_URL = API_BASE + '/users?login={user}';
var CHANNEL_BADGE_URL = API_BASE + '/chat/{channel}/badges';
var CHANNEL_ROOMS_URL = API_BASE + '/chat/{channel}/rooms';
var CHANNEL_STREAM_INFO_URL = API_BASE + '/streams?channel={channels}';
var CHANNEL_INFO_URL = API_BASE + '/channels/{channel}';
var BITS_ACTION_URL = API_BASE + '/bits/actions?channel_id={channel}';
var CHANNEL_STREAM_POPUP_URL = 'https://player.twitch.tv/?channel={channel}&volume=1&parent={parent}';
var GLOBAL_BADGE_URL = 'https://badges.twitch.tv/v1/badges/global/display';
var ROOMID_BADGE_URL = 'https://badges.twitch.tv/v1/badges/channels/{room_id}/display';

var CHANNEL_INFO_PROMISES = {};
var CHANNEL_BADGE_PROMISES = {};
var ROOMID_BADGE_PROMISES = {};

var GLOBAL_BADGE_PROMISE = void 0;
var BITS_ACTION_PROMISE = {};
var BITS_ACTIONS = {};
var BITS_REGEX = {};
var BITS_REGEX_G = {};
var COLOR_RE = /^#[a-f0-9]{6,6}$/i;
var AL_RE = /^[a-z]{1,100}$/i;

var STATIC_CDN_BASE_URL = 'https://static-cdn.jtvnw.net';
var DEFAULT_PROFILE_PICS_BASE = STATIC_CDN_BASE_URL + '/user-default-pictures/';
var DEFAULT_PROFILE_PIC_SUFFIX = '-profile_image-{size}x{size}.jpg';
var DEFAULT_PROFILE_PICS = ['bb97f7e6-f11a-4194-9708-52bf5a5125e8', '27103734-3cda-44d6-a384-f2ab71e4bb85', '49988c7b-57bc-4dee-bd4f-6df4ad215d3a', '0ecbb6c3-fecb-4016-8115-aa467b7c36ed', 'cd618d3e-f14d-4960-b7cf-094231b04735', '4cbf10f1-bb9f-4f57-90e1-15bf06cfe6f5', 'b83b1794-7df9-4878-916c-88c2ad2e4f9f'];

function numDefaultAvatars() {
    return DEFAULT_PROFILE_PICS.length;
}
function defaultAvatar() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var idx = options.idx;
    if (idx === undefined) {
        idx = _.random(0, numDefaultAvatars() - 1);
    }
    return DEFAULT_PROFILE_PICS_BASE + DEFAULT_PROFILE_PICS[idx] + DEFAULT_PROFILE_PIC_SUFFIX;
}

function usernamesToIds(session, usernames) {
    return ajax(session, {
        url: (0, _uriTemplates2.default)(USERID_URL).fill({
            user: usernames
        }),
        dataType: 'json'
    });
}

function bitsAction(session, channel) {
    if (!BITS_ACTION_PROMISE[channel]) {
        BITS_ACTION_PROMISE[channel] = new _promise2.default(function bitsActionProcess(resolve, reject) {
            channelsToInfo(session, [channel]).then(function (channelInfo) {
                if (channelInfo && channelInfo[channel]) {
                    ajax(session, {
                        url: (0, _uriTemplates2.default)(BITS_ACTION_URL).fill({
                            channel: channelInfo[channel]._id
                        }),
                        dataType: 'json'
                    }).done(function bitsActionProcessDone(response, status, jqXHR) {
                        if (response && response.actions && response.actions.length) {
                            var actions = response.actions.forEach(function bitsActionMap(action) {
                                if (_.isString(action.prefix) && AL_RE.test(action.prefix) && action.tiers) {
                                    BITS_ACTIONS[action.prefix.toLowerCase()] = action.tiers;
                                }
                            });
                            var re = '\\b(' + (0, _keys2.default)(BITS_ACTIONS).join('|') + ')(\\d+)\\b';
                            BITS_REGEX[channel] = new RegExp(re, 'i');
                            BITS_REGEX_G[channel] = new RegExp(re, 'gi');
                        }
                        resolve(response);
                    });
                } else {
                    resolve();
                }
            });
        });
    }
    return BITS_ACTION_PROMISE[channel];
}

function channelsToInfo(session, channels) {
    var chanString = channels.join(',');
    if (!CHANNEL_INFO_PROMISES[chanString]) {
        var promise = new _promise2.default(function fetchChannelIdProcess(resolve, reject) {
            usernamesToIds(session, channels).done(function fetchUserIdDone(response, status, jqXHR) {
                if (response && response.users && response.users.length) {
                    var channelIds = {};
                    response.users.forEach(function (u) {
                        return channelIds[u.name] = u;
                    });
                    resolve(channelIds);
                } else {
                    delete CHANNEL_INFO_PROMISES[chanString];
                    channels.forEach(function (chan) {
                        delete CHANNEL_INFO_PROMISES[chan];
                    });
                    resolve();
                }
            });
        });
        CHANNEL_INFO_PROMISES[chanString] = promise;
        channels.forEach(function (chan) {
            CHANNEL_INFO_PROMISES[chan] = promise;
        });
    }
    return CHANNEL_INFO_PROMISES[chanString];
}

function popupStream(session, channel) {
    var url = (0, _uriTemplates2.default)(CHANNEL_STREAM_POPUP_URL).fill({
        channel: channel,
        parent: session.getHost()
    });
    var title = 'twitchStreamPopup';
    var w = 960;
    var h = 540;

    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    var specs = 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + ',menubar=0,status=1';
    var newWindow = window.open('', title, specs);
    newWindow.opener = null;
    newWindow.location.href = url;
}

function parseBadgeTag(tag, asObject) {
    var badges = [];
    if (asObject) {
        badges = {};
    }
    if (tag) {
        tag.split(',').forEach(function parseBadgeTagEach(part) {
            var match = part.match(/([a-z\d_-]+)\/(\d+)/);
            if (match) {
                if (asObject) {
                    badges[match[1]] = match[2];
                } else {
                    badges.push({
                        type: match[1],
                        value: match[2]
                    });
                }
            }
        });
    }
    return badges;
}

function channelBadgeUrl(session, channel, roomId, badge) {
    return new _promise2.default(function channelBadgeUrlProcess(resolve, reject) {
        if (badge.type === 'subscriber') {
            if (roomId) {
                resolve(fetchRoomIdSubBadge(session, roomId, badge.value));
            } else {
                resolve(fetchChannelSubBadge(session, channel));
            }
        } else {
            resolve(globalBadgeUrl(session, badge.type, badge.value));
        }
    });
}

function globalBadgeUrl(session, type, value) {
    return new _promise2.default(function globalBadgeUrlProcess(resolve, reject) {
        fetchGlobalBadge(session).then(function globalBadgeUrlFetchDone(response) {
            resolve(lookupGlobalBadgeData(response, type, value));
        });
    });
}

function matchCheers(channel, input) {
    if (BITS_REGEX[channel]) {
        var cheers = input.match(BITS_REGEX_G[channel]);
        if (cheers) {
            return cheers.map(function (cheer) {
                var cheerParts = cheer.match(BITS_REGEX[channel]);
                return {
                    text: cheerParts[0],
                    value: cheerParts[2],
                    type: cheerParts[1].toLowerCase()
                };
            });
        }
    }
}

function splitCheerParts(channel, input) {
    var cheers = matchCheers(channel, input);
    if (cheers) {
        var parts = [];
        var parsedIndex = 0;
        cheers.forEach(function splitCheerPartsEach(cheer) {
            var textValue = input.slice(parsedIndex, input.indexOf(cheer.text, parsedIndex));
            if (textValue !== '') {
                parts.push({
                    text: textValue
                });
            }
            var part = {
                cheer: true,
                text: cheer.text,
                value: cheer.value,
                tier: bitsTier(cheer.value),
                type: cheer.type
            };
            if (BITS_ACTIONS[part.type][part.tier] && BITS_ACTIONS[part.type][part.tier].images && BITS_ACTIONS[part.type][part.tier].images.light && BITS_ACTIONS[part.type][part.tier].images.dark && BITS_ACTIONS[part.type][part.tier].images.light.animated && BITS_ACTIONS[part.type][part.tier].images.dark.animated && BITS_ACTIONS[part.type][part.tier].images.light.animated[1] && BITS_ACTIONS[part.type][part.tier].images.dark.animated[1]) {
                parts.push(part);
            } else {
                parts.push({
                    text: cheer.text
                });
            }
            parsedIndex += textValue.length + cheer.text.length;
        });
        var textValue = input.slice(parsedIndex);
        if (textValue !== '') {
            parts.push({
                text: textValue
            });
        }
        return parts;
    } else {
        return [{
            text: input
        }];
    }
}

function cheerUrl(type, tier) {
    var theme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'light';
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var animated = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    var state = animated ? 'animated' : 'static';
    return BITS_ACTIONS[type][tier].images[theme][state][size];
}

function cheerValue(type, tier, value) {
    var valueInt = value - 0;
    if (valueInt >= 10000) {
        valueInt = Number(valueInt).toLocaleString();
    }
    var color = BITS_ACTIONS[type][tier].color;
    var colorStyle = '';
    if (COLOR_RE.test(color)) {
        colorStyle = ' style="color: ' + color + ';"';
    }
    var span = '<span class="twitchCheer__value"' + colorStyle + '>';
    span += valueInt;
    span += '</span>';
    return span;
}

function fetchChannelInfo(session, channel) {
    // https://dev.twitch.tv/docs/v5/reference/channels/#get-channel-by-id
    return new _promise2.default(function fetchChannelInfoProcess(resolve, reject) {
        channelsToInfo(session, [channel]).then(function (channelInfo) {
            if (channelInfo && channelInfo[channel]) {
                ajax(session, {
                    url: (0, _uriTemplates2.default)(CHANNEL_INFO_URL).fill({
                        channel: channelInfo[channel]._id
                    }),
                    dataType: 'json'
                }).done(function fetchChannelInfoDone(response, status, jqXHR) {
                    resolve(response);
                });
            } else {
                resolve();
            }
        });
    });
}

function fetchStreamInfo(session, channels, auth) {
    // Streams support multi-get, channels don't
    // https://dev.twitch.tv/docs/v5/reference/streams/#get-stream-by-channel
    return new _promise2.default(function fetchStreamInfoProcess(resolve, reject) {
        channelsToInfo(session, channels).then(function fetchStreamInfoIdAll(channelInfo) {
            if (!channelInfo) {
                resolve();
                return;
            }
            var channelStreamInfo = {};
            var filteredChannelIds = _.filter(_.pluck(channelInfo, '_id'), _.identity);
            if (!filteredChannelIds.length) {
                resolve(channelStreamInfo);
                return;
            }
            ajax(session, {
                url: (0, _uriTemplates2.default)(CHANNEL_STREAM_INFO_URL).fill({
                    channels: filteredChannelIds
                }),
                dataType: 'json'
            }).done(function fetchStreamInfoDone(response, status, jqXHR) {
                if (response && _.isArray(response.streams)) {
                    response.streams.forEach(function fetchStreamInfoEach(stream) {
                        if (stream.channel && _.isString(stream.channel.name)) {
                            channelStreamInfo[stream.channel.name.toLowerCase()] = stream;
                        }
                    });
                }
                var promises = _.map(channels, function fetchStreamInfoCheckEach(channel) {
                    if (channelStreamInfo[channel]) {
                        return fetchChannelRooms(session, channel, auth).then(function fetchChannelRoomsThen(rooms) {
                            channelStreamInfo[channel].rooms = rooms;
                            return [channel, channelStreamInfo[channel]];
                        });
                    } else {
                        return fetchChannelInfo(session, channel).then(function fetchChannelInfoThen(response) {
                            if (response && response.name) {
                                channelStreamInfo[channel] = {
                                    channel: response
                                };
                                return fetchChannelRooms(session, channel, auth).then(function fetchChannelRoomsThen(rooms) {
                                    channelStreamInfo[channel].rooms = rooms;
                                    return [channel, channelStreamInfo[channel]];
                                });
                            } else {
                                return [channel, { error: response }];
                            }
                        });
                    }
                });
                _promise2.default.all(promises).then(function fetchStreamInfoAll(values) {
                    resolve(channelStreamInfo);
                });
            });
        });
    });
}

function ajax(session) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options.headers = options.headers || {};
    options.headers['Client-ID'] = CLIENT_ID;
    options.headers['Accept'] = API_VERSION_TYPE;
    if (options.auth) {
        options.headers['Authorization'] = 'OAuth ' + options.auth;
    }
    options.silent = true;
    return session.ajax(options, null, function ajaxErrortest(jqXHR, errorString, errorThrown) {
        // Suppress ajax errors
        return false;
    });
}

// Private

function bitsTier(value) {
    if (value >= 10000) {
        return 4;
    } else if (value >= 5000) {
        return 3;
    } else if (value >= 1000) {
        return 2;
    } else if (value >= 100) {
        return 1;
    } else {
        return 0;
    }
}

function lookupGlobalBadgeData(json, type, value) {
    if (value === undefined) {
        value = 1;
    }
    if (json && json.badge_sets && json.badge_sets[type] && json.badge_sets[type].versions && json.badge_sets[type].versions[value]) {
        return {
            url: json.badge_sets[type].versions[value].image_url_1x,
            url2x: json.badge_sets[type].versions[value].image_url_2x,
            url4x: json.badge_sets[type].versions[value].image_url_4x,
            title: json.badge_sets[type].versions[value].title
        };
    }
}

function lookupChannelSubBadge(json) {
    if (json && json.subscriber) {
        var url = json.subscriber.image;
        var data = {
            url: url,
            title: 'Subscriber'
        };
        return data;
    }
}

function fetchGlobalBadge(session) {
    if (!GLOBAL_BADGE_PROMISE) {
        GLOBAL_BADGE_PROMISE = new _promise2.default(function fetchGlobalBadgeProcess(resolve, reject) {
            ajax(session, {
                url: GLOBAL_BADGE_URL,
                dataType: 'jsonp'
            }).done(function fetchGlobalBadgeDone(response, status, jqXHR) {
                resolve(response);
            });
        });
    }

    return GLOBAL_BADGE_PROMISE;
}

function fetchChannelSubBadge(session, channel) {
    if (!CHANNEL_BADGE_PROMISES[channel]) {
        CHANNEL_BADGE_PROMISES[channel] = new _promise2.default(function fetchChannelSubBadgeProcess(resolve, reject) {
            channelsToInfo(session, [channel]).then(function (channelInfo) {
                if (channelInfo && channelInfo[channel]) {
                    ajax(session, {
                        url: (0, _uriTemplates2.default)(CHANNEL_BADGE_URL).fill({
                            channel: channelInfo[channel]._id
                        }),
                        dataType: 'json'
                    }).done(function fetchChannelSubBadgeDone(response, status, jqXHR) {
                        resolve(lookupChannelSubBadge(response));
                    });
                } else {
                    resolve();
                }
            });
        });
    }
    return CHANNEL_BADGE_PROMISES[channel];
}

function fetchChannelRooms(session, channel, auth) {
    return new _promise2.default(function fetchChannelRoomsProcess(resolve, reject) {
        channelsToInfo(session, [channel]).then(function (channelInfo) {
            if (channelInfo && channelInfo[channel]) {
                ajax(session, {
                    url: (0, _uriTemplates2.default)(CHANNEL_ROOMS_URL).fill({
                        channel: channelInfo[channel]._id
                    }),
                    auth: auth,
                    dataType: 'json'
                }).done(function fetchChannelRoomsDone(response, status, jqXHR) {
                    if (response && _.isArray(response.rooms)) {
                        resolve(response.rooms);
                    } else {
                        resolve();
                    }
                });
            } else {
                resolve();
            }
        });
    });
}

function roomChannel(channelId, room) {
    return '#chatrooms:' + channelId + ':' + room;
}

function roomType(roomInfo) {
    switch (roomInfo.minimum_allowed_role) {
        case 'MODERATOR':
            return 'Mods-only';
        case 'EVERYONE':
            return 'Public';
        case 'SUBSCRIBER':
            var type = 'Subs-only';
            if (roomInfo.is_previewable) {
                type += ' (previewable)';
            }
            return type;
    }
}

function fetchRoomIdSubBadge(session, roomId, value) {
    if (!ROOMID_BADGE_PROMISES[roomId]) {
        ROOMID_BADGE_PROMISES[roomId] = {};
    }
    if (!ROOMID_BADGE_PROMISES[roomId][value]) {
        ROOMID_BADGE_PROMISES[roomId][value] = new _promise2.default(function fetchRoomIdSubBadgeProcess(resolve, reject) {
            ajax(session, {
                url: (0, _uriTemplates2.default)(ROOMID_BADGE_URL).fill({
                    room_id: roomId
                }),
                dataType: 'jsonp'
            }).done(function fetchRoomIdSubBadgeDone(response, status, jqXHR) {
                resolve(lookupGlobalBadgeData(response, 'subscriber', value));
            });
        });
    }
    return ROOMID_BADGE_PROMISES[roomId][value];
}

function loadBadges(session, channel, els) {
    var selector = '.twitch_badges';
    var items = els.find(selector);
    items.each(function loadTwitchBadgesEach(i, badge) {
        var $badge = $(badge);
        var roomId = $badge.data('twitch_room_id');
        var types = parseBadgeTag($badge.data('twitch_badges'));
        var typeInfo = parseBadgeTag($badge.data('twitch_badge_info'), true);
        _.each(types, function loadTwitchBadgesTypesEach(type) {
            var className = 'twitch_badge twitch_badge__' + type.type;
            var badgeContainer = $('<span>').addClass(className);
            $badge.append(badgeContainer);
            channelBadgeUrl(session, channel, roomId, type).then(function onTwitchbadgeUrl(data) {
                if (data) {
                    var title = data.title;
                    if (typeInfo[type.type]) {
                        title += ', ' + typeInfo[type.type] + '-Month Subscriber';
                    }
                    var img = $('<img>').attr({
                        title: title,
                        alt: title,
                        src: data.url,
                        width: 18,
                        height: 18
                    });
                    var srcset = [];
                    if (data.url2x) {
                        srcset.push(data.url2x + ' 2x');
                    }
                    if (data.url4x) {
                        srcset.push(data.url4x + ' 4x');
                    }
                    if (srcset.length) {
                        img.attr('srcset', srcset.join(', '));
                    }
                    badgeContainer.append(img);
                }
            });
        });
    });
}

/***/ }),

/***/ "/KSs":
/***/ (function(module, exports, __webpack_require__) {

var BufferStatusView = __webpack_require__("6G2X");

var urlUtil = __webpack_require__("Dn1P");
var uriTemplates = __webpack_require__("0a14");


var ServerLogStatusView = BufferStatusView.extend({
    events: $.extend({}, BufferStatusView.prototype.events, {
        'buttonClick button.reconnect': 'clickReconnect',
        'buttonClick button.disconnect': 'clickDisconnect'
    }),
    clickReconnect: function (e) {
        this.model.connection.reconnect();
        return false;
    },
    clickDisconnect: function (e) {
        this.model.connection.disconnect();
        return false;
    },
    render: function () {
        BufferStatusView.prototype.render.apply(this, arguments);
        
        this.host = $('<span class="host">');
        this.title.append(this.host);
        
        var identity = $('<div class="identity">');
        
        this.nick = $('<span class="nick">');
        this.name = $('<span class="realname">');
        identity.append(this.nick).append(' ').append(this.name);
        
        $(this.el).append(identity);
        
        return this;
    },
    renderLabel: function () {
        this.label.html(this.formatter.render(this.model.connection.getTitle()));
        if (this.model.connection.isSlack()) {
            this.label.prepend('<i class="fa fa-slack" title="Slack workspace">');
        } else if (this.model.connection.isSSL()) {
            this.label.prepend('<i class="fa fa-shield" title="Secure connection">');
        } else {
            this.label.prepend('<i class="fa fa-globe">');
        }
        var icon = this.model.connection.getServerIcon();
        if (icon && this.model.inlineImagesAllowed()) {
            var size = 32;
            var iconTemplate = urlUtil.toHttps(icon);
            var url_1x = uriTemplates(iconTemplate).fill({
                size: size
            });
            var imgAttribs = {
                'class': 'serverIcon',
                width: size,
                height: size,
                src: url_1x
            };
            if (url_1x != iconTemplate) {
                imgAttribs.srcset = url_1x + ' 1x, ' + uriTemplates(iconTemplate).fill({
                    size: size * 2
                }) + ' 2x';
            }
            var iconHtml = '<img' + this.formatter.makeAttributes(imgAttribs) + '>';
            this.label.prepend(iconHtml);
        }
        return this;
    },
    renderConnectionDetails: function () {
        this.host.text(this.model.connection.getHost());
        this.nick.text(this.model.connection.getNick());
        this.name.html(this.formatter.renderLinkify(this.model.connection.get('realname')));
        this.renderLabel();
    },
    renderButtons: function () {
        BufferStatusView.prototype.renderButtons.apply(this);
        this.appendButton('edit', 'Edit');
        this.appendButton('reconnect', 'Reconnect');
        this.appendButton('disconnect', 'Disconnect');
        
        this.appendOptionsButton();
    }
});

module.exports = ServerLogStatusView;


/***/ }),

/***/ "/SwS":
/***/ (function(module, exports) {

$.fn.addSpin = function () {
    this.removeSpin();
    var button;
    if (this.is('button')) {
        button = this.find('span, a');
    } else {
        button = this.find('[type=submit] span, [type=submit] a');
    }
    button.prepend('<i class="spin">');
    return this;
};
$.fn.removeSpin = function () {
    this.find('i.spin').remove();
    return this;
};

$.fn.highlightFlash = function (timeout) {
    timeout = timeout || 2000;
    var className = 'highlight-flash';
    var self = this;
    self.addClass(className);
    setTimeout(function () {
        self.removeClass(className).addClass(className + '--off');
    }, timeout);
    return self;
};

$.fn.cursorRange = function (start, end) {
    // TODO IE support http://stackoverflow.com/questions/235411
    if (start !== undefined) {
        // Set
        if (end === undefined) {
            end = start;
        }
        this.filter('textarea, input').each(function () {
            this.selectionStart = start;
            this.selectionEnd = end;
        });
        
        return this;
    } else {
        // Get
        var input = this.filter('textarea, input').get(0);
        
        return {
            start: input.selectionStart,
            end: input.selectionEnd
        };
    }
};

$.fn.serializeForm = function () {
    var params = {};
    _.each(this.serializeArray(), function (item, i) {
        params[item.name] = item.value;
    });
    return params;
};


/***/ }),

/***/ "/Vo5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/WYa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cropperjs = __webpack_require__("4RJ8");

var _cropperjs2 = _interopRequireDefault(_cropperjs);

__webpack_require__("5Qkr");

var _avatar = __webpack_require__("lKP6");

var _avatar2 = _interopRequireDefault(_avatar);

var _connection = __webpack_require__("LLdI");

var _connection2 = _interopRequireDefault(_connection);

var _dialogview = __webpack_require__("EjYC");

var _dialogview2 = _interopRequireDefault(_dialogview);

var _avatarUploadDialog = __webpack_require__("pRb+");

var _avatarUploadDialog2 = _interopRequireDefault(_avatarUploadDialog);

__webpack_require__("D6pB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Super = _dialogview2.default.prototype;

exports.default = _dialogview2.default.extend({

    showInstant: true,
    hideInstant: true,

    template: _avatarUploadDialog2.default,

    className: 'avatarUploadDialog accountContainer form',

    events: _.extend({}, Super.events, {
        'submit .avatarUploadDialog__form': 'onSubmit'
    }),

    initialize: function initialize(options) {
        Super.initialize.apply(this, arguments);

        this.model.bind('avatarPreview', this.renderPreview, this);
    },
    onSubmit: function onSubmit(e) {
        e.preventDefault();
        if (this.avatar && this.cropper) {
            var canvas = this.cropper.getCroppedCanvas();
            // Recreate the blob as the originl mime type
            var dataUrl = canvas.toDataURL(this.avatar.getType());
            var blob = _avatar2.default.blobFromDataURI(dataUrl);
            blob.name = this.avatar.getName();
            var avatar = _avatar2.default.fromFile(blob, this.model);
            var cropData = this.cropper.getData(true);
            var data = $(e.currentTarget).serializeForm();
            avatar.set({
                width: cropData.width,
                height: cropData.height,
                is_primary: data.primary == '1'
            });
            avatar.bind('avatar-uploadSuccess', function () {
                avatar.cacheDataUrl(dataUrl);
                this.hide();
            }, this);
            avatar.bind('avatar-uploadError', function () {
                this.model.trigger('postError', avatar.getError());
            }, this);
            this.finalise(avatar, dataUrl);
        }
    },
    finalise: function finalise(avatar, dataUrl) {
        this.model.trigger('finaliseAvatarFromPromise', avatar, dataUrl);
    },
    render: function render() {
        this.$el.html(this.template());
        this.afterRender();
        return this;
    },
    afterRender: function afterRender() {
        this.cropperWrapper = this.$('.avatarCropper__wrapper');
        this.cropperImg = this.cropperWrapper.find('.avatarCropper__image');
    },
    closed: function closed() {
        this.localFileData = null;
        this.avatar = null;
        if (this.cropper) {
            this.cropper.destroy();
            this.cropper = null;
        }
        Super.closed.apply(this, arguments);
    },
    renderPreview: function renderPreview(target, avatar, options) {
        var primary = target === this.model;
        this.localFileData = null;
        this.avatar = avatar;

        if (this.avatar.localFile && window.FileReader) {
            this.readFileData().done(_.bind(function (src) {
                if (target instanceof _connection2.default) {
                    this.$('.avatarChooser__nick').text(target.getNick());
                    this.$('.avatarChooser__network').text(target.getDisplayName());
                    this.$('.avatarChooser__connection').show();
                } else {
                    this.$('.avatarChooser__connection').hide();
                }
                this.$('.avatarUploadDialog__set-default').toggle(!primary);
                this.show();
                this.initCropper();
            }, this));
        } else {
            // No preview possible, finalise
            this.finalise(this.avatar);
        }
    },
    readFileData: function readFileData() {
        var fileRead = new $.Deferred().done(_.bind(function (src) {
            this.localFileData = src;
        }, this));
        if (this.localFileData) {
            fileRead.resolve(this.localFileData);
        } else {
            var reader = new window.FileReader();
            reader.onload = function (e) {
                fileRead.resolve(e.target.result);
            };
            reader.readAsDataURL(this.avatar.localFile);
        }
        return fileRead.promise();
    },
    initCropper: function initCropper() {
        var _this = this;

        this.$el.addClass('avatarEditor--cropper');
        if (this.cropper) {
            this.cropper.destroy();
        }
        this.cropperImg.attr('src', this.localFileData).one('load', function (e) {
            var isSquare = _this.cropperImg[0].width === _this.cropperImg[0].height;
            var autoCrop = isSquare ? 1 : 0.8;
            _this.cropper = new _cropperjs2.default(_this.cropperImg[0], {
                viewMode: 2,
                aspectRatio: 1,
                autoCropArea: autoCrop,
                toggleDragModeOnDblclick: false,
                preview: '.avatarPreview__previewThumb',
                minCropBoxWidth: 32,
                minCropBoxHeight: 32,
                zoomable: false
            });
        });
    }
});

/***/ }),

/***/ "/Wd8":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");
var util = __webpack_require__("GmLC");


var NoAuthDialogView = DialogView.extend({
    el: '#noAuth',
    closeOnEsc: false,
    initialize: function (options) {
        this.init();
        
        this.router = options.router;
        this.router.bind('route', this.onRoute, this);
        this.router.route('?/password-reset', 'passwordReset', _.bind(this.showForgotPassword, this));
        this.router.route('?/error=:error', 'showError', _.bind(this.showError, this));
        this.router.route('?/team-error=:error', 'showError', _.bind(this.showError, this));
        this.router.route('?/account-deleted', 'showAccountDeleted', _.bind(this.showAccountDeleted, this));
        this.router.route('?/invite=:key&email=:email', 'fillSignup', _.bind(this.fillSignup, this));
        this.router.route('?/invite=:key&email=:email&url=*url', 'fillSignup', _.bind(this.fillSignup, this));
        
        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit form.signin': 'signIn',
        'submit form.signupForm': 'signUp',
        'submit form.forgotPasswordForm': 'forgotPassword',
        'click .aboutReveal': 'clickAboutReveal',
        'click .signinReveal': 'clickSigninReveal',
        'click .noAuthAbout .noAuthOverlayClose': 'clickAboutClose',
        'click .noAuthSignin .noAuthOverlayClose': 'clickSigninClose',
        'click .noAuthForgotPassword .noAuthOverlayClose': 'clickForgotClose',
        'click .noAuthShade': 'clickShade'
    }),
    init: function () {
        this.$('form.signupForm').show();
        this.hideOverlays();
        
        this.$('.signupInfo').hide();
        this.$('.signupInfo.none').show();
        this.$('.accountDeleted').hide();
        this.$('.noAuthSignupNick').hide();
        this.$('.inviteEmail').hide();
        this.$('.noAuthSignupEmail').show();
    },  
    onRoute: function (route, args) {
        if (!this.model.isAuthed()) {
            if (!_.include(['passwordReset'], route)) {
                this.hideForgot();
            }
        }
    },
    showError: function (error) {
        var msg;
        switch (error) {
        case 'invalid_invite':
            msg = 'Invalid invite key';
            break;
        case "redeemed_elsewhere":
            msg = "This invite has already been used";
            break;
        case "org_deleted":
            msg = "This team has been deleted";
            break;
        case "invite_revoked":
            msg = "This invite has been revoked";
            break;
        default:
            msg = 'An error occurred';
            break;
        }
        this.$('.urlError').text(msg).fadeIn('fast');
    },
    showAccountDeleted: function () {
        this.$('.accountDeleted').fadeIn('fast');
    },
    clickAboutReveal: function (e) {
        e.preventDefault();
        this.$('.noAuthAbout, .noAuthShade').show();
        setTimeout(_.bind(function () {
            this.$el.addClass('showAbout');
        }, this), 0);
    },
    clickAboutClose: function (e) {
        e.preventDefault();
        this.$('.noAuthAbout, .noAuthShade').hide();
        this.$el.removeClass('showAbout');
    },
    clickSigninReveal: function (e) {
        e.preventDefault();
        this.$('.noAuthSignin, .noAuthShade').show();
        this.focusLoginEmail();
        setTimeout(_.bind(function () {
            this.$el.addClass('showSignin');
        }, this), 0);
    },
    clickSigninClose: function (e) {
        e.preventDefault();
        this.$('.noAuthSignin, .noAuthShade').hide();
        this.$el.removeClass('showSignin');
    },
    clickShade: function (e) {
        e.preventDefault();
        this.hideOverlays();
    },
    showForgotPassword: function () {
        this.$('.noAuthForgotPassword, .noAuthShade').show();
        this.$('#noAuthForgotEmail').val(this.$('#noAuthSigninEmail').val());
        this.focusForgotPasswordEmail();
        setTimeout(_.bind(function () {
            this.$el.addClass('showForgot').removeClass('showSignin').removeClass('showAbout');
        }, this), 0);
    },
    clickForgotClose: function (e) {
        e.preventDefault();
        this.hideForgot();
    },
    hideForgot: function () {
        if (this.$el.hasClass('showForgot')) {
            this.model.back();
            this.$('.noAuthForgotPassword, .noAuthShade').hide();
            this.$el.removeClass('showForgot');
        }
    },
    hideOverlays: function () {
        this.hideForgot();
        this.$('.noAuthOverlay, .noAuthShade').hide();
        this.$el.removeClass('showSignin').removeClass('showAbout');
    },
    fillSignupNetwork: function (url) {
        var bufferParts = util.getBufferParts(url);
        var legacyBufferParts = util.getBufferPartsLegacy(
            url, Backbone.history.getHash()
        );
        if (legacyBufferParts) {
            if (
                !bufferParts ||
                !bufferParts.hostname ||
                (!bufferParts.buffer && legacyBufferParts.buffer)
            ) {
                bufferParts = legacyBufferParts;
            }
        }
        this.$('[name=invite_url]').val(url);
        this.$('.signupInfo').hide();
        if (bufferParts && bufferParts.hostname) {
            if (bufferParts.buffer) {
                this.$('.signupInfo .channel').text(bufferParts.buffer);
                this.$('.signupInfo .network').text(bufferParts.hostname);
                this.$('.signupInfo.channel').show();
            } else {
                this.$('.signupInfo .network').text(bufferParts.hostname);
                this.$('.signupInfo.network').show();
            }
            this.$('.noAuthSignupNick').show();
        }
    },
    fillOrgSignup: function (key, email, orgName) {
        this.$('[name=org_invite]').val(key);
        this.$('.signupInfo .org').text(decodeURIComponent(orgName));
        this.$('.signupInfo.org').show();
        this.fillSignup('', email);
    },
    fillSignup: function (key, email, url) {
        if (this.model.isAuthed()) {
            if (url) {
                this.model.trigger('navigate', 'irc/' + url, {replace: true, trigger: true});
            } else {
                this.model.trigger('startFallback');
            }
        } else {
            if (url) {
                this.fillSignupNetwork(url);
            }
            this.$('.noAuthSignupEmail').hide();
            this.$('#noAuthSignupEmail').prop('disabled', true);
            this.$('#noAuthSignupEmailHidden').prop('disabled', false);
            
            email = decodeURIComponent(email);
            var emailParts = email.split('@');
            var nick = emailParts[0].replace(NoAuthDialogView.VALID_NICK_RE, '');
            if (nick.match(/^\d/)) {
                nick = 'user_' + nick;
            }
            this.$('#noAuthSignupNick').val(nick);
            
            this.$('.accountEmail').text(email);
            this.$('[name=signup_email]').val(email);
            this.$('[name=email]').val(email);
            this.$('.inviteEmail').show();
            this.$('[name=invite]').val(key);
        }
    },
    afterShow: function () {
        this.focusSignupNick();
        this.renderImages();
    },
    renderImages: function () {
        if (!this.renderImagesDone) {
            this.renderImagesDone = true;
            var devices = this.$('.mobileDevices');
            devices.append($('<img>')
                .attr('src', window.IRCConfig.static_path + '/landing/imgs/ipad.png')
                .addClass('mobileIpad')
            );
            devices.append($('<img>')
                .attr('src', window.IRCConfig.static_path + '/landing/imgs/iphone.png')
                .addClass('mobileIphone')
            );
            devices.append($('<img>')
                .attr('src', window.IRCConfig.static_path + '/landing/imgs/android.png')
                .addClass('mobileAndroid')
            );
        }
    },
    focusSignupNick: function () {
        this.$('#noAuthSignupNick').focus().select();
    },
    focusLoginEmail: function () {
        this.$('#noAuthSigninEmail').focus().select();
    },
    focusForgotPasswordEmail: function () {
        this.$('#noAuthForgotEmail').focus().select();
    },
    isValidNick: function (nick) {
        if (nick.length > 30) {
            return false;
        }
        if (nick.match(/^[0-9-]/)) {
            return false;
        }
        if (nick.match(NoAuthDialogView.VALID_NICK_RE)) {
            return false;
        }
        return true;
    },
    forgotPassword: function (e) {
        e.preventDefault();
        var form = $(e.target);
        form.find('.userError').hide();
        form.find('.userSuccess').hide();
        var email = this.$('#noAuthForgotEmail').val();
        this.model.forgotPassword(email, _.bind(function (response) {
            if (response.success) {
                form.find('.userSuccess').fadeIn('fast');
            } else {
                var msg;
                switch (response.message) {
                case 'email':
                    msg = 'Invalid email address';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                default:
                    msg = 'Error sending password reset';
                }
                form.find('.userError').text(msg).fadeIn('fast');
            }
        }, this));
    },
    signUp: function (e) {
        e.preventDefault();
        var form = $(e.target);
        form.find('.userError').hide();
        var formData = form.serializeForm();
        var data = {
            email: formData.signup_email,
            password: formData.signup_password,
            realname: formData.signup_realname,
            invite: formData.invite,
            org_invite: formData.org_invite,
            invite_url: formData.invite_url
        };
        if (form.find('.noAuthSignupNick').is(':visible')) {
            var nick = form.find('#noAuthSignupNick').val();
            if (!nick) {
                form.find('.nickMissing').fadeIn('fast');
                return;
            }
            if (!this.isValidNick(nick)) {
                form.find('.nickInvalid').fadeIn('fast');
                return;
            }
            data.nickname = nick;
        }
        form.addSpin();
        this.model.signup(data, _.bind(function (response) {
            form.removeSpin();
            if (response.success) {
                this.startSession(response, formData.invite_url);
                this.hide();
            } else {
                var msg;
                switch (response.message) {
                case 'missing_nick':
                    form.find('.nickMissing').fadeIn('fast');
                    break;
                case 'invalid_nick':
                    form.find('.nickInvalid').fadeIn('fast');
                    break;
                case 'email':
                    msg = 'Invalid email address';
                    break;
                case 'email_exists':
                    msg = 'This email address is already in use, please sign in or try another';
                    break;
                case 'invalid_invite':
                    msg = 'Invalid invite key';
                    break;
                case 'password':
                    msg = 'Invalid password';
                    break;
                case "password_too_long":
                    msg = 'Maximum password length: ' + window.IRCConfig.max_password_length;
                    break;
                case "password_error":
                    msg = 'Invalid password, try again';
                    break;
                case 'realname':
                    form.find('.realnameInvalid').fadeIn('fast');
                    break;
                case 'banned':
                    msg = 'Signup server unavailable, please try again later';
                    break;
                case 'bad_email':
                    msg = 'No signups allowed from that domain';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                case 'rate_limited':
                    msg = 'Too many signups from your IP. Try again later.';
                    break;
                case 'ip_banned':
                    msg = 'Signup server unavailable, please try again later';
                    break;
                case 'tor_blocked':
                    msg = 'No signups allowed from TOR exit nodes';
                    break;
                case 'signup_ip_blocked':
                    msg = 'Your IP address has been blacklisted';
                    break;
                default:
                    msg = 'Error signing up your account: ' + response.message;
                    break;
                }
                if (msg) {
                    form.find('.signupError').text(msg).fadeIn('fast');
                }
            }
        }, this));
    },
    startSession: function (response, inviteUrl) {
        window.WS_SOCKET_HOST = response.websocket_host;
        window.WS_SOCKET_PATH = response.websocket_path;
        window.API_HOST = response.api_host;
        var url = response.url;
        if (!url && inviteUrl) {
            url = 'irc/' + inviteUrl;
        }
        this.model.startSession(response.session, url);
    },
    signIn: function (e) {
        e.preventDefault();
        var form = $(e.target);
        form.find('.userError').hide();
        var inviteUrl = form.find('[name=invite_url]').val();
        form.addSpin();
        this.model.signin({
            email: form.find('[name=email]').val(),
            password: form.find('[name=password]').val(),
            invite_url: inviteUrl
        }, _.bind(function (response) {
            form.removeSpin();
            if (response.success) {
                this.startSession(response, inviteUrl);
            } else {
                var msg;
                switch (response.message) {
                case "auth":
                    msg = 'Incorrect email or password';
                    break;
                case "email":
                    msg = 'Email left blank';
                    break;
                case "password":
                    msg = 'Password left blank';
                    break;
                case "rate_limited":
                    msg = 'Rate limited, try again in a few mins';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                case "email_exists":
                    msg = 'An account with this email already exists';
                    break;
                case "password_too_long":
                    msg = 'Maximum password length: ' + window.IRCConfig.max_password_length;
                    break;
                case "password_error":
                    msg = 'Invalid password, try again';
                    break;
                case "external_failed":
                    msg = 'Authentication server error';
                    break;
                default:
                    msg = 'Error signing in';
                    break;
                }
                form.find('.signinError').text(msg).fadeIn('fast');
            }
        }, this));
    }
}, {
    VALID_NICK_RE: /[^a-z0-9_\\[\]{}^`|-]/gi
});


module.exports = NoAuthDialogView;


/***/ }),

/***/ "/ybZ":
/***/ (function(module, exports, __webpack_require__) {

var BufferListChildView = __webpack_require__("1ka6");


var BufferListChannelView = BufferListChildView.extend({
    className: BufferListChildView.prototype.className + ' channel',
    getTemplate: function () {
        if (!BufferListChannelView._structure) {
            var structure = BufferListChildView.prototype.getTemplate.call(this);
            structure.append('<i class="fa fa-lock">');
            BufferListChannelView._structure = structure;
        }
        return BufferListChannelView._structure.clone();
    },
    render: function () {
        BufferListChildView.prototype.render.call(this);
        
        this.renderMode();
        this.renderTwitch();
        this.model.bind('modeChange', this.renderMode, this);
        this.model.bind('twitchChannelChange', this.renderTwitch, this);
        return this;
    },
    renderMode: function () {
        $(this.el).toggleClass('secret', this.model.hasMode('s'));
        $(this.el).toggleClass('private', this.model.hasMode('p'));
        $(this.el).toggleClass('moderated', this.model.hasMode('m'));
        $(this.el).toggleClass('inviteOnly', this.model.hasMode('i'));
        $(this.el).toggleClass('password', this.model.isPassworded());
        $(this.el).toggleClass('topicControl', this.model.hasMode('t'));
        $(this.el).toggleClass('noExternal', this.model.hasMode('n'));
        $(this.el).toggleClass('limited', this.model.hasMode('l'));
        return this;
    },
    renderTwitch: function () {
        if (this.model.connection.isTwitch()) {
            this.renderLinkText();
            $(this.el).toggleClass(
                'twitch_restricted_room',
                this.model.isTwitchRestrictedRoom()
            );
        }
    },
    renderLinkText: function () {
        var displayName = this.model.getDisplayName();
        var tooltip = this.model.getDisplayNameWithConnection();
        var twitchInfo = this.model.getTwitchInfo();
        var twitchDisplayName = this.model.getTwitchDisplayName(twitchInfo);
        if (twitchDisplayName) {
            if (twitchInfo.game) {
                tooltip = 'Playing ' + twitchInfo.game;
                if (twitchInfo.viewers) {
                    tooltip += ' (' + twitchInfo.viewers.toLocaleString() + ' viewers)';
                }
            } else if (twitchInfo.viewers) {
                tooltip = twitchInfo.viewers.toLocaleString() + ' viewers';
            } else {
                tooltip = 'Offline';
            }
            var tooltipPrefix = twitchDisplayName;
            if (twitchInfo.channel.name.toLowerCase() != twitchDisplayName.toLowerCase()) {
                tooltipPrefix += ' (' + twitchInfo.channel.name + ')';
            }
            tooltip = tooltipPrefix + ' — ' + tooltip;
            displayName = twitchDisplayName;
        }
        if (this.model.isTwitchRoom()) {
            var roomParts = this.model.getTwitchRoomNameParts();
            if (roomParts) {
                tooltip = roomParts.join(' : ');
            }
        }
        this.link.attr('title', tooltip);
        this.setLinkLabelHtml(this.formatter.render(this.model.disambiguateListName(displayName, this.model.getName())));

        if (twitchDisplayName) {
            if (twitchInfo.viewers) {
                var twitchStatus = $('<span class="twitchStatus">');
                twitchStatus.append('<i class="fa fa-play-circle">');
                this.linkLabel.prepend(twitchStatus);
            }
        }
        var safeChanSuffix = this.model.safeChanSuffix();
        if (safeChanSuffix) {
            this.linkLabel.append(' ').append($('<small>').text(safeChanSuffix));
        }
        return this;
    }
});


module.exports = BufferListChannelView;


/***/ }),

/***/ "/zkE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0LDK":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<div class=\"g channelLinks__live-region\" aria-live=\"polite\"></div>\n<ul>\n";
  stack1 = ((helper = (helper = lookupProperty(helpers,"filtered") || (depth0 != null ? lookupProperty(depth0,"filtered") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"filtered","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":0},"end":{"line":6,"column":13}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"filtered")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</ul>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li class=\"channelLinks__item\"><a href=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"href") || (depth0 != null ? lookupProperty(depth0,"href") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"href","hash":{},"data":data,"loc":{"start":{"line":5,"column":40},"end":{"line":5,"column":48}}}) : helper)))
    + "\" class=\"channelLinks__link\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"displayName") || (depth0 != null ? lookupProperty(depth0,"displayName") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"displayName","hash":{},"data":data,"loc":{"start":{"line":5,"column":77},"end":{"line":5,"column":92}}}) : helper)))
    + " <span class=\"channelLinks__serverName\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"serverName") || (depth0 != null ? lookupProperty(depth0,"serverName") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"serverName","hash":{},"data":data,"loc":{"start":{"line":5,"column":132},"end":{"line":5,"column":146}}}) : helper)))
    + "</span></a></li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"filtered") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":8,"column":7}}})) != null ? stack1 : "");
},"useData":true});

/***/ }),

/***/ "0bCg":
/***/ (function(module, exports, __webpack_require__) {

var Pastebin = __webpack_require__("RvJ1");


var PastebinView = Backbone.View.extend({
    tagName: 'div',
    className: 'paste',
    model: Pastebin,
    events: {
        'buttonClick .deleteButton': 'removePrompt',
        'buttonClick .editButton': 'toggleEdit',
        'buttonClick .linesButton': 'toggleLines',
        'buttonClick .editForm .cancel': 'toggleEdit',
        'submit .editForm': 'submitEditForm'
    },
    lines: function (lineLen) {
        lineLen = lineLen || this.model.get('lines');
        var lines = '';
        if (lineLen) {
            lines = lineLen + ' line';
            if (lineLen != 1) {
                lines += 's';
            }
        }
        return lines;
    },
    toggleLines: function (e) {
        e.preventDefault();
        this.doToggleLines();
    },
    doToggleLines: function () {
        this.$el.toggleClass('nolinenums');
        this.ace.renderer.setShowGutter(!this.ace.renderer.getShowGutter());
    },
    updateSyntaxSelect: function (name) {
        var value = this.getAceMode(name).name;
        this.select.val(value).change();
    },
    chooseExtension: function (name, ext) {
        // Choose an extension from modelist, can be multiple e.g. sh = sh|bash|^.bashrc
        var modelist = window.ace.require("ace/ext/modelist");
        var mode = modelist.modesByName[ext];
        var match = name.match(mode.extRe);
        if (match) {
            return match[0].split('.').pop();
        } else {
            return mode.extensions.split('|')[0].replace(/^\^\.?/, ''); 
        }
    },
    getAceTheme: function () {
        var theme = (
            PastebinView.themeMap[this.model.getTheme()] ||
            PastebinView.themeMap['dawn']
        );
        return 'ace/theme/' + theme;
    },
    getAceMode: function (name) {
        var modelist = window.ace.require("ace/ext/modelist");
        var mode;
        if (name) {
            mode = modelist.getModeForPath(name);
        } else {
            mode = modelist.getModeForPath(this.model.get('extension'));
            var dotMode = modelist.getModeForPath('.' + this.model.get('extension'));
            if (mode.name != dotMode.name) {
                mode = (mode.name === 'text') ? dotMode : mode;
            }
        }
        mode.path = mode.mode;
        return mode;
    },
    aceModePretty: function (mode) {
        if (mode.name == 'text') {
            return 'Plain Text';
        }
        return mode.caption;
    },
    renderSyntaxSelect: function (nameInput) {
        this.select = $('<select name="aceMode">');
        var langs = [];
        var modelist = window.ace.require("ace/ext/modelist");
        _.each(modelist.modesByName, function (mode, name) {
            if (name !== 'text') {
                langs.push(mode);
            }
        });
        langs.sort(function (a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
        langs.unshift(modelist.modesByName.text);
        _.each(langs, _.bind(function (mode) {
            this.select.append($('<option>').attr('value', mode.name).text(this.aceModePretty(mode)));
        }, this));
        this.updateSyntaxSelect();

        this.select.on('change', _.bind(function () {
            var mode = modelist.modesByName[this.select.val()];
            mode.path = mode.mode;
            this.updateMode(mode);
        }, this));

        if (nameInput) {
            nameInput.on('input keyup update', _.debounce(_.bind(function () {
                this.updateSyntaxSelect(nameInput.val());
            }, this), 10));
        }
        return this;
    },
    toggleEdit: function (e) {
        if (e) {
            e.preventDefault();
        }
        this.hideEditError();
        this.renderName();
        this.renderBody();
        this.updateSyntaxSelect();
        this.$el.toggleClass('edit');
        var readOnlyCurrent = this.ace.getOption('readOnly');
        this.ace.setOptions({
            readOnly: !readOnlyCurrent,
            // workaround for disappearing editor when clearing all and
            // beginning to type an html tag/or other foldable line on the first line
            minLines: readOnlyCurrent ? 7 : 1
        });
        this.ace.resize();
        this.$('.nameInput').select().focus();
        this.trigger('toggleEdit');
    },
    save: function (name, callback) {
        var aceMode = this.select ? this.select.val() : this.getAceMode().name;
        var extension = this.chooseExtension(name, aceMode);
        var body = this.ace ? this.editorContents() : this.model.getBody();
        return this.model.save({
            name: name,
            extension: extension,
            contents: body
        }, callback);
    },
    submitEditForm: function (e) {
        e.preventDefault();
        this.editForm.addSpin();
        var data = this.editForm.serializeForm();
        this.hideEditError();
        var extension = this.chooseExtension(data.name, data.aceMode);
        var body = this.editorContents();
        this.model.edit({
            name: data.name,
            extension: extension,
            body: body
        }, _.bind(function (response) {
            this.editForm.removeSpin();
            if (response.success) {
                this.toggleEdit();
            } else {
                var message = "";
                switch (response.message) {
                case 'auth':
                    message = 'You don’t have permission to edit this pastebin';
                    break;
                case 'missing_extension':
                    message = 'Missing file extension';
                    break;
                case 'not_found':
                    message = 'Unknown pastebin';
                    break;
                case 'paste_too_large':
                    message = "Sorry, you can’t paste more than 50 KB of text.";
                    break;
                case 'paste_invalid':
                    message = "Sorry, you need to paste valid UTF8.";
                    break;
                case 'paste_empty':
                    message = "No empty pastes allowed";
                    break;
                case 'server_error':
                    message = 'There was a problem editing this pastebin';
                    break;
                default:
                    message = 'There was a problem editing this pastebin: ' + response.message;
                    break;
                }
                this.showEditError(message);
            }
        }, this));
    },
    hideEditError: function () {
        this.editError.hide();
    },
    showEditError: function (text) {
        this.editError.text(text).fadeIn('fast');
    },
    removePrompt: function (e) {
        e.preventDefault();
        var actions = this.$('span.actions');
        var confirm = this.$('span.confirm');
        confirm.one('buttonClick', 'button', _.bind(function (e) {
            confirm.hide();
            if ($(e.target).is('button.delete')) {
                this.model.remove(function (response) {
                    if (!response.success && response.message != 'not_found') {
                        actions.removeClass('show');
                    }
                });
            } else {
                actions.removeClass('show');
            }
            return false;
        }, this));
        confirm.show();
        actions.addClass('show');
    },
    clearTimeago: function () {
        this.$('.details .date').timeago('dispose');
    },
    collapse: function (animate) {
        this.clearTimeago();
        if (animate) {
            $(this.el).slideUp(100).fadeOut();
        } else {
            $(this.el).hide();
        }
    },
    renderEditForm: function () {
        var nameInput = $('<input class="input nameInput" name="name">');
        this.renderSyntaxSelect(nameInput);
        var editSubmit = $('<button type="submit" class="action">').append($('<span>').text('Save'));
        var editCancel = $('<button type="button" class="cancel">').append($('<span>').text('Cancel'));
        return $('<form action="" method="post" class="editForm">')
            .append($('<p class="form">')
                .append(nameInput)
                .append(this.select)
                .append(editSubmit)
                .append(editCancel)
            );
    },
    syntax: function () {
        return this.aceModePretty(this.getAceMode());
    },
    renderName: function () {
        this.$('.nameInput').val(this.model.get('name'));
        this.$('.name').text(this.model.get('name'));
    },
    renderLines: function () {
        this.$('span.lines').text(this.lines());
    },
    renderSyntax: function () {
        this.$('.syntax').text(this.syntax());
    },
    renderMobileHeader: function (options) {
        var header = $('<div class="mobileHeader">');
        
        header.append($('<p class="name">'));
        
        var date = this.model.getDate();
        var formatString = 'dd MMMM yyyy HH:mm';
        header.append($('<p class="date">').text(date.toString(formatString)));
        
        header.append($('<p class="info">')
            .append($('<span class="syntax">'))
            .append(' • ')
            .append($('<span class="lines">'))
        );
        
        return header;
    },
    renderHeader: function (options) {
        var header = $('<h1 class="header">');

        var details = $('<span class="details">')
            .append($('<span class="name">'))
            .append(' ')
            .append($('<span class="info">')
                .append($('<span class="syntax">'))
                .append(' • ')
                .append($('<span class="lines">'))
                .append(' ')
            );
        if (options.date) {
            var date = this.model.getDate();
            var dateContainer;
            if (options.linkDate) {
                dateContainer = $('<a target="_blank" rel="noreferrer">').attr('href', this.model.getUrl());
            } else {
                dateContainer = $('<span>');
            }
            dateContainer
                .addClass('date')
                .attr('title', date.toISOString())
                .text(date.formatFullDate())
                .timeago();
            details
                .append(dateContainer)
                .append(' ');
        }
        var modes = $('<span class="modes">');
        if (this.model.get('external_url')) {
            var externalUrl;
            try {
                externalUrl = new window.URL(this.model.get('external_url'));
            } catch (exc) {
                // pass
            }
            if (externalUrl) {
                var externalLink = $('<a target="_blank" rel="noreferrer">').attr({
                    href: this.model.getUrl()
                }).text(this.model.get('service_url') || externalUrl.host);
                if (
                    this.model.get('service_name') == 'Slack' ||
                    /\.slack\.com$/.test(this.model.get('service_url')) ||
                    /\.slack\.com$/.test(externalUrl.host)
                ) {
                    externalLink.prepend('<i class="fa fa-slack">');
                }
                modes.append(externalLink);
                modes.append(' | ');
            }
        }

        var rawUrl = this.model.getRawUrl();
        if (rawUrl) {
            modes.append($('<a target="_blank" rel="noreferrer">').attr({
                href: rawUrl
            }).text('raw'));
            modes.append(' | ');
        }

        modes.append($('<button class="link linesButton">').text('line numbers'));
        modes.append(' ');
        details.append(modes);

        header.append(details);

        var actions = $('<span class="actions">');
        if (this.model.isOwn()) {
            this.editForm = this.renderEditForm();
            header.append(this.editForm);

            var deleteConfirm = $('<span class="confirm">')
                .append($('<span class="explanation">').text('Are you sure?'))
                .append($('<button type="button" class="delete">').append($('<span>').text('Yup, trash it')))
                .append($('<button type="button" class="cancel">').append($('<span>').text('Cancel')));
            header.append(deleteConfirm);

            actions.append($('<button class="link editButton">').text('edit'));
            actions.append(' • ');
            actions.append($('<button class="link deleteButton">').text('delete'));
            if (options.withClose) {
                actions.append(' • ');
            }
        }
        if (options.withClose) {
            actions.append($('<button class="link closeButton">').text('close'));
        }
        header.append(actions);

        if (this.model.isOwn()) {
            this.editError = $('<p class="userError editError">');
            header.append(this.editError);
        }

        return header;
    },
    focusEditor: function () {
        this.ace.focus();
    },
    editorContents: function () {
        return this.ace.getValue();
    },
    rendered: function () {
        this.model.bind('loaded', this.loaded, this);
        this.model.bind('fetchError', this.fetchError, this);
        this.model.bind('removed', this.removed, this);
        this.model.bind('change:name', this.renderName, this);
        this.model.bind('change:lines', this.renderLines, this);
        this.model.bind('change:extension', this.renderExtension, this);
        this.model.bind('change:body', this.renderBody, this);
        return this;
    },
    render: function (options) {
        options = options || {};
        if (options.header) {
            this.$el.append(this.renderHeader(options));
            if (options.standalone) {
                this.$el.append(this.renderMobileHeader(options));
            }
            this.renderLines();
        }

        this.renderName();
        this.renderSyntax();

        var editor = $('<div class="editor">').text(this.model.getBody());
        this.$el.append(editor);
        if (this.model.get('truncated')) {
            var moreLines = this.model.get('lines') - this.model.get('preview_lines');
            var fullLink = $('<a class="truncated">')
                .attr({
                    href: this.model.getUrl(),
                    target: '_blank',
                    rel: 'noreferrer'
                })
                .text('truncated… see full snippet');
            this.$el.append(fullLink);
        }
        this.ace = window.ace.edit(editor[0]);
        this.ace.commands.removeCommand('find');
        this.ace.commands.removeCommand('findnext');
        this.ace.commands.removeCommand('findprevious');
        this.ace.commands.removeCommand('gotoline');
        var aceOpts = {
            minLines: options.editable ? 8 : 1,
            // setting this any higher than 12 while inline breaks scrolling to bottom
            maxLines: options.standalone ? Infinity : 12, 
            readOnly: !options.editable,
            highlightActiveLine: false,
            highlightGutterLine: false,
            highlightSelectedWord: false,
            showPrintMargin: false,
            displayIndentGuides: true,
            theme: this.getAceTheme(),
            useSoftTabs: true,
            wrap: true,
            mode: "ace/mode/text",
            useWorker: false,
            cursorStyle: "slim",
            indentedSoftWrap: false
        };
        this.listenTo(this.model.session, 'prefChange:theme', function () {
            this.ace.setTheme(this.getAceTheme());
        }),
        this.ace.setOptions(aceOpts);
        this.updateMode();
        this.ace.renderer.on("afterRender", _.bind(function () {
            this.trigger('rendered');
        }, this));
        this.ace.renderer.on('resize', _.bind(function () {
            this.trigger('editorResize');
        }, this));
        this.ace.on('focus', _.bind(function (e, editor) {
            if (!this.ace.getOption('readOnly')) {
                this.ace.setOptions({
                    highlightActiveLine: true,
                    highlightGutterLine: true,
                    highlightSelectedWord: true
                });
            }
        }, this));
        this.ace.on('blur', _.bind(function (e, editor) {
            if (!this.ace.getOption('readOnly')) {
                this.ace.setOptions({
                    highlightActiveLine: false,
                    highlightGutterLine: false,
                    highlightSelectedWord: false
                });
                this.ace.clearSelection();
            }
        }, this));

        this.rendered();

        return this;
    },
    loaded: function () {
        $(this.el).removeClass('loading').addClass('loaded');
    },
    renderExtension: function () {
        this.updateMode();
        this.renderSyntax();
        this.updateSyntaxSelect();
    },
    updateMode: function (mode) {
        mode = mode || this.getAceMode();
        this.ace.getSession().setMode(mode);
    },
    renderBody: function () {
        var aceSession = this.ace.getSession();
        var scrollTop = aceSession.getScrollTop();
        this.ace.setValue(this.model.getBody());
        this.ace.clearSelection();
        aceSession.setScrollTop(scrollTop);
    },
    fetchError: function (errorStatus, errorText) {
        var error = 'Error fetching paste';
        this.$('pre.body').text(error);
        $(this.el).removeClass('loading').addClass('error');
    },
    removed: function () {
        // If it's in the backlog, revert to the link
        this.collapse();
        // Clear the body in case it's not in a backlog
        this.$('pre.body').text('Pastebin deleted');
        $(this.el).removeClass('loading').addClass('error');
    }
}, {
    TRUNCATE_LENGTH: 500,
    MESSAGE_LENGTH_TRIGGER: 1080, // 3 lines of text
    themeMap: {
        dawn: 'crimson_editor',
        dusk: 'cobalt',
        tropic: 'solarized_dark',
        emerald: 'mono_industrial',
        sand: 'twilight',
        rust: 'mono_industrial',
        orchid: 'vibrant_ink',
        ash: 'twilight',
        midnight: 'twilight'
    },
    fromPaste: function (paste, session, el) {
        return new PastebinView({
            model: new Pastebin(paste, {
                session: session
            }),
            el: el
        });
    },
    fromBody: function (body, session) {
        return PastebinView.fromPaste({
            body: body
        }, session);
    },
    fromEl: function (el, session) {
        return PastebinView.fromPaste({
            id: $(el).data('id'),
            url: $(el).data('url')
        }, session, el);
    }
});

module.exports = PastebinView;


/***/ }),

/***/ "0lcd":
/***/ (function(module, exports, __webpack_require__) {

var FileWrapper = __webpack_require__("JHsc");


var FileProgressView = Backbone.View.extend({
    model: FileWrapper,
    tagName: 'li',
    className: 'fileProgress starting',
    initialize: function (options) {
    },
    events: {
        'click .cancel': 'clickCancel',
        'click .remove': 'clickRemove',
        'click a.file': 'clickFile'
    },
    clickFile: function (e) {
        if (this.model.showMessage()) {
            e.preventDefault();
        }
    },
    clickCancel: function (e) {
        e.preventDefault();
        this.model.cancelUpload();
    },
    clickRemove: function (e) {
        e.preventDefault();
        this.remove();
    },
    remove: function (callback) {
        var args = arguments;
        this.$el.slideUp(_.bind(function () {
            Backbone.View.prototype.remove.apply(this, args);
            if (callback) {
                callback();
            }
        }, this));
        return this;
    },
    uploadProgress: function (e, percentComplete) {
        this.setStatusClass('progress');
        this.progress.stop().animate({
            'width': percentComplete + '%'
        });
        this.status.text(percentComplete + '%');
    },
    uploadFinalise: function () {
        this.setStatusClass('finalising');
        this.status.text('Finishing…');
    },
    uploadCancelled: function () {
        this.setStatusClass('cancelled');
        this.status.text('Cancelled');
        this.uploadDone();
    },
    uploadError: function () {
        this.setStatusClass('error');
        this.status.text('Failed');
        this.uploadDone();
    },
    uploadSuccess: function () {
        this.render(true);
    },
    setStatusClass: function (status) {
        this.$el.removeClass('starting progress finalising cancelled error');
        this.$el.addClass(status);
    },
    uploadDone: function () {
        this.progress.stop().css('width', 'auto');
    },
    render: function (done) {
        var table = $('<table class="fileTable" cellpadding="0" cellspacing="0">');

        this.name = $('<td class="name" colspan="2">').text(this.model.getName());
        table.append($('<tr>').append(this.name));

        var infoStatus = $('<tr class="infoStatus">');

        var fileInfo = $('<td class="fileInfo explanation">')
            .append($('<span>').text(this.model.getSize()))
            .append(' • ')
            .append($('<span>').text(this.model.getType()));
        infoStatus.append(fileInfo);

        var statusCell = $('<td class="status">');
        this.status = $('<span class="statusText">');
        if (done) {
            this.status.text('Done');
        }
        statusCell.append(this.status);
        this.progress = $('<div class="progressBar">');
        statusCell.append(this.progress);
        infoStatus.append(statusCell);

        table.append(infoStatus);

        this.$el.empty();

        var link = $('<a href="" class="file" target="_blank">');
        if (done) {
            link.attr('href', this.model.getUrl());
            this.setStatusClass('success');
        }
        this.$el.append(link.append(table));

        this.rendered();

        return this;
    },
    rendered: function () {
        this.model.bind('uploadProgress', this.uploadProgress, this);
        this.model.bind('uploadFinalise', this.uploadFinalise, this);
        this.model.bind('uploadSuccess', this.uploadSuccess, this);
        this.model.bind('uploadCancelled', this.uploadCancelled, this);
        this.model.bind('uploadError', this.uploadError, this);
        return this;
    }
});

module.exports = FileProgressView;


/***/ }),

/***/ "0xAE":
/***/ (function(module, exports, __webpack_require__) {

var Connection = __webpack_require__("LLdI");
var RenderReasons = __webpack_require__("ilaq");
var Formatter = __webpack_require__("5gSh");
var SelectAutoComplete = __webpack_require__("cgtr");
var AvatarUploadPreview = __webpack_require__("ew4Z").default;
var util = __webpack_require__("GmLC");


var NetworkEditor = Backbone.View.extend({
    tagName: 'form',
    initialize: function (options) {
        this.$el.addClass('networkEditor');
        this.session = options.session;
        
        this.idPrefix = options.idPrefix || '';
        this.classPrefix = options.classPrefix || '';
        this.action = options.action;
        this.prepareFormData = options.prepareFormData;
        this.callback = options.callback;
        this.extraFields = options.extraFields;
        this.cellGroups = options.cellGroups;
        this.submitLabel = options.submitLabel || 'Submit';
        this.cancelLabel = options.cancelLabel || 'Cancel';
        this.tabFocus = options.tabFocus || 'Nick';
        this.cancel = options.cancel;
        this.afterSubmit = $.makeArray(options.afterSubmit);
        
        this.inputs = {};
        this.cells = {};
        this.nameMap = {};
        this.containers = {};
        this.error = null;
        this.submit = null;
        this.networkComplete = null;
        this.formatter = new Formatter();
    },
    events: {
        'load': 'onLoad',
        'submit': 'onSubmit',
        'click label': 'clickLabel',
        'change input.reveal[type=checkbox]': 'changeRevealPass'
    },
    onLoad: function (e) {
        // Load networks
        this.session.getNetworks(_.bind(function (response) {
            // Build option list
            var hostnameEl = this.input('Hostname');
            if (hostnameEl) {
                hostnameEl.html(this.$('.placeholder'));
                _.each(response.networks, function (net, i) {
                    _.each(net.servers, function (server, j) {
                        var option = $('<option>')
                            .text(net.name)
                            .data('hostname', server.hostname)
                            .data('port', server.port)
                            .data('ssl', server.ssl);
                        hostnameEl.append(option);
                    }, this);
                }, this);
            }
        }, this));
    },
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.$('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.$('input, button, textarea').prop('disabled', false);
        }
    },
    clickLabel: function (e) {
        var forId = $(e.target).attr('for');
        if (this.networkComplete && $('#' + forId).is(this.networkComplete.el)) {
            this.networkComplete.focus();
        }
    },
    changeRevealPass: function (e) {
        var t = $(e.target);
        var input = t.data('input');
        if (t.is(':checked')) {
            input.removeAttr('type');
        } else {
            input.attr('type', 'password');
        }
    },
    formData: function () {
        var data = this.serializeForm();
        if (this.prepareFormData) {
            return this.prepareFormData(data);
        } else {
            return data;
        }
    },
    onSubmit: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }
        var data = this.formData();
        this.disableForm();
        this.action(data, _.bind(function (response) {
            if (this.callback) {
                this.callback(response);
            }
            this.enableForm();
            if (response.success) {
                this.hideError();
            } else {
                var message;
                switch (response.message) {
                case 'hostname':
                    message = 'Please provide a valid <b>Hostname</b>';
                    break;
                case 'port':
                    message = 'Please provide a valid <b>Port</b>';
                    break;
                case 'nickname':
                    message = 'Please choose a valid <b>Nickname</b>';
                    break;
                case 'realname':
                    message = 'Please choose a valid <b>Real name</b>';
                    break;
                case 'passworded_servers':
                    message = '<a href="/?/upgrade">Upgrade now</a> to connect to passworded servers.';
                    break;
                case 'slack_disallowed':
                    message = '<a href="/?/upgrade">Upgrade now</a> to connect to Slack workspaces.';
                    break;
                case 'connection_unavailable':
                    message = 'This connection is temporarily unavailable. Try again later.';
                    break;
                case 'server_error':
                    message = 'There was a problem joining this network';
                    break;
                case 'too_many_connections':
                    message = 'You’ve exceeded the connection limit. Delete some connections before adding any more';
                    break;
                case 'restricted':
                    message = RenderReasons.renderRestricted(response.reason).replace(/<b>(.*)<\/b>/, '<a href="/?/upgrade">$1</a>');
                    break;
                case 'sts_policy':
                    message = 'You can’t disable secure connections to this network because it’s using a strict transport security policy';
                    break;
                default:
                    message = 'There was a problem joining this network: ' + this.formatter.escapeText(response.message);
                    break;
                }
                this.showError(message);
            }
        }, this));
    },
    serializeForm: function () {
        var data = this.$el.serializeForm();
        for (var k in this.nameMap) {
            if (k in data) {
                data[this.nameMap[k]] = data[k];
                delete data[k];
            }
        }
        if (this.extraFields) {
            $.extend(data, this.extraFields.serializeForm());
        }
        return data;
    },
    focusNick: function () {
        this.focusInput('Nick');
    },
    focusInput: function (input) {
        var inputEl = this.input(input);
        if (inputEl) {
            inputEl.focus().select();
        }
    },
    focusNetname: function () {
        this.focusInput('Netname');
    },
    focusNetwork: function () {
        if (this.networkComplete) {
            this.networkComplete.focus();
        }
    },
    focusChannels: function () {
        this.focusInput('Channels');
    },
    checkPort: function (port) {
        var port_s = util.stringify(port);
        if (this.lastPort !== port_s) {
            var plusMatches = port_s.match(/\+(\d+)/);
            if (plusMatches) {
                this.setSSL(true);
                this.lastPort = plusMatches[1];
                this.setInput('Port', plusMatches[1]);
            } else if (port_s == util.stringify(Connection.defaultSSLPort)) {
                this.lastPort = port_s;
                this.setSSL(true);
            } else if (port_s == util.stringify(Connection.defaultPort)) {
                this.lastPort = port_s;
                this.setSSL(false);
            }
        }
    },
    renderSelectComplete: function (container) {
        // Autodetect SSL port
        var portEl = this.input('Port');
        if (portEl) {
            portEl.on('input keyup update', _.bind(function (e) {
                this.checkPort(portEl.val());
            }, this));
        }
        // Setup network autocomplete
        var hostnameEl = this.input('Hostname');
        if (hostnameEl) {
            this.networkComplete = new SelectAutoComplete({
                el: hostnameEl,
                appendTo: container,
                className: this.classPrefix + 'Hostname',
                selectItem: _.bind(function (event, item) {
                    if (item.option) {
                        this.setHostname(item.option.data('hostname'));
                        this.setPort(item.option.data('port'));
                        this.setSSL(item.option.data('ssl'));
                    } else {
                        this.setHostname(item.value);
                    }
                    // Focus nick unless we tabbed or the entry is blank
                    if (item.value && event.which != 9) { // TAB
                        this.focusInput(this.tabFocus);
                    } else {
                        this.networkComplete.focus();
                    }
                }, this),
                selectTerm: _.bind(function (event, term) {
                    this.setHostname(term);
                }, this),
                footer: _.bind(function (term) {
                    return {
                        label: 'Choose a hostname and port…',
                        value: term,
                        className: 'autoCompleteFooter'
                    };
                }, this),
                optionMapper: _.bind(function (option, term, matcher) {
                    var opt = $(option);
                    if (opt.is('.placeholder')) {
                        return null;
                    }
                    var label = opt.text();
                    var hostname = opt.data('hostname');
                    if (label && (!term || label.match(matcher) || hostname.match(matcher))) {
                        var icon = opt.data('ssl') ? 'shield' : 'globe';
                        var formattedLabel = '<i class="fa fa-' + icon + '" title="Secure connection"></i> ' +
                            util.highlightTerm(label, term) +
                            ' <span class="host">' + util.highlightTerm(hostname, term) + '</span>';
                        return {
                            label: formattedLabel,
                            value: hostname,
                            option: opt
                        };
                    }
                }, this)
            });
        
            this.networkComplete.render();
        }
        
        return this;
    },
    setHostname: function (value) {
        var host, port;
        
        var bracketMatch = value.match(/\[([^\]]+)\](?::(\d+))?/);
        if (bracketMatch) {
            host = bracketMatch[1];
            port = bracketMatch[2];
        } else {
            var splitParts = value.split(':');
            if (splitParts.length == 2 && !isNaN(splitParts[1] - 0)) {
                host = splitParts[0];
                port = splitParts[1];
            } else {
                host = value;
            }
        }
        if (this.networkComplete) {
            this.networkComplete.setValue(host);
        }
        if (port) {
            this.setPort(port);
        }
    },
    setInput: function (input, value, options) {
        options = options || {};
        var inputEl = this.input(input);
        if (inputEl) {
            if (options.keep && inputEl.val()) {
                return;
            }
            inputEl.val(value);
            if (options.then) {
                options.then();
            }
        }
    },
    setPort: function (value) {
        this.setInput('Port', value, {
            then: _.bind(function () {
                this.checkPort(value);
            }, this)
        });
    },
    setAutoChannels: function (value) {
        this.setInput('Channels', value);
    },
    setAutoCommands: function (value) {
        this.setInput('Commands', value);
    },
    setUser: function (user) {
        if (user) {
            this.setRealname(user.getRealname(), {keep: true});
            this.setNickname(user.get('nick'), {keep: true});
        }
    },
    setNetname: function (value) {
        this.setInput('Netname', value);
    },
    setNetwork: function (connection) {
        this.setInput('Hostname', connection.getHost());
    },
    setNickname: function (value, options) {
        this.setInput('Nick', value, options);
    },
    setRealname: function (value, options) {
        this.setInput('Realname', value, options);
    },
    setSSL: function (value) {
        var sslEl = this.input('SSL');
        if (sslEl) {
            sslEl.prop('checked', !!value);
        }
    },
    setNickservPass: function (value) {
        this.setInput('Nspass', value);
    },
    setServerPassword: function (value) {
        this.setInput('Password', value);
    },
    setAvatar: function (connection) {
        if (this.avatar) {
            this.avatar.setModel(connection);
            if (connection.nativeAvatarUploadsSupported()) {
                this.avatar.show();
            } else {
                this.avatar.hide();
            }
        }
    },
    setConnection: function (connection) {
        this.setNetname(connection.getName());

        this.setNetwork(connection);
        
        this.setHostname(connection.get('hostname') || '');
        
        var ssl = !!connection.get('ssl');
        var port = connection.get('port') ||
            (ssl ? Connection.defaultSSLPort : Connection.defaultPort);
        this.setPort(port);
        this.setSSL(ssl);
        
        this.setAutoChannels('');

        this.setNickname(connection.get('nick'));
        this.setRealname(connection.get('realname'));
        
        this.setNickservPass(connection.get('nickserv_pass'));
        
        this.setServerPassword(connection.get('server_pass'));
        
        this.setAutoCommands(connection.get('join_commands'));

        this.setAvatar(connection);
    },
    hideError: function () {
        this.error.hide();
    },
    showError: function (message) {
        this.error.html(message).fadeIn('fast');
    },
    prefill: function (user, bufferParts) {
        this.setUser(user);
        if (bufferParts) {
            this.setHostname(bufferParts.hostname || '');

            var ssl = !!bufferParts.ssl;
            var port = bufferParts.port ||
                (ssl ? Connection.defaultSSLPort : Connection.defaultPort);
            this.setPort(port);
            this.setSSL(ssl);

            this.setAutoChannels(bufferParts.buffer || '');
        }
        this.setNickservPass('');
        this.setServerPassword('');
        this.setAutoCommands('');
        this.triggerLoad();
    },
    input: function (name) {
        return this.inputs[name];
    },
    cell: function (name) {
        return this.cells[name];
    },
    triggerLoad: function () {
        this.$el.triggerHandler('load');
    },
    render: function () {
        this.$el.attr('method', 'post');
        this.$el.attr('novalidate', true);
        this.$el.append('<input type="text" style="display:none;"><input type="password" style="display:none;">');
        
        this.renderCellGroups();
        
        return this;
    },
    renderCellGroups: function () {
        _.each(this.cellGroups, function (cellGroup, i) {
            // Container
            var container = this.$el;
            if (cellGroup.collapsed) {
                container = $('<div>')
                    .addClass('networkEditor__container networkEditor__container--collapsed')
                    .addClass(this.classPrefix + cellGroup.collapsed + 'Container');
                this.$el.append(container);
                this.containers[cellGroup.collapsed] = container;
            }
            
            // Heading
            if (cellGroup.heading) {
                var heading = this.buildCellHeading(cellGroup.heading, cellGroup.collapsed);
                if (heading) {
                    container.append(heading);
                }
            }
            
            if (cellGroup.cells) {
                var table = this.buildCellTable(cellGroup.cells, cellGroup.className);
                container.append(table);
            }

            if (cellGroup.after) {
                container.append(cellGroup.after);
            }
        }, this);
        
        // Error
        this.error = $('<p class="userError" tabindex="-1">').attr('id', this.idPrefix + 'Error');
        this.$el.append(this.error);
        
        // Submit
        this.submit = $('<p class="form">').addClass(this.classPrefix + 'Submit');
        this.submit.append($('<button class="action" type="submit">').append($('<span>').text(this.submitLabel)));
        if (this.cancel) {
            var cancelButton = $('<button type="button" class="cancel">').append($('<span>').text(this.cancelLabel)).on('buttonClick', _.bind(function (e) {
                this.cancel();
                return false;
            }, this));
            this.submit.append(cancelButton);
        }
        if (this.afterSubmit) {
            _.each(this.afterSubmit, function (el, i) {
                this.submit.append(el);
            }, this);
        }
        this.$el.append(this.submit);
        
        return this;
    },
    setSubmitLabel: function (label) {
        this.submitLabel = label;
        this.submit.find('button.action span').text(this.submitLabel);
    },
    setCancelLabel: function (label) {
        this.cancelLabel = label;
        this.submit.find('button.cancel span').text(this.cancelLabel);
    },
    toggleCollapsed: function (container) {
        this.containers[container].toggleClass('networkEditor__container--collapsed');
        this.trigger('collapsedChange', container);
    },
    buildCellHeading: function (options, collapsed) {
        if (!options) {
            return false;
        }
        var heading = $('<h2>');
        heading.addClass(this.classPrefix + 'Heading');
        heading.addClass('networkEditorHeading');
        if (options.className) {
            heading.addClass('networkEditorHeading__' + options.className);
            heading.addClass(this.classPrefix + options.className + 'Heading');
        }
        if (options.label) {
            var wrapper;
            if (collapsed) {
                wrapper = $('<a href="#">').click(_.bind(function (e) {
                    this.toggleCollapsed(collapsed);
                    return false;
                }, this));
            } else {
                wrapper = $('<span>');
            }
            heading.append(wrapper.html(options.label));
            if (options.icon) {
                wrapper.prepend('<i class="fa fa-' + options.icon + '">');
            }
        }
        return heading;
    },
    buildCellTable: function (cells, className) {
        var table = $('<table cellpadding="0" cellspacing="0" class="form">');
        table.addClass(this.classPrefix + 'Cells');
        table.addClass('networkEditorCells');
        if (className) {
            table.addClass('networkEditorCells__' + className);
        }
        var labels = $('<tr>');
        var inputs = $('<tr>');
        var hasLabels = false;
        _.each(cells, function (cell, j) {
            var inputAttrs = _.clone(cell.inputAttrs);
            if (j > 0 && cell.row) {
                // New row
                table.append(labels);
                table.append(inputs);
                labels = $('<tr>');
                inputs = $('<tr>');
            }
            var labelCell = $('<th>');
            var inputCell = $('<td>');
            if (cell.cellClass !== false) {
                // No prefix
                var cellClass = cell.cellClass || inputAttrs.name;
                labelCell.addClass(cellClass);
                inputCell.addClass(cellClass);
            }
            if (cell.colSpan) {
                labelCell.attr('colspan', cell.colSpan);
                inputCell.attr('colspan', cell.colSpan);
            }
            if (cell.optional) {
                labelCell.addClass('optional');
                inputCell.addClass('optional');
            }
            
            // Input
            var inputElement = cell.inputElement || 'input';
            var input;
            if (inputAttrs.type == 'avatar') {
                input = $($('#tpl-avatar-preview').html());
                this.avatar = new AvatarUploadPreview({
                    session: this.session,
                    el: input,
                    size: 32
                }).hide();
            } else {
                input = $(cell.input || ('<' + inputElement + '>'));
                if ($.inArray(inputAttrs.type, ['checkbox', 'radio']) === -1) {
                    input.addClass('input');
                }
            }
            var inputId;
            if (cell.inputClass) {
                input.addClass(this.classPrefix + cell.inputClass);
                inputId = cell.inputClass;
            }
            if (cell.inputId !== false) {
                inputId = cell.inputId || inputId;
                if (cell.inputIdSuffix) {
                    inputId += cell.inputIdSuffix;
                }
                input.attr('id', this.idPrefix + inputId);
            }
            if (cell.autocomplete) {
                input.attr('autocomplete', cell.autocomplete);
            }
            if (inputAttrs.type == 'password') {
                var newName = inputAttrs.name + '_' + util.ts();
                this.nameMap[newName] = inputAttrs.name;
                inputAttrs.name = newName;
            }
            input.attr(inputAttrs);
            if (inputId) {
                this.cells[inputId] = inputCell;
                this.inputs[inputId] = input;
            }
            inputCell.append(input);
            
            // Label
            if (cell.label) {
                var label = $('<label>').html(cell.label);
                if (inputId) {
                    label.attr('for', this.idPrefix + inputId);
                }
                labelCell.append(label);
                hasLabels = true;
            }


            if (inputAttrs.type == 'password' && cell.reveal) {
                var revealId = this.idPrefix + inputId + 'Reveal';
                var reveal = $('<span>')
                    .append(' ')
                    .append($('<input type="checkbox" class="reveal">').attr('id', revealId).data('input', input))
                    .append($('<label>').attr('for', revealId).text(' Reveal'));
                input.addClass('password');
                inputCell.append(reveal);
            }

            // After input
            if (cell.after) {
                var afterContents;
                if (_.isFunction(cell.after)) {
                    afterContents = cell.after(this.idPrefix + inputId);
                } else {
                    afterContents = cell.after;
                }
                var after = $(afterContents).addClass(this.classPrefix + 'after' + cell.inputClass);
                if (cell.afterLabel) {
                    after = $('<label>').append(after);
                    if (inputId) {
                        after.attr('for', this.idPrefix + inputId);
                    }
                }
                inputCell.append(after);
            }
            
            labels.append(labelCell);
            inputs.append(inputCell);
        }, this);
        if (hasLabels) {
            table.append(labels);
        }
        table.append(inputs);
        return table;
    }
});
NetworkEditor.CELLS = {
    channels: {
        row: true,
        optional: true,
        inputElement: "textarea",
        inputClass: "Channels",
        inputAttrs: {
            name: "channels",
            rows: 4,
            placeholder: "e.g. #chat, #feedback, #secretchat password1"
        },
        label: 'Channels to join <small class="explanation">— comma or line separated, password after a space</small>'
    },
    serverPass: {
        row: true,
        optional: true,
        inputClass: "Password",
        autocomplete: "new-password",
        inputAttrs: {
            name: "server_pass",
            type: "password"
        },
        label: 'Server password <small class="explanation">— (optional) for private servers <a href="/?/upgrade" class="passwordedWarning">upgrade required</a></small>',
        reveal: true
        
    }
};
NetworkEditor.CELL_GROUPS = {
    network: {
        className: 'network',
        cells: [{
            inputClass: "Hostname",
            inputAttrs: {
                name: "hostname"
            },
            label: "Hostname",
            input: '<select><option class="placeholder" value="">Choose a network…</option></select>'
        }, {
            inputClass: "Port",
            inputAttrs: {
                name: "port",
                value: Connection.defaultPort
            },
            label: "Port"
        }, {
            inputClass: "SSL",
            inputAttrs: {
                name: "ssl",
                type: "checkbox",
                value: "1"
            },
            after: '<span><i class="fa fa-shield" title="Use a secure connection to this server"></i>Secure port</span>',
            afterLabel: true
        }]
    },
    identity: {
        heading: {
            icon: 'user',
            className: "Identity",
            label: "Your identity"
        },
        cells: [{
            inputClass: "Nick",
            inputAttrs: {
                name: "nickname"
            },
            label: "Nickname"
        }, {
            inputClass: "Realname",
            inputAttrs: {
                name: "realname",
                placeholder: "optional"
            },
            label: "Full name (optional)"
        // }, {
        //     inputClass: "Avatar",
        //     inputAttrs: {
        //         type: "avatar"
        //     }
        }]
    },
    channels: {
        heading: true,
        cells: [NetworkEditor.CELLS.channels]
    },
    advanced: {
        heading: {
            icon: 'cog',
            className: "Advanced",
            label: "Advanced options"
        },
        collapsed: "Advanced",
        cells: [{
            row: true,
            optional: true,
            inputClass: "Nspass",
            autocomplete: "new-password",
            inputAttrs: {
                name: "nspass",
                type: "password"
            },
            label: 'NickServ password <small class="explanation">— if the server supports it and you’ve registered your nickname</small>',
            reveal: true
        }, {
            row: true,
            optional: true,
            inputElement: "textarea",
            inputClass: "Commands",
            inputAttrs: {
                name: "joincommands",
                rows: 4,
                placeholder: "AUTH <user> <password> etc..."
            },
            label: 'Commands to run on connect <small class="explanation">— one per line, e.g. for opering up on connect.<br>' +
                   'If you need to add a (eg, 15 sec) delay between commands, you can write: WAIT 15</small>'
        },
        NetworkEditor.CELLS.serverPass
        // , {
        //     row: true,
        //     optional: true,
        //     inputClass: "Username",
        //     inputAttrs: {
        //         name: "username"
        //     },
        //     label: 'Custom username <small class="explanation">— used on some servers for identity and authentication</small>'
        // }
        ]
    },
    slack: {
        after: __webpack_require__("FXrJ")()
    },
    netname: {
        cells: [{
            inputClass: "Netname",
            inputAttrs: {
                name: "netname"
            },
            label: "Name"
        }]
    },
};


module.exports = NetworkEditor;


/***/ }),

/***/ "1Cb+":
/***/ (function(module, exports, __webpack_require__) {

// Polyfills, patches, config, plugins and helpers
__webpack_require__("hF98");
__webpack_require__("/SwS");
__webpack_require__("xpYO");
__webpack_require__("8OS9");
__webpack_require__("PT53");
__webpack_require__("MfRu");


/***/ }),

/***/ "1ka6":
/***/ (function(module, exports, __webpack_require__) {

var BufferListBufferView = __webpack_require__("VFp6");


var BufferListChildView = BufferListBufferView.extend({
    tagName: 'li',
    className: 'buffer',
    attributes: {
        'role': 'presentation'
    },
    render: function () {
        BufferListBufferView.prototype.render.call(this);
        this.model.bind('urlChange', this.renderLinkUrl, this);
        this.model.bind('change:name', this.renderLinkText, this);
        this.listenTo(this.model.session.pinnedBuffers, 'change', this.renderLinkText);
        this.listenTo(this.model.session.pinnedBuffers, 'fullChange', this.renderLinkText);

        this.model.bind('moveSegment', this.remove, this);
        
        return this;
    },
    renderLinkUrl: function () {
        this.link.attr('href', this.model.url());
        return this;
    },
    renderLinkText: function () {
        var displayName = this.model.getDisambiguatedListName();
        this.link.attr('title', this.model.getDisplayNameWithConnection());
        this.setLinkLabelHtml(this.formatter.render(displayName));
        return this;
    }
});


module.exports = BufferListChildView;


/***/ }),

/***/ "2ZbG":
/***/ (function(module, exports) {

var canvas = document.createElement('canvas');
var context = canvas.getContext('2d');

var RE_LINUX = /Linux/;
var RE_MAC = /Mac/;
var RE_WINDOWS = /Win/;

module.exports = {
    // on high-DPI screens, different browsers draw bitmaps on canvas
    // in different ways
    // 
    // www.html5rocks.com/en/tutorials/canvas/hidpi/
    getPixelRatio: function () {
        var devicePixelRatio = window.devicePixelRatio || 1;
        var backingStoreRatio = 
            context.backingStorePixelRatio || 
            context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio || 1;

        return devicePixelRatio / backingStoreRatio;
    },
    isHighDensity: function () {
        return this.getPixelRatio() > 1.3;
    },
    isLinux: function () {
        return RE_LINUX.test(window.navigator.platform);
    },
    isMac: function () {
        return RE_MAC.test(window.navigator.platform);
    },
    isWindows: function () {
        return RE_WINDOWS.test(window.navigator.platform);
    }
};


/***/ }),

/***/ "2rjW":
/***/ (function(module, exports, __webpack_require__) {

var BufferPromptHandler = __webpack_require__("JGoS");


var ConnectionPromptHandler = BufferPromptHandler.extend({
    bindMessageHandlers: function () {
        for (var type in this.messageHandlers) {
            this.connection.bind('message:' + type, this.handleMessage, this);
        }
        this.connection.bind('nickPrompt', this.nickPrompt, this);
        this.connection.bind('joinPrompt', this.joinPrompt, this);
        this.connection.bind('ignorePrompt', this.ignorePrompt, this);
        this.connection.bind('invitePrompt', this.invitePrompt, this);
        this.connection.bind('genericConfirm', this.genericConfirm, this);
        this.connection.bind('deleteConfirm', this.deleteConfirm, this);
        this.connection.bind('deletePMConfirm', this.deletePMConfirm, this);
        this.connection.bind('postError', this.postError, this);
        this.model.bind('postError', this.postError, this);
        this.model.bind('sayError', this.postError, this);
        this.model.bind('longMessageConfirm', this.longMessageConfirm, this);
    },
    handleMessage: function () {
        var ret = BufferPromptHandler.prototype.handleMessage.apply(this, arguments);
        if (ret) {
            // Clear focus on make buffer if we get any prompts
            // many of them are about invalid channel names
            // that mean a join will never come
            this.connection.setFocusOnMakeBuffer(null);
        }
        return ret;
    },
    nickPromptText: function (promptText, nickLen) {
        promptText = promptText || 'Choose a new nickname';
        if (nickLen || nickLen === 0) {
            var s = Math.abs(nickLen) === 1 ? '' : 's';
            promptText += ' (' + nickLen + ' char' + s + ')';
        }
        return promptText;
    },
    standardReply: function (type, message) {
        var msg = '<b>' + type + ': ' + this.formatter.escapeText(message.command) + '</b>: ' +
            this.formatter.escapeText(message.code) + ': ' +
            this.formatter.escapeText(message.description);
        if (message.context && message.context.length) {
            msg += ' [ ' + this.formatter.escapeText(message.context.join(' , ')) + ' ]';
        }
        return this.htmlAlert(msg);
    },
    channelAlert: function (message, options) {
        options = options || {};
        var prefix = options.prefix || '';
        var msg = prefix + this.formatter.renderLinkify(options.msg || message.msg);
        var chan = options.key ? message[options.key] : message.channel || message.chan;
        if (chan) {
            msg = this.formatter.linkChannel(chan) + ': ' + msg;
        }
        return this.htmlAlert(msg);
    },
    nickPrompt: function (promptText, promptNick) {
        var nickLen = this.connection.getISupport('NICKLEN');
        promptNick = promptNick || this.connection.getNick();
        var finalPromptText = this.nickPromptText(promptText, nickLen - promptNick.length);
        var overlay = this.htmlPrompt(finalPromptText, _.bind(function (nick) {
            this.connection.nick(nick);
        }, this), promptNick, {
            onPromptKey: _.bind(function (e, input, textContainer) {
                textContainer.text(this.nickPromptText(promptText, nickLen - input.val().length));
            }, this)
        });
        overlay.className = 'connection_nick_prompt';
        this.triggerAdd(overlay);
    },
    joinPrompt: function () {
        var promptText = 'Which channel do you want to join?';
        var overlay = this.prompt(promptText, _.bind(function (channel) {
            this.connection.joinChannel(channel);
        }, this));
        overlay.className = 'connection_nick_prompt';
        this.triggerAdd(overlay);
    },
    ignorePrompt: function (user, callback) {
        var promptText = "Ignore messages from " + user.getNick() + ' at this hostmask:';
        var overlay = this.prompt(promptText, _.bind(function (mask) {
            this.connection.ignore(mask);
            if (callback) {
                callback();
            }
        }, this), user.getBanMask());
        overlay.className = 'connection_ignore_prompt';
        this.triggerAdd(overlay);
    },
    invitePrompt: function (user, callback) {
        var promptText = "Invite " + user.getNick() + " to a channel";
        var overlay = this.prompt(promptText, _.bind(function (channel) {
            user.invite(channel);
            if (callback) {
                callback();
            }
        }, this));
        overlay.className = 'connection_invite_prompt';
        this.triggerAdd(overlay);
    },
    genericConfirm: function (confirmText, callback, options) {
        var overlay = this.confirm(confirmText, _.bind(function () {
            if (callback) {
                callback();
            }
        }, this), options);
        overlay.className = options.overlayClass;
        this.triggerAdd(overlay);
    },
    deleteConfirm: function (callback) {
        var downloadLink = $('<a href="">').text('download').click(_.bind(function (e) {
            e.preventDefault();
            this.model.session.trigger('exportConfirm', this.connection);
        }, this));
        var confirmHtml = $('<div>');
        confirmHtml.append($('<p>').html("Are you sure you want to remove this connection and all its logs? Make sure you ").append(downloadLink).append(" any logs you want to keep before deleting."));
        var overlay = this.htmlConfirm(confirmHtml, _.bind(function () {
            this.connection.remove();
            if (callback) {
                callback();
            }
        }, this), {
            confirmClass: 'delete'
        });
        overlay.className = 'connection_delete_confirm';
        this.triggerAdd(overlay);
    },
    deletePMConfirm: function (callback) {
        var pms = this.connection.buffers.activeConversations;
        if (pms.length) {
            var s = pms.length > 1 ? 's' : '';
            var confirmHTML = $('<div>');
            confirmHTML.append($("<p>").text("You’ve chosen to delete " + pms.length + " private message" + s + ". Uncheck any you’d prefer to keep before continuing."));
            confirmHTML.append('<hr>');
            var list = $('<ul>');
            _.each(pms.sortBy('created'), function (pm, i) {
                var htmlId = 'b' + pm.id;
                var item = $('<li>');
                var badge = $('<span class="badge">');
                var label = $('<label>').attr('for', htmlId).text(pm.getName()).prepend(badge);
                if (pm.isTrackingUnread() && pm.hasUnseen()) {
                    label.addClass('unread');
                }
                if (pm.hasUnseenHighlights()) {
                    badge.text(pm.unseenHighlightCount());
                    label.addClass('activeBadge');
                }
                
                item
                    .append($('<input type="checkbox" checked>').attr({
                        'id': htmlId,
                        'name': 'bid',
                        'value': pm.id 
                    }))
                    .append(' ')
                    .append(label);
                list.append(item);
            }, this);
            confirmHTML.append(list);
            if (this.connection.hasUModeR()) {
                confirmHTML.append('<hr>');
                var commands = $('<a href="">').text('commands to run on connect').click(_.bind(function (e) {
                    e.preventDefault();
                    this.connection.select();
                    this.connection.trigger('showEdit', true, 'Commands');
                }, this));
                confirmHTML.append($('<p>').html("If you'd like to block messages from users who haven't identified with the IRC server, add <b><code>/umode +R</code></b> to your ").append(commands));
            }
            var overlay = this.htmlConfirm(confirmHTML, _.bind(function (formData, formDataArray) {
                _.each(formDataArray, function (data) {
                    if (data.name == 'bid') {
                        var pm = pms.get(data.value);
                        pm.remove();
                    }
                });
                if (callback) {
                    callback();
                }
            }, this), {
                confirmClass: 'delete',
                okText: 'Delete private messages'
            });
            overlay.className = 'connection_delete_pm_confirm';
            this.triggerAdd(overlay);
        }
    },
    messageHandlers: $.extend({}, BufferPromptHandler.prototype.messageHandlers, {
        // Prompt for input
        invalid_nick: function (message) {
            var promptText = this.formatter.render(message.msg);
            this.nickPrompt(promptText, message.invalid_nick);
        },
        no_such_channel: function (message) {
            var promptText = 'Invalid channel name on ' + this.connection.getFullLabel() + ', try again.';
            return this.prompt(promptText, _.bind(function (bufferName) {
                this.connection.openBuffer(bufferName);
            }, this), message.chan);
        },
        invalid_watch_nick: function (message) {
            return this.prompt(message.msg, _.bind(function (bufferName) {
                this.connection.serverLog.say('/watch +' + bufferName);
            }, this), message.nick, {
                okText: 'Watch'
            });
        },
        too_many_watch: function (message) {
            if (message.nick) {
                return this.alert(message.nick + ': ' + message.msg);
            } else {
                return this.alert(message.msg);
            }
        },
        no_such_nick: function (message) {
            var label = 'channel/nick';
            var okText = 'Open';
            switch (message.cmd_reply) {
            case 'whois':
                label = 'nick';
                okText = 'Whois';
                break;
            case 'names':
                label = 'channel';
                okText = '/names';
                break;
            }
            var promptText = 'No such ' + label + ' on ' + this.connection.getFullLabel() + ', try again.';
            return this.prompt(promptText, _.bind(function (bufferName) {
                switch (message.cmd_reply) {
                case 'whois':
                    this.connection.post('whois', {nick: bufferName});
                    break;
                case 'names':
                    this.connection.serverLog.say('/names ' + bufferName);
                    break;
                default:
                    this.connection.openBuffer(bufferName);
                    break;
                }
            }, this), message.nick, {
                okText: okText
            });
        },
        bad_channel_key: function (message) {
            var promptText = 'Password for ' + message.chan;
            return this.prompt(promptText, _.bind(function (key) {
                this.connection.joinChannel(message.chan, key);
            }, this));
        },
        bad_channel_name: function (message) {
            var promptText = 'Bad channel name: ' + message.chan + ', try again.';
            return this.prompt(promptText, _.bind(function (channel) {
                this.connection.joinChannel(channel);
            }, this), message.chan);
        },
        
        // Confirmation/alert
        need_registered_nick: function (message) {
            if (message.rfc2812) {
                // Conflict on IRCNet/2812 servers with ERR_NOCHANMODES
                return this.channelAlert(message);
            } else {
                var msg = this.formatter.linkChannel(message.chan) + ': ';
                msg += this.formatter.renderLinkify(message.msg);
                return this.htmlConfirm(msg, _.bind(function () {
                    this.connection.trigger('nickServPrompt', this.connection);
                }, this), {
                    okText: 'Identify with NickServ…',
                    extraContent: $('<p class="explanation">').text('Note: NickServ is not available on all networks')
                });
            }
        },
        blocked_channel: function (message) {
            return this.channelAlert(message, {
                msg: 'This channel is blocked by IRCCloud, you have been disconnected.'
            });
        },
        
        // Alerts
        invite_only_chan: function (message) {
            return this.channelAlert(message);
        },
        channel_full: function (message) {
            return this.channelAlert(message);
        },
        channel_key_set: function (message) {
            return this.channelAlert(message);  
        },
        banned_from_channel: function (message) {
            return this.channelAlert(message);
        },
        oper_only: function (message) {
            return this.alert(message.msg);
        },
        invalid_nick_change: function (message) {
            var msg = this.formatter.linkBuffer(message.ban_channel) +
                      ': ' + this.formatter.renderLinkify(message.msg);
            return this.htmlAlert(msg);
        },
        nickname_in_use: function (message) {
            return this.alert(message.nick + ': ' + message.msg);
        },
        no_nick_change: function (message) {
            return this.channelAlert(message);
        },
        no_messages_from_non_registered: function (message) {
            if (message.nick) {
                return this.alert(message.nick + ': ' + message.msg);
            } else {
                return this.alert(message.msg);
            }
        },
        not_registered: function (message) {
            var msg = message.first;
            if (message.rest) {
                msg += ' ' + message.rest;
            }
            return this.alert(msg + ': ' + message.msg);
        },
        already_registered: function (message) {
            return this.alert(message.msg);
        },
        too_many_channels: function (message) {
            return this.channelAlert(message);
        },
        too_many_targets: function (message) {
            return this.alert(message.description + ': ' + message.msg);
        },
        no_such_server: function (message) {
            return this.alert(message.server + ': ' + message.msg);
        },
        unknown_command: function (message) {
            var msg = message.msg || 'Unknown command';
            return this.htmlAlert('<b>' + this.formatter.escapeText(message.command) + '</b>: ' + this.formatter.escapeText(msg));
        },
        unknown_error: function (message) {
            return this.alert('Unknown error [' + message.command + '] ' + message.msg);
        },
        help_not_found: function (message) {
            return this.alert(message.topic + ': ' + message.msg);
        },
        accept_full: function (message) {
            return this.alert(message.msg);
        },
        accept_exists: function (message) {
            return this.alert(message.nick + ' ' + message.msg);
        },
        accept_not: function (message) {
            return this.alert(message.nick + ' ' + message.msg);
        },
        nick_collision: function (message) {
            return this.alert(message.collision + ': ' + message.msg);
        },
        nick_too_fast: function (message) {
            return this.alert(message.nick + ': ' + message.msg);
        },
        save_nick: function (message) {
            return this.alert(message.nick + ': ' + message.msg + ': ' + message.new_nick);
        },
        unknown_mode: function (message) {
            return this.alert('Missing mode: ' + message.param);
        },
        ban_list_full: function (message) {
            var prefix;
            if (message.ban) {
                prefix = '<b>' + this.formatter.render(message.ban) + '</b> ';
            }
            return this.channelAlert(message, {
                prefix: prefix
            });
        },
        user_not_in_channel: function (message) {
            return this.alert(message.nick + ' is not in ' + message.channel);
        },
        need_more_params: function (message) {
            return this.alert('Missing parameters for command: ' + message.command);
        },
        users_dont_match: function (message) {
            return this.alert(message.msg);
        },
        cannot_set_mode_r: function (message) {
            return this.alert(message.msg);
        },
        chan_privs_needed: function (message) {
            return this.channelAlert(message);
        },
        chan_own_priv_needed: function (message) {
            return this.channelAlert(message);
        },
        unknown_umode: function (message) {
            var msg = this.formatter.render(message.msg);
            if (message.flag) {
                msg = '<b>' + this.formatter.render(message.flag) + '</b> ' + msg;
            }
            return this.htmlAlert(msg);
        },

        users_disabled: function (message) {
            return this.alert(message.msg);
        },
        invalid_operator_password: function (message) {
            return this.alert(message.msg);
        },
        flood_warning: function (message) {
            return this.alert(message.msg);
        },
        privs_needed: function (message) {
            return this.alert(message.msg);
        },
        operator_fail: function (message) {
            return this.alert(message.msg);
        },
        not_on_channel: function (message) {
            return this.channelAlert(message);
        },
        ban_on_chan: function (message) {
            return this.htmlAlert(
                this.formatter.linkChannel(message.channel) +
                ': nick change prevented<br>' +
                this.formatter.escapeText(this.connection.getNick()) +
                ' → ' +
                this.formatter.escapeText(message.proposed_nick) +
                '<br>' +
                this.formatter.renderLinkify(message.msg)
            );
        },
        cannot_send_to_chan: function (message) {
            return this.channelAlert(message);
        },
        cant_send_to_user: function (message) {
            return this.alert(message.nick + ': ' + message.msg);
        },
        user_on_channel: function (message) {
            return this.htmlAlert(this.formatter.linkBuffer(message.nick) + ' is already a member of ' + this.formatter.linkChannel(message.channel));
        },
        pong: function (message) {
            var overlay;
            if (message.origin) {
                overlay = this.alert('PONG from ' + message.origin + ': ' + message.msg);
            } else {
                overlay = this.alert('PONG: ' + message.msg);
            }
            overlay.keepFocus = true;
            return overlay;
        },
        no_nick_given: function (message) {
            return this.alert('No nickname given');
        },
        no_text_to_send: function (message) {
            return this.alert(message.msg);
        },
        no_origin: function (message) {
            return this.alert(message.msg);
        },
        only_servers_can_change_mode: function (message) {
            return this.alert(message.msg);
        },
        not_for_halfops: function (message) {
            return this.alert(message.msg);
        },
        // unreal/ircu/inspircd 3+
        silence: function (message) {
            var mask = message.usermask;
            var msg;
            if (message.usermask.indexOf('-') === 0) {
                msg = mask.substr(1) + ' removed from silence list';
            } else if (mask.indexOf('+') === 0) {
                msg = mask.substr(1) + ' added to silence list';
            } else {
                msg = 'Silence list change: ' + mask;
            }
            return this.alert(msg);
        },
        // inspircd 2.0
        unsilenced: function (message) {
            return this.alert(message.msg);
        },
        silenced: function (message) {
            return this.alert(message.msg);
        },
        not_silenced: function (message) {
            return this.alert(message.msg);
        },
        monitor_full: function (message) {
            var msg = '<b>' + this.formatter.escapeText(message.targets) + '</b>: ' + this.formatter.render(message.msg);
            if (_.isNumber(message.limit)) {
                msg += ' (limit: ' + message.limit + ')';
            }
            return this.htmlAlert(msg);
        },
        no_channel_topic: function (message) {
            return this.channelAlert(message);
        },
        channel_topic_is: function (message) {
            var msg = '<p class="explanation">';
            if (message.author) {
                var author = this.connection.makeUserFromTarget(
                    null,
                    _.extend({}, message, {
                        nick: message.author
                    })
                );
                msg += "Set by " + this.formatter.linkUser(author);
            } else {
                msg += 'Set';
            }
            msg += " on " + new Date(message.time * 1000).formatFullDate();
            msg += '</p>';
            msg += '<p>' + this.formatter.renderLinkifyComicSans(message.text) + '</p>';
            return this.htmlAlert(msg, {
                head: 'Topic for ' + this.formatter.linkChannel(message.chan) + ' (' + this.formatter.linkModel(this.connection) + ')'
            });
        },
        mlock_restricted: function (message) {
            var msg = '<p>' + this.formatter.linkChannel(message.channel) + ': ' + this.formatter.render(message.msg) + '</p>';
            msg += '<p>MLOCK: <b>' + this.formatter.render(message.mlock) + '</b></p>';
            msg += '<p>Requested mode change: <b>' + this.formatter.render(message.mode_change) + '</b></p>';
            return this.htmlAlert(msg);
        },
        cannot_do_cmd: function (message) {
            var msg = '';
            if (message.cmd) {
                msg += message.cmd + ': ';
            }
            msg += message.msg;
            return this.alert(msg);
        },
        secure_only_chan: function (message) {
            return this.channelAlert(message);
        },
        cannot_change_chan_mode: function (message) {
            var msg = "You can't change channel mode";
            if (message.mode) {
                msg += ': <b>' + this.formatter.render(message.mode) + '</b>';
            }
            msg += '; ' + this.formatter.render(message.msg);
            return this.htmlAlert(msg);
        },
        knock_delivered: function (message) {
            return this.channelAlert(message);
        },
        too_many_knocks: function (message) {
            return this.channelAlert(message);
        },
        chan_open: function (message) {
            return this.channelAlert(message);
        },
        knock_on_chan: function (message) {
            return this.channelAlert(message);
        },
        knock_disabled: function (message) {
            return this.channelAlert(message);
        },
        cannotknock: function (message) {
            return this.channelAlert(message);
        },
        ownmode: function (message) {
            return this.alert(message.msg);
        },
        nossl: function (message) {
            return this.channelAlert(message);
        },
        link_channel: function (message) {
            if (!message.valid_channel || message.valid_channel == '*') {
                var prefix = '';
                if (message.invalid_chan) {
                    prefix = this.formatter.linkChannel(message.invalid_chan) + ' ';
                }
                return this.htmlAlert(prefix + this.formatter.renderLinkify(message.msg));
            }
        },
        redirect_error: function (message) {
            return this.alert(message.msg);
        },
        invalid_flood: function (message) {
            return this.channelAlert(message);
        },
        join_flood: function (message) {
            return this.channelAlert(message);
        },
        err_restricted: function (message) {
            if (message.channel) {
                var options = {};
                if (message.target) {
                    options.prefix = '(' + this.formatter.linkBuffer(message.target) + ') ';
                }
                return this.channelAlert(message, options);
            } else {
                return this.alert(message.msg);
            }
        },
        list_syntax: function (message) {
            return this.alert(message.msg);
        },
        who_syntax: function (message) {
            return this.alert(message.msg);
        },

        metadata_limit: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_targetinvalid: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_nomatchingkey: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.key) + '</b> for target: <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_keyinvalid: function (message) {
            var msg = 'Invalid metadata key: <b>' + this.formatter.escapeText(message.key) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_keynotset: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.key) + '</b> for target: <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_keynopermission: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.key) + '</b> for target: <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_toomanysubs: function (message) {
            var msg = 'Metadata key subscription limit reached, keys after and including <b>' + this.formatter.escapeText(message.key) + '</b> not subscribed';
            return this.htmlAlert(msg);
        },
        fail: function (message) {
            return this.standardReply('FAIL', message);
        },
        warn: function (message) {
            return this.standardReply('WARN', message);
        },
        note: function (message) {
            return this.standardReply('NOTE', message);
        }
    })
});


module.exports = ConnectionPromptHandler;


/***/ }),

/***/ "38es":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.c = c;
exports.nc = nc;
exports.atLeastOne = atLeastOne;
exports.atLeastNone = atLeastNone;
exports.opt = opt;
exports.oneOf = oneOf;
exports.isA = isA;
exports.notA = notA;
exports.escape = escape;
/* eslint-env es6 */

function c(pattern) {
    return '(' + pattern + ')';
}
function nc(pattern) {
    return '(?:' + pattern + ')';
}
function atLeastOne(pattern) {
    return pattern + '+';
}
function atLeastNone(pattern) {
    return pattern + '*';
}
function opt(pattern) {
    return pattern + '?';
}
function oneOf() {
    if (_.isArray(arguments[0])) {
        return arguments[0].join('|');
    } else {
        return Array.prototype.join.call(arguments, '|');
    }
}
function isA(pattern) {
    return '[' + pattern + ']';
}
function notA(pattern) {
    return isA('^' + pattern);
}
var wordBound = exports.wordBound = '\\b';
var nonWordBound = exports.nonWordBound = '\\B';

function escape(value) {
    return value.replace(/[-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

/***/ }),

/***/ "3BDD":
/***/ (function(module, exports, __webpack_require__) {

var FilesDialogView = __webpack_require__("Nbol");
var PastebinView = __webpack_require__("0bCg");

var PastebinsDialogView = FilesDialogView.extend({
    el: '#pastebinsOverlayContents',
    wrapper: $('#pastebinsContainer'),
    list: $('#pastebinList'),
    urlRoot: 'pastebins',
    collectionKey: 'pastebins',
    modelView: PastebinView,
    removeModel: function (model) {
        var view = this.modelViews[model.id];
        view.clearTimeago();
        FilesDialogView.prototype.removeModel.apply(this, arguments);
    },
    renderView: function (view) {
        return view.render({
            header: true,
            date: true,
            linkDate: true
        });
    }
});


module.exports = PastebinsDialogView;


/***/ }),

/***/ "3F0q":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var DisconnectGrouper = __webpack_require__("udet");
var JoinPartFormatter = __webpack_require__("RTnb");
var MessageList = __webpack_require__("7gVv");
var UserChannelMode = __webpack_require__("O4T4");
var ts = __webpack_require__("GmLC").ts;
var IRCFormatter = __webpack_require__("XiBv");


var LineMessageRenderer = function (buffer) {
    this.buffer = buffer;
    this.formatter = new BufferFormatter(this.buffer);
    
    this.lastSeenEid = null;
    this.firstRender = null;
    
    this.currentJoinPart = null;
    this.currentDiscoGroup = null;
    
    this.rows = [];
};
LineMessageRenderer.prototype = {
    flush: function () {
        var rows = this.rows;
        this.rows = [];
        return rows;
    },
    push: function (row) {
        this.rows.push(row);
        
        return this;
    },
    prerender: function (message) {
        return _.filter(_.map(message.split(/[\r\n]/), function (line, i) {
            if (!line) {
                return null;
            }
            if (message.indexOf('/me ') === 0 && message.length > 4) {
                // /me message
                return {
                    message: message.substr(4),
                    type: 'buffer_me_msg'
                };
            } else if (message.indexOf('/') !== 0) {
                // Non slash commands
                return {
                    message: line,
                    type: 'buffer_msg'
                };
            } else if (message.indexOf('//') === 0) {
                // Escaped slash
                return {
                    message: line.substr(1),
                    type: 'buffer_msg'
                };
            }
        }), _.identity);
    },
    renderMessagesAtTop: function (messages, options) {
        options = options || {};
        if (!messages || !messages.length) {
            return;
        }

        var currentJoinPart = this.currentJoinPart;
        var currentDiscoGroup = this.currentDiscoGroup;
        this.currentJoinPart = null;
        this.currentDiscoGroup = null;

        options.lastBatch = _.last(messages);
        this.renderMessages(messages, options);

        // Reset join/part and disco groups unless we just rendered the most recent
        if (!this.buffer.getLastMessage().equals(_.last(messages))) {
            this.currentJoinPart = currentJoinPart;
            this.currentDiscoGroup = currentDiscoGroup;
        }
    },
    renderMessages: function (messages, options) {
        function render (message) {
            this.render(message, options);
        }
        if (messages instanceof MessageList) {
            messages.each(render, this);
        } else {
            _.each(messages, render, this);
        }
        
        return this;
    },
    render: function (message, options) {
        var type = message.get('type');
        if (type in this.messageHandlers) {
            // Clear flags
            this.joinPart = false;
            this.createdJoinPart = false;
            this.discoGroup = false;
            this.createdDiscoGroup = false;
            this.endedConcat = null;
            var index = this.rows.length;
            this.messageOptions = options;
            this.messageHandlers[type].call(this, message);
            this.postProcess(index, message);
            this.messageOptions = null;
        }
        return this;
    },
    postProcess: function (index, message) {
        var previous = message.previousVisible();
        if (this.rows.length > index) {
            // Only for buffer messages (not prerenders or tests)
            if (
                !message.isEmpty() &&
                (!this.messageOptions || !this.messageOptions.actions) &&
                message.collection
            ) {
                // Prepend date row if the date has changed since the previous message
                if (!previous || !message.hasSameDate(previous)) {
                    this.rows.splice(index++, 0, this.buildDateRow(message));
                }
            }

            // Group disconnects
            index = this.groupDisconnect(index, message);
            
            // Group join/parts
            if (this.buffer.isChannel() || this.buffer.isConversation()) {
                index = this.groupJoinPart(index, message);
            }

            this.handlePreformatted(message);
        }
        
        // Render last seen marker if we're not already marked
        if (message.collection && !message.isInThreadCollection() && !this.lastSeenEid) {
            // AND if:
            if (
                (
                    // 1. This is the last seen event OR
                    this.buffer.isMessageLastSeen(message)
                ) || (
                    // 2. The last seen event falls between this and the next message OR
                    !this.buffer.isMessageUnseen(message) &&
                    this.buffer.isMessageUnseen(message.nextMessage())
                ) || (
                    // 3. This is a self message with nothing after it
                    !message.nextMessage() && message.isSelf()
                )
            ) {
                this.renderLastSeenDivider(message);
            }
        }
        
        return this;
    },
    addSameAuthorClass: function (message, classNames, previous, inThread) {
        if (message) {
            if (previous === undefined) {
                previous = message.previousVisible();
            }
            if (inThread === undefined) {
                inThread = message.isInThread();
            }
            if (
                message.hasSameAuthor(previous) &&
                (
                    (!inThread && !previous.isInThread()) ||
                    message.isSameThread(previous)
                )
            ) {
                classNames.push("sameAuthor");
                return true;
            }
        }
    },
    renderLoadMore: function (message) {
        var row = this.buildRow(message, {
            classNames: ['loadMore'],
            contents: '<button class="loadMore__button" tabindex="-1"><span>Load more backlog…</span></button>',
            noId: true
        });
        return this.push(row);
    },
    renderFetchingDivider: function (message, initial) {
        var classNames = ['fetch'];
        if (initial) {
            classNames.push('initialFetch');
        }
        this.addSameAuthorClass(message, classNames);
        var text = initial ? 'Fetching history…' : 'Fetching more history…';
        var row = this.buildDividerRow(message, {
            classNames: classNames,
            contents: text,
            noId: true
        });
        return this.push(row);
    },
    renderBacklogDivider: function (message, classNames) {
        classNames = classNames || [];
        classNames.push('backlogDivider');
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            classNames: classNames,
            noId: true
        });
        return this.push(row);
    },
    renderFetchFailedDivider: function (message) {
        var classNames = ['fetch', 'fetchFailed'];
        if (this.buffer.isDeferred()) {
            classNames.push('initialFetch');
        }
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            classNames: classNames,
            contents: 'Fetching failed',
            noId: true
        });
        return this.push(row);
    },
    renderBottomSeenDivider: function (message) {
        var classNames = ['seenDivider', 'bottomSeen', 'hidden'];
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            contents: 'New messages since you scrolled up',
            classNames: classNames,
            data: {
                'locked-time': ts()
            },
            noId: true
        });
        return this.push(row);
    },
    renderFocusSeenDivider: function (message) {
        var classNames = ['seenDivider', 'focusSeen', 'hidden'];
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            contents: 'New messages since you tabbed out',
            classNames: classNames,
            noId: true
        });
        return this.push(row);
    },
    renderLastSeenDivider: function (message) {
        // No change
        if (this.lastSeenEid == message.id) {
            return this;
        }
        
        this.lastSeenEid = message.id;
        
        var classNames = ['seenDivider', 'lastSeen'];
        // Hide marker if it's the last
        if (!message.nextVisible()) {
            classNames.push('hidden');
        }
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            contents: 'New messages',
            classNames: classNames,
            noId: true
        });
        return this.push(row);
    },
    unhandled: function (message) {
        if (message.get('eid') > 0) {
            debug.warn('Unrendered message', message.get('type'), message);
            this.renderWarning(message, 'Unrendered message [' + message.get('type') + ']');
        }
        
        return this;
    },
    
    renderDiscoGroup: function () {
        if (!this.currentDiscoGroup) {
            return;
        }
        this.currentDiscoGroup.render();
        // Make the heading row
        var classNames = ['groupedDisco collapsedHead'];
        if (this.currentDiscoGroup.expanded) {
            classNames.push('expanded');
        }
        var heading = this.buildMessageRow(
            this.currentDiscoGroup.getFirstLine(),
            this.currentDiscoGroup.sentences,
            {
                classNames: classNames,
                attr: {
                    'role': 'button',
                    'aria-expanded': String(this.currentDiscoGroup.expanded)
                },
                noId: true
            }
        );
        var part = this.buildDividerRow(
            this.currentDiscoGroup.getFirstLine(),
            {
                classNames: ['part groupedDiscoPart'],
                noId: true
            }
        );
        // Splice the heading and group back into our current row buffer
        var group = '<div class="collapseGroup discoGroup">';
        _.each(this.currentDiscoGroup.rows, function (row, i) {
            if (!$(row).is('.part')) {
                group += row;
            }
        }, this);
        group += '</div>';
        
        // Push new heading and group
        this.rows.push(
            heading,
            group,
            part
        );
        return this.currentDiscoGroup.index;
    },
    
    addToDiscoGroup: function (index, message) {
        var created = this.currentDiscoGroup.addMessage(message, this.rows.splice(index));
        
        // Remove previous rows
        // Either remove first message rows or remove heading/group/part
        this.rows.splice(
            this.currentDiscoGroup.index,
            this.currentDiscoGroup.spliceCount
        );
        
        var remainder = this.rows.length -
            this.currentDiscoGroup.index;
        this.currentDiscoGroup.setIndex(this.currentDiscoGroup.index + remainder);
        
        if (created) {
            // This is the first time we've rendered it as a group
            // Set a flag (will get cleared on the next message)
            this.createdDiscoGroup = true;
        } else {
            this.discoGroup = true;
            var next = message.nextMessage();
            if (
                next &&
                (!this.messageOptions || this.messageOptions.lastBatch || !message.equals(this.messageOptions.lastBatch)) &&
                next.isDisconnect() &&
                message.hasSameDate(next)
            ) {
                // Don't render if the next message is also a disco from the same date
                return this.currentDiscoGroup.index;
            }
        }
        return this.renderDiscoGroup();
    },
    renderJoinPart: function () {
        if (!this.currentJoinPart) {
            return;
        }
        this.currentJoinPart.render();
        // Make the heading row
        var classNames = ['joinPart groupedJoinPart collapsedHead'];
        if (this.currentJoinPart.expanded) {
            classNames.push('expanded');
        }
        var heading = this.buildMessageRow(
            this.currentJoinPart.getFirstLine(),
            this.currentJoinPart.sentences,
            {
                classNames: classNames,
                attr: {
                    'role': 'button',
                    'aria-expanded': String(this.currentJoinPart.expanded),
                    'tabindex': '0'
                },
                noId: true
            }
        );
        // Splice the heading and group back into our current row buffer
        var group = '<div class="collapseGroup joinPart joinPartGroup">';
        _.each(this.currentJoinPart.rows, function (row, i) {
            group += row;
        }, this);
        group += '</div>';
        
        // Push new heading and group
        this.rows.push(
            heading,
            group
        );
        return this.currentJoinPart.index;
    },
    addToJoinPart: function (index, message) {
        var created = this.currentJoinPart.addMessage(message, this.rows.splice(index));
        
        // Remove previous rows
        // Either remove first message rows or remove heading/group
        this.rows.splice(
            this.currentJoinPart.index,
            this.currentJoinPart.spliceCount
        );
        
        var remainder = this.rows.length -
            this.currentJoinPart.index;
        this.currentJoinPart.setIndex(this.currentJoinPart.index + remainder);
        
        if (created) {
            // This is the first time we've rendered it as a group
            // Set a flag (will get cleared on the next message)
            this.createdJoinPart = true;
        } else {
            this.joinPart = true;
            var next = message.nextMessage();
            if (
                next &&
                (!this.messageOptions || !this.messageOptions.lastBatch || !message.equals(this.messageOptions.lastBatch)) &&
                next.isJoinPart() &&
                message.hasSameDate(next)
            ) {
                // Don't render if the next message is also a join/part from the same date
                return this.currentJoinPart.index;
            }
        }
        return this.renderJoinPart();
    },

    groupDisconnect: function (index, message) {
        if (message.isDisconnect()) {
            var previous = message.previousVisible();
            if (!this.currentDiscoGroup || !message.hasSameDate(previous)) {
                // 1: Start a new group if:
                // * No existing group OR
                // * Date change
                this.currentDiscoGroup = new DisconnectGrouper({
                    line: message,
                    rows: this.rows.slice(index),
                    formatter: this.formatter,
                    buffer: this.buffer,
                    index: index
                });
            } else {
                // 2: We're in a group already, add the new line to it
                index = this.addToDiscoGroup(index, message);
            }
        } else {
            // 3: Not groupable, close any existing group
            this.currentDiscoGroup = null;
        }
        return index;
    },
    groupJoinPart: function (index, message) {
        if (message.isJoinPart()) {
            var previous = message.previousVisible();
            if (!this.currentJoinPart || !message.hasSameDate(previous)) {
                // 1: Start a new group if:
                // * No existing group OR
                // * Date change
                this.currentJoinPart = new JoinPartFormatter({
                    line: message,
                    rows: this.rows.slice(index),
                    formatter: this.formatter,
                    buffer: this.buffer,
                    index: index
                });
            } else {
                // 2: We're in a group already, add the new line to it
                index = this.addToJoinPart(index, message);
            }
        } else {
            // 3: Not groupable, close any existing group
            this.currentJoinPart = null;
        }
        
        return index;
    },

    handlePreformatted: function (message) {
        // Skip prerenders
        if (!message.collection) {
            return;
        }
        // Skip if pref disabled
        if (!this.buffer.formatCodeBlock()) {
            return;
        }
        if (message.isPrivmsg() && !message.hasConcatTag()) {
            var stripped = IRCFormatter.stripPreformatted(message.get('msg'));
            var tripleBacktick = /```/.test(stripped);
            if (this.preformatted) {
                if (this.preformatted[0].hasSameAuthor(message)) {
                    // Group
                    this.preformatted.push(message);
                    if (tripleBacktick) {
                        // End
                        var msgid;
                        _.each(this.preformatted, function (m, i) {
                            if (i === 0) {
                                m.setConcatStart();
                                msgid = m.getMsgId();
                            } else {
                                m.setConcatLine(msgid, i === this.preformatted.length - 1);
                            }
                        }, this);
                        this.endedConcat = this.preformatted;
                        this.preformatted = null;
                    }
                } else {
                    // Abort, author changed
                    this.preformatted = null;
                }
            } else {
                if (tripleBacktick) {
                    // Start
                    this.preformatted = [message];
                }
            }
        } else {
            // Abort, wrong message type
            this.preformatted = null;
        }
    },
    
    processLastSpoke: function (nick, message) {
        if (this.buffer.isChannel()) {
            var member = this.buffer.getMember(nick);
            if (member) {
                var time = message.getTime();
                member.setLastSpoke(time);
                if (message.isImportantHighlight()) {
                    member.setLastHighlighted(time);
                }
            }
        }
    },
    
    avatar: function (message, nick, options) {
        options = options || {};
        var img = '';
        var avatar = message.getAvatar();
        var external = false;
        var fallback = false;
        var delayFallback = false;
        if (avatar) {
            fallback = true;
            if (!avatar.guess) {
                delayFallback = true;
            }
            external = avatar.external;
            img += this.formatter.imageAvatar(avatar.src, message.isSelf(), {
                size: options.size,
                external: external,
                hasDataParent: true
            });
        }
        img += this.formatter.avatar(nick, message.isSelf(), {
            color: options.color,
            name: options.name,
            fallback: fallback,
            delayFallback: delayFallback,
            external: external,
            hasDataParent: true
        });
        return img;
    },
    
    buildStatusMsg: function (message) {
        var status_msg = message.get('statusmsg') || message.get('op_only');
        if (status_msg === true) {
            status_msg = '@';
        }
        if (status_msg) {
            var dummyUser = this.formatter.getDummyUserFromModeSymbol(status_msg);
            if (dummyUser) {
                var modeClass = 'statusmsg mode_' + dummyUser.getModeCategory();
                var modeSymbol = '<span title="' + dummyUser.getModeTitle() + '" class="mode_prefix mode_symbol ' + modeClass + '">' + this.formatter.escapeText(dummyUser.getModeSymbol()) + '</span>';
                var modePill = '<span title="' + dummyUser.getModeTitle() + '" class="mode_prefix mode_pill ' + modeClass + '">•</span>';
                
                return '<span class="' + modeClass + '">' + modeSymbol + modePill + dummyUser.getModeTitle() + '</span> ';
            }
        }
        return '';
    },
    buildMessageRow: function (message, content, options) {
        options = options || {};
        var classNames = ['messageRow'];
        var html = '';

        var date = message.getDate();
        if (date) {
            html += '<span class="date">';
            html += this.formatter.timestamp(date);
            html += '</span>';
            html += '<span class="g">&nbsp;</span>';
        }

        var suffix = '';
        var inThread;
        // Only for buffer messages (not prerenders or tests)
        if (
            this.buffer.isChild() && 
            !options.noData &&
            !options.noId &&
            message.collection &&
            !message.isDeletedOrRedacted() &&
            (
                message.isReplyable() ||
                message.isReactable() ||
                message.isEditable() ||
                message.isDeletable() || 
                message.isRedactable()
            )
        ) {
            suffix += '<span class="messageActions">';

            if (message.isReactable()) {
                suffix += '<button class="react__add messageActions__action messageActions__action--first" title="Add a reaction" aria-label="Add a reaction" aria-haspopup="true" aria-expanded="false" aria-controls="emojiContextMenu">';
                suffix +=     '<i class="fa fa-smile-o"></i>';
                suffix += '</button>';
            }

            if (message.isEditable() && message.hasSameAccount(this.buffer.user)) {
                suffix += '<button class="editMessage messageActions__action" title="Edit this message" aria-label="Edit this message">';
                suffix +=     '<i class="fa fa-edit"></i>';
                suffix += '</button>';
            }
            if (message.isRedactable() || message.isDeletable()) {
                suffix += '<button class="deleteMessage messageActions__action" title="Delete this message" aria-label="Delete this message">';
                suffix +=     '<i class="fa fa-trash"></i>';
                suffix += '</button>';
            }

            if (message.isReplyable() && !message.isInThreadCollection()) {
                inThread = message.isInThread();
                suffix += '<button class="reply__add messageActions__action" title="Reply to this message" aria-label="Reply to this message">';
                suffix +=     '<i class="fa fa-reply"></i>';
                suffix += '</button>';

                suffix += '<button class="reply__toggle reply__toggle--on messageActions__action" title="Expand this thread" aria-label="Expand this thread" aria-expanded="false">';
                suffix +=     '<i class="fa fa-plus-square-o"></i>';
                suffix += '</button>';

                suffix += '<button class="reply__toggle reply__toggle--off messageActions__action" title="Collapse this thread" aria-label="Collapse this thread" aria-expanded="true">';
                suffix +=     '<i class="fa fa-minus-square-o"></i>';
                suffix += '</button>';
            }
            suffix += '</span>';
        }
        
        var author = '';
        var collapseWidget = '';
        if (options.author) {
            this.processLastSpoke(options.author, message);
            
            var previous = message.previousVisible();
            if (
                !this.firstRender ||
                message.equals(this.firstRender) ||
                !this.addSameAuthorClass(message, classNames, previous, inThread)
            ) {
                classNames.push("firstAuthor");
            }
            var authorProps = _.extend({}, {
                className: 'author',
                color: true,
                suffix: options.authorSuffix,
                noData: true,
                hasDataParent: true
            }, options.authorProps);
            if (message.isRelayBot()) {
                authorProps.noMode = true;
            }
            var relayMsgParts = message.relayMsgParts(options.author);
            var authorName = relayMsgParts.nick;
            author += '<span class="authorWrap">';


            var channelContext = message.channelContext();
            if (channelContext) {
                classNames.push("has-channel-context");
                author += '<span class="channel-context">';
                if (this.buffer.isChannel()) {
                    var target = message.get('target');
                    if (message.isSelf() && target) {
                        author += '<span><i class="fa fa-eye"></i>Only visible to ';
                        var targetUser = this.buffer.connection.makeUserFromTarget(
                            this.buffer.bid(), {
                                nick: target,
                                hostmask: message.get('recipient_hostmask'),
                                ident_prefix: message.get('recipient_ident_prefix'),
                                from_name: message.get('recipient_name'),
                                from_host: message.get('recipient_host'),
                                from_mode: message.get('recipient_mode'),
                                from_account: message.get('recipient_account'),
                                from_realname: message.get('recipient_realname'),
                                avatar: message.get('recipient_avatar'),
                                avatar_url: message.get('recipient_avatar_url'),
                                display_name: message.get('recipient_display_name'),
                                bot_url: message.get('recipient_bot_url')
                            }
                        );
                        author += this.formatter.linkUserMode(targetUser);
                        author += '</span>';
                    } else {
                        author += '<span><i class="fa fa-eye"></i>Only visible to you</span>';
                    }
                } else {
                    author += this.formatter.linkChannel(channelContext);
                }
                author += '</span>';
            } else if (message.isEphemeral()) {
                classNames.push("has-channel-context");
                author += '<span class="channel-context">';
                author += '<span><i class="fa fa-eye"></i>Only visible to you</span>';
                author += '</span>';
            }

            author += this.avatar(message, authorName, {
                color: options.avatarColor,
                name: authorProps.name
            });
            if (options.authorPrefix) {
                author += options.authorPrefix;
            }
            author += '<span class="g" aria-hidden="true">&lt;</span>';
            if (options.linkAuthor) {
                author += this.formatter.linkMessageUser(authorName, message, authorProps);
            } else {
                author += this.formatter.spanMessageUser(authorName, message, authorProps);
            }
            author += '<span class="g" aria-hidden="true">&gt;</span>';
            author += '&nbsp;';
            if (options.linkAuthor || relayMsgParts.relay) {
                var user = message.makeUser(authorName);
                var realname = user.getSensibleRealname();
                if (
                    !message.getTagDisplayName() &&
                    !message.parseDisplayAuthor() &&
                    realname &&
                    realname != authorName
                ) {
                    author += '<span class="author-realname">';
                    author += this.formatter.renderLinkify(realname, {
                        noColor: true
                    });
                    author += '&nbsp;';
                    author += '</span>';
                }

                var botSuffix = this.botSuffix(message, authorName, relayMsgParts, classNames);
                author += botSuffix;
            }
            author += '</span>';
        } else if (message.isJoinPart() || message.isDisconnect()) {
            var groupLabel = message.isJoinPart() ? "User activity" : "Disconnections";
            collapseWidget += '<span class="collapseWidget" aria-label="' + groupLabel + '">';
            collapseWidget    += '<i class="fa fa-minus-square-o collapseIcon">';
            collapseWidget    += '</i>';
            collapseWidget    += '<i class="fa fa-plus-square-o expandIcon">';
            collapseWidget    += '</i>';
            collapseWidget    += '<i class="fa fa-angle-right collapsedIcon">';
            collapseWidget    += '</i>';
            collapseWidget += '</span>';
        }
        if (message.isHideableJoinPart()) {
            classNames.push('joinPart');
        }

        var quoteReply = '';
        var replyIndicator = '';
        if (
            this.buffer.isChild() && 
            message.collection &&
            (message.isReplyable() || message.isTwitchReplyable())
        ) {
            var reply = message.getReply();
            replyIndicator += '<button class="reply__indicator" aria-label="Reply">';
            if (reply) {
                classNames.push('reply');
                classNames.push('reply__child');
                classNames.push('reply_' + this.formatter.getReplyColorIndex(reply));
                var quoteReplyString = message.quoteReplyString();
                quoteReply = '<span class="reply__quote">';
                if (quoteReplyString) {
                    quoteReply += '<span class="link">';
                    quoteReply += this.formatter.escapeText(quoteReplyString);
                    quoteReply += '</span>';
                }
                quoteReply += '</span>';
                replyIndicator += '<i class="fa fa-comments"></i>';
            } else {
                replyIndicator += '<i class="fa fa-comment"></i>';
            }
            replyIndicator += '</button>';
        }
        
        var statusmsg = '';
        if (!options.hideStatusMsg) {
            statusmsg += this.buildStatusMsg(message);
        }
        
        if (message.isImportantHighlight()) {
            classNames.push('highlight');
        }
        if (options.classNames) {
            classNames = classNames.concat(options.classNames);
        }
        var fullContent = collapseWidget + statusmsg + content;
        var contents = html + quoteReply + '<span class="message">' + author + '<span class="content">' + replyIndicator + fullContent + '</span></span>' + suffix;
        var row = this.buildRow(message, {
            classNames: classNames,
            attr: options.attr,
            contents: contents,
            noData: options.noData,
            noId: options.noId,
            data: options.data
        });
        return row;
    },
    buildRow: function (message, options) {
        options = options || {};
        // Class
        var classNames = ['row'];
        if (options.classNames) {
            classNames = classNames.concat(options.classNames);
        }
        if (this.messageOptions && this.messageOptions.classNames) {
            classNames = classNames.concat(this.messageOptions.classNames);
        }
        
        // Attrs
        var attrs = _.extend({}, options.attr);
        if (message) {
            if (!options.noData && !options.noId) {
                var pendingReqid = message.get('_pendingreqid');
                if (pendingReqid) {
                    classNames.push('pending', 'pending_' + pendingReqid);
                }
                
                if (message.get('type')) {
                    classNames.push('type_' + message.get('type'));
                }
                if (message.isIgnored()) {
                    classNames.push('ignored');
                }
                classNames.push('userParent');
            }
            attrs.data = this.messageData(message, options);
            // ID
            if (!options.noId) {
                attrs['id'] = message.getEventId();
            }
        }
        attrs['class'] = classNames.join(' ');
        var html = '<div' + this.formatter.makeAttributes(attrs) + '>';
        if (options.contents) {
            html += options.contents;
        }
        html += '</div>';
        return html;
    },
    messageData: function (message, options) {
        options = options || {};
        var data = {
            'cid': this.buffer.getCid(),
            'bid': this.buffer.bid(),
            'eid': message.id,
            'time': message.getTime()
        };
        if (!options.noData && !options.noId) {
            data['usermask'] = message.get('hostmask');
            data['name'] = options.author || message.getNick();
            data['msgid'] = message.getMsgId() || message.id;
            data['reply'] = message.getReply();
        }
        data = _.extend(data, options.data);
        return data;
    },
    buildDividerRow: function (message, options) {
        options = options || {};
        var contents = '<hr>';
        if (options.contents) {
            contents += '<h4 class="divider-text-wrapper"><span class="divider-text">' + options.contents + '</span></h4>';
        }
        options.contents = contents;
        return this.buildRow(message, options);
    },
    buildDateRow: function (message, classNames, extraContent) {
        extraContent = extraContent || '';
        var date = message.getDate().toString("dddd, MMMM dS, yyyy");
        classNames = classNames || [];
        classNames.push('dateChange');
        var row = this.buildRow(message, {
            classNames: classNames,
            contents: '<h3>' + extraContent + this.formatter.escapeText(date) + '</h3>',
            noId: true
        });
        return row;
    },
    renderGroupedLines: function (message) {
        var group = '<div class="groupedLines">';
        if (message.get('start')) {
            group += '<h2 class="groupedLines__line">' + this.formatter.renderLinkify(message.get('start'), {
                message: message
            }) + '</h2>';
        }
        _.each(message.get('lines'), function (line) {
            group += '<div class="groupedLines__line">';
            group += this.formatter.renderLinkify(line, {
                message: message
            });
            group += '</div>';
        }, this);
        group += '</div>';
        
        var row = this.buildRow(message, {
            classNames: ['messageRow'],
            contents: group
        });
        
        return this.push(row);
    },
    renderMotd: function (message, content) {
        var row = this.buildMessageRow(message, content, {
            classNames: ['motd']
        });
        return this.push(row);
    },
    renderNotice: function (message, content, from) {
        var linkAuthor = false;
        if (message.get('from') && !from) {
            linkAuthor = true;
        }
        from = from || message.get('from');
        var classNames = ['notice'];
        if (message.isDeletedOrRedacted()) {
            classNames.push('redacted');
        }
        var authorProps = {};
        if (message.getDisplayAuthor()) {
            this.formatter.setDisplayAuthorProps(
                authorProps, message.getDisplayAuthor(), from
            );
        }
        var row = this.buildMessageRow(message, content, {
            author: from,
            linkAuthor: linkAuthor,
            classNames: classNames,
            authorProps: authorProps
        });
        return this.push(row);
    },
    renderWarning: function (message, content, from) {
        var linkAuthor = false;
        if (message.get('from') && !from) {
            linkAuthor = true;
        }
        from = from || message.get('from');
        var row = this.buildMessageRow(message, content, {
            author: from,
            linkAuthor: linkAuthor,
            classNames: ['warning']
        });
        return this.push(row);
    },
    renderStatus: function (message, content, from) {
        var row = this.buildMessageRow(message, content, {
            author: from,
            classNames: ['status']
        });
        return this.push(row);
    },
    renderMonoStatus: function (message, content, options) {
        options = options || {};
        var row = this.buildMessageRow(message, content, {
            author: options.from,
            classNames: ['status', 'monospace'],
            noId: options.noId
        });
        return this.push(row);
    },
    renderMonoWarning: function (message, content, from) {
        var row = this.buildMessageRow(message, content, {
            author: from,
            classNames: ['status', 'monospace', 'warning']
        });
        return this.push(row);
    },
    renderHelp: function (message) {
        return this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
    },
    renderStats: function (message) {
        var msg = '';
        if (message.get('parts')) {
            msg += this.formatter.render(message.get('parts'));
            if (message.get('msg')) {
                msg += ': ';
            }
        }
        if (message.get('msg')) {
            msg += this.formatter.renderLinkify(message.get('msg'));
        }
        return this.renderMonoStatus(message, msg);
    },
    renderChat: function (message, content) {
        var classNames = ['chat'];
        if (message.isSelf()) {
            classNames.push('self');
        }
        if (message.isDeletedOrRedacted()) {
            classNames.push('redacted');
        }
        if (message.isThrottled()) {
            classNames.push('throttled');
        }
        if (message.isOnlyEmoji()) {
            classNames.push('only_emoji');
        }
        if (message.isOnlyEmojiNative()) {
            classNames.push('only_emoji--native');
        }
        var from = message.get('from');
        var author;
        var linkAuthor = false;
        if (from) {
            author = from;
            linkAuthor = true;
        } else {
            author = message.get('server');
        }
        var messageProps = {
            'author': author,
            'linkAuthor': linkAuthor,
            'classNames': classNames
        };
        var authorProps = {};
        var twitchTags = message.getTwitchTags();
        if (twitchTags) {
            this.formatter.setTwitchAuthorProps(message, authorProps, author);
            if (!message.isSelf() && twitchTags['color']) {
                messageProps.avatarColor = twitchTags['color'];
            }
            authorProps.prefix = this.formatter.renderTwitchBadges(message);
        }
        if (message.getDisplayAuthor()) {
            this.formatter.setDisplayAuthorProps(
                authorProps, message.getDisplayAuthor(), author
            );
        }
        messageProps.authorProps = authorProps;
        var row = this.buildMessageRow(message, content, messageProps);
        return this.push(row);
    },
    renderMeMessage: function (message, content) {
        var nick = message.get('from');
        var linkAuthor = false;
        if (nick) {
            linkAuthor = true;
        } else {
            nick = message.get('server');
        }
        var prefix = '<span class="me_prefix">—</span>&nbsp;';
        var authorProps = {
            className: 'author',
            color: true,
            noData: true,
            hasDataParent: true
        };
        if (message.isRelayBot()) {
            authorProps.noMode = true;
        }
        var classNames = ['me'];
        if (message.isSelf()) {
            classNames.push('self');
        }
        if (message.isDeletedOrRedacted()) {
            classNames.push('redacted');
        }
        if (message.isThrottled()) {
            classNames.push('throttled');
        }
        var messageProps = {
            hideStatusMsg: true,
            classNames: classNames
        };
        var avatarColor;
        var twitchTags = message.getTwitchTags();
        var authorLink = '';
        if (nick) {
            this.processLastSpoke(nick, message);
            if (twitchTags) {
                this.formatter.setTwitchAuthorProps(message, authorProps, nick);
                if (!message.isSelf() && twitchTags['color']) {
                    avatarColor = twitchTags['color'];
                }
                prefix += this.formatter.renderTwitchBadges(message);
            }
            if (message.getDisplayAuthor()) {
                this.formatter.setDisplayAuthorProps(
                    authorProps, message.getDisplayAuthor(), nick
                );
            }
            // var authorName = nick;
            var relayMsgParts = message.relayMsgParts(nick);
            var authorName = relayMsgParts.nick;
            prefix = this.avatar(message, authorName, {
                color: avatarColor,
                size: 16,
                name: authorProps.name
            }) + prefix;

            if (linkAuthor) {
                authorLink = this.formatter.linkMessageUser(authorName, message, authorProps);
            } else {
                authorLink = this.formatter.spanMessageUser(authorName, message, authorProps);
            }

            var botSuffix = this.botSuffix(message, authorName, relayMsgParts, classNames);
            if (botSuffix) {
                authorLink += '&nbsp;' + botSuffix;
            }
        }
        var row = this.buildMessageRow(message, prefix + authorLink + '&nbsp;' + this.buildStatusMsg(message) + content, messageProps);
        return this.push(row);
    },
    botSuffix: function (message, authorName, relayMsgParts, classNames) {
        var suffix = '';
        var user = message.makeUser(authorName);
        var botUrl = user.get('bot_url');
        var botLink;
        if (relayMsgParts.relay) {
            var relayTitle = 'Relayed by ' + this.formatter.escapeText(relayMsgParts.relay);
            if (relayMsgParts.server) {
                relayTitle += ' from ' + this.formatter.escapeText(relayMsgParts.server);
            }
            var relayTxt = '<span class="author-bot-nick" title="' + relayTitle + '">RELAY: ';
            if (relayMsgParts.server) {
                relayTxt += this.formatter.escapeText(relayMsgParts.server);
            }
            relayTxt += '</span>';
            suffix += '<span class="author-bot">' + relayTxt + '&nbsp;</span>';
        }
        if (botUrl || message.isBot()) {
            classNames.push("bot");
            suffix += '<span class="author-bot">';
            var botText = 'BOT';
            if (message.isRelayBot()) {
                botText = 'RELAY';
            }
            if (message.getDisplayAuthor()) {
                botText += '<span class="author-bot-nick">: ' + this.formatter.escapeText(authorName) + '</span>';
            }
            // Sanitise link
            if (botUrl) {
                botLink = this.formatter.linker.makeLinkFromUrl(
                    botUrl, botText
                );
            }
            if (botLink) {
                suffix += botLink;
            } else {
                var botTitle = '';
                if (botUrl) {
                    botTitle += '(' + this.formatter.escapeText(botUrl) + ')';
                }
                suffix += '<span title="' + botTitle + '">' + botText + '</span>';
            }
            suffix += '&nbsp;</span>';
        }
        return suffix;
    },
    renderLine: function (message, content) {
        var row = this.buildMessageRow(message, content);
        return this.push(row);
    },
    renderMonospace: function (message, content) {
        var row = this.buildMessageRow(message, content, {
            classNames: ['monospace']
        });
        return this.push(row);
    },
    renderPart: function (message, noId) {
        var row = this.buildDividerRow(message, {
            classNames: ['part'],
            noId: noId
        });
        return this.push(row);
    },
    renderLineWithPart: function (message, content) {
        return this.renderLine(message, content).renderPart(message, true);
    },
    renderDateRow: function (message, classNames, extraContent) {
        this.push(this.buildDateRow(message, classNames, extraContent));
    },
    messageHandlers: {
        channel_topic: function (message) {
            var msg = '';
            var author = message.get('author');
            var server = message.get('server');
            if (server) {
                msg += 'The server ' + this.formatter.linkServer(server) + ' ';
            } else if (author) {
                msg += this.formatter.linkMessageUser(author, message) + ' ';
            }
            if (message.get('topic')) {
                msg += 'set the topic: ' + this.formatter.renderLinkify(message.get('topic'), {
                    message: message
                });
            } else {
                msg += 'cleared the topic';
            }
            this.renderStatus(message, msg);
        },
        buffer_msg: function (message) {
            var content;
            var msg = this.formatter.renderLinkifyComicSans(message.get('msg'), {
                message: message,
                codeSpan: this.buffer.formatCodeSpan(),
                codeBlock: this.buffer.formatCodeBlock(),
                quote: this.buffer.formatQuote(),
                stripDisplayName: message.getTagDisplayName() || message.parseDisplayAuthor()
            });
            var attachment = this.formatter.renderAttachment(message, msg);
            var slackBlocks = this.formatter.renderSlackBlocks(message);
            if (message.isAttachmentFallback() || message.hasSlackBlocks()) {
                msg = '';
                if (!attachment && !slackBlocks) {
                    return;
                }
            }
            content = slackBlocks + msg + attachment;
            this.renderChat(message, content);
        },
        buffer_me_msg: function (message) {
            var content;
            var msg = this.formatter.renderLinkifyComicSans(message.get('msg'), {
                message: message,
                codeSpan: this.buffer.formatCodeSpan(),
                stripDisplayName: message.getTagDisplayName() || message.parseDisplayAuthor()
            });
            var attachment = this.formatter.renderAttachment(message, msg);
            if (message.isAttachmentFallback()) {
                msg = '';
                if (!attachment) {
                    return;
                }
            }
            content = msg + attachment;
            this.renderMeMessage(message, content);
        },
        notice: function (message) {
            // If there's a host but no name, pass a from string so that it doesn't get linked
            var from;
            if (message.get('from_host') && !message.get('from_name')) {
                from = message.get('from');
            }
            var content;
            var msg = this.formatter.renderLinkify(message.get('msg'), {
                message: message,
                stripDisplayName: message.getTagDisplayName() || message.parseDisplayAuthor()
            });
            if (this.buffer.isServerLog() && (message.get('to_chan') || message.isSelf()) && message.get('target') != '*') {
                msg = this.formatter.linkBuffer(message.get('target')) + ': ' + msg;
            }
            content = msg;
            this.renderNotice(message, content, from);
        },
        newsflash: function (message) {
            this.renderNotice(message, this.formatter.render(message.get('msg')));
        },
        invited: function (message) {
            this.renderNotice(message, this.formatter.linkNick(message.get('inviter')) + ' invited ' + this.formatter.linkNick(message.get('invitee')) + ' to join ' + this.formatter.linkChannel(message.get('channel')));
        },
        channel_invite: function (message) {
            var channelLink = this.formatter.linkChannel(message.get('channel'), {
                className: 'channelInviteLink'
            });
            this.renderNotice(message, "Invite to join " + channelLink);
        },
        callerid: function (message) {
            var msg = this.formatter.linkMessageUser(message.get('nick'), message) + " (" + this.formatter.renderNoEmoji(message.get('usermask')) + ") " + this.formatter.render(message.get('msg'));
            this.renderNotice(message, msg);
        },
        twitch_hosttarget_start: function (message) {
            var target = message.get('target');
            var msg = 'This channel is now hosting ' + this.formatter.linkChannel('#' + target, {name: target});
            if (message.get('viewer_count')) {
                msg += ' (' + this.formatter.escapeText(message.get('viewer_count')) + ' viewers)';
            }
            this.renderStatus(message, msg);
        },
        twitch_hosttarget_stop: function (message) {
            var msg = 'This channel has stopped hosting';
            this.renderStatus(message, msg);
        },
        twitch_usernotice: function (message) {
            var tags = message.getTwitchTags();
            var nick = tags['login'];
            var prefix = '<span class="me_prefix">—</span>&nbsp;';
            var status = '';
            var statusMsg = tags['system-msg'];
            var classNames = ['me'];
            if (message.isSelf()) {
                classNames.push('self');
            }
            var messageProps = {
                hideStatusMsg: true,
                classNames: classNames
            };
            if ((tags['msg-id'] == 'resub' || tags['msg-id'] == 'sub') && tags['msg-param-cumulative-months'].match(/^\d+$/)) {
                var authorProps = {
                    className: 'author',
                    color: true
                };
                this.formatter.setTwitchAuthorProps(message, authorProps, nick);
                var avatarColor;
                if (!message.isSelf() && tags['color']) {
                    avatarColor = tags['color'];
                }
                prefix += this.formatter.renderTwitchBadges(message);
                prefix = this.avatar(message, nick, {
                    color: avatarColor,
                    name: authorProps.name
                }) + prefix;
                var authorLink = this.formatter.linkMessageUser(nick, message, authorProps);
                status += prefix + authorLink + '&nbsp;';
                statusMsg = '<b>Subscribed</b>';
                var tier;
                var plan = tags['msg-param-sub-plan'];
                if (plan == 'Prime') {
                    var chanParam = '&channel=' + this.formatter.escapeText(this.buffer.normalise());
                    tier = 'with <a href="https://twitch.amazon.com/prime?ref=subscriptionMessage' + chanParam + '" target="_blank">Twitch Prime</a>';
                } else {
                    var planTier = plan.match(/([0-9])000/);
                    if (planTier) {
                        tier = 'at Tier ' + planTier[1];
                    } else if (plan) {
                        tier = '(' + this.formatter.escapeText(plan) + ')';
                    }
                }
                if (tier) {
                    statusMsg += ' ' + tier;
                }
                if (tags['msg-id'] == 'resub') {
                    statusMsg += '. They’ve subscribed for ' + tags['msg-param-cumulative-months'] + ' months!';
                }
            } else {
                status += prefix;
            }
            status = status + '<span class="twitch_usernotice_msg">' + statusMsg + '</span>';
            var content = '';
            if (message.get('msg')) {
                content = this.formatter.renderLinkifyComicSans(message.get('msg'), {
                    message: message
                });
            }
            var row = this.buildMessageRow(message, status + '&nbsp;' + this.buildStatusMsg(message) + content, messageProps);
            return this.push(row);
        },
        your_unique_id: function (message) {
            this.renderMonoStatus(message, 'Your unique ID is <b>' + this.formatter.render(message.get('unique_id')) + '</b>');
        },
        server_welcome: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('msg')));
        },
        server_yourhost: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('msg')));
        },
        server_created: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        myinfo: function (message) {
            var options = {noId: true};
            this.renderMonoStatus(message, 'Host: ' + this.formatter.render(message.get('server')));
            this.renderMonoStatus(message, 'IRCd: ' + this.formatter.render(message.get('version')), options);
            this.renderMonoStatus(message, 'User modes: ' + this.formatter.render(message.get('user_modes')), options);
            this.renderMonoStatus(message, 'Channel modes: ' + this.formatter.render(message.get('channel_modes')), options);
            if (message.get('rest')) {
                this.renderMonoStatus(message, 'Parametric channel modes: ' + this.formatter.render(message.get('rest')), options);
            }
        },
        version: function (message) {
            var msg = '';
            if (message.get('server_version')) {
                msg += '<b>' + this.formatter.escapeText(message.get('server_version')) + '</b> ';
            }
            msg += this.formatter.render(message.get('comments'));
            this.renderMonoStatus(message, msg);
        },
        server_luserclient: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserop: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('value')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserunknown: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('value')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserchannels: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('value')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserconns: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserme: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_n_global: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_n_local: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_snomask: function (message) {
            var msg = message.get('msg');
            var flags = message.get('flags');
            if (flags) {
                this.renderMonoStatus(message, this.formatter.renderLinkify(msg + ' [' + flags + ']'));
            } else {
                this.renderMonoStatus(message, this.formatter.renderLinkify(msg));
            }
        },
        self_details: function (message) {
            var noId = false;
            if (message.get('userhost') && message.get('user')) {
                this.renderMonoStatus(message, 'Your hostmask: <b>' + this.formatter.renderNoEmoji(message.get('usermask')) + '</b>');
                noId = true;
            }
            if (message.get('server_realname')) {
                this.renderMonoStatus(message, 'Your name: <b>' + this.formatter.renderLinkify(message.get('server_realname')) + '</b>', {noId: noId});
            }
        },
        hidden_host_set: function (message) {
            this.renderMonoStatus(message, '<b>' + this.formatter.render(message.get('hidden_host')) + '</b> ' + this.formatter.renderLinkify(message.get('msg') || 'is your hostname'));
        },
        codepage: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            if (message.get('codepage')) {
                msg = '<b>' + this.formatter.render(message.get('codepage')) + '</b> ' + msg;
            }
            this.renderMonoStatus(message, msg);
        },
        logged_in_as: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        logged_out: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        register: function (message) {
            var msg = '<b>' + this.formatter.render(message.get('account')) + '</b>: ' + this.formatter.renderLinkify(message.get('msg'));
            if (message.get('action') == 'SUCCESS') {
                this.renderMonoStatus(message, msg);
            } else {
                msg += ' (' + this.formatter.render(message.get('action')) + ')';
                this.renderMonoStatus(message, msg);
            }
        },
        verify: function (message) {
            var msg = '<b>' + this.formatter.render(message.get('account')) + '</b>: ' + this.formatter.renderLinkify(message.get('msg'));
            if (message.get('action') == 'SUCCESS') {
                this.renderMonoStatus(message, msg);
            } else {
                msg += ' (' + this.formatter.render(message.get('action')) + ')';
                this.renderMonoStatus(message, msg);
            }
        },
        nick_locked: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        
        // These are kept for backwards compat
        server_motdstart: function (message) {
            this.renderMotd(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_motd: function (message) {
            this.renderMotd(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_endofmotd: function (message) {
            this.renderMotd(message, this.formatter.renderLinkify(message.get('msg')));
        },
        // This is still used
        server_nomotd: function (message) {
            this.renderMotd(message, this.formatter.renderLinkify(message.get('msg')));
        },
        // New style grouped
        motd_response: function (message) {
            this.renderGroupedLines(message);
        },
        info_response: function (message) {
            this.renderGroupedLines(message);
        },
        generic_server_info: function (message) {
            this.renderNotice(message, this.formatter.renderLinkify(message.get('msg')));
        },
        error: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        unknown_umode: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            if (message.get('flag')) {
                msg = '<b>' + this.formatter.render(message.get('flag')) + '</b> ' + msg;
            }
            this.renderWarning(message, msg);
        },
        wallops: function (message) {
            // If there's a host but no name, pass a from string so that it doesn't get linked
            var from;
            if (message.get('from_host') && !message.get('from_name')) {
                from = message.get('from');
            }
            this.renderNotice(message, this.formatter.renderLinkify(message.get('msg')), from);
        },
        too_fast: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            if (message.get('target')) {
                msg = '<b>' + this.formatter.render(message.get('target')) + '</b> ' + msg;
            }
            this.renderWarning(message, msg);
        },
        no_bots: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        bad_ping: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        nickname_in_use: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('nick')) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        invalid_nick_change: function (message) {
            this.renderWarning(message, this.formatter.linkBuffer(message.get('ban_channel')) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        save_nick: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('nick')) + ': ' + this.formatter.renderLinkify(message.get('msg')) + ': <b>' + this.formatter.render(message.get('new_nick')) + '</b>');
        },
        nick_collision: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('collision')) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        bad_channel_mask: function (message) {
            this.renderWarning(message, this.formatter.linkChannel(message.get('channel')) + ' ' + this.formatter.renderLinkify(message, message.get('msg')));
        },
        you_are_operator: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_success: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_fail: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_mechs: function (message) {
            this.renderMonoStatus(message, '<b>SASL</b>     Mechanisms: ' + this.formatter.render(message.get('mechs')));
        },
        sasl_too_long: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_aborted: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_already: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        cap_ls: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b> Server supports: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_list: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>         Enabled: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_new: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>    Server added: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_del: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>  Server removed: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_req: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>      Requesting: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_ack: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>    Acknowledged: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_nak: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>        Rejected: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_raw: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b> " + this.formatter.render(message.get('line')));
        },
        cap_invalid: function (message) {
            this.renderMonoWarning(message, "<b>CAP</b> " + this.formatter.render(message.get('msg')));
        },
        rehashed_config: function (message) {
            this.renderNotice(message, this.formatter.render('Rehashed config: ' + message.get('file') + ' (' + message.get('msg') + ')'));
        },
        inviting_to_channel: function (message) {
            this.renderStatus(message, 'You invited ' + this.formatter.linkNick(message.get('recipient')) + ' to join ' + this.formatter.linkChannel(message.get('channel')));
        },
        invite_notify: function (message) {
            this.renderStatus(message, this.formatter.linkMessageUser(message.get('from'), message) + ' invited ' + this.formatter.linkNick(message.get('target')) + ' to join ' + this.formatter.linkChannel(message.get('channel')));
        },
        user_chghost: function (message) {
            var newUser = message.getIdent();
            var newMask = newUser + '@' + message.getHost();
            var oldMask = message.get('usermask');

            var msg = this.formatter.linkMessageUser(message.get('nick'), message);
            msg += ' changed host: ';
            msg += this.formatter.renderNoEmoji(oldMask);
            msg += ' <span class="prefix">→</span> ';
            msg += this.formatter.renderNoEmoji(newMask);
            this.renderLine(message, msg);
        },
        channel_name_change: function (message) {
            var renamer;
            if (message.get('from')) {
                renamer = this.formatter.linkMessageUser(message.get('from'), message);
            } else {
                renamer = 'The server';
                if (message.get('server')) {
                    renamer += ' ' + this.formatter.linkServer(message.get('server'));
                }
            }
            var msg = renamer + ' renamed the channel: ' + this.formatter.render(message.get('old_name')) + ' <span class="prefix">→</span> <b>' + this.formatter.render(message.get('new_name')) + '</b>';
            if (message.get('reason')) {
                msg += ': ' + this.formatter.renderLinkify(message.get('reason'), {
                    message: message
                });
            }
            this.renderLine(message, msg);
        },
        knock: function (message) {
            var nick = message.get('nick');
            var msg;
            if (nick) {
                msg = this.formatter.linkMessageUser(nick, message) + " " + this.formatter.renderLinkify(message.get('msg'));
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            } else {
                msg = this.formatter.render(message.get('userhost')) + " " + this.formatter.renderLinkify(message.get('msg'));
            }
            this.renderNotice(message, msg);
        },
        kill_deny: function (message) {
            this.renderWarning(message, this.formatter.linkChannel(message.get('channel')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        chan_own_priv_needed: function (message) {
            this.renderWarning(message, this.formatter.linkChannel(message.get('channel')) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        not_for_halfops: function (message) {
            this.renderWarning(message, this.formatter.linkModel(this.buffer) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        channel_renamed: function (message) {
            var msg = this.formatter.linkChannel(message.get('old_chan')) +
                ' → ' + this.formatter.linkChannel(message.get('new_chan')) +
                ' ' + this.formatter.renderLinkify(message.get('msg'));
            this.renderWarning(message, msg);
        },
        link_channel: function (message) {
            var prefix = '';
            if (message.get('invalid_chan')) {
                prefix = this.formatter.linkChannel(message.get('invalid_chan')) + ' ';
                if (message.get('valid_chan') && message.get('valid_chan') != '*') {
                    prefix += '→ ' + this.formatter.linkChannel(message.get('valid_chan')) + ' ';
                }
            }
            this.renderWarning(message, prefix + this.formatter.renderLinkify(message.get('msg')));
        },
        chan_forbidden: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            var chan = message.get('channel');
            if (chan) {
                msg = this.formatter.render(chan) + ': ' + msg;
            }
            this.renderWarning(message, msg);
        },
        joined_channel: function (message) {
            var msg = '<span class="prefix">→</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " joined";
            if (this.buffer.isConversation()) {
                msg += ' ' + this.formatter.linkChannel(message.get('chan'));
            }
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            this.renderLine(message, msg);
        },
        you_joined_channel: function (message) {
            var msg = '<span class="prefix">→</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " joined";
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            this.renderLine(message, msg);
        },
        parted_channel: function (message) {
            var msg = '<span class="prefix">←</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " left";
            if (this.buffer.isConversation()) {
                msg += ' ' + this.formatter.linkChannel(message.get('chan'));
            }
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            if (message.get('msg')) {
                msg += ": " + this.formatter.renderLinkify(message.get('msg'), {
                    message: message
                });
            }
            this.renderLine(message, msg);
        },
        you_parted_channel: function (message) {
            var msg = '<span class="prefix">←</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " left";
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            if (message.get('msg')) {
                msg += ": " + this.formatter.renderLinkify(message.get('msg'), {
                    message: message
                });
            }
            this.renderLineWithPart(message, msg);
        },
        kicked_channel: function (message) {
            var msg = '<span class="prefix">←</span> ' + this.formatter.linkMessageUser(message.get('nick'), message);
            if (message.get('hostmask')) {
                msg += " (" + this.formatter.renderNoEmoji(message.get('hostmask')) + ")";
            }
            msg += " was kicked";
            if (this.buffer.isConversation()) {
                msg += ' from ' + this.formatter.linkChannel(message.get('chan'));
            }
            
            var kicker = message.get('kicker');
            if (kicker) {
                if (message.get('kicker_hostmask')) {
                    var user = this.buffer.connection.makeUserFromTarget(this.buffer.bid(), {
                        nick: kicker,
                        hostmask: message.get('kicker_hostmask'),
                        ident_prefix: message.get('kicker_ident_prefix'),
                        from_name: message.get('kicker_name'),
                        from_host: message.get('kicker_host'),
                        from_mode: message.get('kicker_mode'),
                        from_account: message.get('kicker_account'),
                        from_realname: message.get('kicker_realname'),
                        avatar: message.get('kicker_avatar'),
                        avatar_url: message.get('kicker_avatar_url'),
                        display_name: message.get('kicker_display_name'),
                        bot_url: message.get('kicker_bot_url')
                    });
                    msg += ' by ' + this.formatter.linkUserMode(user);
                } else {
                    msg += ' by ' + this.formatter.linkServer(kicker);
                }
            }
            var kickMsg = message.get('msg');
            if (kickMsg && kickMsg != kicker) {
                msg += ": " + this.formatter.renderLinkify(kickMsg);
            }
            this.renderLine(message, msg);
        },
        you_kicked_channel: function (message) {
            var msg = '<span class="prefix">←</span> ' + "You were kicked";
            
            var kicker = message.get('kicker');
            if (kicker) {
                if (message.get('kicker_hostmask')) {
                    var user = this.buffer.connection.makeUserFromTarget(this.buffer.bid(), {
                        nick: kicker,
                        hostmask: message.get('kicker_hostmask'),
                        ident_prefix: message.get('kicker_ident_prefix'),
                        from_name: message.get('kicker_name'),
                        from_host: message.get('kicker_host'),
                        from_mode: message.get('kicker_mode'),
                        from_account: message.get('kicker_account'),
                        from_realname: message.get('kicker_realname'),
                        avatar: message.get('kicker_avatar'),
                        avatar_url: message.get('kicker_avatar_url'),
                        display_name: message.get('kicker_display_name'),
                        bot_url: message.get('kicker_bot_url')
                    });
                    msg += ' by ' + this.formatter.linkUserMode(user);
                } else {
                    msg += ' by ' + this.formatter.render(kicker);
                }
            }
            var kickMsg = message.get('msg');
            if (kickMsg && kickMsg != kicker) {
                msg += ": " + this.formatter.renderLinkify(kickMsg);
            }
            this.renderLineWithPart(message, msg);
        },
        quit: function (message) {
            var msg = '<span class="prefix">⇐</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " quit";
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            var quitMsg = message.get('msg');
            if (quitMsg && quitMsg.toLowerCase().replace(/quit:?\s*$/, '')) {
                msg += " " + this.formatter.renderLinkify(quitMsg, {
                    message: message
                });
            }
            this.renderLine(message, msg);
        },
        
        quit_server: function (message) {
            var msg = '<span class="prefix">⇐</span> You disconnected';
            if (message.get('msg')) {
                msg += ": " + this.formatter.renderLinkify(message.get('msg'));
            }
            this.renderLine(message, msg);
        },
        kill: function (message) {
            var msg = '<span class="prefix">⇐</span> You were killed';
            
            var killer = message.get('from');
            
            if (killer) {
                if (message.get('killer_hostmask')) {
                    var user = this.buffer.connection.makeUserFromTarget(this.buffer.bid(), {
                        nick: killer,
                        hostmask: message.get('killer_hostmask'),
                        ident_prefix: message.get('killer_ident_prefix'),
                        from_name: message.get('killer_name'),
                        from_host: message.get('killer_host'),
                        from_mode: message.get('killer_mode'),
                        from_account: message.get('killer_account'),
                        from_realname: message.get('killer_realname'),
                        avatar: message.get('killer_avatar'),
                        avatar_url: message.get('killer_avatar_url'),
                        display_name: message.get('killer_display_name'),
                        bot_url: message.get('killer_bot_url')
                    });
                    msg += ' by ' + this.formatter.linkUserMode(user);
                    msg += " (" + this.formatter.render(message.get('killer_hostmask')) + ")";
                } else {
                    msg += ' by ' + this.formatter.render(killer);
                }
            }
            var reason = message.get('reason');
            if (reason && reason != "()") {
                msg += ": " + this.formatter.renderLinkify(reason);
            }
            this.renderLine(message, msg);
        },
        banned: function (message) {
            var msg = '<span class="prefix">⇐</span> You were banned';
            if (message.get('server')) {
                msg += ' from ' + this.formatter.render(message.get('server'));
            }
            if (message.get('reason')) {
                msg += ": " + this.formatter.renderLinkify(message.get('reason'));
            }
            this.renderLine(message, msg);
        },
        socket_closed: function (message) {
            var msg = message.getDisconnectMessage();
            if (msg) {
                this.renderLineWithPart(message, this.formatter.renderLinkify(msg));
            } else {
                this.renderPart(message);
            }
        },
        connecting_failed: function (message) {
            this.renderLineWithPart(message, this.formatter.renderLinkify(message.getDisconnectMessage()));
        },
        connecting_cancelled: function (message) {
            this.renderLineWithPart(message, this.formatter.renderLinkify(message.getDisconnectMessage()));
        },
        
        wait: function (message) {
            this.renderStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        starircd_welcome: function (message) {
            this.renderStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        nickchange: function (message) {
            if (this.buffer.connection.isSlack()) {
                return;
            }
            var oldNick = message.get('oldnick');
            var newNick = message.get('newnick');
            var displayName = message.get('display_name');
            var newUser = this.formatter.linkMessageUser(
                newNick,
                message,
                {name: newNick}
            );
            this.renderLine(message, this.formatter.render(oldNick) + ' <span class="prefix">→</span> ' + newUser);
        },
        you_nickchange: function (message) {
            if (this.buffer.connection.isSlack()) {
                return;
            }
            this.renderLine(message, this.formatter.render(message.get('oldnick')) + ' <span class="prefix">→</span> ' + this.formatter.linkMessageUser(message.get('newnick'), message, {name: message.get('newnick')}));
        },
        channel_mode_list_change: function (message) {
            // Only one operation per message at the moment
            var op, actionPrefix, diff, msg;
            var actionSuffix = '';
            var linkTarget = false;
            var invex = this.buffer.connection.getISupport('INVEX');
            var ex = this.buffer.connection.getISupport('EXCEPTS');
            if (message.get('ops').add.length) {
                op = message.get('ops').add[0];
                switch (op.mode) {
                case 'b':
                    actionPrefix = 'banned';
                    break;
                case 'a':
                    actionPrefix = 'protected';
                    linkTarget = true;
                    break;
                case 'q':
                    if (op.param.indexOf('@') === -1 && op.param.indexOf('$') === -1) {
                        // just a nick, owner
                        actionPrefix = 'promoted';
                        actionSuffix = ' to owner';
                        linkTarget = true;
                    } else {
                        // hostmask or extban, quiet
                        actionPrefix = 'quieted';
                    }
                    break;
                default:
                    if (invex && ((invex === true && op.mode == 'I') || op.mode == invex)) {
                        actionPrefix = 'added';
                        actionSuffix = ' to the invite list';
                    } else if (ex && ((ex === true && op.mode == 'e') || op.mode == ex)) {
                        actionPrefix = 'exempted';
                        actionSuffix = ' from bans';
                    } else {
                        actionPrefix = 'added';
                        actionSuffix = ' to the <code>' + this.formatter.escapeText(op.mode) + '</code> list';
                    }
                }
                diff = '+';
            } else if (message.get('ops').remove.length) {
                op = message.get('ops').remove[0];
                switch (op.mode) {
                case 'b':
                    actionPrefix = 'un-banned';
                    break;
                case 'a':
                    actionPrefix = 'un-protected';
                    linkTarget = true;
                    break;
                case 'q':
                    if (op.param.indexOf('@') === -1 && op.param.indexOf('$') === -1) {
                        // just a nick, owner
                        actionPrefix = 'demoted';
                        actionSuffix = ' from owner';
                        linkTarget = true;
                    } else {
                        // hostmask, quiet
                        actionPrefix = 'un-quieted';
                    }
                    break;
                default:
                    if (invex && ((invex === true && op.mode == 'I') || op.mode == invex)) {
                        actionPrefix = 'removed';
                        actionSuffix = ' from the invite list';
                    } else if (ex && ((ex === true && op.mode == 'e') || op.mode == ex)) {
                        actionPrefix = 'un-exempted';
                        actionSuffix = ' from bans';
                    } else {
                        actionPrefix = 'removed';
                        actionSuffix = ' from the <code>' + this.formatter.escapeText(op.mode) + '</code> list';
                    }
                }
                diff = '-';
            } else {
                debug.warn('no ops for channel_mode_list_change', message.get('diff'), message);
                msg = 'Channel list changed <span class="rawMode">' + this.formatter.renderNoEmoji(message.get('diff'), {
                    message: message
                }) + '</span>';
            }
            if (!msg) {
                var target = op.param;
                if (linkTarget) {
                    var targetUser = this.buffer.connection.makeUserFromTarget(
                        this.buffer.bid(),
                        _.extend({}, op, {
                            nick: target
                        })
                    );
                    target = this.formatter.linkUserMode(targetUser);
                } else {
                    target = '<b>' + this.formatter.renderNoEmoji(target) + '</b>';
                }
                var mode = op.mode;
                msg =  actionPrefix + ' ' + target + actionSuffix + ' (' + '<span class="mono rawMode">' + diff + this.formatter.escapeText(mode) + '</span>)';
            }
            var author;
            if (message.get('from')) {
                author = this.formatter.linkMessageUser(message.get('from'), message);
            } else if (message.get('server')) {
                author = 'The server ' + this.formatter.linkServer(message.get('server'));
            }
            msg = author + ' ' + msg;
            this.renderStatus(message, msg);
        },
        user_channel_mode: function (message) {
            var msg = '';
            var nick = message.get('nick');
            var targetUser = message.makeUser(nick);
            var modeChange = new UserChannelMode(message.attributes, {
                buffer: this.buffer,
                user: targetUser
            });
            var action = modeChange.getAction();
            
            var userLink = this.formatter.linkUserMode(targetUser);
            var diff = modeChange.get('diff');
            if (action) {
                msg += userLink + ' was ' + action;
                if (diff) {
                    msg += ' (<span class="mode_prefix mode_' + modeChange.getCategory() + '">' + this.formatter.render(diff) + '</span>)';
                }
            } else if (diff) {
                msg += userLink + ' was set to <b>' + this.formatter.render(diff) + '</b>';
            }
            if (message.get('from')) {
                var byMessage = message.clone();
                byMessage.unset('eid');
                byMessage.unset('newmode');
                byMessage.unset('type');
                for (var kB in byMessage.attributes) {
                    if (kB.indexOf('target_') === 0) {
                        byMessage.unset(kB);
                    }
                }
                msg += ' by ' + this.formatter.linkMessageUser(byMessage.get('from'), byMessage);
            } else {
                msg += ' by the server ' + this.formatter.linkServer(message.get('server'));
            }
            this.renderStatus(message, msg);
        },
        user_mode: function (message) {
            var msg = 'Your user mode';
            if (message.get('newmode')) {
                if (message.get('is_diff')) {
                    msg += ' changed';
                }
            } else {
                if (message.get('is_diff')) {
                    msg += ' was cleared';
                } else {
                    msg += ' is blank';
                }
            }
            if (message.get('newmode')) {
                msg += ': <b>';
                if (!message.get('is_diff')) {
                    msg += '+';
                }
                msg += this.formatter.render(message.get('newmode'));
                msg += '</b>';
            }
            if (message.get('is_diff')) {
                msg += ' (' + this.formatter.render(message.get('diff')) + ')';
            }
            this.renderMonoStatus(message, msg);
        },
        channel_mode: function (message) {
            var msg = 'Channel mode set to <b>' + this.formatter.render(message.get('diff'), {
                message: message
            }) + '</b>';
            if (message.get('from')) {
                msg += ' by ' + this.formatter.linkMessageUser(message.get('from'), message);
            } else {
                msg += ' by the server ' + this.formatter.linkServer(message.get('server'));
            }
            this.renderStatus(message, msg);
        },
        channel_mode_is: function (message) {
            var msg;
            if (message.get('newmode')) {
                msg = 'Channel mode is <b>+' + this.formatter.render(message.get('newmode')) + '</b>';
            } else {
                msg = 'No channel mode';
            }
            this.renderStatus(message, msg);
        },
        channel_url: function (message) {
            this.renderStatus(message, 'Homepage: ' + this.formatter.renderLinkify(message.get('url')));
        },
        zurna_motd: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        loaded_module: function (message) {
            var msg = '<b>' + this.formatter.render(message.get('module')) + '</b> ' + this.formatter.render(message.get('msg'));
            this.renderMonoStatus(message, msg);
        },
        unloaded_module: function (message) {
            var msg = '<b>' + this.formatter.render(message.get('module')) + '</b> ' + this.formatter.render(message.get('msg'));
            this.renderMonoStatus(message, msg);
        },
        unhandled_line: function (message) {
            debug.warn('Unparsed command', message.get('command'), message.get('raw') || message.get('msg'));
            var msg = '';
            if (message.get('command')) {
                msg += this.formatter.escapeText(message.get('command')) + ' ';
            }
            this.renderWarning(message, msg + this.formatter.escapeText(message.get('raw') || message.get('msg')));
        },
        unparsed_line: function (message) {
            debug.warn('Unrecognised numeric', message.get('msg'));
            this.renderWarning(message, this.formatter.escapeText(message.get('msg')));
        },
        msg_services: function (message) {
            this.renderWarning(message, this.formatter.render(message.get('msg')));
        },
        // For backwards compat
        ambiguous_error_message: function (message) {
            this.renderWarning(message, this.formatter.render(message.get('msg')));
        },
        list_usage: function (message) {
            this.renderNotice(message, this.formatter.render(message.get('msg')));
        },
        list_syntax: function (message) {
            this.renderWarning(message, this.formatter.render(message.get('msg')));
        },
        who_syntax: function (message) {
            this.renderWarning(message, this.formatter.render(message.get('msg')));
        },
        nologin: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            var user = message.get('user');
            if (user) {
                msg = this.formatter.linkNick(user) + ': ' + msg;
            }
            this.renderWarning(message, msg);
        },
        services_down: function (message) {
            this.renderWarning(message, '<b>' + this.formatter.render(message.get('services_name')) + '</b>: ' + this.formatter.render(message.get('msg')));
        },
        // HELP
        help_topics_start: function (message) {
            this.renderHelp(message);
        },
        help_topics: function (message) {
            this.renderHelp(message);
        },
        help_topics_end: function (message) {
            this.renderHelp(message);
        },
        helphdr: function (message) {
            this.renderHelp(message);
        },
        helpop: function (message) {
            this.renderHelp(message);
        },
        helptlr: function (message) {
            this.renderHelp(message);
        },
        helphlp: function (message) {
            this.renderHelp(message);
        },
        helpfwd: function (message) {
            this.renderHelp(message);
        },
        helpign: function (message) {
            this.renderHelp(message);
        },
        // STATS
        stats: function (message) {
            this.renderStats(message);
        },
        statslinkinfo: function (message) {
            this.renderStats(message);
        },
        statscommands: function (message) {
            this.renderStats(message);
        },
        statscline: function (message) {
            this.renderStats(message);
        },
        statsnline: function (message) {
            this.renderStats(message);
        },
        statsiline: function (message) {
            this.renderStats(message);
        },
        statskline: function (message) {
            this.renderStats(message);
        },
        statsqline: function (message) {
            this.renderStats(message);
        },
        statsyline: function (message) {
            this.renderStats(message);
        },
        endofstats: function (message) {
            this.renderStats(message);
        },
        statsbline: function (message) {
            this.renderStats(message);
        },
        statsgline: function (message) {
            this.renderStats(message);
        },
        statstline: function (message) {
            this.renderStats(message);
        },
        statseline: function (message) {
            this.renderStats(message);
        },
        statsvline: function (message) {
            this.renderStats(message);
        },
        statslline: function (message) {
            this.renderStats(message);
        },
        statsuptime: function (message) {
            this.renderStats(message);
        },
        statsoline: function (message) {
            this.renderStats(message);
        },
        statshline: function (message) {
            this.renderStats(message);
        },
        statssline: function (message) {
            this.renderStats(message);
        },
        statsuline: function (message) {
            this.renderStats(message);
        },
        statsdebug: function (message) {
            this.renderStats(message);
        },
        spamfilter: function (message) {
            this.renderStats(message);  
        },
        text: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        target_callerid: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('target_nick')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        target_notified: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('target_nick')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        time: function (message) {
            var msg = this.formatter.escapeText(message.get('time_string'));
            if (message.get('time_stamp')) {
                msg += ' (' + this.formatter.escapeText(message.get('time_stamp')) + ')';
            }
            msg += ' — <b>' + this.formatter.escapeText(message.get('time_server')) + '</b>';
            this.renderMonoStatus(message, msg);
        },
        admin_info: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        watch_status: function (message) {
            if (message.get('watch_nick')) {
                this.renderMonoStatus(message, this.formatter.linkNick(message.get('watch_nick')) + ' ' + this.formatter.renderLinkify(message.get('msg')) + ' (' + this.formatter.escapeText(message.get('username')) + '@' + this.formatter.escapeText(message.get('userhost')) + ')');
            }
        },
        sqline_nick: function (message) {
            this.renderMonoStatus(message, '<b>' + this.formatter.render(message.get('charset')) + '</b> ' + this.formatter.render(message.get('msg')));
        }
    }
};


module.exports = LineMessageRenderer;


/***/ }),

/***/ "3dP0":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1Cb+");

// CSS
__webpack_require__("PfEk");
__webpack_require__("5t0/");
__webpack_require__("luaz");
__webpack_require__("sFba");
__webpack_require__("HNx2");
__webpack_require__("j9rr");
__webpack_require__("d1Sw");
__webpack_require__("K/24");
__webpack_require__("sZ6Q");
__webpack_require__("/Vo5");
__webpack_require__("SIBJ");
__webpack_require__("7J3D");
__webpack_require__("Eh61");

/***/ }),

/***/ "3fPi":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<button type=\"button\" class=\"close channelSwitchDialog__close\"><span>Close</span></button>\n<h2 class=\"channelSwitchDialog__title\">Jump to channel</h2>\n<ul class=\"channelSwitchDialog__help\">\n    <li><strong>tab</strong>  or  <strong>↑ ↓</strong> to navigate</li>\n    <li><strong>↵</strong> to select</li>\n    <li><strong>esc</strong> to dismiss</li>\n    <li><i class=\"spin\"></i></li>\n</ul>\n<input class=\"channelSwitchDialog__input input\">\n<div class=\"channelSwitchDialog__channelLinks\"></div>\n";
},"useData":true});

/***/ }),

/***/ "4PFu":
/***/ (function(module, exports, __webpack_require__) {

var BufferStatusView = __webpack_require__("6G2X");


var ChildStatusView = BufferStatusView.extend({});


module.exports = ChildStatusView;


/***/ }),

/***/ "4lyz":
/***/ (function(module, exports) {

var StatusView = Backbone.View.extend({
    el: '.statusContainer',
    initialize: function (options) {
        this.statusMessage = $('#statusMessage');
        
        this.model.connections.bind('init', this.loadingStep, this);
        this.model.bind('doneLoading', this.clearMessage, this);
        
        this.model.backend.bind('stream:starting', this.connecting, this);
        this.model.backend.bind('stream:stopped', this.stopped, this);
        this.model.backend.bind('connected', this.loading, this);
        this.model.backend.bind('tempUnavailableTick', this.tempUnavailableTick, this);
        this.model.backend.bind('unsupported', this.clearMessage, this);
        this.model.backend.bind('offline', this.stopped, this);
        
        this.renderVisible();
    },
    events: {
        'click #statusMessage a.reconnect': 'clickReconnect'
    },
    clickReconnect: function (e) {
        e.preventDefault();
        this.model.startBackend();
    },
    loading: function (numConnections) {
        this.clearReconnectingCountdown();
        this.setMessage('Loading…');
    },
    loadingStep: function (connection) {
        if (!this.model.isInitialized()) {
            this.setMessage('Loading… (' + connection.getName() + ')');
        }
    },
    renderVisible: function () {
        var contents = this.statusMessage.html();
        this.statusMessage.toggle(!!contents);
        this.$el.toggle(!!contents || this.model.isXhrFallback() || this.model.isDbDown());
        this.trigger('change');
    },
    setMessage: function (text) {
        this.statusMessage.text(text);
        this.renderVisible();
    },
    setMessageHtml: function (html) {
        this.statusMessage.html(html);
        this.renderVisible();
    },
    clearMessage: function () {
        this.setMessage('');
    },
    reconnectingIn: function (seconds) {
        this.setMessage('Reconnecting in ' + seconds + ' second' + (seconds == 1 ? '' : 's') + '…');
        this.reconnectingCountdown(seconds - 1);
    },
    clearReconnectingCountdown: function () {
        if (this.connectingMessageTimeout) {
            clearTimeout(this.connectingMessageTimeout);
            this.connectingMessageTimeout = null;
        }
    },
    reconnectingCountdown: function (seconds) {
        this.connectingMessageTimeout = setTimeout(_.bind(function () {
            if (seconds) {
                this.reconnectingIn(seconds);
            } else {
                this.setMessage('Reconnecting…');
            }
        }, this), 1000);
    },
    connecting: function () {
        if (this.model.backend.startDelay) {
            this.clearReconnectingCountdown();
            this.reconnectingIn(this.model.backend.startDelay);
        } else {
            this.setMessage('Connecting…');
        }
    },
    stopped: function () {
        this.clearReconnectingCountdown();
        
        if (this.model.isAuthed()) {
            this.setMessageHtml('Offline. <a href="" class="reconnect">Reconnect</a>');
        } else {
            this.clearMessage();
        }
    },
    tempUnavailableTick: function (seconds) {
        var msg = 'Your account is temporarily unavailable (retrying in ' + seconds + ' second' + (seconds == 1 ? '' : 's') + ')<br><a href="" class="reconnect">Reconnect now</a>';
        if (!this.model.ent()) {
            msg += ' • Check <a href="https://bsky.app/profile/irccloud.com" target="_blank" rel="noreferrer">Bluesky</a> for updates';
        }
        this.setMessageHtml(msg);
        this.trigger('change');
    }
});


module.exports = StatusView;


/***/ }),

/***/ "52EP":
/***/ (function(module, exports, __webpack_require__) {

var ContextMenuView = __webpack_require__("hI2d");
var Formatter = __webpack_require__("5gSh");
var util = __webpack_require__("GmLC");

__webpack_require__("x4eI");


var EmojiContextMenuView = ContextMenuView.extend({
    el: '#emojiContextMenu',
    initialize: function (options) {
        this.afterHide = _.bind(this.deactivateCell, this);
        ContextMenuView.prototype.initialize.call(this, options);
        this.formatter = new Formatter();

        this.list = this.$('.emojiContextMenu__list');
        this.picker = this.$('.emojiContextMenu__picker');
        this.searchInput = this.$('.emojiContextMenu__search');
        this.previewEmoji = this.$('.emojiContextMenu__previewEmoji');
        this.previewName = this.$('.emojiContextMenu__previewName');
    },
    events: $.extend({}, ContextMenuView.prototype.events, {
        'click .emojiContextMenu__pick': 'clickPick',
        'buttonClick .emojiContextMenu__pick': 'clickPick',
        'click .emojiContextMenu__skinPick': 'clickSkin',
        'buttonClick .emojiContextMenu__skinPick': 'clickSkin',
        'mouseenter .emojiContextMenu__pick': 'hoverPick',
        'mouseenter .emojiContextMenu__skinPick': 'hoverSkin',
        'input .emojiContextMenu__search': 'onSearchInput',
        'submit .emojiContextMenu__searchForm': 'onSearchSubmit'
    }),
    clickPick: function (e) {
        window.getSelection().removeAllRanges();
        this.focusSearch();
        e.preventDefault();
        if (!e.shiftKey) {
            this.hide();
            this.reset();
        }
        this.buffer.trigger(this.action, $(e.currentTarget).data('colon'), this.actionData);
    },
    hoverPick: function (e) {
        var colon = $(e.currentTarget).data('colon');
        var idx = $(e.currentTarget).data('idx');
        this.previewEmoji.html(emoji.replace_colons(colon));
        var names = [];
        _.each(emoji.data[idx][3].concat(emoji.colon_aliases[idx] || []), function (c) {
            if (c.indexOf('&') === -1) {
                names.push('<span class="emojiContextMenu__previewNameItem">:' + this.formatter.escapeText(c) + ':</span>');
            }
        }, this);
        this.previewName.html(names.join(''));
    },
    clickSkin: function (e) {
        window.getSelection().removeAllRanges();
        this.focusSearch();
        e.preventDefault();
        this.setSkinTone($(e.currentTarget).data('tone'));
        this.render();
        return false;
    },
    hoverSkin: function (e) {
        var tone = $(e.currentTarget).data('tone');
        var idx = emoji.skin_tone_to_idx(tone);
        if (idx) {
            this.previewEmoji.html(emoji.replace_unified(tone));
            this.previewName.text(emoji.data[idx][3][0]);
        } else {
            this.previewEmoji.html('');
            this.previewName.text('No skin tone');
        }
    },
    onSearchInput: function (e) {
        this.getCandidates(this.searchInput.val());
        this.resetPreview();
        this.render();
    },
    onSearchSubmit: function (e) {
        e.preventDefault();
    },
    previewHints: [
        'Hint: Shift-click to choose more than one'
    ],
    reactionPreviewHints: [
        'Hint: Type +:emoji: in the chat box and use Shift+Up/Down'
    ],
    resetPreview: function () {
        this.previewEmoji.html('');
        var hints = this.previewHints;
        if (this.reaction) {
            hints = hints.concat(this.reactionPreviewHints);
        }
        this.previewName.text(_.sample(hints));
    },
    reset: function () {
        this.searchInput.val('');
        this.onSearchInput();
    },
    render: function () {
        if (this.searchCandidates) {
            this.renderSearchResults();
        } else {
            this.renderEmoji();
        }
    },
    getCandidates: function (input) {
        this.searchCandidates = util.matchEmoji(input);
    },
    deactivateCell: function () {
        this.triggerEl.attr('aria-expanded', 'false');
        if (this.triggerEl && this.triggerEl.is('.emojicell')) {
            this.triggerEl.removeClass('menuActive');
        }
    },
    reactions: [
        '+1',
        '-1',
        'ok_hand',
        'wave',
        '<3',
        'star',
        'fire',
        'tada',
        'joy',
        'laughing',
        'hugging_face',
        'open_mouth',
        'cry',
        'confused',
        'thinking_face',
        'rage'
    ],
    renderSkinTonePicker: function () {
        var html = [];
        var noneClasses = ['emojiContextMenu__skinPick', 'emojiContextMenu__emoji', 'emojiContextMenu__skinPick--none'];
        var skinTone = this.getSkinTone();
        if (!skinTone) {
            noneClasses.push('emojiContextMenu__skinPick--selected');
        }
        html.push('<span role="button" tabindex="0" class="' + noneClasses.join(' ') + '"><i class="fa fa-square title="no skin tone" aria-label="no skin tone"></i></span>');
        _.each(emoji.map.category['Component'], function (item) {
            if (item.item[7] !== 'skin-tone') {
                return;
            }
            var px = item.item[4];
            var py = item.item[5];
            var title = item.item[3][0];
            var mul = 100 / (emoji.sheet_size - 1);
            var attrs = {
                classNames: ['emojiContextMenu__skin'],
                style: 'background-position:'+(mul*px)+'% '+(mul*py)+'%;',
                title: title,
                'aria-label': title
            };
            var classNames = ['emojiContextMenu__skinPick', 'emojiContextMenu__emoji'];
            if (item.item[0][0] === skinTone) {
                classNames.push('emojiContextMenu__skinPick--selected');
            }
            var skinPick = '<span role="button" tabindex="0" class="' + classNames.join(' ') + '" data-tone="' + item.item[0][0] + '">' + emoji.wrap_span('', attrs) + '</span>';
            html.push(skinPick);
        }, this);
        this.picker[0].innerHTML = html.join('');
    },
    renderSearchResults: function () {
        this.renderSkinTonePicker();
        var resultsHtml;
        if (this.searchCandidates.length) {
            var skinTone = this.getSkinTone();
            resultsHtml = ['<h2>Search Results</h2>'];
            resultsHtml = resultsHtml.concat(_.map(this.searchCandidates, function (result) {
                return this.renderSingleEmoji(result.idx, emoji.data[result.idx], skinTone);
            }, this));
        } else {
            resultsHtml = ['<h2>No Results</h2>'];
        }
        this.list[0].innerHTML = resultsHtml.join('');
    },
    renderSingleEmoji: function (key, item, skinTone) {
        var em = emoji.replacement(key, '', item[3][0], undefined, undefined, skinTone);
        var colon = emoji.idx_to_colon(key, skinTone);
        var emPick = '<span class="emojiContextMenu__pick emojiContextMenu__emoji" role="button" tabindex="0" data-colon="' + colon + '" data-idx="' + key + '">' + em + '</span><wbr>';
        return emPick;
    },
    getSkinTone: function () {
        return this.model.getPref('skin-tone');
    },
    setSkinTone: function (tone) {
        return this.model.setPref('skin-tone', tone);
    },
    renderEmoji: function () {
        this.renderSkinTonePicker();
        var skinTone = this.getSkinTone();
        var fullEmHtml = [];
        if (this.reaction) {
            fullEmHtml.push('<h2>Reactions</h2>');
            _.each(this.reactions, function (reaction) {
                var key = emoji.map.colons.get(reaction);
                fullEmHtml.push(this.renderSingleEmoji(key, emoji.data[key], skinTone));
            }, this);
        }
        _.each(emoji.categories, function (category) {
            fullEmHtml.push('<h2>');
            fullEmHtml.push(this.formatter.escapeText(category));
            fullEmHtml.push('</h2>');
            _.each(emoji.map.category[category], function (item) {
                fullEmHtml.push(this.renderSingleEmoji(item.key, item.item, skinTone));
            }, this);
        }, this);
        this.list[0].innerHTML = fullEmHtml.join('');
        this.rendered = true;
    },
    afterShow: function () {
        this.focusSearch();
    },
    focusSearch: function () {
        this.searchInput.focus().select();
    },
    show: function (buffer, triggerEl, options) {
        window.getSelection().removeAllRanges();

        options = options || {};

        this.buffer = buffer;
        this.triggerEl = triggerEl;
        this.action = options.action || 'insertAtCursor';
        this.actionData = options.actionData;
        var previousReaction = this.reaction;
        this.reaction = options.reaction;

        if (!this.rendered || this.reaction != previousReaction) {
            this.reset();
        }
        
        var showOptions = {};
        this.triggerEl.attr('aria-expanded', 'true');
        if (this.triggerEl.is('.emojicell')) {
            this.triggerEl.addClass('menuActive');
            showOptions.anchorRight = true;
            showOptions.anchorBottom = true;
        }
        
        var offset = this.triggerEl.offset();
        var x = offset.left + this.triggerEl.outerWidth();
        var y = offset.top;
        
        ContextMenuView.prototype.show.call(this, x, y, showOptions);
    }
});


module.exports = EmojiContextMenuView;


/***/ }),

/***/ "532c":
/***/ (function(module, exports) {

var VerifyNoticeView = Backbone.View.extend({
    el: '#verifyNotice',
    initialize: function (options) {
        this.resend = $('#resendVerify');
        this.throbber = $('#resendVerifyThrobber');
        
        this.model.bind('init', this.render, this);
    },
    events: {
        'click #resendVerify a': 'clickResend'
    },
    clickResend: function (e) {
        e.preventDefault();
        this.sending();
        this.model.resendVerifyEmail(_.bind(function (response) {
            if (response.success) {
                this.success();
            } else {
                this.failed();
            }
        }, this));
    },
    render: function () {
        if (this.model.isVerified()) {
            this.hide();
        } else {
            this.show();
        }
        this.model.bind('change:verified', this.render, this);
    },
    show: function () {
        // Show a reverify link if they joined more than a day ago
        this.resend.show();
        $(this.el).show();
    },
    hide: function () {
        $(this.el).slideUp('fast');
    },
    sending: function () {
        this.resend.hide();
        this.throbber.text('Sending confirmation…').show();
    },
    success: function () {
        this.resend.hide();
        this.throbber.text('Resent confirmation!').show();
    },
    failed: function () {
        this.resend.show();
        this.throbber.text('Sending failed').show();
    }
});

module.exports = VerifyNoticeView;


/***/ }),

/***/ "5gSh":
/***/ (function(module, exports, __webpack_require__) {

var AutoLinker = __webpack_require__("INx5");
var Buf = __webpack_require__("t9zO");
var Message = __webpack_require__("j9Sh");
var User = __webpack_require__("Xgjh");
var uriTemplates = __webpack_require__("0a14");
var IRCFormatter = __webpack_require__("XiBv");
var FileWrapper = __webpack_require__("JHsc");
var util = __webpack_require__("GmLC");
var twitch = __webpack_require__("/7tV");
var attachment = __webpack_require__("Mkrm");
var slackBlock = __webpack_require__("RAIu");

var TWITCH_EMOTE_TEMPLATE = 'https://static-cdn.jtvnw.net/emoticons/v1/{emote_id}/{size}';

var Formatter = function () {
    this.linker = new AutoLinker(this);
};
Formatter.prototype = {
    makeDataAttributes: function (data) {
        var dataAttribs = {};
        for (var k in data) {
            if (data[k] != null) {
                dataAttribs['data-' + k] = data[k];
            }
        }
        return dataAttribs;
    },
    makeAttributes: function (attribs) {
        var dataAttribs = this.makeDataAttributes(attribs.data);
        delete attribs.data;
        attribs = _.extend(attribs, dataAttribs);
        var parts = [];
        for (var attr in attribs) {
            if (attribs[attr] != null) {
                if (attribs[attr] === true) {
                    parts.push(attr);
                } else {
                    parts.push(attr + '="' + this.escapeText(attribs[attr], {rawSpace: true}) + '"');
                }
            }
        }
        if (parts.length) {
            return ' ' + parts.join(' ');
        } else {
            return '';
        }
    },
    normaliseIdentifier: function (identifier) {
        identifier = IRCFormatter.strip(util.stringify(identifier)) || ' ';
        // Careful to fallback to unstripped version for syntax only nicks
        var stripped = identifier.toLowerCase()
            // remove @ or | till the end
            .replace(/[@|].*$/, '')
            // remove any leading syntax
            .replace(/^[\\[\]^_`{|}]+/, '')
            // remove all ` or _ suffixes
            .replace(/[`_]+$/, '')|| identifier;
        return stripped;
    },
    getReplyColorIndex: function (identifier) {
        return this.getNickColorIndex(identifier, {
            raw: true
        });
    },
    getNickColorIndex: function (identifier, options) {
        options = options || {};
        options.length = options.length || window.IRCConfig.nickColors;
        var stripped;
        if (options.raw) {
            stripped = identifier;
        } else {
            stripped = this.normaliseIdentifier(identifier);
        }

        // Hash the identifier
        var hash = 0;
        for (var i = 0; i < stripped.length; i++) {
            hash = stripped.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
        }

        // Get an index from the hash, update if adding colours
        var index = Math.abs(hash % options.length);
        return index;
    },
    imageAvatar: function (urlTemplate, self, options) {
        options = options || {};
        var size = options.size || 32;
        var attribs = {
            data: options.data
        };
        var className = 'avatar imageAvatar';
        if (!options.standalone) {
            className += ' imageAvatar--loading';
        }
        if (options.external && (!this.buffer || !this.buffer.connection.isSlackOAuth())) {
            className += ' imageAvatar--external';
        }
        if (self) {
            className += ' imageAvatar--self';
        }
        if (options.hasDataParent) {
            className += ' hasUserParent';
        }
        var avatar_1x = uriTemplates(urlTemplate).fill({
            size: size
        });
        var imgAttribs = {
            alt: ''
        };
        if (!options.standalone) {
            imgAttribs.src = avatar_1x;
            imgAttribs['class'] = 'irccloud_avatar';
        }
        if (avatar_1x != urlTemplate) {
            // Might not be a template
            className += ' imageAvatar--templated';
            if (!options.no2x) {
                imgAttribs.srcset = avatar_1x + ' 1x, ' + uriTemplates(urlTemplate).fill({
                    size: size * 2
                }) + ' 2x';
            }
        }
        attribs['class'] = className;
        var img = '<img' + this.makeAttributes(imgAttribs) + '>';
        return '<span' + this.makeAttributes(attribs) + '>' + img + '</span>';
    },
    avatar: function (nick, self, options) {
        options = options || {};
        var identifier = options.name || nick;
        // Careful to fallback to unstripped version for syntax only nicks
        var stripped = this.normaliseIdentifier(identifier);
        var firstLetter = String.fromCodePoint(
            stripped.toUpperCase().codePointAt(0)
        );
        var attribs = {
            data: options.data,
            title: options.title
        };
        var className = 'avatar letterAvatar';
        if (options.fallback) {
            var type;
            if (options.external && (!this.buffer || !this.buffer.connection.isSlackOAuth())) {
                type = 'external';
            } else {
                type = 'internal';
            }
            className += ' letterAvatar--' + type;
            // Delay fallback, starts hidden, will be shown after a timeout
            // via a css animation
            if (options.delayFallback) {
                className += ' letterAvatar--delay_fallback';
            }
        }
        if (options.hasDataParent) {
            className += ' hasUserParent';
        }
        if (!self) {
            if (options.color) {
                attribs['style'] = 'background-color: ' + this.escapeText(options.color) + ';';
                if (_.include(['#fff', '#ffffff', '#fefefe', 'white'], options.color.toLowerCase())) {
                    className += ' letterAvatar--white';
                }
            } else {
                var nickColor = this.getNickColorIndex(identifier);
                className += ' c' + nickColor;
            }
        } else {
            className += ' letterAvatar--self';
        }
        attribs['class'] = className;
        return '<span' + this.makeAttributes(attribs) + '><span role="presentation">' + this.escapeText(firstLetter) + '</span></span>';
    },
    renderTwitchBadges: function (message) {
        var tags = message.getTwitchTags();
        if (tags && tags['badges']) {
            var twitchBadges = '<span' + this.makeAttributes({
                'class': 'twitch_badges',
                data: {
                    twitch_badges: tags['badges'],
                    twitch_badge_info: tags['badge-info'],
                    twitch_room_id: tags['room-id']
                }
            }) + '></span>';
            return twitchBadges;
        }
        return '';
    },
    setDisplayAuthorProps: function (authorProps, displayAuthor, nick) {
        if (displayAuthor) {
            authorProps.name = displayAuthor;
            if (displayAuthor.toLowerCase() != nick.toLowerCase()) {
                authorProps.suffix = '<span class="actualName">&nbsp;(' + this.escapeText(nick) + ')</span>';
            }
        }
    },
    setTwitchAuthorProps: function (message, authorProps, nick) {
        authorProps.title = '';
        var tags = message.getTwitchTags();
        this.setDisplayAuthorProps(authorProps, tags['display-name'], nick);
        if (!message.isSelf() && tags['color']) {
            this.setAuthorColor(authorProps, tags['color']);
        }
    },
    setAuthorColor: function (authorProps, color) {
        authorProps.color = false;
        authorProps.styles = {
            'color': color
        };
        if (_.include(['#fff', '#ffffff', '#fefefe', 'white'], color.toLowerCase())) {
            authorProps.className += ' whiteNick';
        }
    },
    embedSpin: function () {
        return '<i class="spin embedSpin"></i>';
    },
    howLong: function (date, prefix) {
        var strings = Formatter[prefix ? 'HOW_LONG_STRINGS_PREFIX' : 'HOW_LONG_STRINGS'];
        var formattedText = '<span title="' + date.formatFullDate() + '">' + $.timeago(date, strings) + '</span>';
        return formattedText;
    },
    timestamp: function (date) {
        var formattedText = '<span class="timestamp" title="' + date.formatFullDate() + '">' + date.formatTime() + '</span>';
        return formattedText;
    },
    date: function (timestamp, format) {
        format = format || 'MMMM dd, yyyy';
        return new Date(timestamp * 1000).toString(format);
    },
    amountSign: function (amount) {
        if (amount < 0) {
            return '-';
        } else {
            return '';
        }
    },
    amount: function (currency, amount, multiplier, fixed) {
        if (fixed === undefined) {
            fixed = 2;
        }
        var curr = currency.toLowerCase();
        var value = (amount / 100);
        if (curr == 'btc') {
            value = value / 1000000;
        }
        if (multiplier) {
            value = value * multiplier;
        }
        var prefix = '';
        if (value < 0) {
            value = value * -1;
            prefix = '-';
        }
        if (fixed === 0 && value % 1 > 0) {
            fixed = 2;
        }
        return prefix + this.getCurrencySymbol(curr) + value.toFixed(fixed);
    },
    getCurrencySymbol: function (cur) {
        var symbols = {
            'usd': '$',
            'gbp': '£',
            'eur': '€',
            'btc': '฿'
        };
        return symbols[cur.toLowerCase()] || '';
    },
    escapeQuerySelector: function (text) {
        // TODO switch to CSS.escape or $.escapeSelector
        return util.stringify(text).replace(/([\\'"])/g, '\\$1');
    },
    escapeText: function (text, options) {
        return IRCFormatter.escapeHtml(text, options);
    },
    escapeTextMinimal: function (text, options) {
        return IRCFormatter.escapeHtmlMinimal(text, options);
    },
    escapeTextComicSans: function (text) {
        return IRCFormatter.escapeHtml(text);
    },
    isRtl: function (text) {
        return Formatter.RTL_REGEX.test(text);
    },
    pluralise: function (count, text, plural) {
        if (count == 1) {
            return text;
        } else {
            return plural || (text + 's');
        }
    },
    listSentence: function (parts, options) {
        options = options || {};
        var msg = '';
        _.each(parts, function (p, i) {
            if (i > 0) {
                if (!options.noAnd && i == parts.length - 1) {
                    msg += ' and ';
                } else {
                    msg += ', ';
                }
            }
            if (options.render) {
                msg += options.render(p, i);
            } else {
                msg += p;
            }
        });
        return msg;
    },
    renderProcessor: function (options, textPart, textIndex) {
        var part = {
            value: textPart,
            index: textIndex
        };
        return this.renderMatches(part, options);
    },
    render: function (lines, options) {
        lines = $.makeArray(lines);
        // Format parts
        var formattedLines = [];
        options = _.extend({}, options, {
            processor: _.bind(this.renderProcessor, this, options)
        });
        _.each(lines, function (text) {
            var formattedText = IRCFormatter.renderHtml(text, options);
            formattedLines.push(formattedText);
        }, this);
        // Join lines back up and return
        var formattedText = formattedLines.join('<br>');
        return formattedText;
    },
    renderMatches: function (part, options) {
        options = options || {};
        var tagOffsets = [];
        var matchOffsetTags = {
            start_offset: '<span class="match">',
            end_offset: '</span>'
        };
        var matchTokens = options.message && options.message.get('match_tokens');
        _.each(matchTokens, function (tok) {
            _.each(['start_offset', 'end_offset'], function (offsetName) {
                if (tok[offsetName] >= part.index && tok[offsetName] <= part.index + part.value.length) {
                    tagOffsets.push({
                        offset: tok[offsetName] - part.index,
                        name: offsetName
                    });
                }
            });
        });
        var index = 0;
        var value = part.value;
        var rendered = '';
        _.each(tagOffsets, function (tagOffset) {
            rendered += this.renderReplacements({
                value: part.value.slice(index, tagOffset.offset),
                index: part.index + index
            }, _.extend({}, options, {withPlain: true}));
            rendered += matchOffsetTags[tagOffset.name];
            value = part.value.slice(tagOffset.offset);
            index = tagOffset.offset;
        }, this);
        if (value) {
            rendered += this.renderReplacements({
                value: value,
                index: part.index + index
            }, options);
        }
        return rendered;
    },
    renderReplacements: function (part, options) {
        if (options.replacements) {
            var index = 0;
            var value = part.value;
            var rendered = '';
            _.each(options.replacements, function (replacement) {
                var rOffset = replacement.startOffset || 0;
                var rStart = rOffset + (replacement.start - part.index);
                var rEnd = rOffset + (replacement.end - part.index);
                if (
                    rStart >= 0 &&
                    rStart <= part.value.length &&
                    rEnd <= part.value.length
                ) {
                    rendered += this.renderTwitchCheer(util.stringSlice(part.value, index, rStart), options);
                    var replacementText = util.stringSlice(part.value, rStart, rEnd);
                    var plainClassName;
                    switch (replacement.type) {
                    case 'mention':
                        if (replacementText === replacement.nick) {
                            var name = replacement.nick;
                            if (this.buffer) {
                                var member = this.buffer.getMember(name);
                                var user;
                                var nickData;
                                if (options.mention_data && options.mention_data[name]) {
                                    user = this.buffer.connection.makeUserFromTarget(
                                        this.buffer.bid(),
                                        options.mention_data[name]
                                    );
                                } else if (member) {
                                    user = member;
                                } else {
                                    user = this.buffer.connection.makeUserFromTarget(
                                        this.buffer.bid(),
                                        { nick: name }
                                    );
                                }
                                var displayAuthor = user.getDisplayAuthor();
                                if (
                                    options.partOptions && options.partOptions.atMention &&
                                    displayAuthor && displayAuthor != name
                                ) {
                                    name = displayAuthor;
                                }
                                var className = 'mention';
                                if (!user.isSelf()) {
                                    className += ' c' + this.getNickColorIndex(displayAuthor || name);
                                }
                                rendered += this.linkUser(user, {
                                    noData: true,
                                    name: name,
                                    className: className
                                });
                            } else {
                                rendered += this.escapeText(name);
                            }
                        } else {
                            debug.warn("mention replacement doesn't match nick", replacement, options.message && options.message.toJSON());
                            rendered += this.escapeText(replacementText);
                        }
                        break;
                    case 'emoji':
                        var emoteSrc = replacement.url;
                        rendered += '<img' + this.makeAttributes({
                            'class': 'notCloseable customEmoji loading',
                            src: emoteSrc,
                            title: replacementText,
                            alt: replacementText
                        }) + '>';
                        plainClassName = 'customEmojiText';
                        break;
                    case 'twitch_emote':
                        var emote1x = uriTemplates(TWITCH_EMOTE_TEMPLATE).fill({
                            emote_id: replacement.emote,
                            size: '1.0'
                        });
                        rendered += '<img' + this.makeAttributes({
                            'class': 'notCloseable twitchEmote loading',
                            src: emote1x,
                            srcset: emote1x + ' 1x, ' + uriTemplates(TWITCH_EMOTE_TEMPLATE).fill({
                                emote_id: replacement.emote,
                                size: '2.0'
                            }) + ' 2x',
                            title: replacementText,
                            alt: replacementText
                        }) + '>';
                        plainClassName = 'twitchEmoteText';
                        break;
                    }
                    if (plainClassName) {
                        if (options.withPlain) {
                            rendered += ' (' + this.escapeText(replacementText) + ')';
                        } else {
                            rendered += '<span class="' + plainClassName + '">' + this.escapeText(replacementText) + '</span>';
                        }
                    }
                    value = util.stringSlice(part.value, rEnd);
                    index = rEnd;
                }
            }, this);
            if (value) {
                rendered += this.renderTwitchCheer(value, options);
            }
            return rendered;
        } else {
            return this.renderTwitchCheer(part.value, options);
        }
    },
    renderTwitchCheer: function (input, options) {
        if (this.buffer && options.embeds && options.embeds.twitch_tags && options.embeds.twitch_tags.bits) {
            var parts = twitch.splitCheerParts(this.buffer.normalise(), input);
            return _.map(parts, function renderTwitchCheerMap (part) {
                if (part.cheer) {
                    var replacement = '';
                    _.each(['light', 'dark'], function renderTwitchCheerThemes (theme) {
                        var chear1x = twitch.cheerUrl(part.type, part.tier, theme, 1);
                        replacement += '<img' + this.makeAttributes({
                            'class': 'loading twitchEmote twitchEmote--' + theme,
                            src: chear1x,
                            srcset: chear1x + ' 1x, ' + twitch.cheerUrl(part.type, part.tier, theme, 2) + ' 2x',
                            title: part.text,
                            alt: part.text
                        }) + '>';
                    }, this);
                    replacement += ' ';
                    replacement += twitch.cheerValue(part.type, part.tier, part.value);
                    if (options.withPlain) {
                        replacement += ' (' + this.escapeText(part.text) + ')';
                    }
                    return replacement;
                } else {
                    return this.renderEmoji(this.escapeText(part.text), options);
                }
            }, this).join('');
        } else {
            return this.renderEmoji(this.escapeText(input), options);
        }
    },
    renderComicSans: function (input) {
        var re = /(comic sans)/gi;
        var replacement = "<span style=\"font-family:'comic sans ms', 'chalkboard', 'chalkboard se';\">$1</span>";
        return util.stringify(input).replace(re, replacement);
    },
    renderNoEmoji: function (input, options) {
        options = options || {};
        options.noEmoji = true;
        return this.render(input, options);
    },
    renderEmoji: function (input, options) {
        options = options || {};
        if (options.noEmoji) {
            return input;
        }
        return emoji.replace_colons(
            emoji.replace_unified(input)
        );
    },
    prepareCustomEmoji: function (embeds) {
        var customEmoji = embeds && embeds.emoji;
        if (!customEmoji) {
            return;
        }
        var customEmojiJson;
        try {
            customEmojiJson = JSON.parse(customEmoji);
        } catch (exc) {
            // pass
        }
        if (!customEmojiJson || _.isArray(customEmojiJson)) {
            return;
        }
        var offsets = [];
        // [{
        //     url: 'https://example.com/emoji.png',
        //     idx: [
        //         [0,4],
        //         [5,6]
        //     ]
        // }]
        _.each(customEmojiJson, function (json) {
            if (!json.url || !json.url.match(/https:\/\/.+/)) {
                return;
            }
            if (!json.idx || !_.isArray(json.idx)) {
                return;
            }
            _.each(json.idx, function (jsonOffset) {
                if (!jsonOffset || !_.isArray(jsonOffset) || jsonOffset.length !== 2) {
                    return;
                }
                var offset = {
                    url: json.url,
                    start: jsonOffset[0]-0,
                    end: jsonOffset[1]-0
                };
                if (offset.end > offset.start) {
                    offsets.push(offset);
                }
            });
        });
        if (offsets.length) {
            offsets.sort(function (a, b) {
                return a.start - b.start;
            });
            return offsets;
        }
    },

    renderAttachment: function (message, fallback) {
        return attachment.render.call(this, message, fallback);
    },
    renderSlackBlocks: function (message) {
        return slackBlock.render.call(this, message);
    },

    renderLinkify: function (lines, options) {
        options = options || {};
        var embeds, replacements;
        if (options.message) {
            options = _.extend({}, options, {
                embeds: options.message.getEmbeds(),
                replacements: options.message.getReplacements(),
                mention_data: options.message.getMentionData(),
            });
        }
        return this.renderLinkifyWithTextFunction(lines, options, _.bind(function (part, partOptions) {
            var output = this.renderMatches(part, _.extend({}, options, {
                partOptions: partOptions
            }));
            if (options.comicSans) {
                output = this.renderComicSans(output);
            }
            return output;
        }, this));
    },
    renderLinkifyComicSans: function (lines, options) {
        return this.renderLinkify(lines, _.extend({}, options, {
            comicSans: true
        }));
    },
    renderLinkifyProcessor: function (textFunction, lineData, lineEmbeds, embedHtml, textPart, textIndex, options) {
        var urlSplitParts = this.linker.splitTextOnUrls(textPart, textIndex);
        var parts = _.map(urlSplitParts, function (part, index) {
            // Link up URLs
            if (part.url) {
                var bits = this.linker.renderUrl(part.url, options);
                var result;
                if (!bits) {
                    result = textFunction(part, options);
                } else {
                    if (bits.data) {
                        // Delete data already seen in a line
                        // NOTE: this might cause issues in bufferlogcontainer
                        // since we aren't also deleting the classnames that trigger
                        // the data handling, e.g. for twitter
                        if (util.containsEqual(lineData, bits.data)) {
                            delete bits.data;
                        }
                        lineData.push(bits.data);
                    }
                    result = this.linker.makeLinkFromBits(bits.html, bits);
                    if (bits.embed && !util.containsEqual(lineEmbeds, bits.embed)) {
                        lineEmbeds.push(bits.embed);
                        // Add a close button
                        var closeTitle = 'Close ' + bits.className;
                        var close = '<a href="" class="embedClose" title="' + closeTitle + '"></a>';
                        // Add a spinner for images
                        var spin = '';
                        var embed;
                        if (bits.className == 'image') {
                            var embedBits = _.extend({}, bits, {
                                attrs: {
                                    'tabindex': '-1'
                                }
                            });
                            spin = this.linker.makeLinkFromBits(this.embedSpin(), embedBits, 'spin');
                            embed = this.linker.makeLinkFromBits(bits.embed, embedBits);
                        } else {
                            embed = bits.embed;
                        }
                        embedHtml.push(spin + '<span class="directEmbedWrap ' + bits.className + 'Wrap">' + embed + close + '</span>');
                    }
                }
                return result;
            } else {
                return textFunction(part, options);
            }
        }, this);
        return parts.join('');
    },
    renderRedacted: function (message) {
        var redacted = message.getRedacted() || message.getDeletion();
        var title = 'Deleted';
        if (redacted) {
            var from = redacted.get('from');
            var reason = redacted.get('reason');
            var author;
            if (from) {
                author = from;
            } else {
                author = redacted.get('server');
            }
            title += ' by ' + author;
            if (reason) {
                title += ': ' + reason;
            }
            title += ' (' + redacted.getDate().formatFullDate() + ')';
        }
        var attribs = {
            title: title,
            'class': 'message-redacted'
        };
        return '<span' + this.makeAttributes(attribs) + '>(deleted)</span> ';
    },
    renderLinkifyWithTextFunction: function (lines, options, textFunction) {
        lines = $.makeArray(lines);
        // Format parts
        var formattedLines = [];
        _.each(lines, function (text) {
            var embedHtml = [];
            var lineData = [];
            var lineEmbeds = [];
            var formattedText = IRCFormatter.renderHtml(text, _.extend({}, options, {
                processor: _.bind(this.renderLinkifyProcessor, this, textFunction, lineData, lineEmbeds, embedHtml)
            }));
            if (options.message) {
                var edit = options.message.getEditOrig();
                var deleted = options.message.isDeletedOrRedacted();
                if (edit) {
                    var title = edit.get('previous_msg') + ' (' + edit.getDate().formatFullDate() + ')';
                    var attribs = {
                        title: title,
                        'class': 'message-edited'
                    };
                    formattedText += ' <span' + this.makeAttributes(attribs) + '>(edited)</span>';
                }
                if (deleted) {
                    formattedText = this.renderRedacted(options.message) + formattedText;
                }
            }
            if (options.embeds && options.embeds.files) {
                _.each(options.embeds.files, function (file) {
                    if (!file.id) {
                        debug.warn("Invalid embedded file", file);
                        return;
                    }
                    var fw = new FileWrapper(file);
                    var fileData = fw.toJSON();
                    delete fileData.properties;
                    fileData.width = fw.getWidth();
                    fileData.height = fw.getHeight();
                    embedHtml.push('<span class="fileWrap loading">' +
                        this.linker.makeLinkFromBits(this.embedSpin(), {
                            url: file.url,
                            className: 'file',
                            loading: true,
                            target: '_blank',
                            data: fileData
                        }) +
                        '</span>');
                }, this);
            }
            formattedLines.push(formattedText + embedHtml.join(''));
        }, this);
        // Join lines back up and return
        var formattedText = formattedLines.join('<br>');
        return formattedText;
    },
    linkModel: function (model, options) {
        var name = model.getName();
        if (!name) {
            return '[unknown]';
        }
        options = options || {};
        var data = _.extend({}, options.data);
        var className = "buffer bufferLink";
        if (options.className) {
            className += ' ' + options.className;
        }
        var style;
        if (options.styles) {
            style = _.map(options.styles, function (v, k) {
                return k + ': ' + v + ';';
            }).join(' ');
        }
        var title = options.title;
        if (title === undefined) {
            title = model.getTitle();
        }
        if (!options.hasDataParent) {
            data['cid'] = model.getCid();
            data['name'] = data['name'] || name;
            if (model instanceof Buf || model instanceof Message || model instanceof User) {
                data['bid'] = model.bid();
            }
        }
        var attributes = _.extend({}, options.attr, {
            href: model.url(),
            style: style,
            'class': className,
            title: title,
            data: data
        });
        var displayName = options.name || model.getDisplayName();
        var suffix = options.suffix || '';
        return this.linker.make(
            this.escapeText(util.truncate(IRCFormatter.strip(displayName), 64)) + suffix,
            attributes,
            options.button
        );
    }
};
$.extend(Formatter, {
    RTL_REGEX: /[\u05BE\u05C0\u05C3\u05D0-\u05EA\u05F0-\u05F4\u061B\u061F\u0621-\u063A\u0640-\u064A\u066D-\u066F\u0671-\u06D5\u06DD\u06E5-\u06E6\u06FA-\u06FE\u0700-\u070D\u0710\u0712-\u072C\u0780-\u07A5\u07B1\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFC\uFE70-\uFE74\uFE76-\uFEFC]/,
    PRECISION_STRINGS: $.extend({}, $.timeago.settings.strings, {
        prefixFromNow: 'in',
        suffixFromNow: null,
        second: '%d second',
        seconds: '%d seconds',
        minute: '%d seconds',
        hour: '%d minutes'
    }),
    HOW_LONG_STRINGS: $.extend({}, $.timeago.settings.strings),
    HOW_LONG_STRINGS_PREFIX: $.extend({}, $.timeago.settings.strings, {
        prefixAgo: "for",
        suffixAgo: null
    })
});

document.body.addEventListener(
    'load',
    function (e) {
        if (e.target.className == 'irccloud_avatar') {
            var parent = $(e.target.parentNode);
            // Show image avatar, adjust class name
            parent.removeClass('imageAvatar--loading').addClass('imageAvatar--loaded');
            // Hide letter avatar
            parent.next('.letterAvatar--internal').addClass('letterAvatar--internal_fallback');
            parent.next('.letterAvatar--external').addClass('letterAvatar--external_fallback');
            parent.trigger('reflowImageContainer');
        }
    },
    true // <-- useCapture
);
document.body.addEventListener(
    'error',
    function (e) {
        if (e.target.className == 'irccloud_avatar') {
            var parent = $(e.target.parentNode);
            // Adjust class name, already hidden and letter avatar already shown
            parent.removeClass('imageAvatar--loading').addClass('imageAvatar--error');
        }
    },
    true // <-- useCapture
);

module.exports = Formatter;


/***/ }),

/***/ "5gbS":
/***/ (function(module, exports, __webpack_require__) {

var BillingMixins = __webpack_require__("uUaF");
var OrgEntity = __webpack_require__("gEBD");
var OrgMember = __webpack_require__("w2pc");
var OrgMemberList = __webpack_require__("L46s");
var util = __webpack_require__("GmLC");


var Org = OrgEntity.extend($.extend(true, {}, BillingMixins, {
    initialize: function (data, options) {
        OrgEntity.prototype.initialize.apply(this, arguments);
        this.invitees = new OrgMemberList();
        this.members = new OrgMemberList();
    },
    
    post: function (method, data, callback) {
        data.org = this.id;
        return this.session.post(method, data, callback);
    },
    
    // BillingMixins
    subscribeUrl: 'subscribe-org-stripe',
    billingInfoUrl: 'org-billing',
    billingInfoParams: function () {
        return {
            org: this.id
        };
    },
    updateCustomerUrl: 'update-org-stripe-customer',
    reinstateSubscriptionUrl: 'reinstate-org-subscription',
    cancelStripeSubscriptionUrl: 'cancel-org-subscription',
    getReceiptUrl: function (chargeId) {
        return "/team-receipt/" + this.id + "/s/" + chargeId;
    },
    getInvoiceUrl: function (invoiceId) {
        return "/team-invoice/" + this.id + "/s/" + invoiceId;
    },
    getHostedInvoiceUrl: function (invoiceId) {
        return "/team-invoice/" + this.id + "/s-auth/" + invoiceId;
    },

    canSeeSubscription: function () {
        return this.isAdmin();
    },
    isOnlyAdmin: function () {
        return this.isAdmin() && !this.members.find(function (m) {
            return m.isAdmin();
        });
    },
    addMember: function (m, options) {
        var member = new OrgMember(m, {
            org: this,
            session: this.session
        });
        this.members.add(member, options);
    },
    addMembers: function (membersData) {
        _.each(membersData, function (member) {
            this.addMember(member, {silent: true});
        }, this);
        this.members.trigger('reset');
    },
    membersNeedSaving: function () {
        return this.members.any(function (m) {
            return m.needsSaving();
        }, this);
    },
    saveMembers: function (callback) {
        var membersToSave = this.members.groupBy(function (m) {
            if (m.needsRemoving()) {
                return 'remove';
            } else if (m.needsSaving()) {
                return 'saveAdmin';
            } else {
                return 'unchanged';
            }
        }, this);
        var remove = _.invoke(membersToSave['remove'], 'toJSON');
        var saveAdmin = _.invoke(membersToSave['saveAdmin'], 'toJSON');
        return this.post('edit-org-members', {
            remove: JSON.stringify(remove),
            save_admin: JSON.stringify(saveAdmin)
        }, _.bind(function (response) {
            if (response.success) {
                _.each(membersToSave['saveAdmin'], function (m) {
                    m.reset();
                }, this);
                _.each(membersToSave['remove'], function (m) {
                    this.members.remove(m);
                }, this);
                this.members.trigger('saved');
            }
            if (callback) {
                callback();
            }
        }, this));
    },
    remove: function (callback) {
        this.session.removeOrg(this, callback);
    },
    leave: function (callback) {
        this.session.leaveOrg(this, callback);
    },
    edit: function (data, callback) {
        data = $.extend({
            name: this.get('name'),
            billing_email: this.get('billing_email')
        }, data);
        return this.post('edit-org', data, _.bind(function (response) {
            if (response.success) {
                this.set(response.org);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    hasFetchedMembers: function () {
        return !!this.membersFetched;
    },
    haveJoined: function () {
        return this.get('join_time');
    },

    getMembers: function (callback, delay, failCount) {
        this.session.backend.get('org-members', {
            org: this.id
        }, _.bind(function (response) {
            if (response.error || response.success === false) {
                if (
                    failCount >= 10 ||
                    response.message == 'not_found' ||
                    response.message == 'auth' ||
                    response.message == 'database_down'
                ) {
                    // TODO error
                    if (callback) {
                        callback(response);
                    }
                } else {
                    if (delay) {
                        delay *= 2;
                        if (delay > 5000) {
                            delay = 5000;
                        }
                    } else {
                        delay = 500;
                    }
                    if (failCount) {
                        failCount++;
                    } else {
                        failCount = 1;
                    }
                    // TODO error
                    setTimeout(_.bind(function () {
                        this.getMembers(callback, delay, failCount);
                    }, this), delay);
                }
            } else {
                this.members.reset();
                this.membersFetched = true;
                this.addMembers(response);
            }
            if (callback) {
                callback();
            }
        }, this));
    },
    areConnectionsChosen: function () {
        return !!this.connections || this.hasIrcd();
    },
    joinConnections: function (data, callback) {
        return this.post('join-org-connections', data, callback);
    },
    addIrcd: function (data, callback) {
        var channels = util.parseChannels(data.channels, true);
        return this.post('set-org-ircd-channels', {
            channels: channels.join(' ')
        }, _.bind(function (response) {
            if (response.success) {
                this.set({
                    ircd: true,
                    ircd_channels: response.channels
                });
                if (response.cid) {
                    this.session.setFocusOnMakeServer(response.cid);
                }

            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    removeIrcd: function (callback) {
        return this.post('remove-org-ircd', {}, _.bind(function (response) {
            if (response.success) {
                this.set({
                    ircd: false,
                    ircd_channels: null
                });
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    addNetwork: function (data, callback) {
        if (!this.connections) {
            this.connections = [];
        }
        data.channels = util.parseChannels(data.channels);
        var previousConnections = _.clone(this.connections);
        this.connections.push(data);
        this.saveConnections(previousConnections, callback);
    },
    removeNetwork: function (i, callback) {
        var previousConnections = _.clone(this.connections);
        this.connections.splice(i, 1);
        this.saveConnections(previousConnections, callback);
    },
    parseConnections: function () {
        if (this.get('connections')) {
            var previousConnections = _.clone(this.connections);
            try {
                this.connections = JSON.parse(this.get('connections'));
                if (!_.isArray(this.connections)) {
                    // Save empty list back to server
                    debug.warn('connections blob not an array', this.get('connections'));
                    this.connections = [];
                    this.saveConnections(previousConnections);
                }
            } catch (exc) {
                // Save empty list back to server
                debug.warn('invalid connections blob', this.get('connections'), exc);
                this.connections = [];
                this.saveConnections(previousConnections);
            }
            this.trigger('connectionsChange', {
                previous: previousConnections
            });
        }
    },
    saveConnections: function (previousConnections, callback) {
        if (!this.connections) {
            this.connections = [];
        }
        var json = JSON.stringify(this.connections);
        return this.post('set-org-connections', {
            connections: json
        }, _.bind(function (response) {
            if (response.success) {
                this.set({connections: json});
            } else {
                this.connections = previousConnections;
            }
            if (response.cids && response.cids[0]) {
                this.session.setFocusOnMakeServer(response.cids[0]);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    hasMembersOrInvitees: function () {
        return !!(this.members.length || this.invitees.length);
    },
    inviteMembers: function (callback) {
        if (this.invitees.length) {
            var members = _.invoke(this.invitees.filter(function (m) {
                return !m.isRemoved();
            }), 'toJSON');
            return this.post('invite-org-members', {
                members: JSON.stringify(members)
            }, _.bind(function (response) {
                if (response.success) {
                    this.addMembers(response.members);
                    this.invitees.reset();
                }
                if (callback) {
                    callback(response);
                }
            }, this));
        }
    },
    resendInvite: function (member, callback) {
        return this.post('resend-org-invite', {
            invite_email: member.get('invite_email')
        }, callback);
    }
}));


module.exports = Org;


/***/ }),

/***/ "5hW5":
/***/ (function(module, exports, __webpack_require__) {

var BufferListBufferView = __webpack_require__("VFp6");
var Keyboard = __webpack_require__("fDhS").default;

var BufferListServerLogView = BufferListBufferView.extend({
    getTemplate: function () {
        if (!BufferListServerLogView._structure) {
            var structure = BufferListBufferView.prototype.getTemplate.call(this);
            structure.prepend('<i class="spin">');
            var bufferOptions = this.renderBufferOptions();
            structure.prepend(bufferOptions);
            structure.prepend('<span class="drag" title="Drag">');

            structure.append('<i class="fa fa-globe">');
            structure.append('<i class="fa fa-shield" title="Secure connection">');
            structure.append('<i class="fa fa-slack" title="Slack Team">');
            structure.append('<i class="fa fa-exclamation ssl_verify_error_icon" title="Strict transport security error">');
            BufferListServerLogView._structure = structure;
        }
        return BufferListServerLogView._structure.clone();
    },
    render: function () {
        BufferListBufferView.prototype.render.call(this);

        this.bindBufferOptions();
        
        this.listenTo(this.model.connection, 'change:name', this.renderLinkText);
        this.listenTo(this.model.connection, 'urlChange', this.renderLinkUrl);

        return this;
    },
    renderBufferOptions: function () {
        return $('<button class="bufferOptions fa fa-cog">').attr({
            'title': "Options",
            'aria-label': "Options",
            'aria-expanded': false,
            'aria-controls': 'serverLogContextMenu',
            'aria-haspopup': 'true'
        });
    },
    bindBufferOptions: function () {
        var bufferOptions = this.link.find('.bufferOptions');  
        // Can't bind these on render, need to wait till they're added to the dom
        bufferOptions.on('keypress buttonClick mouseup', _.bind(function (e) {
            // Prevent buffer select
            e.stopPropagation();
        }, this));
        bufferOptions.on('click', _.bind(function (e) {
            // Prevent buffer select
            e.stopPropagation();
            this.model.session.trigger('bufferOptions', bufferOptions, this.model, e);
        }, this));
    },
    renderLinkUrl: function () {
        this.link.attr('href', this.model.connection.url());
        return this;
    },
    renderLinkText: function () {
        this.link.attr('title', this.model.connection.getName());
        this.setLinkLabelHtml(this.formatter.render(this.model.connection.getName()));
        return this;
    }
});


module.exports = BufferListServerLogView;


/***/ }),

/***/ "5t0/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "61Uw":
/***/ (function(module, exports, __webpack_require__) {

var Channel = __webpack_require__("KU+H");
var OrderedBufferList = __webpack_require__("zICk");


var ChannelList = OrderedBufferList.extend({
    model: Channel
});


module.exports = ChannelList;


/***/ }),

/***/ "64IP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "66sV":
/***/ (function(module, exports, __webpack_require__) {

var FileWrapper = __webpack_require__("JHsc");


var FileList = Backbone.Collection.extend({
    model: FileWrapper,
    initialize: function (models, options) {
        this.session = options.session;
    },
    comparator: function (file) {
        return -file.get('date');
    },
    getPages: function () {
        if (this.total) {
            return Math.ceil(this.total/this.per_page);
        }
    },
    fetch: function (page) {
        var data = {};
        if (page > 1) {
            data.page = page;
        }
        if (this.fetchComplete) {
            this.fetchComplete.reject();
        }
        var complete = this.session.getBackoff('files', data);
        this.fetchComplete = complete;
        return complete.done(_.bind(function (response) {
            this.total = response.total;
            this.per_page = response.per_page;
            this.page = response.page;
            this.set(response.files, {
                session: this.session
            });
            this.trigger('fetched');
        }, this));
    }
});


module.exports = FileList;


/***/ }),

/***/ "6AFE":
/***/ (function(module, exports, __webpack_require__) {

var FileWrapper = __webpack_require__("JHsc");


var FileView = Backbone.View.extend({
    model: FileWrapper,
    tagName: 'div',
    className: 'file',
    initialize: function (options) {
        this.model.bind('uploadSuccess', this.uploadSuccess, this);
    },
    events: {
        'click a.edit': 'toggleEdit',
        'click a.delete': 'clickDelete',
        'click a.restore': 'clickRestore',
        'buttonClick .edit': 'toggleEdit',
        'buttonClick .delete': 'clickDelete',
        'buttonClick .restore': 'clickRestore',
        'buttonClick .editForm .cancel': 'toggleEdit',
        'submit .editForm': 'submitEditForm'
    },
    uploadSuccess: function () {
        if (this.localFileData) {
            this.model.cacheDataUrl(this.localFileData);
        }
    },
    renderName: function () {
        var name = this.model.desiredName();
        if (this.name) {
            this.name.text(name);
        }
        if (this.editForm) {
            this.editForm.find('.nameInput').val(name);
        }
        this.$('a.fileLink').attr('href', this.model.getUrl());
        this.$('span.documentIcon').data('DownloadURL', this.dragDownloadURL());
    },
    toggleEdit: function (e) {
        e.preventDefault();
        this.hideEditError();
        this.renderName();
        this.$el.toggleClass('edit');
        this.$('.nameInput').select().focus();
        this.trigger('toggleEdit');
    },
    clickDelete: function (e) {
        e.preventDefault();
        var button = $(e.currentTarget);
        button.addSpin();
        button.prop('disabled', true);
        this.model.remove(_.bind(function (response) {
            button.removeSpin();
            button.prop('disabled', false);
            if (!response.success) {
                var message = "";
                switch (response.message) {
                case 'auth':
                    message = 'You don’t have permission to delete this file';
                    break;
                case 'file_not_found':
                    message = 'Unknown file';
                    break;
                case 'server_error':
                    message = 'There was a problem deleting this file';
                    break;
                default:
                    message = 'There was a problem deleting this file: ' + response.message;
                    break;
                }
                this.showEditError(message);
            }
        }, this));
    },
    clickRestore: function (e) {
        e.preventDefault();
        var button = $(e.currentTarget);
        button.addSpin();
        button.prop('disabled', true);
        this.model.restore(_.bind(function (response) {
            button.removeSpin();
            button.prop('disabled', false);
            if (!response.success) {
                var message = "";
                switch (response.message) {
                case 'auth':
                    message = 'You don’t have permission to restore this file';
                    break;
                case 'file_not_found':
                    message = 'Unknown file';
                    break;
                case 'upload_limit_reached':
                    message = "Sorry, you can’t upload more than 100 MB of files";
                    break;
                case 'server_error':
                    message = 'There was a problem restoring this file';
                    break;
                default:
                    message = 'There was a problem restoring this file: ' + response.message;
                    break;
                }
                this.showEditError(message);
            }
        }, this));
    },
    submitEditForm: function (e) {
        e.preventDefault();
        this.editForm.addSpin();
        var data = this.editForm.serializeForm();
        this.hideEditError();
        this.model.edit(data, _.bind(function (response) {
            this.editForm.removeSpin();
            if (response.success) {
                this.$el.removeClass('edit');
            } else {
                var message = "";
                switch (response.message) {
                case 'auth':
                    message = 'You don’t have permission to edit this file';
                    break;
                case 'file_not_found':
                    message = 'Unknown file';
                    break;
                case 'missing_name':
                    message = 'Missing file name';
                    break;
                case 'server_error':
                    message = 'There was a problem editing this file';
                    break;
                default:
                    message = 'There was a problem editing this file: ' + response.message;
                    break;
                }
                this.showEditError(message);
            }
        }, this));
    },
    hideEditError: function () {
        this.editError.hide();
    },
    showEditError: function (text) {
        this.editError.text(text).fadeIn('fast');
    },
    renderDeleted: function () {
        this.$el.toggleClass('deleted', this.model.isDeleted());
        this.hideEditError();
    },
    renderEditForm: function () {
        var nameInput = $('<textarea class="input nameInput" name="name">');
        var editSubmit = $('<button type="submit" class="action">').append($('<span>').text('Save'));
        var editCancel = $('<button type="button" class="cancel">').append($('<span>').text('Cancel'));
        return $('<form action="" method="post" class="editForm">')
            .append($('<p class="form">').append(nameInput))
            .append($('<p class="form">').append(editSubmit).append(editCancel));
    },
    render: function (header) {
        var info = $('<div class="info">');

        var date = $('<p class="date">');
        date.text(this.model.getDate().formatFullDate());
        info.append(date);

        this.name = $('<div class="name">');
        info.append(this.name);

        this.editForm = this.renderEditForm();
        info.append(this.editForm);

        var link = $('<a class="fileLink" target="_blank">')
            .append($('<span>').text(this.model.getSize()))
            .append(' • ')
            .append($('<span>').text(this.model.getType()));
        info.append($('<p class="link">').append(link));
        this.$el.append(info);

        var preview = $('<div class="preview">');
        var previewLink = $('<a target="_blank" class="fileLink previewLink">');
        if (!this.model.isPreviewableImage()) {
            previewLink.addClass('docLink');
        }
        previewLink.append(this.renderPreview());
        preview.append(previewLink);

        this.editError = $('<p class="userError editError">');
        preview.append(this.editError);

        var actions = this.renderActions();
        preview.append(actions);

        this.$el.append(preview);

        this.rendered();

        return this;
    },
    rendered: function () {
        this.renderName();
        this.model.bind('change:deleted', this.renderDeleted, this);
        this.model.bind('change:name', function () {
            this.renderName();
        }, this);
    },
    renderActions: function () {
        var actions = $('<span class="actions">');
        if (this.model.isOwn()) {
            actions.append($('<button type="button" class="edit">').append($('<span>').text('edit')));
            actions.append($('<button type="button" class="delete">').append($('<span>').text('delete')));
            actions.append($('<button type="button" class="restore">').append($('<span>').text('restore')));
        }
        return actions;
    },
    sizeImage: function (img, dimensions) {
        img.attr({
            src: this.model.getCachedUrl(dimensions),
            width: dimensions.width,
            height: dimensions.height
        });
        img.css({
            marginTop: -dimensions.height/2,
            marginLeft: -dimensions.width/2
        });
    },
    renderPreview: function () {
        if (this.model.isPreviewableImage()) {
            var img = $('<img class="filePreview">');
            var dimensions = this.constrainDimensions(
                FileView.MAX_WIDTH,
                FileView.MAX_HEIGHT
            );
            if (dimensions) {
                this.sizeImage(img, dimensions);
            } else {
                img.attr({
                    src: this.model.getCachedUrl({width: FileView.MAX_WIDTH})
                }).one('load', _.bind(function (e) {
                    dimensions = FileView.constrainDimensions(
                        img[0].width,
                        img[0].height,
                        FileView.MAX_WIDTH,
                        FileView.MAX_HEIGHT
                    );
                    this.sizeImage(img, dimensions);
                }, this));
            }
            return img;
        } else {
            return this.docIcon();
        }
    },
    constrainDimensions: function (maxWidth, maxHeight) {
        return FileView.constrainDimensions(
            this.model.getWidth(),
            this.model.getHeight(),
            maxWidth,
            maxHeight
        );
    },
    readFileData: function () {
        var fileRead = new $.Deferred().done(_.bind(function (src) {
            this.localFileData = src;
        }, this));
        if (this.localFileData) {
            fileRead.resolve(this.localFileData);
        } else {
            var reader = new window.FileReader();
            reader.onload = function (e) {
                fileRead.resolve(e.target.result);
            };
            reader.readAsDataURL(this.model.localFile);
        }
        return fileRead.promise();
    },
    renderLocalPreview: function (className) {
        var complete = new $.Deferred();
        if (this.model.localFile && window.FileReader && this.model.isPreviewable()) {
            var img = $('<img class="unknownFilePreview">');
            if (className) {
                img.addClass(className);
            }
            var result = $('<span class="localPreview localImagePreview">').append(img);
            this.readFileData().done(_.bind(function (src) {
                img.attr('src', src);
                this.model.set('properties', {
                    width: img[0].width,
                    height: img[0].height
                });
                complete.resolve(result);
            }, this));
        } else {
            var docIcon = this.docIcon();
            complete.resolve($('<span class="localPreview docPreview">').append(docIcon));
        }
        return complete.promise();
    },
    docIcon: function () {
        var docIcon = $('<span class="documentIcon">').addClass('ext_' + this.model.getExtension());
        if (this.model.isImage()) {
            docIcon.addClass('image');
        }
        if (this.model.isText()) {
            docIcon.addClass('text');
        }
        docIcon.append($('<span class="tag">'));
        docIcon.append($('<span class="label">').text(this.model.getExtension()));
        return docIcon;
    },
    dragDownloadURL: function () {
        return [
            this.model.getType(),
            this.model.getName().replace(/:/, '-'),
            this.model.getUrl()
        ].join(':');
        
    }
}, {
    // Sync with css
    MAX_WIDTH: 250,
    MAX_HEIGHT: 150,
    constrainDimensions: function (width, height, maxWidth, maxHeight) {
        if (!width || !height) {
            return;
        }
        var newWidth, newHeight, ratio;
        if (width > height) {
            newWidth = Math.min(width, maxWidth);
            ratio = newWidth / width;
            width = newWidth;
            height = newHeight = height * ratio;
            if (height > maxHeight) {
                newHeight = maxHeight;
                ratio = newHeight / height;
                width = newWidth = newWidth * ratio;
            }
        } else {
            newHeight = Math.min(height, maxHeight);
            ratio = newHeight / height;
            height = newHeight;
            width = newWidth = width * ratio;
            if (width > maxWidth) {
                newWidth = maxWidth;
                ratio = newWidth / width;
                height = newHeight = newHeight * ratio;
            }
        }
        return {
            width: newWidth,
            height: newHeight
        };
    },
});

module.exports = FileView;


/***/ }),

/***/ "6Cw2":
/***/ (function(module, exports, __webpack_require__) {

var ContextMenuView = __webpack_require__("hI2d");
var FileProgressView = __webpack_require__("0lcd");
var FileList = __webpack_require__("66sV");


var UploadContextMenuView = ContextMenuView.extend({
    el: '#uploadContextMenu',
    initialize: function (options) {
        this.afterHide = _.bind(this.deactivateCell, this);
        ContextMenuView.prototype.initialize.call(this, options);

        this.files = new FileList(null, {session: this.model.session});

        this.progressBars = $('#uploadProgressBars');
        this.model.bind('uploadConfirmed', this.uploadConfirmed, this);
        this.model.bind('uploadSuccess', this.trimUploaded, this);
    },
    events: $.extend({}, ContextMenuView.prototype.events, {
        'buttonClick button.uploadFile': 'clickUploadFile',
        'buttonClick button.newPaste': 'clickNewPaste',
    }),
    trimUploaded: function () {
        var uploaded = this.files.filter(function (f) {
            return f.isUploaded();
        });
        if (uploaded.length > 6) {
            this.files.remove(_.last(uploaded));
            this.trimUploaded();
        }
    },
    uploadConfirmed: function (fileWrap) {
        if (!this.files.contains(fileWrap)) {
            this.files.add(fileWrap);
            var view = new FileProgressView({model: fileWrap});
            fileWrap.bind('remove', function () {
                view.remove();
            });
            this.progressBars.prepend(view.render().el);
        }
        this.trimUploaded();
    },
    clickUploadFile: function (e) {
        e.preventDefault();
        if (this.model.uploadsEnabled()) {
            this.hide();
            this.buffer.trigger('uploadPrompt');
        }
    },
    clickNewPaste: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('pastePrompt');
    },
    deactivateCell: function () {
        if (this.cell) {
            this.cell.removeClass('menuActive').attr('aria-expanded', 'false');
        }
    },
    show: function (buffer, cell) {
        this.buffer = buffer;
        this.cell = cell;
        
        this.cell.addClass('menuActive').attr('aria-expanded', 'true');
        
        this.deactivateItem(this.$('li.uploadFile'), !this.model.uploadsEnabled());
        this.$('.uploadFileDisabled').toggle(!this.model.uploadsEnabled());
        
        var offset = this.cell.offset();
        var x = offset.left + this.cell.outerWidth();
        var y = offset.top;
        
        ContextMenuView.prototype.show.call(this, x, y, {
            anchorRight: true,
            anchorBottom: true
        });
    }
});


module.exports = UploadContextMenuView;


/***/ }),

/***/ "6G2X":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var Keyboard = __webpack_require__("fDhS").default;


var BufferStatusView = Backbone.View.extend({
    tagName: 'div',
    className: 'status bufferHead',
    initialize: function (options) {
        this.model.bind('remove', this.remove, this);
        this.formatter = new BufferFormatter(this.model);
    },
    render: function () {
        this.renderButtons();
        this.$el.append(this.buttons);
        
        this.label = $('<span class="bufferlabel label">');
        if (!this.model.isThread()) {
            this.label.attr('id', 'bufferlabel_' + this.model.bid());
        }
        this.renderLabel();
        
        this.title = $('<h2 class="bufferHeading">');
        this.title.append(this.label)
            .append(' ');
        this.$el.append(this.title);
        
        return this;
    },
    postrender: function () {
        if (this.model.connection.isSlackUpgradable()) {
            this.$el.append('<div class="userInfo slackLegacy">This Slack IRC gateway is closing down, but you can upgrade to a new integration. <a href="https://blog.irccloud.com/slack-integration/" target="_blank">Read the announcement and upgrade instructions</a></div>');
        }
    },
    expandTitle: function () {
        this.title.removeClass('bufferHeadingCollapsed');
        this.trigger('topChange');
    },
    collapseTitle: function () {
        this.title.addClass('bufferHeadingCollapsed');
        this.trigger('topChange');
    },
    toggleExpandTitle: function () {
        this.title.toggleClass('bufferHeadingCollapsed');
        this.trigger('topChange');
    },
    renderLabel: function () {
        this.label.html(this.formatter.render(this.model.getTitle()));
    },
    appendOptionsButton: function () {
        var menuId;
        if (this.model.isChannel()) {
            menuId = 'channelContextMenu';
        } else if (this.model.isConversation()) {
            menuId = 'conversationContextMenu';
        } else if (this.model.isServerLog()) {
            menuId = 'serverLogContextMenu';
        }
        var button = $('<button class="bufferOptions fa fa-cog">').attr({
            'title': "Options",
            'aria-label': "Options",
            'aria-expanded': false,
            'aria-controls': menuId,
            'aria-haspopup': 'true'
        });
        button.click(_.bind(function (e) {
            this.model.session.trigger('bufferOptions', button, this.model, e);
            return false;
        }, this));
        this.buttons.append(button);
    },
    renderButtons: function () {
        this.buttons = $('<p class="buttons">');
    },
    appendButton: function (className, text, image) {
        var span = $('<span>').text(text);
        if (image) {
            span.append(image);
        }
        var button = $('<button>').addClass(className).append(span);
        this.buttons.append(button);
    }
});


module.exports = BufferStatusView;


/***/ }),

/***/ "7J3D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7gVv":
/***/ (function(module, exports, __webpack_require__) {

var Message = __webpack_require__("j9Sh");


var MessageList = Backbone.Collection.extend({
    model: Message,
    initialize: function (models, options) {
        this.buffer = options.buffer;
        this.threads = {};
    },
    comparator: function (message) {
        return message.id;
    },
    findByMsgId: function (msgid) {
        return this.findWhere({'msgid': msgid});
    },
    registerThread: function (message) {
        var reply = message.getReply();
        if (reply) {
            this.threads[reply] = true;
        }
    },
    isInThread: function (msgid) {
        return !!this.threads[msgid];
    },
    getThread: function (replyId, excludeEmpty) {
        var msgIds = {};
        return this.filter(function (m) {
            if (excludeEmpty && m.isEmpty()) {
                return false;
            }
            if (m.isSameThread(m, replyId)) {
                if (m.getMsgId()) {
                    msgIds[m.getMsgId()] = true;
                }
                return true;
            } else if (msgIds[m.getReply()]) {
                return true;
            } else if (msgIds[m.getConcatTag()]) {
                return true;
            } else if (msgIds[m.getEdit()]) {
                return true;
            } else if (msgIds[m.getDelete()]) {
                return true;
            }
        }, this);
    },
    lastVisible: function () {
        var last = this.last();
        if (last && last.isEmpty()) {
            last = last.previousVisible();
        }
        return last;
    },
    lastReplyable: function () {
        var last = this.last();
        if (last && !last.isReplyable()) {
            last = last.previousReplyable();
        }
        return last;
    },
    // Filter the message list exclusively
    filterBeforeEid: function (eid, num) {
        // Use find to shortcut the iteration because messages are sorted by eid
        var until = this.find(function (message) {
            return message.id >= eid;
        });
        // Until might not have found anything
        var messages = until ? this.first(this.indexOf(until)) : [];
        if (num) {
            return _.last(messages, num);
        } else {
            return messages;
        }
    }
});


module.exports = MessageList;


/***/ }),

/***/ "88d4":
/***/ (function(module, exports) {

// Modified from https://gist.github.com/gwwar/2166393

// test for ie: turn on conditional comments
var jscript/*@cc_on=@_jscript_version@*/;
var styleProp = (jscript) ? "display" : "pointerEvents";

function atPoint (clientX, clientY, filter, bound, lastElement) {
    //support for child iframes
    var d = (lastElement) ? lastElement.ownerDocument : document;
    var $el;
    // No support from FF until this bug is closed:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1164427
    var efp = d.elementsFromPoint || d.msElementsFromPoint;
    if (efp) {
        var elements = efp.call(d, clientX, clientY);
        if (filter) {
            var found;
            for (var i = 0; i < elements.length; i++) {
                $el = $(elements[i]);
                if ($el.is(filter) || (bound && $el.is(bound))) {
                    found = elements[i];
                    break;
                }
            }
            if (found && $(found).is(filter)) {
                return [found];
            } else {
                return [];
            }
        } else if (_.isArray(elements)) {
            return elements;
        } else {
            // msElementsFromPoint returns a nodelist, convert to an array
            // for loop is faster than Array.prototype.slice in IE
            var els = [];
            for (var j = 0, len = elements.length; j < len; j++) {
                els[j] = elements[j];
            }
            return els;
        }
    } else {
        //the last element in the list
        lastElement = lastElement || document.body.parentNode;

        var element = d.elementFromPoint(clientX, clientY);
        if (element && element.nodeType == 3) { // avoid text nodes
            element = element.parentNode;
        }
        $el = $(element);
        if (!element || (bound && $el.is(bound))) {
            return [];
        }
        if (filter) {
            if ($el.is(filter)) {
                return [element];
            } else {
                var closest = $el.closest(filter);
                if (closest.is(filter) && (!bound || closest.closest(bound).is(bound))) {
                    return [closest[0]];
                    // return [];
                } else {
                    return [];
                }
            }
        }
        if (element === lastElement || element.nodeName === "HTML") {
            return [element];
        } else {
            var style = element.style[styleProp];
            element.style[styleProp]="none"; //let us peak at the next layer
            var result = [element].concat(atPoint(clientX,clientY,filter,bound,lastElement));
            element.style[styleProp]= style; //restore
            return result;
        }
    }
}

module.exports = atPoint;


/***/ }),

/***/ "8Gq8":
/***/ (function(module, exports, __webpack_require__) {

var Connection = __webpack_require__("LLdI");


var ConnectionList = Backbone.Collection.extend({
    model: Connection,
    comparator: function (connection) {
        return connection.getOrder();
    },
    initialize: function (models, options) {
        this.session = options.session;
    },
    saveOrder: function () {
        this.sort();
        this.session.post('reorder-connections', {
            cids: this.pluck('cid').join(',')
        });
    },
    move: function (connection, up) {
        var index = this.indexOf(connection);
        if (up) {
            index--;
        } else {
            index++;
        }
        if (index < 0 || index >= this.length) {
            debug.warn('Tried to move a connection out of bounds', index, connection);
            return;
        }
        this.moveTo(connection, index);
    },
    moveTo: function (connection, at) {
        this.remove(connection, {silent: true});
        this.add(connection, {at: at, silent: true});
        this.each(function (conn, i) {
            conn.setOrder(i+1);
        });
        this.saveOrder();
        this.trigger('moveTo', connection, at);
    },
    orderChanged: function (order) {
        _.each(order, function (cid, i) {
            var conn = this.get(cid);
            conn.setOrder(i + 1);
            this.trigger('moveTo', conn, i);
        }, this);
        this.sort();
    }
});


module.exports = ConnectionList;


/***/ }),

/***/ "8OS9":
/***/ (function(module, exports) {

// https://github.com/jwheare/js-emoji/tree/irccloud
// Update .emoji background-size in CSS when sheet_size changes
window.emoji.sheet_size = 63;
window.emoji.data = {
    "0023-fe0f-20e3":[["\u0023\uFE0F\u20E3"],"Symbols",1564,["hash"],0,0,"0.6","keycap"],
    "002a-fe0f-20e3":[["\u002A\uFE0F\u20E3"],"Symbols",1565,["keycap_star"],0,1,"2.0","keycap"],
    "0030-fe0f-20e3":[["\u0030\uFE0F\u20E3"],"Symbols",1566,["zero"],0,2,"0.6","keycap"],
    "0031-fe0f-20e3":[["\u0031\uFE0F\u20E3"],"Symbols",1567,["one"],0,3,"0.6","keycap"],
    "0032-fe0f-20e3":[["\u0032\uFE0F\u20E3"],"Symbols",1568,["two"],0,4,"0.6","keycap"],
    "0033-fe0f-20e3":[["\u0033\uFE0F\u20E3"],"Symbols",1569,["three"],0,5,"0.6","keycap"],
    "0034-fe0f-20e3":[["\u0034\uFE0F\u20E3"],"Symbols",1570,["four"],0,6,"0.6","keycap"],
    "0035-fe0f-20e3":[["\u0035\uFE0F\u20E3"],"Symbols",1571,["five"],0,7,"0.6","keycap"],
    "0036-fe0f-20e3":[["\u0036\uFE0F\u20E3"],"Symbols",1572,["six"],0,8,"0.6","keycap"],
    "0037-fe0f-20e3":[["\u0037\uFE0F\u20E3"],"Symbols",1573,["seven"],0,9,"0.6","keycap"],
    "0038-fe0f-20e3":[["\u0038\uFE0F\u20E3"],"Symbols",1574,["eight"],0,10,"0.6","keycap"],
    "0039-fe0f-20e3":[["\u0039\uFE0F\u20E3"],"Symbols",1575,["nine"],0,11,"0.6","keycap"],
    "00a9-fe0f":[["\u00A9\uFE0F"],"Symbols",1560,["copyright"],0,12,"0.6","other-symbol"],
    "00ae-fe0f":[["\u00AE\uFE0F"],"Symbols",1561,["registered"],0,13,"0.6","other-symbol"],
    "1f004":[["\uD83C\uDC04"],"Activities",1151,["mahjong"],0,14,"0.6","game"],
    "1f0cf":[["\uD83C\uDCCF"],"Activities",1150,["black_joker"],0,15,"0.6","game"],
    "1f170-fe0f":[["\uD83C\uDD70\uFE0F"],"Symbols",1582,["a"],0,16,"0.6","alphanum"],
    "1f171-fe0f":[["\uD83C\uDD71\uFE0F"],"Symbols",1584,["b"],0,17,"0.6","alphanum"],
    "1f17e-fe0f":[["\uD83C\uDD7E\uFE0F"],"Symbols",1593,["o2"],0,18,"0.6","alphanum"],
    "1f17f-fe0f":[["\uD83C\uDD7F\uFE0F"],"Symbols",1595,["parking"],0,19,"0.6","alphanum"],
    "1f18e":[["\uD83C\uDD8E"],"Symbols",1583,["ab"],0,20,"0.6","alphanum"],
    "1f191":[["\uD83C\uDD91"],"Symbols",1585,["cl"],0,21,"0.6","alphanum"],
    "1f192":[["\uD83C\uDD92"],"Symbols",1586,["cool"],0,22,"0.6","alphanum"],
    "1f193":[["\uD83C\uDD93"],"Symbols",1587,["free"],0,23,"0.6","alphanum"],
    "1f194":[["\uD83C\uDD94"],"Symbols",1589,["id"],0,24,"0.6","alphanum"],
    "1f195":[["\uD83C\uDD95"],"Symbols",1591,["new"],0,25,"0.6","alphanum"],
    "1f196":[["\uD83C\uDD96"],"Symbols",1592,["ng"],0,26,"0.6","alphanum"],
    "1f197":[["\uD83C\uDD97"],"Symbols",1594,["ok"],0,27,"0.6","alphanum"],
    "1f198":[["\uD83C\uDD98"],"Symbols",1596,["sos"],0,28,"0.6","alphanum"],
    "1f199":[["\uD83C\uDD99"],"Symbols",1597,["up"],0,29,"0.6","alphanum"],
    "1f19a":[["\uD83C\uDD9A"],"Symbols",1598,["vs"],0,30,"0.6","alphanum"],
    "1f1e6-1f1e8":[["\uD83C\uDDE6\uD83C\uDDE8"],"Flags",1658,["flag-ac"],0,31,"2.0","country-flag"],
    "1f1e6-1f1e9":[["\uD83C\uDDE6\uD83C\uDDE9"],"Flags",1659,["flag-ad"],0,32,"2.0","country-flag"],
    "1f1e6-1f1ea":[["\uD83C\uDDE6\uD83C\uDDEA"],"Flags",1660,["flag-ae"],0,33,"2.0","country-flag"],
    "1f1e6-1f1eb":[["\uD83C\uDDE6\uD83C\uDDEB"],"Flags",1661,["flag-af"],0,34,"2.0","country-flag"],
    "1f1e6-1f1ec":[["\uD83C\uDDE6\uD83C\uDDEC"],"Flags",1662,["flag-ag"],0,35,"2.0","country-flag"],
    "1f1e6-1f1ee":[["\uD83C\uDDE6\uD83C\uDDEE"],"Flags",1663,["flag-ai"],0,36,"2.0","country-flag"],
    "1f1e6-1f1f1":[["\uD83C\uDDE6\uD83C\uDDF1"],"Flags",1664,["flag-al"],0,37,"2.0","country-flag"],
    "1f1e6-1f1f2":[["\uD83C\uDDE6\uD83C\uDDF2"],"Flags",1665,["flag-am"],0,38,"2.0","country-flag"],
    "1f1e6-1f1f4":[["\uD83C\uDDE6\uD83C\uDDF4"],"Flags",1666,["flag-ao"],0,39,"2.0","country-flag"],
    "1f1e6-1f1f6":[["\uD83C\uDDE6\uD83C\uDDF6"],"Flags",1667,["flag-aq"],0,40,"2.0","country-flag"],
    "1f1e6-1f1f7":[["\uD83C\uDDE6\uD83C\uDDF7"],"Flags",1668,["flag-ar"],0,41,"2.0","country-flag"],
    "1f1e6-1f1f8":[["\uD83C\uDDE6\uD83C\uDDF8"],"Flags",1669,["flag-as"],0,42,"2.0","country-flag"],
    "1f1e6-1f1f9":[["\uD83C\uDDE6\uD83C\uDDF9"],"Flags",1670,["flag-at"],0,43,"2.0","country-flag"],
    "1f1e6-1f1fa":[["\uD83C\uDDE6\uD83C\uDDFA"],"Flags",1671,["flag-au"],0,44,"2.0","country-flag"],
    "1f1e6-1f1fc":[["\uD83C\uDDE6\uD83C\uDDFC"],"Flags",1672,["flag-aw"],0,45,"2.0","country-flag"],
    "1f1e6-1f1fd":[["\uD83C\uDDE6\uD83C\uDDFD"],"Flags",1673,["flag-ax"],0,46,"2.0","country-flag"],
    "1f1e6-1f1ff":[["\uD83C\uDDE6\uD83C\uDDFF"],"Flags",1674,["flag-az"],0,47,"2.0","country-flag"],
    "1f1e7-1f1e6":[["\uD83C\uDDE7\uD83C\uDDE6"],"Flags",1675,["flag-ba"],0,48,"2.0","country-flag"],
    "1f1e7-1f1e7":[["\uD83C\uDDE7\uD83C\uDDE7"],"Flags",1676,["flag-bb"],0,49,"2.0","country-flag"],
    "1f1e7-1f1e9":[["\uD83C\uDDE7\uD83C\uDDE9"],"Flags",1677,["flag-bd"],0,50,"2.0","country-flag"],
    "1f1e7-1f1ea":[["\uD83C\uDDE7\uD83C\uDDEA"],"Flags",1678,["flag-be"],0,51,"2.0","country-flag"],
    "1f1e7-1f1eb":[["\uD83C\uDDE7\uD83C\uDDEB"],"Flags",1679,["flag-bf"],0,52,"2.0","country-flag"],
    "1f1e7-1f1ec":[["\uD83C\uDDE7\uD83C\uDDEC"],"Flags",1680,["flag-bg"],0,53,"2.0","country-flag"],
    "1f1e7-1f1ed":[["\uD83C\uDDE7\uD83C\uDDED"],"Flags",1681,["flag-bh"],0,54,"2.0","country-flag"],
    "1f1e7-1f1ee":[["\uD83C\uDDE7\uD83C\uDDEE"],"Flags",1682,["flag-bi"],0,55,"2.0","country-flag"],
    "1f1e7-1f1ef":[["\uD83C\uDDE7\uD83C\uDDEF"],"Flags",1683,["flag-bj"],0,56,"2.0","country-flag"],
    "1f1e7-1f1f1":[["\uD83C\uDDE7\uD83C\uDDF1"],"Flags",1684,["flag-bl"],0,57,"2.0","country-flag"],
    "1f1e7-1f1f2":[["\uD83C\uDDE7\uD83C\uDDF2"],"Flags",1685,["flag-bm"],0,58,"2.0","country-flag"],
    "1f1e7-1f1f3":[["\uD83C\uDDE7\uD83C\uDDF3"],"Flags",1686,["flag-bn"],0,59,"2.0","country-flag"],
    "1f1e7-1f1f4":[["\uD83C\uDDE7\uD83C\uDDF4"],"Flags",1687,["flag-bo"],0,60,"2.0","country-flag"],
    "1f1e7-1f1f6":[["\uD83C\uDDE7\uD83C\uDDF6"],"Flags",1688,["flag-bq"],0,61,"2.0","country-flag"],
    "1f1e7-1f1f7":[["\uD83C\uDDE7\uD83C\uDDF7"],"Flags",1689,["flag-br"],0,62,"2.0","country-flag"],
    "1f1e7-1f1f8":[["\uD83C\uDDE7\uD83C\uDDF8"],"Flags",1690,["flag-bs"],1,0,"2.0","country-flag"],
    "1f1e7-1f1f9":[["\uD83C\uDDE7\uD83C\uDDF9"],"Flags",1691,["flag-bt"],1,1,"2.0","country-flag"],
    "1f1e7-1f1fb":[["\uD83C\uDDE7\uD83C\uDDFB"],"Flags",1692,["flag-bv"],1,2,"2.0","country-flag"],
    "1f1e7-1f1fc":[["\uD83C\uDDE7\uD83C\uDDFC"],"Flags",1693,["flag-bw"],1,3,"2.0","country-flag"],
    "1f1e7-1f1fe":[["\uD83C\uDDE7\uD83C\uDDFE"],"Flags",1694,["flag-by"],1,4,"2.0","country-flag"],
    "1f1e7-1f1ff":[["\uD83C\uDDE7\uD83C\uDDFF"],"Flags",1695,["flag-bz"],1,5,"2.0","country-flag"],
    "1f1e8-1f1e6":[["\uD83C\uDDE8\uD83C\uDDE6"],"Flags",1696,["flag-ca"],1,6,"2.0","country-flag"],
    "1f1e8-1f1e8":[["\uD83C\uDDE8\uD83C\uDDE8"],"Flags",1697,["flag-cc"],1,7,"2.0","country-flag"],
    "1f1e8-1f1e9":[["\uD83C\uDDE8\uD83C\uDDE9"],"Flags",1698,["flag-cd"],1,8,"2.0","country-flag"],
    "1f1e8-1f1eb":[["\uD83C\uDDE8\uD83C\uDDEB"],"Flags",1699,["flag-cf"],1,9,"2.0","country-flag"],
    "1f1e8-1f1ec":[["\uD83C\uDDE8\uD83C\uDDEC"],"Flags",1700,["flag-cg"],1,10,"2.0","country-flag"],
    "1f1e8-1f1ed":[["\uD83C\uDDE8\uD83C\uDDED"],"Flags",1701,["flag-ch"],1,11,"2.0","country-flag"],
    "1f1e8-1f1ee":[["\uD83C\uDDE8\uD83C\uDDEE"],"Flags",1702,["flag-ci"],1,12,"2.0","country-flag"],
    "1f1e8-1f1f0":[["\uD83C\uDDE8\uD83C\uDDF0"],"Flags",1703,["flag-ck"],1,13,"2.0","country-flag"],
    "1f1e8-1f1f1":[["\uD83C\uDDE8\uD83C\uDDF1"],"Flags",1704,["flag-cl"],1,14,"2.0","country-flag"],
    "1f1e8-1f1f2":[["\uD83C\uDDE8\uD83C\uDDF2"],"Flags",1705,["flag-cm"],1,15,"2.0","country-flag"],
    "1f1e8-1f1f3":[["\uD83C\uDDE8\uD83C\uDDF3"],"Flags",1706,["cn","flag-cn"],1,16,"0.6","country-flag"],
    "1f1e8-1f1f4":[["\uD83C\uDDE8\uD83C\uDDF4"],"Flags",1707,["flag-co"],1,17,"2.0","country-flag"],
    "1f1e8-1f1f5":[["\uD83C\uDDE8\uD83C\uDDF5"],"Flags",1708,["flag-cp"],1,18,"2.0","country-flag"],
    "1f1e8-1f1f6":[["\uD83C\uDDE8\uD83C\uDDF6"],"Flags",1709,["flag-sark"],1,19,"16.0","country-flag"],
    "1f1e8-1f1f7":[["\uD83C\uDDE8\uD83C\uDDF7"],"Flags",1710,["flag-cr"],1,20,"2.0","country-flag"],
    "1f1e8-1f1fa":[["\uD83C\uDDE8\uD83C\uDDFA"],"Flags",1711,["flag-cu"],1,21,"2.0","country-flag"],
    "1f1e8-1f1fb":[["\uD83C\uDDE8\uD83C\uDDFB"],"Flags",1712,["flag-cv"],1,22,"2.0","country-flag"],
    "1f1e8-1f1fc":[["\uD83C\uDDE8\uD83C\uDDFC"],"Flags",1713,["flag-cw"],1,23,"2.0","country-flag"],
    "1f1e8-1f1fd":[["\uD83C\uDDE8\uD83C\uDDFD"],"Flags",1714,["flag-cx"],1,24,"2.0","country-flag"],
    "1f1e8-1f1fe":[["\uD83C\uDDE8\uD83C\uDDFE"],"Flags",1715,["flag-cy"],1,25,"2.0","country-flag"],
    "1f1e8-1f1ff":[["\uD83C\uDDE8\uD83C\uDDFF"],"Flags",1716,["flag-cz"],1,26,"2.0","country-flag"],
    "1f1e9-1f1ea":[["\uD83C\uDDE9\uD83C\uDDEA"],"Flags",1717,["de","flag-de"],1,27,"0.6","country-flag"],
    "1f1e9-1f1ec":[["\uD83C\uDDE9\uD83C\uDDEC"],"Flags",1718,["flag-dg"],1,28,"2.0","country-flag"],
    "1f1e9-1f1ef":[["\uD83C\uDDE9\uD83C\uDDEF"],"Flags",1719,["flag-dj"],1,29,"2.0","country-flag"],
    "1f1e9-1f1f0":[["\uD83C\uDDE9\uD83C\uDDF0"],"Flags",1720,["flag-dk"],1,30,"2.0","country-flag"],
    "1f1e9-1f1f2":[["\uD83C\uDDE9\uD83C\uDDF2"],"Flags",1721,["flag-dm"],1,31,"2.0","country-flag"],
    "1f1e9-1f1f4":[["\uD83C\uDDE9\uD83C\uDDF4"],"Flags",1722,["flag-do"],1,32,"2.0","country-flag"],
    "1f1e9-1f1ff":[["\uD83C\uDDE9\uD83C\uDDFF"],"Flags",1723,["flag-dz"],1,33,"2.0","country-flag"],
    "1f1ea-1f1e6":[["\uD83C\uDDEA\uD83C\uDDE6"],"Flags",1724,["flag-ea"],1,34,"2.0","country-flag"],
    "1f1ea-1f1e8":[["\uD83C\uDDEA\uD83C\uDDE8"],"Flags",1725,["flag-ec"],1,35,"2.0","country-flag"],
    "1f1ea-1f1ea":[["\uD83C\uDDEA\uD83C\uDDEA"],"Flags",1726,["flag-ee"],1,36,"2.0","country-flag"],
    "1f1ea-1f1ec":[["\uD83C\uDDEA\uD83C\uDDEC"],"Flags",1727,["flag-eg"],1,37,"2.0","country-flag"],
    "1f1ea-1f1ed":[["\uD83C\uDDEA\uD83C\uDDED"],"Flags",1728,["flag-eh"],1,38,"2.0","country-flag"],
    "1f1ea-1f1f7":[["\uD83C\uDDEA\uD83C\uDDF7"],"Flags",1729,["flag-er"],1,39,"2.0","country-flag"],
    "1f1ea-1f1f8":[["\uD83C\uDDEA\uD83C\uDDF8"],"Flags",1730,["es","flag-es"],1,40,"0.6","country-flag"],
    "1f1ea-1f1f9":[["\uD83C\uDDEA\uD83C\uDDF9"],"Flags",1731,["flag-et"],1,41,"2.0","country-flag"],
    "1f1ea-1f1fa":[["\uD83C\uDDEA\uD83C\uDDFA"],"Flags",1732,["flag-eu"],1,42,"2.0","country-flag"],
    "1f1eb-1f1ee":[["\uD83C\uDDEB\uD83C\uDDEE"],"Flags",1733,["flag-fi"],1,43,"2.0","country-flag"],
    "1f1eb-1f1ef":[["\uD83C\uDDEB\uD83C\uDDEF"],"Flags",1734,["flag-fj"],1,44,"2.0","country-flag"],
    "1f1eb-1f1f0":[["\uD83C\uDDEB\uD83C\uDDF0"],"Flags",1735,["flag-fk"],1,45,"2.0","country-flag"],
    "1f1eb-1f1f2":[["\uD83C\uDDEB\uD83C\uDDF2"],"Flags",1736,["flag-fm"],1,46,"2.0","country-flag"],
    "1f1eb-1f1f4":[["\uD83C\uDDEB\uD83C\uDDF4"],"Flags",1737,["flag-fo"],1,47,"2.0","country-flag"],
    "1f1eb-1f1f7":[["\uD83C\uDDEB\uD83C\uDDF7"],"Flags",1738,["fr","flag-fr"],1,48,"0.6","country-flag"],
    "1f1ec-1f1e6":[["\uD83C\uDDEC\uD83C\uDDE6"],"Flags",1739,["flag-ga"],1,49,"2.0","country-flag"],
    "1f1ec-1f1e7":[["\uD83C\uDDEC\uD83C\uDDE7"],"Flags",1740,["gb","uk","flag-gb"],1,50,"0.6","country-flag"],
    "1f1ec-1f1e9":[["\uD83C\uDDEC\uD83C\uDDE9"],"Flags",1741,["flag-gd"],1,51,"2.0","country-flag"],
    "1f1ec-1f1ea":[["\uD83C\uDDEC\uD83C\uDDEA"],"Flags",1742,["flag-ge"],1,52,"2.0","country-flag"],
    "1f1ec-1f1eb":[["\uD83C\uDDEC\uD83C\uDDEB"],"Flags",1743,["flag-gf"],1,53,"2.0","country-flag"],
    "1f1ec-1f1ec":[["\uD83C\uDDEC\uD83C\uDDEC"],"Flags",1744,["flag-gg"],1,54,"2.0","country-flag"],
    "1f1ec-1f1ed":[["\uD83C\uDDEC\uD83C\uDDED"],"Flags",1745,["flag-gh"],1,55,"2.0","country-flag"],
    "1f1ec-1f1ee":[["\uD83C\uDDEC\uD83C\uDDEE"],"Flags",1746,["flag-gi"],1,56,"2.0","country-flag"],
    "1f1ec-1f1f1":[["\uD83C\uDDEC\uD83C\uDDF1"],"Flags",1747,["flag-gl"],1,57,"2.0","country-flag"],
    "1f1ec-1f1f2":[["\uD83C\uDDEC\uD83C\uDDF2"],"Flags",1748,["flag-gm"],1,58,"2.0","country-flag"],
    "1f1ec-1f1f3":[["\uD83C\uDDEC\uD83C\uDDF3"],"Flags",1749,["flag-gn"],1,59,"2.0","country-flag"],
    "1f1ec-1f1f5":[["\uD83C\uDDEC\uD83C\uDDF5"],"Flags",1750,["flag-gp"],1,60,"2.0","country-flag"],
    "1f1ec-1f1f6":[["\uD83C\uDDEC\uD83C\uDDF6"],"Flags",1751,["flag-gq"],1,61,"2.0","country-flag"],
    "1f1ec-1f1f7":[["\uD83C\uDDEC\uD83C\uDDF7"],"Flags",1752,["flag-gr"],1,62,"2.0","country-flag"],
    "1f1ec-1f1f8":[["\uD83C\uDDEC\uD83C\uDDF8"],"Flags",1753,["flag-gs"],2,0,"2.0","country-flag"],
    "1f1ec-1f1f9":[["\uD83C\uDDEC\uD83C\uDDF9"],"Flags",1754,["flag-gt"],2,1,"2.0","country-flag"],
    "1f1ec-1f1fa":[["\uD83C\uDDEC\uD83C\uDDFA"],"Flags",1755,["flag-gu"],2,2,"2.0","country-flag"],
    "1f1ec-1f1fc":[["\uD83C\uDDEC\uD83C\uDDFC"],"Flags",1756,["flag-gw"],2,3,"2.0","country-flag"],
    "1f1ec-1f1fe":[["\uD83C\uDDEC\uD83C\uDDFE"],"Flags",1757,["flag-gy"],2,4,"2.0","country-flag"],
    "1f1ed-1f1f0":[["\uD83C\uDDED\uD83C\uDDF0"],"Flags",1758,["flag-hk"],2,5,"2.0","country-flag"],
    "1f1ed-1f1f2":[["\uD83C\uDDED\uD83C\uDDF2"],"Flags",1759,["flag-hm"],2,6,"2.0","country-flag"],
    "1f1ed-1f1f3":[["\uD83C\uDDED\uD83C\uDDF3"],"Flags",1760,["flag-hn"],2,7,"2.0","country-flag"],
    "1f1ed-1f1f7":[["\uD83C\uDDED\uD83C\uDDF7"],"Flags",1761,["flag-hr"],2,8,"2.0","country-flag"],
    "1f1ed-1f1f9":[["\uD83C\uDDED\uD83C\uDDF9"],"Flags",1762,["flag-ht"],2,9,"2.0","country-flag"],
    "1f1ed-1f1fa":[["\uD83C\uDDED\uD83C\uDDFA"],"Flags",1763,["flag-hu"],2,10,"2.0","country-flag"],
    "1f1ee-1f1e8":[["\uD83C\uDDEE\uD83C\uDDE8"],"Flags",1764,["flag-ic"],2,11,"2.0","country-flag"],
    "1f1ee-1f1e9":[["\uD83C\uDDEE\uD83C\uDDE9"],"Flags",1765,["flag-id"],2,12,"2.0","country-flag"],
    "1f1ee-1f1ea":[["\uD83C\uDDEE\uD83C\uDDEA"],"Flags",1766,["flag-ie"],2,13,"2.0","country-flag"],
    "1f1ee-1f1f1":[["\uD83C\uDDEE\uD83C\uDDF1"],"Flags",1767,["flag-il"],2,14,"2.0","country-flag"],
    "1f1ee-1f1f2":[["\uD83C\uDDEE\uD83C\uDDF2"],"Flags",1768,["flag-im"],2,15,"2.0","country-flag"],
    "1f1ee-1f1f3":[["\uD83C\uDDEE\uD83C\uDDF3"],"Flags",1769,["flag-in"],2,16,"2.0","country-flag"],
    "1f1ee-1f1f4":[["\uD83C\uDDEE\uD83C\uDDF4"],"Flags",1770,["flag-io"],2,17,"2.0","country-flag"],
    "1f1ee-1f1f6":[["\uD83C\uDDEE\uD83C\uDDF6"],"Flags",1771,["flag-iq"],2,18,"2.0","country-flag"],
    "1f1ee-1f1f7":[["\uD83C\uDDEE\uD83C\uDDF7"],"Flags",1772,["flag-ir"],2,19,"2.0","country-flag"],
    "1f1ee-1f1f8":[["\uD83C\uDDEE\uD83C\uDDF8"],"Flags",1773,["flag-is"],2,20,"2.0","country-flag"],
    "1f1ee-1f1f9":[["\uD83C\uDDEE\uD83C\uDDF9"],"Flags",1774,["it","flag-it"],2,21,"0.6","country-flag"],
    "1f1ef-1f1ea":[["\uD83C\uDDEF\uD83C\uDDEA"],"Flags",1775,["flag-je"],2,22,"2.0","country-flag"],
    "1f1ef-1f1f2":[["\uD83C\uDDEF\uD83C\uDDF2"],"Flags",1776,["flag-jm"],2,23,"2.0","country-flag"],
    "1f1ef-1f1f4":[["\uD83C\uDDEF\uD83C\uDDF4"],"Flags",1777,["flag-jo"],2,24,"2.0","country-flag"],
    "1f1ef-1f1f5":[["\uD83C\uDDEF\uD83C\uDDF5"],"Flags",1778,["jp","flag-jp"],2,25,"0.6","country-flag"],
    "1f1f0-1f1ea":[["\uD83C\uDDF0\uD83C\uDDEA"],"Flags",1779,["flag-ke"],2,26,"2.0","country-flag"],
    "1f1f0-1f1ec":[["\uD83C\uDDF0\uD83C\uDDEC"],"Flags",1780,["flag-kg"],2,27,"2.0","country-flag"],
    "1f1f0-1f1ed":[["\uD83C\uDDF0\uD83C\uDDED"],"Flags",1781,["flag-kh"],2,28,"2.0","country-flag"],
    "1f1f0-1f1ee":[["\uD83C\uDDF0\uD83C\uDDEE"],"Flags",1782,["flag-ki"],2,29,"2.0","country-flag"],
    "1f1f0-1f1f2":[["\uD83C\uDDF0\uD83C\uDDF2"],"Flags",1783,["flag-km"],2,30,"2.0","country-flag"],
    "1f1f0-1f1f3":[["\uD83C\uDDF0\uD83C\uDDF3"],"Flags",1784,["flag-kn"],2,31,"2.0","country-flag"],
    "1f1f0-1f1f5":[["\uD83C\uDDF0\uD83C\uDDF5"],"Flags",1785,["flag-kp"],2,32,"2.0","country-flag"],
    "1f1f0-1f1f7":[["\uD83C\uDDF0\uD83C\uDDF7"],"Flags",1786,["kr","flag-kr"],2,33,"0.6","country-flag"],
    "1f1f0-1f1fc":[["\uD83C\uDDF0\uD83C\uDDFC"],"Flags",1787,["flag-kw"],2,34,"2.0","country-flag"],
    "1f1f0-1f1fe":[["\uD83C\uDDF0\uD83C\uDDFE"],"Flags",1788,["flag-ky"],2,35,"2.0","country-flag"],
    "1f1f0-1f1ff":[["\uD83C\uDDF0\uD83C\uDDFF"],"Flags",1789,["flag-kz"],2,36,"2.0","country-flag"],
    "1f1f1-1f1e6":[["\uD83C\uDDF1\uD83C\uDDE6"],"Flags",1790,["flag-la"],2,37,"2.0","country-flag"],
    "1f1f1-1f1e7":[["\uD83C\uDDF1\uD83C\uDDE7"],"Flags",1791,["flag-lb"],2,38,"2.0","country-flag"],
    "1f1f1-1f1e8":[["\uD83C\uDDF1\uD83C\uDDE8"],"Flags",1792,["flag-lc"],2,39,"2.0","country-flag"],
    "1f1f1-1f1ee":[["\uD83C\uDDF1\uD83C\uDDEE"],"Flags",1793,["flag-li"],2,40,"2.0","country-flag"],
    "1f1f1-1f1f0":[["\uD83C\uDDF1\uD83C\uDDF0"],"Flags",1794,["flag-lk"],2,41,"2.0","country-flag"],
    "1f1f1-1f1f7":[["\uD83C\uDDF1\uD83C\uDDF7"],"Flags",1795,["flag-lr"],2,42,"2.0","country-flag"],
    "1f1f1-1f1f8":[["\uD83C\uDDF1\uD83C\uDDF8"],"Flags",1796,["flag-ls"],2,43,"2.0","country-flag"],
    "1f1f1-1f1f9":[["\uD83C\uDDF1\uD83C\uDDF9"],"Flags",1797,["flag-lt"],2,44,"2.0","country-flag"],
    "1f1f1-1f1fa":[["\uD83C\uDDF1\uD83C\uDDFA"],"Flags",1798,["flag-lu"],2,45,"2.0","country-flag"],
    "1f1f1-1f1fb":[["\uD83C\uDDF1\uD83C\uDDFB"],"Flags",1799,["flag-lv"],2,46,"2.0","country-flag"],
    "1f1f1-1f1fe":[["\uD83C\uDDF1\uD83C\uDDFE"],"Flags",1800,["flag-ly"],2,47,"2.0","country-flag"],
    "1f1f2-1f1e6":[["\uD83C\uDDF2\uD83C\uDDE6"],"Flags",1801,["flag-ma"],2,48,"2.0","country-flag"],
    "1f1f2-1f1e8":[["\uD83C\uDDF2\uD83C\uDDE8"],"Flags",1802,["flag-mc"],2,49,"2.0","country-flag"],
    "1f1f2-1f1e9":[["\uD83C\uDDF2\uD83C\uDDE9"],"Flags",1803,["flag-md"],2,50,"2.0","country-flag"],
    "1f1f2-1f1ea":[["\uD83C\uDDF2\uD83C\uDDEA"],"Flags",1804,["flag-me"],2,51,"2.0","country-flag"],
    "1f1f2-1f1eb":[["\uD83C\uDDF2\uD83C\uDDEB"],"Flags",1805,["flag-mf"],2,52,"2.0","country-flag"],
    "1f1f2-1f1ec":[["\uD83C\uDDF2\uD83C\uDDEC"],"Flags",1806,["flag-mg"],2,53,"2.0","country-flag"],
    "1f1f2-1f1ed":[["\uD83C\uDDF2\uD83C\uDDED"],"Flags",1807,["flag-mh"],2,54,"2.0","country-flag"],
    "1f1f2-1f1f0":[["\uD83C\uDDF2\uD83C\uDDF0"],"Flags",1808,["flag-mk"],2,55,"2.0","country-flag"],
    "1f1f2-1f1f1":[["\uD83C\uDDF2\uD83C\uDDF1"],"Flags",1809,["flag-ml"],2,56,"2.0","country-flag"],
    "1f1f2-1f1f2":[["\uD83C\uDDF2\uD83C\uDDF2"],"Flags",1810,["flag-mm"],2,57,"2.0","country-flag"],
    "1f1f2-1f1f3":[["\uD83C\uDDF2\uD83C\uDDF3"],"Flags",1811,["flag-mn"],2,58,"2.0","country-flag"],
    "1f1f2-1f1f4":[["\uD83C\uDDF2\uD83C\uDDF4"],"Flags",1812,["flag-mo"],2,59,"2.0","country-flag"],
    "1f1f2-1f1f5":[["\uD83C\uDDF2\uD83C\uDDF5"],"Flags",1813,["flag-mp"],2,60,"2.0","country-flag"],
    "1f1f2-1f1f6":[["\uD83C\uDDF2\uD83C\uDDF6"],"Flags",1814,["flag-mq"],2,61,"2.0","country-flag"],
    "1f1f2-1f1f7":[["\uD83C\uDDF2\uD83C\uDDF7"],"Flags",1815,["flag-mr"],2,62,"2.0","country-flag"],
    "1f1f2-1f1f8":[["\uD83C\uDDF2\uD83C\uDDF8"],"Flags",1816,["flag-ms"],3,0,"2.0","country-flag"],
    "1f1f2-1f1f9":[["\uD83C\uDDF2\uD83C\uDDF9"],"Flags",1817,["flag-mt"],3,1,"2.0","country-flag"],
    "1f1f2-1f1fa":[["\uD83C\uDDF2\uD83C\uDDFA"],"Flags",1818,["flag-mu"],3,2,"2.0","country-flag"],
    "1f1f2-1f1fb":[["\uD83C\uDDF2\uD83C\uDDFB"],"Flags",1819,["flag-mv"],3,3,"2.0","country-flag"],
    "1f1f2-1f1fc":[["\uD83C\uDDF2\uD83C\uDDFC"],"Flags",1820,["flag-mw"],3,4,"2.0","country-flag"],
    "1f1f2-1f1fd":[["\uD83C\uDDF2\uD83C\uDDFD"],"Flags",1821,["flag-mx"],3,5,"2.0","country-flag"],
    "1f1f2-1f1fe":[["\uD83C\uDDF2\uD83C\uDDFE"],"Flags",1822,["flag-my"],3,6,"2.0","country-flag"],
    "1f1f2-1f1ff":[["\uD83C\uDDF2\uD83C\uDDFF"],"Flags",1823,["flag-mz"],3,7,"2.0","country-flag"],
    "1f1f3-1f1e6":[["\uD83C\uDDF3\uD83C\uDDE6"],"Flags",1824,["flag-na"],3,8,"2.0","country-flag"],
    "1f1f3-1f1e8":[["\uD83C\uDDF3\uD83C\uDDE8"],"Flags",1825,["flag-nc"],3,9,"2.0","country-flag"],
    "1f1f3-1f1ea":[["\uD83C\uDDF3\uD83C\uDDEA"],"Flags",1826,["flag-ne"],3,10,"2.0","country-flag"],
    "1f1f3-1f1eb":[["\uD83C\uDDF3\uD83C\uDDEB"],"Flags",1827,["flag-nf"],3,11,"2.0","country-flag"],
    "1f1f3-1f1ec":[["\uD83C\uDDF3\uD83C\uDDEC"],"Flags",1828,["flag-ng"],3,12,"2.0","country-flag"],
    "1f1f3-1f1ee":[["\uD83C\uDDF3\uD83C\uDDEE"],"Flags",1829,["flag-ni"],3,13,"2.0","country-flag"],
    "1f1f3-1f1f1":[["\uD83C\uDDF3\uD83C\uDDF1"],"Flags",1830,["flag-nl"],3,14,"2.0","country-flag"],
    "1f1f3-1f1f4":[["\uD83C\uDDF3\uD83C\uDDF4"],"Flags",1831,["flag-no"],3,15,"2.0","country-flag"],
    "1f1f3-1f1f5":[["\uD83C\uDDF3\uD83C\uDDF5"],"Flags",1832,["flag-np"],3,16,"2.0","country-flag"],
    "1f1f3-1f1f7":[["\uD83C\uDDF3\uD83C\uDDF7"],"Flags",1833,["flag-nr"],3,17,"2.0","country-flag"],
    "1f1f3-1f1fa":[["\uD83C\uDDF3\uD83C\uDDFA"],"Flags",1834,["flag-nu"],3,18,"2.0","country-flag"],
    "1f1f3-1f1ff":[["\uD83C\uDDF3\uD83C\uDDFF"],"Flags",1835,["flag-nz"],3,19,"2.0","country-flag"],
    "1f1f4-1f1f2":[["\uD83C\uDDF4\uD83C\uDDF2"],"Flags",1836,["flag-om"],3,20,"2.0","country-flag"],
    "1f1f5-1f1e6":[["\uD83C\uDDF5\uD83C\uDDE6"],"Flags",1837,["flag-pa"],3,21,"2.0","country-flag"],
    "1f1f5-1f1ea":[["\uD83C\uDDF5\uD83C\uDDEA"],"Flags",1838,["flag-pe"],3,22,"2.0","country-flag"],
    "1f1f5-1f1eb":[["\uD83C\uDDF5\uD83C\uDDEB"],"Flags",1839,["flag-pf"],3,23,"2.0","country-flag"],
    "1f1f5-1f1ec":[["\uD83C\uDDF5\uD83C\uDDEC"],"Flags",1840,["flag-pg"],3,24,"2.0","country-flag"],
    "1f1f5-1f1ed":[["\uD83C\uDDF5\uD83C\uDDED"],"Flags",1841,["flag-ph"],3,25,"2.0","country-flag"],
    "1f1f5-1f1f0":[["\uD83C\uDDF5\uD83C\uDDF0"],"Flags",1842,["flag-pk"],3,26,"2.0","country-flag"],
    "1f1f5-1f1f1":[["\uD83C\uDDF5\uD83C\uDDF1"],"Flags",1843,["flag-pl"],3,27,"2.0","country-flag"],
    "1f1f5-1f1f2":[["\uD83C\uDDF5\uD83C\uDDF2"],"Flags",1844,["flag-pm"],3,28,"2.0","country-flag"],
    "1f1f5-1f1f3":[["\uD83C\uDDF5\uD83C\uDDF3"],"Flags",1845,["flag-pn"],3,29,"2.0","country-flag"],
    "1f1f5-1f1f7":[["\uD83C\uDDF5\uD83C\uDDF7"],"Flags",1846,["flag-pr"],3,30,"2.0","country-flag"],
    "1f1f5-1f1f8":[["\uD83C\uDDF5\uD83C\uDDF8"],"Flags",1847,["flag-ps"],3,31,"2.0","country-flag"],
    "1f1f5-1f1f9":[["\uD83C\uDDF5\uD83C\uDDF9"],"Flags",1848,["flag-pt"],3,32,"2.0","country-flag"],
    "1f1f5-1f1fc":[["\uD83C\uDDF5\uD83C\uDDFC"],"Flags",1849,["flag-pw"],3,33,"2.0","country-flag"],
    "1f1f5-1f1fe":[["\uD83C\uDDF5\uD83C\uDDFE"],"Flags",1850,["flag-py"],3,34,"2.0","country-flag"],
    "1f1f6-1f1e6":[["\uD83C\uDDF6\uD83C\uDDE6"],"Flags",1851,["flag-qa"],3,35,"2.0","country-flag"],
    "1f1f7-1f1ea":[["\uD83C\uDDF7\uD83C\uDDEA"],"Flags",1852,["flag-re"],3,36,"2.0","country-flag"],
    "1f1f7-1f1f4":[["\uD83C\uDDF7\uD83C\uDDF4"],"Flags",1853,["flag-ro"],3,37,"2.0","country-flag"],
    "1f1f7-1f1f8":[["\uD83C\uDDF7\uD83C\uDDF8"],"Flags",1854,["flag-rs"],3,38,"2.0","country-flag"],
    "1f1f7-1f1fa":[["\uD83C\uDDF7\uD83C\uDDFA"],"Flags",1855,["ru","flag-ru"],3,39,"0.6","country-flag"],
    "1f1f7-1f1fc":[["\uD83C\uDDF7\uD83C\uDDFC"],"Flags",1856,["flag-rw"],3,40,"2.0","country-flag"],
    "1f1f8-1f1e6":[["\uD83C\uDDF8\uD83C\uDDE6"],"Flags",1857,["flag-sa"],3,41,"2.0","country-flag"],
    "1f1f8-1f1e7":[["\uD83C\uDDF8\uD83C\uDDE7"],"Flags",1858,["flag-sb"],3,42,"2.0","country-flag"],
    "1f1f8-1f1e8":[["\uD83C\uDDF8\uD83C\uDDE8"],"Flags",1859,["flag-sc"],3,43,"2.0","country-flag"],
    "1f1f8-1f1e9":[["\uD83C\uDDF8\uD83C\uDDE9"],"Flags",1860,["flag-sd"],3,44,"2.0","country-flag"],
    "1f1f8-1f1ea":[["\uD83C\uDDF8\uD83C\uDDEA"],"Flags",1861,["flag-se"],3,45,"2.0","country-flag"],
    "1f1f8-1f1ec":[["\uD83C\uDDF8\uD83C\uDDEC"],"Flags",1862,["flag-sg"],3,46,"2.0","country-flag"],
    "1f1f8-1f1ed":[["\uD83C\uDDF8\uD83C\uDDED"],"Flags",1863,["flag-sh"],3,47,"2.0","country-flag"],
    "1f1f8-1f1ee":[["\uD83C\uDDF8\uD83C\uDDEE"],"Flags",1864,["flag-si"],3,48,"2.0","country-flag"],
    "1f1f8-1f1ef":[["\uD83C\uDDF8\uD83C\uDDEF"],"Flags",1865,["flag-sj"],3,49,"2.0","country-flag"],
    "1f1f8-1f1f0":[["\uD83C\uDDF8\uD83C\uDDF0"],"Flags",1866,["flag-sk"],3,50,"2.0","country-flag"],
    "1f1f8-1f1f1":[["\uD83C\uDDF8\uD83C\uDDF1"],"Flags",1867,["flag-sl"],3,51,"2.0","country-flag"],
    "1f1f8-1f1f2":[["\uD83C\uDDF8\uD83C\uDDF2"],"Flags",1868,["flag-sm"],3,52,"2.0","country-flag"],
    "1f1f8-1f1f3":[["\uD83C\uDDF8\uD83C\uDDF3"],"Flags",1869,["flag-sn"],3,53,"2.0","country-flag"],
    "1f1f8-1f1f4":[["\uD83C\uDDF8\uD83C\uDDF4"],"Flags",1870,["flag-so"],3,54,"2.0","country-flag"],
    "1f1f8-1f1f7":[["\uD83C\uDDF8\uD83C\uDDF7"],"Flags",1871,["flag-sr"],3,55,"2.0","country-flag"],
    "1f1f8-1f1f8":[["\uD83C\uDDF8\uD83C\uDDF8"],"Flags",1872,["flag-ss"],3,56,"2.0","country-flag"],
    "1f1f8-1f1f9":[["\uD83C\uDDF8\uD83C\uDDF9"],"Flags",1873,["flag-st"],3,57,"2.0","country-flag"],
    "1f1f8-1f1fb":[["\uD83C\uDDF8\uD83C\uDDFB"],"Flags",1874,["flag-sv"],3,58,"2.0","country-flag"],
    "1f1f8-1f1fd":[["\uD83C\uDDF8\uD83C\uDDFD"],"Flags",1875,["flag-sx"],3,59,"2.0","country-flag"],
    "1f1f8-1f1fe":[["\uD83C\uDDF8\uD83C\uDDFE"],"Flags",1876,["flag-sy"],3,60,"2.0","country-flag"],
    "1f1f8-1f1ff":[["\uD83C\uDDF8\uD83C\uDDFF"],"Flags",1877,["flag-sz"],3,61,"2.0","country-flag"],
    "1f1f9-1f1e6":[["\uD83C\uDDF9\uD83C\uDDE6"],"Flags",1878,["flag-ta"],3,62,"2.0","country-flag"],
    "1f1f9-1f1e8":[["\uD83C\uDDF9\uD83C\uDDE8"],"Flags",1879,["flag-tc"],4,0,"2.0","country-flag"],
    "1f1f9-1f1e9":[["\uD83C\uDDF9\uD83C\uDDE9"],"Flags",1880,["flag-td"],4,1,"2.0","country-flag"],
    "1f1f9-1f1eb":[["\uD83C\uDDF9\uD83C\uDDEB"],"Flags",1881,["flag-tf"],4,2,"2.0","country-flag"],
    "1f1f9-1f1ec":[["\uD83C\uDDF9\uD83C\uDDEC"],"Flags",1882,["flag-tg"],4,3,"2.0","country-flag"],
    "1f1f9-1f1ed":[["\uD83C\uDDF9\uD83C\uDDED"],"Flags",1883,["flag-th"],4,4,"2.0","country-flag"],
    "1f1f9-1f1ef":[["\uD83C\uDDF9\uD83C\uDDEF"],"Flags",1884,["flag-tj"],4,5,"2.0","country-flag"],
    "1f1f9-1f1f0":[["\uD83C\uDDF9\uD83C\uDDF0"],"Flags",1885,["flag-tk"],4,6,"2.0","country-flag"],
    "1f1f9-1f1f1":[["\uD83C\uDDF9\uD83C\uDDF1"],"Flags",1886,["flag-tl"],4,7,"2.0","country-flag"],
    "1f1f9-1f1f2":[["\uD83C\uDDF9\uD83C\uDDF2"],"Flags",1887,["flag-tm"],4,8,"2.0","country-flag"],
    "1f1f9-1f1f3":[["\uD83C\uDDF9\uD83C\uDDF3"],"Flags",1888,["flag-tn"],4,9,"2.0","country-flag"],
    "1f1f9-1f1f4":[["\uD83C\uDDF9\uD83C\uDDF4"],"Flags",1889,["flag-to"],4,10,"2.0","country-flag"],
    "1f1f9-1f1f7":[["\uD83C\uDDF9\uD83C\uDDF7"],"Flags",1890,["flag-tr"],4,11,"2.0","country-flag"],
    "1f1f9-1f1f9":[["\uD83C\uDDF9\uD83C\uDDF9"],"Flags",1891,["flag-tt"],4,12,"2.0","country-flag"],
    "1f1f9-1f1fb":[["\uD83C\uDDF9\uD83C\uDDFB"],"Flags",1892,["flag-tv"],4,13,"2.0","country-flag"],
    "1f1f9-1f1fc":[["\uD83C\uDDF9\uD83C\uDDFC"],"Flags",1893,["flag-tw"],4,14,"2.0","country-flag"],
    "1f1f9-1f1ff":[["\uD83C\uDDF9\uD83C\uDDFF"],"Flags",1894,["flag-tz"],4,15,"2.0","country-flag"],
    "1f1fa-1f1e6":[["\uD83C\uDDFA\uD83C\uDDE6"],"Flags",1895,["flag-ua"],4,16,"2.0","country-flag"],
    "1f1fa-1f1ec":[["\uD83C\uDDFA\uD83C\uDDEC"],"Flags",1896,["flag-ug"],4,17,"2.0","country-flag"],
    "1f1fa-1f1f2":[["\uD83C\uDDFA\uD83C\uDDF2"],"Flags",1897,["flag-um"],4,18,"2.0","country-flag"],
    "1f1fa-1f1f3":[["\uD83C\uDDFA\uD83C\uDDF3"],"Flags",1898,["flag-un"],4,19,"4.0","country-flag"],
    "1f1fa-1f1f8":[["\uD83C\uDDFA\uD83C\uDDF8"],"Flags",1899,["us","flag-us"],4,20,"0.6","country-flag"],
    "1f1fa-1f1fe":[["\uD83C\uDDFA\uD83C\uDDFE"],"Flags",1900,["flag-uy"],4,21,"2.0","country-flag"],
    "1f1fa-1f1ff":[["\uD83C\uDDFA\uD83C\uDDFF"],"Flags",1901,["flag-uz"],4,22,"2.0","country-flag"],
    "1f1fb-1f1e6":[["\uD83C\uDDFB\uD83C\uDDE6"],"Flags",1902,["flag-va"],4,23,"2.0","country-flag"],
    "1f1fb-1f1e8":[["\uD83C\uDDFB\uD83C\uDDE8"],"Flags",1903,["flag-vc"],4,24,"2.0","country-flag"],
    "1f1fb-1f1ea":[["\uD83C\uDDFB\uD83C\uDDEA"],"Flags",1904,["flag-ve"],4,25,"2.0","country-flag"],
    "1f1fb-1f1ec":[["\uD83C\uDDFB\uD83C\uDDEC"],"Flags",1905,["flag-vg"],4,26,"2.0","country-flag"],
    "1f1fb-1f1ee":[["\uD83C\uDDFB\uD83C\uDDEE"],"Flags",1906,["flag-vi"],4,27,"2.0","country-flag"],
    "1f1fb-1f1f3":[["\uD83C\uDDFB\uD83C\uDDF3"],"Flags",1907,["flag-vn"],4,28,"2.0","country-flag"],
    "1f1fb-1f1fa":[["\uD83C\uDDFB\uD83C\uDDFA"],"Flags",1908,["flag-vu"],4,29,"2.0","country-flag"],
    "1f1fc-1f1eb":[["\uD83C\uDDFC\uD83C\uDDEB"],"Flags",1909,["flag-wf"],4,30,"2.0","country-flag"],
    "1f1fc-1f1f8":[["\uD83C\uDDFC\uD83C\uDDF8"],"Flags",1910,["flag-ws"],4,31,"2.0","country-flag"],
    "1f1fd-1f1f0":[["\uD83C\uDDFD\uD83C\uDDF0"],"Flags",1911,["flag-xk"],4,32,"2.0","country-flag"],
    "1f1fe-1f1ea":[["\uD83C\uDDFE\uD83C\uDDEA"],"Flags",1912,["flag-ye"],4,33,"2.0","country-flag"],
    "1f1fe-1f1f9":[["\uD83C\uDDFE\uD83C\uDDF9"],"Flags",1913,["flag-yt"],4,34,"2.0","country-flag"],
    "1f1ff-1f1e6":[["\uD83C\uDDFF\uD83C\uDDE6"],"Flags",1914,["flag-za"],4,35,"2.0","country-flag"],
    "1f1ff-1f1f2":[["\uD83C\uDDFF\uD83C\uDDF2"],"Flags",1915,["flag-zm"],4,36,"2.0","country-flag"],
    "1f1ff-1f1fc":[["\uD83C\uDDFF\uD83C\uDDFC"],"Flags",1916,["flag-zw"],4,37,"2.0","country-flag"],
    "1f201":[["\uD83C\uDE01"],"Symbols",1599,["koko"],4,38,"0.6","alphanum"],
    "1f202-fe0f":[["\uD83C\uDE02\uFE0F"],"Symbols",1600,["sa"],4,39,"0.6","alphanum"],
    "1f21a":[["\uD83C\uDE1A"],"Symbols",1606,["u7121"],4,40,"0.6","alphanum"],
    "1f22f":[["\uD83C\uDE2F"],"Symbols",1603,["u6307"],4,41,"0.6","alphanum"],
    "1f232":[["\uD83C\uDE32"],"Symbols",1607,["u7981"],4,42,"0.6","alphanum"],
    "1f233":[["\uD83C\uDE33"],"Symbols",1611,["u7a7a"],4,43,"0.6","alphanum"],
    "1f234":[["\uD83C\uDE34"],"Symbols",1610,["u5408"],4,44,"0.6","alphanum"],
    "1f235":[["\uD83C\uDE35"],"Symbols",1615,["u6e80"],4,45,"0.6","alphanum"],
    "1f236":[["\uD83C\uDE36"],"Symbols",1602,["u6709"],4,46,"0.6","alphanum"],
    "1f237-fe0f":[["\uD83C\uDE37\uFE0F"],"Symbols",1601,["u6708"],4,47,"0.6","alphanum"],
    "1f238":[["\uD83C\uDE38"],"Symbols",1609,["u7533"],4,48,"0.6","alphanum"],
    "1f239":[["\uD83C\uDE39"],"Symbols",1605,["u5272"],4,49,"0.6","alphanum"],
    "1f23a":[["\uD83C\uDE3A"],"Symbols",1614,["u55b6"],4,50,"0.6","alphanum"],
    "1f250":[["\uD83C\uDE50"],"Symbols",1604,["ideograph_advantage"],4,51,"0.6","alphanum"],
    "1f251":[["\uD83C\uDE51"],"Symbols",1608,["accept"],4,52,"0.6","alphanum"],
    "1f300":[["\uD83C\uDF00"],"Travel & Places",1061,["cyclone"],4,53,"0.6","sky & weather"],
    "1f301":[["\uD83C\uDF01"],"Travel & Places",908,["foggy"],4,54,"0.6","place-other"],
    "1f302":[["\uD83C\uDF02"],"Travel & Places",1063,["closed_umbrella"],4,55,"0.6","sky & weather"],
    "1f303":[["\uD83C\uDF03"],"Travel & Places",909,["night_with_stars"],4,56,"0.6","place-other"],
    "1f304":[["\uD83C\uDF04"],"Travel & Places",911,["sunrise_over_mountains"],4,57,"0.6","place-other"],
    "1f305":[["\uD83C\uDF05"],"Travel & Places",912,["sunrise"],4,58,"0.6","place-other"],
    "1f306":[["\uD83C\uDF06"],"Travel & Places",913,["city_sunset"],4,59,"0.6","place-other"],
    "1f307":[["\uD83C\uDF07"],"Travel & Places",914,["city_sunrise"],4,60,"0.6","place-other"],
    "1f308":[["\uD83C\uDF08"],"Travel & Places",1062,["rainbow"],4,61,"0.6","sky & weather"],
    "1f309":[["\uD83C\uDF09"],"Travel & Places",915,["bridge_at_night"],4,62,"0.6","place-other"],
    "1f30a":[["\uD83C\uDF0A"],"Travel & Places",1074,["ocean"],5,0,"0.6","sky & weather"],
    "1f30b":[["\uD83C\uDF0B"],"Travel & Places",866,["volcano"],5,1,"0.6","place-geographic"],
    "1f30c":[["\uD83C\uDF0C"],"Travel & Places",1048,["milky_way"],5,2,"0.6","sky & weather"],
    "1f30d":[["\uD83C\uDF0D"],"Travel & Places",856,["earth_africa"],5,3,"0.7","place-map"],
    "1f30e":[["\uD83C\uDF0E"],"Travel & Places",857,["earth_americas"],5,4,"0.7","place-map"],
    "1f30f":[["\uD83C\uDF0F"],"Travel & Places",858,["earth_asia"],5,5,"0.6","place-map"],
    "1f310":[["\uD83C\uDF10"],"Travel & Places",859,["globe_with_meridians"],5,6,"1.0","place-map"],
    "1f311":[["\uD83C\uDF11"],"Travel & Places",1028,["new_moon"],5,7,"0.6","sky & weather"],
    "1f312":[["\uD83C\uDF12"],"Travel & Places",1029,["waxing_crescent_moon"],5,8,"1.0","sky & weather"],
    "1f313":[["\uD83C\uDF13"],"Travel & Places",1030,["first_quarter_moon"],5,9,"0.6","sky & weather"],
    "1f314":[["\uD83C\uDF14"],"Travel & Places",1031,["moon","waxing_gibbous_moon"],5,10,"0.6","sky & weather"],
    "1f315":[["\uD83C\uDF15"],"Travel & Places",1032,["full_moon"],5,11,"0.6","sky & weather"],
    "1f316":[["\uD83C\uDF16"],"Travel & Places",1033,["waning_gibbous_moon"],5,12,"1.0","sky & weather"],
    "1f317":[["\uD83C\uDF17"],"Travel & Places",1034,["last_quarter_moon"],5,13,"1.0","sky & weather"],
    "1f318":[["\uD83C\uDF18"],"Travel & Places",1035,["waning_crescent_moon"],5,14,"1.0","sky & weather"],
    "1f319":[["\uD83C\uDF19"],"Travel & Places",1036,["crescent_moon"],5,15,"0.6","sky & weather"],
    "1f31a":[["\uD83C\uDF1A"],"Travel & Places",1037,["new_moon_with_face"],5,16,"1.0","sky & weather"],
    "1f31b":[["\uD83C\uDF1B"],"Travel & Places",1038,["first_quarter_moon_with_face"],5,17,"0.6","sky & weather"],
    "1f31c":[["\uD83C\uDF1C"],"Travel & Places",1039,["last_quarter_moon_with_face"],5,18,"0.7","sky & weather"],
    "1f31d":[["\uD83C\uDF1D"],"Travel & Places",1042,["full_moon_with_face"],5,19,"1.0","sky & weather"],
    "1f31e":[["\uD83C\uDF1E"],"Travel & Places",1043,["sun_with_face"],5,20,"1.0","sky & weather"],
    "1f31f":[["\uD83C\uDF1F"],"Travel & Places",1046,["star2"],5,21,"0.6","sky & weather"],
    "1f320":[["\uD83C\uDF20"],"Travel & Places",1047,["stars"],5,22,"0.6","sky & weather"],
    "1f321-fe0f":[["\uD83C\uDF21\uFE0F"],"Travel & Places",1040,["thermometer"],5,23,"0.7","sky & weather"],
    "1f324-fe0f":[["\uD83C\uDF24\uFE0F"],"Travel & Places",1052,["mostly_sunny","sun_small_cloud"],5,24,"0.7","sky & weather"],
    "1f325-fe0f":[["\uD83C\uDF25\uFE0F"],"Travel & Places",1053,["barely_sunny","sun_behind_cloud"],5,25,"0.7","sky & weather"],
    "1f326-fe0f":[["\uD83C\uDF26\uFE0F"],"Travel & Places",1054,["partly_sunny_rain","sun_behind_rain_cloud"],5,26,"0.7","sky & weather"],
    "1f327-fe0f":[["\uD83C\uDF27\uFE0F"],"Travel & Places",1055,["rain_cloud"],5,27,"0.7","sky & weather"],
    "1f328-fe0f":[["\uD83C\uDF28\uFE0F"],"Travel & Places",1056,["snow_cloud"],5,28,"0.7","sky & weather"],
    "1f329-fe0f":[["\uD83C\uDF29\uFE0F"],"Travel & Places",1057,["lightning","lightning_cloud"],5,29,"0.7","sky & weather"],
    "1f32a-fe0f":[["\uD83C\uDF2A\uFE0F"],"Travel & Places",1058,["tornado","tornado_cloud"],5,30,"0.7","sky & weather"],
    "1f32b-fe0f":[["\uD83C\uDF2B\uFE0F"],"Travel & Places",1059,["fog"],5,31,"0.7","sky & weather"],
    "1f32c-fe0f":[["\uD83C\uDF2C\uFE0F"],"Travel & Places",1060,["wind_blowing_face"],5,32,"0.7","sky & weather"],
    "1f32d":[["\uD83C\uDF2D"],"Food & Drink",780,["hotdog"],5,33,"1.0","food-prepared"],
    "1f32e":[["\uD83C\uDF2E"],"Food & Drink",782,["taco"],5,34,"1.0","food-prepared"],
    "1f32f":[["\uD83C\uDF2F"],"Food & Drink",783,["burrito"],5,35,"1.0","food-prepared"],
    "1f330":[["\uD83C\uDF30"],"Food & Drink",759,["chestnut"],5,36,"0.6","food-vegetable"],
    "1f331":[["\uD83C\uDF31"],"Animals & Nature",708,["seedling"],5,37,"0.6","plant-other"],
    "1f332":[["\uD83C\uDF32"],"Animals & Nature",710,["evergreen_tree"],5,38,"1.0","plant-other"],
    "1f333":[["\uD83C\uDF33"],"Animals & Nature",711,["deciduous_tree"],5,39,"1.0","plant-other"],
    "1f334":[["\uD83C\uDF34"],"Animals & Nature",712,["palm_tree"],5,40,"0.6","plant-other"],
    "1f335":[["\uD83C\uDF35"],"Animals & Nature",713,["cactus"],5,41,"0.6","plant-other"],
    "1f336-fe0f":[["\uD83C\uDF36\uFE0F"],"Food & Drink",750,["hot_pepper"],5,42,"0.7","food-vegetable"],
    "1f337":[["\uD83C\uDF37"],"Animals & Nature",706,["tulip"],5,43,"0.6","plant-flower"],
    "1f338":[["\uD83C\uDF38"],"Animals & Nature",697,["cherry_blossom"],5,44,"0.6","plant-flower"],
    "1f339":[["\uD83C\uDF39"],"Animals & Nature",701,["rose"],5,45,"0.6","plant-flower"],
    "1f33a":[["\uD83C\uDF3A"],"Animals & Nature",703,["hibiscus"],5,46,"0.6","plant-flower"],
    "1f33b":[["\uD83C\uDF3B"],"Animals & Nature",704,["sunflower"],5,47,"0.6","plant-flower"],
    "1f33c":[["\uD83C\uDF3C"],"Animals & Nature",705,["blossom"],5,48,"0.6","plant-flower"],
    "1f33d":[["\uD83C\uDF3D"],"Food & Drink",749,["corn"],5,49,"0.6","food-vegetable"],
    "1f33e":[["\uD83C\uDF3E"],"Animals & Nature",714,["ear_of_rice"],5,50,"0.6","plant-other"],
    "1f33f":[["\uD83C\uDF3F"],"Animals & Nature",715,["herb"],5,51,"0.6","plant-other"],
    "1f340":[["\uD83C\uDF40"],"Animals & Nature",717,["four_leaf_clover"],5,52,"0.6","plant-other"],
    "1f341":[["\uD83C\uDF41"],"Animals & Nature",718,["maple_leaf"],5,53,"0.6","plant-other"],
    "1f342":[["\uD83C\uDF42"],"Animals & Nature",719,["fallen_leaf"],5,54,"0.6","plant-other"],
    "1f343":[["\uD83C\uDF43"],"Animals & Nature",720,["leaves"],5,55,"0.6","plant-other"],
    "1f344-200d-1f7eb":[["\uD83C\uDF44\u200D\uD83D\uDFEB"],"Food & Drink",762,["brown_mushroom"],5,56,"15.1","food-vegetable"],
    "1f344":[["\uD83C\uDF44"],"Animals & Nature",723,["mushroom"],5,57,"0.6","plant-other"],
    "1f345":[["\uD83C\uDF45"],"Food & Drink",742,["tomato"],5,58,"0.6","food-fruit"],
    "1f346":[["\uD83C\uDF46"],"Food & Drink",746,["eggplant"],5,59,"0.6","food-vegetable"],
    "1f347":[["\uD83C\uDF47"],"Food & Drink",725,["grapes"],5,60,"0.6","food-fruit"],
    "1f348":[["\uD83C\uDF48"],"Food & Drink",726,["melon"],5,61,"0.6","food-fruit"],
    "1f349":[["\uD83C\uDF49"],"Food & Drink",727,["watermelon"],5,62,"0.6","food-fruit"],
    "1f34a":[["\uD83C\uDF4A"],"Food & Drink",728,["tangerine"],6,0,"0.6","food-fruit"],
    "1f34b-200d-1f7e9":[["\uD83C\uDF4B\u200D\uD83D\uDFE9"],"Food & Drink",730,["lime"],6,1,"15.1","food-fruit"],
    "1f34b":[["\uD83C\uDF4B"],"Food & Drink",729,["lemon"],6,2,"1.0","food-fruit"],
    "1f34c":[["\uD83C\uDF4C"],"Food & Drink",731,["banana"],6,3,"0.6","food-fruit"],
    "1f34d":[["\uD83C\uDF4D"],"Food & Drink",732,["pineapple"],6,4,"0.6","food-fruit"],
    "1f34e":[["\uD83C\uDF4E"],"Food & Drink",734,["apple"],6,5,"0.6","food-fruit"],
    "1f34f":[["\uD83C\uDF4F"],"Food & Drink",735,["green_apple"],6,6,"0.6","food-fruit"],
    "1f350":[["\uD83C\uDF50"],"Food & Drink",736,["pear"],6,7,"1.0","food-fruit"],
    "1f351":[["\uD83C\uDF51"],"Food & Drink",737,["peach"],6,8,"0.6","food-fruit"],
    "1f352":[["\uD83C\uDF52"],"Food & Drink",738,["cherries"],6,9,"0.6","food-fruit"],
    "1f353":[["\uD83C\uDF53"],"Food & Drink",739,["strawberry"],6,10,"0.6","food-fruit"],
    "1f354":[["\uD83C\uDF54"],"Food & Drink",777,["hamburger"],6,11,"0.6","food-prepared"],
    "1f355":[["\uD83C\uDF55"],"Food & Drink",779,["pizza"],6,12,"0.6","food-prepared"],
    "1f356":[["\uD83C\uDF56"],"Food & Drink",773,["meat_on_bone"],6,13,"0.6","food-prepared"],
    "1f357":[["\uD83C\uDF57"],"Food & Drink",774,["poultry_leg"],6,14,"0.6","food-prepared"],
    "1f358":[["\uD83C\uDF58"],"Food & Drink",799,["rice_cracker"],6,15,"0.6","food-asian"],
    "1f359":[["\uD83C\uDF59"],"Food & Drink",800,["rice_ball"],6,16,"0.6","food-asian"],
    "1f35a":[["\uD83C\uDF5A"],"Food & Drink",801,["rice"],6,17,"0.6","food-asian"],
    "1f35b":[["\uD83C\uDF5B"],"Food & Drink",802,["curry"],6,18,"0.6","food-asian"],
    "1f35c":[["\uD83C\uDF5C"],"Food & Drink",803,["ramen"],6,19,"0.6","food-asian"],
    "1f35d":[["\uD83C\uDF5D"],"Food & Drink",804,["spaghetti"],6,20,"0.6","food-asian"],
    "1f35e":[["\uD83C\uDF5E"],"Food & Drink",764,["bread"],6,21,"0.6","food-prepared"],
    "1f35f":[["\uD83C\uDF5F"],"Food & Drink",778,["fries"],6,22,"0.6","food-prepared"],
    "1f360":[["\uD83C\uDF60"],"Food & Drink",805,["sweet_potato"],6,23,"0.6","food-asian"],
    "1f361":[["\uD83C\uDF61"],"Food & Drink",811,["dango"],6,24,"0.6","food-asian"],
    "1f362":[["\uD83C\uDF62"],"Food & Drink",806,["oden"],6,25,"0.6","food-asian"],
    "1f363":[["\uD83C\uDF63"],"Food & Drink",807,["sushi"],6,26,"0.6","food-asian"],
    "1f364":[["\uD83C\uDF64"],"Food & Drink",808,["fried_shrimp"],6,27,"0.6","food-asian"],
    "1f365":[["\uD83C\uDF65"],"Food & Drink",809,["fish_cake"],6,28,"0.6","food-asian"],
    "1f366":[["\uD83C\uDF66"],"Food & Drink",815,["icecream"],6,29,"0.6","food-sweet"],
    "1f367":[["\uD83C\uDF67"],"Food & Drink",816,["shaved_ice"],6,30,"0.6","food-sweet"],
    "1f368":[["\uD83C\uDF68"],"Food & Drink",817,["ice_cream"],6,31,"0.6","food-sweet"],
    "1f369":[["\uD83C\uDF69"],"Food & Drink",818,["doughnut"],6,32,"0.6","food-sweet"],
    "1f36a":[["\uD83C\uDF6A"],"Food & Drink",819,["cookie"],6,33,"0.6","food-sweet"],
    "1f36b":[["\uD83C\uDF6B"],"Food & Drink",824,["chocolate_bar"],6,34,"0.6","food-sweet"],
    "1f36c":[["\uD83C\uDF6C"],"Food & Drink",825,["candy"],6,35,"0.6","food-sweet"],
    "1f36d":[["\uD83C\uDF6D"],"Food & Drink",826,["lollipop"],6,36,"0.6","food-sweet"],
    "1f36e":[["\uD83C\uDF6E"],"Food & Drink",827,["custard"],6,37,"0.6","food-sweet"],
    "1f36f":[["\uD83C\uDF6F"],"Food & Drink",828,["honey_pot"],6,38,"0.6","food-sweet"],
    "1f370":[["\uD83C\uDF70"],"Food & Drink",821,["cake"],6,39,"0.6","food-sweet"],
    "1f371":[["\uD83C\uDF71"],"Food & Drink",798,["bento"],6,40,"0.6","food-asian"],
    "1f372":[["\uD83C\uDF72"],"Food & Drink",790,["stew"],6,41,"0.6","food-prepared"],
    "1f373":[["\uD83C\uDF73"],"Food & Drink",788,["fried_egg","cooking"],6,42,"0.6","food-prepared"],
    "1f374":[["\uD83C\uDF74"],"Food & Drink",851,["fork_and_knife"],6,43,"0.6","dishware"],
    "1f375":[["\uD83C\uDF75"],"Food & Drink",833,["tea"],6,44,"0.6","drink"],
    "1f376":[["\uD83C\uDF76"],"Food & Drink",834,["sake"],6,45,"0.6","drink"],
    "1f377":[["\uD83C\uDF77"],"Food & Drink",836,["wine_glass"],6,46,"0.6","drink"],
    "1f378":[["\uD83C\uDF78"],"Food & Drink",837,["cocktail"],6,47,"0.6","drink"],
    "1f379":[["\uD83C\uDF79"],"Food & Drink",838,["tropical_drink"],6,48,"0.6","drink"],
    "1f37a":[["\uD83C\uDF7A"],"Food & Drink",839,["beer"],6,49,"0.6","drink"],
    "1f37b":[["\uD83C\uDF7B"],"Food & Drink",840,["beers"],6,50,"0.6","drink"],
    "1f37c":[["\uD83C\uDF7C"],"Food & Drink",829,["baby_bottle"],6,51,"1.0","drink"],
    "1f37d-fe0f":[["\uD83C\uDF7D\uFE0F"],"Food & Drink",850,["knife_fork_plate"],6,52,"0.7","dishware"],
    "1f37e":[["\uD83C\uDF7E"],"Food & Drink",835,["champagne"],6,53,"1.0","drink"],
    "1f37f":[["\uD83C\uDF7F"],"Food & Drink",794,["popcorn"],6,54,"1.0","food-prepared"],
    "1f380":[["\uD83C\uDF80"],"Activities",1091,["ribbon"],6,55,"0.6","event"],
    "1f381":[["\uD83C\uDF81"],"Activities",1092,["gift"],6,56,"0.6","event"],
    "1f382":[["\uD83C\uDF82"],"Food & Drink",820,["birthday"],6,57,"0.6","food-sweet"],
    "1f383":[["\uD83C\uDF83"],"Activities",1075,["jack_o_lantern"],6,58,"0.6","event"],
    "1f384":[["\uD83C\uDF84"],"Activities",1076,["christmas_tree"],6,59,"0.6","event"],
    "1f385":[["\uD83C\uDF85"],"People & Body",374,["santa"],6,60,"0.6","person-fantasy"],
    "1f386":[["\uD83C\uDF86"],"Activities",1077,["fireworks"],7,3,"0.6","event"],
    "1f387":[["\uD83C\uDF87"],"Activities",1078,["sparkler"],7,4,"0.6","event"],
    "1f388":[["\uD83C\uDF88"],"Activities",1081,["balloon"],7,5,"0.6","event"],
    "1f389":[["\uD83C\uDF89"],"Activities",1082,["tada"],7,6,"0.6","event"],
    "1f38a":[["\uD83C\uDF8A"],"Activities",1083,["confetti_ball"],7,7,"0.6","event"],
    "1f38b":[["\uD83C\uDF8B"],"Activities",1084,["tanabata_tree"],7,8,"0.6","event"],
    "1f38c":[["\uD83C\uDF8C"],"Flags",1652,["crossed_flags"],7,9,"0.6","flag"],
    "1f38d":[["\uD83C\uDF8D"],"Activities",1085,["bamboo"],7,10,"0.6","event"],
    "1f38e":[["\uD83C\uDF8E"],"Activities",1086,["dolls"],7,11,"0.6","event"],
    "1f38f":[["\uD83C\uDF8F"],"Activities",1087,["flags"],7,12,"0.6","event"],
    "1f390":[["\uD83C\uDF90"],"Activities",1088,["wind_chime"],7,13,"0.6","event"],
    "1f391":[["\uD83C\uDF91"],"Activities",1089,["rice_scene"],7,14,"0.6","event"],
    "1f392":[["\uD83C\uDF92"],"Objects",1185,["school_satchel"],7,15,"0.6","clothing"],
    "1f393":[["\uD83C\uDF93"],"Objects",1199,["mortar_board"],7,16,"0.6","clothing"],
    "1f396-fe0f":[["\uD83C\uDF96\uFE0F"],"Activities",1096,["medal"],7,17,"0.7","award-medal"],
    "1f397-fe0f":[["\uD83C\uDF97\uFE0F"],"Activities",1093,["reminder_ribbon"],7,18,"0.7","event"],
    "1f399-fe0f":[["\uD83C\uDF99\uFE0F"],"Objects",1219,["studio_microphone"],7,19,"0.7","music"],
    "1f39a-fe0f":[["\uD83C\uDF9A\uFE0F"],"Objects",1220,["level_slider"],7,20,"0.7","music"],
    "1f39b-fe0f":[["\uD83C\uDF9B\uFE0F"],"Objects",1221,["control_knobs"],7,21,"0.7","music"],
    "1f39e-fe0f":[["\uD83C\uDF9E\uFE0F"],"Objects",1259,["film_frames"],7,22,"0.7","light & video"],
    "1f39f-fe0f":[["\uD83C\uDF9F\uFE0F"],"Activities",1094,["admission_tickets"],7,23,"0.7","event"],
    "1f3a0":[["\uD83C\uDFA0"],"Travel & Places",917,["carousel_horse"],7,24,"0.6","place-other"],
    "1f3a1":[["\uD83C\uDFA1"],"Travel & Places",919,["ferris_wheel"],7,25,"0.6","place-other"],
    "1f3a2":[["\uD83C\uDFA2"],"Travel & Places",920,["roller_coaster"],7,26,"0.6","place-other"],
    "1f3a3":[["\uD83C\uDFA3"],"Activities",1123,["fishing_pole_and_fish"],7,27,"0.6","sport"],
    "1f3a4":[["\uD83C\uDFA4"],"Objects",1222,["microphone"],7,28,"0.6","music"],
    "1f3a5":[["\uD83C\uDFA5"],"Objects",1258,["movie_camera"],7,29,"0.6","light & video"],
    "1f3a6":[["\uD83C\uDFA6"],"Symbols",1517,["cinema"],7,30,"0.6","av-symbol"],
    "1f3a7":[["\uD83C\uDFA7"],"Objects",1223,["headphones"],7,31,"0.6","music"],
    "1f3a8":[["\uD83C\uDFA8"],"Activities",1155,["art"],7,32,"0.6","arts & crafts"],
    "1f3a9":[["\uD83C\uDFA9"],"Objects",1198,["tophat"],7,33,"0.6","clothing"],
    "1f3aa":[["\uD83C\uDFAA"],"Travel & Places",922,["circus_tent"],7,34,"0.6","place-other"],
    "1f3ab":[["\uD83C\uDFAB"],"Activities",1095,["ticket"],7,35,"0.6","event"],
    "1f3ac":[["\uD83C\uDFAC"],"Objects",1261,["clapper"],7,36,"0.6","light & video"],
    "1f3ad":[["\uD83C\uDFAD"],"Activities",1153,["performing_arts"],7,37,"0.6","arts & crafts"],
    "1f3ae":[["\uD83C\uDFAE"],"Activities",1136,["video_game"],7,38,"0.6","game"],
    "1f3af":[["\uD83C\uDFAF"],"Activities",1129,["dart"],7,39,"0.6","game"],
    "1f3b0":[["\uD83C\uDFB0"],"Activities",1138,["slot_machine"],7,40,"0.6","game"],
    "1f3b1":[["\uD83C\uDFB1"],"Activities",1133,["8ball"],7,41,"0.6","game"],
    "1f3b2":[["\uD83C\uDFB2"],"Activities",1139,["game_die"],7,42,"0.6","game"],
    "1f3b3":[["\uD83C\uDFB3"],"Activities",1111,["bowling"],7,43,"0.6","sport"],
    "1f3b4":[["\uD83C\uDFB4"],"Activities",1152,["flower_playing_cards"],7,44,"0.6","game"],
    "1f3b5":[["\uD83C\uDFB5"],"Objects",1217,["musical_note"],7,45,"0.6","music"],
    "1f3b6":[["\uD83C\uDFB6"],"Objects",1218,["notes"],7,46,"0.6","music"],
    "1f3b7":[["\uD83C\uDFB7"],"Objects",1225,["saxophone"],7,47,"0.6","musical-instrument"],
    "1f3b8":[["\uD83C\uDFB8"],"Objects",1229,["guitar"],7,48,"0.6","musical-instrument"],
    "1f3b9":[["\uD83C\uDFB9"],"Objects",1230,["musical_keyboard"],7,49,"0.6","musical-instrument"],
    "1f3ba":[["\uD83C\uDFBA"],"Objects",1226,["trumpet"],7,50,"0.6","musical-instrument"],
    "1f3bb":[["\uD83C\uDFBB"],"Objects",1231,["violin"],7,51,"0.6","musical-instrument"],
    "1f3bc":[["\uD83C\uDFBC"],"Objects",1216,["musical_score"],7,52,"0.6","music"],
    "1f3bd":[["\uD83C\uDFBD"],"Activities",1125,["running_shirt_with_sash"],7,53,"0.6","sport"],
    "1f3be":[["\uD83C\uDFBE"],"Activities",1109,["tennis"],7,54,"0.6","sport"],
    "1f3bf":[["\uD83C\uDFBF"],"Activities",1126,["ski"],7,55,"0.6","sport"],
    "1f3c0":[["\uD83C\uDFC0"],"Activities",1105,["basketball"],7,56,"0.6","sport"],
    "1f3c1":[["\uD83C\uDFC1"],"Flags",1650,["checkered_flag"],7,57,"0.6","flag"],
    "1f3c2":[["\uD83C\uDFC2"],"People & Body",467,["snowboarder"],7,58,"0.6","person-sport"],
    "1f3c3-200d-2640-fe0f":[["\uD83C\uDFC3\u200D\u2640\uFE0F"],"People & Body",447,["woman-running"],8,1,"4.0","person-activity"],
    "1f3c3-200d-2640-fe0f-200d-27a1-fe0f":[["\uD83C\uDFC3\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"People & Body",449,["woman_running_facing_right"],8,7,"15.1","person-activity"],
    "1f3c3-200d-2642-fe0f":[["\uD83C\uDFC3\u200D\u2642\uFE0F"],"People & Body",446,["man-running"],8,13,"4.0","person-activity"],
    "1f3c3-200d-2642-fe0f-200d-27a1-fe0f":[["\uD83C\uDFC3\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"People & Body",450,["man_running_facing_right"],8,19,"15.1","person-activity"],
    "1f3c3-200d-27a1-fe0f":[["\uD83C\uDFC3\u200D\u27A1\uFE0F"],"People & Body",448,["person_running_facing_right"],8,25,"15.1","person-activity"],
    "1f3c3":[["\uD83C\uDFC3"],"People & Body",445,["runner","running"],8,31,"0.6","person-activity"],
    "1f3c4-200d-2640-fe0f":[["\uD83C\uDFC4\u200D\u2640\uFE0F"],"People & Body",473,["woman-surfing"],8,37,"4.0","person-sport"],
    "1f3c4-200d-2642-fe0f":[["\uD83C\uDFC4\u200D\u2642\uFE0F"],"People & Body",472,["man-surfing"],8,43,"4.0","person-sport"],
    "1f3c4":[["\uD83C\uDFC4"],"People & Body",471,["surfer"],8,49,"0.6","person-sport"],
    "1f3c5":[["\uD83C\uDFC5"],"Activities",1098,["sports_medal"],8,55,"1.0","award-medal"],
    "1f3c6":[["\uD83C\uDFC6"],"Activities",1097,["trophy"],8,56,"0.6","award-medal"],
    "1f3c7":[["\uD83C\uDFC7"],"People & Body",465,["horse_racing"],8,57,"1.0","person-sport"],
    "1f3c8":[["\uD83C\uDFC8"],"Activities",1107,["football"],9,0,"0.6","sport"],
    "1f3c9":[["\uD83C\uDFC9"],"Activities",1108,["rugby_football"],9,1,"1.0","sport"],
    "1f3ca-200d-2640-fe0f":[["\uD83C\uDFCA\u200D\u2640\uFE0F"],"People & Body",479,["woman-swimming"],9,2,"4.0","person-sport"],
    "1f3ca-200d-2642-fe0f":[["\uD83C\uDFCA\u200D\u2642\uFE0F"],"People & Body",478,["man-swimming"],9,8,"4.0","person-sport"],
    "1f3ca":[["\uD83C\uDFCA"],"People & Body",477,["swimmer"],9,14,"0.6","person-sport"],
    "1f3cb-fe0f-200d-2640-fe0f":[["\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F"],"People & Body",485,["woman-lifting-weights"],9,20,"4.0","person-sport"],
    "1f3cb-fe0f-200d-2642-fe0f":[["\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F"],"People & Body",484,["man-lifting-weights"],9,26,"4.0","person-sport"],
    "1f3cb-fe0f":[["\uD83C\uDFCB\uFE0F"],"People & Body",483,["weight_lifter"],9,32,"0.7","person-sport"],
    "1f3cc-fe0f-200d-2640-fe0f":[["\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F"],"People & Body",470,["woman-golfing"],9,38,"4.0","person-sport"],
    "1f3cc-fe0f-200d-2642-fe0f":[["\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F"],"People & Body",469,["man-golfing"],9,44,"4.0","person-sport"],
    "1f3cc-fe0f":[["\uD83C\uDFCC\uFE0F"],"People & Body",468,["golfer"],9,50,"0.7","person-sport"],
    "1f3cd-fe0f":[["\uD83C\uDFCD\uFE0F"],"Travel & Places",953,["racing_motorcycle"],9,56,"0.7","transport-ground"],
    "1f3ce-fe0f":[["\uD83C\uDFCE\uFE0F"],"Travel & Places",952,["racing_car"],9,57,"0.7","transport-ground"],
    "1f3cf":[["\uD83C\uDFCF"],"Activities",1112,["cricket_bat_and_ball"],9,58,"1.0","sport"],
    "1f3d0":[["\uD83C\uDFD0"],"Activities",1106,["volleyball"],9,59,"1.0","sport"],
    "1f3d1":[["\uD83C\uDFD1"],"Activities",1113,["field_hockey_stick_and_ball"],9,60,"1.0","sport"],
    "1f3d2":[["\uD83C\uDFD2"],"Activities",1114,["ice_hockey_stick_and_puck"],9,61,"1.0","sport"],
    "1f3d3":[["\uD83C\uDFD3"],"Activities",1116,["table_tennis_paddle_and_ball"],9,62,"1.0","sport"],
    "1f3d4-fe0f":[["\uD83C\uDFD4\uFE0F"],"Travel & Places",863,["snow_capped_mountain"],10,0,"0.7","place-geographic"],
    "1f3d5-fe0f":[["\uD83C\uDFD5\uFE0F"],"Travel & Places",868,["camping"],10,1,"0.7","place-geographic"],
    "1f3d6-fe0f":[["\uD83C\uDFD6\uFE0F"],"Travel & Places",869,["beach_with_umbrella"],10,2,"0.7","place-geographic"],
    "1f3d7-fe0f":[["\uD83C\uDFD7\uFE0F"],"Travel & Places",875,["building_construction"],10,3,"0.7","place-building"],
    "1f3d8-fe0f":[["\uD83C\uDFD8\uFE0F"],"Travel & Places",880,["house_buildings"],10,4,"0.7","place-building"],
    "1f3d9-fe0f":[["\uD83C\uDFD9\uFE0F"],"Travel & Places",910,["cityscape"],10,5,"0.7","place-other"],
    "1f3da-fe0f":[["\uD83C\uDFDA\uFE0F"],"Travel & Places",881,["derelict_house_building"],10,6,"0.7","place-building"],
    "1f3db-fe0f":[["\uD83C\uDFDB\uFE0F"],"Travel & Places",874,["classical_building"],10,7,"0.7","place-building"],
    "1f3dc-fe0f":[["\uD83C\uDFDC\uFE0F"],"Travel & Places",870,["desert"],10,8,"0.7","place-geographic"],
    "1f3dd-fe0f":[["\uD83C\uDFDD\uFE0F"],"Travel & Places",871,["desert_island"],10,9,"0.7","place-geographic"],
    "1f3de-fe0f":[["\uD83C\uDFDE\uFE0F"],"Travel & Places",872,["national_park"],10,10,"0.7","place-geographic"],
    "1f3df-fe0f":[["\uD83C\uDFDF\uFE0F"],"Travel & Places",873,["stadium"],10,11,"0.7","place-building"],
    "1f3e0":[["\uD83C\uDFE0"],"Travel & Places",882,["house"],10,12,"0.6","place-building"],
    "1f3e1":[["\uD83C\uDFE1"],"Travel & Places",883,["house_with_garden"],10,13,"0.6","place-building"],
    "1f3e2":[["\uD83C\uDFE2"],"Travel & Places",884,["office"],10,14,"0.6","place-building"],
    "1f3e3":[["\uD83C\uDFE3"],"Travel & Places",885,["post_office"],10,15,"0.6","place-building"],
    "1f3e4":[["\uD83C\uDFE4"],"Travel & Places",886,["european_post_office"],10,16,"1.0","place-building"],
    "1f3e5":[["\uD83C\uDFE5"],"Travel & Places",887,["hospital"],10,17,"0.6","place-building"],
    "1f3e6":[["\uD83C\uDFE6"],"Travel & Places",888,["bank"],10,18,"0.6","place-building"],
    "1f3e7":[["\uD83C\uDFE7"],"Symbols",1426,["atm"],10,19,"0.6","transport-sign"],
    "1f3e8":[["\uD83C\uDFE8"],"Travel & Places",889,["hotel"],10,20,"0.6","place-building"],
    "1f3e9":[["\uD83C\uDFE9"],"Travel & Places",890,["love_hotel"],10,21,"0.6","place-building"],
    "1f3ea":[["\uD83C\uDFEA"],"Travel & Places",891,["convenience_store"],10,22,"0.6","place-building"],
    "1f3eb":[["\uD83C\uDFEB"],"Travel & Places",892,["school"],10,23,"0.6","place-building"],
    "1f3ec":[["\uD83C\uDFEC"],"Travel & Places",893,["department_store"],10,24,"0.6","place-building"],
    "1f3ed":[["\uD83C\uDFED"],"Travel & Places",894,["factory"],10,25,"0.6","place-building"],
    "1f3ee":[["\uD83C\uDFEE"],"Objects",1272,["izakaya_lantern","lantern"],10,26,"0.6","light & video"],
    "1f3ef":[["\uD83C\uDFEF"],"Travel & Places",895,["japanese_castle"],10,27,"0.6","place-building"],
    "1f3f0":[["\uD83C\uDFF0"],"Travel & Places",896,["european_castle"],10,28,"0.6","place-building"],
    "1f3f3-fe0f-200d-1f308":[["\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08"],"Flags",1655,["rainbow-flag"],10,29,"4.0","flag"],
    "1f3f3-fe0f-200d-26a7-fe0f":[["\uD83C\uDFF3\uFE0F\u200D\u26A7\uFE0F"],"Flags",1656,["transgender_flag"],10,30,"13.0","flag"],
    "1f3f3-fe0f":[["\uD83C\uDFF3\uFE0F"],"Flags",1654,["waving_white_flag"],10,31,"0.7","flag"],
    "1f3f4-200d-2620-fe0f":[["\uD83C\uDFF4\u200D\u2620\uFE0F"],"Flags",1657,["pirate_flag"],10,32,"11.0","flag"],
    "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f":[["\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F"],"Flags",1917,["flag-england"],10,33,"5.0","subdivision-flag"],
    "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f":[["\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F"],"Flags",1918,["flag-scotland"],10,34,"5.0","subdivision-flag"],
    "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f":[["\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F"],"Flags",1919,["flag-wales"],10,35,"5.0","subdivision-flag"],
    "1f3f4":[["\uD83C\uDFF4"],"Flags",1653,["waving_black_flag"],10,36,"1.0","flag"],
    "1f3f5-fe0f":[["\uD83C\uDFF5\uFE0F"],"Animals & Nature",700,["rosette"],10,37,"0.7","plant-flower"],
    "1f3f7-fe0f":[["\uD83C\uDFF7\uFE0F"],"Objects",1290,["label"],10,38,"0.7","book-paper"],
    "1f3f8":[["\uD83C\uDFF8"],"Activities",1117,["badminton_racquet_and_shuttlecock"],10,39,"1.0","sport"],
    "1f3f9":[["\uD83C\uDFF9"],"Objects",1360,["bow_and_arrow"],10,40,"1.0","tool"],
    "1f3fa":[["\uD83C\uDFFA"],"Food & Drink",855,["amphora"],10,41,"1.0","dishware"],
    "1f3fb":[["\uD83C\uDFFB"],"Component",560,["skin-tone-2"],10,42,"1.0","skin-tone"],
    "1f3fc":[["\uD83C\uDFFC"],"Component",561,["skin-tone-3"],10,43,"1.0","skin-tone"],
    "1f3fd":[["\uD83C\uDFFD"],"Component",562,["skin-tone-4"],10,44,"1.0","skin-tone"],
    "1f3fe":[["\uD83C\uDFFE"],"Component",563,["skin-tone-5"],10,45,"1.0","skin-tone"],
    "1f3ff":[["\uD83C\uDFFF"],"Component",564,["skin-tone-6"],10,46,"1.0","skin-tone"],
    "1f400":[["\uD83D\uDC00"],"Animals & Nature",613,["rat"],10,47,"1.0","animal-mammal"],
    "1f401":[["\uD83D\uDC01"],"Animals & Nature",612,["mouse2"],10,48,"1.0","animal-mammal"],
    "1f402":[["\uD83D\uDC02"],"Animals & Nature",593,["ox"],10,49,"1.0","animal-mammal"],
    "1f403":[["\uD83D\uDC03"],"Animals & Nature",594,["water_buffalo"],10,50,"1.0","animal-mammal"],
    "1f404":[["\uD83D\uDC04"],"Animals & Nature",595,["cow2"],10,51,"1.0","animal-mammal"],
    "1f405":[["\uD83D\uDC05"],"Animals & Nature",582,["tiger2"],10,52,"1.0","animal-mammal"],
    "1f406":[["\uD83D\uDC06"],"Animals & Nature",583,["leopard"],10,53,"1.0","animal-mammal"],
    "1f407":[["\uD83D\uDC07"],"Animals & Nature",616,["rabbit2"],10,54,"1.0","animal-mammal"],
    "1f408-200d-2b1b":[["\uD83D\uDC08\u200D\u2B1B"],"Animals & Nature",579,["black_cat"],10,55,"13.0","animal-mammal"],
    "1f408":[["\uD83D\uDC08"],"Animals & Nature",578,["cat2"],10,56,"0.7","animal-mammal"],
    "1f409":[["\uD83D\uDC09"],"Animals & Nature",659,["dragon"],10,57,"1.0","animal-reptile"],
    "1f40a":[["\uD83D\uDC0A"],"Animals & Nature",654,["crocodile"],10,58,"1.0","animal-reptile"],
    "1f40b":[["\uD83D\uDC0B"],"Animals & Nature",663,["whale2"],10,59,"1.0","animal-marine"],
    "1f40c":[["\uD83D\uDC0C"],"Animals & Nature",680,["snail"],10,60,"0.6","animal-bug"],
    "1f40d":[["\uD83D\uDC0D"],"Animals & Nature",657,["snake"],10,61,"0.6","animal-reptile"],
    "1f40e":[["\uD83D\uDC0E"],"Animals & Nature",587,["racehorse"],10,62,"0.6","animal-mammal"],
    "1f40f":[["\uD83D\uDC0F"],"Animals & Nature",600,["ram"],11,0,"1.0","animal-mammal"],
    "1f410":[["\uD83D\uDC10"],"Animals & Nature",602,["goat"],11,1,"1.0","animal-mammal"],
    "1f411":[["\uD83D\uDC11"],"Animals & Nature",601,["sheep"],11,2,"0.6","animal-mammal"],
    "1f412":[["\uD83D\uDC12"],"Animals & Nature",566,["monkey"],11,3,"0.6","animal-mammal"],
    "1f413":[["\uD83D\uDC13"],"Animals & Nature",633,["rooster"],11,4,"1.0","animal-bird"],
    "1f414":[["\uD83D\uDC14"],"Animals & Nature",632,["chicken"],11,5,"0.6","animal-bird"],
    "1f415-200d-1f9ba":[["\uD83D\uDC15\u200D\uD83E\uDDBA"],"Animals & Nature",572,["service_dog"],11,6,"12.0","animal-mammal"],
    "1f415":[["\uD83D\uDC15"],"Animals & Nature",570,["dog2"],11,7,"0.7","animal-mammal"],
    "1f416":[["\uD83D\uDC16"],"Animals & Nature",597,["pig2"],11,8,"1.0","animal-mammal"],
    "1f417":[["\uD83D\uDC17"],"Animals & Nature",598,["boar"],11,9,"0.6","animal-mammal"],
    "1f418":[["\uD83D\uDC18"],"Animals & Nature",607,["elephant"],11,10,"0.6","animal-mammal"],
    "1f419":[["\uD83D\uDC19"],"Animals & Nature",671,["octopus"],11,11,"0.6","animal-marine"],
    "1f41a":[["\uD83D\uDC1A"],"Animals & Nature",672,["shell"],11,12,"0.6","animal-marine"],
    "1f41b":[["\uD83D\uDC1B"],"Animals & Nature",682,["bug"],11,13,"0.6","animal-bug"],
    "1f41c":[["\uD83D\uDC1C"],"Animals & Nature",683,["ant"],11,14,"0.6","animal-bug"],
    "1f41d":[["\uD83D\uDC1D"],"Animals & Nature",684,["bee","honeybee"],11,15,"0.6","animal-bug"],
    "1f41e":[["\uD83D\uDC1E"],"Animals & Nature",686,["ladybug","lady_beetle"],11,16,"0.6","animal-bug"],
    "1f41f":[["\uD83D\uDC1F"],"Animals & Nature",667,["fish"],11,17,"0.6","animal-marine"],
    "1f420":[["\uD83D\uDC20"],"Animals & Nature",668,["tropical_fish"],11,18,"0.6","animal-marine"],
    "1f421":[["\uD83D\uDC21"],"Animals & Nature",669,["blowfish"],11,19,"0.6","animal-marine"],
    "1f422":[["\uD83D\uDC22"],"Animals & Nature",655,["turtle"],11,20,"0.6","animal-reptile"],
    "1f423":[["\uD83D\uDC23"],"Animals & Nature",634,["hatching_chick"],11,21,"0.6","animal-bird"],
    "1f424":[["\uD83D\uDC24"],"Animals & Nature",635,["baby_chick"],11,22,"0.6","animal-bird"],
    "1f425":[["\uD83D\uDC25"],"Animals & Nature",636,["hatched_chick"],11,23,"0.6","animal-bird"],
    "1f426-200d-1f525":[["\uD83D\uDC26\u200D\uD83D\uDD25"],"Animals & Nature",652,["phoenix"],11,24,"15.1","animal-bird"],
    "1f426-200d-2b1b":[["\uD83D\uDC26\u200D\u2B1B"],"Animals & Nature",650,["black_bird"],11,25,"15.0","animal-bird"],
    "1f426":[["\uD83D\uDC26"],"Animals & Nature",637,["bird"],11,26,"0.6","animal-bird"],
    "1f427":[["\uD83D\uDC27"],"Animals & Nature",638,["penguin"],11,27,"0.6","animal-bird"],
    "1f428":[["\uD83D\uDC28"],"Animals & Nature",623,["koala"],11,28,"0.6","animal-mammal"],
    "1f429":[["\uD83D\uDC29"],"Animals & Nature",573,["poodle"],11,29,"0.6","animal-mammal"],
    "1f42a":[["\uD83D\uDC2A"],"Animals & Nature",603,["dromedary_camel"],11,30,"1.0","animal-mammal"],
    "1f42b":[["\uD83D\uDC2B"],"Animals & Nature",604,["camel"],11,31,"0.6","animal-mammal"],
    "1f42c":[["\uD83D\uDC2C"],"Animals & Nature",664,["dolphin","flipper"],11,32,"0.6","animal-marine"],
    "1f42d":[["\uD83D\uDC2D"],"Animals & Nature",611,["mouse"],11,33,"0.6","animal-mammal"],
    "1f42e":[["\uD83D\uDC2E"],"Animals & Nature",592,["cow"],11,34,"0.6","animal-mammal"],
    "1f42f":[["\uD83D\uDC2F"],"Animals & Nature",581,["tiger"],11,35,"0.6","animal-mammal"],
    "1f430":[["\uD83D\uDC30"],"Animals & Nature",615,["rabbit"],11,36,"0.6","animal-mammal"],
    "1f431":[["\uD83D\uDC31"],"Animals & Nature",577,["cat"],11,37,"0.6","animal-mammal"],
    "1f432":[["\uD83D\uDC32"],"Animals & Nature",658,["dragon_face"],11,38,"0.6","animal-reptile"],
    "1f433":[["\uD83D\uDC33"],"Animals & Nature",662,["whale"],11,39,"0.6","animal-marine"],
    "1f434":[["\uD83D\uDC34"],"Animals & Nature",584,["horse"],11,40,"0.6","animal-mammal"],
    "1f435":[["\uD83D\uDC35"],"Animals & Nature",565,["monkey_face"],11,41,"0.6","animal-mammal"],
    "1f436":[["\uD83D\uDC36"],"Animals & Nature",569,["dog"],11,42,"0.6","animal-mammal"],
    "1f437":[["\uD83D\uDC37"],"Animals & Nature",596,["pig"],11,43,"0.6","animal-mammal"],
    "1f438":[["\uD83D\uDC38"],"Animals & Nature",653,["frog"],11,44,"0.6","animal-amphibian"],
    "1f439":[["\uD83D\uDC39"],"Animals & Nature",614,["hamster"],11,45,"0.6","animal-mammal"],
    "1f43a":[["\uD83D\uDC3A"],"Animals & Nature",574,["wolf"],11,46,"0.6","animal-mammal"],
    "1f43b-200d-2744-fe0f":[["\uD83D\uDC3B\u200D\u2744\uFE0F"],"Animals & Nature",622,["polar_bear"],11,47,"13.0","animal-mammal"],
    "1f43b":[["\uD83D\uDC3B"],"Animals & Nature",621,["bear"],11,48,"0.6","animal-mammal"],
    "1f43c":[["\uD83D\uDC3C"],"Animals & Nature",624,["panda_face"],11,49,"0.6","animal-mammal"],
    "1f43d":[["\uD83D\uDC3D"],"Animals & Nature",599,["pig_nose"],11,50,"0.6","animal-mammal"],
    "1f43e":[["\uD83D\uDC3E"],"Animals & Nature",630,["feet","paw_prints"],11,51,"0.6","animal-mammal"],
    "1f43f-fe0f":[["\uD83D\uDC3F\uFE0F"],"Animals & Nature",617,["chipmunk"],11,52,"0.7","animal-mammal"],
    "1f440":[["\uD83D\uDC40"],"People & Body",228,["eyes"],11,53,"0.6","body-parts"],
    "1f441-fe0f-200d-1f5e8-fe0f":[["\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F"],"Smileys & Emotion",167,["eye-in-speech-bubble"],11,54,"2.0","emotion"],
    "1f441-fe0f":[["\uD83D\uDC41\uFE0F"],"People & Body",229,["eye"],11,55,"0.7","body-parts"],
    "1f442":[["\uD83D\uDC42"],"People & Body",220,["ear"],11,56,"0.6","body-parts"],
    "1f443":[["\uD83D\uDC43"],"People & Body",222,["nose"],11,62,"0.6","body-parts"],
    "1f444":[["\uD83D\uDC44"],"People & Body",231,["lips"],12,5,"0.6","body-parts"],
    "1f445":[["\uD83D\uDC45"],"People & Body",230,["tongue"],12,6,"0.6","body-parts"],
    "1f446":[["\uD83D\uDC46"],"People & Body",194,["point_up_2"],12,7,"0.6","hand-single-finger"],
    "1f447":[["\uD83D\uDC47"],"People & Body",196,["point_down"],12,13,"0.6","hand-single-finger"],
    "1f448":[["\uD83D\uDC48"],"People & Body",192,["point_left"],12,19,"0.6","hand-single-finger"],
    "1f449":[["\uD83D\uDC49"],"People & Body",193,["point_right"],12,25,"0.6","hand-single-finger"],
    "1f44a":[["\uD83D\uDC4A"],"People & Body",202,["facepunch","punch"],12,31,"0.6","hand-fingers-closed"],
    "1f44b":[["\uD83D\uDC4B"],"People & Body",172,["wave"],12,37,"0.6","hand-fingers-open"],
    "1f44c":[["\uD83D\uDC4C"],"People & Body",183,["ok_hand"],12,43,"0.6","hand-fingers-partial"],
    "1f44d":[["\uD83D\uDC4D"],"People & Body",199,["+1","thumbsup"],12,49,"0.6","hand-fingers-closed"],
    "1f44e":[["\uD83D\uDC4E"],"People & Body",200,["-1","thumbsdown"],12,55,"0.6","hand-fingers-closed"],
    "1f44f":[["\uD83D\uDC4F"],"People & Body",205,["clap"],12,61,"0.6","hands"],
    "1f450":[["\uD83D\uDC50"],"People & Body",208,["open_hands"],13,4,"0.6","hands"],
    "1f451":[["\uD83D\uDC51"],"Objects",1196,["crown"],13,10,"0.6","clothing"],
    "1f452":[["\uD83D\uDC52"],"Objects",1197,["womans_hat"],13,11,"0.6","clothing"],
    "1f453":[["\uD83D\uDC53"],"Objects",1160,["eyeglasses"],13,12,"0.6","clothing"],
    "1f454":[["\uD83D\uDC54"],"Objects",1165,["necktie"],13,13,"0.6","clothing"],
    "1f455":[["\uD83D\uDC55"],"Objects",1166,["shirt","tshirt"],13,14,"0.6","clothing"],
    "1f456":[["\uD83D\uDC56"],"Objects",1167,["jeans"],13,15,"0.6","clothing"],
    "1f457":[["\uD83D\uDC57"],"Objects",1172,["dress"],13,16,"0.6","clothing"],
    "1f458":[["\uD83D\uDC58"],"Objects",1173,["kimono"],13,17,"0.6","clothing"],
    "1f459":[["\uD83D\uDC59"],"Objects",1178,["bikini"],13,18,"0.6","clothing"],
    "1f45a":[["\uD83D\uDC5A"],"Objects",1179,["womans_clothes"],13,19,"0.6","clothing"],
    "1f45b":[["\uD83D\uDC5B"],"Objects",1181,["purse"],13,20,"0.6","clothing"],
    "1f45c":[["\uD83D\uDC5C"],"Objects",1182,["handbag"],13,21,"0.6","clothing"],
    "1f45d":[["\uD83D\uDC5D"],"Objects",1183,["pouch"],13,22,"0.6","clothing"],
    "1f45e":[["\uD83D\uDC5E"],"Objects",1187,["mans_shoe","shoe"],13,23,"0.6","clothing"],
    "1f45f":[["\uD83D\uDC5F"],"Objects",1188,["athletic_shoe"],13,24,"0.6","clothing"],
    "1f460":[["\uD83D\uDC60"],"Objects",1191,["high_heel"],13,25,"0.6","clothing"],
    "1f461":[["\uD83D\uDC61"],"Objects",1192,["sandal"],13,26,"0.6","clothing"],
    "1f462":[["\uD83D\uDC62"],"Objects",1194,["boot"],13,27,"0.6","clothing"],
    "1f463":[["\uD83D\uDC63"],"People & Body",558,["footprints"],13,28,"0.6","person-symbol"],
    "1f464":[["\uD83D\uDC64"],"People & Body",550,["bust_in_silhouette"],13,29,"0.6","person-symbol"],
    "1f465":[["\uD83D\uDC65"],"People & Body",551,["busts_in_silhouette"],13,30,"1.0","person-symbol"],
    "1f466":[["\uD83D\uDC66"],"People & Body",235,["boy"],13,31,"0.6","person"],
    "1f467":[["\uD83D\uDC67"],"People & Body",236,["girl"],13,37,"0.6","person"],
    "1f468-200d-1f33e":[["\uD83D\uDC68\u200D\uD83C\uDF3E"],"People & Body",304,["male-farmer"],13,43,"4.0","person-role"],
    "1f468-200d-1f373":[["\uD83D\uDC68\u200D\uD83C\uDF73"],"People & Body",307,["male-cook"],13,49,"4.0","person-role"],
    "1f468-200d-1f37c":[["\uD83D\uDC68\u200D\uD83C\uDF7C"],"People & Body",371,["man_feeding_baby"],13,55,"13.0","person-role"],
    "1f468-200d-1f393":[["\uD83D\uDC68\u200D\uD83C\uDF93"],"People & Body",295,["male-student"],13,61,"4.0","person-role"],
    "1f468-200d-1f3a4":[["\uD83D\uDC68\u200D\uD83C\uDFA4"],"People & Body",325,["male-singer"],14,4,"4.0","person-role"],
    "1f468-200d-1f3a8":[["\uD83D\uDC68\u200D\uD83C\uDFA8"],"People & Body",328,["male-artist"],14,10,"4.0","person-role"],
    "1f468-200d-1f3eb":[["\uD83D\uDC68\u200D\uD83C\uDFEB"],"People & Body",298,["male-teacher"],14,16,"4.0","person-role"],
    "1f468-200d-1f3ed":[["\uD83D\uDC68\u200D\uD83C\uDFED"],"People & Body",313,["male-factory-worker"],14,22,"4.0","person-role"],
    "1f468-200d-1f466-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",540,["man-boy-boy"],14,28,"4.0","family"],
    "1f468-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC66"],"People & Body",539,["man-boy"],14,29,"4.0","family"],
    "1f468-200d-1f467-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",542,["man-girl-boy"],14,30,"4.0","family"],
    "1f468-200d-1f467-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",543,["man-girl-girl"],14,31,"4.0","family"],
    "1f468-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC67"],"People & Body",541,["man-girl"],14,32,"4.0","family"],
    "1f468-200d-1f468-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66"],"People & Body",529,["man-man-boy"],14,33,"2.0","family"],
    "1f468-200d-1f468-200d-1f466-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",532,["man-man-boy-boy"],14,34,"2.0","family"],
    "1f468-200d-1f468-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67"],"People & Body",530,["man-man-girl"],14,35,"2.0","family"],
    "1f468-200d-1f468-200d-1f467-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",531,["man-man-girl-boy"],14,36,"2.0","family"],
    "1f468-200d-1f468-200d-1f467-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",533,["man-man-girl-girl"],14,37,"2.0","family"],
    "1f468-200d-1f469-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66"],"People & Body",524,["man-woman-boy"],14,38,"2.0","family"],
    "1f468-200d-1f469-200d-1f466-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",527,["man-woman-boy-boy"],14,39,"2.0","family"],
    "1f468-200d-1f469-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67"],"People & Body",525,["man-woman-girl"],14,40,"2.0","family"],
    "1f468-200d-1f469-200d-1f467-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",526,["man-woman-girl-boy"],14,41,"2.0","family"],
    "1f468-200d-1f469-200d-1f467-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",528,["man-woman-girl-girl"],14,42,"2.0","family"],
    "1f468-200d-1f4bb":[["\uD83D\uDC68\u200D\uD83D\uDCBB"],"People & Body",322,["male-technologist"],14,43,"4.0","person-role"],
    "1f468-200d-1f4bc":[["\uD83D\uDC68\u200D\uD83D\uDCBC"],"People & Body",316,["male-office-worker"],14,49,"4.0","person-role"],
    "1f468-200d-1f527":[["\uD83D\uDC68\u200D\uD83D\uDD27"],"People & Body",310,["male-mechanic"],14,55,"4.0","person-role"],
    "1f468-200d-1f52c":[["\uD83D\uDC68\u200D\uD83D\uDD2C"],"People & Body",319,["male-scientist"],14,61,"4.0","person-role"],
    "1f468-200d-1f680":[["\uD83D\uDC68\u200D\uD83D\uDE80"],"People & Body",334,["male-astronaut"],15,4,"4.0","person-role"],
    "1f468-200d-1f692":[["\uD83D\uDC68\u200D\uD83D\uDE92"],"People & Body",337,["male-firefighter"],15,10,"4.0","person-role"],
    "1f468-200d-1f9af-200d-27a1-fe0f":[["\uD83D\uDC68\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"People & Body",430,["man_with_white_cane_facing_right"],15,16,"15.1","person-activity"],
    "1f468-200d-1f9af":[["\uD83D\uDC68\u200D\uD83E\uDDAF"],"People & Body",429,["man_with_probing_cane"],15,22,"12.0","person-activity"],
    "1f468-200d-1f9b0":[["\uD83D\uDC68\u200D\uD83E\uDDB0"],"People & Body",243,["red_haired_man"],15,28,"11.0","person"],
    "1f468-200d-1f9b1":[["\uD83D\uDC68\u200D\uD83E\uDDB1"],"People & Body",244,["curly_haired_man"],15,34,"11.0","person"],
    "1f468-200d-1f9b2":[["\uD83D\uDC68\u200D\uD83E\uDDB2"],"People & Body",246,["bald_man"],15,40,"11.0","person"],
    "1f468-200d-1f9b3":[["\uD83D\uDC68\u200D\uD83E\uDDB3"],"People & Body",245,["white_haired_man"],15,46,"11.0","person"],
    "1f468-200d-1f9bc-200d-27a1-fe0f":[["\uD83D\uDC68\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"People & Body",436,["man_in_motorized_wheelchair_facing_right"],15,52,"15.1","person-activity"],
    "1f468-200d-1f9bc":[["\uD83D\uDC68\u200D\uD83E\uDDBC"],"People & Body",435,["man_in_motorized_wheelchair"],15,58,"12.0","person-activity"],
    "1f468-200d-1f9bd-200d-27a1-fe0f":[["\uD83D\uDC68\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"People & Body",442,["man_in_manual_wheelchair_facing_right"],16,1,"15.1","person-activity"],
    "1f468-200d-1f9bd":[["\uD83D\uDC68\u200D\uD83E\uDDBD"],"People & Body",441,["man_in_manual_wheelchair"],16,7,"12.0","person-activity"],
    "1f468-200d-2695-fe0f":[["\uD83D\uDC68\u200D\u2695\uFE0F"],"People & Body",292,["male-doctor"],16,13,"4.0","person-role"],
    "1f468-200d-2696-fe0f":[["\uD83D\uDC68\u200D\u2696\uFE0F"],"People & Body",301,["male-judge"],16,19,"4.0","person-role"],
    "1f468-200d-2708-fe0f":[["\uD83D\uDC68\u200D\u2708\uFE0F"],"People & Body",331,["male-pilot"],16,25,"4.0","person-role"],
    "1f468-200d-2764-fe0f-200d-1f468":[["\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68"],"People & Body",522,["man-heart-man"],16,31,"2.0","family"],
    "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468":[["\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68"],"People & Body",518,["man-kiss-man"],16,57,"2.0","family"],
    "1f468":[["\uD83D\uDC68"],"People & Body",239,["man"],17,20,"0.6","person"],
    "1f469-200d-1f33e":[["\uD83D\uDC69\u200D\uD83C\uDF3E"],"People & Body",305,["female-farmer"],17,26,"4.0","person-role"],
    "1f469-200d-1f373":[["\uD83D\uDC69\u200D\uD83C\uDF73"],"People & Body",308,["female-cook"],17,32,"4.0","person-role"],
    "1f469-200d-1f37c":[["\uD83D\uDC69\u200D\uD83C\uDF7C"],"People & Body",370,["woman_feeding_baby"],17,38,"13.0","person-role"],
    "1f469-200d-1f393":[["\uD83D\uDC69\u200D\uD83C\uDF93"],"People & Body",296,["female-student"],17,44,"4.0","person-role"],
    "1f469-200d-1f3a4":[["\uD83D\uDC69\u200D\uD83C\uDFA4"],"People & Body",326,["female-singer"],17,50,"4.0","person-role"],
    "1f469-200d-1f3a8":[["\uD83D\uDC69\u200D\uD83C\uDFA8"],"People & Body",329,["female-artist"],17,56,"4.0","person-role"],
    "1f469-200d-1f3eb":[["\uD83D\uDC69\u200D\uD83C\uDFEB"],"People & Body",299,["female-teacher"],17,62,"4.0","person-role"],
    "1f469-200d-1f3ed":[["\uD83D\uDC69\u200D\uD83C\uDFED"],"People & Body",314,["female-factory-worker"],18,5,"4.0","person-role"],
    "1f469-200d-1f466-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",545,["woman-boy-boy"],18,11,"4.0","family"],
    "1f469-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC66"],"People & Body",544,["woman-boy"],18,12,"4.0","family"],
    "1f469-200d-1f467-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",547,["woman-girl-boy"],18,13,"4.0","family"],
    "1f469-200d-1f467-200d-1f467":[["\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",548,["woman-girl-girl"],18,14,"4.0","family"],
    "1f469-200d-1f467":[["\uD83D\uDC69\u200D\uD83D\uDC67"],"People & Body",546,["woman-girl"],18,15,"4.0","family"],
    "1f469-200d-1f469-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66"],"People & Body",534,["woman-woman-boy"],18,16,"2.0","family"],
    "1f469-200d-1f469-200d-1f466-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",537,["woman-woman-boy-boy"],18,17,"2.0","family"],
    "1f469-200d-1f469-200d-1f467":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67"],"People & Body",535,["woman-woman-girl"],18,18,"2.0","family"],
    "1f469-200d-1f469-200d-1f467-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",536,["woman-woman-girl-boy"],18,19,"2.0","family"],
    "1f469-200d-1f469-200d-1f467-200d-1f467":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",538,["woman-woman-girl-girl"],18,20,"2.0","family"],
    "1f469-200d-1f4bb":[["\uD83D\uDC69\u200D\uD83D\uDCBB"],"People & Body",323,["female-technologist"],18,21,"4.0","person-role"],
    "1f469-200d-1f4bc":[["\uD83D\uDC69\u200D\uD83D\uDCBC"],"People & Body",317,["female-office-worker"],18,27,"4.0","person-role"],
    "1f469-200d-1f527":[["\uD83D\uDC69\u200D\uD83D\uDD27"],"People & Body",311,["female-mechanic"],18,33,"4.0","person-role"],
    "1f469-200d-1f52c":[["\uD83D\uDC69\u200D\uD83D\uDD2C"],"People & Body",320,["female-scientist"],18,39,"4.0","person-role"],
    "1f469-200d-1f680":[["\uD83D\uDC69\u200D\uD83D\uDE80"],"People & Body",335,["female-astronaut"],18,45,"4.0","person-role"],
    "1f469-200d-1f692":[["\uD83D\uDC69\u200D\uD83D\uDE92"],"People & Body",338,["female-firefighter"],18,51,"4.0","person-role"],
    "1f469-200d-1f9af-200d-27a1-fe0f":[["\uD83D\uDC69\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"People & Body",432,["woman_with_white_cane_facing_right"],18,57,"15.1","person-activity"],
    "1f469-200d-1f9af":[["\uD83D\uDC69\u200D\uD83E\uDDAF"],"People & Body",431,["woman_with_probing_cane"],19,0,"12.0","person-activity"],
    "1f469-200d-1f9b0":[["\uD83D\uDC69\u200D\uD83E\uDDB0"],"People & Body",248,["red_haired_woman"],19,6,"11.0","person"],
    "1f469-200d-1f9b1":[["\uD83D\uDC69\u200D\uD83E\uDDB1"],"People & Body",250,["curly_haired_woman"],19,12,"11.0","person"],
    "1f469-200d-1f9b2":[["\uD83D\uDC69\u200D\uD83E\uDDB2"],"People & Body",254,["bald_woman"],19,18,"11.0","person"],
    "1f469-200d-1f9b3":[["\uD83D\uDC69\u200D\uD83E\uDDB3"],"People & Body",252,["white_haired_woman"],19,24,"11.0","person"],
    "1f469-200d-1f9bc-200d-27a1-fe0f":[["\uD83D\uDC69\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"People & Body",438,["woman_in_motorized_wheelchair_facing_right"],19,30,"15.1","person-activity"],
    "1f469-200d-1f9bc":[["\uD83D\uDC69\u200D\uD83E\uDDBC"],"People & Body",437,["woman_in_motorized_wheelchair"],19,36,"12.0","person-activity"],
    "1f469-200d-1f9bd-200d-27a1-fe0f":[["\uD83D\uDC69\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"People & Body",444,["woman_in_manual_wheelchair_facing_right"],19,42,"15.1","person-activity"],
    "1f469-200d-1f9bd":[["\uD83D\uDC69\u200D\uD83E\uDDBD"],"People & Body",443,["woman_in_manual_wheelchair"],19,48,"12.0","person-activity"],
    "1f469-200d-2695-fe0f":[["\uD83D\uDC69\u200D\u2695\uFE0F"],"People & Body",293,["female-doctor"],19,54,"4.0","person-role"],
    "1f469-200d-2696-fe0f":[["\uD83D\uDC69\u200D\u2696\uFE0F"],"People & Body",302,["female-judge"],19,60,"4.0","person-role"],
    "1f469-200d-2708-fe0f":[["\uD83D\uDC69\u200D\u2708\uFE0F"],"People & Body",332,["female-pilot"],20,3,"4.0","person-role"],
    "1f469-200d-2764-fe0f-200d-1f468":[["\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68"],"People & Body",521,["woman-heart-man"],20,9,"2.0","family"],
    "1f469-200d-2764-fe0f-200d-1f469":[["\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69"],"People & Body",523,["woman-heart-woman"],20,35,"2.0","family"],
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468":[["\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68"],"People & Body",517,["woman-kiss-man"],20,61,"2.0","family"],
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469":[["\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69"],"People & Body",519,["woman-kiss-woman"],21,24,"2.0","family"],
    "1f469":[["\uD83D\uDC69"],"People & Body",247,["woman"],21,50,"0.6","person"],
    "1f46a":[["\uD83D\uDC6A"],"People & Body",553,["family"],21,56,"0.6","person-symbol"],
    "1f46b":[["\uD83D\uDC6B"],"People & Body",514,["man_and_woman_holding_hands","woman_and_man_holding_hands","couple"],21,57,"0.6","family"],
    "1f46c":[["\uD83D\uDC6C"],"People & Body",515,["two_men_holding_hands","men_holding_hands"],22,20,"1.0","family"],
    "1f46d":[["\uD83D\uDC6D"],"People & Body",513,["two_women_holding_hands","women_holding_hands"],22,46,"1.0","family"],
    "1f46e-200d-2640-fe0f":[["\uD83D\uDC6E\u200D\u2640\uFE0F"],"People & Body",341,["female-police-officer"],23,9,"4.0","person-role"],
    "1f46e-200d-2642-fe0f":[["\uD83D\uDC6E\u200D\u2642\uFE0F"],"People & Body",340,["male-police-officer"],23,15,"4.0","person-role"],
    "1f46e":[["\uD83D\uDC6E"],"People & Body",339,["cop"],23,21,"0.6","person-role"],
    "1f46f-200d-2640-fe0f":[["\uD83D\uDC6F\u200D\u2640\uFE0F"],"People & Body",457,["women-with-bunny-ears-partying","woman-with-bunny-ears-partying"],23,27,"4.0","person-activity"],
    "1f46f-200d-2642-fe0f":[["\uD83D\uDC6F\u200D\u2642\uFE0F"],"People & Body",456,["men-with-bunny-ears-partying","man-with-bunny-ears-partying"],23,53,"4.0","person-activity"],
    "1f46f":[["\uD83D\uDC6F"],"People & Body",455,["dancers"],24,16,"0.6","person-activity"],
    "1f470-200d-2640-fe0f":[["\uD83D\uDC70\u200D\u2640\uFE0F"],"People & Body",365,["woman_with_veil"],24,42,"13.0","person-role"],
    "1f470-200d-2642-fe0f":[["\uD83D\uDC70\u200D\u2642\uFE0F"],"People & Body",364,["man_with_veil"],24,48,"13.0","person-role"],
    "1f470":[["\uD83D\uDC70"],"People & Body",363,["bride_with_veil"],24,54,"0.6","person-role"],
    "1f471-200d-2640-fe0f":[["\uD83D\uDC71\u200D\u2640\uFE0F"],"People & Body",256,["blond-haired-woman"],24,60,"4.0","person"],
    "1f471-200d-2642-fe0f":[["\uD83D\uDC71\u200D\u2642\uFE0F"],"People & Body",257,["blond-haired-man"],25,3,"4.0","person"],
    "1f471":[["\uD83D\uDC71"],"People & Body",238,["person_with_blond_hair"],25,9,"0.6","person"],
    "1f472":[["\uD83D\uDC72"],"People & Body",358,["man_with_gua_pi_mao"],25,15,"0.6","person-role"],
    "1f473-200d-2640-fe0f":[["\uD83D\uDC73\u200D\u2640\uFE0F"],"People & Body",357,["woman-wearing-turban"],25,21,"4.0","person-role"],
    "1f473-200d-2642-fe0f":[["\uD83D\uDC73\u200D\u2642\uFE0F"],"People & Body",356,["man-wearing-turban"],25,27,"4.0","person-role"],
    "1f473":[["\uD83D\uDC73"],"People & Body",355,["man_with_turban"],25,33,"0.6","person-role"],
    "1f474":[["\uD83D\uDC74"],"People & Body",259,["older_man"],25,39,"0.6","person"],
    "1f475":[["\uD83D\uDC75"],"People & Body",260,["older_woman"],25,45,"0.6","person"],
    "1f476":[["\uD83D\uDC76"],"People & Body",233,["baby"],25,51,"0.6","person"],
    "1f477-200d-2640-fe0f":[["\uD83D\uDC77\u200D\u2640\uFE0F"],"People & Body",351,["female-construction-worker"],25,57,"4.0","person-role"],
    "1f477-200d-2642-fe0f":[["\uD83D\uDC77\u200D\u2642\uFE0F"],"People & Body",350,["male-construction-worker"],26,0,"4.0","person-role"],
    "1f477":[["\uD83D\uDC77"],"People & Body",349,["construction_worker"],26,6,"0.6","person-role"],
    "1f478":[["\uD83D\uDC78"],"People & Body",354,["princess"],26,12,"0.6","person-role"],
    "1f479":[["\uD83D\uDC79"],"Smileys & Emotion",114,["japanese_ogre"],26,18,"0.6","face-costume"],
    "1f47a":[["\uD83D\uDC7A"],"Smileys & Emotion",115,["japanese_goblin"],26,19,"0.6","face-costume"],
    "1f47b":[["\uD83D\uDC7B"],"Smileys & Emotion",116,["ghost"],26,20,"0.6","face-costume"],
    "1f47c":[["\uD83D\uDC7C"],"People & Body",373,["angel"],26,21,"0.6","person-fantasy"],
    "1f47d":[["\uD83D\uDC7D"],"Smileys & Emotion",117,["alien"],26,27,"0.6","face-costume"],
    "1f47e":[["\uD83D\uDC7E"],"Smileys & Emotion",118,["space_invader"],26,28,"0.6","face-costume"],
    "1f47f":[["\uD83D\uDC7F"],"Smileys & Emotion",109,["imp"],26,29,"0.6","face-negative"],
    "1f480":[["\uD83D\uDC80"],"Smileys & Emotion",110,["skull"],26,30,"0.6","face-negative"],
    "1f481-200d-2640-fe0f":[["\uD83D\uDC81\u200D\u2640\uFE0F"],"People & Body",275,["woman-tipping-hand"],26,31,"4.0","person-gesture"],
    "1f481-200d-2642-fe0f":[["\uD83D\uDC81\u200D\u2642\uFE0F"],"People & Body",274,["man-tipping-hand"],26,37,"4.0","person-gesture"],
    "1f481":[["\uD83D\uDC81"],"People & Body",273,["information_desk_person"],26,43,"0.6","person-gesture"],
    "1f482-200d-2640-fe0f":[["\uD83D\uDC82\u200D\u2640\uFE0F"],"People & Body",347,["female-guard"],26,49,"4.0","person-role"],
    "1f482-200d-2642-fe0f":[["\uD83D\uDC82\u200D\u2642\uFE0F"],"People & Body",346,["male-guard"],26,55,"4.0","person-role"],
    "1f482":[["\uD83D\uDC82"],"People & Body",345,["guardsman"],26,61,"0.6","person-role"],
    "1f483":[["\uD83D\uDC83"],"People & Body",452,["dancer"],27,4,"0.6","person-activity"],
    "1f484":[["\uD83D\uDC84"],"Objects",1204,["lipstick"],27,10,"0.6","clothing"],
    "1f485":[["\uD83D\uDC85"],"People & Body",213,["nail_care"],27,11,"0.6","hand-prop"],
    "1f486-200d-2640-fe0f":[["\uD83D\uDC86\u200D\u2640\uFE0F"],"People & Body",408,["woman-getting-massage"],27,17,"4.0","person-activity"],
    "1f486-200d-2642-fe0f":[["\uD83D\uDC86\u200D\u2642\uFE0F"],"People & Body",407,["man-getting-massage"],27,23,"4.0","person-activity"],
    "1f486":[["\uD83D\uDC86"],"People & Body",406,["massage"],27,29,"0.6","person-activity"],
    "1f487-200d-2640-fe0f":[["\uD83D\uDC87\u200D\u2640\uFE0F"],"People & Body",411,["woman-getting-haircut"],27,35,"4.0","person-activity"],
    "1f487-200d-2642-fe0f":[["\uD83D\uDC87\u200D\u2642\uFE0F"],"People & Body",410,["man-getting-haircut"],27,41,"4.0","person-activity"],
    "1f487":[["\uD83D\uDC87"],"People & Body",409,["haircut"],27,47,"0.6","person-activity"],
    "1f488":[["\uD83D\uDC88"],"Travel & Places",921,["barber"],27,53,"0.6","place-other"],
    "1f489":[["\uD83D\uDC89"],"Objects",1385,["syringe"],27,54,"0.6","medical"],
    "1f48a":[["\uD83D\uDC8A"],"Objects",1387,["pill"],27,55,"0.6","medical"],
    "1f48b":[["\uD83D\uDC8B"],"Smileys & Emotion",157,["kiss"],27,56,"0.6","emotion"],
    "1f48c":[["\uD83D\uDC8C"],"Smileys & Emotion",132,["love_letter"],27,57,"0.6","heart"],
    "1f48d":[["\uD83D\uDC8D"],"Objects",1205,["ring"],27,58,"0.6","clothing"],
    "1f48e":[["\uD83D\uDC8E"],"Objects",1206,["gem"],27,59,"0.6","clothing"],
    "1f48f":[["\uD83D\uDC8F"],"People & Body",516,["couplekiss"],27,60,"0.6","family"],
    "1f490":[["\uD83D\uDC90"],"Animals & Nature",696,["bouquet"],28,23,"0.6","plant-flower"],
    "1f491":[["\uD83D\uDC91"],"People & Body",520,["couple_with_heart"],28,24,"0.6","family"],
    "1f492":[["\uD83D\uDC92"],"Travel & Places",897,["wedding"],28,50,"0.6","place-building"],
    "1f493":[["\uD83D\uDC93"],"Smileys & Emotion",137,["heartbeat"],28,51,"0.6","heart"],
    "1f494":[["\uD83D\uDC94"],"Smileys & Emotion",142,["broken_heart"],28,52,"0.6","heart","<\/3"],
    "1f495":[["\uD83D\uDC95"],"Smileys & Emotion",139,["two_hearts"],28,53,"0.6","heart"],
    "1f496":[["\uD83D\uDC96"],"Smileys & Emotion",135,["sparkling_heart"],28,54,"0.6","heart"],
    "1f497":[["\uD83D\uDC97"],"Smileys & Emotion",136,["heartpulse"],28,55,"0.6","heart"],
    "1f498":[["\uD83D\uDC98"],"Smileys & Emotion",133,["cupid"],28,56,"0.6","heart"],
    "1f499":[["\uD83D\uDC99"],"Smileys & Emotion",150,["blue_heart"],28,57,"0.6","heart","<3"],
    "1f49a":[["\uD83D\uDC9A"],"Smileys & Emotion",149,["green_heart"],28,58,"0.6","heart","<3"],
    "1f49b":[["\uD83D\uDC9B"],"Smileys & Emotion",148,["yellow_heart"],28,59,"0.6","heart","<3"],
    "1f49c":[["\uD83D\uDC9C"],"Smileys & Emotion",152,["purple_heart"],28,60,"0.6","heart","<3"],
    "1f49d":[["\uD83D\uDC9D"],"Smileys & Emotion",134,["gift_heart"],28,61,"0.6","heart"],
    "1f49e":[["\uD83D\uDC9E"],"Smileys & Emotion",138,["revolving_hearts"],28,62,"0.6","heart"],
    "1f49f":[["\uD83D\uDC9F"],"Smileys & Emotion",140,["heart_decoration"],29,0,"0.6","heart"],
    "1f4a0":[["\uD83D\uDCA0"],"Symbols",1646,["diamond_shape_with_a_dot_inside"],29,1,"0.6","geometric"],
    "1f4a1":[["\uD83D\uDCA1"],"Objects",1270,["bulb"],29,2,"0.6","light & video"],
    "1f4a2":[["\uD83D\uDCA2"],"Smileys & Emotion",159,["anger"],29,3,"0.6","emotion"],
    "1f4a3":[["\uD83D\uDCA3"],"Objects",1358,["bomb"],29,4,"0.6","tool"],
    "1f4a4":[["\uD83D\uDCA4"],"Smileys & Emotion",171,["zzz"],29,5,"0.6","emotion"],
    "1f4a5":[["\uD83D\uDCA5"],"Smileys & Emotion",161,["boom","collision"],29,6,"0.6","emotion"],
    "1f4a6":[["\uD83D\uDCA6"],"Smileys & Emotion",163,["sweat_drops"],29,7,"0.6","emotion"],
    "1f4a7":[["\uD83D\uDCA7"],"Travel & Places",1073,["droplet"],29,8,"0.6","sky & weather"],
    "1f4a8":[["\uD83D\uDCA8"],"Smileys & Emotion",164,["dash"],29,9,"0.6","emotion"],
    "1f4a9":[["\uD83D\uDCA9"],"Smileys & Emotion",112,["pile_of_poo", "hankey","poop","shit"],29,10,"0.6","face-costume"],
    "1f4aa":[["\uD83D\uDCAA"],"People & Body",215,["muscle"],29,11,"0.6","body-parts"],
    "1f4ab":[["\uD83D\uDCAB"],"Smileys & Emotion",162,["dizzy"],29,17,"0.6","emotion"],
    "1f4ac":[["\uD83D\uDCAC"],"Smileys & Emotion",166,["speech_balloon"],29,18,"0.6","emotion"],
    "1f4ad":[["\uD83D\uDCAD"],"Smileys & Emotion",170,["thought_balloon"],29,19,"1.0","emotion"],
    "1f4ae":[["\uD83D\uDCAE"],"Animals & Nature",698,["white_flower"],29,20,"0.6","plant-flower"],
    "1f4af":[["\uD83D\uDCAF"],"Smileys & Emotion",158,["100"],29,21,"0.6","emotion"],
    "1f4b0":[["\uD83D\uDCB0"],"Objects",1292,["moneybag"],29,22,"0.6","money"],
    "1f4b1":[["\uD83D\uDCB1"],"Symbols",1540,["currency_exchange"],29,23,"0.6","currency"],
    "1f4b2":[["\uD83D\uDCB2"],"Symbols",1541,["heavy_dollar_sign"],29,24,"0.6","currency"],
    "1f4b3":[["\uD83D\uDCB3"],"Objects",1299,["credit_card"],29,25,"0.6","money"],
    "1f4b4":[["\uD83D\uDCB4"],"Objects",1294,["yen"],29,26,"0.6","money"],
    "1f4b5":[["\uD83D\uDCB5"],"Objects",1295,["dollar"],29,27,"0.6","money"],
    "1f4b6":[["\uD83D\uDCB6"],"Objects",1296,["euro"],29,28,"1.0","money"],
    "1f4b7":[["\uD83D\uDCB7"],"Objects",1297,["pound"],29,29,"1.0","money"],
    "1f4b8":[["\uD83D\uDCB8"],"Objects",1298,["money_with_wings"],29,30,"0.6","money"],
    "1f4b9":[["\uD83D\uDCB9"],"Objects",1301,["chart"],29,31,"0.6","money"],
    "1f4ba":[["\uD83D\uDCBA"],"Travel & Places",987,["seat"],29,32,"0.6","transport-air"],
    "1f4bb":[["\uD83D\uDCBB"],"Objects",1247,["computer"],29,33,"0.6","computer"],
    "1f4bc":[["\uD83D\uDCBC"],"Objects",1322,["briefcase"],29,34,"0.6","office"],
    "1f4bd":[["\uD83D\uDCBD"],"Objects",1253,["minidisc"],29,35,"0.6","computer"],
    "1f4be":[["\uD83D\uDCBE"],"Objects",1254,["floppy_disk"],29,36,"0.6","computer"],
    "1f4bf":[["\uD83D\uDCBF"],"Objects",1255,["cd"],29,37,"0.6","computer"],
    "1f4c0":[["\uD83D\uDCC0"],"Objects",1256,["dvd"],29,38,"0.6","computer"],
    "1f4c1":[["\uD83D\uDCC1"],"Objects",1323,["file_folder"],29,39,"0.6","office"],
    "1f4c2":[["\uD83D\uDCC2"],"Objects",1324,["open_file_folder"],29,40,"0.6","office"],
    "1f4c3":[["\uD83D\uDCC3"],"Objects",1283,["page_with_curl"],29,41,"0.6","book-paper"],
    "1f4c4":[["\uD83D\uDCC4"],"Objects",1285,["page_facing_up"],29,42,"0.6","book-paper"],
    "1f4c5":[["\uD83D\uDCC5"],"Objects",1326,["date"],29,43,"0.6","office"],
    "1f4c6":[["\uD83D\uDCC6"],"Objects",1327,["calendar"],29,44,"0.6","office"],
    "1f4c7":[["\uD83D\uDCC7"],"Objects",1330,["card_index"],29,45,"0.6","office"],
    "1f4c8":[["\uD83D\uDCC8"],"Objects",1331,["chart_with_upwards_trend"],29,46,"0.6","office"],
    "1f4c9":[["\uD83D\uDCC9"],"Objects",1332,["chart_with_downwards_trend"],29,47,"0.6","office"],
    "1f4ca":[["\uD83D\uDCCA"],"Objects",1333,["bar_chart"],29,48,"0.6","office"],
    "1f4cb":[["\uD83D\uDCCB"],"Objects",1334,["clipboard"],29,49,"0.6","office"],
    "1f4cc":[["\uD83D\uDCCC"],"Objects",1335,["pushpin"],29,50,"0.6","office"],
    "1f4cd":[["\uD83D\uDCCD"],"Objects",1336,["round_pushpin"],29,51,"0.6","office"],
    "1f4ce":[["\uD83D\uDCCE"],"Objects",1337,["paperclip"],29,52,"0.6","office"],
    "1f4cf":[["\uD83D\uDCCF"],"Objects",1339,["straight_ruler"],29,53,"0.6","office"],
    "1f4d0":[["\uD83D\uDCD0"],"Objects",1340,["triangular_ruler"],29,54,"0.6","office"],
    "1f4d1":[["\uD83D\uDCD1"],"Objects",1288,["bookmark_tabs"],29,55,"0.6","book-paper"],
    "1f4d2":[["\uD83D\uDCD2"],"Objects",1282,["ledger"],29,56,"0.6","book-paper"],
    "1f4d3":[["\uD83D\uDCD3"],"Objects",1281,["notebook"],29,57,"0.6","book-paper"],
    "1f4d4":[["\uD83D\uDCD4"],"Objects",1274,["notebook_with_decorative_cover"],29,58,"0.6","book-paper"],
    "1f4d5":[["\uD83D\uDCD5"],"Objects",1275,["closed_book"],29,59,"0.6","book-paper"],
    "1f4d6":[["\uD83D\uDCD6"],"Objects",1276,["book","open_book"],29,60,"0.6","book-paper"],
    "1f4d7":[["\uD83D\uDCD7"],"Objects",1277,["green_book"],29,61,"0.6","book-paper"],
    "1f4d8":[["\uD83D\uDCD8"],"Objects",1278,["blue_book"],29,62,"0.6","book-paper"],
    "1f4d9":[["\uD83D\uDCD9"],"Objects",1279,["orange_book"],30,0,"0.6","book-paper"],
    "1f4da":[["\uD83D\uDCDA"],"Objects",1280,["books"],30,1,"0.6","book-paper"],
    "1f4db":[["\uD83D\uDCDB"],"Symbols",1546,["name_badge"],30,2,"0.6","other-symbol"],
    "1f4dc":[["\uD83D\uDCDC"],"Objects",1284,["scroll"],30,3,"0.6","book-paper"],
    "1f4dd":[["\uD83D\uDCDD"],"Objects",1321,["memo","pencil"],30,4,"0.6","writing"],
    "1f4de":[["\uD83D\uDCDE"],"Objects",1241,["telephone_receiver"],30,5,"0.6","phone"],
    "1f4df":[["\uD83D\uDCDF"],"Objects",1242,["pager"],30,6,"0.6","phone"],
    "1f4e0":[["\uD83D\uDCE0"],"Objects",1243,["fax"],30,7,"0.6","phone"],
    "1f4e1":[["\uD83D\uDCE1"],"Objects",1384,["satellite_antenna"],30,8,"0.6","science"],
    "1f4e2":[["\uD83D\uDCE2"],"Objects",1211,["loudspeaker"],30,9,"0.6","sound"],
    "1f4e3":[["\uD83D\uDCE3"],"Objects",1212,["mega"],30,10,"0.6","sound"],
    "1f4e4":[["\uD83D\uDCE4"],"Objects",1306,["outbox_tray"],30,11,"0.6","mail"],
    "1f4e5":[["\uD83D\uDCE5"],"Objects",1307,["inbox_tray"],30,12,"0.6","mail"],
    "1f4e6":[["\uD83D\uDCE6"],"Objects",1308,["package"],30,13,"0.6","mail"],
    "1f4e7":[["\uD83D\uDCE7"],"Objects",1303,["e-mail"],30,14,"0.6","mail"],
    "1f4e8":[["\uD83D\uDCE8"],"Objects",1304,["incoming_envelope"],30,15,"0.6","mail"],
    "1f4e9":[["\uD83D\uDCE9"],"Objects",1305,["envelope_with_arrow"],30,16,"0.6","mail"],
    "1f4ea":[["\uD83D\uDCEA"],"Objects",1310,["mailbox_closed"],30,17,"0.6","mail"],
    "1f4eb":[["\uD83D\uDCEB"],"Objects",1309,["mailbox"],30,18,"0.6","mail"],
    "1f4ec":[["\uD83D\uDCEC"],"Objects",1311,["mailbox_with_mail"],30,19,"0.7","mail"],
    "1f4ed":[["\uD83D\uDCED"],"Objects",1312,["mailbox_with_no_mail"],30,20,"0.7","mail"],
    "1f4ee":[["\uD83D\uDCEE"],"Objects",1313,["postbox"],30,21,"0.6","mail"],
    "1f4ef":[["\uD83D\uDCEF"],"Objects",1213,["postal_horn"],30,22,"1.0","sound"],
    "1f4f0":[["\uD83D\uDCF0"],"Objects",1286,["newspaper"],30,23,"0.6","book-paper"],
    "1f4f1":[["\uD83D\uDCF1"],"Objects",1238,["iphone"],30,24,"0.6","phone"],
    "1f4f2":[["\uD83D\uDCF2"],"Objects",1239,["calling"],30,25,"0.6","phone"],
    "1f4f3":[["\uD83D\uDCF3"],"Symbols",1522,["vibration_mode"],30,26,"0.6","av-symbol"],
    "1f4f4":[["\uD83D\uDCF4"],"Symbols",1523,["mobile_phone_off"],30,27,"0.6","av-symbol"],
    "1f4f5":[["\uD83D\uDCF5"],"Symbols",1448,["no_mobile_phones"],30,28,"1.0","warning"],
    "1f4f6":[["\uD83D\uDCF6"],"Symbols",1520,["signal_strength"],30,29,"0.6","av-symbol"],
    "1f4f7":[["\uD83D\uDCF7"],"Objects",1263,["camera"],30,30,"0.6","light & video"],
    "1f4f8":[["\uD83D\uDCF8"],"Objects",1264,["camera_with_flash"],30,31,"1.0","light & video"],
    "1f4f9":[["\uD83D\uDCF9"],"Objects",1265,["video_camera"],30,32,"0.6","light & video"],
    "1f4fa":[["\uD83D\uDCFA"],"Objects",1262,["tv"],30,33,"0.6","light & video"],
    "1f4fb":[["\uD83D\uDCFB"],"Objects",1224,["radio"],30,34,"0.6","music"],
    "1f4fc":[["\uD83D\uDCFC"],"Objects",1266,["vhs"],30,35,"0.6","light & video"],
    "1f4fd-fe0f":[["\uD83D\uDCFD\uFE0F"],"Objects",1260,["film_projector"],30,36,"0.7","light & video"],
    "1f4ff":[["\uD83D\uDCFF"],"Objects",1203,["prayer_beads"],30,37,"1.0","clothing"],
    "1f500":[["\uD83D\uDD00"],"Symbols",1499,["twisted_rightwards_arrows"],30,38,"1.0","av-symbol"],
    "1f501":[["\uD83D\uDD01"],"Symbols",1500,["repeat"],30,39,"1.0","av-symbol"],
    "1f502":[["\uD83D\uDD02"],"Symbols",1501,["repeat_one"],30,40,"1.0","av-symbol"],
    "1f503":[["\uD83D\uDD03"],"Symbols",1466,["arrows_clockwise"],30,41,"0.6","arrow"],
    "1f504":[["\uD83D\uDD04"],"Symbols",1467,["arrows_counterclockwise"],30,42,"1.0","arrow"],
    "1f505":[["\uD83D\uDD05"],"Symbols",1518,["low_brightness"],30,43,"1.0","av-symbol"],
    "1f506":[["\uD83D\uDD06"],"Symbols",1519,["high_brightness"],30,44,"1.0","av-symbol"],
    "1f507":[["\uD83D\uDD07"],"Objects",1207,["mute"],30,45,"1.0","sound"],
    "1f508":[["\uD83D\uDD08"],"Objects",1208,["speaker"],30,46,"0.7","sound"],
    "1f509":[["\uD83D\uDD09"],"Objects",1209,["sound"],30,47,"1.0","sound"],
    "1f50a":[["\uD83D\uDD0A"],"Objects",1210,["loud_sound"],30,48,"0.6","sound"],
    "1f50b":[["\uD83D\uDD0B"],"Objects",1244,["battery"],30,49,"0.6","computer"],
    "1f50c":[["\uD83D\uDD0C"],"Objects",1246,["electric_plug"],30,50,"0.6","computer"],
    "1f50d":[["\uD83D\uDD0D"],"Objects",1267,["mag"],30,51,"0.6","light & video"],
    "1f50e":[["\uD83D\uDD0E"],"Objects",1268,["mag_right"],30,52,"0.6","light & video"],
    "1f50f":[["\uD83D\uDD0F"],"Objects",1347,["lock_with_ink_pen"],30,53,"0.6","lock"],
    "1f510":[["\uD83D\uDD10"],"Objects",1348,["closed_lock_with_key"],30,54,"0.6","lock"],
    "1f511":[["\uD83D\uDD11"],"Objects",1349,["key"],30,55,"0.6","lock"],
    "1f512":[["\uD83D\uDD12"],"Objects",1345,["lock"],30,56,"0.6","lock"],
    "1f513":[["\uD83D\uDD13"],"Objects",1346,["unlock"],30,57,"0.6","lock"],
    "1f514":[["\uD83D\uDD14"],"Objects",1214,["bell"],30,58,"0.6","sound"],
    "1f515":[["\uD83D\uDD15"],"Objects",1215,["no_bell"],30,59,"1.0","sound"],
    "1f516":[["\uD83D\uDD16"],"Objects",1289,["bookmark"],30,60,"0.6","book-paper"],
    "1f517":[["\uD83D\uDD17"],"Objects",1370,["link"],30,61,"0.6","tool"],
    "1f518":[["\uD83D\uDD18"],"Symbols",1647,["radio_button"],30,62,"0.6","geometric"],
    "1f519":[["\uD83D\uDD19"],"Symbols",1468,["back"],31,0,"0.6","arrow"],
    "1f51a":[["\uD83D\uDD1A"],"Symbols",1469,["end"],31,1,"0.6","arrow"],
    "1f51b":[["\uD83D\uDD1B"],"Symbols",1470,["on"],31,2,"0.6","arrow"],
    "1f51c":[["\uD83D\uDD1C"],"Symbols",1471,["soon"],31,3,"0.6","arrow"],
    "1f51d":[["\uD83D\uDD1D"],"Symbols",1472,["top"],31,4,"0.6","arrow"],
    "1f51e":[["\uD83D\uDD1E"],"Symbols",1449,["underage"],31,5,"0.6","warning"],
    "1f51f":[["\uD83D\uDD1F"],"Symbols",1576,["keycap_ten"],31,6,"0.6","keycap"],
    "1f520":[["\uD83D\uDD20"],"Symbols",1577,["capital_abcd"],31,7,"0.6","alphanum"],
    "1f521":[["\uD83D\uDD21"],"Symbols",1578,["abcd"],31,8,"0.6","alphanum"],
    "1f522":[["\uD83D\uDD22"],"Symbols",1579,["1234"],31,9,"0.6","alphanum"],
    "1f523":[["\uD83D\uDD23"],"Symbols",1580,["symbols"],31,10,"0.6","alphanum"],
    "1f524":[["\uD83D\uDD24"],"Symbols",1581,["abc"],31,11,"0.6","alphanum"],
    "1f525":[["\uD83D\uDD25"],"Travel & Places",1072,["fire"],31,12,"0.6","sky & weather"],
    "1f526":[["\uD83D\uDD26"],"Objects",1271,["flashlight"],31,13,"0.6","light & video"],
    "1f527":[["\uD83D\uDD27"],"Objects",1363,["wrench"],31,14,"0.6","tool"],
    "1f528":[["\uD83D\uDD28"],"Objects",1351,["hammer"],31,15,"0.6","tool"],
    "1f529":[["\uD83D\uDD29"],"Objects",1365,["nut_and_bolt"],31,16,"0.6","tool"],
    "1f52a":[["\uD83D\uDD2A"],"Food & Drink",853,["hocho","knife"],31,17,"0.6","dishware"],
    "1f52b":[["\uD83D\uDD2B"],"Activities",1132,["gun"],31,18,"0.6","game"],
    "1f52c":[["\uD83D\uDD2C"],"Objects",1382,["microscope"],31,19,"1.0","science"],
    "1f52d":[["\uD83D\uDD2D"],"Objects",1383,["telescope"],31,20,"1.0","science"],
    "1f52e":[["\uD83D\uDD2E"],"Activities",1134,["crystal_ball"],31,21,"0.6","game"],
    "1f52f":[["\uD83D\uDD2F"],"Symbols",1484,["six_pointed_star"],31,22,"0.6","religion"],
    "1f530":[["\uD83D\uDD30"],"Symbols",1547,["beginner"],31,23,"0.6","other-symbol"],
    "1f531":[["\uD83D\uDD31"],"Symbols",1545,["trident"],31,24,"0.6","other-symbol"],
    "1f532":[["\uD83D\uDD32"],"Symbols",1649,["black_square_button"],31,25,"0.6","geometric"],
    "1f533":[["\uD83D\uDD33"],"Symbols",1648,["white_square_button"],31,26,"0.6","geometric"],
    "1f534":[["\uD83D\uDD34"],"Symbols",1616,["red_circle"],31,27,"0.6","geometric"],
    "1f535":[["\uD83D\uDD35"],"Symbols",1620,["large_blue_circle"],31,28,"0.6","geometric"],
    "1f536":[["\uD83D\uDD36"],"Symbols",1640,["large_orange_diamond"],31,29,"0.6","geometric"],
    "1f537":[["\uD83D\uDD37"],"Symbols",1641,["large_blue_diamond"],31,30,"0.6","geometric"],
    "1f538":[["\uD83D\uDD38"],"Symbols",1642,["small_orange_diamond"],31,31,"0.6","geometric"],
    "1f539":[["\uD83D\uDD39"],"Symbols",1643,["small_blue_diamond"],31,32,"0.6","geometric"],
    "1f53a":[["\uD83D\uDD3A"],"Symbols",1644,["small_red_triangle"],31,33,"0.6","geometric"],
    "1f53b":[["\uD83D\uDD3B"],"Symbols",1645,["small_red_triangle_down"],31,34,"0.6","geometric"],
    "1f53c":[["\uD83D\uDD3C"],"Symbols",1509,["arrow_up_small"],31,35,"0.6","av-symbol"],
    "1f53d":[["\uD83D\uDD3D"],"Symbols",1511,["arrow_down_small"],31,36,"0.6","av-symbol"],
    "1f549-fe0f":[["\uD83D\uDD49\uFE0F"],"Symbols",1475,["om_symbol"],31,37,"0.7","religion"],
    "1f54a-fe0f":[["\uD83D\uDD4A\uFE0F"],"Animals & Nature",639,["dove_of_peace"],31,38,"0.7","animal-bird"],
    "1f54b":[["\uD83D\uDD4B"],"Travel & Places",905,["kaaba"],31,39,"1.0","place-religious"],
    "1f54c":[["\uD83D\uDD4C"],"Travel & Places",901,["mosque"],31,40,"1.0","place-religious"],
    "1f54d":[["\uD83D\uDD4D"],"Travel & Places",903,["synagogue"],31,41,"1.0","place-religious"],
    "1f54e":[["\uD83D\uDD4E"],"Symbols",1483,["menorah_with_nine_branches"],31,42,"1.0","religion"],
    "1f550":[["\uD83D\uDD50"],"Travel & Places",1006,["clock1"],31,43,"0.6","time"],
    "1f551":[["\uD83D\uDD51"],"Travel & Places",1008,["clock2"],31,44,"0.6","time"],
    "1f552":[["\uD83D\uDD52"],"Travel & Places",1010,["clock3"],31,45,"0.6","time"],
    "1f553":[["\uD83D\uDD53"],"Travel & Places",1012,["clock4"],31,46,"0.6","time"],
    "1f554":[["\uD83D\uDD54"],"Travel & Places",1014,["clock5"],31,47,"0.6","time"],
    "1f555":[["\uD83D\uDD55"],"Travel & Places",1016,["clock6"],31,48,"0.6","time"],
    "1f556":[["\uD83D\uDD56"],"Travel & Places",1018,["clock7"],31,49,"0.6","time"],
    "1f557":[["\uD83D\uDD57"],"Travel & Places",1020,["clock8"],31,50,"0.6","time"],
    "1f558":[["\uD83D\uDD58"],"Travel & Places",1022,["clock9"],31,51,"0.6","time"],
    "1f559":[["\uD83D\uDD59"],"Travel & Places",1024,["clock10"],31,52,"0.6","time"],
    "1f55a":[["\uD83D\uDD5A"],"Travel & Places",1026,["clock11"],31,53,"0.6","time"],
    "1f55b":[["\uD83D\uDD5B"],"Travel & Places",1004,["clock12"],31,54,"0.6","time"],
    "1f55c":[["\uD83D\uDD5C"],"Travel & Places",1007,["clock130"],31,55,"0.7","time"],
    "1f55d":[["\uD83D\uDD5D"],"Travel & Places",1009,["clock230"],31,56,"0.7","time"],
    "1f55e":[["\uD83D\uDD5E"],"Travel & Places",1011,["clock330"],31,57,"0.7","time"],
    "1f55f":[["\uD83D\uDD5F"],"Travel & Places",1013,["clock430"],31,58,"0.7","time"],
    "1f560":[["\uD83D\uDD60"],"Travel & Places",1015,["clock530"],31,59,"0.7","time"],
    "1f561":[["\uD83D\uDD61"],"Travel & Places",1017,["clock630"],31,60,"0.7","time"],
    "1f562":[["\uD83D\uDD62"],"Travel & Places",1019,["clock730"],31,61,"0.7","time"],
    "1f563":[["\uD83D\uDD63"],"Travel & Places",1021,["clock830"],31,62,"0.7","time"],
    "1f564":[["\uD83D\uDD64"],"Travel & Places",1023,["clock930"],32,0,"0.7","time"],
    "1f565":[["\uD83D\uDD65"],"Travel & Places",1025,["clock1030"],32,1,"0.7","time"],
    "1f566":[["\uD83D\uDD66"],"Travel & Places",1027,["clock1130"],32,2,"0.7","time"],
    "1f567":[["\uD83D\uDD67"],"Travel & Places",1005,["clock1230"],32,3,"0.7","time"],
    "1f56f-fe0f":[["\uD83D\uDD6F\uFE0F"],"Objects",1269,["candle"],32,4,"0.7","light & video"],
    "1f570-fe0f":[["\uD83D\uDD70\uFE0F"],"Travel & Places",1003,["mantelpiece_clock"],32,5,"0.7","time"],
    "1f573-fe0f":[["\uD83D\uDD73\uFE0F"],"Smileys & Emotion",165,["hole"],32,6,"0.7","emotion"],
    "1f574-fe0f":[["\uD83D\uDD74\uFE0F"],"People & Body",454,["man_in_business_suit_levitating"],32,7,"0.7","person-activity"],
    "1f575-fe0f-200d-2640-fe0f":[["\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F"],"People & Body",344,["female-detective"],32,13,"4.0","person-role"],
    "1f575-fe0f-200d-2642-fe0f":[["\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F"],"People & Body",343,["male-detective"],32,19,"4.0","person-role"],
    "1f575-fe0f":[["\uD83D\uDD75\uFE0F"],"People & Body",342,["sleuth_or_spy"],32,25,"0.7","person-role"],
    "1f576-fe0f":[["\uD83D\uDD76\uFE0F"],"Objects",1161,["dark_sunglasses"],32,31,"0.7","clothing"],
    "1f577-fe0f":[["\uD83D\uDD77\uFE0F"],"Animals & Nature",689,["spider"],32,32,"0.7","animal-bug"],
    "1f578-fe0f":[["\uD83D\uDD78\uFE0F"],"Animals & Nature",690,["spider_web"],32,33,"0.7","animal-bug"],
    "1f579-fe0f":[["\uD83D\uDD79\uFE0F"],"Activities",1137,["joystick"],32,34,"0.7","game"],
    "1f57a":[["\uD83D\uDD7A"],"People & Body",453,["man_dancing"],32,35,"3.0","person-activity"],
    "1f587-fe0f":[["\uD83D\uDD87\uFE0F"],"Objects",1338,["linked_paperclips"],32,41,"0.7","office"],
    "1f58a-fe0f":[["\uD83D\uDD8A\uFE0F"],"Objects",1318,["lower_left_ballpoint_pen"],32,42,"0.7","writing"],
    "1f58b-fe0f":[["\uD83D\uDD8B\uFE0F"],"Objects",1317,["lower_left_fountain_pen"],32,43,"0.7","writing"],
    "1f58c-fe0f":[["\uD83D\uDD8C\uFE0F"],"Objects",1319,["lower_left_paintbrush"],32,44,"0.7","writing"],
    "1f58d-fe0f":[["\uD83D\uDD8D\uFE0F"],"Objects",1320,["lower_left_crayon"],32,45,"0.7","writing"],
    "1f590-fe0f":[["\uD83D\uDD90\uFE0F"],"People & Body",174,["raised_hand_with_fingers_splayed"],32,46,"0.7","hand-fingers-open"],
    "1f595":[["\uD83D\uDD95"],"People & Body",195,["middle_finger","reversed_hand_with_middle_finger_extended"],32,52,"1.0","hand-single-finger"],
    "1f596":[["\uD83D\uDD96"],"People & Body",176,["spock-hand"],32,58,"1.0","hand-fingers-open"],
    "1f5a4":[["\uD83D\uDDA4"],"Smileys & Emotion",154,["black_heart"],33,1,"3.0","heart"],
    "1f5a5-fe0f":[["\uD83D\uDDA5\uFE0F"],"Objects",1248,["desktop_computer"],33,2,"0.7","computer"],
    "1f5a8-fe0f":[["\uD83D\uDDA8\uFE0F"],"Objects",1249,["printer"],33,3,"0.7","computer"],
    "1f5b1-fe0f":[["\uD83D\uDDB1\uFE0F"],"Objects",1251,["three_button_mouse"],33,4,"0.7","computer"],
    "1f5b2-fe0f":[["\uD83D\uDDB2\uFE0F"],"Objects",1252,["trackball"],33,5,"0.7","computer"],
    "1f5bc-fe0f":[["\uD83D\uDDBC\uFE0F"],"Activities",1154,["frame_with_picture"],33,6,"0.7","arts & crafts"],
    "1f5c2-fe0f":[["\uD83D\uDDC2\uFE0F"],"Objects",1325,["card_index_dividers"],33,7,"0.7","office"],
    "1f5c3-fe0f":[["\uD83D\uDDC3\uFE0F"],"Objects",1342,["card_file_box"],33,8,"0.7","office"],
    "1f5c4-fe0f":[["\uD83D\uDDC4\uFE0F"],"Objects",1343,["file_cabinet"],33,9,"0.7","office"],
    "1f5d1-fe0f":[["\uD83D\uDDD1\uFE0F"],"Objects",1344,["wastebasket"],33,10,"0.7","office"],
    "1f5d2-fe0f":[["\uD83D\uDDD2\uFE0F"],"Objects",1328,["spiral_note_pad"],33,11,"0.7","office"],
    "1f5d3-fe0f":[["\uD83D\uDDD3\uFE0F"],"Objects",1329,["spiral_calendar_pad"],33,12,"0.7","office"],
    "1f5dc-fe0f":[["\uD83D\uDDDC\uFE0F"],"Objects",1367,["compression"],33,13,"0.7","tool"],
    "1f5dd-fe0f":[["\uD83D\uDDDD\uFE0F"],"Objects",1350,["old_key"],33,14,"0.7","lock"],
    "1f5de-fe0f":[["\uD83D\uDDDE\uFE0F"],"Objects",1287,["rolled_up_newspaper"],33,15,"0.7","book-paper"],
    "1f5e1-fe0f":[["\uD83D\uDDE1\uFE0F"],"Objects",1356,["dagger_knife"],33,16,"0.7","tool"],
    "1f5e3-fe0f":[["\uD83D\uDDE3\uFE0F"],"People & Body",549,["speaking_head_in_silhouette"],33,17,"0.7","person-symbol"],
    "1f5e8-fe0f":[["\uD83D\uDDE8\uFE0F"],"Smileys & Emotion",168,["left_speech_bubble"],33,18,"2.0","emotion"],
    "1f5ef-fe0f":[["\uD83D\uDDEF\uFE0F"],"Smileys & Emotion",169,["right_anger_bubble"],33,19,"0.7","emotion"],
    "1f5f3-fe0f":[["\uD83D\uDDF3\uFE0F"],"Objects",1314,["ballot_box_with_ballot"],33,20,"0.7","mail"],
    "1f5fa-fe0f":[["\uD83D\uDDFA\uFE0F"],"Travel & Places",860,["world_map"],33,21,"0.7","place-map"],
    "1f5fb":[["\uD83D\uDDFB"],"Travel & Places",867,["mount_fuji"],33,22,"0.6","place-geographic"],
    "1f5fc":[["\uD83D\uDDFC"],"Travel & Places",898,["tokyo_tower"],33,23,"0.6","place-building"],
    "1f5fd":[["\uD83D\uDDFD"],"Travel & Places",899,["statue_of_liberty"],33,24,"0.6","place-building"],
    "1f5fe":[["\uD83D\uDDFE"],"Travel & Places",861,["japan"],33,25,"0.6","place-map"],
    "1f5ff":[["\uD83D\uDDFF"],"Objects",1423,["moyai"],33,26,"0.6","other-object"],
    "1f600":[["\uD83D\uDE00"],"Smileys & Emotion",1,["grinning"],33,27,"1.0","face-smiling",":D"],
    "1f601":[["\uD83D\uDE01"],"Smileys & Emotion",4,["grin"],33,28,"0.6","face-smiling"],
    "1f602":[["\uD83D\uDE02"],"Smileys & Emotion",8,["joy"],33,29,"0.6","face-smiling"],
    "1f603":[["\uD83D\uDE03"],"Smileys & Emotion",2,["smiley"],33,30,"0.6","face-smiling",":)"],
    "1f604":[["\uD83D\uDE04"],"Smileys & Emotion",3,["smile"],33,31,"0.6","face-smiling",":)"],
    "1f605":[["\uD83D\uDE05"],"Smileys & Emotion",6,["sweat_smile"],33,32,"0.6","face-smiling"],
    "1f606":[["\uD83D\uDE06"],"Smileys & Emotion",5,["laughing","satisfied"],33,33,"0.6","face-smiling"],
    "1f607":[["\uD83D\uDE07"],"Smileys & Emotion",14,["innocent"],33,34,"1.0","face-smiling"],
    "1f608":[["\uD83D\uDE08"],"Smileys & Emotion",108,["smiling_imp"],33,35,"1.0","face-negative"],
    "1f609":[["\uD83D\uDE09"],"Smileys & Emotion",12,["wink"],33,36,"0.6","face-smiling",";)"],
    "1f60a":[["\uD83D\uDE0A"],"Smileys & Emotion",13,["blush"],33,37,"0.6","face-smiling",":)"],
    "1f60b":[["\uD83D\uDE0B"],"Smileys & Emotion",24,["yum"],33,38,"0.6","face-tongue"],
    "1f60c":[["\uD83D\uDE0C"],"Smileys & Emotion",53,["relieved"],33,39,"0.6","face-sleepy"],
    "1f60d":[["\uD83D\uDE0D"],"Smileys & Emotion",16,["heart_eyes"],33,40,"0.6","face-affection"],
    "1f60e":[["\uD83D\uDE0E"],"Smileys & Emotion",74,["sunglasses"],33,41,"1.0","face-glasses"],
    "1f60f":[["\uD83D\uDE0F"],"Smileys & Emotion",44,["smirk"],33,42,"0.6","face-neutral-skeptical"],
    "1f610":[["\uD83D\uDE10"],"Smileys & Emotion",39,["neutral_face"],33,43,"0.7","face-neutral-skeptical"],
    "1f611":[["\uD83D\uDE11"],"Smileys & Emotion",40,["expressionless"],33,44,"1.0","face-neutral-skeptical"],
    "1f612":[["\uD83D\uDE12"],"Smileys & Emotion",45,["unamused"],33,45,"0.6","face-neutral-skeptical",":("],
    "1f613":[["\uD83D\uDE13"],"Smileys & Emotion",100,["sweat"],33,46,"0.6","face-concerned"],
    "1f614":[["\uD83D\uDE14"],"Smileys & Emotion",54,["pensive"],33,47,"0.6","face-sleepy"],
    "1f615":[["\uD83D\uDE15"],"Smileys & Emotion",77,["confused"],33,48,"1.0","face-concerned"],
    "1f616":[["\uD83D\uDE16"],"Smileys & Emotion",97,["confounded"],33,49,"0.6","face-concerned"],
    "1f617":[["\uD83D\uDE17"],"Smileys & Emotion",19,["kissing"],33,50,"1.0","face-affection"],
    "1f618":[["\uD83D\uDE18"],"Smileys & Emotion",18,["kissing_heart"],33,51,"0.6","face-affection"],
    "1f619":[["\uD83D\uDE19"],"Smileys & Emotion",22,["kissing_smiling_eyes"],33,52,"1.0","face-affection"],
    "1f61a":[["\uD83D\uDE1A"],"Smileys & Emotion",21,["kissing_closed_eyes"],33,53,"0.6","face-affection"],
    "1f61b":[["\uD83D\uDE1B"],"Smileys & Emotion",25,["stuck_out_tongue"],33,54,"1.0","face-tongue",":p"],
    "1f61c":[["\uD83D\uDE1C"],"Smileys & Emotion",26,["stuck_out_tongue_winking_eye"],33,55,"0.6","face-tongue",";p"],
    "1f61d":[["\uD83D\uDE1D"],"Smileys & Emotion",28,["stuck_out_tongue_closed_eyes"],33,56,"0.6","face-tongue"],
    "1f61e":[["\uD83D\uDE1E"],"Smileys & Emotion",99,["disappointed"],33,57,"0.6","face-concerned",":("],
    "1f61f":[["\uD83D\uDE1F"],"Smileys & Emotion",79,["worried"],33,58,"1.0","face-concerned"],
    "1f620":[["\uD83D\uDE20"],"Smileys & Emotion",106,["angry"],33,59,"0.6","face-negative"],
    "1f621":[["\uD83D\uDE21"],"Smileys & Emotion",105,["rage"],33,60,"0.6","face-negative"],
    "1f622":[["\uD83D\uDE22"],"Smileys & Emotion",94,["cry"],33,61,"0.6","face-concerned",":'("],
    "1f623":[["\uD83D\uDE23"],"Smileys & Emotion",98,["persevere"],33,62,"0.6","face-concerned"],
    "1f624":[["\uD83D\uDE24"],"Smileys & Emotion",104,["triumph"],34,0,"0.6","face-negative"],
    "1f625":[["\uD83D\uDE25"],"Smileys & Emotion",93,["disappointed_relieved"],34,1,"0.6","face-concerned"],
    "1f626":[["\uD83D\uDE26"],"Smileys & Emotion",89,["frowning"],34,2,"1.0","face-concerned"],
    "1f627":[["\uD83D\uDE27"],"Smileys & Emotion",90,["anguished"],34,3,"1.0","face-concerned"],
    "1f628":[["\uD83D\uDE28"],"Smileys & Emotion",91,["fearful"],34,4,"0.6","face-concerned"],
    "1f629":[["\uD83D\uDE29"],"Smileys & Emotion",101,["weary"],34,5,"0.6","face-concerned"],
    "1f62a":[["\uD83D\uDE2A"],"Smileys & Emotion",55,["sleepy"],34,6,"0.6","face-sleepy"],
    "1f62b":[["\uD83D\uDE2B"],"Smileys & Emotion",102,["tired_face"],34,7,"0.6","face-concerned"],
    "1f62c":[["\uD83D\uDE2C"],"Smileys & Emotion",47,["grimacing"],34,8,"1.0","face-neutral-skeptical"],
    "1f62d":[["\uD83D\uDE2D"],"Smileys & Emotion",95,["sob"],34,9,"0.6","face-concerned",":'("],
    "1f62e-200d-1f4a8":[["\uD83D\uDE2E\u200D\uD83D\uDCA8"],"Smileys & Emotion",48,["face_exhaling"],34,10,"13.1","face-neutral-skeptical"],
    "1f62e":[["\uD83D\uDE2E"],"Smileys & Emotion",82,["open_mouth"],34,11,"1.0","face-concerned"],
    "1f62f":[["\uD83D\uDE2F"],"Smileys & Emotion",83,["hushed"],34,12,"1.0","face-concerned"],
    "1f630":[["\uD83D\uDE30"],"Smileys & Emotion",92,["cold_sweat"],34,13,"0.6","face-concerned"],
    "1f631":[["\uD83D\uDE31"],"Smileys & Emotion",96,["scream"],34,14,"0.6","face-concerned"],
    "1f632":[["\uD83D\uDE32"],"Smileys & Emotion",84,["astonished"],34,15,"0.6","face-concerned"],
    "1f633":[["\uD83D\uDE33"],"Smileys & Emotion",85,["flushed"],34,16,"0.6","face-concerned"],
    "1f634":[["\uD83D\uDE34"],"Smileys & Emotion",57,["sleeping"],34,17,"1.0","face-sleepy"],
    "1f635-200d-1f4ab":[["\uD83D\uDE35\u200D\uD83D\uDCAB"],"Smileys & Emotion",69,["face_with_spiral_eyes"],34,18,"13.1","face-unwell"],
    "1f635":[["\uD83D\uDE35"],"Smileys & Emotion",68,["dizzy_face"],34,19,"0.6","face-unwell"],
    "1f636-200d-1f32b-fe0f":[["\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F"],"Smileys & Emotion",43,["face_in_clouds"],34,20,"13.1","face-neutral-skeptical"],
    "1f636":[["\uD83D\uDE36"],"Smileys & Emotion",41,["no_mouth"],34,21,"1.0","face-neutral-skeptical"],
    "1f637":[["\uD83D\uDE37"],"Smileys & Emotion",59,["mask"],34,22,"0.6","face-unwell"],
    "1f638":[["\uD83D\uDE38"],"Smileys & Emotion",121,["smile_cat"],34,23,"0.6","cat-face"],
    "1f639":[["\uD83D\uDE39"],"Smileys & Emotion",122,["joy_cat"],34,24,"0.6","cat-face"],
    "1f63a":[["\uD83D\uDE3A"],"Smileys & Emotion",120,["smiley_cat"],34,25,"0.6","cat-face"],
    "1f63b":[["\uD83D\uDE3B"],"Smileys & Emotion",123,["heart_eyes_cat"],34,26,"0.6","cat-face"],
    "1f63c":[["\uD83D\uDE3C"],"Smileys & Emotion",124,["smirk_cat"],34,27,"0.6","cat-face"],
    "1f63d":[["\uD83D\uDE3D"],"Smileys & Emotion",125,["kissing_cat"],34,28,"0.6","cat-face"],
    "1f63e":[["\uD83D\uDE3E"],"Smileys & Emotion",128,["pouting_cat"],34,29,"0.6","cat-face"],
    "1f63f":[["\uD83D\uDE3F"],"Smileys & Emotion",127,["crying_cat_face"],34,30,"0.6","cat-face"],
    "1f640":[["\uD83D\uDE40"],"Smileys & Emotion",126,["scream_cat"],34,31,"0.6","cat-face"],
    "1f641":[["\uD83D\uDE41"],"Smileys & Emotion",80,["slightly_frowning_face"],34,32,"1.0","face-concerned"],
    "1f642-200d-2194-fe0f":[["\uD83D\uDE42\u200D\u2194\uFE0F"],"Smileys & Emotion",51,["head_shaking_horizontally"],34,33,"15.1","face-neutral-skeptical"],
    "1f642-200d-2195-fe0f":[["\uD83D\uDE42\u200D\u2195\uFE0F"],"Smileys & Emotion",52,["head_shaking_vertically"],34,34,"15.1","face-neutral-skeptical"],
    "1f642":[["\uD83D\uDE42"],"Smileys & Emotion",9,["slightly_smiling_face"],34,35,"1.0","face-smiling"],
    "1f643":[["\uD83D\uDE43"],"Smileys & Emotion",10,["upside_down_face"],34,36,"1.0","face-smiling"],
    "1f644":[["\uD83D\uDE44"],"Smileys & Emotion",46,["face_with_rolling_eyes"],34,37,"1.0","face-neutral-skeptical"],
    "1f645-200d-2640-fe0f":[["\uD83D\uDE45\u200D\u2640\uFE0F"],"People & Body",269,["woman-gesturing-no"],34,38,"4.0","person-gesture"],
    "1f645-200d-2642-fe0f":[["\uD83D\uDE45\u200D\u2642\uFE0F"],"People & Body",268,["man-gesturing-no"],34,44,"4.0","person-gesture"],
    "1f645":[["\uD83D\uDE45"],"People & Body",267,["no_good"],34,50,"0.6","person-gesture"],
    "1f646-200d-2640-fe0f":[["\uD83D\uDE46\u200D\u2640\uFE0F"],"People & Body",272,["woman-gesturing-ok"],34,56,"4.0","person-gesture"],
    "1f646-200d-2642-fe0f":[["\uD83D\uDE46\u200D\u2642\uFE0F"],"People & Body",271,["man-gesturing-ok"],34,62,"4.0","person-gesture"],
    "1f646":[["\uD83D\uDE46"],"People & Body",270,["ok_woman"],35,5,"0.6","person-gesture"],
    "1f647-200d-2640-fe0f":[["\uD83D\uDE47\u200D\u2640\uFE0F"],"People & Body",284,["woman-bowing"],35,11,"4.0","person-gesture"],
    "1f647-200d-2642-fe0f":[["\uD83D\uDE47\u200D\u2642\uFE0F"],"People & Body",283,["man-bowing"],35,17,"4.0","person-gesture"],
    "1f647":[["\uD83D\uDE47"],"People & Body",282,["bow"],35,23,"0.6","person-gesture"],
    "1f648":[["\uD83D\uDE48"],"Smileys & Emotion",129,["see_no_evil"],35,29,"0.6","monkey-face"],
    "1f649":[["\uD83D\uDE49"],"Smileys & Emotion",130,["hear_no_evil"],35,30,"0.6","monkey-face"],
    "1f64a":[["\uD83D\uDE4A"],"Smileys & Emotion",131,["speak_no_evil"],35,31,"0.6","monkey-face"],
    "1f64b-200d-2640-fe0f":[["\uD83D\uDE4B\u200D\u2640\uFE0F"],"People & Body",278,["woman-raising-hand"],35,32,"4.0","person-gesture"],
    "1f64b-200d-2642-fe0f":[["\uD83D\uDE4B\u200D\u2642\uFE0F"],"People & Body",277,["man-raising-hand"],35,38,"4.0","person-gesture"],
    "1f64b":[["\uD83D\uDE4B"],"People & Body",276,["raising_hand"],35,44,"0.6","person-gesture"],
    "1f64c":[["\uD83D\uDE4C"],"People & Body",206,["raised_hands"],35,50,"0.6","hands"],
    "1f64d-200d-2640-fe0f":[["\uD83D\uDE4D\u200D\u2640\uFE0F"],"People & Body",263,["woman-frowning"],35,56,"4.0","person-gesture"],
    "1f64d-200d-2642-fe0f":[["\uD83D\uDE4D\u200D\u2642\uFE0F"],"People & Body",262,["man-frowning"],35,62,"4.0","person-gesture"],
    "1f64d":[["\uD83D\uDE4D"],"People & Body",261,["person_frowning"],36,5,"0.6","person-gesture"],
    "1f64e-200d-2640-fe0f":[["\uD83D\uDE4E\u200D\u2640\uFE0F"],"People & Body",266,["woman-pouting"],36,11,"4.0","person-gesture"],
    "1f64e-200d-2642-fe0f":[["\uD83D\uDE4E\u200D\u2642\uFE0F"],"People & Body",265,["man-pouting"],36,17,"4.0","person-gesture"],
    "1f64e":[["\uD83D\uDE4E"],"People & Body",264,["person_with_pouting_face"],36,23,"0.6","person-gesture"],
    "1f64f":[["\uD83D\uDE4F"],"People & Body",211,["pray"],36,29,"0.6","hands"],
    "1f680":[["\uD83D\uDE80"],"Travel & Places",993,["rocket"],36,35,"0.6","transport-air"],
    "1f681":[["\uD83D\uDE81"],"Travel & Places",988,["helicopter"],36,36,"1.0","transport-air"],
    "1f682":[["\uD83D\uDE82"],"Travel & Places",923,["steam_locomotive"],36,37,"1.0","transport-ground"],
    "1f683":[["\uD83D\uDE83"],"Travel & Places",924,["railway_car"],36,38,"0.6","transport-ground"],
    "1f684":[["\uD83D\uDE84"],"Travel & Places",925,["bullettrain_side"],36,39,"0.6","transport-ground"],
    "1f685":[["\uD83D\uDE85"],"Travel & Places",926,["bullettrain_front"],36,40,"0.6","transport-ground"],
    "1f686":[["\uD83D\uDE86"],"Travel & Places",927,["train2"],36,41,"1.0","transport-ground"],
    "1f687":[["\uD83D\uDE87"],"Travel & Places",928,["metro"],36,42,"0.6","transport-ground"],
    "1f688":[["\uD83D\uDE88"],"Travel & Places",929,["light_rail"],36,43,"1.0","transport-ground"],
    "1f689":[["\uD83D\uDE89"],"Travel & Places",930,["station"],36,44,"0.6","transport-ground"],
    "1f68a":[["\uD83D\uDE8A"],"Travel & Places",931,["tram"],36,45,"1.0","transport-ground"],
    "1f68b":[["\uD83D\uDE8B"],"Travel & Places",934,["train"],36,46,"1.0","transport-ground"],
    "1f68c":[["\uD83D\uDE8C"],"Travel & Places",935,["bus"],36,47,"0.6","transport-ground"],
    "1f68d":[["\uD83D\uDE8D"],"Travel & Places",936,["oncoming_bus"],36,48,"0.7","transport-ground"],
    "1f68e":[["\uD83D\uDE8E"],"Travel & Places",937,["trolleybus"],36,49,"1.0","transport-ground"],
    "1f68f":[["\uD83D\uDE8F"],"Travel & Places",962,["busstop"],36,50,"0.6","transport-ground"],
    "1f690":[["\uD83D\uDE90"],"Travel & Places",938,["minibus"],36,51,"1.0","transport-ground"],
    "1f691":[["\uD83D\uDE91"],"Travel & Places",939,["ambulance"],36,52,"0.6","transport-ground"],
    "1f692":[["\uD83D\uDE92"],"Travel & Places",940,["fire_engine"],36,53,"0.6","transport-ground"],
    "1f693":[["\uD83D\uDE93"],"Travel & Places",941,["police_car"],36,54,"0.6","transport-ground"],
    "1f694":[["\uD83D\uDE94"],"Travel & Places",942,["oncoming_police_car"],36,55,"0.7","transport-ground"],
    "1f695":[["\uD83D\uDE95"],"Travel & Places",943,["taxi"],36,56,"0.6","transport-ground"],
    "1f696":[["\uD83D\uDE96"],"Travel & Places",944,["oncoming_taxi"],36,57,"1.0","transport-ground"],
    "1f697":[["\uD83D\uDE97"],"Travel & Places",945,["car","red_car"],36,58,"0.6","transport-ground"],
    "1f698":[["\uD83D\uDE98"],"Travel & Places",946,["oncoming_automobile"],36,59,"0.7","transport-ground"],
    "1f699":[["\uD83D\uDE99"],"Travel & Places",947,["blue_car"],36,60,"0.6","transport-ground"],
    "1f69a":[["\uD83D\uDE9A"],"Travel & Places",949,["truck"],36,61,"0.6","transport-ground"],
    "1f69b":[["\uD83D\uDE9B"],"Travel & Places",950,["articulated_lorry"],36,62,"1.0","transport-ground"],
    "1f69c":[["\uD83D\uDE9C"],"Travel & Places",951,["tractor"],37,0,"1.0","transport-ground"],
    "1f69d":[["\uD83D\uDE9D"],"Travel & Places",932,["monorail"],37,1,"1.0","transport-ground"],
    "1f69e":[["\uD83D\uDE9E"],"Travel & Places",933,["mountain_railway"],37,2,"1.0","transport-ground"],
    "1f69f":[["\uD83D\uDE9F"],"Travel & Places",989,["suspension_railway"],37,3,"1.0","transport-air"],
    "1f6a0":[["\uD83D\uDEA0"],"Travel & Places",990,["mountain_cableway"],37,4,"1.0","transport-air"],
    "1f6a1":[["\uD83D\uDEA1"],"Travel & Places",991,["aerial_tramway"],37,5,"1.0","transport-air"],
    "1f6a2":[["\uD83D\uDEA2"],"Travel & Places",981,["ship"],37,6,"0.6","transport-water"],
    "1f6a3-200d-2640-fe0f":[["\uD83D\uDEA3\u200D\u2640\uFE0F"],"People & Body",476,["woman-rowing-boat"],37,7,"4.0","person-sport"],
    "1f6a3-200d-2642-fe0f":[["\uD83D\uDEA3\u200D\u2642\uFE0F"],"People & Body",475,["man-rowing-boat"],37,13,"4.0","person-sport"],
    "1f6a3":[["\uD83D\uDEA3"],"People & Body",474,["rowboat"],37,19,"1.0","person-sport"],
    "1f6a4":[["\uD83D\uDEA4"],"Travel & Places",977,["speedboat"],37,25,"0.6","transport-water"],
    "1f6a5":[["\uD83D\uDEA5"],"Travel & Places",969,["traffic_light"],37,26,"0.6","transport-ground"],
    "1f6a6":[["\uD83D\uDEA6"],"Travel & Places",970,["vertical_traffic_light"],37,27,"1.0","transport-ground"],
    "1f6a7":[["\uD83D\uDEA7"],"Travel & Places",972,["construction"],37,28,"0.6","transport-ground"],
    "1f6a8":[["\uD83D\uDEA8"],"Travel & Places",968,["rotating_light"],37,29,"0.6","transport-ground"],
    "1f6a9":[["\uD83D\uDEA9"],"Flags",1651,["triangular_flag_on_post"],37,30,"0.6","flag"],
    "1f6aa":[["\uD83D\uDEAA"],"Objects",1392,["door"],37,31,"0.6","household"],
    "1f6ab":[["\uD83D\uDEAB"],"Symbols",1442,["no_entry_sign"],37,32,"0.6","warning"],
    "1f6ac":[["\uD83D\uDEAC"],"Objects",1417,["smoking"],37,33,"0.6","other-object"],
    "1f6ad":[["\uD83D\uDEAD"],"Symbols",1444,["no_smoking"],37,34,"0.6","warning"],
    "1f6ae":[["\uD83D\uDEAE"],"Symbols",1427,["put_litter_in_its_place"],37,35,"1.0","transport-sign"],
    "1f6af":[["\uD83D\uDEAF"],"Symbols",1445,["do_not_litter"],37,36,"1.0","warning"],
    "1f6b0":[["\uD83D\uDEB0"],"Symbols",1428,["potable_water"],37,37,"1.0","transport-sign"],
    "1f6b1":[["\uD83D\uDEB1"],"Symbols",1446,["non-potable_water"],37,38,"1.0","warning"],
    "1f6b2":[["\uD83D\uDEB2"],"Travel & Places",958,["bike"],37,39,"0.6","transport-ground"],
    "1f6b3":[["\uD83D\uDEB3"],"Symbols",1443,["no_bicycles"],37,40,"1.0","warning"],
    "1f6b4-200d-2640-fe0f":[["\uD83D\uDEB4\u200D\u2640\uFE0F"],"People & Body",488,["woman-biking"],37,41,"4.0","person-sport"],
    "1f6b4-200d-2642-fe0f":[["\uD83D\uDEB4\u200D\u2642\uFE0F"],"People & Body",487,["man-biking"],37,47,"4.0","person-sport"],
    "1f6b4":[["\uD83D\uDEB4"],"People & Body",486,["bicyclist"],37,53,"1.0","person-sport"],
    "1f6b5-200d-2640-fe0f":[["\uD83D\uDEB5\u200D\u2640\uFE0F"],"People & Body",491,["woman-mountain-biking"],37,59,"4.0","person-sport"],
    "1f6b5-200d-2642-fe0f":[["\uD83D\uDEB5\u200D\u2642\uFE0F"],"People & Body",490,["man-mountain-biking"],38,2,"4.0","person-sport"],
    "1f6b5":[["\uD83D\uDEB5"],"People & Body",489,["mountain_bicyclist"],38,8,"1.0","person-sport"],
    "1f6b6-200d-2640-fe0f":[["\uD83D\uDEB6\u200D\u2640\uFE0F"],"People & Body",414,["woman-walking"],38,14,"4.0","person-activity"],
    "1f6b6-200d-2640-fe0f-200d-27a1-fe0f":[["\uD83D\uDEB6\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"People & Body",416,["woman_walking_facing_right"],38,20,"15.1","person-activity"],
    "1f6b6-200d-2642-fe0f":[["\uD83D\uDEB6\u200D\u2642\uFE0F"],"People & Body",413,["man-walking"],38,26,"4.0","person-activity"],
    "1f6b6-200d-2642-fe0f-200d-27a1-fe0f":[["\uD83D\uDEB6\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"People & Body",417,["man_walking_facing_right"],38,32,"15.1","person-activity"],
    "1f6b6-200d-27a1-fe0f":[["\uD83D\uDEB6\u200D\u27A1\uFE0F"],"People & Body",415,["person_walking_facing_right"],38,38,"15.1","person-activity"],
    "1f6b6":[["\uD83D\uDEB6"],"People & Body",412,["walking"],38,44,"0.6","person-activity"],
    "1f6b7":[["\uD83D\uDEB7"],"Symbols",1447,["no_pedestrians"],38,50,"1.0","warning"],
    "1f6b8":[["\uD83D\uDEB8"],"Symbols",1440,["children_crossing"],38,51,"1.0","warning"],
    "1f6b9":[["\uD83D\uDEB9"],"Symbols",1430,["mens"],38,52,"0.6","transport-sign"],
    "1f6ba":[["\uD83D\uDEBA"],"Symbols",1431,["womens"],38,53,"0.6","transport-sign"],
    "1f6bb":[["\uD83D\uDEBB"],"Symbols",1432,["restroom"],38,54,"0.6","transport-sign"],
    "1f6bc":[["\uD83D\uDEBC"],"Symbols",1433,["baby_symbol"],38,55,"0.6","transport-sign"],
    "1f6bd":[["\uD83D\uDEBD"],"Objects",1399,["toilet"],38,56,"0.6","household"],
    "1f6be":[["\uD83D\uDEBE"],"Symbols",1434,["wc"],38,57,"0.6","transport-sign"],
    "1f6bf":[["\uD83D\uDEBF"],"Objects",1401,["shower"],38,58,"1.0","household"],
    "1f6c0":[["\uD83D\uDEC0"],"People & Body",510,["bath"],38,59,"0.6","person-resting"],
    "1f6c1":[["\uD83D\uDEC1"],"Objects",1402,["bathtub"],39,2,"1.0","household"],
    "1f6c2":[["\uD83D\uDEC2"],"Symbols",1435,["passport_control"],39,3,"1.0","transport-sign"],
    "1f6c3":[["\uD83D\uDEC3"],"Symbols",1436,["customs"],39,4,"1.0","transport-sign"],
    "1f6c4":[["\uD83D\uDEC4"],"Symbols",1437,["baggage_claim"],39,5,"1.0","transport-sign"],
    "1f6c5":[["\uD83D\uDEC5"],"Symbols",1438,["left_luggage"],39,6,"1.0","transport-sign"],
    "1f6cb-fe0f":[["\uD83D\uDECB\uFE0F"],"Objects",1397,["couch_and_lamp"],39,7,"0.7","household"],
    "1f6cc":[["\uD83D\uDECC"],"People & Body",511,["sleeping_accommodation"],39,8,"1.0","person-resting"],
    "1f6cd-fe0f":[["\uD83D\uDECD\uFE0F"],"Objects",1184,["shopping_bags"],39,14,"0.7","clothing"],
    "1f6ce-fe0f":[["\uD83D\uDECE\uFE0F"],"Travel & Places",995,["bellhop_bell"],39,15,"0.7","hotel"],
    "1f6cf-fe0f":[["\uD83D\uDECF\uFE0F"],"Objects",1396,["bed"],39,16,"0.7","household"],
    "1f6d0":[["\uD83D\uDED0"],"Symbols",1473,["place_of_worship"],39,17,"1.0","religion"],
    "1f6d1":[["\uD83D\uDED1"],"Travel & Places",971,["octagonal_sign"],39,18,"3.0","transport-ground"],
    "1f6d2":[["\uD83D\uDED2"],"Objects",1416,["shopping_trolley"],39,19,"3.0","household"],
    "1f6d5":[["\uD83D\uDED5"],"Travel & Places",902,["hindu_temple"],39,20,"12.0","place-religious"],
    "1f6d6":[["\uD83D\uDED6"],"Travel & Places",879,["hut"],39,21,"13.0","place-building"],
    "1f6d7":[["\uD83D\uDED7"],"Objects",1393,["elevator"],39,22,"13.0","household"],
    "1f6d8":[["\uD83D\uDED8"],"Travel & Places",865,["landslide"],39,23,"17.0","place-geographic"],
    "1f6dc":[["\uD83D\uDEDC"],"Symbols",1521,["wireless"],39,24,"15.0","av-symbol"],
    "1f6dd":[["\uD83D\uDEDD"],"Travel & Places",918,["playground_slide"],39,25,"14.0","place-other"],
    "1f6de":[["\uD83D\uDEDE"],"Travel & Places",967,["wheel"],39,26,"14.0","transport-ground"],
    "1f6df":[["\uD83D\uDEDF"],"Travel & Places",974,["ring_buoy"],39,27,"14.0","transport-water"],
    "1f6e0-fe0f":[["\uD83D\uDEE0\uFE0F"],"Objects",1355,["hammer_and_wrench"],39,28,"0.7","tool"],
    "1f6e1-fe0f":[["\uD83D\uDEE1\uFE0F"],"Objects",1361,["shield"],39,29,"0.7","tool"],
    "1f6e2-fe0f":[["\uD83D\uDEE2\uFE0F"],"Travel & Places",965,["oil_drum"],39,30,"0.7","transport-ground"],
    "1f6e3-fe0f":[["\uD83D\uDEE3\uFE0F"],"Travel & Places",963,["motorway"],39,31,"0.7","transport-ground"],
    "1f6e4-fe0f":[["\uD83D\uDEE4\uFE0F"],"Travel & Places",964,["railway_track"],39,32,"0.7","transport-ground"],
    "1f6e5-fe0f":[["\uD83D\uDEE5\uFE0F"],"Travel & Places",980,["motor_boat"],39,33,"0.7","transport-water"],
    "1f6e9-fe0f":[["\uD83D\uDEE9\uFE0F"],"Travel & Places",983,["small_airplane"],39,34,"0.7","transport-air"],
    "1f6eb":[["\uD83D\uDEEB"],"Travel & Places",984,["airplane_departure"],39,35,"1.0","transport-air"],
    "1f6ec":[["\uD83D\uDEEC"],"Travel & Places",985,["airplane_arriving"],39,36,"1.0","transport-air"],
    "1f6f0-fe0f":[["\uD83D\uDEF0\uFE0F"],"Travel & Places",992,["satellite"],39,37,"0.7","transport-air"],
    "1f6f3-fe0f":[["\uD83D\uDEF3\uFE0F"],"Travel & Places",978,["passenger_ship"],39,38,"0.7","transport-water"],
    "1f6f4":[["\uD83D\uDEF4"],"Travel & Places",959,["scooter"],39,39,"3.0","transport-ground"],
    "1f6f5":[["\uD83D\uDEF5"],"Travel & Places",954,["motor_scooter"],39,40,"3.0","transport-ground"],
    "1f6f6":[["\uD83D\uDEF6"],"Travel & Places",976,["canoe"],39,41,"3.0","transport-water"],
    "1f6f7":[["\uD83D\uDEF7"],"Activities",1127,["sled"],39,42,"5.0","sport"],
    "1f6f8":[["\uD83D\uDEF8"],"Travel & Places",994,["flying_saucer"],39,43,"5.0","transport-air"],
    "1f6f9":[["\uD83D\uDEF9"],"Travel & Places",960,["skateboard"],39,44,"11.0","transport-ground"],
    "1f6fa":[["\uD83D\uDEFA"],"Travel & Places",957,["auto_rickshaw"],39,45,"12.0","transport-ground"],
    "1f6fb":[["\uD83D\uDEFB"],"Travel & Places",948,["pickup_truck"],39,46,"13.0","transport-ground"],
    "1f6fc":[["\uD83D\uDEFC"],"Travel & Places",961,["roller_skate"],39,47,"13.0","transport-ground"],
    "1f7e0":[["\uD83D\uDFE0"],"Symbols",1617,["large_orange_circle"],39,48,"12.0","geometric"],
    "1f7e1":[["\uD83D\uDFE1"],"Symbols",1618,["large_yellow_circle"],39,49,"12.0","geometric"],
    "1f7e2":[["\uD83D\uDFE2"],"Symbols",1619,["large_green_circle"],39,50,"12.0","geometric"],
    "1f7e3":[["\uD83D\uDFE3"],"Symbols",1621,["large_purple_circle"],39,51,"12.0","geometric"],
    "1f7e4":[["\uD83D\uDFE4"],"Symbols",1622,["large_brown_circle"],39,52,"12.0","geometric"],
    "1f7e5":[["\uD83D\uDFE5"],"Symbols",1625,["large_red_square"],39,53,"12.0","geometric"],
    "1f7e6":[["\uD83D\uDFE6"],"Symbols",1629,["large_blue_square"],39,54,"12.0","geometric"],
    "1f7e7":[["\uD83D\uDFE7"],"Symbols",1626,["large_orange_square"],39,55,"12.0","geometric"],
    "1f7e8":[["\uD83D\uDFE8"],"Symbols",1627,["large_yellow_square"],39,56,"12.0","geometric"],
    "1f7e9":[["\uD83D\uDFE9"],"Symbols",1628,["large_green_square"],39,57,"12.0","geometric"],
    "1f7ea":[["\uD83D\uDFEA"],"Symbols",1630,["large_purple_square"],39,58,"12.0","geometric"],
    "1f7eb":[["\uD83D\uDFEB"],"Symbols",1631,["large_brown_square"],39,59,"12.0","geometric"],
    "1f7f0":[["\uD83D\uDFF0"],"Symbols",1531,["heavy_equals_sign"],39,60,"14.0","math"],
    "1f90c":[["\uD83E\uDD0C"],"People & Body",184,["pinched_fingers"],39,61,"13.0","hand-fingers-partial"],
    "1f90d":[["\uD83E\uDD0D"],"Smileys & Emotion",156,["white_heart"],40,4,"12.0","heart"],
    "1f90e":[["\uD83E\uDD0E"],"Smileys & Emotion",153,["brown_heart"],40,5,"12.0","heart"],
    "1f90f":[["\uD83E\uDD0F"],"People & Body",185,["pinching_hand"],40,6,"12.0","hand-fingers-partial"],
    "1f910":[["\uD83E\uDD10"],"Smileys & Emotion",37,["zipper_mouth_face"],40,12,"1.0","face-neutral-skeptical"],
    "1f911":[["\uD83E\uDD11"],"Smileys & Emotion",29,["money_mouth_face"],40,13,"1.0","face-tongue"],
    "1f912":[["\uD83E\uDD12"],"Smileys & Emotion",60,["face_with_thermometer"],40,14,"1.0","face-unwell"],
    "1f913":[["\uD83E\uDD13"],"Smileys & Emotion",75,["nerd_face"],40,15,"1.0","face-glasses"],
    "1f914":[["\uD83E\uDD14"],"Smileys & Emotion",35,["thinking_face"],40,16,"1.0","face-hand"],
    "1f915":[["\uD83E\uDD15"],"Smileys & Emotion",61,["face_with_head_bandage"],40,17,"1.0","face-unwell"],
    "1f916":[["\uD83E\uDD16"],"Smileys & Emotion",119,["robot_face"],40,18,"1.0","face-costume"],
    "1f917":[["\uD83E\uDD17"],"Smileys & Emotion",30,["hugging_face"],40,19,"1.0","face-hand"],
    "1f918":[["\uD83E\uDD18"],"People & Body",190,["the_horns","sign_of_the_horns"],40,20,"1.0","hand-fingers-partial"],
    "1f919":[["\uD83E\uDD19"],"People & Body",191,["call_me_hand"],40,26,"3.0","hand-fingers-partial"],
    "1f91a":[["\uD83E\uDD1A"],"People & Body",173,["raised_back_of_hand"],40,32,"3.0","hand-fingers-open"],
    "1f91b":[["\uD83E\uDD1B"],"People & Body",203,["left-facing_fist"],40,38,"3.0","hand-fingers-closed"],
    "1f91c":[["\uD83E\uDD1C"],"People & Body",204,["right-facing_fist"],40,44,"3.0","hand-fingers-closed"],
    "1f91d":[["\uD83E\uDD1D"],"People & Body",210,["handshake"],40,50,"3.0","hands"],
    "1f91e":[["\uD83E\uDD1E"],"People & Body",187,["crossed_fingers","hand_with_index_and_middle_fingers_crossed"],41,13,"3.0","hand-fingers-partial"],
    "1f91f":[["\uD83E\uDD1F"],"People & Body",189,["i_love_you_hand_sign"],41,19,"5.0","hand-fingers-partial"],
    "1f920":[["\uD83E\uDD20"],"Smileys & Emotion",71,["face_with_cowboy_hat"],41,25,"3.0","face-hat"],
    "1f921":[["\uD83E\uDD21"],"Smileys & Emotion",113,["clown_face"],41,26,"3.0","face-costume"],
    "1f922":[["\uD83E\uDD22"],"Smileys & Emotion",62,["nauseated_face"],41,27,"3.0","face-unwell"],
    "1f923":[["\uD83E\uDD23"],"Smileys & Emotion",7,["rolling_on_the_floor_laughing"],41,28,"3.0","face-smiling"],
    "1f924":[["\uD83E\uDD24"],"Smileys & Emotion",56,["drooling_face"],41,29,"3.0","face-sleepy"],
    "1f925":[["\uD83E\uDD25"],"Smileys & Emotion",49,["lying_face"],41,30,"3.0","face-neutral-skeptical"],
    "1f926-200d-2640-fe0f":[["\uD83E\uDD26\u200D\u2640\uFE0F"],"People & Body",287,["woman-facepalming"],41,31,"4.0","person-gesture"],
    "1f926-200d-2642-fe0f":[["\uD83E\uDD26\u200D\u2642\uFE0F"],"People & Body",286,["man-facepalming"],41,37,"4.0","person-gesture"],
    "1f926":[["\uD83E\uDD26"],"People & Body",285,["face_palm"],41,43,"3.0","person-gesture"],
    "1f927":[["\uD83E\uDD27"],"Smileys & Emotion",64,["sneezing_face"],41,49,"3.0","face-unwell"],
    "1f928":[["\uD83E\uDD28"],"Smileys & Emotion",38,["face_with_raised_eyebrow","face_with_one_eyebrow_raised"],41,50,"5.0","face-neutral-skeptical"],
    "1f929":[["\uD83E\uDD29"],"Smileys & Emotion",17,["star-struck","grinning_face_with_star_eyes"],41,51,"5.0","face-affection"],
    "1f92a":[["\uD83E\uDD2A"],"Smileys & Emotion",27,["zany_face","grinning_face_with_one_large_and_one_small_eye"],41,52,"5.0","face-tongue"],
    "1f92b":[["\uD83E\uDD2B"],"Smileys & Emotion",34,["shushing_face","face_with_finger_covering_closed_lips"],41,53,"5.0","face-hand"],
    "1f92c":[["\uD83E\uDD2C"],"Smileys & Emotion",107,["face_with_symbols_on_mouth","serious_face_with_symbols_covering_mouth"],41,54,"5.0","face-negative"],
    "1f92d":[["\uD83E\uDD2D"],"Smileys & Emotion",31,["face_with_hand_over_mouth","smiling_face_with_smiling_eyes_and_hand_covering_mouth"],41,55,"5.0","face-hand"],
    "1f92e":[["\uD83E\uDD2E"],"Smileys & Emotion",63,["face_vomiting","face_with_open_mouth_vomiting"],41,56,"5.0","face-unwell"],
    "1f92f":[["\uD83E\uDD2F"],"Smileys & Emotion",70,["exploding_head","shocked_face_with_exploding_head"],41,57,"5.0","face-unwell"],
    "1f930":[["\uD83E\uDD30"],"People & Body",366,["pregnant_woman"],41,58,"3.0","person-role"],
    "1f931":[["\uD83E\uDD31"],"People & Body",369,["breast-feeding"],42,1,"5.0","person-role"],
    "1f932":[["\uD83E\uDD32"],"People & Body",209,["palms_up_together"],42,7,"5.0","hands"],
    "1f933":[["\uD83E\uDD33"],"People & Body",214,["selfie"],42,13,"3.0","hand-prop"],
    "1f934":[["\uD83E\uDD34"],"People & Body",353,["prince"],42,19,"3.0","person-role"],
    "1f935-200d-2640-fe0f":[["\uD83E\uDD35\u200D\u2640\uFE0F"],"People & Body",362,["woman_in_tuxedo"],42,25,"13.0","person-role"],
    "1f935-200d-2642-fe0f":[["\uD83E\uDD35\u200D\u2642\uFE0F"],"People & Body",361,["man_in_tuxedo"],42,31,"13.0","person-role"],
    "1f935":[["\uD83E\uDD35"],"People & Body",360,["person_in_tuxedo"],42,37,"3.0","person-role"],
    "1f936":[["\uD83E\uDD36"],"People & Body",375,["mrs_claus","mother_christmas"],42,43,"3.0","person-fantasy"],
    "1f937-200d-2640-fe0f":[["\uD83E\uDD37\u200D\u2640\uFE0F"],"People & Body",290,["woman-shrugging"],42,49,"4.0","person-gesture"],
    "1f937-200d-2642-fe0f":[["\uD83E\uDD37\u200D\u2642\uFE0F"],"People & Body",289,["man-shrugging"],42,55,"4.0","person-gesture"],
    "1f937":[["\uD83E\uDD37"],"People & Body",288,["shrug"],42,61,"3.0","person-gesture"],
    "1f938-200d-2640-fe0f":[["\uD83E\uDD38\u200D\u2640\uFE0F"],"People & Body",494,["woman-cartwheeling"],43,4,"4.0","person-sport"],
    "1f938-200d-2642-fe0f":[["\uD83E\uDD38\u200D\u2642\uFE0F"],"People & Body",493,["man-cartwheeling"],43,10,"4.0","person-sport"],
    "1f938":[["\uD83E\uDD38"],"People & Body",492,["person_doing_cartwheel"],43,16,"3.0","person-sport"],
    "1f939-200d-2640-fe0f":[["\uD83E\uDD39\u200D\u2640\uFE0F"],"People & Body",506,["woman-juggling"],43,22,"4.0","person-sport"],
    "1f939-200d-2642-fe0f":[["\uD83E\uDD39\u200D\u2642\uFE0F"],"People & Body",505,["man-juggling"],43,28,"4.0","person-sport"],
    "1f939":[["\uD83E\uDD39"],"People & Body",504,["juggling"],43,34,"3.0","person-sport"],
    "1f93a":[["\uD83E\uDD3A"],"People & Body",464,["fencer"],43,40,"3.0","person-sport"],
    "1f93c-200d-2640-fe0f":[["\uD83E\uDD3C\u200D\u2640\uFE0F"],"People & Body",497,["woman-wrestling"],43,41,"4.0","person-sport"],
    "1f93c-200d-2642-fe0f":[["\uD83E\uDD3C\u200D\u2642\uFE0F"],"People & Body",496,["man-wrestling"],44,4,"4.0","person-sport"],
    "1f93c":[["\uD83E\uDD3C"],"People & Body",495,["wrestlers"],44,30,"3.0","person-sport"],
    "1f93d-200d-2640-fe0f":[["\uD83E\uDD3D\u200D\u2640\uFE0F"],"People & Body",500,["woman-playing-water-polo"],44,56,"4.0","person-sport"],
    "1f93d-200d-2642-fe0f":[["\uD83E\uDD3D\u200D\u2642\uFE0F"],"People & Body",499,["man-playing-water-polo"],44,62,"4.0","person-sport"],
    "1f93d":[["\uD83E\uDD3D"],"People & Body",498,["water_polo"],45,5,"3.0","person-sport"],
    "1f93e-200d-2640-fe0f":[["\uD83E\uDD3E\u200D\u2640\uFE0F"],"People & Body",503,["woman-playing-handball"],45,11,"4.0","person-sport"],
    "1f93e-200d-2642-fe0f":[["\uD83E\uDD3E\u200D\u2642\uFE0F"],"People & Body",502,["man-playing-handball"],45,17,"4.0","person-sport"],
    "1f93e":[["\uD83E\uDD3E"],"People & Body",501,["handball"],45,23,"3.0","person-sport"],
    "1f93f":[["\uD83E\uDD3F"],"Activities",1124,["diving_mask"],45,29,"12.0","sport"],
    "1f940":[["\uD83E\uDD40"],"Animals & Nature",702,["wilted_flower"],45,30,"3.0","plant-flower"],
    "1f941":[["\uD83E\uDD41"],"Objects",1233,["drum_with_drumsticks"],45,31,"3.0","musical-instrument"],
    "1f942":[["\uD83E\uDD42"],"Food & Drink",841,["clinking_glasses"],45,32,"3.0","drink"],
    "1f943":[["\uD83E\uDD43"],"Food & Drink",842,["tumbler_glass"],45,33,"3.0","drink"],
    "1f944":[["\uD83E\uDD44"],"Food & Drink",852,["spoon"],45,34,"3.0","dishware"],
    "1f945":[["\uD83E\uDD45"],"Activities",1120,["goal_net"],45,35,"3.0","sport"],
    "1f947":[["\uD83E\uDD47"],"Activities",1099,["first_place_medal"],45,36,"3.0","award-medal"],
    "1f948":[["\uD83E\uDD48"],"Activities",1100,["second_place_medal"],45,37,"3.0","award-medal"],
    "1f949":[["\uD83E\uDD49"],"Activities",1101,["third_place_medal"],45,38,"3.0","award-medal"],
    "1f94a":[["\uD83E\uDD4A"],"Activities",1118,["boxing_glove"],45,39,"3.0","sport"],
    "1f94b":[["\uD83E\uDD4B"],"Activities",1119,["martial_arts_uniform"],45,40,"3.0","sport"],
    "1f94c":[["\uD83E\uDD4C"],"Activities",1128,["curling_stone"],45,41,"5.0","sport"],
    "1f94d":[["\uD83E\uDD4D"],"Activities",1115,["lacrosse"],45,42,"11.0","sport"],
    "1f94e":[["\uD83E\uDD4E"],"Activities",1104,["softball"],45,43,"11.0","sport"],
    "1f94f":[["\uD83E\uDD4F"],"Activities",1110,["flying_disc"],45,44,"11.0","sport"],
    "1f950":[["\uD83E\uDD50"],"Food & Drink",765,["croissant"],45,45,"3.0","food-prepared"],
    "1f951":[["\uD83E\uDD51"],"Food & Drink",745,["avocado"],45,46,"3.0","food-vegetable"],
    "1f952":[["\uD83E\uDD52"],"Food & Drink",752,["cucumber"],45,47,"3.0","food-vegetable"],
    "1f953":[["\uD83E\uDD53"],"Food & Drink",776,["bacon"],45,48,"3.0","food-prepared"],
    "1f954":[["\uD83E\uDD54"],"Food & Drink",747,["potato"],45,49,"3.0","food-vegetable"],
    "1f955":[["\uD83E\uDD55"],"Food & Drink",748,["carrot"],45,50,"3.0","food-vegetable"],
    "1f956":[["\uD83E\uDD56"],"Food & Drink",766,["baguette_bread"],45,51,"3.0","food-prepared"],
    "1f957":[["\uD83E\uDD57"],"Food & Drink",793,["green_salad"],45,52,"3.0","food-prepared"],
    "1f958":[["\uD83E\uDD58"],"Food & Drink",789,["shallow_pan_of_food"],45,53,"3.0","food-prepared"],
    "1f959":[["\uD83E\uDD59"],"Food & Drink",785,["stuffed_flatbread"],45,54,"3.0","food-prepared"],
    "1f95a":[["\uD83E\uDD5A"],"Food & Drink",787,["egg"],45,55,"3.0","food-prepared"],
    "1f95b":[["\uD83E\uDD5B"],"Food & Drink",830,["glass_of_milk"],45,56,"3.0","drink"],
    "1f95c":[["\uD83E\uDD5C"],"Food & Drink",757,["peanuts"],45,57,"3.0","food-vegetable"],
    "1f95d":[["\uD83E\uDD5D"],"Food & Drink",741,["kiwifruit"],45,58,"3.0","food-fruit"],
    "1f95e":[["\uD83E\uDD5E"],"Food & Drink",770,["pancakes"],45,59,"3.0","food-prepared"],
    "1f95f":[["\uD83E\uDD5F"],"Food & Drink",812,["dumpling"],45,60,"5.0","food-asian"],
    "1f960":[["\uD83E\uDD60"],"Food & Drink",813,["fortune_cookie"],45,61,"5.0","food-asian"],
    "1f961":[["\uD83E\uDD61"],"Food & Drink",814,["takeout_box"],45,62,"5.0","food-asian"],
    "1f962":[["\uD83E\uDD62"],"Food & Drink",849,["chopsticks"],46,0,"5.0","dishware"],
    "1f963":[["\uD83E\uDD63"],"Food & Drink",792,["bowl_with_spoon"],46,1,"5.0","food-prepared"],
    "1f964":[["\uD83E\uDD64"],"Food & Drink",844,["cup_with_straw"],46,2,"5.0","drink"],
    "1f965":[["\uD83E\uDD65"],"Food & Drink",744,["coconut"],46,3,"5.0","food-fruit"],
    "1f966":[["\uD83E\uDD66"],"Food & Drink",754,["broccoli"],46,4,"5.0","food-vegetable"],
    "1f967":[["\uD83E\uDD67"],"Food & Drink",823,["pie"],46,5,"5.0","food-sweet"],
    "1f968":[["\uD83E\uDD68"],"Food & Drink",768,["pretzel"],46,6,"5.0","food-prepared"],
    "1f969":[["\uD83E\uDD69"],"Food & Drink",775,["cut_of_meat"],46,7,"5.0","food-prepared"],
    "1f96a":[["\uD83E\uDD6A"],"Food & Drink",781,["sandwich"],46,8,"5.0","food-prepared"],
    "1f96b":[["\uD83E\uDD6B"],"Food & Drink",797,["canned_food"],46,9,"5.0","food-prepared"],
    "1f96c":[["\uD83E\uDD6C"],"Food & Drink",753,["leafy_green"],46,10,"11.0","food-vegetable"],
    "1f96d":[["\uD83E\uDD6D"],"Food & Drink",733,["mango"],46,11,"11.0","food-fruit"],
    "1f96e":[["\uD83E\uDD6E"],"Food & Drink",810,["moon_cake"],46,12,"11.0","food-asian"],
    "1f96f":[["\uD83E\uDD6F"],"Food & Drink",769,["bagel"],46,13,"11.0","food-prepared"],
    "1f970":[["\uD83E\uDD70"],"Smileys & Emotion",15,["smiling_face_with_3_hearts"],46,14,"11.0","face-affection"],
    "1f971":[["\uD83E\uDD71"],"Smileys & Emotion",103,["yawning_face"],46,15,"12.0","face-concerned"],
    "1f972":[["\uD83E\uDD72"],"Smileys & Emotion",23,["smiling_face_with_tear"],46,16,"13.0","face-affection"],
    "1f973":[["\uD83E\uDD73"],"Smileys & Emotion",72,["partying_face"],46,17,"11.0","face-hat"],
    "1f974":[["\uD83E\uDD74"],"Smileys & Emotion",67,["woozy_face"],46,18,"11.0","face-unwell"],
    "1f975":[["\uD83E\uDD75"],"Smileys & Emotion",65,["hot_face"],46,19,"11.0","face-unwell"],
    "1f976":[["\uD83E\uDD76"],"Smileys & Emotion",66,["cold_face"],46,20,"11.0","face-unwell"],
    "1f977":[["\uD83E\uDD77"],"People & Body",348,["ninja"],46,21,"13.0","person-role"],
    "1f978":[["\uD83E\uDD78"],"Smileys & Emotion",73,["disguised_face"],46,27,"13.0","face-hat"],
    "1f979":[["\uD83E\uDD79"],"Smileys & Emotion",88,["face_holding_back_tears"],46,28,"14.0","face-concerned"],
    "1f97a":[["\uD83E\uDD7A"],"Smileys & Emotion",87,["pleading_face"],46,29,"11.0","face-concerned"],
    "1f97b":[["\uD83E\uDD7B"],"Objects",1174,["sari"],46,30,"12.0","clothing"],
    "1f97c":[["\uD83E\uDD7C"],"Objects",1163,["lab_coat"],46,31,"11.0","clothing"],
    "1f97d":[["\uD83E\uDD7D"],"Objects",1162,["goggles"],46,32,"11.0","clothing"],
    "1f97e":[["\uD83E\uDD7E"],"Objects",1189,["hiking_boot"],46,33,"11.0","clothing"],
    "1f97f":[["\uD83E\uDD7F"],"Objects",1190,["womans_flat_shoe"],46,34,"11.0","clothing"],
    "1f980":[["\uD83E\uDD80"],"Animals & Nature",675,["crab"],46,35,"1.0","animal-marine"],
    "1f981":[["\uD83E\uDD81"],"Animals & Nature",580,["lion_face"],46,36,"1.0","animal-mammal"],
    "1f982":[["\uD83E\uDD82"],"Animals & Nature",691,["scorpion"],46,37,"1.0","animal-bug"],
    "1f983":[["\uD83E\uDD83"],"Animals & Nature",631,["turkey"],46,38,"1.0","animal-bird"],
    "1f984":[["\uD83E\uDD84"],"Animals & Nature",588,["unicorn_face"],46,39,"1.0","animal-mammal"],
    "1f985":[["\uD83E\uDD85"],"Animals & Nature",640,["eagle"],46,40,"3.0","animal-bird"],
    "1f986":[["\uD83E\uDD86"],"Animals & Nature",641,["duck"],46,41,"3.0","animal-bird"],
    "1f987":[["\uD83E\uDD87"],"Animals & Nature",620,["bat"],46,42,"3.0","animal-mammal"],
    "1f988":[["\uD83E\uDD88"],"Animals & Nature",670,["shark"],46,43,"3.0","animal-marine"],
    "1f989":[["\uD83E\uDD89"],"Animals & Nature",643,["owl"],46,44,"3.0","animal-bird"],
    "1f98a":[["\uD83E\uDD8A"],"Animals & Nature",575,["fox_face"],46,45,"3.0","animal-mammal"],
    "1f98b":[["\uD83E\uDD8B"],"Animals & Nature",681,["butterfly"],46,46,"3.0","animal-bug"],
    "1f98c":[["\uD83E\uDD8C"],"Animals & Nature",590,["deer"],46,47,"3.0","animal-mammal"],
    "1f98d":[["\uD83E\uDD8D"],"Animals & Nature",567,["gorilla"],46,48,"3.0","animal-mammal"],
    "1f98e":[["\uD83E\uDD8E"],"Animals & Nature",656,["lizard"],46,49,"3.0","animal-reptile"],
    "1f98f":[["\uD83E\uDD8F"],"Animals & Nature",609,["rhinoceros"],46,50,"3.0","animal-mammal"],
    "1f990":[["\uD83E\uDD90"],"Animals & Nature",677,["shrimp"],46,51,"3.0","animal-marine"],
    "1f991":[["\uD83E\uDD91"],"Animals & Nature",678,["squid"],46,52,"3.0","animal-marine"],
    "1f992":[["\uD83E\uDD92"],"Animals & Nature",606,["giraffe_face"],46,53,"5.0","animal-mammal"],
    "1f993":[["\uD83E\uDD93"],"Animals & Nature",589,["zebra_face"],46,54,"5.0","animal-mammal"],
    "1f994":[["\uD83E\uDD94"],"Animals & Nature",619,["hedgehog"],46,55,"5.0","animal-mammal"],
    "1f995":[["\uD83E\uDD95"],"Animals & Nature",660,["sauropod"],46,56,"5.0","animal-reptile"],
    "1f996":[["\uD83E\uDD96"],"Animals & Nature",661,["t-rex"],46,57,"5.0","animal-reptile"],
    "1f997":[["\uD83E\uDD97"],"Animals & Nature",687,["cricket"],46,58,"5.0","animal-bug"],
    "1f998":[["\uD83E\uDD98"],"Animals & Nature",628,["kangaroo"],46,59,"11.0","animal-mammal"],
    "1f999":[["\uD83E\uDD99"],"Animals & Nature",605,["llama"],46,60,"11.0","animal-mammal"],
    "1f99a":[["\uD83E\uDD9A"],"Animals & Nature",647,["peacock"],46,61,"11.0","animal-bird"],
    "1f99b":[["\uD83E\uDD9B"],"Animals & Nature",610,["hippopotamus"],46,62,"11.0","animal-mammal"],
    "1f99c":[["\uD83E\uDD9C"],"Animals & Nature",648,["parrot"],47,0,"11.0","animal-bird"],
    "1f99d":[["\uD83E\uDD9D"],"Animals & Nature",576,["raccoon"],47,1,"11.0","animal-mammal"],
    "1f99e":[["\uD83E\uDD9E"],"Animals & Nature",676,["lobster"],47,2,"11.0","animal-marine"],
    "1f99f":[["\uD83E\uDD9F"],"Animals & Nature",692,["mosquito"],47,3,"11.0","animal-bug"],
    "1f9a0":[["\uD83E\uDDA0"],"Animals & Nature",695,["microbe"],47,4,"11.0","animal-bug"],
    "1f9a1":[["\uD83E\uDDA1"],"Animals & Nature",629,["badger"],47,5,"11.0","animal-mammal"],
    "1f9a2":[["\uD83E\uDDA2"],"Animals & Nature",642,["swan"],47,6,"11.0","animal-bird"],
    "1f9a3":[["\uD83E\uDDA3"],"Animals & Nature",608,["mammoth"],47,7,"13.0","animal-mammal"],
    "1f9a4":[["\uD83E\uDDA4"],"Animals & Nature",644,["dodo"],47,8,"13.0","animal-bird"],
    "1f9a5":[["\uD83E\uDDA5"],"Animals & Nature",625,["sloth"],47,9,"12.0","animal-mammal"],
    "1f9a6":[["\uD83E\uDDA6"],"Animals & Nature",626,["otter"],47,10,"12.0","animal-mammal"],
    "1f9a7":[["\uD83E\uDDA7"],"Animals & Nature",568,["orangutan"],47,11,"12.0","animal-mammal"],
    "1f9a8":[["\uD83E\uDDA8"],"Animals & Nature",627,["skunk"],47,12,"12.0","animal-mammal"],
    "1f9a9":[["\uD83E\uDDA9"],"Animals & Nature",646,["flamingo"],47,13,"12.0","animal-bird"],
    "1f9aa":[["\uD83E\uDDAA"],"Animals & Nature",679,["oyster"],47,14,"12.0","animal-marine"],
    "1f9ab":[["\uD83E\uDDAB"],"Animals & Nature",618,["beaver"],47,15,"13.0","animal-mammal"],
    "1f9ac":[["\uD83E\uDDAC"],"Animals & Nature",591,["bison"],47,16,"13.0","animal-mammal"],
    "1f9ad":[["\uD83E\uDDAD"],"Animals & Nature",666,["seal"],47,17,"13.0","animal-marine"],
    "1f9ae":[["\uD83E\uDDAE"],"Animals & Nature",571,["guide_dog"],47,18,"12.0","animal-mammal"],
    "1f9af":[["\uD83E\uDDAF"],"Objects",1369,["probing_cane"],47,19,"12.0","tool"],
    "1f9b4":[["\uD83E\uDDB4"],"People & Body",227,["bone"],47,20,"11.0","body-parts"],
    "1f9b5":[["\uD83E\uDDB5"],"People & Body",218,["leg"],47,21,"11.0","body-parts"],
    "1f9b6":[["\uD83E\uDDB6"],"People & Body",219,["foot"],47,27,"11.0","body-parts"],
    "1f9b7":[["\uD83E\uDDB7"],"People & Body",226,["tooth"],47,33,"11.0","body-parts"],
    "1f9b8-200d-2640-fe0f":[["\uD83E\uDDB8\u200D\u2640\uFE0F"],"People & Body",379,["female_superhero"],47,34,"11.0","person-fantasy"],
    "1f9b8-200d-2642-fe0f":[["\uD83E\uDDB8\u200D\u2642\uFE0F"],"People & Body",378,["male_superhero"],47,40,"11.0","person-fantasy"],
    "1f9b8":[["\uD83E\uDDB8"],"People & Body",377,["superhero"],47,46,"11.0","person-fantasy"],
    "1f9b9-200d-2640-fe0f":[["\uD83E\uDDB9\u200D\u2640\uFE0F"],"People & Body",382,["female_supervillain"],47,52,"11.0","person-fantasy"],
    "1f9b9-200d-2642-fe0f":[["\uD83E\uDDB9\u200D\u2642\uFE0F"],"People & Body",381,["male_supervillain"],47,58,"11.0","person-fantasy"],
    "1f9b9":[["\uD83E\uDDB9"],"People & Body",380,["supervillain"],48,1,"11.0","person-fantasy"],
    "1f9ba":[["\uD83E\uDDBA"],"Objects",1164,["safety_vest"],48,7,"12.0","clothing"],
    "1f9bb":[["\uD83E\uDDBB"],"People & Body",221,["ear_with_hearing_aid"],48,8,"12.0","body-parts"],
    "1f9bc":[["\uD83E\uDDBC"],"Travel & Places",956,["motorized_wheelchair"],48,14,"12.0","transport-ground"],
    "1f9bd":[["\uD83E\uDDBD"],"Travel & Places",955,["manual_wheelchair"],48,15,"12.0","transport-ground"],
    "1f9be":[["\uD83E\uDDBE"],"People & Body",216,["mechanical_arm"],48,16,"12.0","body-parts"],
    "1f9bf":[["\uD83E\uDDBF"],"People & Body",217,["mechanical_leg"],48,17,"12.0","body-parts"],
    "1f9c0":[["\uD83E\uDDC0"],"Food & Drink",772,["cheese_wedge"],48,18,"1.0","food-prepared"],
    "1f9c1":[["\uD83E\uDDC1"],"Food & Drink",822,["cupcake"],48,19,"11.0","food-sweet"],
    "1f9c2":[["\uD83E\uDDC2"],"Food & Drink",796,["salt"],48,20,"11.0","food-prepared"],
    "1f9c3":[["\uD83E\uDDC3"],"Food & Drink",846,["beverage_box"],48,21,"12.0","drink"],
    "1f9c4":[["\uD83E\uDDC4"],"Food & Drink",755,["garlic"],48,22,"12.0","food-vegetable"],
    "1f9c5":[["\uD83E\uDDC5"],"Food & Drink",756,["onion"],48,23,"12.0","food-vegetable"],
    "1f9c6":[["\uD83E\uDDC6"],"Food & Drink",786,["falafel"],48,24,"12.0","food-prepared"],
    "1f9c7":[["\uD83E\uDDC7"],"Food & Drink",771,["waffle"],48,25,"12.0","food-prepared"],
    "1f9c8":[["\uD83E\uDDC8"],"Food & Drink",795,["butter"],48,26,"12.0","food-prepared"],
    "1f9c9":[["\uD83E\uDDC9"],"Food & Drink",847,["mate_drink"],48,27,"12.0","drink"],
    "1f9ca":[["\uD83E\uDDCA"],"Food & Drink",848,["ice_cube"],48,28,"12.0","drink"],
    "1f9cb":[["\uD83E\uDDCB"],"Food & Drink",845,["bubble_tea"],48,29,"13.0","drink"],
    "1f9cc":[["\uD83E\uDDCC"],"People & Body",404,["troll"],48,30,"14.0","person-fantasy"],
    "1f9cd-200d-2640-fe0f":[["\uD83E\uDDCD\u200D\u2640\uFE0F"],"People & Body",420,["woman_standing"],48,31,"12.0","person-activity"],
    "1f9cd-200d-2642-fe0f":[["\uD83E\uDDCD\u200D\u2642\uFE0F"],"People & Body",419,["man_standing"],48,37,"12.0","person-activity"],
    "1f9cd":[["\uD83E\uDDCD"],"People & Body",418,["standing_person"],48,43,"12.0","person-activity"],
    "1f9ce-200d-2640-fe0f":[["\uD83E\uDDCE\u200D\u2640\uFE0F"],"People & Body",423,["woman_kneeling"],48,49,"12.0","person-activity"],
    "1f9ce-200d-2640-fe0f-200d-27a1-fe0f":[["\uD83E\uDDCE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"People & Body",425,["woman_kneeling_facing_right"],48,55,"15.1","person-activity"],
    "1f9ce-200d-2642-fe0f":[["\uD83E\uDDCE\u200D\u2642\uFE0F"],"People & Body",422,["man_kneeling"],48,61,"12.0","person-activity"],
    "1f9ce-200d-2642-fe0f-200d-27a1-fe0f":[["\uD83E\uDDCE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"People & Body",426,["man_kneeling_facing_right"],49,4,"15.1","person-activity"],
    "1f9ce-200d-27a1-fe0f":[["\uD83E\uDDCE\u200D\u27A1\uFE0F"],"People & Body",424,["person_kneeling_facing_right"],49,10,"15.1","person-activity"],
    "1f9ce":[["\uD83E\uDDCE"],"People & Body",421,["kneeling_person"],49,16,"12.0","person-activity"],
    "1f9cf-200d-2640-fe0f":[["\uD83E\uDDCF\u200D\u2640\uFE0F"],"People & Body",281,["deaf_woman"],49,22,"12.0","person-gesture"],
    "1f9cf-200d-2642-fe0f":[["\uD83E\uDDCF\u200D\u2642\uFE0F"],"People & Body",280,["deaf_man"],49,28,"12.0","person-gesture"],
    "1f9cf":[["\uD83E\uDDCF"],"People & Body",279,["deaf_person"],49,34,"12.0","person-gesture"],
    "1f9d0":[["\uD83E\uDDD0"],"Smileys & Emotion",76,["face_with_monocle"],49,40,"5.0","face-glasses"],
    "1f9d1-200d-1f33e":[["\uD83E\uDDD1\u200D\uD83C\uDF3E"],"People & Body",303,["farmer"],49,41,"12.1","person-role"],
    "1f9d1-200d-1f373":[["\uD83E\uDDD1\u200D\uD83C\uDF73"],"People & Body",306,["cook"],49,47,"12.1","person-role"],
    "1f9d1-200d-1f37c":[["\uD83E\uDDD1\u200D\uD83C\uDF7C"],"People & Body",372,["person_feeding_baby"],49,53,"13.0","person-role"],
    "1f9d1-200d-1f384":[["\uD83E\uDDD1\u200D\uD83C\uDF84"],"People & Body",376,["mx_claus"],49,59,"13.0","person-fantasy"],
    "1f9d1-200d-1f393":[["\uD83E\uDDD1\u200D\uD83C\uDF93"],"People & Body",294,["student"],50,2,"12.1","person-role"],
    "1f9d1-200d-1f3a4":[["\uD83E\uDDD1\u200D\uD83C\uDFA4"],"People & Body",324,["singer"],50,8,"12.1","person-role"],
    "1f9d1-200d-1f3a8":[["\uD83E\uDDD1\u200D\uD83C\uDFA8"],"People & Body",327,["artist"],50,14,"12.1","person-role"],
    "1f9d1-200d-1f3eb":[["\uD83E\uDDD1\u200D\uD83C\uDFEB"],"People & Body",297,["teacher"],50,20,"12.1","person-role"],
    "1f9d1-200d-1f3ed":[["\uD83E\uDDD1\u200D\uD83C\uDFED"],"People & Body",312,["factory_worker"],50,26,"12.1","person-role"],
    "1f9d1-200d-1f4bb":[["\uD83E\uDDD1\u200D\uD83D\uDCBB"],"People & Body",321,["technologist"],50,32,"12.1","person-role"],
    "1f9d1-200d-1f4bc":[["\uD83E\uDDD1\u200D\uD83D\uDCBC"],"People & Body",315,["office_worker"],50,38,"12.1","person-role"],
    "1f9d1-200d-1f527":[["\uD83E\uDDD1\u200D\uD83D\uDD27"],"People & Body",309,["mechanic"],50,44,"12.1","person-role"],
    "1f9d1-200d-1f52c":[["\uD83E\uDDD1\u200D\uD83D\uDD2C"],"People & Body",318,["scientist"],50,50,"12.1","person-role"],
    "1f9d1-200d-1f680":[["\uD83E\uDDD1\u200D\uD83D\uDE80"],"People & Body",333,["astronaut"],50,56,"12.1","person-role"],
    "1f9d1-200d-1f692":[["\uD83E\uDDD1\u200D\uD83D\uDE92"],"People & Body",336,["firefighter"],50,62,"12.1","person-role"],
    "1f9d1-200d-1f91d-200d-1f9d1":[["\uD83E\uDDD1\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1"],"People & Body",512,["people_holding_hands"],51,5,"12.0","family"],
    "1f9d1-200d-1f9af-200d-27a1-fe0f":[["\uD83E\uDDD1\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"People & Body",428,["person_with_white_cane_facing_right"],51,31,"15.1","person-activity"],
    "1f9d1-200d-1f9af":[["\uD83E\uDDD1\u200D\uD83E\uDDAF"],"People & Body",427,["person_with_probing_cane"],51,37,"12.1","person-activity"],
    "1f9d1-200d-1f9b0":[["\uD83E\uDDD1\u200D\uD83E\uDDB0"],"People & Body",249,["red_haired_person"],51,43,"12.1","person"],
    "1f9d1-200d-1f9b1":[["\uD83E\uDDD1\u200D\uD83E\uDDB1"],"People & Body",251,["curly_haired_person"],51,49,"12.1","person"],
    "1f9d1-200d-1f9b2":[["\uD83E\uDDD1\u200D\uD83E\uDDB2"],"People & Body",255,["bald_person"],51,55,"12.1","person"],
    "1f9d1-200d-1f9b3":[["\uD83E\uDDD1\u200D\uD83E\uDDB3"],"People & Body",253,["white_haired_person"],51,61,"12.1","person"],
    "1f9d1-200d-1f9bc-200d-27a1-fe0f":[["\uD83E\uDDD1\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"People & Body",434,["person_in_motorized_wheelchair_facing_right"],52,4,"15.1","person-activity"],
    "1f9d1-200d-1f9bc":[["\uD83E\uDDD1\u200D\uD83E\uDDBC"],"People & Body",433,["person_in_motorized_wheelchair"],52,10,"12.1","person-activity"],
    "1f9d1-200d-1f9bd-200d-27a1-fe0f":[["\uD83E\uDDD1\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"People & Body",440,["person_in_manual_wheelchair_facing_right"],52,16,"15.1","person-activity"],
    "1f9d1-200d-1f9bd":[["\uD83E\uDDD1\u200D\uD83E\uDDBD"],"People & Body",439,["person_in_manual_wheelchair"],52,22,"12.1","person-activity"],
    "1f9d1-200d-1f9d1-200d-1f9d2":[["\uD83E\uDDD1\u200D\uD83E\uDDD1\u200D\uD83E\uDDD2"],"People & Body",554,["family_adult_adult_child"],52,28,"15.1","person-symbol"],
    "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2":[["\uD83E\uDDD1\u200D\uD83E\uDDD1\u200D\uD83E\uDDD2\u200D\uD83E\uDDD2"],"People & Body",555,["family_adult_adult_child_child"],52,29,"15.1","person-symbol"],
    "1f9d1-200d-1f9d2-200d-1f9d2":[["\uD83E\uDDD1\u200D\uD83E\uDDD2\u200D\uD83E\uDDD2"],"People & Body",557,["family_adult_child_child"],52,30,"15.1","person-symbol"],
    "1f9d1-200d-1f9d2":[["\uD83E\uDDD1\u200D\uD83E\uDDD2"],"People & Body",556,["family_adult_child"],52,31,"15.1","person-symbol"],
    "1f9d1-200d-1fa70":[["\uD83E\uDDD1\u200D\uD83E\uDE70"],"People & Body",451,["ballet_dancer"],52,32,"17.0","person-activity"],
    "1f9d1-200d-2695-fe0f":[["\uD83E\uDDD1\u200D\u2695\uFE0F"],"People & Body",291,["health_worker"],52,38,"12.1","person-role"],
    "1f9d1-200d-2696-fe0f":[["\uD83E\uDDD1\u200D\u2696\uFE0F"],"People & Body",300,["judge"],52,44,"12.1","person-role"],
    "1f9d1-200d-2708-fe0f":[["\uD83E\uDDD1\u200D\u2708\uFE0F"],"People & Body",330,["pilot"],52,50,"12.1","person-role"],
    "1f9d1":[["\uD83E\uDDD1"],"People & Body",237,["adult"],52,56,"5.0","person"],
    "1f9d2":[["\uD83E\uDDD2"],"People & Body",234,["child"],52,62,"5.0","person"],
    "1f9d3":[["\uD83E\uDDD3"],"People & Body",258,["older_adult"],53,5,"5.0","person"],
    "1f9d4-200d-2640-fe0f":[["\uD83E\uDDD4\u200D\u2640\uFE0F"],"People & Body",242,["woman_with_beard"],53,11,"13.1","person"],
    "1f9d4-200d-2642-fe0f":[["\uD83E\uDDD4\u200D\u2642\uFE0F"],"People & Body",241,["man_with_beard"],53,17,"13.1","person"],
    "1f9d4":[["\uD83E\uDDD4"],"People & Body",240,["bearded_person"],53,23,"5.0","person"],
    "1f9d5":[["\uD83E\uDDD5"],"People & Body",359,["person_with_headscarf"],53,29,"5.0","person-role"],
    "1f9d6-200d-2640-fe0f":[["\uD83E\uDDD6\u200D\u2640\uFE0F"],"People & Body",460,["woman_in_steamy_room"],53,35,"5.0","person-activity"],
    "1f9d6-200d-2642-fe0f":[["\uD83E\uDDD6\u200D\u2642\uFE0F"],"People & Body",459,["man_in_steamy_room"],53,41,"5.0","person-activity"],
    "1f9d6":[["\uD83E\uDDD6"],"People & Body",458,["person_in_steamy_room"],53,47,"5.0","person-activity"],
    "1f9d7-200d-2640-fe0f":[["\uD83E\uDDD7\u200D\u2640\uFE0F"],"People & Body",463,["woman_climbing"],53,53,"5.0","person-activity"],
    "1f9d7-200d-2642-fe0f":[["\uD83E\uDDD7\u200D\u2642\uFE0F"],"People & Body",462,["man_climbing"],53,59,"5.0","person-activity"],
    "1f9d7":[["\uD83E\uDDD7"],"People & Body",461,["person_climbing"],54,2,"5.0","person-activity"],
    "1f9d8-200d-2640-fe0f":[["\uD83E\uDDD8\u200D\u2640\uFE0F"],"People & Body",509,["woman_in_lotus_position"],54,8,"5.0","person-resting"],
    "1f9d8-200d-2642-fe0f":[["\uD83E\uDDD8\u200D\u2642\uFE0F"],"People & Body",508,["man_in_lotus_position"],54,14,"5.0","person-resting"],
    "1f9d8":[["\uD83E\uDDD8"],"People & Body",507,["person_in_lotus_position"],54,20,"5.0","person-resting"],
    "1f9d9-200d-2640-fe0f":[["\uD83E\uDDD9\u200D\u2640\uFE0F"],"People & Body",385,["female_mage"],54,26,"5.0","person-fantasy"],
    "1f9d9-200d-2642-fe0f":[["\uD83E\uDDD9\u200D\u2642\uFE0F"],"People & Body",384,["male_mage"],54,32,"5.0","person-fantasy"],
    "1f9d9":[["\uD83E\uDDD9"],"People & Body",383,["mage"],54,38,"5.0","person-fantasy"],
    "1f9da-200d-2640-fe0f":[["\uD83E\uDDDA\u200D\u2640\uFE0F"],"People & Body",388,["female_fairy"],54,44,"5.0","person-fantasy"],
    "1f9da-200d-2642-fe0f":[["\uD83E\uDDDA\u200D\u2642\uFE0F"],"People & Body",387,["male_fairy"],54,50,"5.0","person-fantasy"],
    "1f9da":[["\uD83E\uDDDA"],"People & Body",386,["fairy"],54,56,"5.0","person-fantasy"],
    "1f9db-200d-2640-fe0f":[["\uD83E\uDDDB\u200D\u2640\uFE0F"],"People & Body",391,["female_vampire"],54,62,"5.0","person-fantasy"],
    "1f9db-200d-2642-fe0f":[["\uD83E\uDDDB\u200D\u2642\uFE0F"],"People & Body",390,["male_vampire"],55,5,"5.0","person-fantasy"],
    "1f9db":[["\uD83E\uDDDB"],"People & Body",389,["vampire"],55,11,"5.0","person-fantasy"],
    "1f9dc-200d-2640-fe0f":[["\uD83E\uDDDC\u200D\u2640\uFE0F"],"People & Body",394,["mermaid"],55,17,"5.0","person-fantasy"],
    "1f9dc-200d-2642-fe0f":[["\uD83E\uDDDC\u200D\u2642\uFE0F"],"People & Body",393,["merman"],55,23,"5.0","person-fantasy"],
    "1f9dc":[["\uD83E\uDDDC"],"People & Body",392,["merperson"],55,29,"5.0","person-fantasy"],
    "1f9dd-200d-2640-fe0f":[["\uD83E\uDDDD\u200D\u2640\uFE0F"],"People & Body",397,["female_elf"],55,35,"5.0","person-fantasy"],
    "1f9dd-200d-2642-fe0f":[["\uD83E\uDDDD\u200D\u2642\uFE0F"],"People & Body",396,["male_elf"],55,41,"5.0","person-fantasy"],
    "1f9dd":[["\uD83E\uDDDD"],"People & Body",395,["elf"],55,47,"5.0","person-fantasy"],
    "1f9de-200d-2640-fe0f":[["\uD83E\uDDDE\u200D\u2640\uFE0F"],"People & Body",400,["female_genie"],55,53,"5.0","person-fantasy"],
    "1f9de-200d-2642-fe0f":[["\uD83E\uDDDE\u200D\u2642\uFE0F"],"People & Body",399,["male_genie"],55,54,"5.0","person-fantasy"],
    "1f9de":[["\uD83E\uDDDE"],"People & Body",398,["genie"],55,55,"5.0","person-fantasy"],
    "1f9df-200d-2640-fe0f":[["\uD83E\uDDDF\u200D\u2640\uFE0F"],"People & Body",403,["female_zombie"],55,56,"5.0","person-fantasy"],
    "1f9df-200d-2642-fe0f":[["\uD83E\uDDDF\u200D\u2642\uFE0F"],"People & Body",402,["male_zombie"],55,57,"5.0","person-fantasy"],
    "1f9df":[["\uD83E\uDDDF"],"People & Body",401,["zombie"],55,58,"5.0","person-fantasy"],
    "1f9e0":[["\uD83E\uDDE0"],"People & Body",223,["brain"],55,59,"5.0","body-parts"],
    "1f9e1":[["\uD83E\uDDE1"],"Smileys & Emotion",147,["orange_heart"],55,60,"5.0","heart"],
    "1f9e2":[["\uD83E\uDDE2"],"Objects",1200,["billed_cap"],55,61,"5.0","clothing"],
    "1f9e3":[["\uD83E\uDDE3"],"Objects",1168,["scarf"],55,62,"5.0","clothing"],
    "1f9e4":[["\uD83E\uDDE4"],"Objects",1169,["gloves"],56,0,"5.0","clothing"],
    "1f9e5":[["\uD83E\uDDE5"],"Objects",1170,["coat"],56,1,"5.0","clothing"],
    "1f9e6":[["\uD83E\uDDE6"],"Objects",1171,["socks"],56,2,"5.0","clothing"],
    "1f9e7":[["\uD83E\uDDE7"],"Activities",1090,["red_envelope"],56,3,"11.0","event"],
    "1f9e8":[["\uD83E\uDDE8"],"Activities",1079,["firecracker"],56,4,"11.0","event"],
    "1f9e9":[["\uD83E\uDDE9"],"Activities",1140,["jigsaw"],56,5,"11.0","game"],
    "1f9ea":[["\uD83E\uDDEA"],"Objects",1379,["test_tube"],56,6,"11.0","science"],
    "1f9eb":[["\uD83E\uDDEB"],"Objects",1380,["petri_dish"],56,7,"11.0","science"],
    "1f9ec":[["\uD83E\uDDEC"],"Objects",1381,["dna"],56,8,"11.0","science"],
    "1f9ed":[["\uD83E\uDDED"],"Travel & Places",862,["compass"],56,9,"11.0","place-map"],
    "1f9ee":[["\uD83E\uDDEE"],"Objects",1257,["abacus"],56,10,"11.0","computer"],
    "1f9ef":[["\uD83E\uDDEF"],"Objects",1415,["fire_extinguisher"],56,11,"11.0","household"],
    "1f9f0":[["\uD83E\uDDF0"],"Objects",1374,["toolbox"],56,12,"11.0","tool"],
    "1f9f1":[["\uD83E\uDDF1"],"Travel & Places",876,["bricks"],56,13,"11.0","place-building"],
    "1f9f2":[["\uD83E\uDDF2"],"Objects",1375,["magnet"],56,14,"11.0","tool"],
    "1f9f3":[["\uD83E\uDDF3"],"Travel & Places",996,["luggage"],56,15,"11.0","hotel"],
    "1f9f4":[["\uD83E\uDDF4"],"Objects",1405,["lotion_bottle"],56,16,"11.0","household"],
    "1f9f5":[["\uD83E\uDDF5"],"Activities",1156,["thread"],56,17,"11.0","arts & crafts"],
    "1f9f6":[["\uD83E\uDDF6"],"Activities",1158,["yarn"],56,18,"11.0","arts & crafts"],
    "1f9f7":[["\uD83E\uDDF7"],"Objects",1406,["safety_pin"],56,19,"11.0","household"],
    "1f9f8":[["\uD83E\uDDF8"],"Activities",1141,["teddy_bear"],56,20,"11.0","game"],
    "1f9f9":[["\uD83E\uDDF9"],"Objects",1407,["broom"],56,21,"11.0","household"],
    "1f9fa":[["\uD83E\uDDFA"],"Objects",1408,["basket"],56,22,"11.0","household"],
    "1f9fb":[["\uD83E\uDDFB"],"Objects",1409,["roll_of_paper"],56,23,"11.0","household"],
    "1f9fc":[["\uD83E\uDDFC"],"Objects",1411,["soap"],56,24,"11.0","household"],
    "1f9fd":[["\uD83E\uDDFD"],"Objects",1414,["sponge"],56,25,"11.0","household"],
    "1f9fe":[["\uD83E\uDDFE"],"Objects",1300,["receipt"],56,26,"11.0","money"],
    "1f9ff":[["\uD83E\uDDFF"],"Objects",1421,["nazar_amulet"],56,27,"11.0","other-object"],
    "1fa70":[["\uD83E\uDE70"],"Objects",1193,["ballet_shoes"],56,28,"12.0","clothing"],
    "1fa71":[["\uD83E\uDE71"],"Objects",1175,["one-piece_swimsuit"],56,29,"12.0","clothing"],
    "1fa72":[["\uD83E\uDE72"],"Objects",1176,["briefs"],56,30,"12.0","clothing"],
    "1fa73":[["\uD83E\uDE73"],"Objects",1177,["shorts"],56,31,"12.0","clothing"],
    "1fa74":[["\uD83E\uDE74"],"Objects",1186,["thong_sandal"],56,32,"13.0","clothing"],
    "1fa75":[["\uD83E\uDE75"],"Smileys & Emotion",151,["light_blue_heart"],56,33,"15.0","heart"],
    "1fa76":[["\uD83E\uDE76"],"Smileys & Emotion",155,["grey_heart"],56,34,"15.0","heart"],
    "1fa77":[["\uD83E\uDE77"],"Smileys & Emotion",146,["pink_heart"],56,35,"15.0","heart"],
    "1fa78":[["\uD83E\uDE78"],"Objects",1386,["drop_of_blood"],56,36,"12.0","medical"],
    "1fa79":[["\uD83E\uDE79"],"Objects",1388,["adhesive_bandage"],56,37,"12.0","medical"],
    "1fa7a":[["\uD83E\uDE7A"],"Objects",1390,["stethoscope"],56,38,"12.0","medical"],
    "1fa7b":[["\uD83E\uDE7B"],"Objects",1391,["x-ray"],56,39,"14.0","medical"],
    "1fa7c":[["\uD83E\uDE7C"],"Objects",1389,["crutch"],56,40,"14.0","medical"],
    "1fa80":[["\uD83E\uDE80"],"Activities",1130,["yo-yo"],56,41,"12.0","game"],
    "1fa81":[["\uD83E\uDE81"],"Activities",1131,["kite"],56,42,"12.0","game"],
    "1fa82":[["\uD83E\uDE82"],"Travel & Places",986,["parachute"],56,43,"12.0","transport-air"],
    "1fa83":[["\uD83E\uDE83"],"Objects",1359,["boomerang"],56,44,"13.0","tool"],
    "1fa84":[["\uD83E\uDE84"],"Activities",1135,["magic_wand"],56,45,"13.0","game"],
    "1fa85":[["\uD83E\uDE85"],"Activities",1142,["pinata"],56,46,"13.0","game"],
    "1fa86":[["\uD83E\uDE86"],"Activities",1144,["nesting_dolls"],56,47,"13.0","game"],
    "1fa87":[["\uD83E\uDE87"],"Objects",1235,["maracas"],56,48,"15.0","musical-instrument"],
    "1fa88":[["\uD83E\uDE88"],"Objects",1236,["flute"],56,49,"15.0","musical-instrument"],
    "1fa89":[["\uD83E\uDE89"],"Objects",1237,["harp"],56,50,"16.0","musical-instrument"],
    "1fa8a":[["\uD83E\uDE8A"],"Objects",1227,["trombone"],56,51,"17.0","musical-instrument"],
    "1fa8e":[["\uD83E\uDE8E"],"Objects",1293,["treasure_chest"],56,52,"17.0","money"],
    "1fa8f":[["\uD83E\uDE8F"],"Objects",1377,["shovel"],56,53,"16.0","tool"],
    "1fa90":[["\uD83E\uDE90"],"Travel & Places",1044,["ringed_planet"],56,54,"12.0","sky & weather"],
    "1fa91":[["\uD83E\uDE91"],"Objects",1398,["chair"],56,55,"12.0","household"],
    "1fa92":[["\uD83E\uDE92"],"Objects",1404,["razor"],56,56,"12.0","household"],
    "1fa93":[["\uD83E\uDE93"],"Objects",1352,["axe"],56,57,"12.0","tool"],
    "1fa94":[["\uD83E\uDE94"],"Objects",1273,["diya_lamp"],56,58,"12.0","light & video"],
    "1fa95":[["\uD83E\uDE95"],"Objects",1232,["banjo"],56,59,"12.0","musical-instrument"],
    "1fa96":[["\uD83E\uDE96"],"Objects",1201,["military_helmet"],56,60,"13.0","clothing"],
    "1fa97":[["\uD83E\uDE97"],"Objects",1228,["accordion"],56,61,"13.0","musical-instrument"],
    "1fa98":[["\uD83E\uDE98"],"Objects",1234,["long_drum"],56,62,"13.0","musical-instrument"],
    "1fa99":[["\uD83E\uDE99"],"Objects",1291,["coin"],57,0,"13.0","money"],
    "1fa9a":[["\uD83E\uDE9A"],"Objects",1362,["carpentry_saw"],57,1,"13.0","tool"],
    "1fa9b":[["\uD83E\uDE9B"],"Objects",1364,["screwdriver"],57,2,"13.0","tool"],
    "1fa9c":[["\uD83E\uDE9C"],"Objects",1376,["ladder"],57,3,"13.0","tool"],
    "1fa9d":[["\uD83E\uDE9D"],"Objects",1373,["hook"],57,4,"13.0","tool"],
    "1fa9e":[["\uD83E\uDE9E"],"Objects",1394,["mirror"],57,5,"13.0","household"],
    "1fa9f":[["\uD83E\uDE9F"],"Objects",1395,["window"],57,6,"13.0","household"],
    "1faa0":[["\uD83E\uDEA0"],"Objects",1400,["plunger"],57,7,"13.0","household"],
    "1faa1":[["\uD83E\uDEA1"],"Activities",1157,["sewing_needle"],57,8,"13.0","arts & crafts"],
    "1faa2":[["\uD83E\uDEA2"],"Activities",1159,["knot"],57,9,"13.0","arts & crafts"],
    "1faa3":[["\uD83E\uDEA3"],"Objects",1410,["bucket"],57,10,"13.0","household"],
    "1faa4":[["\uD83E\uDEA4"],"Objects",1403,["mouse_trap"],57,11,"13.0","household"],
    "1faa5":[["\uD83E\uDEA5"],"Objects",1413,["toothbrush"],57,12,"13.0","household"],
    "1faa6":[["\uD83E\uDEA6"],"Objects",1419,["headstone"],57,13,"13.0","other-object"],
    "1faa7":[["\uD83E\uDEA7"],"Objects",1424,["placard"],57,14,"13.0","other-object"],
    "1faa8":[["\uD83E\uDEA8"],"Travel & Places",877,["rock"],57,15,"13.0","place-building"],
    "1faa9":[["\uD83E\uDEA9"],"Activities",1143,["mirror_ball"],57,16,"14.0","game"],
    "1faaa":[["\uD83E\uDEAA"],"Objects",1425,["identification_card"],57,17,"14.0","other-object"],
    "1faab":[["\uD83E\uDEAB"],"Objects",1245,["low_battery"],57,18,"14.0","computer"],
    "1faac":[["\uD83E\uDEAC"],"Objects",1422,["hamsa"],57,19,"14.0","other-object"],
    "1faad":[["\uD83E\uDEAD"],"Objects",1180,["folding_hand_fan"],57,20,"15.0","clothing"],
    "1faae":[["\uD83E\uDEAE"],"Objects",1195,["hair_pick"],57,21,"15.0","clothing"],
    "1faaf":[["\uD83E\uDEAF"],"Symbols",1485,["khanda"],57,22,"15.0","religion"],
    "1fab0":[["\uD83E\uDEB0"],"Animals & Nature",693,["fly"],57,23,"13.0","animal-bug"],
    "1fab1":[["\uD83E\uDEB1"],"Animals & Nature",694,["worm"],57,24,"13.0","animal-bug"],
    "1fab2":[["\uD83E\uDEB2"],"Animals & Nature",685,["beetle"],57,25,"13.0","animal-bug"],
    "1fab3":[["\uD83E\uDEB3"],"Animals & Nature",688,["cockroach"],57,26,"13.0","animal-bug"],
    "1fab4":[["\uD83E\uDEB4"],"Animals & Nature",709,["potted_plant"],57,27,"13.0","plant-other"],
    "1fab5":[["\uD83E\uDEB5"],"Travel & Places",878,["wood"],57,28,"13.0","place-building"],
    "1fab6":[["\uD83E\uDEB6"],"Animals & Nature",645,["feather"],57,29,"13.0","animal-bird"],
    "1fab7":[["\uD83E\uDEB7"],"Animals & Nature",699,["lotus"],57,30,"14.0","plant-flower"],
    "1fab8":[["\uD83E\uDEB8"],"Animals & Nature",673,["coral"],57,31,"14.0","animal-marine"],
    "1fab9":[["\uD83E\uDEB9"],"Animals & Nature",721,["empty_nest"],57,32,"14.0","plant-other"],
    "1faba":[["\uD83E\uDEBA"],"Animals & Nature",722,["nest_with_eggs"],57,33,"14.0","plant-other"],
    "1fabb":[["\uD83E\uDEBB"],"Animals & Nature",707,["hyacinth"],57,34,"15.0","plant-flower"],
    "1fabc":[["\uD83E\uDEBC"],"Animals & Nature",674,["jellyfish"],57,35,"15.0","animal-marine"],
    "1fabd":[["\uD83E\uDEBD"],"Animals & Nature",649,["wing"],57,36,"15.0","animal-bird"],
    "1fabe":[["\uD83E\uDEBE"],"Animals & Nature",724,["leafless_tree"],57,37,"16.0","plant-other"],
    "1fabf":[["\uD83E\uDEBF"],"Animals & Nature",651,["goose"],57,38,"15.0","animal-bird"],
    "1fac0":[["\uD83E\uDEC0"],"People & Body",224,["anatomical_heart"],57,39,"13.0","body-parts"],
    "1fac1":[["\uD83E\uDEC1"],"People & Body",225,["lungs"],57,40,"13.0","body-parts"],
    "1fac2":[["\uD83E\uDEC2"],"People & Body",552,["people_hugging"],57,41,"13.0","person-symbol"],
    "1fac3":[["\uD83E\uDEC3"],"People & Body",367,["pregnant_man"],57,42,"14.0","person-role"],
    "1fac4":[["\uD83E\uDEC4"],"People & Body",368,["pregnant_person"],57,48,"14.0","person-role"],
    "1fac5":[["\uD83E\uDEC5"],"People & Body",352,["person_with_crown"],57,54,"14.0","person-role"],
    "1fac6":[["\uD83E\uDEC6"],"People & Body",559,["fingerprint"],57,60,"16.0","person-symbol"],
    "1fac8":[["\uD83E\uDEC8"],"People & Body",405,["hairy_creature"],57,61,"17.0","person-fantasy"],
    "1facd":[["\uD83E\uDECD"],"Animals & Nature",665,["orca"],57,62,"17.0","animal-marine"],
    "1face":[["\uD83E\uDECE"],"Animals & Nature",585,["moose"],58,0,"15.0","animal-mammal"],
    "1facf":[["\uD83E\uDECF"],"Animals & Nature",586,["donkey"],58,1,"15.0","animal-mammal"],
    "1fad0":[["\uD83E\uDED0"],"Food & Drink",740,["blueberries"],58,2,"13.0","food-fruit"],
    "1fad1":[["\uD83E\uDED1"],"Food & Drink",751,["bell_pepper"],58,3,"13.0","food-vegetable"],
    "1fad2":[["\uD83E\uDED2"],"Food & Drink",743,["olive"],58,4,"13.0","food-fruit"],
    "1fad3":[["\uD83E\uDED3"],"Food & Drink",767,["flatbread"],58,5,"13.0","food-prepared"],
    "1fad4":[["\uD83E\uDED4"],"Food & Drink",784,["tamale"],58,6,"13.0","food-prepared"],
    "1fad5":[["\uD83E\uDED5"],"Food & Drink",791,["fondue"],58,7,"13.0","food-prepared"],
    "1fad6":[["\uD83E\uDED6"],"Food & Drink",832,["teapot"],58,8,"13.0","drink"],
    "1fad7":[["\uD83E\uDED7"],"Food & Drink",843,["pouring_liquid"],58,9,"14.0","drink"],
    "1fad8":[["\uD83E\uDED8"],"Food & Drink",758,["beans"],58,10,"14.0","food-vegetable"],
    "1fad9":[["\uD83E\uDED9"],"Food & Drink",854,["jar"],58,11,"14.0","dishware"],
    "1fada":[["\uD83E\uDEDA"],"Food & Drink",760,["ginger_root"],58,12,"15.0","food-vegetable"],
    "1fadb":[["\uD83E\uDEDB"],"Food & Drink",761,["pea_pod"],58,13,"15.0","food-vegetable"],
    "1fadc":[["\uD83E\uDEDC"],"Food & Drink",763,["root_vegetable"],58,14,"16.0","food-vegetable"],
    "1fadf":[["\uD83E\uDEDF"],"Symbols",1563,["splatter"],58,15,"16.0","other-symbol"],
    "1fae0":[["\uD83E\uDEE0"],"Smileys & Emotion",11,["melting_face"],58,16,"14.0","face-smiling"],
    "1fae1":[["\uD83E\uDEE1"],"Smileys & Emotion",36,["saluting_face"],58,17,"14.0","face-hand"],
    "1fae2":[["\uD83E\uDEE2"],"Smileys & Emotion",32,["face_with_open_eyes_and_hand_over_mouth"],58,18,"14.0","face-hand"],
    "1fae3":[["\uD83E\uDEE3"],"Smileys & Emotion",33,["face_with_peeking_eye"],58,19,"14.0","face-hand"],
    "1fae4":[["\uD83E\uDEE4"],"Smileys & Emotion",78,["face_with_diagonal_mouth"],58,20,"14.0","face-concerned"],
    "1fae5":[["\uD83E\uDEE5"],"Smileys & Emotion",42,["dotted_line_face"],58,21,"14.0","face-neutral-skeptical"],
    "1fae6":[["\uD83E\uDEE6"],"People & Body",232,["biting_lip"],58,22,"14.0","body-parts"],
    "1fae7":[["\uD83E\uDEE7"],"Objects",1412,["bubbles"],58,23,"14.0","household"],
    "1fae8":[["\uD83E\uDEE8"],"Smileys & Emotion",50,["shaking_face"],58,24,"15.0","face-neutral-skeptical"],
    "1fae9":[["\uD83E\uDEE9"],"Smileys & Emotion",58,["face_with_bags_under_eyes"],58,25,"16.0","face-sleepy"],
    "1faea":[["\uD83E\uDEEA"],"Smileys & Emotion",86,["distorted_face"],58,26,"17.0","face-concerned"],
    "1faef":[["\uD83E\uDEEF"],"Smileys & Emotion",160,["fight_cloud"],58,27,"17.0","emotion"],
    "1faf0":[["\uD83E\uDEF0"],"People & Body",188,["hand_with_index_finger_and_thumb_crossed"],58,28,"14.0","hand-fingers-partial"],
    "1faf1":[["\uD83E\uDEF1"],"People & Body",177,["rightwards_hand"],58,34,"14.0","hand-fingers-open"],
    "1faf2":[["\uD83E\uDEF2"],"People & Body",178,["leftwards_hand"],58,40,"14.0","hand-fingers-open"],
    "1faf3":[["\uD83E\uDEF3"],"People & Body",179,["palm_down_hand"],58,46,"14.0","hand-fingers-open"],
    "1faf4":[["\uD83E\uDEF4"],"People & Body",180,["palm_up_hand"],58,52,"14.0","hand-fingers-open"],
    "1faf5":[["\uD83E\uDEF5"],"People & Body",198,["index_pointing_at_the_viewer"],58,58,"14.0","hand-single-finger"],
    "1faf6":[["\uD83E\uDEF6"],"People & Body",207,["heart_hands"],59,1,"14.0","hands"],
    "1faf7":[["\uD83E\uDEF7"],"People & Body",181,["leftwards_pushing_hand"],59,7,"15.0","hand-fingers-open"],
    "1faf8":[["\uD83E\uDEF8"],"People & Body",182,["rightwards_pushing_hand"],59,13,"15.0","hand-fingers-open"],
    "203c-fe0f":[["\u203C\uFE0F"],"Symbols",1533,["bangbang"],59,19,"0.6","punctuation"],
    "2049-fe0f":[["\u2049\uFE0F"],"Symbols",1534,["interrobang"],59,20,"0.6","punctuation"],
    "2122-fe0f":[["\u2122\uFE0F"],"Symbols",1562,["tm"],59,21,"0.6","other-symbol"],
    "2139-fe0f":[["\u2139\uFE0F"],"Symbols",1588,["information_source"],59,22,"0.6","alphanum"],
    "2194-fe0f":[["\u2194\uFE0F"],"Symbols",1461,["left_right_arrow"],59,23,"0.6","arrow"],
    "2195-fe0f":[["\u2195\uFE0F"],"Symbols",1460,["arrow_up_down"],59,24,"0.6","arrow"],
    "2196-fe0f":[["\u2196\uFE0F"],"Symbols",1459,["arrow_upper_left"],59,25,"0.6","arrow"],
    "2197-fe0f":[["\u2197\uFE0F"],"Symbols",1453,["arrow_upper_right"],59,26,"0.6","arrow"],
    "2198-fe0f":[["\u2198\uFE0F"],"Symbols",1455,["arrow_lower_right"],59,27,"0.6","arrow"],
    "2199-fe0f":[["\u2199\uFE0F"],"Symbols",1457,["arrow_lower_left"],59,28,"0.6","arrow"],
    "21a9-fe0f":[["\u21A9\uFE0F"],"Symbols",1462,["leftwards_arrow_with_hook"],59,29,"0.6","arrow"],
    "21aa-fe0f":[["\u21AA\uFE0F"],"Symbols",1463,["arrow_right_hook"],59,30,"0.6","arrow"],
    "231a":[["\u231A"],"Travel & Places",999,["watch"],59,31,"0.6","time"],
    "231b":[["\u231B"],"Travel & Places",997,["hourglass"],59,32,"0.6","time"],
    "2328-fe0f":[["\u2328\uFE0F"],"Objects",1250,["keyboard"],59,33,"1.0","computer"],
    "23cf-fe0f":[["\u23CF\uFE0F"],"Symbols",1516,["eject"],59,34,"1.0","av-symbol"],
    "23e9":[["\u23E9"],"Symbols",1503,["fast_forward"],59,35,"0.6","av-symbol"],
    "23ea":[["\u23EA"],"Symbols",1507,["rewind"],59,36,"0.6","av-symbol"],
    "23eb":[["\u23EB"],"Symbols",1510,["arrow_double_up"],59,37,"0.6","av-symbol"],
    "23ec":[["\u23EC"],"Symbols",1512,["arrow_double_down"],59,38,"0.6","av-symbol"],
    "23ed-fe0f":[["\u23ED\uFE0F"],"Symbols",1504,["black_right_pointing_double_triangle_with_vertical_bar"],59,39,"0.7","av-symbol"],
    "23ee-fe0f":[["\u23EE\uFE0F"],"Symbols",1508,["black_left_pointing_double_triangle_with_vertical_bar"],59,40,"0.7","av-symbol"],
    "23ef-fe0f":[["\u23EF\uFE0F"],"Symbols",1505,["black_right_pointing_triangle_with_double_vertical_bar"],59,41,"1.0","av-symbol"],
    "23f0":[["\u23F0"],"Travel & Places",1000,["alarm_clock"],59,42,"0.6","time"],
    "23f1-fe0f":[["\u23F1\uFE0F"],"Travel & Places",1001,["stopwatch"],59,43,"1.0","time"],
    "23f2-fe0f":[["\u23F2\uFE0F"],"Travel & Places",1002,["timer_clock"],59,44,"1.0","time"],
    "23f3":[["\u23F3"],"Travel & Places",998,["hourglass_flowing_sand"],59,45,"0.6","time"],
    "23f8-fe0f":[["\u23F8\uFE0F"],"Symbols",1513,["double_vertical_bar"],59,46,"0.7","av-symbol"],
    "23f9-fe0f":[["\u23F9\uFE0F"],"Symbols",1514,["black_square_for_stop"],59,47,"0.7","av-symbol"],
    "23fa-fe0f":[["\u23FA\uFE0F"],"Symbols",1515,["black_circle_for_record"],59,48,"0.7","av-symbol"],
    "24c2-fe0f":[["\u24C2\uFE0F"],"Symbols",1590,["m"],59,49,"0.6","alphanum"],
    "25aa-fe0f":[["\u25AA\uFE0F"],"Symbols",1638,["black_small_square"],59,50,"0.6","geometric"],
    "25ab-fe0f":[["\u25AB\uFE0F"],"Symbols",1639,["white_small_square"],59,51,"0.6","geometric"],
    "25b6-fe0f":[["\u25B6\uFE0F"],"Symbols",1502,["arrow_forward"],59,52,"0.6","av-symbol"],
    "25c0-fe0f":[["\u25C0\uFE0F"],"Symbols",1506,["arrow_backward"],59,53,"0.6","av-symbol"],
    "25fb-fe0f":[["\u25FB\uFE0F"],"Symbols",1635,["white_medium_square"],59,54,"0.6","geometric"],
    "25fc-fe0f":[["\u25FC\uFE0F"],"Symbols",1634,["black_medium_square"],59,55,"0.6","geometric"],
    "25fd":[["\u25FD"],"Symbols",1637,["white_medium_small_square"],59,56,"0.6","geometric"],
    "25fe":[["\u25FE"],"Symbols",1636,["black_medium_small_square"],59,57,"0.6","geometric"],
    "2600-fe0f":[["\u2600\uFE0F"],"Travel & Places",1041,["sunny"],59,58,"0.6","sky & weather"],
    "2601-fe0f":[["\u2601\uFE0F"],"Travel & Places",1049,["cloud"],59,59,"0.6","sky & weather"],
    "2602-fe0f":[["\u2602\uFE0F"],"Travel & Places",1064,["umbrella"],59,60,"0.7","sky & weather"],
    "2603-fe0f":[["\u2603\uFE0F"],"Travel & Places",1069,["snowman"],59,61,"0.7","sky & weather"],
    "2604-fe0f":[["\u2604\uFE0F"],"Travel & Places",1071,["comet"],59,62,"1.0","sky & weather"],
    "260e-fe0f":[["\u260E\uFE0F"],"Objects",1240,["phone","telephone"],60,0,"0.6","phone"],
    "2611-fe0f":[["\u2611\uFE0F"],"Symbols",1550,["ballot_box_with_check"],60,1,"0.6","other-symbol"],
    "2614":[["\u2614"],"Travel & Places",1065,["umbrella_with_rain_drops"],60,2,"0.6","sky & weather"],
    "2615":[["\u2615"],"Food & Drink",831,["coffee"],60,3,"0.6","drink"],
    "2618-fe0f":[["\u2618\uFE0F"],"Animals & Nature",716,["shamrock"],60,4,"1.0","plant-other"],
    "261d-fe0f":[["\u261D\uFE0F"],"People & Body",197,["point_up"],60,5,"0.6","hand-single-finger"],
    "2620-fe0f":[["\u2620\uFE0F"],"Smileys & Emotion",111,["skull_and_crossbones"],60,11,"1.0","face-negative"],
    "2622-fe0f":[["\u2622\uFE0F"],"Symbols",1450,["radioactive_sign"],60,12,"1.0","warning"],
    "2623-fe0f":[["\u2623\uFE0F"],"Symbols",1451,["biohazard_sign"],60,13,"1.0","warning"],
    "2626-fe0f":[["\u2626\uFE0F"],"Symbols",1480,["orthodox_cross"],60,14,"1.0","religion"],
    "262a-fe0f":[["\u262A\uFE0F"],"Symbols",1481,["star_and_crescent"],60,15,"0.7","religion"],
    "262e-fe0f":[["\u262E\uFE0F"],"Symbols",1482,["peace_symbol"],60,16,"1.0","religion"],
    "262f-fe0f":[["\u262F\uFE0F"],"Symbols",1478,["yin_yang"],60,17,"0.7","religion"],
    "2638-fe0f":[["\u2638\uFE0F"],"Symbols",1477,["wheel_of_dharma"],60,18,"0.7","religion"],
    "2639-fe0f":[["\u2639\uFE0F"],"Smileys & Emotion",81,["white_frowning_face"],60,19,"0.7","face-concerned"],
    "263a-fe0f":[["\u263A\uFE0F"],"Smileys & Emotion",20,["relaxed"],60,20,"0.6","face-affection"],
    "2640-fe0f":[["\u2640\uFE0F"],"Symbols",1524,["female_sign"],60,21,"4.0","gender"],
    "2642-fe0f":[["\u2642\uFE0F"],"Symbols",1525,["male_sign"],60,22,"4.0","gender"],
    "2648":[["\u2648"],"Symbols",1486,["aries"],60,23,"0.6","zodiac"],
    "2649":[["\u2649"],"Symbols",1487,["taurus"],60,24,"0.6","zodiac"],
    "264a":[["\u264A"],"Symbols",1488,["gemini"],60,25,"0.6","zodiac"],
    "264b":[["\u264B"],"Symbols",1489,["cancer"],60,26,"0.6","zodiac"],
    "264c":[["\u264C"],"Symbols",1490,["leo"],60,27,"0.6","zodiac"],
    "264d":[["\u264D"],"Symbols",1491,["virgo"],60,28,"0.6","zodiac"],
    "264e":[["\u264E"],"Symbols",1492,["libra"],60,29,"0.6","zodiac"],
    "264f":[["\u264F"],"Symbols",1493,["scorpius"],60,30,"0.6","zodiac"],
    "2650":[["\u2650"],"Symbols",1494,["sagittarius"],60,31,"0.6","zodiac"],
    "2651":[["\u2651"],"Symbols",1495,["capricorn"],60,32,"0.6","zodiac"],
    "2652":[["\u2652"],"Symbols",1496,["aquarius"],60,33,"0.6","zodiac"],
    "2653":[["\u2653"],"Symbols",1497,["pisces"],60,34,"0.6","zodiac"],
    "265f-fe0f":[["\u265F\uFE0F"],"Activities",1149,["chess_pawn"],60,35,"11.0","game"],
    "2660-fe0f":[["\u2660\uFE0F"],"Activities",1145,["spades"],60,36,"0.6","game"],
    "2663-fe0f":[["\u2663\uFE0F"],"Activities",1148,["clubs"],60,37,"0.6","game"],
    "2665-fe0f":[["\u2665\uFE0F"],"Activities",1146,["hearts"],60,38,"0.6","game"],
    "2666-fe0f":[["\u2666\uFE0F"],"Activities",1147,["diamonds"],60,39,"0.6","game"],
    "2668-fe0f":[["\u2668\uFE0F"],"Travel & Places",916,["hotsprings"],60,40,"0.6","place-other"],
    "267b-fe0f":[["\u267B\uFE0F"],"Symbols",1543,["recycle"],60,41,"0.6","other-symbol"],
    "267e-fe0f":[["\u267E\uFE0F"],"Symbols",1532,["infinity"],60,42,"11.0","math"],
    "267f":[["\u267F"],"Symbols",1429,["wheelchair"],60,43,"0.6","transport-sign"],
    "2692-fe0f":[["\u2692\uFE0F"],"Objects",1354,["hammer_and_pick"],60,44,"1.0","tool"],
    "2693":[["\u2693"],"Travel & Places",973,["anchor"],60,45,"0.6","transport-water"],
    "2694-fe0f":[["\u2694\uFE0F"],"Objects",1357,["crossed_swords"],60,46,"1.0","tool"],
    "2695-fe0f":[["\u2695\uFE0F"],"Symbols",1542,["medical_symbol","staff_of_aesculapius"],60,47,"4.0","other-symbol"],
    "2696-fe0f":[["\u2696\uFE0F"],"Objects",1368,["scales"],60,48,"1.0","tool"],
    "2697-fe0f":[["\u2697\uFE0F"],"Objects",1378,["alembic"],60,49,"1.0","science"],
    "2699-fe0f":[["\u2699\uFE0F"],"Objects",1366,["gear"],60,50,"1.0","tool"],
    "269b-fe0f":[["\u269B\uFE0F"],"Symbols",1474,["atom_symbol"],60,51,"1.0","religion"],
    "269c-fe0f":[["\u269C\uFE0F"],"Symbols",1544,["fleur_de_lis"],60,52,"1.0","other-symbol"],
    "26a0-fe0f":[["\u26A0\uFE0F"],"Symbols",1439,["warning"],60,53,"0.6","warning"],
    "26a1":[["\u26A1"],"Travel & Places",1067,["zap"],60,54,"0.6","sky & weather"],
    "26a7-fe0f":[["\u26A7\uFE0F"],"Symbols",1526,["transgender_symbol"],60,55,"13.0","gender"],
    "26aa":[["\u26AA"],"Symbols",1624,["white_circle"],60,56,"0.6","geometric"],
    "26ab":[["\u26AB"],"Symbols",1623,["black_circle"],60,57,"0.6","geometric"],
    "26b0-fe0f":[["\u26B0\uFE0F"],"Objects",1418,["coffin"],60,58,"1.0","other-object"],
    "26b1-fe0f":[["\u26B1\uFE0F"],"Objects",1420,["funeral_urn"],60,59,"1.0","other-object"],
    "26bd":[["\u26BD"],"Activities",1102,["soccer"],60,60,"0.6","sport"],
    "26be":[["\u26BE"],"Activities",1103,["baseball"],60,61,"0.6","sport"],
    "26c4":[["\u26C4"],"Travel & Places",1070,["snowman_without_snow"],60,62,"0.6","sky & weather"],
    "26c5":[["\u26C5"],"Travel & Places",1050,["partly_sunny"],61,0,"0.6","sky & weather"],
    "26c8-fe0f":[["\u26C8\uFE0F"],"Travel & Places",1051,["thunder_cloud_and_rain"],61,1,"0.7","sky & weather"],
    "26ce":[["\u26CE"],"Symbols",1498,["ophiuchus"],61,2,"0.6","zodiac"],
    "26cf-fe0f":[["\u26CF\uFE0F"],"Objects",1353,["pick"],61,3,"0.7","tool"],
    "26d1-fe0f":[["\u26D1\uFE0F"],"Objects",1202,["helmet_with_white_cross"],61,4,"0.7","clothing"],
    "26d3-fe0f-200d-1f4a5":[["\u26D3\uFE0F\u200D\uD83D\uDCA5"],"Objects",1371,["broken_chain"],61,5,"15.1","tool"],
    "26d3-fe0f":[["\u26D3\uFE0F"],"Objects",1372,["chains"],61,6,"0.7","tool"],
    "26d4":[["\u26D4"],"Symbols",1441,["no_entry"],61,7,"0.6","warning"],
    "26e9-fe0f":[["\u26E9\uFE0F"],"Travel & Places",904,["shinto_shrine"],61,8,"0.7","place-religious"],
    "26ea":[["\u26EA"],"Travel & Places",900,["church"],61,9,"0.6","place-religious"],
    "26f0-fe0f":[["\u26F0\uFE0F"],"Travel & Places",864,["mountain"],61,10,"0.7","place-geographic"],
    "26f1-fe0f":[["\u26F1\uFE0F"],"Travel & Places",1066,["umbrella_on_ground"],61,11,"0.7","sky & weather"],
    "26f2":[["\u26F2"],"Travel & Places",906,["fountain"],61,12,"0.6","place-other"],
    "26f3":[["\u26F3"],"Activities",1121,["golf"],61,13,"0.6","sport"],
    "26f4-fe0f":[["\u26F4\uFE0F"],"Travel & Places",979,["ferry"],61,14,"0.7","transport-water"],
    "26f5":[["\u26F5"],"Travel & Places",975,["boat","sailboat"],61,15,"0.6","transport-water"],
    "26f7-fe0f":[["\u26F7\uFE0F"],"People & Body",466,["skier"],61,16,"0.7","person-sport"],
    "26f8-fe0f":[["\u26F8\uFE0F"],"Activities",1122,["ice_skate"],61,17,"0.7","sport"],
    "26f9-fe0f-200d-2640-fe0f":[["\u26F9\uFE0F\u200D\u2640\uFE0F"],"People & Body",482,["woman-bouncing-ball"],61,18,"4.0","person-sport"],
    "26f9-fe0f-200d-2642-fe0f":[["\u26F9\uFE0F\u200D\u2642\uFE0F"],"People & Body",481,["man-bouncing-ball"],61,24,"4.0","person-sport"],
    "26f9-fe0f":[["\u26F9\uFE0F"],"People & Body",480,["person_with_ball"],61,30,"0.7","person-sport"],
    "26fa":[["\u26FA"],"Travel & Places",907,["tent"],61,36,"0.6","place-other"],
    "26fd":[["\u26FD"],"Travel & Places",966,["fuelpump"],61,37,"0.6","transport-ground"],
    "2702-fe0f":[["\u2702\uFE0F"],"Objects",1341,["scissors"],61,38,"0.6","office"],
    "2705":[["\u2705"],"Symbols",1549,["white_check_mark"],61,39,"0.6","other-symbol"],
    "2708-fe0f":[["\u2708\uFE0F"],"Travel & Places",982,["airplane"],61,40,"0.6","transport-air"],
    "2709-fe0f":[["\u2709\uFE0F"],"Objects",1302,["email","envelope"],61,41,"0.6","mail"],
    "270a":[["\u270A"],"People & Body",201,["fist"],61,42,"0.6","hand-fingers-closed"],
    "270b":[["\u270B"],"People & Body",175,["hand","raised_hand"],61,48,"0.6","hand-fingers-open"],
    "270c-fe0f":[["\u270C\uFE0F"],"People & Body",186,["v"],61,54,"0.6","hand-fingers-partial"],
    "270d-fe0f":[["\u270D\uFE0F"],"People & Body",212,["writing_hand"],61,60,"0.7","hand-prop"],
    "270f-fe0f":[["\u270F\uFE0F"],"Objects",1315,["pencil2"],62,3,"0.6","writing"],
    "2712-fe0f":[["\u2712\uFE0F"],"Objects",1316,["black_nib"],62,4,"0.6","writing"],
    "2714-fe0f":[["\u2714\uFE0F"],"Symbols",1551,["heavy_check_mark"],62,5,"0.6","other-symbol"],
    "2716-fe0f":[["\u2716\uFE0F"],"Symbols",1527,["heavy_multiplication_x"],62,6,"0.6","math"],
    "271d-fe0f":[["\u271D\uFE0F"],"Symbols",1479,["latin_cross"],62,7,"0.7","religion"],
    "2721-fe0f":[["\u2721\uFE0F"],"Symbols",1476,["star_of_david"],62,8,"0.7","religion"],
    "2728":[["\u2728"],"Activities",1080,["sparkles"],62,9,"0.6","event"],
    "2733-fe0f":[["\u2733\uFE0F"],"Symbols",1557,["eight_spoked_asterisk"],62,10,"0.6","other-symbol"],
    "2734-fe0f":[["\u2734\uFE0F"],"Symbols",1558,["eight_pointed_black_star"],62,11,"0.6","other-symbol"],
    "2744-fe0f":[["\u2744\uFE0F"],"Travel & Places",1068,["snowflake"],62,12,"0.6","sky & weather"],
    "2747-fe0f":[["\u2747\uFE0F"],"Symbols",1559,["sparkle"],62,13,"0.6","other-symbol"],
    "274c":[["\u274C"],"Symbols",1552,["x"],62,14,"0.6","other-symbol"],
    "274e":[["\u274E"],"Symbols",1553,["negative_squared_cross_mark"],62,15,"0.6","other-symbol"],
    "2753":[["\u2753"],"Symbols",1535,["question"],62,16,"0.6","punctuation"],
    "2754":[["\u2754"],"Symbols",1536,["grey_question"],62,17,"0.6","punctuation"],
    "2755":[["\u2755"],"Symbols",1537,["grey_exclamation"],62,18,"0.6","punctuation"],
    "2757":[["\u2757"],"Symbols",1538,["exclamation","heavy_exclamation_mark"],62,19,"0.6","punctuation"],
    "2763-fe0f":[["\u2763\uFE0F"],"Smileys & Emotion",141,["heavy_heart_exclamation_mark_ornament"],62,20,"1.0","heart"],
    "2764-fe0f-200d-1f525":[["\u2764\uFE0F\u200D\uD83D\uDD25"],"Smileys & Emotion",143,["heart_on_fire"],62,21,"13.1","heart"],
    "2764-fe0f-200d-1fa79":[["\u2764\uFE0F\u200D\uD83E\uDE79"],"Smileys & Emotion",144,["mending_heart"],62,22,"13.1","heart"],
    "2764-fe0f":[["\u2764\uFE0F"],"Smileys & Emotion",145,["heart"],62,23,"0.6","heart","<3"],
    "2795":[["\u2795"],"Symbols",1528,["heavy_plus_sign"],62,24,"0.6","math"],
    "2796":[["\u2796"],"Symbols",1529,["heavy_minus_sign"],62,25,"0.6","math"],
    "2797":[["\u2797"],"Symbols",1530,["heavy_division_sign"],62,26,"0.6","math"],
    "27a1-fe0f":[["\u27A1\uFE0F"],"Symbols",1454,["arrow_right"],62,27,"0.6","arrow"],
    "27b0":[["\u27B0"],"Symbols",1554,["curly_loop"],62,28,"0.6","other-symbol"],
    "27bf":[["\u27BF"],"Symbols",1555,["loop"],62,29,"1.0","other-symbol"],
    "2934-fe0f":[["\u2934\uFE0F"],"Symbols",1464,["arrow_heading_up"],62,30,"0.6","arrow"],
    "2935-fe0f":[["\u2935\uFE0F"],"Symbols",1465,["arrow_heading_down"],62,31,"0.6","arrow"],
    "2b05-fe0f":[["\u2B05\uFE0F"],"Symbols",1458,["arrow_left"],62,32,"0.6","arrow"],
    "2b06-fe0f":[["\u2B06\uFE0F"],"Symbols",1452,["arrow_up"],62,33,"0.6","arrow"],
    "2b07-fe0f":[["\u2B07\uFE0F"],"Symbols",1456,["arrow_down"],62,34,"0.6","arrow"],
    "2b1b":[["\u2B1B"],"Symbols",1632,["black_large_square"],62,35,"0.6","geometric"],
    "2b1c":[["\u2B1C"],"Symbols",1633,["white_large_square"],62,36,"0.6","geometric"],
    "2b50":[["\u2B50"],"Travel & Places",1045,["star"],62,37,"0.6","sky & weather"],
    "2b55":[["\u2B55"],"Symbols",1548,["o"],62,38,"0.6","other-symbol"],
    "3030-fe0f":[["\u3030\uFE0F"],"Symbols",1539,["wavy_dash"],62,39,"0.6","punctuation"],
    "303d-fe0f":[["\u303D\uFE0F"],"Symbols",1556,["part_alternation_mark"],62,40,"0.6","other-symbol"],
    "3297-fe0f":[["\u3297\uFE0F"],"Symbols",1612,["congratulations"],62,41,"0.6","alphanum"],
    "3299-fe0f":[["\u3299\uFE0F"],"Symbols",1613,["secret"],62,42,"0.6","alphanum"]
};
window.emoji.variations_data = {
    "1f385":{"1f3fb":["1f385-1f3fb",6,61,["\uD83C\uDF85\uD83C\uDFFB"],"1.0"],"1f3fc":["1f385-1f3fc",6,62,["\uD83C\uDF85\uD83C\uDFFC"],"1.0"],"1f3fd":["1f385-1f3fd",7,0,["\uD83C\uDF85\uD83C\uDFFD"],"1.0"],"1f3fe":["1f385-1f3fe",7,1,["\uD83C\uDF85\uD83C\uDFFE"],"1.0"],"1f3ff":["1f385-1f3ff",7,2,["\uD83C\uDF85\uD83C\uDFFF"],"1.0"]},
    "1f3c2":{"1f3fb":["1f3c2-1f3fb",7,59,["\uD83C\uDFC2\uD83C\uDFFB"],"1.0"],"1f3fc":["1f3c2-1f3fc",7,60,["\uD83C\uDFC2\uD83C\uDFFC"],"1.0"],"1f3fd":["1f3c2-1f3fd",7,61,["\uD83C\uDFC2\uD83C\uDFFD"],"1.0"],"1f3fe":["1f3c2-1f3fe",7,62,["\uD83C\uDFC2\uD83C\uDFFE"],"1.0"],"1f3ff":["1f3c2-1f3ff",8,0,["\uD83C\uDFC2\uD83C\uDFFF"],"1.0"]},
    "1f3c3-200d-2640-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-2640-fe0f",8,2,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3c3-1f3fc-200d-2640-fe0f",8,3,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3c3-1f3fd-200d-2640-fe0f",8,4,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3c3-1f3fe-200d-2640-fe0f",8,5,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3c3-1f3ff-200d-2640-fe0f",8,6,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3c3-200d-2640-fe0f-200d-27a1-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",8,8,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f3c3-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",8,9,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f3c3-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",8,10,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f3c3-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",8,11,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f3c3-1f3ff-200d-2640-fe0f-200d-27a1-fe0f",8,12,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f3c3-200d-2642-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-2642-fe0f",8,14,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3c3-1f3fc-200d-2642-fe0f",8,15,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3c3-1f3fd-200d-2642-fe0f",8,16,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3c3-1f3fe-200d-2642-fe0f",8,17,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3c3-1f3ff-200d-2642-fe0f",8,18,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3c3-200d-2642-fe0f-200d-27a1-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",8,20,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f3c3-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",8,21,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f3c3-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",8,22,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f3c3-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",8,23,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f3c3-1f3ff-200d-2642-fe0f-200d-27a1-fe0f",8,24,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f3c3-200d-27a1-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-27a1-fe0f",8,26,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f3c3-1f3fc-200d-27a1-fe0f",8,27,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f3c3-1f3fd-200d-27a1-fe0f",8,28,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f3c3-1f3fe-200d-27a1-fe0f",8,29,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f3c3-1f3ff-200d-27a1-fe0f",8,30,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f3c3":{"1f3fb":["1f3c3-1f3fb",8,32,["\uD83C\uDFC3\uD83C\uDFFB"],"1.0"],"1f3fc":["1f3c3-1f3fc",8,33,["\uD83C\uDFC3\uD83C\uDFFC"],"1.0"],"1f3fd":["1f3c3-1f3fd",8,34,["\uD83C\uDFC3\uD83C\uDFFD"],"1.0"],"1f3fe":["1f3c3-1f3fe",8,35,["\uD83C\uDFC3\uD83C\uDFFE"],"1.0"],"1f3ff":["1f3c3-1f3ff",8,36,["\uD83C\uDFC3\uD83C\uDFFF"],"1.0"]},
    "1f3c4-200d-2640-fe0f":{"1f3fb":["1f3c4-1f3fb-200d-2640-fe0f",8,38,["\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3c4-1f3fc-200d-2640-fe0f",8,39,["\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3c4-1f3fd-200d-2640-fe0f",8,40,["\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3c4-1f3fe-200d-2640-fe0f",8,41,["\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3c4-1f3ff-200d-2640-fe0f",8,42,["\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3c4-200d-2642-fe0f":{"1f3fb":["1f3c4-1f3fb-200d-2642-fe0f",8,44,["\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3c4-1f3fc-200d-2642-fe0f",8,45,["\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3c4-1f3fd-200d-2642-fe0f",8,46,["\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3c4-1f3fe-200d-2642-fe0f",8,47,["\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3c4-1f3ff-200d-2642-fe0f",8,48,["\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3c4":{"1f3fb":["1f3c4-1f3fb",8,50,["\uD83C\uDFC4\uD83C\uDFFB"],"1.0"],"1f3fc":["1f3c4-1f3fc",8,51,["\uD83C\uDFC4\uD83C\uDFFC"],"1.0"],"1f3fd":["1f3c4-1f3fd",8,52,["\uD83C\uDFC4\uD83C\uDFFD"],"1.0"],"1f3fe":["1f3c4-1f3fe",8,53,["\uD83C\uDFC4\uD83C\uDFFE"],"1.0"],"1f3ff":["1f3c4-1f3ff",8,54,["\uD83C\uDFC4\uD83C\uDFFF"],"1.0"]},
    "1f3c7":{"1f3fb":["1f3c7-1f3fb",8,58,["\uD83C\uDFC7\uD83C\uDFFB"],"1.0"],"1f3fc":["1f3c7-1f3fc",8,59,["\uD83C\uDFC7\uD83C\uDFFC"],"1.0"],"1f3fd":["1f3c7-1f3fd",8,60,["\uD83C\uDFC7\uD83C\uDFFD"],"1.0"],"1f3fe":["1f3c7-1f3fe",8,61,["\uD83C\uDFC7\uD83C\uDFFE"],"1.0"],"1f3ff":["1f3c7-1f3ff",8,62,["\uD83C\uDFC7\uD83C\uDFFF"],"1.0"]},
    "1f3ca-200d-2640-fe0f":{"1f3fb":["1f3ca-1f3fb-200d-2640-fe0f",9,3,["\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3ca-1f3fc-200d-2640-fe0f",9,4,["\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3ca-1f3fd-200d-2640-fe0f",9,5,["\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3ca-1f3fe-200d-2640-fe0f",9,6,["\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3ca-1f3ff-200d-2640-fe0f",9,7,["\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3ca-200d-2642-fe0f":{"1f3fb":["1f3ca-1f3fb-200d-2642-fe0f",9,9,["\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3ca-1f3fc-200d-2642-fe0f",9,10,["\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3ca-1f3fd-200d-2642-fe0f",9,11,["\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3ca-1f3fe-200d-2642-fe0f",9,12,["\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3ca-1f3ff-200d-2642-fe0f",9,13,["\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3ca":{"1f3fb":["1f3ca-1f3fb",9,15,["\uD83C\uDFCA\uD83C\uDFFB"],"1.0"],"1f3fc":["1f3ca-1f3fc",9,16,["\uD83C\uDFCA\uD83C\uDFFC"],"1.0"],"1f3fd":["1f3ca-1f3fd",9,17,["\uD83C\uDFCA\uD83C\uDFFD"],"1.0"],"1f3fe":["1f3ca-1f3fe",9,18,["\uD83C\uDFCA\uD83C\uDFFE"],"1.0"],"1f3ff":["1f3ca-1f3ff",9,19,["\uD83C\uDFCA\uD83C\uDFFF"],"1.0"]},
    "1f3cb-fe0f-200d-2640-fe0f":{"1f3fb":["1f3cb-1f3fb-200d-2640-fe0f",9,21,["\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3cb-1f3fc-200d-2640-fe0f",9,22,["\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3cb-1f3fd-200d-2640-fe0f",9,23,["\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3cb-1f3fe-200d-2640-fe0f",9,24,["\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3cb-1f3ff-200d-2640-fe0f",9,25,["\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3cb-fe0f-200d-2642-fe0f":{"1f3fb":["1f3cb-1f3fb-200d-2642-fe0f",9,27,["\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3cb-1f3fc-200d-2642-fe0f",9,28,["\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3cb-1f3fd-200d-2642-fe0f",9,29,["\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3cb-1f3fe-200d-2642-fe0f",9,30,["\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3cb-1f3ff-200d-2642-fe0f",9,31,["\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3cb-fe0f":{"1f3fb":["1f3cb-1f3fb",9,33,["\uD83C\uDFCB\uD83C\uDFFB"],"2.0"],"1f3fc":["1f3cb-1f3fc",9,34,["\uD83C\uDFCB\uD83C\uDFFC"],"2.0"],"1f3fd":["1f3cb-1f3fd",9,35,["\uD83C\uDFCB\uD83C\uDFFD"],"2.0"],"1f3fe":["1f3cb-1f3fe",9,36,["\uD83C\uDFCB\uD83C\uDFFE"],"2.0"],"1f3ff":["1f3cb-1f3ff",9,37,["\uD83C\uDFCB\uD83C\uDFFF"],"2.0"]},
    "1f3cc-fe0f-200d-2640-fe0f":{"1f3fb":["1f3cc-1f3fb-200d-2640-fe0f",9,39,["\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3cc-1f3fc-200d-2640-fe0f",9,40,["\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3cc-1f3fd-200d-2640-fe0f",9,41,["\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3cc-1f3fe-200d-2640-fe0f",9,42,["\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3cc-1f3ff-200d-2640-fe0f",9,43,["\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3cc-fe0f-200d-2642-fe0f":{"1f3fb":["1f3cc-1f3fb-200d-2642-fe0f",9,45,["\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3cc-1f3fc-200d-2642-fe0f",9,46,["\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3cc-1f3fd-200d-2642-fe0f",9,47,["\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3cc-1f3fe-200d-2642-fe0f",9,48,["\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3cc-1f3ff-200d-2642-fe0f",9,49,["\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3cc-fe0f":{"1f3fb":["1f3cc-1f3fb",9,51,["\uD83C\uDFCC\uD83C\uDFFB"],"4.0"],"1f3fc":["1f3cc-1f3fc",9,52,["\uD83C\uDFCC\uD83C\uDFFC"],"4.0"],"1f3fd":["1f3cc-1f3fd",9,53,["\uD83C\uDFCC\uD83C\uDFFD"],"4.0"],"1f3fe":["1f3cc-1f3fe",9,54,["\uD83C\uDFCC\uD83C\uDFFE"],"4.0"],"1f3ff":["1f3cc-1f3ff",9,55,["\uD83C\uDFCC\uD83C\uDFFF"],"4.0"]},
    "1f442":{"1f3fb":["1f442-1f3fb",11,57,["\uD83D\uDC42\uD83C\uDFFB"],"1.0"],"1f3fc":["1f442-1f3fc",11,58,["\uD83D\uDC42\uD83C\uDFFC"],"1.0"],"1f3fd":["1f442-1f3fd",11,59,["\uD83D\uDC42\uD83C\uDFFD"],"1.0"],"1f3fe":["1f442-1f3fe",11,60,["\uD83D\uDC42\uD83C\uDFFE"],"1.0"],"1f3ff":["1f442-1f3ff",11,61,["\uD83D\uDC42\uD83C\uDFFF"],"1.0"]},
    "1f443":{"1f3fb":["1f443-1f3fb",12,0,["\uD83D\uDC43\uD83C\uDFFB"],"1.0"],"1f3fc":["1f443-1f3fc",12,1,["\uD83D\uDC43\uD83C\uDFFC"],"1.0"],"1f3fd":["1f443-1f3fd",12,2,["\uD83D\uDC43\uD83C\uDFFD"],"1.0"],"1f3fe":["1f443-1f3fe",12,3,["\uD83D\uDC43\uD83C\uDFFE"],"1.0"],"1f3ff":["1f443-1f3ff",12,4,["\uD83D\uDC43\uD83C\uDFFF"],"1.0"]},
    "1f446":{"1f3fb":["1f446-1f3fb",12,8,["\uD83D\uDC46\uD83C\uDFFB"],"1.0"],"1f3fc":["1f446-1f3fc",12,9,["\uD83D\uDC46\uD83C\uDFFC"],"1.0"],"1f3fd":["1f446-1f3fd",12,10,["\uD83D\uDC46\uD83C\uDFFD"],"1.0"],"1f3fe":["1f446-1f3fe",12,11,["\uD83D\uDC46\uD83C\uDFFE"],"1.0"],"1f3ff":["1f446-1f3ff",12,12,["\uD83D\uDC46\uD83C\uDFFF"],"1.0"]},
    "1f447":{"1f3fb":["1f447-1f3fb",12,14,["\uD83D\uDC47\uD83C\uDFFB"],"1.0"],"1f3fc":["1f447-1f3fc",12,15,["\uD83D\uDC47\uD83C\uDFFC"],"1.0"],"1f3fd":["1f447-1f3fd",12,16,["\uD83D\uDC47\uD83C\uDFFD"],"1.0"],"1f3fe":["1f447-1f3fe",12,17,["\uD83D\uDC47\uD83C\uDFFE"],"1.0"],"1f3ff":["1f447-1f3ff",12,18,["\uD83D\uDC47\uD83C\uDFFF"],"1.0"]},
    "1f448":{"1f3fb":["1f448-1f3fb",12,20,["\uD83D\uDC48\uD83C\uDFFB"],"1.0"],"1f3fc":["1f448-1f3fc",12,21,["\uD83D\uDC48\uD83C\uDFFC"],"1.0"],"1f3fd":["1f448-1f3fd",12,22,["\uD83D\uDC48\uD83C\uDFFD"],"1.0"],"1f3fe":["1f448-1f3fe",12,23,["\uD83D\uDC48\uD83C\uDFFE"],"1.0"],"1f3ff":["1f448-1f3ff",12,24,["\uD83D\uDC48\uD83C\uDFFF"],"1.0"]},
    "1f449":{"1f3fb":["1f449-1f3fb",12,26,["\uD83D\uDC49\uD83C\uDFFB"],"1.0"],"1f3fc":["1f449-1f3fc",12,27,["\uD83D\uDC49\uD83C\uDFFC"],"1.0"],"1f3fd":["1f449-1f3fd",12,28,["\uD83D\uDC49\uD83C\uDFFD"],"1.0"],"1f3fe":["1f449-1f3fe",12,29,["\uD83D\uDC49\uD83C\uDFFE"],"1.0"],"1f3ff":["1f449-1f3ff",12,30,["\uD83D\uDC49\uD83C\uDFFF"],"1.0"]},
    "1f44a":{"1f3fb":["1f44a-1f3fb",12,32,["\uD83D\uDC4A\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44a-1f3fc",12,33,["\uD83D\uDC4A\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44a-1f3fd",12,34,["\uD83D\uDC4A\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44a-1f3fe",12,35,["\uD83D\uDC4A\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44a-1f3ff",12,36,["\uD83D\uDC4A\uD83C\uDFFF"],"1.0"]},
    "1f44b":{"1f3fb":["1f44b-1f3fb",12,38,["\uD83D\uDC4B\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44b-1f3fc",12,39,["\uD83D\uDC4B\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44b-1f3fd",12,40,["\uD83D\uDC4B\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44b-1f3fe",12,41,["\uD83D\uDC4B\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44b-1f3ff",12,42,["\uD83D\uDC4B\uD83C\uDFFF"],"1.0"]},
    "1f44c":{"1f3fb":["1f44c-1f3fb",12,44,["\uD83D\uDC4C\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44c-1f3fc",12,45,["\uD83D\uDC4C\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44c-1f3fd",12,46,["\uD83D\uDC4C\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44c-1f3fe",12,47,["\uD83D\uDC4C\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44c-1f3ff",12,48,["\uD83D\uDC4C\uD83C\uDFFF"],"1.0"]},
    "1f44d":{"1f3fb":["1f44d-1f3fb",12,50,["\uD83D\uDC4D\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44d-1f3fc",12,51,["\uD83D\uDC4D\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44d-1f3fd",12,52,["\uD83D\uDC4D\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44d-1f3fe",12,53,["\uD83D\uDC4D\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44d-1f3ff",12,54,["\uD83D\uDC4D\uD83C\uDFFF"],"1.0"]},
    "1f44e":{"1f3fb":["1f44e-1f3fb",12,56,["\uD83D\uDC4E\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44e-1f3fc",12,57,["\uD83D\uDC4E\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44e-1f3fd",12,58,["\uD83D\uDC4E\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44e-1f3fe",12,59,["\uD83D\uDC4E\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44e-1f3ff",12,60,["\uD83D\uDC4E\uD83C\uDFFF"],"1.0"]},
    "1f44f":{"1f3fb":["1f44f-1f3fb",12,62,["\uD83D\uDC4F\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44f-1f3fc",13,0,["\uD83D\uDC4F\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44f-1f3fd",13,1,["\uD83D\uDC4F\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44f-1f3fe",13,2,["\uD83D\uDC4F\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44f-1f3ff",13,3,["\uD83D\uDC4F\uD83C\uDFFF"],"1.0"]},
    "1f450":{"1f3fb":["1f450-1f3fb",13,5,["\uD83D\uDC50\uD83C\uDFFB"],"1.0"],"1f3fc":["1f450-1f3fc",13,6,["\uD83D\uDC50\uD83C\uDFFC"],"1.0"],"1f3fd":["1f450-1f3fd",13,7,["\uD83D\uDC50\uD83C\uDFFD"],"1.0"],"1f3fe":["1f450-1f3fe",13,8,["\uD83D\uDC50\uD83C\uDFFE"],"1.0"],"1f3ff":["1f450-1f3ff",13,9,["\uD83D\uDC50\uD83C\uDFFF"],"1.0"]},
    "1f466":{"1f3fb":["1f466-1f3fb",13,32,["\uD83D\uDC66\uD83C\uDFFB"],"1.0"],"1f3fc":["1f466-1f3fc",13,33,["\uD83D\uDC66\uD83C\uDFFC"],"1.0"],"1f3fd":["1f466-1f3fd",13,34,["\uD83D\uDC66\uD83C\uDFFD"],"1.0"],"1f3fe":["1f466-1f3fe",13,35,["\uD83D\uDC66\uD83C\uDFFE"],"1.0"],"1f3ff":["1f466-1f3ff",13,36,["\uD83D\uDC66\uD83C\uDFFF"],"1.0"]},
    "1f467":{"1f3fb":["1f467-1f3fb",13,38,["\uD83D\uDC67\uD83C\uDFFB"],"1.0"],"1f3fc":["1f467-1f3fc",13,39,["\uD83D\uDC67\uD83C\uDFFC"],"1.0"],"1f3fd":["1f467-1f3fd",13,40,["\uD83D\uDC67\uD83C\uDFFD"],"1.0"],"1f3fe":["1f467-1f3fe",13,41,["\uD83D\uDC67\uD83C\uDFFE"],"1.0"],"1f3ff":["1f467-1f3ff",13,42,["\uD83D\uDC67\uD83C\uDFFF"],"1.0"]},
    "1f468-200d-1f33e":{"1f3fb":["1f468-1f3fb-200d-1f33e",13,44,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF3E"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f33e",13,45,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF3E"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f33e",13,46,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF3E"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f33e",13,47,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF3E"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f33e",13,48,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF3E"],"4.0"]},
    "1f468-200d-1f373":{"1f3fb":["1f468-1f3fb-200d-1f373",13,50,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF73"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f373",13,51,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF73"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f373",13,52,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF73"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f373",13,53,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF73"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f373",13,54,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF73"],"4.0"]},
    "1f468-200d-1f37c":{"1f3fb":["1f468-1f3fb-200d-1f37c",13,56,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF7C"],"13.0"],"1f3fc":["1f468-1f3fc-200d-1f37c",13,57,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF7C"],"13.0"],"1f3fd":["1f468-1f3fd-200d-1f37c",13,58,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF7C"],"13.0"],"1f3fe":["1f468-1f3fe-200d-1f37c",13,59,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF7C"],"13.0"],"1f3ff":["1f468-1f3ff-200d-1f37c",13,60,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF7C"],"13.0"]},
    "1f468-200d-1f393":{"1f3fb":["1f468-1f3fb-200d-1f393",13,62,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF93"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f393",14,0,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF93"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f393",14,1,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF93"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f393",14,2,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF93"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f393",14,3,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF93"],"4.0"]},
    "1f468-200d-1f3a4":{"1f3fb":["1f468-1f3fb-200d-1f3a4",14,5,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA4"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f3a4",14,6,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA4"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f3a4",14,7,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA4"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f3a4",14,8,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA4"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f3a4",14,9,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA4"],"4.0"]},
    "1f468-200d-1f3a8":{"1f3fb":["1f468-1f3fb-200d-1f3a8",14,11,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA8"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f3a8",14,12,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA8"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f3a8",14,13,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA8"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f3a8",14,14,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA8"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f3a8",14,15,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA8"],"4.0"]},
    "1f468-200d-1f3eb":{"1f3fb":["1f468-1f3fb-200d-1f3eb",14,17,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFEB"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f3eb",14,18,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFEB"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f3eb",14,19,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFEB"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f3eb",14,20,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFEB"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f3eb",14,21,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFEB"],"4.0"]},
    "1f468-200d-1f3ed":{"1f3fb":["1f468-1f3fb-200d-1f3ed",14,23,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFED"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f3ed",14,24,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFED"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f3ed",14,25,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFED"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f3ed",14,26,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFED"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f3ed",14,27,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFED"],"4.0"]},
    "1f468-200d-1f4bb":{"1f3fb":["1f468-1f3fb-200d-1f4bb",14,44,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBB"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f4bb",14,45,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBB"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f4bb",14,46,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBB"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f4bb",14,47,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBB"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f4bb",14,48,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBB"],"4.0"]},
    "1f468-200d-1f4bc":{"1f3fb":["1f468-1f3fb-200d-1f4bc",14,50,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBC"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f4bc",14,51,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBC"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f4bc",14,52,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBC"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f4bc",14,53,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBC"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f4bc",14,54,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBC"],"4.0"]},
    "1f468-200d-1f527":{"1f3fb":["1f468-1f3fb-200d-1f527",14,56,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD27"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f527",14,57,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD27"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f527",14,58,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD27"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f527",14,59,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD27"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f527",14,60,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD27"],"4.0"]},
    "1f468-200d-1f52c":{"1f3fb":["1f468-1f3fb-200d-1f52c",14,62,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD2C"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f52c",15,0,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD2C"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f52c",15,1,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD2C"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f52c",15,2,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD2C"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f52c",15,3,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD2C"],"4.0"]},
    "1f468-200d-1f680":{"1f3fb":["1f468-1f3fb-200d-1f680",15,5,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE80"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f680",15,6,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE80"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f680",15,7,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE80"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f680",15,8,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE80"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f680",15,9,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE80"],"4.0"]},
    "1f468-200d-1f692":{"1f3fb":["1f468-1f3fb-200d-1f692",15,11,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE92"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f692",15,12,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE92"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f692",15,13,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE92"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f692",15,14,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE92"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f692",15,15,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE92"],"4.0"]},
    "1f468-200d-1f9af-200d-27a1-fe0f":{"1f3fb":["1f468-1f3fb-200d-1f9af-200d-27a1-fe0f",15,17,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f468-1f3fc-200d-1f9af-200d-27a1-fe0f",15,18,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f468-1f3fd-200d-1f9af-200d-27a1-fe0f",15,19,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f468-1f3fe-200d-1f9af-200d-27a1-fe0f",15,20,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f468-1f3ff-200d-1f9af-200d-27a1-fe0f",15,21,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f468-200d-1f9af":{"1f3fb":["1f468-1f3fb-200d-1f9af",15,23,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF"],"12.0"],"1f3fc":["1f468-1f3fc-200d-1f9af",15,24,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF"],"12.0"],"1f3fd":["1f468-1f3fd-200d-1f9af",15,25,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF"],"12.0"],"1f3fe":["1f468-1f3fe-200d-1f9af",15,26,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF"],"12.0"],"1f3ff":["1f468-1f3ff-200d-1f9af",15,27,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF"],"12.0"]},
    "1f468-200d-1f9b0":{"1f3fb":["1f468-1f3fb-200d-1f9b0",15,29,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB0"],"11.0"],"1f3fc":["1f468-1f3fc-200d-1f9b0",15,30,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB0"],"11.0"],"1f3fd":["1f468-1f3fd-200d-1f9b0",15,31,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB0"],"11.0"],"1f3fe":["1f468-1f3fe-200d-1f9b0",15,32,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB0"],"11.0"],"1f3ff":["1f468-1f3ff-200d-1f9b0",15,33,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB0"],"11.0"]},
    "1f468-200d-1f9b1":{"1f3fb":["1f468-1f3fb-200d-1f9b1",15,35,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB1"],"11.0"],"1f3fc":["1f468-1f3fc-200d-1f9b1",15,36,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB1"],"11.0"],"1f3fd":["1f468-1f3fd-200d-1f9b1",15,37,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB1"],"11.0"],"1f3fe":["1f468-1f3fe-200d-1f9b1",15,38,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB1"],"11.0"],"1f3ff":["1f468-1f3ff-200d-1f9b1",15,39,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB1"],"11.0"]},
    "1f468-200d-1f9b2":{"1f3fb":["1f468-1f3fb-200d-1f9b2",15,41,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB2"],"11.0"],"1f3fc":["1f468-1f3fc-200d-1f9b2",15,42,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB2"],"11.0"],"1f3fd":["1f468-1f3fd-200d-1f9b2",15,43,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB2"],"11.0"],"1f3fe":["1f468-1f3fe-200d-1f9b2",15,44,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB2"],"11.0"],"1f3ff":["1f468-1f3ff-200d-1f9b2",15,45,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB2"],"11.0"]},
    "1f468-200d-1f9b3":{"1f3fb":["1f468-1f3fb-200d-1f9b3",15,47,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB3"],"11.0"],"1f3fc":["1f468-1f3fc-200d-1f9b3",15,48,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB3"],"11.0"],"1f3fd":["1f468-1f3fd-200d-1f9b3",15,49,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB3"],"11.0"],"1f3fe":["1f468-1f3fe-200d-1f9b3",15,50,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB3"],"11.0"],"1f3ff":["1f468-1f3ff-200d-1f9b3",15,51,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB3"],"11.0"]},
    "1f468-200d-1f9bc-200d-27a1-fe0f":{"1f3fb":["1f468-1f3fb-200d-1f9bc-200d-27a1-fe0f",15,53,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f468-1f3fc-200d-1f9bc-200d-27a1-fe0f",15,54,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f468-1f3fd-200d-1f9bc-200d-27a1-fe0f",15,55,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f468-1f3fe-200d-1f9bc-200d-27a1-fe0f",15,56,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f468-1f3ff-200d-1f9bc-200d-27a1-fe0f",15,57,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"]},
    "1f468-200d-1f9bc":{"1f3fb":["1f468-1f3fb-200d-1f9bc",15,59,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC"],"12.0"],"1f3fc":["1f468-1f3fc-200d-1f9bc",15,60,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC"],"12.0"],"1f3fd":["1f468-1f3fd-200d-1f9bc",15,61,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC"],"12.0"],"1f3fe":["1f468-1f3fe-200d-1f9bc",15,62,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC"],"12.0"],"1f3ff":["1f468-1f3ff-200d-1f9bc",16,0,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC"],"12.0"]},
    "1f468-200d-1f9bd-200d-27a1-fe0f":{"1f3fb":["1f468-1f3fb-200d-1f9bd-200d-27a1-fe0f",16,2,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f468-1f3fc-200d-1f9bd-200d-27a1-fe0f",16,3,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f468-1f3fd-200d-1f9bd-200d-27a1-fe0f",16,4,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f468-1f3fe-200d-1f9bd-200d-27a1-fe0f",16,5,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f468-1f3ff-200d-1f9bd-200d-27a1-fe0f",16,6,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"]},
    "1f468-200d-1f9bd":{"1f3fb":["1f468-1f3fb-200d-1f9bd",16,8,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD"],"12.0"],"1f3fc":["1f468-1f3fc-200d-1f9bd",16,9,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD"],"12.0"],"1f3fd":["1f468-1f3fd-200d-1f9bd",16,10,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD"],"12.0"],"1f3fe":["1f468-1f3fe-200d-1f9bd",16,11,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD"],"12.0"],"1f3ff":["1f468-1f3ff-200d-1f9bd",16,12,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD"],"12.0"]},
    "1f468-200d-2695-fe0f":{"1f3fb":["1f468-1f3fb-200d-2695-fe0f",16,14,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2695\uFE0F"],"4.0"],"1f3fc":["1f468-1f3fc-200d-2695-fe0f",16,15,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2695\uFE0F"],"4.0"],"1f3fd":["1f468-1f3fd-200d-2695-fe0f",16,16,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2695\uFE0F"],"4.0"],"1f3fe":["1f468-1f3fe-200d-2695-fe0f",16,17,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2695\uFE0F"],"4.0"],"1f3ff":["1f468-1f3ff-200d-2695-fe0f",16,18,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2695\uFE0F"],"4.0"]},
    "1f468-200d-2696-fe0f":{"1f3fb":["1f468-1f3fb-200d-2696-fe0f",16,20,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2696\uFE0F"],"4.0"],"1f3fc":["1f468-1f3fc-200d-2696-fe0f",16,21,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2696\uFE0F"],"4.0"],"1f3fd":["1f468-1f3fd-200d-2696-fe0f",16,22,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2696\uFE0F"],"4.0"],"1f3fe":["1f468-1f3fe-200d-2696-fe0f",16,23,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2696\uFE0F"],"4.0"],"1f3ff":["1f468-1f3ff-200d-2696-fe0f",16,24,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2696\uFE0F"],"4.0"]},
    "1f468-200d-2708-fe0f":{"1f3fb":["1f468-1f3fb-200d-2708-fe0f",16,26,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2708\uFE0F"],"4.0"],"1f3fc":["1f468-1f3fc-200d-2708-fe0f",16,27,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2708\uFE0F"],"4.0"],"1f3fd":["1f468-1f3fd-200d-2708-fe0f",16,28,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2708\uFE0F"],"4.0"],"1f3fe":["1f468-1f3fe-200d-2708-fe0f",16,29,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2708\uFE0F"],"4.0"],"1f3ff":["1f468-1f3ff-200d-2708-fe0f",16,30,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2708\uFE0F"],"4.0"]},
    "1f468-200d-2764-fe0f-200d-1f468":{"1f3fb-1f3fb":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",16,32,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",16,33,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",16,34,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",16,35,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",16,36,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",16,37,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",16,38,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",16,39,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",16,40,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",16,41,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",16,42,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",16,43,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",16,44,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",16,45,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",16,46,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",16,47,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",16,48,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",16,49,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",16,50,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",16,51,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",16,52,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",16,53,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",16,54,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",16,55,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",16,56,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"]},
    "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468":{"1f3fb-1f3fb":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",16,58,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",16,59,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",16,60,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",16,61,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",16,62,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,0,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,1,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,2,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,3,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,4,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,5,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,6,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,7,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,8,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,9,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,10,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,11,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,12,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,13,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,14,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,15,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,16,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,17,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,18,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,19,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"]},
    "1f468":{"1f3fb":["1f468-1f3fb",17,21,["\uD83D\uDC68\uD83C\uDFFB"],"1.0"],"1f3fc":["1f468-1f3fc",17,22,["\uD83D\uDC68\uD83C\uDFFC"],"1.0"],"1f3fd":["1f468-1f3fd",17,23,["\uD83D\uDC68\uD83C\uDFFD"],"1.0"],"1f3fe":["1f468-1f3fe",17,24,["\uD83D\uDC68\uD83C\uDFFE"],"1.0"],"1f3ff":["1f468-1f3ff",17,25,["\uD83D\uDC68\uD83C\uDFFF"],"1.0"]},
    "1f469-200d-1f33e":{"1f3fb":["1f469-1f3fb-200d-1f33e",17,27,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF3E"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f33e",17,28,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF3E"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f33e",17,29,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF3E"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f33e",17,30,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF3E"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f33e",17,31,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF3E"],"4.0"]},
    "1f469-200d-1f373":{"1f3fb":["1f469-1f3fb-200d-1f373",17,33,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF73"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f373",17,34,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF73"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f373",17,35,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF73"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f373",17,36,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF73"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f373",17,37,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF73"],"4.0"]},
    "1f469-200d-1f37c":{"1f3fb":["1f469-1f3fb-200d-1f37c",17,39,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF7C"],"13.0"],"1f3fc":["1f469-1f3fc-200d-1f37c",17,40,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF7C"],"13.0"],"1f3fd":["1f469-1f3fd-200d-1f37c",17,41,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF7C"],"13.0"],"1f3fe":["1f469-1f3fe-200d-1f37c",17,42,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF7C"],"13.0"],"1f3ff":["1f469-1f3ff-200d-1f37c",17,43,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF7C"],"13.0"]},
    "1f469-200d-1f393":{"1f3fb":["1f469-1f3fb-200d-1f393",17,45,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF93"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f393",17,46,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF93"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f393",17,47,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF93"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f393",17,48,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF93"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f393",17,49,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF93"],"4.0"]},
    "1f469-200d-1f3a4":{"1f3fb":["1f469-1f3fb-200d-1f3a4",17,51,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA4"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f3a4",17,52,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA4"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f3a4",17,53,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA4"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f3a4",17,54,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA4"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f3a4",17,55,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA4"],"4.0"]},
    "1f469-200d-1f3a8":{"1f3fb":["1f469-1f3fb-200d-1f3a8",17,57,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA8"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f3a8",17,58,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA8"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f3a8",17,59,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA8"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f3a8",17,60,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA8"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f3a8",17,61,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA8"],"4.0"]},
    "1f469-200d-1f3eb":{"1f3fb":["1f469-1f3fb-200d-1f3eb",18,0,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFEB"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f3eb",18,1,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f3eb",18,2,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFEB"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f3eb",18,3,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFEB"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f3eb",18,4,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFEB"],"4.0"]},
    "1f469-200d-1f3ed":{"1f3fb":["1f469-1f3fb-200d-1f3ed",18,6,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFED"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f3ed",18,7,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFED"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f3ed",18,8,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFED"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f3ed",18,9,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFED"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f3ed",18,10,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFED"],"4.0"]},
    "1f469-200d-1f4bb":{"1f3fb":["1f469-1f3fb-200d-1f4bb",18,22,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBB"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f4bb",18,23,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBB"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f4bb",18,24,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBB"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f4bb",18,25,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBB"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f4bb",18,26,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBB"],"4.0"]},
    "1f469-200d-1f4bc":{"1f3fb":["1f469-1f3fb-200d-1f4bc",18,28,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBC"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f4bc",18,29,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBC"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f4bc",18,30,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBC"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f4bc",18,31,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBC"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f4bc",18,32,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBC"],"4.0"]},
    "1f469-200d-1f527":{"1f3fb":["1f469-1f3fb-200d-1f527",18,34,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD27"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f527",18,35,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD27"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f527",18,36,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD27"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f527",18,37,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD27"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f527",18,38,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD27"],"4.0"]},
    "1f469-200d-1f52c":{"1f3fb":["1f469-1f3fb-200d-1f52c",18,40,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD2C"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f52c",18,41,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD2C"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f52c",18,42,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD2C"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f52c",18,43,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD2C"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f52c",18,44,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD2C"],"4.0"]},
    "1f469-200d-1f680":{"1f3fb":["1f469-1f3fb-200d-1f680",18,46,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE80"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f680",18,47,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE80"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f680",18,48,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE80"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f680",18,49,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE80"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f680",18,50,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE80"],"4.0"]},
    "1f469-200d-1f692":{"1f3fb":["1f469-1f3fb-200d-1f692",18,52,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE92"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f692",18,53,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE92"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f692",18,54,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE92"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f692",18,55,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE92"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f692",18,56,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE92"],"4.0"]},
    "1f469-200d-1f9af-200d-27a1-fe0f":{"1f3fb":["1f469-1f3fb-200d-1f9af-200d-27a1-fe0f",18,58,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f469-1f3fc-200d-1f9af-200d-27a1-fe0f",18,59,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f469-1f3fd-200d-1f9af-200d-27a1-fe0f",18,60,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f469-1f3fe-200d-1f9af-200d-27a1-fe0f",18,61,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f469-1f3ff-200d-1f9af-200d-27a1-fe0f",18,62,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f469-200d-1f9af":{"1f3fb":["1f469-1f3fb-200d-1f9af",19,1,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF"],"12.0"],"1f3fc":["1f469-1f3fc-200d-1f9af",19,2,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF"],"12.0"],"1f3fd":["1f469-1f3fd-200d-1f9af",19,3,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF"],"12.0"],"1f3fe":["1f469-1f3fe-200d-1f9af",19,4,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF"],"12.0"],"1f3ff":["1f469-1f3ff-200d-1f9af",19,5,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF"],"12.0"]},
    "1f469-200d-1f9b0":{"1f3fb":["1f469-1f3fb-200d-1f9b0",19,7,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB0"],"11.0"],"1f3fc":["1f469-1f3fc-200d-1f9b0",19,8,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB0"],"11.0"],"1f3fd":["1f469-1f3fd-200d-1f9b0",19,9,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB0"],"11.0"],"1f3fe":["1f469-1f3fe-200d-1f9b0",19,10,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB0"],"11.0"],"1f3ff":["1f469-1f3ff-200d-1f9b0",19,11,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB0"],"11.0"]},
    "1f469-200d-1f9b1":{"1f3fb":["1f469-1f3fb-200d-1f9b1",19,13,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB1"],"11.0"],"1f3fc":["1f469-1f3fc-200d-1f9b1",19,14,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB1"],"11.0"],"1f3fd":["1f469-1f3fd-200d-1f9b1",19,15,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB1"],"11.0"],"1f3fe":["1f469-1f3fe-200d-1f9b1",19,16,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB1"],"11.0"],"1f3ff":["1f469-1f3ff-200d-1f9b1",19,17,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB1"],"11.0"]},
    "1f469-200d-1f9b2":{"1f3fb":["1f469-1f3fb-200d-1f9b2",19,19,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB2"],"11.0"],"1f3fc":["1f469-1f3fc-200d-1f9b2",19,20,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB2"],"11.0"],"1f3fd":["1f469-1f3fd-200d-1f9b2",19,21,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB2"],"11.0"],"1f3fe":["1f469-1f3fe-200d-1f9b2",19,22,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB2"],"11.0"],"1f3ff":["1f469-1f3ff-200d-1f9b2",19,23,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB2"],"11.0"]},
    "1f469-200d-1f9b3":{"1f3fb":["1f469-1f3fb-200d-1f9b3",19,25,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB3"],"11.0"],"1f3fc":["1f469-1f3fc-200d-1f9b3",19,26,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB3"],"11.0"],"1f3fd":["1f469-1f3fd-200d-1f9b3",19,27,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB3"],"11.0"],"1f3fe":["1f469-1f3fe-200d-1f9b3",19,28,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB3"],"11.0"],"1f3ff":["1f469-1f3ff-200d-1f9b3",19,29,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB3"],"11.0"]},
    "1f469-200d-1f9bc-200d-27a1-fe0f":{"1f3fb":["1f469-1f3fb-200d-1f9bc-200d-27a1-fe0f",19,31,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f469-1f3fc-200d-1f9bc-200d-27a1-fe0f",19,32,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f469-1f3fd-200d-1f9bc-200d-27a1-fe0f",19,33,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f469-1f3fe-200d-1f9bc-200d-27a1-fe0f",19,34,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f469-1f3ff-200d-1f9bc-200d-27a1-fe0f",19,35,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"]},
    "1f469-200d-1f9bc":{"1f3fb":["1f469-1f3fb-200d-1f9bc",19,37,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC"],"12.0"],"1f3fc":["1f469-1f3fc-200d-1f9bc",19,38,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC"],"12.0"],"1f3fd":["1f469-1f3fd-200d-1f9bc",19,39,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC"],"12.0"],"1f3fe":["1f469-1f3fe-200d-1f9bc",19,40,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC"],"12.0"],"1f3ff":["1f469-1f3ff-200d-1f9bc",19,41,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC"],"12.0"]},
    "1f469-200d-1f9bd-200d-27a1-fe0f":{"1f3fb":["1f469-1f3fb-200d-1f9bd-200d-27a1-fe0f",19,43,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f469-1f3fc-200d-1f9bd-200d-27a1-fe0f",19,44,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f469-1f3fd-200d-1f9bd-200d-27a1-fe0f",19,45,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f469-1f3fe-200d-1f9bd-200d-27a1-fe0f",19,46,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f469-1f3ff-200d-1f9bd-200d-27a1-fe0f",19,47,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"]},
    "1f469-200d-1f9bd":{"1f3fb":["1f469-1f3fb-200d-1f9bd",19,49,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD"],"12.0"],"1f3fc":["1f469-1f3fc-200d-1f9bd",19,50,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD"],"12.0"],"1f3fd":["1f469-1f3fd-200d-1f9bd",19,51,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD"],"12.0"],"1f3fe":["1f469-1f3fe-200d-1f9bd",19,52,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD"],"12.0"],"1f3ff":["1f469-1f3ff-200d-1f9bd",19,53,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD"],"12.0"]},
    "1f469-200d-2695-fe0f":{"1f3fb":["1f469-1f3fb-200d-2695-fe0f",19,55,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2695\uFE0F"],"4.0"],"1f3fc":["1f469-1f3fc-200d-2695-fe0f",19,56,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2695\uFE0F"],"4.0"],"1f3fd":["1f469-1f3fd-200d-2695-fe0f",19,57,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2695\uFE0F"],"4.0"],"1f3fe":["1f469-1f3fe-200d-2695-fe0f",19,58,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2695\uFE0F"],"4.0"],"1f3ff":["1f469-1f3ff-200d-2695-fe0f",19,59,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2695\uFE0F"],"4.0"]},
    "1f469-200d-2696-fe0f":{"1f3fb":["1f469-1f3fb-200d-2696-fe0f",19,61,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2696\uFE0F"],"4.0"],"1f3fc":["1f469-1f3fc-200d-2696-fe0f",19,62,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2696\uFE0F"],"4.0"],"1f3fd":["1f469-1f3fd-200d-2696-fe0f",20,0,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2696\uFE0F"],"4.0"],"1f3fe":["1f469-1f3fe-200d-2696-fe0f",20,1,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2696\uFE0F"],"4.0"],"1f3ff":["1f469-1f3ff-200d-2696-fe0f",20,2,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2696\uFE0F"],"4.0"]},
    "1f469-200d-2708-fe0f":{"1f3fb":["1f469-1f3fb-200d-2708-fe0f",20,4,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2708\uFE0F"],"4.0"],"1f3fc":["1f469-1f3fc-200d-2708-fe0f",20,5,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2708\uFE0F"],"4.0"],"1f3fd":["1f469-1f3fd-200d-2708-fe0f",20,6,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2708\uFE0F"],"4.0"],"1f3fe":["1f469-1f3fe-200d-2708-fe0f",20,7,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2708\uFE0F"],"4.0"],"1f3ff":["1f469-1f3ff-200d-2708-fe0f",20,8,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2708\uFE0F"],"4.0"]},
    "1f469-200d-2764-fe0f-200d-1f468":{"1f3fb-1f3fb":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",20,10,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",20,11,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",20,12,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",20,13,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",20,14,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",20,15,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",20,16,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",20,17,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",20,18,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",20,19,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",20,20,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",20,21,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",20,22,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",20,23,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",20,24,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",20,25,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",20,26,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",20,27,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",20,28,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",20,29,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",20,30,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",20,31,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",20,32,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",20,33,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",20,34,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"]},
    "1f469-200d-2764-fe0f-200d-1f469":{"1f3fb-1f3fb":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",20,36,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",20,37,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",20,38,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",20,39,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",20,40,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",20,41,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",20,42,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",20,43,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",20,44,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",20,45,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",20,46,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",20,47,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",20,48,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",20,49,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",20,50,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",20,51,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",20,52,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",20,53,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",20,54,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",20,55,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",20,56,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",20,57,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",20,58,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",20,59,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",20,60,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"]},
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468":{"1f3fb-1f3fb":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",20,62,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,0,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,1,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,2,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,3,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,4,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,5,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,6,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,7,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,8,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,9,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,10,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,11,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,12,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,13,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,14,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,15,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,16,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,17,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,18,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,19,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,20,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,21,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,22,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,23,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"]},
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469":{"1f3fb-1f3fb":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,25,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,26,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",21,27,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",21,28,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",21,29,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,30,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,31,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",21,32,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",21,33,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",21,34,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,35,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,36,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",21,37,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",21,38,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",21,39,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,40,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,41,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",21,42,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",21,43,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",21,44,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,45,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,46,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",21,47,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",21,48,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",21,49,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"]},
    "1f469":{"1f3fb":["1f469-1f3fb",21,51,["\uD83D\uDC69\uD83C\uDFFB"],"1.0"],"1f3fc":["1f469-1f3fc",21,52,["\uD83D\uDC69\uD83C\uDFFC"],"1.0"],"1f3fd":["1f469-1f3fd",21,53,["\uD83D\uDC69\uD83C\uDFFD"],"1.0"],"1f3fe":["1f469-1f3fe",21,54,["\uD83D\uDC69\uD83C\uDFFE"],"1.0"],"1f3ff":["1f469-1f3ff",21,55,["\uD83D\uDC69\uD83C\uDFFF"],"1.0"]},
    "1f46b":{"1f3fb":["1f46b-1f3fb",21,58,["\uD83D\uDC6B\uD83C\uDFFB"],"12.0"],"1f3fc":["1f46b-1f3fc",21,59,["\uD83D\uDC6B\uD83C\uDFFC"],"12.0"],"1f3fd":["1f46b-1f3fd",21,60,["\uD83D\uDC6B\uD83C\uDFFD"],"12.0"],"1f3fe":["1f46b-1f3fe",21,61,["\uD83D\uDC6B\uD83C\uDFFE"],"12.0"],"1f3ff":["1f46b-1f3ff",21,62,["\uD83D\uDC6B\uD83C\uDFFF"],"12.0"],"1f3fb-1f3fc":["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",22,0,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fb-1f3fd":["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",22,1,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3fb-1f3fe":["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",22,2,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"],"1f3fb-1f3ff":["1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",22,3,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.0"],"1f3fc-1f3fb":["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",22,4,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fc-1f3fd":["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",22,5,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3fc-1f3fe":["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",22,6,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"],"1f3fc-1f3ff":["1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",22,7,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.0"],"1f3fd-1f3fb":["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",22,8,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fd-1f3fc":["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",22,9,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fd-1f3fe":["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",22,10,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"],"1f3fd-1f3ff":["1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",22,11,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.0"],"1f3fe-1f3fb":["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",22,12,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fe-1f3fc":["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",22,13,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fe-1f3fd":["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",22,14,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3fe-1f3ff":["1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",22,15,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.0"],"1f3ff-1f3fb":["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",22,16,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3ff-1f3fc":["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",22,17,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3ff-1f3fd":["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",22,18,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3ff-1f3fe":["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe",22,19,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"]},
    "1f46c":{"1f3fb":["1f46c-1f3fb",22,21,["\uD83D\uDC6C\uD83C\uDFFB"],"12.0"],"1f3fc":["1f46c-1f3fc",22,22,["\uD83D\uDC6C\uD83C\uDFFC"],"12.0"],"1f3fd":["1f46c-1f3fd",22,23,["\uD83D\uDC6C\uD83C\uDFFD"],"12.0"],"1f3fe":["1f46c-1f3fe",22,24,["\uD83D\uDC6C\uD83C\uDFFE"],"12.0"],"1f3ff":["1f46c-1f3ff",22,25,["\uD83D\uDC6C\uD83C\uDFFF"],"12.0"],"1f3fb-1f3fc":["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",22,26,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.1"],"1f3fb-1f3fd":["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",22,27,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.1"],"1f3fb-1f3fe":["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",22,28,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.1"],"1f3fb-1f3ff":["1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",22,29,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.1"],"1f3fc-1f3fb":["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",22,30,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fc-1f3fd":["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",22,31,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.1"],"1f3fc-1f3fe":["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",22,32,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.1"],"1f3fc-1f3ff":["1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",22,33,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.1"],"1f3fd-1f3fb":["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",22,34,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fd-1f3fc":["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",22,35,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fd-1f3fe":["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",22,36,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.1"],"1f3fd-1f3ff":["1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",22,37,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.1"],"1f3fe-1f3fb":["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",22,38,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fe-1f3fc":["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",22,39,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fe-1f3fd":["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",22,40,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3fe-1f3ff":["1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",22,41,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.1"],"1f3ff-1f3fb":["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",22,42,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3ff-1f3fc":["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",22,43,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3ff-1f3fd":["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",22,44,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3ff-1f3fe":["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe",22,45,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"]},
    "1f46d":{"1f3fb":["1f46d-1f3fb",22,47,["\uD83D\uDC6D\uD83C\uDFFB"],"12.0"],"1f3fc":["1f46d-1f3fc",22,48,["\uD83D\uDC6D\uD83C\uDFFC"],"12.0"],"1f3fd":["1f46d-1f3fd",22,49,["\uD83D\uDC6D\uD83C\uDFFD"],"12.0"],"1f3fe":["1f46d-1f3fe",22,50,["\uD83D\uDC6D\uD83C\uDFFE"],"12.0"],"1f3ff":["1f46d-1f3ff",22,51,["\uD83D\uDC6D\uD83C\uDFFF"],"12.0"],"1f3fb-1f3fc":["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",22,52,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC"],"12.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",22,53,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD"],"12.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",22,54,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE"],"12.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",22,55,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF"],"12.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",22,56,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB"],"12.0"],"1f3fc-1f3fd":["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",22,57,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD"],"12.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",22,58,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE"],"12.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",22,59,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF"],"12.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",22,60,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB"],"12.0"],"1f3fd-1f3fc":["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",22,61,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC"],"12.0"],"1f3fd-1f3fe":["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",22,62,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE"],"12.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",23,0,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF"],"12.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",23,1,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB"],"12.0"],"1f3fe-1f3fc":["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",23,2,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC"],"12.0"],"1f3fe-1f3fd":["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",23,3,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD"],"12.0"],"1f3fe-1f3ff":["1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",23,4,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF"],"12.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",23,5,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB"],"12.0"],"1f3ff-1f3fc":["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",23,6,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC"],"12.0"],"1f3ff-1f3fd":["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",23,7,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD"],"12.0"],"1f3ff-1f3fe":["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe",23,8,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE"],"12.0"]},
    "1f46e-200d-2640-fe0f":{"1f3fb":["1f46e-1f3fb-200d-2640-fe0f",23,10,["\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f46e-1f3fc-200d-2640-fe0f",23,11,["\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f46e-1f3fd-200d-2640-fe0f",23,12,["\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f46e-1f3fe-200d-2640-fe0f",23,13,["\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f46e-1f3ff-200d-2640-fe0f",23,14,["\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f46e-200d-2642-fe0f":{"1f3fb":["1f46e-1f3fb-200d-2642-fe0f",23,16,["\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f46e-1f3fc-200d-2642-fe0f",23,17,["\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f46e-1f3fd-200d-2642-fe0f",23,18,["\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f46e-1f3fe-200d-2642-fe0f",23,19,["\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f46e-1f3ff-200d-2642-fe0f",23,20,["\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f46e":{"1f3fb":["1f46e-1f3fb",23,22,["\uD83D\uDC6E\uD83C\uDFFB"],"1.0"],"1f3fc":["1f46e-1f3fc",23,23,["\uD83D\uDC6E\uD83C\uDFFC"],"1.0"],"1f3fd":["1f46e-1f3fd",23,24,["\uD83D\uDC6E\uD83C\uDFFD"],"1.0"],"1f3fe":["1f46e-1f3fe",23,25,["\uD83D\uDC6E\uD83C\uDFFE"],"1.0"],"1f3ff":["1f46e-1f3ff",23,26,["\uD83D\uDC6E\uD83C\uDFFF"],"1.0"]},
    "1f46f-200d-2640-fe0f":{"1f3fb":["1f46f-1f3fb-200d-2640-fe0f",23,28,["\uD83D\uDC6F\uD83C\uDFFB\u200D\u2640\uFE0F"],"17.0"],"1f3fc":["1f46f-1f3fc-200d-2640-fe0f",23,29,["\uD83D\uDC6F\uD83C\uDFFC\u200D\u2640\uFE0F"],"17.0"],"1f3fd":["1f46f-1f3fd-200d-2640-fe0f",23,30,["\uD83D\uDC6F\uD83C\uDFFD\u200D\u2640\uFE0F"],"17.0"],"1f3fe":["1f46f-1f3fe-200d-2640-fe0f",23,31,["\uD83D\uDC6F\uD83C\uDFFE\u200D\u2640\uFE0F"],"17.0"],"1f3ff":["1f46f-1f3ff-200d-2640-fe0f",23,32,["\uD83D\uDC6F\uD83C\uDFFF\u200D\u2640\uFE0F"],"17.0"],"1f3fb-1f3fc":["1f469-1f3fb-200d-1f430-200d-1f469-1f3fc",23,33,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFC"],"17.0"],"1f3fb-1f3fd":["1f469-1f3fb-200d-1f430-200d-1f469-1f3fd",23,34,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFD"],"17.0"],"1f3fb-1f3fe":["1f469-1f3fb-200d-1f430-200d-1f469-1f3fe",23,35,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFE"],"17.0"],"1f3fb-1f3ff":["1f469-1f3fb-200d-1f430-200d-1f469-1f3ff",23,36,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFF"],"17.0"],"1f3fc-1f3fb":["1f469-1f3fc-200d-1f430-200d-1f469-1f3fb",23,37,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFB"],"17.0"],"1f3fc-1f3fd":["1f469-1f3fc-200d-1f430-200d-1f469-1f3fd",23,38,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFD"],"17.0"],"1f3fc-1f3fe":["1f469-1f3fc-200d-1f430-200d-1f469-1f3fe",23,39,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFE"],"17.0"],"1f3fc-1f3ff":["1f469-1f3fc-200d-1f430-200d-1f469-1f3ff",23,40,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFF"],"17.0"],"1f3fd-1f3fb":["1f469-1f3fd-200d-1f430-200d-1f469-1f3fb",23,41,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFB"],"17.0"],"1f3fd-1f3fc":["1f469-1f3fd-200d-1f430-200d-1f469-1f3fc",23,42,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFC"],"17.0"],"1f3fd-1f3fe":["1f469-1f3fd-200d-1f430-200d-1f469-1f3fe",23,43,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFE"],"17.0"],"1f3fd-1f3ff":["1f469-1f3fd-200d-1f430-200d-1f469-1f3ff",23,44,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFF"],"17.0"],"1f3fe-1f3fb":["1f469-1f3fe-200d-1f430-200d-1f469-1f3fb",23,45,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFB"],"17.0"],"1f3fe-1f3fc":["1f469-1f3fe-200d-1f430-200d-1f469-1f3fc",23,46,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFC"],"17.0"],"1f3fe-1f3fd":["1f469-1f3fe-200d-1f430-200d-1f469-1f3fd",23,47,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFD"],"17.0"],"1f3fe-1f3ff":["1f469-1f3fe-200d-1f430-200d-1f469-1f3ff",23,48,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFF"],"17.0"],"1f3ff-1f3fb":["1f469-1f3ff-200d-1f430-200d-1f469-1f3fb",23,49,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFB"],"17.0"],"1f3ff-1f3fc":["1f469-1f3ff-200d-1f430-200d-1f469-1f3fc",23,50,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFC"],"17.0"],"1f3ff-1f3fd":["1f469-1f3ff-200d-1f430-200d-1f469-1f3fd",23,51,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFD"],"17.0"],"1f3ff-1f3fe":["1f469-1f3ff-200d-1f430-200d-1f469-1f3fe",23,52,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFE"],"17.0"]},
    "1f46f-200d-2642-fe0f":{"1f3fb":["1f46f-1f3fb-200d-2642-fe0f",23,54,["\uD83D\uDC6F\uD83C\uDFFB\u200D\u2642\uFE0F"],"17.0"],"1f3fc":["1f46f-1f3fc-200d-2642-fe0f",23,55,["\uD83D\uDC6F\uD83C\uDFFC\u200D\u2642\uFE0F"],"17.0"],"1f3fd":["1f46f-1f3fd-200d-2642-fe0f",23,56,["\uD83D\uDC6F\uD83C\uDFFD\u200D\u2642\uFE0F"],"17.0"],"1f3fe":["1f46f-1f3fe-200d-2642-fe0f",23,57,["\uD83D\uDC6F\uD83C\uDFFE\u200D\u2642\uFE0F"],"17.0"],"1f3ff":["1f46f-1f3ff-200d-2642-fe0f",23,58,["\uD83D\uDC6F\uD83C\uDFFF\u200D\u2642\uFE0F"],"17.0"],"1f3fb-1f3fc":["1f468-1f3fb-200d-1f430-200d-1f468-1f3fc",23,59,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFC"],"17.0"],"1f3fb-1f3fd":["1f468-1f3fb-200d-1f430-200d-1f468-1f3fd",23,60,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFD"],"17.0"],"1f3fb-1f3fe":["1f468-1f3fb-200d-1f430-200d-1f468-1f3fe",23,61,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFE"],"17.0"],"1f3fb-1f3ff":["1f468-1f3fb-200d-1f430-200d-1f468-1f3ff",23,62,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFF"],"17.0"],"1f3fc-1f3fb":["1f468-1f3fc-200d-1f430-200d-1f468-1f3fb",24,0,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFB"],"17.0"],"1f3fc-1f3fd":["1f468-1f3fc-200d-1f430-200d-1f468-1f3fd",24,1,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFD"],"17.0"],"1f3fc-1f3fe":["1f468-1f3fc-200d-1f430-200d-1f468-1f3fe",24,2,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFE"],"17.0"],"1f3fc-1f3ff":["1f468-1f3fc-200d-1f430-200d-1f468-1f3ff",24,3,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFF"],"17.0"],"1f3fd-1f3fb":["1f468-1f3fd-200d-1f430-200d-1f468-1f3fb",24,4,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFB"],"17.0"],"1f3fd-1f3fc":["1f468-1f3fd-200d-1f430-200d-1f468-1f3fc",24,5,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFC"],"17.0"],"1f3fd-1f3fe":["1f468-1f3fd-200d-1f430-200d-1f468-1f3fe",24,6,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFE"],"17.0"],"1f3fd-1f3ff":["1f468-1f3fd-200d-1f430-200d-1f468-1f3ff",24,7,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFF"],"17.0"],"1f3fe-1f3fb":["1f468-1f3fe-200d-1f430-200d-1f468-1f3fb",24,8,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFB"],"17.0"],"1f3fe-1f3fc":["1f468-1f3fe-200d-1f430-200d-1f468-1f3fc",24,9,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFC"],"17.0"],"1f3fe-1f3fd":["1f468-1f3fe-200d-1f430-200d-1f468-1f3fd",24,10,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFD"],"17.0"],"1f3fe-1f3ff":["1f468-1f3fe-200d-1f430-200d-1f468-1f3ff",24,11,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFF"],"17.0"],"1f3ff-1f3fb":["1f468-1f3ff-200d-1f430-200d-1f468-1f3fb",24,12,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFB"],"17.0"],"1f3ff-1f3fc":["1f468-1f3ff-200d-1f430-200d-1f468-1f3fc",24,13,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFC"],"17.0"],"1f3ff-1f3fd":["1f468-1f3ff-200d-1f430-200d-1f468-1f3fd",24,14,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFD"],"17.0"],"1f3ff-1f3fe":["1f468-1f3ff-200d-1f430-200d-1f468-1f3fe",24,15,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFE"],"17.0"]},
    "1f46f":{"1f3fb":["1f46f-1f3fb",24,17,["\uD83D\uDC6F\uD83C\uDFFB"],"17.0"],"1f3fc":["1f46f-1f3fc",24,18,["\uD83D\uDC6F\uD83C\uDFFC"],"17.0"],"1f3fd":["1f46f-1f3fd",24,19,["\uD83D\uDC6F\uD83C\uDFFD"],"17.0"],"1f3fe":["1f46f-1f3fe",24,20,["\uD83D\uDC6F\uD83C\uDFFE"],"17.0"],"1f3ff":["1f46f-1f3ff",24,21,["\uD83D\uDC6F\uD83C\uDFFF"],"17.0"],"1f3fb-1f3fc":["1f9d1-1f3fb-200d-1f430-200d-1f9d1-1f3fc",24,22,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFC"],"17.0"],"1f3fb-1f3fd":["1f9d1-1f3fb-200d-1f430-200d-1f9d1-1f3fd",24,23,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFD"],"17.0"],"1f3fb-1f3fe":["1f9d1-1f3fb-200d-1f430-200d-1f9d1-1f3fe",24,24,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFE"],"17.0"],"1f3fb-1f3ff":["1f9d1-1f3fb-200d-1f430-200d-1f9d1-1f3ff",24,25,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFF"],"17.0"],"1f3fc-1f3fb":["1f9d1-1f3fc-200d-1f430-200d-1f9d1-1f3fb",24,26,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFB"],"17.0"],"1f3fc-1f3fd":["1f9d1-1f3fc-200d-1f430-200d-1f9d1-1f3fd",24,27,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFD"],"17.0"],"1f3fc-1f3fe":["1f9d1-1f3fc-200d-1f430-200d-1f9d1-1f3fe",24,28,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFE"],"17.0"],"1f3fc-1f3ff":["1f9d1-1f3fc-200d-1f430-200d-1f9d1-1f3ff",24,29,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFF"],"17.0"],"1f3fd-1f3fb":["1f9d1-1f3fd-200d-1f430-200d-1f9d1-1f3fb",24,30,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFB"],"17.0"],"1f3fd-1f3fc":["1f9d1-1f3fd-200d-1f430-200d-1f9d1-1f3fc",24,31,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFC"],"17.0"],"1f3fd-1f3fe":["1f9d1-1f3fd-200d-1f430-200d-1f9d1-1f3fe",24,32,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFE"],"17.0"],"1f3fd-1f3ff":["1f9d1-1f3fd-200d-1f430-200d-1f9d1-1f3ff",24,33,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFF"],"17.0"],"1f3fe-1f3fb":["1f9d1-1f3fe-200d-1f430-200d-1f9d1-1f3fb",24,34,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFB"],"17.0"],"1f3fe-1f3fc":["1f9d1-1f3fe-200d-1f430-200d-1f9d1-1f3fc",24,35,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFC"],"17.0"],"1f3fe-1f3fd":["1f9d1-1f3fe-200d-1f430-200d-1f9d1-1f3fd",24,36,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFD"],"17.0"],"1f3fe-1f3ff":["1f9d1-1f3fe-200d-1f430-200d-1f9d1-1f3ff",24,37,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFF"],"17.0"],"1f3ff-1f3fb":["1f9d1-1f3ff-200d-1f430-200d-1f9d1-1f3fb",24,38,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFB"],"17.0"],"1f3ff-1f3fc":["1f9d1-1f3ff-200d-1f430-200d-1f9d1-1f3fc",24,39,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFC"],"17.0"],"1f3ff-1f3fd":["1f9d1-1f3ff-200d-1f430-200d-1f9d1-1f3fd",24,40,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFD"],"17.0"],"1f3ff-1f3fe":["1f9d1-1f3ff-200d-1f430-200d-1f9d1-1f3fe",24,41,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFE"],"17.0"]},
    "1f470-200d-2640-fe0f":{"1f3fb":["1f470-1f3fb-200d-2640-fe0f",24,43,["\uD83D\uDC70\uD83C\uDFFB\u200D\u2640\uFE0F"],"13.0"],"1f3fc":["1f470-1f3fc-200d-2640-fe0f",24,44,["\uD83D\uDC70\uD83C\uDFFC\u200D\u2640\uFE0F"],"13.0"],"1f3fd":["1f470-1f3fd-200d-2640-fe0f",24,45,["\uD83D\uDC70\uD83C\uDFFD\u200D\u2640\uFE0F"],"13.0"],"1f3fe":["1f470-1f3fe-200d-2640-fe0f",24,46,["\uD83D\uDC70\uD83C\uDFFE\u200D\u2640\uFE0F"],"13.0"],"1f3ff":["1f470-1f3ff-200d-2640-fe0f",24,47,["\uD83D\uDC70\uD83C\uDFFF\u200D\u2640\uFE0F"],"13.0"]},
    "1f470-200d-2642-fe0f":{"1f3fb":["1f470-1f3fb-200d-2642-fe0f",24,49,["\uD83D\uDC70\uD83C\uDFFB\u200D\u2642\uFE0F"],"13.0"],"1f3fc":["1f470-1f3fc-200d-2642-fe0f",24,50,["\uD83D\uDC70\uD83C\uDFFC\u200D\u2642\uFE0F"],"13.0"],"1f3fd":["1f470-1f3fd-200d-2642-fe0f",24,51,["\uD83D\uDC70\uD83C\uDFFD\u200D\u2642\uFE0F"],"13.0"],"1f3fe":["1f470-1f3fe-200d-2642-fe0f",24,52,["\uD83D\uDC70\uD83C\uDFFE\u200D\u2642\uFE0F"],"13.0"],"1f3ff":["1f470-1f3ff-200d-2642-fe0f",24,53,["\uD83D\uDC70\uD83C\uDFFF\u200D\u2642\uFE0F"],"13.0"]},
    "1f470":{"1f3fb":["1f470-1f3fb",24,55,["\uD83D\uDC70\uD83C\uDFFB"],"1.0"],"1f3fc":["1f470-1f3fc",24,56,["\uD83D\uDC70\uD83C\uDFFC"],"1.0"],"1f3fd":["1f470-1f3fd",24,57,["\uD83D\uDC70\uD83C\uDFFD"],"1.0"],"1f3fe":["1f470-1f3fe",24,58,["\uD83D\uDC70\uD83C\uDFFE"],"1.0"],"1f3ff":["1f470-1f3ff",24,59,["\uD83D\uDC70\uD83C\uDFFF"],"1.0"]},
    "1f471-200d-2640-fe0f":{"1f3fb":["1f471-1f3fb-200d-2640-fe0f",24,61,["\uD83D\uDC71\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f471-1f3fc-200d-2640-fe0f",24,62,["\uD83D\uDC71\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f471-1f3fd-200d-2640-fe0f",25,0,["\uD83D\uDC71\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f471-1f3fe-200d-2640-fe0f",25,1,["\uD83D\uDC71\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f471-1f3ff-200d-2640-fe0f",25,2,["\uD83D\uDC71\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f471-200d-2642-fe0f":{"1f3fb":["1f471-1f3fb-200d-2642-fe0f",25,4,["\uD83D\uDC71\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f471-1f3fc-200d-2642-fe0f",25,5,["\uD83D\uDC71\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f471-1f3fd-200d-2642-fe0f",25,6,["\uD83D\uDC71\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f471-1f3fe-200d-2642-fe0f",25,7,["\uD83D\uDC71\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f471-1f3ff-200d-2642-fe0f",25,8,["\uD83D\uDC71\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f471":{"1f3fb":["1f471-1f3fb",25,10,["\uD83D\uDC71\uD83C\uDFFB"],"1.0"],"1f3fc":["1f471-1f3fc",25,11,["\uD83D\uDC71\uD83C\uDFFC"],"1.0"],"1f3fd":["1f471-1f3fd",25,12,["\uD83D\uDC71\uD83C\uDFFD"],"1.0"],"1f3fe":["1f471-1f3fe",25,13,["\uD83D\uDC71\uD83C\uDFFE"],"1.0"],"1f3ff":["1f471-1f3ff",25,14,["\uD83D\uDC71\uD83C\uDFFF"],"1.0"]},
    "1f472":{"1f3fb":["1f472-1f3fb",25,16,["\uD83D\uDC72\uD83C\uDFFB"],"1.0"],"1f3fc":["1f472-1f3fc",25,17,["\uD83D\uDC72\uD83C\uDFFC"],"1.0"],"1f3fd":["1f472-1f3fd",25,18,["\uD83D\uDC72\uD83C\uDFFD"],"1.0"],"1f3fe":["1f472-1f3fe",25,19,["\uD83D\uDC72\uD83C\uDFFE"],"1.0"],"1f3ff":["1f472-1f3ff",25,20,["\uD83D\uDC72\uD83C\uDFFF"],"1.0"]},
    "1f473-200d-2640-fe0f":{"1f3fb":["1f473-1f3fb-200d-2640-fe0f",25,22,["\uD83D\uDC73\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f473-1f3fc-200d-2640-fe0f",25,23,["\uD83D\uDC73\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f473-1f3fd-200d-2640-fe0f",25,24,["\uD83D\uDC73\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f473-1f3fe-200d-2640-fe0f",25,25,["\uD83D\uDC73\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f473-1f3ff-200d-2640-fe0f",25,26,["\uD83D\uDC73\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f473-200d-2642-fe0f":{"1f3fb":["1f473-1f3fb-200d-2642-fe0f",25,28,["\uD83D\uDC73\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f473-1f3fc-200d-2642-fe0f",25,29,["\uD83D\uDC73\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f473-1f3fd-200d-2642-fe0f",25,30,["\uD83D\uDC73\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f473-1f3fe-200d-2642-fe0f",25,31,["\uD83D\uDC73\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f473-1f3ff-200d-2642-fe0f",25,32,["\uD83D\uDC73\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f473":{"1f3fb":["1f473-1f3fb",25,34,["\uD83D\uDC73\uD83C\uDFFB"],"1.0"],"1f3fc":["1f473-1f3fc",25,35,["\uD83D\uDC73\uD83C\uDFFC"],"1.0"],"1f3fd":["1f473-1f3fd",25,36,["\uD83D\uDC73\uD83C\uDFFD"],"1.0"],"1f3fe":["1f473-1f3fe",25,37,["\uD83D\uDC73\uD83C\uDFFE"],"1.0"],"1f3ff":["1f473-1f3ff",25,38,["\uD83D\uDC73\uD83C\uDFFF"],"1.0"]},
    "1f474":{"1f3fb":["1f474-1f3fb",25,40,["\uD83D\uDC74\uD83C\uDFFB"],"1.0"],"1f3fc":["1f474-1f3fc",25,41,["\uD83D\uDC74\uD83C\uDFFC"],"1.0"],"1f3fd":["1f474-1f3fd",25,42,["\uD83D\uDC74\uD83C\uDFFD"],"1.0"],"1f3fe":["1f474-1f3fe",25,43,["\uD83D\uDC74\uD83C\uDFFE"],"1.0"],"1f3ff":["1f474-1f3ff",25,44,["\uD83D\uDC74\uD83C\uDFFF"],"1.0"]},
    "1f475":{"1f3fb":["1f475-1f3fb",25,46,["\uD83D\uDC75\uD83C\uDFFB"],"1.0"],"1f3fc":["1f475-1f3fc",25,47,["\uD83D\uDC75\uD83C\uDFFC"],"1.0"],"1f3fd":["1f475-1f3fd",25,48,["\uD83D\uDC75\uD83C\uDFFD"],"1.0"],"1f3fe":["1f475-1f3fe",25,49,["\uD83D\uDC75\uD83C\uDFFE"],"1.0"],"1f3ff":["1f475-1f3ff",25,50,["\uD83D\uDC75\uD83C\uDFFF"],"1.0"]},
    "1f476":{"1f3fb":["1f476-1f3fb",25,52,["\uD83D\uDC76\uD83C\uDFFB"],"1.0"],"1f3fc":["1f476-1f3fc",25,53,["\uD83D\uDC76\uD83C\uDFFC"],"1.0"],"1f3fd":["1f476-1f3fd",25,54,["\uD83D\uDC76\uD83C\uDFFD"],"1.0"],"1f3fe":["1f476-1f3fe",25,55,["\uD83D\uDC76\uD83C\uDFFE"],"1.0"],"1f3ff":["1f476-1f3ff",25,56,["\uD83D\uDC76\uD83C\uDFFF"],"1.0"]},
    "1f477-200d-2640-fe0f":{"1f3fb":["1f477-1f3fb-200d-2640-fe0f",25,58,["\uD83D\uDC77\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f477-1f3fc-200d-2640-fe0f",25,59,["\uD83D\uDC77\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f477-1f3fd-200d-2640-fe0f",25,60,["\uD83D\uDC77\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f477-1f3fe-200d-2640-fe0f",25,61,["\uD83D\uDC77\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f477-1f3ff-200d-2640-fe0f",25,62,["\uD83D\uDC77\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f477-200d-2642-fe0f":{"1f3fb":["1f477-1f3fb-200d-2642-fe0f",26,1,["\uD83D\uDC77\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f477-1f3fc-200d-2642-fe0f",26,2,["\uD83D\uDC77\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f477-1f3fd-200d-2642-fe0f",26,3,["\uD83D\uDC77\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f477-1f3fe-200d-2642-fe0f",26,4,["\uD83D\uDC77\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f477-1f3ff-200d-2642-fe0f",26,5,["\uD83D\uDC77\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f477":{"1f3fb":["1f477-1f3fb",26,7,["\uD83D\uDC77\uD83C\uDFFB"],"1.0"],"1f3fc":["1f477-1f3fc",26,8,["\uD83D\uDC77\uD83C\uDFFC"],"1.0"],"1f3fd":["1f477-1f3fd",26,9,["\uD83D\uDC77\uD83C\uDFFD"],"1.0"],"1f3fe":["1f477-1f3fe",26,10,["\uD83D\uDC77\uD83C\uDFFE"],"1.0"],"1f3ff":["1f477-1f3ff",26,11,["\uD83D\uDC77\uD83C\uDFFF"],"1.0"]},
    "1f478":{"1f3fb":["1f478-1f3fb",26,13,["\uD83D\uDC78\uD83C\uDFFB"],"1.0"],"1f3fc":["1f478-1f3fc",26,14,["\uD83D\uDC78\uD83C\uDFFC"],"1.0"],"1f3fd":["1f478-1f3fd",26,15,["\uD83D\uDC78\uD83C\uDFFD"],"1.0"],"1f3fe":["1f478-1f3fe",26,16,["\uD83D\uDC78\uD83C\uDFFE"],"1.0"],"1f3ff":["1f478-1f3ff",26,17,["\uD83D\uDC78\uD83C\uDFFF"],"1.0"]},
    "1f47c":{"1f3fb":["1f47c-1f3fb",26,22,["\uD83D\uDC7C\uD83C\uDFFB"],"1.0"],"1f3fc":["1f47c-1f3fc",26,23,["\uD83D\uDC7C\uD83C\uDFFC"],"1.0"],"1f3fd":["1f47c-1f3fd",26,24,["\uD83D\uDC7C\uD83C\uDFFD"],"1.0"],"1f3fe":["1f47c-1f3fe",26,25,["\uD83D\uDC7C\uD83C\uDFFE"],"1.0"],"1f3ff":["1f47c-1f3ff",26,26,["\uD83D\uDC7C\uD83C\uDFFF"],"1.0"]},
    "1f481-200d-2640-fe0f":{"1f3fb":["1f481-1f3fb-200d-2640-fe0f",26,32,["\uD83D\uDC81\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f481-1f3fc-200d-2640-fe0f",26,33,["\uD83D\uDC81\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f481-1f3fd-200d-2640-fe0f",26,34,["\uD83D\uDC81\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f481-1f3fe-200d-2640-fe0f",26,35,["\uD83D\uDC81\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f481-1f3ff-200d-2640-fe0f",26,36,["\uD83D\uDC81\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f481-200d-2642-fe0f":{"1f3fb":["1f481-1f3fb-200d-2642-fe0f",26,38,["\uD83D\uDC81\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f481-1f3fc-200d-2642-fe0f",26,39,["\uD83D\uDC81\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f481-1f3fd-200d-2642-fe0f",26,40,["\uD83D\uDC81\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f481-1f3fe-200d-2642-fe0f",26,41,["\uD83D\uDC81\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f481-1f3ff-200d-2642-fe0f",26,42,["\uD83D\uDC81\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f481":{"1f3fb":["1f481-1f3fb",26,44,["\uD83D\uDC81\uD83C\uDFFB"],"1.0"],"1f3fc":["1f481-1f3fc",26,45,["\uD83D\uDC81\uD83C\uDFFC"],"1.0"],"1f3fd":["1f481-1f3fd",26,46,["\uD83D\uDC81\uD83C\uDFFD"],"1.0"],"1f3fe":["1f481-1f3fe",26,47,["\uD83D\uDC81\uD83C\uDFFE"],"1.0"],"1f3ff":["1f481-1f3ff",26,48,["\uD83D\uDC81\uD83C\uDFFF"],"1.0"]},
    "1f482-200d-2640-fe0f":{"1f3fb":["1f482-1f3fb-200d-2640-fe0f",26,50,["\uD83D\uDC82\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f482-1f3fc-200d-2640-fe0f",26,51,["\uD83D\uDC82\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f482-1f3fd-200d-2640-fe0f",26,52,["\uD83D\uDC82\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f482-1f3fe-200d-2640-fe0f",26,53,["\uD83D\uDC82\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f482-1f3ff-200d-2640-fe0f",26,54,["\uD83D\uDC82\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f482-200d-2642-fe0f":{"1f3fb":["1f482-1f3fb-200d-2642-fe0f",26,56,["\uD83D\uDC82\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f482-1f3fc-200d-2642-fe0f",26,57,["\uD83D\uDC82\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f482-1f3fd-200d-2642-fe0f",26,58,["\uD83D\uDC82\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f482-1f3fe-200d-2642-fe0f",26,59,["\uD83D\uDC82\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f482-1f3ff-200d-2642-fe0f",26,60,["\uD83D\uDC82\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f482":{"1f3fb":["1f482-1f3fb",26,62,["\uD83D\uDC82\uD83C\uDFFB"],"1.0"],"1f3fc":["1f482-1f3fc",27,0,["\uD83D\uDC82\uD83C\uDFFC"],"1.0"],"1f3fd":["1f482-1f3fd",27,1,["\uD83D\uDC82\uD83C\uDFFD"],"1.0"],"1f3fe":["1f482-1f3fe",27,2,["\uD83D\uDC82\uD83C\uDFFE"],"1.0"],"1f3ff":["1f482-1f3ff",27,3,["\uD83D\uDC82\uD83C\uDFFF"],"1.0"]},
    "1f483":{"1f3fb":["1f483-1f3fb",27,5,["\uD83D\uDC83\uD83C\uDFFB"],"1.0"],"1f3fc":["1f483-1f3fc",27,6,["\uD83D\uDC83\uD83C\uDFFC"],"1.0"],"1f3fd":["1f483-1f3fd",27,7,["\uD83D\uDC83\uD83C\uDFFD"],"1.0"],"1f3fe":["1f483-1f3fe",27,8,["\uD83D\uDC83\uD83C\uDFFE"],"1.0"],"1f3ff":["1f483-1f3ff",27,9,["\uD83D\uDC83\uD83C\uDFFF"],"1.0"]},
    "1f485":{"1f3fb":["1f485-1f3fb",27,12,["\uD83D\uDC85\uD83C\uDFFB"],"1.0"],"1f3fc":["1f485-1f3fc",27,13,["\uD83D\uDC85\uD83C\uDFFC"],"1.0"],"1f3fd":["1f485-1f3fd",27,14,["\uD83D\uDC85\uD83C\uDFFD"],"1.0"],"1f3fe":["1f485-1f3fe",27,15,["\uD83D\uDC85\uD83C\uDFFE"],"1.0"],"1f3ff":["1f485-1f3ff",27,16,["\uD83D\uDC85\uD83C\uDFFF"],"1.0"]},
    "1f486-200d-2640-fe0f":{"1f3fb":["1f486-1f3fb-200d-2640-fe0f",27,18,["\uD83D\uDC86\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f486-1f3fc-200d-2640-fe0f",27,19,["\uD83D\uDC86\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f486-1f3fd-200d-2640-fe0f",27,20,["\uD83D\uDC86\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f486-1f3fe-200d-2640-fe0f",27,21,["\uD83D\uDC86\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f486-1f3ff-200d-2640-fe0f",27,22,["\uD83D\uDC86\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f486-200d-2642-fe0f":{"1f3fb":["1f486-1f3fb-200d-2642-fe0f",27,24,["\uD83D\uDC86\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f486-1f3fc-200d-2642-fe0f",27,25,["\uD83D\uDC86\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f486-1f3fd-200d-2642-fe0f",27,26,["\uD83D\uDC86\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f486-1f3fe-200d-2642-fe0f",27,27,["\uD83D\uDC86\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f486-1f3ff-200d-2642-fe0f",27,28,["\uD83D\uDC86\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f486":{"1f3fb":["1f486-1f3fb",27,30,["\uD83D\uDC86\uD83C\uDFFB"],"1.0"],"1f3fc":["1f486-1f3fc",27,31,["\uD83D\uDC86\uD83C\uDFFC"],"1.0"],"1f3fd":["1f486-1f3fd",27,32,["\uD83D\uDC86\uD83C\uDFFD"],"1.0"],"1f3fe":["1f486-1f3fe",27,33,["\uD83D\uDC86\uD83C\uDFFE"],"1.0"],"1f3ff":["1f486-1f3ff",27,34,["\uD83D\uDC86\uD83C\uDFFF"],"1.0"]},
    "1f487-200d-2640-fe0f":{"1f3fb":["1f487-1f3fb-200d-2640-fe0f",27,36,["\uD83D\uDC87\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f487-1f3fc-200d-2640-fe0f",27,37,["\uD83D\uDC87\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f487-1f3fd-200d-2640-fe0f",27,38,["\uD83D\uDC87\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f487-1f3fe-200d-2640-fe0f",27,39,["\uD83D\uDC87\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f487-1f3ff-200d-2640-fe0f",27,40,["\uD83D\uDC87\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f487-200d-2642-fe0f":{"1f3fb":["1f487-1f3fb-200d-2642-fe0f",27,42,["\uD83D\uDC87\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f487-1f3fc-200d-2642-fe0f",27,43,["\uD83D\uDC87\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f487-1f3fd-200d-2642-fe0f",27,44,["\uD83D\uDC87\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f487-1f3fe-200d-2642-fe0f",27,45,["\uD83D\uDC87\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f487-1f3ff-200d-2642-fe0f",27,46,["\uD83D\uDC87\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f487":{"1f3fb":["1f487-1f3fb",27,48,["\uD83D\uDC87\uD83C\uDFFB"],"1.0"],"1f3fc":["1f487-1f3fc",27,49,["\uD83D\uDC87\uD83C\uDFFC"],"1.0"],"1f3fd":["1f487-1f3fd",27,50,["\uD83D\uDC87\uD83C\uDFFD"],"1.0"],"1f3fe":["1f487-1f3fe",27,51,["\uD83D\uDC87\uD83C\uDFFE"],"1.0"],"1f3ff":["1f487-1f3ff",27,52,["\uD83D\uDC87\uD83C\uDFFF"],"1.0"]},
    "1f48f":{"1f3fb":["1f48f-1f3fb",27,61,["\uD83D\uDC8F\uD83C\uDFFB"],"13.1"],"1f3fc":["1f48f-1f3fc",27,62,["\uD83D\uDC8F\uD83C\uDFFC"],"13.1"],"1f3fd":["1f48f-1f3fd",28,0,["\uD83D\uDC8F\uD83C\uDFFD"],"13.1"],"1f3fe":["1f48f-1f3fe",28,1,["\uD83D\uDC8F\uD83C\uDFFE"],"13.1"],"1f3ff":["1f48f-1f3ff",28,2,["\uD83D\uDC8F\uD83C\uDFFF"],"13.1"],"1f3fb-1f3fc":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",28,3,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",28,4,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",28,5,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",28,6,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",28,7,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fd":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",28,8,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",28,9,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",28,10,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",28,11,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",28,12,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fe":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",28,13,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",28,14,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",28,15,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",28,16,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",28,17,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fe-1f3ff":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",28,18,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",28,19,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",28,20,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",28,21,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",28,22,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"]},
    "1f491":{"1f3fb":["1f491-1f3fb",28,25,["\uD83D\uDC91\uD83C\uDFFB"],"13.1"],"1f3fc":["1f491-1f3fc",28,26,["\uD83D\uDC91\uD83C\uDFFC"],"13.1"],"1f3fd":["1f491-1f3fd",28,27,["\uD83D\uDC91\uD83C\uDFFD"],"13.1"],"1f3fe":["1f491-1f3fe",28,28,["\uD83D\uDC91\uD83C\uDFFE"],"13.1"],"1f3ff":["1f491-1f3ff",28,29,["\uD83D\uDC91\uD83C\uDFFF"],"13.1"],"1f3fb-1f3fc":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",28,30,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",28,31,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",28,32,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",28,33,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",28,34,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fd":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",28,35,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",28,36,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",28,37,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",28,38,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",28,39,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fe":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",28,40,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",28,41,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",28,42,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",28,43,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",28,44,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fe-1f3ff":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",28,45,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",28,46,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",28,47,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",28,48,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe",28,49,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"]},
    "1f4aa":{"1f3fb":["1f4aa-1f3fb",29,12,["\uD83D\uDCAA\uD83C\uDFFB"],"1.0"],"1f3fc":["1f4aa-1f3fc",29,13,["\uD83D\uDCAA\uD83C\uDFFC"],"1.0"],"1f3fd":["1f4aa-1f3fd",29,14,["\uD83D\uDCAA\uD83C\uDFFD"],"1.0"],"1f3fe":["1f4aa-1f3fe",29,15,["\uD83D\uDCAA\uD83C\uDFFE"],"1.0"],"1f3ff":["1f4aa-1f3ff",29,16,["\uD83D\uDCAA\uD83C\uDFFF"],"1.0"]},
    "1f574-fe0f":{"1f3fb":["1f574-1f3fb",32,8,["\uD83D\uDD74\uD83C\uDFFB"],"4.0"],"1f3fc":["1f574-1f3fc",32,9,["\uD83D\uDD74\uD83C\uDFFC"],"4.0"],"1f3fd":["1f574-1f3fd",32,10,["\uD83D\uDD74\uD83C\uDFFD"],"4.0"],"1f3fe":["1f574-1f3fe",32,11,["\uD83D\uDD74\uD83C\uDFFE"],"4.0"],"1f3ff":["1f574-1f3ff",32,12,["\uD83D\uDD74\uD83C\uDFFF"],"4.0"]},
    "1f575-fe0f-200d-2640-fe0f":{"1f3fb":["1f575-1f3fb-200d-2640-fe0f",32,14,["\uD83D\uDD75\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f575-1f3fc-200d-2640-fe0f",32,15,["\uD83D\uDD75\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f575-1f3fd-200d-2640-fe0f",32,16,["\uD83D\uDD75\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f575-1f3fe-200d-2640-fe0f",32,17,["\uD83D\uDD75\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f575-1f3ff-200d-2640-fe0f",32,18,["\uD83D\uDD75\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f575-fe0f-200d-2642-fe0f":{"1f3fb":["1f575-1f3fb-200d-2642-fe0f",32,20,["\uD83D\uDD75\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f575-1f3fc-200d-2642-fe0f",32,21,["\uD83D\uDD75\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f575-1f3fd-200d-2642-fe0f",32,22,["\uD83D\uDD75\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f575-1f3fe-200d-2642-fe0f",32,23,["\uD83D\uDD75\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f575-1f3ff-200d-2642-fe0f",32,24,["\uD83D\uDD75\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f575-fe0f":{"1f3fb":["1f575-1f3fb",32,26,["\uD83D\uDD75\uD83C\uDFFB"],"2.0"],"1f3fc":["1f575-1f3fc",32,27,["\uD83D\uDD75\uD83C\uDFFC"],"2.0"],"1f3fd":["1f575-1f3fd",32,28,["\uD83D\uDD75\uD83C\uDFFD"],"2.0"],"1f3fe":["1f575-1f3fe",32,29,["\uD83D\uDD75\uD83C\uDFFE"],"2.0"],"1f3ff":["1f575-1f3ff",32,30,["\uD83D\uDD75\uD83C\uDFFF"],"2.0"]},
    "1f57a":{"1f3fb":["1f57a-1f3fb",32,36,["\uD83D\uDD7A\uD83C\uDFFB"],"3.0"],"1f3fc":["1f57a-1f3fc",32,37,["\uD83D\uDD7A\uD83C\uDFFC"],"3.0"],"1f3fd":["1f57a-1f3fd",32,38,["\uD83D\uDD7A\uD83C\uDFFD"],"3.0"],"1f3fe":["1f57a-1f3fe",32,39,["\uD83D\uDD7A\uD83C\uDFFE"],"3.0"],"1f3ff":["1f57a-1f3ff",32,40,["\uD83D\uDD7A\uD83C\uDFFF"],"3.0"]},
    "1f590-fe0f":{"1f3fb":["1f590-1f3fb",32,47,["\uD83D\uDD90\uD83C\uDFFB"],"1.0"],"1f3fc":["1f590-1f3fc",32,48,["\uD83D\uDD90\uD83C\uDFFC"],"1.0"],"1f3fd":["1f590-1f3fd",32,49,["\uD83D\uDD90\uD83C\uDFFD"],"1.0"],"1f3fe":["1f590-1f3fe",32,50,["\uD83D\uDD90\uD83C\uDFFE"],"1.0"],"1f3ff":["1f590-1f3ff",32,51,["\uD83D\uDD90\uD83C\uDFFF"],"1.0"]},
    "1f595":{"1f3fb":["1f595-1f3fb",32,53,["\uD83D\uDD95\uD83C\uDFFB"],"1.0"],"1f3fc":["1f595-1f3fc",32,54,["\uD83D\uDD95\uD83C\uDFFC"],"1.0"],"1f3fd":["1f595-1f3fd",32,55,["\uD83D\uDD95\uD83C\uDFFD"],"1.0"],"1f3fe":["1f595-1f3fe",32,56,["\uD83D\uDD95\uD83C\uDFFE"],"1.0"],"1f3ff":["1f595-1f3ff",32,57,["\uD83D\uDD95\uD83C\uDFFF"],"1.0"]},
    "1f596":{"1f3fb":["1f596-1f3fb",32,59,["\uD83D\uDD96\uD83C\uDFFB"],"1.0"],"1f3fc":["1f596-1f3fc",32,60,["\uD83D\uDD96\uD83C\uDFFC"],"1.0"],"1f3fd":["1f596-1f3fd",32,61,["\uD83D\uDD96\uD83C\uDFFD"],"1.0"],"1f3fe":["1f596-1f3fe",32,62,["\uD83D\uDD96\uD83C\uDFFE"],"1.0"],"1f3ff":["1f596-1f3ff",33,0,["\uD83D\uDD96\uD83C\uDFFF"],"1.0"]},
    "1f645-200d-2640-fe0f":{"1f3fb":["1f645-1f3fb-200d-2640-fe0f",34,39,["\uD83D\uDE45\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f645-1f3fc-200d-2640-fe0f",34,40,["\uD83D\uDE45\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f645-1f3fd-200d-2640-fe0f",34,41,["\uD83D\uDE45\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f645-1f3fe-200d-2640-fe0f",34,42,["\uD83D\uDE45\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f645-1f3ff-200d-2640-fe0f",34,43,["\uD83D\uDE45\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f645-200d-2642-fe0f":{"1f3fb":["1f645-1f3fb-200d-2642-fe0f",34,45,["\uD83D\uDE45\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f645-1f3fc-200d-2642-fe0f",34,46,["\uD83D\uDE45\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f645-1f3fd-200d-2642-fe0f",34,47,["\uD83D\uDE45\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f645-1f3fe-200d-2642-fe0f",34,48,["\uD83D\uDE45\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f645-1f3ff-200d-2642-fe0f",34,49,["\uD83D\uDE45\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f645":{"1f3fb":["1f645-1f3fb",34,51,["\uD83D\uDE45\uD83C\uDFFB"],"1.0"],"1f3fc":["1f645-1f3fc",34,52,["\uD83D\uDE45\uD83C\uDFFC"],"1.0"],"1f3fd":["1f645-1f3fd",34,53,["\uD83D\uDE45\uD83C\uDFFD"],"1.0"],"1f3fe":["1f645-1f3fe",34,54,["\uD83D\uDE45\uD83C\uDFFE"],"1.0"],"1f3ff":["1f645-1f3ff",34,55,["\uD83D\uDE45\uD83C\uDFFF"],"1.0"]},
    "1f646-200d-2640-fe0f":{"1f3fb":["1f646-1f3fb-200d-2640-fe0f",34,57,["\uD83D\uDE46\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f646-1f3fc-200d-2640-fe0f",34,58,["\uD83D\uDE46\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f646-1f3fd-200d-2640-fe0f",34,59,["\uD83D\uDE46\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f646-1f3fe-200d-2640-fe0f",34,60,["\uD83D\uDE46\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f646-1f3ff-200d-2640-fe0f",34,61,["\uD83D\uDE46\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f646-200d-2642-fe0f":{"1f3fb":["1f646-1f3fb-200d-2642-fe0f",35,0,["\uD83D\uDE46\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f646-1f3fc-200d-2642-fe0f",35,1,["\uD83D\uDE46\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f646-1f3fd-200d-2642-fe0f",35,2,["\uD83D\uDE46\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f646-1f3fe-200d-2642-fe0f",35,3,["\uD83D\uDE46\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f646-1f3ff-200d-2642-fe0f",35,4,["\uD83D\uDE46\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f646":{"1f3fb":["1f646-1f3fb",35,6,["\uD83D\uDE46\uD83C\uDFFB"],"1.0"],"1f3fc":["1f646-1f3fc",35,7,["\uD83D\uDE46\uD83C\uDFFC"],"1.0"],"1f3fd":["1f646-1f3fd",35,8,["\uD83D\uDE46\uD83C\uDFFD"],"1.0"],"1f3fe":["1f646-1f3fe",35,9,["\uD83D\uDE46\uD83C\uDFFE"],"1.0"],"1f3ff":["1f646-1f3ff",35,10,["\uD83D\uDE46\uD83C\uDFFF"],"1.0"]},
    "1f647-200d-2640-fe0f":{"1f3fb":["1f647-1f3fb-200d-2640-fe0f",35,12,["\uD83D\uDE47\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f647-1f3fc-200d-2640-fe0f",35,13,["\uD83D\uDE47\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f647-1f3fd-200d-2640-fe0f",35,14,["\uD83D\uDE47\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f647-1f3fe-200d-2640-fe0f",35,15,["\uD83D\uDE47\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f647-1f3ff-200d-2640-fe0f",35,16,["\uD83D\uDE47\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f647-200d-2642-fe0f":{"1f3fb":["1f647-1f3fb-200d-2642-fe0f",35,18,["\uD83D\uDE47\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f647-1f3fc-200d-2642-fe0f",35,19,["\uD83D\uDE47\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f647-1f3fd-200d-2642-fe0f",35,20,["\uD83D\uDE47\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f647-1f3fe-200d-2642-fe0f",35,21,["\uD83D\uDE47\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f647-1f3ff-200d-2642-fe0f",35,22,["\uD83D\uDE47\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f647":{"1f3fb":["1f647-1f3fb",35,24,["\uD83D\uDE47\uD83C\uDFFB"],"1.0"],"1f3fc":["1f647-1f3fc",35,25,["\uD83D\uDE47\uD83C\uDFFC"],"1.0"],"1f3fd":["1f647-1f3fd",35,26,["\uD83D\uDE47\uD83C\uDFFD"],"1.0"],"1f3fe":["1f647-1f3fe",35,27,["\uD83D\uDE47\uD83C\uDFFE"],"1.0"],"1f3ff":["1f647-1f3ff",35,28,["\uD83D\uDE47\uD83C\uDFFF"],"1.0"]},
    "1f64b-200d-2640-fe0f":{"1f3fb":["1f64b-1f3fb-200d-2640-fe0f",35,33,["\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f64b-1f3fc-200d-2640-fe0f",35,34,["\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f64b-1f3fd-200d-2640-fe0f",35,35,["\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f64b-1f3fe-200d-2640-fe0f",35,36,["\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f64b-1f3ff-200d-2640-fe0f",35,37,["\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f64b-200d-2642-fe0f":{"1f3fb":["1f64b-1f3fb-200d-2642-fe0f",35,39,["\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f64b-1f3fc-200d-2642-fe0f",35,40,["\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f64b-1f3fd-200d-2642-fe0f",35,41,["\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f64b-1f3fe-200d-2642-fe0f",35,42,["\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f64b-1f3ff-200d-2642-fe0f",35,43,["\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f64b":{"1f3fb":["1f64b-1f3fb",35,45,["\uD83D\uDE4B\uD83C\uDFFB"],"1.0"],"1f3fc":["1f64b-1f3fc",35,46,["\uD83D\uDE4B\uD83C\uDFFC"],"1.0"],"1f3fd":["1f64b-1f3fd",35,47,["\uD83D\uDE4B\uD83C\uDFFD"],"1.0"],"1f3fe":["1f64b-1f3fe",35,48,["\uD83D\uDE4B\uD83C\uDFFE"],"1.0"],"1f3ff":["1f64b-1f3ff",35,49,["\uD83D\uDE4B\uD83C\uDFFF"],"1.0"]},
    "1f64c":{"1f3fb":["1f64c-1f3fb",35,51,["\uD83D\uDE4C\uD83C\uDFFB"],"1.0"],"1f3fc":["1f64c-1f3fc",35,52,["\uD83D\uDE4C\uD83C\uDFFC"],"1.0"],"1f3fd":["1f64c-1f3fd",35,53,["\uD83D\uDE4C\uD83C\uDFFD"],"1.0"],"1f3fe":["1f64c-1f3fe",35,54,["\uD83D\uDE4C\uD83C\uDFFE"],"1.0"],"1f3ff":["1f64c-1f3ff",35,55,["\uD83D\uDE4C\uD83C\uDFFF"],"1.0"]},
    "1f64d-200d-2640-fe0f":{"1f3fb":["1f64d-1f3fb-200d-2640-fe0f",35,57,["\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f64d-1f3fc-200d-2640-fe0f",35,58,["\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f64d-1f3fd-200d-2640-fe0f",35,59,["\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f64d-1f3fe-200d-2640-fe0f",35,60,["\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f64d-1f3ff-200d-2640-fe0f",35,61,["\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f64d-200d-2642-fe0f":{"1f3fb":["1f64d-1f3fb-200d-2642-fe0f",36,0,["\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f64d-1f3fc-200d-2642-fe0f",36,1,["\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f64d-1f3fd-200d-2642-fe0f",36,2,["\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f64d-1f3fe-200d-2642-fe0f",36,3,["\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f64d-1f3ff-200d-2642-fe0f",36,4,["\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f64d":{"1f3fb":["1f64d-1f3fb",36,6,["\uD83D\uDE4D\uD83C\uDFFB"],"1.0"],"1f3fc":["1f64d-1f3fc",36,7,["\uD83D\uDE4D\uD83C\uDFFC"],"1.0"],"1f3fd":["1f64d-1f3fd",36,8,["\uD83D\uDE4D\uD83C\uDFFD"],"1.0"],"1f3fe":["1f64d-1f3fe",36,9,["\uD83D\uDE4D\uD83C\uDFFE"],"1.0"],"1f3ff":["1f64d-1f3ff",36,10,["\uD83D\uDE4D\uD83C\uDFFF"],"1.0"]},
    "1f64e-200d-2640-fe0f":{"1f3fb":["1f64e-1f3fb-200d-2640-fe0f",36,12,["\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f64e-1f3fc-200d-2640-fe0f",36,13,["\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f64e-1f3fd-200d-2640-fe0f",36,14,["\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f64e-1f3fe-200d-2640-fe0f",36,15,["\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f64e-1f3ff-200d-2640-fe0f",36,16,["\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f64e-200d-2642-fe0f":{"1f3fb":["1f64e-1f3fb-200d-2642-fe0f",36,18,["\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f64e-1f3fc-200d-2642-fe0f",36,19,["\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f64e-1f3fd-200d-2642-fe0f",36,20,["\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f64e-1f3fe-200d-2642-fe0f",36,21,["\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f64e-1f3ff-200d-2642-fe0f",36,22,["\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f64e":{"1f3fb":["1f64e-1f3fb",36,24,["\uD83D\uDE4E\uD83C\uDFFB"],"1.0"],"1f3fc":["1f64e-1f3fc",36,25,["\uD83D\uDE4E\uD83C\uDFFC"],"1.0"],"1f3fd":["1f64e-1f3fd",36,26,["\uD83D\uDE4E\uD83C\uDFFD"],"1.0"],"1f3fe":["1f64e-1f3fe",36,27,["\uD83D\uDE4E\uD83C\uDFFE"],"1.0"],"1f3ff":["1f64e-1f3ff",36,28,["\uD83D\uDE4E\uD83C\uDFFF"],"1.0"]},
    "1f64f":{"1f3fb":["1f64f-1f3fb",36,30,["\uD83D\uDE4F\uD83C\uDFFB"],"1.0"],"1f3fc":["1f64f-1f3fc",36,31,["\uD83D\uDE4F\uD83C\uDFFC"],"1.0"],"1f3fd":["1f64f-1f3fd",36,32,["\uD83D\uDE4F\uD83C\uDFFD"],"1.0"],"1f3fe":["1f64f-1f3fe",36,33,["\uD83D\uDE4F\uD83C\uDFFE"],"1.0"],"1f3ff":["1f64f-1f3ff",36,34,["\uD83D\uDE4F\uD83C\uDFFF"],"1.0"]},
    "1f6a3-200d-2640-fe0f":{"1f3fb":["1f6a3-1f3fb-200d-2640-fe0f",37,8,["\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f6a3-1f3fc-200d-2640-fe0f",37,9,["\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f6a3-1f3fd-200d-2640-fe0f",37,10,["\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f6a3-1f3fe-200d-2640-fe0f",37,11,["\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f6a3-1f3ff-200d-2640-fe0f",37,12,["\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f6a3-200d-2642-fe0f":{"1f3fb":["1f6a3-1f3fb-200d-2642-fe0f",37,14,["\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f6a3-1f3fc-200d-2642-fe0f",37,15,["\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f6a3-1f3fd-200d-2642-fe0f",37,16,["\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f6a3-1f3fe-200d-2642-fe0f",37,17,["\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f6a3-1f3ff-200d-2642-fe0f",37,18,["\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f6a3":{"1f3fb":["1f6a3-1f3fb",37,20,["\uD83D\uDEA3\uD83C\uDFFB"],"1.0"],"1f3fc":["1f6a3-1f3fc",37,21,["\uD83D\uDEA3\uD83C\uDFFC"],"1.0"],"1f3fd":["1f6a3-1f3fd",37,22,["\uD83D\uDEA3\uD83C\uDFFD"],"1.0"],"1f3fe":["1f6a3-1f3fe",37,23,["\uD83D\uDEA3\uD83C\uDFFE"],"1.0"],"1f3ff":["1f6a3-1f3ff",37,24,["\uD83D\uDEA3\uD83C\uDFFF"],"1.0"]},
    "1f6b4-200d-2640-fe0f":{"1f3fb":["1f6b4-1f3fb-200d-2640-fe0f",37,42,["\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f6b4-1f3fc-200d-2640-fe0f",37,43,["\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f6b4-1f3fd-200d-2640-fe0f",37,44,["\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f6b4-1f3fe-200d-2640-fe0f",37,45,["\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f6b4-1f3ff-200d-2640-fe0f",37,46,["\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f6b4-200d-2642-fe0f":{"1f3fb":["1f6b4-1f3fb-200d-2642-fe0f",37,48,["\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f6b4-1f3fc-200d-2642-fe0f",37,49,["\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f6b4-1f3fd-200d-2642-fe0f",37,50,["\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f6b4-1f3fe-200d-2642-fe0f",37,51,["\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f6b4-1f3ff-200d-2642-fe0f",37,52,["\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f6b4":{"1f3fb":["1f6b4-1f3fb",37,54,["\uD83D\uDEB4\uD83C\uDFFB"],"1.0"],"1f3fc":["1f6b4-1f3fc",37,55,["\uD83D\uDEB4\uD83C\uDFFC"],"1.0"],"1f3fd":["1f6b4-1f3fd",37,56,["\uD83D\uDEB4\uD83C\uDFFD"],"1.0"],"1f3fe":["1f6b4-1f3fe",37,57,["\uD83D\uDEB4\uD83C\uDFFE"],"1.0"],"1f3ff":["1f6b4-1f3ff",37,58,["\uD83D\uDEB4\uD83C\uDFFF"],"1.0"]},
    "1f6b5-200d-2640-fe0f":{"1f3fb":["1f6b5-1f3fb-200d-2640-fe0f",37,60,["\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f6b5-1f3fc-200d-2640-fe0f",37,61,["\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f6b5-1f3fd-200d-2640-fe0f",37,62,["\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f6b5-1f3fe-200d-2640-fe0f",38,0,["\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f6b5-1f3ff-200d-2640-fe0f",38,1,["\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f6b5-200d-2642-fe0f":{"1f3fb":["1f6b5-1f3fb-200d-2642-fe0f",38,3,["\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f6b5-1f3fc-200d-2642-fe0f",38,4,["\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f6b5-1f3fd-200d-2642-fe0f",38,5,["\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f6b5-1f3fe-200d-2642-fe0f",38,6,["\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f6b5-1f3ff-200d-2642-fe0f",38,7,["\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f6b5":{"1f3fb":["1f6b5-1f3fb",38,9,["\uD83D\uDEB5\uD83C\uDFFB"],"1.0"],"1f3fc":["1f6b5-1f3fc",38,10,["\uD83D\uDEB5\uD83C\uDFFC"],"1.0"],"1f3fd":["1f6b5-1f3fd",38,11,["\uD83D\uDEB5\uD83C\uDFFD"],"1.0"],"1f3fe":["1f6b5-1f3fe",38,12,["\uD83D\uDEB5\uD83C\uDFFE"],"1.0"],"1f3ff":["1f6b5-1f3ff",38,13,["\uD83D\uDEB5\uD83C\uDFFF"],"1.0"]},
    "1f6b6-200d-2640-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-2640-fe0f",38,15,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f6b6-1f3fc-200d-2640-fe0f",38,16,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f6b6-1f3fd-200d-2640-fe0f",38,17,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f6b6-1f3fe-200d-2640-fe0f",38,18,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f6b6-1f3ff-200d-2640-fe0f",38,19,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f6b6-200d-2640-fe0f-200d-27a1-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",38,21,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f6b6-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",38,22,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f6b6-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",38,23,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f6b6-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",38,24,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f6b6-1f3ff-200d-2640-fe0f-200d-27a1-fe0f",38,25,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f6b6-200d-2642-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-2642-fe0f",38,27,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f6b6-1f3fc-200d-2642-fe0f",38,28,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f6b6-1f3fd-200d-2642-fe0f",38,29,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f6b6-1f3fe-200d-2642-fe0f",38,30,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f6b6-1f3ff-200d-2642-fe0f",38,31,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f6b6-200d-2642-fe0f-200d-27a1-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",38,33,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f6b6-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",38,34,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f6b6-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",38,35,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f6b6-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",38,36,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f6b6-1f3ff-200d-2642-fe0f-200d-27a1-fe0f",38,37,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f6b6-200d-27a1-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-27a1-fe0f",38,39,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f6b6-1f3fc-200d-27a1-fe0f",38,40,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f6b6-1f3fd-200d-27a1-fe0f",38,41,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f6b6-1f3fe-200d-27a1-fe0f",38,42,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f6b6-1f3ff-200d-27a1-fe0f",38,43,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f6b6":{"1f3fb":["1f6b6-1f3fb",38,45,["\uD83D\uDEB6\uD83C\uDFFB"],"1.0"],"1f3fc":["1f6b6-1f3fc",38,46,["\uD83D\uDEB6\uD83C\uDFFC"],"1.0"],"1f3fd":["1f6b6-1f3fd",38,47,["\uD83D\uDEB6\uD83C\uDFFD"],"1.0"],"1f3fe":["1f6b6-1f3fe",38,48,["\uD83D\uDEB6\uD83C\uDFFE"],"1.0"],"1f3ff":["1f6b6-1f3ff",38,49,["\uD83D\uDEB6\uD83C\uDFFF"],"1.0"]},
    "1f6c0":{"1f3fb":["1f6c0-1f3fb",38,60,["\uD83D\uDEC0\uD83C\uDFFB"],"1.0"],"1f3fc":["1f6c0-1f3fc",38,61,["\uD83D\uDEC0\uD83C\uDFFC"],"1.0"],"1f3fd":["1f6c0-1f3fd",38,62,["\uD83D\uDEC0\uD83C\uDFFD"],"1.0"],"1f3fe":["1f6c0-1f3fe",39,0,["\uD83D\uDEC0\uD83C\uDFFE"],"1.0"],"1f3ff":["1f6c0-1f3ff",39,1,["\uD83D\uDEC0\uD83C\uDFFF"],"1.0"]},
    "1f6cc":{"1f3fb":["1f6cc-1f3fb",39,9,["\uD83D\uDECC\uD83C\uDFFB"],"4.0"],"1f3fc":["1f6cc-1f3fc",39,10,["\uD83D\uDECC\uD83C\uDFFC"],"4.0"],"1f3fd":["1f6cc-1f3fd",39,11,["\uD83D\uDECC\uD83C\uDFFD"],"4.0"],"1f3fe":["1f6cc-1f3fe",39,12,["\uD83D\uDECC\uD83C\uDFFE"],"4.0"],"1f3ff":["1f6cc-1f3ff",39,13,["\uD83D\uDECC\uD83C\uDFFF"],"4.0"]},
    "1f90c":{"1f3fb":["1f90c-1f3fb",39,62,["\uD83E\uDD0C\uD83C\uDFFB"],"13.0"],"1f3fc":["1f90c-1f3fc",40,0,["\uD83E\uDD0C\uD83C\uDFFC"],"13.0"],"1f3fd":["1f90c-1f3fd",40,1,["\uD83E\uDD0C\uD83C\uDFFD"],"13.0"],"1f3fe":["1f90c-1f3fe",40,2,["\uD83E\uDD0C\uD83C\uDFFE"],"13.0"],"1f3ff":["1f90c-1f3ff",40,3,["\uD83E\uDD0C\uD83C\uDFFF"],"13.0"]},
    "1f90f":{"1f3fb":["1f90f-1f3fb",40,7,["\uD83E\uDD0F\uD83C\uDFFB"],"12.0"],"1f3fc":["1f90f-1f3fc",40,8,["\uD83E\uDD0F\uD83C\uDFFC"],"12.0"],"1f3fd":["1f90f-1f3fd",40,9,["\uD83E\uDD0F\uD83C\uDFFD"],"12.0"],"1f3fe":["1f90f-1f3fe",40,10,["\uD83E\uDD0F\uD83C\uDFFE"],"12.0"],"1f3ff":["1f90f-1f3ff",40,11,["\uD83E\uDD0F\uD83C\uDFFF"],"12.0"]},
    "1f918":{"1f3fb":["1f918-1f3fb",40,21,["\uD83E\uDD18\uD83C\uDFFB"],"1.0"],"1f3fc":["1f918-1f3fc",40,22,["\uD83E\uDD18\uD83C\uDFFC"],"1.0"],"1f3fd":["1f918-1f3fd",40,23,["\uD83E\uDD18\uD83C\uDFFD"],"1.0"],"1f3fe":["1f918-1f3fe",40,24,["\uD83E\uDD18\uD83C\uDFFE"],"1.0"],"1f3ff":["1f918-1f3ff",40,25,["\uD83E\uDD18\uD83C\uDFFF"],"1.0"]},
    "1f919":{"1f3fb":["1f919-1f3fb",40,27,["\uD83E\uDD19\uD83C\uDFFB"],"3.0"],"1f3fc":["1f919-1f3fc",40,28,["\uD83E\uDD19\uD83C\uDFFC"],"3.0"],"1f3fd":["1f919-1f3fd",40,29,["\uD83E\uDD19\uD83C\uDFFD"],"3.0"],"1f3fe":["1f919-1f3fe",40,30,["\uD83E\uDD19\uD83C\uDFFE"],"3.0"],"1f3ff":["1f919-1f3ff",40,31,["\uD83E\uDD19\uD83C\uDFFF"],"3.0"]},
    "1f91a":{"1f3fb":["1f91a-1f3fb",40,33,["\uD83E\uDD1A\uD83C\uDFFB"],"3.0"],"1f3fc":["1f91a-1f3fc",40,34,["\uD83E\uDD1A\uD83C\uDFFC"],"3.0"],"1f3fd":["1f91a-1f3fd",40,35,["\uD83E\uDD1A\uD83C\uDFFD"],"3.0"],"1f3fe":["1f91a-1f3fe",40,36,["\uD83E\uDD1A\uD83C\uDFFE"],"3.0"],"1f3ff":["1f91a-1f3ff",40,37,["\uD83E\uDD1A\uD83C\uDFFF"],"3.0"]},
    "1f91b":{"1f3fb":["1f91b-1f3fb",40,39,["\uD83E\uDD1B\uD83C\uDFFB"],"3.0"],"1f3fc":["1f91b-1f3fc",40,40,["\uD83E\uDD1B\uD83C\uDFFC"],"3.0"],"1f3fd":["1f91b-1f3fd",40,41,["\uD83E\uDD1B\uD83C\uDFFD"],"3.0"],"1f3fe":["1f91b-1f3fe",40,42,["\uD83E\uDD1B\uD83C\uDFFE"],"3.0"],"1f3ff":["1f91b-1f3ff",40,43,["\uD83E\uDD1B\uD83C\uDFFF"],"3.0"]},
    "1f91c":{"1f3fb":["1f91c-1f3fb",40,45,["\uD83E\uDD1C\uD83C\uDFFB"],"3.0"],"1f3fc":["1f91c-1f3fc",40,46,["\uD83E\uDD1C\uD83C\uDFFC"],"3.0"],"1f3fd":["1f91c-1f3fd",40,47,["\uD83E\uDD1C\uD83C\uDFFD"],"3.0"],"1f3fe":["1f91c-1f3fe",40,48,["\uD83E\uDD1C\uD83C\uDFFE"],"3.0"],"1f3ff":["1f91c-1f3ff",40,49,["\uD83E\uDD1C\uD83C\uDFFF"],"3.0"]},
    "1f91d":{"1f3fb":["1f91d-1f3fb",40,51,["\uD83E\uDD1D\uD83C\uDFFB"],"14.0"],"1f3fc":["1f91d-1f3fc",40,52,["\uD83E\uDD1D\uD83C\uDFFC"],"14.0"],"1f3fd":["1f91d-1f3fd",40,53,["\uD83E\uDD1D\uD83C\uDFFD"],"14.0"],"1f3fe":["1f91d-1f3fe",40,54,["\uD83E\uDD1D\uD83C\uDFFE"],"14.0"],"1f3ff":["1f91d-1f3ff",40,55,["\uD83E\uDD1D\uD83C\uDFFF"],"14.0"],"1f3fb-1f3fc":["1faf1-1f3fb-200d-1faf2-1f3fc",40,56,["\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3fb-1f3fd":["1faf1-1f3fb-200d-1faf2-1f3fd",40,57,["\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3fb-1f3fe":["1faf1-1f3fb-200d-1faf2-1f3fe",40,58,["\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFE"],"14.0"],"1f3fb-1f3ff":["1faf1-1f3fb-200d-1faf2-1f3ff",40,59,["\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFF"],"14.0"],"1f3fc-1f3fb":["1faf1-1f3fc-200d-1faf2-1f3fb",40,60,["\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3fc-1f3fd":["1faf1-1f3fc-200d-1faf2-1f3fd",40,61,["\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3fc-1f3fe":["1faf1-1f3fc-200d-1faf2-1f3fe",40,62,["\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFE"],"14.0"],"1f3fc-1f3ff":["1faf1-1f3fc-200d-1faf2-1f3ff",41,0,["\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFF"],"14.0"],"1f3fd-1f3fb":["1faf1-1f3fd-200d-1faf2-1f3fb",41,1,["\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3fd-1f3fc":["1faf1-1f3fd-200d-1faf2-1f3fc",41,2,["\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3fd-1f3fe":["1faf1-1f3fd-200d-1faf2-1f3fe",41,3,["\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFE"],"14.0"],"1f3fd-1f3ff":["1faf1-1f3fd-200d-1faf2-1f3ff",41,4,["\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFF"],"14.0"],"1f3fe-1f3fb":["1faf1-1f3fe-200d-1faf2-1f3fb",41,5,["\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3fe-1f3fc":["1faf1-1f3fe-200d-1faf2-1f3fc",41,6,["\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3fe-1f3fd":["1faf1-1f3fe-200d-1faf2-1f3fd",41,7,["\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3fe-1f3ff":["1faf1-1f3fe-200d-1faf2-1f3ff",41,8,["\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFF"],"14.0"],"1f3ff-1f3fb":["1faf1-1f3ff-200d-1faf2-1f3fb",41,9,["\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3ff-1f3fc":["1faf1-1f3ff-200d-1faf2-1f3fc",41,10,["\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3ff-1f3fd":["1faf1-1f3ff-200d-1faf2-1f3fd",41,11,["\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3ff-1f3fe":["1faf1-1f3ff-200d-1faf2-1f3fe",41,12,["\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFE"],"14.0"]},
    "1f91e":{"1f3fb":["1f91e-1f3fb",41,14,["\uD83E\uDD1E\uD83C\uDFFB"],"3.0"],"1f3fc":["1f91e-1f3fc",41,15,["\uD83E\uDD1E\uD83C\uDFFC"],"3.0"],"1f3fd":["1f91e-1f3fd",41,16,["\uD83E\uDD1E\uD83C\uDFFD"],"3.0"],"1f3fe":["1f91e-1f3fe",41,17,["\uD83E\uDD1E\uD83C\uDFFE"],"3.0"],"1f3ff":["1f91e-1f3ff",41,18,["\uD83E\uDD1E\uD83C\uDFFF"],"3.0"]},
    "1f91f":{"1f3fb":["1f91f-1f3fb",41,20,["\uD83E\uDD1F\uD83C\uDFFB"],"5.0"],"1f3fc":["1f91f-1f3fc",41,21,["\uD83E\uDD1F\uD83C\uDFFC"],"5.0"],"1f3fd":["1f91f-1f3fd",41,22,["\uD83E\uDD1F\uD83C\uDFFD"],"5.0"],"1f3fe":["1f91f-1f3fe",41,23,["\uD83E\uDD1F\uD83C\uDFFE"],"5.0"],"1f3ff":["1f91f-1f3ff",41,24,["\uD83E\uDD1F\uD83C\uDFFF"],"5.0"]},
    "1f926-200d-2640-fe0f":{"1f3fb":["1f926-1f3fb-200d-2640-fe0f",41,32,["\uD83E\uDD26\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f926-1f3fc-200d-2640-fe0f",41,33,["\uD83E\uDD26\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f926-1f3fd-200d-2640-fe0f",41,34,["\uD83E\uDD26\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f926-1f3fe-200d-2640-fe0f",41,35,["\uD83E\uDD26\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f926-1f3ff-200d-2640-fe0f",41,36,["\uD83E\uDD26\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f926-200d-2642-fe0f":{"1f3fb":["1f926-1f3fb-200d-2642-fe0f",41,38,["\uD83E\uDD26\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f926-1f3fc-200d-2642-fe0f",41,39,["\uD83E\uDD26\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f926-1f3fd-200d-2642-fe0f",41,40,["\uD83E\uDD26\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f926-1f3fe-200d-2642-fe0f",41,41,["\uD83E\uDD26\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f926-1f3ff-200d-2642-fe0f",41,42,["\uD83E\uDD26\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f926":{"1f3fb":["1f926-1f3fb",41,44,["\uD83E\uDD26\uD83C\uDFFB"],"3.0"],"1f3fc":["1f926-1f3fc",41,45,["\uD83E\uDD26\uD83C\uDFFC"],"3.0"],"1f3fd":["1f926-1f3fd",41,46,["\uD83E\uDD26\uD83C\uDFFD"],"3.0"],"1f3fe":["1f926-1f3fe",41,47,["\uD83E\uDD26\uD83C\uDFFE"],"3.0"],"1f3ff":["1f926-1f3ff",41,48,["\uD83E\uDD26\uD83C\uDFFF"],"3.0"]},
    "1f930":{"1f3fb":["1f930-1f3fb",41,59,["\uD83E\uDD30\uD83C\uDFFB"],"3.0"],"1f3fc":["1f930-1f3fc",41,60,["\uD83E\uDD30\uD83C\uDFFC"],"3.0"],"1f3fd":["1f930-1f3fd",41,61,["\uD83E\uDD30\uD83C\uDFFD"],"3.0"],"1f3fe":["1f930-1f3fe",41,62,["\uD83E\uDD30\uD83C\uDFFE"],"3.0"],"1f3ff":["1f930-1f3ff",42,0,["\uD83E\uDD30\uD83C\uDFFF"],"3.0"]},
    "1f931":{"1f3fb":["1f931-1f3fb",42,2,["\uD83E\uDD31\uD83C\uDFFB"],"5.0"],"1f3fc":["1f931-1f3fc",42,3,["\uD83E\uDD31\uD83C\uDFFC"],"5.0"],"1f3fd":["1f931-1f3fd",42,4,["\uD83E\uDD31\uD83C\uDFFD"],"5.0"],"1f3fe":["1f931-1f3fe",42,5,["\uD83E\uDD31\uD83C\uDFFE"],"5.0"],"1f3ff":["1f931-1f3ff",42,6,["\uD83E\uDD31\uD83C\uDFFF"],"5.0"]},
    "1f932":{"1f3fb":["1f932-1f3fb",42,8,["\uD83E\uDD32\uD83C\uDFFB"],"5.0"],"1f3fc":["1f932-1f3fc",42,9,["\uD83E\uDD32\uD83C\uDFFC"],"5.0"],"1f3fd":["1f932-1f3fd",42,10,["\uD83E\uDD32\uD83C\uDFFD"],"5.0"],"1f3fe":["1f932-1f3fe",42,11,["\uD83E\uDD32\uD83C\uDFFE"],"5.0"],"1f3ff":["1f932-1f3ff",42,12,["\uD83E\uDD32\uD83C\uDFFF"],"5.0"]},
    "1f933":{"1f3fb":["1f933-1f3fb",42,14,["\uD83E\uDD33\uD83C\uDFFB"],"3.0"],"1f3fc":["1f933-1f3fc",42,15,["\uD83E\uDD33\uD83C\uDFFC"],"3.0"],"1f3fd":["1f933-1f3fd",42,16,["\uD83E\uDD33\uD83C\uDFFD"],"3.0"],"1f3fe":["1f933-1f3fe",42,17,["\uD83E\uDD33\uD83C\uDFFE"],"3.0"],"1f3ff":["1f933-1f3ff",42,18,["\uD83E\uDD33\uD83C\uDFFF"],"3.0"]},
    "1f934":{"1f3fb":["1f934-1f3fb",42,20,["\uD83E\uDD34\uD83C\uDFFB"],"3.0"],"1f3fc":["1f934-1f3fc",42,21,["\uD83E\uDD34\uD83C\uDFFC"],"3.0"],"1f3fd":["1f934-1f3fd",42,22,["\uD83E\uDD34\uD83C\uDFFD"],"3.0"],"1f3fe":["1f934-1f3fe",42,23,["\uD83E\uDD34\uD83C\uDFFE"],"3.0"],"1f3ff":["1f934-1f3ff",42,24,["\uD83E\uDD34\uD83C\uDFFF"],"3.0"]},
    "1f935-200d-2640-fe0f":{"1f3fb":["1f935-1f3fb-200d-2640-fe0f",42,26,["\uD83E\uDD35\uD83C\uDFFB\u200D\u2640\uFE0F"],"13.0"],"1f3fc":["1f935-1f3fc-200d-2640-fe0f",42,27,["\uD83E\uDD35\uD83C\uDFFC\u200D\u2640\uFE0F"],"13.0"],"1f3fd":["1f935-1f3fd-200d-2640-fe0f",42,28,["\uD83E\uDD35\uD83C\uDFFD\u200D\u2640\uFE0F"],"13.0"],"1f3fe":["1f935-1f3fe-200d-2640-fe0f",42,29,["\uD83E\uDD35\uD83C\uDFFE\u200D\u2640\uFE0F"],"13.0"],"1f3ff":["1f935-1f3ff-200d-2640-fe0f",42,30,["\uD83E\uDD35\uD83C\uDFFF\u200D\u2640\uFE0F"],"13.0"]},
    "1f935-200d-2642-fe0f":{"1f3fb":["1f935-1f3fb-200d-2642-fe0f",42,32,["\uD83E\uDD35\uD83C\uDFFB\u200D\u2642\uFE0F"],"13.0"],"1f3fc":["1f935-1f3fc-200d-2642-fe0f",42,33,["\uD83E\uDD35\uD83C\uDFFC\u200D\u2642\uFE0F"],"13.0"],"1f3fd":["1f935-1f3fd-200d-2642-fe0f",42,34,["\uD83E\uDD35\uD83C\uDFFD\u200D\u2642\uFE0F"],"13.0"],"1f3fe":["1f935-1f3fe-200d-2642-fe0f",42,35,["\uD83E\uDD35\uD83C\uDFFE\u200D\u2642\uFE0F"],"13.0"],"1f3ff":["1f935-1f3ff-200d-2642-fe0f",42,36,["\uD83E\uDD35\uD83C\uDFFF\u200D\u2642\uFE0F"],"13.0"]},
    "1f935":{"1f3fb":["1f935-1f3fb",42,38,["\uD83E\uDD35\uD83C\uDFFB"],"3.0"],"1f3fc":["1f935-1f3fc",42,39,["\uD83E\uDD35\uD83C\uDFFC"],"3.0"],"1f3fd":["1f935-1f3fd",42,40,["\uD83E\uDD35\uD83C\uDFFD"],"3.0"],"1f3fe":["1f935-1f3fe",42,41,["\uD83E\uDD35\uD83C\uDFFE"],"3.0"],"1f3ff":["1f935-1f3ff",42,42,["\uD83E\uDD35\uD83C\uDFFF"],"3.0"]},
    "1f936":{"1f3fb":["1f936-1f3fb",42,44,["\uD83E\uDD36\uD83C\uDFFB"],"3.0"],"1f3fc":["1f936-1f3fc",42,45,["\uD83E\uDD36\uD83C\uDFFC"],"3.0"],"1f3fd":["1f936-1f3fd",42,46,["\uD83E\uDD36\uD83C\uDFFD"],"3.0"],"1f3fe":["1f936-1f3fe",42,47,["\uD83E\uDD36\uD83C\uDFFE"],"3.0"],"1f3ff":["1f936-1f3ff",42,48,["\uD83E\uDD36\uD83C\uDFFF"],"3.0"]},
    "1f937-200d-2640-fe0f":{"1f3fb":["1f937-1f3fb-200d-2640-fe0f",42,50,["\uD83E\uDD37\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f937-1f3fc-200d-2640-fe0f",42,51,["\uD83E\uDD37\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f937-1f3fd-200d-2640-fe0f",42,52,["\uD83E\uDD37\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f937-1f3fe-200d-2640-fe0f",42,53,["\uD83E\uDD37\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f937-1f3ff-200d-2640-fe0f",42,54,["\uD83E\uDD37\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f937-200d-2642-fe0f":{"1f3fb":["1f937-1f3fb-200d-2642-fe0f",42,56,["\uD83E\uDD37\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f937-1f3fc-200d-2642-fe0f",42,57,["\uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f937-1f3fd-200d-2642-fe0f",42,58,["\uD83E\uDD37\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f937-1f3fe-200d-2642-fe0f",42,59,["\uD83E\uDD37\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f937-1f3ff-200d-2642-fe0f",42,60,["\uD83E\uDD37\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f937":{"1f3fb":["1f937-1f3fb",42,62,["\uD83E\uDD37\uD83C\uDFFB"],"3.0"],"1f3fc":["1f937-1f3fc",43,0,["\uD83E\uDD37\uD83C\uDFFC"],"3.0"],"1f3fd":["1f937-1f3fd",43,1,["\uD83E\uDD37\uD83C\uDFFD"],"3.0"],"1f3fe":["1f937-1f3fe",43,2,["\uD83E\uDD37\uD83C\uDFFE"],"3.0"],"1f3ff":["1f937-1f3ff",43,3,["\uD83E\uDD37\uD83C\uDFFF"],"3.0"]},
    "1f938-200d-2640-fe0f":{"1f3fb":["1f938-1f3fb-200d-2640-fe0f",43,5,["\uD83E\uDD38\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f938-1f3fc-200d-2640-fe0f",43,6,["\uD83E\uDD38\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f938-1f3fd-200d-2640-fe0f",43,7,["\uD83E\uDD38\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f938-1f3fe-200d-2640-fe0f",43,8,["\uD83E\uDD38\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f938-1f3ff-200d-2640-fe0f",43,9,["\uD83E\uDD38\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f938-200d-2642-fe0f":{"1f3fb":["1f938-1f3fb-200d-2642-fe0f",43,11,["\uD83E\uDD38\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f938-1f3fc-200d-2642-fe0f",43,12,["\uD83E\uDD38\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f938-1f3fd-200d-2642-fe0f",43,13,["\uD83E\uDD38\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f938-1f3fe-200d-2642-fe0f",43,14,["\uD83E\uDD38\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f938-1f3ff-200d-2642-fe0f",43,15,["\uD83E\uDD38\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f938":{"1f3fb":["1f938-1f3fb",43,17,["\uD83E\uDD38\uD83C\uDFFB"],"3.0"],"1f3fc":["1f938-1f3fc",43,18,["\uD83E\uDD38\uD83C\uDFFC"],"3.0"],"1f3fd":["1f938-1f3fd",43,19,["\uD83E\uDD38\uD83C\uDFFD"],"3.0"],"1f3fe":["1f938-1f3fe",43,20,["\uD83E\uDD38\uD83C\uDFFE"],"3.0"],"1f3ff":["1f938-1f3ff",43,21,["\uD83E\uDD38\uD83C\uDFFF"],"3.0"]},
    "1f939-200d-2640-fe0f":{"1f3fb":["1f939-1f3fb-200d-2640-fe0f",43,23,["\uD83E\uDD39\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f939-1f3fc-200d-2640-fe0f",43,24,["\uD83E\uDD39\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f939-1f3fd-200d-2640-fe0f",43,25,["\uD83E\uDD39\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f939-1f3fe-200d-2640-fe0f",43,26,["\uD83E\uDD39\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f939-1f3ff-200d-2640-fe0f",43,27,["\uD83E\uDD39\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f939-200d-2642-fe0f":{"1f3fb":["1f939-1f3fb-200d-2642-fe0f",43,29,["\uD83E\uDD39\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f939-1f3fc-200d-2642-fe0f",43,30,["\uD83E\uDD39\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f939-1f3fd-200d-2642-fe0f",43,31,["\uD83E\uDD39\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f939-1f3fe-200d-2642-fe0f",43,32,["\uD83E\uDD39\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f939-1f3ff-200d-2642-fe0f",43,33,["\uD83E\uDD39\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f939":{"1f3fb":["1f939-1f3fb",43,35,["\uD83E\uDD39\uD83C\uDFFB"],"3.0"],"1f3fc":["1f939-1f3fc",43,36,["\uD83E\uDD39\uD83C\uDFFC"],"3.0"],"1f3fd":["1f939-1f3fd",43,37,["\uD83E\uDD39\uD83C\uDFFD"],"3.0"],"1f3fe":["1f939-1f3fe",43,38,["\uD83E\uDD39\uD83C\uDFFE"],"3.0"],"1f3ff":["1f939-1f3ff",43,39,["\uD83E\uDD39\uD83C\uDFFF"],"3.0"]},
    "1f93c-200d-2640-fe0f":{"1f3fb":["1f93c-1f3fb-200d-2640-fe0f",43,42,["\uD83E\uDD3C\uD83C\uDFFB\u200D\u2640\uFE0F"],"17.0"],"1f3fc":["1f93c-1f3fc-200d-2640-fe0f",43,43,["\uD83E\uDD3C\uD83C\uDFFC\u200D\u2640\uFE0F"],"17.0"],"1f3fd":["1f93c-1f3fd-200d-2640-fe0f",43,44,["\uD83E\uDD3C\uD83C\uDFFD\u200D\u2640\uFE0F"],"17.0"],"1f3fe":["1f93c-1f3fe-200d-2640-fe0f",43,45,["\uD83E\uDD3C\uD83C\uDFFE\u200D\u2640\uFE0F"],"17.0"],"1f3ff":["1f93c-1f3ff-200d-2640-fe0f",43,46,["\uD83E\uDD3C\uD83C\uDFFF\u200D\u2640\uFE0F"],"17.0"],"1f3fb-1f3fc":["1f469-1f3fb-200d-1faef-200d-1f469-1f3fc",43,47,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFC"],"17.0"],"1f3fb-1f3fd":["1f469-1f3fb-200d-1faef-200d-1f469-1f3fd",43,48,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFD"],"17.0"],"1f3fb-1f3fe":["1f469-1f3fb-200d-1faef-200d-1f469-1f3fe",43,49,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFE"],"17.0"],"1f3fb-1f3ff":["1f469-1f3fb-200d-1faef-200d-1f469-1f3ff",43,50,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFF"],"17.0"],"1f3fc-1f3fb":["1f469-1f3fc-200d-1faef-200d-1f469-1f3fb",43,51,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFB"],"17.0"],"1f3fc-1f3fd":["1f469-1f3fc-200d-1faef-200d-1f469-1f3fd",43,52,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFD"],"17.0"],"1f3fc-1f3fe":["1f469-1f3fc-200d-1faef-200d-1f469-1f3fe",43,53,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFE"],"17.0"],"1f3fc-1f3ff":["1f469-1f3fc-200d-1faef-200d-1f469-1f3ff",43,54,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFF"],"17.0"],"1f3fd-1f3fb":["1f469-1f3fd-200d-1faef-200d-1f469-1f3fb",43,55,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFB"],"17.0"],"1f3fd-1f3fc":["1f469-1f3fd-200d-1faef-200d-1f469-1f3fc",43,56,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFC"],"17.0"],"1f3fd-1f3fe":["1f469-1f3fd-200d-1faef-200d-1f469-1f3fe",43,57,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFE"],"17.0"],"1f3fd-1f3ff":["1f469-1f3fd-200d-1faef-200d-1f469-1f3ff",43,58,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFF"],"17.0"],"1f3fe-1f3fb":["1f469-1f3fe-200d-1faef-200d-1f469-1f3fb",43,59,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFB"],"17.0"],"1f3fe-1f3fc":["1f469-1f3fe-200d-1faef-200d-1f469-1f3fc",43,60,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFC"],"17.0"],"1f3fe-1f3fd":["1f469-1f3fe-200d-1faef-200d-1f469-1f3fd",43,61,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFD"],"17.0"],"1f3fe-1f3ff":["1f469-1f3fe-200d-1faef-200d-1f469-1f3ff",43,62,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFF"],"17.0"],"1f3ff-1f3fb":["1f469-1f3ff-200d-1faef-200d-1f469-1f3fb",44,0,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFB"],"17.0"],"1f3ff-1f3fc":["1f469-1f3ff-200d-1faef-200d-1f469-1f3fc",44,1,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFC"],"17.0"],"1f3ff-1f3fd":["1f469-1f3ff-200d-1faef-200d-1f469-1f3fd",44,2,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFD"],"17.0"],"1f3ff-1f3fe":["1f469-1f3ff-200d-1faef-200d-1f469-1f3fe",44,3,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFE"],"17.0"]},
    "1f93c-200d-2642-fe0f":{"1f3fb":["1f93c-1f3fb-200d-2642-fe0f",44,5,["\uD83E\uDD3C\uD83C\uDFFB\u200D\u2642\uFE0F"],"17.0"],"1f3fc":["1f93c-1f3fc-200d-2642-fe0f",44,6,["\uD83E\uDD3C\uD83C\uDFFC\u200D\u2642\uFE0F"],"17.0"],"1f3fd":["1f93c-1f3fd-200d-2642-fe0f",44,7,["\uD83E\uDD3C\uD83C\uDFFD\u200D\u2642\uFE0F"],"17.0"],"1f3fe":["1f93c-1f3fe-200d-2642-fe0f",44,8,["\uD83E\uDD3C\uD83C\uDFFE\u200D\u2642\uFE0F"],"17.0"],"1f3ff":["1f93c-1f3ff-200d-2642-fe0f",44,9,["\uD83E\uDD3C\uD83C\uDFFF\u200D\u2642\uFE0F"],"17.0"],"1f3fb-1f3fc":["1f468-1f3fb-200d-1faef-200d-1f468-1f3fc",44,10,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFC"],"17.0"],"1f3fb-1f3fd":["1f468-1f3fb-200d-1faef-200d-1f468-1f3fd",44,11,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFD"],"17.0"],"1f3fb-1f3fe":["1f468-1f3fb-200d-1faef-200d-1f468-1f3fe",44,12,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFE"],"17.0"],"1f3fb-1f3ff":["1f468-1f3fb-200d-1faef-200d-1f468-1f3ff",44,13,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFF"],"17.0"],"1f3fc-1f3fb":["1f468-1f3fc-200d-1faef-200d-1f468-1f3fb",44,14,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFB"],"17.0"],"1f3fc-1f3fd":["1f468-1f3fc-200d-1faef-200d-1f468-1f3fd",44,15,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFD"],"17.0"],"1f3fc-1f3fe":["1f468-1f3fc-200d-1faef-200d-1f468-1f3fe",44,16,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFE"],"17.0"],"1f3fc-1f3ff":["1f468-1f3fc-200d-1faef-200d-1f468-1f3ff",44,17,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFF"],"17.0"],"1f3fd-1f3fb":["1f468-1f3fd-200d-1faef-200d-1f468-1f3fb",44,18,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFB"],"17.0"],"1f3fd-1f3fc":["1f468-1f3fd-200d-1faef-200d-1f468-1f3fc",44,19,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFC"],"17.0"],"1f3fd-1f3fe":["1f468-1f3fd-200d-1faef-200d-1f468-1f3fe",44,20,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFE"],"17.0"],"1f3fd-1f3ff":["1f468-1f3fd-200d-1faef-200d-1f468-1f3ff",44,21,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFF"],"17.0"],"1f3fe-1f3fb":["1f468-1f3fe-200d-1faef-200d-1f468-1f3fb",44,22,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFB"],"17.0"],"1f3fe-1f3fc":["1f468-1f3fe-200d-1faef-200d-1f468-1f3fc",44,23,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFC"],"17.0"],"1f3fe-1f3fd":["1f468-1f3fe-200d-1faef-200d-1f468-1f3fd",44,24,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFD"],"17.0"],"1f3fe-1f3ff":["1f468-1f3fe-200d-1faef-200d-1f468-1f3ff",44,25,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFF"],"17.0"],"1f3ff-1f3fb":["1f468-1f3ff-200d-1faef-200d-1f468-1f3fb",44,26,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFB"],"17.0"],"1f3ff-1f3fc":["1f468-1f3ff-200d-1faef-200d-1f468-1f3fc",44,27,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFC"],"17.0"],"1f3ff-1f3fd":["1f468-1f3ff-200d-1faef-200d-1f468-1f3fd",44,28,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFD"],"17.0"],"1f3ff-1f3fe":["1f468-1f3ff-200d-1faef-200d-1f468-1f3fe",44,29,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFE"],"17.0"]},
    "1f93c":{"1f3fb":["1f93c-1f3fb",44,31,["\uD83E\uDD3C\uD83C\uDFFB"],"17.0"],"1f3fc":["1f93c-1f3fc",44,32,["\uD83E\uDD3C\uD83C\uDFFC"],"17.0"],"1f3fd":["1f93c-1f3fd",44,33,["\uD83E\uDD3C\uD83C\uDFFD"],"17.0"],"1f3fe":["1f93c-1f3fe",44,34,["\uD83E\uDD3C\uD83C\uDFFE"],"17.0"],"1f3ff":["1f93c-1f3ff",44,35,["\uD83E\uDD3C\uD83C\uDFFF"],"17.0"],"1f3fb-1f3fc":["1f9d1-1f3fb-200d-1faef-200d-1f9d1-1f3fc",44,36,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFC"],"17.0"],"1f3fb-1f3fd":["1f9d1-1f3fb-200d-1faef-200d-1f9d1-1f3fd",44,37,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFD"],"17.0"],"1f3fb-1f3fe":["1f9d1-1f3fb-200d-1faef-200d-1f9d1-1f3fe",44,38,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFE"],"17.0"],"1f3fb-1f3ff":["1f9d1-1f3fb-200d-1faef-200d-1f9d1-1f3ff",44,39,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFF"],"17.0"],"1f3fc-1f3fb":["1f9d1-1f3fc-200d-1faef-200d-1f9d1-1f3fb",44,40,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFB"],"17.0"],"1f3fc-1f3fd":["1f9d1-1f3fc-200d-1faef-200d-1f9d1-1f3fd",44,41,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFD"],"17.0"],"1f3fc-1f3fe":["1f9d1-1f3fc-200d-1faef-200d-1f9d1-1f3fe",44,42,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFE"],"17.0"],"1f3fc-1f3ff":["1f9d1-1f3fc-200d-1faef-200d-1f9d1-1f3ff",44,43,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFF"],"17.0"],"1f3fd-1f3fb":["1f9d1-1f3fd-200d-1faef-200d-1f9d1-1f3fb",44,44,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFB"],"17.0"],"1f3fd-1f3fc":["1f9d1-1f3fd-200d-1faef-200d-1f9d1-1f3fc",44,45,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFC"],"17.0"],"1f3fd-1f3fe":["1f9d1-1f3fd-200d-1faef-200d-1f9d1-1f3fe",44,46,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFE"],"17.0"],"1f3fd-1f3ff":["1f9d1-1f3fd-200d-1faef-200d-1f9d1-1f3ff",44,47,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFF"],"17.0"],"1f3fe-1f3fb":["1f9d1-1f3fe-200d-1faef-200d-1f9d1-1f3fb",44,48,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFB"],"17.0"],"1f3fe-1f3fc":["1f9d1-1f3fe-200d-1faef-200d-1f9d1-1f3fc",44,49,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFC"],"17.0"],"1f3fe-1f3fd":["1f9d1-1f3fe-200d-1faef-200d-1f9d1-1f3fd",44,50,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFD"],"17.0"],"1f3fe-1f3ff":["1f9d1-1f3fe-200d-1faef-200d-1f9d1-1f3ff",44,51,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFF"],"17.0"],"1f3ff-1f3fb":["1f9d1-1f3ff-200d-1faef-200d-1f9d1-1f3fb",44,52,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFB"],"17.0"],"1f3ff-1f3fc":["1f9d1-1f3ff-200d-1faef-200d-1f9d1-1f3fc",44,53,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFC"],"17.0"],"1f3ff-1f3fd":["1f9d1-1f3ff-200d-1faef-200d-1f9d1-1f3fd",44,54,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFD"],"17.0"],"1f3ff-1f3fe":["1f9d1-1f3ff-200d-1faef-200d-1f9d1-1f3fe",44,55,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFE"],"17.0"]},
    "1f93d-200d-2640-fe0f":{"1f3fb":["1f93d-1f3fb-200d-2640-fe0f",44,57,["\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f93d-1f3fc-200d-2640-fe0f",44,58,["\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f93d-1f3fd-200d-2640-fe0f",44,59,["\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f93d-1f3fe-200d-2640-fe0f",44,60,["\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f93d-1f3ff-200d-2640-fe0f",44,61,["\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f93d-200d-2642-fe0f":{"1f3fb":["1f93d-1f3fb-200d-2642-fe0f",45,0,["\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f93d-1f3fc-200d-2642-fe0f",45,1,["\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f93d-1f3fd-200d-2642-fe0f",45,2,["\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f93d-1f3fe-200d-2642-fe0f",45,3,["\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f93d-1f3ff-200d-2642-fe0f",45,4,["\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f93d":{"1f3fb":["1f93d-1f3fb",45,6,["\uD83E\uDD3D\uD83C\uDFFB"],"3.0"],"1f3fc":["1f93d-1f3fc",45,7,["\uD83E\uDD3D\uD83C\uDFFC"],"3.0"],"1f3fd":["1f93d-1f3fd",45,8,["\uD83E\uDD3D\uD83C\uDFFD"],"3.0"],"1f3fe":["1f93d-1f3fe",45,9,["\uD83E\uDD3D\uD83C\uDFFE"],"3.0"],"1f3ff":["1f93d-1f3ff",45,10,["\uD83E\uDD3D\uD83C\uDFFF"],"3.0"]},
    "1f93e-200d-2640-fe0f":{"1f3fb":["1f93e-1f3fb-200d-2640-fe0f",45,12,["\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f93e-1f3fc-200d-2640-fe0f",45,13,["\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f93e-1f3fd-200d-2640-fe0f",45,14,["\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f93e-1f3fe-200d-2640-fe0f",45,15,["\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f93e-1f3ff-200d-2640-fe0f",45,16,["\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f93e-200d-2642-fe0f":{"1f3fb":["1f93e-1f3fb-200d-2642-fe0f",45,18,["\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f93e-1f3fc-200d-2642-fe0f",45,19,["\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f93e-1f3fd-200d-2642-fe0f",45,20,["\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f93e-1f3fe-200d-2642-fe0f",45,21,["\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f93e-1f3ff-200d-2642-fe0f",45,22,["\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f93e":{"1f3fb":["1f93e-1f3fb",45,24,["\uD83E\uDD3E\uD83C\uDFFB"],"3.0"],"1f3fc":["1f93e-1f3fc",45,25,["\uD83E\uDD3E\uD83C\uDFFC"],"3.0"],"1f3fd":["1f93e-1f3fd",45,26,["\uD83E\uDD3E\uD83C\uDFFD"],"3.0"],"1f3fe":["1f93e-1f3fe",45,27,["\uD83E\uDD3E\uD83C\uDFFE"],"3.0"],"1f3ff":["1f93e-1f3ff",45,28,["\uD83E\uDD3E\uD83C\uDFFF"],"3.0"]},
    "1f977":{"1f3fb":["1f977-1f3fb",46,22,["\uD83E\uDD77\uD83C\uDFFB"],"13.0"],"1f3fc":["1f977-1f3fc",46,23,["\uD83E\uDD77\uD83C\uDFFC"],"13.0"],"1f3fd":["1f977-1f3fd",46,24,["\uD83E\uDD77\uD83C\uDFFD"],"13.0"],"1f3fe":["1f977-1f3fe",46,25,["\uD83E\uDD77\uD83C\uDFFE"],"13.0"],"1f3ff":["1f977-1f3ff",46,26,["\uD83E\uDD77\uD83C\uDFFF"],"13.0"]},
    "1f9b5":{"1f3fb":["1f9b5-1f3fb",47,22,["\uD83E\uDDB5\uD83C\uDFFB"],"11.0"],"1f3fc":["1f9b5-1f3fc",47,23,["\uD83E\uDDB5\uD83C\uDFFC"],"11.0"],"1f3fd":["1f9b5-1f3fd",47,24,["\uD83E\uDDB5\uD83C\uDFFD"],"11.0"],"1f3fe":["1f9b5-1f3fe",47,25,["\uD83E\uDDB5\uD83C\uDFFE"],"11.0"],"1f3ff":["1f9b5-1f3ff",47,26,["\uD83E\uDDB5\uD83C\uDFFF"],"11.0"]},
    "1f9b6":{"1f3fb":["1f9b6-1f3fb",47,28,["\uD83E\uDDB6\uD83C\uDFFB"],"11.0"],"1f3fc":["1f9b6-1f3fc",47,29,["\uD83E\uDDB6\uD83C\uDFFC"],"11.0"],"1f3fd":["1f9b6-1f3fd",47,30,["\uD83E\uDDB6\uD83C\uDFFD"],"11.0"],"1f3fe":["1f9b6-1f3fe",47,31,["\uD83E\uDDB6\uD83C\uDFFE"],"11.0"],"1f3ff":["1f9b6-1f3ff",47,32,["\uD83E\uDDB6\uD83C\uDFFF"],"11.0"]},
    "1f9b8-200d-2640-fe0f":{"1f3fb":["1f9b8-1f3fb-200d-2640-fe0f",47,35,["\uD83E\uDDB8\uD83C\uDFFB\u200D\u2640\uFE0F"],"11.0"],"1f3fc":["1f9b8-1f3fc-200d-2640-fe0f",47,36,["\uD83E\uDDB8\uD83C\uDFFC\u200D\u2640\uFE0F"],"11.0"],"1f3fd":["1f9b8-1f3fd-200d-2640-fe0f",47,37,["\uD83E\uDDB8\uD83C\uDFFD\u200D\u2640\uFE0F"],"11.0"],"1f3fe":["1f9b8-1f3fe-200d-2640-fe0f",47,38,["\uD83E\uDDB8\uD83C\uDFFE\u200D\u2640\uFE0F"],"11.0"],"1f3ff":["1f9b8-1f3ff-200d-2640-fe0f",47,39,["\uD83E\uDDB8\uD83C\uDFFF\u200D\u2640\uFE0F"],"11.0"]},
    "1f9b8-200d-2642-fe0f":{"1f3fb":["1f9b8-1f3fb-200d-2642-fe0f",47,41,["\uD83E\uDDB8\uD83C\uDFFB\u200D\u2642\uFE0F"],"11.0"],"1f3fc":["1f9b8-1f3fc-200d-2642-fe0f",47,42,["\uD83E\uDDB8\uD83C\uDFFC\u200D\u2642\uFE0F"],"11.0"],"1f3fd":["1f9b8-1f3fd-200d-2642-fe0f",47,43,["\uD83E\uDDB8\uD83C\uDFFD\u200D\u2642\uFE0F"],"11.0"],"1f3fe":["1f9b8-1f3fe-200d-2642-fe0f",47,44,["\uD83E\uDDB8\uD83C\uDFFE\u200D\u2642\uFE0F"],"11.0"],"1f3ff":["1f9b8-1f3ff-200d-2642-fe0f",47,45,["\uD83E\uDDB8\uD83C\uDFFF\u200D\u2642\uFE0F"],"11.0"]},
    "1f9b8":{"1f3fb":["1f9b8-1f3fb",47,47,["\uD83E\uDDB8\uD83C\uDFFB"],"11.0"],"1f3fc":["1f9b8-1f3fc",47,48,["\uD83E\uDDB8\uD83C\uDFFC"],"11.0"],"1f3fd":["1f9b8-1f3fd",47,49,["\uD83E\uDDB8\uD83C\uDFFD"],"11.0"],"1f3fe":["1f9b8-1f3fe",47,50,["\uD83E\uDDB8\uD83C\uDFFE"],"11.0"],"1f3ff":["1f9b8-1f3ff",47,51,["\uD83E\uDDB8\uD83C\uDFFF"],"11.0"]},
    "1f9b9-200d-2640-fe0f":{"1f3fb":["1f9b9-1f3fb-200d-2640-fe0f",47,53,["\uD83E\uDDB9\uD83C\uDFFB\u200D\u2640\uFE0F"],"11.0"],"1f3fc":["1f9b9-1f3fc-200d-2640-fe0f",47,54,["\uD83E\uDDB9\uD83C\uDFFC\u200D\u2640\uFE0F"],"11.0"],"1f3fd":["1f9b9-1f3fd-200d-2640-fe0f",47,55,["\uD83E\uDDB9\uD83C\uDFFD\u200D\u2640\uFE0F"],"11.0"],"1f3fe":["1f9b9-1f3fe-200d-2640-fe0f",47,56,["\uD83E\uDDB9\uD83C\uDFFE\u200D\u2640\uFE0F"],"11.0"],"1f3ff":["1f9b9-1f3ff-200d-2640-fe0f",47,57,["\uD83E\uDDB9\uD83C\uDFFF\u200D\u2640\uFE0F"],"11.0"]},
    "1f9b9-200d-2642-fe0f":{"1f3fb":["1f9b9-1f3fb-200d-2642-fe0f",47,59,["\uD83E\uDDB9\uD83C\uDFFB\u200D\u2642\uFE0F"],"11.0"],"1f3fc":["1f9b9-1f3fc-200d-2642-fe0f",47,60,["\uD83E\uDDB9\uD83C\uDFFC\u200D\u2642\uFE0F"],"11.0"],"1f3fd":["1f9b9-1f3fd-200d-2642-fe0f",47,61,["\uD83E\uDDB9\uD83C\uDFFD\u200D\u2642\uFE0F"],"11.0"],"1f3fe":["1f9b9-1f3fe-200d-2642-fe0f",47,62,["\uD83E\uDDB9\uD83C\uDFFE\u200D\u2642\uFE0F"],"11.0"],"1f3ff":["1f9b9-1f3ff-200d-2642-fe0f",48,0,["\uD83E\uDDB9\uD83C\uDFFF\u200D\u2642\uFE0F"],"11.0"]},
    "1f9b9":{"1f3fb":["1f9b9-1f3fb",48,2,["\uD83E\uDDB9\uD83C\uDFFB"],"11.0"],"1f3fc":["1f9b9-1f3fc",48,3,["\uD83E\uDDB9\uD83C\uDFFC"],"11.0"],"1f3fd":["1f9b9-1f3fd",48,4,["\uD83E\uDDB9\uD83C\uDFFD"],"11.0"],"1f3fe":["1f9b9-1f3fe",48,5,["\uD83E\uDDB9\uD83C\uDFFE"],"11.0"],"1f3ff":["1f9b9-1f3ff",48,6,["\uD83E\uDDB9\uD83C\uDFFF"],"11.0"]},
    "1f9bb":{"1f3fb":["1f9bb-1f3fb",48,9,["\uD83E\uDDBB\uD83C\uDFFB"],"12.0"],"1f3fc":["1f9bb-1f3fc",48,10,["\uD83E\uDDBB\uD83C\uDFFC"],"12.0"],"1f3fd":["1f9bb-1f3fd",48,11,["\uD83E\uDDBB\uD83C\uDFFD"],"12.0"],"1f3fe":["1f9bb-1f3fe",48,12,["\uD83E\uDDBB\uD83C\uDFFE"],"12.0"],"1f3ff":["1f9bb-1f3ff",48,13,["\uD83E\uDDBB\uD83C\uDFFF"],"12.0"]},
    "1f9cd-200d-2640-fe0f":{"1f3fb":["1f9cd-1f3fb-200d-2640-fe0f",48,32,["\uD83E\uDDCD\uD83C\uDFFB\u200D\u2640\uFE0F"],"12.0"],"1f3fc":["1f9cd-1f3fc-200d-2640-fe0f",48,33,["\uD83E\uDDCD\uD83C\uDFFC\u200D\u2640\uFE0F"],"12.0"],"1f3fd":["1f9cd-1f3fd-200d-2640-fe0f",48,34,["\uD83E\uDDCD\uD83C\uDFFD\u200D\u2640\uFE0F"],"12.0"],"1f3fe":["1f9cd-1f3fe-200d-2640-fe0f",48,35,["\uD83E\uDDCD\uD83C\uDFFE\u200D\u2640\uFE0F"],"12.0"],"1f3ff":["1f9cd-1f3ff-200d-2640-fe0f",48,36,["\uD83E\uDDCD\uD83C\uDFFF\u200D\u2640\uFE0F"],"12.0"]},
    "1f9cd-200d-2642-fe0f":{"1f3fb":["1f9cd-1f3fb-200d-2642-fe0f",48,38,["\uD83E\uDDCD\uD83C\uDFFB\u200D\u2642\uFE0F"],"12.0"],"1f3fc":["1f9cd-1f3fc-200d-2642-fe0f",48,39,["\uD83E\uDDCD\uD83C\uDFFC\u200D\u2642\uFE0F"],"12.0"],"1f3fd":["1f9cd-1f3fd-200d-2642-fe0f",48,40,["\uD83E\uDDCD\uD83C\uDFFD\u200D\u2642\uFE0F"],"12.0"],"1f3fe":["1f9cd-1f3fe-200d-2642-fe0f",48,41,["\uD83E\uDDCD\uD83C\uDFFE\u200D\u2642\uFE0F"],"12.0"],"1f3ff":["1f9cd-1f3ff-200d-2642-fe0f",48,42,["\uD83E\uDDCD\uD83C\uDFFF\u200D\u2642\uFE0F"],"12.0"]},
    "1f9cd":{"1f3fb":["1f9cd-1f3fb",48,44,["\uD83E\uDDCD\uD83C\uDFFB"],"12.0"],"1f3fc":["1f9cd-1f3fc",48,45,["\uD83E\uDDCD\uD83C\uDFFC"],"12.0"],"1f3fd":["1f9cd-1f3fd",48,46,["\uD83E\uDDCD\uD83C\uDFFD"],"12.0"],"1f3fe":["1f9cd-1f3fe",48,47,["\uD83E\uDDCD\uD83C\uDFFE"],"12.0"],"1f3ff":["1f9cd-1f3ff",48,48,["\uD83E\uDDCD\uD83C\uDFFF"],"12.0"]},
    "1f9ce-200d-2640-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-2640-fe0f",48,50,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F"],"12.0"],"1f3fc":["1f9ce-1f3fc-200d-2640-fe0f",48,51,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F"],"12.0"],"1f3fd":["1f9ce-1f3fd-200d-2640-fe0f",48,52,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F"],"12.0"],"1f3fe":["1f9ce-1f3fe-200d-2640-fe0f",48,53,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F"],"12.0"],"1f3ff":["1f9ce-1f3ff-200d-2640-fe0f",48,54,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F"],"12.0"]},
    "1f9ce-200d-2640-fe0f-200d-27a1-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",48,56,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9ce-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",48,57,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9ce-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",48,58,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9ce-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",48,59,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9ce-1f3ff-200d-2640-fe0f-200d-27a1-fe0f",48,60,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9ce-200d-2642-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-2642-fe0f",48,62,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F"],"12.0"],"1f3fc":["1f9ce-1f3fc-200d-2642-fe0f",49,0,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F"],"12.0"],"1f3fd":["1f9ce-1f3fd-200d-2642-fe0f",49,1,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F"],"12.0"],"1f3fe":["1f9ce-1f3fe-200d-2642-fe0f",49,2,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F"],"12.0"],"1f3ff":["1f9ce-1f3ff-200d-2642-fe0f",49,3,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F"],"12.0"]},
    "1f9ce-200d-2642-fe0f-200d-27a1-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",49,5,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9ce-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",49,6,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9ce-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",49,7,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9ce-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",49,8,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9ce-1f3ff-200d-2642-fe0f-200d-27a1-fe0f",49,9,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9ce-200d-27a1-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-27a1-fe0f",49,11,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9ce-1f3fc-200d-27a1-fe0f",49,12,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9ce-1f3fd-200d-27a1-fe0f",49,13,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9ce-1f3fe-200d-27a1-fe0f",49,14,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9ce-1f3ff-200d-27a1-fe0f",49,15,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9ce":{"1f3fb":["1f9ce-1f3fb",49,17,["\uD83E\uDDCE\uD83C\uDFFB"],"12.0"],"1f3fc":["1f9ce-1f3fc",49,18,["\uD83E\uDDCE\uD83C\uDFFC"],"12.0"],"1f3fd":["1f9ce-1f3fd",49,19,["\uD83E\uDDCE\uD83C\uDFFD"],"12.0"],"1f3fe":["1f9ce-1f3fe",49,20,["\uD83E\uDDCE\uD83C\uDFFE"],"12.0"],"1f3ff":["1f9ce-1f3ff",49,21,["\uD83E\uDDCE\uD83C\uDFFF"],"12.0"]},
    "1f9cf-200d-2640-fe0f":{"1f3fb":["1f9cf-1f3fb-200d-2640-fe0f",49,23,["\uD83E\uDDCF\uD83C\uDFFB\u200D\u2640\uFE0F"],"12.0"],"1f3fc":["1f9cf-1f3fc-200d-2640-fe0f",49,24,["\uD83E\uDDCF\uD83C\uDFFC\u200D\u2640\uFE0F"],"12.0"],"1f3fd":["1f9cf-1f3fd-200d-2640-fe0f",49,25,["\uD83E\uDDCF\uD83C\uDFFD\u200D\u2640\uFE0F"],"12.0"],"1f3fe":["1f9cf-1f3fe-200d-2640-fe0f",49,26,["\uD83E\uDDCF\uD83C\uDFFE\u200D\u2640\uFE0F"],"12.0"],"1f3ff":["1f9cf-1f3ff-200d-2640-fe0f",49,27,["\uD83E\uDDCF\uD83C\uDFFF\u200D\u2640\uFE0F"],"12.0"]},
    "1f9cf-200d-2642-fe0f":{"1f3fb":["1f9cf-1f3fb-200d-2642-fe0f",49,29,["\uD83E\uDDCF\uD83C\uDFFB\u200D\u2642\uFE0F"],"12.0"],"1f3fc":["1f9cf-1f3fc-200d-2642-fe0f",49,30,["\uD83E\uDDCF\uD83C\uDFFC\u200D\u2642\uFE0F"],"12.0"],"1f3fd":["1f9cf-1f3fd-200d-2642-fe0f",49,31,["\uD83E\uDDCF\uD83C\uDFFD\u200D\u2642\uFE0F"],"12.0"],"1f3fe":["1f9cf-1f3fe-200d-2642-fe0f",49,32,["\uD83E\uDDCF\uD83C\uDFFE\u200D\u2642\uFE0F"],"12.0"],"1f3ff":["1f9cf-1f3ff-200d-2642-fe0f",49,33,["\uD83E\uDDCF\uD83C\uDFFF\u200D\u2642\uFE0F"],"12.0"]},
    "1f9cf":{"1f3fb":["1f9cf-1f3fb",49,35,["\uD83E\uDDCF\uD83C\uDFFB"],"12.0"],"1f3fc":["1f9cf-1f3fc",49,36,["\uD83E\uDDCF\uD83C\uDFFC"],"12.0"],"1f3fd":["1f9cf-1f3fd",49,37,["\uD83E\uDDCF\uD83C\uDFFD"],"12.0"],"1f3fe":["1f9cf-1f3fe",49,38,["\uD83E\uDDCF\uD83C\uDFFE"],"12.0"],"1f3ff":["1f9cf-1f3ff",49,39,["\uD83E\uDDCF\uD83C\uDFFF"],"12.0"]},
    "1f9d1-200d-1f33e":{"1f3fb":["1f9d1-1f3fb-200d-1f33e",49,42,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF3E"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f33e",49,43,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF3E"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f33e",49,44,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF3E"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f33e",49,45,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF3E"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f33e",49,46,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF3E"],"12.1"]},
    "1f9d1-200d-1f373":{"1f3fb":["1f9d1-1f3fb-200d-1f373",49,48,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF73"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f373",49,49,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF73"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f373",49,50,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF73"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f373",49,51,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF73"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f373",49,52,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF73"],"12.1"]},
    "1f9d1-200d-1f37c":{"1f3fb":["1f9d1-1f3fb-200d-1f37c",49,54,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF7C"],"13.0"],"1f3fc":["1f9d1-1f3fc-200d-1f37c",49,55,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF7C"],"13.0"],"1f3fd":["1f9d1-1f3fd-200d-1f37c",49,56,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF7C"],"13.0"],"1f3fe":["1f9d1-1f3fe-200d-1f37c",49,57,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF7C"],"13.0"],"1f3ff":["1f9d1-1f3ff-200d-1f37c",49,58,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF7C"],"13.0"]},
    "1f9d1-200d-1f384":{"1f3fb":["1f9d1-1f3fb-200d-1f384",49,60,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF84"],"13.0"],"1f3fc":["1f9d1-1f3fc-200d-1f384",49,61,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF84"],"13.0"],"1f3fd":["1f9d1-1f3fd-200d-1f384",49,62,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF84"],"13.0"],"1f3fe":["1f9d1-1f3fe-200d-1f384",50,0,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF84"],"13.0"],"1f3ff":["1f9d1-1f3ff-200d-1f384",50,1,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF84"],"13.0"]},
    "1f9d1-200d-1f393":{"1f3fb":["1f9d1-1f3fb-200d-1f393",50,3,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF93"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f393",50,4,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF93"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f393",50,5,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF93"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f393",50,6,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF93"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f393",50,7,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF93"],"12.1"]},
    "1f9d1-200d-1f3a4":{"1f3fb":["1f9d1-1f3fb-200d-1f3a4",50,9,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA4"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f3a4",50,10,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA4"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f3a4",50,11,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA4"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f3a4",50,12,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA4"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f3a4",50,13,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA4"],"12.1"]},
    "1f9d1-200d-1f3a8":{"1f3fb":["1f9d1-1f3fb-200d-1f3a8",50,15,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA8"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f3a8",50,16,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA8"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f3a8",50,17,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA8"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f3a8",50,18,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA8"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f3a8",50,19,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA8"],"12.1"]},
    "1f9d1-200d-1f3eb":{"1f3fb":["1f9d1-1f3fb-200d-1f3eb",50,21,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFEB"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f3eb",50,22,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFEB"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f3eb",50,23,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFEB"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f3eb",50,24,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFEB"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f3eb",50,25,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFEB"],"12.1"]},
    "1f9d1-200d-1f3ed":{"1f3fb":["1f9d1-1f3fb-200d-1f3ed",50,27,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFED"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f3ed",50,28,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFED"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f3ed",50,29,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFED"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f3ed",50,30,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFED"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f3ed",50,31,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFED"],"12.1"]},
    "1f9d1-200d-1f4bb":{"1f3fb":["1f9d1-1f3fb-200d-1f4bb",50,33,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBB"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f4bb",50,34,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBB"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f4bb",50,35,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBB"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f4bb",50,36,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBB"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f4bb",50,37,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBB"],"12.1"]},
    "1f9d1-200d-1f4bc":{"1f3fb":["1f9d1-1f3fb-200d-1f4bc",50,39,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBC"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f4bc",50,40,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBC"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f4bc",50,41,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBC"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f4bc",50,42,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBC"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f4bc",50,43,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBC"],"12.1"]},
    "1f9d1-200d-1f527":{"1f3fb":["1f9d1-1f3fb-200d-1f527",50,45,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD27"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f527",50,46,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD27"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f527",50,47,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD27"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f527",50,48,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD27"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f527",50,49,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD27"],"12.1"]},
    "1f9d1-200d-1f52c":{"1f3fb":["1f9d1-1f3fb-200d-1f52c",50,51,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD2C"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f52c",50,52,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD2C"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f52c",50,53,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD2C"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f52c",50,54,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD2C"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f52c",50,55,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD2C"],"12.1"]},
    "1f9d1-200d-1f680":{"1f3fb":["1f9d1-1f3fb-200d-1f680",50,57,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE80"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f680",50,58,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE80"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f680",50,59,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE80"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f680",50,60,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE80"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f680",50,61,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE80"],"12.1"]},
    "1f9d1-200d-1f692":{"1f3fb":["1f9d1-1f3fb-200d-1f692",51,0,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE92"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f692",51,1,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE92"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f692",51,2,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE92"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f692",51,3,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE92"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f692",51,4,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE92"],"12.1"]},
    "1f9d1-200d-1f91d-200d-1f9d1":{"1f3fb-1f3fb":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",51,6,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3fb-1f3fc":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",51,7,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.1"],"1f3fb-1f3fd":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",51,8,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.1"],"1f3fb-1f3fe":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",51,9,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.1"],"1f3fb-1f3ff":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",51,10,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.1"],"1f3fc-1f3fb":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",51,11,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3fc-1f3fc":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",51,12,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.0"],"1f3fc-1f3fd":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",51,13,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.1"],"1f3fc-1f3fe":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",51,14,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.1"],"1f3fc-1f3ff":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",51,15,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.1"],"1f3fd-1f3fb":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",51,16,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3fd-1f3fc":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",51,17,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.0"],"1f3fd-1f3fd":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",51,18,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.0"],"1f3fd-1f3fe":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",51,19,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.1"],"1f3fd-1f3ff":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",51,20,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.1"],"1f3fe-1f3fb":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",51,21,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3fe-1f3fc":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",51,22,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.0"],"1f3fe-1f3fd":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",51,23,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.0"],"1f3fe-1f3fe":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",51,24,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.0"],"1f3fe-1f3ff":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",51,25,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.1"],"1f3ff-1f3fb":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",51,26,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3ff-1f3fc":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",51,27,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.0"],"1f3ff-1f3fd":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",51,28,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.0"],"1f3ff-1f3fe":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",51,29,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.0"],"1f3ff-1f3ff":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",51,30,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.0"]},
    "1f9d1-200d-1f9af-200d-27a1-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-1f9af-200d-27a1-fe0f",51,32,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9af-200d-27a1-fe0f",51,33,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9af-200d-27a1-fe0f",51,34,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9af-200d-27a1-fe0f",51,35,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9af-200d-27a1-fe0f",51,36,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9d1-200d-1f9af":{"1f3fb":["1f9d1-1f3fb-200d-1f9af",51,38,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9af",51,39,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9af",51,40,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9af",51,41,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9af",51,42,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF"],"12.1"]},
    "1f9d1-200d-1f9b0":{"1f3fb":["1f9d1-1f3fb-200d-1f9b0",51,44,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB0"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9b0",51,45,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB0"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9b0",51,46,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB0"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9b0",51,47,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB0"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9b0",51,48,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB0"],"12.1"]},
    "1f9d1-200d-1f9b1":{"1f3fb":["1f9d1-1f3fb-200d-1f9b1",51,50,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB1"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9b1",51,51,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB1"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9b1",51,52,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB1"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9b1",51,53,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB1"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9b1",51,54,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB1"],"12.1"]},
    "1f9d1-200d-1f9b2":{"1f3fb":["1f9d1-1f3fb-200d-1f9b2",51,56,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB2"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9b2",51,57,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB2"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9b2",51,58,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB2"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9b2",51,59,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB2"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9b2",51,60,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB2"],"12.1"]},
    "1f9d1-200d-1f9b3":{"1f3fb":["1f9d1-1f3fb-200d-1f9b3",51,62,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB3"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9b3",52,0,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB3"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9b3",52,1,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB3"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9b3",52,2,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB3"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9b3",52,3,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB3"],"12.1"]},
    "1f9d1-200d-1f9bc-200d-27a1-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-1f9bc-200d-27a1-fe0f",52,5,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9bc-200d-27a1-fe0f",52,6,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9bc-200d-27a1-fe0f",52,7,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9bc-200d-27a1-fe0f",52,8,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9bc-200d-27a1-fe0f",52,9,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9d1-200d-1f9bc":{"1f3fb":["1f9d1-1f3fb-200d-1f9bc",52,11,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9bc",52,12,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9bc",52,13,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9bc",52,14,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9bc",52,15,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC"],"12.1"]},
    "1f9d1-200d-1f9bd-200d-27a1-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-1f9bd-200d-27a1-fe0f",52,17,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9bd-200d-27a1-fe0f",52,18,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9bd-200d-27a1-fe0f",52,19,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9bd-200d-27a1-fe0f",52,20,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9bd-200d-27a1-fe0f",52,21,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9d1-200d-1f9bd":{"1f3fb":["1f9d1-1f3fb-200d-1f9bd",52,23,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9bd",52,24,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9bd",52,25,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9bd",52,26,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9bd",52,27,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD"],"12.1"]},
    "1f9d1-200d-1fa70":{"1f3fb":["1f9d1-1f3fb-200d-1fa70",52,33,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDE70"],"17.0"],"1f3fc":["1f9d1-1f3fc-200d-1fa70",52,34,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDE70"],"17.0"],"1f3fd":["1f9d1-1f3fd-200d-1fa70",52,35,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDE70"],"17.0"],"1f3fe":["1f9d1-1f3fe-200d-1fa70",52,36,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDE70"],"17.0"],"1f3ff":["1f9d1-1f3ff-200d-1fa70",52,37,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDE70"],"17.0"]},
    "1f9d1-200d-2695-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-2695-fe0f",52,39,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2695\uFE0F"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-2695-fe0f",52,40,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2695\uFE0F"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-2695-fe0f",52,41,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2695\uFE0F"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-2695-fe0f",52,42,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2695\uFE0F"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-2695-fe0f",52,43,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2695\uFE0F"],"12.1"]},
    "1f9d1-200d-2696-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-2696-fe0f",52,45,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2696\uFE0F"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-2696-fe0f",52,46,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2696\uFE0F"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-2696-fe0f",52,47,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2696\uFE0F"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-2696-fe0f",52,48,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2696\uFE0F"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-2696-fe0f",52,49,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2696\uFE0F"],"12.1"]},
    "1f9d1-200d-2708-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-2708-fe0f",52,51,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2708\uFE0F"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-2708-fe0f",52,52,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2708\uFE0F"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-2708-fe0f",52,53,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2708\uFE0F"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-2708-fe0f",52,54,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2708\uFE0F"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-2708-fe0f",52,55,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2708\uFE0F"],"12.1"]},
    "1f9d1":{"1f3fb":["1f9d1-1f3fb",52,57,["\uD83E\uDDD1\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d1-1f3fc",52,58,["\uD83E\uDDD1\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d1-1f3fd",52,59,["\uD83E\uDDD1\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d1-1f3fe",52,60,["\uD83E\uDDD1\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d1-1f3ff",52,61,["\uD83E\uDDD1\uD83C\uDFFF"],"5.0"]},
    "1f9d2":{"1f3fb":["1f9d2-1f3fb",53,0,["\uD83E\uDDD2\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d2-1f3fc",53,1,["\uD83E\uDDD2\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d2-1f3fd",53,2,["\uD83E\uDDD2\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d2-1f3fe",53,3,["\uD83E\uDDD2\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d2-1f3ff",53,4,["\uD83E\uDDD2\uD83C\uDFFF"],"5.0"]},
    "1f9d3":{"1f3fb":["1f9d3-1f3fb",53,6,["\uD83E\uDDD3\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d3-1f3fc",53,7,["\uD83E\uDDD3\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d3-1f3fd",53,8,["\uD83E\uDDD3\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d3-1f3fe",53,9,["\uD83E\uDDD3\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d3-1f3ff",53,10,["\uD83E\uDDD3\uD83C\uDFFF"],"5.0"]},
    "1f9d4-200d-2640-fe0f":{"1f3fb":["1f9d4-1f3fb-200d-2640-fe0f",53,12,["\uD83E\uDDD4\uD83C\uDFFB\u200D\u2640\uFE0F"],"13.1"],"1f3fc":["1f9d4-1f3fc-200d-2640-fe0f",53,13,["\uD83E\uDDD4\uD83C\uDFFC\u200D\u2640\uFE0F"],"13.1"],"1f3fd":["1f9d4-1f3fd-200d-2640-fe0f",53,14,["\uD83E\uDDD4\uD83C\uDFFD\u200D\u2640\uFE0F"],"13.1"],"1f3fe":["1f9d4-1f3fe-200d-2640-fe0f",53,15,["\uD83E\uDDD4\uD83C\uDFFE\u200D\u2640\uFE0F"],"13.1"],"1f3ff":["1f9d4-1f3ff-200d-2640-fe0f",53,16,["\uD83E\uDDD4\uD83C\uDFFF\u200D\u2640\uFE0F"],"13.1"]},
    "1f9d4-200d-2642-fe0f":{"1f3fb":["1f9d4-1f3fb-200d-2642-fe0f",53,18,["\uD83E\uDDD4\uD83C\uDFFB\u200D\u2642\uFE0F"],"13.1"],"1f3fc":["1f9d4-1f3fc-200d-2642-fe0f",53,19,["\uD83E\uDDD4\uD83C\uDFFC\u200D\u2642\uFE0F"],"13.1"],"1f3fd":["1f9d4-1f3fd-200d-2642-fe0f",53,20,["\uD83E\uDDD4\uD83C\uDFFD\u200D\u2642\uFE0F"],"13.1"],"1f3fe":["1f9d4-1f3fe-200d-2642-fe0f",53,21,["\uD83E\uDDD4\uD83C\uDFFE\u200D\u2642\uFE0F"],"13.1"],"1f3ff":["1f9d4-1f3ff-200d-2642-fe0f",53,22,["\uD83E\uDDD4\uD83C\uDFFF\u200D\u2642\uFE0F"],"13.1"]},
    "1f9d4":{"1f3fb":["1f9d4-1f3fb",53,24,["\uD83E\uDDD4\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d4-1f3fc",53,25,["\uD83E\uDDD4\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d4-1f3fd",53,26,["\uD83E\uDDD4\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d4-1f3fe",53,27,["\uD83E\uDDD4\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d4-1f3ff",53,28,["\uD83E\uDDD4\uD83C\uDFFF"],"5.0"]},
    "1f9d5":{"1f3fb":["1f9d5-1f3fb",53,30,["\uD83E\uDDD5\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d5-1f3fc",53,31,["\uD83E\uDDD5\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d5-1f3fd",53,32,["\uD83E\uDDD5\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d5-1f3fe",53,33,["\uD83E\uDDD5\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d5-1f3ff",53,34,["\uD83E\uDDD5\uD83C\uDFFF"],"5.0"]},
    "1f9d6-200d-2640-fe0f":{"1f3fb":["1f9d6-1f3fb-200d-2640-fe0f",53,36,["\uD83E\uDDD6\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9d6-1f3fc-200d-2640-fe0f",53,37,["\uD83E\uDDD6\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9d6-1f3fd-200d-2640-fe0f",53,38,["\uD83E\uDDD6\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9d6-1f3fe-200d-2640-fe0f",53,39,["\uD83E\uDDD6\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9d6-1f3ff-200d-2640-fe0f",53,40,["\uD83E\uDDD6\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9d6-200d-2642-fe0f":{"1f3fb":["1f9d6-1f3fb-200d-2642-fe0f",53,42,["\uD83E\uDDD6\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9d6-1f3fc-200d-2642-fe0f",53,43,["\uD83E\uDDD6\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9d6-1f3fd-200d-2642-fe0f",53,44,["\uD83E\uDDD6\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9d6-1f3fe-200d-2642-fe0f",53,45,["\uD83E\uDDD6\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9d6-1f3ff-200d-2642-fe0f",53,46,["\uD83E\uDDD6\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9d6":{"1f3fb":["1f9d6-1f3fb",53,48,["\uD83E\uDDD6\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d6-1f3fc",53,49,["\uD83E\uDDD6\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d6-1f3fd",53,50,["\uD83E\uDDD6\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d6-1f3fe",53,51,["\uD83E\uDDD6\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d6-1f3ff",53,52,["\uD83E\uDDD6\uD83C\uDFFF"],"5.0"]},
    "1f9d7-200d-2640-fe0f":{"1f3fb":["1f9d7-1f3fb-200d-2640-fe0f",53,54,["\uD83E\uDDD7\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9d7-1f3fc-200d-2640-fe0f",53,55,["\uD83E\uDDD7\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9d7-1f3fd-200d-2640-fe0f",53,56,["\uD83E\uDDD7\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9d7-1f3fe-200d-2640-fe0f",53,57,["\uD83E\uDDD7\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9d7-1f3ff-200d-2640-fe0f",53,58,["\uD83E\uDDD7\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9d7-200d-2642-fe0f":{"1f3fb":["1f9d7-1f3fb-200d-2642-fe0f",53,60,["\uD83E\uDDD7\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9d7-1f3fc-200d-2642-fe0f",53,61,["\uD83E\uDDD7\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9d7-1f3fd-200d-2642-fe0f",53,62,["\uD83E\uDDD7\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9d7-1f3fe-200d-2642-fe0f",54,0,["\uD83E\uDDD7\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9d7-1f3ff-200d-2642-fe0f",54,1,["\uD83E\uDDD7\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9d7":{"1f3fb":["1f9d7-1f3fb",54,3,["\uD83E\uDDD7\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d7-1f3fc",54,4,["\uD83E\uDDD7\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d7-1f3fd",54,5,["\uD83E\uDDD7\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d7-1f3fe",54,6,["\uD83E\uDDD7\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d7-1f3ff",54,7,["\uD83E\uDDD7\uD83C\uDFFF"],"5.0"]},
    "1f9d8-200d-2640-fe0f":{"1f3fb":["1f9d8-1f3fb-200d-2640-fe0f",54,9,["\uD83E\uDDD8\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9d8-1f3fc-200d-2640-fe0f",54,10,["\uD83E\uDDD8\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9d8-1f3fd-200d-2640-fe0f",54,11,["\uD83E\uDDD8\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9d8-1f3fe-200d-2640-fe0f",54,12,["\uD83E\uDDD8\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9d8-1f3ff-200d-2640-fe0f",54,13,["\uD83E\uDDD8\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9d8-200d-2642-fe0f":{"1f3fb":["1f9d8-1f3fb-200d-2642-fe0f",54,15,["\uD83E\uDDD8\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9d8-1f3fc-200d-2642-fe0f",54,16,["\uD83E\uDDD8\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9d8-1f3fd-200d-2642-fe0f",54,17,["\uD83E\uDDD8\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9d8-1f3fe-200d-2642-fe0f",54,18,["\uD83E\uDDD8\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9d8-1f3ff-200d-2642-fe0f",54,19,["\uD83E\uDDD8\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9d8":{"1f3fb":["1f9d8-1f3fb",54,21,["\uD83E\uDDD8\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d8-1f3fc",54,22,["\uD83E\uDDD8\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d8-1f3fd",54,23,["\uD83E\uDDD8\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d8-1f3fe",54,24,["\uD83E\uDDD8\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d8-1f3ff",54,25,["\uD83E\uDDD8\uD83C\uDFFF"],"5.0"]},
    "1f9d9-200d-2640-fe0f":{"1f3fb":["1f9d9-1f3fb-200d-2640-fe0f",54,27,["\uD83E\uDDD9\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9d9-1f3fc-200d-2640-fe0f",54,28,["\uD83E\uDDD9\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9d9-1f3fd-200d-2640-fe0f",54,29,["\uD83E\uDDD9\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9d9-1f3fe-200d-2640-fe0f",54,30,["\uD83E\uDDD9\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9d9-1f3ff-200d-2640-fe0f",54,31,["\uD83E\uDDD9\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9d9-200d-2642-fe0f":{"1f3fb":["1f9d9-1f3fb-200d-2642-fe0f",54,33,["\uD83E\uDDD9\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9d9-1f3fc-200d-2642-fe0f",54,34,["\uD83E\uDDD9\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9d9-1f3fd-200d-2642-fe0f",54,35,["\uD83E\uDDD9\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9d9-1f3fe-200d-2642-fe0f",54,36,["\uD83E\uDDD9\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9d9-1f3ff-200d-2642-fe0f",54,37,["\uD83E\uDDD9\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9d9":{"1f3fb":["1f9d9-1f3fb",54,39,["\uD83E\uDDD9\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d9-1f3fc",54,40,["\uD83E\uDDD9\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d9-1f3fd",54,41,["\uD83E\uDDD9\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d9-1f3fe",54,42,["\uD83E\uDDD9\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d9-1f3ff",54,43,["\uD83E\uDDD9\uD83C\uDFFF"],"5.0"]},
    "1f9da-200d-2640-fe0f":{"1f3fb":["1f9da-1f3fb-200d-2640-fe0f",54,45,["\uD83E\uDDDA\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9da-1f3fc-200d-2640-fe0f",54,46,["\uD83E\uDDDA\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9da-1f3fd-200d-2640-fe0f",54,47,["\uD83E\uDDDA\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9da-1f3fe-200d-2640-fe0f",54,48,["\uD83E\uDDDA\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9da-1f3ff-200d-2640-fe0f",54,49,["\uD83E\uDDDA\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9da-200d-2642-fe0f":{"1f3fb":["1f9da-1f3fb-200d-2642-fe0f",54,51,["\uD83E\uDDDA\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9da-1f3fc-200d-2642-fe0f",54,52,["\uD83E\uDDDA\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9da-1f3fd-200d-2642-fe0f",54,53,["\uD83E\uDDDA\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9da-1f3fe-200d-2642-fe0f",54,54,["\uD83E\uDDDA\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9da-1f3ff-200d-2642-fe0f",54,55,["\uD83E\uDDDA\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9da":{"1f3fb":["1f9da-1f3fb",54,57,["\uD83E\uDDDA\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9da-1f3fc",54,58,["\uD83E\uDDDA\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9da-1f3fd",54,59,["\uD83E\uDDDA\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9da-1f3fe",54,60,["\uD83E\uDDDA\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9da-1f3ff",54,61,["\uD83E\uDDDA\uD83C\uDFFF"],"5.0"]},
    "1f9db-200d-2640-fe0f":{"1f3fb":["1f9db-1f3fb-200d-2640-fe0f",55,0,["\uD83E\uDDDB\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9db-1f3fc-200d-2640-fe0f",55,1,["\uD83E\uDDDB\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9db-1f3fd-200d-2640-fe0f",55,2,["\uD83E\uDDDB\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9db-1f3fe-200d-2640-fe0f",55,3,["\uD83E\uDDDB\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9db-1f3ff-200d-2640-fe0f",55,4,["\uD83E\uDDDB\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9db-200d-2642-fe0f":{"1f3fb":["1f9db-1f3fb-200d-2642-fe0f",55,6,["\uD83E\uDDDB\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9db-1f3fc-200d-2642-fe0f",55,7,["\uD83E\uDDDB\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9db-1f3fd-200d-2642-fe0f",55,8,["\uD83E\uDDDB\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9db-1f3fe-200d-2642-fe0f",55,9,["\uD83E\uDDDB\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9db-1f3ff-200d-2642-fe0f",55,10,["\uD83E\uDDDB\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9db":{"1f3fb":["1f9db-1f3fb",55,12,["\uD83E\uDDDB\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9db-1f3fc",55,13,["\uD83E\uDDDB\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9db-1f3fd",55,14,["\uD83E\uDDDB\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9db-1f3fe",55,15,["\uD83E\uDDDB\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9db-1f3ff",55,16,["\uD83E\uDDDB\uD83C\uDFFF"],"5.0"]},
    "1f9dc-200d-2640-fe0f":{"1f3fb":["1f9dc-1f3fb-200d-2640-fe0f",55,18,["\uD83E\uDDDC\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9dc-1f3fc-200d-2640-fe0f",55,19,["\uD83E\uDDDC\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9dc-1f3fd-200d-2640-fe0f",55,20,["\uD83E\uDDDC\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9dc-1f3fe-200d-2640-fe0f",55,21,["\uD83E\uDDDC\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9dc-1f3ff-200d-2640-fe0f",55,22,["\uD83E\uDDDC\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9dc-200d-2642-fe0f":{"1f3fb":["1f9dc-1f3fb-200d-2642-fe0f",55,24,["\uD83E\uDDDC\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9dc-1f3fc-200d-2642-fe0f",55,25,["\uD83E\uDDDC\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9dc-1f3fd-200d-2642-fe0f",55,26,["\uD83E\uDDDC\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9dc-1f3fe-200d-2642-fe0f",55,27,["\uD83E\uDDDC\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9dc-1f3ff-200d-2642-fe0f",55,28,["\uD83E\uDDDC\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9dc":{"1f3fb":["1f9dc-1f3fb",55,30,["\uD83E\uDDDC\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9dc-1f3fc",55,31,["\uD83E\uDDDC\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9dc-1f3fd",55,32,["\uD83E\uDDDC\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9dc-1f3fe",55,33,["\uD83E\uDDDC\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9dc-1f3ff",55,34,["\uD83E\uDDDC\uD83C\uDFFF"],"5.0"]},
    "1f9dd-200d-2640-fe0f":{"1f3fb":["1f9dd-1f3fb-200d-2640-fe0f",55,36,["\uD83E\uDDDD\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9dd-1f3fc-200d-2640-fe0f",55,37,["\uD83E\uDDDD\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9dd-1f3fd-200d-2640-fe0f",55,38,["\uD83E\uDDDD\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9dd-1f3fe-200d-2640-fe0f",55,39,["\uD83E\uDDDD\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9dd-1f3ff-200d-2640-fe0f",55,40,["\uD83E\uDDDD\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9dd-200d-2642-fe0f":{"1f3fb":["1f9dd-1f3fb-200d-2642-fe0f",55,42,["\uD83E\uDDDD\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9dd-1f3fc-200d-2642-fe0f",55,43,["\uD83E\uDDDD\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9dd-1f3fd-200d-2642-fe0f",55,44,["\uD83E\uDDDD\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9dd-1f3fe-200d-2642-fe0f",55,45,["\uD83E\uDDDD\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9dd-1f3ff-200d-2642-fe0f",55,46,["\uD83E\uDDDD\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9dd":{"1f3fb":["1f9dd-1f3fb",55,48,["\uD83E\uDDDD\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9dd-1f3fc",55,49,["\uD83E\uDDDD\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9dd-1f3fd",55,50,["\uD83E\uDDDD\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9dd-1f3fe",55,51,["\uD83E\uDDDD\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9dd-1f3ff",55,52,["\uD83E\uDDDD\uD83C\uDFFF"],"5.0"]},
    "1fac3":{"1f3fb":["1fac3-1f3fb",57,43,["\uD83E\uDEC3\uD83C\uDFFB"],"14.0"],"1f3fc":["1fac3-1f3fc",57,44,["\uD83E\uDEC3\uD83C\uDFFC"],"14.0"],"1f3fd":["1fac3-1f3fd",57,45,["\uD83E\uDEC3\uD83C\uDFFD"],"14.0"],"1f3fe":["1fac3-1f3fe",57,46,["\uD83E\uDEC3\uD83C\uDFFE"],"14.0"],"1f3ff":["1fac3-1f3ff",57,47,["\uD83E\uDEC3\uD83C\uDFFF"],"14.0"]},
    "1fac4":{"1f3fb":["1fac4-1f3fb",57,49,["\uD83E\uDEC4\uD83C\uDFFB"],"14.0"],"1f3fc":["1fac4-1f3fc",57,50,["\uD83E\uDEC4\uD83C\uDFFC"],"14.0"],"1f3fd":["1fac4-1f3fd",57,51,["\uD83E\uDEC4\uD83C\uDFFD"],"14.0"],"1f3fe":["1fac4-1f3fe",57,52,["\uD83E\uDEC4\uD83C\uDFFE"],"14.0"],"1f3ff":["1fac4-1f3ff",57,53,["\uD83E\uDEC4\uD83C\uDFFF"],"14.0"]},
    "1fac5":{"1f3fb":["1fac5-1f3fb",57,55,["\uD83E\uDEC5\uD83C\uDFFB"],"14.0"],"1f3fc":["1fac5-1f3fc",57,56,["\uD83E\uDEC5\uD83C\uDFFC"],"14.0"],"1f3fd":["1fac5-1f3fd",57,57,["\uD83E\uDEC5\uD83C\uDFFD"],"14.0"],"1f3fe":["1fac5-1f3fe",57,58,["\uD83E\uDEC5\uD83C\uDFFE"],"14.0"],"1f3ff":["1fac5-1f3ff",57,59,["\uD83E\uDEC5\uD83C\uDFFF"],"14.0"]},
    "1faf0":{"1f3fb":["1faf0-1f3fb",58,29,["\uD83E\uDEF0\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf0-1f3fc",58,30,["\uD83E\uDEF0\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf0-1f3fd",58,31,["\uD83E\uDEF0\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf0-1f3fe",58,32,["\uD83E\uDEF0\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf0-1f3ff",58,33,["\uD83E\uDEF0\uD83C\uDFFF"],"14.0"]},
    "1faf1":{"1f3fb":["1faf1-1f3fb",58,35,["\uD83E\uDEF1\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf1-1f3fc",58,36,["\uD83E\uDEF1\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf1-1f3fd",58,37,["\uD83E\uDEF1\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf1-1f3fe",58,38,["\uD83E\uDEF1\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf1-1f3ff",58,39,["\uD83E\uDEF1\uD83C\uDFFF"],"14.0"]},
    "1faf2":{"1f3fb":["1faf2-1f3fb",58,41,["\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf2-1f3fc",58,42,["\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf2-1f3fd",58,43,["\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf2-1f3fe",58,44,["\uD83E\uDEF2\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf2-1f3ff",58,45,["\uD83E\uDEF2\uD83C\uDFFF"],"14.0"]},
    "1faf3":{"1f3fb":["1faf3-1f3fb",58,47,["\uD83E\uDEF3\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf3-1f3fc",58,48,["\uD83E\uDEF3\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf3-1f3fd",58,49,["\uD83E\uDEF3\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf3-1f3fe",58,50,["\uD83E\uDEF3\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf3-1f3ff",58,51,["\uD83E\uDEF3\uD83C\uDFFF"],"14.0"]},
    "1faf4":{"1f3fb":["1faf4-1f3fb",58,53,["\uD83E\uDEF4\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf4-1f3fc",58,54,["\uD83E\uDEF4\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf4-1f3fd",58,55,["\uD83E\uDEF4\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf4-1f3fe",58,56,["\uD83E\uDEF4\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf4-1f3ff",58,57,["\uD83E\uDEF4\uD83C\uDFFF"],"14.0"]},
    "1faf5":{"1f3fb":["1faf5-1f3fb",58,59,["\uD83E\uDEF5\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf5-1f3fc",58,60,["\uD83E\uDEF5\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf5-1f3fd",58,61,["\uD83E\uDEF5\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf5-1f3fe",58,62,["\uD83E\uDEF5\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf5-1f3ff",59,0,["\uD83E\uDEF5\uD83C\uDFFF"],"14.0"]},
    "1faf6":{"1f3fb":["1faf6-1f3fb",59,2,["\uD83E\uDEF6\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf6-1f3fc",59,3,["\uD83E\uDEF6\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf6-1f3fd",59,4,["\uD83E\uDEF6\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf6-1f3fe",59,5,["\uD83E\uDEF6\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf6-1f3ff",59,6,["\uD83E\uDEF6\uD83C\uDFFF"],"14.0"]},
    "1faf7":{"1f3fb":["1faf7-1f3fb",59,8,["\uD83E\uDEF7\uD83C\uDFFB"],"15.0"],"1f3fc":["1faf7-1f3fc",59,9,["\uD83E\uDEF7\uD83C\uDFFC"],"15.0"],"1f3fd":["1faf7-1f3fd",59,10,["\uD83E\uDEF7\uD83C\uDFFD"],"15.0"],"1f3fe":["1faf7-1f3fe",59,11,["\uD83E\uDEF7\uD83C\uDFFE"],"15.0"],"1f3ff":["1faf7-1f3ff",59,12,["\uD83E\uDEF7\uD83C\uDFFF"],"15.0"]},
    "1faf8":{"1f3fb":["1faf8-1f3fb",59,14,["\uD83E\uDEF8\uD83C\uDFFB"],"15.0"],"1f3fc":["1faf8-1f3fc",59,15,["\uD83E\uDEF8\uD83C\uDFFC"],"15.0"],"1f3fd":["1faf8-1f3fd",59,16,["\uD83E\uDEF8\uD83C\uDFFD"],"15.0"],"1f3fe":["1faf8-1f3fe",59,17,["\uD83E\uDEF8\uD83C\uDFFE"],"15.0"],"1f3ff":["1faf8-1f3ff",59,18,["\uD83E\uDEF8\uD83C\uDFFF"],"15.0"]},
    "261d-fe0f":{"1f3fb":["261d-1f3fb",60,6,["\u261D\uD83C\uDFFB"],"1.0"],"1f3fc":["261d-1f3fc",60,7,["\u261D\uD83C\uDFFC"],"1.0"],"1f3fd":["261d-1f3fd",60,8,["\u261D\uD83C\uDFFD"],"1.0"],"1f3fe":["261d-1f3fe",60,9,["\u261D\uD83C\uDFFE"],"1.0"],"1f3ff":["261d-1f3ff",60,10,["\u261D\uD83C\uDFFF"],"1.0"]},
    "26f9-fe0f-200d-2640-fe0f":{"1f3fb":["26f9-1f3fb-200d-2640-fe0f",61,19,["\u26F9\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["26f9-1f3fc-200d-2640-fe0f",61,20,["\u26F9\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["26f9-1f3fd-200d-2640-fe0f",61,21,["\u26F9\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["26f9-1f3fe-200d-2640-fe0f",61,22,["\u26F9\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["26f9-1f3ff-200d-2640-fe0f",61,23,["\u26F9\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "26f9-fe0f-200d-2642-fe0f":{"1f3fb":["26f9-1f3fb-200d-2642-fe0f",61,25,["\u26F9\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["26f9-1f3fc-200d-2642-fe0f",61,26,["\u26F9\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["26f9-1f3fd-200d-2642-fe0f",61,27,["\u26F9\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["26f9-1f3fe-200d-2642-fe0f",61,28,["\u26F9\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["26f9-1f3ff-200d-2642-fe0f",61,29,["\u26F9\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "26f9-fe0f":{"1f3fb":["26f9-1f3fb",61,31,["\u26F9\uD83C\uDFFB"],"2.0"],"1f3fc":["26f9-1f3fc",61,32,["\u26F9\uD83C\uDFFC"],"2.0"],"1f3fd":["26f9-1f3fd",61,33,["\u26F9\uD83C\uDFFD"],"2.0"],"1f3fe":["26f9-1f3fe",61,34,["\u26F9\uD83C\uDFFE"],"2.0"],"1f3ff":["26f9-1f3ff",61,35,["\u26F9\uD83C\uDFFF"],"2.0"]},
    "270a":{"1f3fb":["270a-1f3fb",61,43,["\u270A\uD83C\uDFFB"],"1.0"],"1f3fc":["270a-1f3fc",61,44,["\u270A\uD83C\uDFFC"],"1.0"],"1f3fd":["270a-1f3fd",61,45,["\u270A\uD83C\uDFFD"],"1.0"],"1f3fe":["270a-1f3fe",61,46,["\u270A\uD83C\uDFFE"],"1.0"],"1f3ff":["270a-1f3ff",61,47,["\u270A\uD83C\uDFFF"],"1.0"]},
    "270b":{"1f3fb":["270b-1f3fb",61,49,["\u270B\uD83C\uDFFB"],"1.0"],"1f3fc":["270b-1f3fc",61,50,["\u270B\uD83C\uDFFC"],"1.0"],"1f3fd":["270b-1f3fd",61,51,["\u270B\uD83C\uDFFD"],"1.0"],"1f3fe":["270b-1f3fe",61,52,["\u270B\uD83C\uDFFE"],"1.0"],"1f3ff":["270b-1f3ff",61,53,["\u270B\uD83C\uDFFF"],"1.0"]},
    "270c-fe0f":{"1f3fb":["270c-1f3fb",61,55,["\u270C\uD83C\uDFFB"],"1.0"],"1f3fc":["270c-1f3fc",61,56,["\u270C\uD83C\uDFFC"],"1.0"],"1f3fd":["270c-1f3fd",61,57,["\u270C\uD83C\uDFFD"],"1.0"],"1f3fe":["270c-1f3fe",61,58,["\u270C\uD83C\uDFFE"],"1.0"],"1f3ff":["270c-1f3ff",61,59,["\u270C\uD83C\uDFFF"],"1.0"]},
    "270d-fe0f":{"1f3fb":["270d-1f3fb",61,61,["\u270D\uD83C\uDFFB"],"1.0"],"1f3fc":["270d-1f3fc",61,62,["\u270D\uD83C\uDFFC"],"1.0"],"1f3fd":["270d-1f3fd",62,0,["\u270D\uD83C\uDFFD"],"1.0"],"1f3fe":["270d-1f3fe",62,1,["\u270D\uD83C\uDFFE"],"1.0"],"1f3ff":["270d-1f3ff",62,2,["\u270D\uD83C\uDFFF"],"1.0"]}
};

/***/ }),

/***/ "8SYU":
/***/ (function(module, exports, __webpack_require__) {

var FileWrapper = __webpack_require__("JHsc");
var FileInlineView = __webpack_require__("G5kp");

var FileTreeView = Backbone.View.extend({
    initialize: function (options) {
        this.tree = options.fileTree;
        this.session = options.session;
        this.files = [];
        this.fileViews = {};
        this.uploadPromises = {};
        this.uploadProgress = {};

        this.treeRender = this.renderFullTree();
    },
    uploadFiles: function () {
        _.each(this.files, function (file) {
            var uploaded = file.upload();
            this.uploadPromises[file.getUploadId()] = uploaded;
        }, this);
        return this.uploadPromises;
    },
    cancelUpload: function () {
        _.each(this.files, function (file) {
            file.cancelUpload();
        }, this);
    },
    removeFile: function (fileView) {
        var file = fileView.model;
        this.files = _.without(this.files, file);
        delete this.fileViews[file.getUploadId()];
        delete this.uploadPromises[file.getUploadId()];
        delete this.uploadProgress[file.getUploadId()];
        fileView.remove();
    },
    dummyMessage: function (options) {
        options = options || {};
        var dummyMessage = _.map(this.files, function (file) {
            return file.dummyUrl();
        }, this).join(' ');
        if (options.message) {
            dummyMessage = options.message + ' ' + dummyMessage;
        }
        return dummyMessage;
    },
    renderLocalInlinePreview: function (buffer, options) {
        var extraHtml = $('<span>');

        var previewsToLoad = this.files.length;
        var previewsLoaded = new $.Deferred();
        previewsLoaded.progress(function () {
            previewsToLoad--;
            if (!previewsToLoad) {
                previewsLoaded.resolve(extraHtml);
            }
        });
        _.each(this.files, function (file) {
            var inlineView = this.fileViews[file.getUploadId()];
            var promise = this.uploadPromises[file.getUploadId()];
            var progress = inlineView.renderLocalInlineProgress(promise, options);
            var wrap = $('<span class="fileProgress">');
            wrap.append(progress);
            var el = $('<span class="fileWrap">');
            inlineView.setElement(el);
            extraHtml.append(el.append(wrap));
            this.uploadProgress[file.getUploadId()] = progress;

            if (options.filenames) {
                file.desiredFilename = options.filenames['name[' + file.getUploadId() + ']'];
            }

            inlineView.renderLocalInlinePreview().done(function (preview) {
                wrap.append(preview);
                previewsLoaded.notify();
            });
            file.setReqId(buffer, options.reqid);
        }, this);
        return previewsLoaded.promise();
    },
    finaliseFiles: function (options) {
        var filesToProcess = this.files.length;
        var allProcessed = new $.Deferred();
        allProcessed.progress(_.bind(function (file) {
            filesToProcess--;
            if (!filesToProcess) {
                allProcessed.resolve();
            }
        }, this));
        _.each(this.files, function (file) {
            file.triggerBubble('uploadConfirmed');
            var uploaded = this.uploadPromises[file.getUploadId()];
            uploaded.done(function (uploadResponse) {
                file.finalise(options, function (finaliseResponse) {
                    allProcessed.notify(file);
                });
            }).fail(function (errorString, errorResponse) {
                allProcessed.notify(file, errorString, errorResponse);
            });
        }, this);
        return allProcessed.promise();
    },
    processFinalised: function () {
        var finalisedFiles = [];
        _.each(this.files, function (file) {
            if (file.isUploaded()) {
                finalisedFiles.push(file);
            } else {
                var progress = this.uploadProgress[file.getUploadId()];
                if (progress) {
                    progress.removeClass('busy');
                    progress.css('height', 0);
                }
            }
        }, this);
        return finalisedFiles;
    },
    renderFullTree: function () {
        var root = $('<ul class="root">');
        _.each(this.tree, function (node) {
            this.renderTree(node, root);
        }, this);
        root.on('change', 'input[type=checkbox]', _.bind(function (e) {
            this.files = _.map(root.find('input.uploadPreviewName:not([disabled])'), function (input) {
                return $(input).data('file');
            });
        }, this));
        return root;
    },
    renderTree: function (node, list, depth) {
        depth = depth || 0;
        var nodeItem = $('<li class="form">');
        if (node.dir) {
            if (!node.children.length) {
                return false;
            }
            var newList = $('<ul>');
            var children = false;
            _.each(node.children, function (child) {
                if (this.renderTree(child, newList, depth + 1)) { 
                    children = true;
                }
            }, this);
            if (children) {
                var dirIcon = $('<span class="dirIcon">')
                    .append('<span class="dirIconTab">')
                    .append('<span class="dirIconBody">');
                nodeItem.append($('<p class="directory">').text(node.dir).prepend(dirIcon));
                nodeItem.append(newList);
            }
        } else {
            var fw = FileWrapper.fromFile(node, this.session);
            fw.setUploadId();
            var fv = new FileInlineView({
                model: fw
            });
            var previewContainer = $('<span class="treePreview">');
            fv.renderLocalPreview().done(function (preview) {
                previewContainer.append(preview);
                if (fw.isPreviewable()) {
                    var img = preview.find('img');
                    var width = img.width();
                    var height = img.height();
                    img.css({
                        marginTop: -height/2,
                        marginLeft: -width/2
                    }).addClass('rendered');
                }
            });

            var checkbox = $('<input type="checkbox" tabindex="-1">');

            var info = $('<span class="info explanation">');
            var type = fw.getType();
            if (type) {
                type += ' • ';
            }
            info.text(type + fw.getSize());

            var name;
            if (fw.isTooLarge()) {
                nodeItem.addClass('disabled tooLarge');
                checkbox.prop('disabled', true);
                name = $('<span class="name">').text(fw.getName());
            } else {
                var idAttr = 'uploadPreviewName' + fw.getUploadId();
                var nameAttr = 'name[' + fw.getUploadId() + ']';
                name = $('<input class="input uploadPreviewName">').attr({
                    'id': idAttr,
                    name: nameAttr
                }).data('file', fw).css('width', FileTreeView.MAX_INPUT_WIDTH-(FileTreeView.DEPTH_PAD*depth));
                name.val(fw.getName());
                checkbox.prop('checked', true);
                checkbox.on('change', function () {
                    var checked = checkbox.is(':checked');
                    name.prop('disabled', !checked);
                    nodeItem.toggleClass('disabled', !checked);
                });
                previewContainer.on('click', function () {
                    checkbox.prop('checked', !checkbox.is(':checked')).change();
                });
                this.files.push(fw);
                this.fileViews[fw.getUploadId()] = fv;
            }

            nodeItem
                .append(previewContainer)
                .append(checkbox)
                .append(' ')
                .append(name)
                .append(' ')
                .append(info);
        }
        list.append(nodeItem);
        return true;
    }
}, {
    // Sync with css
    MAX_INPUT_WIDTH: 475,
    DEPTH_PAD: 16
});

module.exports = FileTreeView;


/***/ }),

/***/ "99PH":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");

var scriptjs = __webpack_require__("zhAq");

var EmailBounceView = DialogView.extend({
    el: '.emailBounce',
    initialize: function (options) {
        this.email = this.$('.emailBounce__email');
        this.reason = this.$('.emailBounce__reason');
        this.time = this.$('.emailBounce__time');
        this.details = this.$('.emailBounce__details');

        this.listenTo(this.model, 'change:email', this.emailChange);

        DialogView.prototype.initialize.apply(this, arguments);
    },

    emailChange: function () {
        this.checkPostmarkRebound();
    },
    loadPostmarkRebound: function () {
        // https://postmarkapp.com/rebound
        window.ReboundSettings = {
            publicToken: window.IRCConfig.postmark_rebound_public_key,
            email: this.model.get('email'),
            appearance: "custom",
            // Set unused options to 0 to minimise network traffic
            actionUrl: 0,
            actionLabel: 0,
            description: 0,
            title: 0,
            position: 0,
            color: 0,
            repeat: 0,
            complete: _.bind(this.postmarkReboundComplete, this),
        };
        if (this._loadPostmarkRebound) {
            return false;
        }
        this._loadPostmarkRebound = true;
        scriptjs([
            "https://rebound.postmarkapp.com/widget/1.0"
        ], function () {
            if (window.Rebound) {
                scriptjs.done('rebound');
            }
        });
        return true;
    },
    checkPostmarkRebound: function () {
        if (!this.loadPostmarkRebound()) {
            scriptjs.ready('rebound', _.bind(function () {
                window.Rebound.check(window.ReboundSettings);
            }, this));
        }
    },
    postmarkReboundComplete: function (response) {
        if (response.inactive) {
            this.email.text(response.data.email);
            this.reason.text(response.data.reason);
            this.time.text(response.data.time);
            this.details.text(response.data.details);
            this.show();
        }
    }
});


module.exports = EmailBounceView;


/***/ }),

/***/ "9PKk":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");


var BufferNickView = Backbone.View.extend({
    tagName: 'span',
    className: 'buffernick',
    initialize: function (options) {
        this.buffer = options.buffer || this.model;

        this.listenTo(this.buffer.getUser(), 'change:nick', this.render);
        this.listenTo(this.buffer.getUser(), 'change:display_name', this.render);
        this.listenTo(this.buffer.getUser(), 'change:away', this.render);
        this.listenTo(this.buffer.getUser(), 'change:avatar', this.render);
        this.listenTo(this.buffer.getUser(), 'change:mode', this.render);
        this.listenTo(this.buffer.getUser(), 'change:avatar_url', this.render);
        this.listenTo(this.buffer.getUser(), 'change:avatars_supported', this.render);
        this.listenTo(this.buffer.getUser(), 'change:ircserver', this.render);
        this.listenTo(this.buffer.getUser(), 'change:hostname', this.render);
        this.listenTo(this.buffer.getUser(), 'change:usermask', this.render);
        this.listenTo(this.buffer.getUser(), 'change:account', this.render);

        this.listenTo(this.model.session, 'change:avatar', this.render);
        this.listenTo(this.model.session, 'change:avatar_url', this.render);

        this.buffer.bind('change:avatar', this.render, this);
        this.buffer.bind('change:avatar_url', this.render, this);
        this.buffer.bind('prefChange:inlineimages', this.render, this);
        this.buffer.bind('prefChange:avatars-off', this.render, this);
        this.buffer.bind('prefChange:avatars-image-off', this.render, this);
        this.buffer.bind('activeChange', this.render, this);
        this.buffer.bind('remove', this.remove, this);
        this.formatter = new BufferFormatter(this.buffer);
    },
    events: {
        'click .nick': 'click',
        'click .avatar': 'clickAvatar',
        'click .avatar-upload-prompt__dismiss': 'clickAvatarPromptDismiss',
        'click .avatar-upload-prompt': 'clickAvatar'
    },
    click: function (e) {
        this.model.connection.trigger('nickPrompt');
        return false;
    },
    clickAvatarPromptDismiss: function (e) {
        this.model.connection.setPromptAvatarPref(false);
        return false;
    },
    clickAvatar: function (e) {
        if (!this.model.connection.avatarUploadsSupported()) {
            return;
        }
        var props = {};
        var org = this.model.connection.getOrg();
        var model = this.model.connection;
        if (!this.model.connection.nativeAvatarUploadsSupported()) {
            props.is_primary = true;
            model = this.model.session;
        } else if (org) {
            props.org = org.id;
        } else {
            props.cid = this.model.connection.id;
        }
        this.model.session.trigger('avatarPrompt', model, {
            properties: props
        });
        return false;
    },
    render: function () {
        var user = this.buffer.getUser();
        var userHtml = '';
        var fallback = false;
        var delayFallback = false;
        var external = false;
        var avatar;
        if (this.buffer.imageAvatarsEnabled()) {
            avatar = user.getAvatar({
                buffer: this.buffer
            });
        }
        if (avatar) {
            if (avatar.guess) {
                var sessionAvatar = this.model.session.getUser().getAvatar({strict: true});
                if (sessionAvatar) {
                    avatar = sessionAvatar;
                }
            }
            fallback = true;
            if (!avatar.guess) {
                delayFallback = true;
            }
            external = avatar.external;
            userHtml += this.formatter.imageAvatar(avatar.src, true, {
                size: 24,
                external: external
            });
        }
        var letterOpts = {
            fallback: fallback,
            name: user.getDisplayAuthor(),
            delayFallback: delayFallback,
            external: external
        };
        if (this.model.connection.avatarUploadsSupported()) {
            letterOpts.title = 'Choose an avatar';
            userHtml += this.formatter.avatar(user.get('nick'), true, letterOpts);
            userHtml += '<button class="action avatar-upload-prompt"><span>';
            userHtml += 'Choose an avatar';
            userHtml += '<i class="fa fa-close avatar-upload-prompt__dismiss"></i>';
            userHtml += '</span></button>';
        } else {
            userHtml += this.formatter.avatar(user.get('nick'), true, letterOpts);
        }

        userHtml += this.formatter.linkUserMode(user, {
            className: 'nick'
        });
        $(this.el).html(userHtml);
        return this;
    }
});


module.exports = BufferNickView;


/***/ }),

/***/ "9cM4":
/***/ (function(module, exports, __webpack_require__) {

var browser = __webpack_require__("2ZbG");
var IRCFormatter = __webpack_require__("XiBv");

var not = window.Notification;
// We need to store these so they don't get garbage collected and lose their event handlers
var notStore = {};
var notIds = 0;

var macgap = window.macgap;

// https://notifications.spec.whatwg.org/
function notifier (session) {
    this.session = session;
}

notifier.supported = !!(not || macgap);
notifier.shouldRequest = function () {
    if (macgap) {
        // Notifications always allowed without permissions
        return false;
    } else if (not) {
        // Request if no decision has yet been made
        return not.permission === 'default';
    } else {
        // Notifications not supported
        return false;
    }
};
notifier.allowed = function () {
    if (macgap) {
        // Notifications always allowed without permissions
        return true;
    } else if (not) {
        // Check if explicitly granted
        return not.permission === 'granted';
    } else {
        // Notifications not supported
        return false;
    }
};
notifier.requestPermission = function (callback) {
    if (notifier.allowed() || !notifier.supported) {
        return;
    }
    try {
        not.requestPermission(function (permission) {
            callback(permission);
        });
    } catch (exc) {
        debug.warn('Notification.requestPermission', exc);
    }
};

notifier.prototype = {
    notify: function (options) {
        var tag = 'irccloudNotification:' + options.tag;
        var title = options.title;
        var body = options.body;
        var click = options.click || $.noop;
        var close = options.close || $.noop;
        var show = options.show || $.noop;
        var iconSize = '72';
        if (browser.isHighDensity()) {
            iconSize = '144';
        }
        var icon = this.session.getOrigin() + '/static/favicon/favicon-' + iconSize + 'x' + iconSize + '.png';
        if (macgap) {
            // Native notifications
            macgap.notice.notify({
                title: title,
                content: body,
                id: tag,
                sound: false,
                silent: true
            });
        } else if (not) {
            if (!notifier.allowed()) {
                if (notifier.shouldRequest()) {
                    notifier.requestPermission(_.bind(function (permission) {
                        this.session.trigger('notificationPermissionRequested', permission);
                        if (permission === 'granted') {
                            this.notify(options);
                        }
                    }, this));
                }
                return;
            }
            // WebKit/W3C Notifications
            var uid = ++notIds;
            
            var notification;
            if (not) {
                if (this.session.isDesktop() && browser.isLinux()) {
                    // linux desktop spec allows markup in body
                    // https://developer.gnome.org/notification-spec/#markup
                    // Escape it so people can't leak IPs with <img> or spoof links
                    // This is probably better fixed by electron checking for
                    // 'body-markup' in the notify-osd server caps/info
                    body = IRCFormatter.escapeHtmlLinuxNotification(body);
                }
                var notOptions = {
                    body: body,
                    tag: tag,
                    silent: true
                };
                if (options.image) {
                    notOptions.icon = options.image;
                } else if (!this.session.isDesktop()) {
                    notOptions.icon = icon;
                }
                notification = new not(title, notOptions);
                // For debug tracking
                notification.irccloud_uid = uid;
                // Chrome doesn't recognise these when set in options
                // Safari doesn't call them at all seemingly
                notification.onclick = _.bind(function (event) {
                    this.session.trigger('notificationClick');
                    click(notification);
                }, this);
                notification.onclose = function (event) {
                    delete notStore[uid];
                    close(notification);
                };
                notification.onshow = function (event) {
                    notStore[uid] = notification;
                    show(notification);
                };
                // Call manually to track notification for Safari
                notification.onshow();
                setTimeout(function () {
                    notification.close();
                    // Call this manually for Safari
                    notification.onclose();
                }, 5000);
            }
            
            return;
        
        }
        return;
    }
};

module.exports = notifier;


/***/ }),

/***/ "9gHr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _upgradeDefines = __webpack_require__("a4TI");

var _upgradeDefines2 = _interopRequireDefault(_upgradeDefines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    events: {
        'buttonClick .upgradePayment__cancel-card': 'onCardCancel'
    },
    onCardCancel: function onCardCancel(e) {
        e.preventDefault();
        this.doCardCancel();
    },
    doCardCancel: function doCardCancel() {
        this.clearState('card', 'card_method', 'card_data', 'card_error');
    },
    onCardSuccess: function onCardSuccess(response) {
        this.setInitialState();
    },
    onCardError: function onCardError(response) {
        var html = this.upgrade.formatStripeError(response);
        this.extendState({
            card: 'idle',
            card_method: [this.getPaymentCards()],
            card_error: html,
            card_data: null
        });
    },
    afterPay: function afterPay(response) {
        if (response.success) {
            this.onCardSuccess(response);
        } else {
            this.onCardError(response);
        }
    },

    paymentHandlers: {
        card: function card() {
            var _this = this;

            this.extendState({
                card: 'waiting',
                card_error: null
            });
            var afterStripe = function afterStripe(data) {
                if (data) {
                    _this.extendState({
                        card: 'progress',
                        card_data: data
                    });
                } else {
                    _this.doCardCancel();
                }
            };
            switch (this.state.chosen) {
                case _upgradeDefines2.default.SCHEDULE_MONTHLY_RECURRING:
                    this.upgrade.subscribeMonthly(afterStripe);
                    break;
                case _upgradeDefines2.default.SCHEDULE_ANNUAL_ONEOFF:
                    this.upgrade.subscribeYearly(false, afterStripe);
                    break;
                case _upgradeDefines2.default.SCHEDULE_ANNUAL_RECURRING:
                    this.upgrade.subscribeYearly(true, afterStripe);
                    break;
            }
        }
    },
    getPaymentCards: function getPaymentCards() {
        return {
            button: 'Pay with a card',
            methods: [{
                img: '/static/cards/american-express-curved-32px.png',
                label: 'American Express',
                width: 51,
                height: 32
            }, {
                img: '/static/cards/mastercard-curved-32px.png',
                label: 'MasterCard',
                width: 51,
                height: 32
            }, {
                img: '/static/cards/visa-curved-32px.png',
                alt: 'Visa',
                width: 51,
                height: 32
            }],
            value: 'card'
        };
    }
};

/***/ }),

/***/ "9iIa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9lob":
/***/ (function(module, exports, __webpack_require__) {

var ChatterBarView = __webpack_require__("hKI7");


var UpperChatterBarView = ChatterBarView.extend({
    buttonText: '↑',
    buttonTitle: 'Scroll to last read',
    className: ChatterBarView.prototype.className + ' bufferAboveExtras',
    render: function () {
        var dismiss = $('<span class="extrasDismiss bufferAboveExtrasDismiss">')
            .text('Mark as read (Esc)');
        $(this.el).append(dismiss);
        
        ChatterBarView.prototype.render.apply(this, arguments);
        
        return this;
    },
    update: function (upperMessage) {
        if (!upperMessage) {
            return null;
        }
        
        if (this.model.isMessageUnseen(upperMessage)) {
            // Clear highlights from upper visible till the bottom seen message
            var remainder = this.model.clearUnseenHighlightsAfter(upperMessage);
            this.renderMentions(remainder);

            if (this.model.getLastSeen()) {
                // Gets the difference between the upper visible and last seen message
                var seenMessage = this.model.getLastSeenMessage();
                var linesAgo;
                if (seenMessage) {
                    if (this.model.countMessagesBetween(seenMessage, upperMessage) > 100) {
                        linesAgo = true;
                    } else {
                        linesAgo = this.model.countImportantMessagesBetween(seenMessage, upperMessage);
                    }
                } else {
                    linesAgo = true; // undefined number of messages
                }
                // Render the chatter bar if there unseen important messages
                if (linesAgo) {
                    this.renderChatter(this.model.getLastSeenDate(), linesAgo);
                    return true;
                }
            }
        }
        // Last seen is later than upper message, or no unseen important messages, hide
        this.hide();
        return false;
    }
});


module.exports = UpperChatterBarView;


/***/ }),

/***/ "BVYZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _upgradeDefines = __webpack_require__("a4TI");

var _upgradeDefines2 = _interopRequireDefault(_upgradeDefines);

var _util = __webpack_require__("GmLC");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    initialize: function initialize(options, upgrade) {},

    events: {
        'buttonClick .upgradePayment__confirm-country-button': 'onPayPalConfirmCountry',
        'buttonClick .upgradePayment__cancel-paypal': 'onPayPalCancel'
    },
    onPayPalCancel: function onPayPalCancel(e) {
        e.preventDefault();
        this.doPayPalCancel();
    },
    onPayPalConfirmCountry: function onPayPalConfirmCountry(e) {
        var _this = this;

        e.preventDefault();
        this.extendState({
            paypal: 'progress',
            paypal_error: null
        });
        var country = $(e.target).data('country');
        this.model.completePayPalSubscription({
            'token': this.state.paypal_response.token,
            'PayerID': this.state.paypal_response.payer_id,
            'type': this.state.paypal_response.type,
            country: country
        }, function (completeResponse) {
            if (completeResponse.success) {
                _this.paypalDone();
            } else {
                _this.setPayPalPayError(completeResponse);
            }
        });
    },
    doPayPalCancel: function doPayPalCancel() {
        this.paypalClosed();
        this.clearState('paypal', 'paypal_method', 'paypal_response', 'paypal_confirm_countries', 'paypal_error');
    },

    paymentHandlers: {
        paypal: function paypal() {
            switch (this.state.chosen) {
                case _upgradeDefines2.default.SCHEDULE_MONTHLY_RECURRING:
                    this.startPaypal();
                    break;
                case _upgradeDefines2.default.SCHEDULE_ANNUAL_ONEOFF:
                    this.startPaypal('oneoff');
                    break;
                case _upgradeDefines2.default.SCHEDULE_ANNUAL_RECURRING:
                    this.startPaypal('yearly');
                    break;
            }
        }
    },
    startPaypal: function startPaypal(type) {
        this.extendState({
            paypal: 'waiting',
            paypal_error: null
        });
        var url = '/chat/subscribe-solo-paypal';
        if (type) {
            url += '?type=' + type;
        }

        var _openPopup = (0, _util.openPopup)(url, 'paypal', {
            closeCallback: _.bind(this.doPayPalCancel, this)
        });

        var _openPopup2 = (0, _slicedToArray3.default)(_openPopup, 2);

        this.popup = _openPopup2[0];
        this.popupWatcher = _openPopup2[1];

        this.popupResponsePromise = this.model.findMessage(_.bind(function (event) {
            if (event.source !== this.popup) {
                return false;
            }
            return event.data;
        }, this)).done(_.bind(function (response) {
            if (response.success) {
                this.paypalSuccess(response);
            } else {
                this.paypalError(response);
            }
        }, this));
    },
    paypalClosed: function paypalClosed() {
        // Popup closes itself after a timeout to allow post messages to arrive
        // but we can close it early if we've received the message.
        if (this.popup && !this.popup.closed) {
            this.popup.close();
        }
        clearInterval(this.popupWatcher);
        if (this.popupResponsePromise && this.popupResponsePromise.cleanup) {
            this.popupResponsePromise.cleanup();
        }
        this.popup = null;
        this.popupWatcher = null;
        this.popupResponsePromise = null;
    },
    paypalSuccess: function paypalSuccess() {
        debug.log('<- [PAYPAL] success');
        this.paypalClosed();
        this.paypalDone();
    },
    paypalError: function paypalError(error) {
        debug.warn('<- [PAYPAL]', error);
        this.paypalClosed();
        this.setPayPalPayError(error);
    },
    setPayPalPayError: function setPayPalPayError(response) {
        var html = void 0;
        switch (response.message) {
            case 'country_mismatch':
                this.setConfirmPaypalCountry(response);
                return;
            case 'request_error':
                html = 'Temporary subscription error, please wait, and contact <a href="mailto:team@irccloud.com">team@irccloud.com</a> if this problem doesn’t resolve itself.';
                break;
            case 'invalid_funding_source':
                html = "The PayPal funding source you chose isn't valid for recurring payments, please try again and choose another source.";
                break;
            case 'payment_declined':
                html = "PayPal has declined this payment attempt";
                break;
            case 'payment_blocked':
                html = "This payment attempt is not accepted";
                break;
            case 'duplicate_payment_attempt':
                html = "This PayPal payment attempt has already succeeded. You have not been double charged";
                break;
            case 'token_expired':
                html = "Your PayPal payment attempt has expired. Please try again, you have not been charged.";
                break;
            case 'no_funding_source':
                html = "You don't have a valid funding source on your PayPal account. We can't accept PayPal balance for recurring payments.";
                break;
            default:
                html = 'PayPal payment failed, try again later';
        }
        this.extendState({
            paypal: 'idle',
            paypal_method: [this.getPaymentPayPal()],
            paypal_error: html
        });
    },
    paypalDone: function paypalDone() {
        this.upgrade.payDone();
        this.setInitialState();
    },
    setConfirmPaypalCountry: function setConfirmPaypalCountry(response) {
        var _this2 = this;

        var seen = {};
        var paypal_confirm_countries = [];
        _.each(response.country_evidence, function (code, key) {
            if (code) {
                var keyMatch = key.match(/(.*)_code$/);
                if (keyMatch && !(code in seen)) {
                    seen[code] = true;
                    var type = keyMatch[1];
                    var name = response.country_evidence[type + '_name'];
                    var label = _this2.upgrade.getCountryEvidenceLabel(type);
                    paypal_confirm_countries.push({
                        type: type,
                        label: label,
                        name: name,
                        code: code
                    });
                }
            }
        });
        this.extendState({
            paypal: 'confirm_country',
            paypal_response: response,
            paypal_confirm_countries: paypal_confirm_countries
        });
    },
    getPaymentPayPal: function getPaymentPayPal() {
        return {
            button: 'Pay with PayPal',
            methods: [{
                img: '/static/cards/paypal-curved-32px.png',
                alt: 'PayPal',
                width: 51,
                height: 32
            }],
            value: 'paypal',
            img: '/static/PP_logo_h_100x26.png',
            alt: 'PayPal',
            width: 100,
            height: 26
        };
    }
};

/***/ }),

/***/ "C3KD":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var Message = __webpack_require__("j9Sh");
var Overlay = __webpack_require__("jcM0");
var Whois = __webpack_require__("Jvek");
var sko = __webpack_require__("pyif").default;
var twitch = __webpack_require__("/7tV");
var utils = __webpack_require__("GmLC");


var BufferOverlayHandler = Backbone.View.extend({
    initialize: function (options) {
        this.bindMessageHandlers();
        
        this.formatter = new BufferFormatter(this.model);
        this.model.on('remove', this.remove, this);
    },
    bindMessageHandlers: function () {
        var lastMesage = this.model.getLastMessage();
        this.max_rendered = lastMesage && lastMesage.id || 0;
        for (var type in this.messages) {
            this.model.bind('message:' + type, this.handleMessage, this);
        }
        this.model.bind('twitchRoomsOverlay', this.twitchRooms, this);
    },
    twitchRooms: function (rooms) {
        var displayName = this.model.getDisplayName();
        var title;
        var twitchInfo = this.model.getTwitchInfo();
        if (twitchInfo && twitchInfo.channel.display_name) {
            title = this.formatter.escapeText(twitchInfo.channel.display_name);
        } else {
            title = this.formatter.render(displayName);
        }
        var headers;
        if (rooms.length) {
            headers = [{
                title: 'Name',
                format: _.bind(function (data) {
                    return this.formatter.linkChannel(
                        twitch.roomChannel(data.owner_id, data._id),
                        {name: data.name}
                    );
                }, this)
            }, {
                title: 'Topic',
                name: 'topic'
            }, {
                title: 'Type',
                format: _.bind(function (data) {
                    return this.formatter.escapeText(twitch.roomType(data));
                }, this)
            }];
        }
        var overlay = new Overlay(this.buildTable(
            {type: 'twitchRooms'},
            'Twitch rooms for ' + title,
            rooms,
            headers,
            title + ' hasn’t created any rooms yet'
        ));
        this.triggerAdd(overlay);
    },
    isMessageIgnored: function (message) {
        if (!Message.isIgnorable(message.type)) {
            return false;
        }
        return this.model.connection.isIgnored(message.from || message.nick, message.hostmask);
    },
    handleMessage: function (message) {
        if (!message.eid || message.eid < 0 || message.eid > this.max_rendered) {
            if (this.isMessageIgnored(message)) {
                return;
            }
            var overlay = this.messages[message.type].call(this, message);
            if (overlay) {
                overlay.message = message;
                this.triggerAdd(overlay);
                if (message.eid > 0) {
                    this.max_rendered = message.eid;
                }
            }
        }
    },
    triggerAdd: function (overlay) {
        this.trigger('addOverlay', overlay);
    },
    appendWhoisChannels: function (content, whois, priv) {
        var memberTypes = [{
            key: 'oper',
            title: 'Oper in'
        }, {
            key: 'owner',
            title: 'Owner of'
        }, {
            key: 'admin',
            title: 'Admin in'
        }, {
            key: 'op',
            title: 'Operator in'
        }, {
            key: 'halfop',
            title: 'Halfop in'
        }, {
            key: 'voiced',
            title: 'Voiced in'
        }, {
            key: 'member',
            title: 'Member of'
        }];
        _.each(memberTypes, function (type, i) {
            var channels = whois.getChannels(type.key, priv);
            if (channels && channels.length) {
                content.append($('<p>').text(type.title + ':'));
                var opList = $('<ul>');
                _.each(channels, function (chan, j) {
                    var html = this.formatter.linkChannel(chan.channel);
                    if (chan.prefix) {
                        html += ' <b>' + this.formatter.escapeText(chan.prefix) + '</b>';
                    }
                    opList.append($("<li>").html(html));
                }, this);
                content.append(opList);
            }
        }, this);
    },
    buildTable: function (message, title, data, headers, noDataMessage) {
        var content = $('<div>');
        // Heading
        if (title) {
            var heading = $('<div class="heading">');
            var headingTitle = $('<h2>').html(title);
            heading.append(headingTitle);
            content.append(heading);
        }
        
        // Table
        if (data && data.length) {
            var table = $('<table cellspacing="0" class="overlayTable">');
            var headRow = $('<tr>');
            _.each(headers, function (header, i) {
                var className = 'data_' + message.type;
                if (header.name) {
                    className += '_' + header.name;
                }
                header.className = className;
                headRow.append($('<th>').html(header.title).addClass(header.className));
            }, this);
            var body = $('<tbody>');
            _.each(data, function (item, i) {
                var className = i % 2 ? 'even' : 'odd';
                var dataRow = $('<tr>').addClass(className);
                if (headers) {
                    _.each(headers, function (header, headerI) {
                        var value = false;
                        if (header.format) {
                            // Format function
                            value = header.format(item);
                        } else if (typeof item[header.name] == "boolean") {
                            // Format bool
                            value = '<i class="fa fa-' + (item[header.name] ? 'check' : 'times') + '" title="' + (item[header.name] ? 'Yes' : 'No') + '"></i>';
                        } else if (header.channel && item[header.channel] != '*' && header.channel in item) {
                            // Format channel link
                            value = this.formatter.linkChannel(item[header.channel]);
                        } else if (header.nick && header.nick in item) {
                            // Format nick link
                            value = this.formatter.linkNick(item[header.nick]);
                        } else if (header.mask && header.mask in item) {
                            // Format mask
                            value = this.formatter.renderNoEmoji(item[header.mask]);
                        } else if (header.link && header.link in item) {
                            // Format link
                            value = this.formatter.linkBuffer(item[header.link]);
                        } else if (header.name in item) {
                            // Format anything else
                            value = this.formatter.render(item[header.name]);
                        }
                        if (value !== false) {
                            dataRow.append($('<td>').html(value).addClass(header.className));
                        }
                    }, this);
                } else {
                    var iterator;
                    if (_.isObject(item)) {
                        iterator = item;
                    } else {
                        iterator = $.makeArray(item);
                    }
                    _.each(iterator, function (itemValue) {
                        var value = this.formatter.renderLinkify(itemValue);
                        var className = 'data_' + message.type;
                        dataRow.append($('<td>').html(value).addClass(className));
                    }, this);
                }
                body.append(dataRow);
            }, this);
            table.append($('<thead>').append(headRow))
                .append(body);
            content.append(table);
        } else {
            noDataMessage = noDataMessage || 'No data';
            content.append($('<p class="noData">').html(noDataMessage));
        }
        return content;
    },
    buildIsupportTable: function (params) {
        var table = $('<table cellspacing="0">');
        var body = $('<tbody>');
        var value;
        var objectTable, objectK;
        for (var k in params) {
            switch (typeof params[k]) {
            case "boolean":
                // Format bool
                value = '<i class="fa fa-' + (params[k] ? 'check' : 'times') + '" title="' + (params[k] ? 'Yes' : 'No') + '"></i>';
                break;
            case "string":
                value = this.formatter.escapeText(params[k]);
                break;
            default:
                if ($.isPlainObject(params[k])) {
                    objectTable = $('<table>');
                    for (objectK in params[k]) {
                        objectTable.append(
                            $('<tr>')
                                .append($('<th class="data_isupport_object_key">').text(objectK))
                                .append($('<td>').text(params[k][objectK]))
                        );
                    }
                    value = objectTable;
                } else {
                    value = this.formatter.escapeText(JSON.stringify(params[k]));
                }
            }
            body.append(
                $('<tr>')
                    .append($('<th class="data_isupport_key">').text(k))
                    .append($('<td>').html(value))
            );
        }
        table.append(body);
        return table;
    },
    simple: function (message) {
        return new Overlay(this.formatter.render(message.msg), {
            doneText: 'Close',
        });
    },
    messages: {
        who_response: function (message) {
            var subject;
            if (message.subject == '*') {
                subject = this.formatter.linkConnection();
            } else {
                subject = this.formatter.linkBuffer(message.subject);
            }
            return new Overlay(this.buildTable(message, 'WHO response for ' + subject, message.users, [{
                format: _.bind(function (data) {
                    var className;
                    var title = data.nick;
                    if (data.away) {
                        title += ' (away)';
                        className = 'away';
                    }
                    return this.formatter.linkNick(data.nick, {
                        className: className,
                        title: title
                    });
                }, this),
                title: 'Nickname'
            }, {
                format: _.bind(function (data) {
                    return this.formatter.renderLinkify(data.realname);
                }, this),
                title: 'Real name'
            }, {
                mask: 'usermask',
                title: 'Usermask'
            }, {
                format: _.bind(function (data) {
                    var message = data.ircserver;
                    if (data.hopcount) {
                        message += ' (' + data.hopcount + ' hops)';
                    }
                    return this.formatter.render(message);
                }, this),
                title: 'Connected via'
            }]));
        },
        who_special_response: function (message) {
            var subject;
            if (message.subject == '*') {
                subject = this.formatter.linkConnection();
            } else {
                subject = this.formatter.linkBuffer(message.subject);
            }
            return new Overlay(this.buildTable(message, 'WHO response for ' + subject, message.users));
        },
        whowas_response: function (message) {
            var lines, headers, noDataMessage;
            if (message.lines[0].no_such_nick) {
                lines = [];
                noDataMessage = this.formatter.render(message.lines[0].no_such_nick);
            } else {
                lines = message.lines;
                headers = [{
                    title: 'Nick',
                    nick: 'nick'
                }, {
                    title: 'Usermask',
                    format: _.bind(function (data) {
                        if (data.user && data.host) {
                            return this.formatter.renderNoEmoji(data.user + '@' + data.host);
                        } else {
                            return '';
                        }
                    }, this)
                }, {
                    title: 'Real name',
                    name: 'realname'
                }, {
                    title: 'Last connected',
                    name: 'last_seen'
                }, {
                    title: 'Connected via',
                    name: 'ircserver'
                }];
                if (utils.hasKey(message.lines, 'user_logged_in_as')) {
                    headers.push({
                        title: 'Account',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.user_logged_in_as);
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'connecting_from')) {
                    headers.push({
                        title: 'Info',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.connecting_from);
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'real_host')) {
                    headers.push({
                        title: 'Real Host',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.real_host.replace('was connecting from ', ''));
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'actual_host')) {
                    headers.push({
                        title: 'Actual host',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.actual_host);
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'country')) {
                    headers.push({
                        title: 'Country',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.country.replace('was connecting from ', ''));
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'asn_msg')) {
                    headers.push({
                        title: 'ASN',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.asn_msg.replace('was connecting from ', ''));
                        }, this)
                    });
                }
            }
            var table = this.buildTable(
                message, 'WHOWAS response for ' + this.formatter.linkBuffer(message.nick), lines, headers, noDataMessage
            );
            return new Overlay(table);
        },
        whois_response: function (message) {
            var whois = new Whois(message);
            var nick = whois.get('user_nick') || whois.get('nick');

            var content = $('<div class="whoisInfo irccolors">');

            // Name/real name hostmask
            var nameParts = [];
            if (whois.get('user_realname')) {
                nameParts.push(this.formatter.renderLinkify(whois.get('user_realname')));
            }
            var mask = whois.getHostMask();
            var nameParenParts = [];
            if (mask) {
                nameParenParts.push(this.formatter.renderNoEmoji(mask));
            }
            if (whois.get('actual_host')) {
                nameParenParts.push(this.formatter.renderNoEmoji(whois.get('actual_host')));
            }
            if (nameParenParts.length) {
                nameParts.push('(' + nameParenParts.join(' / ') + ')');
            }
            if (whois.get('user_logged_in_as')) {
                nameParts.push('is authed as ' + this.formatter.renderLinkify(whois.get('user_logged_in_as')));
            }
            if (nameParts.length) {
                var name = nameParts.join(' ');
                content.append($('<p>').html(name));
            }
            
            // Away
            var away = whois.get('away');
            if (away) {
                var awayMsg = 'Away';
                if (away.toLowerCase() != 'away') {
                    awayMsg += ': ' + away;
                }
                content.append($('<p>').html(this.formatter.render(awayMsg)));
            }

            // Signon/idle time
            if (whois.get('signon_time')) {
                var online = "Online " + this.formatter.howLong(whois.getSignonDate(), true);
                if (whois.get('idle_secs')) {
                    online += " (idle " + this.formatter.howLong(whois.getIdleTime(), true) + ")";
                }
                content.append($('<p>').html(online));
            }
            
            // Status
            if (whois.get('bot_msg')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('bot_msg'))));
            }
            if (whois.get('op_nick')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('op_msg'))));
            }
            if (whois.get('opername')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('opername_msg') + ' ' + whois.get('opername'))));
            }
            if (whois.get('userip')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('userip'))));
            }
            // Connected via
            if (whois.get('server_addr')) {
                var server = "is connected via " + this.formatter.render(whois.get('server_addr'));
                if (whois.get('server_extra')) {
                    server += " (" + this.formatter.renderLinkify(whois.get('server_extra')) + ")";
                }
                content.append($('<p>').html(this.formatter.render(nick) + ' ' + server));
            }
            // Connecting from
            if (whois.get('host')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('host'))));
            }

            // Channel lists
            this.appendWhoisChannels(content, whois);

            // Private/secret channels
            if (whois.get('private_channels')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('private_channels'))));
                this.appendWhoisChannels(content, whois, true);
            }
            
            // Secure
            if (whois.get('secure')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('secure'))));
            }
            // CGI:IRC
            if (whois.get('cgi')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('cgi'))));
            }

            // Country
            if (whois.get('country')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('country'))));
            }
            // ASN
            if (whois.get('asn_msg')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('asn_msg'))));
            }
            
            // Client cert
            if (whois.get('client_cert')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('client_cert'))));
            }

            // Available for help
            if (whois.get('help')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('help'))));
            }
            // Staff
            if (whois.get('staff')) {
                content.append($('<p>').html(this.formatter.render(nick + ' is staff: ' + whois.get('staff'))));
            }
            // Special
            if (whois.get('special')) {
                _.each(whois.get('special'), function (specialLine) {
                    content.append($('<p>').html(this.formatter.render(nick + ' ' + specialLine)));
                }, this);
            }
            // Modes
            if (whois.get('modes')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('modes'))));
            }
            // Callerid
            if (whois.get('callerid')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('callerid'))));
            }
            // Stats Dline
            if (whois.get('stats_dline')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('stats_dline'))));
            }
            // BTN metadata
            if (whois.get('btn_metadata')) {
                content.append($('<p>').html(this.formatter.render(nick) + ' ' + this.formatter.renderLinkify(whois.get('btn_metadata'))));
            }
            // Text
            if (whois.get('text')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('text'))));
            }
            // msg_only_reg
            if (whois.get('msg_only_reg')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('msg_only_reg'))));
            }
            // suspend
            if (whois.get('suspend')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('suspend'))));
            }
            // chanop
            if (whois.get('chanop')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('chanop'))));
            }
            // kill
            if (whois.get('kill')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('kill'))));
            }
            // helper
            if (whois.get('helper')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('helper'))));
            }
            // admin
            if (whois.get('admin')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('admin'))));
            }
            // codepage
            if (whois.get('codepage')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('codepage'))));
            }
            var head = "Whois " + this.formatter.linkNick(nick);
            return new Overlay(content, {
                head: head
            });
        },
        text: function (message) {
            return this.simple(message);
        },
        help: function (message) {
            return this.simple(message);
        },
        list_usage: function (message) {
            return this.simple(message);
        },
        stats: function (message) {
            var msg = '';
            if (message.parts) {
                msg += this.formatter.render(message.parts);
                if (message.msg) {
                    msg += ': ';
                }
            }
            if (message.msg) {
                msg += this.formatter.renderLinkify(message.msg);
            }
            return new Overlay(msg, {
                doneText: 'Close',
            });
        },
        ignore_list: function (message) {
            var currentIgnores = new sko();
            if (this.model.session.currentBuffer) {
                this.model.session.currentBuffer.messages.each(function (m) {
                    var ig = m.isIgnored({returnMap: true});
                    if (ig.match) {
                        _.each(ig.masks, function (mask) {
                            currentIgnores.incr(mask);
                        });
                    }
                }, this);
            }
            var table = this.buildTable(message, 'Ignore list for ' + this.formatter.render(this.model.connection.getFullLabel()), message.masks, [{
                format: _.bind(function (mask) {
                    var matches = '';
                    var currentIgnore;
                    if ((currentIgnore = currentIgnores.get(mask))) {
                        matches = ' <span class="explanation">(' + currentIgnore + ' ';
                        matches += this.formatter.pluralise(currentIgnore, 'message');
                        matches += ' matched)</span>';
                    }
                    return this.formatter.linker.make('x', {
                        href: "",
                        'class': 'unignore',
                        'title': 'Unignore ' + mask,
                        'data-mask': mask
                    }) + ' ' + this.formatter.renderNoEmoji(mask) + matches;
                }, this),
                title: 'Usermask'
            }], 'You’re not ignoring anyone at the moment. You can ignore people from a menu by clicking their nickname or by using <kbd>/ignore</kbd>');
            
            var overlay = new Overlay(table);
            
            table.on('click', 'a.unignore', _.bind(function (e) {
                e.preventDefault();
                var link = $(e.currentTarget);
                this.model.connection.unignore(link.attr('data-mask'), _.bind(function (response) {
                    if (response.success) {
                        var row = link.closest('td');
                        link.removeClass('unignore');
                        link.addClass('undounignore');
                        row.addClass('unignored');
                    }
                }, this));
            }, this));
            table.on('click', 'a.undounignore', _.bind(function (e) {
                e.preventDefault();
                var link = $(e.currentTarget);
                this.model.connection.ignore(link.attr('data-mask'), _.bind(function (response) {
                    if (response.success) {
                        var row = link.closest('td');
                        link.addClass('unignore');
                        link.removeClass('undounignore');
                        row.removeClass('unignored');
                    }
                }, this));
            }, this));
            
            return overlay;
        },
        monitor_list: function (message) {
            var table = this.buildTable(message, 'Monitor list for ' + this.formatter.render(this.model.connection.getFullLabel()), message.list, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Target'
            }], "You’re not monitoring anyone at the moment. You can monitor when people go on and offline by using <kbd>/monitor + <code>nick</code></kbd>");
            
            var overlay = new Overlay(table);
            return overlay;
        },
        a_list: function (message) {
            var table = this.buildTable(message, 'Protected list for ' + this.formatter.linkChannel(message.channel), message.list, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Nick'
            }], 'No protected channel members');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        reop_list: function (message) {
            var table = this.buildTable(message, 'Reop list for ' + this.formatter.linkChannel(message.channel), message.list, [{
                format: _.bind(function (mask) {
                    return this.formatter.renderNoEmoji(mask);
                }, this),
                title: 'Mask'
            }], 'Empty channel reop list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        quiet_list: function (message) {
            var table = this.buildTable(message, 'Quiet list for ' + this.formatter.linkChannel(message.channel), message.list, [{
                mask: 'quiet_mask',
                title: 'Quiet mask'
            }, {
                mask: 'usermask',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time && data.time > 0) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }], 'Empty quiet list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        exempt_chan_ops: function (message) {
            var table = this.buildTable(message, 'Channel exemptions for ' + this.formatter.linkChannel(message.channel), message.list, [{
                name: 'exemption',
                title: 'Exemption'
            }, {
                name: 'mode',
                title: 'Mode'
            }, {
                name: 'setter',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time && data.time > 0) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }], 'Empty channel exemptions list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        invited_list: function (message) {
            var table = this.buildTable(message, 'Pending channel invites', message.list, [{
                name: 'channel',
                title: 'Channel',
                channel: 'channel'
            }], 'You haven’t been invited to any channels');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        invite_list: function (message) {
            var table = this.buildTable(message, 'Invite list for ' + this.formatter.linkChannel(message.channel), message.list, [{
                mask: 'mask',
                title: 'Invite mask'
            }, {
                mask: 'usermask',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }], 'Empty invite list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        q_list: function (message) {
            var table = this.buildTable(message, 'Owner list for ' + this.formatter.linkChannel(message.channel), message.nicks, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Nick'
            }], 'No channel owners');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        ircops: function (message) {
            var content = $('<div>');
            var heading = $('<div class="heading">');
            var headingTitle = $('<h2>').text('IRCOPS');
            heading.append(headingTitle);
            content.append(heading);

            if (message.lines.length) {
                _.each(message.lines, function (line) {
                    content.append($('<p>').html(this.formatter.render(line)));
                }, this);
            } else {
                content.append($('<p class="noData">').text('No IRCOPS'));
            }
            var overlay = new Overlay(content);
            return overlay;
        },
        ban_list: function (message) {
            var headers = [{
                mask: 'mask',
                title: 'Ban mask'
            }, {
                mask: 'usermask',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }];
            var channel = this.model.connection.findChannel(message.channel);
            if (channel && channel.userMember && channel.userMember.isMod()) {
                headers.push({
                    title: 'Remove',
                    format: _.bind(function (item) {
                        return this.formatter.linker.make('x', {
                            href: "",
                            'class': 'unban',
                            'title': 'Unban ' + item.mask,
                            'data-mask': item.mask
                        });
                    }, this)
                });
            }
            var table = this.buildTable(message, 'Ban list for ' + this.formatter.linkChannel(message.channel), message.bans, headers, 'No bans in effect');
            
            var overlay = new Overlay(table);
            
            table.on('click', 'a.unban', _.bind(function (e) {
                e.preventDefault();
                var link = $(e.currentTarget);
                this.model.connection.channelUnban(message.channel, link.attr('data-mask'), _.bind(function (response) {
                    if (response.success) {
                        this.model.connection.channelBanList(message.channel);
                    }
                }, this));
            }, this));
            
            return overlay;
        },
        modules_list: function (message) {
            var table = this.buildTable(message, 'Modules list for ' + this.formatter.render(this.model.connection.getFullLabel()), message.modules, false, 'No modules loaded');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        ban_exception_list: function (message) {
            var table = this.buildTable(message, 'Ban exception list for ' + this.formatter.linkChannel(message.channel), message.exceptions, [{
                mask: 'mask',
                title: 'Exception mask'
            }, {
                mask: 'usermask',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    return this.formatter.howLong(new Date(data.time * 1000));
                }, this)
            }, {
                title: 'Remove',
                format: _.bind(function (item) {
                    return this.formatter.linker.make('x', {
                        href: "",
                        'class': 'unexcept',
                        'title': 'Remove ban exception ' + item.mask,
                        'data-mask': item.mask
                    });
                }, this)
            }], 'No ban exceptions in effect');
            
            var overlay = new Overlay(table);
            
            table.on('click', 'a.unexcept', _.bind(function (e) {
                e.preventDefault();
                var link = $(e.currentTarget);
                this.model.connection.channelUnexcept(message.channel, link.attr('data-mask'), _.bind(function (response) {
                    if (response.success) {
                        this.model.connection.channelExceptList(message.channel);
                    }
                }, this));
            }, this));
            
            return overlay;
        },
        accept_list: function (message) {
            var table = this.buildTable(message, 'Accept list', message.nicks, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Nick'
            }], 'No accepted nicks');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        map_list: function (message) {
            return new Overlay(this.buildTable(message, this.formatter.render(this.model.connection.getFullLabel()), message.servers, [{
                format: _.bind(function (server) {
                    return this.formatter.render(server);
                }, this),
                title: 'Server map'
            }], 'No servers mapped'));
        },
        silence_list: function (message) {
            var table = this.buildTable(message, "Silence list for " + this.formatter.linkNick(message.nick), message.usermasks, [{
                format: _.bind(function (mask) {
                    return this.formatter.renderNoEmoji(mask);
                }, this),
                title: 'Patterns'
            }], 'Empty silence list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        rules_response: function (message) {
            var title = message.start || "Server rules for " + (message.server || message.from);
            var content = $('<div>');
            var heading = $('<div class="heading">');
            content.append($('<h2>').html(this.formatter.render(title)));
            if (message.lines.length) {
                _.each(message.lines, function (line) {
                    content.append($('<p>').html(this.formatter.render(line)));
                }, this);
            } else {
                content.append($('<p class="noData">').text('Server rules missing'));
            }
            var overlay = new Overlay(content);
            return overlay;
        },
        links_response: function (message) {
            var title = "Servers linked to " + this.formatter.render(message.server);
            if (message.mask && message.mask !== '*') {
                title += ' matching <b>' + this.formatter.renderNoEmoji(message.mask) + '</b>';
            }
            return new Overlay(this.buildTable(message, title, message.links, [{
                name: 'server',
                title: 'Server'
            }, {
                name: 'info',
                title: 'Info'
            }, {
                name: 'hopcount',
                title: 'Hops'
            }], 'No servers linked'));
        },
        chanfilter_list: function (message) {
            var title = "Channel filter patterns for " + this.formatter.linkChannel(message.channel);
            return new Overlay(this.buildTable(message, title, message.list, [{
                name: 'pattern',
                title: 'Pattern'
            }, {
                name: 'author',
                title: 'Set by'
            }, {
                name: 'time',
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time && data.time > 0) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }], 'No channel filter patterns'));
        },
        query_too_long: function (message) {
            return new Overlay(this.formatter.renderNoEmoji(message.mask) + ': ' + this.formatter.render(message.msg));
        },
        input_too_long: function (message) {
            return new Overlay(this.formatter.render(message.msg));
        },
        try_again: function (message) {
            return new Overlay(this.formatter.render(message.command) + ': ' + this.formatter.render(message.msg));
        },
        list_response_fetching: function (message) {
            return new Overlay('Loading channel list for ' + this.formatter.render(message.server) + '…');
        },
        list_response_toomany: function (message) {
            var elistHint = '';
            var elist = this.model.connection.getISupport('ELIST');
            if (elist.indexOf('U') > -1) {
                elistHint = ' Try limiting the list to only respond with channels that have more than e.g. 50 members: /LIST >50.';
            }
            var linkHint = '';
            var netname = this.model.connection.getISupport('NETWORK');
            if (
                netname &&
                !this.model.connection.isTeamServer() &&
                !this.model.connection.isSlack() &&
                !this.model.connection.isTwitch()
            ) {
                var netsplitLink = this.formatter.linker.make('irc.netsplit.de', {
                    href: 'https://netsplit.de/channels/?net=' + netname,
                    rel: 'noreferrer',
                    target: '_blank'
                });
                linkHint = ' Look up channels on ' + netsplitLink;
            }
            return new Overlay('Too many channels to list for ' + this.formatter.render(message.server) + elistHint + linkHint);
        },
        list_response: function (message) {
            return new Overlay(this.buildTable(message, 'List of channels on ' + this.formatter.render(message.server), message.channels, [{
                name: 'name',
                title: 'Channels&nbsp;(' + this.formatter.render(message.num) + ')',
                channel: 'name'
            }, {
                title: 'Topic',
                format: _.bind(function (data) {
                    return this.formatter.renderLinkify(data.topic);
                }, this)
            }, {
                name: 'num_members',
                title: 'Members'
            }]));
        },
        isupport_list: function (message) {
            var table = this.buildIsupportTable(message.params);
            var head = "ISUPPORT parameters on " + this.formatter.linkConnection();
            return new Overlay(table, {
                head: head
            });
        },
        remote_isupport_params: function (message) {
            var table = this.buildIsupportTable(message.params);
            var head = "ISUPPORT parameters on <b>" + this.formatter.render(message.server) + '</b>';
            return new Overlay(table, {
                head: head
            });
        },
        names_reply: function (message) {
            return new Overlay(this.buildTable(message, 'Members of ' + this.formatter.linkChannel(message.chan), message.members, [{
                name: 'nick',
                title: 'Nickname',
                nick: 'nick'
            }, {
                name: 'mode',
                title: 'Mode'
            }]));
        },
        notice: function (message) {
            if (message.self) {
                return null;
            }
            if (this.model.isSelected()) {
                return null;
            }
            if (this.model.isServerLog()) {
                if ('server' in message) {
                    // Server notices (with no discernable sender) shouldn't overlay
                    // e.g. *** Looking up your hostname...
                    // see Message#isImportant
                    // We make an exception for throttle messages
                    var chan = Message.checkThrottleChan(message.msg);
                    if (chan) {
                        // ok
                    } else {
                        return null;
                    }
                }
                if (message.to_buffer) {
                    // Extra server notices from buffers. The pm notice will
                    // already make an overlay for this
                    return null;
                }
            }
            if (message.to_chan) {
                // Channel notices shouldn't overlay
                return null;
            }
            var connectionLabel = ' (' + this.formatter.render(this.model.connection.getName()) + ')';
            var target;
            if (message.from_host && message.from_name) {
                // Notice came from a connected user
                if (this.model.isChannel()) {
                    // Targetted to a channel
                    target  = this.formatter.link();
                    target += ' from ' + this.formatter.linkNick(message.from);
                } else {
                    // Targetted to you directly
                    target = this.formatter.linkNick(message.from);
                }
                target += connectionLabel;
            } else {
                // Notice came from the server
                if (this.model.isServerLog()) {
                    target = this.formatter.linkConnection();
                } else {
                    target = this.formatter.link();
                    // Not a server notice, so add the connection label
                    target += connectionLabel;
                }
            }
            var content = this.formatter.renderLinkify(message.msg);
            var head = "Notice: " + target;
            return new Overlay(content, {
                head: head,
                timeout: 5000,
                doneText: 'Close',
                keepFocus: true
            });
        },
        services_down: function (message) {
            var content = this.formatter.render(message.services_name) + ': ' + this.formatter.renderLinkify(message.msg);
            var head = "Notice on " + this.formatter.render(this.model.connection.getFullLabel());
            return new Overlay(content, {
                head: head
            });
        },
        time: function (message) {
            var content = this.formatter.render(message.time_string) + ' — <b>' + this.formatter.render(message.time_server) + '</b>';
            
            var head = "Time on " + this.formatter.render(this.model.connection.getFullLabel());
            return new Overlay(content, {
                head: head
            });
        },
        ison: function (message) {
            return new Overlay(this.buildTable(message, 'ISON results for ' + this.formatter.render(this.model.connection.getFullLabel()), message.nicks, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Active nicks'
            }], 'No active nick results'));
        },
        trace_response: function (message) {
            return new Overlay(this.buildTable(message, 'Trace for <b>' + this.formatter.render(message.query) + '</b>', message.trace, [{
                format: _.bind(function (trace) {
                    return this.formatter.render(trace);
                }, this),
                title: 'Results'
            }], 'No results'));
        },
        monitor_offline: function (message) {
            var content = this.buildTable(message, null, message.targets, [{
                format: _.bind(function (target) {
                    var targetUser = this.model.connection.makeUserFromTarget(
                        this.model.bid(),
                        target
                    );
                    return this.formatter.linkUser(targetUser);
                }, this),
                title: 'Offline'
            }]);
            var head = "Monitor status " + this.formatter.render(this.model.connection.getFullLabel());
            
            return new Overlay(content, {
                head: head,
                timeout: 5000,
                doneText: 'Close',
                keepFocus: true
            });
        },
        monitor_online: function (message) {
            var content = this.buildTable(message, null, message.targets, [{
                format: _.bind(function (target) {
                    var targetUser = this.model.connection.makeUserFromTarget(
                        this.model.bid(),
                        target
                    );
                    return this.formatter.linkUser(targetUser);
                }, this),
                title: 'Online'
            }]);
            var head = "Monitor status " + this.formatter.render(this.model.connection.getFullLabel());
            
            return new Overlay(content, {
                head: head,
                timeout: 5000,
                doneText: 'Close',
                keepFocus: true
            });
        },
        watch_status: function (message) {
            var content, timeout, keepFocus;
            if (message.stat) {
                content = this.formatter.renderLinkify(message.stat);
            } else if (message.nicks) {
                content = this.buildTable(message, null, message.nicks, [{
                    format: _.bind(function (nick) {
                        return this.formatter.linkNick(nick);
                    }, this),
                    title: 'Watching'
                }], 'Not watching any nicks');
            } else if (message.watch_nick) {
                // Notification about someone in the watch list, these timeout
                content = this.formatter.linkNick(message.watch_nick) + ' ' + this.formatter.renderLinkify(message.msg) + ' (' + this.formatter.render(message.username + '@' + message.userhost) + ')';
                timeout = 5000;
                keepFocus = true;
            } else {
                content = this.formatter.renderLinkify(message.msg);
            }
            var head = "Watch list status on " + this.formatter.render(this.model.connection.getFullLabel());
            
            return new Overlay(content, {
                head: head,
                timeout: timeout,
                doneText: 'Close',
                keepFocus: keepFocus
            });
        },
        channel_query: function (message) {
            var content;
            switch (message.query_type) {
            case 'timestamp':
                if (message.timestamp > 0) {
                    var createdDate = new Date(message.timestamp * 1000);
                    content = this.formatter.linkChannel(message.channel) + ' created on <b>' + createdDate.formatFullDate() + '</b>';
                }
                break;
            case 'mode':
                content = this.formatter.linkChannel(message.channel) + ' ';
                if (message.newmode) {
                    content += 'mode is <b>+' + this.formatter.render(message.newmode) + '</b>';
                } else {
                    content += 'no channel mode';
                }
                break;
            case 'url':
                content = this.formatter.linkChannel(message.channel) + ' homepage: ' + this.formatter.renderLinkify(message.url);
                break;
            }
            if (content) {
                return new Overlay(content, {
                    doneText: 'Close',
                });
            }
        },
        userhost: function (message) {
            return new Overlay(this.buildTable(message, 'USERHOST results for ' + this.formatter.render(this.model.connection.getFullLabel()), message.users, [{
                format: _.bind(function (data) {
                    var className;
                    var title = data.nick;
                    if (data.away) {
                        title += ' (away)';
                        className = 'away';
                    }
                    return this.formatter.linkNick(data.nick, {
                        className: className,
                        title: title
                    });
                }, this),
                title: 'Active nicks'
            }, {
                name: 'userhost',
                title: 'Userhost'
            }, {
                name: 'oper',
                title: 'Oper'
            }], 'No active nick results'));
        },
        channel_invite: function (message) {
            if (this.model.isServerLog() && (message.to_chan || message.to_buffer)) {
                // Extra server invites. The pm invite will
                // already make an overlay for this
                return null;
            }
            var channelLink = this.formatter.linkChannel(message.channel, {
                className: 'channelInviteLink'
            });
            var content = this.formatter.linkNick(message.from) + " is inviting you to join " + channelLink;
            var head = "Channel invite on " + this.formatter.linkConnection();
            return new Overlay(content, {
                head: head,
                timeout: 5000
            });
        }
    }
});

module.exports = BufferOverlayHandler;


/***/ }),

/***/ "D6pB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dn1P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__("W3Iv");

var _entries2 = _interopRequireDefault(_entries);

exports.getParts = getParts;
exports.matchEmail = matchEmail;
exports.isEmail = isEmail;
exports.protoMatch = protoMatch;
exports.protoStrip = protoStrip;
exports.domainMatch = domainMatch;
exports.domainEndMatch = domainEndMatch;
exports.domainEndSplit = domainEndSplit;
exports.domainSplit = domainSplit;
exports.isNum = isNum;
exports.trailingPuncMatch = trailingPuncMatch;
exports.closeParenMatch = closeParenMatch;
exports.isHttp = isHttp;
exports.isLooseHttp = isLooseHttp;
exports.isBareHttp = isBareHttp;
exports.isFtp = isFtp;
exports.isDangerousString = isDangerousString;
exports.isData = isData;
exports.isVbscript = isVbscript;
exports.isFile = isFile;
exports.isSmb = isSmb;
exports.isMs = isMs;
exports.isJavascript = isJavascript;
exports.isIrc = isIrc;
exports.isDisallowed = isDisallowed;
exports.isMagnet = isMagnet;
exports.isSpotify = isSpotify;
exports.isSkype = isSkype;
exports.matchYouTube = matchYouTube;
exports.matchTwitter = matchTwitter;
exports.matchInstagram = matchInstagram;
exports.matchMastodon = matchMastodon;
exports.matchBsky = matchBsky;
exports.matchReddit = matchReddit;
exports.parseSearch = parseSearch;
exports.cleanAmpUrl = cleanAmpUrl;
exports.matchAmpProject = matchAmpProject;
exports.matchAmpViewer = matchAmpViewer;
exports.isAmp = isAmp;
exports.isCurrentUrl = isCurrentUrl;
exports.urlParts = urlParts;
exports.escapeRTLO = escapeRTLO;
exports.toHttps = toHttps;
exports.filterSearchParams = filterSearchParams;
exports.paramsToString = paramsToString;

var _re = __webpack_require__("38es");

var re = _interopRequireWildcard(_re);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROTOCOL_REGEX = /[a-z_+-]+:\/{1,3}/; /* eslint-env es6 */

var PROTOCOL_REGEX_START = new RegExp('^' + PROTOCOL_REGEX.source, 'i');
var LOOSE_HTTP_REGEX = /^http[s]?:\/{0,2}/i;
var HTTP_REGEX = /^http[s]?:\/\//i;
var FTP_REGEX = /^[s]?ftp?:\/\//i;
var DANGEROUS_REGEX = /(?:%%300)|(?:%0%30)|(?:%%30%30)/;
var DATA_REGEX = /^data:/i;
var VBSCRIPT_REGEX = /^vbscript:/i;
var FILE_REGEX = /^file:/i;
var SMB_REGEX = /^smb:/i;
var MS_REGEX = /^(search)|(search-ms)|(ms-msdt)|(ms-officecmd)|(ms-cxh)|(ms-cxh-full):/i;
var JS_REGEX = /^javascript:/i;
var IRC_REGEX = /^irc[s]?:\/{0,2}/i;

// http://data.iana.org/TLD/tlds-alpha-by-domain.txt
// Version 2024031100, Last Updated Mon Mar 11 07:07:01 2024 UTC
// See http://en.wikipedia.org/wiki/List_of_Internet_top-level_domains
// Excludes TLDs more common as file extensions
// SH (Saint Helena)
// CC (Cocos Islands)
// PY (Paraguay)
// MD (Moldova)
// RS (Serbia)
// ZIP (https://www.registry.google/about/faqs.html)
var TLDS = "AAA|AARP|ABB|ABBOTT|ABBVIE|ABC|ABLE|ABOGADO|ABUDHABI|AC|ACADEMY|ACCENTURE|ACCOUNTANT|ACCOUNTANTS|ACO|ACTOR|AD|ADS|ADULT|AE|AEG|AERO|AETNA|AF|AFL|AFRICA|AG|AGAKHAN|AGENCY|AI|AIG|AIRBUS|AIRFORCE|AIRTEL|AKDN|AL|ALIBABA|ALIPAY|ALLFINANZ|ALLSTATE|ALLY|ALSACE|ALSTOM|AM|AMAZON|AMERICANEXPRESS|AMERICANFAMILY|AMEX|AMFAM|AMICA|AMSTERDAM|ANALYTICS|ANDROID|ANQUAN|ANZ|AO|AOL|APARTMENTS|APP|APPLE|AQ|AQUARELLE|AR|ARAB|ARAMCO|ARCHI|ARMY|ARPA|ART|ARTE|AS|ASDA|ASIA|ASSOCIATES|AT|ATHLETA|ATTORNEY|AU|AUCTION|AUDI|AUDIBLE|AUDIO|AUSPOST|AUTHOR|AUTO|AUTOS|AVIANCA|AW|AWS|AX|AXA|AZ|AZURE|BA|BABY|BAIDU|BANAMEX|BAND|BANK|BAR|BARCELONA|BARCLAYCARD|BARCLAYS|BAREFOOT|BARGAINS|BASEBALL|BASKETBALL|BAUHAUS|BAYERN|BB|BBC|BBT|BBVA|BCG|BCN|BD|BE|BEATS|BEAUTY|BEER|BENTLEY|BERLIN|BEST|BESTBUY|BET|BF|BG|BH|BHARTI|BI|BIBLE|BID|BIKE|BING|BINGO|BIO|BIZ|BJ|BLACK|BLACKFRIDAY|BLOCKBUSTER|BLOG|BLOOMBERG|BLUE|BM|BMS|BMW|BN|BNPPARIBAS|BO|BOATS|BOEHRINGER|BOFA|BOM|BOND|BOO|BOOK|BOOKING|BOSCH|BOSTIK|BOSTON|BOT|BOUTIQUE|BOX|BR|BRADESCO|BRIDGESTONE|BROADWAY|BROKER|BROTHER|BRUSSELS|BS|BT|BUILD|BUILDERS|BUSINESS|BUY|BUZZ|BV|BW|BY|BZ|BZH|CA|CAB|CAFE|CAL|CALL|CALVINKLEIN|CAM|CAMERA|CAMP|CANON|CAPETOWN|CAPITAL|CAPITALONE|CAR|CARAVAN|CARDS|CARE|CAREER|CAREERS|CARS|CASA|CASE|CASH|CASINO|CAT|CATERING|CATHOLIC|CBA|CBN|CBRE|CD|CENTER|CEO|CERN|CF|CFA|CFD|CG|CH|CHANEL|CHANNEL|CHARITY|CHASE|CHAT|CHEAP|CHINTAI|CHRISTMAS|CHROME|CHURCH|CI|CIPRIANI|CIRCLE|CISCO|CITADEL|CITI|CITIC|CITY|CK|CL|CLAIMS|CLEANING|CLICK|CLINIC|CLINIQUE|CLOTHING|CLOUD|CLUB|CLUBMED|CM|CN|CO|COACH|CODES|COFFEE|COLLEGE|COLOGNE|COM|COMMBANK|COMMUNITY|COMPANY|COMPARE|COMPUTER|COMSEC|CONDOS|CONSTRUCTION|CONSULTING|CONTACT|CONTRACTORS|COOKING|COOL|COOP|CORSICA|COUNTRY|COUPON|COUPONS|COURSES|CPA|CR|CREDIT|CREDITCARD|CREDITUNION|CRICKET|CROWN|CRS|CRUISE|CRUISES|CU|CUISINELLA|CV|CW|CX|CY|CYMRU|CYOU|CZ|DABUR|DAD|DANCE|DATA|DATE|DATING|DATSUN|DAY|DCLK|DDS|DE|DEAL|DEALER|DEALS|DEGREE|DELIVERY|DELL|DELOITTE|DELTA|DEMOCRAT|DENTAL|DENTIST|DESI|DESIGN|DEV|DHL|DIAMONDS|DIET|DIGITAL|DIRECT|DIRECTORY|DISCOUNT|DISCOVER|DISH|DIY|DJ|DK|DM|DNP|DO|DOCS|DOCTOR|DOG|DOMAINS|DOT|DOWNLOAD|DRIVE|DTV|DUBAI|DUNLOP|DUPONT|DURBAN|DVAG|DVR|DZ|EARTH|EAT|EC|ECO|EDEKA|EDU|EDUCATION|EE|EG|EMAIL|EMERCK|ENERGY|ENGINEER|ENGINEERING|ENTERPRISES|EPSON|EQUIPMENT|ER|ERICSSON|ERNI|ES|ESQ|ESTATE|ET|EU|EUROVISION|EUS|EVENTS|EXCHANGE|EXPERT|EXPOSED|EXPRESS|EXTRASPACE|FAGE|FAIL|FAIRWINDS|FAITH|FAMILY|FAN|FANS|FARM|FARMERS|FASHION|FAST|FEDEX|FEEDBACK|FERRARI|FERRERO|FI|FIDELITY|FIDO|FILM|FINAL|FINANCE|FINANCIAL|FIRE|FIRESTONE|FIRMDALE|FISH|FISHING|FIT|FITNESS|FJ|FK|FLICKR|FLIGHTS|FLIR|FLORIST|FLOWERS|FLY|FM|FO|FOO|FOOD|FOOTBALL|FORD|FOREX|FORSALE|FORUM|FOUNDATION|FOX|FR|FREE|FRESENIUS|FRL|FROGANS|FRONTIER|FTR|FUJITSU|FUN|FUND|FURNITURE|FUTBOL|FYI|GA|GAL|GALLERY|GALLO|GALLUP|GAME|GAMES|GAP|GARDEN|GAY|GB|GBIZ|GD|GDN|GE|GEA|GENT|GENTING|GEORGE|GF|GG|GGEE|GH|GI|GIFT|GIFTS|GIVES|GIVING|GL|GLASS|GLE|GLOBAL|GLOBO|GM|GMAIL|GMBH|GMO|GMX|GN|GODADDY|GOLD|GOLDPOINT|GOLF|GOO|GOODYEAR|GOOG|GOOGLE|GOP|GOT|GOV|GP|GQ|GR|GRAINGER|GRAPHICS|GRATIS|GREEN|GRIPE|GROCERY|GROUP|GS|GT|GU|GUCCI|GUGE|GUIDE|GUITARS|GURU|GW|GY|HAIR|HAMBURG|HANGOUT|HAUS|HBO|HDFC|HDFCBANK|HEALTH|HEALTHCARE|HELP|HELSINKI|HERE|HERMES|HIPHOP|HISAMITSU|HITACHI|HIV|HK|HKT|HM|HN|HOCKEY|HOLDINGS|HOLIDAY|HOMEDEPOT|HOMEGOODS|HOMES|HOMESENSE|HONDA|HORSE|HOSPITAL|HOST|HOSTING|HOT|HOTELS|HOTMAIL|HOUSE|HOW|HR|HSBC|HT|HU|HUGHES|HYATT|HYUNDAI|IBM|ICBC|ICE|ICU|ID|IE|IEEE|IFM|IKANO|IL|IM|IMAMAT|IMDB|IMMO|IMMOBILIEN|IN|INC|INDUSTRIES|INFINITI|INFO|ING|INK|INSTITUTE|INSURANCE|INSURE|INT|INTERNATIONAL|INTUIT|INVESTMENTS|IO|IPIRANGA|IQ|IR|IRISH|IS|ISMAILI|IST|ISTANBUL|IT|ITAU|ITV|JAGUAR|JAVA|JCB|JE|JEEP|JETZT|JEWELRY|JIO|JLL|JM|JMP|JNJ|JO|JOBS|JOBURG|JOT|JOY|JP|JPMORGAN|JPRS|JUEGOS|JUNIPER|KAUFEN|KDDI|KE|KERRYHOTELS|KERRYLOGISTICS|KERRYPROPERTIES|KFH|KG|KH|KI|KIA|KIDS|KIM|KINDLE|KITCHEN|KIWI|KM|KN|KOELN|KOMATSU|KOSHER|KP|KPMG|KPN|KR|KRD|KRED|KUOKGROUP|KW|KY|KYOTO|KZ|LA|LACAIXA|LAMBORGHINI|LAMER|LANCASTER|LAND|LANDROVER|LANXESS|LASALLE|LAT|LATINO|LATROBE|LAW|LAWYER|LB|LC|LDS|LEASE|LECLERC|LEFRAK|LEGAL|LEGO|LEXUS|LGBT|LI|LIDL|LIFE|LIFEINSURANCE|LIFESTYLE|LIGHTING|LIKE|LILLY|LIMITED|LIMO|LINCOLN|LINK|LIPSY|LIVE|LIVING|LK|LLC|LLP|LOAN|LOANS|LOCKER|LOCUS|LOL|LONDON|LOTTE|LOTTO|LOVE|LPL|LPLFINANCIAL|LR|LS|LT|LTD|LTDA|LU|LUNDBECK|LUXE|LUXURY|LV|LY|MA|MADRID|MAIF|MAISON|MAKEUP|MAN|MANAGEMENT|MANGO|MAP|MARKET|MARKETING|MARKETS|MARRIOTT|MARSHALLS|MATTEL|MBA|MC|MCKINSEY|ME|MED|MEDIA|MEET|MELBOURNE|MEME|MEMORIAL|MEN|MENU|MERCKMSD|MG|MH|MIAMI|MICROSOFT|MIL|MINI|MINT|MIT|MITSUBISHI|MK|ML|MLB|MLS|MM|MMA|MN|MO|MOBI|MOBILE|MODA|MOE|MOI|MOM|MONASH|MONEY|MONSTER|MORMON|MORTGAGE|MOSCOW|MOTO|MOTORCYCLES|MOV|MOVIE|MP|MQ|MR|MS|MSD|MT|MTN|MTR|MU|MUSEUM|MUSIC|MV|MW|MX|MY|MZ|NA|NAB|NAGOYA|NAME|NATURA|NAVY|NBA|NC|NE|NEC|NET|NETBANK|NETFLIX|NETWORK|NEUSTAR|NEW|NEWS|NEXT|NEXTDIRECT|NEXUS|NF|NFL|NG|NGO|NHK|NI|NICO|NIKE|NIKON|NINJA|NISSAN|NISSAY|NL|NO|NOKIA|NORTON|NOW|NOWRUZ|NOWTV|NP|NR|NRA|NRW|NTT|NU|NYC|NZ|OBI|OBSERVER|OFFICE|OKINAWA|OLAYAN|OLAYANGROUP|OLLO|OM|OMEGA|ONE|ONG|ONL|ONLINE|OOO|OPEN|ORACLE|ORANGE|ORG|ORGANIC|ORIGINS|OSAKA|OTSUKA|OTT|OVH|PA|PAGE|PANASONIC|PARIS|PARS|PARTNERS|PARTS|PARTY|PAY|PCCW|PE|PET|PF|PFIZER|PG|PH|PHARMACY|PHD|PHILIPS|PHONE|PHOTO|PHOTOGRAPHY|PHOTOS|PHYSIO|PICS|PICTET|PICTURES|PID|PIN|PING|PINK|PIONEER|PIZZA|PK|PL|PLACE|PLAY|PLAYSTATION|PLUMBING|PLUS|PM|PN|PNC|POHL|POKER|POLITIE|PORN|POST|PR|PRAMERICA|PRAXI|PRESS|PRIME|PRO|PROD|PRODUCTIONS|PROF|PROGRESSIVE|PROMO|PROPERTIES|PROPERTY|PROTECTION|PRU|PRUDENTIAL|PS|PT|PUB|PW|PWC|QA|QPON|QUEBEC|QUEST|RACING|RADIO|RE|READ|REALESTATE|REALTOR|REALTY|RECIPES|RED|REDSTONE|REDUMBRELLA|REHAB|REISE|REISEN|REIT|RELIANCE|REN|RENT|RENTALS|REPAIR|REPORT|REPUBLICAN|REST|RESTAURANT|REVIEW|REVIEWS|REXROTH|RICH|RICHARDLI|RICOH|RIL|RIO|RIP|RO|ROCKS|RODEO|ROGERS|ROOM|RSVP|RU|RUGBY|RUHR|RUN|RW|RWE|RYUKYU|SA|SAARLAND|SAFE|SAFETY|SAKURA|SALE|SALON|SAMSCLUB|SAMSUNG|SANDVIK|SANDVIKCOROMANT|SANOFI|SAP|SARL|SAS|SAVE|SAXO|SB|SBI|SBS|SC|SCB|SCHAEFFLER|SCHMIDT|SCHOLARSHIPS|SCHOOL|SCHULE|SCHWARZ|SCIENCE|SCOT|SD|SE|SEARCH|SEAT|SECURE|SECURITY|SEEK|SELECT|SENER|SERVICES|SEVEN|SEW|SEX|SEXY|SFR|SG|SHANGRILA|SHARP|SHAW|SHELL|SHIA|SHIKSHA|SHOES|SHOP|SHOPPING|SHOUJI|SHOW|SI|SILK|SINA|SINGLES|SITE|SJ|SK|SKI|SKIN|SKY|SKYPE|SL|SLING|SM|SMART|SMILE|SN|SNCF|SO|SOCCER|SOCIAL|SOFTBANK|SOFTWARE|SOHU|SOLAR|SOLUTIONS|SONG|SONY|SOY|SPA|SPACE|SPORT|SPOT|SR|SRL|SS|ST|STADA|STAPLES|STAR|STATEBANK|STATEFARM|STC|STCGROUP|STOCKHOLM|STORAGE|STORE|STREAM|STUDIO|STUDY|STYLE|SU|SUCKS|SUPPLIES|SUPPLY|SUPPORT|SURF|SURGERY|SUZUKI|SV|SWATCH|SWISS|SX|SY|SYDNEY|SYSTEMS|SZ|TAB|TAIPEI|TALK|TAOBAO|TARGET|TATAMOTORS|TATAR|TATTOO|TAX|TAXI|TC|TCI|TD|TDK|TEAM|TECH|TECHNOLOGY|TEL|TEMASEK|TENNIS|TEVA|TF|TG|TH|THD|THEATER|THEATRE|TIAA|TICKETS|TIENDA|TIPS|TIRES|TIROL|TJ|TJMAXX|TJX|TK|TKMAXX|TL|TM|TMALL|TN|TO|TODAY|TOKYO|TOOLS|TOP|TORAY|TOSHIBA|TOTAL|TOURS|TOWN|TOYOTA|TOYS|TR|TRADE|TRADING|TRAINING|TRAVEL|TRAVELERS|TRAVELERSINSURANCE|TRUST|TRV|TT|TUBE|TUI|TUNES|TUSHU|TV|TVS|TW|TZ|UA|UBANK|UBS|UG|UK|UNICOM|UNIVERSITY|UNO|UOL|UPS|US|UY|UZ|VA|VACATIONS|VANA|VANGUARD|VC|VE|VEGAS|VENTURES|VERISIGN|VERSICHERUNG|VET|VG|VI|VIAJES|VIDEO|VIG|VIKING|VILLAS|VIN|VIP|VIRGIN|VISA|VISION|VIVA|VIVO|VLAANDEREN|VN|VODKA|VOLVO|VOTE|VOTING|VOTO|VOYAGE|VU|WALES|WALMART|WALTER|WANG|WANGGOU|WATCH|WATCHES|WEATHER|WEATHERCHANNEL|WEBCAM|WEBER|WEBSITE|WED|WEDDING|WEIBO|WEIR|WF|WHOSWHO|WIEN|WIKI|WILLIAMHILL|WIN|WINDOWS|WINE|WINNERS|WME|WOLTERSKLUWER|WOODSIDE|WORK|WORKS|WORLD|WOW|WS|WTC|WTF|XBOX|XEROX|XIHUAN|XIN|XN--11B4C3D|XN--1CK2E1B|XN--1QQW23A|XN--2SCRJ9C|XN--30RR7Y|XN--3BST00M|XN--3DS443G|XN--3E0B707E|XN--3HCRJ9C|XN--3PXU8K|XN--42C2D9A|XN--45BR5CYL|XN--45BRJ9C|XN--45Q11C|XN--4DBRK0CE|XN--4GBRIM|XN--54B7FTA0CC|XN--55QW42G|XN--55QX5D|XN--5SU34J936BGSG|XN--5TZM5G|XN--6FRZ82G|XN--6QQ986B3XL|XN--80ADXHKS|XN--80AO21A|XN--80AQECDR1A|XN--80ASEHDB|XN--80ASWG|XN--8Y0A063A|XN--90A3AC|XN--90AE|XN--90AIS|XN--9DBQ2A|XN--9ET52U|XN--9KRT00A|XN--B4W605FERD|XN--BCK1B9A5DRE4C|XN--C1AVG|XN--C2BR7G|XN--CCK2B3B|XN--CCKWCXETD|XN--CG4BKI|XN--CLCHC0EA0B2G2A9GCD|XN--CZR694B|XN--CZRS0T|XN--CZRU2D|XN--D1ACJ3B|XN--D1ALF|XN--E1A4C|XN--ECKVDTC9D|XN--EFVY88H|XN--FCT429K|XN--FHBEI|XN--FIQ228C5HS|XN--FIQ64B|XN--FIQS8S|XN--FIQZ9S|XN--FJQ720A|XN--FLW351E|XN--FPCRJ9C3D|XN--FZC2C9E2C|XN--FZYS8D69UVGM|XN--G2XX48C|XN--GCKR3F0F|XN--GECRJ9C|XN--GK3AT1E|XN--H2BREG3EVE|XN--H2BRJ9C|XN--H2BRJ9C8C|XN--HXT814E|XN--I1B6B1A6A2E|XN--IMR513N|XN--IO0A7I|XN--J1AEF|XN--J1AMH|XN--J6W193G|XN--JLQ480N2RG|XN--JVR189M|XN--KCRX77D1X4A|XN--KPRW13D|XN--KPRY57D|XN--KPUT3I|XN--L1ACC|XN--LGBBAT1AD8J|XN--MGB9AWBF|XN--MGBA3A3EJT|XN--MGBA3A4F16A|XN--MGBA7C0BBN0A|XN--MGBAAM7A8H|XN--MGBAB2BD|XN--MGBAH1A3HJKRD|XN--MGBAI9AZGQP6J|XN--MGBAYH7GPA|XN--MGBBH1A|XN--MGBBH1A71E|XN--MGBC0A9AZCG|XN--MGBCA7DZDO|XN--MGBCPQ6GPA1A|XN--MGBERP4A5D4AR|XN--MGBGU82A|XN--MGBI4ECEXP|XN--MGBPL2FH|XN--MGBT3DHD|XN--MGBTX2B|XN--MGBX4CD0AB|XN--MIX891F|XN--MK1BU44C|XN--MXTQ1M|XN--NGBC5AZD|XN--NGBE9E0A|XN--NGBRX|XN--NODE|XN--NQV7F|XN--NQV7FS00EMA|XN--NYQY26A|XN--O3CW4H|XN--OGBPF8FL|XN--OTU796D|XN--P1ACF|XN--P1AI|XN--PGBS0DH|XN--PSSY2U|XN--Q7CE6A|XN--Q9JYB4C|XN--QCKA1PMC|XN--QXA6A|XN--QXAM|XN--RHQV96G|XN--ROVU88B|XN--RVC1E0AM3E|XN--S9BRJ9C|XN--SES554G|XN--T60B56A|XN--TCKWE|XN--TIQ49XQYJ|XN--UNUP4Y|XN--VERMGENSBERATER-CTB|XN--VERMGENSBERATUNG-PWB|XN--VHQUV|XN--VUQ861B|XN--W4R85EL8FHU5DNRA|XN--W4RS40L|XN--WGBH1C|XN--WGBL6A|XN--XHQ521B|XN--XKC2AL3HYE2A|XN--XKC2DL3A5EE0H|XN--Y9A3AQ|XN--YFRO4I67O|XN--YGBI2AMMX|XN--ZFR164B|XXX|XYZ|YACHTS|YAHOO|YAMAXUN|YANDEX|YE|YODOBASHI|YOGA|YOKOHAMA|YOU|YOUTUBE|YT|YUN|ZA|ZAPPOS|ZARA|ZERO|ZM|ZONE|ZUERICH|ZW";
var PUNC_CHARS = '\\s\\(\\)\\\\\\[\\]{};:\'"`,<>!?«»“”‘’';
var domainEndPunc = new RegExp(re.isA('\\s\\(\\)\\\\\\[\\]{};\'#"`,<>!?«»“”‘’…/'));
var puncPipe = PUNC_CHARS + '|';

var domainRoot = re.atLeastOne(re.nc(re.atLeastOne(re.notA(PUNC_CHARS + '…./|*@')) + re.isA('.')));
var domain = domainRoot + re.nc(TLDS);
var domainRe = new RegExp(domain, 'i');

var DOMAIN_SEP = /[?#\/]/;
var HASH_RE = /^#/;
var SLASH_RE = /^\//;
var SEARCH_RE = /^\?/;
var NUM_RE = /^\d+$/;
var TRAILING_PUNC_REGEX = /[\s\\;:'"’”`)\]}>»,!?.]+$/;
var CLOSE_PAREN_REGEX = /['"’”`)\]}>»]/;

// Based on http://www.regular-expressions.info/email.html
var EMAIL_REGEX = new RegExp(re.wordBound + re.atLeastOne(re.isA('\\w._%+!-')) + '@' + re.atLeastOne(re.notA(PUNC_CHARS + '/')) + '[a-z]{2,}' + re.wordBound, 'gi');

var MASTODON_REGEX = new RegExp('^/@'
// username
+ re.c(re.atLeastOne(re.isA('a-zA-Z0-9_')))
// optional user instance
+ re.opt(re.nc('@' + re.c(domain))) + '/'
// status id
+ re.c('\\d{18,18}$'), 'i');

function getParts(chanRegex) {
    var parts = [
    // 1: Email addresses
    re.c(EMAIL_REGEX.source),

    // 2: Qualified URL
    re.c(re.wordBound + PROTOCOL_REGEX.source + re.atLeastOne(re.notA('"\\s`'))),

    // 3: Simple domain with an optional ending: example.com/asd, example.com#asd, example.com?asd
    re.c(domain + re.nc(re.oneOf(re.atLeastOne(re.nc(re.atLeastOne('[/#?!:]') + re.atLeastOne(re.notA(puncPipe)))), '/' + re.nonWordBound, re.wordBound))),

    // 4: Channel names: #channel
    re.c(re.nonWordBound + chanRegex),

    // 5: Spotify/Skype
    re.c(re.wordBound + re.nc(re.oneOf('spotify', 'skype')) + ':' + re.atLeastOne(re.notA('"\\s'))),

    // 6: Magnet
    re.c(re.wordBound + 'magnet:\\?' + re.atLeastOne(re.notA('"\\s')))];
    return parts;
}

function matchEmail(text) {
    return text.match(EMAIL_REGEX);
}
function isEmail(url) {
    if (PROTOCOL_REGEX_START.test(url)) {
        return false;
    }
    var matches = matchEmail(url);
    if (matches && matches.length === 1) {
        return true;
    } else {
        return false;
    }
}

function protoMatch(url) {
    return url.match(PROTOCOL_REGEX_START);
}
function protoStrip(url) {
    return url.replace(PROTOCOL_REGEX_START, '');
}
function domainMatch(url) {
    return url.match(domainRe);
}
function domainEndMatch(url) {
    return url.match(domainEndPunc);
}
function domainEndSplit(url) {
    return url.split(domainEndPunc);
}
function domainSplit(url) {
    return url.split(DOMAIN_SEP);
}
function isNum(text) {
    return text.match(NUM_RE);
}
function trailingPuncMatch(url) {
    return url.match(TRAILING_PUNC_REGEX);
}
function closeParenMatch(url) {
    return url.match(CLOSE_PAREN_REGEX);
}

function isHttp(url) {
    return HTTP_REGEX.test(url);
}
function isLooseHttp(url) {
    return LOOSE_HTTP_REGEX.test(url);
}
function isBareHttp(url) {
    return url.match(HTTP_REGEX.source + '$');
}
function isFtp(url) {
    return FTP_REGEX.test(url);
}
function isDangerousString(url) {
    return DANGEROUS_REGEX.test(url);
}
function isData(url) {
    return DATA_REGEX.test(url);
}
function isVbscript(url) {
    return VBSCRIPT_REGEX.test(url);
}
function isFile(url) {
    return FILE_REGEX.test(url);
}
function isSmb(url) {
    return SMB_REGEX.test(url);
}
function isMs(url) {
    return MS_REGEX.test(url);
}
function isJavascript(url) {
    return JS_REGEX.test(url);
}
function isIrc(url) {
    return IRC_REGEX.test(url);
}

function isDisallowed(url) {
    return isJavascript(url) || isData(url) || isVbscript(url) || isFile(url) || isSmb(url) || isMs(url);
}

function isMagnet(url) {
    return url.indexOf('magnet:?') === 0;
}

function isSpotify(url) {
    if (!url) {
        return false;
    }
    return url.indexOf('spotify:') === 0;
}
function isSkype(url) {
    if (!url) {
        return false;
    }
    return url.indexOf('skype:') === 0;
}
function matchYouTube(parts) {
    return parts.hostname.match(/(?:^|\.)youtube(?:-nocookie)?(?:\.googleapis)?\.com$/i);
}
function matchTwitter(parts) {
    return parts.hostname.match(/^(www\.)?(twitter|x)\.com$/i);
}
function matchInstagram(parts) {
    return parts.hostname.match(/^(www\.)?(instagram\.com)|(instagr\.am)$/i);
}
function matchMastodon(parts) {
    return parts.pathname.match(MASTODON_REGEX);
}
function matchBsky(parts) {
    return parts.hostname.match(/^(www\.)?(bsky)\.app$/i);
}
function matchReddit(parts) {
    return parts.hostname.match(/^(www\.)|(old\.)?(reddit\.com)$/i);
}
function parseSearch(search) {
    var parts = {};
    _.each(search.replace(/^\?/, '').split('&'), function (part) {
        if (part) {
            var kv = part.split('=');
            var val = kv[1];
            if (val) {
                val = decodeURIComponent(kv[1]);
            } else {
                val = '';
            }
            parts[decodeURIComponent(kv[0])] = val;
        }
    });
    return parts;
}
function cleanAmpUrl(parts, force) {
    if (!force && !isAmp(parts)) {
        return parts;
    }
    var hashParts = parseSearch(parts.hash.replace(/^\#/, ''));
    if (hashParts.ampshare) {
        var shareParts = urlParts(hashParts.ampshare);
        if (shareParts) {
            return cleanAmpUrl(shareParts, true);
        }
    }
    var ampOrig = matchAmpProject(parts) || matchAmpViewer(parts);
    if (ampOrig) {
        var ampOrigParts = urlParts('https://' + ampOrig[1]);
        if (ampOrigParts) {
            return cleanAmpUrl(ampOrigParts, true);
        }
    }
    delete hashParts.referrer;
    delete hashParts.amp_tf;
    parts.hash = paramsToString((0, _entries2.default)(hashParts));
    // These are site dependent, but are probably a safe bet at this point until proven otherwise
    // 1. strip ?amp (e.g. independent.co.uk)
    parts = filterSearchParams(parts, ['amp']);
    return parts;
}
function matchAmpProject(parts) {
    if (parts.hostname.match(/\.ampproject\.org$/i)) {
        return parts.pathname.match(/^\/v\/s\/(.*)?$/);
    }
}
function matchAmpViewer(parts) {
    if (parts.hostname.match(/(?:^|\.)google\.(com|(co\.uk))$/i)) {
        return parts.pathname.match(/^\/amp\/(?:s\/)?(.*)?$/);
    }
}
function isAmp(parts) {
    if (matchAmpProject(parts) || matchAmpViewer(parts)) {
        return true;
    }
    if (parts.searchParams) {
        if (parts.searchParams.has('amp_js_v') && parts.searchParams.has('amp_gsa')) {
            return true;
        }
        return false;
    }

    var parsedParts = parseSearch(parts.search);
    if ('amp_js_v' in parsedParts && 'amp_gsa' in parsedParts && 'amp' in parsedParts) {
        return true;
    }
    return false;
}

function isCurrentUrl(urlParts) {
    return urlParts.protocol === window.location.protocol && urlParts.hostname === window.location.hostname && (urlParts.pathname === window.location.pathname || !!urlParts.pathname.match(/^\/(irc(\/|$)|!|$)/));
}

function isHash(url) {
    return url.match(HASH_RE);
}
function isPath(url) {
    return url.match(SLASH_RE);
}
function isSearch(url) {
    return url.match(SEARCH_RE);
}

function urlParts(url) {
    var parts = void 0;
    // http://url.spec.whatwg.org/
    try {
        if (!url) {
            parts = new window.URL(window.location.href);
        } else if (isHash(url)) {
            parts = new window.URL(window.location.href);
            parts.pathname = '/';
            parts.hash = url;
        } else if (isSearch(url)) {
            parts = new window.URL(window.location.href);
            parts.pathname = '/';
            parts.search = url;
            parts.hash = '';
        } else if (isPath(url)) {
            parts = new window.URL(window.location.href);
            parts.pathname = url;
            parts.hash = '';
        } else {
            parts = new window.URL(url);
            // Try accessing href to trigger Incorrect function exception
            // in Edge for urls like http:/google.com
            // that have <Permission Denied> values
            parts.href;
        }
    } catch (exc) {
        // debug.warn('Failed to make URL', url, exc);
        return;
    }
    return parts;
}

// The right-to-left override character can allow domain spoofing when rendered before and within a URL
// escape it to prevent that. This works hand in hand with the following css rule on links:
// direction: ltr;
// unicode-bidi: isolate-override;
function escapeRTLO(url) {
    return url.replace(/\u202e/g, '%E2%80%AE');
}

function toHttps(url) {
    return url.replace(/^http:/g, 'https:');
}

function filterSearchParams(parts, keysToDrop) {
    if (parts.searchParams) {
        keysToDrop.forEach(function (k) {
            if (parts.searchParams.has(k)) {
                parts.searchParams.delete(k);
            }
        });
        return parts;
    }

    var search = parts.search.replace(/^\?/, '');
    var parsedParts = [];
    if (search) {
        search.split('&').forEach(function (kv) {
            var i = kv.indexOf('=');
            var k = void 0,
                v = void 0;
            if (i === -1) {
                k = kv;
                v = '';
            } else {
                k = kv.slice(0, i);
                v = kv.slice(i + 1);
            }
            if (!keysToDrop.includes(k)) {
                parsedParts.push([k, v]);
            }
        });
    }
    parts.search = paramsToString(parsedParts);
    return parts;
}

function paramsToString(searchParams) {
    var parts = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(searchParams), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

            var k = _ref2[0];
            var v = _ref2[1];

            var val = encodeURIComponent(k);
            if (v) {
                val += '=' + encodeURIComponent(v);
            }
            parts.push(val);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return parts.join('&');
}

/***/ }),

/***/ "Dudk":
/***/ (function(module, exports, __webpack_require__) {

var StreamHandler = __webpack_require__("oPQz");
var util = __webpack_require__("GmLC");


var XHRStreamHandler = function (url) {
    StreamHandler.call(this);
    this.url = url;
    this.xhr = new XMLHttpRequest();
    
    this._initXhr();
    debug.log('XHR', 'construct', this.url, this.xhr);
};
XHRStreamHandler.UNSENT = 0;
XHRStreamHandler.OPENED = 1;
XHRStreamHandler.HEADERS_RECEIVED = 2;
XHRStreamHandler.LOADING = 3;
XHRStreamHandler.DONE = 4;
XHRStreamHandler.prototype = util.inherit(StreamHandler, {
    getHandler: function () {
        return this.xhr;
    },
    isOpen: function () {
        return this._getReadyState() > XHRStreamHandler.UNSENT && this._getReadyState() < XHRStreamHandler.DONE;
    },
    isConnecting: function () {
        return this._getReadyState() == XHRStreamHandler.OPENED;
    },
    isSocket: function () {
        return this.isConnecting() || this.isOpen();
    },
    _getHost: function () {
        this.setQueryParam('ts', util.ts());
        return this.url + this.getQueryString();
    },
    connect: function () {
        var host = this._getHost();
        debug.log('XHR', 'connect');
        this._responseOffset = 0;
        this.errored = null;
        try {
            this.xhr.open('GET', host);
            this.xhr.send(null);
            debug.log('XHR', 'send request', this.xhr);
        } catch (exc) {
            debug.group('stream connection error');
            debug.error('XHR failed', exc.message, exc.fileName + ' [line '+exc.lineNumber+']');
            this.onConnectionError();
            debug.groupEnd();
        }
    },
    close: function (error) {
        if (!this.xhr) {
            debug.warn('No XHR to abort');
            return;
        }
        debug.log('XHR', 'close', this.xhr, '(readyState: ' + this._getReadyState() + ' status: ' + this._getStatus() + ')');
        if (error) {
            this.errored = true;
        }
        this.xhr.abort();
    },
    _initXhr: function () {
        // Setup XMLHttpRequest
        var self = this;
        this.xhr.onreadystatechange = function xhrOnReadyStateChange () {
            self._onReadyStateChange();
        };
        this.xhr.onerror = function xhrOnError (e) {
            debug.group('stream error');
            debug.warn('XHR', 'onerror', e, self.xhr, '(status: ' + self._getStatus() + ')');
            self._onData();
            self.onError();
            self.onDisconnect();
            debug.groupEnd();
        };
        this.xhr.onabort = function xhrOnAbort (e) {
            debug.group('stream abort');
            debug.log('XHR', 'onabort', e, self.xhr, '(status: ' + self._getStatus() + ')');
            self._onData();
            if (self.errored ||self._getStatus() != 200) {
                self.onError();
            }
            self.onDisconnect();
            debug.groupEnd();
        };
        this.xhr.onload = function xhrOnLoad (e) {
            debug.group('stream close');
            debug.log('XHR', 'onload', e, self.xhr, '(status: ' + self._getStatus() + ')');
            self._onData();
            if (self._getStatus() != 200) {
                self.onError();
            }
            self.onDisconnect();
            debug.groupEnd();
        };
    },
    _parseChunk: function (chunk) {
        // Loop through lines
        var msgs = chunk.split('\n');
        var self = this;
        _.each(msgs, function parseChunk (msg, i) {
            if (msg) {
                var message;
                try {
                    message = self.parseJsonMessage(msg);
                } catch (e) {
                    // Incomplete line, reset the offset
                    self._responseOffset -= msg.length;
                    return false; // break
                }
                self.onMessage(message);
            }
            return true;
        });
    },
    
    _getStatus: function () {
        if (this.xhr) {
            return this.xhr.status;
        }
    },
    _getReadyState: function () {
        if (this.xhr) {
            return this.xhr.readyState;
        }
    },
    
    _onData: function () {
        this.reset();
        // this.xhr.responseText always contains the full response since we started streaming
        // Seek to the last offset in the text and update the offset
        var chunk = this.xhr.responseText.substr(this._responseOffset);
        this._responseOffset += chunk.length;
        // Parse the chunk
        this._parseChunk(chunk);
    },
    _onReadyStateChange: function () {
        // 0: The object has been created, but not initialized (the open method has not been called).
        // 1: A request has been opened, but the send method has not been called.
        // 2: The send method has been called. No data is available yet.
        // 3: Some data has been received; however, neither responseText nor responseBody is available.
        // 4: All the data has been received.
        if (this._getReadyState() == 2) {
            this.trigger('connected');
        }
        if (this._getReadyState() == 3 && this._getStatus() == 200) {
            this._onData();
        }
    }
});


module.exports = XHRStreamHandler;


/***/ }),

/***/ "DyWj":
/***/ (function(module, exports) {

var Topic = Backbone.Model.extend({
    getTime: function () {
        if (this.get('time') > 0) {
            return new Date(this.get('time'));
        }
    },
    getText: function () {
        return this.get('topic');
    }
});


module.exports = Topic;


/***/ }),

/***/ "E+Fz":
/***/ (function(module, exports, __webpack_require__) {

var BufferView = __webpack_require__("uiw5");
var NetworkEditor = __webpack_require__("0xAE");
var ServerLogStatusView = __webpack_require__("/KSs");


var ServerLogView = BufferView.extend({
    className: BufferView.prototype.className + ' server',
    initialize: function (options) {
        this.status = new ServerLogStatusView(options);
        
        this.editorVisible = false;
        this.listenTo(this.model.connection, 'showEdit', this.showEdit);
        
        BufferView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, BufferView.prototype.events, {
        'buttonClick button.edit': 'clickEdit'
    }),
    render: function () {
        BufferView.prototype.render.apply(this, arguments);
        
        this.renderCollapseDisconnects(true);
        // Use wrapper functions so the event args aren't passed along
        this.model.bind('prefChange:expandDisco', function () {
            this.renderCollapseDisconnects();
        }, this);
        
        return this;
    },
    clickEdit: function (e) {
        e.preventDefault();
        this.toggleEdit();
        return false;
    },
    renderCollapseDisconnects: function (initial) {
        var pinBottom;
        if (!initial) {
            pinBottom = this.scroll.isScrolledToBottom();
        }
        $(this.el).toggleClass('expandDisco', !this.model.isCollapsingDisconnects());
        if (!initial) {
            this.scroll.onChange(pinBottom);
        }
        return this;
    },
    renderConnectionStatus: function () {
        $(this.el).toggleClass('loading', this.model.connection.isConnecting());
        $(this.el).toggleClass('failed', this.model.connection.isFailed());
        $(this.el).toggleClass('badRetry', this.model.connection.badRetry());
        return BufferView.prototype.renderConnectionStatus.apply(this, arguments);
    },
    renderConnectionDetails: function () {
        $(this.el).toggleClass('ssl', this.model.connection.isSSL());
        this.status.renderConnectionDetails();
        if (this.editor && !this.isEditorVisible()) {
            this.editor.setConnection(this.model.connection);
            this.editor.setNickname(this.model.connection.getNick());
        }
    },
    makeEditor: function () {
        // Make a network editor
        var idPrefix = "editServer" + this.model.connection.getCid();
        return new NetworkEditor({
            model: this.model,
            session: this.model.session,
            action: _.bind(this.model.connection.edit, this.model.connection),
            callback: _.bind(function (response) {
                if (response.success) {
                    this.hideEdit();
                }
            }, this),
            className: 'addNetworkForm editNetworkForm',
            classPrefix: "addNetwork",
            id: idPrefix + 'Form',
            idPrefix: idPrefix,
            submitLabel: "Save",
            cancel: _.bind(this.hideEdit, this),
            afterSubmit: [
                $('<span class="explanation">').text('Changing your real name or any of the host settings requires a reconnect'),
                $('<input type="hidden" name="cid">').val(this.model.connection.getCid())
            ],
            cellGroups: [
                NetworkEditor.CELL_GROUPS.netname,
                NetworkEditor.CELL_GROUPS.network,
                NetworkEditor.CELL_GROUPS.identity,
                NetworkEditor.CELL_GROUPS.advanced
            ]
        }, this);
    },
    makeSlackOAuthEditor: function () {
        var idPrefix = "editServer" + this.model.connection.getCid();
        return new NetworkEditor({
            model: this.model,
            session: this.model.session,
            action: _.bind(this.model.connection.editName, this.model.connection),
            prepareFormData: _.bind(function (data) {
                return data.netname;
            }),
            callback: _.bind(function (response) {
                if (response.success) {
                    this.hideEdit();
                }
            }, this),
            className: 'addNetworkForm editNetworkForm',
            classPrefix: "addNetwork",
            id: idPrefix + 'Form',
            idPrefix: idPrefix,
            submitLabel: "Save",
            cancel: _.bind(this.hideEdit, this),
            afterSubmit: [
                $('<input type="hidden" name="cid">').val(this.model.connection.getCid())
            ],
            cellGroups: [
                NetworkEditor.CELL_GROUPS.netname
            ]
        }, this);
    },
    initEditor: function () {
        if (this.editor) {
            this.editor.remove();
            this.editorOverlay.remove();
        }
        if (this.model.connection.isSlackOAuth()) {
            this.editor = this.makeSlackOAuthEditor();
        } else {
            this.editor = this.makeEditor();
        }
        this.editorOverlay = $('<div class="editNetworkOverlay">').append(this.editor.render().el);
        this.$('div.viewport').append(this.editorOverlay);
        this.editor.renderSelectComplete($(this.el));
    },
    postrender: function () {
        this.initEditor();
        this.renderConnectionDetails();
        this.listenTo(this.model.connection, 'change:slack', this.initEditor);
        this.listenTo(this.model.connection, 'change', this.renderConnectionDetails);
    },
    toggleEdit: function () {
        if (this.isEditorVisible()) {
            this.hideEdit();
        } else {
            this.showEdit();
        }
    },
    isEditorVisible: function () {
        return this.editorVisible;
    },
    showEdit: function (withAdvanced, focusInput) {
        if (!this.isEditorVisible()) {
            if (this.editor) {
                this.editor.triggerLoad();
                this.editorOverlay.slideDown('fast', _.bind(function () {
                    if (withAdvanced) {
                        this.editor.toggleCollapsed('Advanced');
                    }
                    if (focusInput) {
                        this.editor.focusInput(focusInput);
                    } else if (this.model.connection.isSlackOAuth()) {
                        this.editor.focusNetname();
                    } else {
                        this.editor.focusNetwork();
                    }
                }, this));
            }
            this.editorVisible = true;
            this.mainTopChange();
        }
    },
    hideEdit: function () {
        if (this.isEditorVisible()) {
            if (this.editor) {
                this.editorOverlay.slideUp('fast');
            }
            this.editorVisible = false;
            this.mainTopChange();
        }
    }
});


module.exports = ServerLogView;


/***/ }),

/***/ "EAmV":
/***/ (function(module, exports, __webpack_require__) {

var ChildContextMenuView = __webpack_require__("SbjP");


var ChannelContextMenuView = ChildContextMenuView.extend({
    el: '#channelContextMenu',
    initialize: function (options) {
        this.mode = this.$('.modeLine');
        this.modeList = this.$('.modeList');
        this.modActions = this.$('.modAction');
        
        ChildContextMenuView.prototype.initialize.call(this, options);
    },
    events: $.extend({}, ChildContextMenuView.prototype.events, {
        'buttonClick button.topic': 'clickTopic',
        'buttonClick button.invite': 'clickInvite',
        'buttonClick button.leave': 'clickLeave',
        'buttonClick button.rejoin': 'clickRejoin',
        'buttonClick button.bans': 'clickBans',
        'buttonClick button.members': 'clickMembers',
        'buttonClick button.notifyAll': 'clickNotifyAll',
        'buttonClick button.rename': 'clickRename',
        'buttonClick button.delete': 'clickDelete'
    }),
    clickTopic: function (e) {
        e.preventDefault();
        if (this.buffer.canSetTopic()) {
            this.hide();
            this.buffer.trigger('topicPrompt');
            this.clearContext();
        }
    },
    clickInvite: function (e) {
        e.preventDefault();
        var org = this.buffer.connection.getOrg();
        if (org) {
            if (org.isAdmin()) {
                this.hide();
                this.buffer.session.trigger('navigate', '?/team=' + org.id, {trigger: true});
                this.clearContext();
            }
        } else if (this.buffer.isActive()) {
            this.hide();
            this.buffer.trigger('invitePrompt');
            this.clearContext();
        }
    },
    clickLeave: function (e) {
        e.preventDefault();
        if (this.buffer.isActive()) {
            this.hide();
            this.buffer.part();
            this.clearContext();
        }
    },
    clickRejoin: function (e) {
        e.preventDefault();
        if (!this.buffer.isActive()) {
            this.hide();
            this.buffer.join();
            this.clearContext();
        }
    },
    clickBans: function (e) {
        e.preventDefault();
        if (this.buffer.isActive()) {
            this.hide();
            this.buffer.banList();
            this.clearContext();
        }
    },
    clickMembers: function (e) {        
        e.preventDefault();        
        if (this.buffer.isActive()) {      
            this.hide();
            this.buffer.setShowMembersPref(!this.buffer.shouldShowMemberList());
            this.clearContext();
        }
    },
    clickNotifyAll: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setNotifyAllPref(!this.buffer.shouldNotifyAll());
        this.clearContext();
    },
    clickRename: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('renamePrompt', this.buffer.getName());
        this.clearContext();
    },
    clickDelete: function (e) {
        this.hide();
        this.buffer.trigger('deleteConfirm');
        this.clearContext();
        return false;
    },
    setModeInfo: function () {
        this.mode.empty();
        this.modeList.empty();
        if (this.buffer.modeString) {
            this.mode.html("Mode: +" + this.formatter.render(this.buffer.modeString)).show();
            if (this.buffer.hasMode('i')) {
                this.modeList.append($('<li class="inviteOnly">').text('Invite-only (i)'));
            }
            if (this.buffer.isPassworded()) {
                this.modeList.append($('<li class="password">').html('Password: ' + this.formatter.render(this.buffer.getKey()) + ' (k)'));
            }
            if (this.buffer.hasMode('l')) {
                this.modeList.append($('<li class="limited">').text('Limited to ' + this.buffer.getMode('l') + ' members (l)'));
            }
            if (this.buffer.hasMode('m')) {
                this.modeList.append($('<li class="moderated">').text('Moderated: Only ops and voiced members may talk (m)'));
            }
            if (this.buffer.hasMode('n')) {
                this.modeList.append($('<li class="noExternal">').text('No messages allowed from outside the channel (n)'));
            }
            if (this.buffer.hasMode('p')) {
                this.modeList.append($('<li class="private">').text('Private: Membership is only visible to other members (p)'));
            }
            if (this.buffer.hasMode('s')) {
                this.modeList.append($('<li class="secret">').text('Secret: This channel is unlisted and membership is only visible to other members (s)'));
            }
            if (this.buffer.hasMode('t')) {
                this.modeList.append($('<li class="topicControl">').text('Only ops can set the topic (t)'));
            }
            
            this.mode.show();
            this.modeList.show();
        } else {
            this.mode.hide();
            this.modeList.hide();
        }
    },
    onShow: function () {
        // Mode
        this.setModeInfo();
        
        // Leave/rejoin
        this.deactivateItem(this.$('li.leave'), !this.buffer.isActive(), true);
        this.deactivateItem(this.$('li.rejoin'), this.buffer.isActive(), true);
        this.deactivateItem(this.$('li.rename'), this.buffer.isActive(), true);
        
        // Invite
        var org = this.buffer.connection.getOrg();
        var canInvite = org ? org.isAdmin() : true;
        this.deactivateItem(this.$('li.invite'), !canInvite, true);
        
        // Topic control
        this.deactivateItem(this.$('li.topic'), !this.buffer.canSetTopic());
        
        // Members list
        this.enableItem(this.$('li.showMembers'), this.buffer.shouldShowMemberList());
        
        // Notify on all messages
        this.enableItem(this.$('li.notifyAll'), this.buffer.shouldNotifyAll());
        this.deactivateItem(this.$('li.notifyAll'), this.buffer.isSlackMultiPersonDm(), true);

        
        // Mod actions
        var isMod = this.buffer.isMod();
        this.deactivateItem(this.modActions, !isMod, true);
        
        ChildContextMenuView.prototype.onShow.call(this);
    }
});


module.exports = ChannelContextMenuView;


/***/ }),

/***/ "ER68":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");
var PastebinView = __webpack_require__("0bCg");


var PastebinDialogView = DialogView.extend({
    el: '#pastebinContainer',
    initialize: function (options) {
        this.form = $('#pastebinForm');
        this.pastebinSelect = this.$('.pastebinSelect');
        this.pastebinWrapper = this.$('.pastebinWrapper');
        this.nameInput = $('#pastePreviewName');
        this.messageInput = $('#pastePreviewMessage');
        
        this.askContainer = $('#pasteConfirmAskContainer');
        this.askCheckbox = $('#pasteConfirmAsk');
        

        this.init();
        this.afterHide = _.bind(this.init, this);

        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit #pastebinForm': 'submit',
        'buttonClick .sendAsText': 'clickSendAsText',
        'keydown': 'keyDown',
    }),
    init: function () {
        if (this.onCancel && (!this.confirmed || this.errored)) {
            this.onCancel();
        }
        this.onCancel = null;
        this.confirmed = null;
        this.errored = null;

        this.buffer = null;
        this.options = null;
        this.pbv = null;

        this.pastebinSelect.empty();
        this.pastebinWrapper.empty();
        this.nameInput.val('');
        this.messageInput.val('');
        this.enableForm();
    },
    keyDown: function (e) {
        if (e.shiftKey && e.keyCode == 13) { // shift+enter
            this.clickSendAsText(e);
        }
    },
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.$('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.$('input, button, textarea').prop('disabled', false);
        }
    },
    submit: function (e) {
        e.preventDefault();
        var data = this.form.serializeForm();
        this.disableForm();
        this.options.message = data.message;
        this.options.name = data.name;
        this.savePastebin(this.options, this.buffer);
    },
    clickSendAsText: function (e) {
        e.preventDefault();
        var focused = this.$(':focus');
        this.$el.hide();
        this.closed();
        this.buffer.say(this.pbv.editorContents(), {
            onConfirm: _.bind(function () {
                this.opened();
                this.done();
            }, this),
            onCancel: _.bind(function () {
                this.$el.show();
                this.opened();
                focused.focus();
            }, this) 
        });
    },
    done: function () {
        this.confirmed = true;
        this.hide();
    },
    savePastebin: function (options, buffer) {
        var pbv = this.pbv;
        pbv.save(options.name, _.bind(function (response) {
            if (response.success) {
                var msg = pbv.model.getUrl();
                if (options.message) {
                    msg = options.message + ' ' + msg;
                }
                buffer.say(msg);
            } else {
                this.errored = true;
                buffer.trigger('postError', response);
            }
            this.done();
        }, this));
    },
    makePaste: function () {
        var paste = {
            body: this.options.contents
        };
        if (this.options.file) {
            this.options.name = this.options.file.name;
            paste.name = this.options.file.name;
        }
        return PastebinView.fromPaste(paste, this.model);
    },
    show: function (buffer, options, onCancel) {
        this.buffer = buffer;
        this.options = options || {};

        this.onCancel = onCancel;

        this.pbv = this.makePaste();
        if (this.pbv.model.isTooLarge()) {
            this.errored = true;
            this.buffer.trigger('postError', {message: 'paste_too_large'});
        } else if (this.options.immediate) {
            delete this.options.message;
            this.savePastebin(this.options, this.buffer);
        } else {
            this.render();
            DialogView.prototype.show.call(this);
        }
    },
    render: function () {
        this.nameInput.val(this.options.name);
        
        this.pbv.render({editable: true});
        this.pbv.renderSyntaxSelect(this.nameInput);
        this.messageInput.val(this.options.message);

        this.pastebinSelect.append(this.pbv.select);

        this.pastebinWrapper.append(this.pbv.el);
        
        this.askContainer.toggle(!this.options.manual);
        
        this.askCheckbox.off('change');
        this.askCheckbox.prop('checked', this.model.shouldPromptPastebins());
        this.askCheckbox.on('change', _.bind(function (e) {
            e.preventDefault();
            var value = this.askCheckbox.prop('checked');
            this.model.setPastebinPrompts(value);
        }, this));

        var pbv = this.pbv;
        this.afterShow = _.bind(function () {
            if (this.options.contents) {
                this.nameInput.focus().select();
            } else {
                pbv.focusEditor();
            }
        }, this);
    }
});


module.exports = PastebinDialogView;


/***/ }),

/***/ "ET1g":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");
var FileWrapper = __webpack_require__("JHsc");


var FileUploadDialogView = DialogView.extend({
    el: '#fileUploadContainer',
    initialize: function (options) {
        this.form = $('#fileUploadForm');

        this.batch = this.$('.batch');
        this.tree = this.$('.treeContainer');
        this.maxUploadBatchInfo = this.$('.maxUploadBatchInfo');
        this.maxUploadBatch = this.$('.maxUploadBatch');

        this.single = this.$('.single');
        this.previewWrapper = this.$('.previewWrapper');
        this.heading = this.$('.heading');
        this.info = this.$('.info');
        this.dropped = this.$('.dropped');
        this.nameInput = $('#uploadPreviewName');
        
        this.messageInput = $('#uploadPreviewMessage');

        this.sendAsText = this.$('.sendAsText');

        this.init();
        this.afterHide = _.bind(this.init, this);

        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit #fileUploadForm': 'submitPreview',
        'buttonClick .sendAsText': 'clickSendAsText'
    }),
    init: function () {
        if (this.onCancel && !this.confirmed) {
            this.onCancel();
        }
        this.buffer = null;
        this.onConfirm = null;
        this.onCancel = null;
        this.confirmed = null;

        this.renderHeading();

        this.$el.removeClass('batch');

        this.batch.hide();
        this.tree.empty();
        this.maxUploadBatchInfo.hide();

        this.single.hide();
        this.previewWrapper.empty();
        this.info.empty();
        this.dropped.hide();
        this.sendAsText.hide();
        this.nameInput.val('');
        this.messageInput.val('');
        this.enableForm();
    },
    renderHeading: function (buffer, multiple) {
        var file = multiple ? 'files' : 'a file';
        var base = 'Upload ' + file;
        if (buffer) {
            this.heading.text(base + ' to ' + buffer.getTitle());
        } else {
            this.heading.text(base);
        }
    },
    
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.$('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.$('input, button, textarea').prop('disabled', false);
        }
    },
    submitPreview: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }
        var data = this.form.serializeForm();
        this.disableForm();
        this.onConfirm(data);
        this.done();
    },
    clickSendAsText: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }
        this.disableForm();
        this.buffer.say(this.options.dataURI);
        this.done();
    },
    done: function () {
        this.confirmed = true;
        this.hide();
    },
    showBatch: function (fileTree, buffer, options, onConfirm, onCancel) {
        this.renderBatchPreviewForm(fileTree, options);
        this.renderHeading(buffer, true);
        this.afterShow = _.bind(function () {
            this.messageInput.focus().select();
        }, this);
        this.show(buffer, options, onConfirm, onCancel);
    },
    showSingle: function (fileView, buffer, options, onConfirm, onCancel) {
        this.renderSinglePreviewForm(fileView, options);
        this.renderHeading(buffer);
        this.afterShow = _.bind(function () {
            this.nameInput.focus().select();
        }, this);
        this.show(buffer, options, onConfirm, onCancel);
    },
    show: function (buffer, options, onConfirm, onCancel) {
        this.buffer = buffer;
        this.options = options;
        this.onConfirm = onConfirm;
        this.onCancel = onCancel;

        if (this.options.message) {
            this.messageInput.val(this.options.message);
        }
        this.sendAsText.toggle(!!this.options.dataURI);
        this.dropped.toggle(!this.options.dropped);

        DialogView.prototype.show.call(this);
    },
    renderBatchPreviewForm: function (fileTree, options) {
        this.$el.addClass('batch');

        this.tree.append(fileTree);

        if (options.truncated) {
            this.maxUploadBatch.text(FileWrapper.MAX_UPLOAD_BATCH);
            this.maxUploadBatchInfo.show();
        }

        this.batch.show();
    },
    renderSinglePreviewForm: function (fileView, options) {
        fileView.renderLocalPreview().done(_.bind(function (preview) {
            this.previewWrapper.append(preview);
        }, this));
        
        this.nameInput.val(fileView.model.getName());

        this.info.text(fileView.model.getSize() + ' • ' + fileView.model.getType());

        this.single.show();
    }
});


module.exports = FileUploadDialogView;


/***/ }),

/***/ "Eh61":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EjYC":
/***/ (function(module, exports, __webpack_require__) {

var Keyboard = __webpack_require__("fDhS").default;


var DialogView = $.extend(Backbone.View.extend({
    hideInstant: false,
    showInstant: false,
    closeOnClickOff: false,
    closeOnEsc: true,
    initialize: function (options) {
        this.visible = false;

        _.bindAll(this, 'hide');
    },
    events: {
        'click a.close': 'clickClose',
        'buttonClick button.close': 'clickClose'
    },
    clickClose: function (e) {
        e.preventDefault();
        this.hide();
    },
    isVisible: function () {
        return this.visible;
    },

    toggle: function () {
        if (this.isVisible()) {
            this.hide();
        } else {
            this.show();
        }
        return this;
    },

    doAfterShow: function () {
        if (this.afterShow) {
            this.afterShow();
        }
    },

    triggerOpen: function () {
        this.trigger('open');
        DialogView.trigger('open', this);
    },

    show: function (instant) {
        if (this.isVisible()) {
            this.setCurrent();
            this.doAfterShow();
            this.triggerOpen();
            return;
        }
        if (this.showInstant || instant) {
            this.$el.show();
            this.doAfterShow();
            this.opened();
        } else {
            this.$el.fadeIn('fast', _.bind(function () {
                this.doAfterShow();
                this.opened();
            }, this));
        }
        return this;
    },
    bindClickOff: function () {
        this.clickOffHandler = _.bind(this.clickOff, this);
        $(document).on('click', this.clickOffHandler);
    },
    bindEsc: function () {
        this.escHandler = _.bind(this.esc, this);
        $(document).on('keydown', this.escHandler);
    },
    unbindClickOff: function () {
        if (this.clickOffHandler) {
            $(document).off('click', this.clickOffHandler);
            this.clickOffHandler = null;
        }
    },
    unbindEsc: function () {
        if (this.escHandler) {
            $(document).off('keydown', this.escHandler);
            this.escHandler = null;
        }
    },
    clickOff: function (e) {
        if (!this.isVisible()) {
            return true;
        }
        // Hide if they click off
        var root = this.clickOffRoot || this.$el;
        if (e.target !== root.get(0) && !$.contains(root.get(0), e.target)) {
            this.hideClickOff();
        }
        return true;
    },
    esc: function (e) {
        // Hide if they hit escape
        if (e.which == Keyboard.KEYS.ESC) {
            if (!this.isVisible()) {
                return true;
            }
            this.hideEsc();
            return false;
        }
        return true;
    },
    hideEsc: function () {
        var close = this.$('.mainClose');
        if (!close.length) {
            close = this.$('.close:not([disabled])');
        }
        close.addClass('active').delay(50).queue(function () {
            $(this).removeClass('active').dequeue();
        });
        this._hideEsc();
    },
    _hideEsc: function () {
        this.hide();
    },
    hideClickOff: function () {
        this.hide();
    },
    hide: function (instant) {
        if (!this.isVisible()) {
            return;
        }
        if (this.hideInstant || instant) {
            this.$el.hide();
            if (this.afterHide) {
                this.afterHide();
            }
            this.closed();
        } else {
            this.$el.fadeOut('fast', _.bind(function () {
                if (this.afterHide) {
                    this.afterHide();
                }
                this.closed();
            }, this));
        }
        return this;
    },
    setCurrent: function () {
        if (DialogView.current != this) {
            DialogView.current = this;
        }
    },
    opened: function () {
        this.setCurrent();
        this.visible = true;
        if (this.closeOnClickOff) {
            this.bindClickOff();
        }
        if (this.closeOnEsc) {
            this.bindEsc();
        }
        DialogView.open = true;
        this.triggerOpen();
    },
    closed: function () {
        this.visible = false;
        if (this.closeOnClickOff) {
            this.unbindClickOff();
        }
        if (this.closeOnEsc) {
            this.unbindEsc();
        }
        if (DialogView.current == this) {
            DialogView.open = false;
            DialogView.current = null;
        }
        this.trigger('close');
        DialogView.trigger('close', this);
    }
}, {
    closeCurrent: function () {
        if (DialogView.current) {
            DialogView.current.hide();
        }
    }
}), Backbone.Events);


module.exports = DialogView;


/***/ }),

/***/ "FFQa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _topPrompt = __webpack_require__("+E2x");

var _topPrompt2 = _interopRequireDefault(_topPrompt);

var _topPrompt3 = __webpack_require__("b9V4");

var _topPrompt4 = _interopRequireDefault(_topPrompt3);

var _dialogview = __webpack_require__("EjYC");

var _dialogview2 = _interopRequireDefault(_dialogview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
    template: _topPrompt2.default,
    el: '.topMessage',
    initialize: function initialize(options) {
        this.listenTo(this.model, 'init', this.init);
        // this.dialog = new DialogView({
        //     el: '#gdprContainer'
        // });
    },

    events: {
        'buttonClick .topMessage__confirm': 'onConfirm',
        'buttonClick .topMessage__dismiss': 'onDismiss'
    },
    getTemplateData: function getTemplateData() {
        return {
            messagePrompt: "We updated our pricing for new subscriptions on January 9th 2023",
            confirmText: 'Read the full announcement',
            dismissText: 'Dismiss'
        };
    },
    render: function render() {
        this.$el.html(this.template(this.getTemplateData()));
        return this;
    },
    show: function show() {
        this.$el.addClass('topMessage--show');
    },
    hide: function hide() {
        this.$el.removeClass('topMessage--show');
    },
    onConfirm: function onConfirm(e) {
        window.open('https://blog.irccloud.com/2023-price-increase/');
        // this.dialog.show();
    },
    onDismiss: function onDismiss(e) {
        e.preventDefault();
        this.model.setPrompted('pricing_2023');
        this.hide();
    },
    shouldShow: function shouldShow() {
        return false;
        // if (this.model.hasBeenPrompted('pricing_2023')) {
        //     return false;
        // }
        // return true;
    },
    init: function init(inited) {
        this.render();
        if (this.shouldShow()) {
            this.show();
            this.trigger('layoutChange');
        }
    }
});

/***/ }),

/***/ "FHm1":
/***/ (function(module, exports, __webpack_require__) {

var AddNetworkView = __webpack_require__("f6UI");
var SettingsView = __webpack_require__("ZAC8");
var TopPrompt = __webpack_require__("FFQa").default;
var SessionPromptHandler = __webpack_require__("Sirl");
var ConnectionPromptHandler = __webpack_require__("2rjW");
var ConversationPromptHandler = __webpack_require__("X9Qn");
var ChannelPromptHandler = __webpack_require__("z+V+");
var BufferNotificationHandler = __webpack_require__("LKWs");
var BufferOverlayHandler = __webpack_require__("C3KD");
var ChannelView = __webpack_require__("OzoI");
var ConversationView = __webpack_require__("TP0+");
var DialogView = __webpack_require__("EjYC");
var ServerLogView = __webpack_require__("E+Fz");
var Thread = __webpack_require__("ptDp");
var ThreadView = __webpack_require__("t2v7");
var Keyboard = __webpack_require__("fDhS").default;


var MainAreaView = Backbone.View.extend({
    el: '#mainwrapper',
    initialize: function (options) {
        this.timeContainer = $('#timeContainer');

        this.addNetwork = new AddNetworkView(options);
        this.settings = new SettingsView(options);
        this.topPrompt = new TopPrompt(options);
        this.topPrompt.on('layoutChange', this.timeLayoutChange, this);

        var promptHandler = new SessionPromptHandler(options);
        promptHandler.on('addOverlay', this.renderCurrentOverlay, this);

        this.model.on('currentBufferChange', this.currentBufferChange, this);
        this.model.on('doneLoading', this.doneLoading, this);

        this.model.buffers.on('add', this.bufferAdded, this);
        this.model.buffers.on('selectedChange', this.bufferSelectedChange, this);
        this.model.on('threadChange', this.renderThread, this);

        this.model.buffers.on('remove', this.bufferRemoved, this);
        this.model.buffers.on('reset', this.resetBuffers, this);

        this.bufferPanes = $('#bufferPanes');
        this.buffersContainer = $('#buffersContainer');
        this.threadContainer = $('#threadContainer');

        this.buffers = {};

        this.checkDelayedLoads();

        this.bindDocEvents();

        this.model.bind('focusChange', this.focusChange, this);

        this.renderTimeFrame();
    },
    bindDocEvents: function () {
        $(window).resize(_.bind(this.windowResize, this));
        $(document).on('paste keydown', _.bind(this.docKeyDown, this));
        $(document).on('keyup', _.bind(this.docKeyUp, this));
        $(document).on('click', _.bind(this.docClick, this));
        var selectionChange = _.debounce(_.bind(this.onSelectionChange, this), 200);
        $(document).on('selectionchange mouseup', selectionChange);
    },
    focusChange: function () {
        if (this.current) {
            this.current.focusChange();
        }
    },
    timeLayoutChange: function () {
        if (!(this.current && this.model.isBacklogLoaded())) {
            return;
        }
        var cell;
        var timeRight = true;
        if (this.current) {
            cell = this.current.timeCell;
            timeRight = this.current.buffer.isTimeRight();
        }
        var offset = cell.offset();
        this.timeContainer.css({
            'top': offset.top,
            'left': offset.left - (timeRight ? 0 : 4),
            'width': cell.width(),
            'height': cell.height(),
            'line-height': cell.height() + 'px',
            'text-align': timeRight ? 'left' : 'right'
        });
        this.renderTime();
        this.timeContainer.show();
    },
    renderTimeFrame: function () {
        var self = this;
        requestAnimationFrame(function () {
            self.renderTime();
            setTimeout(function () {
                self.renderTimeFrame();
            }, 500);
        });
    },
    renderTime: function () {
        if (!this.current) {
            return;
        }
        var date = new Date();

        var fullDateString = date.formatFullDate();
        if (this.lastFullDateString != fullDateString) {
            this.lastFullDateString = fullDateString;
            this.timeContainer.attr('title', fullDateString);
        }
        var dateString = date.formatTime();
        if (this.lastDateString != dateString) {
            this.lastDateString = dateString;
            this.timeContainer.text(dateString);
        }
    },
    windowResize: function (e) {
        if (this.current) {
            this.current.scroll.checkPinBottom(function (pinBottom) {
                this.current.scroll.setResizing();
                this.current.fullLayoutChange(pinBottom);
                this.timeLayoutChange();
            }, this, { checkRecent: true });
        }
        if (this.currentThread) {
            this.currentThread.scroll.checkPinBottom(function (pinBottom) {
                this.currentThread.scroll.setResizing();
                this.currentThread.fullLayoutChange(pinBottom);
            }, this, { checkRecent: true });
        }
    },
    handlePaste: function (e) {
        if (this.suppressPaste) {
            return;
        }
        this.current.input.collectPasteData(e).done(_.bind(function (e, strings, files) {
            this.pasteTimeout = setTimeout(_.bind(function () {
                if (this.current) {
                    this.current.input.handlePasteData(e, strings, files);
                    this.pasteTimeout = null;
                }
            }, this), 100);
        }, this));
    },
    cancelPaste: function () {
        if (this.pasteTimeout) {
            clearTimeout(this.pasteTimeout);
            this.pasteTimeout = null;
        } else {
            this.suppressPaste = true;
            setTimeout(_.bind(function () {
                this.suppressPaste = false;
            }, this), 200);
        }
    },
    docClick: function (e) {
        if (e.button == 1 && $(e.target).is('a')) {
            this.cancelPaste();
        }
    },
    onSelectionChange: function () {
        if (this.current) {
            this.current.trigger('textSelectionChange');
        }
    },
    docKeyDown: function (e) {
        if (e.which === Keyboard.KEYS.ESC) {
            if (this.current) {
                this.current.clearReplyHighlight(true);
            }
            if (this.current && this.current.scroll.inputInfo.isVisible()) {
                this.current.scroll.inputInfo.makeOriginalChoice();
            } else {
                if (e.shiftKey) {
                    this.model.markAllAsRead();
                } else if (this.model.currentBuffer) {
                    this.model.currentBuffer.read();
                }
                return false;
            }
        }
        if (!this.current) {
            return;
        }
        // Input focus
        var modifier = e.metaKey || e.ctrlKey || (e.which < 48 && e.which !== 0);
        if (!$(e.target).is('input, textarea') && !DialogView.open) {
            if (e.type == 'paste') {
                this.handlePaste(e);
            } else if (!modifier) {
                this.current.input.focus();
            }
        }
        // Scroll
        if (e.ctrlKey && e.altKey) { // holding ctrl + alt
            if (e.which === Keyboard.KEYS.LEFT) {
                this.current.scroll.scrollToLastSeenOrTop();
                return false;
            } else if (e.which === Keyboard.KEYS.RIGHT) {
                this.current.scroll.scrollToBottomSeenOrBottom();
                return false;
            }
        }
        this.current.trigger('docKeyDown', e);

        if (Keyboard.isModifier(e, true) && e.altKey && e.which == Keyboard.KEYS.R) {
            // CmdOrCtrl-Alt-R: reply
            if (!this.currentThread || !this.currentThread.input.isFocused()) {
                var last = this.model.currentBuffer.messages.lastReplyable();
                if (last) {
                    this.model.setThreadId(this.model.currentBuffer.threadId(last.getReplyId()));
                    return false;
                }
            }
        }
        if (Keyboard.isModifier(e, true) && e.altKey && e.which == Keyboard.KEYS.COMMA) {
            this.model.trigger('navigate', '?/settings', {trigger: true});
        }
        if (e.shiftKey && !e.altKey && _.include([Keyboard.KEYS.UP, Keyboard.KEYS.DOWN], e.which)) {
            var cycleRet = false;
            if (this.currentThread && this.currentThread.input.isFocused()) {
                cycleRet = this.currentThread.cycleReplyHighlights(e.which);
            }
            if (cycleRet === false) {
                cycleRet = this.current.cycleReplyHighlights(e.which);
            }
            if (cycleRet) {
                return false;
            }
        }
    },
    docKeyUp: function (e) {
        if (this.current) {
            this.current.trigger('docKeyUp', e);
        }
    },
    resetBuffers: function () {
        for (var bid in this.buffers) {
            this.buffers[bid].remove();
        }
        this.buffers = {};
    },
    bufferRemoved: function (buffer) {
        delete this.buffers[buffer.bid()];
    },
    bufferAdded: function (buffer) {
        var options = {
            model: buffer
        };
        var overlayHandler = new BufferOverlayHandler(options);
        overlayHandler.on('addOverlay', this.renderCurrentOverlay, this);
        new BufferNotificationHandler(options);
        var promptHandler;
        if (buffer.isServerLog()) {
            promptHandler = new ConnectionPromptHandler(options);
        } else if (buffer.isChannel()) {
            promptHandler = new ChannelPromptHandler(options);
        } else if (buffer.isConversation()) {
            promptHandler = new ConversationPromptHandler(options);
        }
        if (promptHandler) {
            promptHandler.on('addOverlay', this.renderCurrentOverlay, this);
        }
    },
    bufferSelectedChange: function (buffer) {
        if (buffer.isSelected()) {
            var view = this.renderBuffer(buffer);
            this.renderThread(true);

            this.current = view;
            this.timeLayoutChange();
        }
    },
    checkDelayedLoads: function () {
        var bufViews = _.values(this.buffers);
        if (this.currentThread) {
            bufViews.push(this.currentThread);
        }
        var boundOnLoads = _.map(bufViews, function (bufferView) {
            return bufferView.scroll.log.checkDelayedLoads();
        });
        _.each(boundOnLoads, function (bufBoundOnLoads) {
            _.each(bufBoundOnLoads, function (boundOnLoad) {
                if (boundOnLoad) {
                    boundOnLoad();
                }
            });
        });
        setTimeout(_.bind(this.checkDelayedLoads, this), 2000);
    },
    renderThread: function (bufSelected) {
        var pinBottom;
        if (!bufSelected) {
            pinBottom = this.current.scroll.shouldPinBottom();
        }
        if (this.model.threadId) {
            var parts = this.model.threadId.split('-');
            var bid = parts.shift();
            var threadId = parts.join('-');
            var buffer = this.model.buffers.get(bid);

            if (buffer) {
                var thread = new Thread({
                    id: threadId
                }, {
                    buffer: buffer,
                    connection: buffer.connection,
                    session: this.model
                });

                if (this.currentThread) {
                    if (this.currentThread.model.equals(thread)) {
                        this.currentThread.focusInput();
                        return true;
                    }
                    this.clearCurrentThread();
                }

                thread.init();

                var view = new ThreadView({
                    model: thread,
                    buffer: buffer
                });
                view.bind('timeLayoutChange', this.timeLayoutChange, this);
                this.threadContainer.append(view.el);
                this.currentThread = view;
                this.threadContainer.show();
                view.show();
                if (!bufSelected) {
                    view.focusInput();
                    this.current.fullLayoutChange(pinBottom);
                }
                return true;
            }
        }
        this.clearCurrentThread();
        if (!bufSelected) {
            this.current.fullLayoutChange(pinBottom);
        }
        return false;
    },
    clearCurrentThread: function () {
        this.threadContainer.hide();
        if (this.currentThread) {
            this.currentThread.model.delete();
            this.currentThread = null;
        }
    },
    renderBuffer: function (buffer) {
        if (!this.buffers[buffer.bid()]) {
            var options = {
                model: buffer
            };
            var view;
            if (buffer.isServerLog()) {
                view = new ServerLogView(options);
            } else if (buffer.isChannel()) {
                view = new ChannelView(options);
            } else if (buffer.isConversation()) {
                view = new ConversationView(options);
            }
            this.buffers[buffer.bid()] = view;

            view.bind('timeLayoutChange', this.timeLayoutChange, this);
            view.bind('addOverlay', this.renderCurrentOverlay, this);

            this.buffersContainer.append(view.el);
            view.renderSelected();
        }
        return this.buffers[buffer.bid()];
    },
    showBuffers: function () {
        this.bufferPanes.addClass('canShow');
        this.timeLayoutChange();
        this.model.trigger('buffersShown');
    },
    hideBuffers: function () {
        this.bufferPanes.removeClass('canShow');
    },
    clearCurrent: function () {
        this.current = null;
        this.timeContainer.hide();
    },
    currentBufferChange: function () {
        if (!this.model.currentBuffer) {
            this.clearCurrent();
        }
    },
    doneLoading: function (inited) {
        if (!inited) {
            $('.mainSpin').remove();
        }
        this.timeLayoutChange();
    },
    highlightCurrentUserRows: function (user) {
        if (this.current && user.connection == this.model.currentBuffer.connection) {
            this.current.hoverUserRows(user);
        }
    },
    unhighlightCurrentUserRows: function () {
        if (this.current) {
            this.current.unhoverUserRows();
        }
    },
    renderCurrentOverlay: function (overlay) {
        if (this.current) {
            this.current.renderOverlay(overlay);
        } else if (this.addNetwork.isSelected()) {
            this.addNetwork.renderOverlay(overlay);
        } else if (this.settings.isSelected()) {
            this.settings.renderOverlay(overlay);
        }
    },

    // Layout callbacks

    currentBufferTopChange: function () {
        if (this.current) {
            this.current.mainTopChange();
        }
    }
});


module.exports = MainAreaView;


/***/ }),

/***/ "FIf4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _formatter = __webpack_require__("5gSh");

var _formatter2 = _interopRequireDefault(_formatter);

var _upgradeSchedules = __webpack_require__("Z/we");

var _upgradeSchedules2 = _interopRequireDefault(_upgradeSchedules);

var _upgradeSchedules3 = __webpack_require__("m+fz");

var _upgradeSchedules4 = _interopRequireDefault(_upgradeSchedules3);

var _upgradeCard = __webpack_require__("9gHr");

var _upgradeCard2 = _interopRequireDefault(_upgradeCard);

var _upgradePaypal = __webpack_require__("BVYZ");

var _upgradePaypal2 = _interopRequireDefault(_upgradePaypal);

var _upgradeDefines = __webpack_require__("a4TI");

var _upgradeDefines2 = _interopRequireDefault(_upgradeDefines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend($.extend({}, _upgradeCard2.default, _upgradePaypal2.default, {
    template: _upgradeSchedules2.default,
    el: 'div.upgradeSchedules',
    initialize: function initialize(options, upgrade) {
        this.upgrade = upgrade;
        this.formatter = new _formatter2.default();
        this.setInitialState();
        this.model.on('plansChange', this.render, this);
        if (_upgradeCard2.default.initialize) {
            _upgradePaypal2.default.initialize.apply(this, arguments);
        }
        if (_upgradePaypal2.default.initialize) {
            _upgradePaypal2.default.initialize.apply(this, arguments);
        }
    },

    events: _.extend({}, _upgradeCard2.default.events, _upgradePaypal2.default.events, {
        'click tr.upgradeSchedules__item': 'onClick',
        'click .upgradeSchedules__cancel-button': 'onCancel',
        'submit form.upgradeSchedules__form': 'onSubmit',
        'buttonClick .upgradePayment__back-button': 'onBack',
        'buttonClick .upgradePayment__payment-button': 'onPayment'
    }),

    isVisible: function isVisible() {
        return this.$el.is(':visible');
    },
    show: function show() {
        this.$el.show();
    },
    hide: function hide() {
        this.$el.hide();
    },
    toggle: function toggle(condition) {
        this.$el.toggle(condition);
    },
    onClick: function onClick(e) {
        e.preventDefault();
        var value = $(e.target).closest('tr').data('value');
        this.select(value);
    },
    onSubmit: function onSubmit(e) {
        e.preventDefault();
        this.choose(this.state.selected);
    },
    onCancel: function onCancel(e) {
        this.upgrade.cancelUpgrade();
    },
    onBack: function onBack(e) {
        e.preventDefault();
        this.clearState('chosen');
    },
    onPayment: function onPayment(e) {
        e.preventDefault();
        this.paymentHandlers[e.target.value].call(this);
    },

    paymentHandlers: $.extend({}, _upgradeCard2.default.paymentHandlers, _upgradePaypal2.default.paymentHandlers),
    setInitialState: function setInitialState() {
        var state = {};
        if (this.model.featureCheck('annual_payments')) {
            state.selected = _upgradeDefines2.default.SCHEDULE_ANNUAL_RECURRING;
        } else {
            state.selected = _upgradeDefines2.default.SCHEDULE_MONTHLY_RECURRING;
        }
        this.setState(state);
    },
    setUpgradedState: function setUpgradedState(value) {
        this.extendState({ upgraded: value });
    },
    setState: function setState(state) {
        this.state = state;
        this.render();
    },
    extendState: function extendState(updates) {
        this.setState(_.extend({}, this.state, updates));
    },
    clearState: function clearState() {
        var _this = this;

        for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
            keys[_key] = arguments[_key];
        }

        keys.forEach(function (key) {
            delete _this.state[key];
        });
        this.render();
    },
    select: function select(value) {
        this.extendState({ selected: value });
    },
    choose: function choose(value) {
        this.extendState({ chosen: value });
    },
    render: function render() {
        if (!this.model.plans.solo) {
            return this;
        }
        this.$el.html(this.template(this.getTemplateData()));
        if (_upgradeCard2.default.render) {
            _upgradeCard2.default.render.call(this);
        }
        if (_upgradePaypal2.default.render) {
            _upgradePaypal2.default.render.call(this);
        }
        this.processEmoji();
        return this;
    },
    processEmoji: function processEmoji() {
        emoji.include_title = false;
        this.$('.upgradeChecklist li').each(function (i, li) {
            var $li = $(li);
            $li.html(emoji.replace_unified($li.html()));
        });
        emoji.include_title = true;
    },
    getCountry: function getCountry() {
        return this.state.chosen_country || this.model.plans.country;
    },
    getTemplateData: function getTemplateData() {
        var _this2 = this;

        var data = {
            state: this.state,
            schedules: []
        };
        if (this.model.plans.eu_vat && this.model.plans.eu_vat.applicable) {
            data.vat_applicable = true;
        }
        if (!this.model.featureCheck('upgrades')) {
            data.disabled = true;
        }
        if (this.model.isDesktop()) {
            data.desktop = true;
        }
        if (this.model.isSSBFluid()) {
            data.ssb_fluid = true;
        }
        if (this.model.featureCheck('annual_payments')) {
            data.annual_payments = true;
        }
        var countries = _.map(this.model.plans.countries, function (name, code) {
            var isSelected = code === _this2.getCountry();
            var country = {
                code: code,
                name: name,
                isSelected: isSelected
            };
            if (isSelected) {
                data.detected_country = country;
            }
            return country;
        });
        data.countries = countries;
        if (this.state.paypal) {
            data['paypal_' + this.state.paypal] = true;
        }
        if (this.state.card) {
            data['card_' + this.state.card] = true;
        }
        if (this.model.featureCheck('upgrades')) {
            data.schedules = this.getAnnualPlans().concat(this.getMonthlyPlans());
        }

        if (data.schedules.length == 1) {
            data.only_schedule = true;
        }

        data.schedules.forEach(function (schedule) {
            if (_this2.state.selected === schedule.value) {
                schedule.isActive = true;
            }
            if (data.only_schedule || _this2.state.chosen === schedule.value) {
                _this2.state.chosen = schedule.value;
                data.chosen_schedule = schedule;
                schedule.methods.forEach(function (method) {
                    if (_this2.state.waiting === method.value) {
                        method.isWaiting = true;
                    }
                });
            }
        });
        return data;
    },
    isPayPalAvailable: function isPayPalAvailable() {
        return !this.model.isSSBFluid();
    },
    getMonthlyPlans: function getMonthlyPlans(state) {
        var monthlyPlans = [];
        if (!this.model.plans.solo) {
            return monthlyPlans;
        }
        var payment = [this.getPaymentCards()];
        var methods = [this.getPaymentCards()];
        if (this.isPayPalAvailable()) {
            if (this.model.plans.paypal_recurring_available) {
                payment.unshift(this.getPaymentPayPal());
                methods.push(this.getPaymentPayPal());
            }
        }
        var currency = this.model.getCurrency();
        var price = this.formatter.amount('', this.model.plans.solo.amount, 1, 0);
        var period = 'per month; ' + this.formatter.amount(currency, this.model.plans.solo.amount * 12, 1, 0) + ' a year';
        var monthlyRecurringPlan = {
            label: 'Monthly recurring',
            currencySymbol: this.formatter.getCurrencySymbol(currency),
            price: price,
            period: period,
            description: 'every month',
            payment: payment,
            methods: methods,
            value: _upgradeDefines2.default.SCHEDULE_MONTHLY_RECURRING
        };
        monthlyPlans.push(monthlyRecurringPlan);
        return monthlyPlans;
    },
    getAnnualPlans: function getAnnualPlans(state) {
        if (!this.model.featureCheck('annual_payments')) {
            return [];
        }
        var annualPlans = [];
        if (!this.model.plans.solo_yearly) {
            return annualPlans;
        }
        var payment = [this.getPaymentCards()];
        var methods = [this.getPaymentCards()];
        var oneOffPayment = [this.getPaymentCards()];
        var oneOffMethods = [this.getPaymentCards()];
        if (this.isPayPalAvailable()) {
            if (this.model.plans.paypal_recurring_available) {
                payment.unshift(this.getPaymentPayPal());
                methods.push(this.getPaymentPayPal());
            }
            oneOffPayment.unshift(this.getPaymentPayPal());
            oneOffMethods.push(this.getPaymentPayPal());
        }

        var currency = this.model.getCurrency();
        var currencySymbol = this.formatter.getCurrencySymbol(currency);
        var price = this.formatter.amount('', this.model.plans.solo_yearly[currency].amount, 1, 0);

        var annualOneOffPlan = {
            label: 'Annual one-off',
            currencySymbol: currencySymbol,
            price: price,
            period: 'lasts for 1 year',
            description: 'for 12 months',
            payment: oneOffPayment,
            methods: oneOffMethods,
            value: _upgradeDefines2.default.SCHEDULE_ANNUAL_ONEOFF
        };
        annualPlans.push(annualOneOffPlan);

        var annualRecurringPlan = {
            label: 'Annual recurring',
            currencySymbol: currencySymbol,
            price: price,
            period: 'per year',
            description: 'every 12 months',
            payment: payment,
            methods: methods,
            value: _upgradeDefines2.default.SCHEDULE_ANNUAL_RECURRING
        };
        annualPlans.push(annualRecurringPlan);
        return annualPlans;
    }
}));

/***/ }),

/***/ "FXrJ":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"addSlack\">\n    <span class=\"explanation addSlack__or\">OR</span>\n    <button type=\"button\" class=\"addSlack__button light\">\n        <span>\n            <i class=\"fa fa-slack\"></i>\n            Add Slack Workspace\n        </span>\n    </button>\n</div>\n<p class=\"userError addSlack__error\"></p>";
},"useData":true});

/***/ }),

/***/ "Fj2Y":
/***/ (function(module, exports, __webpack_require__) {

var ChildStatusView = __webpack_require__("4PFu");
var twitch = __webpack_require__("/7tV");


var ChannelStatusView = ChildStatusView.extend({
    events: $.extend({}, ChildStatusView.prototype.events, {
        'buttonClick button.rejoin': 'clickRejoin',
        'buttonClick button.archive': 'clickArchive',
        'buttonClick button.unarchive': 'clickUnarchive',
        'click': 'mouseTitle',
        'mousemove': 'mouseTitle',
        'mousedown': 'mouseTitle',
        'click .memberToggle': 'clickMemberToggle',
        'buttonClick .memberToggle': 'clickMemberToggle',
        'click .twitchViewers': 'clickTwitchViewers',
        'buttonClick .twitchViewers': 'clickTwitchViewers',
        'buttonClick .twitchRooms': 'clickTwitchRooms',
        'click .twitchStatus': 'clickTwitchStatus'
    }),
    clickMemberToggle: function (e) {
        this.model.setShowMembersPref(!this.model.shouldShowMemberList());
        return false;
    },
    clickTwitchViewers: function (e) {
        this.label.find('a')[0].click();
    },
    clickTwitchStatus: function (e) {
        twitch.popupStream(this.model.session, this.model.normalise());
    },
    clickRejoin: function (e) {
        this.model.join();
        return false;
    },
    clickArchive: function (e) {
        this.model.archive();
        return false;
    },
    clickUnarchive: function (e) {
        this.model.unarchive();
        return false;
    },
    mouseTitle: function (e) {
        switch (e.type) {
        case 'mousedown':
            this.mouseMoving = false;
            break;
        case 'mousemove':
            this.mouseMoving = true;
            break;
        case 'click':
            if (!this.mouseMoving) {
                if ($(e.target).is('a')) {
                    return;
                }
                this.toggleExpandTitle();
            }
            this.mouseMoving = false;
            break;
        }
    },
    render: function () {
        ChildStatusView.prototype.render.apply(this, arguments);
        
        this.collapseTitle();
        this.topic = $('<span class="topic">');
        this.title.append(this.topic);
        
        this.model.bind('urlChange', this.renderLabel, this);
        this.model.bind('modeChange', this.renderLabel, this);
        this.model.bind('change:name', this.renderLabel, this);
        
        this.renderTooltip();
        this.model.bind('timestampChange', this.renderTooltip, this);
        this.model.bind('urlChange', this.renderTooltip, this);

        this.renderTopic();
        this.model.bind('topicChange', function () {
            this.renderTopic();
            if (this.model.isActive()) {
                this.expandTitle();
            }
        }, this);

        this.renderTwitchRooms();
        this.model.bind('twitchChannelChange', this.renderTwitchInfo, this);
        
        this.model.bind('init', function () {
            if (this.model.connection.isInitialized()) {
                this.expandTitle();
            }
        }, this);
        
        return this;
    },
    renderTwitchRoomLabel: function (twitchRoomParts) {
        var roomInfo = twitchRoomParts[0];
        var twitchInfo = twitchRoomParts[1];

        this.renderTwitchLabel(twitchInfo);

        var roomTitle = $('<span class="twitchRoom explanation">').text(' room: ' + roomInfo.name);
        this.label.append(roomTitle);

        if (roomInfo.minimum_allowed_role != 'EVERYONE') {
            var lockTitle = twitch.roomType(roomInfo);
            var lock = $('<i class="fa fa-lock">').attr('title', lockTitle);
            if (this.label.find('img')[0]) {
                this.label.find('img').after(lock);
            } else {
                this.label.prepend(lock);
            }
        }
    },
    renderTwitchLabel: function (twitchInfo) {
        var displayName = this.model.getDisplayName();
        var twitchDisplayName = this.model.getTwitchDisplayName(twitchInfo);
        var title;
        if (twitchDisplayName) {
            title = this.formatter.escapeText(twitchDisplayName);
        } else {
            title = this.formatter.render(displayName);
        }
        if (twitchInfo.channel.url) {
            this.label.html(this.formatter.linker.makeLinkFromBits(title, {
                url: twitchInfo.channel.url,
                target: '_blank'
            }));
        } else {
            this.label.html(title);
        }
        if (twitchDisplayName) {
            if (twitchInfo.channel.name.toLowerCase() != twitchDisplayName.toLowerCase()) {
                this.label.append(' (' + this.formatter.escapeText(twitchInfo.channel.name) + ')');
            }
            if (twitchInfo.viewers) {
                var twitchStatus = $('<span class="twitchStatus">');
                twitchStatus.append('<i class="fa fa-play-circle">');
                this.label.prepend(twitchStatus);
            }
        }
        if (twitchInfo.game) {
            var gameUrl = 'https://www.twitch.tv/directory/game/' + twitchInfo.game;
            var gameLink = $('<a>').attr({
                href: gameUrl,
                target: '_blank'
            }).text(twitchInfo.game);
            this.label.append(' playing ').append(gameLink);
        }
        if (twitchInfo.channel.logo) {
            this.label.prepend($('<img>').attr({
                src: twitchInfo.channel.logo,
                width: 32,
                height: 32
            }).css({
                'vertical-align': 'middle',
                'margin': '0 10px 0 0'
            }));
        }
    },
    renderLabel: function () {
        var twitchInfo = this.model.getTwitchInfo();
        if (twitchInfo) {
            this.renderTwitchLabel(twitchInfo);
        } else {
            var twitchRoomParts = this.model.getTwitchRoomParts();
            if (twitchRoomParts) {
                this.renderTwitchRoomLabel(twitchRoomParts);
            } else {
                var displayName = this.model.getDisplayName();
                var title = this.formatter.render(displayName);
                var label = title;
                var channelUrl = this.model.getUrl();
                if (channelUrl) {
                    var cleanLink = this.formatter.linker.makeLinkFromUrl(channelUrl, title);
                    if (cleanLink) {
                        label = cleanLink;
                    }
                }
                if (this.model.isSlackMultiPersonDm()) {
                    label = 'Direct message with ' + label;
                }
                this.label.html(label);
                var safeChanSuffix = this.model.safeChanSuffix();
                if (safeChanSuffix) {
                    this.label.append(' ').append($('<small>').text(safeChanSuffix));
                }
                if (this.model.isPassworded()) {
                    this.label.prepend('<i class="fa fa-lock" title="Password protected">');
                } else if (this.model.connection.isSlack() && this.model.isSecret()) {
                    this.label.prepend('<i class="fa fa-lock" title="Private channel">');
                }
            }
        }
        this.trigger('topChange');
    },
    renderButtons: function () {
        ChildStatusView.prototype.renderButtons.apply(this);
        
        this.appendButton('rejoin', 'Rejoin');
        this.appendButton('archive', 'Archive');
        this.appendButton('unarchive', 'Unarchive');
        
        this.memberCount = $('<span>');
        this.memberCountWrapper = $('<span class="totalMemberCount" role="button" tabindex="0">')
            .attr({
                'title': 'Members list',
                'aria-label': 'Members list'
            })
            .addClass('memberToggle')
            .append('<i class="fa fa-list-ul">')
            .append('<i class="fa fa-twitch">')
            .append(this.memberCount);
        this.buttons.append(this.memberCountWrapper);

        if (this.model.connection.isTwitch()) {
            var twitchRoomsButton = $('<button class="twitchRooms fa fa-list-alt">');
            this.buttons.append(twitchRoomsButton);
        }

        this.appendOptionsButton();
    },
    clickTwitchRooms: function (e) {
        var twitchInfo = this.model.getTwitchInfo();
        if (twitchInfo && twitchInfo.rooms) {
            this.model.trigger('twitchRoomsOverlay', twitchInfo.rooms);
        }
    },
    renderMemberCount: function () {
        var members, title;
        var twitchInfo = this.model.getTwitchInfo();
        this.memberCountWrapper.toggleClass('memberToggle', !twitchInfo);
        this.memberCountWrapper.toggleClass('twitchViewers', !!twitchInfo);
        if (twitchInfo) {
            if (twitchInfo.viewers) {
                title = 'Watching now';
                members = twitchInfo.viewers;
            } else {
                title = 'Offline';
                members = 'Offline';
            }
        } else {
            if (this.model.chan_members_failed) {
                if (this.model.chan_members_failed === 'timeout') {
                    title = 'The system is overloaded and functionality may be slow or unavailable.';
                } else {
                    title = 'The system is having problems and some functionality may not be working properly.';
                }
                members = 'Unavailable';
            } else {
                title = 'Members list';
                members = this.model.members.length;
            }
        }
        this.memberCountWrapper.attr({
            'title': title,
            'aria-label': title
        });
        this.memberCount.text(members.toLocaleString());
        this.trigger('topChange');
    },
    renderTwitchTopic: function (twitchInfo) {
        this.topic.html(this.formatter.renderLinkify(twitchInfo.channel.status));
        if (twitchInfo.created_at) {
            var time = new Date(twitchInfo.created_at);
            var title = 'Started on ' + time.formatFullDate();
            this.topic.attr("title", title);
        } else {
            this.topic.removeAttr('title');
        }
    },
    renderTwitchRoomTopic: function (twitchRoomParts) {
        var roomInfo = twitchRoomParts[0];
        var twitchInfo = twitchRoomParts[1];
        this.topic.html(this.formatter.renderLinkify(roomInfo.topic));
    },
    renderTwitchRooms: function () {
        this.$el.toggleClass('hasTwitchRooms', this.model.hasTwitchRooms());
    },
    renderTopic: function () {
        var twitchInfo = this.model.getTwitchInfo();
        if (twitchInfo && twitchInfo.channel.status) {
            this.renderTwitchTopic(twitchInfo);
        } else {
            var twitchRoomParts = this.model.getTwitchRoomParts();
            if (twitchRoomParts) {
                this.renderTwitchRoomTopic(twitchRoomParts);
            } else {
                if (this.model.topic) {
                    this.topic.html(this.formatter.renderLinkifyComicSans(this.model.topic.get('topic')));
                    var author = this.model.topic.get('author');
                    var server = this.model.topic.get('server');
                    if (author || server) {
                        var title = 'Topic set';
                        if (server) {
                            title += ' by the server ' + server;
                        } else {
                            var authorTitle = author.getTitleWithHostmask();
                            if (authorTitle) {
                                title += ' by ' + authorTitle;
                            }
                        }
                        var time = this.model.topic.getTime();
                        if (time) {
                            title += ' on ' + time.formatFullDate();
                        }
                        this.topic.attr("title", title);
                    } else {
                        this.topic.removeAttr('title');
                    }
                } else {
                    this.topic.empty();
                    this.topic.removeAttr('title');
                }
            }
        }
        this.trigger('topChange');
    },
    renderTooltip: function () {
        var url = this.model.getUrl();
        if (this.model.timestamp > 0 || url) {
            var title = '';
            if (this.model.timestamp > 0) {
                title += "Created on " + this.model.getTimestamp().formatFullDate() + ' ';
            }
            if (url) {
                title += '(' + url + ')';
            }
            this.title.attr('title', title);
        } else {
            this.title.removeAttr('title');
        }
    },
    renderTwitchInfo: function () {
        this.renderLabel();
        this.renderTopic();
        this.renderMemberCount();
        this.renderTwitchRooms();
    }
});


module.exports = ChannelStatusView;


/***/ }),

/***/ "G5kp":
/***/ (function(module, exports, __webpack_require__) {

var FileView = __webpack_require__("6AFE");

var FileInlineView = FileView.extend({
    tagName: 'span',
    events: _.extend({}, FileView.prototype.events, {
        'click a.fileClose': 'clickClose',
        'click a.retry': 'retryUpload'
    }),
    clickClose: function (e) {
        e.preventDefault();
        this.collapse(true);
    },
    retryUpload: function (e) {
        e.preventDefault();
        if (!this.model.isUploaded()) {
            var promise = this.model.upload();
            this.trigger('finalise', promise, this);
        }
    },
    collapse: function (animate) {
        this.$('.media').each(function (i, m) {
            m.pause();
        });
        if (animate) {
            this.$el.slideUp(100).fadeOut(_.bind(function () {
                this.trigger('collapsed');
            }, this));
        } else {
            this.$el.hide();
            this.trigger('collapsed');
        }
    },
    sizeImage: function (img, dimensions) {
        img.attr({
            src: this.model.getCachedUrl(dimensions),
            width: dimensions.width,
            height: dimensions.height
        });
    },
    sizeDummy: function (dummy, dimensions) {
        dummy.css({
            width: dimensions.width,
            'line-height': dimensions.height + 'px'
        });
    },
    render: function (container) {
        var link = $('<a target="_blank" class="fileLink previewLink">');
        var close, media;
        if (this.model.isPreviewableImage()) {
            this.$el.addClass('imagePreview');
            var img = $('<img class="filePreview image loading">');
            var dummy = $('<div class="filePreviewImageDummy">').append('<i class="spin">');
            var dimensions = this.inlinePreviewDimensions(container);
            if (dimensions) {
                this.sizeImage(img, dimensions);
                this.sizeDummy(dummy, dimensions);
            } else {
                img.attr({
                    src: this.model.getCachedUrl({width: FileView.MAX_WIDTH})
                }).one('load', _.bind(function (e) {
                    var containerWidth = container.width();
                    dimensions = FileView.constrainDimensions(
                        img[0].width,
                        img[0].height,
                        FileInlineView.MAX_WIDTH_INLINE_RATIO * containerWidth,
                        FileInlineView.MAX_HEIGHT_INLINE
                    );
                    this.sizeImage(img, dimensions);
                    this.sizeDummy(dummy, dimensions);
                }, this));
            }
            link.append(img);
            link.append(dummy);
            close = '<a href="" class="embedClose" title="Close image"></a>';
        } else {
            link.addClass('docLink');
            link.append(this.docIcon());
            if (this.model.isPreviewableMedia()) {
                this.$el.addClass('mediaPreview');
                var closeText;
                if (this.model.isVideo()) {
                    media = $('<video class="video">');
                    closeText = 'Close video';
                } else if (this.model.isAudio()) {
                    media = $('<audio class="audio">');
                    closeText = 'Close audio';
                }
                media.addClass("filePreview media loading").attr({
                    preload: 'metadata',
                    controls: true,
                    src: this.model.getUrl()
                }).click(_.bind(function (e) {
                    e.preventDefault();
                    var v = e.target;
                    if (v.paused) {
                        v.play();
                    } else {
                        v.pause();
                    }
                }, this));
                close = '<a href="" class="embedClose" title="' + closeText + '"></a>';
            } else {
                this.$el.addClass('docPreview');
            }
        }
        this.$el.append(link);
        
        if (media) {
            this.$el.append(media);
        }
        
        if (close) {
            this.$el.append(close);
        }

        this.editForm = this.renderEditForm();
        this.$el.append(this.editForm);

        var info = this.renderInlineInfo();

        var actions = this.renderActions();
        info.append(actions);

        this.$el.append(info);

        this.editError = $('<p class="userError editError">');
        this.$el.append(this.editError);

        this.rendered();

        return this;
    },
    renderActions: function (noEdit) {
        var actions = $('<span class="actions">');
        if (!noEdit && this.model.isOwn()) {
            actions.append($('<a href="" class="edit">').text('edit'));
            actions.append(' • ');
            actions.append($('<a href="" class="delete">').text('delete'));
            actions.append($('<a href="" class="restore">').text('restore'));
            actions.append(' • ');
        }
        actions.append($('<a href="" class="fileClose">').text('close'));
        return actions;
    },
    renderEditForm: function () {
        var nameInput = $('<input class="input nameInput" name="name">');
        var editSubmit = $('<button type="submit" class="action">').append($('<span>').text('Save'));
        var editCancel = $('<button type="button" class="cancel">').append($('<span>').text('Cancel'));
        return $('<form action="" method="post" class="editForm">')
            .append($('<p class="form">').append(nameInput).append(editSubmit).append(editCancel));
    },
    renderInlineInfo: function () {
        var info = $('<span class="info">');
        var link = $('<a target="_blank" class="fileLink">');

        this.name = $('<span class="name">');
        link.append(this.name);

        var fileInfo = $('<span class="explanation">');
        fileInfo.text(this.model.getSize() + ' • ' + this.model.getType());
        link.append(fileInfo);

        info.append(link);
        return info;
    },
    inlinePreviewDimensions: function (container) {
        if (this.model.isPreviewableImage()) {
            var containerWidth = container.width();
            return this.constrainDimensions(
                FileInlineView.MAX_WIDTH_INLINE_RATIO * containerWidth,
                FileInlineView.MAX_HEIGHT_INLINE
            );
        } else {
            return {
                width: FileInlineView.INLINE_DOC_WIDTH,
                height: FileInlineView.INLINE_DOC_HEIGHT + FileInlineView.INLINE_INFO_HEIGHT
            };
        }
    },
    renderLocalInlineProgress: function (promise, options) {
        var progress = $('<span class="progress">');
        promise.progress(_.bind(function (evt, percentComplete) {
            progress.stop();
            if (evt) {
                progress.removeClass('busy');
                progress.animate({
                    height: percentComplete + '%'
                });
            } else {
                progress.addClass('busy');
                progress.css('height', '100%');
            }
        }, this));
        promise.fail(_.bind(function () {
            progress.removeClass('busy');
            progress.css('height', 0);
        }, this));
        return progress;
    },
    renderLocalInlinePreview: function () {
        return this.renderLocalPreview('image loading').done(_.bind(function (preview) {
            var info = this.renderInlineInfo();
            var actions = this.renderActions(true);
            actions.append($('<span class="retryWrap">')
                .append(' • ')
                .append($('<a href="" class="retry">').text('retry'))
            );
            info.append(actions);
            preview.append(info);

            var error = $('<p class="userError">');
            preview.append(error);
            this.renderName();
        }, this));
    }
}, {
    // Sync with css
    MAX_WIDTH_INLINE_RATIO: 0.92,
    MAX_HEIGHT_INLINE: 250,
    INLINE_DOC_WIDTH: 40,
    INLINE_DOC_HEIGHT: 50,
    INLINE_INFO_HEIGHT: 20
});

module.exports = FileInlineView;


/***/ }),

/***/ "GmLC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fromCodePoint = __webpack_require__("qUhW");

var _fromCodePoint2 = _interopRequireDefault(_fromCodePoint);

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

exports.inherit = inherit;
exports.arrayFrom = arrayFrom;
exports.stringSlice = stringSlice;
exports.hasKey = hasKey;
exports.ts = ts;
exports.highlightTerm = highlightTerm;
exports.stringify = stringify;
exports.containsEqual = containsEqual;
exports.lengthInUtf8Bytes = lengthInUtf8Bytes;
exports.truncate = truncate;
exports.strHex = strHex;
exports.naturalCompare = naturalCompare;
exports.getBufferPartsLegacy = getBufferPartsLegacy;
exports.getBufferParts = getBufferParts;
exports.ircUrlParts = ircUrlParts;
exports.normaliseChan = normaliseChan;
exports.parseChannels = parseChannels;
exports.slugify = slugify;
exports.capitalize = capitalize;
exports.matchEmoji = matchEmoji;
exports.openPopup = openPopup;

var _fuzzaldrinPlus = __webpack_require__("yPLO");

var _fuzzaldrinPlus2 = _interopRequireDefault(_fuzzaldrinPlus);

var _re = __webpack_require__("38es");

var re = _interopRequireWildcard(_re);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-env es6 */

function inherit(obj, properties) {
    function F() {}
    F.prototype = obj.prototype;
    return $.extend(new F(), properties);
}

function arrayFrom(input) {
    return (0, _from2.default)(input);
}

function stringSlice(str, beginIndex, endIndex) {
    return (0, _from2.default)(str).slice(beginIndex, endIndex).join('');
}

function hasKey(objList, key) {
    return objList.some(function (obj) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    });
}

function ts() {
    return new Date().getTime();
}

function highlightTerm(string, term, replacement) {
    replacement = replacement || "<strong>$1</strong>";
    if (term) {
        return string.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + re.escape(term) + ")(?![^<>]*>)(?![^&;]+;)", "gi"), replacement);
    } else {
        return string;
    }
}

function stringify(value) {
    if (_.isString(value)) {
        return value;
    }
    return value || value === 0 ? String(value) : '';
}

function containsEqual(list, value) {
    return !!_.find(list, function (v) {
        return _.isEqual(value, v);
    });
}

function lengthInUtf8Bytes(str) {
    // https://gist.github.com/mathiasbynens/1010324
    try {
        return ~-encodeURI(str).split(/%..|./).length;
    } catch (exc) {
        // Fallback if they're sending us invalid utf8
        return str.length;
    }
}

function truncate(str, length) {
    var lines = str.split(/[,\r\n]/);
    var first = lines[0];
    if (first.length <= length + 3) {
        if (lines.length > 1) {
            first += '…';
        }
        return first;
    }
    return first.slice(0, length) + '…';
}

function strHex(string) {
    return _.map(string, function (chr) {
        var code = chr.charCodeAt(0);
        if (code < 32) {
            var hex = code.toString(16);
            return '\\u' + '0000'.substr(hex.length) + hex;
        } else {
            return chr;
        }
    }).join('');
}

function naturalCompare(a, b) {
    // https://github.com/litejs/natural-compare-lite
    if (a != b) for (var i, ca, cb = 1, ia = 0, ib = 0; cb;) {
        ca = a.codePointAt(ia++) || 0;
        cb = b.codePointAt(ib++) || 0;

        if (ca < 58 && ca > 47 && cb < 58 && cb > 47) {
            for (i = ia; ca = a.codePointAt(ia), ca < 58 && ca > 47; ia++) {}
            ca = (a.slice(i - 1, ia) | 0) + 1;
            for (i = ib; cb = b.codePointAt(ib), cb < 58 && cb > 47; ib++) {}
            cb = (b.slice(i - 1, ib) | 0) + 1;
            if (ca != cb) return ca < cb ? -1 : 1;
        } else if (ca != cb) {
            return (0, _fromCodePoint2.default)(ca).localeCompare((0, _fromCodePoint2.default)(cb));
        }

        if (ca != cb) return (0, _fromCodePoint2.default)(ca).localeCompare((0, _fromCodePoint2.default)(cb));
    }
    return 0;
}

function getSharedBufferParts(bufferId) {
    if (!bufferId) {
        return null;
    }
    if (bufferId.indexOf(' ') !== -1) {
        return null;
    }

    bufferId = bufferId.replace(/^!\//, '');

    var parts = {
        connectionId: ''
    };

    var protocolParts = bufferId.split('://');
    var bufferParts = protocolParts.pop().split('/');
    if (protocolParts[0] === 'ircs') {
        parts.ssl = true;
        parts.connectionId += 'ircs://';
    }
    var hostPortPart = bufferParts.shift();
    var connectionParts = hostPortPart.split(':');
    parts.hostname = decodeURIComponent(connectionParts[0]);
    // Max FQDN is 255, max protocol is 63
    if (parts.hostname.length > 255) {
        parts.hostname = '';
    }
    parts.connectionId += parts.hostname;
    if (parts.hostname && connectionParts[1]) {
        parts.port = decodeURIComponent(connectionParts[1]);
        // Max port is unsigned 16 bit int
        if (parts.port > 65535) {
            delete parts.port;
        } else {
            parts.connectionId += ':' + parts.port;
        }
    }
    // Arbitrary disambiguation limit, use same as port
    if (parts.port && connectionParts[2] && connectionParts[2] <= 65535) {
        parts.disambiguation = connectionParts[2];
    }

    if (parts.disambiguation) {
        parts.connectionId += ':' + parts.disambiguation;
    }
    parts.bufferParts = bufferParts;
    return parts;
}

function getBufferPartsLegacy(bufferId, hash) {
    var parts = getSharedBufferParts(bufferId);
    if (!parts) {
        return parts;
    }
    var bufferParts = parts.bufferParts;
    delete parts.bufferParts;

    if (!bufferParts[0] && hash) {
        bufferParts[0] = encodeURIComponent('#') + hash;
    }
    if (parts.connectionId && bufferParts[0]) {
        // Limit to first comma delimited value
        parts.buffer = decodeURIComponent(bufferParts[0]).split(',')[0];
        // RFC says max length is 200 or 50, most servers use 32, add a bit of leeway
        if (parts.buffer.length > 255) {
            delete parts.buffer;
        }
    }
    return parts;
}

function getBufferParts(bufferId) {
    var parts = getSharedBufferParts(bufferId);
    if (!parts) {
        return parts;
    }
    var bufferParts = parts.bufferParts;
    delete parts.bufferParts;

    if (parts.connectionId && bufferParts[0]) {
        // Limit to first comma delimited value
        if (!bufferParts[1]) {
            return parts;
        }
        var bufferName = decodeURIComponent(bufferParts[1]).split(',')[0];
        if (bufferParts[0] == 'channel') {
            parts.type = 'channel';
            parts.buffer = bufferName;
        } else if (bufferParts[0] == 'messages') {
            parts.type = 'conversation';
            parts.buffer = bufferName;
        } else if (bufferParts[0] == 'thread') {
            parts.thread = decodeURIComponent(bufferParts[1]);
        }
        // RFC says max length is 200 or 50, most servers use 32, add a bit of leeway
        if (parts.buffer && parts.buffer.length > 255) {
            delete parts.buffer;
        }

        if (!parts.thread && bufferParts[2] == 'thread') {
            parts.thread = decodeURIComponent(bufferParts[3]);
        }
    }
    return parts;
}

function ircUrlParts(ircUrl) {
    // http://tools.ietf.org/html/draft-butcher-irc-url-04
    if (!ircUrl) {
        return;
    }
    var urlParts = ircUrl.match(/(ircs?):\/{0,2}(.*)/i);
    if (!urlParts || !urlParts[2]) {
        return;
    }
    var protocol = urlParts[1];
    var rest = urlParts[2];
    var bufferParts = rest.split('#');
    var rootPart, bufferString;
    if (bufferParts[0].indexOf('/') === -1) {
        // No slash used as channel delimiter, just hash
        rootPart = bufferParts.shift();
        if (bufferParts.length) {
            bufferString = '#' + bufferParts.join('#');
        }
    } else {
        bufferParts = rest.split('/');
        rootPart = bufferParts.shift();
        if (bufferParts.length) {
            bufferString = bufferParts.join('/');
        }
    }

    // Convert +6697 to ircs port
    var user, pass;
    var userHostSplit = rootPart.split('@');
    if (userHostSplit[1]) {
        rootPart = userHostSplit[1];
        var userPassSplit = userHostSplit[0].split(':');
        user = userPassSplit[0];
        pass = userPassSplit[1];
    } else {
        rootPart = userHostSplit[0];
    }
    var rootPartSplit = rootPart.split(':');
    if (rootPartSplit[1]) {
        var rootPortSSL = rootPartSplit[1].match(/^\+(\d+)$/);
        if (rootPortSSL) {
            protocol = 'ircs';
            rootPart = rootPartSplit[0] + ':' + rootPortSSL[1];
        }
    }
    if (protocol && protocol.toLowerCase() === 'ircs') {
        rootPart = 'ircs://' + rootPart;
    }

    var url = rootPart;
    var label;
    var type = 'network';
    var query;
    if (bufferString) {
        var bufferQueryParts = bufferString.split('?');
        query = bufferQueryParts[1];
        var bufferStringParts = bufferQueryParts[0].split(',');
        label = decodeURIComponent(bufferStringParts[0]);
        var isNick = bufferStringParts[1] == 'isuser' || bufferStringParts[1] == 'isnick';
        if (isNick) {
            type = 'user';
        } else {
            type = 'channel';
        }
        if (!isNick && $.inArray(label[0], ['#', '＃', '&', '+', '!']) == -1) {
            label = '#' + label;
        }
        url += '/' + encodeURIComponent(label);
    }
    return {
        root: rootPart,
        user: user,
        pass: pass,
        query: query,
        label: label,
        url: url,
        type: type
    };
}

function makeChan(chan) {
    if (!chan) {
        return;
    }
    if (chan.indexOf('#') !== 0) {
        chan = '#' + chan;
    }
    return chan;
}
var prefix_regexes = {};
function normaliseChan(chan, prefixes) {
    if (!chan) {
        return;
    }
    prefixes = prefixes || '#';
    if (!prefix_regexes[prefixes]) {
        prefix_regexes[prefixes] = new RegExp("^[" + re.escape(prefixes) + "]+");
    }

    return chan.toLowerCase().replace(prefix_regexes[prefixes], '');
}
function parseChannels(channels, noPasswords) {
    if (_.isArray(channels)) {
        return channels;
    } else {
        return _.uniq(_.filter(_.flatten(_.map(stringify(channels).trim().split(/[,\r\n]/), function (chan) {
            var chanParts = stringify(chan).trim().split(' ');
            if (!noPasswords && chanParts.length > 0 && chanParts.length <= 2) {
                var result = makeChan(chanParts[0]);
                if (!result) {
                    return;
                }
                if (chanParts[1]) {
                    result += ' ' + chanParts[1];
                }
                return result;
            } else if (noPasswords || chanParts.length > 2) {
                return _.map(chanParts, makeChan);
            }
        })), _.identity));
    }
}

function slugify(value) {
    return value.toLowerCase().replace(/[^a-z0-9_ ]+/g, '').replace(/ /g, '-');
}

function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

function matchEmoji(input) {
    var candidates = null;
    if (input.length) {
        candidates = [];
        var found = {};
        emoji.map.colons.each(function searchInputColons(colon, idx) {
            if (!found[idx]) {
                var score = _fuzzaldrinPlus2.default.score(colon, input);
                if (colon.indexOf('flag-') === 0) {
                    score = Math.max(score, _fuzzaldrinPlus2.default.score(colon.substr(5), input));
                }
                if (score > 0.05) {
                    candidates.push({
                        score: score,
                        idx: idx,
                        colon: colon
                    });
                    found[idx] = true;
                }
            }
        });
        candidates.sort(function (a, b) {
            return b.score - a.score;
        });
    }
    return candidates;
}

function openPopup(url, title) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var w = 1024 || options.w;
    var h = 900 || options.h;

    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    var specs = 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + '';
    var newWindow = window.open(url, 'popup:' + title, specs);

    var closeWatcher = setInterval(function () {
        if (newWindow.closed) {
            clearInterval(closeWatcher);
            if (options.closeCallback) {
                options.closeCallback();
            }
        }
    }, 500);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }

    return [newWindow, closeWatcher];
}

/***/ }),

/***/ "GnMM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HBAA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = parse;
exports.icons = icons;

var _uaParserJs = __webpack_require__("GCDA");

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ua_extensions = {
    browser: [[/ (IRCCloud)\/([\w\.-]+) Chrome/i], [[_uaParserJs2.default.BROWSER.NAME, 'IRCCloud Electron'], _uaParserJs2.default.BROWSER.VERSION], [
    // IRCCloud/4.28 (Mac; en-US; iPadOS 18.1)
    // /^(IRCCloud)\/([\w\.-]+) \(Mac; /i
    /^(IRCCloud)\/([\w\.-]+) \(Mac; [^;]+; iPadOS [\w\.]+/i], [[_uaParserJs2.default.BROWSER.NAME, 'IRCCloud Silicon'], _uaParserJs2.default.BROWSER.VERSION], [/^(IRCCloud)\/([\w\.-]+)/i], [[_uaParserJs2.default.BROWSER.NAME, 'IRCCloud Mobile'], _uaParserJs2.default.BROWSER.VERSION], [/^irccloudapi\/[\w\.-]+ (prattle)\/([\w\.-]+)/i], [_uaParserJs2.default.BROWSER.NAME, _uaParserJs2.default.BROWSER.VERSION]],
    engine: [[/ IRCCloud\/[\w\.-]+ Chrome\/[\w\.-]+ (Electron)\/([\w\.-]+)/i], [_uaParserJs2.default.ENGINE.NAME, _uaParserJs2.default.ENGINE.VERSION], [/^(irccloudapi)\/([\w\.-]+) prattle\/[\w\.-]+/i], [_uaParserJs2.default.ENGINE.NAME, _uaParserJs2.default.ENGINE.VERSION]],
    device: [[/^IRCCloud\/[\w\.-]+ \(([^;]+); [a-z]{2,2}; Android /i], [_uaParserJs2.default.DEVICE.MODEL, [_uaParserJs2.default.DEVICE.TYPE, 'mobile']]],
    os: [[/^IRCCloud\/[\w\.-]+ \(Mac; [^;]+; (iPadOS) ([\w\.]+)/i], [[_uaParserJs2.default.OS.NAME, 'Mac iPadOS'], _uaParserJs2.default.OS.VERSION], [/^IRCCloud\/[\w\.-]+ \(i(?:(?:phone)|(?:pad)|(?:pod touch)); [^;]+; ((?:ios)|(?:ipados)) ([\w\.]+)/i], [[_uaParserJs2.default.OS.NAME, 'iOS'], _uaParserJs2.default.OS.VERSION], [/^irccloudapi\/[\w\.-]+ (prattle)\/([\w\.-]+)/i], [_uaParserJs2.default.OS.NAME, _uaParserJs2.default.OS.VERSION]]
}; /* eslint-env es6 */

var ua_parser = new _uaParserJs2.default(ua_extensions);

function parse(ua) {
    return ua_parser.setUA(ua).getResult();
}

function icons(ua) {
    var icons = [];
    var result = parse(ua);

    var osIcon = '';
    switch (result.os.name) {
        case 'Mac OS':
        case 'iOS':
        case 'Mac iPadOS':
            osIcon = 'fa-apple';
            break;
        case 'Windows':
            osIcon = 'fa-windows';
            break;
        case 'Android':
            osIcon = 'fa-android';
            break;
        case 'Linux':
            osIcon = 'fa-linux';
            break;
    }

    if (osIcon) {
        icons.push($('<i>').addClass('fa ' + osIcon));
    }

    var browserIcon = '';
    switch (result.browser.name) {
        case 'Chrome':
            browserIcon = 'fa-chrome';
            break;
        case 'Firefox':
            browserIcon = 'fa-firefox';
            break;
        case 'Safari':
            browserIcon = 'fa-safari';
            break;
        case 'IE':
            browserIcon = 'fa-internet-explorer';
            break;
        case 'IRCCloud Electron':
            browserIcon = 'fa-desktop';
            break;
        case 'IRCCloud Mobile':
            browserIcon = 'fa-mobile-phone';
            break;
    }
    if (browserIcon) {
        icons.push($('<i>').addClass('fa ' + browserIcon));
    }

    return icons;
}

/***/ }),

/***/ "HNx2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hg18":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");


var NickservView = DialogView.extend({
    el: '#nickservContainer',
    initialize: function (options) {
        this.setErrorMessage = $('p#nickservPasswordSetError');
        this.cidInputs = this.$('input[name=cid]');
        this.nsPass = $('input#nsPass');
        this.netName = $('#nickservNetname');
        this.host = $('#nickservHost');
        this.nick = $('#nickservNick');
        
        this.afterHide = _.bind(function () {
            this.model = null;
            this.hideErrors();
            this.nsPass.val('');
            this.cidInputs.val('');
            this.netName.empty();
            this.host.empty();
            this.nick.empty();
            this.nsPass.prop('disabled', true);
        }, this);
        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit form#nickservHelpForm': 'submitHelp',
        'submit form#nickservPasswordSetForm': 'submitSet'
    }),
    submitHelp: function (e) {
        e.preventDefault();
        this.model.nickservRegisterHelp(_.bind(function (response) {
            this.hide();
            if (!response.success) {
                this.model.trigger('postError', response);
            }
        }, this));
    },
    submitSet: function (e) {
        e.preventDefault();
        this.model.setNickservPassword(this.nsPass.val(), _.bind(function (response) {
            if (response.success) {
                this.hide();
            } else {
                var message;
                switch (response.message) {
                case 'connection_unavailable':
                    message = 'This connection is temporarily unavailable. Try again later.';
                    break;
                case 'server_error':
                    message = 'There was a problem joining this network';
                    break;
                default:
                    message = 'Error setting NickServ password: ' + response.message;
                    break;
                }
                this.showSetError(message);
            }
        }, this));
    },
    showSetError: function (message) {
        this.setErrorMessage.text(message).fadeIn('fast');
    },
    hideErrors: function () {
        this.setErrorMessage.hide();
    },
    show: function (connection) {
        this.model = connection;
        this.netName.text(this.model.getName());
        this.host.text(this.model.getHost());
        this.nick.text(this.model.get('nick'));
        this.nsPass.val(this.model.get('nickserv_pass'));
        this.nsPass.prop('disabled', false);
        this.cidInputs.val(this.model.getCid());
        DialogView.prototype.show.call(this);
    }
});


module.exports = NickservView;


/***/ }),

/***/ "IJ5v":
/***/ (function(module, exports) {

var MemberView = Backbone.View.extend({
    tagName: 'li',
    className: 'user',
    initialize: function (options) {
        this.formatter = options.formatter;
        this.model.bind('change:nick', this.remove, this);
        this.model.bind('change:display_name', this.renderLink, this);
        this.model.bind('change:usermask', this.renderLink, this);
        this.model.bind('change:realname', this.renderLink, this);
        this.model.bind('change:away', this.renderLink, this);
        this.model.bind('remove', this.remove, this);
        this.model.collection.bind('reset', this.remove, this);
        if (this.model.channel) {
            this.listenTo(this.model.channel, 'preinit', this.remove);
        }
    },
    getLinkClassName: function () {
        var className = 'link buffer bufferLink user ' + this.model.getModeClass();
        if (this.model.isAway()) {
            className += ' away';
        } else {
            className += ' present';
        }
        if (!this.model.isSelf()) {
            var index = this.formatter.getNickColorIndex(this.model.getName());
            className += ' c' + index;
        }
        return className;
    },
    remove: function () {
        return Backbone.View.prototype.remove.apply(this, arguments);
    },
    renderLink: function () {
        this.$el.toggleClass('away', this.model.isAway());
        this.$el.toggleClass('present', !this.model.isAway());
        var name = this.model.getDisplayAuthor() || this.model.getName();
        this.link.text(name);
        this.link.removeClass();
        this.link.addClass(this.getLinkClassName());
        this.link.attr({
            'aria-controls': 'memberContextMenu',
            'aria-haspopup': 'true'
        });
        var title = this.model.getTitle();
        if (title) {
            this.link.attr('title', title);
        }
        if (this.model.channel) {
            this.$el.attr('data-bid', this.model.channel.bid());
        }
        this.$el.attr('data-cid', this.model.getCid());
        this.$el.attr('data-name', this.model.getName());
        this.$el.attr('data-usermask', this.model.getHostMask());
        this.$el.attr('data-ident_prefix', this.model.get('ident_prefix'));
        this.$el.attr('data-user', this.model.get('user'));
        this.$el.attr('data-userhost', this.model.get('userhost'));
        this.$el.attr('data-mode', this.model.get('mode'));
        this.link.attr('data-cid', this.model.getCid());
        this.link.attr('data-name', this.model.getName());
        this.link.attr('data-usermask', this.model.getHostMask());
        this.link.attr('data-ident_prefix', this.model.get('ident_prefix'));
        this.link.attr('data-user', this.model.get('user'));
        this.link.attr('data-userhost', this.model.get('userhost'));
        this.link.attr('data-mode', this.model.get('mode'));
        return this;
    },
    render: function () {
        this.link = $('<button>');
        this.renderLink();
        this.$el.append(this.link);
        return this;
    }
});


module.exports = MemberView;


/***/ }),

/***/ "INx5":
/***/ (function(module, exports, __webpack_require__) {

var Connection = __webpack_require__("LLdI");
var FileWrapper = __webpack_require__("JHsc");
var IRCFormatter = __webpack_require__("XiBv");
var util = __webpack_require__("GmLC");
var uriTemplates = __webpack_require__("0a14");

var urlUtil = __webpack_require__("Dn1P");
var re = __webpack_require__("38es");

var VIDEO_WIDTH = 416;
var VIDEO_HEIGHT = 234;

var image_ext_parts = ['jpe?g', 'gif', 'png', 'webp'];
var IMAGE_EXT_RE = new RegExp('\\.' + re.c(re.oneOf(image_ext_parts)) + '$');

var CHAN_PREFIX_CHARS = '#＃';
var EMOJI_HASH_SUFFIX = '\\ufe0e\\ufe0f\\u20e3';
var BAD_CHAN_CHARS = '<>",\\s';

var QUOTES = {
    '"': '"',
    "'": "'",
    ')': '(',
    ']': '[',
    '}': '{',
    '>': '<',
    '”': '“',
    '’': '‘',
    '»': '«',
    '`': '`'
};

var regexCache = {};

var linker = function (formatter) {
    this.formatter = formatter;
    this.buffer = formatter.buffer;
    this.setRegex();
    if (this.buffer) {
        this.listenTo(this.buffer.connection, 'iSupportChange', this.setRegex);
    }
};
_.extend(linker.prototype, Backbone.Events, {
    setRegex: function () {
        this.chanPrefix = this.buffer ? this.buffer.connection.getChannelPrefixes() : CHAN_PREFIX_CHARS;
        if (regexCache[this.chanPrefix]) {
            this.chanRegex = regexCache[this.chanPrefix].chanRegex;
            this.chanRegexStart = regexCache[this.chanPrefix].chanRegexStart;
            this.regex = regexCache[this.chanPrefix].regex;
        } else {
            this.chanRegex = re.isA(re.escape(this.chanPrefix)) +
                re.notA(EMOJI_HASH_SUFFIX + BAD_CHAN_CHARS) +
                re.atLeastNone(re.notA(BAD_CHAN_CHARS));
            this.chanRegexStart = new RegExp('^' + this.chanRegex),
            this.regex = new RegExp(re.oneOf(urlUtil.getParts(this.chanRegex)), 'gi');
            regexCache[this.chanPrefix] = {
                chanRegex: this.chanRegex,
                chanRegexStart: this.chanRegexStart,
                regex: this.regex
            };
        }
    },
    isChannelName: function (string) {
        return !!string.match(this.chanRegexStart);
    },
    isCurrentUrl: function (urlParts) {
        return urlUtil.isCurrentUrl(urlParts);
    },
    isImage: function (urlParts) {
        var re = IMAGE_EXT_RE;
        return re.test(urlParts.pathname.toLowerCase()) ||
               re.test(urlParts.search.toLowerCase()) ||
               re.test(urlParts.hash.toLowerCase());
    },
    imageUrl: function (urlParts, url, message) {
        if (this.fileParts(urlParts, message)) {
            return;
        }
        if (this.isAttachmentImage(url, message)) {
            return;
        }
        urlParts.protocol = 'https:';
        if (urlParts.hostname.match(/^(?:www\.)?dropbox\.com$/i)) {
            var dropboxMatch = urlParts.pathname.match(/^\/s\/([^\/&]+)\/([^\/&]+)\/?$/);
            if (dropboxMatch) {
                return 'https://dl.dropboxusercontent.com/s/' + dropboxMatch[1] + '/' + dropboxMatch[2];
            }
        } else if (urlParts.hostname.match(/^pbs\.twimg\.com$/i)) {
            var twimgMatch = urlParts.pathname.match(/^\/media\/([^\/:]+)(:\w+)?\/?$/);
            if (twimgMatch) {
                return 'https://pbs.twimg.com/media/' + twimgMatch[1] + '?format=jpg&name=small';
            }
        } else if (urlParts.hostname.match(/^droplr\.com$/i) || urlParts.hostname.match(/^d\.pr$/i)) {
            var dprMatch = urlParts.pathname.match(/^\/i\/([^\/+]+)/);
            if (dprMatch) {
                return 'https://d.pr/i/' + dprMatch[1] + '+';
            }
        } else if (urlParts.hostname.match(/\.steam(?:powered|usercontent)\.com$/i)) {
            var steamMatch = urlParts.pathname.match(/^\/ugc\/([^\/&]+)\/([^\/&]+)\/?/);
            if (steamMatch) {
                return urlParts.href;
            }
        } else if (urlParts.hostname.match(/^lh\d+\.(googleusercontent)|(ggpht)\.com$/i)) {
            return urlParts.href;
        } else if (urlParts.hostname.match(/i\.reddituploads\.com$/i)) {
            return urlParts.href;
        }
        if (this.isImage(urlParts)) {
            return urlParts.href;
        }
    },
    singleImage: function (message, options) {
        options = options || {};
        var image;
        var embeds = message.getEmbeds();
        if (options.files) {
            if (embeds && embeds.files) {
                _.any(embeds.files, function (file) {
                    if (!file.id) {
                        return false;
                    }
                    var fw = new FileWrapper(file);
                    if (fw.isPreviewable()) {
                        image = fw.getUrl();
                        return true;
                    }
                    return false;
                }, this);
            }
        }
        if (!image && options.images) {
            var urlSplitParts = this.splitTextOnUrls(IRCFormatter.strip(message.get('msg')), 0);
            _.any(urlSplitParts, function (part, index) {
                if (part.url) {
                    var urlParts = urlUtil.urlParts(part.url);
                    if (urlParts) {
                        image = this.imageUrl(urlParts, part.url, message);
                        if (image) {
                            return true;
                        }
                    }

                }
            }, this);
        }
        if (!image && message.buffer.imageAvatarsEnabled()) {
            var avatar = message.getAvatar();
            if (avatar) {
                image = uriTemplates(avatar.src).fill({
                    size: 128
                });
            }
        }
        return image;
    },
    gistParts: function (urlParts) {
        var gistMatch;
        if (urlParts.hostname.match(/^gist\.github\.com$/i)) {
            gistMatch = urlParts.pathname.match(/^\/(?:([^\/&]+)\/)?([^\/\.&]+)\/?$/);
        }
        if (gistMatch && gistMatch[2] && (
            urlUtil.isNum(gistMatch[2]) || gistMatch[2].length >= 20
        )) {
            return {
                gist_owner: gistMatch[1],
                gist_id: gistMatch[2],
                gist_hash: urlParts.hash
            };
        }
    },
    host: function () {
        return this.buffer ? this.buffer.session.getHost() : window.location.hostname;
    },
    fileHost: function () {
        return window.IRCConfig.file_upload_domain;
    },
    pasteParts: function (urlParts) {
        var pasteMatch;
        if (urlParts.hostname == this.host()) {
            pasteMatch = urlParts.pathname.match(/^\/pastebin\/([^\/\.&]+)/);
        }
        if (pasteMatch) {
            return {
                paste_id: pasteMatch[1],
            };
        }
    },
    fileParts: function (urlParts, message) {
        if (message) {
            var embeds = message.getEmbeds();
            if (embeds && embeds.files) {
                if (urlParts.hostname == this.host() || urlParts.hostname == this.fileHost()) {
                    var fileMatch = urlParts.pathname.match(/^\/file\/(.+)/);
                    if (fileMatch) {
                        var pathParts = fileMatch[1].split('/');
                        var file = _.find(embeds.files, function (f) {
                            if (_.include(pathParts, f.id)) {
                                return true;
                            }
                        });
                        if (file) {
                            return {
                                file_id: file.id
                            };
                        }
                    }
                }
            }
        }
    },
    isAttachmentImage: function (url, message) {
        if (message) {
            var attachments = message.getAttachmentsJson();
            var concatParent = message.getConcatParent();
            if (concatParent) {
                attachments = attachments.concat(concatParent.getAttachmentsJson());
            }
            return !!_.find(attachments, function (attach) {
                if (
                    url === attach.from_url ||
                    url === attach.title_link ||
                    url === attach.file_url
                ) {
                    return true;
                }
            });
        }
        return false;
    },
    twitchParts: function (urlParts) {
        var twitchMatch;
        if (urlParts.hostname.match(/^(\w+\.)?twitch\.tv$/i)) {
            twitchMatch = urlParts.pathname.match(/^\/([^\/\.&]+)\/?(.*)$/);
        }
        if (twitchMatch) {
            var parts = {
                channel: twitchMatch[1]
            };
            var partMatch = twitchMatch[2].match(/^(b|c)\/([^\/\.&]+)\/?/);
            if (partMatch && partMatch[1] == 'b') {
                parts.archive = partMatch[2];
            }
            if (partMatch && partMatch[1] == 'c') {
                parts.chapter = partMatch[2];
            }
            return parts;
        }
    },
    gfycatParts: function (urlParts) {
        if (urlParts.hostname.match(/(^|\.)gfycat\.com$/i)) {
            var pathMatch = urlParts.pathname.match(/^\/(?:detail\/)?([^\/&]+)$/);
            if (pathMatch && !_.include([
                'about', 'api', 'terms'
            ], pathMatch[1])) {
                var ret = {
                    gfycat_id: pathMatch[1].split('.')[0].split('-')[0]
                };
                return ret;
            }
        }
    },
    imgurEmbedParts: function (urlParts) {
        if (urlParts.hostname.match(/(^|(www|m|i)\.)imgur\.com$/i)) {
            var pathMatch = urlParts.pathname.match(/^\/(?:(a|(?:gallery)|(?:(?:g|t|r)\/[^\/&]+))\/)?([^\/\.&]{2,})/);
            if (pathMatch) {
                var hashIndex = urlParts.hash.match(/^#?(\d+)$/);
                var idx = 0;
                if (hashIndex) {
                    idx = hashIndex[1] - 0;
                }
                var prefix = '';
                if (pathMatch[1]) {
                    prefix = pathMatch[1] + '/';
                }
                var idList = pathMatch[2].split(',');
                var id = idList[idx];
                return {
                    id: id,
                    prefix: prefix
                };
            }
        }
    },
    wikiParts: function (urlParts) {
        var wikiMatch, titleMatch;
        var hostMatch = urlParts.hostname.match(/\.wiki[pm]edia\.org$/i);
        if (hostMatch) {
            wikiMatch = urlParts.pathname.match(/^\/wiki\/(.*)/);
            if (wikiMatch) {
                titleMatch = wikiMatch[1].match(/^(File:.+)/);
                if (!titleMatch) {
                    titleMatch = urlParts.hash.match(/^#?\/media\/(File:.+)/);
                }
            }
        }
        if (titleMatch) {
            return {
                wiki_host: urlParts.hostname,
                wiki_title: titleMatch[1]
            };
        }
    },
    twitterParts: function (urlParts) {
        var twitterMatch, momentMatch, iwebMatch;
        if (urlUtil.matchTwitter(urlParts)) {
            twitterMatch = urlParts.pathname.match(/^\/([^\/&]+)\/status(?:es)?\/(\d+)\/?/);
            iwebMatch = urlParts.pathname.match(/^\/i\/web\/status\/(\d+)\/?/);
            momentMatch = urlParts.pathname.match(/^\/i\/moments\/(\d+)\/?/);
        }
        if (twitterMatch) {
            return {
                twitter_owner: twitterMatch[1],
                twitter_id: twitterMatch[2]
            };
        } else if (iwebMatch) {
            return {
                twitter_id: iwebMatch[1]
            };
        } else if (momentMatch) {
            return {
                twitter_moment_id: momentMatch[1]
            };
        }
    },
    pinterestParts: function (urlParts) {
        var pinMatch;
        if (urlParts.hostname.match(/(?:^|\.)pinterest\.com$/i)) {
            pinMatch = urlParts.pathname.match(/^\/pin\/(\d+)\/?/);
        }
        if (pinMatch) {
            return {
                pin_id: pinMatch[1]
            };
        }
    },
    xkcdParts: function (urlParts) {
        var xkcdMatch;
        if (urlParts.hostname.match(/^(www\.)?xkcd\.com$/i)) {
            xkcdMatch = urlParts.pathname.match(/^\/(\d+)/);
        }
        if (xkcdMatch) {
            return {
                comic_id: xkcdMatch[1]
            };
        }
    },
    isFlickr: function (urlParts) {
        var flickrMatch;
        if (urlParts.hostname.match(/^(www\.)?flickr\.com$/i)) {
            flickrMatch = urlParts.pathname.match(/^\/photos\/([^\/&]+)\/([^\/\.&]+)\/?/);
        }
        if (!flickrMatch && urlParts.hostname.match(/^(www\.)?flic\.kr$/i)) {
            flickrMatch = urlParts.pathname.match(/^\/p\/([^\/\.&]+)\/?$/);
        }
        return !!flickrMatch;
    },
    instagramParts: function (urlParts) {
        var instagramMatch;
        if (urlUtil.matchInstagram(urlParts)) {
            instagramMatch = urlParts.pathname.match(/^\/((p)|(reel))\/([^\/\.&]+)\/?$/);
        }
        if (instagramMatch) {
            return {
                photo_id: instagramMatch[4],
                insta_type: instagramMatch[1]
            };
        }
    },
    mastodonParts: function (urlParts) {
        var mastodonMatch = urlUtil.matchMastodon(urlParts);
        if (mastodonMatch) {
            return {
                mastodon_origin: urlParts.origin,
                mastodon_username: mastodonMatch[1],
                mastodon_userinstance: mastodonMatch[2],
                mastodon_status: mastodonMatch[3]
            };
        }
    },
    bskyParts: function (urlParts) {
        var bskyMatch;
        if (urlUtil.matchBsky(urlParts)) {
            bskyMatch = urlParts.pathname.match(/^\/profile\/([^\/]+)\/post\/([^\/]+)/);
        }
        if (bskyMatch) {
            var parts = {
                bsky_post: bskyMatch[2]
            };
            if (bskyMatch[1].indexOf('did:') === 0) {
                parts.bsky_did = bskyMatch[1];
            } else {
                parts.bsky_handle = bskyMatch[1];
            }
            return parts;
        }
    },
    redditParts: function (urlParts) {
        var redditMatch;
        if (urlUtil.matchReddit(urlParts)) {
            redditMatch = urlParts.pathname.match(/^\/r\/([^\/]+)\/comments\/([a-z0-9]+)/);
        }
        if (redditMatch) {
            return {
                reddit_sub: redditMatch[1],
                reddit_post: redditMatch[2]
            };
        }
    },
    embedFrame: function (urlParts) {
        var videoParts = this.youTubeParts(urlParts);
        if (videoParts) {
            return this.buildYoutubeFrame(videoParts);
        }
        videoParts = this.vimeoParts(urlParts);
        if (videoParts) {
            return this.buildVimeoFrame(videoParts);
        }
        videoParts = this.tenorParts(urlParts);
        if (videoParts) {
            return this.buildTenorFrame(videoParts);
        }
        videoParts = this.garminParts(urlParts);
        if (videoParts) {
            return this.buildGarminFrame(videoParts);
        }
        videoParts = this.twitchClipParts(urlParts);
        if (videoParts) {
            return this.buildTwitchClipFrame(videoParts);
        }
        videoParts = this.kickstarterParts(urlParts);
        if (videoParts) {
            return this.buildKickstarterFrame(videoParts);
        }
        if (this.isSpotifyEmbed(urlParts)) {
            return this.buildSpotifyFrame(urlParts);
        }
    },
    youTubeParts: function (urlParts) {
        var videoIdMatches, videoId;
        if (urlUtil.matchYouTube(urlParts)) {
            videoIdMatches = urlParts.search.match(/[?&]v=([^"&?\/ ]{11})/) ||
                           urlParts.pathname.match(/^\/(?:v|e|shorts)\/([^"&?\/ ]{11})/);
        } else if (urlParts.hostname.match(/(?:^|\.)youtu\.be$/i)) {
            videoIdMatches = urlParts.pathname.match(/^\/([^"&?\/ ]{11})/);
        }
        if (videoIdMatches) {
            videoId = videoIdMatches[1];
            var ts;
            var tsMatches = urlParts.hash.match(/[#&]t=([^&]+)/) ||
                            urlParts.search.match(/[?&]t=([^&]+)/);
            if (tsMatches) {
                ts = tsMatches[1];
            }
            return {
                vid: videoId,
                ts: ts
            };
        }
    },
    vimeoParts: function (urlParts) {
        var videoIdMatches, videoId;
        if (urlParts.hostname.match(/(?:^|\.)vimeo\.com$/i)) {
            videoIdMatches = urlParts.pathname.match(/^\/(\d+)/);
        }
        if (videoIdMatches) {
            videoId = videoIdMatches[1];
            return {
                vid: videoId
            };
        }
    },
    tenorParts: function (urlParts) {
        var tenorIdMatches, tenorId;
        if (urlParts.hostname.match(/(?:^|\.)tenor\.com$/i)) {
            tenorIdMatches = urlParts.pathname.match(/^\/view\/.*-(\d+)$/);
        }
        if (tenorIdMatches) {
            tenorId = tenorIdMatches[1];
            return {
                id: tenorId
            };
        }
    },
    garminParts: function (urlParts) {
        var activityIdMatches, activityId;
        if (urlParts.hostname.match(/(?:^|\.)garmin\.com$/i)) {
            activityIdMatches = urlParts.pathname.match(/^\/(?:modern\/)?activity\/(?:embed\/)?(\d+)/);
        }
        if (activityIdMatches) {
            activityId = activityIdMatches[1];
            return {
                id: activityId
            };
        }
    },
    kickstarterParts: function (urlParts) {
        if (urlParts.hostname.match(/(?:^|\.)kickstarter\.com$/i)) {
            var projectMatches = urlParts.pathname.match(/^\/projects\/([^/]+)\/([^/]+)/);
            if (projectMatches) {
                return {
                    id: projectMatches[1],
                    name: projectMatches[2]
                };
            }
        }
    },
    twitchClipParts: function (urlParts) {
        var clipMatches;
        if (urlParts.hostname.match(/^clips\.twitch\.tv$/i)) {
            if (urlParts.pathname.match(/^\/embed\/?$/)) {
                clipMatches = urlParts.search.match(/[?&]clip=([^&]+)/);
            } else {
                clipMatches = urlParts.pathname.match(/^\/([A-Z][\w-]+)/);
            }
        } else if (urlParts.hostname.match(/(?:^|\.)twitch\.tv$/i)) {
            clipMatches = urlParts.pathname.match(/^\/[^/]+\/clip\/([^/]+)$/);
        }
        if (clipMatches) {
            return {
                clip: clipMatches[1]
            };
        }
    },
    pastebincomParts: function (urlParts) {
        var idMatches, id;
        if (urlParts.hostname.match(/(?:^|\.)pastebin\.com$/i)) {
            idMatches = urlParts.pathname.match(/^\/(?:raw\/)?([A-Za-z0-9]{8,8})(?:\/|$)/);
        }
        if (idMatches) {
            id = idMatches[1];
            var charTypeMatches = _.filter([
                /[A-Z]/.test(id),
                /[a-z]/.test(id),
                /[0-9]/.test(id)
            ], _.identity);
            if (charTypeMatches.length > 1) {
                return {
                    id: id
                };
            }
        }
    },
    iframeProps: function (allowScrolling) {
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe
        var sandbox = [
            'allow-forms',
            'allow-popups',
            'allow-popups-to-escape-sandbox',
            'allow-same-origin',
            'allow-scripts',
            'allow-presentation'
        ];
        var props = {
            'type': 'text/html',
            'allowfullscreen': 'true',
            'mozallowfullscreen': 'true',
            'webkitallowfullscreen': 'true',
            'sandbox': sandbox.join(' ')
        };
        if (!allowScrolling) {
            props.scrolling = 'no';
        }
        return props;
    },
    buildEmbedFrame: function (src, extraClass, width, height, embedTest, allowScrolling) {
        width = width || VIDEO_WIDTH;
        height = height || VIDEO_HEIGHT;
        embedTest = embedTest || (this.buffer && this.buffer.inlineImagesAllowed());
        var tag = embedTest ? 'iframe' : 'i';
        var className = 'iframeEmbed';
        if (extraClass) {
            className += ' ' + extraClass;
        }
        var ifProps = this.iframeProps(allowScrolling);
        ifProps['class'] = className;
        ifProps['width'] = width;
        ifProps['height'] = height;
        ifProps['src'] = src;
        var pxWidth = /^\d+$/.test(width) ? (width + 'px') : width;
        var pxHeight = /^\d+$/.test(height) ? (height + 'px') : height;
        ifProps['style'] = 'width: ' + pxWidth + '; height: ' + pxHeight + '; max-width: ' + pxWidth;
        var props = this.formatter.makeAttributes(ifProps);
        var frame = '<' + tag + ' ' + props + '></' + tag + '>';
        return [frame, width, extraClass];
    },
    buildYoutubeFrame: function (parts) {
        var params = {
            autohide: 1,
            controls: 1,
            // enablejsapi: 1,
            // playerapiid: 'TODO',
            rel: 1,
            showinfo: 1,
            start: this.ytStart(parts.ts),
            fs: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            autoplay: 0
        };
        if (this.buffer) {
            params.origin = this.buffer.session.getOrigin();
        }
        var src = 'https://www.youtube.com/embed/' +
            this.formatter.escapeText(encodeURIComponent(parts.vid)) + '?' +
            $.param(params);
        return this.buildEmbedFrame(src, 'video');
    },
    buildVimeoFrame: function (parts) {
        var src = 'https://player.vimeo.com/video/' +
            this.formatter.escapeText(encodeURIComponent(parts.vid));
        return this.buildEmbedFrame(src, 'video');
    },
    buildTenorFrame: function (parts) {
        var params = {};
        if (this.buffer) {
            params.canonicalurl = this.buffer.session.getOrigin();
        }
        var src = 'https://tenor.com/embed/' +
            this.formatter.escapeText(encodeURIComponent(parts.id)) + '?' +
            $.param(params);
        return this.buildEmbedFrame(src, 'tenor video', VIDEO_WIDTH, VIDEO_WIDTH/1.33);
    },
    buildGarminFrame: function (parts) {
        var src = 'https://connect.garmin.com/activity/embed/' +
            this.formatter.escapeText(encodeURIComponent(parts.id));
        return this.buildEmbedFrame(src, 'garmin video', 465, 500);
    },
    buildSpotifyFrame: function (parts) {
        // Remove the hash, timestamp links don't work anymore and mess up the embed
        parts.hash = '';
        var src = 'https://embed.spotify.com/?uri=' +
            this.formatter.escapeText(encodeURIComponent(parts.href));
        return this.buildEmbedFrame(src, 'spotify video', VIDEO_WIDTH, 80);
    },
    buildPastebinComFrame: function (parts) {
        var src = 'https://pastebin.com/embed_iframe/' +
            this.formatter.escapeText(encodeURIComponent(parts.id));
        return this.buildEmbedFrame(
            src,
            'pastebincom',
            '100%', 190,
            (this.buffer && this.buffer.inlinePastesAllowed()),
            true
        );
    },
    buildKickstarterFrame: function (parts) {
        var src = 'https://www.kickstarter.com/projects/' +
            this.formatter.escapeText(encodeURIComponent(parts.id)) + '/' +
            this.formatter.escapeText(encodeURIComponent(parts.name)) +
            '/widget/video.html'; // card.html;
        return this.buildEmbedFrame(src, 'kickstarter video');
    },
    buildTwitchClipFrame: function (parts) {
        var src = 'https://clips.twitch.tv/embed?autoplay=false&parent=' + 
            this.formatter.escapeText(encodeURIComponent(this.host())) + '&clip=' +
            this.formatter.escapeText(encodeURIComponent(parts.clip));
        return this.buildEmbedFrame(src, 'video');
    },
    ytStart: function (startString) {
        if (!startString) {
            return;
        }
        startString = startString.toLowerCase();
        var startHSplit = startString.split('h');
        var startMSplit;
        var h, m, s;
        if (startHSplit[1] === '') {
            h = startHSplit[0] - 0;
            m = 0;
            s = 0;
        } else {
            if (startHSplit[1]) {
                h = startHSplit[0] - 0;
                startMSplit = startHSplit[1].split('m');
            } else {
                h = 0;
                startMSplit = startHSplit[0].split('m');
            }
            var startSSplit;
            if (startMSplit[1]) {
                m = startMSplit[0] - 0;
                startSSplit = startMSplit[1].split('s');
                s = startSSplit[0] - 0;
            } else if (startMSplit[1] === '') {
                m = startMSplit[0] - 0;
                s = 0;
            } else {
                m = 0;
                startSSplit = startMSplit[0].split('s');
                s = startSSplit[0] - 0;
            }
        }
        return s + (((h * 60) + m) * 60);
    },
    isSpotifyEmbed: function (urlParts) {
        if (urlUtil.isSpotify(urlParts.href)) {
            return true;
        }
        if (urlParts.hostname.match(/^open\.spotify\.com$/i)) {
            return true;
        }
        return false;
    },
    isSoundcloudEmbed: function (urlParts) {
        return !!urlParts.hostname.match(/^((?:www|api)\.)?soundcloud\.com$/i);
    },
    isStreamableCom: function (urlParts) {
        // https://streamable.com/3bse
        if (urlParts.hostname.match(/(?:^|\.)streamable\.com$/i)) {
            if (urlParts.pathname.match(/^\/([^\/&]+)/)) {
                return true;
            }
        }
        return false;
    },
    renderUrl: function (url, options) {
        options = options || {};
        url = util.stringify(urlUtil.escapeRTLO(url));
        var htmlContent = this.formatter.escapeText(url);
        var className = 'link';
        var target = null;
        var frame;
        var allowEmbed = !options.inBlock;
        var data = {};
        var embed = '';
        var loading;
        var videoWidth;
        var after;
        var httpAdded = false;
        if (this.isChannelName(url)) {
            if (this.buffer) {
                className = 'buffer bufferLink channel';
                allowEmbed = false;
                data.cid = this.buffer.getCid();
                data.name = url;
                data.bid = this.buffer.bid();
                url = this.buffer.connection.buildUrl([
                    'channel', this.buffer.connection.channelSlug(url)
                ]);
            }
        } else {
            target = "_blank";
            var protocolMatch = urlUtil.protoMatch(url);
            var ircParts;
            if (!protocolMatch) {
                if (urlUtil.isEmail(url)) {
                    // Email address
                    url = 'mailto:' + url;
                    className = 'email';
                    allowEmbed = false;
                } else if (url.indexOf('irc.') === 0) {
                    // Make a network link if it starts with irc.
                    ircParts = util.ircUrlParts('irc://' + url);
                    if (ircParts) {
                        target = null;
                        allowEmbed = false;
                        className = 'buffer bufferLink irc';
                        url = Connection.buildLegacyUrl(ircParts.root, ircParts.label);
                        data.url = url;
                        url = '/' + url;
                    }
                } else if (
                    !urlUtil.isSpotify(url) &&
                    !urlUtil.isSkype(url) &&
                    !urlUtil.isMagnet(url)
                ) {
                    // Prepend http if there's no protocol and it's not a spotify link
                    httpAdded = true;
                    url = 'http://' + url;
                }
            } else if (!urlUtil.isHttp(protocolMatch[0])) {
                if (urlUtil.isLooseHttp(protocolMatch[0])) {
                    var p = urlUtil.urlParts(url);
                    if (p) {
                        url = p.href;
                    }
                } else {
                    allowEmbed = false;
                    target = null;
                    if (urlUtil.isIrc(protocolMatch[0])) {
                        // Convert to network link
                        ircParts = util.ircUrlParts(url);
                        if (ircParts) {
                            className = 'buffer bufferLink irc';
                            url = Connection.buildLegacyUrl(ircParts.root, ircParts.label);
                            data.url = url;
                            url = '/' + url;
                        } else {
                            target = "_blank";
                        }
                    } else if (urlUtil.isFtp(protocolMatch[0])) {
                        // https://code.google.com/p/chromium/issues/detail?id=30892
                        // FTP url's should open in default app on Mac OS X
                        // (affects firefox too)
                        // (doesn't affect safari, but it will complain about mime types, so stick to new window for safety)
                        target = "_blank";
                    } else if (!$.browser.safari) {
                        // https://bugzilla.mozilla.org/show_bug.cgi?id=667865
                        // Clicking a non-http protocol url erroneously triggers the onbeforeunload event
                        // (chrome does the same now)
                        // Safari handles protocol urls fine, no retargeting needed
                        target = "_blank";
                    }
                }
            }
        }
        var urlParts = urlUtil.urlParts(url);
        if (!urlParts) {
            return;
        }
        if (urlParts.username || urlParts.password) {
            if (httpAdded) {
                return;
            }
            var userPass = '<span class="urlUserPass"> (';
            var hiddenUserPass = '';
            if (urlParts.username) {
                userPass += 'username: ' + this.formatter.escapeText(urlParts.username);
                if (urlParts.password) {
                    userPass += ' ';
                }
                hiddenUserPass += this.formatter.escapeText(
                    encodeURIComponent(urlParts.username)
                );
            }
            if (urlParts.password) {
                userPass += 'password: ' + this.formatter.escapeText(urlParts.password);
                hiddenUserPass += this.formatter.escapeText(
                    ':' + encodeURIComponent(urlParts.password)
                );
            }
            userPass += ')</span>';
            after = userPass;
            htmlContent = this.formatter.escapeText(urlParts.protocol + '//');
            htmlContent += '<span class="urlUserPassHidden">';
            htmlContent += hiddenUserPass;
            htmlContent += '@</span>';
            htmlContent += this.formatter.escapeText(
                urlParts.host + urlParts.pathname + urlParts.search + urlParts.hash
            );
        }
        if (this.isCurrentUrl(urlParts)) {
            if (urlParts.pathname == '/') {
                url = urlParts.search + urlParts.hash;
            } else {
                url = urlParts.pathname + urlParts.search + urlParts.hash;
            }
            target = null;
        } else if (options.embeds && allowEmbed) {
            // We use assignment in conditionals here to avoid
            // nesting hell
            var gistParts,
                pasteParts,
                instagramParts,
                twitterParts,
                imgurEmbedParts,
                wikiParts,
                pinParts,
                xkcdParts,
                gfycatParts,
                mastodonParts,
                bskyParts,
                redditParts,
                imageUrl,
                pastebincomParts;
            if ((gistParts = this.gistParts(urlParts))) {
                className = 'gist';
                loading = true;
                data = _.extend({}, data, gistParts);
            } else if ((pasteParts = this.pasteParts(urlParts))) {
                className = 'paste';
                loading = true;
                if (options.embeds && options.embeds.pastes) {
                    var entity = _.find(options.embeds.pastes, function (paste) {
                        return paste.id == pasteParts.paste_id;
                    });
                    if (entity) {
                        for (var k in entity) {
                            pasteParts['paste_' + k] = entity[k];
                        }
                    }
                }
                data = _.extend({}, data, pasteParts);
            } else if (this.isFlickr(urlParts)) {
                className = 'flickr';
                loading = true;
            } else if ((instagramParts = this.instagramParts(urlParts))) {
                className = 'instagram';
                loading = true;
                data = _.extend({}, data, instagramParts);
            } else if (this.isSoundcloudEmbed(urlParts)) {
                className = 'soundcloud';
                loading = true;
            } else if (this.isStreamableCom(urlParts)) {
                className = 'streamablecom';
                loading = true;
            } else if ((twitterParts = this.twitterParts(urlParts))) {
                className = 'twitter';
                loading = true;
                data = _.extend({}, data, twitterParts);
            } else if ((imgurEmbedParts = this.imgurEmbedParts(urlParts))) {
                className = 'imgur';
                loading = true;
                data.imgur_embed = imgurEmbedParts.id;
                data.imgur_embed_prefix = imgurEmbedParts.prefix;
            } else if ((wikiParts = this.wikiParts(urlParts))) {
                className = 'wiki';
                loading = true;
                data = _.extend({}, data, wikiParts);
            } else if ((pinParts = this.pinterestParts(urlParts))) {
                className = 'pinterest';
                loading = true;
                data = _.extend({}, data, pinParts);
            } else if ((xkcdParts = this.xkcdParts(urlParts))) {
                className = 'xkcd';
                loading = true;
                data = _.extend({}, data, xkcdParts);
            } else if ((gfycatParts = this.gfycatParts(urlParts))) {
                className = 'gfycat';
                loading = true;
                data = _.extend({}, data, gfycatParts);
            } else if ((mastodonParts = this.mastodonParts(urlParts))) {
                className = 'mastodon';
                loading = true;
                data = _.extend({}, data, mastodonParts);
            } else if ((bskyParts = this.bskyParts(urlParts))) {
                className = 'bsky';
                loading = true;
                data = _.extend({}, data, bskyParts);
            } else if ((redditParts = this.redditParts(urlParts))) {
                className = 'reddit';
                loading = true;
                data = _.extend({}, data, redditParts);
            } else if ((imageUrl = this.imageUrl(urlParts, url, options.message))) {
                var tag = (this.buffer && this.buffer.inlineImagesAllowed()) ? 'img' : 'i';
                embed = '<' + tag + ' src="' + this.formatter.escapeText(imageUrl) + '" class="image loading"></' + tag + '>';
                className = 'image';
            } else if ((pastebincomParts = this.pastebincomParts(urlParts))) {
                frame = this.buildPastebinComFrame(pastebincomParts);
                embed = frame[0];
                className = 'pastebincom';
            } else if ((frame = this.embedFrame(urlParts))) {
                embed = frame[0];
                videoWidth = frame[1];
                if (frame[2]) {
                    className = frame[2];
                } else {
                    className = 'video';
                }
            }
        }
        return {
            html: htmlContent,
            url: url,
            className: className,
            target: target,
            data: data,
            embed: embed,
            loading: loading,
            videoWidth: videoWidth,
            after: after,
            parts: urlParts
        };
    },
    makeLinkFromBits: function (html, bits, extraClass) {
        var className = bits.className;
        if (extraClass) {
            className += ' ' + extraClass;
        }
        if (bits.loading) {
            className += ' loading';
        }
        return this.make(html, _.extend({
            href: bits.url,
            'class': className,
            'rel': 'noreferrer',
            target: bits.target,
            data: bits.data
        }, bits.attrs)) + (bits.after || '');
    },
    makeLinkFromUrl: function (url, html, attrs) {
        html = html || url;
        var parts = this.splitTextOnUrls(url);
        if (parts && parts.length === 1 && parts[0].url) {
            var bits = this.renderUrl(parts[0].url);
            if (bits) {
                bits.attrs = attrs;
                delete bits.after;
                delete bits.loading;
                return this.makeLinkFromBits(html, bits);
            }
        }
    },
    make: function (html, attributes, button) {
        var tag = 'a';
        if (button) {
            delete attributes.href;
            attributes['class'] += ' link';
            tag = button || 'button';
        }
        if (attributes.href) {
            var urlParts = urlUtil.urlParts(attributes.href);
            if (urlUtil.isDisallowed(urlParts.protocol)) {
                return html + ': ' + this.formatter.escapeText(attributes.href);
            } else {
                attributes.href = urlParts.href;
            }
        }
        return '<' + tag + this.formatter.makeAttributes(attributes)+ '>' + html + '</' + tag + '>';
    },
    isUnbalanced: function (url) {
        var lastChar = url.slice(-1);
        return lastChar in QUOTES &&
            url.split(lastChar).length !== url.split(QUOTES[lastChar]).length;
    },
    cutBackUrl: function (url, prefix) {
        return url.slice(0, url.indexOf(prefix) + prefix.length);
    },
    splitTextOnUrls: function (text, textIndex) {
        textIndex = textIndex || 0;
        text = util.stringify(text);
        // Extract URLs and hashes
        var urls = [];
        try {
            urls = text.match(this.regex);
        } catch (e) {
            debug.error(e, text);
        }
        // Split text into linkable parts
        var textParts = [];
        var parsedIndex = 0;
        var prevWasText = false;
        var prevIdx = -1;
        if (urls) {
            _.each(urls, function (url, i) {
                var textValue = text.slice(parsedIndex, text.indexOf(url, parsedIndex));
                if (textValue !== '') {
                    if (prevWasText) {
                        textParts[prevIdx].value += textValue;
                    } else {
                        textParts.push({
                            value: textValue,
                            index: textIndex + parsedIndex
                        });
                        prevIdx++;
                        prevWasText = true;
                    }
                }
                var part = {
                    index: textIndex + parsedIndex + textValue.length
                };
                parsedIndex += textValue.length + url.length;

                var prevChar = textValue.slice(-1);

                // Strip trailing punctuation
                var trailPuncMatch, innerPunc;
                while (url && (trailPuncMatch = urlUtil.trailingPuncMatch(url))) {
                    innerPunc = trailPuncMatch[0][0];
                    if (innerPunc in QUOTES && prevChar != QUOTES[innerPunc]) {
                        break;
                    }
                    url = url.slice(0, -trailPuncMatch[0].length);
                    parsedIndex -= trailPuncMatch[0].length;
                }
                var closeParenMatch;
                while (url && (closeParenMatch = urlUtil.closeParenMatch(url))) {
                    innerPunc = closeParenMatch[0][0];
                    if (innerPunc in QUOTES && prevChar != QUOTES[innerPunc]) {
                        break;
                    }
                    parsedIndex -= url.slice(closeParenMatch.index).length;
                    url = url.slice(0, closeParenMatch.index);

                }
                var protoStrip = urlUtil.protoStrip(url);
                var domainParts = urlUtil.domainSplit(protoStrip);
                if (!urlUtil.isEmail(url) && (domainParts[1] || domainParts[0] === protoStrip)) {
                    var colonParts = domainParts[0].split(':');
                    // Non-digit after colon and first part doesn't
                    // contain ?#/ then stop matching before the colon
                    var preColon = colonParts[0];

                    var postColonPart = 1;
                    var postColon = colonParts[postColonPart];
                    if (urlUtil.domainMatch(preColon)) {
                        if (postColon && postColon.indexOf('@') !== -1) {
                            // User/password, check next value
                            preColon += ':' + postColon;
                            postColonPart = 2;
                            postColon = colonParts[postColonPart];
                        }
                        var newUrl;
                        var domainSplit = urlUtil.domainEndSplit(domainParts[0]);
                        if (postColon) {
                            var cutBack;
                            if (
                                postColon.match(/^\d+/) ||
                                // +6697 indicates ircs in irc urls
                                (urlUtil.isIrc(url) && postColon.match(/^\+(\d+)$/))
                            ) {
                                // port digit matched, shouldn't have more parts
                                if (colonParts[postColonPart + 1]) {
                                    preColon += ':' + postColon;
                                    cutBack = true;
                                }
                            } else if (!urlUtil.domainEndMatch(preColon)) {
                                // no port digit matched, previous part doesn't contain
                                // a domain ender
                                cutBack = true;
                            }
                            if (cutBack) {
                                // Only match url up to the colon
                                var preColonSplit = urlUtil.domainEndSplit(preColon);
                                if (preColonSplit[1] !== undefined) {
                                    preColon = preColonSplit[0];
                                }
                                newUrl = this.cutBackUrl(url, preColon);
                                parsedIndex -= url.length - newUrl.length;
                                url = newUrl;
                            } else if (domainSplit[1] !== undefined) {
                                newUrl = this.cutBackUrl(url, domainSplit[0]);
                                parsedIndex -= url.length - newUrl.length;
                                url = newUrl;
                            }
                        } else if (domainSplit[1] !== undefined) {
                            newUrl = this.cutBackUrl(url, domainSplit[0]);
                            parsedIndex -= url.length - newUrl.length;
                            url = newUrl;
                        }
                    }
                }

                var nextChar = text[parsedIndex];
                var nextChar2 = text[parsedIndex+1];
                while (this.isUnbalanced(url)) {
                    // Don't include last character if it's unbalanced
                    url = url.slice(0, -1);
                    parsedIndex--;
                }

                if (urlUtil.isDangerousString(url)) {
                    // strings that crash browsers
                } else if (nextChar =='.' && nextChar2 && nextChar2.match(/\w/)) {
                    // looks like a class path e.g. java.security.SecureRandom
                } else if (prevChar == '&' && url[0] == '#') {
                    // colour code
                } else if ($.inArray(prevChar, ['/', '\\']) !== -1) {
                    // previous char is slash, e.g. a file path
                } else if (urlUtil.isEmail(url) && nextChar == '/') {
                    // next char after email is slash
                } else if (url == '#') {
                    // bare hash, (probably due to trailing punc)
                } else if (this.isChannelName(url) && urlUtil.isNum(url.slice(1))) {
                    // #1 numeral
                } else if (urlUtil.isBareHttp(url)) {
                    // Don't match bare http links
                } else if (urlUtil.isDisallowed(url)) {
                    // Don't match disallowed links
                } else {
                    part.url = url;
                }
                part.value = url;
                if (part.url) {
                    textParts.push(part);
                    prevIdx++;
                    prevWasText = false;
                } else {
                    if (prevWasText) {
                        textParts[prevIdx].value += part.value;
                    } else {
                        textParts.push(part);
                        prevIdx++;
                        prevWasText = true;
                    }
                }
            }, this);
        }
        var textValue = text.slice(parsedIndex);
        if (textValue !== '') {
            if (prevWasText) {
                textParts[prevIdx].value += textValue;
            } else {
                textParts.push({
                    value: textValue,
                    index: textIndex + parsedIndex
                });
            }
        }
        return textParts;
    }
});


module.exports = linker;


/***/ }),

/***/ "J6S1":
/***/ (function(module, exports, __webpack_require__) {

var Keyboard = __webpack_require__("fDhS").default;


var HistoryCompletion = Backbone.View.extend({
    initialize: function (options) {
        this.input = options.input;

        this.currentValue = {msg: ''};

        this.index = 0;

        this.model.bind('sayRequest', this.sayRequest, this);
        this.model.bind('removePending', this.removePending, this);
        this.model.bind('removeAllPending', this.removePending, this);
    },
    events: {
        'keydown': 'keyDown'
    },
    sayRequest: function (message, reqid) {
        this.resetIndex();
        this.pending = true;
    },
    removePending: function () {
        this.pending = false;
    },
    pushState: function (message, reply) {
        this.model.pushInputHistory(message, reply);
    },
    isIndexReset: function () {
        // Can be 0 or undefined
        return !this.index;
    },
    incrementIndex: function (value) {
        this.index += value;
    },
    resetIndex: function () {
        this.index = 0;
    },
    getFromEnd: function (index) {
        return this.model.inputHistory[this.getLength() + this.index + index];
    },
    getLength: function () {
        return this.model.inputHistory.length;
    },
    getEarlier: function () {
        var value = this.getFromEnd(-1);
        if (value !== undefined) {
            // Move index up
            this.incrementIndex(-1);
        }
        return value;
    },
    getLater: function () {
        // Invalid if called from the bottom of the index
        if (this.isIndexReset()) {
            return undefined;
        }
        var value = this.getFromEnd(1);
        if (value !== undefined) {
            // Move index down
            this.incrementIndex(1);
        } else {
            // We've moved to the end, reset the index to the end
            this.resetIndex();
        }
        return value;
    },
    setVal: function (value) {
        this.input.setVal(value.msg);
        if (value.reply) {
            this.model.trigger('lockReplyHighlight', value.reply);
        } else {
            this.model.trigger('clearReplyHighlight');
        }
    },
    keyDown: function (e) {
        if (e.metaKey || e.altKey || e.shiftKey) {
            // Ignore modifier keys
            return true;
        }

        // TODO reverse behaviour setting
        if (e.ctrlKey) {
            if (e.which === Keyboard.KEYS.UP) {
                var editMessage = this.model.getLastEditableMessage();
                if (editMessage) {
                    if (!this.pending) {
                        this.model.trigger('editMessagePrompt', editMessage);
                    }
                    return false;
                }
            }
            return true;
        }

        var value;
        if (e.which === Keyboard.KEYS.UP) {
            // Store the input value before we go galloping off into the history
            if (this.isIndexReset()) {
                this.currentValue = {
                    msg: this.input.val(),
                    reply: this.input.replyTarget
                };
                if (this.currentValue.msg.indexOf('\n') !== -1) {
                    // abort if there's a new line in the current text
                    return true;
                }
                if (this.input.autogrow && this.input.autogrow.isGrown()) {
                    // abort if the input is wrapping to multiple lines
                    return true;
                }
            }
            value = this.getEarlier();
            if (value !== undefined) {
                this.setVal(value);
            }
            return false;
        } else if (e.which === Keyboard.KEYS.DOWN) {
            if (this.isIndexReset()) {
                // We're at the bottom
                if (this.input.autogrow && this.input.autogrow.isGrown()) {
                    // abort if the input is wrapping to multiple lines
                    return true;
                }
                // push any current text onto the buffer and reset
                var val = this.input.val();
                if (val) {
                    this.pushState(val, this.input.replyTarget);
                    this.setVal({msg: ''});
                    return true;
                }
                return false;
            }
            value = this.getLater();
            if (value !== undefined) {
                this.setVal(value);
            } else {
                // Reset the input value to it's previous value
                this.setVal(this.currentValue);
            }
            return false;
        } else {
            // Any other key preses resets the index to the end
            this.resetIndex();
        }
        return true;
    }
});


module.exports = HistoryCompletion;


/***/ }),

/***/ "JGoS":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var Overlay = __webpack_require__("jcM0");
var RenderReasons = __webpack_require__("ilaq");
var DialogView = __webpack_require__("EjYC");


var BufferPromptHandler = Backbone.View.extend({
    initialize: function (options) {
        this.connection = this.model.connection;
        this.bindMessageHandlers();
        
        this.formatter = new BufferFormatter(this.model);
        this.model.on('remove', this.remove, this);
    },
    bindMessageHandlers: function () {
        for (var type in this.messageHandlers) {
            this.model.bind('message:' + type, this.handleMessage, this);
        }
        this.model.bind('sayError', this.postError, this);
        this.model.bind('postError', this.postError, this);
        this.model.bind('inlineImageConfirm', this.inlineImageConfirm, this);
        this.model.bind('inlineMastodonConfirm', this.inlineMastodonConfirm, this);
        this.model.bind('longMessageConfirm', this.longMessageConfirm, this);
        this.model.bind('deleteMessageConfirm', this.deleteMessageConfirm, this);
        this.model.bind('editMessagePrompt', this.editMessagePrompt, this);
    },
    defaultHead: function () {
        return this.formatter.linkModel(this.connection, {
            name: this.connection.getFullLabel()
        });
    },
    longMessageConfirm: function (onConfirm, onCancel) {
        var confirmHtml = "You’re about to send a very long message. Are you absolutely sure?";
        var overlay = this.htmlConfirm(confirmHtml, onConfirm, {
            okText: 'Yes',
            head: 'Long message warning',
            onCancel: onCancel
        });
        this.triggerAdd(overlay);
    },
    inlineImageConfirm: function (callback) {
        this.model.session.trigger('inlineImageConfirm', _.bind(function () {
            this.model.enableInlineImages();
        }, this));
    },
    inlineMastodonConfirm: function (callback) {
        this.model.session.trigger('inlineMastodonConfirm', _.bind(function () {
            this.model.setInlineMastodonPref(true);
        }, this));
    },
    deleteMessageConfirm: function (message, callback) {
        var overlay;
        if (message.isRedactable()) {
            overlay = this.prompt("Are you sure you want to delete this message? Reason (optional)", _.bind(function (reason) {
                this.model.redactMessage(message.get('msgid'), reason);
                if (callback) {
                    callback();
                }
            }, this));
        } else {
            overlay = this.confirm("Are you sure you want to delete this message?", _.bind(function () {
                this.model.deleteMessage(message.get('msgid'));
                if (callback) {
                    callback();
                }
            }, this));
        }
        overlay.className = 'delete_message_prompt';
        this.triggerAdd(overlay);
    },
    editMessagePrompt: function (message, callback) {
        var overlay = this.prompt("Edit message", _.bind(function (newMsg) {
            this.model.editMessage(message.get('msgid'), newMsg);
            if (callback) {
                callback();
            }
        }, this), message.get('msg'), {
            multiline: true
        });
        overlay.className = 'edit_message_prompt';
        this.triggerAdd(overlay);
    },
    postError: function (response, message) {
        var alertText = this.formatter.escapeText(RenderReasons.renderPostError(response, message));
        var overlay = new Overlay(alertText, {
            className: 'buffer_post_error',
            prompt: true,
            head: this.defaultHead(),
            doneText: 'OK'
        });
        this.triggerAdd(overlay);
    },
    handleMessage: function (message) {
        if (!message.eid || message.eid < 0) {
            var overlay = this.messageHandlers[message.type].call(this, message);
            if (overlay) {
                overlay.message = message;
                this.triggerAdd(overlay);
                return true;
            }
        }
    },
    triggerAdd: function (overlay) {
        this.trigger('addOverlay', overlay);
    },
    alert: function (content, options) {
        return this.htmlAlert(this.formatter.render(content), options);
    },
    htmlAlert: function (content, options) {
        options = options || {};
        return new Overlay(content, {
            prompt: true,
            head: options.head || this.defaultHead(),
            doneText: 'OK'
        });
    },
    confirm: function (content, onConfirm, options) {
        return this.htmlConfirm(this.formatter.render(content), onConfirm, options);
    },
    htmlConfirm: function (content, onConfirm, options) {
        options = options || {};
        var confirmClass = options.confirmClass || 'action';
        var confirmButton = $('<button class="confirm">').addClass(confirmClass).append($('<span>').text(options.okText || 'OK'));
        confirmButton.keypress(function (e) {
            if (e.which == 3) {
                // enter key
                e.preventDefault();
                fullContent.submit();
            }
        });

        var buttons = $('<p class="buttons">');
        buttons.append(confirmButton);
        var extra = options.extraButton;
        var extraButton;
        if (extra) {
            extraButton = $('<button type="button" class="extra">');
            extraButton.addClass(extra.className);
            extraButton.append($('<span>').text(extra.text));
            buttons.append(extraButton);
        }
        var extraButtonHtml = options.extraButtonHtml;
        if (extraButtonHtml) {
            buttons.append(extraButtonHtml);
        }
        if (options.cancel !== false) {
            var cancelButton = $('<button type="button" class="close">').append($('<span>').text('Cancel'));
            buttons.append(cancelButton);
        }

        var contentTag = options.contentTag || 'p';
        var textContainer = $('<' + contentTag + ' class="content">').append(content);
        var fullContent = $('<form action="">');
        if (options.error) {
            fullContent.append($('<p class="userError">').html(options.error).show());
        }
        fullContent.append(textContainer);
        
        if (options.prompt) {
            var multiline = this.connection.hasMultiline() && options.multiline;
            var input = multiline ? $('<textarea class="input prompt">') : $('<input class="input prompt">');
            if (options.promptHint) {
                input.attr('placeholder', options.promptHint);
            }
            if (options.prompt !== true) {
                input.val(options.prompt);
            }
            if (options.onPromptKey) {
                input.on('input', function (e) {
                    options.onPromptKey(e, input, textContainer);
                });
            }
            fullContent.append($('<p class="form">').append(input));
        }
        
        fullContent.append(buttons);

        if (options.extraContent) {
            fullContent.append($('<div class="extraPromptContent">').append(options.extraContent));
        }
        
        var keepFocus = !!DialogView.open;
        if ('keepFocus' in options) {
            keepFocus = options.keepFocus;
        }
        var overlay = new Overlay(fullContent, {
            prompt: true,
            head: options.head || this.defaultHead(),
            keepFocus: true,
            doneText: null,
            onCancel: options.onCancel,
            afterAppend: options.afterAppend || _.bind(function () {
                if (!keepFocus) {
                    if (options.prompt) {
                        input.focus().select();
                    } else {
                        confirmButton.focus();
                    }
                }
            }, this)
        });
        
        var submitted = false;
        
        function doConfirm (e) {
            e.preventDefault();
            if (submitted) {
                return;
            }
            // Disable and mark as already submitted
            var formData = fullContent.serializeForm();
            var formDataArray = fullContent.serializeArray();
            fullContent.find('input, button, textarea').blur().prop('disabled', true);
            submitted = true;
            overlay.hide();
            if (options.prompt) {
                onConfirm(input.val(), formData);
            } else {
                onConfirm(formData, formDataArray);
            }
        }

        if (extra) {
            var extraSubmitted = false;
            extraButton.on('buttonClick', _.bind(function (e) {
                if (extra.form) {
                    if (extraSubmitted) {
                        return;
                    }
                    // Disable and mark as already submitted
                    fullContent.find('input, button, textarea').blur().prop('disabled', true);
                    extraSubmitted = true;
                }
                if (extra.hide) {
                    overlay.hide();
                }
                if (extra.action) {
                    extra.action();
                }
            }, this));
        }

        fullContent.submit(doConfirm);
        return overlay;
    },
    prompt: function (content, onConfirm, prompt, options) {
        return this.htmlPrompt(this.formatter.render(content), onConfirm, prompt, options);
    },
    htmlPrompt: function (content, onConfirm, prompt, options) {
        options = options || {};
        options.prompt = prompt || true;
        return this.htmlConfirm(content, onConfirm, options);
    },
    messageHandlers: {}
});


module.exports = BufferPromptHandler;


/***/ }),

/***/ "JHsc":
/***/ (function(module, exports, __webpack_require__) {

var uriTemplates = __webpack_require__("0a14");
var ts = __webpack_require__("GmLC").ts;

var FileWrapper = Backbone.Model.extend({
    initialize: function (data, options) {
        options = options || {};
        this.session = options.session;
        this.localFile = options.localFile;
    },
    triggerBubble: function () {
        var args = _.toArray(arguments);
        this.trigger.apply(this, args);
        var event = args.shift();
        args.unshift(event, this);
        this.session.trigger.apply(this.session, args);
    },
    isPreviewable: function () {
        return this.isPreviewableImage() && this.isPreviewableSize();
    },
    isOwn: function () {
        return !!this.get('own_file');
    },
    isImage: function () {
        return FileWrapper.isImage(this.getType());
    },
    isVideo: function () {
        return FileWrapper.isVideo(this.getType());
    },
    isAudio: function () {
        return FileWrapper.isAudio(this.getType());
    },
    isMedia: function () {
        return FileWrapper.isMedia(this.getType());
    },
    isPreviewableImage: function () {
        return FileWrapper.isPreviewableImage(this.getType());
    },
    isPreviewableMedia: function () {
        return FileWrapper.isPreviewableMedia(this.getType());
    },
    isPreviewableSize: function () {
        return FileWrapper.isPreviewableSize(this.get('size'));
    },
    isTooLarge: function () {
        return FileWrapper.isTooLarge(this.get('size'));
    },
    isText: function () {
        return FileWrapper.isText(this.getType());
    },
    getName: function () {
        return this.get('name');
    },
    getUrl: function () {
        return uriTemplates(this.getTemplateUri()).fill(this.getTemplateUriParams());
    },
    isWidthAboveThreshold: function (width) {
        var fileWidth = this.getWidth();
        return !fileWidth || (fileWidth / width) > 1.1;
    },
    getResizedUrl: function (dimensions) {
        if (dimensions && dimensions.width && this.isWidthAboveThreshold(dimensions.width)) {
            var quantiseWindow = 100;
            var quantised = Math.ceil(dimensions.width/quantiseWindow)*quantiseWindow;
            return this.getWidthUrl(quantised);
        }
        return this.getUrl();
    },
    getWidthUrl: function (width) {
        return this.getTemplateUrl('w' + width);
    },
    getSquareUrl: function (width) {
        return this.getTemplateUrl('s' + width);
    },
    getTemplateUri: function () {
        return window.IRCConfig.file_uri_template;
    },
    getBaseTemplateUriParams: function () {
        return {
            id: this.id
        };
    },
    getTemplateUriParams: function () {
        var params = this.getBaseTemplateUriParams();
        params.name = this.get('name');
        return params;
    },
    getTemplateUrl: function (modifier) {
        var params = this.getBaseTemplateUriParams();
        params.modifiers = modifier;
        return uriTemplates(this.getTemplateUri()).fill(params);
    },
    cacheDataUrl: function (dataUrl) {
        FileWrapper.cacheDataUrl(this.id, dataUrl);
    },
    uncacheDataUrl: function () {
        FileWrapper.uncacheDataUrl(this.id);
    },
    getCachedUrl: function (dimensions) {
        return FileWrapper.cachedDataUrl(this.id) || this.getResizedUrl(dimensions);
    },
    desiredName: function () {
        return this.desiredFilename || this.getName();
    },
    dummyUrl: function () {
        var name = this.desiredName();
        if (FileWrapper.nameToExtension(name) != this.get('extension')) {
            name += this.get('extension');
        }
        return uriTemplates(this.getTemplateUri()).fill({
            id: this.id || '...',
            name: name
        });
    },
    getJSONUrl: function () {
        return this.session.backend.buildRawUrl('/file/json/' + this.id);
    },
    getType: function () {
        return this.get('mime_type');
    },
    getSize: function () {
        return FileWrapper.sizeToString(this.get('size'));
    },
    getDate: function () {
        return new Date(this.get('date') * 1000);
    },
    getExtension: function () {
        return this.get('extension').replace(/^\./, '');
    },
    getProp: function (key) {
        var props = this.get('properties');
        if (props) {
            return props[key];
        }
    },
    getWidth: function () {
        return this.get('width') || (this.getProp('width') - 0);
    },
    getHeight: function () {
        return this.get('height') || (this.getProp('height') - 0);
    },
    isDeleted: function () {
        return !!this.get('deleted');
    },
    isErrored: function () {
        return !!this.get('errored');
    },
    fetch: function () {
        var url = this.getJSONUrl();
        if (!url) {
            return $.Deferred().reject().promise();
        }
        return this.session.ajax({
            url: url,
            dataType: 'json',
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            }
        }, function (response) {
            return !!response.id;
        }, function (request) {
            return request.status != 404;
        }).done(_.bind(function (response, statusText, request) {
            this.uploaded = true;
            if (statusText == 404) {
                this.set('deleted', true);
            } else {
                this.set(response);
            }
        }, this)).fail(_.bind(function (request, errorString, errorThrown) {
            this.set('errored', true);
        }, this));
    },
    setUploadId: function () {
        if (!this.uploadId) {
            this.uploadId = FileWrapper._UPLOAD_IDS++;
        }
    },
    getUploadId: function () {
        return this.uploadId;
    },
    uploadPath: function () {
        return this.session.backend.buildRawUrl(FileWrapper.UPLOAD_PATH);
    },
    upload: function () {
        this.setUploadId();
        this.triggerBubble('uploadStart');
        var complete = new $.Deferred();
        var formData = new window.FormData();
        formData.append('file', this.localFile);
        var promise = this.session.ajax({
            url: this.uploadPath(),
            type: 'post',
            data: formData,
            dataType: 'json',
            headers: {
                'x-irccloud-session': this.session.getAuthCookie()
            },
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            },
            // Options to tell jQuery not to process data or worry about content-type.
            contentType: false,
            processData: false
        }, function (response) {
            return !!response;
        });

        this.bind('cancelUpload', function () {
            if (promise.state() == 'pending') {
                promise.ajax.abort();
            } else {
                complete.reject('cancel');
                this.triggerBubble('uploadCancelled');
            }
        });
        promise.done(_.bind(function (response, status, jqXHR) {
            this.set('id', response.id);
            complete.resolve(response);
        }, this));
        promise.progress(_.bind(function (type, evt) {
            if (type == 'upload' && evt.lengthComputable) {
                var percentComplete = Math.round(evt.loaded * 100 / evt.total);
                complete.notify(evt, percentComplete);
                this.triggerBubble('uploadProgress', evt, percentComplete);
            } else {
                // Always triggered once for download phase
                // enters non-deteministic finalising state
                complete.notify();
                this.triggerBubble('uploadFinalise');
            }
        }, this));
        promise.fail(_.bind(function (jqXHR, errorString, response) {
            this.uploadErrorType = errorString;
            this.uploadError = response;
            if (errorString == 'abort') {
                complete.reject('cancel', response);
                this.triggerBubble('uploadCancelled');
            } else {
                complete.reject('error', response);
                this.triggerBubble('uploadError');
            }
        }, this));
        return complete.promise();
    },
    getError: function () {
        return this.finaliseError || this.uploadError;
    },
    cancelUpload: function () {
        this.trigger('cancelUpload');
    },
    finaliseParams: function () {
        return {
            id: this.id,
            filename: this.desiredName(),
            original_filename: this.localFile.name
        };
    },
    finalise: function (options, callback) {
        return this.session.post('upload-finalise', this.finaliseParams(), _.bind(function (response) {
            if (response.success) {
                var cachedWidth = this.getWidth();
                var cachedHeight = this.getHeight();
                this.set(response.file);
                this.uploaded = true;
                this.triggerBubble('uploadSuccess'); // results in dataURL getting cached
                // Check whether we should immediately uncache it
                if (
                    cachedWidth != this.getWidth() ||
                    cachedHeight != this.getHeight()
                ) {
                    // Dimensions changed, probably orientation corrected
                    // discard cached data
                    this.uncacheDataUrl();
                }
            } else {
                this.finaliseError = response || true;
                this.triggerBubble('uploadError');
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    setReqId: function (buffer, reqid) {
        this.sentToBuffer = buffer;
        this.reqid = reqid;
        this.sentToBuffer.messages.bind('add', this.setSentMessage, this);
    },
    setSentMessage: function (message) {
        if (message.get('reqid') == this.reqid) {
            this.sentMessage = message;
            if (!this.isUploaded()) {
                // Failed upload within a batch
                this.sentToBuffer.trigger('addErrorUpload', this, this.uploadErrorType, this.getError());
            }
            this.sentToBuffer.messages.unbind('add', this.setSentMessage, this);
        }
    },
    showMessage: function () {
        if (this.sentToBuffer) {
            this.sentToBuffer.select();
            if (this.sentMessage) {
                if (this.sentMessage.show()) {
                    return true;
                }
            }
            if (this.reqid) {
                this.sentToBuffer.trigger('showPending', this.reqid);
                return true;
            }
        }
        return false;
    },
    isUploaded: function () {
        return !!this.uploaded;
    },
    post: function (method, data, callback) {
        data.file = this.id;
        return this.session.post(method, data, callback);
    },
    edit: function (data, callback) {
        return this.post('edit-file', data, _.bind(function (response) {
            if (response.success) {
                this.set(response.file);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    remove: function (callback) {
        return this.post('delete-file', {}, _.bind(function (response) {
            if (response.success) {
                this.set('deleted', true);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    restore: function (callback) {
        return this.post('restore-file', {}, _.bind(function (response) {
            if (response.success) {
                this.set('deleted', false);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    }
}, {
    _UPLOAD_IDS: 1,
    KB: 1000,
    MB: 1000 * 1000,
    MAX_LENGTH_BYTES: 15728640,
    MAX_UPLOAD_BATCH: 10,
    DATA_URL_CACHE: {},
    CAN_PLAY_CACHE: {},
    FILE_BLACKLIST: {
        '.DS_Store': true
    },
    UPLOAD_PATH: '/chat/upload',
    sizeToString: function (size) {
        var fileSize = 0;
        if (size > FileWrapper.MB) {
            fileSize = (Math.round(size * 100 / FileWrapper.MB) / 100).toString() + 'MB';
        } else {
            fileSize = (Math.round(size * 100 / FileWrapper.KB) / 100).toString() + 'KB';
        }
        return fileSize;
    },
    cacheDataUrl: function (id, dataUrl) {
        FileWrapper.DATA_URL_CACHE[id] = dataUrl;
    },
    uncacheDataUrl: function (id) {
        delete FileWrapper.DATA_URL_CACHE[id];
    },
    cachedDataUrl: function (id) {
        return FileWrapper.DATA_URL_CACHE[id];
    },
    nameToExtension: function (name) {
        var match = name.match(/(\.[^.]+)$/);
        return match ? match[1] : '';
    },
    isPreviewableSize: function (size) {
        return size < (5 * FileWrapper.MB);
    },
    isTooLarge: function (size) {
        return size > FileWrapper.MAX_LENGTH_BYTES;
    },
    isPreviewableImage: function (type) {
        return type === 'image/png'
            || type === 'image/gif'
            || type === 'image/jpeg'
            || type === 'image/webp';
    },
    isPreviewableMedia: function (type) {
        if (type in FileWrapper.CAN_PLAY_CACHE) {
            return FileWrapper.CAN_PLAY_CACHE[type];
        } else {
            if (FileWrapper.isMedia(type)) {
                var canPlay = false;
                var v = document.createElement('video');
                if (v.canPlayType && v.canPlayType(type).replace(/no/, '')) {
                    canPlay = true;
                }
                FileWrapper.CAN_PLAY_CACHE[type] = canPlay;
                return canPlay;
            } else {
                return false;
            }
        }
    },
    isImage: function (type) {
        return !!type.match(/^image\//i);
    },
    isVideo: function (type) {
        return !!type.match(/^video\//i)
            || type === 'application/ogg';
    },
    isAudio: function (type) {
        return !!type.match(/^audio\//i);
    },
    isMedia: function (type) {
        return FileWrapper.isVideo(type) || FileWrapper.isAudio(type);
    },
    isText: function (type) {
        return !!type.match(/^text\//i)
            || type === 'application/atom+xml'
            || type === 'application/ecmascript'
            || type === 'application/javascript'
            || type === 'application/json'
            || type === 'application/rdf+xml'
            || type === 'application/rss+xml'
            || type === 'application/xhtml+xml'
            || type === 'application/xml';
    },
    fromFile: function (file, session, type) {
        var name = file.name || '';
        type = type || FileWrapper;
        return new type({
            name: name,
            extension: FileWrapper.nameToExtension(name),
            mime_type: file.type,
            size: file.size,
            date: Math.round(ts()/1000),
            own_file: true
        }, {
            session: session,
            localFile: file
        });
    },
    // Based on http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata/15754051#15754051
    detectDataURI: function (text) {
        return text.match(/data:([^;]+);base64,([a-z0-9+\/]+=*)/im);
    },
    blobFromDataURI: function (dataURI) {
        // convert base64/URLEncoded data component to raw
        // binary data held in a string
        if (!dataURI) {
            return;
        }
        var uriMatch = dataURI.match(/^data:([^;]+);base64,([a-z0-9+\/]+=*)$/i);
        if (!uriMatch) {
            return;
        }
        var mimeString = uriMatch[1];
        var data = uriMatch[2];
        var byteString;
        try {
            byteString = atob(data);
        } catch (exc) {
            // Invalid data
            return;
        }

        // write the bytes of the string to a typed array
        var ab = new window.ArrayBuffer(byteString.length);
        var ia = new window.Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        var blob = new Blob([ia], {type:mimeString});
        if (!blob.size) {
            return;
        }

        return blob;
    },
    getEntries: function (dt) {
        if (dt.items && dt.items[0]) {
            if (dt.items[0].webkitGetAsEntry) {
                return _.filter(_.map(dt.items, function (item) {
                    return item.webkitGetAsEntry();
                }), _.identity);
            }
        }
    },
    traverseFileTree: function (entry, complete, currentDir) {
        currentDir = currentDir || complete.tree;
        if (entry.isFile) {
            // Get file
            if (FileWrapper.FILE_BLACKLIST[entry.name]) {
                complete.notify('done', 1);
            } else {
                entry.file(function(file) {
                    currentDir.push(file);
                    complete.notify('addFile');
                    complete.notify('done', 1);
                });
            }
        } else if (entry.isDirectory) {
            // Get folder contents
            var newCurrentDir = [];
            currentDir.push({
                dir: entry.name,
                children: newCurrentDir
            });
            var dirReader = entry.createReader();
            FileWrapper.readDirEntries(dirReader, newCurrentDir, complete);
        }
    },
    readDirEntries: function (dirReader, newCurrentDir, complete) {
        dirReader.readEntries(function (entries) {
            if (complete.state() != 'pending') {
                return;
            }
            if (entries.length) {
                complete.notify('add', entries.length);
                _.each(entries, function (dirEntry) {
                    if (complete.state() != 'pending') {
                        return;
                    }
                    FileWrapper.traverseFileTree(dirEntry, complete, newCurrentDir);
                });
                FileWrapper.readDirEntries(dirReader, newCurrentDir, complete);
            } else {
                complete.notify('done', 1);
            }
        });
    },
    flattenTree: function (tree, flattened) {
        flattened = flattened || [];
        if (tree.length) {
            _.each(tree, function (node) {
                if (node.dir) {
                    flattened = flattened.concat(FileWrapper.flattenTree(node.children, flattened));
                } else if (!FileWrapper.isTooLarge(node.size)) {
                    flattened.push(node);
                }
            });
        }
        return flattened;
    },
    collectFileTree: function (entries, files) {
        var processCount = 0;
        var fileCount = 0;
        var complete = new $.Deferred();
        complete.tree = [];
        complete.progress(function (event, amount) {
            switch (event) {
            case 'add':
                processCount += amount;
                break;
            case 'done':
                processCount -= amount;
                break;
            case 'addFile':
                fileCount++;
                break;
            }
            if (fileCount > FileWrapper.MAX_UPLOAD_BATCH) {
                return complete.resolve(complete.tree, true);
            }
            if (!processCount) {
                return complete.resolve(complete.tree);
            }
        });
        if (entries) {
            complete.notify('add', entries.length);
            _.each(entries, function (entry) {
                FileWrapper.traverseFileTree(entry, complete);
            });
        } else if (files) {
            files = _.filter(files, function (file) {
                return file.size > 0;
            });
            complete.resolve(files);
        } else {
            complete.reject();
        }
        return complete.promise();
    }
});

module.exports = FileWrapper;


/***/ }),

/***/ "Jvek":
/***/ (function(module, exports) {

var Whois = Backbone.Model.extend({
    getChannels: function (type, priv) {
        var privatePrefix = '';
        if (priv) {
            privatePrefix = 'private_';
        }
        if (type == 'member') {
            return this.get(privatePrefix + 'prefix_channels_member');
        } else {
            return this.get(privatePrefix + 'prefix_channels_' + type);
        }
    },
    getHostMask: function () {
        var ident = this.get('user_ident_prefix') || '';
        var user = ident + (this.get('user_username') || '');
        var host = this.get('user_host') || '';
        if (user && host) {
            return user + '@' + host;
        } else if (host || user) {
            return host || user;
        }
        return '';
    },
    getSignonDate: function () {
        return new Date(this.getSignonTime());
    },
    getIdleTime: function () {
        return (new Date()).addSeconds(-this.get('idle_secs'));
    },
    getSignonTime: function () {
        return this.get('signon_time') * 1000;
    }
});


module.exports = Whois;


/***/ }),

/***/ "JvxA":
/***/ (function(module, exports, __webpack_require__) {

var BufferContextMenuView = __webpack_require__("cmaB");


var ServerLogContextMenuView = BufferContextMenuView.extend({
    el: '#serverLogContextMenu',
    events: $.extend({}, BufferContextMenuView.prototype.events, {
        'buttonClick button.edit': 'clickEdit',
        'buttonClick button.join': 'clickJoin',
        'buttonClick button.delete': 'clickDelete',
        'buttonClick button.nickserv': 'clickNickserv',
        'buttonClick button.connToken__prompt': 'clickConnectionToken',
        'buttonClick button.disconnect': 'clickDisconnect',
        'buttonClick button.reconnect': 'clickReconnect',
        'buttonClick button.reorder': 'clickReorder',
        'buttonClick button.collapse': 'clickToggleCollapse',
        'buttonClick button.expand': 'clickToggleCollapse',
        'buttonClick button.discocollapse': 'clickDisconnectCollapse',
        'buttonClick button.deleteConversations': 'clickDeleteConversations',
        'buttonClick button.upgradeSlack': 'clickUpgradeSlack',
        'buttonClick button.replyCollapse': 'clickReplyCollapse',
        'buttonClick button.replyQuote': 'clickReplyQuote'
    }),
    clickEdit: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.select();
        this.buffer.connection.trigger('showEdit');
        this.clearContext();
    },
    clickJoin: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.trigger('joinPrompt');
        this.clearContext();
    },
    clickDelete: function (e) {
        e.preventDefault();
        if (!this.buffer.connection.isActive()) {
            this.hide();
            this.buffer.connection.trigger('deleteConfirm');
            this.clearContext();
        }
    },
    clickNickserv: function (e) {
        e.preventDefault();
        if (this.buffer.connection.isActive() && !this.buffer.connection.isOrgServer()) {
            this.hide();
            this.buffer.connection.trigger('nickServPrompt', this.buffer.connection);
            this.clearContext();
        }
    },
    clickConnectionToken: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.trigger('showConnectionToken', this.buffer.connection);
        this.clearContext();
    },
    clickDisconnect: function (e) {
        e.preventDefault();
        if (!this.buffer.connection.isInactive()) {
            this.hide();
            this.buffer.connection.disconnect();
            this.clearContext();
        }
    },
    clickReconnect: function (e) {
        e.preventDefault();
        if (this.buffer.connection.isInactive()) {
            this.hide();
            this.buffer.connection.reconnect();
            this.clearContext();
        }
    },
    clickReorder: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.session.trigger('reorderConnections', e);
        this.clearContext();
    },
    clickToggleCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.toggleCollapsed();
        this.clearContext();
    },
    clickDisconnectCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setCollapsingDisconnectsPref(!this.buffer.isCollapsingDisconnects());
        this.clearContext();
    },
    clickDeleteConversations: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.trigger('deletePMConfirm');
        this.clearContext();
    },
    clickUpgradeSlack: function (e) {
        e.preventDefault();
        this.buffer.connection.upgradeSlack();
    },
    clickReplyCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.setCollapsingRepliesPref(!this.buffer.connection.isCollapsingReplies());
        this.clearContext();
    },
    clickReplyQuote: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.setQuoteRepliesPref(!this.buffer.connection.isShowingQuoteReplies());
        this.clearContext();
    },
    onShow: function () {
        this.$('.contextMenu__buffer-actions').toggle(this.button.is('.bufferHead button'));

        this.deactivateItem(this.$('li.reorder'), !this.buffer.session.connections.length > 1, true);
        this.deactivateItem(this.$('li.collapse'), this.buffer.connection.isCollapsed(), true);
        this.deactivateItem(this.$('li.expand'), !this.buffer.connection.isCollapsed(), true);
        this.deactivateItem(this.$('li.reconnect'), !this.buffer.connection.isInactive(), true);
        this.deactivateItem(this.$('li.disconnect'), this.buffer.connection.isInactive(), true);
        this.deactivateItem(this.$('li.delete'), this.buffer.connection.isActive(), true);
        this.deactivateItem(this.$('li.nickserv'), this.buffer.connection.isOrgServer(), true);
        this.deactivateItem(this.$('li.connToken__menuitem'), !this.buffer.session.bncEnabled(), true);
        this.deactivateItem(this.$('li.nickserv'), !this.buffer.connection.isActive());
        this.deactivateItem(this.$('li.deleteConversations'), !this.buffer.connection.buffers.activeConversations.length, true);
        this.enableItem(this.$('li.collapseDisconnects'), this.buffer.isCollapsingDisconnects());
        this.deactivateItem(this.$('li.upgradeSlack'), !this.buffer.connection.isSlackUpgradable(), true);

        // Replies
        this.deactivateItem(this.$('li.replyCollapse'), !this.buffer.connection.hasReliableClientTags(), true);
        this.enableItem(this.$('li.replyCollapse'), this.buffer.connection.isCollapsingReplies());
    }
});


module.exports = ServerLogContextMenuView;


/***/ }),

/***/ "K/24":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K0O/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.startAuth = startAuth;

var _util = __webpack_require__("GmLC");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startAuth(session) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var popup, popupWatcher, popupResponsePromise;
    function done() {
        clearInterval(popupWatcher);
        if (popupResponsePromise && popupResponsePromise.cleanup) {
            popupResponsePromise.cleanup();
        }
        popup = null;
        popupWatcher = null;
        popupResponsePromise = null;
    }

    var url = '/chat/oauth-slack-start';
    if (options.data) {
        url += '?' + $.param(options.data);
    }

    var _openPopup = (0, _util.openPopup)(url, 'slack', {
        closeCallback: function closeCallback() {
            if (popupWatcher) {
                if (options.onClose) {
                    options.onClose();
                }
                done();
            }
        }
    });

    var _openPopup2 = (0, _slicedToArray3.default)(_openPopup, 2);

    popup = _openPopup2[0];
    popupWatcher = _openPopup2[1];


    popupResponsePromise = session.findMessage(function (event) {
        if (event.source !== popup) {
            return false;
        }
        return event.data;
    }).done(function (response) {
        oAuthComplete(response, popup, done, options);
    });
} /* eslint-env es6 */

function oAuthComplete(response, popup, done, options) {
    // Popup closes itself after a timeout to allow post messages to arrive
    // but we can close it early if we've received the message.
    if (popup && !popup.closed) {
        popup.close();
    }
    if (response.success) {
        debug.log('<- [OAUTH SLACK] complete', response);
        if (options.onSuccess) {
            options.onSuccess(response);
        }
    } else {
        var message = '';
        switch (response.error) {
            case 'slack_disallowed':
                message = 'Slack workspaces aren’t available on your account';
                break;
            case 'slack_disabled':
                message = 'Slack workspaces disabled';
                break;
            case 'add_connection':
                message = 'Error adding Slack workspace';
                break;
            case 'unknown':
                message = 'Missing Slack workspace details';
                break;
            case 'state_mismatch':
                message = 'Unverified Slack authorisation';
                break;
            case 'state_invalid':
                message = 'Invalid Slack verification';
                break;
            case 'state_timeout':
                message = 'Slack authorisation timeout';
                break;
            case 'slack_error':
                // No error if canceled
                if (response.slack_error != 'access_denied') {
                    message = 'Error authorising Slack workspace: ' + response.slack_error;
                }
                break;
            case 'empty':
                message = 'Missing Slack authorisation details';
                break;
            default:
                message = 'Error requesting Slack authorisation: ' + response.error;
        }
        if (message) {
            debug.warn('<- [OAUTH SLACK] error', response);
        } else {
            debug.log('<- [OAUTH SLACK] error', response);
        }
        if (options.onError) {
            options.onError(message);
        }
    }
    done();
}

/***/ }),

/***/ "KEE7":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var MemberView = __webpack_require__("IJ5v");


var ChannelMembersView = Backbone.View.extend({
    tagName: 'ul',
    className: 'memberList',
    initialize: function () {
        this.model.bind('remove', this.remove, this);
        this.model.bind('preinit', this.render, this);
        this.formatter = new BufferFormatter(this.model);
    },
    makeSegmentedList: function (collection, categoryName) {
        var category = $('<li class="category">').addClass(collection.getClass());
        this.lists[categoryName] = category;

        var heading = $('<h2>').text(collection.getModeTitle());
        
        var headingExtras = $('<span class="memberExtras">');
        
        var modeSymbol = collection.getModeSymbol();
        if (!collection.isMember() && modeSymbol) {
            modeSymbol = $('<span class="mode_prefix mode_symbol">').addClass('mode_' + collection.getModeCategory()).text(modeSymbol);
            var modePill = $('<span class="mode_prefix mode_pill">').addClass('mode_' + collection.getModeCategory()).text('•');
            headingExtras.append(modeSymbol);
            headingExtras.append(modePill);
        }
        
        headingExtras.append($('<span class="memberCount">'));
        
        heading.append(headingExtras);
        category.append(heading);

        var list = $('<ul class="categoryMemberList categoryMemberList--present">');
        this.renderMembers(list, collection);
        category.append(list);

        var listAway;
        if (this.model.connection.isSlackOAuth()) {
            listAway = $('<ul class="categoryMemberList categoryMemberList--away">');
            this.renderMembers(listAway, collection);
            category.append(listAway);
        }

        this.listenTo(collection, 'add', function (member) {
            this.renderMember(list, collection, member);
            if (listAway) {
                this.renderMember(listAway, collection, member);
            }
        });
        this.listenTo(collection, 'remove', function () {
            this.renderList(collection);
        });
        if (this.model.connection.isSlackOAuth()) {
            this.listenTo(collection, 'change:away', function () {
                this.renderList(collection);
            });
        }
        this.listenTo(collection, 'reset', function () {
            this.renderMembers(list, collection);
            if (listAway) {
                this.renderMembers(listAway, collection);
            }
            this.renderList(collection);
        });
        
        this.$el.append(category);
    },
    render: function (members) {
        this.$el.empty();
        this.stopListening();
        this.lists = {};
        _.each(this.model.members.lists, function (collection, categoryName) {
            this.makeSegmentedList(collection, categoryName);
        }, this);
        
        return this;
    },
    renderMembers: function (list, collection) {
        list.empty();
        collection.sort();
        var els = collection.map(function (member) {
            var memberView = new MemberView({
                model: member,
                formatter: this.formatter
            });
            return memberView.render().el;
        }, this);
        list.append.apply(list, els);
        this.renderList(collection);
    },
    renderMember: function (list, collection, member) {
        var memberView = new MemberView({
            model: member,
            formatter: this.formatter
        });
        
        // Insert in the correct position
        var selector = memberView.tagName + '.' + memberView.className.split(' ').join('.');
        var existing = list.find(selector);
        var index = collection.indexOf(member);
        var el = memberView.render().el;
        if (index == existing.length) {
            list.append(el);
        } else {
            existing.eq(collection.indexOf(member)).before(el);
        }
        
        this.renderList(collection);
    },
    renderList: function (collection) {
        var size = collection.length;
        // if (this.model.connection.isSlackOAuth()) {
        //     size = collection.filter(function (m) {
        //         return !m.isAway();
        //     }).length;
        // }
        var segment = this.lists[collection.getModeCategory()];
        segment.toggle(!!size);
        segment.find('h2 span.memberCount').text(size);
    }
});


module.exports = ChannelMembersView;


/***/ }),

/***/ "KQDl":
/***/ (function(module, exports, __webpack_require__) {

var Connection = __webpack_require__("LLdI");
var IRCFormatter = __webpack_require__("XiBv");
var util = __webpack_require__("GmLC");


var JoinDefaultServersMixins = {
    initialize: function (options) {
        this.joinRealName = this.$('.joinDefaultRealName');
        this.joinName = this.$('.joinDefaultName');
        this.joinForm = this.$('.joinDefaultForm');
        this.joinConnectionsWrapper = this.$('.joinDefaultConnectionsWrapper');
        this.joinConnections = this.$('.joinDefaultConnections');
        this.joinExplanation = this.$('.joinDefaultExplanation');
        this.joinAlready = this.$('.joinDefaultAlready');
        this.joinError = this.$('.joinDefaultError');
    },
    events: {
        'submit .joinDefaultForm': 'submitJoinForm',
        'change p.revealPass input[type=checkbox]': 'changeRevealPass',
        'click .network .matchConn a.chan': 'clickChan',
        'buttonClick .network .matchConnChoice .matchConnTitle': 'clickConnTitle'
    },
    changeRevealPass: function (e) {
        var t = $(e.target);
        t.closest('.network').find('.revealPass').toggleClass('revealed', t.is(':checked'));
    },
    clickChan: function (e) {
        e.preventDefault();
        var t = $(e.target);
        var isChosen = t.hasClass('chosen');
        var chName = t.data('name');
        t.closest('.channels').find('.matchConn a.chan').each(function () {
            if ($(this).data('name') === chName) {
                $(this).toggleClass('chosen', !isChosen);
            }
        });
    },
    clickConnTitle: function (e) {
        e.preventDefault();
        var t = $(e.target);
        var cid = t.data('cid');
        var wrapper = t.closest('.network');
        wrapper.find('.matchConnChoice button.matchConnTitle').removeClass('active');
        wrapper.find('.matchConn').removeClass('active');
        wrapper.find('.matchPass').removeClass('active');
        wrapper.find('.matchConn input').prop('disabled', true);
        if (cid) {
            wrapper.find('.matchConnChoice button.matchConnTitle.c' + cid).addClass('active');
            wrapper.find('.matchConn.c' + cid).addClass('active');
            wrapper.find('.matchConn.c' + cid + ' input').prop('disabled', false);
            wrapper.find('.matchPass.c' + cid).addClass('active');
        } else {
            wrapper.find('.matchConnChoice button.matchConnTitleNone').addClass('active');
            wrapper.find('.matchConnNone').addClass('active');
            wrapper.find('.matchConnNone input').prop('disabled', false);
        }
    },

    renderChannelMatchConn: function (connId, c, active, admin, mc, org) {
        var channels = util.parseChannels(c.channels, c.ircd);
        var matchConn = $('<div class="matchConn">');
        matchConn.toggleClass('active', active);

        if (mc) {
            matchConn.addClass('c' + mc.getCid());
            matchConn.data('cid', mc.getCid());
            matchConn.data('server_pass', c.server_pass);
        } else {
            if (c.ircd) {
                matchConn.addClass('matchConnIrcd');
            }
            matchConn.addClass('matchConnNone');
            matchConn.data('connId', connId);
            if (!admin || org.hasSubscribed()) {
                var nick = this.model.getNick();
                var nickId = 'matchConnNick_' + connId;
                var nickInput = $('<input class="nick input" name="nick[' + connId + ']">').val(nick).attr('id', nickId);
                if (!active) {
                    nickInput.prop('disabled', true);
                }
                var nickLabel = $('<label>').text('Choose a nickname').attr('for', nickId);
                matchConn.append($('<p class="form matchConnNick">')
                    .append(nickLabel)
                    .append('<br>')
                    .append(nickInput));
            }
        }
        var chans = $('<div class="chans">');
        _.each(channels, function (ch) {
            var chParts = ch.split(' ');
            var data = {
                name: chParts[0],
                pass: chParts[1]
            };
            var chan;
            if (org.isAdmin() && !org.hasSubscribed()) {
                chan = $('<strong class="chan found">');
            } else if (mc) {
                var chanMatch = mc.buffers.channels.find(function (ach) {
                    return (
                        ach.isActive() &&
                        data.name.toLowerCase() == ach.getName().toLowerCase()
                    );
                });
                if (chanMatch) {
                    if (!org.haveJoined()) {
                        this.joinAlready.show();
                    }
                    chan = $('<strong class="chan found">');
                }
            }
            if (!chan) {
                chan = $('<a class="chan chosen" href="">');
            }
            chan.text(data.name).data(data);
            if (data.pass) {
                chan.addClass('pass');
                chan.prepend('<i class="fa fa-lock">');
                chan.attr('title', 'Password: ' + data.pass);
            }
            chans.append(chan);
        }, this);

        matchConn.append(chans);
        return matchConn;
    },
    focusNick: function () {
        this.$('input.nick').focus().select();
    },
    renderChannelMatches: function (connId, c, matchingConns, admin, org) {
        var nodes = $('<div class="matchConnNodes">');

        var matchConnChoiceText = $('<p class="matchConnChoiceExplanation">');
        if (c.server_pass) {
            matchConnChoiceText.html('You’re already connected to a similar network with a different <b>password</b>. How would you like to proceed?');
            matchConnChoiceText.addClass('password');
        } else {
            matchConnChoiceText.html('You’re already connected to a similar network on a different <b>port</b>. How would you like to proceed?');
        }
        var matchConnChoice = $('<div class="matchConnChoice">');
        nodes.append(matchConnChoiceText, matchConnChoice);
        _.each(matchingConns, function (mc, i) {
            var isActive = i === 0;
            var cid = mc.getCid();
            var matchConnButton = $('<button type="button" class="matchConnTitle">').data('cid', cid).addClass('c' + cid);
            var matchConnText, matchConnLabel;
            if (c.server_pass) {
                matchConnText = 'Update ';
                matchConnLabel = mc.getName();
            } else {
                matchConnText = 'Join on ';
                matchConnLabel = mc.getHost(true);
            }
            var matchConnTitle = $('<span class="matchConnLabel">').text(matchConnText).append($('<b>').text(matchConnLabel));
            if (mc.isSSL()) {
                matchConnTitle.prepend('<i class="fa fa-shield" title="Secure connection"> ');
            } else {
                matchConnTitle.prepend('<i class="fa fa-globe"> ');
            }
            matchConnButton.toggleClass('active', isActive);
            matchConnChoice.append(matchConnButton.append(matchConnTitle));
            var matchConn = this.renderChannelMatchConn(connId, c, isActive, admin, mc, org);
            nodes.append(matchConn);
        }, this);

        // Don't use a match
        var matchConnButtonNone = $('<button type="button" class="matchConnTitle matchConnTitleNone">');
        var matchConnTitleNone = $('<span>').text('Add a new network');
        matchConnChoice.append(matchConnButtonNone.append(matchConnTitleNone));
        var matchConnNone = this.renderChannelMatchConn(connId, c, false, admin, null, org);
        nodes.append(matchConnNone);
        return nodes;
    },
    findPerfectMatch: function (matchingConns, c, org) {
        var perfectMatch = null;
        if (matchingConns.length) {
            var filteredConns = _.filter(matchingConns, function (mc) {
                return mc.get('server_pass') == c.server_pass;
            });
            if (filteredConns.length) {
                perfectMatch = _.find(filteredConns, function (mc) {
                    return mc.getPort() == c.port;
                })
                || _.find(filteredConns, function (mc) {
                    var ports = [mc.getPort()-0, c.port-0];
                    return _.include(ports, Connection.defaultPort) && _.include(ports, Connection.defaultSSLPort);
                });
            }
        }
        return perfectMatch;
    },
    renderConnection: function (c, i, admin, org) {
        var row = $('<div class="network">').data('index', i);

        // Host
        var hostLine = $('<p class="head">');
        if (admin) {
            hostLine.append('<small class="delete edit"><a href="" class="delete">remove</a></small> ');
        }
        if (c.ircd) {
            row.addClass('ircd');
            hostLine.addClass('ircd');
        }
        if (c.ssl) {
            hostLine.addClass('ssl');
            hostLine.append('<i class="fa fa-shield" title="Secure connection">');
        } else {
            hostLine.append('<i class="fa fa-globe">');
        }
        if (c.ircd) {
            hostLine.append($('<span class="host">').text(' ' + org.get('name') + ' '));
        } else {
            hostLine.append($('<span class="host">').text(' ' + c.hostname + ':' + c.port + ' '));
        }
        row.append(hostLine);

        if (admin && c.ircd) {
            var removeIrcdConfirm = $('<div class="userInfo" id="orgRemoveIrcdConfirm">');
            removeIrcdConfirm.append($('<p>').text('Are you sure you want to remove these default channels'));
            removeIrcdConfirm.append($('<p>')
                .append('<button class="cancel" type="button"><span>Cancel</span></button>')
                .append('<button class="delete" type="button"><span>Yes, we don’t need them anymore</span></button>')
            );
            row.append(removeIrcdConfirm);
        }

        // Channels
        var chanNodes;
        var imperfectMatches = false;
        var matchingConns;
        if (c.ircd) {
            var orgMatch;
            if (org.id) {
                orgMatch = this.model.findOrgConn(org.id);
            } else {
                orgMatch = this.model.findTeamConn();
            }
            if (orgMatch) {
                chanNodes = this.renderChannelMatchConn(i, c, true, admin, orgMatch, org);
            }
        } else {
            matchingConns = this.model.findMatchingConnections(c.hostname);
            var perfectMatch = this.findPerfectMatch(matchingConns, c, org);
            if (perfectMatch) {
                chanNodes = this.renderChannelMatchConn(i, c, true, admin, perfectMatch, org);
            } else if (matchingConns.length) {
                chanNodes = this.renderChannelMatches(i, c, matchingConns, admin, org);
                imperfectMatches = true;
            }
        }
        if (!chanNodes) {
            chanNodes = this.renderChannelMatchConn(i, c, true, admin, null, org);
        }
        var channelLine = $('<div class="channels">').append(chanNodes);
        row.append(channelLine);

        // Server pass
        if (c.server_pass) {
            var passLine = $('<p class="revealPass">')
                .append($('<input type="checkbox">').attr('id', 'orgConnRevealPass' + i))
                .append($('<label>').attr('for', 'orgConnRevealPass' + i).text(' Reveal server password '))
                .append($(' <span class="pass">').text(c.server_pass));
            if (imperfectMatches && matchingConns && matchingConns.length) {
                _.each(matchingConns, function (mc, i) {
                    var isActive = i === 0;
                    var cid = mc.getCid();
                    var matchPassItem = $('<div class="matchPass">').addClass('c' + cid);
                    if (mc.get('server_pass')) {
                        matchPassItem.text('Current ').append($('<span class="pass">').text(mc.get('server_pass')));
                    } else {
                        matchPassItem.append('Current: none');
                    }
                    matchPassItem.toggleClass('active', isActive);
                    passLine.append(matchPassItem);
                });
            }
            row.append(passLine);
            row.addClass('hasPass');
        }
        return row;
    },
    showJoinInit: function (name) {
        this.hideJoinError();
        this.joinAlready.hide();
        this.joinForm.hide();
        this.joinForm.removeData('org');
        this.joinForm.removeSpin();

        this.joinRealName.val(this.model.get('name'));
        this.joinName.text(decodeURIComponent(name));
    },
    showJoinOrg: function (org) {
        this.joinForm.data('org', org);
        if (org.hasConnections() || org.hasIrcd()) {
            var lines = _.map(org.connections, function (c, i) {
                return this.renderConnection(c, i, false, org);
            }, this);
            if (org.hasIrcd()) {
                lines.unshift(this.renderConnection(org.getIrcdConnection(), 'ircd', false, org));
            }
            this.joinConnections.html('').append(lines);
            this.joinConnectionsWrapper.show();
        } else {
            this.joinConnectionsWrapper.hide();
        }
        this.joinForm.show();
    },
    showJoinError: function (response) {
        var msg;
        switch (response.message) {
        case "missing_nickname":
            msg = "Missing nickname";
            break;
        case "invalid_nickname":
            msg = "Invalid nickname";
            break;
        case "redeemed_elsewhere":
            msg = "This invite has already been used";
            break;
        case "org_deleted":
            msg = "This team has been deleted";
            break;
        case "invite_revoked":
            msg = "This invite has been revoked";
            break;
        case "invalid_invite":
            msg = "Invalid team invite";
            break;
        case "already_redeemed":
            msg = 'You’ve already used this <a href="/?/team=' + response.org + '">team</a> invite';
            break;
        case "already_joined":
            msg = 'You’re already a member of this <a href="/?/team=' + response.org + '">team</a>';
            break;
        case "failed_joining_org":
            msg = "Error joining this team";
            break;
        default:
            msg = "Error joining this team: " + IRCFormatter.escapeHtml(response.message);
            break;
        }
        this.joinError.html(msg).fadeIn('fast');
    },
    hideJoinError: function () {
        this.joinError.hide();
    },
    getFoundConns: function () {
        var conns = {};
        this.$('.network .matchConn.active:not(.matchConnNone)').each(function () {
            var key = $(this).data('cid');
            if (!conns[key]) {
                conns[key] = {
                    cid: key,
                    channels: []
                };
            }
            $(this).find('strong.chan.found').each(function () {
                conns[key].channels.push($(this).data('name'));
            });
        });
        var connList = _.map(conns, function (props, cid) {
            props.cid = cid;
            return props;
        });
        return connList;
    },
    getChosenConns: function (context, org, data) {
        var newConns = [];
        var oldConns = {};
        var ircd_channels = [];
        var ircd_nick;
        context.find('.network .matchConn.active').each(function () {
            var d = $.extend({}, $(this).data());
            var key;
            if ('connId' in d) {
                key = d.connId;
                if (key == 'ircd') {
                    $(this).find('a.chan.chosen').each(function () {
                        ircd_channels.push($(this).data('name'));
                        ircd_nick = data['nick[ircd]'];
                    });
                    delete data['nick[ircd]'];
                } else {
                    var fConn = $.extend({}, org.connections[key]);
                    fConn.ssl = !!fConn.ssl;
                    fConn.nick = data['nick[' + key + ']'];
                    delete data['nick[' + key + ']'];
                    delete fConn.channels;
                    newConns[key] = fConn;
                    $(this).find('a.chan.chosen').each(function () {
                        var chanD = $.extend({}, $(this).data());
                        if (!newConns[key].chans) {
                            newConns[key].chans = [];
                        }
                        newConns[key].chans.push(chanD);
                    });
                }
            } else if ('cid' in d) {
                key = d.cid;
                if (!oldConns[key]) {
                    oldConns[key] = {
                        server_pass: d.server_pass
                    };
                }
                $(this).find('a.chan.chosen').each(function () {
                    var chanD = $.extend({}, $(this).data());
                    if (!oldConns[key].chans) {
                        oldConns[key].chans = [];
                    }
                    oldConns[key].chans.push(chanD);
                });
            }
        });
        return {
            'new': _.filter(newConns, _.identity),
            'current': oldConns,
            'ircd_channels': ircd_channels.join(' '),
            'ircd_nick': ircd_nick
        };
    },
    submitJoinForm: function (e) {
        e.preventDefault();
        var data = this.joinForm.serializeForm();
        var org = this.joinForm.data('org');
        var chosen = this.getChosenConns(this.joinForm, org, data);
        data.connections = JSON.stringify(chosen);
        this.hideJoinError();
        this.joinForm.addSpin();
        this.joinDefaultServerAction(data, _.bind(function (response) {
            this.joinForm.removeSpin();
            if (response.success) {
                if (response.cids && response.cids[0]) {
                    this.model.setFocusOnMakeServer(response.cids[0]);
                } else {
                    this.joinDefaultServerEndAction();
                }
            } else {
                this.showJoinError(response);
            }
        }, this));
    }
};


module.exports = JoinDefaultServersMixins;


/***/ }),

/***/ "KU+H":
/***/ (function(module, exports, __webpack_require__) {

var ChannelMemberList = __webpack_require__("vxt3");
var Child = __webpack_require__("MN+i");
var Member = __webpack_require__("abDD");
var Topic = __webpack_require__("DyWj");
var util = __webpack_require__("GmLC");
var twitch = __webpack_require__("/7tV");


var Channel = Child.extend({
    initialize: function (data, options) {
        options.channel = this;
        this.members = new ChannelMemberList([], options);
        Child.prototype.initialize.apply(this, arguments);
        this.setUserMember(this.user);
        this.timestamp = null;
        this.channelUrl = null;
        this.modeParams = {};
        this.modeString = '';
    },
    idName: function () {
        return this.connection.channelSlug(this.getName());
    },
    idNamespace: function () {
        return 'channel';
    },
    getType: function () {
        if (this.isSlackMultiPersonDm()) {
            return 'direct message';
        } else {
            return 'channel';
        }
    },
    isChannel: function() {
        return true;
    },
    getTimestamp: function () {
        if (this.timestamp > 0) {
            return new Date(this.timestamp);
        }
    },
    checkFocusOnMakeBufferName: function (focusOnMakeBuffer) {
        var parts = this.getSafeChanParts();
        if (parts) {
            if (focusOnMakeBuffer === parts.prefix + parts.name) {
                return true;
            }
            if (focusOnMakeBuffer === parts.prefix + parts.prefix + parts.name) {
                return true;
            }
        }
        return focusOnMakeBuffer === this.getName().toLowerCase();
    },
    isSlackMultiPersonDm: function () {
        return this.connection.isSlack() && !!this.getSlackMultiPersonParts();
    },
    getTwitchInfo: function () {
        return this.connection.getTwitchChannelInfo(this);
    },
    getTwitchRoomParts: function () {
        if (!this.isTwitchRoom()) {
            return;
        }
        var parts = this.normalise().split(':');
        var foundRoom, foundInfo, foundChannel;
        if (this.connection.twitchChannelInfo) {
            _.find(this.connection.twitchChannelInfo, function (info, channel) {
                if (info.rooms && info.channel._id == parts[1]) {
                    _.find(info.rooms, function (room) {
                        if (room._id == parts[2]) {
                            foundRoom = room;
                            foundInfo = info;
                            foundChannel = channel;
                            return true;
                        }
                        return false;
                    });
                }
                return false;
            });
            if (foundInfo && foundRoom) {
                return [foundRoom, foundInfo, foundChannel];
            }
        }
    },
    getTwitchRoomNameParts: function () {
        var parts = this.getTwitchRoomParts();
        if (parts) {
            return [parts[1].channel.display_name, parts[0].name];
        }
    },
    getTwitchDisplayName: function (twitchInfo) {
        twitchInfo = twitchInfo || this.getTwitchInfo();
        if (twitchInfo && twitchInfo.channel.display_name) {
            return twitchInfo.channel.display_name;
        }
    },
    getDisplayName: function () {
        var safeChanParts = this.getSafeChanParts();
        if (safeChanParts) {
            return safeChanParts.prefix + safeChanParts.name;
        } else if (this.connection.isSlack()) {
            var mpdm = this.getSlackMultiPersonNicks();
            if (mpdm) {
                return _.map(this.getSlackMultiPersonNicks(), function (nick) {
                    var u = this.connection.findUser(nick);
                    return u ? u.getDisplayName() : nick;
                }, this).join(', ');
            }
        } else if (this.connection.isTwitch()) {
            if (this.isTwitchRoom()) {
                var twitchRoomNameParts = this.getTwitchRoomNameParts();
                if (twitchRoomNameParts) {
                    return twitchRoomNameParts.join(' : ');
                }
            } else {
                var twitchName = this.getTwitchDisplayName();
                if (twitchName) {
                    return twitchName;
                }
            }
        }
        return this.getName();
    },
    getSlackMultiPersonParts: function () {
        return this.getName().match(/^#mpdm-(.*)-\d$/);
    },
    getSlackMultiPersonNicks: function () {
        var parts = this.getSlackMultiPersonParts();
        if (parts) {
            var nicks = _.filter(parts[1].split('--'), _.bind(function (nick) {
                return nick != this.connection.getNick();
            }, this));
            if (nicks.length) {
                nicks.sort(util.naturalCompare);
                return nicks;
            }
        }
    },
    isTwitchRoom: function () {
        return this.connection.isTwitch() &&
            this.normalise().indexOf('chatrooms:') === 0;
    },
    isTwitchRestrictedRoom: function () {
        if (this.isTwitchRoom()) {
            var twitchRoomParts = this.getTwitchRoomParts();
            if (twitchRoomParts) {
                var roomInfo = twitchRoomParts[0];
                return roomInfo.minimum_allowed_role &&
                    roomInfo.minimum_allowed_role != 'EVERYONE';
            }
        }
        return false;
    },
    hasTwitchRooms: function (twitchInfo) {
        twitchInfo = twitchInfo || this.getTwitchInfo();
        if (twitchInfo && twitchInfo.rooms && twitchInfo.rooms.length) {
            return true;
        } else {
            return false;
        }
    },
    safeChanSuffix: function () {
        var idParts = this.getSafeChanParts();
        if (idParts) {
            return '(' + idParts.id + ')';
        }
    },
    getSafeChanParts: function () {
        var idchan = this.connection.getISupport('IDCHAN');
        if (idchan) {
            var name = this.getName();
            var prefix = name[0];
            if (prefix in idchan) {
                var idLength = idchan[prefix];
                var id = name.slice(1, idLength + 1);
                var chanName = name.slice(idLength + 1);
                return {
                    prefix: prefix,
                    id: id,
                    name: chanName
                };
            }
        }
    },
    getUrl: function () {
        if (this.connection.isSlack()) {
            return this.getSlackUrl();
        }
        return this.channelUrl;
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl() + 'messages/' + this.normalise() + '/details/';
    },
    setTimestamp: function (timestamp) {
        this.timestamp = timestamp;
        this.trigger('timestampChange', this);
    },
    setUrl: function (url) {
        this.channelUrl = url;
        this.trigger('urlChange', this);
    },
    init: function (message) {
        this.trigger('preinit');
        this.chan_members_failed = message.chan_members_failed;

        this.resetMembers(message.members);
        // Propagate to existing conversations
        this.getMembers().each(function (member, i) {
            var conversation = member.findConversation();
            if (conversation) {
                conversation.setRecipientProps(member.attributes);
            }
        }, this);
        
        if (message.timestamp > 0) {
            this.setTimestamp(message.timestamp * 1000);
        }
        
        var topic = message.topic;
        if (topic) {
            var author;
            if (topic.nick) {
                author = this.connection.makeUserFromTarget(
                    this.id,
                    _.extend({}, topic, {
                        hostmask: topic.usermask,
                        from_name: topic.user,
                        from_host: topic.userhost
                    })
                );
            }
            this.setTopic(topic.text, author, topic.time, topic.server);
        }
        
        this.setMode(message.ops);

        this.setUrl(message.url);

        if (this.connection.isInitialized() && this.connection.isTwitch()) {
            this.connection.setupTwitch();
            this.connection.throttledTwitchPoll();
        }
        
        this.activate();
        
        this.trigger('init', this);
        
        return this;
    },
    messageHandlers: $.extend({}, Child.prototype.messageHandlers, {
        rename_channel: function (message) {
            var newName = message.new_name;
            this.set({name: newName});
            if (this.isSelected()) {
                this.connection.urlChange();
            }
        },
        channel_init: function (message) {
            this.init(message);
        },
        member_updates: function (message) {
            _.each(message.updates, function (details, nick) {
                var member = this.getMember(nick);
                // We can be sent this event when not joined to the channel,
                // so the member list would be empty
                if (member) {
                    // Don't override an away message we might already have
                    var memberAway = member.getAway();
                    if (memberAway && details.away) {
                        details.away = memberAway;
                    }
                    member.set(details);
                }
                // Propagate to existing conversation
                var conversation = this.connection.findConversation(nick);
                if (conversation) {
                    conversation.setRecipientProps(details);
                }
            }, this);
        }
    }),
    initializedMessageHandlers: $.extend({}, Child.prototype.initializedMessageHandlers, {
        channel_topic: function (message) {
            var author;
            var server = message.get('server');
            if (!server) {
                author = this.connection.makeUserFromTarget(
                    this.id,
                    _.extend({}, message.attributes, {
                        nick: message.get('author')
                    })
                );
            }
            this.setTopic(message.get('topic'), author, message.get('topic_time'), server);
        },
        channel_timestamp: function (message) {
            this.setTimestamp(message.get('timestamp') * 1000);
        },
        channel_url: function (message) {
            this.setUrl(message.get('url'));
        },
        channel_mode_is: function (message) {
            this.setMode(message.get('ops'));
        },
        channel_mode: function (message) {
            this.setMode(message.get('ops'));
        },
        user_channel_mode: function (message) {
            var member = this.getMember(message.get('nick'));
            if (member) {
                member.setMode(message.get('newmode'));
            }
        },
        user_chghost: function (message) {
            var member = this.getMember(message.get('nick'));
            if (member) {
                member.set({
                    user: message.from_name,
                    userhost: message.from_host,
                    usermask: message.hostmask
                });
            }
        },
        joined_channel: function (message) {
            var params = {};
            _.each({
                'cid': 'cid',
                'bid': 'bid',
                'nick': 'nick',
                'hostmask': 'usermask',
                'ident_prefix': 'ident_prefix',
                'from_name': 'user',
                'from_host': 'userhost',
                'realname': 'realname',
                'from_realname': 'realname',
                'account': 'account',
                'from_account': 'account',
                'avatar': 'avatar',
                'avatar_url': 'avatar_url',
                'display_name': 'display_name',
                'status_text': 'status_text',
                'pronouns': 'pronouns',
                'bot_url': 'bot_url'
            }, function (uprop, mprop) {
                if (message.has(mprop)) {
                    params[uprop] = message.get(mprop);
                }
            });
            this.addMember(params);
        },
        parted_channel: function (message) {
            this.removeMember(message.get('nick'));
        },
        quit: function (message) {
            this.removeMember(message.get('nick'));
        },
        kicked_channel: function (message) {
            this.removeMember(message.get('nick'));
        },
        you_parted_channel: function (message) {
            this.deactivate();
        },
        you_kicked_channel: function (message) {
            this.deactivate();
        },
        nickchange: function (message) {
            this.updateMemberNick(message);
        },
        you_nickchange: function (message) {
            this.updateMemberNick(message);
        }
    }),
    addMember: function (data) {
        var member = this.getMember(data.nick);
        if (!member) {
            this.members.add(this.createMember(data));
        } else {
            debug.warn('Duplicate member joined_channel: ' + data.nick, data, member);
        }
    },
    removeMember: function (nick) {
        var member = this.getMember(nick);
        if (member) {
            this.members.remove(member);
        } else {
            debug.warn('Removing a missing member: ' + nick);
        }
    },
    updateMemberNick: function (message) {
        var member = this.getMember(message.get('oldnick'));
        // This is sent for us even when not in channel
        if (member) {
            member.set({nick: message.get('newnick')});
        }
    },
    getPrefKey: function (key) {
        return 'channel-' + key;
    },
    prefKeys: $.extend({}, Child.prototype.prefKeys, {
        'hiddenMembers': ['showMembers', true],
        'notifications-all': ['notifications-all-disable', false]
    }),
    setShowMembersPref: function (enable) {
        this.setOverridePref(enable, 'hiddenMembers');
    },
    setNotifyAllPref: function (enable) {
        this.setOverridePref(enable, 'notifications-all');
    },
    shouldShowMemberList: function () {
        return this.checkPref('hiddenMembers');
    },
    shouldNotifyAll: function () {
        return this.checkPref('notifications-all');
    },
    // Ignore global setting for mpdms
    isTrackingUnread: function () {
        if (this.isSlackMultiPersonDm()) {
            return !this.getPref('disableTrackUnread');
        } else {
            return this.checkPref('disableTrackUnread');
        }
    },
    setTrackingUnreadPref: function (enable) {
        if (this.isSlackMultiPersonDm()) {
            this.setPref('disableTrackUnread', !enable);
        } else {
            this.setOverridePref(enable, 'disableTrackUnread');
        }
    },
    createMember: function (data) {
        return new Member(data, {
            session: this.session,
            connection: this.connection,
            channel: this
        });
    },
    resetMembers: function (members) {
        var nicks = [];
        // Filter dupes, this should never happen but does
        var memberList = _.filter(_.map(members, function (member, i) {
            if (_.include(nicks, member.nick)) {
                debug.warn('Duplicate member in channel_init: ' + member.nick, _.find(members, function (m) {
                    return m.nick == member.nick;
                }), member);
            } else {
                nicks.push(member.nick);
                var newMember = this.createMember({
                    cid: this.getCid(),
                    bid: this.bid(),
                    nick: member.nick,
                    realname: member.realname,
                    account: member.account,
                    mode: member.mode,
                    ircserver: member.ircserver,
                    away: member.away,
                    user: member.user,
                    usermask: member.usermask,
                    userhost: member.userhost,
                    ident_prefix: member.ident_prefix,
                    avatar: member.avatar,
                    avatar_url: member.avatar_url,
                    display_name: member.display_name,
                    status_text: member.status_text,
                    pronouns: member.pronouns,
                    bot_url: member.bot_url
                });
                if (this.session.isInitialized()) {
                    var existingMember = this.getMember(member.nick);
                    if (existingMember) {
                        newMember.setLastSpoke(existingMember.getLastSpoke());
                        newMember.setLastHighlighted(existingMember.getLastHighlighted());
                    }
                }
                return newMember;
            }
        }, this), _.identity);
        this.members.reset(memberList);
        // Not guaranteed to be in the member list, IRCds and ZNC etc can do strange things
        this.setUserMember(this.getMember(this.connection.getNick()));
    },
    getUser: function () {
        return this.userMember || Child.prototype.getUser.call(this);
    },
    clearTopic: function () {
        this.topic = null;
        this.trigger('topicChange', this);
    },
    isMod: function () {
        return this.userMember.isMod();
    },
    canSetTopic: function () {
        var topicControl = !!this.hasMode('t');
        return this.isActive() && (!topicControl || this.isMod());
    },
    setTopic: function (topic, author, time, server) {
        if (time > 0) {
            time = time * 1000;
        } else {
            time = null;
        }
        this.topic = new Topic({
            author: author,
            topic: topic,
            time: time,
            server: server
        });
        this.trigger('topicChange', this);
    },
    setMode: function (ops) {
        if (!ops) {
            return;
        }
        _.each(ops.remove, function (remove, i) {
            delete this.modeParams[remove.mode];
        }, this);
        _.each(ops.add, function (add, i) {
            this.modeParams[add.mode] = add.param;
        }, this);
        
        this.previousModeString = this.modeString;
        this.modeString = '';
        var values = [];
        for (var k in this.modeParams) {
            if (this.modeParams[k]) {
                values.push(this.modeParams[k]);
            }
            this.modeString += k;
        }
        if (values.length) {
            this.modeString += ' ' + values.join(' ');
        }
        if (this.previousModeString != this.modeString) {
            this.trigger('modeChange', this);
        }
    },
    clearMode: function () {
        this.modeString = '';
        this.previousModeString = '';
        this.modeParams = {};
        this.trigger('modeChange', this);
    },
    hasMode: function (mode) {
        return mode in this.modeParams;
    },
    getMode: function (mode) {
        return this.modeParams[mode];
    },
    isPassworded: function () {
        return this.hasMode('k');
    },
    isSecret: function () {
        return this.hasMode('s');
    },
    getKey: function () {
        return this.getMode('k');
    },
    getTopic: function () {
        return this.topic;
    },
    connectionStateChange: function () {
        if (this.connection.isDisconnected() && !this.connection.wasDisconnected()) {
            this.deactivate();
        }
    },
    setUserMember: function (user) {
        if (user) {
            if (!this.userMember) {
                this.userMember = new Member(user.attributes, {
                    session: user.connection,
                    connection: this.connection,
                    buffer: this,
                    channel: this
                });
            } else {
                this.userMember.set(user.attributes);
            }
            this.stopListening(null, 'change', this.setUserMember);
            this.listenTo(user, 'change', this.setUserMember);
        }
    },
    rename: function (newName, callback) {
        this.post('rename-channel', {
            name: newName
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('renameError', newName, response, callback);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    deactivate: function () {
        Child.prototype.deactivate.call(this);
        this.members.reset();
        this.setUserMember(this.user);
        this.clearMode();
        this.setTimestamp(null);
        this.setUrl(null);
        this.clearTopic();
    },
    
    // Actions
    join: function () {
        this.connectionPost('join', {
            channel: this.getName(),
            key: this.getKey()
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    part: function (message) {
        this.connectionPost('part', {
            channel: this.getName(),
            msg: message
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    op: function (user) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/op " + user.getName());
    },
    deop: function (user) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/deop " + user.getName());
    },
    voice: function (user) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/voice " + user.getName());
    },
    devoice: function (user) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/devoice " + user.getName());
    },
    kick: function (user, reason) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/kick " + user.getName() + " " + reason);
    },
    ban: function (mask) {
        this.connection.channelBan(this.getName(), mask);
    },
    banList: function () {
        this.connection.channelBanList(this.getName());
    },
    updateTopic: function (topic) {
        this.connectionPost('topic', {
            channel: this.getName(),
            topic: topic
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    }
});


module.exports = Channel;


/***/ }),

/***/ "KgJn":
/***/ (function(module, exports, __webpack_require__) {

var LineMessageRenderer = __webpack_require__("3F0q");
var BufferLogContainerView = __webpack_require__("Qc6Z");
var Message = __webpack_require__("j9Sh");
var FileInlineView = __webpack_require__("G5kp");
var RenderReasons = __webpack_require__("ilaq");
var util = __webpack_require__("GmLC");


var BufferLogView = BufferLogContainerView.extend({
    tagName: 'div',
    className: 'log',
    initialize: function (options, scroll) {
        BufferLogContainerView.prototype.initialize.apply(this, arguments);
        
        this.model.bind('remove', this.remove, this);
        this.model.bind('clear', this.clear, this);
        this.model.bind('rendered', this.rendered, this);
        this.listenTo(this.model.session.backend, 'connected', this.removeAllPendingRows);
        
        this.lineRenderer = new LineMessageRenderer(this.model);
        
        this.bottomSeenVisible = false;
        this.focusSeenVisible = false;
        this.messageBuffer = [];
        this.rendered = false;
    },
    events: $.extend({}, BufferLogContainerView.prototype.events, {}),
    getVisibleLineStrict: function (message) {
        var line = this.getLine(message);
        if (line.length && line.is(':visible')) {
            return line;
        }
    },
    getVisibleLine: function (message) {
        var line = this.getLine(message);
        if (line.length && !line.is(':visible')) {
            var group = line.closest('.joinPartGroup').prev('.groupedJoinPart');
            if (group.length) {
                line = group;
            }
            while (line && !line.is(':visible')) {
                line = line.prev();
            }
        }
        return line;
    },
    preRenderMessageData: function (message, reqid) {
        return _.map(this.lineRenderer.prerender(message), function (prerendered, i) {
            var user = this.model.getUser();
            var data = {
                bid: this.model.bid(),
                type: prerendered.type,
                eid: this.model.session.backend.ts()*1000,
                from: user.getName(),
                msg: prerendered.message,
                chan: this.model.getName(),
                name: this.model.getName(),
                cid: this.model.getCid(),
                self: true,
                hostmask: user.get('usermask'),
                ident_prefix: user.get('ident_prefix'),
                from_host: user.get('userhost'),
                from_name: user.get('user'),
                from_mode: user.getMode(),
                from_account: user.get('account'),
                from_realname: user.getRealname(),
                avatar: user.get('avatar'),
                avatar_url: user.get('avatar_url'),
                display_name: user.get('display_name'),
                bot_url: user.get('bot_url')
            };
            if (reqid) {
                data._pendingreqid = reqid;
            }
            return data;
        }, this);
    },
    // Only bound after render
    sayRequest: function (message, reqid, extraHtml) {
        if (!message) {
            return;
        }
        // Parse message to see how we should pre-render it
        var messages = _.map(this.preRenderMessageData(message, reqid), function (data) {
            var m = new Message(data, {
                buffer: this.model
            });
            m._previousMessage = this.model.messages.lastVisible();
            return m;
        }, this);
        if (messages.length) {
            var rows = this.lineRenderer.renderMessages(messages).flush();
            var els = this.append(rows);
            if (extraHtml) {
                els.last().find('.message').append(extraHtml);
                this.triggerImagesLoaded(extraHtml);
            }
            this.removeLastSeen();
            
            this.scroll.onChange(true);
        }
    },
    rewriteSayRequest: function (reqid, newMessage) {
        if (newMessage) {
            // Parse message to see how we should pre-render it
            var messages = _.map(this.preRenderMessageData(newMessage, reqid), function (data) {
                return new Message(data, {
                    buffer: this.model
                });
            }, this);

            var rows = this.lineRenderer.renderMessages(messages).flush();
            // Assume only a single row to rewrite
            var content = $(rows[0]).find('.content').html();
            var row = this.getPendingRow(reqid);
            row.find('.content').html(content);
        } else {
            this.removePendingRow(reqid);
        }

        this.scroll.onChange(true);
    },
    throttleMessage: function () {
        var lastIndex = this.model.messages.findLastIndex(function (m) {
            return m.isThrottlable();
        });
        if (lastIndex !== -1) {
            var msg = this.model.messages.at(lastIndex);
            msg.markAsThrottled();
            this.getLine(msg).addClass('throttled').highlightFlash();
        }
    },
    addErrorUpload: function (file, errorType, errorResponse) {
        var line = this.getLine(file.sentMessage);
        var fileView = new FileInlineView({model: file});
        
        fileView.once('finalise', function (retryPromise) {
            var options = {
                reqid: this.model.session.backend._getRequestId()
            };
            fileView.remove();
            this.model.trigger('finaliseFileFromPromise', retryPromise, fileView, options);
        }, this);

        fileView.renderLocalInlinePreview().done(_.bind(function (preview) {
            if (errorResponse && errorType != 'abort') {
                preview.find('.userError').text(RenderReasons.renderPostError(errorResponse, file.sentMessage));
            }
            var extraHtml = $('<span class="fileWrap error">').append($('<span class="file">').append(preview));
            fileView.setElement(extraHtml);

            line.find('.message').append(extraHtml);

            this.triggerImagesLoaded(extraHtml);

            this.scroll.onChange(true);
        }, this));
    },
    sayError: function (response, message) {
        var pending = this.getPendingRow(response._reqid);
        pending.find('.fileWrap .userError').text(RenderReasons.renderPostError(response, message));
        pending.addClass('pendingError');

        this.scroll.onChange(true);
    },
    getPendingRow: function (reqid) {
        return this.$('.pending_' + reqid);
    },
    markPendingRowAsError: function (reqid) {
        this.getPendingRow(reqid).addClass('pendingError');
    },
    unmarkErrorPendingRow: function (reqid) {
        this.getPendingRow(reqid).removeClass('pendingError');
    },
    removePendingRow: function (reqid) {
        this.getPendingRow(reqid).remove();
        this.model.trigger('removePending', reqid);
    },
    removeAllPendingRows: function () {
        this.$('.pending').remove();
        this.model.trigger('removeAllPending');
    },
    renderBottomSeen: function () {
        var rows = this.lineRenderer.renderBottomSeenDivider(this.model.getBottomSeen()).flush();
        this.removeBottomSeen();
        this.append(rows);
    },
    renderFocusSeen: function () {
        var rows = this.lineRenderer.renderFocusSeenDivider(this.model.focusSeen).flush();
        this.removeFocusSeen();
        this.append(rows);
    },
    showBottomSeen: function () {
        var bottomSeen = this.getBottomSeen();
        if (bottomSeen.length) {
            if (!this.bottomSeenVisible) {
                // Remove any other markers to avoid a dupe
                this.removeFocusSeen();
                this.removeLastSeen();
                bottomSeen.removeClass('hidden');
                this.bottomSeenVisible = true;
            }
            return !!this.model.getBottomSeen();
        }
    },
    showFocusSeen: function () {
        var focusSeen = this.getFocusSeen();
        if (focusSeen.length) {
            if (!this.focusSeenVisible) {
                // Remove any other markers to avoid a dupe
                this.removeBottomSeen();
                this.removeLastSeen();
                focusSeen.removeClass('hidden');
                this.focusSeenVisible = true;
            }
            return !!this.model.getFocusSeen();
        }
    },
    removeBottomSeen: function () {
        this.getBottomSeen().remove();
        this.bottomSeenVisible = false;
    },
    removeFocusSeen: function () {
        this.getFocusSeen().remove();
        this.focusSeenVisible = false;
    },
    getBottomSeen: function () {
        return this.$('.bottomSeen');
    },
    getFocusSeen: function () {
        return this.$('.focusSeen');
    },
    renderFetching: function (initial) {
        this.removeLoadMore();
        this.removeFetchFailed();
        var rows = this.lineRenderer.renderFetchingDivider(this.model.messages.first(), initial).flush();
        this.prepend(rows);
    },
    removeFetchingRow: function () {
        this.$('.fetch').remove();
    },
    removeBacklogDivider: function () {
        this.getBacklogDivider().remove();
    },
    removeFetchFailed: function () {
        this.$('.fetchFailed').remove();
    },
    renderFetchFailed: function (discontinuity) {
        if (!discontinuity) {
            this.removeFetchingRow();
        }
        
        this.renderLoadMore();
        
        var rows = this.lineRenderer.renderFetchFailedDivider(this.model.messages.first()).flush();
        this.prepend(rows);
    },
    clear: function () {
        this.scroll.clearFirstRendered();

        this.$el.empty();

        this.renderLoadMore();

        var rows = this.lineRenderer.flush();
        
        // Add rows to DOM
        this.prepend(rows);
    },
    rendered: function () {
        this.rendered = true;
    },
    isRendered: function () {
        return !!this.rendered;
    },
    removeBefore: function (message) {
        var line = this.getLine(message);
        if (line.length) {
            this.scroll.setFirstRendered(message);
            this.removeLoadMore();

            // Reset first date change divider
            if (message.hasSameDateAsPrevious()) {
                this.$('.dateChange:first').remove();
                this.lineRenderer.renderDateRow(message);
            }
            
            // Check if we're in a group and pick out the lines we want to
            // keep before removing the group
            var group = line.closest('.joinPartGroup');
            var messages;
            if (group.length) {
                messages = _.filter(_.map(group.find('.row'), function (r) {
                    var msg = this.scroll.getMessageForRow($(r));
                    if (msg && msg.id >= message.id) {
                        return msg;
                    }
                }, this), _.identity);
                
                // Remove previous lines and group
                group.prevAll().remove();
                group.remove();
            } else {
                // Remove previous lines
                line.prevAll().remove();
            }

            // Reset firstAuthor if needed
            if (line.is('.sameAuthor')) {
                line.addClass('firstAuthor');
                line.removeClass('sameAuthor');
            }

            this.renderLoadMore();

            this.lineRenderer.renderMessagesAtTop(messages);
            
            var rows = this.lineRenderer.flush();
            
            // Add rows to DOM
            this.prepend(rows);
        }
    },
    renderFetchedMessages: function (messages, prevEarliest, discontinuity) {
        if (prevEarliest) {
            this.removeBefore(this.model.getMessage(prevEarliest));
        }

        this.scroll.setFirstRendered(messages[0]);

        if (!discontinuity) {
            this.removeFetchingRow();
        }

        this.renderLoadMore();

        this.lineRenderer.renderMessagesAtTop(messages);
        
        if (prevEarliest) {
            var dividingMessage = this.model.getMessage(prevEarliest);
            if (dividingMessage) {
                var previous = dividingMessage.previousVisible();
                if (previous) {
                    // Reset firstAuthor if needed
                    if (dividingMessage.hasSameAuthor(previous)) {
                        var line = this.getLine(dividingMessage);
                        if (line.is('.firstAuthor')) {
                            line.addClass('sameAuthor');
                            line.removeClass('firstAuthor');
                        }
                    }
                    
                    // Remove previous date change divider
                    if (dividingMessage.hasSameDate(previous)) {
                        this.$('.dateChange:first').remove();
                    } else if (previous) {
                        this.lineRenderer.renderDateRow(dividingMessage);
                    }
                }
            }
            
            this.removeBacklogDivider();
            
            if (messages.length && !discontinuity) {
                this.lineRenderer.renderBacklogDivider(dividingMessage);
            }
        }
    },
    renderFetched: function (messages, prevEarliest, discontinuity) {
        this.renderFetchedMessages(messages, prevEarliest, discontinuity);
        var rows = this.lineRenderer.flush();
        if (prevEarliest) {
            this.initialPrepend(rows);
        } else {
            this.initialAppend(rows);
        }

        if (messages.length) {
            this.handleClientTagsAtTop(messages);

            if (prevEarliest && !discontinuity) {
                return this.getBacklogDivider();
            }
        }
    },
    getBacklogDivider: function () {
        return this.$('.backlogDivider');
    },
    // Only bound after render, this is for real time messages,
    // initial backlog and past backlog are handled on render and
    // in the fetched handler
    bufferMessage: function (message) {
        this.messageBuffer.push(message);
        if (this.messageBuffer.length > this.trimDetectThreshold) {
            this.messageBuffer = this.messageBuffer.slice(-this.trimThreshold);
            this.messageBufferTrim = this.messageBuffer[0];
        }
    },
    bufferFlushTimeout: 200,
    checkFlush: function () {
        if (!this.lastFlush || util.ts() - this.lastFlush > this.bufferFlushTimeout) {
            this.flushBuffer();
        } else {
            setTimeout(_.bind(this.checkFlush, this), this.bufferFlushTimeout);
        }
    },
    trimDetectThreshold: 350,
    trimThreshold: 200,
    checkTrim: function (end) {
        var firstRender = this.scroll.getFirstRendered();
        if (firstRender) {
            var trimmable = this.model.trimmableMessages(firstRender, end);
            if (
                trimmable.length > this.trimDetectThreshold &&
                (end || this.scroll.isScrolledToBottom())
            ) {
                // Trim extra backlog
                var threshHoldMessage = trimmable.slice(-this.trimThreshold)[0];
                if (this.model.isSelected()) {
                    var topMessage = this.scroll.getMessageAtTopOfScroll();
                    if (topMessage && topMessage.isBefore(threshHoldMessage)) {
                        // Selected and top message occurs above threshold
                        // trim from that instead
                        debug.log(this.model.getTitle(), 'top selected');
                        this.removeBefore(topMessage);
                    } else {
                        debug.log(this.model.getTitle(), 'threshold selected');
                        this.removeBefore(threshHoldMessage);
                    }
                } else {
                    debug.log(this.model.getTitle(), 'unselected');
                    this.removeBefore(threshHoldMessage);
                }
                debug.timeStamp(this.model.getTitle() + ' [trim]');
            }
        }
    },
    renderBelowScroll: function () {
        var bottomSeen = this.scroll.getMessageForRow(this.getBottomSeen());
        this.flushBuffer(bottomSeen);
    },
    removePending: function (message) {
        if (message.has('reqid')) {
            if (!message.get('entities') || !message.get('entities').files || !message.get('entities').files[0].url) {
                this.removePendingRow(message.get('reqid'));
            }
        } else if (this.model.isConversation() && this.model.isSelf()) {
            this.removeAllPendingRows();
        }
    },
    flushBuffer: function (bottomSeen) {
        this.lastFlush = util.ts();
        this.checkTrim(bottomSeen);
        if (!this.messageBuffer.length) {
            return;
        }
        var batchOptions = this.batchOptions();

        this.scroll.checkPinBottom(function (pinBottom) {
            if (!bottomSeen && !pinBottom) {
                // Only render client tags if scrolled up
                // Filter successfully processed messages out of the buffer
                this.messageBuffer = _.filter(this.messageBuffer, function (message) {
                    if (this.handleClientTags(message, batchOptions)) {
                        this.removePending(message);
                        return false;
                    } else {
                        return true;
                    }
                }, this);
                this.processBatched(batchOptions);
                this.scroll.onChange();
                return;
            }
            this.batchRendering = true;
            if (this.messageBufferTrim) {
                this.removeBefore(this.messageBufferTrim);
                delete this.messageBufferTrim;
            }
            var els = $();
            _.each(this.messageBuffer, function renderMessagesEach (message) {
                this.removePending(message);
                var batchEls = this.renderMessage(message, batchOptions);
                if (batchEls) {
                    var lastMessageRow = batchEls.closest('.messageRow').last();
                    var lastJoinPartHeading = batchEls.closest('.groupedJoinPart').last();
                    var lastDiscoHeading = batchEls.closest('.groupedDisco').last();
                    if (lastMessageRow.length) {
                        batchOptions.lastMessageRow = lastMessageRow;
                    }
                    if (lastJoinPartHeading.length) {
                        batchOptions.lastJoinPartHeading = lastJoinPartHeading;
                    }
                    if (lastDiscoHeading.length) {
                        batchOptions.lastDiscoHeading = lastDiscoHeading;
                    }

                    if (message.get('reqid')) {
                        if (batchOptions.reqidMap[message.get('reqid')]) {
                            batchEls = batchOptions.reqidMap[message.get('reqid')].add(batchEls);
                        }
                        batchOptions.reqidMap[message.get('reqid')] = batchEls;
                    } else {
                        batchOptions.nonReqidEls = batchOptions.nonReqidEls.add(batchEls);
                    }
                    els = els.add(batchEls);
                }
            }, this);
            els = els.not(batchOptions.toExclude);
            if (els.length) {
                this.batchAppend(els);
            }
            delete this.batchRendering;

            _.each(this.messageBuffer, function (message) {
                this.handleClientTags(message, batchOptions);
            }, this);

            this.processBatched(batchOptions);

            this.messageBuffer = [];
            this.scroll.onChange(pinBottom);
        }, this);
    },
    processBatched: function (options) {
        options.toRemove.remove();

        var replaceEls = _.reduce(options.toReplace, function (memo, els, key, obj) {
            return memo.add(els);
        }, $());
        this.prepareEmbeds(replaceEls);

        _.each(options.toReplace, function (replacement, messageId) {
            var row = this.getMsgIdRow(messageId);
            if (row.length) {
                this.doReplaceRow(row, replacement, messageId);
            }
        }, this);
        
        _.each(options.reqidMap, function (reqidEls, reqid) {
            this.postInsertion(reqidEls.not(options.toExclude), false, reqid);
        }, this);
        this.postInsertion(options.nonReqidEls.not(options.toExclude));
    },
    batchOptions: function () {
        return {
            batch: true,
            toExclude: $(),
            toRemove: $(),
            toReplace: {},
            nonReqidEls: $(),
            reqidMap: {}
        };
    },
    handleClientTagsAtTop: function (messages) {
        var batchOptions = this.batchOptions();

        _.each(messages, function (message) {
            this.handleClientTags(message, batchOptions);
        }, this);

        // Then check for any missing targets
        var missingReplyTargets = this.missingReplyTargets;
        this.missingReplyTargets = [];
        while (missingReplyTargets.length) {
            this.handleClientTags(missingReplyTargets.shift(), batchOptions);
        }

        this.processBatched(batchOptions);
    },
    renderMessage: function (message, options) {
        if (!this.scroll.getFirstRendered()) {
            if (!message.isEmpty()) {
                this.scroll.setFirstRendered(message);
                if (!this.scroll.isFetching()) {
                    this.removeLoadMore();
                    this.renderLoadMore();
                }
            }
        }
        if (message.equals(this.model.discontinuity)) {
            this.scroll.loadDiscontinuity();
        } else {
            var els = BufferLogContainerView.prototype.renderMessage.apply(this, arguments);
            if (!options || !options.batch) {
                this.handleClientTags(message, options);
            }
            if (els.length) {
                // Only show marker if not ignored and not a hidden join/part
                // (server logs don't have the isShowingJoinPart method)
                if (message.isSelf()) {
                    this.removeLastSeen();
                } else if (!message.isIgnored() &&
                    (this.model.isServerLog() || !message.isJoinPart() || this.model.isShowingJoinPart())
                ) {
                    this.showSeenMarker();
                }
                
                return els;
            }
        }
    },
    showSeenMarker: function () {
        // Show markers, but avoid dupes
        var bottom = this.showBottomSeen();
        if (!bottom) {
            var focus = this.showFocusSeen();
            if (!focus) {
                this.showLastSeen();
            }
        }
    },
    handleMessage: function (message) {
        this.bufferMessage(message);
        if (this.model.connection.isBacklogLoaded()) {
            this.checkFlush();
        }
    },
    renderLastSeen: function () {
        var lastSeen = this.model.getLastSeenMessage();
        if (lastSeen) {
            var rows = this.lineRenderer.renderLastSeenDivider(lastSeen).flush();
            if (rows.length) {
                this.scroll.checkPinBottom(function (pinBottom) {
                    // Insert if the last seen line is rendered
                    var lastSeenLine = this.getLine(lastSeen);
                    var isLastRendered = !!lastSeenLine.length;
                    
                    this.removeLastSeen({silent: isLastRendered});

                    if (isLastRendered) {
                        this.insertAfter(lastSeenLine, rows);
                    }
                    
                    this.scroll.onChange(pinBottom);
                }, this);
            }
        }
    },
    showLastSeen: function () {
        var lastSeen = this.getLastSeenRow();
        if (lastSeen.length) {
            this.removeFocusSeen();
            this.removeBottomSeen();
            this.getLastSeenRow().removeClass('hidden');
            return true;
        }
    },
    removeLastSeen: function (options) {
        options = options || {};
        this.getLastSeenRow().remove();
        if (!options.silent) {
            this.lineRenderer.lastSeenEid = null;
        }
    },
    getLastSeenRow: function () {
        return this.$('.lastSeen');
    },
    
    renderLoadMore: function () {
        this.removeLoadMore();
        if (!this.scroll.isFullyRendered()) {
            this.lineRenderer.renderLoadMore(this.scroll.getFirstRendered());
        }
    },
    removeLoadMore: function () {
        this.$('.loadMore').remove();
    },
    render: function () {
        var batch;
        if (this.model.messages.length) {
            // Render backlog of messages
            batch = this.model.messages.last(this.scroll.batchSize);
            // Filter out before the most recent discontinuity
            if (this.model.discontinuity) {
                batch = _.filter(batch, function (m) {
                    return m.id > this.model.discontinuity.id;
                }, this);
            }
            this.scroll.setFirstRendered(batch[0]);
            this.renderLoadMore();
            this.lineRenderer.renderMessages(batch);
        } else if (this.model.isDeferred()) {
            this.renderLoadMore();
        } else if (this.model.isThread() && !this.model.hasFirstMessage()) {
            this.renderLoadMore();
        }
        
        var rows = this.lineRenderer.flush();
        this.initialAppend(rows);

        if (batch) {
            var batchOptions = this.batchOptions();
            _.each(batch, function (message) {
                this.handleClientTags(message, batchOptions);
            }, this);
            this.processBatched(batchOptions);
        }
        
        this.setRendered();
        
        if (this.model.isDeferred() || this.model.isCacheReset()) {
            this.scroll.loadOrRenderBacklog();
        }
        
        return this;
    },
    setRendered: function () {
        this.model.messages.bind('add', this.handleMessage, this);
        this.model.bind('sayRequest', this.sayRequest, this);
        this.model.bind('throttleMessage', this.throttleMessage, this);
        this.model.bind('retryPending', this.unmarkErrorPendingRow, this);
        this.model.bind('rewriteSayRequest', this.rewriteSayRequest, this);
        this.model.bind('addErrorUpload', this.addErrorUpload, this);
        this.model.bind('sayError', this.sayError, this);
        this.listenTo(this.model.connection, 'ignoresChange', this.ignoresChange);
        this.listenTo(this.model.connection, 'reload', this.checkFlush);
    },
    
    ignoresChange: function () {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$('.row').each(_.bind(function (i, row) {
                var r = $(row);
                var message = this.scroll.getMessageForRow(r);
                if (message) {
                    r.toggleClass('ignored', message.isIgnored());
                }
            }, this));
            
            this.scroll.onChange(pinBottom);
        }, this);
    },
    batchAppend: function (els) {
        this.prepareEmbeds(els);
        $(this.el).append(els);
        return els;
    },
    initialAppend: function (rows) {
        var els = this.prepareInsertion(rows, null, true);
        $(this.el).append(els);
        this.initialPostInsertion(els);
        return els;
    },
    initialPrepend: function (rows) {
        var els = this.prepareInsertion(rows, null, true);
        $(this.el).prepend(els);
        this.initialPostInsertion(els);
        return els;
    },
    prepend: function (rows, classNames) {
        var els = this.prepareInsertion(rows, classNames);
        $(this.el).prepend(els);
        this.postInsertion(els);
        return els;
    },
    insertAfter: function (target, rows, classNames) {
        var els = this.prepareInsertion(rows, classNames);
        target.after(els);
        this.postInsertion(els);
        return this;
    },
    initialPostInsertion: function (els) {
        if (this.isRendered()) {
            this.postInsertion(els, true);
        } else {
            this.model.once('afterShow', _.bind(function () {
                this.initialPostInsertion(els);
            }, this));
        }
    }
});


module.exports = BufferLogView;


/***/ }),

/***/ "L46s":
/***/ (function(module, exports, __webpack_require__) {

var OrgMember = __webpack_require__("w2pc");


var OrgMemberList = Backbone.Collection.extend({
    model: OrgMember,
    initialize: function (models, options) {
        
    },
    comparator: function (a, b) {
        // Invites first
        if (a.isJoined() && !b.isJoined()) {
            return 1;
        } else if (b.isJoined() && !a.isJoined()) {
            return -1;
        // Among members, admins first
        } else if (a.isAdmin() && !b.isAdmin()) {
            return -1;
        } else if (b.isAdmin() && !a.isAdmin()) {
            return 1;
        // Among members, first joined first
        } else if (a.get('join_time') > b.get('join_time')) {
            return -1;
        } else if (a.get('join_time') < b.get('join_time')) {
            return 1;
        // Among invites, first invited first
        } else if (a.get('invite_time') > b.get('invite_time')) {
            return -1;
        } else if (a.get('invite_time') < b.get('invite_time')) {
            return 1;
        } else {
            return 0;
        }
    }
});


module.exports = OrgMemberList;


/***/ }),

/***/ "LKWs":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var IRCFormatter = __webpack_require__("XiBv");


var BufferNotificationHandler = Backbone.View.extend({
    initialize: function (options) {
        this.bindMessageHandlers();
        this.model.bind('unseenHighlightChange', this.unseenHighlightChange, this);
        
        this.formatter = new BufferFormatter(this.model);
        this.model.on('remove', this.remove, this);
    },
    bindMessageHandlers: function () {
        for (var type in this.messages) {
            this.model.bind('notableMessage:' + type, this.handleMessage, this);
        }
    },
    shouldNotify: function (message) {
        if (!this.model.session.isInitialized()) {
            return false;
        }
        // Don't notify if this buffer is selected and the window has focus
        // unless it's below the bottom seen
        if (!this.model.isBelowBottomSeen(message) &&
            this.model.isSelected() &&
            this.model.session.isFocused()) {
            return false;
        }
        return true;
    },
    handleMessage: function (message) {
        if (this.shouldNotify(message)) {
            this.messages[message.get('type')].call(this, message);
        }
    },
    messages: {
        buffer_msg: function (message) {
            var title = message.getDisplayName() + ' — ';
            if (this.model.isChannel()) {
                title += this.model.getDisplayName();
            } else {
                title += this.model.connection.getDisplayName();
            }
            
            var content = IRCFormatter.strip(message.get('msg'));
            this.notify(message, title, content);
        },
        buffer_me_msg: function (message) {
            var title = message.getDisplayName() + ' — ';
            if (this.model.isChannel()) {
                title += this.model.getDisplayName();
            } else {
                title += this.model.connection.getDisplayName();
            }
            
            var content = IRCFormatter.strip(message.get('msg'));
            this.notify(message, title, content);
        },
        notice: function (message) {
            var title = message.getDisplayName() + ' — ';
            if (this.model.isChannel()) {
                title += this.model.getDisplayName();
            } else {
                title += this.model.connection.getDisplayName();
            }
            
            var content = IRCFormatter.strip(message.get('msg'));
            this.notify(message, title, content);
        },
        channel_invite: function (message) {
            var title = 'Channel invite from: ' + message.getDisplayName() + ' (' + this.model.connection.getDisplayName() + ')';
            
            var content = IRCFormatter.strip("Invite to join " + message.get('channel'));
            this.notify(message, title, content);
        },
        callerid: function (message) {
            var title = 'Callerid: ' + message.get('nick') + ' (' + this.model.connection.getDisplayName() + ')';
            
            var content = IRCFormatter.strip(message.get('nick') + ' ' + message.get('msg'));
            this.notify(message, title, content);
        },
        wallops: function (message) {
            var title = message.getDisplayName() + ' (' + this.model.connection.getDisplayName() + ')';
            var content = IRCFormatter.strip(message.get('msg'));
            this.notify(message, title, content);
        }
    },
    close: function () {
        if (this.notification) {
            this.notification.close();
            // Close handlers don't work in Safari
            this.notification = null;
        }
    },
    notify: function (message, title, body) {
        if (!this.model.session.getPref('emoji-disableconvert')) {
            body = emoji.replace_colons(body, true);
        }

        var options = {
            model: message,
            tag: this.model.getId(),
            title: title,
            body: body,
            show: _.bind(function (notification) {
                this.notification = notification;
            }, this),
            close: _.bind(function (notification) {
                // Won't work in Safari
                this.notification = null;
            }, this),
            click: _.bind(function (notification) {
                // Won't work in Safari
                // Select buffer and scroll to row
                this.model.select();
                if (!this.model.isDeferred()) {
                    message.show();
                }
                // Focus window
                window.focus();
            }, this)
        };
        options.image = this.formatter.linker.singleImage(message, {
            files: this.model.inlineFilesAllowed(),
            images: this.model.inlineImagesAllowed()
        });
        this.model.session.trigger('notify', this.model, options);
    },
    unseenHighlightChange: function () {
        if (!this.model.hasUnseenHighlights()) {
            this.close();
        }
    }
});


module.exports = BufferNotificationHandler;


/***/ }),

/***/ "LLdI":
/***/ (function(module, exports, __webpack_require__) {

var Buf = __webpack_require__("t9zO");
var Channel = __webpack_require__("KU+H");
var Child = __webpack_require__("MN+i");
var ConnectionBufferList = __webpack_require__("h0MN");
var Conversation = __webpack_require__("sCU/");
var Ignore = __webpack_require__("pVJg");
var Message = __webpack_require__("j9Sh");
var PrefMixins = __webpack_require__("/1Z1");
var ServerLog = __webpack_require__("LZT8");
var User = __webpack_require__("Xgjh");
var sko = __webpack_require__("pyif").default;
var twitch = __webpack_require__("/7tV");
var util = __webpack_require__("GmLC");
var startSlackAuth = __webpack_require__("K0O/").startAuth;


var Connection = Backbone.Model.extend($.extend({}, PrefMixins, {
    idAttribute: 'cid',
    initialize: function (data, options) {
        this.session = options.session;
        options.connection = this;
        this.user = new User(data, options);

        this.buffers = new ConnectionBufferList(null, {connection: this});
        this.buffers.on('change:archived', this.onBufferArchiveChange, this);

        this.disambiguation = 0;
        this.serverLog = null;
        this.isupport = {};
        this.usermodes = "";
        this.reloading = false;

        this.inputHistory = new sko();

        this.parseIgnores();

        this.setHostnameTests();

        this.initialized = false;

        this.bind('change:name', this.urlChange, this);
        this.bind('change:hostname', this.urlChange, this);
        this.bind('change:port', this.urlChange, this);
        this.bind('change:ssl', this.urlChange, this);
        this.bind('change:hostname', this.setHostnameTests, this);
        this.bind('change:ircserver', this.setHostnameTests, this);
        this.bind('change:avatar', this.avatarChange, this);
        this.bind('change:avatar_url', this.avatarChange, this);
        this.bind('change', this.updateUser, this);

        PrefMixins.initialize.apply(this, arguments);
    },
    isOrgServer: function () {
        return !!this.get('orgid');
    },
    getOrg: function () {
        var orgid = this.get('orgid');
        if (orgid) {
            return this.session.orgs.get(orgid);
        }
    },
    setOrder: function (order, options) {
        this.set('order', order, options);
    },
    getOrder: function () {
        return this.get('order') || this.getCid();
    },
    move: function (up) {
        this.collection.move(this, up);
    },
    getUser: function () {
        return this.user;
    },
    getPrefKey: function (key) {
        return 'connection-' + key;
    },
    prefKeys: {
        'avatars-disableUploadPrompt': ['avatars-enableUploadPrompt', true],
        'reply-collapse': ['reply-expand', false],
        'reply-quote': ['reply-noquote', false],
    },
    isIgnored: function (nick, hostmask, options) {
        options = options || {};
        if (nick || hostmask) {
            nick = nick || '*';
            hostmask = hostmask || '*';
            if (_.contains(nick, '@')) {
                debug.warn('Nick contains @: ' + nick);
            }
            var check = Ignore.check(nick + '!' + hostmask, this.ignoreMap);
            if (options.returnMap) {
                var masks = [check.nick + '!' + check.user + '@' + check.host];
                if (check.user == '*') {
                    masks.push(check.nick + '!' + check.host);
                    if (check.host == '*') {
                        masks.push(check.nick);
                    }
                } else if (check.nick == '*') {
                    masks.push(check.user + '@' + check.host);
                }
                check.masks = masks;
                return check;
            } else {
                return check.match;
            }
        }
        if (options.returnMap) {
            return {match: false};
        } else {
            return false;
        }
    },
    getIgnores: function () {
        return this.get('ignores') || [];
    },
    parseIgnores: function () {
        var parsed = Ignore.parse(this.getIgnores());
        if (!_.isEqual(parsed, this.ignoreMap)) {
            this.ignoreMap = parsed;
            this.trigger('ignoresChange');
        }
    },
    setIgnores: function (ignores) {
        // Stream response when ignore is changed (used when updated in a separate client)
        ignores.sort();
        this.set({ignores: ignores});
        this.parseIgnores();
    },
    saveIgnores: function (ignores) {
        // Update made through the JS API
        this.setIgnores(ignores);

        this.post('set-ignores', {
            ignores: JSON.stringify(ignores)
        });
    },
    isReloading: function () {
        return this.reloading;
    },
    reload: function (message) {
        this.reloading = true;
        this.set(message);
    },
    doneReload: function () {
        this.reloading = false;
        this.trigger('reload');
    },
    avatarChange: function () {
        var org = this.getOrg();
        if (org) {
            org.set('avatar', this.get('avatar'));
        }
    },
    updateUser: function () {
        this.user.set(this.attributes);
    },
    urlChange: function () {
        this.trigger('urlPropChange', this);
    },
    setServerLog: function (serverLog) {
        this.addBuffer(serverLog);
        this.serverLog = serverLog;
        // For newly created connections
        if (this.session.isInitialized()) {
            this.init();
        }
    },
    getIdKeys: function () {
        // For fuzzy url shortcut matching
        var keys = [
            this.getId(),       // Full ID including disambiguation
            this.getHostname(), // w/o port e.g. irc.foo.com
            this.getHost()      // w/ port e.g. irc.foo.com:6667
        ];
        if (this.isSSL()) {
            keys.push(this.getHostname(true)); // w/o port w/ protocol e.g. ircs://irc.foo.com
            keys.push(this.getHost(true));     // w/ port w/ protocol e.g. ircs://irc.foo.com:6697
        }
        if (this.isIRCSubdomain()) {
            keys.push(this.getHostname().replace(/^irc\./, ''));
        }
        return keys;
    },
    isIRCSubdomain: function (label) {
        label = label || this.getHostname();
        return /^irc\./.test(label);
    },
    buildDisambiguation: function (disambiguation) {
        if (disambiguation) {
            return ':' + disambiguation;
        }
        return '';
    },
    getDisambiguation: function () {
        return this.buildDisambiguation(this.disambiguation);
    },
    setDisambiguation: function (disambiguation) {
        this.disambiguation = disambiguation;
        this.trigger('disambiguationChange', this);
    },
    isSSL: function () {
        return this.get('ssl');
    },
    isSuspiciousPort: function () {
        return (this.isSSL() && this.getPort() == Connection.defaultPort) ||
              (!this.isSSL() && this.getPort() == Connection.defaultSSLPort);
    },
    hasSpam: function () {
        return this.buffers.hasSpam();
    },
    isSuspiciousHostname: function () {
        var hostname = this.get('hostname');
        return (hostname[0] == '.') ||
               (hostname[hostname.length - 1] == '.') ||
               (hostname.indexOf('.') == -1 && hostname.indexOf(':') == -1);
    },
    isTeamServer: function () {
        if (this.get('team_server')) {
            return true;
        }
        if (this.session.ent('unixname') == this.get('hostname')) {
            return true;
        }
        return false;
    },
    getPort: function () {
        return this.get('port');
    },
    // Includes port
    getHost: function (withSSL) {
        var host = this.getHostname(withSSL);
        if (this.has('port')) {
            host += ':' + this.getPort();
        }
        return host;
    },
    // Without port
    getHostname: function (withSSL) {
        var hostname = '';
        if (withSSL && this.isSSL()) {
            hostname += 'ircs://';
        }
        hostname += this.get('hostname').toLowerCase();
        return hostname;
    },
    getNetworkId: function () {
        return this.getSlug();
    },
    getEncodedNetworkId: function () {
        return encodeURIComponent(this.getSlug());
    },
    url: function () {
        return this.buildUrl();
    },
    urlId: function () {
        return this.buildUrlId();
    },
    userUrl: function () {
        return this.buildUrl(['messages', this.getNick()]);
    },
    urlRoot: function () {
        return this.getEncodedNetworkId() + this.getDisambiguation();
    },
    getId: function () {
        return this.getNetworkId() + this.getDisambiguation();
    },
    buildUrl: function (parts) {
        return Connection.buildUrl(this.urlRoot(), parts);
    },
    buildUrlId: function (namespace, label) {
        return this.joinUrlParts([namespace, label]);
    },
    joinUrlParts: function (parts) {
        return Connection.joinUrlParts(this.urlRoot(), parts);
    },
    buildId: function (namespace, label) {
        return Connection.buildId(Connection.buildId(this.getId(), namespace), label);
    },
    channelSlug: function (name) {
        name = name.toLowerCase();
        var stripped = name.replace(/^#/, '');
        if (stripped != this.normaliseBufferName(stripped)) {
            stripped = name;
        }
        return stripped;
    },
    testId: function (disambiguation) {
        return this.getNetworkId() + this.buildDisambiguation(disambiguation);
    },
    normaliseBufferName: function (bufferName) {
        return util.normaliseChan(bufferName, this.getChannelPrefixes());
    },
    getCid: function () {
        return this.get('cid');
    },
    bindMessages: function () {
        this.listenTo(this.session, 'connectionMessage:' + this.getCid(), this.handleMessage);
        this.listenTo(this.session, 'connectionResponse:' + this.getCid(), this.handleResponse);
    },
    getBuffer: function (bid) {
        return this.buffers.get(bid);
    },
    isBacklogLoaded: function () {
        return this.isInitialized() && !this.isReloading();
    },
    triggerInitializedMessageEvent: function (message) {
        if (this.isBacklogLoaded()) {
            this.trigger('message:' + message.type, message);
        }
    },
    handleMessage: function (message) {
        if (this.messageHandlers[message.type]) {
            this.messageHandlers[message.type].call(this, message);
        }
        if (this.isBacklogLoaded() && this.initializedMessageHandlers[message.type]) {
            this.initializedMessageHandlers[message.type].call(this, message);
        }
        if (message.bid && message.bid > 0) {
            var buffer = this.getBuffer(message.bid);
            if (buffer) {
                buffer.addMessage(message);
            }
        } else if (this.serverLog) {
            this.serverLog.triggerInitializedMessageEvent(message);
        }
        this.triggerInitializedMessageEvent(message);
    },
    handleResponse: function (response, request) {
        if (this.responses[response.type]) {
            this.responses[response.type].call(this, response, request);
        }
    },
    setFocusOnMakeBuffer: function (name) {
        if (name) {
            clearTimeout(this.focusOnMakeBufferTimeout);
            this.focusOnMakeBuffer = name.toLowerCase();
            var buffer;
            if (this.focusOnMakeBuffer == '*') {
                buffer = this.buffers.getFirstBuffer() || this.serverLog;
            } else {
                buffer = this.findBuffer(this.focusOnMakeBuffer);
            }
            if (buffer) {
                this.checkFocusOnMakeBuffer(buffer);
            } else {
                this.focusOnMakeBufferTimeout = setTimeout(_.bind(function () {
                    this.setFocusOnMakeBuffer();
                }, this), 10000);
            }
        } else {
            this.focusOnMakeBuffer = null;
        }
        this.trigger('focusOnMakeBufferChange');
    },
    checkFocusOnMakeBuffer: function (buffer) {
        var select;
        if (this.focusOnMakeBuffer == '*') {
            // Star means select the first non server log buffer we get
            if (buffer.getName() == '*') {
                // Do select the server log, but don't clear the focus
                buffer.select({automatic: true});
            } else {
                select = buffer;
            }
        } else if (buffer.checkFocusOnMakeBufferName(this.focusOnMakeBuffer)) {
            select = buffer;
        }
        if (select) {
            select.select();
        }
    },
    isInitialized: function () {
        return this.initialized;
    },
    select: function () {
        this.doSelectOrWaitForMakeBuffer(this.serverLog, "*");
    },
    isSelected: function () {
        return this.equals(this.session.currentBuffer);
    },
    responses: {
        open_buffer: function (response, request) {
            if ((
                request._method == 'say' ||
                request._method == 'reply' ||
                request._method == 'react'
            ) && request.to == response.name) {
                // Saying to the buffer directly, e.g. via user.say/buffer.say or connection.openBuffer
                // meaning we already handle selection if needed
                return;
            } else {
                this.selectOrWaitForMakeBuffer(response.name);
            }
        }
    },
    selectOrWaitForMakeBuffer: function (name) {
        var buffer = this.findBuffer(name, true);
        this.doSelectOrWaitForMakeBuffer(buffer, name);
    },
    doSelectOrWaitForMakeBuffer: function (buffer, name) {
        if (buffer) {
            buffer.select();
        } else {
            this.setFocusOnMakeBuffer(name);
        }
    },
    isChannelName: function (name) {
        if (!name) {
            return false;
        }
        return _.include(this.getChannelPrefixes(), name[0]);
    },
    makeChild: function (data) {
        var name = data.name || data.chan;
        if (name) {
            if (this.isChannelName(name)) {
                return this.makeChannel(data);
            } else {
                return this.makeConversation(data);
            }
        } else {
            return this.makeServerLog(data);
        }
    },
    makeChannel: function (data) {
        return new Channel(data, {
            connection: this,
            session: this.session
        });
    },
    makeConversation: function (data) {
        return new Conversation(data, {
            connection: this,
            session: this.session
        });
    },
    makeServerLog: function (data) {
        return new ServerLog(data, {
            connection: this,
            session: this.session
        });
    },
    messageHandlers: {
        makebuffer: function (message) {
            var buffer = this.getBuffer(message.bid);
            if (buffer) {
                // Already created
                buffer.setLastSeen(message.last_seen_eid);
                buffer.set(message);
            } else {
                switch (message.buffer_type) {
                case 'console':
                    this.setServerLog(this.makeServerLog(message));
                    break;
                case 'channel':
                    this.addBuffer(this.makeChannel(message));
                    break;
                case 'conversation':
                    this.addBuffer(this.makeConversation(message));
                    break;
                }
            }
        },
        isupport_params: function (message) {
            this.setISupport(message.params);
            this.setUsermodes(message.usermodes);
            this.setVersion(message.version);
        },
        myinfo: function (message) {
            this.setMyInfo({
                server: message.server,
                version: message.version,
                user_modes: message.user_modes,
                channel_modes: message.channel_modes,
                rest: message.rest
            });
            this.setVersion(message.version);
            this.set({ircserver: message.server});
        },
        end_of_backlog: function (message) {
            if (this.isReloading()) {
                // setLastSeen is called in makebuffer before messages
                // are received, so we need to reset it here after they've
                // all come through
                this.buffers.each(function (buffer) {
                    buffer.resetLastSeen();
                });
                this.doneReload();
            } else if (!this.isInitialized() && this.serverLog) {
                this.init();
            }
        }
    },
    initializedMessageHandlers: {
        notice: function (message) {
            if (!this.serverLog || message.bid != this.serverLog.id) {
                // Only server log messages
                return;
            }
            if ('server' in message) {
                var chan = Message.checkThrottleChan(message.msg);
                var buffer = this.findChannel(chan);
                if (buffer) {
                    buffer.trigger('throttleMessage');
                }
            }
        },
        server_details_changed: function (message) {
            this.set(message);
        },
        set_ignores: function (message) {
            this.setIgnores(message.masks);
        },
        self_details: function (message) {
            var props = {};
            if (message.server_realname) {
                props.server_realname = message.server_realname;
            }
            if (message.usermask) {
                props.ident_prefix = message.ident_prefix;
                props.user = message.user;
                props.userhost = message.userhost;
                props.usermask = message.usermask;
            }
            this.propagateUserProps(this.getNick(), props, true);
        },
        avatar_change: function (message) {
            this.propagateUserProps(message.nick, {
                avatar: message.avatar,
                avatar_url: message.avatar_url
            }, message.self);
        },
        display_name_change: function (message) {
            this.propagateUserProps(message.nick, {
                display_name: message.display_name
            }, message.self);
        },
        status_text_change: function (message) {
            this.propagateUserProps(message.nick, {
                status_text: message.status_text
            }, message.self);
        },
        pronouns_change: function (message) {
            this.propagateUserProps(message.nick, {
                pronouns: message.pronouns
            }, message.self);
        },
        bot_url_change: function (message) {
            this.propagateUserProps(message.nick, {
                bot_url: message.bot_url
            }, message.self);
        },
        cap_change: function (message) {
            var values = message.cap_values || this.get('cap_values');
            this.set({
                caps: message.caps,
                cap_values: values,
                avatars_supported: message.avatars_supported
            });
        },
        you_nickchange: function (message) {
            this.set({nick: message.newnick});
        },
        channel_renamed: function (message) {
            if (this.focusOnMakeBuffer === message.old_chan.toLowerCase() || this.findChannel(message.old_chan)) {
                var buffer = this.findChannel(message.new_chan);
                if (buffer) {
                    buffer.select();
                } else {
                    this.setFocusOnMakeBuffer();
                }
            }
        },
        link_channel: function (message) {
            if (message.invalid_chan && this.focusOnMakeBuffer === message.invalid_chan.toLowerCase() || this.findChannel(message.invalid_chan)) {
                var buffer = this.findChannel(message.valid_chan);
                if (buffer) {
                    buffer.select();
                } else {
                    this.setFocusOnMakeBuffer();
                }
            }
        },
        // From whois/PM
        away: function (message) {
            // TODO we need to track this server side and return it in makebuffer
            if (message.self) {
                this.setAway(message.msg);
            }
            var conversation = this.findConversation(message.nick);
            if (conversation) {
                conversation.setAway(message.msg);
            }
        },
        logged_in_as: function (message) {
            this.set('account', message.name);
        },
        hidden_host_set: function (message) {
            var props = {
                userhost: message.hidden_host
            };
            if (message.hidden_mask) {
                props.usermask = message.hidden_mask;
            }
            if (message.user) {
                props.user = message.user;
            }
            if (message.ident_prefix) {
                props.ident_prefix = message.ident_prefix;
            }
            this.propagateUserProps(
                this.getNick(), props, true
            );
        },
        whois_response: function (message) {
            // Set certain properties from response
            var props = {};
            if (message.server_addr) {
                props.ircserver = message.server_addr;
            }
            if (message.user_realname) {
                props.realname = message.user_realname;
            }
            if (message.user_ident_prefix) {
                props.user = message.user_username;
                props.usermask = message.user_mask;
                props.userhost = message.user_host;
                props.ident_prefix = message.user_ident_prefix;
            } else if (message.user_host) {
                // ident_prefix and mask weren't always available
                props.user = message.user_username.replace(/^~/, '');
                props.usermask = message.user_username + '@' + message.user_host;
                props.userhost = message.user_host;
                props.ident_prefix = message.user_username.indexOf('~') === 0 ? '~' : '';
            }
            this.propagateUserProps(message.nick, props);
        },
        user_account: function (message) {
            this.propagateUserProps(message.nick, {
                // needs a value or else it won't override
                account: message.account || '*'
            }, message.self);
        },
        user_realname: function (message) {
            this.propagateUserProps(message.nick, {
                realname: message.realname,
                server_realname: message.server_realname
            }, message.self);
        },
        user_mode: function (message) {
            var userMode = message.newmode;
            if (userMode) {
                userMode = '+' + userMode;
            }
            this.set('user_mode', userMode);
        },
        user_away: function (message) {
            var nick = message.nick;
            if (message.self) {
                this.setAway(message.msg);
            }
            // Propagate to existing buffers
            var conversation = this.findConversation(nick);
            if (conversation) {
                conversation.setAway(message.msg);
            }
            this.buffers.channels.each(function (ch) {
                var member = ch.getMember(nick);
                if (member) {
                    member.setAway(message.msg);
                }
            });
        },
        user_back: function (message) {
            var nick = message.nick;
            if (message.self) {
                this.setBack();
            }
            // Propagate to existing buffers
            var conversation = this.findConversation(nick);
            if (conversation) {
                conversation.setBack();
            }
            this.buffers.channels.each(function (ch) {
                var member = ch.getMember(nick);
                if (member) {
                    member.setBack();
                }
            });
        },
        self_away: function (message) {
            this.setAway(message.away_msg);
        },
        self_back: function (message) {
            this.setBack();
        },

        // Connection status
        status_changed: function (message) {
            var fail = message.fail_info;
            var status = message.new_status;
            var currentFail = this.get('fail_info');
            if (
                // Don't overwrite fail_info on ip_retry
                (!$.isEmptyObject(currentFail) && status == 'ip_retry')
                // Don't wipe fail_info on queued or connecting
                || ($.isEmptyObject(fail) && (status == 'queued' || status == 'connecting'))) {
                fail = currentFail;
            }
            var props = {
                status: status,
                fail_info: fail
            };
            if (message.nick) {
                props.nick = message.nick;
            }
            this.set(props);
            if (this.isDisconnected() || this.isStatus('connected')) {
                this.resetDetails();
            }
        }
    },
    findUser: function (nick) {
        var u;
        this.buffers.channels.find(function (ch) {
            u = ch.getMember(nick);
            if (u) {
                return true;
            }
        });
        return u;
    },
    findUserProps: function (nick) {
        var u = this.findUser(nick);
        if (u) {
            return u.attributes;
        }
    },
    propagateUserProps: function (nick, props, self) {
        if (self) {
            this.set(props);
        }
        // Propagate to existing buffers
        var conversation = this.findConversation(nick);
        if (conversation) {
            conversation.setRecipientProps(props);
        }
        this.buffers.channels.each(function (ch) {
            var member = ch.getMember(nick);
            if (member) {
                member.set(props);
            }
        });
    },
    resetDetails: function () {
        this.set({
            'away': '',
            'ident_prefix': '',
            'user': '',
            'userhost': '',
            'usermask': '',
            'account': '',
            'server_realname': '',
            'caps': [],
            'avatars_supported': false,
            'avatar_url': '',
            'display_name': '',
            'status_text': '',
            'pronouns': '',
            'bot_url': '',
            'user_mode': '',
        });
    },
    init: function () {
        this.initialized = true;
        this.trigger('preinit', this);
        this.trigger('init', this);
        this.setupTwitch();
    },
    getTwitchChanNames: function () {
        if (!this.isTwitch()) {
            return [];
        }
        return _.invoke(this.buffers.channels.filter(function (chan) {
            return !chan.isTwitchRoom();
        }, this), 'normalise');
    },
    setupTwitch: function () {
        if (this.isTwitch() && !this.twitchChannelInfo) {
            this.twitchChannelInfo = {};
            this.throttledTwitchPoll = _.throttle(_.bind(this.doPollTwitch, this), 2000);
            this.pollTwitch();
        }
    },
    getTwitchOAuth: function () {
        return (this.get('server_pass') || '').replace(/^oauth:/, '');
    },
    doPollTwitch: function () {
        twitch.fetchStreamInfo(
            this.session,
            this.getTwitchChanNames(),
            this.getTwitchOAuth()
        ).then(_.bind(function pollTwitchChannelInfo (info) {
            if (!info) {
                return;
            }
            var previousTwitchChannelInfo = $.extend(true, {}, this.twitchChannelInfo);
            this.twitchChannelInfo = info;
            _.each(info, function pollTwitchEachStream (chanInfo, channel) {
                if (previousTwitchChannelInfo[channel]) {
                    if (_.isEqual(chanInfo, previousTwitchChannelInfo[channel])) {
                        delete previousTwitchChannelInfo[channel];
                    }
                } else {
                    previousTwitchChannelInfo[channel] = undefined;
                }
            }, this);
            if (!_.isEmpty(previousTwitchChannelInfo)) {
                _.each(previousTwitchChannelInfo, function pollTwitchEachPreviousValueStream (previousValue, channel) {
                    var chan = this.findChannel('#' + channel);
                    if (chan) {
                        chan.trigger('twitchChannelChange', chan, previousValue);
                    }
                    if (info[channel] && info[channel].rooms) {
                        _.each(info[channel].rooms, function pollTwitchEachRoomChange (room) {
                            var roomChan = this.findChannel(
                                twitch.roomChannel(room.owner_id, room._id)
                            );
                            if (roomChan) {
                                roomChan.trigger('twitchChannelChange', roomChan);
                            }
                        }, this);
                    }
                }, this);
                this.trigger('twitchChannelChange', this);
            }
        }, this));
    },
    pollTwitch: function () {
        this.throttledTwitchPoll();
        setTimeout(_.bind(this.pollTwitch, this), 60000);
    },
    getTwitchChannelInfo: function (buffer) {
        if (this.twitchChannelInfo) {
            var channelName = buffer.normalise();
            return this.twitchChannelInfo[channelName];
        }
    },
    equals: function (cid) {
        if (cid instanceof Connection || cid instanceof Buf) {
            cid = cid.getCid();
        }
        return this.getCid() == cid;
    },
    addBuffer: function (buffer) {
        var name = buffer.getName();
        if (this.inputHistory.get(name)) {
            buffer.setInputHistory(this.inputHistory.get(name));
            this.inputHistory.unset(name);
        }
        this.session.addPinnedBuffer(buffer);
        this.buffers.add(buffer);
        this.checkFocusOnMakeBuffer(buffer);
    },
    removeChildren: function () {
        this.buffers.each(function (buffer) {
            if (!buffer.isServerLog()) {
                this.removeBuffer(buffer);
            }
        }, this);
    },
    removeBuffer: function (buffer) {
        // Make sure we have a buffer, this can take a bid
        buffer = this.getBuffer(buffer);
        if (buffer) {
            this.trigger('beforeBufferRemove', buffer);
            this.buffers.remove(buffer);
            buffer.stopListening();
        }
    },
    getTitle: function () {
        return this.getName();
    },
    onBufferArchiveChange: function (buffer) {
        if (buffer.isDeferred()) {
            this.decrementDeferredArchives();
        }
    },
    hasDeferredArchives: function () {
        return this.get('deferred_archives') > 0;
    },
    decrementDeferredArchives: function () {
        var deferred = this.get('deferred_archives');
        if (deferred > 0) {
            this.set('deferred_archives', deferred - 1);
        }
    },
    isFetchingArchives: function () {
        return !!this.fetchingArchives;
    },
    fetchArchives: function (callback) {
        this.fetchingArchives = true;
        return this.session.backend.get('archives', {
            cid: this.getCid()
        }, _.bind(function (response) {
            if (response.error || response.success === false) {
                this.fetchingArchives = false;
                this.trigger('archiveFetchFailed', response);
            } else {
                var buffersToAdd = _.map(response, function (message) {
                    var buffer;
                    switch (message.buffer_type) {
                    case 'channel':
                        buffer = this.makeChannel(message);
                        break;
                    case 'conversation':
                        buffer = this.makeConversation(message);
                        break;
                    }

                    var name = buffer.getName();
                    if (this.inputHistory.get(name)) {
                        buffer.setInputHistory(this.inputHistory.get(name));
                        this.inputHistory.unset(name);
                    }

                    return buffer;
                }, this);
                this.buffers.add(buffersToAdd);
                this.set('deferred_archives', false);
                this.fetchingArchives = false;
                this.trigger('archivesFetched');
                _.each(buffersToAdd, function (buffer) {
                    this.checkFocusOnMakeBuffer(buffer);
                }, this);
            }
            callback(response);
        }, this));
    },
    hasArchivedBuffers: function () {
        return this.buffers.hasArchivedBuffers();
    },
    isWhitelisted: function () {
        return $.inArray(this.getHostname(), Connection.whitelist) !== -1;
    },
    setIsTwitch: function () {
        this._isTwitch = /\.twitch\.tv$/.test(this.getHostname());
    },
    setHostnameTests: function () {
        this.setIsSlack();
        this.setIsTwitch();
    },
    setIsSlack: function () {
        this._isSlackHost = /\.slack\.com$/.test(this.getHostname());
        this._isSlackServer = /\.slack\.com$/.test(this.get('ircserver'));
    },
    isTwitch: function () {
        // Disable twitch
        return false;
        // return this._isTwitch;
    },
    isSlack: function () {
        return this.isSlackOAuth() || this._isSlackHost || this._isSlackServer;
    },
    isSlackUpgradable: function () {
        return this.session.isSlackOauthAllowed() && this.isSlack() && !this.isSlackOAuth();
    },
    isSlackOAuth: function () {
        return !!this.get('slack');
    },
    upgradeSlack: function () {
        if (this.isSlackUpgradable()) {
            startSlackAuth(this.session, {
                data: {
                    cid: this.id
                },
                onSuccess: _.bind(function (response) {
                    this.session.setFocusOnMakeServer(response.cid);
                }, this),
                onError: _.bind(function (message) {
                    if (message) {
                        this.trigger('postError', {
                            message: message
                        });
                    }
                }, this)
            });
        }
    },
    getSlackBaseUrl: function () {
        var slackMatches = this.getHostname().match(/^([^.]+).*\.slack\.com$/);
        if (!slackMatches) {
            slackMatches = this.get('ircserver').match(/^([^.]+).*\.slack\.com$/);
        }
        if (slackMatches) {
            return 'https://' + slackMatches[1] + '.slack.com/';
        }
    },
    clientTagDeny: function (tagname) {
        var denyList = this.getISupport('CLIENTTAGDENY');
        if (!denyList || !_.isString(denyList)) {
            return false;
        }
        var denied = false;
        _.each(denyList.split(','), function (tag) {
            if (tag === '*' || tag === tagname) {
                denied = true;
            }
            if (tag === ('-' + tagname)) {
                denied = false;
            }
        });
        return denied;
    },
    hasReliableClientTags: function () {
        return this.hasClientTags() && this.hasLabel();
    },
    blocksTyping: function () {
        return this.clientTagDeny('typing');
    },
    blocksReplies: function () {
        return this.clientTagDeny('reply') && this.clientTagDeny('draft/reply');
    },
    blocksReactions: function () {
        return this.blocksReplies() || this.clientTagDeny('draft/react');
    },
    blocksEdits: function () {
        return this.clientTagDeny('draft/edit') || this.clientTagDeny('draft/edit-text');
    },
    blocksDeletes: function () {
        return this.clientTagDeny('draft/delete');
    },
    hasClientTags: function () {
        return _.include(this.get('caps'), "message-tags");
    },
    hasLabel: function () {
        return (
            _.include(this.get('caps'), "labeled-response") ||
            _.include(this.get('caps'), "draft/labeled-response")
        );
    },
    hasMetadata: function () {
        return (
            _.include(this.get('caps'), "draft/metadata-2") ||
            _.include(this.get('caps'), "draft/metadata-notify-2")
        );
    },
    hasMultiline: function () {
        return _.include(this.get('caps'), "draft/multiline");
    },
    hasRedaction: function () {
        return _.include(this.get('caps'), "draft/message-redaction");
    },
    shouldGuessAvatar: function () {
        if (this.session.ent()) {
            return false;
        }
        if (this.get('avatars_supported')) {
            return false;
        }
        return true;
    },
    nativeAvatarUploadsSupported: function () {
        return (this.get('avatar') || this.get('avatars_supported'))
            && !!this.get('ircserver')
            && !this.isSlackOAuth();
    },
    avatarUploadsSupported: function () {
        if (this.nativeAvatarUploadsSupported()) {
            return true;
        }
        if (this.session.get('avatar') && !this.isSlack()) {
            return true;
        }
        return false;
    },
    setPromptAvatarPref: function (enable) {
        this.setOverridePref(enable, 'avatars-disableUploadPrompt');
    },
    setCollapsingRepliesPref: function (enable) {
        this.setOverridePref(enable, 'reply-collapse');
    },
    setQuoteRepliesPref: function (enable) {
        this.setOverridePref(enable, 'reply-quote');
    },
    isCollapsingReplies: function () {
        return this.checkPref('reply-collapse');
    },
    isShowingQuoteReplies: function () {
        return this.checkPref('reply-quote');
    },
    getRelayBots: function () {
        return this.getPref('relaybot-whitelist') || [];
    },
    setRelayBots: function (bots) {
        this.setPref('relaybot-whitelist', bots);
    },
    isRelayBot: function (nick) {
        var bots = this.getRelayBots();
        return _.contains(bots, nick);
    },
    setRelayBot: function (nick) {
        var bots = this.getRelayBots();
        var newBots = _.unique(bots.concat([nick]));
        this.setRelayBots(newBots);
    },
    unsetRelayBot: function (nick) {
        var bots = this.getRelayBots();
        var newBots = _.unique(_.without(bots, nick));
        this.setRelayBots(newBots);
    },
    hasMeaningfulHostnames: function () {
        return !this.isTwitch() && !this.isSlack();
    },
    hasUModeR: function () {
        return !this.isTeamServer() && !this.isTwitch() && !this.isSlack();
    },
    getNick: function () {
        return this.get('nick');
    },
    getName: function () {
        return this.get('name') || this.get('hostname');
    },
    getSlug: function () {
        return this.getName().toLowerCase().replace(/[_:\s]/g, '-').replace(/^irc\./, '');
    },
    getDisplayName: function () {
        return this.getName();
    },
    getFullLabel: function () {
        var name = this.getName();
        var host = this.getHost();
        if (name) {
            if (host) {
                return name + ' (' + host + ')';
            } else {
                return name;
            }
        } else {
            return host;
        }
    },
    nick: function (nick, callback) {
        return this.post('nick', {nick: nick}, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    channelBanList: function (channelName, callback) {
        return this.channelMaskModeList(channelName, 'b', callback);
    },
    channelBan: function (channelName, mask, callback) {
        return this.channelMaskModeOn(channelName, 'b', mask, callback);
    },
    channelUnban: function (channelName, mask, callback) {
        return this.channelMaskModeOff(channelName, 'b', mask, callback);
    },
    channelExceptList: function (channelName, callback) {
        return this.channelMaskModeList(channelName, 'e', callback);
    },
    channelExcept: function (channelName, mask, callback) {
        return this.channelMaskModeOn(channelName, 'e', mask, callback);
    },
    channelUnexcept: function (channelName, mask, callback) {
        return this.channelMaskModeOff(channelName, 'e', mask, callback);
    },
    channelMaskModeList: function (channelName, mode, callback) {
        // TODO make this a web service so we don't need to construct the call
        return this.say({
            msg: '/mode ' + channelName + ' +' + mode
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    channelMaskModeOn: function (channelName, mode, mask, callback) {
        // TODO make this a web service so we don't need to construct the call
        return this.say({
            msg: '/mode ' + channelName + ' +' + mode + ' ' + mask
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    channelMaskModeOff: function (channelName, mode, mask, callback) {
        // TODO make this a web service so we don't need to construct the call
        return this.say({
            msg: '/mode ' + channelName + ' -' + mode + ' ' + mask
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    prefillInputHistory: function (bufferName, message) {
        bufferName = bufferName.toLowerCase();
        if (!this.inputHistory.get(bufferName)) {
            this.inputHistory.set(bufferName, []);
        }
        this.inputHistory.get(bufferName).push({msg: message});
    },
    sayPaste: function (data, callback) {
        return this._say('say-paste', data, callback);
    },
    say: function (data, callback) {
        return this._say('say', data, callback);
    },
    react: function (data, callback) {
        return this._say('react', data, callback);
    },
    typing: function (data, callback) {
        return this._say('typing', data, callback);
    },
    reply: function (data, callback) {
        return this._say('reply', data, callback);
    },
    deleteMessage: function (data, callback) {
        return this._say('delete-message', data, callback);
    },
    redactMessage: function (data, callback) {
        return this._say('redact-message', data, callback);
    },
    editMessage: function (data, callback) {
        return this._say('edit-message', data, callback);
    },
    _say: function (endpoint, message, callback) {
        return this.post(endpoint, $.extend({
            to: '*'
        }, message), _.bind(function (response) {
            if (callback) {
                callback(response);
            } else {
                if (!response.success) {
                    this.trigger('postError', response);
                }
            }
        }, this));
    },
    post: function (method, message, callback) {
        return this.session.post(method, $.extend({
            cid: this.getCid()
        }, message), callback);
    },
    getServerIcon: function () {
        return this.getISupport('ICON') || this.getISupport('draft/ICON');
    },
    getUserModeHierarchy: function () {
        var modes = this.usermodes;
        if (modes) {
            var ownerLetter = this.getISupport('OWNER');
            return _.map(modes, function (mode) {
                if (mode == ownerLetter) {
                    return 'OWNER';
                } else if (ownerLetter && User.defaultModes[mode] == 'OWNER') {
                    return mode;
                } else if (mode == mode.toUpperCase()) {
                    if (_.includes(modes, mode.toLowerCase())) {
                        return mode;
                    } else {
                        return User.defaultModes[mode.toLowerCase()] || mode;
                    }
                } else {
                    return User.defaultModes[mode] || mode;
                }
            });
        } else {
            return User.defaultModeHierarchy;
        }
    },
    getUserModes: function () {
        var modes = this.usermodes;
        if (modes) {
            var prefixModes = {};
            var ownerLetter = this.getISupport('OWNER');
            _.each(modes, function (mode) {
                if (mode == ownerLetter) {
                    prefixModes.OWNER = mode;
                } else if (ownerLetter && User.defaultModes[mode] == 'OWNER') {
                    prefixModes[mode] = mode;
                } else if (mode == mode.toUpperCase()) {
                    if (_.includes(modes, mode.toLowerCase())) {
                        prefixModes[mode] = mode;
                    } else {
                        prefixModes[User.defaultModes[mode.toLowerCase()] || mode] = mode;
                    }
                } else {
                    prefixModes[User.defaultModes[mode] || mode] = mode;
                }
            });
            return prefixModes;
        } else {
            return User.defaultModeLetters;
        }
    },
    makeUserFromTarget: function (bid, target) {
        return new User({
            nick: target.nick,
            usermask: target.hostmask,
            ident_prefix: target.ident_prefix,
            user: target.from_name,
            userhost: target.from_host,
            mode: target.from_mode,
            account: target.from_account,
            realname: target.from_realname,
            avatar: target.avatar,
            avatar_url: target.avatar_url,
            display_name: target.display_name,
            bot_url: target.bot_url
        }, {
            session: this.session,
            connection: this,
            buffer: this.getBuffer(bid)
        });
    },
    findBuffer: function (name, exact) {
        return this.buffers.lookup(name, exact);
    },
    findConversation: function (name, exact) {
        var buf = this.findBuffer(name, exact);
        if (buf && buf.isConversation()) {
            return buf;
        }
    },
    findChannel: function (name, exact) {
        var buf = this.findBuffer(name, exact);
        if (buf && buf.isChannel()) {
            return buf;
        }
    },
    getOrMakeBuffer: function (name, exact) {
        return this.findBuffer(name, exact) || this.makeChild({name: name});
    },
    openNewBuffer: function (name) {
        // Open a new buffer
        this.setFocusOnMakeBuffer(name);
        var buffer = this.makeChild({name: name});
        buffer.open();
        return buffer;
    },
    openBuffer: function (name, exact) {
        var buffer = this.findBuffer(name, exact);
        if (buffer) {
            buffer.select();
            return buffer;
        } else {
            return this.openNewBuffer(name);
        }
    },
    joinChannel: function (name, key) {
        return this.post('join', {
            channel: name,
            key: key
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    remove: function (cid) {
        return this.post('delete-connection', {}, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    edit: function (data, callback) {
        return this.post("edit-server", data, callback);
    },
    editName: function (netName, callback) {
        return this.post('set-netname', {
            netname: netName
        }, callback);
    },
    nickservRegisterHelp: function (callback) {
        return this.post("ns-help-register", {}, callback);
    },
    setNickservPassword: function (nsPass, callback) {
        this.set({'nickserv_pass': nsPass});
        return this.post("set-nspass", {
            nspass: nsPass
        }, _.bind(function (response) {
            if (callback) {
                callback(response);
            }
        }, this));
    },
    disconnect: function (cid, message) {
        return this.post('disconnect', {
            msg: message
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    reconnect: function (cid) {
        return this.post('reconnect', {}, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    ignore: function (mask, callback) {
        this.post('ignore', {
            mask: mask
        }, callback);
    },
    unignore: function (mask, callback) {
        this.post('unignore', {
            mask: mask
        }, callback);
    },

    setAway: function (msg) {
        this.propagateUserProps(
            this.getNick(), {away: msg}, true
        );
    },
    setBack: function () {
        this.propagateUserProps(
            this.getNick(), {away: false}, true
        );
    },
    isCollapsed: function () {
        if (!this.serverLog) {
            return false;
        }
        return this.serverLog.isArchived();
    },
    setCollapsed: function () {
        this.serverLog.archive();
    },
    setExpanded: function () {
        this.serverLog.unarchive();
    },
    toggleCollapsed: function () {
        if (this.isCollapsed()) {
            this.setExpanded();
        } else {
            this.setCollapsed();
        }
    },
    away: function (message, callback) {
        this.post('away', {
            msg: message
        }, callback);
    },
    back: function (callback) {
        this.post('back', {}, callback);
    },
    isAway: function () {
        return !!this.get('away');
    },
    setISupport: function (params) {
        for (var k in params) {
            this.isupport[k] = params[k];
        }
        this.trigger('iSupportChange', this);
    },
    getISupport: function (key, fallback) {
        if (key) {
            return this.isupport[key] || fallback;
        }
        return this.isupport;
    },
    getCapValue: function (key) {
        var values = this.get('cap_values') || {};
        return values[key];
    },
    getRelayMsgSeparator: function () {
        return this.getCapValue('draft/relaymsg');
    },
    setUsermodes: function (modes) {
        this.usermodes = modes;
    },
    setVersion: function (version) {
        this.version = version;
    },
    getChannelPrefixes: function () {
        var defaultChanTypes = '#＃';
        var chantypes = this.getISupport('CHANTYPES', defaultChanTypes);
        // In case the isupport value is empty and has been parsed as a flag
        if (chantypes === true) {
            return defaultChanTypes;
        }
        return chantypes;
    },

    // Extra info about servers can be in myinfo and version
    // but we only store it in the backlog, not the conn record (unlike isupport)
    setMyInfo: function (params) {
        this.myinfo = params;
        this.trigger('myInfoChange', this);
    },
    getMyInfo: function (key) {
        if (key) {
            return this.myinfo[key];
        }
        return this.myinfo;
    },

    getFailInfo: function (key) {
        var failInfo = this.get('fail_info');
        if (failInfo && key) {
            return failInfo[key];
        } else {
            return failInfo;
        }
    },
    previousFailInfo: function (key) {
        var failInfo = this.previous('fail_info');
        if (failInfo && key) {
            return failInfo[key];
        } else {
            return failInfo;
        }
    },
    isFailed: function () {
        return !$.isEmptyObject(this.getFailInfo()) && !this.isStatus('ip_retry') && this.getFailInfo('reason') != 'reconnecting' && !this.getFailInfo('ip');
    },
    isSSLVerifyError: function () {
        return this.getFailInfo('reason') == 'ssl_verify_error';
    },
    wasFailed: function () {
        return !$.isEmptyObject(this.previousFailInfo()) && !this.wasStatus('ip_retry') && this.previousFailInfo('reason') != 'reconnecting';
    },
    getStatus: function () {
        return this.get('status');
    },
    isStatus: function (status) {
        return this.getStatus() === status;
    },
    wasStatus: function (status) {
        return this.previous('status') === status;
    },
    isConnected: function () {
        return this.isStatus('connected_ready');
    },
    wasConnected: function () {
        return this.wasStatus('connected_ready');
    },
    isDisconnected: function () {
        return this.isStatus('disconnected') || this.isStatus('undefined') || this.badRetry();
    },
    wasDisconnected: function () {
        return this.wasStatus('disconnected') || this.wasStatus('undefined') || this.wasBadRetry();
    },
    getRetryTimeout: function () {
        if (!this.isFailed()) {
            return;
        }
        var failInfo = this.getFailInfo();
        var ts = this.session.backend.tsOffset((failInfo.timestamp + failInfo.retry_timeout) * 1000);
        return new Date(ts);
    },
    previousRetryTimeout: function () {
        if (!this.wasFailed()) {
            return;
        }
        var failInfo = this.previousFailInfo();
        var ts = this.session.backend.tsOffset((failInfo.timestamp + failInfo.retry_timeout) * 1000);
        return new Date(ts);
    },
    badRetry: function () {
        return this.isStatus('waiting_to_retry') && !this.willRetry();
    },
    wasBadRetry: function () {
        return this.wasStatus('waiting_to_retry') && !this.willHaveRetried();
    },
    willRetry: function () {
        var timeout = this.getRetryTimeout();
        if (timeout) {
            return timeout.getElapsed() < 1;
        }
        return false;
    },
    willHaveRetried: function () {
        var timeout = this.previousRetryTimeout();
        if (timeout) {
            return timeout.getElapsed() < 1;
        }
        return false;
    },
    isConnecting: function () {
        if (this.isStatus('waiting_to_retry')) {
            return this.willRetry();
        }
        return !this.isConnected() && !this.isDisconnected() && !this.isStatus('quitting');
    },
    wasConnecting: function () {
        if (this.wasStatus('waiting_to_retry')) {
            return this.willHaveRetried();
        }
        return !this.wasConnected() && !this.wasDisconnected() && !this.wasStatus('quitting');
    },
    isReady: function () {
        return this.isConnected() || this.isStatus('connected_joining');
    },
    wasReady: function () {
        return this.wasConnected() || this.wasStatus('connected_joining');
    },
    isSocketActive: function () {
        return this.isReady() || this.isStatus('connected');
    },
    wasSocketActive: function () {
        return this.wasReady() || this.wasStatus('connected');
    },
    isActive: function () {
        return this.isSocketActive() || this.isStatus('connecting') || this.isStatus('queued');
    },
    wasActive: function () {
        return this.wasSocketActive() || this.wasStatus('connecting') || this.wasStatus('queued');
    },
    isInactive: function () {
        return this.isDisconnected() || this.isStatus('quitting');
    },
    wasInactive: function () {
        return this.wasDisconnected() || this.wasStatus('quitting');
    }
}), {

    joinUrlParts: function (initial, parts) {
        return _.reduce(parts, function (memo, part) {
            return Connection.joinUrlPart(memo, part);
        }, initial);
    },
    joinUrlPart: function (rootLabel, label) {
        var url = rootLabel;
        if (label) {
            url += '/' + encodeURIComponent(label);
        }
        return url;
    },
    buildUrl: function (rootLabel, parts) {
        return '/irc/' + Connection.joinUrlParts(rootLabel, parts);
    },
    buildLegacyUrl: function (rootLabel, label) {
        return 'irc/' + Connection.joinUrlPart(rootLabel, label);
    },
    buildId: function (rootLabel, label) {
        var id = rootLabel;
        if (label) {
            id += '/' + label;
        }
        return id;
    },
    whitelist: [
        "irc.irccloud.com"
    ],
    defaultPort: 6667,
    defaultSSLPort: 6697
});


module.exports = Connection;


/***/ }),

/***/ "LZT8":
/***/ (function(module, exports, __webpack_require__) {

var Buf = __webpack_require__("t9zO");
var UserList = __webpack_require__("jGPP");


var ServerLog = Buf.extend({
    defaults: {
        name: '*'
    },
    getType: function () {
        return 'server log';
    },
    isServerLog: function() {
        return true;
    },
    idName: function () {
        return '';
    },
    idNamespace: function () {
        return '';
    },
    getTitle: function () {
        return this.connection.getTitle();
    },
    getFullLabel: function () {
        return this.connection.getFullLabel();
    },
    initialize: function (data, options) {
        Buf.prototype.initialize.apply(this, arguments);
        this.members = new UserList(this.getUser());
    },
    connectionStateChange: function () {
        if (this.connection.isDisconnected()) {
            this.deactivate();
        } else {
            this.activate();
        }
    },
    isShowingJoinPart: function () {
        return true;
    },
    isCollapsingJoinPart: function () {
        return true;
    },
    // Prefs
    prefKeys: $.extend({}, Buf.prototype.prefKeys, {
        'expandDisco': ['collapseDisco', true]
    }),
    setCollapsingDisconnectsPref: function (enable) {
        this.setOverridePref(enable, 'expandDisco');
    },
    isCollapsingDisconnects: function () {
        return this.checkPref('expandDisco');
    }
});


module.exports = ServerLog;


/***/ }),

/***/ "M5Sr":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");


var InvitesDialogView = DialogView.extend({
    el: '#invitesContainer',
    initialize: function (options) {
        _.bindAll(this, 'focusEmail', 'hideError');
        this.afterShow = this.focusEmail;
        this.afterHide = this.hideError;
        DialogView.prototype.initialize.apply(this, arguments);
        
        this.email = $('#invitesEmail');
        this.error = $('#invitesError');
        this.invitesHideBadge = $('#invitesHideBadge');
        
        this.model.bind('change:num_invites', this.renderInvites, this);
        this.model.bind('init', this.init, this);
        this.model.bind('showInvites', this.show, this);
        this.model.bind('hideInvites', this.hide, this);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit #invitesForm': 'submit',
        'change #invitesHideBadge': 'toggleShowBadge'
    }),
    toggleShowBadge: function (e) {
        if (this.model.isInitialized()) {
            var showBadge = this.invitesHideBadge.prop('checked');
            this.model.setPref('hideInviteBadge', !showBadge);
        }
    },
    init: function () {
        this.renderInvites();
    },
    submit: function (e) {
        e.preventDefault();
        if (this.model.featureCheck('invites')) {
            this.model.sendInvite(this.email.val(), _.bind(function callback (response) {
                if (response.success) {
                    this.email.val('');
                    this.model.set({num_invites: response.num_remaining});
                    this.hide();
                } else {
                    var message;
                    switch (response.message) {
                    case 'num_invites':
                        message = 'You’ve run out of invites';
                        break;
                    case 'invalid_email':
                        message = 'Invalid email address, try again';
                        break;
                    case 'empty_email':
                        message = 'Missing email address, try again';
                        break;
                    default:
                        message = 'Error sending invite: ' + response.message;
                        break;
                    }
                    this.showError(message);
                }
            }, this));
        } else {
            this.showError("Invites are disabled");
        }
    },
    renderInvites: function () {
        var showBadge = !this.model.getPref('hideInviteBadge');
        this.invitesHideBadge.prop('checked', showBadge);
    },
    showError: function (message) {
        this.error.text(message).fadeIn('fast');
    },
    focusEmail: function () {
        this.email.focus().select();
    },
    hideError: function () {
        this.error.hide();
    }
});


module.exports = InvitesDialogView;


/***/ }),

/***/ "MN+i":
/***/ (function(module, exports, __webpack_require__) {

var Buf = __webpack_require__("t9zO");


var Child = Buf.extend({
    initialize: function (data, options) {
        Buf.prototype.initialize.apply(this, arguments);
        this.threadCollapsedOverrides = {};
        this.threadExpandedOverrides = {};
    },
    messageHandlers: $.extend({}, Buf.prototype.messageHandlers, {
        delete_buffer: function (message) {
            this.removeFromConnection();
        }
    }),
    removeFromConnection: function () {
        this.connection.removeBuffer(this);
    },
    remove: function () {
        this.post('delete-buffer');
    },
    open: function () {
        this.say();
    },
    
    // Prefs
    prefKeys: $.extend({}, Buf.prototype.prefKeys, {
        'hideJoinPart': ['showJoinPart', true],
        'expandJoinPart': ['collapseJoinPart', true],
        'reply-collapse': ['reply-expand', false],
        'reply-quote': ['reply-noquote', false],
        'disableTypingStatus': ['enableTypingStatus', true]
    }),
    setShowingJoinPartPref: function (enable) {
        this.setOverridePref(enable, 'hideJoinPart');
    },
    setCollapsingJoinPartPref: function (enable) {
        this.setOverridePref(enable, 'expandJoinPart');
    },
    setCollapsingRepliesPref: function (enable) {
        this.setOverridePref(enable, 'reply-collapse');
    },
    setQuoteRepliesPref: function (enable) {
        this.setOverridePref(enable, 'reply-quote');
    },
    setTypingStatusPref: function (enable) {
        this.setOverridePref(enable, 'disableTypingStatus');
    },
    isShowingJoinPart: function () {
        return this.checkPref('hideJoinPart');
    },
    isCollapsingJoinPart: function () {
        return this.checkPref('expandJoinPart');
    },
    isSharingTyping: function () {
        return this.checkPref('disableTypingStatus');
    },
    isCollapsingReplies: function () {
        return this.connection.isCollapsingReplies() || this.checkPref('reply-collapse');
    },
    isShowingQuoteReplies: function () {
        return this.connection.isShowingQuoteReplies() || this.checkPref('reply-quote');
    },
    isThreadCollapsed: function (msgId) {
        if (this.isCollapsingReplies()) {
            return !this.isThreadExpandedOverride(msgId);
        } else {
            return this.isThreadCollapsedOverride(msgId);
        }
    },
    isThreadCollapsedOverride: function (msgId) {
        return !!this.threadCollapsedOverrides[msgId];
    },
    isThreadExpandedOverride: function (msgId) {
        return !!this.threadExpandedOverrides[msgId];
    },
    setThreadCollapsedOverride: function (msgId, value) {
        delete this.threadExpandedOverrides[msgId];
        this.threadCollapsedOverrides[msgId] = value;
    },
    setThreadExpandedOverride: function (msgId, value) {
        delete this.threadCollapsedOverrides[msgId];
        this.threadExpandedOverrides[msgId] = value;
    }
});


module.exports = Child;


/***/ }),

/***/ "MfRu":
/***/ (function(module, exports) {

window.getPref = function (key, defaultValue) {
    if (window.SESSION) {
        return window.SESSION.getPref(key, defaultValue);
    }
};

window.cb = function () {
    return window.SESSION.currentBuffer;
};
window.cbc = function () {
    var b = window.cb();
    if (b) {
        return b.connection;
    }
};
window.lcm = function () {
    return window.SESSIONVIEW.lastClickedMessage;
};
window.cbv = function () {
    return window.SESSIONVIEW.mainArea.current;
};

window.ct = function () {
    return window.SESSIONVIEW.mainArea.currentThread.model;
};
window.ctv = function () {
    return window.SESSIONVIEW.mainArea.currentThread;
};


/***/ }),

/***/ "Mkrm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.render = render;
var FileWrapper = __webpack_require__("JHsc");
var Message = __webpack_require__("j9Sh");
var urlUtil = __webpack_require__("Dn1P");

__webpack_require__("bqqG");

// Bind `this` to a formatter instance when using this module

function render(message, fallback) {
    var _this = this;

    var attachmentParts = message.getAttachmentsJson().map(function (attach) {
        return renderOne.call(_this, attach, message, fallback);
    });
    return attachmentParts.join('');
}

function limitText(text, limit) {
    var parts = text.split(' ');
    var result = '';
    var i = 0;
    while (parts.length && result.length < limit) {
        if (i > 0) {
            result += ' ';
        }
        result += parts.shift();
        i++;
    }
    return result;
}

function renderOne(attach, message, fallback) {
    var _this2 = this;

    var urlToParse = attach.from_url || attach.title_link;
    var suppressImage = false;
    var isSlackAttachment = message.buffer.connection.isSlackOAuth() && attach.service_name == 'Slack';
    if (!message.isAttachmentFallback() && !isSlackAttachment) {
        if (urlToParse) {
            var urlParsed = this.linker.renderUrl(urlToParse, { embeds: true });
            if (urlParsed) {
                switch (urlParsed.className) {
                    case 'image':
                    case 'instagram':
                    case 'imgur':
                    case 'xkcd':
                    case 'wiki':
                    case 'kickstarter video':
                    case 'pastebincom':
                    case 'video':
                    case 'flickr':
                        suppressImage = true;
                        break;
                    case 'mastodon':
                    case 'reddit':
                    case 'bsky':
                        return;
                }
            }
        }
    }
    var attachment = '';
    var hasContent = false;
    if (message.isAttachmentFallback() && fallback) {
        attachment += '<span class="attachFallback">';
        attachment += fallback;
        attachment += '</span>';
    }
    var className = 'attachWrap';
    if (isSlackAttachment) {
        className += ' attachWrap--slack';
    } else {
        className += ' attachWrap--external';
    }
    var hasSnippet = false;
    if (_.isString(attach.snippet_preview) && attach.snippet_preview.length) {
        hasSnippet = true;
        className += ' attachWrap--snippet';
    }
    attachment += '<span class="' + className + '">';

    if (attach.pretext) {
        hasContent = true;
        attachment += '<span class="attachment__pretext">';
        attachment += this.renderLinkify(attach.pretext, {
            replacements: Message.getCustomEmoji(attach.pretext_emoji)
        });
        attachment += '</span>';
    }

    var attrs = {
        "class": "attachment"
    };
    if (attach.color) {
        attrs.style = 'border-color: #' + this.escapeText(attach.color);
    }
    attachment += '<span' + this.makeAttributes(attrs) + '>';

    attachment += '<a href="" class="attachmentClose" title="Close attachment">close</a>';

    var imageAllowed = isSlackAttachment || message.buffer.inlineImagesAllowed();
    var imageTag = imageAllowed ? 'img' : 'i';
    var sourceImageTag = message.buffer.inlineImagesAllowed() ? 'img' : 'i';

    if (!suppressImage && attach.thumb_url) {
        hasContent = true;
        // 75x75 max
        attachment += '<' + imageTag + this.makeAttributes({ 'class': 'attachment__thumb image loading', src: urlUtil.toHttps(attach.thumb_url) }) + '></' + imageTag + '>';
    }

    if (attach.author_name || attach.author_subname || attach.service_name) {
        hasContent = true;
        attachment += '<span class="attachment__source">';

        var source_icon = attach.author_icon || attach.service_icon;
        if (source_icon) {
            // 16x16
            attachment += '<' + sourceImageTag + this.makeAttributes({
                'class': 'attachment__source_icon image loading',
                src: urlUtil.toHttps(source_icon),
                width: 16,
                height: 16
            }) + '></' + sourceImageTag + '>';
        }

        var source;
        if (attach.service_name && attach.service_icon && !attach.author_icon && !attach.author_subname) {
            attachment += '<span class="attachment__source_name">';
            source = this.escapeText(attach.service_name);
            var source_url = attach.service_url;
            if (source_url) {
                attachment += this.linker.make(source, {
                    href: source_url,
                    target: '_blank',
                    rel: 'noreferrer'
                });
            } else {
                attachment += source;
            }
            attachment += '</span>';
        }

        if (attach.author_name || attach.author_subname) {
            if (source) {
                attachment += ' | ';
            }
            attachment += '<span class="attachment__author">';
            if (attach.service_name == 'Slack message' && attach.author_name) {
                attachment += this.linkNick(attach.author_name);
                if (attach.author_subname && attach.author_subname != attach.author_name) {
                    attachment += '&nbsp;';
                    attachment += '<span class="attachment__author_realname">';
                    attachment += this.renderLinkify(attach.author_subname);
                    attachment += '</span>';
                }
            } else {
                if (attach.author_name) {
                    var author = this.escapeText(attach.author_name);
                    if (attach.author_link) {
                        attachment += this.linker.make(author, {
                            href: attach.author_link,
                            target: '_blank',
                            rel: 'noreferrer'
                        });
                    } else {
                        attachment += author;
                    }
                }
                if (attach.author_subname) {
                    if (attach.author_name) {
                        attachment += ' | ';
                    }
                    var author_sub = this.escapeText(attach.author_subname);
                    if (attach.author_link && !attach.author_name) {
                        attachment += this.linker.make(author_sub, {
                            href: attach.author_link,
                            target: '_blank',
                            rel: 'noreferrer'
                        });
                    } else {
                        attachment += author_sub;
                    }
                }
            }
            attachment += '</span>';
        }
        attachment += '</span>';
    }

    if (_.isString(attach.title) && attach.title.length && (attach.title.toLowerCase() != 'untitled' || attach.file_url || attach.title_link)) {
        hasContent = true;
        var title = this.renderEmoji(this.escapeText(attach.title.trim()));
        attachment += '<span class="attachment__title">';
        if (attach.file_url || attach.title_link) {
            attachment += this.linker.make(title, {
                href: attach.file_url || attach.title_link,
                target: '_blank',
                rel: 'noreferrer'
            });
        } else {
            attachment += title;
        }
        attachment += '</span>';
    }

    if (hasSnippet) {
        hasContent = true;
        attachment += '<span class="attachment__snippet-title">';
        if (_.isString(attach.snippet_type) && attach.snippet_type.length) {
            attachment += this.escapeText(attach.snippet_type.trim()) + ' snippet';
        } else {
            attachment += 'Snippet';
        }
        attachment += '</span>';
        attachment += '<pre' + this.makeAttributes({
            'class': 'attachment__snippet',
            data: {
                name: attach.title,
                filename: attach.snippet_filename,
                url: attach.title_link,
                lines: attach.snippet_lines,
                preview_lines: attach.snippet_preview_lines,
                ts: attach.ts,
                size: attach.snippet_bytes,
                service_url: attach.service_url,
                service_name: attach.service_name,
                raw_url: attach.snippet_raw
            }
        }) + '>';
        attachment += this.escapeText(attach.snippet_preview);
        attachment += '</pre>';
    }

    if (_.isString(attach.text) && attach.text.length) {
        hasContent = true;
        var text = limitText(attach.text, 500);
        attachment += '<div class="attachment__text">';
        attachment += '<div class="attachment__text-snippet">';
        attachment += this.renderLinkify(text, {
            replacements: Message.getCustomEmoji(attach.text_emoji),
            codeSpan: message.buffer.formatCodeSpan(),
            codeBlock: message.buffer.formatCodeBlock(),
            quote: message.buffer.formatQuote()
        });
        attachment += '</div>';
        if (text.length < attach.text.length) {
            attachment += '<a href="" class="attachment__text-toggle attachment__text-more">See more…</a>';
            attachment += '<div class="attachment__text-full">';
            attachment += this.renderLinkify(attach.text, {
                replacements: Message.getCustomEmoji(attach.text_emoji),
                codeSpan: message.buffer.formatCodeSpan(),
                codeBlock: message.buffer.formatCodeBlock(),
                quote: message.buffer.formatQuote()
            });
            attachment += '</div>';
            attachment += '<a href="" class="attachment__text-toggle attachment__text-less">See less…</a>';
        }
        attachment += '</div>';
    }

    if (_.isArray(attach.fields) && attach.fields.length) {
        attachment += '<span class="attachment__fields">';
        attach.fields.forEach(function (field) {
            if (field.title || field.value) {
                hasContent = true;
                var fieldClassNames = 'attachment__field';
                if (field.short) {
                    fieldClassNames += ' attachment__field--short';
                }
                var f = '<span' + _this2.makeAttributes({ 'class': fieldClassNames }) + '>';
                if (field.title) {
                    f += '<h3 class="attachment__field-title">' + _this2.renderEmoji(_this2.escapeText(field.title)) + '</h3>';
                }
                if (field.value) {
                    f += '<div class="attachment__field-value">' + _this2.renderLinkify(field.value, {
                        replacements: Message.getCustomEmoji(field.emoji)
                    }) + '</div>';
                }
                f += '</span>';
                attachment += f;
            }
        });
        attachment += '</span>';
    }

    var hasImage = !suppressImage && !!attach.image_url && !!attach.image_width && !!attach.image_height;

    if (attach.footer || attach.ts || hasImage && attach.image_bytes || attach.file_url && attach.title_link) {
        hasContent = true;
        attachment += '<span class="attachment__footer">';
        if (attach.footer_icon) {
            // 16x16
            attachment += '<' + sourceImageTag + this.makeAttributes({
                'class': 'attachment__footer_icon image loading',
                src: urlUtil.toHttps(attach.footer_icon),
                width: 16,
                height: 16
            }) + '></' + sourceImageTag + '>';
        }
        if (attach.footer) {
            attachment += '<span class="attachment__footer_label">';
            attachment += this.renderLinkify(attach.footer);
            attachment += '</span> ';
        }
        if (attach.ts) {
            var date = new Date(attach.ts * 1000);
            if (date instanceof Date && !isNaN(date.getTime())) {
                if (attach.footer) {
                    attachment += '| ';
                }
                var ts = date.formatFullDate();
                attachment += '<span class="attachment__footer_ts">';
                if (attach.from_url) {
                    attachment += this.linker.make(ts, {
                        href: attach.from_url,
                        target: '_blank',
                        rel: 'noreferrer'
                    });
                } else {
                    attachment += ts;
                }
                attachment += '</span> ';
            }
        }
        if (attach.image_bytes) {
            attachment += '<span class="attachment__footer_bytes">(';
            attachment += FileWrapper.sizeToString(attach.image_bytes);
            attachment += ')</span> ';
        }
        if (attach.file_url && attach.title_link) {
            attachment += '<span class="attachment__footer_file">';
            attachment += this.linker.make("source", {
                href: attach.title_link,
                target: '_blank',
                rel: 'noreferrer'
            });
            attachment += '</span>';
        }
        attachment += '</span>';
    }

    if (hasImage) {
        hasContent = true;
        // 400x500 max
        var image = '<' + imageTag + this.makeAttributes({
            'class': 'attachment__image_img image loading',
            src: urlUtil.toHttps(attach.image_url),
            width: attach.image_width,
            height: attach.image_height
        }) + '></' + imageTag + '>';
        attachment += '<span class="attachment__image">';
        attachment += this.linker.make(image, {
            'class': 'attachment__image_link',
            href: attach.file_url || attach.image_url,
            target: '_blank',
            rel: 'noreferrer'
        });
        attachment += '</span>';
    }

    attachment += '</span>';
    attachment += '</span>';

    if (hasContent) {
        return attachment;
    }
}

/***/ }),

/***/ "N7yu":
/***/ (function(module, exports, __webpack_require__) {

var Org = __webpack_require__("5gbS");


var OrgList = Backbone.Collection.extend({
    model: Org,
    initialize: function (models, options) {
        
    },
    comparator: function (message) {
        return message.get('creation_time');
    }
});


module.exports = OrgList;


/***/ }),

/***/ "Nbol":
/***/ (function(module, exports, __webpack_require__) {

var HashDialogView = __webpack_require__("o6PP");
var FileView = __webpack_require__("6AFE");

var FilesDialogView = HashDialogView.extend({
    modelViews: {},
    el: '#filesOverlayContents',
    wrapper: $('#filesContainer'),
    list: $('#filesList'),
    urlRoot: 'files',
    collectionKey: 'files',
    modelView: FileView,
    initialize: function (options) {
        HashDialogView.prototype.initialize.call(this, options);
        
        this.collection = this.model[this.collectionKey];
        this.router.route('?/' + this.urlRoot, 'show', _.bind(this.show, this));
        this.router.route('?/' + this.urlRoot + '=:page', 'show', _.bind(this.show, this));
        this.collection.bind('add', this.addModel, this);
        this.collection.bind('remove', this.removeModel, this);
    },
    show: function (page) {
        this.$('.loadingProgress').hide();
        this.$('.loadingError').hide();
        this.fetch(page);
        HashDialogView.prototype.show.call(this);
    },
    renderPage: function (page, label, thisPage, loadingPage) {
        var li = $('<li>');
        if (page) {
            li.addClass('enabled');
            if (page === thisPage) {
                li.addClass('active');
            }
            if (page === loadingPage) {
                li.addClass('loading');
            }
        }
        var link = $('<a>').text(label).attr('href', '/?/' + this.urlRoot + '=' + (page || thisPage));
        li.append(link);
        return li;
    },
    pageRange: function (pages, thisPage) {
        var range;
        if (pages < 13) {
            range = _.range(1, pages+1);
        } else {
            var head = [1,2,3];
            var gap = [null];
            var tail = _.range(pages-2, pages+1);
            if ((thisPage + 1) > (pages - 5)) {
                range = head
                    .concat(gap)
                    .concat(_.range(Math.min(thisPage-1, pages-2), pages+1));
            } else if ((thisPage - 1) < 5) {
                range = _.range(1, Math.max(thisPage+2, 4))
                    .concat(gap)
                    .concat(tail);
            } else {
                range = head
                    .concat(gap)
                    .concat(_.range(thisPage-1, thisPage+2))
                    .concat(gap)
                    .concat(tail);
            }
        }
        return range;
    },
    renderPagination: function (pages, loadingPage) {
        var pagination = this.$('ul.pagination');
        pagination.empty();
        if (pages > 1) {
            var thisPage = this.collection.page;
            var nextPrevPage = loadingPage || thisPage;
            var prev = this.renderPage((nextPrevPage>1) ? nextPrevPage-1 : 0, '«', nextPrevPage);
            pagination.append(prev);

            var range = this.pageRange(pages, thisPage);
            _.each(range, function (page, i) {
                var li = this.renderPage(page, page || '…', thisPage, loadingPage);
                if (i < range.length-1 && !range[i+1]) {
                    li.addClass('right');
                } else if (i && !range[i-1]) {
                    li.addClass('left');
                }
                pagination.append(li);
            }, this);

            var next = this.renderPage((nextPrevPage<pages) ? nextPrevPage+1 : 0, '»', nextPrevPage);
            pagination.append(next);
        }
        pagination.each(function () {
            $(this).find('.enabled').first().addClass('left');
            $(this).find('.enabled').last().addClass('right');
        });
    },
    afterHide: function () {
        if (this.fetchPromise) {
            this.fetchPromise.reject();
            this.fetchPromise = null;
        }
    },
    fetch: function (page) {
        this.$el.addClass('loading');
        var pages = this.collection.getPages();
        this.renderPagination(pages, (page-0||1));
        if (this.fetchPromise) {
            this.fetchPromise.reject();
        }
        this.fetchPromise = this.collection.fetch(page);
        this.fetchPromise.done(_.bind(function () {
            pages = this.collection.getPages();
            if (!page && pages > 1) {
                this.router.navigate('?/' + this.urlRoot + '=1', {replace: true});
            }
            this.renderPagination(pages);
        }, this)).progress(_.bind(function (response, failInfo) {
            var loadingProgress = this.$('.loadingProgress');
            loadingProgress.show();
            var failInfoSpan = loadingProgress.find('.failInfo');
            if (failInfo.failCount > 1) {
                failInfoSpan.text(' (' + failInfo.failCount + ' attempts)');
            }
        }, this)).fail(_.bind(function (response, failInfo) {
            this.$('.loadingError').show();
        }, this)).always(_.bind(function () {
            this.fetchPromise = null;
            this.$('.loadingProgress').hide();
            this.$el.removeClass('loading');
        }, this));
    },
    renderView: function (view) {
        return view.render();
    },
    addModel: function (model) {
        var view = new this.modelView({model: model});
        // Insert at correct position
        var existing = this.list.children();
        var index = this.collection.indexOf(model);
        var el = this.renderView(view).el;
        if (index == existing.length) {
            this.list.append(el);
        } else {
            existing.eq(index).before(el);
        }
        this.modelViews[model.id] = view;
    },
    removeModel: function (model) {
        var view = this.modelViews[model.id];
        view.remove();
        delete this.modelViews[model.id];
    }
});


module.exports = FilesDialogView;


/***/ }),

/***/ "O/fm":
/***/ (function(module, exports, __webpack_require__) {

var StreamHandler = __webpack_require__("oPQz");
var util = __webpack_require__("GmLC");


var SocketStreamHandler = function (host, ssl) {
    StreamHandler.call(this);
    if (ssl === undefined) {
        ssl = (window.location.protocol === 'https:');
    }
    this.protocol = ssl ? 'wss' : 'ws';
    this.setHost(host);
    this.socket = null;
    if (window.CHROME_EXTENSION_VERSION) {
        this.setQueryParam('chrome-ext', window.CHROME_EXTENSION_VERSION);
    }
    debug.log('WebSocket', 'construct', this.protocol);
};
SocketStreamHandler.CONNECTING = 0;
SocketStreamHandler.OPEN = 1;
SocketStreamHandler.CLOSING = 2;
SocketStreamHandler.CLOSED = 3;
SocketStreamHandler.socketID = 0;
SocketStreamHandler.prototype = util.inherit(StreamHandler, {
    setHost: function (host) {
        this.host = host;
    },
    getHandler: function () {
        return this.socket;
    },
    isOpen: function () {
        return this._getReadyState() == SocketStreamHandler.OPEN;
    },
    isConnecting: function () {
        return this._getReadyState() == SocketStreamHandler.CONNECTING;
    },
    isSocket: function () {
        return !!this.socket;
    },
    isClosing: function () {
        return this._getReadyState() == SocketStreamHandler.CLOSING;
    },
    connect: function () {
        var self = this;
        var host = this._getHost();
        debug.log('Websocket', 'connect');
        try {
            // Open WebSocket
            this.socket = new WebSocket(host);
            this.socket.socketID = ++SocketStreamHandler.socketID;
            debug.log('Websocket', 'created', this.socket, this.socket.socketID);
            var openTimeout = setTimeout(_.bind(function () {
                debug.group('stream timeout');
                debug.warn('WebSocket', 'timeout', this.socket, this.socket.socketID, '(readystate: ' + this.socket.readyState + ')');
                this.error();
                debug.groupEnd();
            }, this), 10000);
            this.socket.onopen = function socketOnOpen (event) {
                debug.log('WebSocket', 'open', this, this.socketID, event);
                self.trigger('connected');
                if (openTimeout) {
                    clearTimeout(openTimeout);
                    openTimeout = null;
                }
            };
            this.socket.onmessage = function socketOnMessage (event) {
                if (this !== self.socket) {
                    debug.warn('WebSocket', 'received onmessage for stale socket', this, this.socketID, event);
                    return;
                }
                self.reset();
                if (event.data) {
                    var message;
                    try {
                        message = self.parseJsonMessage(event.data);
                    } catch (exc) {
                        debug.warn('WebSocket', 'parse', exc, event.data, event);
                        message = {
                            error: true,
                            message: 'invalid json',
                            json: event.data
                        };
                    }
                    self.onMessage(message);
                }
            };
            this.socket.onclose = function socketOnClose (event) {
                debug.group('stream close');
                debug.log('WebSocket onclose', this, this.socketID, '(aborted: ' + this.aborted + ' / clean: ' + event.wasClean + ')', event);
                if (openTimeout) {
                    clearTimeout(openTimeout);
                    openTimeout = null;
                }
                if (this !== self.socket) {
                    // This can happen if we manually stopped the socket
                    debug.warn('WebSocket', 'received onclose for stale socket', this.socketID);
                } else {
                    if (!this.aborted) {
                        self.onError();
                    }
                    self.socket = null;
                    self.onDisconnect();
                }
                debug.groupEnd();
            };
            this.socket.onerror = function socketOnError (event) {
                debug.group('stream error');
                debug.warn('WebSocket', 'onerror', this, this.socketID, '(readystate: ' + this.readyState + ')', event, event.wasClean);
                if (openTimeout) {
                    clearTimeout(openTimeout);
                    openTimeout = null;
                }
                debug.groupEnd();
            };
        } catch (exc) {
            debug.group('stream connection error');
            debug.error('WebSocket failed', exc.message, exc.fileName + ' [line '+exc.lineNumber+']');
            this.onConnectionError();
            debug.groupEnd();
        }
    },
    close: function (error) {
        if (!this.isSocket()) {
            debug.warn('No websocket to close');
            this.onDisconnect();
            return;
        }
        if (this.isClosing()) {
            debug.warn('Websocket already closing', this.socket, this.socket.socketID);
            return;
        }
        debug.log('WebSocket', 'close', this.socket, this.socket.socketID, '(readystate: ' + this._getReadyState() + ')');
        if (!error) {
            this.socket.aborted = true;
        }

        this.socket.close();

        // This happens in onclose handler too, but sometimes there's a delay before that, so don't wait
        if (error) {
            this.onError();
        }
        this.socket = null;
        this.onDisconnect();
    },
    socketError: function (warning, type, data) {
        var error = {
            success: false,
            error: 'websocket',
            websocket_error: type,
            message: 'Offline'
        };
        if (data._reqid) {
            error._reqid = data._reqid;
            debug.warn('<- [' + data._reqid + ' SOCK ERROR: ' + type + ']', warning, data);
        } else {
            debug.warn('socket error', type, warning, data);
        }
        this.trigger('socketError', error);
        return;
    },
    send: function (data) {
        var text = JSON.stringify(data);
        var logLine = '-> [';
        if (data._reqid) {
            logLine += data._reqid + ' ';
        }
        logLine += 'SOCK';
        if (data._method) {
            logLine += ' ' + data._method;
        }
        logLine += ']';
        debug.log(logLine, text);
        if (!this.isSocket()) {
            return this.socketError('No websocket to send to', 'no_socket', data);
        }
        if (!this.isOpen()) {
            return this.socketError('Trying to send to a closed Websocket', 'socket_closed', data);
        }
        this.socket.send(text);
    },
    _getHost: function () {
        var host = this.protocol + '://' + this.host;
        return host + this.getQueryString();
    },
    _getUrl: function () {
        if (this.socket) {
            return this.socket.url;
        }
    },
    _getProtocol: function () {
        if (this.socket) {
            return this.socket.protocol;
        }
    },
    _getReadyState: function () {
        if (this.socket) {
            return this.socket.readyState;
        }
    },
    _getBufferedAmount: function () {
        if (this.socket) {
            return this.socket.bufferedAmount;
        }
    }
});


module.exports = SocketStreamHandler;


/***/ }),

/***/ "O4T4":
/***/ (function(module, exports, __webpack_require__) {

var User = __webpack_require__("Xgjh");


var UserChannelMode = Backbone.Model.extend({
    initialize: function (data, options) {
        this.buffer = options.buffer;
        this.connection = this.buffer.connection;
        this.user = options.user || this.makeUser(options);
    },
    makeUser: function (options) {
        var target = {};
        if (this.get('type') == 'channel_mode_list_change') {
            var opList = this.get('ops').add.length ? this.get('ops').add : this.get('ops').remove;
            if (opList.length) {
                target = {
                    nick: opList[0].nick || opList[0].param,
                    hostmask: opList[0].hostmask,
                    ident_prefix: opList[0].ident_prefix,
                    from_name: opList[0].from_name,
                    from_host: opList[0].from_host,
                    from_mode: opList[0].from_mode,
                    from_account: opList[0].from_account,
                    from_realname: opList[0].from_realname,
                    avatar: opList[0].avatar,
                    avatar_url: opList[0].avatar_url,
                    display_name: opList[0].display_name,
                    bot_url: opList[0].bot_url
                };
            }
        } else {
            target = {
                nick: this.get('nick') || this.get('newnick'),
                hostmask: this.get('target_hostmask'),
                ident_prefix: this.get('target_ident_prefix'),
                from_name: this.get('target_name'),
                from_host: this.get('target_host'),
                from_mode: this.get('newmode'),
                from_account: this.get('target_account'),
                from_realname: this.get('target_realname'),
                avatar: this.get('target_avatar'),
                avatar_url: this.get('target_avatar_url'),
                display_name: this.get('target_display_name'),
                bot_url: this.get('target_bot_url')
            };
        }
        return this.connection.makeUserFromTarget(
            this.buffer.bid(),
            target
        );
    },
    getAdded: function () {
        var added = {};
        if (this.get('ops') && this.get('ops').add) {
            _.each(this.get('ops').add, function (add, i) {
                added[add.mode] = add.param;
            });
        }
        return added;
    },
    getRemoved: function () {
        var removed = {};
        if (this.get('ops') && this.get('ops').remove) {
            _.each(this.get('ops').remove, function (remove, i) {
                removed[remove.mode] = remove.param;
            });
        }
        return removed;
    },
    hasAdded: function (mode) {
        return mode in this.getAdded();
    },
    hasRemoved: function (mode) {
        return mode in this.getRemoved();
    },
    getCategory: function () {
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hasRemoved(this.connection.getUserModes()[cat]) ||
                     this.hasAdded(this.connection.getUserModes()[cat]);
        }, this) || 'MEMBER';
    },
    getAddedCategory: function () {
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hasAdded(this.connection.getUserModes()[cat]);
        }, this);
    },
    getAddedAction: function () {
        var category = this.getAddedCategory();
        if (category) {
            return UserChannelMode.addedActions[category];
        }
    },
    getRemovedCategory: function () {
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hasRemoved(this.connection.getUserModes()[cat]);
        }, this);
    },
    getRemovedAction: function () {
        var category = this.getRemovedCategory();
        if (category) {
            return UserChannelMode.removedActions[category];
        }
    },
    getAction: function () {
        return this.getRemovedAction() || this.getAddedAction();
    },
    isSuperior: function (ucm) {
        return this.connection.getUserModeHierarchy().indexOf(ucm.getCategory()) >
               this.connection.getUserModeHierarchy().indexOf(this.getCategory());
    }
}, {
    getActions: function (modes) {
        return _.unique(_.map(modes, function (m) {
            return m.getAction() || m.get('diff');
        }).reverse()).reverse().join(', ');
    },
    addedActions: {
        'OPER': 'promoted to oper',
        'OWNER': 'promoted to owner',
        'ADMIN': 'promoted to admin',
        'OP': 'opped',
        'HALFOP': 'halfopped',
        'VOICED': 'voiced'
    },
    removedActions: {
        'OPER': 'demoted from oper',
        'OWNER': 'demoted from owner',
        'ADMIN': 'demoted from admin',
        'OP': 'de-opped',
        'HALFOP': 'de-halfopped',
        'VOICED': 'de-voiced'
    }
});



module.exports = UserChannelMode;


/***/ }),

/***/ "OC/i":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var Formatter = __webpack_require__("5gSh");
var RenderReasons = __webpack_require__("ilaq");
var IRCFormatter = __webpack_require__("XiBv");

var ConnectionStatusView = Backbone.View.extend({
    tagName: 'div',
    className: 'connectionStatus',
    initialize: function (options) {
        this.visible = false;
        this.formatter = new BufferFormatter(this.model);
        
        this.model.bind('remove', this.remove, this);
    },
    events: {
        'click a.edit': 'clickEdit',
        'click a.back': 'clickBack',
        'click a.reconnect': 'clickReconnect',
        'click a.disconnect': 'clickDisconnect'
    },
    clickEdit: function (e) {
        e.preventDefault();
        this.model.connection.select();
        this.model.connection.trigger('showEdit');
    },
    clickBack: function (e) {
        e.preventDefault();
        this.model.connection.back();
    },
    clickReconnect: function (e) {
        e.preventDefault();
        this.model.connection.reconnect();
    },
    clickDisconnect: function (e) {
        e.preventDefault();
        this.model.connection.disconnect();
    },
    retryingText: function () {
        var timeout = this.model.connection.getRetryTimeout();
        var text = '';
        if (timeout) {
            if (this.model.connection.willRetry()) {
                text = 'Reconnecting ' + $.timeago(timeout, Formatter.PRECISION_STRINGS);
                var times = this.model.connection.getFailInfo('attempts');
                if (times > 1) {
                    var suffix = ["th", "st", "nd", "rd"];
                    var mod = times % 100;
                    var ordinal = times + (suffix[(mod-20)%10] || suffix[mod] || suffix[0]);
                    text += ' (' + this.formatter.escapeText(ordinal) + ' attempt)';
                }
            } else {
                text = 'Reconnecting…';
            }
        }
        return text;
    },
    render: function () {
        var status = this.model.connection.getStatus();
        if (this.retryHandle && status != 'waiting_to_retry') {
            this.clearRetryHandle();
        }
        
        var text = '';
        switch (status) {
        case 'waiting_to_retry':
            if (this.model.connection.getFailInfo('reason') == 'reconnecting') {
                text += 'Reconnecting…';
            } else {
                text += this.retryingText();

                this.clearRetryHandle();
                this.retryHandle = setInterval(_.bind(function () {
                    var retrying = this.retryingText();
                    this.renderText(retrying);
                    if (!retrying) {
                        this.clearRetryHandle();
                    }
                }, this), 1000);
            }
            break;
        case 'queued':
            text += 'Connection queued; waiting our turn…';
            break;
        case 'connecting':
            text += 'Connecting to ' + this.formatter.escapeText(this.model.connection.get('hostname')) + '…';
            break;
        case 'connected':
            text += 'Connected; handshaking…';
            break;
        case 'connected_joining':
            text += 'Connected; setting up…';
            break;
        case 'quitting':
            text += 'Quitting…';
            break;
        case 'ip_retry':
            var error = this.model.connection.getFailInfo('error');
            var ip = this.model.connection.getFailInfo('ip');
            text += 'Connecting';
            if (ip) {
                text += ' to ' + this.formatter.escapeText(ip);
            }
            text += ' failed';
            if (error) {
                text += ' (' + this.formatter.escapeText(error) + ')';
            } else {
                text += ',';
            }
            text += ' resolving a new IP…';
            break;
        case 'disconnected':
            if (!this.model.connection.isFailed()) {
                text += 'Disconnected';
            }
            break;
        case 'connected_ready':
            if (this.model.connection.focusOnMakeBuffer == '*') {
                text += 'Connected; waiting to join…';
            } else if (this.model.connection.focusOnMakeBuffer && this.formatter.linker.isChannelName(this.model.connection.focusOnMakeBuffer)) {
                text += 'Connected; waiting to join ' + this.formatter.escapeText(this.model.connection.focusOnMakeBuffer) + '…';
            }
            break;
        }
        return this.renderText(text);
    },
    isVisible: function () {
        return this.visible;
    },
    show: function () {
        if (!this.isVisible()) {
            $(this.el).addClass(this.className + '--show');
            this.visible = true;
        }
        return this;
    },
    hide: function () {
        if (this.isVisible()) {
            $(this.el).removeClass(this.className + '--show');
            this.visible = false;
        }
        return this;
    },
    renderText: function (status) {
        var html = '';
        var htmlLink;
        var failure = this.model.connection.isFailed();
        var restricted;
        $(this.el).removeClass().addClass(this.className).toggleClass(this.className + '--show', this.isVisible());
        if (failure) {
            $(this.el).addClass('fail');
            var failInfo = this.model.connection.getFailInfo();
            if (failInfo.type == 'connecting_restricted') {
                html += RenderReasons.renderRestricted(failInfo.reason);
                restricted = true;
            }
            if (!restricted && !this.model.connection.badRetry()) {
                html += 'Disconnected';
            }
            if (failInfo.type == 'connection_blocked') {
                html += ' - Connections to this server have been blocked';
            }
            if (failInfo.type == 'killed') {
                html += ' - Killed';
                if (failInfo.reason && failInfo.reason != '()') {
                    html += ': ' + this.formatter.escapeText(IRCFormatter.strip(failInfo.reason));
                }
            } else if (failInfo.reason && !restricted) {
                if (!this.model.connection.badRetry()) {
                    html += ': ';
                }
                if (failInfo.reason == 'ssl_verify_error') {
                    html = '<i class="fa fa-warning"></i> ' + html;
                    html += 'Strict transport security error';
                    var verifyError = RenderReasons.renderSSLVerify(failInfo.ssl_verify_error);
                    if (verifyError) {
                        html += ': ' + verifyError;
                    }
                } else {
                    if (failInfo.type == 'connecting_failed') {
                        html += 'Failed to connect - ';
                    }
                    html += this.formatter.escapeText(IRCFormatter.strip(RenderReasons.render(failInfo.reason)));
                    if (this.model.connection.badRetry()) {
                        html += '; ';
                    }
                }
            }
            if ((failInfo.type == 'connecting_failed' || failInfo.type == 'socket_closed') && !this.model.connection.badRetry()) {
                var failedHtml = '';
                var htmlLinkClass = 'edit';
                var htmlLinkText = 'Check your host, port and ssl settings';
                var htmlLinkHref = '';
                var htmlLinkExtra = '';
                if (this.model.connection.isSlackUpgradable()) {
                    failedHtml += '<b>This Slack IRC gateway is closing down, but you can upgrade to a new integration</b> ';
                    htmlLinkClass = 'upgradeSlack';
                    htmlLinkText = 'Read the announcement and upgrade instructions';
                    htmlLinkHref = 'https://blog.irccloud.com/slack-integration/';
                    htmlLinkExtra = ' target="_blank"';
                } else if (this.model.connection.isSuspiciousPort()) {
                    failedHtml += '<b>You’re trying to connect ';
                    failedHtml += this.model.connection.isSSL() ? 'via' : 'without';
                    failedHtml += ' SSL on port ' + this.model.connection.getPort() + '.</b> ';
                }
                if (!this.model.connection.isTeamServer() && this.model.connection.isSuspiciousHostname()) {
                    failedHtml += '<b>Your hostname looks invalid: ' + this.formatter.escapeText(this.model.connection.get('hostname')) + '</b> ';
                }
                htmlLink = {
                    className: htmlLinkClass,
                    text: htmlLinkText,
                    href: htmlLinkHref,
                    extra: htmlLinkExtra
                };
                htmlLink.html = '<a href="' + htmlLinkHref + '" class="' + htmlLink.className + '"'
                    + htmlLink.extra + '>' + htmlLink.text + '</a>';
                if (!failedHtml) {
                    htmlLink.html = ' (' + htmlLink.html + ')';
                    html += htmlLink.html;
                } else {
                    failedHtml += htmlLink.html;
                    html += ' (' + failedHtml + ')';
                }
            }
            if (!this.model.connection.badRetry() && (status || failInfo.give_up)) {
                html += '; ';
            }
            if (failInfo.give_up) {
                html += 'Gave up retrying';
                if (status) {
                    html += '; ';
                }
            }
        }
        var away = this.model.connection.get('away');
        if (this.model.connection.isConnected() && away) {
            $(this.el).addClass('away');
            var text = 'Away';
            if (away !== true && away.toLowerCase() != 'away') {
                text += ' (' + away + ')';
            }
            html += '<a href="#" class="back"><span class="back">Click to come back (or type /back)</span> ' + this.formatter.render(text);
            if (status) {
                html += ' (' + status + ')';
            }
            html += '</a>';
        } else {
            if (this.model.connection.isDisconnected()) {
                var currentHTML = html;
                if (htmlLink) {
                    $(this.el).addClass(htmlLink.className);
                    html = '<a href="' + htmlLink.href + '" class="' + htmlLink.className + '"'
                        + htmlLink.extra + '>' + '<span class="' + htmlLink.className + '">' +
                        htmlLink.text + '</span> ';
                } else if (this.model.connection.badRetry()) {
                    $(this.el).addClass('disconnect');
                    html = '<a href="/" class="disconnect"><span class="disconnect">Click to disconnect (or type /disconnect)</span> ';
                } else if (restricted) {
                    $(this.el).addClass('upgrade');
                    html = '<a href="/?/upgrade" class="upgrade"><span class="upgrade">Click to see upgrade options</span> ';
                } else {
                    $(this.el).addClass('reconnect');
                    html = '<a href="/" class="reconnect"><span class="reconnect">Click to reconnect (or type /reconnect)</span> ';
                }
                if (currentHTML) {
                    if (htmlLink) {
                        html += currentHTML.replace(htmlLink.html, '');
                    } else {
                        html += currentHTML;
                    }
                }
                if (status) {
                    html += status;
                }
                html += '</a>';
            } else if (status) {
                html += status;
            }
        }

        html = this.chanMembersFailed(html);

        $(this.el).html(html);
        return html ? this.show() : this.hide();
    },
    chanMembersFailed: function (html) {
        var chan_members_failed = this.model.connection.get('chan_members_failed');
        if (chan_members_failed) {
            var suffix = '';
            if (html) {
                suffix = '; ';
            }
            var msg;
            if (chan_members_failed === 'timeout') {
                msg = 'The system is overloaded and functionality may be slow or unavailable.';
            } else {
                msg = 'The system is having problems and some functionality may not be working properly.';
            }
            if (!this.model.session.ent()) {
                msg += ' Check <a href="https://bsky.app/profile/irccloud.com" target="_blank" rel="noreferrer">Bluesky</a> for status updates.';
            }
            html = msg + suffix + html;
            $(this.el).addClass('chan_members_failed');
        }
        return html;
    },
    clearRetryHandle: function () {
        clearInterval(this.retryHandle);
        this.retryHandle = null;
    }
});


module.exports = ConnectionStatusView;


/***/ }),

/***/ "OFe6":
/***/ (function(module, exports, __webpack_require__) {

var BufferListConnectionView = __webpack_require__("Zj5c");
var Keyboard = __webpack_require__("fDhS").default;


var BufferListView = Backbone.View.extend({
    tagName: 'ul',
    className: 'bufferList',
    attributes: {
        'role': 'tablist'
    },
    initialize: function (options, sidebar) {
        this.sidebar = sidebar;
        this.container = $('#buffers');
        this.dragHelperContainer = $('.bufferList--dragHelperContainer');
        this.indicators = $('.sidebarIndicator');
        this.indicatorAbove = $('#sidebarIndicatorAbove');
        this.indicatorBelow = $('#sidebarIndicatorBelow');
        this.tooltip = $('.sidebarIndicatorTooltip');
        this.tooltipVisible = false;
        this.tooltipSummary = $('.sidebarIndicatorTooltip__summary');

        this.initPins();

        _.bindAll(this, 'updateIndicators', 'docKeyDown', 'indicatorClick',
            'indicatorHoverOn', 'indicatorHoverOff', 'indicatorWheel');

        this.indicators.on('click', this.indicatorClick);
        this.indicators.hover(this.indicatorHoverOn, this.indicatorHoverOff);
        this.indicators.on('mousewheel', this.indicatorWheel);

        this.model.bind('doneLoading', this.updateIndicators);
        this.model.bind('prefChange:layout-left', this.updateIndicators, this);
        this.model.bind('change:database_status', this.updateIndicators, this);

        this.model.connections.bind('add', this.renderConnection, this);
        this.model.connections.bind('remove', this.removeConnection, this);
        this.model.connections.bind('reset', this.resetConnections, this);
        this.model.connections.bind('change:status change:fail_info', this.updateIndicators, this);
        this.model.connections.bind('moveTo', this.moveConnectionTo, this);
        this.model.bind('reorderConnections', this.clickReorderNetworks, this);

        $('button#reorderNetworksDone').on('buttonClick', _.bind(this.clickReorderNetworks, this));

        this.connections = {};

        // All connections have been rendered by this point
        this.model.bind('init', this.render, this);

        this.sidebar.$el.scroll(this.updateIndicators);
        $(window).resize(this.updateIndicators);
        $(document).keydown(this.docKeyDown);
    },
    clickReorderNetworks: function (e) {
        e.preventDefault();
        this.sidebar.wrapper.toggleClass('reorder');
    },
    itemToView: function (item) {
        return _.find(this.connections, function (cv, id) {
            return $(item).is(cv.el);
        });
    },
    moveConnectionTo: function (connection, at) {
        var cv = this.connections[connection.id];
        var curIdx = $(cv.el).index();
        if (curIdx === at) {
            return;
        } else {
            var ref = this.$('li.connection').eq(at);
            if (curIdx < at) {
                ref.after(cv.el);
            } else {
                ref.before(cv.el);
            }
        }
    },
    indicatorClick: function (e) {
        e.preventDefault();
        if (e.altKey || e.shiftKey) {
            this.select($(e.target).data('scrollBuffer'));
        } else {
            this.scrollToView($(e.target).data('scrollTarget'));
        }
    },
    indicatorHoverOn: function (e) {
        if ($(e.target).is(this.indicatorBelow)) {
            this.tooltipVisible = 'below';
        } else {
            this.tooltipVisible = 'above';
        }
        this.renderTooltip();
    },
    indicatorHoverOff: function (e) {
        this.tooltipVisible = false;
        this.renderTooltip();
    },
    indicatorWheel: function (e) {
        var currentScroll = this.sidebar.$el.scrollTop();
        var delta = e.originalEvent.wheelDelta;
        var scrollTo = currentScroll - delta;
        this.scrollSidebarTo(scrollTo);
    },
    scrollToView: function (el) {
        var $el = $(el);

        var sidebarTop = this.getSidebarTop();
        var sidebarBottom = sidebarTop + this.getSidebarHeight();

        var elemTop = $el.offset().top;
        var elemBottom = elemTop + $el.height();

        if ((elemBottom >= sidebarBottom) || (elemTop <= sidebarTop)) {
            var to = elemTop + this.sidebar.$el.scrollTop();
            this.scrollSidebarTo(to - 23);
        }
    },
    renderConnectionSortable: function () {
        // http://api.jqueryui.com/sortable/
        var grabPosition = 17;
        this.$el.sortable({
            revert: 100,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            cursorAt: {top: grabPosition},
            distance: 5,
            axis: 'y',
            cursor: 'move',
            opacity: 0.7,
            handle: 'h2.buffer'
        });
        this.$el.on('sortbeforestart', _.bind(function (e, ui) {
            this.sidebar.wrapper.addClass('reorder--jit');
            var scrollTo = this.sidebar.$el.scrollTop() + ui.item.offset().top - e.clientY;
            var maxScrollTop = this.sidebar.el.scrollHeight - this.getSidebarHeight();
            var topAdjustedScrollTo = 0;
            if (scrollTo < 0) {
                topAdjustedScrollTo = -scrollTo;
                this.container.css('margin-top', topAdjustedScrollTo);
                scrollTo = 0;
            } else if (scrollTo > maxScrollTop) {
                topAdjustedScrollTo = -scrollTo;
                this.container.css('margin-bottom', this.getSidebarHeight() + scrollTo - maxScrollTop);
            }
            this.scrollSidebarTo(scrollTo);
            var sidebarRect = this.sidebar.getRect();
            this.dragHelperContainer.css({
                top: sidebarRect.top,
                left: sidebarRect.left,
                width: sidebarRect.width,
                height: sidebarRect.height,
                'margin-top': topAdjustedScrollTo
            }).show();
        }, this));
        this.$el.on('sortstart', _.bind(function (e, ui) {
            ui.helper.appendTo(this.dragHelperContainer);
        }, this));
        this.$el.on('sortstop', _.bind(function (e, ui) {
            this.dragHelperContainer.hide();
            this.sidebar.wrapper.removeClass('reorder--jit');
            this.container.css({
                'margin-top': 0,
                'margin-bottom': 0
            });
            this.scrollToView(ui.item);
            _.each(this.connections, function (cv, cid) {
                cv.model.setOrder(cv.$el.index() + 1);
            });
            this.model.connections.saveOrder();
        }, this));
    },
    renderPinnedSortable: function (el) {
        // http://api.jqueryui.com/sortable/
        el.sortable({
            revert: 100,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            axis: 'y',
            cursor: 'move',
            opacity: 0.7,
            helper: 'clone'
        });
        el.on('sortstop', _.bind(function (e, ui) {
            var order = _.map(this.pinnedBufferList.find('li.buffer'), function (item) {
                return $(item).data('bid');
            });
            this.model.setPinnedOrder(order);
        }, this));
    },
    initPins: function () {
        this.pinnedBuffers = $('<ul class="bufferList pinnedBuffers pinnedBuffers--hidden">');
        var head = $('<h2>').text('Pinned').prepend('<i class="fa fa-thumb-tack">');
        this.pinnedBuffers.append(head);
        this.pinnedBufferList = $('<ul class="pinnedBufferList">');
        this.pinnedBuffers.append(this.pinnedBufferList);
        this.container.append(this.pinnedBuffers);
        this.renderPinnedSortable(this.pinnedBufferList);
    },
    renderPins: function () {
        this.pinnedBuffers.toggleClass('pinnedBuffers--hidden', !this.model.hasPinnedBuffers());
    },
    getFirstPinnedBuffer: function () {
        return this.model.pinnedBuffers.first();
    },
    getLastPinnedBuffer: function () {
        return this.model.pinnedBuffers.last();
    },
    getNextPinnedBuffer: function (buffer) {
        return this.model.pinnedBuffers.next(buffer);
    },
    getPreviousPinnedBuffer: function (buffer) {
        return this.model.pinnedBuffers.previous(buffer);
    },
    render: function () {
        this.container.append(this.el);
        this.renderConnectionSortable();
        this.renderPins();

        this.model.bind('beforeConnectionRemove', this.renderConnectionRemoved, this);
        this.model.connections.bind('beforeBufferRemove', this.renderBufferRemoved, this);
        this.model.buffers.bind('change:archived', this.renderBufferArchived, this);
        this.listenTo(this.model.pinnedBuffers, 'changed', this.renderPins);
        this.model.bind('unseenChange', this.updateIndicators);
        this.model.buffers.bind('unseenHighlightChange', this.updateIndicators);

        return this;
    },
    renderBufferArchived: function (buffer) {
        if (!buffer.isServerLog() && !buffer.wasArchived()) {
            this.renderBufferRemoved(buffer);
            this.updateIndicators();
        }
    },
    renderBufferRemoved: function (buffer) {
        this.updateIndicators();
        if (!buffer.isSelected()) {
            return;
        }
        var options = {replace: true};
        this.model.selectPreviousBuffer(options) || this.selectPreviousOrTopBuffer(buffer, options);
    },
    renderConnectionRemoved: function (connection) {
        this.updateIndicators();
        if (!connection.isSelected()) {
            return;
        }
        var options = {replace: true};
        this.model.selectPreviousBuffer(options) || this.selectConnectionPreviousOrTopBuffer(connection, options);
    },
    resetConnections: function () {
        for (var cid in this.connections) {
            this.connections[cid].remove();
        }
        this.connections = {};
    },
    removeConnection: function (connection) {
        delete this.connections[connection.id];
        this.stopListening(connection, 'init');
    },
    renderConnection: function (connection) {
        var view = new BufferListConnectionView({
            model: connection,
            parent: this
        });
        this.listenTo(connection, 'init', function () {
            var index = this.model.connections.indexOf(connection);
            view.render();
            var existing = this.$el.children();
            if (index == existing.length) {
                this.$el.append(view.el);
            } else {
                existing.eq(index).before(view.el);
            }
        }, this);
        view.bind('scrollTo', this.scrollToView, this);
        view.bind('toggleArchives', this.updateIndicators, this);
        this.connections[connection.id] = view;
    },
    scrollSidebarTo: function (position) {
        this.sidebar.$el.scrollTop(position);
    },

    getNextBuffer: function (buffer, important) {
        if (important === false) {
            return this.getNextBufferFromConnection(buffer) ||
                   this.recurseFirstBuffers(buffer.connection, false);
        }
        return this.getNextBufferFromConnection(buffer, true) || // next important buffer
               this.recurseFirstBuffers(buffer.connection, true) || // forward connections first important buffer
               !important && this.getNextBufferFromConnection(buffer) || // next buffer
               !important && this.recurseFirstBuffers(buffer.connection); // forward connections first buffer
    },
    getPreviousBuffer: function (buffer, important) {
        if (important === false) {
            return this.getPreviousBufferFromConnection(buffer) ||
                   this.recurseLastBuffers(buffer.connection);
        }
        return this.getPreviousBufferFromConnection(buffer, true) || // previous important buffer
               this.recurseLastBuffers(buffer.connection, true) || // back connections last important buffer
               !important && this.getPreviousBufferFromConnection(buffer) || // previous buffer
               !important && this.recurseLastBuffers(buffer.connection); // back connections last buffer
    },
    getFirstBufferForSelection: function () {
        var firstConnection = this.model.connections.first();
        if (firstConnection) {
            var buffer;
            if (firstConnection.isCollapsed()) {
                buffer = this.getNextConnectionFirstBuffer(firstConnection, true);
            }
            buffer = firstConnection.buffers.getFirstBuffer(true) ||
                     this.recurseFirstBuffers(firstConnection, true) ||
                     firstConnection.buffers.getFirstBuffer();
            return buffer;
        }
    },
    getNextConnectionFirstBuffer: function (connection, important) {
        var nextConnection = this.model.connections.next(connection);
        if (nextConnection) {
            if (important && nextConnection.isCollapsed()) {
                return this.getNextConnectionFirstBuffer(nextConnection, true);
            }
            return nextConnection.buffers.getFirstBuffer(true) ||
                   this.recurseFirstBuffers(nextConnection, true) ||
                   !important && nextConnection.buffers.getFirstBuffer() ||
                   !important && nextConnection.serverLog;
        }
    },
    getLastBufferForSelection: function () {
        var lastConnection = this.model.connections.last();
        if (lastConnection) {
            var buffer = lastConnection.buffers.getLastBuffer(true) ||
                         this.recurseLastBuffers(lastConnection, true);
            return buffer;
        }
    },
    importanceCheck: function (important, index) {
        return !important || index > -1;
    },
    getPreviousBufferFromConnection: function (buffer, important) {
        if (buffer.isServerLog()) {
            return null;
        }
        var connection = buffer.connection;
        if (important && connection.isCollapsed()) {
            return null;
        }
        var segment = connection.buffers.findSegment(buffer);

        var result;
        var orders = connection.buffers.getOrder(important);
        var index = _.indexOf(orders, segment);
        // Try to get the previous from the current segment, if it
        // passes the importance check
        if (this.importanceCheck(important, index)) {
            result = segment.previous(buffer);
        }
        if (!result) {
            // Find the index for the previous segment in the list
            index--;
            if (!this.importanceCheck(important, index)) {
                // Failed the importance check so find the nearest preceding one
                var all_orders = connection.buffers.getOrder();
                var all_index = _.indexOf(all_orders, segment);
                while (all_index > -1 && index < 0) {
                    index = _.indexOf(orders, all_orders[--all_index]);
                }
            }
            // Try to get the last of each preceding segment
            while (index > -1 && !result) {
                result = orders[index].last();
                index--;
            }
        }
        if (!important && !result) {
            return connection.serverLog;
        }
        return result;
    },
    getNextBufferFromConnection: function (buffer, important) {
        var connection = buffer.connection;
        if (important && connection.isCollapsed()) {
            return null;
        }
        var segment = connection.buffers.findSegment(buffer);

        var result;
        var orders = connection.buffers.getOrder(important);
        var index = _.indexOf(orders, segment);
        if (segment && this.importanceCheck(important, index)) {
            // Try to get the next from the current segment, if it
            // passes the importance check
            result = segment.next(buffer);
        }
        if (!result) {
            // Find the index for the next segment in the list
            if (segment) {
                index++;
                if (!this.importanceCheck(important, index)) {
                    // Failed the importance check so find the nearest subsequent one
                    var all_orders = connection.buffers.getOrder();
                    var all_index = _.indexOf(all_orders, segment);
                    while (all_index < all_orders.length && index < 0) {
                        index = _.indexOf(orders, all_orders[++all_index]);
                    }
                }
            } else {
                // No segment, use first (e.g. server log)
                index = 0;
            }
            // Try to get the first of each subsequent segment
            while (index < orders.length && !result) {
                result = orders[index++].first();
            }
        }
        return result;
    },
    recurseFirstBuffers: function (connection, important) {
        var nextConnection = this.model.connections.next(connection);
        var buffer;
        while (nextConnection && !buffer) {
            if (important === false) {
                buffer = nextConnection.serverLog;
            } else {
                if (!important || !nextConnection.isCollapsed()) {
                    buffer = nextConnection.buffers.getFirstBuffer(true) ||
                             !important && nextConnection.buffers.getFirstBuffer() ||
                             !important && nextConnection.serverLog;
                }
                nextConnection = this.model.connections.next(nextConnection);
            }
        }
        return buffer;
    },
    recurseLastBuffers: function (connection, important) {
        var previousConnection = this.model.connections.previous(connection);
        var buffer;
        while (previousConnection && !buffer) {
            if (important === false) {
                buffer = previousConnection.buffers.getLastBuffer() ||
                         previousConnection.serverLog;
            } else {
                if (!important || !previousConnection.isCollapsed()) {
                    buffer = previousConnection.buffers.getLastBuffer(true) ||
                             !important && previousConnection.buffers.getLastBuffer() ||
                             !important && previousConnection.serverLog;
                }
            }
            previousConnection = this.model.connections.previous(previousConnection);
        }
        return buffer;
    },

    docKeyDown: function (e) {
        // Keyboard shortcuts
        if (e.altKey) { // holding alt
            switch (e.which) {
            case Keyboard.KEYS.UP:
                if (e.shiftKey) {
                    this.selectPreviousUnreadBuffer();
                } else {
                    this.selectPreviousBuffer();
                }
                return false;
            case Keyboard.KEYS.DOWN:
                if (e.shiftKey) {
                    this.selectNextUnreadBuffer();
                } else {
                    this.selectNextBuffer();
                }
                return false;
            }
        }
        return true;
    },
    updateIndicators: function () {
        var sidebarRect = this.sidebar.getRect();
        this.indicatorBelow.css('top', sidebarRect.bottom - this.indicatorBelow.height() - 1);

        var initCss = {
            width: sidebarRect.width,
            left: sidebarRect.left
        };
        var tooltipCss = {};
        var tooltipHPad = 5;
        initCss.left = sidebarRect.left;
        if (this.model.getPref('layout-left')) {
            tooltipCss.left = initCss.width + tooltipHPad;
        } else {
            tooltipHPad += 2;
            tooltipCss.left = initCss.left - this.tooltip.outerWidth(true) - tooltipHPad;
        }

        this.indicators
            .css(initCss)
            .removeClass('sidebarIndicatorUnread')
            .removeClass('sidebarIndicatorBadged')
            .removeClass('sidebarIndicatorFailed')
            .removeData('scrollTarget')
            .removeData('scrollBuffer');
        this.tooltip.css(tooltipCss);
        if (!this.model.isInitialized()) {
            return;
        }
        var sidebarHeight = this.getSidebarHeight();
        var sidebarTop = this.getSidebarTop();
        this.tooltipData = this.tooltipInit();
        _.each(this.connections, function (connectionView, cid) {
            var connection = this.model.getConnection(cid);
            if (connection && connection.isFailed()) {
                var serverLog = connection.serverLog;
                var top = connectionView.$el.offset().top - sidebarTop;
                var bottom = top + connectionView.$el.height();
                if (bottom < 5) {
                    this.tooltipData.above.failed++;
                    this.indicatorAbove.addClass('sidebarIndicatorFailed');
                    this.indicatorAbove.data('scrollTarget', connectionView.$el);
                    this.indicatorAbove.data('scrollBuffer', serverLog);
                }
                if (top + 5 > sidebarHeight) {
                    this.tooltipData.below.failed++;
                    this.indicatorBelow.addClass('sidebarIndicatorFailed');
                    this.indicatorBelow.data('scrollTarget', connectionView.$el);
                    this.indicatorBelow.data('scrollBuffer', serverLog);
                }
            }
        }, this);
        this.model.unseenBuffers.each(_.bind(function (buffer) {
            var bufferView;
            if (buffer.connection.isCollapsed()) {
                bufferView = this.connections[buffer.getCid()].buffers[buffer.connection.serverLog.bid()];
            } else {
                bufferView = this.connections[buffer.getCid()].buffers[buffer.bid()];
            }
            var bufferEl = bufferView.$el;
            if (bufferEl.is(':visible')) {
                var top = bufferEl.offset().top - sidebarTop;
                var bottom = top + bufferEl.height();
                if (bottom < 5) {
                    this.tooltipData.above.buffers++;
                    this.indicatorAbove.addClass('sidebarIndicatorUnread');
                    if (buffer.hasUnseenHighlights()) {
                        this.indicatorAbove.addClass('sidebarIndicatorBadged');
                        this.tooltipData.above.highlights += buffer.unseenHighlightCount();
                    }
                    this.indicatorAbove.data('scrollTarget', bufferEl);
                    this.indicatorAbove.data('scrollBuffer', buffer);
                }
                if (top + 5 > sidebarHeight) {
                    this.tooltipData.below.buffers++;
                    this.indicatorBelow.addClass('sidebarIndicatorUnread');
                    if (buffer.hasUnseenHighlights()) {
                        this.indicatorBelow.addClass('sidebarIndicatorBadged');
                        this.tooltipData.below.highlights += buffer.unseenHighlightCount();
                    }
                    this.indicatorBelow.data('scrollTarget', bufferEl);
                    this.indicatorBelow.data('scrollBuffer', buffer);
                }
            }
        }, this));
        if (this.tooltipVisible) {
            this.renderTooltip();
        }
    },
    tooltipInit: function () {
        return {
            above: {
                buffers: 0,
                highlights: 0,
                failed: 0
            },
            below: {
                buffers: 0,
                highlights: 0,
                failed: 0
            }
        };
    },
    renderTooltip: function () {
        if (this.tooltipVisible) {
            var data = this.tooltipData[this.tooltipVisible];
            if (data.highlights || data.buffers || data.failed) {
                var css = {};
                var vPadding = 5;
                if (this.tooltipVisible == 'below') {
                    var belowRect = this.indicatorBelow[0].getBoundingClientRect();
                    css.top = 'auto';
                    css.bottom = ($(window).height() - belowRect.bottom) + vPadding;
                } else if (this.tooltipVisible == 'above') {
                    css.top = vPadding;
                    css.bottom = 'auto';
                }
                var className = 'sidebarIndicatorTooltip--' + this.tooltipVisible;
                this.tooltip
                    .css(css)
                    .removeClass('sidebarIndicatorTooltip--above')
                    .removeClass('sidebarIndicatorTooltip--below')
                    .addClass(className)
                    .addClass('sidebarIndicatorTooltip--show');

                this.tooltipSummary.html('');
                if (data.highlights) {
                    var s = data.highlights > 1 ? 's' : '';
                    this.tooltipSummary.append(
                        $('<span class="sidebarIndicatorTooltip__highlights">')
                            .append($('<span class="sidebarIndicatorTooltip__badge">').text(data.highlights))
                            .append('&nbsp;highlight' + s)
                    );
                }
                if (data.buffers) {
                    if (data.highlights) {
                        this.tooltipSummary.append(' •&nbsp;');
                    }
                    this.tooltipSummary.append(
                        $('<span class="sidebarIndicatorTooltip__buffers">')
                            .html(data.buffers + '&nbsp;unread')
                    );
                }
                if (data.failed) {
                    if (data.highlights || data.buffers) {
                        this.tooltipSummary.append(' •&nbsp;');
                    }
                    this.tooltipSummary.append(
                        $('<span class="sidebarIndicatorTooltip__failed">')
                            .html(data.failed + '&nbsp;failed')
                    );
                }
            } else {
                this.tooltipVisible = false;
                this.renderTooltip();
            }
        } else {
            this.tooltip.removeClass('sidebarIndicatorTooltip--show');
        }
    },
    getSidebarHeight: function () {
        return this.sidebar.el.offsetHeight;
    },
    getSidebarTop: function () {
        return this.sidebar.el.offsetTop;
    },
    select: function (buffer, options) {
        if (buffer) {
            buffer.select(options);
            return true;
        }
        return false;
    },
    selectOrClear: function (buffer, options) {
        if (this.select(buffer, options)) {
            return true;
        } else {
            this.model.clearCurrentBuffer();
            return false;
        }
    },
    selectConnectionPreviousOrTopBuffer: function (connection, options) {
        var bufferToSelect = this.getPreviousBufferForSelection(connection.serverLog, true) ||
                             this.getNextConnectionFirstBuffer(connection, true) ||
                             this.getPreviousBuffer(connection.serverLog) ||
                             this.getNextConnectionFirstBuffer(connection);
        return this.selectOrClear(bufferToSelect, options);
    },
    selectPreviousOrTopBuffer: function (buffer, options) {
        var bufferToSelect = this.getPreviousBufferForSelection(buffer, true) ||
                             this.getNextBufferForSelection(buffer, true) ||
                             this.getPreviousBuffer(buffer) ||
                             this.getNextBuffer(buffer);
        return this.selectOrClear(bufferToSelect, options);
    },
    getPreviousBufferForSelection: function (buffer, important) {
        var backup = this.getLastPinnedBuffer() ||
                     this.getLastBufferForSelection();
        if (buffer) {
            var ret;
            if (buffer.isPinned()) {
                ret =  this.getPreviousPinnedBuffer(buffer) ||
                       this.getLastBufferForSelection();
            } else {
                ret =  this.getPreviousBuffer(buffer, important) ||
                       backup;
            }
            if (ret && ret.equals(buffer)) {
                ret = this.getPreviousBuffer(ret);
            }
            return ret;
        } else {
            return backup;
        }
    },
    getNextBufferForSelection: function (buffer, important) {
        var backup = this.getFirstPinnedBuffer() ||
                     this.getFirstBufferForSelection();
        if (buffer) {
            if (buffer.isPinned()) {
                return this.getNextPinnedBuffer(buffer) ||
                       this.getFirstBufferForSelection();
            } else {
                return this.getNextBuffer(buffer, important) ||
                       backup;
            }
        } else {
            return backup;
        }
    },
    selectPreviousBuffer: function (options) {
        this.select(this.getPreviousBufferForSelection(this.model.currentBuffer, true), options);
    },
    selectNextBuffer: function (options) {
        this.select(this.getNextBufferForSelection(this.model.currentBuffer, true), options);
    },
    selectPreviousUnreadBuffer: function (options) {
        if (this.model.unseenBuffers.length) {
            var prev = this.getPreviousBufferForSelection(this.model.currentBuffer, false);
            while (prev) {
                if (prev && prev.hasUnseen() && (prev.isTrackingUnread() || prev.hasUnseenHighlights())) {
                    return this.select(prev, options);
                }
                prev = this.getPreviousBufferForSelection(prev, false);
            }
        }
    },
    selectNextUnreadBuffer: function (options) {
        if (this.model.unseenBuffers.length) {
            var next = this.getNextBufferForSelection(this.model.currentBuffer, false);
            while (next) {
                if (next && next.hasUnseen() && (next.isTrackingUnread() || next.hasUnseenHighlights())) {
                    return this.select(next, options);
                }
                next = this.getNextBufferForSelection(next, false);
            }
        }
    }
});

module.exports = BufferListView;


/***/ }),

/***/ "OzoI":
/***/ (function(module, exports, __webpack_require__) {

var ChannelMembersView = __webpack_require__("KEE7");
var ChannelStatusView = __webpack_require__("Fj2Y");
var ChildView = __webpack_require__("plGQ");


var ChannelView = ChildView.extend({
    className: ChildView.prototype.className + ' channel',
    initialize: function (options) {
        this.status = new ChannelStatusView(options);
        this.members = new ChannelMembersView(options);
        this.model.bind('prefChange:hiddenMembers', this.renderMemberShown, this);
        this.model.bind('twitchChannelChange', this.renderMemberShown, this);
        
        ChildView.prototype.initialize.apply(this, arguments);
    },
    renderActive: function () {
        this.renderMemberShown();
        this.renderMemberCount();
        ChildView.prototype.renderActive.apply(this, arguments);
    },
    shouldShowMemberList: function () {
        return !this.model.getTwitchInfo() && this.model.isActive() && this.model.shouldShowMemberList();
    },
    renderMemberShown: function () {
        if (this.model.isSelected()) {
            this.scroll.onAnimate(250, _.bind(function renderMemberShownTick (pinBottom) {
                this.scrollWidthChange(pinBottom);
            }, this), _.bind(function renderMemberShownAfter () {
                if (this.shouldShowMemberList()) {
                    this.$el.addClass('membersShown');
                }
            }, this));
        }
        this.$('div.memberwrapper').attr('aria-hidden', String(!this.shouldShowMemberList()));
        this.$('.memberToggle').attr('aria-expanded', String(this.shouldShowMemberList()));
        if (this.shouldShowMemberList()) {
            this.$el.addClass('showMembers');
            if (!this.model.isSelected()) {
                this.$el.addClass('membersShown');
            }
        } else {
            this.$el.removeClass('showMembers');
            this.$el.removeClass('membersShown');
        }
    },
    renderMemberCount: function () {
        if (this.model.isActive()) {
            this.status.renderMemberCount();
            this.mainTopChange();
        }
    },
    hoverUserRows: function (user) {
        ChildView.prototype.hoverUserRows.apply(this, arguments);
        var attr = '[data-usermask="' + this.formatter.escapeQuerySelector(user.getHostMask()) + '"]';
        var attr2 = '[data-name="' + this.formatter.escapeQuerySelector(user.getName()) + '"]';
        this.members.$('li.user' + attr + ', li.user' + attr2).addClass('hover');
    },
    unhoverUserRows: function () {
        ChildView.prototype.unhoverUserRows.apply(this, arguments);
        this.members.$('li.user').removeClass('hover');
    },
    postrender: function () {
        this.$('div.memberwrapper').append(this.members.render().el);
        this.renderMemberShown();
    },
    render: function () {
        ChildView.prototype.render.apply(this, arguments);
        
        this.$el.toggleClass('slack_mpdm', this.model.isSlackMultiPersonDm());

        this.renderMode();
        this.model.bind('modeChange', this.renderMode, this);
        this.model.userMember.bind('change:mode', this.renderUserMember, this);
        
        this.model.members.bind('add remove reset', this.renderMemberCount, this);
        
        return this;
    },
    renderUserMember: function () {
        if (this.buffer.userMember.hasChanged()) {
            this.$el.removeClass(this.buffer.userMember.getPreviousModeClass());
        }
        this.$el.addClass(this.buffer.userMember.getModeClass());
        this.$el.toggleClass('mod', this.buffer.userMember.isMod());
    },
    renderMode: function () {
        this.$el.toggleClass('secret', this.buffer.hasMode('s'));
        this.$el.toggleClass('private', this.buffer.hasMode('p'));
        this.$el.toggleClass('moderated', this.buffer.hasMode('m'));
        this.$el.toggleClass('inviteOnly', this.buffer.hasMode('i'));
        this.$el.toggleClass('password', this.buffer.isPassworded());
        this.$el.toggleClass('topicControl', this.buffer.hasMode('t'));
        this.$el.toggleClass('noExternal', this.buffer.hasMode('n'));
        this.$el.toggleClass('limited', this.buffer.hasMode('l'));
        
        // Update classnames for the user member if we have one yet
        this.renderUserMember();
    }
});


module.exports = ChannelView;


/***/ }),

/***/ "P0z8":
/***/ (function(module, exports, __webpack_require__) {

var Conversation = __webpack_require__("sCU/");
var OrderedBufferList = __webpack_require__("zICk");


var ConversationList = OrderedBufferList.extend({
    model: Conversation
});


module.exports = ConversationList;


/***/ }),

/***/ "PQdE":
/***/ (function(module, exports) {

var OrgMemberView = Backbone.View.extend({
    tagName: 'tr',
    initialize: function (options) {
        this.model.bind('remove', this.remove, this);
        this.model.bind('removedChange', this.renderRemoved, this);
        this.model.bind('change:admin', this.renderAdmin, this);
        if (options.undoable === undefined) {
            this.undoable = true;
        } else {
            this.undoable = options.undoable;
        }
    },
    events: {
        'click a.remove': 'clickRemove',
        'click a.undo': 'clickUndo',
        'click a.resend': 'clickResend',
        'change td.admin input[type=checkbox]': 'changeAdmin'
    },
    render: function () {
        this.adminCell = $('<td class="admin">');
        this.renderAdmin();

        this.actionCell = $('<td class="remove">');
        var removeSmall = $('<small>')
            .append($('<a href="" class="remove">').text('remove'))
            .append($('<a href="" class="undo">').text('undo'));

        var email = this.model.get('email');
        var inviteEmail = this.model.get('invite_email');
        var emailCell = $('<td class="email">');
        if (email) {
            emailCell.text(email);
            if (inviteEmail && inviteEmail != email) {
                removeSmall
                    .append(' | ')
                    .append('<span>invited as: ')
                    .append($('<span>').text(inviteEmail));
            }
        } else {
            emailCell.text(inviteEmail);
            $(this.el).addClass('pending');
            removeSmall
                .append(' | ')
                .append($('<a href="" class="resend">').text('resend invite'))
                .append($('<span class="resending">').text('sending…'))
                .append($('<span class="resendFail">').text(' failed'))
                .append($('<span class="resent">').text('sent!'));
            this.actionCell.append(removeSmall);
        }
        if (this.model.isSelf()) {
            this.actionCell.append('<small>That’s you!</small>');
        } else {
            this.actionCell.append(removeSmall);
        }

        $(this.el)
            .append(emailCell)
            .append(this.adminCell)
            .append(this.actionCell);
        return this;
    },
    clickRemove: function (e) {
        e.preventDefault();
        if (this.undoable) {
            this.model.setRemoved(true);
        } else {
            this.model.collection.remove(this.model);
        }
    },
    clickUndo: function (e) {
        e.preventDefault();
        this.model.setRemoved(false);
    },
    changeAdmin: function (e) {
        this.model.setAdmin(this.adminCell.find('input[type=checkbox]').is(':checked'));
    },
    clickResend: function (e) {
        e.preventDefault();
        this.actionCell.find('.resend').hide();
        this.actionCell.find('.resending').show();
        this.actionCell.find('.resendFail').hide();
        this.model.resendInvite(_.bind(function (response) {
            this.actionCell.find('.resending').hide();
            if (response.success) {
                this.actionCell.find('.resent').show();
            } else {
                this.actionCell.find('.resend').show();
                this.actionCell.find('.resendFail').show();
            }
        }, this));
    },
    renderRemoved: function () {
        $(this.el).toggleClass('removed', this.model.isRemoved());
    },
    renderAdmin: function () {
        var check = $('<input type="checkbox" name="admin">').prop('checked', this.model.isAdmin()).prop('disabled', this.model.isSelf());
        this.adminCell.html(check);
    }
});

module.exports = OrgMemberView;


/***/ }),

/***/ "PT53":
/***/ (function(module, exports) {

window.emoji.img_path = "/static/emoji/";
window.emoji.img_suffix = '?v=16.0';
window.emoji.include_title = true;
window.emoji.allow_native = true;
window.emoji.use_sheet = true;
window.emoji.colon_aliases = {
    '1f44d': ['like', 'thumbs_up'],
    '1f44e': ['dislike', 'thumbs_down'],
    '1f415': ['doge'],
    '1f346': ['aubergine'],
    '1f4a8': ['gust_of_wind'],
    '1f389': ['party_popper'],
    '1f631': ['shock'],
    '269b-fe0f': ['atom'],
    '2764-fe0f': ['<3', '&lt;3'],
    '1f494': ['</3', '&lt;&#x2f;3'],
    '1f642': ['simple_smile', ':)', ':-)', ')', '-)'],
    '1f603': ['=D'],
    '1f600': [':D', 'D'],
    '1f61e': [':(', '('],
    '1f622': [":'(", "'(", ':&#x27;(', '&#x27;('],
    '1f62d': [':_(', '_(','loudly_crying_face','sad_tears','bawl'],
    '1f609': [';)'],
    '1f61c': [';p'],
    '1f606': ['XD'],
    '1f604': ['^_^'],
    '1f605': ['^_^;'],
    '1f923': ['rofl'],
    '1f610': [':|', '|'],
    '1f623': ['>.<'],
    '1f6f8': ['ufo'],
    '1f9d9-200d-2640-fe0f': ['female_wizard'],
    '1f9d9-200d-2642-fe0f': ['male_wizard'],
    '1f995': ['brontosaurus', 'diplodocus'],
    '1f996': ['tyrannosaurus'],
    '1f969': ['steak'],
    '1f96b': ['soup_tin'],
    '1f9e2': ['baseball_cap'],
    '1f9d8-200d-2640-fe0f': ['female_yoga'],
    '1f9d8-200d-2642-fe0f': ['male_yoga'],
    '1f9d6-200d-2640-fe0f': ['female_sauna'],
    '1f9d6-200d-2642-fe0f': ['male_sauna'],
    '1f9d5': ['hijab'],
    '1f41e': ['ladybird','ladybug','ladybeetle','coccinellid'],
    '1f48e': ['diamond'],
    '1f607': ['angel_face'],
    '1f608': ['smiling_devil'],
    '1f47f': ['frowning_devil'],
    '1f621': ['mad_rage', 'angry_rage'],
    '1f620': ['mad'],
    '1f682': ['steam_train'],
    '1f393': ['graduation_cap'],
    '1f4a1': ['lightbulb'],
    '1f60e': ['cool_dude', 'deal_with_it'],
    '1f925': ['liar'],
    '1f430': ['bunny'],
    '1f407': ['bunny2'],
    '1f6ac': ['cigarette', 'fag'],
    '1f30a': ['water_wave'],
    '1f92a': ['crazy_face'],
    '1f92b': ['sh'],
    '1f92c': ['angry_swearing','mad_swearing','cursing','swearing','pissed_off','fuck'],
    '1f92d': ['oops'],
    '1f92e': ['throwing_up', 'being_sick'],
    '1f92f': ['mind_blown'],
    '26a1': ['lightning_bolt'],
    '1f38a': ['confetti'],
    '1f5d1-fe0f': ['rubbish', 'trash', 'garbage', 'bin', 'wastepaper_basket']

};
window.emoji.non_native = {};
var tsoffet = new Date().getTimezoneOffset();
var earth_emoji;
if (tsoffet > 180) {
    // UTC-3 or less, america
    earth_emoji = '1f30e';
} else if (tsoffet < -300) {
    // UTC+5 or more, asia
    earth_emoji = '1f30f';
} else {
    // UTC-3 - UTC+5, africa
    earth_emoji = '1f30d';
}
window.emoji.colon_aliases[earth_emoji] = ['earth'];
window.emoji.init_colons();
window.emoji.init_unified();
window.emoji.init_env();


/***/ }),

/***/ "PfEk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QI8C":
/***/ (function(module, exports, __webpack_require__) {

var OnlineChecker = __webpack_require__("mMVu");
var SocketStreamHandler = __webpack_require__("O/fm");
var XHRStreamHandler = __webpack_require__("Dudk");
var ts = __webpack_require__("GmLC").ts;


var BackendController = function (session) {
    this.session = session;
    this.onlineChecker = new OnlineChecker(this.session);
    this.setXHRPost();
    _.bindAll(this, 'processOob', 'oobFail', 'start', '_start', 'beforeUnload', 'idleRestart');
    $(window).on('beforeunload', this.beforeUnload);
};
BackendController.prototype = $.extend({
    streamState: 'disconnected',
    restart: true,
    idleIntervalHandler: null,
    idleInterval: null,
    lastMessageTime: null,
    requestIds: 1,
    maxEid: -1,
    streamId: null,
    
    serverPrefix: '/chat',

    loadingOob: false,
    
    messageQueue: [],
    
    timeOffset: 0,
    oobFailCount: 0,
    
    init: function () {
        if (!this.initialized) {
            this.initialized = true;
            this.initStreamHandler();
            this.onlineChecker.start();
        } else {
            debug.warn('Trying to initialize BackendController again');
        }
    },
    ts: function () {
        return ts() - this.timeOffset;
    },
    tsOffset: function (timestamp) {
        return timestamp + this.timeOffset;
    },
    messageHandlers: {
        // Stream events without an eid, general state
        header: function (message) {
            this.timeOffset = ts() - (message.time*1000);
            this.trigger('connected', message);
            
            this.loadingOob = false;
            this.messageQueue = [];

            this.streamId = message.streamid;
            if (this.streamHandler) {
                this.streamHandler.setQueryParam('stream_id', this.streamId);
            }

            this.startIdleInterval(message.idle_interval);
        },
        oob_include: function (message) {
            this.loadingOob = true;
            this.trigger('oobLoading');
            var httpMethod = 'get';
            var outLogLine = '-> [' + httpMethod.toUpperCase() + ']';
            var inLogLine = '<- [' + httpMethod.toUpperCase() + ']';
            debug.log(outLogLine, message.url);
            var params = {};
            if (this.isXDAPI()) {
                params.session = this.session.getAuthCookie();
            }
            window.API_HOST = message.api_host;
            this._doRequest(httpMethod, window.API_HOST + message.url, params, _.bind(function (response) {
                if (response) {
                    if (response.error || response.success === false) {
                        debug.warn(inLogLine, message.url, response);
                        this.oobFail();
                    } else {
                        debug.log(inLogLine, message.url, response);
                        this.processOob(response);
                    }
                } else {
                    debug.warn(inLogLine, message.url, response);
                    this.oobFail();
                }
            }, this), _.bind(function (response) {
                debug.warn(inLogLine, message.url, response._status, response.message, response);
                this.oobFail();
            }, this));
        },
        oob_skipped: function (message) {
            this.trigger('oobLoading');
            this.trigger('oobLoaded', []);
        },
        idle: function (message) {
            // pass
        }
    },
    
    clearTempUnavailableCountdown: function () {
        if (this.tempUnavailableTimeout) {
            clearTimeout(this.tempUnavailableTimeout);
            this.tempUnavailableTimeout = null;
        }
    },
    tempUnavailableCountdown: function (seconds, callback) {
        this.tempUnavailableTimeout = setTimeout(
            _.bind(this.tempUnavailable, this, seconds, callback),
            1000
        );
    },
    tempUnavailable: function (seconds, callback) {
        if (seconds) {
            this.trigger('tempUnavailableTick', seconds);
            this.tempUnavailableCountdown(seconds - 1, callback);
        } else {
            callback();
        }
    },
    beforeUnload: function (e) {
        // Don't restart the stream when it dies on unload
        this.unloading = true;
        this.restart = false;
    },
    
    // Stream
    setStreamState: function (state) {
        if (this.streamState != state) {
            debug.log('Stream: ' + this.streamState + ' -> ' + state);
            this.streamState = state;
            this.trigger('stream');
            this.trigger('stream:' + this.streamState);
        }
    },
    checkStreamState: function (state) {
        return this.streamState == state;
    },
    _start: function () {
        if (!this.streamHandler) {
            return;
        }
        // Make sure we're still in the starting state
        if (this.checkStreamState('starting')) {
            this.streamHandler.start();
            this.onlineChecker.unbind('onlineChange');
            this.onlineChecker.bind('onlineChange', function () {
                if (this.isOnline()) {
                    this.start(1);
                } else {
                    this.stop(true);
                }
            }, this);
        }
    },
    start: function (delay) {
        if (this.checkStreamState('disconnected')) {
            this.restart = true;
            this.startDelay = delay || 0;
            this.clearStartTimeout();
            this.clearTempUnavailableCountdown();
            this.startTimeout = setTimeout(
                this._start,
                this.startDelay * 1000
            );
            this.setStreamState('starting');
            if (this.startDelay) {
                debug.log('Starting in ' + this.startDelay + 's');
            }
        } else {
            debug.warn('Trying to start a non disconnected stream (' + this.streamState + ')');
        }
    },
    clear: function () {
        this.streamHandler.setQueryParam('stream_id', '');
        this.streamHandler.setQueryParam('since_id', '');
    },
    clearStartTimeout: function () {
        if (this.startTimeout) {
            clearTimeout(this.startTimeout);
            this.startTimeout = null;
        }
    },
    stop: function (offline) {
        if (!this.checkStreamState('disconnected')) {
            if (!offline) {
                this.restart = false;
            }
            if (this.streamHandler) {
                this.streamHandler.stop();
            }
            this.clearIdleInterval();
        } else {
            debug.warn('Trying to stop a disconnected BackendController');
        }
    },
    onNoSocketData: function (failCount) {
        debug.warn('No socket data, falling back to XHR');
        this.setStreamState('disconnected');
        if (this.initFallbackStreamHandler()) {
            this.start();
        }
    },
    onStop: function () {
        this.setStreamState('stopped');
        this.clearTempUnavailableCountdown();
    },
    onConnectionError: function () {
        this.trigger('streamError');
        this.stop();
    },
    offline: function () {
        this.trigger('offline');
        this.onConnectionError();
    },
    unsupported: function () {
        this.trigger('unsupported');
        this.onConnectionError();
    },
    isXDSocket: function () {
        if (window.WS_SOCKET_HOST && window.WS_SOCKET_HOST != this.session.getHost()) {
            return true;
        }
        return false;
    },
    isXDAPI: function () {
        if (window.API_HOST && window.API_HOST != this.session.getOrigin()) {
            return true;
        }
        return false;
    },
    onConnected: function () {
        if (this.streamHandler instanceof SocketStreamHandler && this.isXDSocket()) {
            var cookie = this.session.getAuthCookie();
            this.streamPost("auth", {
                cookie: cookie
            }, _.bind(function (response) {
                if (response.error || response.success === false) {
                    this.processError(response);
                }
            }, this));
        }
        if (this.streamHandler instanceof XHRStreamHandler && !this.xhrFallbackTriggered) {
            this.xhrFallbackTriggered = true;
            this.trigger('xhrFallback');
        }
        this.setStreamState('started');
    },
    onDisconnect: function (failCount) {
        this.setStreamState('disconnected');
        this.trigger('disconnect');
        debug.warn('Backend disconnected', 'oobFailCount: ' + this.oobFailCount, 'failCount: ' + failCount, 'restart?', this.restart, 'online?', this.isOnline());
        if (this.isOnline()) {
            failCount = this.oobFailCount || failCount;
            switch (failCount) {
            case 0:
            case 1:
            case 2:
                if (this.restart) {
                    this.start(failCount);
                }
                break;
            default:
                if (this.restart) {
                    if (failCount < 10) {
                        this.start(10);
                    } else {
                        this.start(30);
                    }
                }
                break;
            }
        } else {
            this.offline();
        }
    },
    onSocketError: function (response) {
        if ("_reqid" in response) {
            this.socketResponse(response);
        }
    },
    onSocketMessage: function (response) {
        if ("_reqid" in response) {
            this.gotMessage();
            this.socketResponse(response);
        } else {
            this.onMessage(response);
        }
    },
    gotMessage: function () {
        this.clearStartTimeout();
        // Set last message time
        this.lastMessageTime = ts();
        this.setStreamState('open');
    },
    onMessage: function (message) {
        this.gotMessage();
        this.processMessage(message, this.loadingOob);
    },
    idleRestart: function () {
        if (this.checkStreamState('starting')) {
            // Already starting, ignore
            return;
        }
        var timeSinceLastMessage = ts() - this.lastMessageTime;
        if (timeSinceLastMessage > this.idleInterval) {
            // Restart the stream if it's gone quiet
            if (this.restart) {
                debug.warn('Idle timeout [' + timeSinceLastMessage + ']: restarting');
                this.streamHandler.stop();
            }
        }
    },
    clearIdleInterval: function () {
        if (this.idleIntervalHandler) {
            clearInterval(this.idleIntervalHandler);
        }
    },
    startIdleInterval: function (interval) {
        if (!interval || interval < 1000) {
            return;
        }
        // Clear any existing interval
        this.clearIdleInterval();
        this.idleInterval = interval;
        this.idleIntervalHandler = setInterval(
            this.idleRestart,
            this.idleInterval
        );
    },
    isOnline: function () {
        return this.onlineChecker.isOnline();
    },
    // Stream handler setup
    setMaxEid: function (eid, bake) {
        if (eid > this.maxEid) {
            this.maxEid = eid;
            if (bake) {
                this.bakeMaxEid();
            }
        }
    },
    bakeMaxEid: function () {
        this.streamHandler.setQueryParam('since_id', this.maxEid);
    },
    getSocketSecure: function () {
        if (window.API_HOST.indexOf('https://') === 0) {
            return true;
        }
        return this.session.isSecure();
    },
    getSocketHost: function () {
        var host;
        if (window.WS_SOCKET_HOST) {
            host = window.WS_SOCKET_HOST;
        } else {
            host = this.session.getHost();
        }
        if (window.WS_SOCKET_PATH) {
            host += window.WS_SOCKET_PATH;
        }
        return host;
    },
    getXHRUrl: function () {
        return this.buildUrl("/stream");
    },
    checkWebSocketSupport: function () {
        if (!this.session.featureCheck('websockets')) {
            return false;
        }
        return !!window.WebSocket;
    },
    bindStreamHandler: function () {
        this.streamHandler.bind('disconnect', this.onDisconnect, this);
        this.streamHandler.bind('connected', this.onConnected, this);
        this.streamHandler.bind('stop', this.onStop, this);
        this.streamHandler.bind('connectionError', this.onConnectionError, this);
    },
    initStreamHandler: function (fallback) {
        if (!fallback && this.checkWebSocketSupport()) {
            this.initSocketStreamHandler();
        } else {
            this.initFallbackStreamHandler();
        }
    },
    initSocketStreamHandler: function () {
        this.streamHandler = new SocketStreamHandler(this.getSocketHost(), this.getSocketSecure());
        this.bind('stream:starting', function () {
            this.streamHandler.setHost(this.getSocketHost());
        }, this);
        this.streamHandler.bind('message', this.onSocketMessage, this);
        this.streamHandler.bind('socketError', this.onSocketError, this);
        this.streamHandler.bind('noData', function () {
            this.unbind('stream:starting');
            this.onNoSocketData();
        }, this);
        
        this.setSocketPost();
        this.bindStreamHandler();
    },
    initXHRStreamHandler: function () {
        this.streamHandler = new XHRStreamHandler(this.getXHRUrl());
        this.streamHandler.bind('message', this.onMessage, this);
        this.streamHandler.bind('noData', this.onDisconnect, this);
        this.setXHRPost();
        this.bindStreamHandler();
    },
    initFallbackStreamHandler: function () {
        if (this.session.featureCheck('xhr') && !$.browser.opera) {
            this.initXHRStreamHandler();
            return true;
        } else {
            this.unsupported();
            return false;
        }
    },
    
    // Messages
    oobFail: function () {
        this.oobFailCount++;
        this.streamHandler.error();
        this.trigger('oobFailed');
        this.loadingOob = false;
    },
    processOobMessages: function (messages) {
        debug.log('OOB length', messages.length);
        _.each(messages, function (message) {
            if (message.cid && message.cid > 0) {
                if (message.bid && message.bid > 0) {
                    debug.log('[OOB ' + message.cid + ' ' + message.bid + ' ' + message.type + ']', message);
                } else {
                    debug.log('[OOB ' + message.cid + ' ' + message.type + ']', message);                }
            } else {
                debug.log('[OOB ' + message.type + ']', message);
            }
            this.processMessage(message);
        }, this);
    },
    processOob: function (messages) {
        this.oobFailCount = 0;
        this.trigger('oobLoaded', messages);
        this.loadingOob = false;
        this.processOobMessages(messages);
        this.handleMessageQueue();
    },
    queueMessage: function (message) {
        this.messageQueue.push(message);
    },
    handleMessageQueue: function () {
        _.each(this.messageQueue, this.triggerMessageEvent, this);
        this.messageQueue = [];
    },
    triggerMessageEvent: function (message) {
        this.trigger('message', message);
        if (this.messageHandlers[message.type]) {
            this.messageHandlers[message.type].call(this, message);
        }
    },
    processError: function (message) {
        var msg = message.error || message.message;
        switch (msg) {
        case 'temp_unavailable':
            debug.warn('Error: temp_unavailable, stopping stream');
            this.stop();
            this.tempUnavailable(30, this.start);
            break;
        case 'auth':
            debug.warn('Error: auth, stopping stream');
            this.trigger('streamAuthError');
            this.stop();
            break;
        case 'auth_timeout':
            debug.warn('Error: auth timeout');
            this.trigger('streamAuthTimeout');
            break;
        case 'set_shard':
            debug.warn('Error: set_shard, stopping stream');
            this.stop();
            this.trigger('setShard', message);
            break;
        }
    },
    processMessage: function (message, queue) {
        if (message.type) {
            if (queue) {
                this.queueMessage(message);
            } else {
                this.triggerMessageEvent(message);
            }
        } else if (message.error || message.success === false) {
            this.processError(message);
        } else {
            debug.warn('Missing type in stream message', message);
        }
    },
    
    // Requests
    buildRawUrl: function (suffix, options) {
        options = options || {};
        var host = options.urlHost || window.API_HOST;
        return host + suffix;
    },
    buildUrl: function (suffix, options) {
        options = options || {};
        var prefix = options.urlPrefix || this.serverPrefix;
        return this.buildRawUrl(prefix + suffix, options);
    },
    _request: function (httpMethod, method, data, callback, ajaxOptions, options) {
        var outLogLine = '-> [';
        if (data._reqid) {
            outLogLine += data._reqid + ' ';
        }
        outLogLine += httpMethod.toUpperCase() + ']';
        debug.log(outLogLine, method, data);
        return this._doRequest(httpMethod, this.buildUrl("/" + method, options), data, _.bind(function (response) {
            var inLogLine = '<- [';
            if (response._reqid) {
                inLogLine += response._reqid + ' ';
            }
            inLogLine += httpMethod.toUpperCase() + ']';
            debug.log(inLogLine, method, response);
            this.triggerResponse(response, $.extend({}, data, {
                _method: method
            }));
            if (callback) {
                callback(response, response._reqid);
            }
        }, this), _.bind(function (response) {
            var inLogLine = '<- [';
            if (response._reqid) {
                inLogLine += response._reqid + ' ';
            }
            inLogLine += httpMethod.toUpperCase() + ']';
            debug.warn(inLogLine, method, response._status, response.message, response);
            if (callback) {
                callback(response);
            }
        }, this), ajaxOptions);
    },
    _doRequest: function (httpMethod, url, data, success, error, ajaxOptions) {
        ajaxOptions = ajaxOptions || {};
        var dataType = ajaxOptions.dataType || 'json';
        ajaxOptions = $.extend(ajaxOptions, {
            url: url,
            data: data,
            type: httpMethod,
            dataType: dataType,
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            },
        });
        return $.ajax(ajaxOptions).done(_.bind(function (response) {
            if (response) {
                if (success) {
                    success(response);
                }
            } else {
                if (dataType == 'json') {
                    response = {
                        error: true,
                        message: 'empty response',
                        _status: 200
                    };
                }
                if (error) {
                    error(response);
                }
            }
        }, this)).fail(_.bind(function (request, errorString, errorThrown) {
            var response;
            if (dataType == 'json' && request.responseText !== undefined) {
                try {
                    response = JSON.parse(request.responseText);
                } catch (e) {
                    response = {
                        error: true,
                        message: 'invalid json',
                        json: request.responseText
                    };
                }
            } else {
                response = {
                    error: true,
                    message: request.statusText,
                    text: request.responseText
                };
            }
            response._status = request.status;
            response._statusText = request.statusText;
            if (error) {
                error(response);
            }
        }, this));
    },
    get: function (method, data, callback) {
        return this._request('get', method, data, callback);
    },
    _getRequestId: function () {
        return this.requestIds++;
    },
    setXHRPost: function () {
        this.streamPost = this.post;
    },
    setSocketPost: function () {
        this.streamPost = this.socketPost;
    },
    post: function (method, data, callback, ajaxOptions, options) {
        data = data || {};
        // Add request ID
        if (!data._reqid) {
            data._reqid = this._getRequestId();
        }
        // Add form token
        var sessionAuth = this.session.getAuthCookie();
        if (sessionAuth) {
            data.session = sessionAuth;
        }
        this._request('post', method, data, callback, ajaxOptions, options);
        return data._reqid;
    },
    socketPost: function (method, data, callback) {
        data = data || {};
        // Add request ID
        if (!data._reqid) {
            data._reqid = this._getRequestId();
        }
        // Add method
        data._method = method;
        // Register response handler
        this.bind('socketResponse:' + data._reqid, function (response) {
            if (callback) {
                callback(response);
            }
            this.triggerResponse(response, data);
            this.unbind('socketResponse:' + data._reqid);
        }, this);
        // Send over the socket
        this.streamHandler.send(data);
        return data._reqid;
    },
    triggerResponse: function (response, request) {
        this.trigger('response', response, request);
    },
    socketResponse: function (response) {
        this.trigger('socketResponse:' + response._reqid, response);
    }
}, Backbone.Events);


module.exports = BackendController;


/***/ }),

/***/ "QX5P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _avatar = __webpack_require__("lKP6");

var _avatar2 = _interopRequireDefault(_avatar);

var _connection = __webpack_require__("LLdI");

var _connection2 = _interopRequireDefault(_connection);

var _dialogview = __webpack_require__("EjYC");

var _dialogview2 = _interopRequireDefault(_dialogview);

var _formatter = __webpack_require__("5gSh");

var _formatter2 = _interopRequireDefault(_formatter);

var _renderreasons = __webpack_require__("ilaq");

var _renderreasons2 = _interopRequireDefault(_renderreasons);

var _avatarChooserDialog = __webpack_require__("qWv8");

var _avatarChooserDialog2 = _interopRequireDefault(_avatarChooserDialog);

__webpack_require__("GnMM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Super = _dialogview2.default.prototype;

exports.default = _dialogview2.default.extend({

    showInstant: true,
    hideInstant: true,

    className: 'avatar-chooser-dialog avatars-on accountContainer',

    template: _avatarChooserDialog2.default,

    events: _.extend({}, Super.events, {
        'click .avatar-chooser__item': 'chooseAvatar',
        'buttonClick .avatar-chooser__add': 'chooseUpload',
        'buttonClick .avatar-chooser__clear': 'chooseClear',
        'submit .avatar-chooser__selected': 'onSubmit'
    }),

    initialize: function initialize(options) {
        Super.initialize.apply(this, arguments);

        this.formatter = new _formatter2.default();
        this.model.bind('avatarPrompt', this.renderAvatars, this);
    },

    closed: function closed() {
        Super.closed.apply(this, arguments);
    },
    chooseAvatar: function chooseAvatar(e) {
        e.preventDefault();
        this.renderAvatars(this.target, _.extend({}, this.options, {
            selected: $(e.currentTarget).data('id')
        }));
    },
    chooseClear: function chooseClear(e) {
        e.preventDefault();
        this.renderAvatars(this.target, _.extend({}, this.options, {
            selected: null,
            clear: true
        }));
    },
    chooseUpload: function chooseUpload(e) {
        e.preventDefault();
        this.hide();
        this.model.trigger('avatarUploadPrompt', this.target, this.options);
    },


    onSubmit: function onSubmit(e) {
        var _this = this;

        e.preventDefault();
        var form = $(e.currentTarget);
        var data = _.extend({}, this.options.properties, form.serializeForm());
        form.addSpin();
        this.$('userError').hide();
        this.model.post('set-avatar', data, function (response) {
            form.removeSpin();
            if (response.success) {
                _this.hide();
            } else {
                _this.renderAvatars(_this.target, _.extend({}, _this.options, {
                    error: _renderreasons2.default.renderPostError(response)
                }));
            }
        });
    },

    renderAvatars: function renderAvatars(target) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        this.options = options;
        this.target = target;
        var selected = this.options.selected;
        var primary = false;
        var isPrimaryChecked = false;
        var current = this.target.get('avatar');
        var hasCurrent = !!current;
        var connection;
        if (this.target instanceof _connection2.default) {
            connection = {
                name: this.target.getDisplayName(),
                nick: this.target.getNick()
            };
        }
        if (this.target === this.model) {
            isPrimaryChecked = primary = true;
        }
        var avatars = _.map(this.model.getAvatars(current), function (av) {
            av.connections = _.map(av.connections, function (c) {
                return {
                    name: c.getDisplayName(),
                    nick: c.getNick()
                };
            }, this);
            if (current && current == av.id) {
                av.isCurrent = true;
                if (!selected && !this.options.clear) {
                    selected = av.id;
                }
            }
            if (selected && selected == av.id) {
                av.isSelected = true;
                selected = av;
                if (selected.primary) {
                    isPrimaryChecked = true;
                }
            }
            av.image64 = this.formatter.imageAvatar(av.template, true, {
                size: 64,
                standalone: true
            });
            av.image256 = this.formatter.imageAvatar(av.template, true, {
                size: 256,
                standalone: true
            });
            return av;
        }, this);
        var isDefaultDisabled = isPrimaryChecked || !selected;
        if (avatars.length) {
            var data = {
                hasCurrent: hasCurrent,
                connection: connection,
                selected: selected,
                avatars: avatars,
                primary: primary,
                isPrimaryChecked: isPrimaryChecked,
                isDefaultDisabled: isDefaultDisabled,
                error: this.options.error
            };
            this.$el.html(this.template(data));
            this.show();
        } else {
            this.model.trigger('avatarUploadPrompt', this.target, this.options);
        }
        return this;
    }
});

/***/ }),

/***/ "Qc6Z":
/***/ (function(module, exports, __webpack_require__) {

var PastebinView = __webpack_require__("0bCg");
var FileWrapper = __webpack_require__("JHsc");
var FileInlineView = __webpack_require__("G5kp");
var Formatter = __webpack_require__("5gSh");
var util = __webpack_require__("GmLC");
var urlUtil = __webpack_require__("Dn1P");
var twitch = __webpack_require__("/7tV");
var atPoint = __webpack_require__("88d4");

var BufferLogContainerView = Backbone.View.extend({
    initialize: function (options, scroll) {
        // buffer can be a session
        this.buffer = options.buffer || this.model;
        this.scroll = scroll;
        this.formatter = new Formatter();
        
        this.missingReplyTargets = [];

        this.initDelayedLoads();
    },
    events: {
        'mousedown .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'mousemove .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'dblclick .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'click .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'buttonClick .joinPartGroup, .groupedJoinPart': 'mouseGroupedJoinPart',
        'mousedown .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'mousemove .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'dblclick .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'click .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'buttonClick .discoGroup, .groupedDisco': 'mouseGroupedDisco',
        'click a.embedClose, a.attachmentClose': 'clickEmbedClose',
        'buttonClick .embedClose, .attachmentClose': 'clickEmbedClose',
        'click div.gistwrap h1.gistwraptitle a.close': 'clickEmbedClose',
        'buttonClick div.paste .closeButton': 'clickPasteClose',
        'mouseenter span.date': 'hoverTimestamp',
        'mouseleave span.date': 'unhoverTimestamp',
        'mouseenter .messageActions': 'hoverMessageActions',
        'mouseleave .messageActions': 'unhoverMessageActions',
        'click span.date': 'clickDate',
        'click .react__add': 'clickReactAdd',
        'buttonClick .react__add': 'clickReactAdd',
        'buttonClick .deleteMessage': 'clickDeleteMessage',
        'buttonClick .editMessage': 'clickEditMessage',
        'buttonClick .reply__toggle': 'clickReplyToggle',
        'click .attachment__text-toggle': 'clickAttachmentTextToggle'
    },
    isSelected: function () {
        return this.buffer.isSelected();
    },
    getLine: function (message) {
        return this.$('#' + message.getEventId());
    },
    getMsgIdRow: function (msgid) {
        return this.$('.row[data-msgid="' + this.formatter.escapeQuerySelector(msgid) + '"]').last();
    },
    getReplyRows: function (msgid) {
        return this.$('.row[data-reply="' + this.formatter.escapeQuerySelector(msgid) + '"]');
    },
    handleClientTags: function (message, options) {
        if (!this.buffer.isChild()) {
            return;
        }
        if (!message.isClientTaggable()) {
            return;
        }
        var redact = message.getRedact() || message.getDelete();
        var edit = message.getEdit();
        var concat = message.getConcatTag();
        var reply = message.getReply();
        var reaction = message.getReaction();
        var unreaction = message.getUnreaction();
        var reactionImage = message.getReactionImage();
        if (redact) {
            if (this.buffer.isShowingDeletedMessages()) {
                return this.handleRedact(message, options, redact);
            } else {
                return this.handleRemove(message, options, redact);
            }
        } else if (edit) {
            return this.handleEdit(message, options, edit);
        } else if (concat) {
            return this.handleConcat(message, options, concat);
        } else if (reply) {
            if (reaction) {
                return this.handleReaction(message, options, reply, reaction, reactionImage);
            } else if (unreaction) {
                return this.handleUnreaction(message, options, reply, unreaction);
            } else {
                return this.handleReply(message, options, reply);
            }
        }
    },
    handleRemove: function (message, options, remove) {
        var row = this.getMsgIdRow(remove);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !message.canDelete(rowMessage)) {
            // Invalid target, mark as processed
            return true;
        }
        var prevDate = row.prev('.dateChange');
        if (prevDate.length) {
            this.removeRow(prevDate, options);
        }
        if (row.hasClass('firstAuthor')) {
            var next = row.next();
            if (next.length && next.hasClass('sameAuthor')) {
                next.removeClass('sameAuthor');
                next.addClass('firstAuthor');
            }
        }
        rowMessage.remove(message);

        this.renderReplySummary(rowMessage);

        this.removeRow(row, options);
        return true;
    },
    handleRedact: function (message, options, redact) {
        var row = this.getMsgIdRow(redact);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !message.canDelete(rowMessage)) {
            // Invalid target, mark as processed
            return true;
        }
        rowMessage.redact(message);

        var opts = _.extend({}, options, {actions: true});
        var rows = this.lineRenderer.render(rowMessage, opts).flush();
        this.replaceRow(row, rows, message, redact, options);
        return true;
    },
    handleEdit: function (message, options, edit) {
        var row = this.getMsgIdRow(edit);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !rowMessage.hasSameAccount(message)) {
            // Invalid target, mark as processed
            return true;
        }
        if (!rowMessage.edit(message)) {
            // Already edited, remove any line we rendered and mark as processed
            this.removeRow(this.getLine(message), options);
            return true;
        }

        var opts = _.extend({}, options, {actions: true});
        var rows = this.lineRenderer.render(rowMessage, opts).flush();
        this.replaceRow(row, rows, message, edit, options);
        return true;
    },
    handleConcat: function (message, options, concat) {
        if (message.isAttachmentFallback()) {
            // Suppress fallback lines, mark as processed
            return true;
        }
        var row = this.getMsgIdRow(concat);
        if (!row.length) {
            // Target not in backlog, remove any line we rendered and continue
            this.removeRow(this.getLine(message), options);
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !rowMessage.hasSameAuthor(message)) {
            // Invalid target, mark as processed
            return true;
        }
        if (!rowMessage.concat(message)) {
            // Already concatted, remove any line we rendered and mark as processed
            this.removeRow(this.getLine(message), options);
            return true;
        }

        this.renderReplySummary(rowMessage);

        var opts = _.extend({}, options, {actions: true});
        var rows = this.lineRenderer.render(rowMessage, opts).flush();

        this.replaceRow(row, rows, message, concat, options);
        return true;
    },
    handleReply: function (message, options, reply) {
        if (!message.isReplyable() && !message.isTwitchReplyable()) {
            // Invalid target, mark as processed
            return true;
        }

        var line = this.getLine(message);
        line.toggleClass('reply--collapsed', this.buffer.isThreadCollapsedOverride(reply));
        line.toggleClass('reply--expanded', this.buffer.isThreadExpandedOverride(reply));

        var row = this.getMsgIdRow(reply);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || (!rowMessage.isReplyable() && !rowMessage.isTwitchReplyable())) {
            // Invalid target, mark as processed
            return true;
        }
        if (row.attr('data-reply') && row.attr('data-reply') != reply) {
            // Don't override existing reply data, this case happens
            // if a client tries to nest replies
            // Don't mark as processed
            return;
        }
        this.renderQuoteReply(message, line);
        this.renderReplySummary(message, reply, row);
        // Don't mark as processed, this isn't an empty message
    },
    renderReaction: function (row, reaction) {
        var prevEmojiIncludeTitle = emoji.include_title;
        var prevEmojiWithEmocodes = emoji.with_emocodes;
        emoji.include_title = false;
        emoji.with_emocodes = false;
        var rendered = this.formatter.renderEmoji(this.formatter.escapeText(reaction));
        emoji.include_title = prevEmojiIncludeTitle;
        emoji.with_emocodes = prevEmojiWithEmocodes;

        var prevEmojiTextMode = emoji.text_mode;
        emoji.text_mode = true;
        var titleText = emoji.strip_colons(this.formatter.renderEmoji(reaction));
        emoji.text_mode = prevEmojiTextMode;
        var toolTipBracket = ' (' + titleText + ')';

        var value = $('<span class="reaction__value">').html(rendered);
        var reactionSpan = row.find('.reaction').filter(function (i, r) {
            return $(r).find('.reaction__value').text() === value.text();
        }).first();

        return [rendered, toolTipBracket, value, reactionSpan];
    },
    handleUnreaction: function (message, options, reply, unreaction) {
        var row = this.getMsgIdRow(reply);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !rowMessage.isReactable()) {
            // Invalid target, mark as processed
            return true;
        }
        var reactionContainer = row.find('.reactions');
        if (!reactionContainer.length) {
            // Target hasn't had any reactions yet
            this.missingReplyTargets.push(message);
            return;
        }
        
        var parts = this.renderReaction(row, unreaction);
        var rendered = parts[0];
        var toolTipBracket = parts[1];
        var value = parts[2];
        var reactionSpan = parts[3];

        if (!reactionSpan.length) {
            // Target hasn't had this reaction yet
            this.missingReplyTargets.push(message);
            return;
        }

        var reactors = _.without(reactionSpan.data('reactors'), message.getDisplayName());
        if (reactors.length) {
            reactionSpan.find('.reaction__count').remove();
            if (reactors.length > 1) {
                var countSpan = $('<span class="reaction__count">').text(reactors.length);
                reactionSpan.append(countSpan);
            }
            reactionSpan
                .attr('title', this.formatter.listSentence(reactors) + toolTipBracket)
                .data({
                    reactors: reactors
                });
        } else {
            reactionSpan.remove();
        }
        if (!reactionContainer.find('.reaction:not(.react__add)').length) {
            reactionContainer.remove();
        }

        // This gets read in flushBuffer to determine scroll updating
        options.reaction = true;
        return true;
    },
    handleReaction: function (message, options, reply, reaction, reactionImage) {
        var row = this.getMsgIdRow(reply);
        if (!row.length) {
            this.missingReplyTargets.push(message);
            return;
        }
        var rowMessage = this.scroll.getMessageForRow(row);
        if (!rowMessage || !rowMessage.isReactable()) {
            // Invalid target, mark as processed
            return true;
        }
        var reactionContainer = row.find('.reactions');
        var reactionAdd;
        if (!reactionContainer.length) {
            reactionContainer = $('<span class="reactions">');
            reactionAdd = $('<span class="reaction react__add reaction--active" role="button" title="Add a reaction" aria-label="Add a reaction" aria-haspopup="true" aria-expanded="false" aria-controls="emojiContextMenu" tabindex="0">')
                .append($('<span class="reaction__value">').html('<i class="fa fa-plus-circle">'));
            reactionContainer.append(reactionAdd);
            var toolTip = row.find('.reply__tooltip');
            if (toolTip.length) {
                toolTip.after(reactionContainer);
            } else {
                row.append(reactionContainer);
            }
        } else {
            reactionAdd = reactionContainer.find('.react__add');
        }
        
        var parts = this.renderReaction(row, reaction);
        var rendered = parts[0];
        var toolTipBracket = parts[1];
        var value = parts[2];
        var reactionSpan = parts[3];

        var nick = message.getDisplayName();

        if (reactionSpan.length) {
            var reactors = _.unique(reactionSpan.data('reactors').concat([nick]));
            reactionSpan.find('.reaction__count').remove();
            if (reactors.length > 1) {
                var countSpan = $('<span class="reaction__count">').text(reactors.length);
                reactionSpan.append(countSpan);
            }
            reactionSpan
                .attr('title', this.formatter.listSentence(reactors) + toolTipBracket)
                .data({
                    reactors: reactors
                });
        } else {
            reactionSpan = $('<span class="reaction reaction--active">')
                .attr('title', nick + toolTipBracket)
                .data({
                    reactors: [nick],
                    reaction: reaction,
                    msgid: reply,
                    cid: message.getCid(),
                    bid: message.bid()
                })
                .append(value);
            if (reactionImage) {
                var img = $('<img class="reaction__image">').attr({
                    src: reactionImage,
                    alt: nick + toolTipBracket
                });
                reactionSpan.addClass('reaction--image');
                reactionSpan.append(img);
            }
            reactionSpan.insertBefore(reactionAdd);
        }
        if (message.isSelf()) {
            reactionSpan.data('self', true);
            reactionSpan.addClass('reaction--self');
            reactionSpan.removeClass('reaction--active');
            reactionSpan.removeAttr('role');
        } else {
            reactionSpan.attr('role', 'button');
        }
        // This gets read in flushBuffer to determine scroll updating
        options.reaction = true;
        return true;
    },
    renderQuoteReply: function (message, line) {
        var quoteReplyString = message.quoteReplyString();
        if (quoteReplyString) {
            var quoteReply = '<span class="link">';
            quoteReply += this.formatter.escapeText(quoteReplyString);
            quoteReply += '</span>';
            line.find('.reply__quote').html(quoteReply);
        }
    },
    renderReplySummary: function (message, reply, row) {
        reply = reply || message.getReply();
        row = row || this.getMsgIdRow(reply);
        if (!row.length) {
            return;
        }
        var replyTooltip = row.find('.reply__tooltip');
        var replySummary = row.find('.reply__summary');
        var replies = message.getReplies();
        if (replies.length) {
            if (!replyTooltip.length) {
                replySummary = $('<span class="reply__summary">');
                row.addClass('reply reply_' + this.formatter.getReplyColorIndex(reply));
                if (this.buffer.isThreadCollapsedOverride(reply)) {
                    row.addClass('reply__top--collapsed');
                }
                if (this.buffer.isThreadExpandedOverride(reply)) {
                    row.addClass('reply__top--expanded');
                }
                row.attr('data-reply', reply);

                replyTooltip = $('<span class="reply__tooltip">');
                row.append(replyTooltip);
                row.append(replySummary);
            }
            var repliers = _.unique(_.invoke(replies, 'getDisplayName'));
            var replyText = replies.length + ' ' + this.formatter.pluralise(replies.length, 'reply', 'replies');
            replySummary.html('<i class="fa fa-comment"></i>');
            replySummary.append($('<span class="link">').text(replyText + ': ' + this.formatter.listSentence(repliers)));
            replyTooltip.text(replyText);
            return true;
        } else {
            row.removeClass('reply reply_' + this.formatter.getReplyColorIndex(reply));
            row.removeAttr('data-reply');
            replyTooltip.remove();
            replySummary.remove();
        }
    },
    renderMessage: function (message, options) {
        options = options || {};
        var rows = this.lineRenderer.render(message, options).flush();
        if (!rows.length) {
            return $();
        }
        var classNames = [];
        if (this.lineRenderer.endedConcat) {
            _.each(this.lineRenderer.endedConcat, function (m) {
                if (!m.equals(message)) {
                    this.handleClientTags(m, options);
                }
            }, this);
        } else if (this.lineRenderer.createdJoinPart || this.lineRenderer.createdDiscoGroup) {
            var lastMessageRow = options.lastMessageRow;
            if (!lastMessageRow) {
                lastMessageRow = this.$('.messageRow:last');
            }
            if (options.batch) {
                options.toExclude = options.toExclude.add(lastMessageRow);
            }
            lastMessageRow.remove();
        } else if (this.lineRenderer.joinPart) {
            var lastJoinPartHeading = options.lastJoinPartHeading;
            if (!lastJoinPartHeading) {
                lastJoinPartHeading = this.$('.groupedJoinPart:last');
            }
            if (lastJoinPartHeading.is('.expanded') || this.lineRenderer.joinPart.expanded) {
                classNames.push('expanded');
            }
            if (options.batch) {
                options.toExclude = options.toExclude.add(lastJoinPartHeading)
                    .add(lastJoinPartHeading.next('.joinPartGroup'));
            }
            lastJoinPartHeading.next('.joinPartGroup').remove();
            lastJoinPartHeading.remove();
        } else if (this.lineRenderer.discoGroup) {
            var lastDiscoHeading = options.lastDiscoHeading;
            if (!lastDiscoHeading) {
                lastDiscoHeading = this.$('.groupedDisco:last');
            }
            if (lastDiscoHeading.is('.expanded') || this.lineRenderer.discoGroup.expanded) {
                classNames.push('expanded');
            }
            if (options.batch) {
                options.toExclude = options.toExclude.add(lastDiscoHeading)
                    .add(lastDiscoHeading.next('.discoGroup'))
                    .add(lastDiscoHeading.next('.groupedDiscoPart'));
            }
            lastDiscoHeading.next('.discoGroup').remove();
            lastDiscoHeading.next('.groupedDiscoPart').remove();
            lastDiscoHeading.remove();
        }
        
        if (message.get('entities')
            && message.get('entities').files
            && message.get('entities').files[0]
            && message.get('entities').files[0].url
        ) {
            classNames.push('fileLoading');
        }
        if (options.batch) {
            return this.prepareFilterClassNames(rows, classNames);
        } else {
            return this.append(rows, classNames, message);
        }
    },
    append: function (rows, classNames, message) {
        var els = this.prepareInsertion(rows, classNames);
        $(this.el).append(els);
        var reqid;
        if (message) {
            reqid = message.get('reqid');
        }
        this.postInsertion(els, false, reqid);
        return els;
    },
    removeRow: function (row, options) {
        if (options && options.batch) {
            options.toExclude = options.toExclude.add(row);
            options.toRemove = options.toRemove.add(row);
        } else {
            row.remove();
        }
    },
    replaceRow: function (row, rows, message, messageId, options) {
        this.removeRow(this.getLine(message), options);

        options = options || {};
        var els = this.prepareFilterClassNames(rows);
        if (options.batch) {
            if (message.get('reqid')) {
                if (options.reqidMap[message.get('reqid')]) {
                    els = options.reqidMap[message.get('reqid')].add(els);
                }
                options.reqidMap[message.get('reqid')] = els;
            } else {
                options.nonReqidEls = options.nonReqidEls.add(els);
            }
            options.toExclude = options.toExclude.add(row);
            options.toReplace[messageId] = els;
        } else {
            this.prepareEmbeds(els);
            this.doReplaceRow(row, els, messageId);
            this.postInsertion(els);
        }
    },
    doReplaceRow: function (row, els, messageId) {
        var reply = row.attr('data-reply');
        var reactionContainer = row.find('.reactions').clone(true);
        var replyToolTip = row.find('.reply__tooltip').clone(true);
        var replySummary = row.find('.reply__summary').clone(true);
        row.replaceWith(els);
        var newRow = this.getMsgIdRow(messageId);
        if (reply) {
            newRow.addClass('reply reply_' + this.formatter.getReplyColorIndex(reply));
            newRow.attr('data-reply', reply);
        }
        if (reactionContainer.length) {
            newRow.append(reactionContainer);
        }
        if (replyToolTip.length) {
            newRow.append(replyToolTip);
        }
        if (replySummary.length) {
            newRow.append(replySummary);
        }
    },
    prepareInsertion: function (rows, classNames, initial) {
        var els = this.prepareFilterClassNames(rows, classNames);
        this.prepareEmbeds(els, initial);
        return els;
    },
    postInsertion: function (els, initial, reqid) {
        this.loadFiles(els, initial, reqid);
    },
    prepareFilterClassNames: function (rows, classNames) {
        // Filter empty items
        var els = $(_.filter($.makeArray(rows), _.identity).join(''));
        if (classNames && classNames.length) {
            els.addClass(classNames.join(' '));
        }
        return els;
    },
    processConsecutiveQuotes: function (els, initial) {
        els.find('blockquote.quote + span.g + blockquote.quote').each(function (i, q) {
            // Adjacent sibling selector ignores non-elment nodes, only add this class
            // if there isn't e.g. a text node in between
            if ($(q.previousSibling.previousSibling).is('blockquote.quote')) {
                $(q).addClass('quote--consecutive');
            }
        });
    },
    prepareEmbeds: function (els, initial) {
        this.processConsecutiveQuotes(els, initial);
        this.loadTwitchBadges(els, initial);
        if (this.buffer.inlineImagesAllowed()) {
            this.inlineImages(els, initial);
        } else {
            this.loadTwitchEmotes(els, initial);
        }
        this.loadAttachmentSnippets(els, initial);
        if (this.buffer.inlinePastesAllowed()) {
            this.loadPastes(els, initial);
            this.loadGists(els, initial);
            // Pastebin.com
            this.loadEmbedIframes(els, initial);
        }
        if (this.buffer.inlineSocialMediaAllowed()) {
            this.loadTweets(els, initial);
        }
        if (this.buffer.inlineMastodonAllowed()) {
            this.loadMastodon(els, initial);
        }
        if (this.buffer.inlineBskyAllowed()) {
            this.loadBsky(els, initial);
        }
        if (this.buffer.inlineRedditAllowed()) {
            this.loadReddit(els, initial);
        }
    },


    // Element at position
    getRowAtPosition: function (x, y) {
        var targets = atPoint(x, y, 'div.row', 'div.scroll, div.timecell');
        var target = targets.pop();
        if (!target) {
            return $();
        }
        return $(target).closest('div.row');
    },
    getRowAtTopOfScroll: function () {
        var clientRect = this.scroll.getRect();
        var offsets = this.scroll.rowPositionOffsets();
        var y = clientRect.top + offsets.y;
        var x = clientRect.left + offsets.x;
        var initialRow = this.getRowAtPosition(Math.ceil(x), Math.ceil(y));
        var row = initialRow;
        
        // If the row isn't fully visible in the viewport the scroll, use the next row
        if (row.length) {
            var delta = y - row.offset().top;
            // var rowHeight = row.outerHeight();
            // var halfHeight = rowHeight / 2;
            // if (delta > halfHeight) { // alternative if we want to allow half of the row to be invisible
            if (delta > 1) {
                var previousRow;
                do {
                    previousRow = row;
                    row = row.next();
                    if (row.is('.joinPartGroup')) {
                        row = row.find('.row:first-child');
                    } else if (!row.length && previousRow.is('.joinPartGroup .row')) {
                        row = previousRow.closest('.joinPartGroup').next();
                    }
                } while (row.length && !row.is(':visible'));
                if (!row.length || !row.is(':visible')) {
                    row = initialRow;
                }
            }
        }
        return [row, initialRow];
    },
    getRowAtBottomOfScroll: function () {
        var clientRect = this.scroll.getRect();
        var x = clientRect.left;
        var y = clientRect.bottom - 2;
        var initialRow = this.getRowAtPosition(Math.ceil(x), Math.floor(y));
        var row = initialRow;
        
        // If more than half the row is off the bottom of the viewport, use the previous row
        if (row.length) {
            var delta = y - row.offset().top;
            var rowHeight = row.outerHeight();
            var halfHeight = rowHeight / 2;
            // if (delta < rowHeight - 1) { // alternative if we want to make sure the full row is visible
            if (delta < halfHeight) {
                var previousRow;
                do {
                    previousRow = row;
                    row = row.prev();
                    if (row.is('.joinPartGroup')) {
                        row = row.find('.row:last-child');
                    } else if (!row.length && previousRow.is('.joinPartGroup .row')) {
                        row = previousRow.closest('.joinPartGroup').prev();
                    }
                } while (row.length && !row.is(':visible'));
                if (!row.length || !row.is(':visible')) {
                    row = initialRow;
                }
            }
        }
        return [row, initialRow];
    },
    
    resetStickyAuthorRow: function () {
        if (this.stickyAuthor) {
            this.stickyAuthor.removeClass('firstAuthor--sticky');
            this.stickyAuthor = null;
        }
    },
    setStickyAuthorRow: function (row) {
        if (this.stickyAuthor && this.stickyAuthor != row) {
            this.resetStickyAuthorRow();
        }
        this.stickyAuthor = row;
        row.addClass('firstAuthor--sticky');
    },
    setStickyAuthor: function (rows) {
        if (!this.buffer.avatarsEnabled() || !this.buffer.multiline()) {
            // Not the right layout
            return this.resetStickyAuthorRow();
        }
        
        var actualTop = rows[1];
        if (!actualTop.is('.sameAuthor, .firstAuthor')) {
            // Not the right message at top
            return this.resetStickyAuthorRow();
        }
        
        var firstAuthor;
        if (actualTop.is('.sameAuthor')) {
            firstAuthor = actualTop
                .prevAll('.firstAuthor:first');
        } else {
            firstAuthor = actualTop;
        }
        
        if (!firstAuthor.length) {
            // Can be missing a first author if the
            // backlog has been trimmed
            return this.resetStickyAuthorRow();
        }
        
        // Keep these synced with CSS
        var avatarHeight = 32;
        var avatarOffset = 8;
        
        var avatarBottom = avatarHeight + avatarOffset;
        
        var firstAvatar = firstAuthor.find('.avatar');
        var firstAuthorRect = firstAuthor[0].getBoundingClientRect();
        var avatarTop = firstAuthorRect.top + avatarOffset;
        var clientRect = this.scroll.getRect();
        var offsets = this.scroll.rowPositionOffsets();
        var scrollTop = clientRect.top + offsets.y;
        if (avatarTop >= scrollTop) {
            // Top avatar is already fully visible
            return this.resetStickyAuthorRow();
        }
        
        var lastAuthor = firstAuthor.nextUntil(':not(.sameAuthor)', '.messageRow').last();
        var lastAuthorRect;
        if (lastAuthor.length) {
            lastAuthorRect = lastAuthor[0].getBoundingClientRect();
        } else {
            lastAuthor = firstAuthor;
            lastAuthorRect = firstAuthorRect;
        }
        var lastTop = lastAuthorRect.bottom - avatarBottom;
        if (lastTop <= avatarTop) {
            // Top avatar is already visible enough
            return this.resetStickyAuthorRow();
        }
        
        var top = Math.min(lastTop - clientRect.top, offsets.y);
        this.setStickyAuthorRow(firstAuthor);
        var eid = firstAuthor.data('eid');
        return [firstAvatar, top, eid];
    },

    hoverTimestamp: function (e) {
        $(e.target).closest('.row').addClass('timestampHighlight');
    },
    unhoverTimestamp: function (e) {
        $(e.target).closest('.row').removeClass('timestampHighlight');
    },
    hoverMessageActions: function (e) {
        $(e.target).closest('.row').addClass('messageActionHighlight');
    },
    unhoverMessageActions: function (e) {
        $(e.target).closest('.row').removeClass('messageActionHighlight');
    },
    clickDate: function (e) {
        var row = $(e.currentTarget).closest('.row');
        var msg = this.buffer.getMessage(row.data('eid'));
        this.buffer.session.trigger('clickedMessageDate', msg);
        return false;
    },
    clickDeleteMessage: function (e) {
        var target = $(e.currentTarget);
        var row = target.closest('.row');
        var msg = this.buffer.getMessage(row.data('eid'));
        this.buffer.trigger('deleteMessageConfirm', msg);
        return false;
    },
    clickEditMessage: function (e) {
        var target = $(e.currentTarget);
        var row = target.closest('.row');
        var msg = this.buffer.getMessage(row.data('eid'));
        this.buffer.trigger('editMessagePrompt', msg);
        return false;
    },
    clickReactAdd: function (e) {
        var target = $(e.currentTarget);
        var row = target.closest('.row');
        var msg = this.buffer.getMessage(row.data('eid'));
        this.buffer.session.trigger('clickedMessageReactAdd', msg, target);
        return false;
    },
    clickReplyToggle: function (e) {
        var target = $(e.currentTarget);
        var row = target.closest('.row');
        var reply = row.data('reply');
        var topRow = this.getMsgIdRow(reply);
        var rows = this.getReplyRows(reply).not(topRow);
        var tooltip = topRow.find('.reply__tooltip');

        var collapsed = this.buffer.isThreadCollapsedOverride(reply);
        var expanded = this.buffer.isThreadExpandedOverride(reply);
        var bufCollapsed = this.buffer.isCollapsingReplies();
        if (bufCollapsed) {
            // All buffer threads collapsed
            // Set expanded status
            this.buffer.setThreadExpandedOverride(reply, !expanded);
            // Remove unneeded overrides
            topRow.removeClass('reply__top--collapsed');
            rows.removeClass('reply--collapsed');
            // Set class
            topRow.toggleClass('reply__top--expanded', !expanded);
            rows.toggleClass('reply--expanded', !expanded);
        } else {
            // All buffer threads expanded (default)
            // Set collapsed status
            this.buffer.setThreadCollapsedOverride(reply, !collapsed);
            // Remove unneeded overrides
            topRow.removeClass('reply__top--expanded');
            rows.removeClass('reply--expanded');
            // Set class
            topRow.toggleClass('reply__top--collapsed', !collapsed);
            rows.toggleClass('reply--collapsed', !collapsed);
        }
        this.scroll.onChange();
        return false;
    },
    clickAttachmentTextToggle: function (e) {
        $(e.currentTarget).closest('.attachment__text').toggleClass('attachment__text--more');
        return false;
    },
    mouseGroupedJoinPart: function (e) {
        if (!this.buffer.isCollapsingJoinPart()) {
            return;
        }
        var target = $(e.currentTarget);
        var group, heading;
        if (target.is('.joinPartGroup')) { 
            group = target;
            heading = group.prev('.groupedJoinPart');
        } else {
            heading = target;
            group = heading.next('.joinPartGroup');
        }
        this.mouseGrouped(e, group, heading);
    },
    mouseGroupedDisco: function (e) {
        if (this.buffer.isServerLog() && !this.buffer.isCollapsingDisconnects()) {
            return;
        }
        var target = $(e.currentTarget);
        var group, heading;
        if (target.is('.discoGroup')) { 
            group = target;
            heading = group.prev('.groupedDisco');
        } else {
            heading = target;
            group = heading.next('.discoGroup');
        }
        this.mouseGrouped(e, group, heading);
    },
    mouseGrouped: function (e, group, heading) {
        switch (e.type) {
        case 'buttonClick':
            this.toggleGrouped(e, group, heading);
            break;
        case 'mousedown':
            group.data('mousecoords', [e.clientX, e.clientY, util.ts()]);
            group.removeData('mousemove');
            group.removeData('dblclick');
            break;
        case 'mousemove':
            group.data('mousemove', true);
            break;
        case 'dblclick':
            group.data('dblclick', true);
            break;
        case 'click':
            var coords = group.data('mousecoords');
            var mousemove = group.data('mousemove');
            group.removeData('mousecoords');
            group.removeData('mousemove');
            group.removeData('dblclick');
            
            var dblclickDelay = 200;
            
            if (mousemove) {
                var diffs = [
                    e.clientX - coords[0],
                    e.clientY - coords[1],
                    util.ts() - coords[2]
                ];
                if (diffs[0] !== 0 || diffs[1] !== 0 || diffs[2] > dblclickDelay) {
                    debug.log('canceling toggle due to move, diffs:', diffs);
                    return;
                }
            }
            setTimeout(_.bind(function () {
                if (!group.data('dblclick')) {
                    this.toggleGrouped(e, group, heading);
                } else {
                    debug.log('canceling toggle due to dblclick');
                }
            }, this), dblclickDelay);
            
            break;
        }
    },
    toggleGrouped: function (e, group, heading) {
        if ($(e.target).is('a, button')) {
            return;
        }
        heading.toggleClass('expanded');
        var expanded = heading.hasClass('expanded');
        heading.attr('aria-expanded', String(expanded));
        group.animate({
            "height": 'toggle',
            "marginTop": 'toggle',
            "marginBottom": 'toggle',
            "paddingTop": 'toggle',
            "paddingBottom": 'toggle'
        }, {
            duration: 'fast',
            step: _.bind(function () {
                this.scroll.onChange();
            }, this),
            complete: function () {
                group.toggleClass('expanded');
                group.css('display', '');
            }
        });
    },

    inlineImages: function (els, initial) {
        this.triggerImagesLoaded(els, initial);
        this.loadEmbedIframes(els, initial);
        this.loadFlickr(els, initial);
        this.loadSoundCloud(els, initial);
        this.loadStreamableCom(els, initial);
        this.loadInstagram(els, initial);
        this.loadPinterest(els, initial);
        this.loadXKCD(els, initial);
        this.loadImgur(els, initial);
        this.loadGfyCat(els, initial);
        this.loadWiki(els, initial);
    },
    loadMedia: function (els, selector, onLoad, initial, reqid) {
        var boundOnLoad = _.bind(onLoad, this, els, initial, reqid);
        this.registerDelayedLoad(els, selector, boundOnLoad);
        return boundOnLoad;
    },
    initDelayedLoads: function () {
        this.delayedLoads = {};
        this.delayedLoadIds = 0;
    },
    checkDelayedLoads: function () {
        return _.map(this.delayedLoads, this.checkDelayedLoad, this);
    },
    checkDelayedLoad: function (args, delayedLoadId) {
        var els = args[0];
        var selector = args[1];
        var boundOnLoad = args[2];
        var timeoutTs = args[3];
        var lastLen = args[4];
        if (util.ts() < timeoutTs) {
            var len = els.find(selector).filter(function (i, e) {
                return $.contains(document, e);
            }).length;
            if (len > 0) {
                if (len != lastLen) {
                    lastLen = len;
                    args[4] = lastLen;
                    this.delayedLoads[delayedLoadId] = args;
                    return boundOnLoad;
                }
                return;
            }
        }
        this.unregisterDelayedLoad(delayedLoadId);
    },
    registerDelayedLoad: function (els, selector, boundOnLoad, timeout) {
        var timeoutTs = util.ts() + (timeout || 60000);
        this.delayedLoads[this.delayedLoadIds++] = [els, selector, boundOnLoad, timeoutTs];
        return boundOnLoad;
    },
    unregisterDelayedLoad: function (delayedLoadId) {
        delete this.delayedLoads[delayedLoadId];
    },
    doOembed: function (url, data, a, spin, checkLenLoad, options) {
        var oembedUrl;
        if (_.isFunction(options.oembedUrl)) {
            oembedUrl = options.oembedUrl(url, data);
        } else {
            oembedUrl = options.oembedUrl;
        }
        var ajaxOptions = {
            type: 'get',
            url: oembedUrl,
            cache: true,
            dataType: options.dataType || 'jsonp'
        };
        if (options.oembedData) {
            ajaxOptions.data = options.oembedData(url, data, a);
        }
        if (options.jsonp) {
            ajaxOptions.jsonp = options.jsonp;
        }
        this.buffer.session.ajax(ajaxOptions, options.filter)
            .done(_.bind(function (response) {
                return options.render(a, spin, url, response, data);
            }, this))
            .fail(_.bind(function () {
                spin.remove();
                $(a).addClass('error');
            }, this))
            .always(_.bind(function () {
                $(a).removeClass('loading');
                checkLenLoad();
            }, this));
    },
    loadOembed: function (els, initial, options) {
        var selector = 'a.' + options.className + '.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var loaded = _.bind(this.triggerImagesLoaded, this, els, initial);
        var checkLenLoad = _.bind(function checkLenLoad () {
            --len;
            if (len === 0) {
                this.mediaLoaded(els, initial);
                loaded();
            }
        }, this);
        items.each(_.bind(function loadOembedEach (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            if (options.prefilter) {
                options.prefilter(url, data).done(_.bind(function (filteredData) {
                    this.doOembed(url, filteredData, a, spin, checkLenLoad, options);
                }, this)).fail(function () {
                    spin.remove();
                    $(a).addClass('error');
                    checkLenLoad();
                }).always(function () {
                    $(a).removeClass('loading');
                });
            } else {
                this.doOembed(url, data, a, spin, checkLenLoad, options);
            }
        }, this));

        return this;
    },
    buildFramePromise: function (
        url, maxSide, className, css,
        postMessageFilter, postMessageFilterTimeout,
        whitelistOrigin, onFrameLoad
    ) {
        var $iframe = $('<iframe class="loading">').addClass(className).attr(_.extend({
            'src': url
        }, this.formatter.linker.iframeProps())).css(_.extend({
            'width': maxSide,
            'height': 0,
            'visibility': 'hidden'
        }, css));
        var complete = new $.Deferred().done(_.bind(function (height) {
            $iframe.data('css', {
                'visibility': 'visible',
                'height': height
            });
            $iframe.addClass('loaded');
        }, this)).fail(function () {
            $iframe.addClass('error');
        }).always(function () {
            $iframe.removeClass('loading');
        });
        var whitelistId;
        if (whitelistOrigin) {
            whitelistId = this.buffer.session.postMessageTempWhitelist(whitelistOrigin);
        }
        $iframe.one('load', _.bind(function (e) {
            if (onFrameLoad) {
                onFrameLoad($iframe);
            }
            this.buffer.session.findMessage(function (event) {
                if (event.source !== $iframe[0].contentWindow) {
                    return false;
                }
                try {
                    var frameData = event.data;
                    if (typeof frameData === 'string') {
                        frameData = JSON.parse(frameData);
                    }
                    return postMessageFilter(frameData);
                } catch (exc) {
                    return null;
                }
            },
            postMessageFilterTimeout || 5000,
            whitelistId).done(_.bind(function (frameData) {
                complete.resolve(frameData);
            }, this)).fail(function () {
                complete.reject();
            });
        }, this));
        var promise = complete.promise();
        
        promise.iframe = $iframe;
        return promise;
    },
    buildGfycatFramePromise: function (gfycatId, width, height) {
        var url = 'https://gfycat.com/ifr/' +
            this.formatter.escapeText(encodeURIComponent(gfycatId));
        return this.buildFramePromise(url, width, 'gfycat', {}, function (frameData) {
            if (frameData.event == 'ready') {
                return height;
            }
            return null;
        });
    },
    buildInstagramFramePromise: function (embedId, embedType, maxSide) {
        var url = 'https://www.instagram.com/' + embedType + '/' +
            this.formatter.escapeText(encodeURIComponent(embedId)) +
            '/embed/captioned/?' +
            $.param({
                cr: 1,
                v: 7,
                wp: maxSide
            });
        return this.buildFramePromise(url, maxSide, 'instagram', {
            'border': '1px solid #ddd'
        }, function (frameData) {
            if (frameData.type == 'MEASURE' && frameData.details && frameData.details.height) {
                return frameData.details.height;
            }
            return null;
        });
    },
    buildMastodonFramePromise: function (origin, url, maxSide) {
        var embedUrl = url + '/embed';
        return this.buildFramePromise(embedUrl, maxSide, 'mastodon', {}, function (frameData) {
            if (frameData.type == 'setHeight' && frameData.height) {
                return frameData.height;
            }
            return null;
        }, 5000, origin, function ($iframe) {
            $iframe[0].contentWindow.postMessage({type: 'setHeight'}, '*');
        });
    },
    buildBskyFramePromise: function (did, post, maxSide) {
        var url = 'https://embed.bsky.app/embed/' + this.formatter.escapeText(did) + '/app.bsky.feed.post/' + this.formatter.escapeText(post);
        return this.buildFramePromise(url, maxSide, 'bsky', {}, function (frameData) {
            if (frameData.height) {
                return frameData.height;
            }
            return null;
        });
    },
    buildRedditFramePromise: function (sub, post, maxSide) {
        var theme = this.buffer.session.isLightTheme() ? '' : 'dark';
        var url = 'https://embed.reddit.com/r/' + this.formatter.escapeText(sub) +
            '/comments/' + this.formatter.escapeText(post) +
            '?' +
            $.param({
                embed: 'true',
                theme: theme
            });
        return this.buildFramePromise(url, maxSide, 'reddit', {}, function (frameData) {
            if (frameData.type == "resize.embed" && frameData.data) {
                return frameData.data;
            }
            return null;
        });
    },
    buildImgurFramePromise: function (embedId, maxSide) {
        var url = 'https://imgur.com/' +
            this.formatter.escapeTextMinimal(encodeURIComponent(embedId).replace(/%2f/gi, '/')) +
            '/embed?' +
            $.param({
                pub: true,
                ref: this.buffer.session.getOrigin(),
                w: maxSide
            });
        return this.buildFramePromise(url, maxSide, 'imgur', {
            'border': '1px solid #ddd'
        }, function (frameData) {
            if (frameData.message == 'resize_imgur') {
                return frameData.height;
            }
            return null;
        });
    },
    loadImgur: function (els, initial) {
        var selector = 'a.imgur.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var imgurLoaded = this.loadMedia(els, selector, this.imgurLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            var imgurOembed = 'https://api.imgur.com/oembed.json?url=';
            var imgurRoot = 'https://imgur.com/';
            var imgurIRoot = 'https://i.imgur.com/';
            var ajaxOptions = {
                type: 'get',
                url: imgurOembed + encodeURIComponent(imgurRoot + data.imgur_embed_prefix + data.imgur_embed),
                cache: true,
                dataType: 'json'
            };
            var filter = function (response) {
                if (response.type == 'rich' && response.html) {
                    var oEmbed = $('<div>' + response.html + '</div>');
                    var embedId = oEmbed.find('blockquote.imgur-embed-pub').data('id');
                    if (embedId) {
                        return embedId;
                    }
                }
                return false;
            };

            var complete = $.Deferred()
                .done(_.bind(function (embedId) {
                    // Add to DOM
                    var maxSide = 390;
                    var framePromise = this.buildImgurFramePromise(embedId, maxSide);
                    this.loadIframe(framePromise, a, maxSide);
                    framePromise.always(_.bind(function () {
                        spin.remove();
                        --len;
                        if (len === 0) {
                            imgurLoaded();
                        }
                    }, this));
                }, this))
                .fail(_.bind(function () {
                    spin.remove();
                    $(a).addClass('error');
                    --len;
                    if (len === 0) {
                        imgurLoaded();
                    }
                }, this))
                .always(_.bind(function () {
                    $(a).removeClass('loading');
                }, this));
            var done = function (embedId) {
                complete.resolve(embedId);
            };
            this.buffer.session.ajax(ajaxOptions, filter).done(done)
                .fail(_.bind(function () {
                    if (data.imgur_embed_prefix) {
                        ajaxOptions.url = imgurOembed + encodeURIComponent(imgurRoot + data.imgur_embed);
                        this.buffer.session.ajax(ajaxOptions, filter).done(done)
                            .fail(_.bind(function () {
                                ajaxOptions.url = imgurOembed + encodeURIComponent(imgurIRoot + data.imgur_embed);
                                this.buffer.session.ajax(ajaxOptions, filter).done(done)
                                    .fail(_.bind(function () {
                                        complete.reject();
                                    }, this));
                            }, this));
                    } else {
                        ajaxOptions.url = imgurOembed + encodeURIComponent(imgurIRoot + data.imgur_embed);
                        this.buffer.session.ajax(ajaxOptions, filter).done(done)
                            .fail(_.bind(function () {
                                complete.reject();
                            }, this));
                    }
                }, this));
        }, this));
    },
    loadWiki: function (els, initial) {
        this.loadOembed(els, initial, {
            className: 'wiki',
            prefilter: _.bind(function (url, data) {
                var complete = $.Deferred();
                if (!this.loadWikiSpecialsPromise) {
                    // https://meta.wikimedia.org/w/api.php?action=help&modules=sitematrix
                    // https://meta.wikimedia.org/wiki/Special:SiteMatrix
                    this.loadWikiSpecialsPromise = this.buffer.session.ajax({
                        url: 'https://meta.wikimedia.org/w/api.php?action=sitematrix&format=json',
                        cache: true,
                        dataType: 'jsonp'
                    }, function (response) {
                        if (response) {
                            var map = {};
                            _.each(response.sitematrix, function (item, key) {
                                if (key == 'specials' && _.isArray(item)) {
                                    _.each(item, function (special) {
                                        if (!('closed' in special)) {
                                            map[special.url] = {
                                                name: special.sitename
                                            };
                                        }
                                    });
                                } else if (key.match(/^\d+$/) && _.isArray(item.site)) {
                                    _.each(item.site, function (site) {
                                        if (!('closed' in site)) {
                                            map[site.url] = {
                                                name: site.sitename,
                                                native_name: item.name,
                                                english_name: item.localname
                                            };
                                        }
                                    });
                                }
                            });
                            return map;
                        }
                        return false;
                    });
                }

                this.loadWikiSpecialsPromise.then(function (map) {
                    var wikiUrl = 'https://' + data.wiki_host;
                    var site = map[wikiUrl];
                    if (site) {
                        data.wiki_url = wikiUrl;
                        data.wiki_props = site;
                        complete.resolve(data);
                    } else {
                        complete.reject();
                    }
                }).fail(function () {
                    complete.reject();
                });
                return complete;
            }, this),
            dataType: 'jsonp',
            oembedUrl: function (url, data) {
                return data.wiki_url + '/w/api.php';
            },
            oembedData: function (url, data) {
                return {
                    action: 'query',
                    prop: 'imageinfo',
                    iiprop: 'url',
                    titles: data.wiki_title,
                    format: 'json'
                };
            },
            filter: function (response) {
                if (response && response.query && response.query.pages) {
                    for (var k in response.query.pages) {
                        if (response.query.pages[k].imageinfo && response.query.pages[k].imageinfo[0]) {
                            return response.query.pages[k];
                        }
                    }
                }
                return false;
            },
            render: _.bind(function (a, spin, url, response, data) {
                // Add to DOM
                var close, embed;
                var img = $('<img class="image loading">').attr({
                    src: urlUtil.toHttps(response.imageinfo[0].url),
                    alt: response.title
                });
                var imgLink = this.makeEmbedLink(url, img).attr('title', response.title);
                close = this.makeClose();
                embed = $('<span class="embedWrap">').append(imgLink, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    makeClose: function (type) {
        type = type || 'image';
        return $('<a href="" class="embedClose">').attr('title', 'Close ' + type);
    },
    makeSpin: function (url) {
        return this.makeEmbedLink(url, this.formatter.embedSpin(), 'image spin');
    },
    makeEmbedLink: function (url, embed, className) {
        className = className || 'image';
        return this.makeLink(url, className)
            .attr('tabindex', '-1')
            .append(embed);
    },
    makeLink: function (url, className) {
        var link = $('<a rel="noreferrer" target="_blank">').attr('href', url);
        if (className) {
            link.addClass(className);
        }
        return link;
    },
    loadFlickr: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'flickr',
            oembedUrl: 'https://www.flickr.com/services/oembed',
            oembedData: function (url) {
                return {
                    url: url,
                    format: 'json'
                };
            },
            dataType: 'jsonp',
            jsonp: 'jsoncallback',
            filter: function (response) {
                if (response) {
                    if (response.type == 'photo' && (response.url || response.thumbnail_url)) {
                        return true;
                    }
                    if (response.type == 'video' && response.html && response.width) {
                        return true;
                    }
                }
                return false;
            },
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                var close, embed;
                if (response.type == 'photo') {
                    var photoUrl, photoHeight;
                    if (response.url) {
                        photoUrl = response.url;
                        photoHeight = response.height;
                    } else {
                        photoUrl = response.thumbnail_url;
                        photoHeight = response.thumbnail_height;
                    }
                    var img = $('<img class="image loading">').attr({
                        src: urlUtil.toHttps(photoUrl),
                        alt: response.title
                    });
                    var imgLink = this.makeEmbedLink(url, img).attr('title', response.title);
                    close = this.makeClose();
                    embed = $('<span class="embedWrap">').append(imgLink, close);
                    $(a).closest('.content').append(embed);
                } else {
                    spin.remove();
                    close = this.makeClose('video').css('left', response.width);
                    embed = $('<span class="embedWrap">').append(response.html.replace(/http:/g, 'https:'), close);
                    $(a).closest('.content').append(embed);
                    this.scroll.onChange();
                }
            }, this)
        });
    },
    loadSoundCloud: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'soundcloud',
            oembedUrl: 'https://soundcloud.com/oembed.json',
            oembedData: function (url) {
                return {
                    url: url
                };
            },
            filter: function (response) {
                if (response && response.html) {
                    return true;
                }
                return false;
            },
            dataType: 'json',
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                spin.remove();
                var urlParts = new window.URL(a.href);
                urlParts.hostname = urlParts.hostname.replace(/^www\./, '');
                var widgetSrc = 'https://w.soundcloud.com/player/?' + $.param({
                    url: urlParts.href,
                    color: 'ff5500',
                    auto_play: 'false',
                    hide_related: 'false',
                    show_comments: 'true',
                    show_artwork: 'false'
                });
                var html = $('<iframe class="video" width="416" height="116">').attr(_.extend({
                    'src': widgetSrc
                }, this.formatter.linker.iframeProps()));
                var close = this.makeClose().css('left', 416);
                var embed = $('<span class="embedWrap">').append(html, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    loadStreamableCom: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'streamablecom',
            oembedUrl: 'https://api.streamable.com/oembed.json',
            oembedData: function (url) {
                return {
                    url: url
                };
            },
            filter: function (response) {
                if (response.type == 'video' && response.html) {
                    var oEmbed = $('<div>' + response.html + '</div>');
                    var embedSrc = oEmbed.find('iframe.streamable-embed').attr('src');
                    if (embedSrc) {
                        return {
                            src: embedSrc.replace(/^http:/, 'https:'),
                            title: response.title
                        };
                    }
                }
                return false;
            },
            dataType: 'json',
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                spin.remove();
                var iframe = $('<iframe class="video">').attr(_.extend({
                    'src': response.src,
                    'width': 416,
                    'height': 234
                }, this.formatter.linker.iframeProps()));
                var close = this.makeClose('video').css('left', 416);
                var embed = $('<span class="embedWrap">').append(iframe, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    loadIframe: function (framePromise, a, maxSide) {
        var renderFrame = _.bind(function () {
            var embed = $('<span class="embedWrap">').append(framePromise.iframe);
            var close = this.makeClose('embed').css('left', maxSide);
            embed.append(close);
            $(a).closest('.content').append(embed);
            this.scroll.onChange();
        }, this);
        if (this.isSelected()) {
            renderFrame();
        } else {
            this.buffer.once('selectedChange', renderFrame);
        }
    },
    loadInstagram: function (els, initial) {
        var selector = 'a.instagram.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var instagramLoaded = this.loadMedia(els, selector, this.instagramLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            // Add to DOM
            var maxSide = 390;
            var framePromise = this.buildInstagramFramePromise(
                data.photo_id, data.insta_type, maxSide
            );
            this.loadIframe(framePromise, a, maxSide);
            framePromise.always(_.bind(function () {
                spin.remove();
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    instagramLoaded();
                }
            }, this));
        }, this));
    },
    loadMastodon: function (els, initial) {
        var selector = 'a.mastodon.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var mastodonLoaded = this.loadMedia(els, selector, this.mastodonLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            var checkLenLoad = _.bind(function checkLenLoad () {
                spin.remove();
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    mastodonLoaded();
                }
            }, this);

            // Add to DOM
            var maxSide = 500;
            var fetchUrl = data.mastodon_origin + '/api/v1/statuses/' + data.mastodon_status;
            fetch(fetchUrl).then(function (response) {
                return response.json();
            }).then(_.bind(function (apiData) {
                var userOrigin;
                if (data.mastodon_userinstance) {
                    userOrigin = 'https://' + data.mastodon_userinstance;
                } else {
                    userOrigin = data.mastodon_origin;
                }
                var userUrl = userOrigin + '/@' + data.mastodon_username;
                if (userUrl !== apiData.account.url) {
                    checkLenLoad();
                    return;
                }
                var urlParts = urlUtil.urlParts(apiData.url);
                if (urlParts.protocol !== 'https:') {
                    checkLenLoad();
                    return;
                }
                var framePromise = this.buildMastodonFramePromise(
                    urlParts.origin, urlParts.href, maxSide
                );

                var renderFrame = _.bind(function () {
                    var embed = $('<div class="mastodonwrap">').append(framePromise.iframe);
                    var close = this.makeClose('post').css('left', maxSide);
                    embed.append(close);
                    $(a).closest('.content').append(embed);
                    this.scroll.onChange();
                }, this);
                if (this.isSelected()) {
                    renderFrame();
                } else {
                    this.buffer.once('selectedChange', renderFrame);
                }
                
                framePromise.always(checkLenLoad);
            }, this)).catch(function () {
                checkLenLoad();
            });
        }, this));
    },
    loadBsky: function (els, initial) {
        var selector = 'a.bsky.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var bskyLoaded = this.loadMedia(els, selector, this.bskyLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            var complete = $.Deferred()
                .done(_.bind(function (did) {
                    // Add to DOM
                    var maxSide = 500;
                    var framePromise = this.buildBskyFramePromise(did, data.bsky_post, maxSide);
                    var renderFrame = _.bind(function () {
                        framePromise.iframe.css('visibility', 'visible');
                        var embed = $('<div class="bskywrap">').append(framePromise.iframe);
                        var close = this.makeClose('post').css('left', maxSide);
                        embed.append(close);
                        $(a).closest('.content').append(embed);
                        this.scroll.onChange();
                    }, this);
                    if (this.isSelected()) {
                        renderFrame();
                    } else {
                        this.buffer.once('selectedChange', renderFrame);
                    }
                    framePromise.always(_.bind(function () {
                        spin.remove();
                        $(a).removeClass('loading');
                        --len;
                        if (len === 0) {
                            bskyLoaded();
                        }
                    }, this));
                }, this))
                .fail(_.bind(function () {
                    spin.remove();
                    $(a).addClass('error');
                    --len;
                    if (len === 0) {
                        bskyLoaded();
                    }
                }, this))
                .always(_.bind(function () {
                    $(a).removeClass('loading');
                }, this));
            var done = function (did) {
                complete.resolve(did);
            };

            if (data.bsky_did) {
                complete.resolve(data.bsky_did);
            } else if (data.bsky_handle) {
                var ajaxOptions = {
                    type: 'get',
                    url: 'https://public.api.bsky.app/xrpc/com.atproto.identity.resolveHandle?handle=' + encodeURIComponent(data.bsky_handle),
                    cache: true,
                    dataType: 'json'
                };
                var filter = function (response) {
                    return response.did || false;
                };
                this.buffer.session.ajax(ajaxOptions, filter).done(done)
                    .fail(_.bind(function () {
                        complete.reject();
                    }, this));
            } else {
                complete.reject();
            }
        }, this));
    },
    loadReddit: function (els, initial) {
        var selector = 'a.reddit.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var redditLoaded = this.loadMedia(els, selector, this.redditLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            // Add to DOM
            var maxSide = 390;
            var framePromise = this.buildRedditFramePromise(
                data.reddit_sub, data.reddit_post, maxSide
            );
            var renderFrame = _.bind(function () {
                var embed = $('<div class="redditwrap">').append(framePromise.iframe);
                var close = this.makeClose('post').css('left', maxSide);
                embed.append(close);
                $(a).closest('.content').append(embed);
                this.scroll.onChange();
            }, this);
            if (this.isSelected()) {
                renderFrame();
            } else {
                this.buffer.once('selectedChange', renderFrame);
            }
            framePromise.always(_.bind(function () {
                spin.remove();
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    redditLoaded();
                }
            }, this));
        }, this));
    },
    loadPinterest: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'pinterest',
            dataType: 'jsonp',
            oembedUrl: 'https://api.pinterest.com/v3/pidgets/pins/info',
            oembedData: function (url, data) {
                return {
                    pin_ids: data.pin_id
                };
            },
            filter: function (response) {
                if (response) {
                    if (response.status === 'success' && response.data && response.data[0] && response.data[0].images && response.data[0].images['237x'] && !response.data[0].is_video) {
                        return true;
                    }
                }
                return false;
            },
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                var photoUrl = response.data[0].images['237x'].url;
                var img = $('<img class="image loading">').attr({
                    src: photoUrl,
                    alt: response.data[0].description
                });
                var imgLink = this.makeEmbedLink(url, img).attr('title', response.data[0].description);
                var close = this.makeClose();
                var embed = $('<span class="embedWrap">').append(imgLink, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    loadXKCD: function (els, initial) {
        return this.loadOembed(els, initial, {
            className: 'xkcd',
            dataType: 'jsonp',
            oembedUrl: function (url, data) {
                return 'https://dynamic.xkcd.com/api-0/jsonp/comic/' + encodeURIComponent(data.comic_id);
            },
            filter: function (response) {
                if (response) {
                    if (response.img) {
                        return true;
                    }
                }
                return false;
            },
            render: _.bind(function (a, spin, url, response) {
                // Add to DOM
                var photoUrl = response.img;
                var img = $('<img class="image loading">').attr({
                    src: photoUrl,
                    alt: response.alt
                });
                var imgLink = this.makeEmbedLink(url, img).attr('title', response.alt);
                var close = this.makeClose();
                var embed = $('<span class="embedWrap">').append(imgLink, close);
                $(a).closest('.content').append(embed);
            }, this)
        });
    },
    loadGfyCat: function (els, initial) {
        var selector = 'a.gfycat.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var gfycatLoaded = this.loadMedia(els, selector, this.gfycatLoaded, initial);
        items.each(_.bind(function (i, a) {
            var url = $(a).attr('href');
            var data = $(a).data();

            // Add a spinner
            var spin = this.makeSpin(url);
            $(a).closest('.content').append(spin);
            this.scroll.onChange();

            // Add to DOM
            var width = 390;
            var height = 273;
            var framePromise = this.buildGfycatFramePromise(
                data.gfycat_id, width, height
            );
            this.loadIframe(framePromise, a, width);
            framePromise.always(_.bind(function () {
                spin.remove();
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    gfycatLoaded();
                }
            }, this));
        }, this));
    },
    twitchEmotesLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {
            '.twitchEmote.imageLoaded': this.onImagesLoaded
        }, false);
    },
    loadTwitchEmotes: function (els, initial) {
        var done = this.loadMedia(els, '.twitchEmote.loading', this.twitchEmotesLoaded, initial);
        this.bindImageLoads(els, done);
        
        return this;
    },
    loadTwitchBadges: function (els, initial) {
        twitch.loadBadges(this.buffer.session, this.buffer.normalise(), els);
    },
    appendGist: function (appendTo, response, url, gist_hash) {
        // Process response div
        var gistDiv = $(response.div);
        // Make links open in a new tab
        gistDiv.find('a').each(function () {
            $(this).attr('target', '_blank');
            $(this).attr('rel', 'noreferrer');
        });

        // Only include first file or a named hash
        var foundFile = false;
        gistDiv.find('.gist-file').addClass('irccloud-to-remove');
        var selectedFile, selectedLine;
        if (gist_hash) {
            var lineMatch = gist_hash.match(/(^.*)-L(\d+)$/);
            var line;
            if (lineMatch) {
                gist_hash = lineMatch[1];
                line = lineMatch[2];
            }
            selectedFile = gistDiv.find('a').filter(function () {
                return this.hash == gist_hash;
            }).closest('.gist-file');
            if (selectedFile.length) {
                if (line) {
                    selectedLine = selectedFile.find(gist_hash + '-LC' + line);
                }
                foundFile = true;
            }
        }
        if (!foundFile) {
            selectedFile = gistDiv.find('.gist-file:first-child');
        }

        selectedFile.removeClass('irccloud-to-remove');
        var table = selectedFile.find('table.js-file-line-container');
        var rows = table.find('tbody tr');
        var truncated = table.find('tbody tr').slice(500);
        if (truncated.length) {
            truncated.remove();
            var fullLink = this.makeLink(url, 'irccloud-gist-truncated');
            fullLink.text('truncated… see full gist (' + rows.length.toLocaleString() + ' lines)');
            table.after(fullLink);
        }

        gistDiv.find('.irccloud-to-remove').remove();

        // remove footer
        // gistDiv.find('.gist-meta').remove();

        // remove line numbers
        // gistDiv.find('.line-numbers').remove();

        // Remove ids, might not be unique in page
        gistDiv.removeAttr('id');
        gistDiv.find('*').removeAttr('id');

        // Add to DOM
        appendTo.append(gistDiv);

        // Highlight and scroll to line
        if (selectedFile && selectedLine) {
            selectedLine.css({
                'background-color': 'rgb(255, 255, 204)'
            });
            selectedFile.find('.gist-data').scrollTop(selectedLine.position().top - selectedLine.height());
        }
    },
    buildGistTitle: function (response, url) {
        var title = $('<h1 class="gistwraptitle">');
        
        var close = '<span class="actions"><a href="" class="close">close</a></span>';
        title.append(close);

        var owner = this.makeLink('https://gist.github.com/' + encodeURIComponent(response.owner));
        owner.text(response.owner);
        title.append(owner);

        if (response.description) {
            title.append($('<span>').text(': ' + response.description));
        }

        var created = new Date(response.created_at);
        title.append(created.toString(" — d MMM yyyy "));

        if (response.files.length > 1) {
            title.append(this.makeLink(url).text(response.files.length + ' files…'));
        }
        return title;
    },
    getTwitterMeta: function () {
        // See <meta> here https://developer.x.com/en/docs/x-for-websites/embedded-tweets/overview
        var meta = {};
        $('meta[name]').each(_.bind(function (i, m) {
            var match = $(m).attr('name').match(/twitter:(.+)/);
            if (match) {
                meta[match[1]] = $(m).attr('content');
            }
        }, this));
        return meta;
    },
    loadTweets: function (els, initial) {
        if (!window.twttr) {
            return;
        }
        var selector = 'a.twitter.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }
        var twitterLoaded = this.loadMedia(els, selector, this.twitterLoaded, initial);
        
        var meta = this.getTwitterMeta();
        var tweetOpts = {
            // align: undefined,
            linkColor: meta['widgets:link-color'],
            // width: 'auto',
            theme: meta['widgets:theme'],
            // lang: 'en',
            dnt: true,
            conversation: 'all',
            cards: 'all'
        };
        if (!this.buffer.session.ent()) {
            tweetOpts.related = 'irccloud';
        }
        
        items.each(_.bind(function (i, a) {
            var moment_id = $(a).attr('data-twitter_moment_id');
            var tweet_id = $(a).attr('data-twitter_id');
            var widgetMethod, widgetArg;
            var thisOpts = _.clone(tweetOpts);
            var close = this.makeClose('tweet');
            var className = 'twitterwrap';
            if (tweet_id) {
                widgetMethod = 'createTweet';
                widgetArg = tweet_id;
            } else if (moment_id) {
                widgetMethod = 'createMoment';
                widgetArg = moment_id;
                thisOpts.limit = 1;
                thisOpts.width = 500;
                close.attr('title', 'Close moment');
                className += ' twitterwrap--moment';
            } else {
                // formatter.renderLinkifyProcessor can delete data that's already been
                // seen in a line
                --len;
                if (len === 0) {
                    twitterLoaded();
                }
                return;
            }

            var wrapper = $('<div>').addClass(className);
            $(a).closest('.content').append(wrapper);
            var complete = $.Deferred().done(_.bind(function (widget, params) {
                wrapper.addClass('loaded');
                wrapper.append(close);
            }, this)).fail(function () {
                wrapper.remove();
                $(a).addClass('error');
            }).always(function () {
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    twitterLoaded();
                }
            });

            window.twttr.ready(_.bind(function (twttr) {
                twttr.widgets[widgetMethod](widgetArg, wrapper[0], thisOpts).then(
                    _.bind(function (widget) {
                        this.tweetEmbedLoaded(widget, complete);
                    }, this)
                );
            }, this));
        }, this));

        return this;
    },

    // message.data: {
    //     'twttr.embed': {
    //         id: "twitter-widget-0"
    //         jsonrpc: "2.0"
    //         method: "twttr.private.resize"
    //         params: [{
    //             width: 550,
    //             height: 842,
    //             data: {
    //                 tweet_id: '1234567890'
    //             }
    //         }]
    //     }
    // }
    findTwitterPostMessage: function (tweetFrameWindow, type) {
        return this.buffer.session.findMessage(_.bind(function (message) {
            if (message.source !== tweetFrameWindow) {
                return false;
            }
            if (
                'twttr.embed' in message.data &&
                message.data['twttr.embed'].method == type
            ) {
                return message.data['twttr.embed'];
            }
            return null;
        }, this), 5000);
    },
    tweetEmbedLoaded: function (widget, complete) {
        if (widget) {
            var tweetFrameWindow = $(widget).find('iframe')[0].contentWindow;
            this.findTwitterPostMessage(tweetFrameWindow, 'twttr.private.rendered')
                .done(function (data) {
                    complete.resolve(widget, data);
                })
                .fail(function () {
                    complete.reject();
                });
        } else {
            complete.reject();
        }
    },
    loadGists: function (els, initial) {
        var selector = 'a.gist.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }
        var gistsLoaded = this.loadMedia(els, selector, this.gistsLoaded, initial);

        items.each(_.bind(function (i, a) {
            var gist_id = $(a).data('gist_id');
            var gist_hash = $(a).data('gist_hash');
            var url = 'https://gist.github.com/';
            url += encodeURIComponent(gist_id);
            var jsonUrl = url + '.json';
            var complete = $.Deferred();
            this.buffer.session.ajax({
                url: jsonUrl,
                cache: true,
                dataType: 'jsonp'
            }, function (response) {
                return !!response;
            }).then(_.bind(function (response) {
                var title = this.buildGistTitle(response, url);
                var gistWrap = $('<div class="gistwrap loaded">');
                gistWrap.append(title);

                var iframe = $('<iframe>').attr(this.formatter.linker.iframeProps()).css({
                    'width': '100%',
                    'height': 190,
                    'overflow': 'hidden'
                });

                gistWrap.append(iframe);
                $(a).closest('.content').append(gistWrap);

                // Add doctype after adding to DOM
                var idocument = iframe[0].contentDocument;
                // Iframe might have been removed from the dom in the mean time
                if (!idocument) {
                    return;
                }
                idocument.open();
                idocument.write("<!DOCTYPE html>");
                idocument.close();

                // Load CSS
                var cssToLoad = 2;
                var cssComplete = new $.Deferred().progress(function () {
                    if (!--cssToLoad) {
                        cssComplete.resolve();
                    }
                });
                var externalCSS = $('<link rel="stylesheet">').attr('href', response.stylesheet).one('load', function () {
                    cssComplete.notify();
                });
                var overrideCSS = $('<link rel="stylesheet">').attr('href', '/static/gist.css').one('load', function () {
                    cssComplete.notify();
                });
                // Resize on load to avoid scrollbars
                cssComplete.done(function () {
                    setTimeout(function () {
                        var gistHeight = iframe.contents().find('.gist .gist-data>div').height();
                        if (gistHeight && gistHeight < 163) {
                            iframe.css('height', gistHeight + 27);
                            setTimeout(function () {
                                iframe.css('height', gistHeight + 28);
                            });
                        } else {
                            iframe.css('height', 195);
                        }
                    });
                });
                // Add CSS
                iframe.contents().find('head').append(externalCSS).append(overrideCSS);
                // Add gist content
                this.appendGist(iframe.contents().find('body'), response, url, gist_hash);
                complete.resolve();
                return complete.promise();
            }, this)).fail(function () {
                $(a).addClass('error');
            }).always(function () {
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    gistsLoaded();
                }
            });
        }, this));

        return this;
    },
    loadFiles: function (els, initial, reqid) {
        var selector = 'a.file.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }
        if (!this.buffer.inlineFilesAllowed()) {
            els.removeClass('fileLoading');
            if (reqid) {
                var pending = this.getPendingRow(reqid);
                pending.remove();
            }
            return;
        }
        
        var loaded = this.loadMedia(els, selector, this.filesLoaded, initial, reqid);
        
        var checkLenLoad = function () {
            --len;
            if (len === 0) {
                loaded();
            }
        };
        items.each(_.bind(function (i, a) {
            var fileData = $(a).data();
            var f = new FileWrapper(fileData, {
                session: this.buffer.session
            });
            var fv = new FileInlineView({model: f});
            fv.bind('toggleEdit', function () {
                this.scroll.onChange();
            }, this);
            fv.bind('collapsed', function () {
                this.scroll.onChange();
            }, this);
            var wrap = $(a).closest('span.fileWrap');
            f.fetch()
                .fail(_.bind(function () {
                    wrap.remove();
                    checkLenLoad();
                }, this))
                .done(_.bind(function () {
                    if (f.isDeleted()) {
                        wrap.remove();
                        checkLenLoad();
                    } else {
                        $(a).removeClass('loading').addClass('loaded');
                        var renderPreview = _.bind(function () {
                            // Only on individual messages (not initial)
                            // Need to show the line briefly to
                            // calculate dimensions
                            if (!initial) {
                                els.removeClass('fileLoading');
                            }
                            var preview = fv.render(wrap).el;
                            if (!initial) {
                                els.addClass('fileLoading');
                            }
                            wrap.removeClass('loading').addClass('loaded');
                            wrap.append(preview);
                            _.each(fv.$('.filePreviewImageDummy'), this.setEmbedClosePosition, this);
                            checkLenLoad();
                        }, this);
                        if (this.isSelected()) {
                            renderPreview();
                        } else {
                            this.buffer.once('selectedChange', renderPreview);
                        }
                    }
                }, this));
        }, this));

        return this;
    },

    fileWrapsLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {
            'a.file.loaded': function (els, loaded, animate) {
                loaded.each(_.bind(function (i, a) {
                    $(a).closest('span.fileWrap').removeClass('loaded').addClass('rendered');
                    $(a).remove();
                }, this));
            }
        });
    },
    fileImagesLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {
            'img.imageLoaded': this.onImagesLoaded,
            '.mediaLoaded': this.onMediaLoaded
        });
    },
    filesLoaded: function (els, initial, reqid) {
        var fileWrapsDone = this.loadMedia(els, 'span.fileWrap.loaded', this.fileWrapsLoaded, initial);
        
        var complete = new $.Deferred().done(_.bind(function () {
            if (!initial) {
                // Only on individual messages (not initial)
                // whole line hidden until loaded
                els.removeClass('fileLoading');
                // Recalculate close position after message
                // is revealed
                _.each(els.find('img.imageRendered, .mediaRendered'), this.setEmbedClosePosition, this);
            }
            fileWrapsDone();
        }, this));
        if (reqid) {
            var pending = this.getPendingRow(reqid);
            pending.addClass('pendingOut');
            // pendingOut class takes a short while to animate out
            // remove it from the DOM after the animation
            setTimeout(_.bind(function () {
                pending.remove();
                complete.resolve();
            }, this), 200);
        } else {
            complete.resolve();
        }
        
        var fileImagesDone = this.loadMedia(els, 'span.fileWrap.loaded', this.fileImagesLoaded, initial);
        var len = 2;
        var fileImagesComplete = new $.Deferred()
            .done(fileImagesDone)
            .progress(function () {
                --len;
                if (len === 0) {
                    fileImagesComplete.resolve();
                }
            });
        function fileImagesNotify () {
            fileImagesComplete.notify();
        }
        this.bindImageLoads(els, fileImagesNotify);
        this.bindMediaLoads(els, fileImagesNotify);
    },
    loadAttachmentSnippets: function (els, initial) {
        var selector = '.attachment__snippet';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }

        var attachSnippetsLoaded = this.loadMedia(els, selector, this.attachSnippetsLoaded, initial);

        items.each(_.bind(function (i, el) {
            var $item = $(el);

            if (!this.buffer.inlinePastesAllowed()) {
                this.hideEmbed($item);
                return;
            }
            if ($item.closest('.content').find('.entityWrap').length) {
                return;
            }

            var pData = $item.data();
            var paste = {
                body: $item.text(),
                name: pData.filename,
                external_url: pData.url,
                external_raw_url: pData.raw_url,
                service_name: pData.service_name,
                service_url: pData.service_url,
                lines: pData.lines,
                date: pData.ts,
                size: pData.size
            };
            if (pData.lines && pData.lines > pData.preview_lines) {
                paste.truncated_lines = pData.preview_lines;
                paste.truncated = true;
            }
            var pbv = PastebinView.fromPaste(paste, this.buffer.session);
            if (pData.name) {
                pbv.model.set('name', pData.name);
            }
            pbv.bind('editorResize', function () {
                this.scroll.onChange();
            }, this);
            pbv.render({header: true, withClose: true});
            var wrap = $('<span class="entityWrap">');
            $item.closest('.content').append(wrap.append(pbv.el));
            pbv.once('rendered', function () {
                var attachWrap = $item.closest('.attachWrap').hide();
                wrap.addClass('loaded');
                --len;
                if (len === 0) {
                    attachSnippetsLoaded();
                }
            }, this);
        }, this));

        return this;
    },
    loadPastes: function (els, initial) {
        var selector = 'a.paste.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            return;
        }
        var pastesLoaded = this.loadMedia(els, selector, this.pastesLoaded, initial);

        items.each(_.bind(function (i, a) {
            var pData = $(a).data();
            var paste = {};
            for (var k in pData) {
                if (k.indexOf('paste_') === 0) {
                    paste[k.replace(/^paste_/, '')] = pData[k];
                }
            }
            if (paste.id) {
                var pbv = PastebinView.fromPaste(paste, this.buffer.session);
                pbv.bind('toggleEdit', function () {
                    this.scroll.onChange();
                }, this);
                pbv.bind('editorResize', function () {
                    this.scroll.onChange();
                }, this);
                pbv.model.bind('removed', function () {
                    this.scroll.onChange();
                }, this);
                pbv.model.fetch().always(_.bind(function () {
                    if (pbv.model.get('body')) {
                        pbv.render({header: true, withClose: true});
                        var wrap = $('<span class="entityWrap">');
                        $(a).closest('.content').append(wrap.append(pbv.el));
                        pbv.once('rendered', function () {
                            wrap.addClass('loaded');
                            $(a).removeClass('loading');
                            --len;
                            if (len === 0) {
                                pastesLoaded();
                            }
                        }, this);
                    } else {
                        $(a).removeClass('loading');
                        --len;
                        if (len === 0) {
                            pastesLoaded();
                        }
                    }
                }, this));
            } else {
                $(a).removeClass('loading');
                --len;
                if (len === 0) {
                    pastesLoaded();
                }
            }
        }, this));

        return this;
    },
    bindMediaLoads: function (els, done) {
        var selector = '.media.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            done();
            return;
        }
        var complete = new $.Deferred();
        complete.progress(function () {
            --len;
            if (len === 0) {
                complete.resolve();
            }
        });
        complete.done(done);
        items.each(function (i, media) {
            var $media = $(media);
            $media.one('loadedmetadata', function (e) {
                $media.removeClass('loading').addClass('mediaLoaded');
                complete.notify('load', media);
            });
            $media.one('error', function (e) {
                $media.removeClass('loading').addClass('mediaError');
                complete.notify('error', media);
            });
        });
        return complete.promise();
    },
    bindImageLoads: function (els, done) {
        var selector = 'img.loading';
        var items = els.find(selector);
        var len = items.length;
        if (!len) {
            done();
            return;
        }

        // create an observer instance
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.removedNodes) {
                    _.each(mutation.removedNodes, function (node) {
                        items.each(function (i, item) {
                            if ($.contains(node, item)) {
                                complete.notify('removed', item);
                            }
                        });
                    });
                }
            });    
        });
        observer.observe(this.el, { childList: true, subtree: true });

        var complete = new $.Deferred();
        complete.progress(function bindImageLoadsProgress () {
            --len;
            if (len === 0) {
                observer.disconnect();
                complete.resolve();
            }
        });

        complete.done(done);
        items.each(function bindImageLoadsEach (i, img) {
            var $img = $(img);
            function imgOnLoad () {
                $img.removeClass('loading').addClass('imageLoaded');
                complete.notify('load', img);
            }
            function imgOnError (e) {
                $img.removeClass('loading').addClass('imageError');
                complete.notify('error', img);
            }
            if (img.complete) {
                imgOnLoad();
            } else {
                if (img.complete === undefined) {
                    // cached images don't fire load sometimes, so we reset src.
                    var src = img.src;
                    // webkit hack from https://groups.google.com/group/jquery-dev/browse_thread/thread/eee6ab7b2da50e1f
                    // data uri bypasses webkit log warning (thx doug jones)
                    img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
                    img.src = src;
                }
                $img.one('load', imgOnLoad);
                $img.one('error', imgOnError);
            }
        });
        return complete.promise();
    },
    triggerImagesLoaded: function (els, initial) {
        var done = this.loadMedia(els, 'img.loading', this.imagesLoaded, initial);
        this.bindImageLoads(els, done);
        
        return this;
    },
    loadEmbedIframes: function (els, initial) {
        var selector = 'iframe.iframeEmbed';
        var items = els.find(selector);
        items.each(_.bind(function (i, iframe) {
            $(iframe).one('load', _.bind(function (e) {
                this.setEmbedClosePositionOnceSelected(iframe);
            }, this));
        }, this));
    },
    mediaLoaded: function (els, initial, loadedMap, animate) {
        this.scroll.checkPinBottom(function (pinBottom) {
            var promise = new $.Deferred();
            if (loadedMap) {
                var mapLen = _.size(loadedMap);
                promise.progress(function mediaLoadedProgress () {
                    if (!--mapLen) {
                        promise.resolve();
                    }
                });
                _.each(loadedMap, _.bind(function mediaLoadedEach (processLoaded, loadedSelector) {
                    var loaded = els.find(loadedSelector);
                    // Only animate after first run and if any loaded
                    if (animate === undefined) {
                        animate = !initial && !!loaded.length;
                    }
                    var result = _.bind(processLoaded, this)(els, loaded, animate);
                    if (result) {
                        result.done(_.bind(function mediaLoadedEachDone () {
                            promise.notify();
                        }, this));
                    } else {
                        promise.notify();
                    }
                }, this));
            } else {
                promise.resolve();
            }
            return promise.promise().done(_.bind(function mediaLoadedDone () {
                // Update scroll
                this.scroll.onChange(pinBottom, animate);
            }, this));
        }, this);
    },
    gistsLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'div.gistwrap.loaded': function (els, loaded, animate) {
            loaded.removeClass('loaded').addClass('rendered');
        }});
    },
    instagramLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.instagram.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    mastodonLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.mastodon.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).removeAttr('scrolling');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    redditLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.reddit.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    bskyLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.bsky.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    gfycatLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.gfycat.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    imgurLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'iframe.imgur.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, iframe) {
                var css = $(iframe).data('css');
                $(iframe).css(css).removeClass('loaded').addClass('rendered');
            }, this));
        }});
    },
    twitterLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'div.twitterwrap.loaded': function (els, loaded, animate) {
            loaded.each(_.bind(function (i, div) {
                $(div).removeClass('loaded').addClass('rendered');
                var widget = $(div).find('iframe');
                this.setEmbedClosePositionOnceSelected(widget[0]);
                if (widget[0]) {
                    var tweetFrameWindow = widget[0].contentWindow;
                    this.findTwitterPostMessage(tweetFrameWindow, 'twttr.private.resize').done(
                        _.bind(function () {
                            this.scroll.onChange();
                        }, this)
                    );
                }
            }, this));
        }});
    },
    pastesLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'span.entityWrap.loaded': function (els, loaded, animate) {
            loaded.removeClass('loaded').addClass('rendered');
        }});
    },
    attachSnippetsLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {'span.entityWrap.loaded': function (els, loaded, animate) {
            loaded.removeClass('loaded').addClass('rendered');
        }});
    },
    onMediaLoaded: function (els, loaded, animate) {
        loaded.each(_.bind(function onMediaLoadedEach (i, media) {
            var $media = $(media);
            $media.closest('.content').find('a.spin').remove();
            $media.removeClass('mediaLoaded');
            $media.addClass('mediaRendered');
            this.setEmbedClosePositionOnceSelected(media);
        }, this));
        // Hide errored
        var errored = els.find('.mediaError');
        errored.each(_.bind(function onMediaLoadedErrorEach (i, media) {
            var $media = $(media);
            $media.closest('.content').find('a.spin').remove();
            $media.closest('.mediaPreview')
                .removeClass('mediaPreview')
                .addClass('docPreview')
                .find('a.embedClose').remove();
            $media.remove();
        }, this));

        if (animate) {
            loaded.animate({opacity: 1}, 'slow');
        } else {
            loaded.css('opacity', 1);
        }
    },
    onImagesLoaded: function (els, loaded, animate) {
        loaded.each(_.bind(function onImagesLoadedEach (i, img) {
            var $img = $(img);
            $img.closest('.content').find('a.spin').remove();
            $img.closest('.content').find('.filePreviewImageDummy').remove();
            $img.removeClass('imageLoaded');
            $img.addClass('imageRendered');
            var closeAble = !$img.is('.notCloseable');
            if (closeAble) {
                this.setEmbedClosePositionOnceSelected(img);
            }
        }, this));
        // Hide errored
        var errored = els.find('img.imageError');
        errored.each(_.bind(function onImagesLoadedErrorEach (i, img) {
            var $img = $(img);
            $img.closest('.content').find('a.spin').remove();
            if ($img.closest('.attachWrap').length) {
                $img.remove();
            } else {
                this.hideEmbed($img);
            }
        }, this));

        if (animate) {
            loaded.animate({opacity: 1}, 'slow');
        } else {
            loaded.css('opacity', 1);
        }
    },
    imagesLoaded: function (els, initial) {
        this.mediaLoaded(els, initial, {
            'img.imageLoaded': this.onImagesLoaded
        });
    },
    setEmbedClosePositionOnceSelected: function (el) {
        if (this.isSelected()) {
            this.setEmbedClosePosition(el);
        } else {
            this.buffer.once('selectedChange', function () {
                this.setEmbedClosePosition(el);
            }, this);
        }
    },
    setEmbedClosePosition: function (el) {
        if (!el) {
            return;
        }
        $(el).closest('.directEmbedWrap, .embedWrap, .mastodonwrap, .bskywrap, .redditwrap, .twitterwrap, .fbwrap, .fileWrap').find('.embedClose').css('left', el.clientWidth + $(el).position().left);
    },
    resetEmbedClosePositions: function () {
        _.each(this.$('img.imageRendered, .mediaRendered, .mastodonwrap.rendered, .bskywrap.rendered, .redditwrap.rendered, .twitterwrap.rendered iframe, .fbwrap.rendered iframe, .directEmbedWrap iframe.iframeEmbed'), this.setEmbedClosePosition, this);
    },
    showAttachmentFallback: function (target) {
        var attachFallback = target.closest('.content').find('.attachFallback');
        if (attachFallback.length) {
            attachFallback.addClass('attachFallback--show');
        }
    },
    hideEmbed: function (target) {
        var fileWrap = target.closest('.fileWrap');
        if (fileWrap.length) {
            fileWrap.find('a.fileClose').click();
        } else {
            var attachWrap = target.closest('.attachWrap');
            if (attachWrap.length) {
                this.showAttachmentFallback(target);
                attachWrap.hide();
            } else {
                var embed = target.closest('.directEmbedWrap, .embedWrap, .mastodonwrap, .bskywrap, .redditwrap, .twitterwrap, .fbwrap, .gistwrap');
                embed.prev('.spin').remove();
                embed.remove();
            }
        }
    },
    clickEmbedClose: function (e) {
        e.preventDefault();
        this.hideEmbed($(e.target));
        this.scroll.onChange();
    },
    clickPasteClose: function (e) {
        // TODO move to pastebinview
        e.preventDefault();
        var target = $(e.target);
        var pasteDiv = target.closest('div.paste');
        var pastebin = PastebinView.fromEl(pasteDiv, this.buffer.session);
        this.showAttachmentFallback(target);
        pastebin.collapse(true);
        this.scroll.onChange();
    }
});

module.exports = BufferLogContainerView;


/***/ }),

/***/ "Qesd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RAIu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.render = render;
var FileWrapper = __webpack_require__("JHsc");
var Message = __webpack_require__("j9Sh");

__webpack_require__("Qesd");

// Bind `this` to a formatter instance when using this module

function render(message) {
    var _this = this;

    var blocks = '';
    var blockParts = message.getSlackBlocks().map(function (block) {
        var blockPart = '';
        switch (block.type) {
            case 'divider':
                blockPart = '<hr class="slack_block__divider">';
                break;
            case 'context':
                blockPart = '<div class="slack_block__section slack_block__section--context">';
                block.elements.forEach(function (element) {
                    if (element.type === 'image') {
                        blockPart += '<div' + _this.makeAttributes({
                            'class': 'slack_block__context_image',
                            style: 'background-image: url("' + element.image_url + '");',
                            title: element.alt_text,
                            'aria-label': element.alt_text
                        }) + '></div>';
                    } else if (element.text) {
                        blockPart += '<div class="slack_block__context_text">' + _this.renderLinkify(element.text, {
                            replacements: Message.getCustomEmoji(element.text_emoji),
                            codeSpan: message.buffer.formatCodeSpan(),
                            codeBlock: message.buffer.formatCodeBlock(),
                            quote: message.buffer.formatQuote()
                        }) + '</div>';
                    }
                });
                // TODO block.elements can contain sub image blocks and text objects
                blockPart += '</div>';
                break;
            case 'call':
                blockPart = '<div class="slack_block__section slack_block__section--call">';

                blockPart += '<div class="slack_block__call_header">';

                blockPart += '<div' + _this.makeAttributes({
                    'class': 'slack_block__call_icon',
                    style: 'background-image: url("' + block.call.v1.app_icon_urls.image_48 + '");'
                }) + '></div>';

                blockPart += '<div class="slack_block__call_header_text">';

                blockPart += '<p class="slack_block__call_title">';
                blockPart += _this.escapeText(block.call.v1.name);
                blockPart += '</p>';
                blockPart += '<p class="slack_block__call_status">';
                blockPart += 'Started ' + _this.timestamp(new Date(block.call.v1.date_start * 1000));
                blockPart += '</p>';

                blockPart += '</div>';

                blockPart += '</div>';

                blockPart += '<div class="slack_block__call_description">';
                blockPart += 'Meeting ID: ' + _this.escapeText(block.call.v1.display_id);
                blockPart += '</div>';

                blockPart += '<div class="slack_block__call_join">';
                blockPart += '<button type="button" class="action">';
                blockPart += _this.linker.make('Join', {
                    href: block.call.v1.join_url,
                    target: '_blank',
                    rel: 'noreferrer'
                });
                blockPart += '</button>';
                blockPart += '</div>';

                blockPart += '</div>';
                break;
            case 'image':
                blockPart = '<div class="slack_block__section slack_block__section--image">';

                blockPart += '<p class="slack_block__image_info">';
                if (block.title && block.title.text) {
                    blockPart += _this.escapeText(block.title.text) + ' ';
                }
                blockPart += '<span class="slack_block__image_bytes">(';
                blockPart += FileWrapper.sizeToString(block.image_bytes);
                blockPart += ')</span> ';
                blockPart += '</p>';

                var image = '<img' + _this.makeAttributes({
                    'class': 'slack_block__image',
                    src: block.image_url,
                    width: block.image_width,
                    height: block.image_height,
                    alt: block.alt_text
                }) + '>';

                blockPart += '<div class="slack_block__image_wrap">';
                blockPart += _this.linker.make(image, {
                    'class': 'slack_block__image_link',
                    href: block.image_url,
                    target: '_blank',
                    rel: 'noreferrer'
                });
                blockPart += '</div>';

                blockPart += '</div>';
                break;
            case 'section':
                blockPart = '<div class="slack_block__section slack_block__section--default">';

                blockPart += '<div class="slack_block__text_block">';

                if (block.text) {
                    blockPart += '<div class="slack_block__text">' + _this.renderLinkify(block.text.text, {
                        replacements: Message.getCustomEmoji(block.text.text_emoji),
                        codeSpan: message.buffer.formatCodeSpan(),
                        codeBlock: message.buffer.formatCodeBlock(),
                        quote: message.buffer.formatQuote()
                    }) + '</div>';
                }

                if (block.fields) {
                    blockPart += '<div class="slack_block__fields">';
                    block.fields.forEach(function (field) {
                        blockPart += '<div class="slack_block__field">' + _this.renderLinkify(field.text, {
                            replacements: Message.getCustomEmoji(field.text_emoji),
                            codeSpan: message.buffer.formatCodeSpan(),
                            codeBlock: message.buffer.formatCodeBlock(),
                            quote: message.buffer.formatQuote()
                        }) + '</div>';
                    });
                    blockPart += '</div>';
                }

                blockPart += '</div>';

                if (block.accessory && block.accessory.type === 'image') {
                    blockPart += '<div' + _this.makeAttributes({
                        'class': 'slack_block__accessory_image',
                        style: 'background-image: url("' + block.accessory.image_url + '");',
                        title: block.accessory.alt_text,
                        'aria-label': block.accessory.alt_text
                    }) + '></div>';
                }

                blockPart += '</div>';
                break;
            case 'table':
                blockPart = '<div class="slack_block__section slack_block__section--default">';

                blockPart += '<table class="slack_block__table_block">';

                block.rows.forEach(function (row) {
                    blockPart += '<tr>';
                    row.forEach(function (col) {
                        blockPart += '<td>';
                        if (col.type == 'raw_text') {
                            blockPart += _this.renderLinkify(col.text, {
                                replacements: Message.getCustomEmoji(col.text_emoji),
                                codeSpan: message.buffer.formatCodeSpan(),
                                codeBlock: message.buffer.formatCodeBlock(),
                                quote: message.buffer.formatQuote()
                            });
                        } else if (col.type == 'rich_text') {
                            col.elements.forEach(function (el) {
                                if (el.type == 'rich_text_section') {
                                    el.elements.forEach(function (rich_el) {
                                        if (rich_el.type == 'link') {
                                            blockPart += _this.linker.make(_this.escapeText(rich_el.text), {
                                                href: rich_el.url,
                                                target: '_blank',
                                                rel: 'noreferrer'
                                            });
                                        } else if (rich_el.type == 'text') {
                                            if (rich_el.style && rich_el.style.bold) {
                                                blockPart += '<b>';
                                            }
                                            if (rich_el.style && rich_el.style.italic) {
                                                blockPart += '<i>';
                                            }
                                            if (rich_el.style && rich_el.style.strike) {
                                                blockPart += '<del>';
                                            }
                                            blockPart += _this.escapeText(rich_el.text);
                                            if (rich_el.style && rich_el.style.strike) {
                                                blockPart += '</del>';
                                            }
                                            if (rich_el.style && rich_el.style.italic) {
                                                blockPart += '</i>';
                                            }
                                            if (rich_el.style && rich_el.style.bold) {
                                                blockPart += '</b>';
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        blockPart += '</td>';
                    });
                    blockPart += '</tr>';
                });

                blockPart += '</table>';

                blockPart += '</div>';
                break;
        }
        return blockPart;
    });
    return blockParts.join('');
}

/***/ }),

/***/ "RTnb":
/***/ (function(module, exports, __webpack_require__) {

var UserChannelMode = __webpack_require__("O4T4");
var sko = __webpack_require__("pyif").default;


var JoinPartFormatter = function (options) {
    this.buffer = options.buffer;
    this.lines = [options.line];
    this.rows = options.rows;
    this.formatter = options.formatter;
    this.index = options.index;
    this.spliceCount = this.rows.length;
    this.sentences = '';
    this.expanded = false;
};
JoinPartFormatter.prototype = {
    setIndex: function (index) {
        this.index = index;
    },
    getFirstLine: function () {
        return this.lines[0];
    },
    addMessage: function (line, rows) {
        if (line.get('match')) {
            this.expanded = true;
        }
        this.lines.push(line);
        this.rows.push.apply(this.rows, rows);
        // Return whether this is the first grouping we've done
        var isFirst = (this.lines.length == 2);
        if (!isFirst) {
            this.spliceCount = 2;
        }
        return isFirst;
    },
    renderMessage: function (line, rows) {
        var isFirst = this.addMessage(line, rows);
        this.render();
        return isFirst;
    },
    render: function () {
        // Collect types
        var state = new sko();
        var connState = new sko();
        var lastType = new sko();
        var mode = new sko();
        var uhost = new sko();
        var nickChange = new sko();
        var nickMessage = new sko();
        var quitOldNick = new sko();
        var leftOldNick = new sko();
        var split = new sko();
        var displayName = new sko();
        var channelMode, channelUrl;
        _.each(this.lines, function (line) {
            var type = line.get('type');
            var nc = type == 'nickchange';
            var chghost = type == 'user_chghost';
            var mc = type == 'user_channel_mode';
            var mlc = line.isNickModeListChange();
            var im, cu;
            if (type == 'channel_mode_is') {
                im = true;
                channelMode = line;
            }
            if (type == 'channel_url') {
                cu = true;
                channelUrl = line;
            }
            var nick = nc ? line.get('newnick') : line.get('nick');
            var dn = line.getDisplayName();
            var modeChange;
            if (mc || mlc) {
                var mcU;
                if (mc) {
                    mcU = line.makeUser(nick);
                } else {
                    mcU = null;
                }
                modeChange = new UserChannelMode(line.attributes, {buffer: this.buffer, user: mcU});
                // For mlc, nick is parsed out of the oplist
                nick = modeChange.user.getNick();
                dn = modeChange.user.getDisplayName();
            }
            displayName.set(nick, dn);
            var jp = type == 'joined_channel' || type == 'you_joined_channel' || type == 'parted_channel';
            var channel;
            var newState = false;
            if (jp) {
                channel = line.get('chan');
            } else if (mc || mlc) {
                channel = line.get('channel');
            }

            if (nick && !nickMessage.get(nick)) {
                nickMessage.set(nick, line);
            }

            if (nick && !state.get(nick)) {
                state.set(nick, new sko());
            }
            var nickState = state.get(nick);

            if (nick && !mode.get(nick)) {
                mode.set(nick, new sko());
            }
            if (nick && !lastType.get(nick)) {
                lastType.set(nick, new sko());
            }

            if (nc) {
                var oldNick = line.get('oldnick');
                /* Check for a reclaim */
                // Previous nick owner has quit
                if (connState.get(nick) === false) {
                    var fl;
                    nickState.each(function(qlChan, qlChanState) {
                        if (qlChanState === 0 && this.action(lastType.get(nick).get(qlChan)) != 'joined') {
                            if (!leftOldNick.get(nick)) {
                                leftOldNick.set(nick, new sko());
                            }
                            leftOldNick.get(nick).set(qlChan, 'flappedIn');
                            fl = true;
                        }
                    }, this);
                    if (!fl) {
                        quitOldNick.set(nick, 'quit');
                    }
                } else {
                    // Previous nick owner has parted
                    nickState.each(function(lChan, lChanState) {
                        if (lChanState < 0) {
                            if (!leftOldNick.get(nick)) {
                                leftOldNick.set(nick, new sko());
                            }
                            leftOldNick.get(nick).set(lChan, 'parted');
                        } else if (lChanState === 0 && this.action(lastType.get(nick).get(lChan)) != 'joined') {
                            if (!leftOldNick.get(nick)) {
                                leftOldNick.set(nick, new sko());
                            }
                            leftOldNick.get(nick).set(lChan, 'flappedIn');

                        }
                    }, this);
                }

                // Copy old state, don't fallback to current state
                state.move(oldNick, nick);
                // This nick was previously quit, make sure we decrement it properly
                if (connState.get(nick) === false && state.get(nick)) {
                    state.get(nick).each(function (chan, chanState) {
                        state.get(nick).decr(chan);
                    });
                }
                // Follow nick change trail
                nickChange.set(nick, nickChange.get(oldNick) || oldNick);
                nickChange.unset(oldNick);
                mode.move(oldNick, nick, true, function (nickUmc) {
                    nickUmc.each(function (chan, chanUmc) {
                        _.each(chanUmc, function (umc) {
                            umc.user.set('nick', nick);
                        });
                    });
                    return nickUmc;
                });
                uhost.move(oldNick, nick, true);
                nickMessage.move(oldNick, nick, true);
                lastType.move(oldNick, nick, true);
                connState.move(oldNick, nick, true);
            } else if (nick && !mc && !mlc && !im && !cu) {
                // State remains undefined for mode changes
                if (channel && nickState.get(channel) === undefined) {
                    newState = true;
                    nickState.set(channel, 0);
                }
            }

            if (!nick) {
                return;
            }
            switch (type) {
            case 'joined_channel':
            case 'you_joined_channel':
                if (connState.get(nick) === false && newState) {
                    // First join after a previous quit, so this is a pop back in
                    nickState.decr(channel);
                }
                nickState.incr(channel);
                connState.set(nick, true);
                break;
            case 'parted_channel':
                nickState.decr(channel);
                connState.set(nick, true);
                break;
            case 'quit':
                nickState.each(function (chan, chanState) {
                    nickState.decr(chan);
                });
                lastType.get(nick).each(function (chan, t) {
                    if (t != 'parted_channel') {
                        lastType.get(nick).set(chan, type);
                    }
                });
                if (line.isNetSplit()) {
                    split.set(nick, line.get('msg'));
                }
                connState.set(nick, false);
                break;
            case 'nickchange':
                connState.set(nick, true);
                break;
            }
            if (modeChange) {
                if (!mode.get(nick).get(channel)) {
                    mode.get(nick).set(channel, []);
                }
                mode.get(nick).get(channel).push(modeChange);
                connState.set(nick, true);
            }
            if (chghost) {
                uhost.set(nick, line);
                connState.set(nick, true);
            }
            if (channel && nick) {
                lastType.get(nick).set(channel, type);
            }
        }, this);
        var actions = JoinPartFormatter.initActions();
        // Process actions from state
        var a;
        state.each(function (nick, nickState) {
            a = null;
            if (!nickState || nickState.isEmpty()) {
                // Empty object, just a mode/nick change/host change/quit
                if (nickChange.get(nick)) {
                    // Quit after nick
                    if (!connState.get(nick)) {
                        a = actions.quit;
                    } else {
                        actions.nickchange.changes.set(nick, nickChange.get(nick));
                    }
                } else if (mode.get(nick) && !mode.get(nick).isEmpty()) {
                    mode.get(nick).each(function(modeChan, modeChanList) {
                        // Quit after mode change
                        if (!connState.get(nick)) {
                            a = actions.quit;
                        } else {
                            a = actions.user_channel_mode;
                        }
                        a.chans.push(modeChan);
                    });
                } else if (uhost.get(nick)) {
                    // Quit after host change
                    if (!connState.get(nick)) {
                        a = actions.quit;
                    }
                } else {
                    a = actions.quit;
                }
                if (a) {
                    a.list.push(nick);
                }
            } else {
                nickState.each(function (chan, chanState) {
                    if (chanState === 0) {
                        // Check last action indicates they are still in the channel
                        if (this.action(lastType.get(nick).get(chan)) == 'joined' && connState.get(nick)) {
                            a = actions.flappedOut;
                            a.chans.push(chan);
                        } else {
                            a = actions.flappedIn;
                            a.chans.push(chan);
                        }
                    } else {
                        a = actions[this.action(lastType.get(nick).get(chan))];
                        if (a && a.chans) {
                            a.chans.push(chan);
                        }
                    }
                    if (a) {
                        if (!_.contains(a.list, nick)) {
                            a.list.push(nick);
                        }
                    }
                }, this);
            }
        }, this);
        quitOldNick.each(function (qNick, qNickAction) {
            if (!state.get(qNick)) {
                actions[qNickAction].list.push(qNick);
            }
        });
        leftOldNick.each(function (lNick, lNickChans) {
            if (!state.get(lNick)) {
                lNickChans.each(function (lNickChan, lNickChanAction) {
                    actions[lNickChanAction].chans.push(lNickChan);
                    actions[lNickChanAction].list.push(lNick);
                });
            }
        });

        this.sentences = JoinPartFormatter.sentence(this.buildSentences(actions, channelUrl, channelMode, mode, uhost, nickChange, nickMessage, quitOldNick, leftOldNick, split, displayName));

        return this;
    },

    formatNetsplits: function (hosts) {
        return _.map(hosts, function (host) {
            return this.formatter.escapeText(host).replace(' ', ' ' + JoinPartFormatter.prefix('⇎'));
        }, this).join(', ') + ' ';
    },
    buildSentences: function (actions, channelUrl, channelMode, mode, uhost, nickChange, nickMessage, quitOldNick, leftOldNick, split, displayName) {
        var msg = '';
        if (split.length() > 1) {
            msg += this.formatNetsplits(_.unique(split.values()));
        }
        _.each(['joined', 'parted', 'quit', 'user_channel_mode', 'flappedIn', 'flappedOut'], function (type, i) {
            var action = actions[type];
            if (!action.list.length) {
                return;
            }
            if (msg && type == 'user_channel_mode') {
                // Add a bullet point prefix for mode changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += JoinPartFormatter.prefix(action.prefix);
            msg += this.formatter.listSentence(action.list, {
                render: _.bind(function (nick, j) {
                    var renderM = '';
                    var chan = action.chans && action.chans[j];
                    var quitNick = (type == 'quit') && quitOldNick.has(nick);
                    var leftNick = (type == 'parted' || type == 'flappedIn') && leftOldNick.has(nick) && leftOldNick.get(nick).has(chan);

                    if (quitNick || leftNick) {
                        renderM += this.formatter.render(nick);
                    } else if (this.buffer.isChannel() && mode.get(nick).has(chan)) {
                        renderM += this.formatter.linkUserMode(_.last(mode.get(nick).get(chan)).user, {
                            name: displayName.get(nick)
                        });
                    } else {
                        renderM += this.formatter.linkMessageUser(nick, nickMessage.get(nick));
                    }
                    if (!quitNick && !leftNick) {
                        var changedNick = nickChange.get(nick) && nickChange.get(nick) != nick;
                        if ((this.buffer.isChannel() && mode.get(nick).has(chan)) || changedNick) {
                            renderM += ' (';
                        }
                        if (changedNick) {
                            renderM += 'was ' + this.formatter.render(nickChange.get(nick));
                            if (this.buffer.isChannel() && mode.get(nick).has(chan)) {
                                renderM += '; ';
                            }
                        }
                        if (this.buffer.isChannel() && mode.get(nick).has(chan)) {
                            renderM += '<span class="mode">' + UserChannelMode.getActions(mode.get(nick).get(chan)) + '</span>';
                        }
                        if ((this.buffer.isChannel() && mode.get(nick).has(chan)) || changedNick) {
                            renderM += ')';
                        }
                    }
                    return renderM;
                }, this)
            });
            if (action.suffix) {
                msg += ' ' + action.suffix;
            }
            if (this.buffer.isConversation() && type != 'quit') {
                var chans = action.chans;
                if (action.chans.length) {
                    msg += ' ' + this.formatter.listSentence(chans, {
                        render: _.bind(function (chan, j) {
                            return this.formatter.linkChannel(chan);
                        }, this)
                    });
                }
            }
            msg += JoinPartFormatter.spacing();
        }, this);
        var nickChangeParts = [];
        var part;
        actions.nickchange.changes.each(function (nick, oldNick) {
            part  = this.formatter.render(oldNick);
            part += ' ' + JoinPartFormatter.prefix('→');

            if (this.buffer.isChannel() && mode.get(nick).has(this.buffer.getName())) {
                mode.get(nick).each(function (modeChan, modeChanList) {
                    part += this.formatter.linkUserMode(_.last(modeChanList).user, {
                        name: displayName.get(nick)
                    });
                    part += ' (<span class="mode">' + UserChannelMode.getActions(modeChanList) + '</span>) ';
                }, this);
            } else {
                part += this.formatter.linkMessageUser(nick, nickMessage.get(nick));
            }

            nickChangeParts.push(part);
        }, this);
        if (nickChangeParts.length) {
            if (msg) {
                // Add a bullet point prefix for nick changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += nickChangeParts.join(', ');
            msg += JoinPartFormatter.spacing();
        }
        if (channelMode && channelMode.get('newmode')) {
            if (msg) {
                // Add a bullet point prefix for channel mode changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += 'Channel mode: <b>+' + this.formatter.render(channelMode.get('newmode')) + '</b>';
            msg += JoinPartFormatter.spacing();
        }
        if (channelUrl) {
            if (msg) {
                // Add a bullet point prefix for channel url changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += 'Channel homepage: ' + this.formatter.renderLinkify(channelUrl.get('url'));
            msg += JoinPartFormatter.spacing();
        }
        if (!uhost.isEmpty()) {
            if (msg) {
                // Add a bullet point prefix for host changes if there's other lines before
                msg += JoinPartFormatter.divider();
            }
            msg += JoinPartFormatter.prefix(actions.user_chghost.prefix);
            msg += this.formatter.listSentence(uhost.entries(), {
                render: _.bind(function (entry, i) {
                    return this.formatter.linkMessageUser(entry[0], entry[1]);
                }, this)
            });
            msg += JoinPartFormatter.spacing();
        }
        if (channelMode && !channelMode.get('newmode') && !msg) {
            msg += 'No channel mode';
        }
        return msg;
    },
    action: function (action) {
        switch (action) {
        case 'joined_channel':
        case 'you_joined_channel':
        case 'user_channel_mode':
        case 'channel_mode_list_change':
        case 'nickchange':
            return 'joined';
        case 'parted_channel':
            return 'parted';
        case 'quit':
            return 'quit';
        }
        return null;
    }
};

JoinPartFormatter.prefix = function (character) {
    return '<span class="prefix">' + character + '</span> ';
};
JoinPartFormatter.sentence = function (content) {
    return '<span class="sentence">' + content + '</span>';
};
JoinPartFormatter.spacing = function () {
    return '&nbsp;&nbsp;';
};
JoinPartFormatter.divider = function () {
    return '•' + JoinPartFormatter.spacing();
};
JoinPartFormatter.initActions = function () {
    return {
        joined: {
            list: [],
            chans: [],
            prefix: '→',
            suffix: 'joined'
        },
        parted: {
            list: [],
            chans: [],
            prefix: '←',
            suffix: 'left'
        },
        quit: {
            list: [],
            chans: [],
            prefix: '⇐',
            suffix: 'quit'
        },
        user_channel_mode: {
            list: [],
            chans: [],
            prefix: 'mode:',
            suffix: ''
        },
        user_chghost: {
            list: [],
            chans: [],
            prefix: 'host change:',
            suffix: ''
        },
        flappedOut: {
            list: [],
            chans: [],
            prefix: '↔',
            suffix: 'nipped out'
        },
        flappedIn: {
            list: [],
            chans: [],
            prefix: '↔',
            suffix: 'popped in'
        },
        nickchange: {
            changes: new sko()
        }
    };
};

module.exports = JoinPartFormatter;


/***/ }),

/***/ "RvJ1":
/***/ (function(module, exports, __webpack_require__) {

var uriTemplates = __webpack_require__("0a14");
var util = __webpack_require__("GmLC");

var Pastebin = Backbone.Model.extend({
    initialize: function (data, options) {
        this.session = options.session;
        if (!this.get('extension')) {
            this.set('extension', this.parseExtension(), {silent: true});
        }
        this.on('removed', function () {
            this.stopListening();
        }, this);
    },
    getUrl: function () {
        if (this.id) {
            return uriTemplates(window.IRCConfig.pastebin_uri_template).fill({
                id: this.id,
                name: this.get('name')
            });
        } else {
            return this.get('external_url');
        }
    },
    getRawUrl: function () {
        if (this.id) {
            var data = {
                type: 'raw',
                id: this.id
            };
            if (this.get('name')) {
                data.name = this.get('name');
            }
            return uriTemplates(window.IRCConfig.pastebin_uri_template).fill(data);
        } else {
            return this.get('external_raw_url');
        }
    },
    getJSONUrl: function () {
        return this.session.backend.buildRawUrl('/pastebin/json/' + this.id);
    },
    getTheme: function () {
        return this.session.getTheme(this.get('theme'));
    },
    isOwn: function () {
        return !!this.get('own_paste');
    },
    getDate: function () {
        return new Date(this.get('date') * 1000);
    },
    parseExtension: function () {
        return Pastebin.parseExtension(this.get('name'));
    },
    getBody: function () {
        // nbsp -> ' '
        return (this.get('body') || '').replace(/\u00a0/g, ' ');
    },
    isTooLarge: function () {
        if (this.getBody() && util.lengthInUtf8Bytes(this.getBody()) > Pastebin.MAX_LENGTH_BYTES) {
            return true;
        }
        return false;
    },
    remove: function (callback) {
        return this.session.post('delete-pastebin', {
            id: this.id
        }, _.bind(function (response) {
            if (response.success || response.message == 'not_found') {
                this.trigger('removed');
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    save: function (data, callback) {
        return this.session.post('paste', data, _.bind(function (response) {
            this.set(response);
            if (callback) {
                callback(response);
            }
        }, this));
    },
    editMultipart: function (data, callback) {
        var formData = new window.FormData();
        formData.append('id', this.id);
        for (var k in data) {
            formData.append(k, data[k]);
        }
        var promise = this.session.ajax({
            url: this.session.backend.buildRawUrl('/chat/edit-pastebin-multipart'),
            type: 'post',
            data: formData,
            dataType: 'json',
            headers: {
                'x-irccloud-session': this.session.getAuthCookie()
            },
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            },
            // Options to tell jQuery not to process data or worry about content-type.
            contentType: false,
            processData: false
        }, function (response) {
            return !!response && response.success;
        });
        promise.done(_.bind(function (response, status, jqXHR) {
            this.set(response.paste);
            this.trigger('edited');
            if (callback) {
                callback(response);
            }
        }, this));
        promise.fail(_.bind(function (jqXHR, errorString, response) {
            if (callback) {
                callback(response);
            }
        }, this));
    },
    editPost: function (data, callback) {
        data.id = this.id;
        return this.session.post('edit-pastebin', data, _.bind(function (response) {
            if (response.success) {
                this.set(response.paste);
                this.trigger('edited');
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    edit: function (data, callback) {
        this.editMultipart(data, callback);
    },
    fetch: function () {
        var url = this.getJSONUrl();
        return this.session.ajax({
            url: url,
            dataType: 'json',
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            }
        }, function (response) {
            return !!response.id;
        }, function (request) {
            return request.status != 404;
        }).done(_.bind(function (response, statusText, request) {
            if (statusText == 404) {
                this.trigger('removed');
            } else {
                this.set(response);
                this.trigger('loaded');
            }
        }, this)).fail(_.bind(function (request, errorString, errorThrown) {
            this.trigger('fetchError', request.status, request.responseText);
        }, this));
    }
}, {
    MAX_LENGTH_BYTES: 50000,
    parseExtension: function (name) {
        if (name) {
            var extMatch = name.match(/\.(\w+)$/);
            if (extMatch) {
                return extMatch[1].toLowerCase();
            }
        }
        return 'txt';
    }
});


module.exports = Pastebin;


/***/ }),

/***/ "SIBJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SbjP":
/***/ (function(module, exports, __webpack_require__) {

var BufferContextMenuView = __webpack_require__("cmaB");


var ChildContextMenuView = BufferContextMenuView.extend({
    events: $.extend({}, BufferContextMenuView.prototype.events, {
        'buttonClick button.hide': 'clickHide',
        'buttonClick button.show': 'clickShow',
        'buttonClick button.joinpart': 'clickJoinPart',
        'buttonClick button.joinpartcollapse': 'clickJoinPartCollapse',
        'buttonClick button.replyCollapse': 'clickReplyCollapse',
        'buttonClick button.replyQuote': 'clickReplyQuote',
        'buttonClick button.typing': 'clickTyping',
        'buttonClick button.files': 'clickFiles',
        'buttonClick button.attachments': 'clickAttachments',
        'buttonClick button.images': 'clickImages',
        'buttonClick button.pastes': 'clickPastes',
        'buttonClick button.socialMedia': 'clickSocialMedia',
        'buttonClick button.mastodon': 'clickMastodon',
        'buttonClick button.bsky': 'clickBsky',
        'buttonClick button.reddit': 'clickReddit',
        'buttonClick button.pinned': 'clickPinned'
    }),
    clickHide: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.archive();
        this.clearContext();
    },
    clickShow: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.unarchive();
        this.clearContext();
    },
    clickJoinPart: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setShowingJoinPartPref(!this.buffer.isShowingJoinPart());
        this.clearContext();
    },
    clickJoinPartCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setCollapsingJoinPartPref(!this.buffer.isCollapsingJoinPart());
        this.clearContext();
    },
    clickReplyCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setCollapsingRepliesPref(!this.buffer.isCollapsingReplies());
        this.clearContext();
    },
    clickReplyQuote: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setQuoteRepliesPref(!this.buffer.isShowingQuoteReplies());
        this.clearContext();
    },
    clickTyping: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setTypingStatusPref(!this.buffer.isSharingTyping());
        this.clearContext();
    },
    clickFiles: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineFilesPref(!this.buffer.inlineFilesAllowed());
        this.clearContext();
    },
    clickAttachments: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineAttachmentsPref(!this.buffer.inlineAttachmentsAllowed());
        this.clearContext();
    },
    clickImages: function (e) {
        e.preventDefault();
        this.hide();
        if (this.buffer.inlineImagesAllowed()) {
            this.buffer.disableInlineImages();
        } else if (this.buffer.session.getPref('inlineimagewarn')) {
            this.buffer.enableInlineImages();
        } else {
            this.buffer.trigger('inlineImageConfirm');
        }
        this.clearContext();
    },
    clickPastes: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlinePastesPref(!this.buffer.inlinePastesAllowed());
        this.clearContext();
    },
    clickSocialMedia: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineSocialMediaPref(!this.buffer.inlineSocialMediaAllowed());
        this.clearContext();
    },
    clickMastodon: function (e) {
        e.preventDefault();
        this.hide();
        if (this.buffer.inlineMastodonAllowed()) {
            this.buffer.setInlineMastodonPref(false);
        } else if (this.buffer.session.getPref('inlinemastodonwarn')) {
            this.buffer.setInlineMastodonPref(true);
        } else {
            this.buffer.trigger('inlineMastodonConfirm');
        }
        this.clearContext();
    },
    clickBsky: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineBskyPref(!this.buffer.inlineBskyAllowed());
        this.clearContext();
    },
    clickReddit: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setInlineRedditPref(!this.buffer.inlineRedditAllowed());
        this.clearContext();
    },
    clickPinned: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setPinned(!this.buffer.isPinned());
        this.clearContext();
    },
    onShow: function () {
        // Archived
        this.deactivateItem(this.$('li.show'), !this.buffer.isArchived(), true);
        this.deactivateItem(this.$('li.hide'), this.buffer.isArchived(), true);

        // Replies
        this.deactivateItem(this.$('li.replyCollapse'), !this.buffer.connection.hasReliableClientTags(), true);
        this.deactivateItem(this.$('li.replyQuote'), !this.buffer.connection.hasReliableClientTags(), true);
        this.enableItem(this.$('li.replyCollapse'), this.buffer.isCollapsingReplies());
        this.enableItem(this.$('li.replyQuote'), this.buffer.isShowingQuoteReplies());

        // Typing indicators
        this.deactivateItem(this.$('li.typing'), !this.buffer.connection.hasClientTags(), true);
        this.enableItem(this.$('li.typing'), this.buffer.isSharingTyping());
        
        // Showing join parts
        this.deactivateItem(this.$('li.collapseJoinPart'), !this.buffer.isShowingJoinPart(), true);
        this.enableItem(this.$('li.showJoinPart'), this.buffer.isShowingJoinPart());
        this.enableItem(this.$('li.collapseJoinPart'), this.buffer.isCollapsingJoinPart());
        
        // Embeds
        this.enableItem(this.$('li.inlineFiles'), this.buffer.inlineFilesAllowed());
        this.deactivateItem(this.$('li.inlineAttachments'), !this.buffer.connection.hasReliableClientTags(), true);
        this.enableItem(this.$('li.inlineAttachments'), this.buffer.inlineAttachmentsAllowed());
        this.enableItem(this.$('li.inlineImages'), this.buffer.inlineImagesAllowed());
        this.enableItem(this.$('li.inlinePastes'), this.buffer.inlinePastesAllowed());
        this.enableItem(this.$('li.inlineSocialMedia'), this.buffer.inlineSocialMediaAllowed());
        this.enableItem(this.$('li.inlineMastodon'), this.buffer.inlineMastodonAllowed());
        this.enableItem(this.$('li.inlineBsky'), this.buffer.inlineBskyAllowed());
        this.enableItem(this.$('li.inlineReddit'), this.buffer.inlineRedditAllowed());

        // Pinned buffers

        this.deactivateItem(this.$('li.pinned'), !this.buffer.canPin(), true);
        this.enableItem(this.$('li.pinned'), this.buffer.isPinned());
    }
});


module.exports = ChildContextMenuView;


/***/ }),

/***/ "SiCN":
/***/ (function(module, exports, __webpack_require__) {

var BufferStatusView = __webpack_require__("6G2X");


var ThreadStatusView = BufferStatusView.extend({
    className: BufferStatusView.prototype.className + ' threadHead',
    events: $.extend({}, BufferStatusView.prototype.events, {
        'buttonClick button.close': 'clickClose'
    }),
    clickClose: function (e) {
        this.model.session.clearThreadId();
        return false;
    },
    render: function () {
        BufferStatusView.prototype.render.apply(this, arguments);
        this.members = $('<span class="thread__members">');
        this.title.append(this.members);
        this.renderMembers();
        this.model.members.on('update', this.renderMembers, this);
        return this;
    },
    renderButtons: function () {
        BufferStatusView.prototype.renderButtons.apply(this);
        this.appendButton('close', 'Close');
    },
    renderMembers: function () {
        var parts = this.model.members.map(function (member) {
            return this.formatter.linkUser(member, {
                noData: true,
                className: 'thread__participant'
            });
        }, this);
        this.members.html(this.formatter.listSentence(parts));
        return this;
    },
    renderLabel: function () {
        var label;
        if (this.model.connection.isSlack()) {
            label = this.formatter.linker.makeLinkFromBits('Thread', {
                url: this.model.getSlackUrl(),
                target: '_blank'
            });
        } else {
            label = 'Thread';
        }
        label += ' from ' + this.formatter.linkModel(this.model);
        this.label.html(label);
    }
});


module.exports = ThreadStatusView;


/***/ }),

/***/ "Sirl":
/***/ (function(module, exports, __webpack_require__) {

var BufferPromptHandler = __webpack_require__("JGoS");
var Formatter = __webpack_require__("5gSh");


var SessionPromptHandler = BufferPromptHandler.extend({
    initialize: function (options) {
        this.bindMessageHandlers();
        
        this.formatter = new Formatter();
    },
    defaultHead: function () {
        return 'IRCCloud';
    },
    bindMessageHandlers: function () {
        this.model.bind('postError', this.postError, this);
        this.model.bind('inlineImageConfirm', this.inlineImageConfirm, this);
        this.model.bind('inlineMastodonConfirm', this.inlineMastodonConfirm, this);
    },
    inlineImageConfirm: function (callback) {
        var confirmHtml = "Be aware that embedding external media may result in your IP address being revealed to any host on the internet.";
        var overlay = this.htmlConfirm(confirmHtml, _.bind(function () {
            this.model.setPref('inlineimagewarn', true);
            if (callback) {
                callback();
            }
        }, this), {
            okText: 'Turn on external embedding',
            head: 'Embedding external media'
        });
        overlay.className = 'inline_image_confirm';
        this.triggerAdd(overlay);
    },
    inlineMastodonConfirm: function (callback) {
        var confirmHtml = "Be aware that embedding Mastodon links may result in your IP address being revealed to any host on the internet.";
        var overlay = this.htmlConfirm(confirmHtml, _.bind(function () {
            this.model.setPref('inlinemastodonwarn', true);
            if (callback) {
                callback();
            }
        }, this), {
            okText: 'Turn on Mastodon embedding',
            head: 'Embedding Mastodon'
        });
        overlay.className = 'inline_image_confirm';
        this.triggerAdd(overlay);
    }
});


module.exports = SessionPromptHandler;


/***/ }),

/***/ "TP0+":
/***/ (function(module, exports, __webpack_require__) {

var ChildView = __webpack_require__("plGQ");
var ConversationStatusView = __webpack_require__("mysc");


var ConversationView = ChildView.extend({
    className: ChildView.prototype.className + ' conversation',
    initialize: function (options) {
        this.status = new ConversationStatusView(options);

        ChildView.prototype.initialize.apply(this, arguments);
    }
});


module.exports = ConversationView;


/***/ }),

/***/ "TT07":
/***/ (function(module, exports, __webpack_require__) {

var Buf = __webpack_require__("t9zO");
var Member = __webpack_require__("abDD");
var User = __webpack_require__("Xgjh");
var Keyboard = __webpack_require__("fDhS").default;
var util = __webpack_require__("GmLC");


var TabCompletion = Backbone.View.extend({
    initialize: function (options) {
        this.clear();
        this.emoji = null;
        this.candidate = 0;
        this.throttledCursorCandidates = _.throttle(_.bind(this.cursorCandidates, this), 60);
    },
    events: {
        'input': 'onInput',
        'keyup': 'onInput',
        'update': 'onInput'
    },
    clear: function () {
        this.word = null;
        this.trail = null;
        this.prev = null;
        this.original = false;
        this.cyclingBlank = false;
        this.cyclingCommand = false;
        this.cyclingBlankCommand = false;
        this.cyclingBlankJoin = false;
        this.cyclingModes = false;
        this.candidateIsChan = false;
        this.candidateIsUser = false;
        this.cyclingTopic = false;
        this.cyclingJoin = false;
        this.cyclingLastHighlighted = false;
        this.cyclingBan = false;
    },
    clearAll: function () {
        this.clear();
        this.emoji = null;
    },
    cursorCandidates: function () {
        if (!this.cyclingTopic) {
            // Setup state again
            this.resetGetCandidates();
            this.candidates = this.getEmojiCandidates();
            this.trigger('completeCandidates', this.word, this.candidates, undefined, this.emoji);
        }
        // Clean up state again
        this.clear();
    },
    onInput: function (e) {
        var value = $(this.el).val();
        if (value != this.getValue()) {
            this.value = value;
            this.throttledCursorCandidates();
        }
    },
    makeClickedChoice: function (index) {
        this.makeChoice(index);
        this.clearAll();
    },
    makeChoice: function (index, options) {
        var choice = this.chooseCandidate(index, options);
        this.updateInput(choice);
    },
    makeOriginalChoice: function () {
        var choice = this.chooseOriginal();
        this.updateInput(choice);
    },
    onKey: function (e) {
        if (e.ctrlKey || e.altKey || e.metaKey) {
            return;
        }

        var cr = $(this.el).cursorRange();
        if (!this.cursorRange) {
            this.cursorRange = cr;
        }
        if (e.which === Keyboard.KEYS.TAB) {
            e.preventDefault();
            if (this.cursorRange.start === this.cursorRange.end) {
                // Don't complete when we have selected text
                var reverse = e.shiftKey;
                this.updateIndex(reverse);
                this.candidates = this.getCandidates();
                var index = this.getIndex();
                if (!this.cyclingTopic) {
                    this.trigger('completeCandidates', this.word, this.candidates, index);
                }
                var options = {};
                var nextChar = this.trail[0] || this.afterSelection[0];
                var prevChar = this.prev[this.prev.length-1];
                if (prevChar !== '@' && this.model.connection.isSlack()) {
                    options.atMention = true;
                }
                if (nextChar === ':' || nextChar === ' ') {
                    options.separator = '';
                    options.nospace = true;
                    options.emojiColonAfter = (nextChar === ':');
                }
                this.makeChoice(index, options);
            }
        } else if (!e.shiftKey && e.which !== Keyboard.KEYS.ESC) {
            // Keypress can move the cursor position, so let's check candidates
            // again (since emoji completions show and hide without pressing tab)
            // Skip if shift is being pressed (e.g. shift arrow selection)
            // Skip if escape was pressed, to allow emoji candidates to be dismissed
            this.throttledCursorCandidates();
        }
    },
    chooseOriginal: function () {
        // Reset the word and return to just the word on its own
        var choice = this.cyclingBlank ? '' : this.word;
        this.clearAll();
        return choice;
    },
    cmpBuffers: function (a, b) {
        // 1. Badged/unread
        var unseen = (b.hasUnseen() && b.isTrackingUnread()) -
                     (a.hasUnseen() && a.isTrackingUnread());
        if (unseen !== 0) {
            return unseen;
        }
        // 2. Last selected
        var time = (b.lastSelected || 0) - (a.lastSelected || 0);
        if (time !== 0) {
            return time;
        }
        // 3. Currently selected, active, unarchived
        var state = (b.isSelected() - a.isSelected()) ||
                    (b.isActive()   - a.isActive())   ||
                    ((a.isServerLog() || a.isArchived()) -
                     (b.isServerLog() || b.isArchived()));
        if (state !== 0) {
            return state;
        }
        // 4. Connection
        if (a.getCid() > b.getCid()) {
            return 1;
        } else if (a.getCid() < b.getCid()) {
            return -1;
        //  5. Deprioritise server logs
        } else if (a.isServerLog() && !b.isServerLog()) {
            return 1;
        } else if (b.isServerLog() && !a.isServerLog()) {
            return -1;
        } else {
            // 5. alpha

            var aName = a.isServerLog() ? a.getFullLabel() : a.getName();
            var bName = b.isServerLog() ? b.getFullLabel() : b.getName();
            if (aName > bName) {
                return 1;
            } else if (aName < bName) {
                return -1;
            } else {
                return 0;
            }
        }
    },
    cmpAll: function (a, b) {
        // 1. Last highlighted, last spoke
        var time;
        var aLastHighlight, bLastHighlight, aLastSpoke, bLastSpoke;
        if (a instanceof Member) {
            aLastSpoke = a.getLastSpoke();
            aLastHighlight = a.getLastHighlighted();
        }
        if (b instanceof Member) {
            bLastSpoke = b.getLastSpoke();
            bLastHighlight = b.getLastHighlighted();
        }
        time = (bLastHighlight || 0) - (aLastHighlight || 0) ||
               (bLastSpoke     || 0) - (aLastSpoke     || 0);
        if (time) {
            return time;
        }

        if (a instanceof User || b instanceof User) {
            if (a instanceof Buf) {
                return -1;
            } else if (b instanceof Buf) {
                return 1;
            } else {
                return util.naturalCompare(a.normalise(), b.normalise());
            }
        }

        // Only buffers should get here
        if (a instanceof Buf || b instanceof Buf) {
            return this.cmpBuffers(a, b);
        } else {
            return this.cmpString(a, b);
        }
    },
    cmpString: function (a, b) {
        if (a > b) {
            return 1;
        } else if (b < a) {
            return -1;
        } else {
            return 0;
        }
    },
    cursorRangeChange: function () {
        var cr = $(this.el).cursorRange();
        return !this.cursorRange || cr.start != this.cursorRange.start || cr.end != this.cursorRange.end;
    },
    cacheCursorRange: function () {
        this.cursorRange = $(this.el).cursorRange();
    },
    getValue: function () {
        return this.value || '';
    },
    updateIndex: function (reverse) {
        // Initial setup
        if (!this.word && !this.cyclingBlank) {
            if (reverse) {
                this.candidate = -1;
            } else {
                this.candidate = 0;
            }
        } else {
            // Move the candidate index on, so we cycle through the choices
            if (reverse) {
                if (this.candidate === 0) {
                    // This indicates we were going forwards and are now going backwards and have reached the start
                    this.original = true;
                }
                this.candidate--;
            } else {
                this.candidate++;
            }
        }
    },
    inputMatchesNoStrip: function (candidate, input) {
        return this.inputMatches(candidate, input, true);
    },
    inputMatches: function (candidate, input, noStrip) {
        if (!candidate) {
            return false;
        }
        // normalise case
        candidate = candidate.toLowerCase();
        input = input.toLowerCase();

        // Just use the last word
        var inputTokens = input.split(/\s+/);
        var lastInput = inputTokens.pop();

        // Strip leading non alphanum chars from candidate unless input starts with one
        if (!noStrip && lastInput.match(/^[a-z0-9]/)) {
            candidate = candidate.replace(/^[^a-z0-9]+/, '');
        }

        return candidate.indexOf(lastInput) === 0;
    },
    splitWords: function (words) {
        // Match words
        return words.match(TabCompletion.WORD_REGEX) || [];
    },
    getWordPrevTrail: function (words) {
        var tokens = this.splitWords(words);
        var word = tokens.pop() || '';
        var index = words.lastIndexOf(word);
        var prev = words.slice(0, index);
        var trail = words.slice(index + word.length);
        return [word, prev, trail];
    },
    splitCursorWordValues: function () {
        this.cacheCursorRange();
        // Split the sentence either side of the word before the selection
        var value = this.getValue();
        this.wordsTillSelection = value.slice(0, this.cursorRange.start);
        this.afterSelection = value.slice(this.cursorRange.start);
        var wordPrevTrail = this.getWordPrevTrail(this.wordsTillSelection);
        this.word = wordPrevTrail[0];
        this.prev = wordPrevTrail[1];
        this.trail = wordPrevTrail[2];
    },
    getEmojiCandidates: function (candidates) {
        candidates = candidates || [];
        if (this.word[0] === ':') {
            var emoWord = this.word.replace(/^:/, '').replace(/_/g, '');
            if (emoWord.length > 1) {
                var emoCandList = util.matchEmoji(emoWord);
                if (emoCandList && emoCandList.length) {
                    this.emoji = this.word;
                    var skinTone = this.model.session.getPref('skin-tone');
                    _.each(emoCandList, function emojiCandListEach (cand) {
                        candidates.push({
                            emoji: cand.idx,
                            title: emoji.strip_colons_only(
                                emoji.idx_to_colon(cand.idx, skinTone)
                            ),
                            skinTone: skinTone,
                            getName: function () {
                                return cand.idx;
                            }
                        });
                    });
                }
            }
        }
        return candidates;
    },
    resetGetCandidates: function () {
        this.emoji = null;
        if (!this.word && !this.cyclingBlank) {
            this.splitCursorWordValues();
        }
    },
    getCandidates: function (emoji) {
        this.resetGetCandidates();

        var members = this.model.getMembers();
        var channels = this.model.connection.buffers.channels;
        var previousBuffer = this.model.session.previousBuffer;

        // Build up list of matching candidates
        var candidates = [];
        
        var command;
        var chanCommand = false;
        var banCommand = false;
        var topicCommand = false;
        var nonJoinOnlyChans = false;

        var commandMatch = this.wordsTillSelection.match(/^\/(\w+)(\s+.*|$)/);
        if (commandMatch) {
            command = commandMatch[1].toLowerCase();
            this.cyclingCommand = command;
            if (commandMatch[2].match(/^\s*$/)) {
                this.cyclingBlank = true;
                this.cyclingBlankCommand = true;
            }
            switch (command) {
            case 'j':
            case 'join':
            case 'channel':
            case 'rejoin':
            case 'mode':
                chanCommand = true;
                if (command == 'mode') {
                    this.cyclingModes = true;
                    if (this.cyclingBlankCommand) {
                        nonJoinOnlyChans = true;
                    }
                } else {
                    this.cyclingJoin = true;
                    if (this.cyclingBlankCommand) {
                        this.cyclingBlankJoin = true;
                    }
                }
                break;
            case 'ban':
                banCommand = true;
                break;
            case 'topic':
                topicCommand = true;
                break;
            }
        }
        if (this.cyclingBlankCommand && chanCommand) {
            // Channel command, only complete from channels
            channels.each(function getCandidatesEachChannelCommand (channel) {
                if (!channel.isArchived()) {
                    candidates.push(channel);
                }
            });

            candidates.sort(this.cmpBuffers);
        } else if (this.model.isChannel() && this.cyclingBlankCommand && topicCommand && this.model.getTopic()) {
            // Cycle topics
            var topic = this.model.getTopic().getText();
            this.cyclingTopic = true;
            // TODO keep a history of topics server side
            candidates.push(topic);
        } else if (!this.word) {
            // No word, only complete from last highlighted (or conversation recipient)
            this.cyclingBlank = true;
            this.cyclingLastHighlighted = true;
            if (this.model.isConversation()) {
                candidates.push(this.model.getRecipient());
            } else {
                members.each(function getCandidatesEachMember (member) {
                    if (!member.isIgnored() && (
                        // Either thread participant or highlighter
                        this.model.isThread() || member.lastHighlighted
                    )) {
                        candidates.push(member);
                    }
                }, this);
            }

            // Sort by last highlighted
            candidates.sort(function getCandidatesSort (a, b) {
                return (b.getLastHighlighted() || 0) - (a.getLastHighlighted() || 0);
            });
        } else {
            // Have a word, not a channel command, add matching members, channels and emoji
            var anyMembers = false;
            var getCandidatesEachMemberWord = function (member) {
                if (
                    this.inputMatches(member.getName(), this.word) ||
                    this.inputMatches(member.getDisplayAuthor(), this.word)
                ) {
                    anyMembers = true;
                    candidates.push(member);
                }
            };
            if (this.model.isThread()) {
                this.model.buffer.getMembers().each(getCandidatesEachMemberWord, this);
            } else {
                members.each(getCandidatesEachMemberWord, this);
            }

            if (!banCommand) {
                channels.each(function getCandidatesEachChannelWord (chan) {
                    if (this.inputMatchesNoStrip(chan.getName(), this.word)) {
                        if (!anyMembers) {
                            nonJoinOnlyChans = true;
                        }
                        candidates.push(chan);
                    }
                }, this);
            }
            candidates.sort(_.bind(this.cmpAll, this));

            // Emoji
            candidates = this.getEmojiCandidates(candidates);
        }

        // Move previous chan to start for join commands
        if (chanCommand && previousBuffer && previousBuffer.isChannel()) {
            var prevChanIndex = $.inArray(previousBuffer, candidates);
            if (prevChanIndex !== -1) {
                var prevChan = candidates.splice(prevChanIndex, 1)[0];
                candidates.unshift(prevChan);
            }
        }

        if (!this.cyclingTopic) {
            var selfIndex = _.indexOf(_.map(candidates, function getCandidatesNormaliseSelf (item, index) {
                return item.getName().toLowerCase();
            }), this.model.getNick().toLowerCase());
            if (selfIndex !== -1) {
                var selfItem = candidates.splice(selfIndex, 1)[0];
                if (this.cyclingModes && this.cyclingBlankCommand) {
                    // Move yourself to the start for modes
                    candidates.unshift(selfItem);
                } else {
                    // Move yourself to the end
                    candidates.push(selfItem);
                }
            } else if (this.cyclingModes && this.cyclingBlankCommand) {
                // Insert yourself at the start for modes
                candidates.unshift(this.model.connection.getUser());
            }
        }

        var selfChanIndex = $.inArray(this.model, candidates);
        if (selfChanIndex !== -1) {
            // Move current chan to end for join commands and to start for other chan only commands
            var selfChan = candidates.splice(selfChanIndex, 1)[0];
            if (nonJoinOnlyChans) {
                candidates.unshift(selfChan);
            } else {
                candidates.push(selfChan);
            }
        }

        if (banCommand) {
            this.cyclingBan = true;
            // Add a ban mask too
            candidates = _.flatten(_.map(candidates, function getCandidatesAddBanMask (m) {
                return [m, m.getBanMask(true)];
            }));
        }

        return candidates;
    },
    getIndex: function () {
        if (this.original) {
            return -1;
        }
        var index = this.candidate;
        if (index < 0) {
            index = this.candidates.length + index;
        }
        return index;
    },
    chooseCandidate: function (index, options) {
        options = options || {};
        if (!this.candidates[index]) {
            // We've overflown the candidates array
            return this.chooseOriginal();
        }

        var choice = this.candidates[index];
        if (choice instanceof Backbone.Model) {
            this.candidateIsChan = (choice instanceof Buf && choice.isChannel());
            this.candidateIsUser = choice instanceof User;
            choice = choice.getName();
        } else if (choice.emoji) {
            var emojiValue = '';
            emojiValue += ':';
            emojiValue += choice.title;
            if (!options.emojiColonAfter) {
                emojiValue += ':';
            }
            choice = emojiValue;
        }
        if (this.candidateIsUser && options.atMention && (
            !this.cyclingCommand || this.cyclingCommand == 'me'
        )) {
            // Always add an at sign when needed
            choice = '@' + choice;
        } else {
            if (options.separator !== undefined) {
                // Allow separator override
                choice += options.separator;
            } else if (this.candidateIsUser && this.word === this.wordsTillSelection) {
                // Add separator if it's the first word of the line and a user mention
                choice += ':';
            }
        }
        // Add a spacer if choice is:
        if (
            !options.nospace &&
            // * not emoji — :lol:
            !this.emoji &&
            // * not topic — /topic+tab
            !this.cyclingTopic &&
            // * not join command on its own — /j+tab
            !this.cyclingBlankJoin
        ) {
            choice += ' ';
        }
        return choice;
    },
    updateInput: function (choice) {
        // Update the input box value
        var beforeSelection;
        if (this.word && !this.cyclingBlank) {
            beforeSelection = this.wordsTillSelection.slice(0, this.wordsTillSelection.lastIndexOf(this.word));
        } else if (this.emoji && !this.cyclingBlank) {
            beforeSelection = this.wordsTillSelection.slice(0, this.wordsTillSelection.lastIndexOf(this.emoji));
        } else {
            beforeSelection = this.wordsTillSelection;
        }
        if (this.word && !this.word.match(/\s+$/) && this.cyclingBlankCommand) {
            beforeSelection += ' ';
        }
        var cursorStart = beforeSelection.length;
        var cursorEnd;
        if (this.word || this.emoji || this.cyclingBlank) {
            beforeSelection += choice;
        }
        this.value = beforeSelection;
        if (this.word) {
            this.value += this.trail;
        }
        this.value += this.afterSelection;
        $(this.el).val(this.value);

        // Move the cursor to after the choice
        if (this.candidateIsChan && this.cyclingJoin) {
            // Select the channel name if it's a channel
            cursorStart++;
            cursorEnd = beforeSelection.length;
        } else {
            // Don't set cursorEnd for mode channels or non channels
            cursorStart = beforeSelection.length;
        }
        $(this.el).cursorRange(cursorStart, cursorEnd);
    }
}, {
    WORD_REGEX: new RegExp('[' +
        // alnum
        'a-z0-9' +
        // Latin
        '\\u00C0-\\u00D6'   +
        '\\u00D8-\\u00F6'   +
        '\\u00F8-\\u02AF'   +
        // Greek
        '\\u0370-\\u03ff'   +
        // CJK
        // http://en.wikipedia.org/wiki/Hangul
        // http://en.wikipedia.org/wiki/Hiragana
        // http://en.wikipedia.org/wiki/Katakana
        // http://en.wikipedia.org/wiki/Han_unification#Unicode_ranges
        '\\uAC00-\\uD7AF'   + // (K)   Hangul Syllables
        '\\u1100-\\u11FF'   + // (K)   Hangul Jamo
        '\\u3130-\\u318F'   + // (K)   Hangul Compat Jamo
        '\\uA960-\\uA97F'   + // (K)   Hangul Jamo Ext A
        '\\uD7B0-\\uD7FF'   + // (K)   Hangul Jamo Ext B
        '\\u3040-\\u309F'   + // (J)   Hiragana
        '\\u30A0-\\u30FF'   + // (J)   Katakana
        '\\u31F0-\\u32FF'   + // (J)   Katakana Phonetic
        // '\\u1B000-\\u1B0FF' + // (J)   Kana Suppl
        '\\uFF00-\\uFFEF'   + // (KJ)  Half/Full Forms
        '\\u4E00-\\u9FFF'   + // (CJK) Unified
        '\\u3400-\\u4DBF'   + // (CJK) Ext A
        // '\\u20000-\\u2A6DF' + // (CJK) Ext B
        // '\\u2A700-\\u2B73F' + // (CJK) Ext C
        // '\\u2B740-\\u2B81F' + // (CJK) Ext D
        '\\uF900-\\uFAFF'   + // (CJK) Unified Compat
        '\\u3200-\\u32FF'   + // (CJK) Enclosed
        // specific list of chars used in nicks and chans:
        '#' + '[' + '\\\\' + '\\]' + '^' + '_' + '`' + '{' + '|' + '}' + '-' +
    ']+|(\\B:[^\\s:]+:?)', 'gi')
});


module.exports = TabCompletion;


/***/ }),

/***/ "TwDC":
/***/ (function(module, exports, __webpack_require__) {

var Formatter = __webpack_require__("5gSh");
var DialogView = __webpack_require__("EjYC");
var Keyboard = __webpack_require__("fDhS").default;


var AccountMenuView = DialogView.extend({
    el: '.accountMenu',
    initialize: function (options, sidebar) {
        DialogView.prototype.initialize.call(this, options);
        
        this.sidebar = sidebar;
        
        this.showInstant = true;
        this.hideInstant = true;
        this.closeOnClickOff = true;
        
        this.formatter = new Formatter();
        this.model.bind('change:email change:name', this.renderLoggedInAs, this);
        this.model.bind('change:shard_id change:shard_name', this.renderShard, this);
        
        $('.accountMenu__button').on('click buttonClick', _.bind(this.clickAccountMenuButton, this));
    },
    events: $.extend({}, DialogView.prototype.events, {
        'buttonClick .accountMenu__invites-button': 'clickInvites',
        'buttonClick .accountMenu__signout-button': 'clickSignout'
    }),
    clickAccountMenuButton: function (e, options) {
        options = options || {};
        if (this.isVisible()) {
            this.hide();
            $('.accountMenu__button').attr('aria-expanded', 'false');
        } else {
            this.isKeypress = e.originalEvent ? Keyboard.isClickEnter(e) : options.keypress;
            this.show();
            $('.accountMenu__button').attr('aria-expanded', 'true');
            this.el.scrollTop = this.el.scrollHeight;
        }
        return false;
    },
    clickInvites: function (e) {
        DialogView.closeCurrent();
        this.model.trigger('showInvites');
        return false;
    },
    clickSignout: function (e) {
        e.preventDefault();
        this.model.logout();
    },
    renderLoggedInAs: function () {
        $('.accountMenu__email').text(this.model.get('email') || '');
        $('.accountMenu__name').text(this.model.get('name') || '');
    },
    renderShard: function() {
        var shardMsg = 'Server name: ' + this.model.get('shard_name') +
                       '; Server id: ' + this.model.get('shard_id');
        $('.accountMenu__title').attr('title', shardMsg);
    },
    afterHide: function () {
        this.isKeypress = null;
    },
    afterShow: function () {
        this.focusFirstItem();
    },
    focusFirstItem: function () {
        if (this.isKeypress) {
            this.$('.addNetworkButton').focus();
        }
    }
});


module.exports = AccountMenuView;


/***/ }),

/***/ "UwCA":
/***/ (function(module, exports, __webpack_require__) {

var HashDialogView = __webpack_require__("o6PP");
var Keyboard = __webpack_require__("fDhS").default;


var ShortcutsDialogView = HashDialogView.extend({
    el: '#shortcutsOverlayContents',
    wrapper: $('#shortcutsContainer'),
    events: $.extend({}, HashDialogView.prototype.events, {
        'click .prefModifierMe__toggle': 'togglePrefModifierMe'
    }),
    initialize: function (options) {
        HashDialogView.prototype.initialize.call(this, options);

        this.router.route('?/shortcuts', 'show', _.bind(this.show, this));

        $(window).on('keydown', _.bind(function (e) {
            if (Keyboard.isModifier(e) && e.which === Keyboard.KEYS['/']) {
                e.preventDefault();
                this.model.trigger('navigate', '?/shortcuts', {trigger: true});
            }
        }, this));

        this.renderModifierMe();
        this.listenTo(this.model, 'prefChange:keyboard-disable-modifier-me', this.renderModifierMe);
    },
    renderModifierMe: function () {
        var shortcut = this.$('.prefModifierMe__shortcut');
        var enabled = this.model.modifierMeEnabled();
        shortcut.toggleClass('prefModifierMe__shortcut--disabled', !enabled);
        shortcut.toggleClass('prefModifierMe__shortcut--enabled', enabled);
    },
    togglePrefModifierMe: function (e) {
        e.preventDefault();
        this.model.setModifierMe(!this.model.modifierMeEnabled());
    }
});


module.exports = ShortcutsDialogView;


/***/ }),

/***/ "V125":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"upgradeChecklist\">\n    <li class=\"explanation\">\ud83d\udce1&nbsp;&nbsp;Stay permanently connected to IRC, even while you're offline</li>\n    <li class=\"explanation\">\ud83d\udd0c&nbsp;&nbsp;No disconnects after periods of inactivity</li>\n    <li class=\"explanation\">\ud83d\udcf1&nbsp;&nbsp;<a href=\"https://blog.irccloud.com/mobile-apps-open-sourced/\" target=\"_blank\" rel=\"noreferrer\">Mobile apps</a> for iOS and Android</li>\n    <li class=\"explanation\">\ud83c\udf0d&nbsp;&nbsp;Connect to as many networks as you need</li>\n    <li class=\"explanation\">\ud83d\udd11&nbsp;&nbsp;Access passworded networks</li>\n    <li class=\"explanation\">\ud83d\udcdc&nbsp;&nbsp;Unlimited access to your chat history</li>\n    <li class=\"explanation\">\ud83d\udc4d&nbsp;&nbsp;Cancel at any time</li>\n</ul>\n            \n<hr>\n\n<p class=\"explanation\">If you choose not to upgrade, you’ll have a 7 day trial period before your account becomes limited.</p>\n\n<p class=\"explanation\">Limited accounts are disconnected after 2 hours unless you have the web site or one of the mobile apps open.</p>\n\n<p class=\"explanation\">Trialing and limited accounts can’t access passworded servers, and can only add 2 external networks, other than irc.irccloud.com.</p>";
},"useData":true});

/***/ }),

/***/ "VBlq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VFp6":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");


var BufferListBufferView = Backbone.View.extend({
    sidebar: $('#sidebar'),
    initialize: function (options) {
        this.formatter = new BufferFormatter(this.model);
    },
    events: {
        'click span.buffer': 'click',
        'buttonClick span.buffer': 'click'
    },
    click: function (e) {
        e.preventDefault();
        this.model.session.trigger('sidebarBufferClick', this.model);
        this.model.select();
    },
    getTemplate: function () {
        if (!BufferListBufferView._structure) {
            BufferListBufferView._structure = $($('#tpl-buffer-link').html());
        }
        return BufferListBufferView._structure.clone();
    },
    render: function () {
        this.link = this.getTemplate();

        var lockTitle;
        if (this.model.connection.isSlack()) {
            lockTitle = "Private channel";
        } else {
            lockTitle = "Password protected";
        }
        this.link.find('.fa-lock').attr('title', lockTitle);

        this.linkLabel = this.link.find('.label');
        this.renderLink();
        
        this.renderActive().renderSelected().renderUnread().renderHighlights().renderDeferred().renderTimeout();
        this.model.bind('selectedChange', this.renderSelected, this);
        this.model.bind('change:deferred', this.renderDeferred, this);
        this.model.bind('change:timeout', this.renderTimeout, this);
        this.model.bind('activeChange', this.renderActive, this);
        this.model.bind('unseenChange', this.renderUnread, this);
        this.model.bind('prefChange:disableTrackUnread', this.renderUnread, this);
        this.model.bind('unseenHighlightChange', this.renderHighlights, this);
        this.model.bind('remove', this.remove, this);
        this.model.on('rendered', this.containerRendered, this);
        
        this.$el.append(this.link);

        if (this.model.isPinned()) {
            this.$el.data('bid', this.model.bid());
        }
        
        return this;
    },
    renderLink: function () {
        return this.renderLinkUrl().renderLinkText();
    },
    setLinkLabelHtml: function (html) {
        this.linkLabel[0].innerHTML = html;
    },
    renderDeferred: function () {
        this.$el.toggleClass('deferred', this.model.isDeferred());
        return this;
    },
    renderTimeout: function () {
        this.$el.toggleClass('timeout', this.model.isTimeout());
        return this;
    },
    renderUnread: function () {
        if (this.model.isTrackingUnread()) {
            this.$el.removeClass('ignoredUnread');
            this.$el.toggleClass('unread', this.model.hasUnseen());
        } else {
            this.$el.removeClass('unread');
            this.$el.toggleClass('ignoredUnread', this.model.hasUnseen());
        }
        return this;
    },
    renderHighlights: function () {
        if (this.model.hasUnseenHighlights()) {
            this.link.find('.badge').text(this.model.unseenHighlightCount());
            this.$el.addClass('activeBadge');
        } else {
            this.link.find('.badge').text('');
            this.$el.removeClass('activeBadge');
        }
        
        return this;
    },
    containerRendered: function () {
        this.link.attr({
            'aria-controls': 'buffercontainer_' + this.model.bid()
        });
    },
    scrollToView: function () {
        this.trigger('scrollTo', this.$el);
    },
    renderSelected: function () {
        var selected = this.model.isSelected();
        this.$el.toggleClass('selected', selected);
        this.link.attr('aria-selected', String(selected));
        return this;
    },
    renderActive: function () {
        this.$el.toggleClass('active', this.model.isActive());
        return this;
    }
});


module.exports = BufferListBufferView;


/***/ }),

/***/ "WeW2":
/***/ (function(module, exports, __webpack_require__) {

var MemberList = __webpack_require__("XZrG");


var MemberAdminList = MemberList.extend({
    modeCategory: 'ADMIN'
});


module.exports = MemberAdminList;


/***/ }),

/***/ "X9Qn":
/***/ (function(module, exports, __webpack_require__) {

var BufferPromptHandler = __webpack_require__("JGoS");


var ConversationPromptHandler = BufferPromptHandler.extend({
    bindMessageHandlers: function (options) {
        BufferPromptHandler.prototype.bindMessageHandlers.call(this, options);
        this.model.bind('deleteConfirm', this.deleteConfirm, this);
        this.model.bind('renamePrompt', this.renamePrompt, this);
        this.model.bind('renameError', this.renameError, this);
    },
    deleteConfirm: function (callback) {
        var confirmText = "Are you sure you want to delete your history with " + this.model.getName();
        var overlay = this.confirm(confirmText, _.bind(function () {
            this.model.remove();
            if (callback) {
                callback();
            }
        }, this), {
            confirmClass: 'delete'
        });
        overlay.className = 'conversation_delete_confirm';
        this.triggerAdd(overlay);
    },
    renameError: function (newName, response, callback) {
        var msg = '';
        switch (response.message) {
        case 'invalid_name':
            msg = 'You must choose a valid nick name';
            break;
        case 'not_conversation':
            msg = 'You can only rename private messages';
            break;
        case 'name_exists':
            msg = 'That name is already taken';
            break;
        default:
            msg = 'Error renaming: ' + response.message;
        }
        this.renamePrompt(newName, callback, msg);
    },
    renamePrompt: function (promptName, callback, error) {
        var promptText = "Choose a new name for this conversation";
        var overlay = this.prompt(promptText, _.bind(function (newName) {
            this.model.rename(newName, callback);
        }, this), promptName, {
            error: error,
            keepFocus: false
        });
        overlay.className = 'conversation_rename_prompt';
        this.triggerAdd(overlay);
    }
});


module.exports = ConversationPromptHandler;


/***/ }),

/***/ "XDey":
/***/ (function(module, exports, __webpack_require__) {

var MemberList = __webpack_require__("XZrG");


var MemberVoicedList = MemberList.extend({
    modeCategory: 'VOICED'
});


module.exports = MemberVoicedList;


/***/ }),

/***/ "XLeX":
/***/ (function(module, exports) {

var TitleView = Backbone.View.extend({
    el: 'title',
    initialize: function (options) {
        this.model.buffers.bind('unseenHighlightChange', this.render, this);
        this.model.connections.bind('change:name', this.connectionChange, this);
        this.model.connections.bind('change:hostname', this.connectionChange, this);
        this.model.connections.bind('twitchChannelChange', this.connectionChange, this);
        this.model.connections.bind('urlPropChange', this.connectionChange, this);
        this.model.bind('unseenChange', this.render, this);
        this.model.bind('currentBufferChange', this.render, this);
        this.model.bind('streamConnectedChange', this.render, this);
    },
    getUnseenMessageStats: function () {
        if (!this.model.unseenBuffers.length) {
            return false;
        }
        var count = 0;
        this.model.unseenBuffers.each(function (buffer) {
            count += buffer.unseenHighlightCount();
        }, this);
        return count;
    },
    connectionChange: function (connection) {
        if (!connection.isSelected()) {
            return;
        }
        this.render();
    },
    
    render: function () {
        var title = 'IRCCloud';
        var entName = this.model.ent('fullname');
        if (entName) {
            title += ': ' + entName;
        }
        var current = this.model.currentBuffer;
        if (current) {
            title = current.connection.getName();
            if (!current.isServerLog()) {
                var displayName = current.getDisplayName();
                if (current.isChannel()) {
                    var twitchInfo = current.getTwitchInfo();
                    if (twitchInfo && twitchInfo.channel.display_name) {
                        displayName = twitchInfo.channel.display_name;
                    }
                }
                title = displayName + ' | ' + title;
            }
        }
        var stats = this.getUnseenMessageStats();
        
        // Fluid badge
        var dockBadge = '';
        if (stats) {
            dockBadge += stats;
        }
        if (window.fluid) {
            window.fluid.dockBadge = dockBadge;
        }
        if (window.macgap) {
            window.macgap.dock.badge = dockBadge;
        }
        if (navigator.setExperimentalAppBadge) {
            navigator.setExperimentalAppBadge(dockBadge);
        }
        if (window.ExperimentalBadge) {
            window.ExperimentalBadge.set(dockBadge);
        }
        
        if (stats !== false) {
            if (stats) {
                title = '(' + stats + ') ' + title;
            } else if (current && current.isTrackingUnread() && current.hasUnseen()) {
                title = '+ ' + title;
            } else {
                title = '* ' + title;
            }
        }
        if (this.model.isAuthed() && !this.model.isStreamConnected() && !this.model.backend.unloading) {
            title = '(Offline) ' + title;
        }
        this.setTitle(title);
        // Reset after a delay. Hack needed for windows chrome
        if (this.titleDelay) {
            clearTimeout(this.titleDelay);
        }
        this.titleDelay = setTimeout(_.bind(function () {
            this.titleDelay = null;
            this.setTitle('');
            this.setTitle(title);
        }, this), TitleView.titleDelay);
    },
    setTitle: function (title) {
        document.title = title;
    },
}, {
    titleDelay: 500,
});


module.exports = TitleView;


/***/ }),

/***/ "XZrG":
/***/ (function(module, exports, __webpack_require__) {

var Member = __webpack_require__("abDD");
var User = __webpack_require__("Xgjh");
var UserList = __webpack_require__("jGPP");
var util = __webpack_require__("GmLC");


var MemberList = UserList.extend({
    model: Member,
    initialize: function (models, modeCategory, connection) {
        this.modeCategory = modeCategory;
        this.connection = connection;
    },
    isMember: function () {
        return this.getModeCategory() === 'MEMBER';
    },
    getModeCategory: function () {
        return this.modeCategory;
    },
    getModeTitle: function () {
        return User.defaultTitles[this.getModeCategory()] || this.getModeCategory();
    },
    getClass: function () {
        return User.defaultClassNames[this.getModeCategory()] ||
            'mode_' + this.getModeCategory();
    },
    getMode: function () {
        return this.connection.getUserModes()[this.getModeCategory()];
    },
    getPrefixSymbol: function () {
        return User.prototype.getPrefixSymbol.call(this);
    },
    getModeSymbol: function () {
        return User.prototype.getModeSymbol.call(this);
    },
    comparator: function (memberA, memberB) {
        return util.naturalCompare(memberA.normalise(), memberB.normalise());
    }
});


module.exports = MemberList;


/***/ }),

/***/ "Xgjh":
/***/ (function(module, exports, __webpack_require__) {

var Message = __webpack_require__("j9Sh");
var UserMixins = __webpack_require__("+9gY");


var User = Backbone.Model.extend($.extend(true, {}, UserMixins, {
    initialize: function (data, options) {
        options = options || {};
        this.session = options.session;
        this.connection = options.connection;
        this.buffer = options.buffer;
        this.message = options.message;
    },
    isIgnored: function (options) {
        return this.connection.isIgnored(this.getNick(), this.getHostMask(), options);
    },
    isSelf: function () {
        return this.equals(this.connection.getUser());
    },
    url: function () {
        return this.connection.buildUrl(['messages', this.getNick()]);
    },
    getCid: function () {
        return this.connection.getCid();
    },
    bid: function () {
        if (this.buffer) {
            return this.buffer.bid();
        }
    },
    getId: function () {
        return this.connection.buildId('messages', this.normalise());
    },
    
    equals: function (user) {
        return this.getCid() == user.getCid() &&
               this.getNick().toLowerCase() == user.getNick().toLowerCase();
    },
    getDisplayAuthor: function () {
        return this.get('display_name');
    },
    getRawHostmask: function () {
        return this.get('usermask');
    },
    getRawIdent: function () {
        return this.get('user');
    },
    getRawHost: function () {
        return this.get('userhost');
    },
    getAccount: function () {
        return this.get('account');
    },
    getInfo: function () {
        var info = '';
        var hostmask = this.getHostMask();
        var realname = this.getRealname();
        if (realname) {
            info += realname;
            if (hostmask) {
                info += ' (';
            }
        }
        if (hostmask) {
            info += hostmask;
            if (realname) {
                info += ')';
            }
        }
        return info;
    },
    setAway: function (msg) {
        this.set({away: msg || true});
    },
    setBack: function () {
        this.set({away: false});
    },
    getAway: function () {
        return this.get('away');
    },
    isAway: function () {
        return !!this.getAway();
    },
    getNick: function () {
        return this.get('nick');
    },
    normalise: function () {
        return this.getName().toLowerCase();
    },
    getName: function () {
        return this.getNick();
    },
    getDisplayName: function () {
        return this.getDisplayAuthor() || this.getName();
    },
    getStatusText: function () {
        return this.get('status_text');
    },
    getPronouns: function () {
        return this.get('pronouns');
    },
    getTitle: function () {
        if (this.connection && !this.connection.hasMeaningfulHostnames()) {
            return this.getNick();
        } else {
            return this.getTitleWithHostmask();
        }
    },
    getTitleWithHostmask: function () {
        var title = this.getNick();
        var hostmask = this.getHostMask();
        if (hostmask) {
            title += ' (' + hostmask + ')';
        }
        return title;
    },
    getRealname: function () {
        var realname = this.get('realname') || this.get('server_realname');
        if (this.connection && this.connection.isSlack() && realname == 'null') {
            realname = '';
        }
        return realname;
    },
    getTwitchUrl: function (withProtocol) {
        return 'https://www.twitch.tv/' + this.normalise();
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl() + 'team/' + this.normalise();
    },
    isMatrix: function () {
        var realname = this.getRealname();
        if (realname) {
            // e.g. @user:example.com
            // https://matrix.org/docs/spec/intro.html#user-identifiers
            var mxid = realname.match(/^@([a-z0-9.=_-]+):([^\s]+)$/i);
            if (mxid) {
                try {
                    var u = new URL('http://' + mxid[2]);
                    if (u.host == mxid[2]) {
                        return true;
                    }
                } catch (exc) {
                    // pass
                }
            }
            return false;
        }
    },
    getTitleWithRealname: function () {
        var name = this.getNick();
        var realname = this.getRealname();
        if (realname) {
            name += ' (' + realname + ')';
        }
        return name;
    },
    openBuffer: function () {
        return this.connection.openBuffer(this.getNick());
    },
    findConversation: function () {
        return this.connection.findConversation(this.getNick());
    },
    // Actions
    say: function (message, options) {
        options = options || {};
        var conversation = this.findConversation();
        if (conversation) {
            conversation.say(message, options);
            conversation.select();
        } else {
            this.connection.setFocusOnMakeBuffer(this.getNick());
            this.connection.prefillInputHistory(this.getNick(), [message]);
            if (message && message.length > Message.LONG_MESSAGE_LIMIT) {
                this.session.currentBuffer.trigger('longMessageConfirm', _.bind(function () {
                    this._doSay(message, options);
                }, this), options.onCancel);
            } else {
                this._doSay(message, options);
            }
        }
    },
    _doSay: function (message, options) {
        options = options || {};
        this.connection.say({
            to: this.getNick(),
            msg: message
        }, options.onConfirm);
    },
    post: function (method, message, callback) {
        return this.connection.post(method, message, callback);
    },
    getBanMask: function (withIdentPrefix) {
        var irccloudUid = this.irccloudUid({
            strict: true,
            numeric: true
        });
        var hostmask;
        if (irccloudUid) {
            hostmask = '*!*id' + irccloudUid + '@*irccloud.com*';
        } else if (this.get('userhost')) {
            var user = this.get('user');
            if (user) {
                if (withIdentPrefix && this.get('ident_prefix')) {
                    user = this.get('ident_prefix') + user;
                }
            } else {
                user = '*';
            }
            hostmask = '*!' + user + '@' + this.get('userhost');
        } else if (this.get('usermask')) {
            hostmask = '*!' + this.get('usermask');
        } else {
            hostmask = this.getNick() + '!*@*';
        }
        return hostmask;
    },
    invite: function (channel) {
        // TODO make this a web service so we don't need to construct the call, and can accept channels without #
        this.connection.say({
            msg: "/invite " + this.getNick() + " " + channel
        });
    },
    whois: function () {
        var nick = this.getNick();
        var params = {
            nick: nick
        };
        this.post('whois', params);
        // This is a separate extra request because remote WHOIS calls can sometimes lag way more than local calls
        var whoisServer = this.get('ircserver');
        if (whoisServer && whoisServer != '*') {
            params.server = whoisServer;
            this.post('whois', params);
        } else if (this.channel) {
            // Use nick twice if they're in a channel
            params.server = nick;
            this.post('whois', params);
        }
    },
    
    // Mode methods
    setMode: function (mode) {
        this.set({mode: mode});
    },
    getMode: function () {
        return this.get('mode') || '';
    },
    previousMode: function () {
        return this.previous('mode') || '';
    },
    hasMode: function (mode) {
        if (!mode) {
            return false;
        }
        return this.getMode().indexOf(mode) !== -1;
    },
    hadMode: function (mode) {
        if (!mode) {
            return false;
        }
        return this.previousMode().indexOf(mode) !== -1;
    },
    isMemberType: function (mode) {
        return this.hasMode(mode);
    },
    wasMemberType: function (mode) {
        return this.hadMode(mode);
    },
    isOper: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.OPER);
    },
    isOwner: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.OWNER);
    },
    isAdmin: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.ADMIN);
    },
    isOp: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.OP);
    },
    isHalfOp: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.HALFOP);
    },
    isVoiced: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.isMemberType(modes.VOICED);
    },
    isMod: function (modes) {
        return this.isHalfOp(modes) || this.canOp(modes);
    },
    isModeAbove: function (category) {
        var hierarchy = this.connection.getUserModeHierarchy();
        var c = this.getModeCategory();
        return c !== 'MEMBER' && hierarchy.indexOf(c) <= hierarchy.indexOf(category);
    },
    wasModeAbove: function (category) {
        var hierarchy = this.connection.getUserModeHierarchy();
        var c = this.getPreviousModeCategory();
        return c !== 'MEMBER' && hierarchy.indexOf(c) <= hierarchy.indexOf(category);
    },
    canOp: function () {
        return this.isModeAbove('OP');
    },
    wasOper: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.OPER);
    },
    wasOwner: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.OWNER);
    },
    wasAdmin: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.ADMIN);
    },
    wasOp: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.OP);
    },
    wasHalfOp: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.HALFOP);
    },
    wasVoiced: function (modes) {
        modes = modes || this.connection.getUserModes();
        return this.wasMemberType(modes.VOICED);
    },
    wasMod: function () {
        return this.wasHalfOp() || this.couldOp();
    },
    couldOp: function () {
        return this.wasModeAbove('OP');
    },
    
    getModeCategory: function (modes) {
        modes = modes || this.connection.getUserModes();
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hasMode(modes[cat]);
        }, this) || 'MEMBER';
    },
    getPreviousModeCategory: function (modes) {
        modes = modes || this.connection.getUserModes();
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hadMode(modes[cat]);
        }, this) || 'MEMBER';
    },
    getModeClass: function () {
        return User.defaultClassNames[this.getModeCategory()] ||
            'mode_' + this.getModeCategory();
    },
    getPreviousModeClass: function () {
        return User.defaultClassNames[this.getPreviousModeCategory()] ||
            'mode_' + this.getPreviousModeCategory();
    },
    getModeTitle: function () {
        return User.defaultTitles[this.getModeCategory()] || this.getModeCategory();
    },
    getPrefixSymbol: function () {
        var prefixes = this.connection.getISupport('PREFIX') || User.defaultPrefixes;
        var prefixLetters = this.connection.usermodes;
        var result = _.reduce(this.getMode(), function (memo, m) {
            var index = prefixLetters.indexOf(m);
            if (index !== -1 && (memo.maxIndex === -1 || index < memo.maxIndex)) {
                memo = {
                    maxIndex: index,
                    symbol: prefixes[m]
                };
            }
            return memo;
        }, {maxIndex: -1});
        return result.symbol;
    },
    getModeSymbol: function () {
        return this.getPrefixSymbol() || User.defaultSymbols[this.getModeCategory()];
    }
}), {
    defaultModeHierarchy: [
        'OPER',
        'OWNER',
        'ADMIN',
        'OP',
        'HALFOP',
        'VOICED'
    ],
    defaultModeLetters: {
        OPER: 'y',
        OWNER:  'q',
        ADMIN:  'a',
        OP:     'o',
        HALFOP: 'h',
        VOICED: 'v'
    },
    defaultSymbols: {
        OPER: '!',
        OWNER:  '~',
        ADMIN:  '&',
        OP:     '@',
        HALFOP: '%',
        VOICED: '+',
        MEMBER: '•'
    },
    defaultTitles: {
        OPER: 'Oper',
        OWNER:  'Owner',
        ADMIN:  'Admins',
        OP:     'Ops',
        HALFOP: 'Half ops',
        VOICED: 'Voiced',
        MEMBER: 'Members'
    },
    defaultClassNames: {
        OPER: 'oper',
        OWNER:  'owner',
        ADMIN:  'admin',
        OP:     'ops',
        HALFOP: 'halfops',
        VOICED: 'voiced',
        MEMBER: 'members'
    }
});
User.defaultPrefixes = {};
_.each(User.defaultModeHierarchy, function (m) {
    User.defaultPrefixes[User.defaultModeLetters[m]] = User.defaultSymbols[m];
});
User.defaultModes = {};
_.each(User.defaultModeHierarchy, function (m) {
    User.defaultModes[User.defaultModeLetters[m]] = m;
});


module.exports = User;


/***/ }),

/***/ "XiBv":
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__("GmLC");
var re = __webpack_require__("38es");


// http://en.wikichip.org/wiki/irc/colors
// https://github.com/myano/jenni/wiki/IRC-String-Formatting

/* Public API */

function renderHtml (text, options) {
    var tokens = tokenize(text, options);
    var output = '';
    var inBlock = false;
    var atMention = false;
    var openQuote, closeQuote, lastOpenQuote, lastCloseQuote = false;
    if (options.stripDisplayName) {
        var strippedOutput = '';
        var stripMatchStartRe = /^[<`\[]/;
        var stripMatchRe = new RegExp('^[<`\\[]' + re.escape(options.stripDisplayName) + '[>`\\]]:? ');
        var closeMatchRe;
    }
    for (var i = 0; i < tokens.length; i++) {
        if (tokens[i] === TOKEN_CONST.OPEN_BLOCK) {
            inBlock = true;
        } else if (tokens[i] === TOKEN_CONST.CLOSE_BLOCK) {
            inBlock = false;
        }
        atMention = (isStringObj(tokens[i-1]) && _.last(tokens[i-1].val) === '@');
        openQuote = (
            tokens[i] === TOKEN_CONST.OPEN_QUOTE ||
            tokens[i] === TOKEN_CONST.OPEN_QUOTE_SPACE
        );
        closeQuote = (
            tokens[i] === TOKEN_CONST.CLOSE_QUOTE ||
            tokens[i] === TOKEN_CONST.CLOSE_QUOTE_SPACE
        );
        // Fill empty quote
        if (lastOpenQuote && closeQuote) {
            output += '&nbsp;';
        }
        // Trim newline before quote
        if (openQuote) {
            output = output.replace(/\n$/, '');
        }
        if (options.stripDisplayName) {
            strippedOutput += stripZWSP(renderTokenStrip(tokens[i]));
            if (strippedOutput && !strippedOutput.match(stripMatchStartRe)) {
                // if output but no open match, abort
                options.stripDisplayName = false;
            } else {
                var fullMatch = strippedOutput.match(stripMatchRe);
                if (fullMatch) {
                    // split on close
                    if (strippedOutput[0] == '<') {
                        closeMatchRe = />:? /;
                    } else if (strippedOutput[0] == '`') {
                        closeMatchRe = /`?:? /;
                    } else if (strippedOutput[0] == '[') {
                        closeMatchRe = /\]:? /;
                    }
                    var closeMatch = tokens[i].val.match(closeMatchRe);
                    var slice = 0;
                    if (closeMatch) {
                        slice = closeMatch.index + closeMatch[0].length;
                    } else if (tokens[i].val.match(/^ /)) {
                        // Fallback to just slicing the space off, if no close
                        // match then match was in previous token
                        slice = 1;
                    }
                    output = '';
                    tokens[i].val = tokens[i].val.slice(slice);
                    options.stripDisplayName = false;
                }
            }
        }
        output += renderTokenHtml(tokens[i], _.extend({}, options, {
            atMention: atMention,
            inBlock: inBlock,
            tokens: tokens,
            lastCloseQuote: lastCloseQuote
        }));
        lastOpenQuote = openQuote;
        lastCloseQuote = closeQuote;
    }
    return stripControl(output);
}
function strip (text, options) {
    var tokens = tokenize(text, options);
    var output = '';
    for (var i = 0; i < tokens.length; i++) {
        output += renderTokenStrip(tokens[i], options);
    }
    return stripControl(output);
}
function stripRegex (text, options) {
    options = options || {};
    var output = stripControl(stripFormat(text));
    if (options.processor) {
        return options.processor(output, options);
    } else {
        return output;
    }
}

function stripPreformatted (text) {
    return text.replace(RE.block, '');
}

function stripZWSP (text) {
    return text.replace(/\u200B/g, '');
}

function stripFormat (text) {
    // Strips colours and formatting
    return text.replace(RE.color, '')
        .replace(RE.hex, '')
        .replace(RE.formatting, '');
}
        
/* Token renderers */

function stripControl (text) {
    return text.replace(RE.control, '');
}
function allSpaces (text) {
    return RE.all_space.test(text);
}
function space2nspb (text) {
    return text.replace(RE.space, '&nbsp;');
}
function escapeHtmlLinuxNotification (text) {
    return escapeHtmlMinimal(text);
}
function escapeHtmlMinimal (text) {
    text = util.stringify(text);
    return text
        .replace(RE.amp, '&amp;')
        .replace(RE.lt, '&lt;')
        .replace(RE.gt, '&gt;')
        .replace(RE.double_quote, '&quot;');
}
function escapeHtml (text, options) {
    options = options || {};
    text = util.stringify(text);
    if (!options.rawSpace && allSpaces(text)) {
        return space2nspb(text);
    } else {
        var repl = text
            .replace(RE.amp, '&amp;')
            .replace(RE.lt, '&lt;')
            .replace(RE.gt, '&gt;')
            .replace(RE.double_quote, '&quot;')
            .replace(RE.single_quote, '&#x27;')
            .replace(RE.slash, '&#x2f;');
        if (options.rawSpace) {
            return repl;
        } else {
            return repl.replace(RE.start_space, space2nspb);
        }
    }
}

// Strip
function renderTokenStrip (token, options) {
    options = options || {};
    if (isStringObj(token)) {
        // Process strings if there's a processor
        if (options.processor) {
            return options.processor(token.val, token.index, options);
        } else {
            return token.val;
        }
    } else if (isCodeBlock(token)) {
        return BLOCK;
    } else if (isCodeSpan(token)) {
        return CODE;
    } else if (token === TOKEN_CONST.OPEN_QUOTE) {
        return QUOTE;
    } else if (token === TOKEN_CONST.OPEN_QUOTE_SPACE) {
        return QUOTE + ' ';
    }
    // Strip everything else
    return '';
}

// HTML
function renderTokenHtml (token, options) {
    if (isStringObj(token)) {
        return renderStringHtml(token, options);
    } else if (isNumber(token)) {
        // Formatting tokens
        if (token == TOKEN_CONST.CLOSE_COLOR && options.noColor) {
            return '';
        }
        return TOKEN_TAGS[token];
    } else if (isColorObj(token)) {
        // Color objects
        if (options.noColor) {
            return '';
        }
        return renderColorHtml(token);
    } else {
        // Shouldn't match anything else
        debug.warn('IRCFormatter: non string, object, number token', token, options);
        return '';
    }
}
function renderStringHtml (token, options) {
    options = options || {};
    var val = token.val;
    // Trim newline after quote
    if (options.lastCloseQuote) {
        val = val.replace(/^\n/, '');
    }
    // Process strings if there's a processor
    if (options.processor) {
        return options.processor(val, token.index, options);
    } else {
        // Escape html chars by default
        return escapeHtml(val);
    }
}
function renderColorHtml (colorToken) {
    var classNames = [];
    var styles = [];
    var fg = colorToken.fg;
    var rgb = colorToken.rgb;
    var rgbfg = rgb;
    var rgbbg = rgb;
    var bg = colorToken.bg || colorToken._bg;
    var inv = colorToken.inv;
    if (inv) {
        var _fg, _bg;
        if (fg) {
            _bg = fg;
        } else {
            _bg = 'inverse';
            rgbbg = false;
        }
        if (bg) {
            _fg = bg;
        } else {
            _fg = 'inverse';
            rgbfg = false;
        }
        fg = _fg;
        bg = _bg;
    }
    if (fg) {
        if (rgbfg) {
            styles.push('color:#' + fg);
        } else if (COLOR_MAP[fg]) {
            classNames.push('irccolor ' + COLOR_MAP[fg]);
        } else if (EXTENDED_COLOR_MAP[fg]) {
            styles.push('color:#' + EXTENDED_COLOR_MAP[fg]);
        }
    }
    if (bg) {
        if (rgbbg) {
            styles.push('background-color:#' + bg);
        } else if (COLOR_MAP[bg]) {
            classNames.push('irccolor-bg bg-' + COLOR_MAP[bg]);
        } else if (EXTENDED_COLOR_MAP[bg]) {
            styles.push('background-color:#' + EXTENDED_COLOR_MAP[bg]);
        }
    }
    var classAttr = '';
    var styleAttr = '';
    if (classNames.length) {
        classAttr = ' class="' + classNames.join(' ') + '"';
    }
    if (styles.length) {
        styleAttr = ' style="' + styles.join(';') + '"';
    }
    return '<wbr><span' + classAttr + styleAttr + '>';
}

/* Internal API */

function tokenizeQuoted (text, list, state, index, options) {
    options = options || {};
    var initialIndex = index;
    var lengthIndex = index;
    var textString = text.join('');
    var blockquoteMatch = textString.match(RE.blockquote_one);
    if (blockquoteMatch) {
        var codeBlockMatch = textString.match(RE.block_one);
        if (codeBlockMatch && codeBlockMatch.index < blockquoteMatch.index) {
            return;
        }
        textString.replace(RE.blockquote, function (matchPart, inner, matchIndex, full) {
            var between = textString.slice(lengthIndex-initialIndex, matchIndex);
            if (between) {
                var betweenChars = util.arrayFrom(between);
                index += tokenizeQuoteRest(betweenChars, list, state, index, options);
                lengthIndex += between.length;
            }

            var token = 'QUOTE';
            index += QUOTE.length;
            lengthIndex += QUOTE.length;
            if (inner && inner[0] == ' ') {
                token = 'QUOTE_SPACE';
                inner = inner.slice(1);
                index++;
                lengthIndex++;
            }
            pushToken(token, list, state);

            if (inner) {
                var innerChars = util.arrayFrom(inner);
                index += tokenizeQuoteRest(innerChars, list, state, index, _.extend({}, options, {quoted: true}));
                lengthIndex += inner.length;
            }

            pushToken(token, list, state);
        });
        var final = textString.slice(lengthIndex-initialIndex);
        if (final) {
            var finalChars = util.arrayFrom(final);
            index += tokenizeQuoteRest(finalChars, list, state, index, options);
        }
        return index;
    }
}

function tokenizePlain (text, list, state, index, options) {
    var length = text.length;
    for (var i = 0; i < text.length; i++) {
        var repl_part, repl_length_diff;
        if (options.replacement_parts && (repl_part = options.replacement_parts[index + i])) {
            pushString(list, repl_part.join(''), index + i);
            // Replacing 'a' character
            repl_length_diff = repl_part.length - 1;
            index += repl_length_diff;
            length += repl_length_diff;
        } else {
            parseToken(text[i], list, state, index + i, options);
        }
    }
    return length;
}

function tokenizePreformatted (text, list, state, index, re, token, label, options, tokenizeRestFun) {
    var initialIndex = index;
    var lengthIndex = index;
    var textString = text.join('');
    if (textString.match(re)) {
        textString.replace(re, function (matchPart, inner, after, matchIndex, full) {
            if (full === undefined) {
                full = matchIndex;
                matchIndex = after;
                after = '';
            }
            var between = textString.slice(lengthIndex-initialIndex, matchIndex);
            if (between) {
                var betweenChars = util.arrayFrom(between);
                index += tokenizeRestFun(betweenChars, list, state, index, options);
                lengthIndex += between.length;
            }

            if (inner.indexOf(BLOCK) === 0 || inner.indexOf(token) === 0) {
                // Abort if inner starts with block marker or code marker for code spans
                var matchPartChars = util.arrayFrom(matchPart);
                index += tokenizeRestFun(matchPartChars, list, state, index, options);
                lengthIndex += matchPart.length;
            } else {
                // Handle inner
                pushToken(label, list, state);
                index += token.length;
                lengthIndex += token.length;

                var innerChars = util.arrayFrom(inner);
                index += tokenizeRestFun(innerChars, list, state, index, _.extend({}, options, {preformatted: true}));
                lengthIndex += inner.length;

                pushToken(label, list, state);
                index += token.length;
                lengthIndex += token.length;

                // Handle after
                if (after) {
                    var afterChars = util.arrayFrom(after);
                    pushString(list, after, index);
                    index += afterChars.length;
                    lengthIndex += after.length;
                }
            }
        });
        var final = textString.slice(lengthIndex-initialIndex);
        if (final) {
            var finalChars = util.arrayFrom(final);
            index += tokenizeRestFun(finalChars, list, state, index, options);
        }
        return index;
    }
}

function postFormat (text, list, state, index, options) {
    options = options || {};
    var newIndex;
    if (options.quote && (newIndex = tokenizeQuoted(
        text, list, state, index, options
    ))) {
        return newIndex;
    } else {
        return tokenizeQuoteRest(text, list, state, index, options);
    }
}

function tokenizeQuoteRest (text, list, state, index, options) {
    var newIndex;
    if (options.codeBlock && (newIndex = tokenizePreformatted(
        text, list, state, index, RE.block, BLOCK, 'BLOCK', options, tokenizeCodeRest
    ))) {
        return newIndex;
    } else {
        return tokenizeCodeRest(text, list, state, index, options);
    }
}

function tokenizeCodeRest (text, list, state, index, options) {
    var newIndex;
    if (!options.preformatted && options.codeSpan && (newIndex = tokenizePreformatted(
        text, list, state, index, RE.code, CODE, 'CODE', options, tokenizePlain
    ))) {
        return newIndex;
    }
    return tokenizePlain(text, list, state, index, options);
}

function tokenizeReplacements (text, list, state, index, options) {
    var repl_parts = {};
    var repl_index = 0;
    var repl_placeholder = [];
    _.each(options.replacements, function (replacement) {
        var rOffset = replacement.startOffset || 0;
        var rStart = rOffset + replacement.start;
        var rEnd = rOffset + replacement.end;
        if (
            rStart >= 0 &&
            rStart <= text.length &&
            rEnd <= text.length
        ) {
            var repl_before = text.slice(repl_index, rStart);
            if (repl_before) {
                repl_placeholder = repl_placeholder.concat(repl_before);
            }
            var repl_text = text.slice(rStart, rEnd);
            repl_parts[rStart] = repl_text;
            repl_placeholder.push('a');
            repl_index = rEnd;
        }
    });
    var repl_after = text.slice(repl_index);
    if (repl_after) {
        repl_placeholder = repl_placeholder.concat(repl_after);
    }
    return postFormat(repl_placeholder, list, state, index, _.extend({}, options, {
        replacement_parts: repl_parts
    }));
}

function isQuote (text) {
    return RE.blockquote_one.test(text);
}

function tokenize (text, options) {
    options = _.extend({}, options, {
        isFormatted: RE.format_one.test(text)
    });
    text = util.arrayFrom(util.stringify(text));
    var list = [];
    var state = [];
    var index = 0;
    if (options && options.replacements) {
        index += tokenizeReplacements(text, list, state, index, options);
    } else {
        index += postFormat(text, list, state, index, options);
    }

    clearEmptyColor(list, state);
    initPrevColorState(list, state, index);
    normalise(list);
    // Clear all state
    clearState(list, state, true);
    return list;
}

// Update state and token list
function pushToken (token, list, state) {
    var lastStateIndex = lastIndexOf(token, state);
    if (lastStateIndex !== -1) {
        // Character is a close tag

        // Close any colors and reopen after
        // Also make any open code tags inert if this isn't a code token
        var colorCount = 0;
        var i;
        for (i = state.length - 1; i > lastStateIndex; i--) {
            if (token !== 'CODE' && state[i] === 'CODE') {
                var openCodeIndex = lastIndexOf(TOKEN_CONST['OPEN_CODE'], list);
                state.splice(i, 1, 'INERT_CODE');
                list.splice(openCodeIndex, 1, TOKEN_CONST['OPEN_INERT_CODE']);
            } else if (state[i] === 'COLOR') {
                state.splice(i, 1);
                pushCloseColor(list);
                colorCount++;
            }
        }
        var colors = [];
        for (i = list.length - 1; colorCount > 0 && i >= 0; i--) {
            if (isColorObj(list[i])) {
                colors.push(list[i]);
                colorCount--;
            }
        }
        // Push the code onto the list and remove state token
        state.splice(lastStateIndex, 1);
        list.push(TOKEN_CONST['CLOSE_' + token]);
        // Reopen colors
        while (colors.length) {
            var color = _.clone(colors.pop());
            if (colors.length > 1) {
                state.push('COLOR');
            } else if (!isEmptyColor(color)) {
                color.complete = true;
            }
            list.push(color);
        }
    } else {
        // Character is an open tag

        // Check for inert_code
        var lastInertCodeIndex = lastIndexOf('INERT_CODE', state);
        if (token === 'CODE' && lastInertCodeIndex !== -1) {
            state.splice(lastInertCodeIndex, 1);
            list.push(TOKEN_CONST['CLOSE_INERT_CODE']);
        } else {
            // Push the code onto the list and add a state token
            state.push(token);
            list.push(TOKEN_CONST['OPEN_' + token]);
        }
    }
}
// Close all formatting state in reverse
function clearState (list, state, final) {
    clearEmptyColor(list, state);
    var stateRestore = [];
    while (state.length) {
        var token = state.pop();
        if (!final && (
            token === 'QUOTE' ||
            token === 'QUOTE_SPACE' ||
            token === 'BLOCK' ||
            token === 'CODE'
        )) {
            stateRestore.push(token);
        } else {
            var tokConst = TOKEN_CONST['CLOSE_' + token];
            if (tokConst) {
                list.push(tokConst);
            }
        }
    }
    while (stateRestore.length) {
        state.push(stateRestore.pop());
    }
    if (list.length && isColorObj(list[list.length-1])) {
        pushCloseColor(list);
    }
}
// Close colored state and token list
function closeColor (list, state, omitToken) {
    for (var i = state.length - 1; i >= 0; i--) {
        if (state[i] === 'COLOR') {
            state.splice(i, 1);
            if (!omitToken) {
                pushCloseColor(list);
            }
        }
    }
}
function pushCloseColor (list) {
    list.push(TOKEN_CONST.CLOSE_COLOR);
}

// Detect color object
function isColorObj (obj) {
    return isObject(obj) && !isStringObj(obj);
}
function isStringObj (obj) {
    return isObject(obj) && ('val' in obj) && ('index' in obj);
}
function isEmptyColor (obj) {
    return (isColorObj(obj) && !obj.fg && !obj.bg && !obj.inv);
}
function isCodeBlock (token) {
    return (
        token === TOKEN_CONST.OPEN_BLOCK ||
        token === TOKEN_CONST.CLOSE_BLOCK
    );
}
function isCodeSpan (token) {
    return (
        token === TOKEN_CONST.OPEN_CODE ||
        token === TOKEN_CONST.CLOSE_CODE ||
        token === TOKEN_CONST.OPEN_INERT_CODE ||
        token === TOKEN_CONST.CLOSE_INERT_CODE
    );
}
// Clear any preceding empty colors
function clearEmptyColor (list, state) {
    if (list.length && isEmptyColor(list[list.length-1])) {
        // Empty color object, remove it and update state and token list
        list.pop();
        closeColor(list, state, true);
    }
}

// Go into COLORed state and start a new string
function endColorParse (chr, list, state, index) {
    state.push('COLOR');
    pushString(list, chr, index);
}

function currentColorCopyDefault (list, state, rgb) {
    var color = currentColorCopy(list, state);
    if (rgb != color.rgb) {
        if (rgb) {
            return {rgb: true};
        } else {
            return {};
        }
    }
    if ('bg' in color) {
        color._bg = color.bg;
        delete color.bg;
    }
    delete color.fg;
    return color;
}

function currentColorCopy (list, state) {
    var currentColor;
    var isColorState = false;
    var i;
    if (lastIndexOf('COLOR', state) !== -1) {
        for (i = list.length - 1; !currentColor && i >= 0; i--) {
            if (isColorObj(list[i])) {
                currentColor = _.clone(list[i]);
                delete currentColor.complete;
            }
        }
    }
    if (!currentColor) {
        currentColor = {};
        for (i = state.length - 1; i >= 0; i--) {
            if (state[i] === 'INVERSE') {
                currentColor.inv = true;
            }
        }
    }
    return currentColor;
}

function invertColor (list, state, index) {
    var isInverse;
    var isColor;
    for (var i = state.length - 1; i >= 0; i--) {
        if (state[i] === 'COLOR') {
            isColor = true;
        }
        if (state[i] === 'INVERSE') {
            isInverse = true;
            state.splice(i, 1);
        }
    }

    if (list.length && isColorObj(list[list.length-1])) {
        // Invert any existing color object
        if (list[list.length-1].inv) {
            delete list[list.length-1].inv;
        } else {
            list[list.length-1].inv = true;
        }
    } else {
        var currentColor;
        if (isColor) {
            // Find current color if there and close it
            currentColor = currentColorCopy(list, state);
            closeColor(list, state);
            // Reopen as the inverse
            if (currentColor.inv) {
                delete currentColor.inv;
            } else {
                currentColor.inv = true;
            }
        } else {
            // No color or inverted, start the inverse
            currentColor = {inv: true};
        }
        list.push(currentColor);
        endColorParse('', list, state, index);
    }
    if (!isInverse) {
        state.push('INVERSE');
    }
}

function normalise (list) {
    _.each(list, function (token) {
        if (isColorObj(token)) {
            delete token.complete;
            if (token.fg === false) {
                delete token.fg;
            }
            if (token.bg === false) {
                delete token.bg;
            }
        }
    });
}

function initPrevColorState (list, state, index) {
    if (list.length) {
        if (isColorObj(list[list.length-1])) {
            // Background indicated but never specified, clear it
            if (list[list.length-1].bg === true) {
                delete list[list.length-1].bg;
                pushString(list, ',', index);
            }
            // Previous token is a color state object, start the colour state
            state.push('COLOR');
        }
    }
}

function pushString (list, chr, index) {
    list.push({val: chr, index: index});
}

// We've detected a color token, parse the next characters as color values
function parseColor (chr, colorObj, list, state, index) {
    // <code><color> - change foreground color
    // <code><color>,<color> - change foreground and background color
    // <code><color>, - change foreground, restore default background
    // <code>,<color> - change background, restore default foreground
    // <code>, - restore default foreground and background
    // <code><text> - restore default foreground and background
    
    if (chr === ',' && !('bg' in colorObj)) {
        // Comma, indicates a background
        delete colorObj._bg;
        colorObj.bg = true;
    } else if (!isNaN(parseInt(chr, 10)) || (colorObj.rgb && chr.match(RE.hex_letters))) {
        // Color code, store it appropriately
        if (colorObj.bg === true) {
            // Background indicated, start it
            colorObj.bg = chr;
        } else if ('bg' in colorObj) {
            if (colorObj.bg === false || (colorObj.rgb && colorObj.bg.length === 6)) {
                // Background color complete, end parse and start a new string
                clearOrEndColor(colorObj, chr, list, state, index);
            } else if (
                !colorObj.rgb &&
                !COLOR_MAP[colorObj.bg + chr] &&
                !EXTENDED_COLOR_MAP[colorObj.bg + chr]
            ) {
                if (colorObj.bg + chr == '99') {
                    // Transparent, clear
                    colorObj.bg = false;
                } else {
                    // Not valid color code, end it
                    endColorParse(chr, list, state, index);
                }
            } else {
                // Append to background
                colorObj.bg += chr;
            }
        } else if ('fg' in colorObj) {
            if (colorObj.fg === false || (colorObj.rgb && colorObj.fg.length === 6)) {
                // Color foreground complete, end parse and start a new string
                clearOrEndColor(colorObj, chr, list, state, index);
            } else if (
                !colorObj.rgb &&
                !COLOR_MAP[colorObj.fg + chr] &&
                !EXTENDED_COLOR_MAP[colorObj.fg + chr]
            ) {
                if (colorObj.fg + chr == '99') {
                    // Transparent, clear
                    colorObj.fg = false;
                } else {
                    // Not valid color code, end it
                    endColorParse(chr, list, state, index);
                }
            } else {
                // Append to foreground
                colorObj.fg += chr;
            }
        } else {
            // Start foreground
            colorObj.fg = chr;
        }
    } else {
        // Invalid color code character
        
        // Background indicated but never specified, clear it
        if (colorObj.bg === true) {
            delete colorObj.bg;
            chr = ',' + chr;
        }
        clearOrEndColor(colorObj, chr, list, state, index);
    }
}

function clearOrEndColor (colorObj, chr, list, state, index) {
    if (isEmptyColor(colorObj)) {
        // Color obj is empty, must have been a closer. Character starts a new string
        clearEmptyColor(list, state);
        pushString(list, chr, index);
    } else {
        // Color obj has value, end the parser and start a new string
        endColorParse(chr, list, state, index);
    }
}

// Parse each character from a string
function parseToken (chr, list, state, i, options) {
    if (options.isFormatted) {
        if (chr === CLEAR) {
            initPrevColorState(list, state, i);
            // Clear all format state
            clearState(list, state);
            return;
        } else if (chr === INVERSE || chr === INVERSE_ALT) {
            // Invert colors
            clearEmptyColor(list, state);
            initPrevColorState(list, state, i);
            invertColor(list, state, i);
            return;
        } else if (chr === COLOR) {
            // Got a color token, push a color obj
            clearEmptyColor(list, state);
            initPrevColorState(list, state, i);
            var color = currentColorCopyDefault(list, state);
            closeColor(list, state);
            list.push(color);
            return;
        } else if (chr === RGB) {
            // Got an RBG color token, push a color obj
            clearEmptyColor(list, state);
            initPrevColorState(list, state, i);
            var rgbColor = currentColorCopyDefault(list, state, true);
            closeColor(list, state);
            list.push(rgbColor);
            return;
        }
    }
    var listLen = list.length;
    if (options.isFormatted) {
        var token = TOKENS[chr];
        // Must be a regular character or token
        if (token) {
            if (listLen) {
                // Got a formatting token, push a constant
                clearEmptyColor(list, state);
                initPrevColorState(list, state, i);
                pushToken(token, list, state);
            } else {
                // Got a formatting token, push a constant
                pushToken(token, list, state);
            }
            return;
        }
    }
    if (listLen) {
        var prevIdx = listLen-1;
        if (isStringObj(list[prevIdx])) {
            // Previous token is a string, append this character to it
            list[prevIdx].val += chr;
        } else if (isColorObj(list[prevIdx])) {
            if (list[prevIdx].complete) {
                endColorParse(chr, list, state, i);
            } else {
                // Previous token is a color state object, try to parse this character as a color code
                parseColor(chr, list[prevIdx], list, state, i);
            }
        } else {
            // Previous token must be a formatting constant. This character should start a new string
            pushString(list, chr, i);
        }
    } else {
        // Empty token list. This character starts a new string
        pushString(list, chr, i);
    }
}

// https://defs.ircdocs.horse/info/formatting.html
// Previously: http://www.visualirc.net/tech-attrs.php (the info on inverse is contradictory)
var TOKENS = {
    '\u0002': 'BOLD',
    '\u0011': 'MONOSPACE',
    '\u001d': 'ITALIC',
    '\u001e': 'STRIKE',
    '\u001f': 'UNDERLINE'
};

var COLOR = '\u0003';
var RGB   = '\u0004';
var CLEAR = '\u000f';
var INVERSE = '\u0012';
var INVERSE_ALT = '\u0016';

var BLOCK = '```';
var CODE = '`';
var QUOTE = '>';

// Strip mIRC colors
var RE = {
    format_one: /[\u0002\u0003\u0004\u000f\u0011\u0012\u0016\u001d\u001e\u001f]/,
    // Doesn't strip \u0009 (TAB \t) \u000a (LF \n)  \u000d (CR \r)
    control: /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f-\u009f]/g,
    // mIRC colors
    color: /\u0003(?:\d{1,2}(?:,\d{1,2})?)?/g,
    // Hex colors
    hex: /\u0004(?:[\da-f]{6,6}(?:,[\da-f]{6,6})?)?/ig,
    hex_letters: /[a-f]/i,
    formatting: new RegExp('[' + _.keys(TOKENS).join('') + CLEAR + ']', 'g'),
    block: new RegExp(BLOCK + '([\\s\\S]+?)' + BLOCK + '(?=(?!`)[\\W\\s\\n]|$)', 'g'),
    block_one: new RegExp(BLOCK + '([\\s\\S]+?)' + BLOCK + '(?=(?!`)[\\W\\s\\n]|$)'),
    code: new RegExp(CODE + '([^`\\n]+?)' + CODE, 'gm'),
    blockquote: new RegExp('^' + QUOTE + '(?:$|(?![<>:;]|[\\W_](?:[<>](?=\\s|$)))(.+)?)', 'gm'),
    blockquote_one: new RegExp('^' + QUOTE + '(?:$|(?![<>:;]|[\\W_](?:[<>](?=\\s|$)))(.+)?)', 'm'),
    all_space: /^ +$/,
    start_space: /^ +/,
    space: / /g,
    amp: /&/g,
    lt: /</g,
    gt: />/g,
    double_quote: /"/g,
    single_quote: /'/g,
    slash: /\//g
};

var TAGS = {
    BOLD: ['b'],
    MONOSPACE: ['tt'],
    ITALIC: ['i'],
    UNDERLINE: ['u'],
    STRIKE: ['del']
};

var TOKEN_TAGS = {};
var TOKEN_CONST = {};
var c = 0;
var v, open;
for (var k in TAGS) {
    TOKEN_CONST['OPEN_' + k] = ++c;
    v = TAGS[k];
    open = '<wbr><' + v[0];
    if (v[1]) {
        open += ' class="' + v[1] + '"';
    }
    open += '>';
    TOKEN_TAGS[c] = open;
    
    TOKEN_CONST['CLOSE_' + k] = ++c;
    TOKEN_TAGS[c] = '</' + v[0] + '>';
}
TOKEN_CONST.CLOSE_COLOR = ++c;
TOKEN_TAGS[c] = '</span>';

// blockquote
TOKEN_CONST.OPEN_QUOTE = ++c;
TOKEN_TAGS[c] = '<span class="g">&gt;</span><blockquote class="quote">';
TOKEN_CONST.OPEN_QUOTE_SPACE = ++c;
TOKEN_TAGS[c] = '<span class="g">&gt; </span><blockquote class="quote">';

TOKEN_CONST.CLOSE_QUOTE = ++c;
TOKEN_TAGS[c] = '</blockquote>';
TOKEN_CONST.CLOSE_QUOTE_SPACE = ++c;
TOKEN_TAGS[c] = '</blockquote>';

// code block
TOKEN_CONST.OPEN_BLOCK = ++c;
TOKEN_TAGS[c] = '<span class="g">```</span><pre class="monoblock">';

TOKEN_CONST.CLOSE_BLOCK = ++c;
TOKEN_TAGS[c] = '</pre><span class="g">```</span>';

// code span
TOKEN_CONST.OPEN_CODE = ++c;
TOKEN_TAGS[c] = '<span class="g">`</span><tt>';

TOKEN_CONST.CLOSE_CODE = ++c;
TOKEN_TAGS[c] = '</tt><span class="g">`</span>';

// inert code span
TOKEN_CONST.OPEN_INERT_CODE = ++c;
TOKEN_TAGS[c] = '`';

TOKEN_CONST.CLOSE_INERT_CODE = ++c;
TOKEN_TAGS[c] = '`';

// http://www.mirc.com/help/colors.html
var COLOR_MAP = {
    'inverse': 'inverse',
    '00': 'white',
    '0': 'white',
    '01': 'black',
    '1': 'black',
    '02': 'navy',
    '2': 'navy',
    '03': 'green',
    '3': 'green',
    '04': 'red',
    '4': 'red',
    '05': 'maroon',
    '5': 'maroon',
    '06': 'purple',
    '6': 'purple',
    '07': 'orange',
    '7': 'orange',
    '08': 'yellow',
    '8': 'yellow',
    '09': 'lime',
    '9': 'lime',
    '10': 'teal',
    '11': 'cyan',
    '12': 'blue',
    '13': 'magenta',
    '14': 'grey',
    '15': 'silver'
};
// http://anti.teamidiot.de/static/nei/*/extended_mirc_color_proposal.html
var EXTENDED_COLOR_MAP = {
    '16': '470000',
    '17': '472100',
    '18': '474700',
    '19': '324700',
    '20': '004700',
    '21': '00472c',
    '22': '004747',
    '23': '002747',
    '24': '000047',
    '25': '2e0047',
    '26': '470047',
    '27': '47002a',
    '28': '740000',
    '29': '743a00',
    '30': '747400',
    '31': '517400',
    '32': '007400',
    '33': '007449',
    '34': '007474',
    '35': '004074',
    '36': '000074',
    '37': '4b0074',
    '38': '740074',
    '39': '740045',
    '40': 'b50000',
    '41': 'b56300',
    '42': 'b5b500',
    '43': '7db500',
    '44': '00b500',
    '45': '00b571',
    '46': '00b5b5',
    '47': '0063b5',
    '48': '0000b5',
    '49': '7500b5',
    '50': 'b500b5',
    '51': 'b5006b',
    '52': 'ff0000',
    '53': 'ff8c00',
    '54': 'ffff00',
    '55': 'b2ff00',
    '56': '00ff00',
    '57': '00ffa0',
    '58': '00ffff',
    '59': '008cff',
    '60': '0000ff',
    '61': 'a500ff',
    '62': 'ff00ff',
    '63': 'ff0098',
    '64': 'ff5959',
    '65': 'ffb459',
    '66': 'ffff71',
    '67': 'cfff60',
    '68': '6fff6f',
    '69': '65ffc9',
    '70': '6dffff',
    '71': '59b4ff',
    '72': '5959ff',
    '73': 'c459ff',
    '74': 'ff66ff',
    '75': 'ff59bc',
    '76': 'ff9c9c',
    '77': 'ffd39c',
    '78': 'ffff9c',
    '79': 'e2ff9c',
    '80': '9cff9c',
    '81': '9cffdb',
    '82': '9cffff',
    '83': '9cd3ff',
    '84': '9c9cff',
    '85': 'dc9cff',
    '86': 'ff9cff',
    '87': 'ff94d3',
    '88': '000000',
    '89': '131313',
    '90': '282828',
    '91': '363636',
    '92': '4d4d4d',
    '93': '656565',
    '94': '818181',
    '95': '9f9f9f',
    '96': 'bcbcbc',
    '97': 'e2e2e2',
    '98': 'ffffff'
};

// Helpers
function lastIndexOf (value, array) {
    if (array.lastIndexOf) {
        return array.lastIndexOf(value);
    }
    if (!array.length) {
        return -1;
    }
    for (var i = array.length - 1; i >= 0; i--) {
        if (array[i] === value) return i;
    }
    return -1;
}
function isObject (obj) {
    return Object.prototype.toString.call(obj) == '[object Object]';
}
function isNumber (obj) {
    return Object.prototype.toString.call(obj) == '[object Number]';
}

module.exports = {
    renderHtml: renderHtml,
    escapeHtml: escapeHtml,
    escapeHtmlMinimal: escapeHtmlMinimal,
    escapeHtmlLinuxNotification: escapeHtmlLinuxNotification,
    strip: strip,
    stripRegex: stripRegex,
    stripPreformatted: stripPreformatted,
    stripZWSP: stripZWSP,
    isQuote: isQuote,
    _tokenize: tokenize,
    _TOKEN_CONST: TOKEN_CONST
};


/***/ }),

/***/ "Y/gw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dialogview = __webpack_require__("EjYC");

var _dialogview2 = _interopRequireDefault(_dialogview);

var _scriptjs = __webpack_require__("zhAq");

var _scriptjs2 = _interopRequireDefault(_scriptjs);

var _stripeCardDialog = __webpack_require__("VBlq");

var _stripeCardDialog2 = _interopRequireDefault(_stripeCardDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Pulled from sniffing around in stripe checkout js
var countriesShowingZipAfterCity = ["AU", "BR", "CA", "CN", "HU", "IN", "ID", "IE", "IL", "JP", "NZ", "PK", "PE", "RU", "SA", "SG", "TH", "UA", "GB", "US"];
var ziplessCountries = ["AE", "AG", "AO", "AW", "BF", "BI", "BJ", "BO", "BS", "BW", "BZ", "CD", "CF", "CG", "CI", "CK", "CM", "DJ", "DM", "ER", "FJ", "GD", "GH", "GM", "GN", "GQ", "GY", "HK", "IE", "JM", "KE", "KI", "KM", "KN", "KP", "LC", "ML", "MO", "MR", "MS", "MU", "MW", "NR", "NU", "PA", "QA", "RW", "SA", "SB", "SC", "SL", "SO", "SR", "ST", "SY", "TF", "TK", "TL", "TO", "TT", "TV", "TZ", "UG", "VU", "YE", "ZA", "ZW"];

exports.default = _dialogview2.default.extend({
    el: '#cardPayment',
    hideInstant: true,
    initialize: function initialize(options) {
        _dialogview2.default.prototype.initialize.call(this, options);

        this.cardholder = this.$('#cardPayment__cardholder');

        this.cardLine1 = this.$('#cardPayment__line1');
        this.cardLine2 = this.$('#cardPayment__line2');
        this.cardState = this.$('#cardPayment__state');
        this.cardCityZip = this.$('#cardPayment__cityZip');
        this.cardCountry = this.$('#cardPayment__country');

        this.submit = this.$('#cardPayment__submit');
        this.cardEl = this.$('#cardPayment__card');
        this.cardLoading = this.$('.cardPayment__cardLoading');
        this.cardError = this.$('.cardPayment__error');
        this.cardInputError = this.$('.cardPayment__input-error');
        this.cardDescription = this.$('.cardPayment__description');
        this.cardAmountHead = this.$('.cardPayment__amountHead');
        this.cardAmount = this.$('.cardPayment__amount');
        this.stripeError = this.$('.stripeError');
    },

    loadStripe: function loadStripe() {
        if (this._loadStripeCalled) {
            return;
        }
        this._loadStripeCalled = true;
        (0, _scriptjs2.default)(["https://js.stripe.com/v3/"], _.bind(function () {
            if (window.Stripe) {
                this.Stripe = window.Stripe(window.IRCConfig.StripeCheckoutOptions.key);
                _scriptjs2.default.done('stripe');
            } else {
                this.showStripeError();
            }
        }, this));
    },
    showStripeError: function showStripeError() {
        this.stripeError.show();
    },
    events: $.extend({}, _dialogview2.default.prototype.events, {
        'buttonClick #cardPayment__submit': 'onSubmit',
        'buttonClick .upgradePayment__confirm-country-button': 'onConfirmCountry',
        'change #cardPayment__country': 'onCountryChange',
        'change #cardPayment__zip': 'onZipChange'
    }),
    reset: function reset() {
        this.model = null;
        this.parent = null;
        this.values = {};
        this.callback = null;
        this.confirmedCountry = null;

        this.resetStripe();
        this.disableForm();
        this.hideError();

        this.cardholder.val('');

        this.cardLine1.val('');
        this.cardLine2.val('');
        this.cardState.val('');
        this.cardCityZip.html('');
        this.cardCity = null;
        this.cardZip = null;
        this.cardCountry.html('');

        this.cardAmount.text('');
        this.cardAmountHead.hide();
        this.cardDescription.text('');
        this.submit.find('span').text('');
        this.cardEl.val('');
        this.submit.removeSpin();
    },
    isDisabled: function isDisabled() {
        return this.disabled;
    },
    disableForm: function disableForm() {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.submit.prop('disabled', true);
        }
    },
    enableForm: function enableForm() {
        if (this.isDisabled()) {
            this.disabled = false;
            this.submit.prop('disabled', false);
        }
    },
    resetStripe: function resetStripe() {
        if (this.cardElement) {
            this.cardElement.destroy();
            this.cardElement = null;
        }
    },
    renderName: function renderName() {
        this.cardholder.val(this.model.session.get('name'));
    },
    getZip: function getZip() {
        if (this.cardZip) {
            return this.cardZip.val();
        }
    },
    getCountry: function getCountry() {
        return this.cardCountry.val();
    },
    renderCityZip: function renderCityZip() {
        var city = this.cardCity ? this.cardCity.val() : null;
        var zip = this.cardZip ? this.cardZip.val() : null;
        var country = this.getCountry();

        this.cardCity = $('<input id="cardPayment__city" type="text" class="input" placeholder="City">');
        if (city) {
            this.cardCity.val(city);
        }
        var label = country === "US" ? "Zip" : "Postcode";
        this.cardZip = $('<input id="cardPayment__zip" type="text" class="input">').attr('placeholder', label);
        if (zip) {
            this.cardZip.val(zip);
        }

        this.cardCityZip.html('');
        if (_.includes(ziplessCountries, country)) {
            this.cardCityZip.append(this.cardCity);
        } else if (!country || _.includes(countriesShowingZipAfterCity, country)) {
            this.cardCityZip.append(this.cardCity);
            this.cardCityZip.append(this.cardZip);
        } else {
            this.cardCityZip.append(this.cardZip);
            this.cardCityZip.append(this.cardCity);
        }
    },
    renderCountries: function renderCountries() {
        this.cardCountry.html('<option>');
        var plans = this.model.session.plans;
        _.each(plans.countries, _.bind(function (name, code) {
            var option = $('<option>').val(code).text(name);
            if (code === (plans.vat_country || plans.country)) {
                option.prop('selected', true);
            }
            this.cardCountry.append(option);
        }, this));
    },
    renderStripe: function renderStripe(callback) {
        var elements = this.Stripe.elements();
        this.cardElement = elements.create('card', {
            hidePostalCode: true
        });
        this.cardElement.mount(this.cardEl[0]);
        this.cardElement.on('change', _.bind(function (e) {
            if (e.error) {
                this.showInputError(e.error.message);
            } else {
                this.hideInputError();
            }
        }, this));
        this.cardElement.on('ready', _.bind(function (e) {
            callback();
        }, this));
    },

    afterHide: function afterHide() {
        this.callback();
        this.reset();
    },
    showError: function showError(response) {
        this.cardError.html(this.parent.formatStripeError(response)).show();
        this.enableForm();
        this.submit.removeSpin();
    },
    hideError: function hideError() {
        this.cardError.hide().html('');
        this.hideInputError();
    },
    showInputError: function showInputError(message) {
        this.cardInputError.text(message).show();
    },
    hideInputError: function hideInputError() {
        this.cardInputError.hide().text('');
    },
    renderLabel: function renderLabel(label) {
        this.submit.find('span').text(label);
    },
    renderValues: function renderValues() {
        this.cardDescription.text(this.values.description);
        if (this.values.amount) {
            this.cardAmount.text(this.parent.formatter.amount(this.values.currency, this.values.amount));
            this.cardAmountHead.show();
        }
    },
    show: function show(options) {
        this.model = options.model;
        this.parent = options.parent;

        this.renderName();
        this.renderCountries();
        this.renderCityZip();

        this.callback = options.callback;
        this.values = options.values;

        this.renderValues();
        this.renderLabel(options.label);

        this.cardLoading.show();
        this.disableForm();

        this.loadStripe();

        _scriptjs2.default.ready('stripe', _.bind(function () {
            this.renderStripe(_.bind(function () {
                this.cardLoading.hide();
                this.enableForm();
            }, this));
        }, this));

        return _dialogview2.default.prototype.show.call(this);
    },
    onCountryChange: function onCountryChange(e) {
        this.renderCityZip();
    },
    onZipChange: function onZipChange(e) {
        if (this.cardElement) {
            this.cardElement.update({ value: { postalCode: this.getZip() } });
        }
    },

    getPaymentMethodData: function getPaymentMethodData() {
        return {
            billing_details: {
                name: this.cardholder.val(),
                email: this.values.email,
                address: {
                    city: this.cardCity.val(),
                    country: this.getCountry(),
                    line1: this.cardLine1.val(),
                    line2: this.cardLine2.val(),
                    postal_code: this.cardZip.val(),
                    state: this.cardState.val()
                }
            }
        };
    },

    createPaymentMethod: function createPaymentMethod() {
        this.Stripe.createPaymentMethod('card', this.cardElement, this.getPaymentMethodData()).then(_.bind(this.handlePaymentMethod, this));
    },

    onConfirmCountry: function onConfirmCountry(e) {
        this.confirmedCountry = $(e.target).data('country');
        this.onSubmit(e);
    },
    onSubmit: function onSubmit(e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }

        this.submit.addSpin();
        this.disableForm();
        this.hideError();

        this.createPaymentMethod();
    },
    handlePaymentMethod: function handlePaymentMethod(stripeMethod) {
        debug.info('<- [STRIPE paymentMethod]', stripeMethod);

        if (stripeMethod.error) {
            return this.showError({
                success: false,
                message: 'card_error',
                data: stripeMethod.error
            });
        }

        this.callback({
            stripe_method: stripeMethod.paymentMethod.id,
            country: this.confirmedCountry
        }, _.bind(this.handlePaymentCallbackResponse, this));
    },
    done: function done(response) {
        if (response.customer && (response.delinquent || !response.initial && response.subscription == 'incomplete')) {
            this.model.payDelinquentStripeInvoice({
                customer_id: response.customer,
                org: this.values.org
            });
        }
        var parent = this.parent;
        this.hide();
        parent.afterPay(response);
    },
    handlePaymentCallbackResponse: function handlePaymentCallbackResponse(callbackResponse) {
        debug.info('<- [STRIPE paymentCallbackResponse]', callbackResponse);

        if (!callbackResponse.success) {
            return this.showError(callbackResponse);
        }
        if (callbackResponse.intent_status !== 'requires_action' && callbackResponse.intent_status !== 'requires_source_action') {
            // No further action necessary, payment confirmed
            this.done(callbackResponse);
        } else {
            var stripeFun = callbackResponse.intent_type == 'setup_intent' ? 'handleCardSetup' : 'handleCardPayment';
            this.Stripe[stripeFun](callbackResponse.intent_client_secret).then(_.bind(this.handlePaymentIntent, this, stripeFun, callbackResponse));
        }
    },
    handlePaymentIntent: function handlePaymentIntent(stripeFun, callbackResponse, stripeIntent) {
        debug.info('<- [STRIPE stripeIntent: ' + stripeFun + ']', stripeIntent, callbackResponse);

        if (stripeIntent.error) {
            if (callbackResponse.customer && callbackResponse.initial) {
                this.model.cancelIncompleteStripeSubscription({
                    customer_id: callbackResponse.customer,
                    org: this.values.org
                });
            }
            return this.showError({
                success: false,
                message: 'card_error',
                data: stripeIntent.error
            });
        }
        // Payment confirmed
        this.done(callbackResponse);
    }
});

/***/ }),

/***/ "YQlf":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"clipboardTriggerAction clipboardTriggerAction--copy\">\n    Copy selected lines\n    <i class=\"fa fa-clipboard\"></i>\n    <i class=\"fa fa-check\"></i>\n</span>\n<span class=\"clipboardTriggerAction clipboardTriggerAction--insert clipboardTriggerAction--hide\">\n    Insert selected lines\n    <i class=\"fa fa-clipboard\"></i>\n    <i class=\"fa fa-check\"></i>\n</span>\n";
},"useData":true});

/***/ }),

/***/ "Z/we":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <p class=\"upgradePayment__label\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "</p>\n    <p class=\"upgradePayment__price\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"currencySymbol") : depth0), depth0))
    + " "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"price") : depth0), depth0))
    + " <span class=\"upgradePayment__description\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"description") : depth0), depth0))
    + "</span></p>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"card_error") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":0},"end":{"line":14,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"card_idle") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":0},"end":{"line":21,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"card_waiting") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":0},"end":{"line":28,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"card_progress") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":0},"end":{"line":35,"column":7}}})) != null ? stack1 : "")
    + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"upgrade__error\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"card_error") : stack1), depth0)) != null ? stack1 : "")
    + "\n    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(__webpack_require__("rUjk"),depth0,{"name":"upgrade-methods","hash":{"back":"upgradePayment__cancel-card","methods":((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"card_method") : stack1)},"data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "    <p class=\"upgrade__progress\">\n        <i class=\"spin\"></i>\n        Waiting for card payment…\n    </p>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "    <p class=\"upgrade__progress\">\n        <i class=\"spin\"></i>\n        Upgrading your account…\n    </p>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"paypal_error") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":0},"end":{"line":45,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"paypal_idle") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":0},"end":{"line":52,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"paypal_confirm_country") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":54,"column":0},"end":{"line":82,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"paypal_waiting") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":84,"column":0},"end":{"line":89,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"paypal_progress") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":91,"column":0},"end":{"line":96,"column":7}}})) != null ? stack1 : "")
    + "\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"upgrade__error\">\n        "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"paypal_error") : stack1), depth0)) != null ? stack1 : "")
    + "\n    </div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(__webpack_require__("rUjk"),depth0,{"name":"upgrade-methods","hash":{"back":"upgradePayment__cancel-paypal","methods":((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"paypal_method") : stack1)},"data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"upgrade__error\">\n        We need to confirm your country of residence to comply with European Union VAT regulations when paying with PayPal.\n    </div>\n    \n    <div class=\"upgradePayment__confirm-countries\">\n"
    + ((stack1 = container.hooks.blockHelperMissing.call(depth0,container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"paypal_confirm_countries") : stack1), depth0),{"name":"state.paypal_confirm_countries","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":60,"column":8},"end":{"line":75,"column":43}}})) != null ? stack1 : "")
    + "        <button class=\"upgradeSchedules__button\n            upgradePayment__button\n            upgradePayment__cancel-paypal\" type=\"button\">\n            Cancel\n        </button>\n    </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"upgradePayment__payment upgradePayment__confirm-country\">\n            <button class=\"\n                upgradeSchedules__button\n                upgradeSchedules__button--action\n                upgradePayment__button\n                upgradePayment__button--action\n                upgradePayment__confirm-country-button\" data-country=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"code") : depth0), depth0))
    + "\" type=\"button\">\n                "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\n            </button>\n            <img src=\"/static/flags/flags-iso/flat/64/"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"code") : depth0), depth0))
    + ".png\"\n                class=\"flag\"\n                width=\"32\" height=\"32\" alt=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\">\n            "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\n        </div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    return "    <p class=\"upgrade__progress\">\n        <i class=\"spin\"></i>\n        Waiting for PayPal…\n    </p>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"paypal") : stack1),{"name":"unless","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":101,"column":0},"end":{"line":156,"column":11}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"chosen_schedule") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":103,"column":0},"end":{"line":154,"column":7}}})) != null ? stack1 : "")
    + "\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(__webpack_require__("rUjk"),depth0,{"name":"upgrade-methods","hash":{"methods":((stack1 = (depth0 != null ? lookupProperty(depth0,"chosen_schedule") : depth0)) != null ? lookupProperty(stack1,"methods") : stack1)},"data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"schedules") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.program(24, data, 0),"data":data,"loc":{"start":{"line":107,"column":4},"end":{"line":150,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = container.invokePartial(__webpack_require__("V125"),depth0,{"name":"upgrade-checklist","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <form class=\"upgradeSchedules__form\">\n        <table class=\"upgradeSchedules__items\">\n        <caption class=\"upgradeSchedules__caption\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"annual_payments") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":111,"column":12},"end":{"line":115,"column":19}}})) != null ? stack1 : "")
    + "            <span class=\"upgradeSchedules__methods_caption\">\n                Payment methods\n            </span>\n        </caption>\n"
    + ((stack1 = container.hooks.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? lookupProperty(depth0,"schedules") : depth0), depth0),{"name":"schedules","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":120,"column":8},"end":{"line":132,"column":22}}})) != null ? stack1 : "")
    + "        </table>\n\n"
    + ((stack1 = container.invokePartial(__webpack_require__("ZMMA"),depth0,{"name":"upgrade-info","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n        <p class=\"upgradeSchedules__pay\">\n            <button class=\"\n            upgradeSchedules__button\n            upgradeSchedules__button--action\" type=\"submit\">Upgrade</button>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"upgraded") : stack1),{"name":"if","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":141,"column":12},"end":{"line":145,"column":19}}})) != null ? stack1 : "")
    + "        </p>\n    </form>\n";
},"17":function(container,depth0,helpers,partials,data) {
    return "            <span class=\"upgradeSchedules__annual_cta\">\n                Pay annually and get 2 months for free!\n            </span>\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <tr class=\"upgradeSchedules__item "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":121,"column":42},"end":{"line":121,"column":97}}})) != null ? stack1 : "")
    + "\" data-value=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"value") : depth0), depth0))
    + "\">\n            <td class=\"upgradeSchedules__item_radio\"><input type=\"radio\" name=\"schedule\" value=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"value") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isActive") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":122,"column":107},"end":{"line":122,"column":137}}})) != null ? stack1 : "")
    + "></td>\n            <td class=\"upgradeSchedules__item_label\">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "</td>\n            <td class=\"upgradeSchedules__item_currency\">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"currencySymbol") : depth0), depth0))
    + "</td>\n            <td class=\"upgradeSchedules__item_price\">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"price") : depth0), depth0))
    + "</td>\n            <td class=\"upgradeSchedules__item_period\">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"period") : depth0), depth0))
    + "</td>\n            <td class=\"upgradeSchedules__item_methods\">\n                "
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"payment") : depth0),{"name":"each","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":128,"column":16},"end":{"line":128,"column":139}}})) != null ? stack1 : "")
    + "\n            </td>\n        </tr>\n        <tr class=\"upgradeSchedules__item_spacer\"><td colspan=\"6\"></td></tr>\n";
},"19":function(container,depth0,helpers,partials,data) {
    return "upgradeSchedules__item--selected";
},"20":function(container,depth0,helpers,partials,data) {
    return "checked";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"methods") : depth0),{"name":"each","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":128,"column":33},"end":{"line":128,"column":130}}})) != null ? stack1 : "");
},"22":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"img") : depth0), depth0))
    + "\" width=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"width") : depth0), depth0))
    + "\" height=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"height") : depth0), depth0))
    + "\" alt=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0))
    + "\">";
},"23":function(container,depth0,helpers,partials,data) {
    return "            <button class=\"\n            upgradeSchedules__button\n            upgradeSchedules__cancel-button\" type=\"button\">Cancel</button>\n";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__("ZMMA"),depth0,{"name":"upgrade-info","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<h1 class=\"upgradeSchedules__header\" tabindex=\"0\">Upgrade your account</h1>\n\n"
    + ((stack1 = container.hooks.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? lookupProperty(depth0,"chosen_schedule") : depth0), depth0),{"name":"chosen_schedule","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":0},"end":{"line":6,"column":20}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"card") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":0},"end":{"line":37,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"paypal") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":0},"end":{"line":98,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"card") : stack1),{"name":"unless","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":100,"column":0},"end":{"line":157,"column":11}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),

/***/ "ZAC8":
/***/ (function(module, exports, __webpack_require__) {

var Avatar = __webpack_require__("lKP6");
var AvatarUploadPreview = __webpack_require__("ew4Z").default;
var Formatter = __webpack_require__("5gSh");
var Channel = __webpack_require__("KU+H");
var Connection = __webpack_require__("LLdI");
var Message = __webpack_require__("j9Sh");
var LineMessageRenderer = __webpack_require__("3F0q");
var OverlayContainerView = __webpack_require__("f01x");
var IRCCloudNotifier = __webpack_require__("9cM4");
var startSlackAuth = __webpack_require__("K0O/").startAuth;
var UA = __webpack_require__("HBAA");

__webpack_require__("9iIa");


var SettingsView = Backbone.View.extend({
    el: '.settingsContainer',
    defaultSection: 'design',
    initialize: function (options) {
        this.selected = false;
        
        this.enableNotifications = $('.enableNotifications');
        
        this.avatar = new AvatarUploadPreview({
            session: this.model,
            el: this.$('.avatarPreview')
        }).setModel(this.model);
        this.name = $('#settingsName');
        this.email = $('#settingsEmail');
        this.highlights = $('#settingsHighlights');
        this.autoaway = $('#settingsAutoaway');
        this.closeButton = $('.settingsClose');
        this.error = $('.settingsError');
        
        this.userPrefsCheckboxes = $('.userPrefsCheckbox');
        this.labsCheckboxes = $('.labsCheckbox');
        
        this.messageLayoutPreview = this.$('.messageLayout__preview');
        
        this.accountFormErrors = $('.settingsAccountForm .userError');
        this.accountFormSuccesses = $('.settingsAccountForm .userSuccess');
        this.settingsCurrentPasswords = $('.settingsCurrentPassword');
        
        this.settingsNewPassword = $('#settingsNewPassword');

        this.passwords = this.$('input[type=password]');
        
        this.formatter = new Formatter();
        
        this.model.bind('init', this.init, this);
        this.model.bind('notificationPermissionRequested', this.renderEnableNotifications, this);
        
        this.overlay = new OverlayContainerView({
            model: this.model,
            session: this.model
        });
        
        this.debouncedSave = _.debounce(_.bind(this.save, this), 300);
        
        this.render();
    },
    events: {
        'buttonClick .settingsSubmit': 'submitForm',
        'buttonClick .settingsClose': 'hide',
        'submit .settingsAccountForm__email': 'submitEmailForm',
        'submit .settingsAccountForm__password': 'submitPasswordForm',
        'submit .settingsAccountForm__delete': 'submitDeleteForm',
        'buttonClick .export': 'clickExportLogs',
        'buttonClick .settingsAccountForm .cancel': 'hideAccountForms',
        'buttonClick .enableNotifications__button': 'clickEnableNotifications',
        'buttonClick #testAlertSound': 'testAlertSound',
        'click .sidebarChooser': 'chooseSidebarLayout',
        'click .themeChooser': 'chooseTheme',
        'buttonClick .fontChooser': 'chooseFont'
    },
    isSelected: function () {
        return this.selected;
    },
    show: function (section) {
        this.selected = true;
        this.showSection(section);
        this.$el.addClass('settingsContainer--show');
        this.passwords.prop('disabled', false);
        this.model.trigger('settingsShown');
    },
    showSection: function (section) {
        if (!this.$('.settingsContents__' + section).length) {
            this.model.trigger('navigate', '?/settings', {trigger: true, replace: true});
            return;
        }
        this.reset();
        if (section === 'notifications') {
            this.renderEnableNotifications();
        }
        if (section == 'account') {
            this.$('.settingsAccountSessions_head').addClass('loading');
            this.model.getStreams(_.bind(function (response) {
                if (response.success) {
                    this.$('.settingsAccountSessions_head').removeClass('loading');
                    var table = $('<table>');
                    _.each(_.sortBy(Object.values(response.sessions), 'issue_date'), function (session) {
                        var headRow = $('<tr>');
                        headRow.append($('<th>').text('Login date'));
                        headRow.append($('<th>').text('Expires'));
                        headRow.append($('<th>').text('Login IP'));
                        headRow.append($('<th>').text('Login user agent'));
                        headRow.append($('<th class="settingsAccountSessions_clients">').text('Active clients'));
                        table.append(headRow);
                        var row = $('<tr class="settingsAccountSessions_session">');
                        row.append($('<td class="settingsAccountSessions_date">').text(
                            new Date(session.issue_date * 1000).toString('ddd dd MMM yyyy HH:mm')
                        ));
                        row.append($('<td class="settingsAccountSessions_expiry">').text(
                            new Date((session.issue_date + session.maxage) * 1000).toString('ddd dd MMM yyyy HH:mm')
                        ));
                        row.append($('<td class="settingsAccountSessions_ip">').text(session.ip_address));
                        row.append($('<td class="settingsAccountSessions_ua">').text(session.user_agent).prepend(UA.icons(session.user_agent)));
                        row.append($('<td class="settingsAccountSessions_clients">').text(session.streams.length));
                        table.append(row);
                        if (session.streams.length) {
                            var streamHeadRow = $('<tr>');
                            streamHeadRow.append($('<th colspan="2">').text('Client start'));
                            streamHeadRow.append($('<th>').text('Client IP'));
                            streamHeadRow.append($('<th>').text('Client user agent'));
                            table.append(streamHeadRow);
                            _.each(_.sortBy(session.streams, 'start_time'), function (stream) {
                                var rowClass = 'settingsAccountSessions_stream_row';
                                var self = stream.self || (stream.stream_id == this.model.getStreamId());
                                if (self) {
                                    rowClass += ' settingsAccountSessions_stream_row--self';
                                }

                                var streamRow = $('<tr>').addClass(rowClass);
                                streamRow.append($('<td class="settingsAccountSessions_stream_start">').text(
                                    new Date(stream.start_time * 1000).toString('ddd dd MMM yyyy HH:mm')
                                ));
                                var streamStart = $(this.formatter.howLong(
                                    new Date(stream.start_time * 1000)
                                ));
                                streamRow.append($('<td class="settingsAccountSessions_stream_age">').html(streamStart));
                                streamRow.append($('<td class="settingsAccountSessions_stream_ip">').text(stream.ip_address));
                                streamRow.append($('<td class="settingsAccountSessions_sream_ua">').text(stream.user_agent).prepend(UA.icons(stream.user_agent)));
                                if (self) {
                                    streamRow.append($('<th class="settingsAccountSessions_sream_current">').text('Current'));
                                }
                                table.append(streamRow);
                            }, this);
                        }
                    }, this);
                    if (response.bnc.length) {
                        var bncHead = $('<tr>').append($('<td colspan="4">').append(
                            $('<h3>').text('Bouncer connections')
                        ));
                        table.append(bncHead);
                        var bncHeadRow = $('<tr>');
                        bncHeadRow.append($('<th>').text('Connect date'));
                        bncHeadRow.append($('<th colspan="2">').text('Client ID'));
                        bncHeadRow.append($('<th>').text('Connection'));
                        table.append(bncHeadRow);
                        _.each(_.sortBy(response.bnc, 'start_time'), function (stream) {
                            var streamRow = $('<tr class="settingsAccountSessions_stream_row">');
                            streamRow.append($('<td class="settingsAccountSessions_stream_start">').text(
                                new Date(stream.start_time * 1000).toString('ddd dd MMM yyyy HH:mm')
                            ));
                            streamRow.append($('<td colspan="2" class="settingsAccountSessions_stream_client_id">').text(stream.client_id));
                            var connection = this.model.connections.get(stream.cid);
                            streamRow.append($('<td class="settingsAccountSessions_stream_connection">').html(
                                this.formatter.linkModel(connection, {
                                    className: 'server'
                                })
                            ));
                            table.append(streamRow);
                        }, this);
                    }
                    this.$('.settingsAccountSessions_sessions').html(table);
                    table.find('.settingsAccountSessions_stream_age span').timeago();
                }
            }, this));
        }
        this.$('.settingsContents').removeClass('settingsContents--show');
        this.$('.settingsMenu__item').removeClass('settingsMenu__item--selected');
        this.$('.settingsContents__' + section).addClass('settingsContents--show');
        this.$('.settingsMenu__item__' + section).addClass('settingsMenu__item--selected');
    },
    hide: function (options) {
        options = options || {};
        if (this.isSelected()) {
            this.selected = false;
            this.$el.removeClass('settingsContainer--show');
            
            if (!options.silent && !this.model.selectPreviousBuffer()) {
                this.model.trigger('currentBufferChange', this);
            }
            
            this.reset();
            
            this.hideError();
            this.$el.removeSpin();
            this.accountFormErrors.hide();
            this.accountFormSuccesses.hide();
            this.passwords.prop('disabled', true);
        }
    },
    resetPasswords: function () {
        this.settingsCurrentPasswords.val('');
        this.settingsNewPassword.val('');
    },
    // This will get called from MainAreaView
    renderOverlay: function (overlay) {
        this.overlay.append(overlay);
        
        return this;
    },
    generateSidebar: function () {
        var menu = $('<div class="settingsMenu">');
        this.$('.settingsContents').each(_.bind(function (i, contents) {
            var section = $(contents).data('section');
            $(contents).addClass('settingsContents__' + section);
            var title = $(contents).find('.settingsTitle').text();
            var link = $('<a class="settingsMenu__link">').attr('href', '/?/settings=' + section).text(title);
            menu.append($('<div class="settingsMenu__item">').addClass('settingsMenu__item__' + section).append(link));
        }, this));
        this.$el.prepend(menu);
    },
    hideAccountForms: function () {
        this.$('.settingsAccountForm').removeClass('settingsAccountForm--show');
    },
    generateAccountLinks: function () {
        this.$('.settingsAccountForm').each(_.bind(function (i, form) {
            var action = $(form).data('action');
            $(form).addClass('settingsAccountForm__' + action);
            var title = $(form).find('.settingsAccountFormTitle').text();
            var button = $('<button type="button" class="link settingsAccountLinks__link">').text(title);
            button.click(_.bind(function (e) {
                this.hideAccountForms();
                $(form).addClass('settingsAccountForm--show');
            }, this));
            this.$('.settingsAccountLinks').append($('<p class="settingsAccountLinks__item">').addClass('settingsAccountLinks__item__' + action).append(button));
        }, this));
    },
    render: function () {
        this.generateSidebar();
        this.generateAccountLinks();
        this.$el.append(this.overlay.render().el);
    },
    reset: function () {
        this.renderStat();
        this.renderName();
        this.renderEmail();
        this.renderHighlights();
        this.renderAutoaway();
        this.renderPrefs();
        this.resetPasswords();
    },
    renderAvatar: function () {
        var avatarLink = Avatar.redirectTemplate(this.model.id, '');
        $('#settingsAvatarLink').attr('href', avatarLink).text(avatarLink);
    },
    init: function () {
        this.generateMessageLayoutPreview();
        this.renderAvatar();
        this.renderFeatures();
        this.renderUpgradeableSlackConnections();
        this.reset();
        this.renderEnableNotifications();
        this.bindSessionEvents();
        _.extend(this.events, {
            'click .settings__embedExternal': 'embedExternalClick',
            'click .settings__embedMastodon': 'embedMastodonClick',
            'change .userPrefsCheckbox': 'saveUserPrefs',
            'change .labsCheckbox': 'saveLabs',
            'change #settingsAutoaway': 'autoawayChange',
            'input .settings__inputSetting': 'inputSettingChange'
        });
        this.delegateEvents();
    },
    bindSessionEvents: function () {
        this.model.bind('stat', this.renderStat, this);
        this.model.bind('prefChange', this.renderPrefs, this);
        this.model.bind('featureChange', this.renderFeatures, this);
        this.listenTo(this.model.connections, 'change', this.renderUpgradeableSlackConnections);
    },
    renderStat: function () {
        this.$('.settings__upgradeRequired').toggle(!this.model.isUnlimited());
    },
    inputSettingChange: function (e) {
        this.debouncedSave();
    },
    autoawayChange: function (e) {
        this.save();
    },
    save: function (callback) {
        this.hideError();
        this.closeButton.addSpin();
        this.model.userSettings(this.name.val(), this.highlights.val(), this.autoaway.is(":checked"), _.bind(function (response) {
            this.closeButton.removeSpin();
            if (!response.success) {
                var message;
                switch (response.message) {
                case 'realname':
                    message = 'Invalid real name';
                    break;
                case 'hwords':
                    message = 'Error setting highlights';
                    break;
                case 'autoaway':
                    message = 'Error setting auto-away';
                    break;
                default:
                    message = 'Error updating account settings: ' + response.message;
                    break;
                }
                this.showError(message);
            }
        }, this));
    },
    submitForm: function (e) {
        e.preventDefault();
        this.save();
    },
    checkboxEnabled: function (checkbox) {
        return true;
    },
    embedExternalClick: function (e) {
        var checkbox = $(e.target);
        if (this.checkboxEnabled(checkbox)) {
            var checked = checkbox.prop('checked');
            if (checked && !this.model.getPref('inlineimagewarn')) {
                this.model.trigger('inlineImageConfirm', _.bind(function () {
                    checkbox.prop('checked', checked);
                    this.saveUserPrefs();
                }, this));
                checkbox.prop('checked', !checked);
                return false;
            }
        }
    },
    embedMastodonClick: function (e) {
        var checkbox = $(e.target);
        if (this.checkboxEnabled(checkbox)) {
            var checked = checkbox.prop('checked');
            if (checked && !this.model.getPref('inlinemastodonwarn')) {
                this.model.trigger('inlineMastodonConfirm', _.bind(function () {
                    checkbox.prop('checked', checked);
                    this.saveUserPrefs();
                }, this));
                checkbox.prop('checked', !checked);
                return false;
            }
        }
    },
    saveCheckboxes: function (checkboxes) {
        var values = {};
        var checks = checkboxes.toArray();
        _.each(checks, function (checkbox, i) {
            checkbox = $(checkbox);
            if (!(checkbox.attr('name') in values) && this.checkboxEnabled(checkbox)) {
                var value = !!checkbox.prop('checked');
                if (checkbox.hasClass('inverse')) {
                    value = !value;
                }
                values[checkbox.attr('name')] = value;
            }
        }, this);
        return values;
    },
    saveUserPrefs: function () {
        var prefs = this.saveCheckboxes(this.userPrefsCheckboxes);
        this.model.setPref(prefs);
    },
    saveLabs: function () {
        var labs = this.saveCheckboxes(this.labsCheckboxes);
        this.model.setLabs(labs);
    },
    changeCredentials: function (form, oldpassword, newpassword, email) {
        form.addSpin();
        form.find('.userSuccess').hide();
        form.find('.userError').hide();
        this.model.changeCredentials(
            oldpassword,
            newpassword,
            email,
            _.bind(function (response) {
                form.removeSpin();
                this.resetPasswords();
                if (response.success) {
                    form.find('.userSuccess').show();
                } else {
                    var message;
                    switch (response.message) {
                    case 'oldpassword':
                        message = 'Current password incorrect';
                        break;
                    case 'rate_limited':
                        message = 'Rate limited, try again in a few mins';
                        break;
                    case 'newpassword':
                        message = 'Invalid new password';
                        break;
                    case "password_too_long":
                        message = 'Maximum password length: ' + window.IRCConfig.max_password_length;
                        break;
                    case 'password_error':
                        message = 'Invalid password, try again';
                        break;
                    case 'email_invalid':
                        message = 'Invalid email address';
                        break;
                    case 'email_not_unique':
                        message = 'This email address is already in use';
                        break;
                    default:
                        message = 'Error changing password: ' + response.message;
                        break;
                    }
                    form.find('.userError').hide().text(message).fadeIn('fast');
                }
            }, this)
        );
    },
    submitEmailForm: function (e) {
        e.preventDefault();

        var form = $(e.target);
        var data = form.serializeForm();
        this.changeCredentials(
            form,
            data.oldpassword,
            '',
            data.email
        );
    },
    submitPasswordForm: function (e) {
        e.preventDefault();

        var form = $(e.target);
        var data = form.serializeForm();
        this.changeCredentials(
            form,
            data.oldpassword,
            data.password,
            this.model.get('email')
        );
    },
    submitDeleteForm: function (e) {
        e.preventDefault();
        if (!confirm('Are you sure you want to delete your account?')) {
            return;
        }
        var form = $(e.target);
        var data = form.serializeForm();
        form.addSpin();
        form.find('.userError').hide();
        this.model.deleteAccount(data.password, _.bind(function (response) {
            form.removeSpin();
            if (response.success) {
                this.hide();
            } else {
                var message;
                switch (response.message) {
                case 'bad_pass':
                    message = 'Incorrect password, try again';
                    break;
                case 'last_admin_cant_leave':
                    message = 'You can’t delete your account as the last admin of a team. <a href="/?/teams">Transfer ownership</a> before continuing';
                    break;
                default:
                    message = 'Error deleting account: ' + this.formatter.escapeText(response.message);
                }
                form.find('.userError').hide().html(message).fadeIn('fast');
            }
        }, this));
    },
    clickExportLogs: function (e) {
        e.preventDefault();
        this.model.trigger('exportConfirm');
    },
    clickEnableNotifications: function (e) {
        e.preventDefault();
        this.renderEnableNotifications();
        IRCCloudNotifier.requestPermission(_.bind(function (permission) {
            if (permission === 'granted') {
                this.model.trigger('notify', null, {
                    tag: 'test',
                    title: 'Sample notification',
                    body: 'You’ll now get a notification whenever you’re highlighted',
                    click: _.bind(function (notification) {
                        notification.close();
                    }, this)
                });
            }
            this.renderEnableNotifications();
        }, this));
    },
    testAlertSound: function (e) {
        e.preventDefault();
        this.model.trigger('playAlert', true);
    },
    renderEnableNotifications: function () {
        this.enableNotifications.toggle(IRCCloudNotifier.shouldRequest());
        return this;
    },
    renderName: function () {
        this.name.val(this.model.get('name'));
        return this;
    },
    renderEmail: function () {
        this.email.val(this.model.get('email'));
        return this;
    },
    renderHighlights: function () {
        this.highlights.val(this.model.getHighlights().join(' '));
        return this;
    },
    renderAutoaway: function () {
        this.autoaway.prop('checked', this.model.get('autoaway'));
        return this;
    },
    chooseSidebarLayout: function (e) {
        var left = $(e.currentTarget).is('.sidebarChooser__left');
        this.model.setPref('layout-left', left);
    },
    chooseTheme: function (e) {
        var theme = $(e.currentTarget).data('theme');
        if (this.model.getPref('theme-auto') && theme == 'dawn') {
            return;
        }
        this.model.setPref('theme', theme);
    },
    chooseFont: function (e) {
        var font = $(e.target).data('font');
        this.model.setPref('font', font);
    },
    generateMessageLayoutPreview: function () {
        var nick = this.model.getNick();
        this.messageLayoutPreviewBuffer = new Channel({
            cid: 1
        }, {
            session: this.model,
            connection: new Connection({
                cid: 1,
                bid: 1,
                nick: nick,
                hostname: 'irc.irccloud.com',
                port: 6697,
                ssl: true
            }, {
                session: this.model
            })
        });
        var nowHour = new Date().getHours();
        var timeOfDay;
        if (nowHour < 5) {
            timeOfDay = 'time of night';
        } else if (nowHour < 12) {
            timeOfDay = 'morning';
        } else if (nowHour < 18) {
            timeOfDay = 'afternoon';
        } else {
            timeOfDay = 'evening';
        }
        var nowTs = this.model.backend.ts();
        var mentions0 = {};
        mentions0[nick] = [[3, nick.length]];
        var messageData = [{
            eid: (nowTs-10000)*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_msg',
            from: 'amita',
            from_realname: 'Amita Ramanujan',
            avatar_url: this.model.getOrigin() + '/static/numb3rs/amita-{size}.png',
            from_mode: 'o',
            msg: 'Hi ' + nick + '! 🙋🏽‍♀️',
            self: false,
            highlight: true,
            entities: {
                mentions: mentions0
            }
        }, {
            eid: (nowTs-7000)*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_me_msg',
            from: 'don',
            from_realname: 'Don Eppes',
            avatar_url: this.model.getOrigin() + '/static/numb3rs/don-{size}.png',
            msg: 'waves',
            self: false
        }, {
            eid: (nowTs-5000)*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_msg',
            from: nick,
            from_realname: this.model.get('name'),
            avatar: this.model.get('avatar'),
            msg: ':wave:',
            self: true
        }, {
            eid: (nowTs-2000)*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_msg',
            from: nick,
            from_realname: this.model.get('name'),
            avatar: this.model.get('avatar'),
            msg: 'Hey @amita, @don. How’s everyone this ' + timeOfDay + '?',
            self: true,
            entities: {
                mentions: {
                    amita: [[5, 5]],
                    don: [[13,3]]
                }
            }
        }, {
            eid: nowTs*1000,
            bid: 1,
            cid: 1,
            type: 'buffer_msg',
            from: 'charlie',
            from_realname: 'Charlie Eppes',
            avatar_url: this.model.getOrigin() + '/static/numb3rs/charlie-{size}.png',
            from_mode: 'v',
            msg: 'Not too bad :)',
            self: false
        }];
        var messages = [];
        _.each(messageData, function (data) {
            var m = new Message(data, {
                buffer: this.messageLayoutPreviewBuffer
            });
            m._previousMessage = _.last(messages);
            messages.push(m);
        }, this);
        var renderer = new LineMessageRenderer(this.messageLayoutPreviewBuffer);
        renderer.firstRender = true;
        var rows = renderer.renderMessages(messages).flush();
        var viewport = $('<div class="viewport">');
        var log = $('<div class="log">');
        log.append(rows);
        viewport.append(log);
        this.messageLayoutPreview.append(viewport);
    },
    toggleCheckboxEnabled: function (checkbox, enabled, forceCheck) {
        if (enabled) {
            checkbox
                .prop('disabled', false)
                .closest('tr')
                .removeClass('messageLayout--disabled');
        } else {
            checkbox
                .prop('disabled', true)
                .closest('tr')
                .addClass('messageLayout--disabled');
        }
        if (forceCheck) {
            checkbox.prop('checked', true);
        }
    },
    renderMessageLayoutPreview: function (e) {
        var multiLine = this.messageLayoutPreviewBuffer.multiline();
        var avatars = this.messageLayoutPreviewBuffer.avatarsEnabled();
        var imageAvatars = this.messageLayoutPreviewBuffer.imageAvatarsEnabled();
        var externalAvatars = this.messageLayoutPreviewBuffer.embedExternalAvatars();
        var timeRightChangeAllowed = !(avatars && multiLine);
        this.toggleCheckboxEnabled(
            this.$('#prefsImageAvatars'),
            avatars
        );
        this.toggleCheckboxEnabled(
            this.$('#prefsRealname'),
            multiLine
        );
        this.toggleCheckboxEnabled(
            this.$('#prefsTimestampRight'),
            timeRightChangeAllowed,
            !timeRightChangeAllowed
        );
        var timeRight = this.messageLayoutPreviewBuffer.isTimeRight();
        var realnames = this.messageLayoutPreviewBuffer.showRealnames();
        
        this.messageLayoutPreview.toggleClass('multiline', multiLine);
        this.messageLayoutPreview.toggleClass('oneline', !multiLine);
        this.messageLayoutPreview.toggleClass('realnames-on', realnames);
        this.messageLayoutPreview.toggleClass('realnames-off', !realnames);
        this.messageLayoutPreview.toggleClass('time-right', timeRight);
        this.messageLayoutPreview.toggleClass('time-left', !timeRight);
        this.messageLayoutPreview.toggleClass('avatars-on', avatars);
        this.messageLayoutPreview.toggleClass('avatars-off', !avatars);
        this.messageLayoutPreview.toggleClass('avatars-image-on', imageAvatars);
        this.messageLayoutPreview.toggleClass('avatars-image-off', !imageAvatars);
        this.messageLayoutPreview.toggleClass('avatars-external', externalAvatars);
        this.messageLayoutPreview.toggleClass('avatars-noexternal', !externalAvatars);
    },
    renderFeatures: function () {
        
    },
    renderUpgradeableSlackConnections: function () {
        $('#upgradeableSlackConnections .networks').empty();
        var showHint = false;
        this.model.connections.each(function (conn) {
            if (conn.isSlackUpgradable()) {
                showHint = true;
                var row = $('<div class="upgradeSlack network">');

                var hostLine = $('<p class="head">');
                hostLine.append('<i class="fa fa-slack">');
                var displayName = conn.getDisplayName();
                hostLine.append($('<span class="host">').text(' ' + displayName + ' '));
                var hostname = conn.getHostname();
                if (hostname != displayName) {
                    hostLine.append(' / ');
                    hostLine.append(this.formatter.escapeText(hostname));
                }
                row.append(hostLine);

                var detailLine = $('<div class="details">');
                detailLine.text('Nick: ' + conn.getNick());

                row.append(detailLine);

                row.on('click', _.bind(function (e) {
                    if (conn.isSlackUpgradable()) {
                        startSlackAuth(this.model, {
                            data: {
                                cid: conn.id
                            },
                            onSuccess: _.bind(function (response) {
                                this.model.setFocusOnMakeServer(response.cid);
                            }, this),
                            onError: _.bind(function (message) {
                                if (message) {
                                    conn.trigger('postError', {
                                        message: message
                                    });
                                }
                            }, this)
                        });
                    }
                }, this));

                $('#upgradeableSlackConnections .networks').append(row);
            }
        }, this);
        this.$('.settings__labsSlack_upgradeable').toggle(showHint);
    },
    renderPrefs: function () {
        var left = !!this.model.getPref('layout-left');
        this.$('.sidebarChooser__left').toggleClass('sidebarChooser--selected', left);
        this.$('.sidebarChooser__right').toggleClass('sidebarChooser--selected', !left);
        
        var theme = this.model.getTheme();
        this.$('.themeChooser').removeClass('themeChooser--selected');
        if (this.model.getPref('theme-auto')) {
            this.$('.themeChooser').addClass('themeChooser--auto');
            var darkTheme = this.model.getDefaultDarkTheme();
            this.$('.themeChooser__' + darkTheme).addClass('themeChooser--selected');
            this.$('.themeChooser__dawn').addClass('themeChooser--selected');
        } else {
            this.$('.themeChooser__' + theme).addClass('themeChooser--selected');
        }
        
        var font = this.model.getFont();
        this.$('.fontChooser__button').removeClass('active');
        this.$('.fontChooser__' + font).addClass('active');
        
        this.renderCheckboxes(this.userPrefsCheckboxes, _.bind(function (name) {
            return !!this.model.getPref(name);
        }, this));
        this.renderCheckboxes(this.labsCheckboxes, _.bind(function (name) {
            return this.model.labCheck(name);
        }, this));
        this.renderMessageLayoutPreview();
        return this;
    },
    renderCheckboxes: function (checkboxes, valueFun) {
        checkboxes.each(_.bind(function (i, checkbox) {
            checkbox = $(checkbox);
            if (this.checkboxEnabled(checkbox)) {
                var value = valueFun(checkbox.attr('name'));
                if (checkbox.hasClass('inverse')) {
                    value = !value;
                }
                checkbox.prop('checked', value);
            }
        }, this));
    },
    hideError: function () {
        this.error.hide();
    },
    showError: function (message) {
        this.error.hide().text(message).fadeIn('fast');
    }
});


module.exports = SettingsView;


/***/ }),

/***/ "ZBd7":
/***/ (function(module, exports, __webpack_require__) {

var browser = __webpack_require__("2ZbG");

var ScrollClockView = Backbone.View.extend({
    tagName: 'div',
    className: 'dateWrapper dateChange',
    tickDelay: 1000,
    radius: 7,
    offset: 1,
    getProps: function () {
        return {
            outerBorder: {
                lineWidth: 1.3,
                color: this.getColor(),
                alpha: 1,
                radius: 0.95
            },
            hub: {
                lineWidth: 1,
                fill: this.getColor(),
                color: this.getColor(),
                alpha: 1,
                radius: 0.1
            },
            hourHand: {
                lineWidth: 2,
                color: this.getColor(),
                alpha: 1,
                startAt: 0,
                endAt: 0.6
            },
            minuteHand: {
                lineWidth: 2,
                color: this.getColor(),
                alpha: 1,
                startAt: 0,
                endAt: 0
            }
        };
    },
    getColor: function () {
        return this.clock.css('color');
    },
    initialize: function (options) {
        this.model.bind('remove', this.remove, this);
        this.diameter = (this.radius + this.offset) * 2;
        this.visible = false;
    },
    show: function () {
        if (!this.isVisible()) {
            $(this.el).show();
            this.visible = true;
            return true;
        }
    },
    hide: function () {
        if (this.isVisible()) {
            $(this.el).hide();
            this.visible = false;
            return true;
        }
    },
    isVisible:function () {
        return this.visible;
    },
    render: function (offset) {
        var table = $('<table class="date">');
        this.date = $('<td class="scrollDate">');
        this.clock = $('<canvas class="clock">');
        var clockCell = $('<td class="clockcell">');
        // Make the canvas the requested size. It's always square.
        clockCell.width(this.diameter);
        

        this.ctx = this.clock[0].getContext("2d");
        // scale the canvas down with CSS
        this.clock.css({
            width: this.diameter,
            height: this.diameter
        });

        this.timeago = $('<td class="timeago">');
        var row = $('<tr>')
            .append(this.date)
            .append(clockCell.append(this.clock))
            .append(this.timeago);
        table.append(row);
        $(this.el).append(table);
        
        return this;
    },
    getHeight: function (force) {
        if (force) {
            return $(this.el).height();
        } else if (this.isVisible()) {
            return this.height;
        } else {
            return 0;
        }
    },
    cacheHeight: function () {
        this.height = this.getHeight(true);
    },
    update: function (upperMessage, atBottom) {
        if (!upperMessage || atBottom) {
            delete this.upperMessage;
            this.height = 0;
            this.hide();
            return false;
        }

        if (upperMessage.equals(this.upperMessage)) {
            return true;
        }
        
        this.upperMessage = upperMessage;
        
        this.show();
        if (!this.height) {
            this.cacheHeight();
        }
        // Update clock time
        var date = upperMessage.getDate();
        this.date.text(date.toString("dddd, MMMM dS, yyyy"));
        this.timeago.timeago('dispose');
        this.timeago.attr('title', date.toISOString()).text(date.formatFullDate()).timeago();
        
        // Pixel density fix
        var ratio = browser.getPixelRatio();
        // stretch the canvas HTML element
        this.clock.attr('width', this.diameter * ratio);
        this.clock.attr('height', this.diameter * ratio);
        // stretch the bitmap on canvas 
        this.ctx.scale(ratio, ratio);
        
        this.renderClock(date.getHours(), date.getMinutes(), date.getSeconds());
        $(this.el).attr('title', date.formatFullDate());
        return true;
    },
    
    fullCircleAt: function(x, y, style) {
        this.ctx.save();
        // Style
        this.ctx.globalAlpha = style.alpha;
        this.ctx.lineWidth = style.lineWidth;
        this.ctx.strokeStyle = style.color;
        // Draw
        this.ctx.translate(this.offset, this.offset);
        this.ctx.beginPath();
        this.ctx.arc(x, y, style.radius * this.radius, 0, 2 * Math.PI, false);
        if (style.fill) {
            this.ctx.fillStyle = style.fill;
            this.ctx.fill();
        } else {
            this.ctx.stroke();
        }
        
        this.ctx.restore();
    },
    radialLineAtAngle: function (angleFraction, style) {
        this.ctx.save();
        // Style
        this.ctx.globalAlpha = style.alpha;
        this.ctx.lineWidth = style.lineWidth;
        this.ctx.strokeStyle = style.color;
        // Draw
        this.ctx.translate(this.radius + this.offset, this.radius + this.offset);
        this.ctx.rotate(Math.PI * (2 * angleFraction - 0.5));
        this.ctx.beginPath();
        this.ctx.moveTo(style.startAt * this.radius, 0);
        this.ctx.lineTo(style.endAt * this.radius, 0);
        this.ctx.stroke();
        
        this.ctx.restore();
    },
    renderClock: function (hour, min, sec) {
        // Clear
        this.ctx.clearRect(0, 0, this.diameter, this.diameter);
        // Outer border
        var props = this.getProps();
        this.fullCircleAt(this.radius, this.radius, props.outerBorder);
        // Hub
        this.fullCircleAt(this.radius, this.radius, props.hub);
        // Hours
        this.radialLineAtAngle((hour + min / 60) /12, props.hourHand);
        // Mins
        this.radialLineAtAngle((min + sec / 60) /60, props.minuteHand);
    }
});


module.exports = ScrollClockView;


/***/ }),

/***/ "ZGvr":
/***/ (function(module, exports) {

var Autogrow = Backbone.View.extend({
    initialize: function (options) {
        this.minHeight = options.minHeight || 10;
        this.manualDetect = !!options.manualDetect;
        this.manualTrigger = !!options.manualTrigger;

        this.renderShim();
    },
    events: {
        'input': 'onInput',
        'keyup': 'onInput',
        'update': 'onInput'
    },
    onInput: function (e) {
        if (!this.manualDetect) {
            this.resize();
        }
    },
    renderShim: function () {
        this.shim = $('<div class="shim">');
        $('#inputShims').append(this.shim);
    },
    isGrown: function () {
        return this.$el.height() > this.minHeight + 5;
    },
    resize: function () {
        // Copy value to shim and get dimensions. triggers style recalculate
        this.shim.width(this.$el.width());
        var value = this.$el.val()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#x27;')
            .replace(/\//g, '&#x2f;');
        this.shim.html(value + '\n');
        // Recalculates styles
        var newHeight = Math.max(this.shim.height(), this.minHeight);
        
        // Only if the height changes
        if (newHeight !== this.currentHeight) {
            this.currentHeight = newHeight;
            // Limit the height to half the window
            var overflow = 'hidden';
            var halfWindowHeight = $(window).height() / 2;
            if (newHeight > halfWindowHeight) {
                newHeight = halfWindowHeight;
                overflow = 'auto';
            }
            var css = {
                'height': newHeight,
                'overflow': overflow
            };
            if (this.manualTrigger) {
                this.$el.trigger('autogrow', css);
            } else {
                this.$el.css(css);
            }
        }
    }
});


module.exports = Autogrow;


/***/ }),

/***/ "ZMMA":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    return "<div class=\"userInfo\">\n    <p>Account upgrades are currently disabled.</p>\n</div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    return "    <small>\n        <br>\n        Businesses in the EU can provide a VAT registration number with a team account\n    </small>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ssb_fluid") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":4},"end":{"line":22,"column":11}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    return "    <div class=\"userInfo\">\n        <p>If you're using IRCCloud inside a <a href=\"http://fluidapp.com/\">Fluid app</a>, you’ll need to switch to a full web browser to upgrade with PayPal.</p>\n    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "")
    + "\n<p class=\"upgradeSchedules__team\">\n    Do you use IRC at work? <a href=\"/?/teams\">Set up accounts for your team here</a>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"vat_applicable") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":14,"column":11}}})) != null ? stack1 : "")
    + "</p>\n\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":0},"end":{"line":23,"column":11}}})) != null ? stack1 : "");
},"useData":true});

/***/ }),

/***/ "ZRaQ":
/***/ (function(module, exports, __webpack_require__) {

var Pastebin = __webpack_require__("RvJ1");


var PastebinList = Backbone.Collection.extend({
    model: Pastebin,
    initialize: function (models, options) {
        this.session = options.session;
    },
    comparator: function (pastebin) {
        return -pastebin.get('date');
    },
    getPages: function () {
        if (this.total) {
            return Math.ceil(this.total/this.per_page);
        }
    },
    fetch: function (page) {
        var data = {};
        if (page > 1) {
            data.page = page;
        }
        if (this.fetchComplete) {
            this.fetchComplete.reject();
        }
        var complete = this.session.getBackoff('pastebins', data);
        this.fetchComplete = complete;
        return complete.promise().done(_.bind(function (response) {
            this.total = response.total;
            this.per_page = response.per_page;
            this.page = response.page;
            this.set(response.pastebins, {
                session: this.session
            });
            this.trigger('fetched');
        }, this));
    }
});


module.exports = PastebinList;


/***/ }),

/***/ "Zj5c":
/***/ (function(module, exports, __webpack_require__) {

var BufferListChannelView = __webpack_require__("/ybZ");
var BufferListConversationView = __webpack_require__("xUgn");
var BufferListServerLogView = __webpack_require__("5hW5");
var ChannelList = __webpack_require__("61Uw");


var BufferListConnectionView = Backbone.View.extend({
    tagName: 'li',
    className: 'connection',
    initialize: function (options) {
        this.model.bind('remove', this.remove, this);
        this.buffers = {};
        this.parent = options.parent;
    },
    events: {
        'buttonClick button.join': 'clickJoin',
        'buttonClick p.archiveToggle button': 'clickArchiveToggle',
        'buttonClick p.collapseToggle button': 'clickCollapseToggle',
        'buttonClick p.spamWarning button': 'clickSpamWarning',
    },
    clickSpamWarning: function (e) {
        this.model.trigger('deletePMConfirm');
        return false;
    },
    clickJoin: function (e) {
        this.model.trigger('joinPrompt');
        return false;
    },
    clickArchiveToggle: function (e) {
        e.preventDefault();
        this.toggleArchives();
    },
    clickCollapseToggle: function (e) {
        e.preventDefault();
        this.model.toggleCollapsed();
    },
    renderServerLog: function () {
        var serverLog = new BufferListServerLogView({
            el: this.heading,
            model: this.model.serverLog
        });
        this.renderBufferView(serverLog);
        
        return this;
    },
    hideCollapseDelayed: function () {
        this.$el.off('mouseleave mouseenter');
        clearTimeout(this.hideCollapseDelayedTimer);
        this.$el.one('mouseleave', _.bind(function () {
            this.hideCollapseDelayedTimer = setTimeout(_.bind(function () {
                this.$el.removeClass('expanded');
                this.$el.off('mouseleave mouseenter');
            }, this), 2000);
            this.$el.one('mouseenter', _.bind(function () {
                this.hideCollapseDelayed();
            }, this));
        }, this));
    },
    renderCollapsed: function (initial, labChange) {
        var collapsed = this.model.isCollapsed();
        if (!initial && !labChange && !collapsed) {
            if (this.$('.collapseToggle').css('visibility') === 'visible') {
                this.$el.addClass('expanded');
                this.hideCollapseDelayed();
            }
        }
        this.$el.toggleClass('collapsed', collapsed);
        this.$('.collapseToggle button').attr('aria-expanded', String(!collapsed))
            .html(collapsed ? '<i class="fa fa-plus-square-o"></i>Expand' : '<i class="fa fa-minus-square-o"></i>Collapse');
    },
    renderCollapsedUnread: function () {
        if (!this.model.isCollapsed()) {
            $(this.el).removeClass('totalUnread');
        } else {
            $(this.el).toggleClass('totalUnread', !!this.model.buffers.any(function (b) {
                return b.isTrackingUnread() && b.hasUnseen();
            }));
        }
    },

    renderCollapsedHighlights: function () {
        var count = 0;
        this.model.session.unseenBuffers.each(function (buffer) {
            if (!buffer.isServerLog() && buffer.connection.equals(this.model)) {
                count += buffer.unseenHighlightCount();
            }
        }, this);

        if (count) {
            this.$('.totalBadge').text(count);
            $(this.el).addClass('activeTotalBadge');
        } else {
            this.$('.totalBadge').text('');
            $(this.el).removeClass('activeTotalBadge');
        }
        
        return this;
    },
    renderSSL: function () {
        this.$el.toggleClass('ssl', this.model.isSSL());
        this.$el.toggleClass('ssl_verify_error', this.model.isSSLVerifyError());
    },
    renderTwitch: function () {
        this.$el.toggleClass('twitch', this.model.isTwitch());
    },
    renderSlack: function () {
        this.$el.toggleClass('slack', this.model.isSlack());
        this.$el.toggleClass('slack--oauth', this.model.isSlackOAuth());
    },
    getTemplate: function () {
        if (!BufferListConnectionView._structure) {
            BufferListConnectionView._structure = $($('#tpl-connection-lists').html());
        }
        return BufferListConnectionView._structure.clone();
    },
    render: function () {
        this.$el.append(this.getTemplate().children());
        this.heading = this.$('h2.buffer');

        this.renderSSL();
        this.model.bind('change:ssl', this.renderSSL, this);
        this.renderTwitch();
        this.renderSlack();
        this.model.bind('change:ircserver', this.renderSlack, this);
        this.model.bind('change:hostname', this.renderSlack, this);
        this.model.bind('change:hostname', this.renderTwitch, this);


        this.renderCollapsed(true);
        this.renderCollapsedUnread();
        this.renderCollapsedHighlights();
        this.listenTo(this.model.buffers, 'unseenChange', this.renderCollapsedUnread);
        this.listenTo(this.model.buffers, 'unseenHighlightChange', this.renderCollapsedHighlights);
        this.listenTo(this.model.serverLog, 'change:archived', function () {
            this.renderCollapsed();
            this.renderCollapsedUnread();
        });
        this.listenTo(this.model.session, 'prefChange:labs', function () {
            this.renderCollapsed(false, true);
        });
        
        // Buffer lists
        this.channelList = this.$('ul.channels');
        this.inactiveChannelList = this.$('ul.inactiveChannels');
        this.conversationList = this.$('ul.conversations');
        this.archivedChannelList = this.$('ul.archivedChannels');
        this.archivedConversationList = this.$('ul.archivedConversations');
        
        this.renderPasswordedWarning();
        
        this.renderServerLog();
        
        this.renderConnectionStatus();
        this.model.bind('change:status change:fail_info', this.renderConnectionStatus, this);
        
        var renderMap = {
            'pinnedBuffers': this.parent.pinnedBufferList,
            'activeChannels': this.channelList,
            'inactiveChannels': this.inactiveChannelList,
            'activeConversations': this.conversationList,
            'archivedChannels': this.archivedChannelList,
            'archivedConversations': this.archivedConversationList
        };
        _.each(renderMap, function (list, collectionName) {
            var collection = this.model.buffers[collectionName];
            var handler = this.renderCollectionBuffers(list, collection);
            collection.bind('add', handler);
        }, this);
        if (this.model.buffers.hasChildren() || this.model.buffers.hasArchivedBuffers()) {
            this.collapseJoinLink();
        } else {
            this.expandJoinLink();
        }
        this.renderSpamWarning();

        // This connection has archives
        if (this.model.buffers.hasArchivedBuffers()) {
            this.showArchives();
        }

        this.model.on('archivesFetched', this.renderArchives, this);
        this.model.on('archiveFetchFailed', this.closeArchives, this);
        this.model.buffers.bind('change:archived', this.renderBufferArchived, this);
        this.model.buffers.bind('selectedChange', this.renderBufferSelected, this);
        this.model.buffers.bind('remove', this.removeBuffer, this);
        this.model.buffers.bind('unseenChange', this.renderSpamWarning, this);
        
        return this;
    },
    renderArchives: function () {
        var renderMap = {
            'archivedChannels': this.archivedChannelList,
            'archivedConversations': this.archivedConversationList
        };
        _.each(renderMap, function (list, collectionName) {
            var collection = this.model.buffers[collectionName];
            this.renderCollectionBuffers(list, collection);
        }, this);
    },
    renderCollectionBuffers: function (list, collection) {
        var handler = _.bind(function (buffer) {
            if (buffer.connection.equals(this.model)) {
                var renderer = buffer.isChannel() ? this.renderChannel : this.renderConversation;
                if (!buffer.isArchived() || !this.model.isFetchingArchives()) {
                    renderer.call(this, buffer, collection, list);
                }
            }
        }, this);
        collection.each(handler);
        return handler;
    },
    renderBufferSelected: function (buffer) {
        this.$el.toggleClass('childSelected', buffer.isSelected());
        if (!buffer.isServerLog() && buffer.isSelected() && buffer.isArchived()) {
            this.openArchives();
        }
        if (buffer.isSelected()) {
            if (buffer.connection.isCollapsed()) {
                this.buffers[buffer.connection.serverLog.bid()].scrollToView();
            } else {
                this.buffers[buffer.bid()].scrollToView();
            }
        }
    },
    renderBufferArchived: function (buffer) {
        if (this.model.buffers.hasArchivedBuffers()) {
            this.showArchives();
        }
        this.conversationList.toggleClass('hide', !this.model.buffers.hasActiveConversations());
        this.renderSpamWarning();
        if (!buffer.isServerLog()) {
            var hasArchives = this.model.buffers.hasArchivedBuffers();
            if (buffer.wasArchived()) {
                if (!hasArchives) {
                    this.hideArchives();
                } else {
                    this.closeArchives();
                }
            } else {
                if (hasArchives) {
                    this.showArchives();
                }
            }
        }
    },
    renderBufferView: function (bufferView) {
        bufferView.render();
        bufferView.bubble('scrollTo', this);
        if (this.buffers[bufferView.model.bid()]) {
            this.buffers[bufferView.model.bid()].remove();
        }
        this.buffers[bufferView.model.bid()] = bufferView;
    },
    renderChildView: function (childView, collection, list) {
        this.renderBufferView(childView);
        
        // This connection has children
        this.collapseJoinLink();
        var buffer = childView.model;
        
        // Insert in the correct position
        var existing = list.children();
        var index = collection.indexOf(buffer);
        var el = childView.el;
        if (index == existing.length) {
            list.append(el);
        } else {
            existing.eq(index).before(el);
        }

        // These can either be conversations of slack mpdms (channels)
        this.conversationList.toggleClass('hide', !this.model.buffers.hasActiveConversations());
    },
    renderChannel: function (channel, collection, list) {
        var channelView = new BufferListChannelView({
            model: channel
        });
        this.renderChildView(channelView, collection, list);
    },
    renderConversation: function (conversation, collection, list) {
        var conversationView = new BufferListConversationView({
            model: conversation
        });
        this.renderChildView(conversationView, collection, list);
    },
    removeBuffer: function (buffer, options) {
        // Just removed the last buffer
        if (!this.model.buffers.hasChildren() && !this.model.buffers.hasArchivedBuffers()) {
            this.expandJoinLink();
        }
        // Removed the last archived buffer
        if (buffer.isArchived() && !this.model.hasArchivedBuffers()) {
            this.hideArchives();
        }
        this.conversationList.toggleClass('hide', !this.model.buffers.hasActiveConversations());
        this.renderSpamWarning();
        delete this.buffers[buffer.bid()];
    },
    hideArchives: function () {
        this.$('p.archiveToggle').removeClass('show');
        this.closeArchives();
        this.trigger('toggleArchives');
    },
    showArchives: function () {
        this.$('p.archiveToggle').addClass('show');
        this.trigger('toggleArchives');
    },
    openArchives: function () {
        if (!this.model.isFetchingArchives() && this.model.hasDeferredArchives()) {
            this.loadArchives();
        }
        this.archivesOpen = true;
        this.$el.addClass('openArchives');
        this.trigger('toggleArchives');
        this.$('p.archiveToggle button').attr('aria-expanded', 'true');
    },
    closeArchives: function () {
        this.archivesOpen = false;
        this.$el.removeClass('openArchives');
        this.trigger('toggleArchives');
        this.$('p.archiveToggle button').attr('aria-expanded', 'false');
    },
    toggleArchives: function () {
        if (this.archivesOpen) {
            this.closeArchives();
        } else {
            this.openArchives();
        }
    },
    loadArchives: function () {
        this.$el.addClass('loadingArchives');
        this.model.fetchArchives(_.bind(function (response) {
            this.$el.removeClass('loadingArchives');
            this.trigger('toggleArchives');
        }, this));
    },
    renderPasswordedWarning: function () {
        this.$('p.passwordedWarning').remove();
        if (this.model.get('server_pass') !== '') {
            var warningContents = $('<span>').text("Your subscription plan doesn't allow passworded connections.");
            var upgradeLink = $('<a>').attr('href', '/?/upgrade').text('Upgrade your account');
            var passwordedWarning = $('<p class="passwordedWarning">');
            passwordedWarning.append(warningContents);
            passwordedWarning.append(upgradeLink);
            this.heading.after(passwordedWarning);
        }
    },
    expandJoinLink: function () {
        this.$('p.join').removeClass('hide');
    },
    collapseJoinLink: function () {
        this.$('p.join').addClass('hide');
    },
    renderSpamWarning: function () {
        this.$('p.spamWarning').toggleClass('show', this.model.hasSpam());
    },
    renderConnectionStatus: function () {
        this.$el.toggleClass('disconnected', this.model.isDisconnected());
        this.$el.toggleClass('connected', !this.model.isDisconnected());
        this.$el.toggleClass('loading', this.model.isConnecting());
        this.$el.toggleClass('badRetry', this.model.badRetry());
        this.$el.toggleClass('failed', this.model.isFailed());
        this.heading.toggleClass('loading', this.model.isConnecting());
        this.heading.toggleClass('badRetry', this.model.badRetry());
        this.heading.toggleClass('failed', this.model.isFailed());
        this.renderSSL();
    }
});


module.exports = BufferListConnectionView;


/***/ }),

/***/ "ZmGF":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"back") || (depth0 != null ? lookupProperty(depth0,"back") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"back","hash":{},"data":data,"loc":{"start":{"line":4,"column":16},"end":{"line":4,"column":24}}}) : helper)));
},"1":function(container,depth0,helpers,partials,data) {
    return "upgradePayment__back-button";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button class=\"\n    upgradeSchedules__button\n    upgradePayment__button\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"back") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":4,"column":66}}})) != null ? stack1 : "")
    + "\" type=\"button\">Back</button>";
},"useData":true});

/***/ }),

/***/ "a/KD":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");
var Overlay = __webpack_require__("jcM0");
var Connection = __webpack_require__("LLdI");


var LogDownloadDialogView = DialogView.extend({
    el: '#logDownloadContainer',
    initialize: function (options) {
        this.error = this.$('.userError');
        this.success = this.$('.userSuccess');
        this.tzSelect = this.$('select.tzSelect');
        this.buttons = this.$('.buttons');

        this.pendingHeader = this.$('.pendingHeader');
        this.pendingExports = this.$('.pendingExports');

        this.availHeader = this.$('.availHeader');
        this.availExports = this.$('.availExports');

        this.expiredHeader = this.$('.expiredHeader');
        this.expiredReveal = this.$('.expiredHeader a');
        this.expiredExports = this.$('.expiredExports');

        this.tz = this.$('.tz');

        this.init();
        this.afterHide = _.bind(this.init, this);

        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'click a.tzChange': 'clickChange',
        'click .expiredHeader a': 'toggleExpired',
        'buttonClick .buttons button': 'clickButton'
    }),
    init: function () {
        this.error.hide();
        this.success.hide();
        this.tzSelect.empty().hide();

        this.pendingHeader.hide();
        this.availHeader.hide();
        this.expiredHeader.hide();
        this.expiredReveal.text('Show expired');
        this.$('.logExport span.explanation').timeago('dispose');
        this.pendingExports.empty().hide();
        this.availExports.empty().hide();
        this.expiredExports.empty().hide();
        this.buttons.find('button').prop('disabled', true).removeData('model');
        this.stopListening();
    },
    clickButton: function (e) {
        e.preventDefault();
        var button = $(e.target);
        var model = button.data('model');
        var options = {
            timezone: this.tzSelect.val(),
            model: model
        };
        button.addSpin();
        this.error.hide();
        this.model.exportLogs(options, _.bind(function (response) {
            button.removeSpin();
            if (response.success) {
                this.success.text('Your log export is in progress. We’ll email you when it’s ready.').fadeIn('fast');
                this.pendingHeader.show();
                var pending = this.renderPendingExport(response['export']);
                pending.highlightFlash();
                this.pendingExports.prepend(pending).show();
            } else {
                var msg;
                switch (response.message) {
                case 'invalid_cid':
                    msg = 'Invalid connection id';
                    break;
                case 'invalid_bid':
                    msg = 'Invalid buffer id';
                    break;
                case 'nothing_to_export':
                    msg = 'Nothing to export';
                    break;
                case 'rate_limited':
                    msg = 'You’re trying to export too quickly, try again later';
                    break;
                default:
                    msg = 'Error exporting logs';
                }
                this.error.text(msg).fadeIn('fast');
            }
        }, this));
    },
    clickChange: function (e) {
        e.preventDefault();
        this.tzSelect.toggle();
    },
    show: function (buffer) {
        this.renderButtons(buffer);
        this.listenTo(this.model, 'exportFinished', this.exportFinished);
        DialogView.prototype.show.call(this);
    },
    afterShow: function () {
        this.model.getExports(_.bind(function (response) {
            if (response.error || response.success === false) {
                this.error.text("Error fetching exports, try again later").fadeIn('fast');
            } else {
                this.renderTimezone(response);
                this.buttons.find('button').prop('disabled', false);
                this.buttons.find('button.buffer').focus();
                this.renderExports(response);
            }
        }, this));
    },
    renderExportTitle: function (exp) {
        var title = '';
        if (exp.cid) {
            var conn = this.model.getConnection(exp.cid);
            if (conn) {
                title += conn.getDisplayName();
                if (exp.bid) {
                    title += ': ';
                    var buf = conn.getBuffer(exp.bid);
                    if (buf) {
                        if (buf.isServerLog()) {
                            title += 'network console';
                        } else {
                            title += buf.getDisplayName();
                        }
                    } else {
                        title += 'unknown log (' + exp.cid + ')';
                    }
                }
            } else {
                title += 'Unknown network (' + exp.cid + ')';
                if (exp.bid) {
                    title += ': unknown log (' + exp.bid + ')';
                }
            }
        } else {
            title += 'All networks';
        }
        return title;
    },
    renderPendingExport: function (exp) {
        var start = new Date(this.model.backend.tsOffset(exp.startdate * 1000));
        var startStrings = $.extend({}, $.timeago.settings.strings, {
            prefixAgo: 'started',
            suffixFromNow: 'ago',
            prefixFromNow: 'started'
        });
        return $('<p class="logExport">')
            .attr('id', 'logExport_' + exp.id)
            .append($('<span>').text(this.renderExportTitle(exp)))
            .append(' ')
            .append($('<span class="explanation">')
                .attr('title', start.toISOString())
                .text(start.formatFullDate())
                .timeago('init', startStrings)
            );
    },
    renderAvailExport: function (exp) {
        var finish = new Date(this.model.backend.tsOffset(exp.finishdate * 1000));
        var expires = new Date(this.model.backend.tsOffset(exp.expirydate * 1000));
        var expiresStrings = $.extend({}, $.timeago.settings.strings, {
            prefixFromNow: 'expires in:',
            suffixFromNow: null,
            suffixAgo: null
        });
        var finishStrings = $.extend({}, $.timeago.settings.strings, {
            suffixFromNow: 'ago',
        });
        return $('<p class="logExport">')
            .attr('id', 'logExport_' + exp.id)
            .append($('<span class="timeago explanation">')
                .attr('title', expires.toISOString())
                .text(expires.formatFullDate())
                .timeago('init', expiresStrings)
            )
            .append(' ')
            .append($('<a>')
                .attr({
                    'href': exp.redirect_url,
                    'download': exp.file_name
                })
                .text(this.renderExportTitle(exp))
            )
            .append(' ')
            .append($('<span class="explanation">')
                .attr('title', finish.toISOString())
                .text(finish.formatFullDate())
                .timeago('init', finishStrings)
            );
    },
    renderExpiredExport: function (exp) {
        var finish = new Date(this.model.backend.tsOffset(exp.finishdate * 1000));
        var expires = new Date(this.model.backend.tsOffset(exp.expirydate * 1000));
        var expiredStrings = $.extend({}, $.timeago.settings.strings, {
            prefixAgo: 'expired:'
        });
        return $('<p class="logExport">')
            .attr('id', 'logExport_' + exp.id)
            .append($('<span class="timeago explanation">')
                .attr('title', expires.toISOString())
                .text(expires.formatFullDate())
                .timeago('init', expiredStrings)
            )
            .append(' ')
            .append($('<span>').text(this.renderExportTitle(exp)))
            .append(' ')
            .append($('<span class="explanation">')
                .attr('title', finish.toISOString())
                .text(finish.formatFullDate())
                .timeago()
            );
    },
    renderTimezone: function (response) {
        var tzDetect;
        _.each(response.timezones, function (tz) {
            var option = $('<option>').attr('value', tz.name).text(tz.abbrev + ' (' + tz.utc_offset + ') ' + tz.name);
            if (tz.name == response.timezone) {
                tzDetect = tz;
                option.prop('selected', true);
            }
            this.tzSelect.append(option);
        }, this);
        if (tzDetect) {
            this.tz.text(tzDetect.abbrev + ' (' + tzDetect.utc_offset + ') ' + tzDetect.name);
        }
    },
    renderExports: function (response) {
        if (response.inprogress.length) {
            this.pendingHeader.show();
            _.each(response.inprogress, _.bind(function (exp) {
                this.pendingExports.append(this.renderPendingExport(exp)).show();
            }, this));
        }
        if (response.available.length) {
            this.availHeader.show();
            _.each(response.available, _.bind(function (exp) {
                this.availExports.append(this.renderAvailExport(exp)).show();
            }, this));
        }
        if (response.expired.length) {
            _.each(response.expired, _.bind(function (exp) {
                this.expiredHeader.show();
                this.expiredExports.append(this.renderExpiredExport(exp));
            }, this));
        }
    },
    toggleExpired: function (e) {
        e.preventDefault();

        var scrollTo, action;
        var offset = this.expiredHeader.prop('offsetTop');
        if (this.expiredExports.is(':visible')) {
            this.expiredExports.slideUp('fast');
            scrollTo = (offset + this.expiredHeader.outerHeight(true)) - this.$el.height();
            action = 'Show';
        } else {
            this.expiredExports.show();
            scrollTo = Math.min(offset, this.el.scrollHeight - this.$el.height());
            action = 'Hide';
        }
        this.expiredReveal.text(action + ' expired');
        this.$el.animate({
            'scrollTop': scrollTo
        }, {
            duration: 'fast',
            queue: false
        });
    },
    renderButtons: function (buffer) {
        var connectionOnly = false;
        if (buffer) {
            var connection;
            if (buffer instanceof Connection) {
                connectionOnly = true;
                connection = buffer;
            } else {
                connection = buffer.connection;
            }
            // All buffers for the connection
            this.buttons.find('button.connection').data('model', connection);
            this.buttons.find('button.connection span').text('This network (' + connection.getDisplayName() + ')');

            if (!connectionOnly) {
                // Just the buffer
                var name;
                if (buffer.isServerLog()) {
                    name = 'This network console';
                } else if (buffer.isChannel()) {
                    name = 'This channel (' + buffer.getDisplayName() + ')';
                } else {
                    name = 'This conversation (' + buffer.getDisplayName() + ')';
                }
                this.buttons.find('button.buffer').data('model', buffer);
                this.buttons.find('button.buffer span').text(name);
            }
        }
        
        var allOnly = !buffer;
        this.$('.logChooseExplain').toggle(!allOnly);
        this.buttons.find('button.connection').toggle(!allOnly);
        this.buttons.find('button.buffer').toggle(!allOnly && !connectionOnly);
        this.buttons.find('button.all').toggle(!allOnly);
        this.buttons.find('button.all_only').toggle(allOnly);
    },
    exportFinished: function (message) {
        var exp = message['export'];
        this.pendingExports.find('#logExport_' + exp.id).remove();
        if (!this.pendingExports.find('p').length) {
            this.pendingHeader.hide();
            this.pendingExports.hide();
        }
        this.renderFinished(exp, this.success);
        this.availHeader.show();
        var avail = this.renderAvailExport(exp);
        avail.addClass('highlight');
        setTimeout(function () {
            avail.removeClass('highlight');
        }, 2000);
        this.availExports.prepend(avail).show();
    },
    renderFinished: function (exp, wrapper) {
        return wrapper
            .text('Your log export is ready. Download it: ')
            .append($('<a>').attr({
                'href': exp.redirect_url,
                'target': '_blank'
            }).text(this.renderExportTitle(exp)));
    },
    finishedOverlay: function (message) {
        var exp = message['export'];
        var msg = this.renderAvailExport(exp);
        msg.addClass('highlight');
        setTimeout(function () {
            msg.removeClass('highlight');
        }, 2000);
        var content = $('<p>').append(msg);
        var head = 'Log export ready';
        var overlay = new Overlay(content, {
            doneText: 'Close',
            head: head,
            message: message
        });
        return overlay;
    }
});


module.exports = LogDownloadDialogView;


/***/ }),

/***/ "a2Rs":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");


var ConnectionTokenView = DialogView.extend({
    el: '.connToken',
    initialize: function (options) {
        this.revealed = false;

        this.error = this.$('.connToken__error');

        this.title = this.$('.connToken__title');
        this.token = this.$('.connToken__token');
        this.tokenPresent = this.$('.connToken__token-present');
        this.input = this.$('.connToken__input');
        this.inputContainer = this.$('.connToken__details-input');
        this.reveal = this.$('.connToken__reveal');
        this.netName = this.$('.connToken__netname');
        this.host = this.$('.connToken__host');
        this.disallowed = this.$('.connToken__disallowed');
        this.generateForm = this.$('.connToken__generate-form');

        this.tokenPrompts = this.$('.connToken__generate-prompts');
        this.regeneratePrompt = this.$('.connToken__regenerate-prompt');

        this.revokeForm = this.$('.connToken__revoke-form');
        this.regenerateForm = this.$('.connToken__regenerate-form');

        this.removeToken();
        this.generateForm.hide();

        this.afterHide = _.bind(function () {
            this.cancelAjax();

            this.connection = null;
            
            this.error.hide();

            this.netName.empty();
            this.host.empty();

            this.removeToken();
            this.generateForm.hide();
        }, this);
        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit form.connToken__generate-form': 'submitGenerate',
        'submit form.connToken__regenerate-form': 'submitGenerate',
        'buttonClick .connToken__revoke-prompt': 'promptRevoke',
        'buttonClick .connToken__reveal': 'clickRevealPass',
        'buttonClick .connToken__revoke-cancel': 'cancelRevoke',
        'buttonClick .connToken__regenerate-prompt': 'promptRegenerate',
        'buttonClick .connToken__regenerate-cancel': 'cancelRegenerate',
        'submit form.connToken__revoke-form': 'submitRevoke',
        'focus .connToken__input': 'selectInput'
    }),
    selectInput: function (e) {
        // https://stackoverflow.com/a/22102081/115076
        this.input.one('mouseup.mouseupSelect', _.bind(function() {
            this.input.select();
            return false;
        }, this));
        this.input.one('mousedown', _.bind(function() {
            // compensate for untriggered 'mouseup' caused by focus via tab
            this.input.off('mouseup.mouseupSelect');
        }, this));
        this.input.select();
    },
    clickRevealPass: function (e) {
        this.revealed = !this.revealed;
        this.renderRevealPass();
    },
    renderRevealPass: function () {
        this.$el.toggleClass('connToken--reveal', this.revealed);
    },
    removeToken: function () {
        this.token.hide();
        this.tokenPresent.hide();
        this.input.val('');
        this.input.prop('disabled', true);
        this.showGenerateForm();
        this.tokenPrompts.hide();
        this.revokeForm.hide();
        this.regenerateForm.hide();
        this.revealed = false;
        this.renderRevealPass();
    },
    showGenerateForm: function () {
        this.generateForm.toggle(this.model.isBncAllowed());
    },
    setConnDetails: function (isSlack) {
        var subdomain = isSlack ? 'slack' : 'bnc';
        var host = subdomain + '.irccloud.com';
        var port = 6697;
        var link = 'ircs://' + host + ':' + port;
        this.$('.connToken__details-link').attr('href', link).text(link);
        this.$('.connToken__details-host').text(host);
        this.$('.connToken__details-port').text(port);
        this.$('.connToken__details-revoke-text').toggle(!isSlack);
        this.$('.connToken__details-history').toggle(!isSlack);
    },
    showToken: function (token, isSlack) {
        this.input.val(token);
        this.setConnDetails(isSlack);
        this.input.prop('disabled', false);
        this.token.toggle(this.model.isBncAllowed());
        this.tokenPresent.toggle(!this.model.isBncAllowed());
        this.revokeForm.hide();
        this.regenerateForm.hide();
        this.generateForm.hide();
        this.regeneratePrompt.toggle(this.model.isBncAllowed());
        this.tokenPrompts.toggle(!isSlack);
    },
    submitGenerate: function (e) {
        e.preventDefault();
        this.connection.post("generate-connection-token", {
            cid: this.connection.id
        }, _.bind(function (response) {
            if (response.success) {
                this.showToken(response.token, false);
                var regen = $(e.target).is(this.regenerateForm);
                var success = 'Password ' + (regen ? 're' : '') + 'generated';
                this.input.highlightFlash(200);
            } else {
                var error;
                switch (response.message) {
                case 'bnc_disallowed':
                    error = 'Connecting with another client <a href="/?/upgrade">requires a subscription</a>';
                    break;
                default:
                    error = 'There was a problem generating a password';
                }
                this.showError(error);
            }
        }, this));
    },
    promptRevoke: function (e) {
        e.preventDefault();
        this.regenerateForm.hide();
        this.revokeForm.show();
    },
    cancelRevoke: function (e) {
        e.preventDefault();
        this.revokeForm.hide();
    },
    promptRegenerate: function (e) {
        e.preventDefault();
        this.revokeForm.hide();
        if (this.model.isBncAllowed()) {
            this.regenerateForm.show();
        }
    },
    cancelRegenerate: function (e) {
        e.preventDefault();
        this.regenerateForm.hide();
    },
    submitRevoke: function (e) {
        e.preventDefault();
        this.connection.post("revoke-connection-token", {
            cid: this.connection.id
        }, _.bind(function (response) {
            if (response.success) {
                this.removeToken();
            } else {
                var message = 'There was a problem revoking the password';
                this.showError(message);
            }
        }, this));
    },
    showError: function (message) {
        this.error.html(message).fadeIn('fast');
    },
    cancelAjax: function () {
        if (this.ajax) {
            this.ajax.cancel();
            this.ajax = null;
        }
    },
    show: function (connection) {
        this.title.addSpin();

        this.connection = connection;
        this.netName.text(this.connection.getName());
        var hostname = this.connection.isSlack() ? 'Slack' : this.connection.getHost();
        this.host.text(hostname);

        this.disallowed.toggle(!this.model.isBncAllowed());

        this.cancelAjax();
        var ajax = this.model.backend.get('get-connection-token', {
            cid: this.connection.id
        }, _.bind(function (response) {
            if (this.ajax === ajax) {
                this.title.removeSpin();
                if (response.error || response.success === false) {
                    if (response.message == 'not_found') {
                        this.showGenerateForm();
                    } else {
                        var message = 'There was a problem checking this connection, try again later';
                        this.showError(message);
                    }
                } else {
                    this.showToken(response.token, response.is_slack);
                }
            }
            this.ajax = null;
        }, this));
        this.ajax = ajax;
        DialogView.prototype.show.call(this);
    }
});


module.exports = ConnectionTokenView;


/***/ }),

/***/ "a4TI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SCHEDULE_MONTHLY_RECURRING: 'monthly_recurring',
    SCHEDULE_ANNUAL_ONEOFF: 'annual_oneoff',
    SCHEDULE_ANNUAL_RECURRING: 'annual_recurring'
};

/***/ }),

/***/ "aQSZ":
/***/ (function(module, exports, __webpack_require__) {

var JoinDefaultServersMixins = __webpack_require__("KQDl");
var OrgEntity = __webpack_require__("gEBD");


var EnterpriseJoinView = Backbone.View.extend($.extend({}, JoinDefaultServersMixins, {
    el: '#enterpriseJoinContainer',
    initialize: function (options) {
        JoinDefaultServersMixins.initialize.call(this, options);
        this.joinExplanationJoined = this.$('.joinDefaultExplanationJoined');
        this.joinExplanationChannels = this.$('.joinDefaultExplanationChannels');
        this.joinExplanationServers = this.$('.joinDefaultExplanationServers');
    },
    joinDefaultServerAction: function (data, callback) {
        this.model.joinDefaultConnections(data, callback);
    },
    show: function (name) {
        if (this.isVisible()) {
            return;
        }

        this.showJoinInit(window.Enterprise.fullname);
        var prattle = this.model.get('autojoin_prattle');
        var org = new OrgEntity({
            name: window.Enterprise.fullname,
            admin: this.model.get('admin'),
            connections: this.model.get('autojoin_custom'),
            ircd: !!prattle,
            ircd_channels: prattle && prattle.join(' ')
        }, {
            session: this.model
        });
        this.showJoinOrg(org);

        this.showJoinPost(org);

        $(this.el).show();
        this.visible = true;
    },
    showJoinPost: function (org) {
        var nets = this.joinConnections;
        var noChans = nets.find('.chan').length === 0;
        this.joinExplanation.toggle(!org.haveJoined());
        if (noChans) {
            this.joinExplanationChannels.hide();
            this.joinExplanationServers.show();
        } else {
            this.joinExplanationServers.hide();
        }
        this.$('.enterpriseJoinedHeader').toggle(org.haveJoined());
        this.$('.enterpriseJoinHeader').toggle(!org.haveJoined());
        if (nets.find('a.chan, .matchConnChoiceExplanation').length || noChans) {
            this.joinExplanationJoined.show();
            this.$('.connections').hide();
            this.$('.join').hide();
            this.$('.passwords').hide();
            this.$('.both').hide();
            if (noChans) {
                this.$('.join').show();
            }
            if (nets.find('a.chan').length) {
                if (org.haveJoined()) {
                    this.$('.connections').show();
                } else {
                    this.$('.join').show();
                }
            }
            if (nets.find('.matchConnChoiceExplanation').length) {
                if (nets.find('.matchConnChoiceExplanation.password').length) {
                    this.$('.passwords').show();
                    if (nets.find('a.chan').length) {
                        this.$('button span.connections').hide();
                        this.$('button span.passwords').hide();
                        this.$('button span.both').show();
                    }
                } else {
                    this.$('.connections').show();
                }
            }
            if (nets.find('strong.chan').length) {
                this.joinAlready.show();
            }
        }
    },
    joinDefaultServerEndAction: function () {
        this.hide();
        if (!this.model.selectPreviousBuffer()) {
            this.model.trigger('currentBufferChange', this);
        }
    },
    hide: function () {
        if (!this.isVisible()) {
            return;
        }
        $(this.el).hide();
        this.hideJoinError();
        this.visible = false;
    },
    isVisible: function () {
        return !!this.visible;
    }
}));


module.exports = EnterpriseJoinView;


/***/ }),

/***/ "abDD":
/***/ (function(module, exports, __webpack_require__) {

var User = __webpack_require__("Xgjh");


var Member = User.extend({
    lastSpoke: null,
    lastHighlighted: null,
    initialize: function (data, options) {
        this.session = options.session;
        this.connection = options.connection;
        this.channel = options.channel;
        this.buffer = options.channel || options.buffer;
    },
    setLastSpoke: function (lastSpoke) {
        if (!this.lastSpoke || lastSpoke > this.lastSpoke) {
            this.lastSpoke = lastSpoke;
        }
    },
    setLastHighlighted: function (lastHighlighted) {
        if (!this.lastHighlighted || lastHighlighted > this.lastHighlighted) {
            this.lastHighlighted = lastHighlighted;
        }
    },
    getLastSpoke: function () {
        if (this.isIgnored()) {
            return 0;
        }
        return this.lastSpoke;
    },
    getLastHighlighted: function () {
        if (this.isIgnored()) {
            return 0;
        }
        return this.lastHighlighted;
    }
});


module.exports = Member;


/***/ }),

/***/ "ayOX":
/***/ (function(module, exports, __webpack_require__) {

var Avatar = __webpack_require__("lKP6");


var AvatarUploadView = Backbone.View.extend({
    tagName: 'form',
    className: 'avatarUploadForm',
    input: null,
    events: {
        'submit': 'submit',
        'click input[type=file]': 'inputClick',
        'change input': 'inputChange'
    },
    initialize: function (options, input) {
        this.uploading = null;
        
        this.model.bind('avatarUploadPrompt', this.prompt, this);
        this.model.bind('finaliseAvatarFromPromise', this.finaliseAvatarFromPromise, this);
    },
    inputClick: function (e) {
        e.stopPropagation();
    },
    inputChange: function (e) {
        var files = this.file[0].files;
        this.doUpload(files);
    },
    doUpload: function (files) {
        if (this.uploading) {
            this.uploading.cancelUpload();
        }
        if (files && files[0]) {
            var file = files[0];
            if (file.size > 0) {
                var avatar = Avatar.fromFile(file, this.model.session);
                if (!avatar.isAcceptableType()) {
                    this.model.trigger('postError', {message: 'invalid_file_type'});
                } else if (avatar.isTooLarge()) {
                    this.model.trigger('postError', {message: 'file_too_large'});
                } else {
                    this.model.trigger('avatarPreview', this.target, avatar, this.options);
                }
            }
        }
        this.clear();
    },
    prompt: function (target, options) {
        this.options = options || {};
        this.target = target;
        this.file.click();
    },
    submit: function (e) {
        e.preventDefault();
    },
    render: function () {
        var labelId = 'avatarUploadView';
        this.label = $('<label class="g">').text('Upload a file').attr('for', labelId);
        this.file = $('<input class="g" name="file" type="file" accept="image/*" tabindex="-1" aria-hidden="true">').attr('id', labelId);
        $(this.el).append(this.label);
        $(this.el).append(this.file);
        
        return this;
    },
    clear: function () {
        this.file.val('');
    },
    val: function () {
        return this.file.val();
    },
    finaliseAvatarFromPromise: function (avatar, dataUrl) {
        this.uploading = avatar;
        
        // Background upload
        var uploadPromise = avatar.upload().always(_.bind(function () {
            this.uploading = null;
        }, this));
        
        var finalisePromise = new $.Deferred();

        avatar.set(this.options.properties);
        
        this.model.trigger('avatarUpload', avatar, dataUrl, uploadPromise, finalisePromise);
        
        uploadPromise.done(_.bind(function (uploadResponse) {
            avatar.finalise({}, _.bind(function (finaliseResponse) {
                if (finaliseResponse.success) {
                    finalisePromise.resolve();
                } else {
                    finalisePromise.reject(finaliseResponse);
                }
            }, this));
        }, this)).fail(_.bind(function (errorString, errorResponse) {
            if (errorString != 'abort') {
                // Can be missing a response if an error was returned before all data was uploaded
                errorResponse = errorResponse || {message: 'upload_error'};
                finalisePromise.reject(errorResponse);
            } else {
                finalisePromise.reject();
            }
        }, this));
    }
});

module.exports = AvatarUploadView;


/***/ }),

/***/ "b9V4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bN3V":
/***/ (function(module, exports, __webpack_require__) {

var MemberList = __webpack_require__("XZrG");


var MemberOperList = MemberList.extend({
    modeCategory: 'OPER'
});


module.exports = MemberOperList;


/***/ }),

/***/ "bqqG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cgtr":
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__("GmLC");
var re = __webpack_require__("38es");


// Wrapper for shitty jQuery UI plugin
var SelectAutoComplete = Backbone.View.extend({
    initialize: function (options) {
        _.bindAll(this, '_optionMapper', '_source');
        this.options = $.extend({
            className: options.className,
            appendTo: options.appendTo,
            optionMapper: this._optionMapper,
            selectItem: $.noop,
            selectTerm: $.noop,
            footer: $.noop
        }, options);
        this.visible = true;
    },
    setValue: function (value) {
        this.input.val(value);
    },
    render: function () {
        $(this.el).hide();
        var selected = $(this.el).children(":selected");
        var inputName = $(this.el).attr('name');
        $(this.el).removeAttr('name');
        this.input = $('<input class="input">');
        if (this.options.className) {
            this.input.addClass(this.options.className + 'Select');
        }
        this.input.attr('placeholder', this.$('.placeholder').text());
        this.input.attr('name', inputName);
        if (!selected.is('.placeholder')) {
            this.setValue(selected.text());
        }
        $(this.el).after($('<div>').append(this.input));
        
        this._setupAutocomplete();
        
        this.button = $('<span class="dropdown">▼</span>')
            .attr("tabIndex", -1)
            .attr("title", "Show All Items")
            .insertAfter(this.input);
        this._setupRevealButton();
    
        var input = this.input;
        this.autocomplete._resizeMenu = function () {
            this.menu.element.outerWidth(input.outerWidth());
        };
        
        return this;
    },
    focus: function () {
        this.input.focus().select();
    },
    hide: function () {
        this.autocomplete.close();
        this.visible = false;
        this.input.hide();
        this.button.hide();
    },
    show: function () {
        this.visible = true;
        this.input.show();
        this.button.show();
    },
    isVisible: function () {
        return this.visible;
    },
    item: function () {
        return this.autocomplete.selectedItem;
    },
    select: function (item) {
        this.autocomplete.selectedItem = item;
    },
    _setupAutocomplete: function () {
        this.input.autocomplete({
            messages: {
                results: _.noop,
                noResults: _.noop
            },
            delay: 0,
            minLength: 0,
            appendTo: this.options.appendTo,
            source: this._source,
            position: {
                my: 'left top-3'
            },
            open: _.bind(function (event, ui) {
                var menu = this.autocomplete.menu;
                menu.next(event);
            }, this),
            select: _.bind(function (event, ui) {
                this.button.removeClass('focusDropdown');
                if (ui.item.option) {
                    ui.item.option.prop('selected', true);
                }
                this.options.selectItem(event, ui.item);
            }, this),
            change: _.bind(function (event, ui) {
                this.button.removeClass('focusDropdown');
                var val = this.input.val();
                if (val && !this.results(val).length) {
                    $(this.el).children("option").prop('selected', false);
                    this.options.selectTerm(event, val);
                }
            }, this)
        });
        this.autocomplete = this.input.data("ui-autocomplete");
        this.autocomplete.term = this.input.val();
        this.autocomplete._renderItem = function (list, item) {
            var li = $("<li>").data("ui-autocomplete-item", item);
            if (item.className) {
                li.addClass(item.className);
            }
            li.append($("<a>").html(item.label));
            list.append(li);
            return li;
        };
    },
    _setupRevealButton: function () {
        this.input.focus(_.bind(function () {
            this.button.addClass('focusDropdown');
        }, this));
        this.input.blur(_.bind(function () {
            this.button.removeClass('focusDropdown');
        }, this));
        this.button.on('click', _.bind(function () {
            this.input.focus();
            // pass empty string as value to search for, displaying all results
            this.autocomplete.search("");
            this.input.focus();
            return false;
        }, this));
    },
    _optionMapper: function (option, term, matcher) {
        var el = $(option);
        var label = el.text();
        if (label && (!term || label.match(matcher))) {
            return {
                label: util.highlightTerm(label, term),
                value: label
            };
        }
    },
    results: function (term) {
        var matcher = new RegExp(re.escape(term), "i");
        return $(this.el).children("option").map(_.bind(function (i, option) {
            return this.options.optionMapper(option, term, matcher);
        }, this));
    },
    _source: function (request, response) {
        var results = this.results(request.term);
        var footer = this.options.footer(request.term);
        if (footer) {
            results.push(footer);
        }
        response(results);
    }
});


module.exports = SelectAutoComplete;


/***/ }),

/***/ "cmaB":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var ContextMenuView = __webpack_require__("hI2d");


var BufferContextMenuView = ContextMenuView.extend({
    initialize: function (options) {
        this.actions = this.$('.actions');
        this.buffer = null;
        this.button = null;
        
        _.bindAll(this, 'deactivateButton');
        
        this.afterHide = this.doAfterHide;
        ContextMenuView.prototype.initialize.call(this, options);
    },
    events: $.extend({}, ContextMenuView.prototype.events, {
        'buttonClick button.ignores': 'clickIgnores',
        'buttonClick button.unread': 'clickUnread',
        'buttonClick button.readOnSelect': 'clickReadOnSelect',
        'buttonClick button.muteNotifications': 'clickMuteNotifications',
        'buttonClick button.export': 'clickExport',
        'buttonClick button.clear': 'clickClear',
        'buttonClick button.formatColor': 'clickFormatColor'
    }),
    clickIgnores: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.ignore();
        this.clearContext();
    },
    clickUnread: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setTrackingUnreadPref(!this.buffer.isTrackingUnread());
        this.clearContext();
    },
    clickReadOnSelect: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setMarkAsReadOnSelectPref(!this.buffer.shouldMarkAsReadOnSelect());
        this.clearContext();
    },
    clickMuteNotifications: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setMuteNotificationsPref(!this.buffer.shouldMuteNotifications());
        this.clearContext();
    },
    clickExport: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.session.trigger('exportConfirm', this.buffer);
        this.clearContext();
    },
    clickClear: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('clear');
        this.clearContext();
    },
    clickFormatColor: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setFormatColorPref(!this.buffer.formatColor());
        this.clearContext();
    },
    doAfterHide: function () {
        this.deactivateButton();
    },
    deactivateButton: function () {
        if (this.button) {
            this.button.removeClass('active').attr('aria-expanded', 'false');
        }
    },
    clearContext: function () {
        this.buffer = null;
        this.formatter = null;
        
        this.actions.hide();
        this.$el.removeClass('active');
    },
    onShow: function () {
        // Override in subclasses
    },
    show: function (buffer, button, options) {
        this.clearContext();
        
        this.buffer = buffer;
        this.formatter = new BufferFormatter(this.buffer);
        this.button = button;
        
        this.button.addClass('active').attr('aria-expanded', 'true');
        
        var offset = this.button.offset();
        var x = offset.left + this.button.outerWidth();
        var y = offset.top  + this.button.outerHeight();
                
        // Prefs
        this.enableItem(this.$('li.trackUnread'), this.buffer.isTrackingUnread());
        this.enableItem(this.$('li.markAsReadOnSelect'), this.buffer.shouldMarkAsReadOnSelect());

        this.enableItem(this.$('li.muteNotifications'), this.buffer.shouldMuteNotifications());

        this.enableItem(this.$('li.formatColor'), this.buffer.formatColor());
        
        this.onShow();
        this.actions.show();
        
        ContextMenuView.prototype.show.call(this, x, y, options);
    }
});


module.exports = BufferContextMenuView;


/***/ }),

/***/ "d1Sw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dFhQ":
/***/ (function(module, exports, __webpack_require__) {

var MemberList = __webpack_require__("XZrG");


var MemberOwnerList = MemberList.extend({
    modeCategory: 'OWNER'
});


module.exports = MemberOwnerList;


/***/ }),

/***/ "eIfS":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");

var scriptjs = __webpack_require__("zhAq");
var util = __webpack_require__("GmLC");
var StripeCardDialogView = __webpack_require__("Y/gw").default;

var stripeDialog = new StripeCardDialogView();

var PayViewMixins = {
    // clickPayButton (fun clickEvent)
    // billingCancelSureText (str)
    // formatPlan (fun billingInfo)
    // formatSubscriptionInvoiceItem (fun subscription)
    initialize: function (options) {
        this.model.bind('billingUpdate', this.renderBillingDetails, this);
        this.model.bind('billingUpdate', this.renderPay, this);
        this.model.bind('billingInfoError', this.renderBillingInfoError, this);
        this.seenTokens = {};
    },
    events: {
        'buttonClick .payButton': 'clickPayButton',
        'click .payButton': 'clickPayButton'
    },
    loadStripeOld: function () {
        if (PayViewMixins._loadStripeCalled) {
            return;
        }
        PayViewMixins._loadStripeCalled = true;
        scriptjs([
            "https://js.stripe.com/v2/",
            "https://checkout.stripe.com/checkout.js"
        ], _.bind(function () {
            if (window.StripeCheckout) {
                PayViewMixins.StripeCheckout = window.StripeCheckout.configure(
                    window.IRCConfig.StripeCheckoutOptions
                );
                scriptjs.done('stripe');
            } else {
                this.renderStripeError();
            }
        }, this));
    },
    hidePayError: function () {
        this.$('.payError').hide();
    },
    getCountryEvidenceLabel: function (key) {
        switch (key) {
        case 'ip':
            return 'IP address';
        case 'billing':
            return 'Billing address';
        case 'origin':
            return 'Billing origin';
        case 'vat':
            return 'VAT country';
        case 'self_certified':
            return 'Confirmation';
        }
    },
    formatCountryEvidence: function (country_evidence) {
        var seen = {};
        var confirm_countries = [];
        _.each(country_evidence, function (code, key) {
            if (code) {
                var keyMatch = key.match(/(.*)_code$/);
                if (keyMatch && !(code in seen)) {
                    seen[code] = true;
                    var type = keyMatch[1];
                    var name = country_evidence[type + '_name'];
                    var label = this.getCountryEvidenceLabel(type);
                    confirm_countries.push({
                        type: type,
                        label: label,
                        name: name,
                        code: code,
                    });
                }
            }
        }, this);

        var choices = $('<div class="upgradePayment__confirm-countries">');
        _.each(confirm_countries, function (country) {
            var choice = $('<div class="upgradePayment__payment upgradePayment__confirm-country">');
            var choiceButton = $('<button type="button">')
                .addClass('upgradeSchedules__button')
                .addClass('upgradeSchedules__button--action')
                .addClass('upgradePayment__button')
                .addClass('upgradePayment__button--action')
                .addClass('upgradePayment__confirm-country-button')
                .attr('data-country', country.code)
                .text(country.name);
            var choiceFlag = $('<img width="32" height="32" class="flag">').attr('src', '/static/flags/flags-iso/flat/64/' + country.code + '.png');
            var choiceLabel = $('<span>').text(' ' + country.label);
            choice.append(choiceButton).append(choiceFlag).append(choiceLabel);
            choices.append(choice);
        });

        return $('<div>')
            .append($('<p>').text("We need to confirm your country of residence to comply with European Union VAT regulations"))
            .append(choices);
    },
        
    formatStripeError: function (response) {
        var html;
        switch (response.message) {
        case 'card_error':
        case 'invalid_request':
            html = this.formatter.escapeText(response.data.message);
            break;
        case 'country_mismatch':
            html = this.formatCountryEvidence(response.country_evidence)[0].outerHTML;
            break;
        case 'request_error':
            html = 'Temporary subscription error, please wait, and contact <a href="mailto:team@irccloud.com">team@irccloud.com</a> if this problem doesn’t resolve itself.';
            break;
        default:
            html = 'Subscription failed, try again later';
        }
        return html;
    },
    showStripePayError: function (response) {
        this.$('.payStatus').hide();
        var html = this.formatStripeError(response);
        this.$('.pay').show();
        this.$('.pay .payError').html(html).fadeIn('fast');
    },
    stripeCheckoutOld: function (label, callback, options) {
        this.hidePayError();
        scriptjs.ready('stripe', _.bind(function () {
            PayViewMixins.StripeCheckout.open($.extend(true, {}, options, {
                panelLabel: label,
                closed: callback,
                token: _.bind(function (stripeResponse) {
                    debug.log('<- [STRIPE]', stripeResponse);
                    var token = stripeResponse.id;
                    if (this.seenTokens[token]) {
                        debug.warn('Seen stripe token again: ' + token);
                        debug.trace();
                        return;
                    }
                    this.seenTokens[token] = true;
                    var data = {
                        stripe_token: token,
                        stripe_token_type: stripeResponse.type
                    };
                    this.$('.pay').show();
                    this.$('.pay .payStatus').show();

                    callback(data, _.bind(function (response) {
                        this.afterPay(response);
                    }, this));
                }, this)
            }));
        }, this));
    },
    isStripeCheckoutShown: function () {
        return stripeDialog.isVisible();
    },
    stripeCheckout: function (label, callback, values) {
        this.hidePayError();
        stripeDialog.show({
            model: this.model,
            parent: this,
            label: label,
            callback: callback,
            values: values
        });
    },
    afterPay: function (response) {
        if (response.success) {
            this.$('.payStatus').hide();
            this.$('.payTrialEnds').hide();
            if (this.model.get('billing')) {
                var te = this.model.get('billing').trial_end;
                if (te) {
                    this.$('.payTrialEnds').show();
                    this.$('.payTrialEndDate').text(this.formatter.date(te));
                }
            }
            if (response.invoice) {
                this.$('.payInvoiceAmount').text(this.formatter.amount(response.invoice.currency, response.invoice.total));
            }
            this.$('.payInvoice').toggle(!!response.invoice);
            this.$('.payComplete').show();
        } else {
            this.showStripePayError(response);
        }
    },
    renderPayActiveSub: function () {

    },
    renderPayNoActiveSub: function () {
        this.$('p.payReinstate').toggle(this.model.isSubscriptionCanceled());
        this.$('p.payUpdate').toggle(this.model.isStripeSubscriptionUnpaid());

        this.$('.pay').show();
    },
    renderPayCanSeeSubscription: function () {
        this.$('.payPastDue').toggle(this.model.isStripeSubscriptionPastDue());
        if (this.model.hasActiveSubscription()) {
            this.hidePayError();
            this.renderPayActiveSub();
        } else {
            this.renderPayNoActiveSub();
        }
    },
    removeBillingInfoError: function () {
        this.$('.billingInfoError').remove();
    },
    renderBillingInfoError: function (response, failInfo) {
        this.removeBillingInfoError();
        var tpl = !failInfo.gave_up ?
            'tpl-billing-info-error-retry': 'tpl-billing-info-error';
        var billingInfoError = $($('#' + tpl).html());
        var failInfoSpan = billingInfoError.find('.failInfo');
        if (failInfo.failCount > 1) {
            failInfoSpan.text(' (' + failInfo.failCount + ' attempts)');
        }
        var close = this.$('.mainClose');
        if (close.length) {
            close.after(billingInfoError);
        } else {
            this.$el.prepend(billingInfoError);
        }
        billingInfoError.show();
    },
    renderStripeError: function () {
        var stripeError = $($('#tpl-billing-stripe-error').html());
        var close = this.$('.mainClose');
        if (close.length) {
            close.after(stripeError);
        } else {
            this.$el.prepend(stripeError);
        }
        stripeError.show();
    },
    renderPay: function () {
        this.$('.pay').hide();
        if (this.model.canSeeSubscription()) {
            this.renderPayCanSeeSubscription();
        }
    },
    getSubscriptionStatus: function () {
        var subStatus = $($('#tpl-billing-sub-status').html());
        return $('<div>').append(subStatus).html();
    },
    getNewPayButtons: function () {
        var tpl;
        if (!this.model.hasActiveSubscription()) {
            tpl = 'billing-pay-new';
        }
        if (tpl) {
            var payButtons = $($('#tpl-' + tpl).html());
            return $('<div>').append(payButtons).html();
        }
    },
    formatStripeSubscriptionBilling: function (sub) {
        var billing = $('<span>');
        if (sub.type) {
            if (sub.country) {
                billing.append($('<img height="16" width="16">').attr({
                    'src': '/static/flags/flags-iso/flat/32/' + sub.country + '.png',
                    'alt': sub.country,
                    'title': sub.country
                }));
                billing.append(' ');
            }
            if (sub.name) {
                billing.append($('<span>').text(sub.name));
                billing.append(' ');
            }
            if (sub.last4) {
                billing.append($('<span>').text('•••• •••• •••• •••• ' + sub.last4));
                billing.append(' ');
            }
            if (sub.exp_month || sub.exp_year) {
                billing.append('Expires: ');
            }
            if (sub.exp_month) {
                billing.append($('<span>').text(sub.exp_month));
                billing.append(' ');
                if (sub.exp_year) {
                    billing.append('/ ');
                }
            }
            if (sub.exp_year) {
                billing.append($('<span>').text(sub.exp_year));
                billing.append(' ');
            }
            // address_city
            // address_country
            // address_line1
            // address_line1_check
            // address_line2
            // address_state
            // address_zip
            // address_zip_check
        } else if (sub.source && sub.source.object == 'bitcoin_receiver') {
            var btcAmount = this.formatter.amount('BTC', sub.source.bitcoin_amount_received);
            billing.append(btcAmount);
            billing.append(' ');
            billing.append(this.formatter.escapeText(sub.source.inbound_address));
            billing.append(' ');
        }
        return billing;
    },
    formatStripeSubscriptionTypeImg: function (sub) {
        var img = $('<img height="16">');
        if (sub.type) {
            img.attr({
                'src': '/static/cards/' + util.slugify(sub.type) + '-curved-32px.png',
                'title': sub.type,
                'alt': sub.type
            });
        } else if (sub.source && sub.source.object == 'bitcoin_receiver') {
            img.attr({
                'src': '/static/btc-icon.png',
                'title': 'Bitcoin',
                'alt': 'Bitcoin'
            });
        }
        return img;
    },
    renderStripeUpdateButton: function (customerId) {
        var updateButton = $('<button type="button">').append($('<span>').text('Update'));
        updateButton.on('buttonClick', _.bind(function (e) {
            e.preventDefault();
            this.stripeCheckout(
                'Update card details',
                _.bind(function (data, callback) {
                    if (data) {
                        data.customer_id = customerId;
                        this.model.updateCustomer(data, callback);
                    }
                }, this),
                {
                    description: 'Update card details'
                }
            );
        }, this));
        return updateButton;
    },
    renderStripeRestoreButton: function (customerId) {
        var restoreButton = $('<button class="action">').append($('<span>').text('Restore'));
        restoreButton.on('buttonClick', _.bind(function (e) {
            e.preventDefault();
            this.hidePayError();
            this.$('.pay .payStatus').show();
            this.model.reinstateSubscription({
                customer_id: customerId
            }, _.bind(function (response) {
                this.afterPay(response);
            }, this));
        }, this));
        return restoreButton;
    },
    renderCancelForm: function (condition, className, action, data) {
        if (condition) {
            var cancelForm = $($('#tpl-billing-cancel-confirm').html());
            var form = cancelForm.find('form.billingCancelForm');
            var buttons = form.find('.billingCancelButtons');
            var status = form.find('.billingCancelStatus');
            var error = form.find('.billingCancelError');
            form.addClass(className);
            form.submit(function (e) {
                e.preventDefault();
                status.show();
                buttons.hide();
                action(data, function (response) {
                    if (!response.success) {
                        status.hide();
                        buttons.show();
                        error.text('There was a problem canceling your subscription: ' + response.message).fadeIn('fast');
                    }
                });
            });
            buttons.find('.cancel').click(function (e) {
                e.preventDefault();
                error.hide();
                cancelForm.hide();
            });
            var cancelButton = $('<button class="delete">').append($('<span>').text('Cancel')).on('buttonClick', function (e) {
                e.preventDefault();
                cancelForm.fadeIn('fast');
            });
            return [cancelForm, cancelButton];
        }
    },
    formatStripeSubscriptionItem: function (sub, ii) {
        var row = $('<tr class="subscription">');
        if (
            !sub.active ||
            _.include(['unpaid', 'canceled', 'incomplete', 'incomplete_expired'], sub.subscription) ||
            (sub.subscription == 'trialing' && sub.cancel_at_period_end)
        ) {
            row.addClass('inactive');
        }

        // 1 date
        row.append($('<td class="dateCell">').text(this.formatter.date(sub.created)));

        // 2 description
        var description = this.formatPlan(sub);
        row.append($('<td class="descriptionCell">').append(description));

        // 3 status
        var status = '';
        switch (sub.subscription) {
        case 'trialing':
            if (sub.cancel_at_period_end) {
                status += 'Cancelled';
            } else if (!sub.ended_at) {
                status += 'Active — starting on ' + this.formatter.date(sub.trial_end);
            }
            break;
        case 'past_due':
            status += 'Active - last payment failed (check your card details)';
            break;
        case 'unpaid':
            status += 'Disabled (check your card details)';
            break;
        case 'incomplete':
            status += 'Incomplete (update card details)';
            break;
        case 'canceled':
        case 'incomplete_expired':
            status += 'Expired on ' + this.formatter.date(sub.ended_at) + ' (cancelled on ' + this.formatter.date(sub.canceled_at) + ')';
            break;
        case 'active':
            if (sub.cancel_at_period_end) {
                status += 'Cancelled — expiring on ' + this.formatter.date(sub.current_period_end);
            } else if (!sub.ended_at) {
                status += 'Active — next invoice on ' + this.formatter.date(sub.current_period_end);
            }
            break;
        }
        var statusCell = $('<td class="statusCell">').append(status + ' ');
        row.append(statusCell);

        // 4 type
        var img = $('<td class="typeCell">');
        img.append(this.formatStripeSubscriptionTypeImg(sub));
        row.append(img);
        
        // 5 extra
        var extra = $('<td class="detailCell">');
        extra.append(this.formatStripeSubscriptionBilling(sub));
        var active = sub.active && _.include(
            ['active', 'trialing', 'past_due'],
            sub.subscription
        );
        if (active && sub.cancel_at_period_end) {
            extra.append(this.renderStripeRestoreButton(sub.customer_id));
            extra.append(' ');
        }
        if (!sub.ended_at && !sub.cancel_at_period_end) {
            extra.append(this.renderStripeUpdateButton(sub.customer_id));
            extra.append(' ');
        }
        row.append(extra);
        
        var cancelFormParts = this.renderCancelForm(
            (!sub.ended_at && !sub.cancel_at_period_end),
            'billingCancelStripeForm',
            _.bind(this.model.cancelStripeSubscription, this.model),
            {customer_id: sub.customer_id}
        );
        
        var billingExtras;
        if (!sub.ended_at && !sub.cancel_at_period_end && ((ii && ii.length) || sub.account_balance)) {
            billingExtras = $('<div class="invoiceItemsWrap">');
            statusCell.append($('<a href="">').text('details').click(function (e) {
                e.preventDefault();
                billingExtras.slideToggle('fast');
            }));
            
            var invoiceItems = $('<table class="invoiceItems">');
            var total = 0;

            var planAmount = sub.amount * sub.quantity;
            total += planAmount;
            var planRow = $('<tr>');
            planRow.append('<td>Subscription</td>');
            planRow.append($('<td>'));
            planRow.append($('<td class="amountCell">').text(this.formatter.amount(sub.currency, planAmount)));
            invoiceItems.append(planRow);

            _.each(ii, function (item) {
                total += item.amount;
                var itemRow = $('<tr>');
                itemRow.append($('<td>').text(item.description));
                itemRow.append($('<td>').text(this.formatter.amountSign(item.amount)));
                itemRow.append($('<td class="amountCell">').text(this.formatter.amount(item.currency, Math.abs(item.amount))));
                itemRow.append($('<td>').text(this.formatter.date(item.date)));
                invoiceItems.append(itemRow);
            }, this);
            if (sub.account_balance) {
                total += sub.account_balance;
                var balRow = $('<tr>');
                var bal = sub.account_balance;
                var rem = '';
                if (sub.account_balance < 0) {
                    if (total < 0) {
                        rem = total * -1;
                        bal = bal - total;
                        total = 0;
                    }
                    bal = bal * -1;
                    balRow.append('<td>Credit</td>');
                    balRow.append($('<td>'));
                } else {
                    balRow.append('<td>Unpaid charges</td>');
                    balRow.append($('<td>').text('-'));
                }
                if (rem) {
                    rem = ' (' + this.formatter.amount(sub.currency, rem) + ' remains)';
                }
                balRow.append($('<td class="amountCell">').text(this.formatter.amount(sub.currency, bal) + rem));
                invoiceItems.append(balRow);
            }
            var totalRow = $('<tr>');
            totalRow.append('<th class="total">Total</th>');
            totalRow.append($('<td>').text(this.formatter.amountSign(total)));
            totalRow.append($('<td class="amountCell">').text(this.formatter.amount(sub.currency, Math.abs(total))));
            invoiceItems.append(totalRow);
            billingExtras.append(invoiceItems);
        }
        if (cancelFormParts || billingExtras) {
            var secondRow = $('<tr>');
            var secondRowCell = $('<td colspan="5" class="extraRow">');
            if (cancelFormParts) {
                extra.append(cancelFormParts[1]);
                extra.append(' ');
                secondRowCell.append(cancelFormParts[0]);
            }
            if (billingExtras) {
                secondRowCell.append(billingExtras);
            }
            secondRow.append(secondRowCell);
            return [row, secondRow];
        } else {
            return row;
        }
    },
    formatPayPalSubscriptionItem: function (sub) {
        var row = $('<tr class="subscription">');
        if (sub.subscription == 'expired') {
            row.addClass('inactive');
        }

        // 1 date
        row.append($('<td class="dateCell">').text(this.formatter.date(sub.startdate)));

        // 2 description
        var description = this.formatPlan(sub);
        row.append($('<td class="descriptionCell">').append(description));

        // 3 status
        var status = '';
        switch (sub.subscription) {
        case 'expired':
            status += 'Expired on ' + this.formatter.date(sub.enddate);
            if (sub.cancelled_at) {
                status += ' (cancelled on ' + this.formatter.date(sub.cancelled_at) + ')';
            }
            break;
        case 'cancelled':
            status += 'Cancelled — expiring ';
            if (sub.expiring) {
                status += 'on ' + this.formatter.date(sub.expiring);
            } else {
                status += 'at the end of the cycle';
            }
            break;
        case 'active':
            status += 'Active';
            if (sub.next_billing_date) {
                status += ' — next invoice on ' + this.formatter.date(sub.next_billing_date);
            }
            break;
        }
        row.append($('<td class="statusCell">').append(status));

        // 4 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/paypal-curved-32px.png" height="16" title="PayPal" alt="PayPal">'));

        // 5 extra
        var extra = $('<td class="detailCell">');
        row.append(extra);
        
        var cancelFormParts = this.renderCancelForm(
            (sub.subscription == 'active'),
            'billingCancelPaypalForm',
            _.bind(this.model.cancelPaypalSubscription, this.model),
            {subscr_id: sub.subscr_id}
        );
        if (cancelFormParts) {
            var secondRow = $('<tr>');
            var secondRowCell = $('<td colspan="5" class="extraRow">');
            
            extra.append(cancelFormParts[1]);
            extra.append(' ');
            secondRowCell.append(cancelFormParts[0]);
            
            secondRow.append(secondRowCell);
            return [row, secondRow];
        } else {
            return row;
        }
    },
    formatAndroidSubscriptionItem: function (sub) {
        var row = $('<tr class="subscription">');
        if (sub.subscription != 'active' && sub.subscription != 'grace_period') {
            row.addClass('inactive');
        }

        // 1 date
        row.append($('<td class="dateCell">').text(this.formatter.date(sub.start_date)));

        // 2 description
        var description = this.formatPlan(sub);
        row.append($('<td class="descriptionCell">').append(description));

        // 3 status
        var status = '';
        switch (sub.subscription) {
        case 'cancelled':
            status += 'Cancelled';
            if (sub.cancelled_at) {
                status += ' on ' + this.formatter.date(sub.cancelled_at);
            }
            break;
        case 'grace_period':
            status += 'Grace period';
            if (sub.next_payment_date) {
                status += ' — next charge on ' + this.formatter.date(sub.next_payment_date);
            }
            break;
        case 'on_hold':
            status += 'On Hold';
            break;
        case 'paused':
            status += 'Paused';
            if (sub.resuming_at) {
                status += ' — resuming on ' + this.formatter.date(sub.resuming_at);
            }
            break;
        case 'active':
            if (sub.cancelled) {
                status += 'Cancelled — expiring on ' + this.formatter.date(sub.end_date);
            } else {
                status += 'Active';
                if (sub.next_payment_date) {
                    status += ' — next charge on ' + this.formatter.date(sub.next_payment_date);
                }
            }
            break;
        }
        row.append($('<td class="statusCell">').append(status));

        // 4 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/google-play-32px.png" height="16" title="Google Play" alt="Google Play">'));

        // 5 extra
        var extra = $('<td class="detailCell">');
        extra.append('<a href="https://play.google.com/store/account/orderhistory" target="_blank">Order history</a>');
        if (sub.active) {
            extra.append(' • <a href="https://play.google.com/store/account/subscriptions?sku=' + sub.plan + '&package=' + sub.package + '" target="_blank">Manage</a>');
        }
        if (sub.last_order_id) {
            extra.append(' — ');
            extra.append($('<span>').text(sub.last_order_id));
        }
        row.append(extra);
        
        return row;
    },
    formatOneOffSubscriptionItem: function (sub, charge) {
        var row = $('<tr class="subscription">');
        if (!sub.active) {
            row.addClass('inactive');
        }

        // 1 date
        row.append($('<td class="dateCell">').text(this.formatter.date(sub.start_date)));

        // 2 description
        var description = this.formatOneOffPlan(sub, charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 3 status
        var status = '';
        if (sub.active) {
            status += 'Active — expiring on';
        } else {
            status += 'Expired on';
        }
        status += ' ' + this.formatter.date(sub.end_date);
        row.append($('<td class="statusCell">').append(status));

        // 4 type
        // 5 extra
        var extra = $('<td class="detailCell">');
        var img = $('<td class="typeCell">');
        if (sub.paypal_txn_id) {
            img.append('<img src="/static/cards/paypal-curved-32px.png" height="16" title="PayPal" alt="PayPal">');
        } else if (sub.android_id) {
            img.append('<img src="/static/cards/google-play-32px.png" height="16" title="Google Play" alt="Google Play">');
        } else if (charge) {
            extra.append(this.formatStripeSubscriptionBilling(charge));
            img.append(this.formatStripeSubscriptionTypeImg(charge));
        }
        
        row.append(img);
        row.append(extra);
        if (sub.android_id) {
            extra.append('<a href="https://play.google.com/store/account/orderhistory" target="_blank">Order history</a>');
            if (charge) {
                extra.append(' — ');
                extra.append($('<span>').text(charge.order_id));
            }
        }

        return row;
    },
    formatStripeChargeDescription: function (charge) {
        var description;
        if (charge.metadata && charge.metadata.oneoff && charge.metadata.interval && charge.metadata.interval_count) {
            var endDate = new Date(charge.created*1000);
            var addConfig = {};
            addConfig[charge.metadata.interval + 's'] = charge.metadata.interval_count;
            endDate.add(addConfig);
            description = 'One off subscription for ' + this.formatter.date(charge.created) + ' — ' + this.formatter.date(endDate.getTime()/1000);
        } else {
            description = this.formatter.escapeText(charge.description);
        }
        if (!charge.paid) {
            description += ' — <span class="failed"><strong>Failed:</strong> ' + this.formatter.escapeText(charge.failure_message) + '</span>';
        }
        return description;
    },
    formatStripeInvoice: function (invoice, charge) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append($('<td class="dateCell">').append('<a href="' + this.model.getInvoiceUrl(invoice.id) + '" target="_blank">' + this.formatter.date(invoice.date) + '</a>'));

        // 2 type
        var img = $('<td class="typeCell">');
        if (charge && charge.type) {
            img.append($('<img height="16">').attr({
                'src': '/static/cards/' + util.slugify(charge.type) + '-curved-32px.png',
                'title': charge.type,
                'alt': charge.type
            }));
        }
        row.append(img);

        // 3 amount
        var amount = this.formatter.amount(invoice.currency, invoice.total);
        if (invoice.starting_balance) {
            amount += ' ( ';
            if (invoice.starting_balance > 0) {
                amount += '+ ' + this.formatter.amount(invoice.currency, invoice.starting_balance) + ' unpaid charges';
            } else {
                amount += '− ' + this.formatter.amount(invoice.currency, invoice.starting_balance * -1) + ' credit';
            }
            amount += ' )';
        }
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = '';
        var sub = _.find(invoice.lines.data, function (line) {
            return line.type == 'subscription';
        });
        if (sub) {
            description += this.formatSubscriptionInvoiceItem(sub);
        } else if (invoice.lines.data.length === 1) {
            description += this.formatter.escapeText(invoice.lines.data[0].description);
        } else if (invoice.lines.data.length > 1) {
            description += invoice.lines.data.length + ' line items';
        }
        if (!invoice.paid) {
            description += ' — ';
            if (invoice.closed) {
                description += 'Closed';
            } else if (invoice.attempted) {
                if (charge && charge.failure_code == 'authentication_required') {
                    description += '<span class="failed">Authentication needed</span> ';
                    description += '<button type="button"><a href="' + this.model.getHostedInvoiceUrl(invoice.id) + '" target="_blank">';
                    description += 'Confirm payment';
                    description += '</a></button> ';
                } else {
                    description += '<span class="failed"><strong>Failed:</strong> ';
                    if (charge) {
                        description += this.formatter.escapeText(charge.failure_message) + ' — ';
                    }
                    if (invoice.next_payment_attempt > 0) {
                        description += 'Retrying on ' + this.formatter.date(invoice.next_payment_attempt);
                    } else {
                        description += 'Gave up retrying';
                    }
                    description += '</span>';
                }
            } else {
                if (invoice.amount_due) {
                    if (invoice.next_payment_attempt > 0) {
                        description += 'Due on ' + this.formatter.date(invoice.next_payment_attempt);
                    } else {
                        description += 'Pending';
                    }
                } else {
                    description += 'No charge';
                }
            }
        }
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell">');
        if (invoice.paid) {
            status.addClass('paid');
            status.append('paid');
        } else if (invoice.closed) {
            status.append('closed');
        } else if (invoice.attempted) {
            status.append('<span style="color: red;">unpaid</span>');
        } else {
            status.append('unattempted');
        }
        
        var refund = '';
        if (charge && charge.amount_refunded) {
            if (charge.refunded) {
                refund += 'fully';
            } else {
                refund += this.formatter.amount(charge.currency, charge.amount_refunded);
            }
            refund += ' refunded';
        }
        if (refund) {
            status.append(' — ' + refund);
        }
        row.append(status);

        return row;
    },
    formatStripeCharge: function (charge) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append($('<td class="dateCell">').append('<a href="' + this.model.getReceiptUrl(charge.id) + '" target="_blank">' + this.formatter.date(charge.created) + '</a>'));

        // 2 type
        var img = $('<td class="typeCell">');
        if (charge.type) {
            img.append($('<img height="16">').attr({
                'src': '/static/cards/' + util.slugify(charge.type) + '-curved-32px.png',
                'title': charge.type,
                'alt': charge.type
            }));
        } else if (charge.source && charge.source.object == 'bitcoin_receiver') {
            img.append('<img src="/static/btc-icon.png" height="16" title="Bitcoin" alt="Bitcoin">');
        }
        row.append(img);

        // 3 amount
        var amount = '';
        if (charge.source && charge.source.object == 'bitcoin_receiver') {
            var btcAmount = this.formatter.amount('BTC', charge.source.bitcoin_amount_received);
            amount += btcAmount + ' / ';
        }
        amount += this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatStripeChargeDescription(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell paid">').append('paid');
        var refund = '';
        if (charge.amount_refunded) {
            if (charge.refunded) {
                refund += 'fully';
            } else {
                refund += this.formatter.amount(charge.currency, charge.amount_refunded);
            }
            refund += ' refunded';
        }
        if (refund) {
            status.append(' — ' + refund);
        }
        row.append(status);
        
        return row;
    },
    formatPayPalCharge: function (charge, refunds) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append($('<td class="dateCell">').append('<a href="' + this.model.getPayPalReceiptUrl(charge.id) + '" target="_blank">' + this.formatter.date(charge.created) + '</a>'));

        // 2 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/paypal-curved-32px.png" height="16" title="PayPal" alt="PayPal">'));

        // 3 amount
        var amount = this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatSubscriptionInvoiceItem(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell paid">').append('paid');
        var refund = '';
        if (refunds) {
            var amountRefunded = _.reduce(refunds, function (acc, r) {
                return acc + r.amount;
            }, 0);
            if ((charge.amount + amountRefunded) === 0) {
                refund += 'fully';
            } else {
                refund += this.formatter.amount(charge.currency, -amountRefunded);
            }
            refund += ' refunded';
        }
        if (refund) {
            status.append(' — ' + refund);
        }
        row.append(status);

        return row;
    },
    formatPayPalOneOffCharge: function (charge, refunds) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append($('<td class="dateCell">').append('<a href="' + this.model.getPayPalReceiptUrl(charge.id) + '" target="_blank">' + this.formatter.date(charge.start_date) + '</a>'));

        // 2 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/paypal-curved-32px.png" height="16" title="PayPal" alt="PayPal">'));

        // 3 amount
        var amount = this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatOneOffSubscriptionInvoiceItem(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell paid">').append('paid');
        var refund = '';
        if (refunds) {
            var amountRefunded = _.reduce(refunds, function (acc, r) {
                return acc + r.amount;
            }, 0);
            if ((charge.amount + amountRefunded) === 0) {
                refund += 'fully';
            } else {
                refund += this.formatter.amount(charge.currency, -amountRefunded);
            }
            refund += ' refunded';
        }
        if (refund) {
            status.append(' — ' + refund);
        }
        row.append(status);

        return row;
    },
    formatAndroidCharge: function (charge) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append(
            $('<td class="dateCell">')
                .append('<a href="https://play.google.com/store/account/orderhistory" target="_blank">' + this.formatter.date(charge.created) + '</a>')
                .append(' — ')
                .append($('<span>').text(charge.order_id))
        );

        // 2 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/google-play-32px.png" height="16" title="PayPal" alt="PayPal">'));

        // 3 amount
        var amount = this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatSubscriptionInvoiceItem(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell">');
        if (charge.paid) {
            status.addClass('paid');
            status.append('paid');
        } else {
            status.append('unpaid or refunded');
        }
        row.append(status);

        return row;
    },
    formatAndroidOneOffCharge: function (charge) {
        var row = $('<tr class="charge">');

        // 1 date
        row.append(
            $('<td class="dateCell">')
                .append('<a href="https://play.google.com/store/account/orderhistory" target="_blank">' + this.formatter.date(charge.start_date) + '</a>')
                .append(' — ')
                .append($('<span>').text(charge.order_id))
        );

        // 2 type
        row.append($('<td class="typeCell">').append('<img src="/static/cards/google-play-32px.png" height="16" title="Google Play" alt="Google Play">'));

        // 3 amount
        var amount = this.formatter.amount(charge.currency, charge.amount);
        row.append($('<td class="amountCell">').append(amount));

        // 4 description
        var description = this.formatOneOffSubscriptionInvoiceItem(charge);
        row.append($('<td class="descriptionCell">').append(description));

        // 5 status
        var status = $('<td class="statusCell">');
        if (charge.paid) {
            status.addClass('paid');
            status.append('paid');
        } else {
            status.append('unpaid or refunded');
        }
        row.append(status);

        return row;
    },

    getOneOffCharge: function (oo, oneOffChargeLookup) {
        return oneOffChargeLookup.paypal[oo.paypal_txn_id] || oneOffChargeLookup.stripe[oo.stripe_charge_id] || oneOffChargeLookup.android[oo.android_id];
    },
    formatBillingDetails: function () {
        var contents = $('<div>');

        var c = this.model.get('charges');
        var inv = this.model.get('invoices');
        var ii = this.model.get('invoice_items');
        var ppc = this.model.get('paypal_charges');
        var ppoc = this.model.get('paypal_oneoff_charges');
        var ac = this.model.get('android_charges');
        var aoc = this.model.get('android_oneoff_charges');
        
        var subs = this.model.get('subscriptions');
        
        if (subs || inv || c || ppc) {
            var formats = [];
            
            formats.push({
                footer: this.getSubscriptionStatus()
            });
            
            // Subscriptions
            
            var subscriptions = [];
            var allSubscriptions = [];
            var subscriptionLookup = {};
            if (subs) {
                _.each(subs.stripe, function (sub) {
                    subscriptionLookup[sub.customer_id] = sub;
                    allSubscriptions.push({
                        type: 'stripe',
                        start: sub.created,
                        data: sub
                    });
                });
                _.each(subs.paypal, function (sub) {
                    allSubscriptions.push({
                        type: 'paypal',
                        start: sub.startdate,
                        data: sub
                    });
                });
                _.each(subs.android, function (sub) {
                    allSubscriptions.push({
                        type: 'android',
                        start: sub.start_date,
                        data: sub
                    });
                });
                _.each(subs.oneoff, function (sub) {
                    allSubscriptions.push({
                        type: 'oneoff',
                        start: sub.start_date,
                        data: sub
                    });
                });
            }
            
            // Charges

            var charges = [];
            var allCharges = [];
            var payPalRefunds = {};
            var invoiceCharges = {};
            var oneOffChargeLookup = {
                paypal: {},
                stripe: {},
                android: {}
            };
            if (inv) {
                _.each(inv, function (invoice) {
                    // Filter out initial and pending invoices for past due subscriptions
                    // as well as incomplete subscriptions
                    var invSub = subscriptionLookup[invoice.customer_id];
                    if (
                        invoice.total > 0 &&
                        (
                            invoice.paid ||
                            invoice.attempted ||
                            !invoice.amount_due ||
                            invoice.next_payment_attempt > 0
                        )
                    ) {
                        allCharges.push({
                            type: 'stripe_invoice',
                            date: invoice.date,
                            data: invoice
                        });
                    }
                });
            }
            if (c) {
                _.each(c, function (charge) {
                    if (charge.metadata && charge.metadata.oneoff) {
                        oneOffChargeLookup.stripe[charge.id] = charge;
                    }
                    if (charge.invoice) {
                        invoiceCharges[charge.invoice] = charge;
                    } else {
                        allCharges.push({
                            type: 'stripe_charge',
                            date: charge.created,
                            data: charge
                        });
                    }
                });
            }
            if (ppc) {
                _.each(ppc, function (charge) {
                    if (charge.refund) {
                        if (!payPalRefunds[charge.refund]) {
                            payPalRefunds[charge.refund] = [];
                        }
                        payPalRefunds[charge.refund].push(charge);
                    } else {
                        allCharges.push({
                            type: 'paypal_charge',
                            date: charge.created,
                            data: charge
                        });
                    }
                });
            }
            if (ppoc) {
                _.each(ppoc, function (charge) {
                    oneOffChargeLookup.paypal[charge.id] = charge;
                    if (charge.refund) {
                        if (!payPalRefunds[charge.refund]) {
                            payPalRefunds[charge.refund] = [];
                        }
                        payPalRefunds[charge.refund].push(charge);
                    } else {
                        allCharges.push({
                            type: 'paypal_oneoff_charge',
                            date: charge.created,
                            data: charge
                        });
                    }
                });
            }
            if (ac) {
                _.each(ac, function (charge) {
                    allCharges.push({
                        type: 'android_charge',
                        date: charge.created,
                        data: charge
                    });
                });
            }
            if (aoc) {
                _.each(aoc, function (charge) {
                    oneOffChargeLookup.android[charge.id] = charge;
                    allCharges.push({
                        type: 'android_oneoff_charge',
                        date: charge.created,
                        data: charge
                    });
                });
            }
            if (allCharges.length) {
                allCharges = _.sortBy(allCharges, 'date').reverse();
                charges.push({
                    name: 'Payment history',
                    items: [{
                        format: _.bind(function () {
                            var table = $('<table class="charges">');
                            var headRow = $('<tr class="head">');
                            headRow.append('<th class="dateCell">Date</th>');
                            headRow.append('<th class="amountCell" colspan="2">Payment</th>');
                            headRow.append('<th class="descriptionCell">Description</th>');
                            headRow.append('<th class="statusCell">Status</th>');
                            table.append(headRow);
                            _.each(allCharges, function (charge) {
                                var row;
                                switch (charge.type) {
                                case 'stripe_invoice':
                                    row = this.formatStripeInvoice(charge.data, invoiceCharges[charge.data.id]);
                                    break;
                                case 'stripe_charge':
                                    row = this.formatStripeCharge(charge.data);
                                    break;
                                case 'paypal_charge':
                                    row = this.formatPayPalCharge(charge.data, payPalRefunds[charge.data.id]);
                                    break;
                                case 'paypal_oneoff_charge':
                                    row = this.formatPayPalOneOffCharge(charge.data, payPalRefunds[charge.data.id]);
                                    break;
                                case 'android_charge':
                                    row = this.formatAndroidCharge(charge.data);
                                    break;
                                case 'android_oneoff_charge':
                                    row = this.formatAndroidOneOffCharge(charge.data);
                                    break;
                                }
                                table.append(row);
                            }, this);
                            return table;
                        }, this)
                    }]
                });
            }
            
            if (allSubscriptions.length) {
                allSubscriptions = _.sortBy(allSubscriptions, 'start').reverse();
                subscriptions.push({
                    name: 'Subscriptions',
                    items: [{
                        format: _.bind(function () {
                            var table = $('<table class="subscriptions">');
                            var headRow = $('<tr class="head">');
                            headRow.append('<th class="dateCell">Started</th>');
                            headRow.append('<th class="descriptionCell">Description</th>');
                            headRow.append('<th class="statusCell" colspan="2">Status</th>');
                            headRow.append('<th class="detailCell">Details</th>');
                            table.append(headRow);
                            _.each(allSubscriptions, function (sub) {
                                var row;
                                switch (sub.type) {
                                case 'stripe':
                                    var subII = _.filter(ii, function (iii) {
                                        return iii.customer_id == sub.data.customer_id;
                                    });
                                    row = this.formatStripeSubscriptionItem(sub.data, subII);
                                    break;
                                case 'paypal':
                                    row = this.formatPayPalSubscriptionItem(sub.data);
                                    break;
                                case 'android':
                                    row = this.formatAndroidSubscriptionItem(sub.data);
                                    break;
                                case 'oneoff':
                                    row = this.formatOneOffSubscriptionItem(sub.data, this.getOneOffCharge(sub.data, oneOffChargeLookup));
                                    break;
                                }
                                table.append(row);
                            }, this);
                            return table;
                        }, this)
                    }]
                });
                var footerButtons = this.getNewPayButtons();
                if (footerButtons) {
                    subscriptions.push({
                        footer: footerButtons
                    });
                }
            }
            
            // Do the render
            var mergedFormats = formats.concat(subscriptions, charges);
            
            _.each(mergedFormats, function (section) {
                var anyItems;
                var container = $('<div class="billing">');
                _.each(section.items, function (item) {
                    var value;
                    if ('format' in item) {
                        value = item.format();
                    }
                    if (value === null) {
                        value = '-';
                    }
                    if (value) {
                        anyItems = true;
                        container.append(value);
                    }
                });
                if (anyItems || section.footer) {
                    var sectionContents = $('<div>').addClass(section.className);
                    if (anyItems) {
                        sectionContents.append($('<h2 tabindex="0">').html(section.name));
                        if (section.header) {
                            sectionContents.append($('<div>').html(section.header));
                        }
                        sectionContents.append(container);
                    }
                    if (section.footer) {
                        sectionContents.append($('<div>').html(section.footer));
                    }
                    contents.append(sectionContents);
                }
            }, this); // each mergedFormats
        } else { // if b || c || ppb || ppc
            contents.append(this.getSubscriptionStatus());
        }
        contents.find('.billingCancelSure').html(this.billingCancelSureText);
        return contents;
    }
};

module.exports = PayViewMixins;


/***/ }),

/***/ "egpX":
/***/ (function(module, exports, __webpack_require__) {

var Formatter = __webpack_require__("5gSh");
var HashDialogView = __webpack_require__("o6PP");
var JoinDefaultServersMixins = __webpack_require__("KQDl");
var Org = __webpack_require__("5gbS");
var OrgDetailView = __webpack_require__("oMKX");


var OrgsDialogView = HashDialogView.extend($.extend({}, JoinDefaultServersMixins, {
    el: '#orgsOverlayContents',
    wrapper: $('#orgsContainer'),
    initialize: function (options) {
        JoinDefaultServersMixins.initialize.call(this, options);
        HashDialogView.prototype.initialize.call(this, options);
        
        this.loading = $('#orgLoading');

        this.orgCurrentUpgrade = $('.orgCurrentUpgrade');

        this.benefits = $('#orgBenefits');

        this.joinScreen = $('#orgJoinScreen');
        this.joinDefaultChanBenefit = $('.orgJoinDefaultChanBenefit');

        this.progression = $('#orgProgression');
        this.progressionSteps = this.progression.find('span.progress');
        this.progressionStart = $('#orgProgressionStart');
        this.progressionConnections = $('#orgProgressionConnections');
        this.progressionMembers = $('#orgProgressionMembers');
        this.progressionPay = $('#orgProgressionPay');

        this.createLoading = $('#orgCreateLoading');
        this.createName = $('#orgCreateName');
        this.createBilling = $('#orgCreateBilling');
        this.createForm = $('form#orgCreateForm');
        this.createPrice = $('#orgCreatePrice');
        this.createError = $('#orgCreateError');
        this.createDisabled = true;

        this.createScreen = $('#orgCreateScreen');
        this.createYours = $('#orgCreateYours');
        this.createYoursPlural = $('#orgCreateYoursPlural');
        this.seatPrice = $('#orgSeatPrice');

        this.listScreen = $('#orgListScreen');

        this.formatter = new Formatter();
        this.detail = new OrgDetailView({
            session: this.model,
            dialog: this
        });

        this.list = $('ul#orgList');

        this.model.bind('change:email', this.renderEmail, this);
        this.model.bind('plansChange', this.renderPlan, this);

        _.bindAll(this, 'show', 'showBilling', '_doShow', 'showError');
        
        this.model.bind('init', this.init, this);

        this.model.bind('stat orgsChange', this.renderOrgs, this);
    },
    events: $.extend({}, HashDialogView.prototype.events, JoinDefaultServersMixins.events, {
        'submit #orgCreateForm': 'submitCreateForm'
    }),
    init: function () {
        if (!this.initialized) {
            this.router.route('?/teams=on', 'show', this.show);
            this.router.route('?/team-error=:error', 'showError', this.showError);
            this.router.route('?/teams', 'show', this.show);
            this.router.route('?/team=:orgId', 'show', this.show);
            this.router.route('?/team-billing=:orgId', 'showBilling', this.showBilling);
            this.initialized = true;
        }
    },
    renderOrgs: function () {
        this.orgCurrentUpgrade.toggle(this.model.hasActiveSubscription());
        this.orgCurrentUpgrade.toggleClass('active', this.model.hasActiveOrgs());
        // Run show again for current org
        if (this.detail.isVisible()) {
            this._doShow(this.model.orgs.get(this.detail.model.id), this.detail.isBillingShown());
        }
        this.list.empty();
        var count = this.model.orgs.length;
        this.createYours.toggle(!!count);
        this.createYoursPlural.toggle(count != 1);
        this.model.orgs.each(function (org) {
            var li = $('<li>').append($('<a>').attr('href', '/?/team=' + org.id).text(org.get('name')));
            this.list.append(li);
        }, this);
        // Org was just created, show it
        if (this.orgToShow) {
            this.showOrg(this.model.orgs.get(this.orgToShow));
            this.orgToShow = null;
        }
    },
    showCreate: function () {
        this.showStartProgression();

        this.loading.hide();
        this.joinScreen.hide();
        this.listScreen.hide();
        this.detail.hide();
        this.benefits.show();

        this.createScreen.show();
    },
    showStartProgression: function () {
        this.progressionSteps.removeClass('active').removeClass('complete');
        this.progressionStart.addClass('active');
        this.progression.addClass('show');
    },
    showConnectionsProgression: function () {
        this.progressionSteps.removeClass('active').removeClass('complete');
        this.progressionStart.addClass('complete');
        this.progressionConnections.addClass('active');
        this.progression.addClass('show');
    },
    showMembersProgression: function () {
        this.progressionSteps.removeClass('active').removeClass('complete');
        this.progressionStart.addClass('complete');
        this.progressionConnections.addClass('complete');
        this.progressionMembers.addClass('active');
        this.progression.addClass('show');
    },
    showPaymentProgression: function () {
        this.progressionSteps.removeClass('active').removeClass('complete');
        this.progressionStart.addClass('complete');
        this.progressionConnections.addClass('complete');
        this.progressionMembers.addClass('complete');
        this.progressionPay.addClass('active');
        this.progression.addClass('show');

    },
    hideProgression: function () {
        this.progression.removeClass('show');
    },
    showOrgOnCreate: function (orgId) {
        this.orgToShow = orgId;
    },
    showOrg: function (org, billing) {
        if (!org.isAdmin()) {
            billing = false;
        }
        var url = billing ? 'team-billing' : 'team';
        this.router.navigate('?/' + url + '=' + org.id, {replace: true});

        this.hideProgression();
        this.loading.hide();
        this.joinScreen.hide();
        this.createScreen.hide();
        this.listScreen.hide();
        this.benefits.hide();

        this.detail.show(org, billing);
    },
    showList: function () {
        this.hideProgression();

        this.loading.hide();
        this.joinScreen.hide();
        this.createScreen.hide();
        this.detail.hide();
        this.benefits.hide();

        this.listScreen.show();
    },
    _doShow: function (orgId, billing) {
        if (orgId !== 'new' && this.model.orgs.length) {
            var org = this.model.orgs.get(orgId);
            if (org) {
                return this.showOrg(org, billing);
            } else if (this.model.hasOneOrg()) {
                return this.showOrg(this.model.orgs.first());
            } else {
                this.showList();
                this.router.navigate('?/teams', {replace: true});
            }
        } else {
            this.showCreate();
            this.router.navigate('?/team=new', {replace: true});
        }
    },
    showError: function (error) {
        this.hideProgression();
        this.loading.hide();

        this.listScreen.hide();
        this.detail.hide();
        this.createScreen.hide();
        this.benefits.hide();

        this.showJoinError({message: error});

        this.joinScreen.fadeIn('fast');

        HashDialogView.prototype.show.call(this);
    },
    showJoin: function (inviteKey, name) {
        if (this.joining) {
            return;
        }
        this.joining = true;
        this.showJoinInit(name);
        $('#orgJoinInvite').val(inviteKey);

        this.model.getOrgInviteConnections(inviteKey, _.bind(function (response) {
            this.loading.hide();
            if (response.error || response.success === false) {
                this.showJoinError(response);
            } else {
                var org = new Org(response, {session: this.model});
                this.showJoinOrg(org);
                if (org.hasConnections() || org.hasIrcd()) {
                    this.joinDefaultChanBenefit.show();
                } else {
                    this.joinDefaultChanBenefit.hide();
                }
            }
            this._doShowJoin();
        }, this));
    },
    joinDefaultServerAction: function (data, callback) {
        this.model.joinOrg(data, callback);
    },
    joinDefaultServerEndAction: function () {
        this.hide();
    },
    _doShowJoin: function () {
        this.benefits.hide();
        this.joinScreen.fadeIn('fast');

        this.joining = false;

        HashDialogView.prototype.show.call(this);
    },
    showBilling: function (orgId) {
        this.show(orgId, true);
    },
    show: function (orgId, billing) {
        this.hideCreateError();
        this._doShow(orgId, billing);
        HashDialogView.prototype.show.call(this);
    },
    getPerSeat: function () {
        return (this.model.plans && this.model.plans.org) ? this.model.plans.org.per_seat : 400;
    },
    renderPlan: function () {
        this.seatPrice.text(this.formatter.amount(this.model.getCurrency(), this.getPerSeat()));
        this.enableCreateForm();
        this.createLoading.hide();
        this.createPrice.show();
    },
    isCreateDisabled: function () {
        return this.createDisabled;
    },
    disableCreateForm: function () {
        if (!this.isCreateDisabled()) {
            this.createDisabled = true;
            this.createForm.find('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableCreateForm: function () {
        if (this.isCreateDisabled()) {
            this.createDisabled = false;
            this.createForm.find('input, button, textarea').prop('disabled', false);
        }
    },
    submitCreateForm: function (e) {
        e.preventDefault();
        if (this.isCreateDisabled()) {
            return;
        }

        var data = this.createForm.serializeForm();

        if (!data.name) {
            this.showCreateError('missing_name');
            return;
        }
        if (!data.billing_email) {
            this.showCreateError('missing_billing_email');
            return;
        }

        this.disableCreateForm();
        this.hideCreateError();

        this.model.createOrg(data, _.bind(function (response) {
            this.enableCreateForm();
            if (response.success) {
                this.createName.val('');
                this.showOrgOnCreate(response.org.id);
            } else {
                this.showCreateError(response.message);
            }
        }, this));
    },
    showCreateError: function (message) {
        var msg = "";
        switch (message) {
        case "missing_plan":
            msg = "Missing plan";
            break;
        case "missing_stripe_token":
            msg = "Missing payment";
            break;
        case "missing_name":
            msg = "Missing team name";
            break;
        case "missing_billing_email":
            msg = "Missing billing email";
            break;
        case 'invalid_billing_email':
            msg = 'Invalid billing email';
            break;
        case 'server_error':
            msg = 'There was a problem creating this team';
            break;
        default:
            msg = 'There was a problem creating this team: ' + message;
            break;
        }
        this.createError.text(msg).fadeIn('fast');
    },
    hideCreateError: function () {
        this.createError.hide();
    },
    renderEmail: function () {
        var currentVal = this.createBilling.val();
        if (!currentVal || this.model.previous('email') == currentVal) {
            this.createBilling.val(this.model.get('email'));
        }
    },
    focusCreateName: function () {
        this.createName.focus().select();
    }
}));


module.exports = OrgsDialogView;


/***/ }),

/***/ "ew4Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _session = __webpack_require__("+9Dv");

var _session2 = _interopRequireDefault(_session);

var _connection = __webpack_require__("LLdI");

var _connection2 = _interopRequireDefault(_connection);

var _org = __webpack_require__("5gbS");

var _org2 = _interopRequireDefault(_org);

var _avatar = __webpack_require__("lKP6");

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Backbone.View.extend({
    initialize: function initialize(options) {
        this.session = options.session;
        this.size = options.size || 120;
        this.progress = this.$('.avatarPreview__uploadProgress');
        this.listenTo(this.session, 'avatarUpload', this.renderUpload);
    },
    events: {
        'click': 'clickPreview',
        'buttonClick': 'clickPreview'
    },
    show: function show() {
        this.$el.show();
        return this;
    },
    hide: function hide() {
        this.$el.hide();
        return this;
    },
    clickPreview: function clickPreview(e) {
        if (this.model) {
            var props = {};
            if (this.model instanceof _session2.default) {
                props.is_primary = true;
            } else if (this.model instanceof _org2.default) {
                props.org = this.model.id;
            } else if (this.model instanceof _connection2.default) {
                props.cid = this.model.id;
            } else {
                return;
            }
            this.model.session.trigger('avatarPrompt', this.model, {
                properties: props
            });
        }
    },
    setModel: function setModel(model) {
        if (this.model) {
            this.stopListening(this.model);
        }
        this.model = model;
        this.setModelAvatar();
        this.listenTo(this.model, 'change:avatar', this.setModelAvatar);
        return this;
    },
    setModelAvatar: function setModelAvatar() {
        if (this.model.get('avatar')) {
            this.setAvatar(new _avatar2.default({
                id: this.model.get('avatar')
            }));
        } else {
            this.setAvatar(null);
        }
    },
    setAvatar: function setAvatar(avatar) {
        this.avatar = avatar;
        this.render();
    },
    render: function render() {
        if (this.avatar) {
            var url = this.avatar.getCachedSquareUrl(this.size);
            this.setImage(url);
        } else {
            this.clearImage();
        }
        return this;
    },
    setImage: function setImage(url) {
        this.$el.css('background-image', 'url("' + url.replace(/"/g, '\\"') + '")');

        this.$el.removeClass('avatarPreview--new');
        this.$el.addClass('avatarPreview--change');
    },
    clearImage: function clearImage(url) {
        this.$el.css('background-image', 'none');

        this.$el.removeClass('avatarPreview--change');
        this.$el.addClass('avatarPreview--new');
    },
    renderUpload: function renderUpload(avatar, dataUrl, uploadPromise, finalisePromise) {
        if (!avatar.matchesModel(this.model)) {
            return;
        }
        this.$el.addClass('avatarPreview--uploading');

        this.setImage(dataUrl);

        finalisePromise.done(_.bind(function () {
            this.setAvatar(avatar);
        }, this)).fail(_.bind(function (errorResponse) {
            this.model.trigger('postError', errorResponse);
            this.setAvatar(null);
        }, this)).always(_.bind(function () {
            this.$el.removeClass('avatarPreview--uploading');
        }, this));

        this.initProgress(uploadPromise, finalisePromise);
    },
    initProgress: function initProgress(uploadPromise, finalisePromise) {
        uploadPromise.progress(_.bind(function (evt, percentComplete) {
            this.progress.stop();
            if (evt) {
                var done = percentComplete == 100;
                this.progress.toggleClass('avatarPreview__uploadProgress--busy', done);
                this.progress.animate({
                    height: percentComplete + '%'
                });
            } else {
                this.progress.addClass('avatarPreview__uploadProgress--busy');
                this.progress.css('height', '100%');
            }
        }, this));
        finalisePromise.always(_.bind(function () {
            this.progress.removeClass('avatarPreview__uploadProgress--busy');
            this.progress.css('height', 0);
        }, this));
    }
});

/***/ }),

/***/ "f01x":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");
var Overlay = __webpack_require__("jcM0");


var OverlayContainerView = DialogView.extend({
    tagName: 'div',
    className: 'overlaycontainer',
    initialize: function (options) {
        this.session = options.session;
        _.bindAll(this, 'clearOverlays', 'hide');
        this.afterHide = this.clearOverlays;
        this.hideInstant = true;
        this.showInstant = true;
        this.closeTimer = null;
        this.keepOverlayOpen = false;
        
        this.closeTimeout = null;
        
        $(window).on('beforeunload', this.hide);
        
        this.messages = [];
        this.classNames = [];
        this.overlays = [];
    },
    events: {
        'buttonClick button.close': 'clickDone',
        'mousemove': 'mouseMove'
    },
    render: function () {
        this.contents = $('<div class="overlaycontents">');
        this.done = $('<button type="button" class="close"><span></span></button>');
        $(this.el).append(this.done);
        $(this.el).append(this.contents);
        
        return this;
    },
    _hideEsc: function () {
        this.cancel();
    },
    clickDone: function (e) {
        this.cancel();
        return false;
    },
    cancel: function () {
        _.each(this.overlays, function (o, i) {
            if (o.onCancel) {
                o.onCancel();
            }
        }, this);
        this.hide(true, true);
    },
    mouseMove: function (e) {
        if (!this.keepOverlayOpen) {
            this.keepOverlayOpen = true;
            this.clearCloseTimer();
        }
    },
    clearOverlays: function () {
        _.each(this.messages, function (message, i) {
            $(this.el).removeClass('overlay_container_type_' + message.type);
        }, this);
        _.each(this.classNames, function (className, i) {
            $(this.el).removeClass('overlay_container_class_' + className);
        }, this);
        $(this.el).removeClass('overlay_container_prompt');
        $(this.el).removeClass('overlay_container_head');
        
        this.clearCloseTimer();
        this.keepOverlayOpen = false;
        this.classNames = [];
        this.messages = [];
        this.closeTimeout = null;
        
        if (this.contents) {
            this.contents.empty();
        }
        _.each(this.overlays, function (o, i) {
            o.unbind();
            o.stopListening();
        }, this);
        this.overlays = [];
    },
    markAsRead: function () {
        // Update buffer seen for messages
        var lastSeenMap = {};
        var buffers = {};
        // This avoids calling setLastSeen for every message in a contiguous sequence
        // we only set it once at the end for the latest in the first contiguous sequence
        // of important events that immediately follows the current last seen.
        _.each(this.messages, function (message, i) {
            var cid = message.cid;
            var bid = message.bid;
            var eid = message.eid;
            if (cid < 0 || bid < 0 || eid < 0) {
                return;
            }
            var connection = this.session.getConnection(message.cid);
            if (!connection) {
                return;
            }
            var buffer = connection.getBuffer(bid);
            if (!buffer) {
                return;
            }
            buffers[bid] = buffer;
            var currentMessage = buffer.getMessage(eid);
            if (!currentMessage) {
                return;
            }
            var previous = currentMessage.previousMessage();
            var prevIndex = i-1;
            var precedingMessage = this.messages[prevIndex];
            while (precedingMessage && precedingMessage.bid != bid && prevIndex) {
                precedingMessage = this.messages[--prevIndex];
            }
            if (precedingMessage && i && lastSeenMap[bid] && (lastSeenMap[bid].equals(previous) || !buffer.countImportantMessagesBetween(buffer.getMessage(precedingMessage.eid), currentMessage))) {
                // Use the latest in any contiguous sequence of messages
                lastSeenMap[bid] = currentMessage;
            } else {
                // If this message immediately follows the last seen, or if there are no
                // important messages in between, we can mark it as read
                var lastSeen = buffer.getLastSeenMessage();
                if (!lastSeen || lastSeen.equals(previous) || !buffer.countImportantMessagesBetween(lastSeen, currentMessage)) {
                    lastSeenMap[bid] = currentMessage;
                }
            }
        }, this);
        // Actually set the last seen points for each buffer
        for (var bid in lastSeenMap) {
            buffers[bid].setLastSeen(lastSeenMap[bid]);
        }
    },
    hide: function (animate, markAsRead) {
        if (markAsRead) {
            this.markAsRead();
        }
        if (animate) {
            $(this.el).slideUp('fast', _.bind(function () {
                DialogView.prototype.hide.call(this);
            }, this));
        } else {
            $(this.el).hide();
            DialogView.prototype.hide.call(this);
        }
    },
    setCloseTimer: function () {
        if (this.closeTimeout && !this.keepOverlayOpen) {
            this.clearCloseTimer();
            if (this.session.isFocused()) {
                this.closeTimer = setTimeout(
                    _.bind(this.hide, this, true),
                    this.closeTimeout
                );
            } else {
                setTimeout(_.bind(this.setCloseTimer, this), 1000);
            }
        } else if (this.closeTimeout === false) {
            this.clearCloseTimer();
        }
    },
    clearCloseTimer: function () {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    },
    focusDone: function () {
        this.done.focus();
    },
    getLastMessage: function () {
        return this.messages[this.messages.length - 1];
    },
    shouldAppendHead: function (overlay) {
        // No head
        if (!overlay.head) {
            return false;
        }
        
        // Show if this overlay has no message
        var message = overlay.message;
        if (!message || !message.bid) {
            return true;
        }
        // Show if there was no previous message
        var lastMessage = this.getLastMessage();
        if (!lastMessage || !lastMessage.bid || !lastMessage) {
            return true;
        }
        // Show if this message was for a different buffer to the last
        if (lastMessage.bid != message.bid) {
            return true;
        }
        // Show if this message is of a different type to the last
        if (lastMessage.type != message.type) {
            return true;
        }
        // Show if this message is from a different sender than the last
        if (lastMessage.from != message.from) {
            return true;
        }

        // Show if this overlay should always include the head
        if (_.contains(Overlay.alwaysShowHead, message.type)) {
            return true;
        }
    },
    append: function (overlay) {
        // Skip to the end of any hide animations, so they don't clear this one on complete
        $(this.el).stop(true, true);

        this.closeTimeout = overlay.timeout;
        
        if (!this.keepOverlayOpen) {
            this.setCloseTimer();
        }
        
        var shouldClear = overlay.shouldClearPrevious(_.last(this.overlays));
        if (shouldClear) {
            this.clearOverlays();
        }
        
        var wrapper = $('<div>');
        
        var message = overlay.message;
        if (message) {
            wrapper.addClass('overlay_type_' + message.type);
            $(this.el).addClass('overlay_container_type_' + message.type);
        }
        if (overlay.prompt) {
            wrapper.addClass('overlay_prompt');
            $(this.el).addClass('overlay_container_prompt');
        }
        if (overlay.className) {
            this.classNames.push(overlay.className);
            wrapper.addClass('overlay_class_' + overlay.className);
            $(this.el).addClass('overlay_container_class_' + overlay.className);
        }
        if (this.shouldAppendHead(overlay)) {
            var head = overlay.makeHead();
            wrapper.append(head);
            if ($(this.el).hasClass('overlay_container_head')) {
                head.addClass('overlayNewHead');
            } else {
                $(this.el).addClass('overlay_container_head');
            }
        }
        
        if (overlay.doneText === null) {
            this.done.attr('disabled', true).hide();
        } else {
            this.done.find('span').text(overlay.doneText || 'Done');
            this.done.attr('disabled', false).show();
        }
        
        wrapper.append(overlay.makeContent());
        this.contents.append(wrapper);
        
        
        var keepFocus = !!DialogView.open;
        $(this.el).slideDown(100, _.bind(function () {
            if (!overlay.keepFocus && !keepFocus) {
                this.focusDone();
            }
            if (overlay.afterAppend) {
                overlay.afterAppend();
            }
        }, this));
        this.show(true);
        
        if (message) {
            this.messages.push(message);
        }
        overlay.bind('clear', function () {
            this.hide(false, true);
        }, this);
        overlay.bind('cancel', function () {
            this.cancel();
        }, this);
        overlay.bind('hide', function () {
            this.hide(true, true);
        }, this);
        this.overlays.push(overlay);
    }
});


module.exports = OverlayContainerView;


/***/ }),

/***/ "f6UI":
/***/ (function(module, exports, __webpack_require__) {

var NetworkEditor = __webpack_require__("0xAE");
var OverlayContainerView = __webpack_require__("f01x");


var AddNetworkView = Backbone.View.extend({
    el: '#addNetworkContainer',
    initialize: function (options) {
        this.selected = false;
        
        this.editorContainer = $('#addNetworkEditor');
        
        this.buffersFooter = $('#buffersFooter');
        this.buttonContainer = $('.addNetworkButton').on('buttonClick', _.bind(function () {
            this.model.trigger('navigate', '?/addNetwork', {trigger: true});
        }, this));
        this.buttonVisible = false;
        
        this.limits = $('#addNetworkLimits');
        this.connectionLimits = this.$('.addNetworkConnectionLimit');

        this.model.bind('change', this.sessionChange, this);
        this.model.bind('featureChange:upgrades', this.renderLimits, this);
        this.model.connections.bind('change', this.renderLimits, this);
        
        this.overlay = new OverlayContainerView({
            model: this.model,
            session: this.model
        });
        
        this.render();
    },
    showLimits: function () {
        this.limits.show();
    },
    hideLimits: function () {
        this.limits.hide();
    },
    toggleLimits: function (show) {
        this.limits.toggle(show);
    },
    render: function () {
        var idPrefix = "addNetwork";
        this.editor = new NetworkEditor({
            session: this.model,
            action: this.model.addNetwork,
            className: 'addNetworkForm',
            id: idPrefix + 'Form',
            classPrefix: "addNetwork",
            idPrefix: idPrefix,
            submitLabel: "Join network",
            cellGroups: [
                NetworkEditor.CELL_GROUPS.network,
                NetworkEditor.CELL_GROUPS.slack,
                NetworkEditor.CELL_GROUPS.identity,
                NetworkEditor.CELL_GROUPS.channels,
                NetworkEditor.CELL_GROUPS.advanced
            ],
            callback: _.bind(function (response) {
                if (response.success) {
                    // makeserver may come before this response
                    var connection = this.model.getConnection(response.cid);
                    if (connection) {
                        connection.select();
                    } else {
                        this.model.setFocusOnMakeServer(response.cid);
                    }
                }
            }, this)
        });
        this.editorContainer.append(this.editor.render().el);
        this.editor.renderSelectComplete(this.editorContainer); // shitty plugin
        
        $(this.el).append(this.overlay.render().el);
        
        this.model.bind('change:nick', this.renderUser, this);
        this.model.bind('change:realname', this.renderUser, this);
    },
    renderUser: function () {
        this.editor.setUser(this.model.getUser());
    },
    sessionChange: function () {
        this.renderLimits();
        this.showButton();
    },
    renderLimits: function () {
        var nets = this.model.getLimit('networks');
        var s = '';
        if (nets != 1) {
            s = 's';
        }
        var text = nets + ' outside connection' + s;
        this.connectionLimits.text(text);
        this.toggleLimits(this.model.areConnectionsLimited() && !!this.model.numActiveConnections());
    },
    showButton: function () {
        if (!this.buttonVisible) {
            this.buffersFooter.fadeIn('fast');
            this.buttonVisible = true;
        }
    },
    hideButton: function () {
        if (this.buttonVisible) {
            this.buffersFooter.fadeOut('fast');
            this.buttonVisible = false;
        }
    },
    isSelected: function () {
        return this.selected;
    },
    show: function (bufferParts) {
        this.selected = true;
        
        $(this.el).show();
        this.buttonContainer.addClass('addNetworkButton--selected');
        
        var prefillUser = this.model.getUser().clone();
        var nick = this.model.getNick();
        prefillUser.set({'nick': nick});
        this.editor.prefill(prefillUser, bufferParts);
        this.editor.focusNetwork();
    },
    hide: function () {
        if (this.isSelected()) {
            this.selected = false;
            this.buttonContainer.removeClass('addNetworkButton--selected');
            $(this.el).hide();
        }
    },
    // This will get called from MainAreaView
    renderOverlay: function (overlay) {
        this.overlay.append(overlay);
        
        return this;
    }
});


module.exports = AddNetworkView;


/***/ }),

/***/ "fDhS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-env es6 */
var macOS = navigator.userAgent.indexOf('Mac OS X') != -1;
var keys = {
    K: 75,
    R: 82,
    ENTER: 13,
    BACKSPACE: 8,
    TAB: 9,
    SHIFT: 16,
    ALT: 18,
    CMD: 91,
    CTRL: 17,
    ESC: 27,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    COMMA: 188,
    '/': 191
};

exports.default = {
    isClickEnter: function isClickEnter(e) {
        // Mouse clicks have a positive detail count to signify how many clicks
        return e.originalEvent.detail === 0;
    },
    modifierName: function modifierName() {
        if (macOS) {
            return 'Cmd';
        } else {
            return 'Ctrl';
        }
    },
    modifierLabel: function modifierLabel() {
        if (macOS) {
            return 'command';
        } else {
            return 'control';
        }
    },
    isModifier: function isModifier(e, allowAltShift) {
        if (!allowAltShift && (e.altKey || e.shiftKey)) {
            return false;
        }
        if (macOS) {
            return e.metaKey && !e.ctrlKey;
        } else {
            return e.ctrlKey;
        }
    },
    isModifierWhich: function isModifierWhich(e) {
        if (macOS) {
            return e.which == keys.CMD;
        } else {
            return e.which == keys.CTRL;
        }
    },

    KEYS: keys
};

/***/ }),

/***/ "fJd+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ts = ts;
exports.mark = mark;
exports.measure = measure;
exports.clear = clear;

var _util = __webpack_require__("GmLC");

var PERFMARKS = {}; /* eslint-env es6 */
function ts() {
    if ('performance' in window) {
        if ('now' in window.performance) {
            return Math.round(window.performance.now());
        } else if ('webkitNow' in window.performance) {
            return Math.round(window.performance.webkitNow());
        }
    }
    return (0, _util.ts)();
}
function mark(name) {
    PERFMARKS[name] = ts();
}
function measure(name) {
    var time = ts() - PERFMARKS[name];
    clear(name);
    return time;
}
function clear(name) {
    delete PERFMARKS[name];
}

/***/ }),

/***/ "gCfx":
/***/ (function(module, exports, __webpack_require__) {

var AccountMenuView = __webpack_require__("TwDC");
var BufferListView = __webpack_require__("OFe6");
var ts = __webpack_require__("GmLC").ts;


var SidebarView = Backbone.View.extend({
    el: '#sidebar',
    initialize: function (options) {
        this.bufferList = new BufferListView(options, this);
        this.accountMenu = new AccountMenuView(options, this);
        
        this.limitsContainer = $('#limits');
        this.wrapper = $('#sidebarwrapper');
        
        this.zombieWarnings = $('.zombieWarning');
        this.softZombieWarning = $('#softZombieWarning');
        this.hardZombieWarning = $('#hardZombieWarning');
        this.freeTrial = this.limitsContainer.find('.freeTrial');
        this.limitedTrial = this.limitsContainer.find('.limitedTrial');
        this.trialRemain = this.limitsContainer.find('.trialRemain');
        this.upgrade = this.$('.payUpgrade');
        this.updateWarning = this.$('.payUpdateWarning');
        
        this.model.bind('setZombie', this.renderZombieLimit, this);
        
        this.model.bind('init', this.init, this);
    },
    init: function () {
        this.renderLimits();
        this.model.bind('stat featureChange:upgrades', this.renderLimits, this);
    },
    renderZombieLimit: function () {
        this.zombieWarnings.hide();
        if (this.model.isZombied()) {
            if (this.model.hardZombie) {
                this.hardZombieWarning.show();
            } else if (this.model.softZombie && this.model.isZombieLimited()) {
                this.softZombieWarning.show();
            }
        }
    },
    renderLimits: function () {
        if (!this.model.isInitialized()) {
            this.limitsContainer.hide();
        } else {
            if (this.model.isUnlimited()) {
                this.limitsContainer.hide();
            } else {
                var unpaid = this.model.isSubscriptionUnpaid();
                this.upgrade.toggle(!unpaid);
                this.updateWarning.toggle(unpaid);
                var limited = this.model.isTrialLimited();
                this.limitedTrial.toggle(limited);
                this.freeTrial.toggle(!limited);
                var trialEnds = this.model.trialEnds();
                if (trialEnds) {
                    var trialEndsIn = trialEnds.getTime() - ts();
                    var days = Math.round(trialEndsIn/1000/24/60/60);
                    if (days <= 1) {
                        this.trialRemain.attr('title', 'Trial ends today').text('Ends today!');
                    } else {
                        this.trialRemain.attr('title', days + ' days remain on the trial').text(days + ' days');
                    }
                }
                this.limitsContainer.show();
            }
        }
        return this;
    },
    getRect: function () {
        return this.$el[0].getBoundingClientRect();
    }
});


module.exports = SidebarView;


/***/ }),

/***/ "gEBD":
/***/ (function(module, exports) {

var OrgEntity = Backbone.Model.extend({
    initialize: function (data, options) {
        this.session = options.session;
        this.bind('change:connections', this.parseConnections, this);
        this.parseConnections();
    },
    
    isAdmin: function () {
        return !!this.get('admin');
    },
    haveJoined: function () {
        return this.session.hasConnections();
    },
    hasSubscribed: function () {
        return true;
    },
    hasConnections: function () {
        return !!(this.connections && this.connections.length);
    },
    hasIrcd: function () {
        return !!this.get('ircd');
    },
    getIrcdConnection: function () {
        if (!this.hasIrcd()) {
            return;
        }
        return {
            ircd: true,
            channels: this.get('ircd_channels')
        };
    },
    parseConnections: function () {
        if (this.get('connections')) {
            var previousConnections = _.clone(this.connections);
            this.connections = this.get('connections');
            this.trigger('connectionsChange', {
                previous: previousConnections
            });
        }
    }
});


module.exports = OrgEntity;


/***/ }),

/***/ "gcT9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gfb+":
/***/ (function(module, exports, __webpack_require__) {

var AutoLinker = __webpack_require__("INx5");
var Formatter = __webpack_require__("5gSh");
var User = __webpack_require__("Xgjh");
var util = __webpack_require__("GmLC");


var BufferFormatter = function (buffer) {
    this.buffer = buffer;
    this.linker = new AutoLinker(this);
};
BufferFormatter.prototype = util.inherit(Formatter, {
    linkNick: function (nick, options) {
        var user = this.buffer.connection.makeUserFromTarget(this.buffer.bid(), {
            nick: nick
        });
        options = options || {};
        if (!options.className) {
            options.className = '';
        }
        options.attr = options.attr || {};
        options.attr['role'] = 'button';
        options.attr['aria-controls'] = 'memberContextMenu';
        options.attr['aria-haspopup'] = 'true';
        options.className += ' user';
        options.button = 'span';
        return this.linkModel(user, options);
    },
    linkChannel: function (name, options) {
        var buffer = this.buffer.connection.makeChannel({name: name});
        options = options || {};
        if (!options.className) {
            options.className = '';
        }
        options.className += ' channel';
        return this.linkModel(buffer, options);
    },
    linkBuffer: function (name, options) {
        var buffer = this.buffer.connection.makeChild({name: name});
        return this.linkModel(buffer, options);
    },
    link: function (options) {
        return this.linkModel(this.buffer, options);
    },
    linkConnection: function (options) {
        return this.linkModel(this.buffer.connection, options);
    },
    linkServer: function (serverName, options) {
        options = options || {};
        if (!options.className) {
            options.className = '';
        }
        options.className += ' server';
        options.name = serverName;
        return this.linkModel(this.buffer.connection, options);
    },
    spanMessageUser: function (nick, message, options) {
        var user = message.makeUser(nick);
        if (options.color && !message.isSelf()) {
            if (!options.className) {
                options.className = '';
            }
            options.className += ' bufferSpan c' + this.getNickColorIndex(
                message.getDisplayAuthor() || nick
            );
        }
        var attrs = {
            title: user.getTitle(),
            'class': options.className
        };
        var html = '<span' + this.makeAttributes(attrs) + '>';
        html += this.escapeText(user.getName());
        html += '</span>';
        return html;
    },
    linkMessageUser: function (nick, message, options) {
        var user = message.makeUser(nick);
        options = options || {};
        if (options.color && !message.isSelf()) {
            if (!options.className) {
                options.className = '';
            }
            options.className += ' c' + this.getNickColorIndex(
                message.getDisplayAuthor() || nick
            );
        }
        if (!options.hasDataParent && message.id) {
            options.data = _.extend({}, options.data, {
                eid: message.id
            });
        }
        return this.linkUserMode(user, options);
    },
    linkUser: function (user, options) {
        options = options || {};
        if (!options.className) {
            options.className = '';
        }
        options.attr = options.attr || {};
        options.attr['role'] = 'button';
        options.attr['aria-controls'] = 'memberContextMenu';
        options.attr['aria-haspopup'] = 'true';
        options.className += ' user';
        var data = {};
        if (options.hasDataParent) {
            options.className += ' hasUserParent';
        } else {
            data.usermask = user.get('usermask');
            data.name = user.getName();
        }
        if (!options.noData) {
            data.ident_prefix = user.get('ident_prefix');
            data.user = user.get('user');
            data.userhost = user.get('userhost');
            data.mode = user.get('newmode') || user.get('mode');
            data.account = user.get('account');
            data.realname = user.getRealname();
            data.avatar = user.get('avatar');
            data.avatar_url = user.get('avatar_url');
            data.display_name = user.get('display_name');
            data.bot_url = user.get('bot_url');
        }
        options.data = _.extend({}, options.data, data);
        options.button = 'span';
        var prefix = (options.prefix || '');
        return prefix + this.linkModel(user, options);
    },
    makeUserMode: function (user, options) {
        options = options || {};
        var modeSymbol = '';
        var modePill = '';
        if (!options.noMode && user && user.getMode()) {
            if (!options.className) {
                options.className = '';
            }
            var modeClass = 'mode_' + user.getModeCategory();
            options.className += ' moded ' + modeClass;
            modeSymbol += '<span title="' + user.getModeTitle() + '" class="mode_prefix mode_symbol ' + modeClass + '">' + this.escapeText(user.getModeSymbol()) + '</span>';
            modePill += '<span title="' + user.getModeTitle() + '" class="mode_prefix mode_pill ' + modeClass + '">•</span>';
        }
        return modeSymbol + modePill;
    },
    linkUserMode: function (user, options) {
        options = options || {};
        var userMode = this.makeUserMode(user, options);
        options.prefix = (options.prefix || '') + userMode;
        return this.linkUser(user, options);
    },
    getDummyUserFromModeSymbol: function (symbol) {
        var prefixes = this.buffer.connection.getISupport('PREFIX') || User.defaultPrefixes;
        for (var letter in prefixes) {
            if (prefixes[letter] == symbol) {
                return new User({
                    mode: letter
                }, {
                    session: this.buffer.session,
                    connection: this.buffer.connection,
                    buffer: this.buffer
                });
            }
        }
    }
});

module.exports = BufferFormatter;


/***/ }),

/***/ "h0MN":
/***/ (function(module, exports, __webpack_require__) {

var Buf = __webpack_require__("t9zO");
var ChannelList = __webpack_require__("61Uw");
var ConversationList = __webpack_require__("P0z8");


var ConnectionBufferList = Backbone.Collection.extend({
    model: Buf,
    initialize: function (models, options) {
        this.connection = options.connection;
        
        this._lookup = {};
        this._reverseLookup = {};
        this.channels      = new ChannelList;
        this.conversations = new ConversationList;
        
        this.pinnedBuffers         = this.connection.session.pinnedBuffers;
        this.activeChannels        = new ChannelList;
        this.inactiveChannels      = new ChannelList;
        this.archivedChannels      = new ChannelList;
        this.activeConversations   = new ConversationList;
        this.archivedConversations = new ConversationList;
        
        this.bind('add', this.addBuffer, this);
        this.bind('remove', this.removeBuffer, this);
        this.bind('change:archived', this.moveBuffer, this);
        this.bind('change:name', this.moveBuffer, this);
        this.bind('beforePinnedChange', this.beforePinnedChange, this);
        this.bind('pinnedChange', this.pinnedChange, this);
        this.bind('resetLookup', this.resetLookup, this);
        this.bind('twitchChannelChange', this.moveBuffer, this);
        this.bind('activeChange', function (buffer) {
            // Conversations don't move based on being active
            if (!this.isConversation(buffer)) {
                this.moveBuffer(buffer);
            }
        }, this);
        this.listenTo(this.connection, 'init', this.sortBuffers);
        this.listenTo(this.connection, 'archivesFetched', this.sortBuffers);
    },
    lookup: function (name, exact) {
        if (name) {
            if (exact) {
                return this.findWhere({name: name});
            } else {
                return this._lookup[name.toLowerCase()];
            }
        }
    },
    shouldSortBuffers: function () {
        return this.connection.isInitialized() && !this.connection.isFetchingArchives();
    },
    sortBuffers: function () {
        _.each([
            this.channels,
            this.conversations,
            this.activeChannels,
            this.inactiveChannels,
            this.archivedChannels,
            this.activeConversations,
            this.archivedConversations
        ], function (list) {
            list.sort();
        });
    },
    getOrder: function (important) {
        var order = [this.activeChannels];
        if (!important) {
            order.push(this.inactiveChannels);
            order.push(this.activeConversations);
        } else if (this.connection.isActive()) {
            order.push(this.activeConversations);
        }
        if (!important) {
            order.push(this.archivedChannels);
            order.push(this.archivedConversations);
        }
        return order;
    },
    getFirstBuffer: function (important) {
        var orders = this.getOrder(important);
        var result;
        for (var i = 0; i < orders.length; i++) {
            result = orders[i].first();
            if (result) {
                return result;
            }
        }
    },
    getLastBuffer: function (important) {
        var orders = this.getOrder(important);
        var result;
        for (var i = orders.length - 1; i > -1; i--) {
            result = orders[i].last();
            if (result) {
                return result;
            }
        }
        if (!important) {
            return this.connection.serverLog;
        }
    },
    hasSpam: function () {
        var potentialSpam = this.activeConversations.reduce(function (acc, c) {
            if (c.hasUnseen() && c.messages.length && c.messages.last().id === c.get('created')) {
                return ++acc;
            } else {
                return acc;
            }
        }, 0, this);
        return potentialSpam > 3;
    },
    hasChildren: function () {
        return !!(this.channels.length || this.conversations.length);
    },
    hasArchivedBuffers: function () {
        return this.connection.hasDeferredArchives() || !!(this.archivedChannels.length || this.archivedConversations.length);
    },
    hasActiveConversations: function () {
        return !!(this.activeConversations.length);
    },
    findSegment: function (buffer) {
        return _.detect([
            this.activeChannels,
            this.inactiveChannels,
            this.archivedChannels,
            this.activeConversations,
            this.archivedConversations
        ], function (list) {
            return !!list.get(buffer.bid());
        });
    },
    isChannel: function (buffer) {
        return buffer.isChannel() && !buffer.isSlackMultiPersonDm();
    },
    isConversation: function (buffer) {
        if (buffer.isChannel() && buffer.isSlackMultiPersonDm()) {
            return true;
        }
        return buffer.isConversation();
    },
    getBufferList: function (buffer) {
        if (this.isChannel(buffer)) {
            return this.channels;
        } else if (this.isConversation(buffer)) {
            return this.conversations;
        }
    },
    getSegmentedBufferList: function (buffer) {
        if (buffer.isPinned()) {
            return this.pinnedBuffers;
        }
        if (this.isChannel(buffer)) {
            if (buffer.isArchived()) {
                return this.archivedChannels;
            } else if (buffer.isActive()) {
                return this.activeChannels;
            } else {
                return this.inactiveChannels;
            }
        } else if (this.isConversation(buffer)) {
            if (buffer.isArchived()) {
                return this.archivedConversations;
            } else {
                return this.activeConversations;
            }
        }
    },
    addBuffer: function (buffer) {
        this.addLookup(buffer);
        var bufferList = this.getBufferList(buffer);
        if (bufferList) {
            bufferList.add(buffer, {
                sort: this.shouldSortBuffers()
            });
            this.addSegmentedBuffer(buffer);
        }
    },
    resetLookup: function (buffer) {
        var name = buffer.getName().toLowerCase();
        var displayName = buffer.getDisplayName().toLowerCase();
        _.each(this._reverseLookup[buffer.bid()], function (key) {
            if (key !== name && key !== displayName) {
                var otherBuffer = this.findWhere({name: key});
                if (otherBuffer) {
                    this.addLookup(otherBuffer);
                } else {
                    delete this._lookup[key];
                }
            } else {
                delete this._lookup[key];
            }
        }, this);
        delete this._reverseLookup[buffer.bid()];
        this.addLookup(buffer);
    },
    addLookup: function (buffer) {
        var name = buffer.getName().toLowerCase();
        
        if (!this._reverseLookup[buffer.bid()]) {
            this._reverseLookup[buffer.bid()] = [];
        }
        this._reverseLookup[buffer.bid()].push(name);
        this._lookup[name] = buffer;
        if (buffer.isActive()) {
            var displayName = buffer.getDisplayName().toLowerCase();
            if (displayName != name) {
                // Remove any existing reverse lookups for this display name
                if (this._lookup[displayName]) {
                    var existingId = this._lookup[displayName].id;
                    this._reverseLookup[existingId] = _.without(
                        this._reverseLookup[existingId], displayName
                    );
                }
                this._lookup[displayName] = buffer;
                this._reverseLookup[buffer.bid()].push(displayName);
                
            }
        }
        this._reverseLookup[buffer.bid()] = _.unique(this._reverseLookup[buffer.bid()]);
    },
    removeLookup: function (buffer) {
        _.each(this._reverseLookup[buffer.bid()], function (key) {
            delete this._lookup[key];
        }, this);
        delete this._reverseLookup[buffer.bid()];
    },
    removeBuffer: function (buffer) {
        this.removeLookup(buffer);
        this.getBufferList(buffer).remove(buffer);
        this.removeSegmentedBuffer(buffer);
    },
    addSegmentedBuffer: function (buffer) {
        var segment = this.getSegmentedBufferList(buffer);
        if (segment) {
            segment.add(buffer, {
                sort: this.shouldSortBuffers()
            });
        }
    },
    removeSegmentedBuffer: function (buffer) {
        var segment = this.getSegmentedBufferList(buffer);
        if (segment) {
            segment.remove(buffer);
        }
    },
    beforePinnedChange: function (buffer) {
        // For buffers about to be pinned, remove from existing segment
        if (!buffer.isPinned()) {
            var segment = this.findSegment(buffer);
            if (segment) {
                segment.remove(buffer, {silent: true});
            }
        }
        // Trigger event to remove from existing sidebar
        buffer.trigger('moveSegment');
    },
    pinnedChange: function (buffer) {
        // For freshly unpinned buffers, add it to a new segment
        if (!buffer.isPinned()) {
            this.addSegmentedBuffer(buffer);
        }
    },
    moveBuffer: function (buffer) {
        this.addLookup(buffer);
        // We don't want to trigger a remove event on the
        // buffer or everything will get removed from the DOM.
        var segment = this.findSegment(buffer);
        if (segment) {
            segment.remove(buffer, {silent: true});
            buffer.trigger('moveSegment');
        }
        this.addSegmentedBuffer(buffer);
    }
});


module.exports = ConnectionBufferList;


/***/ }),

/***/ "hF98":
/***/ (function(module, exports, __webpack_require__) {

var Keyboard = __webpack_require__("fDhS").default;
var urlUtil = __webpack_require__("Dn1P");

// jquery
// Fix browser support props
// http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
$.browser = {};

function testCSS (prop) {
    return prop in document.documentElement.style;
}

// Opera 8.0+
$.browser.opera = !!(window.opera && window.opera.version);
// FF 0.8+
$.browser.mozilla = testCSS('MozBoxSizing');
// At least Safari 3+: "[object HTMLElementConstructor]"
$.browser.safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
// Chrome 1+
$.browser.chrome = !$.browser.safari && testCSS('WebkitTransform');
// At least IE6
$.browser.msie = false || testCSS('msTransform');

// jquery ui
var oldMouseStart = $.ui.sortable.prototype._mouseStart;
$.ui.sortable.prototype._mouseStart = function(event, overrideHandle, noActivation) {
    this._trigger("beforestart", event, this._uiHash());
    oldMouseStart.apply(this, [event, overrideHandle, noActivation]);
};

// jquery timeago
$.timeago.settings.autoDispose = true;
$.timeago.settings.allowFuture = true;

// Date
Date.prototype.formatTime = function () {
    var formatString = '';
    var seconds = '';
    if (window.getPref('time-seconds')) {
        seconds = ':ss';
    }
    if (window.getPref('time-24hr')) {
        formatString += 'HH:mm' + seconds;
    } else {
        formatString += 'h:mm' + seconds + ' tt';
    }
    return this.toString(formatString);
};
Date.prototype.formatFullDate = function () {
    var formatString = 'dddd, MMMM dd, yyyy ';
    if (window.getPref('time-24hr')) {
        formatString += 'HH:mm:ss';
    } else {
        formatString += 'h:mm:ss tt';
    }
    return this.toString(formatString);
};
Date.prototype.isSameDay = function (date) {
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    return this.toString("yyyy-MM-dd") === date.toString("yyyy-MM-dd");
};

// Backbone
// Add an event bubbling method
Backbone.Model.prototype.bubble = function (event, parent, as) {
    this.bind(event, function () {
        var args = _.toArray(arguments);
        args.unshift(as || event);
        parent.trigger.apply(parent, args);
    }, this);
};
Backbone.Collection.prototype.bubble = Backbone.Model.prototype.bubble;
Backbone.View.prototype.bubble = Backbone.Model.prototype.bubble;
Backbone.View.prototype.cached = function (property, accessor, timeout) {
    timeout = timeout || 1000;
    if (!this[property]) {
        this[property] = accessor();
        setTimeout(_.bind(function () {
            this[property] = null;
        }, this), timeout);
    }
    return this[property];
};
Backbone.Collection.prototype.previous = function (model) {
    var index = this.indexOf(model);
    if (index > 0) {
        return this.at(index - 1);
    }
};
Backbone.Collection.prototype.next = function (model) {
    return this.at(this.indexOf(model) + 1);
};

Backbone.Router.prototype._extractParameters = function(route, fragment) {
    var params = route.exec(fragment).slice(1);
    return _.map(params, function(param, i) {
        // Don't decode any params.
        return param || null;
    });
};

// debug
window.irccloud_debug.head = function (count) {
    count = count || 100;
    var logger = debug.getLogger(true);
    debug.getLogs().slice(0, count).forEach(function (log) {
        logger.apply(window, log);
    });
};
window.irccloud_debug.tail = function (count) {
    count = count || 100;
    var logger = debug.getLogger(true);
    debug.getLogs().slice(-count).forEach(function (log) {
        logger.apply(window, log);
    });
};

var route_re = /^\/(irc([\/?#]|$)|[!?#]|$)/;
$(document).on('click', 'a[href]:not([target=_blank])', function(e) {
    if (window.SESSION) {
        var href = $(this).attr("href");
        var urlParts = urlUtil.urlParts(href);
        if (urlUtil.isCurrentUrl(urlParts)) {
            href = urlParts.pathname + urlParts.search + urlParts.hash;
        }
        if (route_re.test(href)) {
            e.preventDefault();
            window.SESSION.trigger('navigate', href.slice(1), {trigger: true});
            return false;
        }
    }
});

// button clicks
// Need to trigger button clicks separately due to browser bugs sometimes
// not triggering click when positioning button between mousedown and mouseup
// Capture button mouse presses (which = 1) means left click only (jQuery normalised)
var buttonPressed;
$(document).on('mousedown', 'button', function (e) {
    if (e.which == 1) {
        buttonPressed = $(e.target).closest('button:not([disabled])');
    }
});
// Clear button press on all mouseups
$(document).on('mouseup', function (e) {
    if (e.which == 1 && buttonPressed) {
        // Check target matches and trigger new event
        var target = $(e.target).closest('button');
        if (target.is(buttonPressed)) {
            var pos = buttonPressed.position();
            buttonPressed.trigger('buttonClick', {x: pos.left, y: pos.top});
        }
        buttonPressed = null;
    }
});
$(document).on('keypress', '[role~=tab]:not([disabled]), [role~=button]:not([disabled])', function (e) {
    if (e.key === 'Enter' || e.key == ' ') {
        var target = $(e.target);
        // Suppress space scroll down
        e.preventDefault();
        var pos = target.position();
        target.trigger('buttonClick', {x: pos.left, y: pos.top, keypress: true});
    }
});
// Fire custom buttonClick on return
$(document).on('click', 'button', function (e) {
    // Don't mess with button links
    if (!$(e.target).is('a')) {
        if (Keyboard.isClickEnter(e)) {
            // Pressing return will always have detail 0
            // And won't have the isPrimary flag on
            var button = $(e.target).closest('button:not([disabled])');
            var pos = button.position();
            button.trigger('buttonClick', {x: pos.left, y: pos.top, keypress: true});
            // Suppress bubble to avoid multiple submits
            return false;
        }  else {
            // Suppress bubble to avoid triggering clickoff dialog handler
            return false;
        }
    }
});
// If a buttonClick bubbles to the top, submit the nearest form because we're
// suppressing the click
$(document).on('buttonClick', 'button', function (e) {
    // Default type for <button> is submit. Use type="button" to avoid this
    if (e.target.type == 'submit') {
        $(e.target).closest('form').submit();
        return false;
    }
});


/***/ }),

/***/ "hI2d":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");


var ContextMenuView = DialogView.extend({
    initialize: function (options) {
        options = options || {};
        DialogView.prototype.initialize.call(this, options);
        
        this.showInstant = true;
        this.hideInstant = true;
        this.closeOnClickOff = true;
    },
    size: function (x, y) {
        // Reset
        $(this.el).removeClass('contextMenu__top');
        $(this.el).removeClass('contextMenu__bottom');
        $(this.el).removeClass('contextMenu__left');
        $(this.el).removeClass('contextMenu__right');
        this.$('.contextMenu__wrap').css('max-height', 'none');
        
        // Ensure we don't overflow the bottom
        var height = $(this.el).height();
        var windowHeight = $(window).height();
        var bottomPad = 25;
        var maxY = windowHeight - height - bottomPad;
        var css = {};
        var maxHeight;
        if (this.options.anchorBottom) {
            $(this.el).addClass('contextMenu__bottom');
            maxHeight = y - bottomPad;
            css.top = 'inherit';
            css.bottom = windowHeight - y;
        } else {
            if (this.options.anchorBottom === false) {
                $(this.el).addClass('contextMenu__top');
                maxHeight = windowHeight - css.top - bottomPad;
                css.top = y;
            } else {
                if (y > maxY) {
                    $(this.el).addClass('contextMenu__bottom');
                    maxHeight = 'none';
                    css.top = maxY;
                } else {
                    $(this.el).addClass('contextMenu__top');
                    maxHeight = windowHeight - css.top - bottomPad;
                    css.top = y;
                }
            }
            css.bottom = 'inherit';
        }
        
        // Ensure we don't overflow the right hand side
        var width = $(this.el).width();
        var windowWidth = $(window).width();
        var maxX = windowWidth - width;
        if (this.options.anchorRight !== false && (this.options.anchorRight || x > maxX)) {
            css.left = 'inherit';
            css.right = windowWidth - x;
            if (x > maxX) {
                $(this.el).addClass('contextMenu__right');
            } else {
                $(this.el).addClass('contextMenu__left');
            }
        } else {
            css.left = x;
            css.right = 'inherit';
            $(this.el).addClass('contextMenu__left');
        }
        $(this.el).css(css);
        this.$('.contextMenu__wrap').css('max-height', maxHeight);
    },
    show: function (x, y, options) {
        this.options = options || {};
        this.$el.on('reflowImageContainer', _.bind(function () {
            if (this.isVisible()) {
                this.size(x, y);
                this.el.scrollTop = 0;
            }
        }, this));

        this.size(x, y);
        
        DialogView.prototype.show.call(this);
        
        this.el.scrollTop = 0;
    },
    enableItem: function (item, condition) {
        item.toggleClass('enabled', condition);
        item.find('button').attr('aria-pressed', String(condition));
    },
    deactivateItem: function (item, condition, toggle) {
        item.toggleClass('inactive', condition).attr('aria-disabled', String(condition));
        item.find('button').prop('disabled', condition);
        item.find('.contextMenu__item').toggleClass('contextMenu__item--disabled', condition);
        if (toggle) {
            item.toggle(!condition);
        }
    },
    afterShow: function () {
        this.focusFirstItem();
    },
    afterHide: function () {
        this.options = null;
    },
    focusFirstItem: function () {
        if (this.options.keypress) {
            this.$('.contextMenu__item:not(.contextMenu__item--disabled):first').focus();
        }
    }
});


module.exports = ContextMenuView;


/***/ }),

/***/ "hKI7":
/***/ (function(module, exports) {

var ChatterBarView = Backbone.View.extend({
    tagName: 'div',
    className: 'extras',
    initialize: function (options) {
        this.timeagoStrings = $.extend(true, {}, $.timeago.settings.strings);
        this.timeagoStrings.prefixAgo = null;
        this.timeagoStrings.suffixAgo = null;
        this.timeagoStrings.prefixFromNow = null;
        this.timeagoStrings.suffixFromNow = null;
        
        this.visible = false;
        this.mentionsVisible = true;
        
        this.model.bind('remove', this.remove, this);
    },
    render: function () {
        this.mentionsBadge = $('<span class="extrasBadge">');
        this.mentionsText = $('<span>');
        this.mentions = $('<span>').append(this.mentionsBadge, this.mentionsText);
        var timeUnknown = $('<span>');
        var timeKnown = $('<span>');
        this.time = timeUnknown.add(timeKnown);
        this.unknownLines = $('<span>').append(timeUnknown, ' of unread messages');
        this.lines = $('<span>');
        this.linesS = $('<span>');
        this.knownLines = $('<span>').append(
            this.lines,
            ' unread message',
            this.linesS,
            ' (', timeKnown, ')'
        );
        this.extrasButton = $('<span class="extrasButton">').text(this.buttonText);
        this.button = $('<span class="extrasBar">').append(
            this.extrasButton, ' ',
            this.mentions,
            this.knownLines,
            this.unknownLines
        );
        $(this.el).append(this.button);
        
        return this;
    },
    isVisible: function () {
        return this.visible;
    },
    show: function () {
        if (!this.isVisible()) {
            $(this.el).show();
            this.visible = true;
            return true;
        }
    },
    hide: function () {
        if (this.isVisible()) {
            $(this.el).hide();
            this.visible = false;
            return true;
        }
    },
    renderChatter: function (time, lines) {
        if (lines) {
            // Check how much chatter is unseen (time)
            var timeago = $.timeago(time, this.timeagoStrings);
            if (timeago != this.lastTimeago) {
                this.lastTimeago = timeago;
                this.time
                    .text(timeago)
                    .attr('title', time.formatFullDate());
            }
            if (lines !== true) {
                var s = lines === 1 ? '' : 's';
                this.lines.text(lines);
                this.linesS.text(s);
            }
            this.knownLines.toggle(lines !== true);
            this.unknownLines.toggle(lines === true);
            return this.show();
        } else {
            return this.hide();
        }
    },
    hideMentions: function () {
        this.mentionsText.text('');
        this.mentionsBadge.text('');
        if (this.mentionsVisible) {
            this.mentions.hide();
            this.mentionsVisible = false;
        }
    },
    showMentions: function () {
        if (!this.mentionsVisible) {
            this.mentions.show();
            this.mentionsVisible = true;
        }
    },
    renderMentions: function (length) {
        if (length) {
            // Unseen highlights
            this.mentionsBadge.text(length);
            var s = length === 1 ? '' : 's';
            this.mentionsText.text(' mention' + s + ' and ');
            this.showMentions();
        } else {
            this.hideMentions();
        }
    }
});


module.exports = ChatterBarView;


/***/ }),

/***/ "ilaq":
/***/ (function(module, exports, __webpack_require__) {

var FileWrapper = __webpack_require__("JHsc");

//norefactor
var RESTRICTED_REASONS = {
    networks: 'You’ve exceeded the connection limit for free accounts. <b>Upgrade now</b> to connect to more servers',
    unverified: 'You can’t connect to external servers until you confirm your email address',
    passworded_servers: 'You can’t connect to passworded servers with free accounts. <b>Upgrade now</b>',
    slack_disallowed: 'You can’t connect to Slack workspaces with free accounts. <b>Upgrade now</b>'
};
var RESTRICTED_REASONS_SHORT = {
    networks: 'Network limit exceeded',
    unverified: 'Email verification required',
    passworded_servers: 'Passworded servers disallowed',
    slack_disallowed: 'Slack disallowed'
};

var RENDER_REASONS = {
    pool_lost: 'Connection pool failed',
    no_pool: 'No available connection pools',
    enetdown: 'Network down',
    etimedout: 'Timed out',
    timeout: 'Timed out',
    closed: 'Connection closed',
    enotconn: 'Connection unavailable',
    ehostunreach: 'Host unreachable',
    econnrefused: 'Connection refused',
    nxdomain: 'Invalid hostname',
    einval: 'Invalid hostname',
    ssl_certificate_error: 'SSL certificate error',
    ssl_error: 'SSL error',
    crash: 'Connection crashed'
};

var SSL_VERIFY_ERRORS = {
    bad_cert: {
        unknown_ca: 'Unknown certificate authority',
        selfsigned_peer: 'Self signed certificate',
        cert_expired: 'Certificate expired',
        invalid_issuer: 'Invalid certificate issuer',
        invalid_signature: 'Invalid certificate signature',
        name_not_permitted: 'Invalid certificate alternative hostname',
        missing_basic_constraint: 'Missing certificate basic contraints',
        invalid_key_usage: 'Invalid certificate key usage'
    },
    ssl_verify_hostname: {
        unable_to_match_altnames: 'Certificate hostname mismatch',
        unable_to_match_common_name: 'Certificate hostname mismatch',
        unable_to_decode_common_name: 'Invalid certificate hostname'
    }
};

var POST_ERRORS = {
    connection_down: function (message, response) {
        return "Connection offline, your " + (message ? 'message' : 'request') + " wasn’t sent";
    },
    connection_unavailable: function (message, response) {
        return "Connection temporarily unavailable, your " + (message ? 'message' : 'request') + " wasn’t sent. Try again later";
    },
    database_down: "Service unavailable. Try again later.",
    auth: "Forbidden",
    invalid_org_id: "Invalid team ID",
    invalid_cid: "Invalid connection ID",
    invalid_nick: "Invalid nickname",
    invalid_edit: "Message edits can't be blank",
    paste_too_large: "Sorry, you can’t paste more than 50 KB of text.",
    paste_invalid: "Sorry, you need to paste valid UTF8.",
    paste_empty: "No empty pastes allowed",
    file_too_large: function (message, response) {
        var size = '';
        var fileSize = response.size || response.content_length;
        if (fileSize) {
            size = ' (upload is ' + FileWrapper.sizeToString(fileSize) + ')';
        }
        return "Sorry, you can’t upload files larger than 15 MB." + size;
    },
    invalid_file_type: "Sorry, you need to upload a valid file",
    image_too_large: "Sorry, you can’t upload images larger than 25 Megapixels",
    file_write_error: "Failed to upload a file",
    banned_content: "Banned content",
    upload_limit_reached: "Sorry, you can’t upload more than 100 MB of files",
    unverified: "Email verification required",
    missing_file: "No file uploaded",
    upload_already_exists: "You’ve already uploaded this file",
    invalid_upload_id: "Invalid upload ID",
    upload_not_found: "Upload not found",
    upload_error: "Failed to upload a file",
    batch_upload_failed: "Failed to upload files",
    blocked_command: "This command has been blocked",
    invalid_topic: "Invalid topic"
};

function renderReason (reason) {
    return RENDER_REASONS[reason] || reason;
}

function renderSSLVerify (info) {
    if (info) {
        var type = SSL_VERIFY_ERRORS[info.type];
        if (type) {
            var error = type[info.error];
            if (error) {
                return error;
            }
        }
        return info.type + ': ' + info.error;
    }
}

function renderRestrictedReason (reason) {
    var defaultReason = 'You can’t connect to this server with a free account. <b>Upgrade now</b>';
    return RESTRICTED_REASONS[reason] || defaultReason;
}

function renderRestrictedReasonShort (reason) {
    var defaultReason = 'Limited';
    return RESTRICTED_REASONS_SHORT[reason] || defaultReason;
}

function renderPostError (response, message) {
    response = response || {};
    var defaultError = message ? "We failed to send your message" : "Your request failed";
    if (_.isFunction(POST_ERRORS[response.message])) {
        return POST_ERRORS[response.message](message, response);
    } else {
        return POST_ERRORS[response.message] || (defaultError + ': ' + response.message);
    }
}

module.exports = {
    render: renderReason,
    renderRestricted: renderRestrictedReason,
    renderRestrictedShort: renderRestrictedReasonShort,
    renderPostError: renderPostError,
    renderSSLVerify: renderSSLVerify
};


/***/ }),

/***/ "j9Sh":
/***/ (function(module, exports, __webpack_require__) {

var RenderReasons = __webpack_require__("ilaq");
var User = __webpack_require__("Xgjh");
var UserMixins = __webpack_require__("+9gY");
var util = __webpack_require__("GmLC");
var IRCFormatter = __webpack_require__("XiBv");


var Message = Backbone.Model.extend($.extend(true, {}, UserMixins, {
    idAttribute: 'eid',
    toString: function () {
        var string = '[' + this.getDate().formatTime();
        if (this.has('chan')) {
            string += ' ' + this.get('chan');
        }
        string += '] ';
        if (this.has('from')) {
            string += this.get('from') + ': ';
        }
        string += this.get('msg') || ('(' + this.get('type') + ')');
        if (this.get('nick')) {
            string += ' [' + this.get('nick') + ']';
        }
        if (this.get('name')) {
            string += ' <' + this.get('name') + '>';
        }
        return string;
    },
    initialize: function (data, options) {
        this.buffer = options.buffer;
        if (!this.buffer && this.collection) {
            this.buffer = this.collection.buffer;
        }
        if (this.buffer) {
            this.connection = this.buffer.connection;
        }
        if (this.collection) {
            this.collection.registerThread(this);
        }
    },
    clone: function () {
        return new Message(this.attributes, {
            buffer: this.buffer
        });
    },
    getCid: function () {
        return this.get('cid');
    },
    bid: function () {
        return this.get('bid');
    },
    getThreadBuf: function () {
        if (this.isInThreadCollection()) {
            return this.collection.thread;
        }
        if (this.buffer.isThread()) {
            return this.buffer;
        }
    },
    getEventId: function (eid) {
        var eventId = 'e' + this.bid() + '_' + this.id;
        var thread = this.getThreadBuf();
        if (thread) {
            eventId = eventId + '_t_' + thread.cid;
        }
        return eventId;
    },
    show: function () {
        this.trigger('show', this, {
            highlight: true
        });
    },
    isHighlight: function () {
        return this.get('highlight');
    },
    isImportantHighlight: function () {
        return this.isImportant() && this.isHighlight();
    },
    getNick: function () {
        return this.get('newnick') || this.get('from') || this.get('nick');
    },
    isPrivmsg: function () {
        return this.get('type') === 'buffer_msg';
    },
    isMeMsg: function () {
        return this.get('type') === 'buffer_me_msg';
    },
    isIgnorable: function () {
        return Message.isIgnorable(this.get('type'));
    },
    isEmpty: function () {
        return Message.isEmpty(this.get('type')) ||
            (this.isAttachmentFallback() && !this.hasAttachment()) ||
            !!this.getConcatTag() ||
            !!this.getEdit() ||
            (this.isDeletedOrRedacted() && !this.buffer.isShowingDeletedMessages());
    },
    getConcatId: function () {
        return this.getConcatTag() || this.getMsgId();
    },
    hasConcatTag: function () {
        var clientTags = this.getClientTags();
        return '+draft/concat-start' in clientTags ||
            '+draft/concat' in clientTags ||
            '+draft/concat-line' in clientTags ||
            '+draft/concat-end' in clientTags;
    },
    getConcatTag: function () {
        var clientTags = this.getClientTags();
        return clientTags['+draft/concat'] || clientTags['+draft/concat-line'];
    },
    getConcat: function () {
        var clientTags = this.getClientTags();
        return clientTags['+draft/concat'];
    },
    getConcatLine: function () {
        var clientTags = this.getClientTags();
        return clientTags['+draft/concat-line'];
    },
    setConcatStart: function () {
        var props = {};
        if (!this.getMsgId()) {
            props.msgid = this.id;
            this.fakeMsgId = true;
        }
        var entities = this.getEntities();
        var clientTags = this.getClientTags();
        clientTags['+draft/concat-start'] = true;
        entities.client_tags = clientTags;
        props.entities = entities;
        this.set(props);
    },
    setConcatLine: function (msgid, end) {
        var entities = this.getEntities();
        var clientTags = this.getClientTags();
        clientTags['+draft/concat-line'] = msgid;
        if (end) {
            clientTags['+draft/concat-end'] = true;
        }
        entities.client_tags = clientTags;
        this.set({entities: entities});
    },
    concat: function (message) {
        var concats = this.get('concats') || {};
        if (message.id in concats) {
            return false;
        }
        concats[message.id] = message;
        var newMsg = this.get('msg');
        if (message.getConcatLine()) {
            newMsg += '\n';
        }
        this.concatMentions(message, newMsg.length);
        newMsg += message.get('msg');
        this.set({
            msg: newMsg,
            concats: concats
        });
        return true;
    },
    getReplyId: function () {
        return this.getReply() || this.getMsgId();
    },
    getMsgId: function () {
        if (this.has('msgid')) {
            return this.get('msgid');
        }
        var twitchTags = this.getTwitchTags();
        if (twitchTags) {
            return twitchTags['id'];
        }
    },
    getReaction: function () {
        return this.getEntities().react || this.getKnownClientTags().react;
    },
    getUnreaction: function () {
        return this.getEntities().unreact || this.getKnownClientTags().unreact;
    },
    getReactionImage: function () {
        var image = this.getEntities().react_image || this.getClientTags()['+draft/react-image'];
        if (image && image.match(/https:\/\/.+/)) {
            return image;
        }
    },
    getReplyTag: function () {
        return this.getEntities().reply || this.getKnownClientTags().reply;
    },
    getReply: function () {
        var reply = this.getReplyTag();
        if (reply) {
            return reply;
        }
        var twitchTags = this.getTwitchTags();
        if (twitchTags) {
            return twitchTags['reply-parent-msg-id'];
        }
    },
    quoteReplyString: function () {
        var reply = this.getReplyId();
        if (reply) {
            var replyMessage = this.buffer.messages.findByMsgId(reply);
            if (replyMessage && replyMessage.isEmpty()) {
                return;
            }
            var string = 'Replying to ';
            if (replyMessage) {
                string += replyMessage.getDisplayName();
                string += ': ' + util.truncate(replyMessage.get('msg'), 120);
            } else {
                string += 'an earlier message';
            }
            return string;
        }
        var twitchTags = this.getTwitchTags();
        if (twitchTags && 'reply-parent-display-name' in twitchTags) {
            var twitchString = 'Replying to @' + twitchTags['reply-parent-display-name'];
            if ('reply-parent-msg-body' in twitchTags) {
                twitchString += ': ' + util.truncate(twitchTags['reply-parent-msg-body'], 120);
            }
            return twitchString;
        }
    },
    isInThread: function () {
        if (this.isInThreadCollection()) {
            return true;
        }
        if (this.getReply()) {
            return true;
        }
        var msgId = this.getMsgId();
        if (msgId && this.collection) {
            return this.collection.isInThread(msgId);
        }
        return false;
    },
    isReplyTargetSelf: function () {
        var reply = this.getReply();
        if (!reply) {
            return false;
        }
        var target = this.buffer.messages.findByMsgId(reply);
        if (target && target.isSelf()) {
            return true;
        }
        return false;
    },
    isInThreadCollection: function () {
        return !!this.collection && !!this.collection.thread;
    },
    isSameThread: function (message, replyId) {
        var buf = this.getThreadBuf();
        if (buf && buf == message.getThreadBuf()) {
            return true;
        }
        if (!replyId) {
            replyId = this.getReplyId();
        }
        return replyId === message.getReplyId() || replyId == message.getMsgId();
    },
    getReplies: function () {
        return this.getThread(true).slice(1);
    },
    getThread: function (excludeEmpty) {
        var replyId = this.getReplyId();
        if (replyId && this.collection) {
            return this.collection.getThread(replyId, excludeEmpty);
        }
        return [this];
    },
    isConcatenation: function (message, concatId) {
        if (!concatId) {
            concatId = this.getConcatId();
        }
        return concatId === message.getConcatId();
    },
    getConcatParent: function () {
        var concatId = this.getConcatTag();
        if (concatId && this.collection) {
            return this.collection.find(function (m) {
                return concatId === m.getMsgId();
            });
        }
    },
    getConcats: function () {
        var concatId = this.getConcatId();
        var msgIds = {};
        if (concatId && this.collection) {
            return this.collection.filter(function (m) {
                if (this.isConcatenation(m, concatId)) {
                    if (m.getMsgId()) {
                        msgIds[m.getMsgId()] = true;
                    }
                    return true;
                } else if (msgIds[m.getConcatId()]) {
                    return true;
                }
            }, this);
        }
        return [this];
    },
    isEditable: function () {
        return (
            this.buffer.connection.hasReliableClientTags() &&
            !this.buffer.connection.blocksEdits() &&
            this.doIsEditable()
        );
    },
    doIsEditable: function () {
        return !this.fakeMsgId &&
            this.has('msgid') &&
            Message.isEditable(this.get('type'));
    },
    doIsDeletable: function () {
        return !this.fakeMsgId &&
            this.has('msgid') &&
            Message.isDeletable(this.get('type'));
    },
    isRedactable: function () {
        return this.buffer.connection.hasRedaction() && (
            this.hasSameAccount(this.buffer.user) || (
                this.buffer.userMember && this.buffer.userMember.canOp()
            )
        );
    },
    isDeletable: function () {
        return (
            this.buffer.connection.hasReliableClientTags() &&
            !this.buffer.connection.blocksDeletes() &&
            this.doIsDeletable() &&
            this.hasSameAccount(this.buffer.user)
        );
    },
    isReplyable: function () {
        return (
            this.buffer.connection.hasReliableClientTags() &&
            !this.buffer.connection.blocksReplies() &&
            this.doIsReplyable()
        );
    },
    doIsReplyable: function () {
        return !this.fakeMsgId && this.has('msgid') && Message.isReplyable(this.get('type'));
    },
    isTwitchReplyable: function () {
        return !this.fakeMsgId && Message.isReplyable(this.get('type'));
    },
    isReactable: function () {
        return (
            this.buffer.connection.hasReliableClientTags() &&
            !this.buffer.connection.blocksReactions() &&
            this.doIsReactable()
        );
    },
    doIsReactable: function () {
        return !this.fakeMsgId && this.has('msgid') && Message.isReactable(this.get('type'));
    },
    isTopLevel: function () {
        return !this.getReply();
    },
    isClientTaggable: function () {
        return Message.isClientTaggable(this.get('type'));
    },
    areEmbedsAllowed: function () {
        return Message.areEmbedsAllowed(this.get('type'));
    },
    getReplacements: function () {
        var twitchEmotes = this.getTwitchEmotes() || [];
        var customEmoji = this.getCustomEmoji() || [];
        var mentions = this.getMentions() || [];
        var replacements = mentions.concat(customEmoji).concat(twitchEmotes);
        if (replacements.length) {
            replacements.sort(function (a, b) {
                var aOffset = a.startOffset || 0;
                var aStart = aOffset + (a.start);
                var bOffset = b.startOffset || 0;
                var bStart = bOffset + (b.start);
                return aStart - bStart;
            });
            return replacements;
        }
    },
    concatMentions: function (message, startOffset) {
        var mentions = message.getMentions();
        if (mentions) {
            if (!this.mentionConcats) {
                this.mentionConcats = [];
            }
            _.each(mentions, function (mentionOffset) {
                mentionOffset.startOffset = startOffset;
                this.mentionConcats.push(mentionOffset);
            }, this);
        }
    },
    getMentionData: function () {
        return this.getEntities().mention_data || {};
    },
    getMentions: function () {
        var mentions = this.getEntities().mentions;
        if (!this.mentionConcats && (!mentions || !$.isPlainObject(mentions))) {
            return;
        }
        var offsets = [];
        // {
        //     nick: [
        //         [0,4],
        //         [5,4]
        //     ]
        // }
        _.each(mentions, function (idx, nick) {
            if (!nick || !idx || !_.isArray(idx)) {
                return;
            }
            _.each(idx, function (idxOffset) {
                if (!idxOffset || !_.isArray(idxOffset) || idxOffset.length !== 2) {
                    return;
                }
                var start = idxOffset[0]-0;
                var length = idxOffset[1]-0;
                offsets.push({
                    type: 'mention',
                    nick: nick,
                    start: start,
                    end: start + length
                });
            });
        });
        if (offsets.length || this.mentionConcats) {
            return (offsets || []).concat(this.mentionConcats || []);
        }
    },
    getEmojiTag: function () {
        return this.getEntities().emoji || this.getClientTags()['+draft/emoji'];
    },
    getCustomEmoji: function () {
        var customEmoji = this.getEmojiTag();
        if (!customEmoji) {
            return;
        }
        var customEmojiJson;
        if (_.isArray(customEmoji)) {
            customEmojiJson = customEmoji;
        } else {
            try {
                customEmojiJson = JSON.parse(customEmoji);
            } catch (exc) {
                // pass
            }
        }
        return Message.getCustomEmoji(customEmojiJson);
    },
    getTwitchEmotes: function () {
        var twitchTags = this.getTwitchTags();
        if (!twitchTags || !twitchTags.emotes) {
            return;
        }
        var offsets = [];
        // Twitch counts the characters '/me ' as part of the message
        var adjustment = this.isMeMsg() ? 4 : 0;
        _.each(twitchTags.emotes.split('/'), function (token) {
            var bounds = token.match(/^(\d+):((?:\d+-\d+,?)+)$/);
            if (bounds) {
                _.each(bounds[2].split(','), function(offsetPair) {
                    var offset = offsetPair.split('-');
                    var bound = {
                        type: 'twitch_emote',
                        emote: bounds[1]-0,
                        start: offset[0]-adjustment,
                        end: (offset[1]-adjustment) + 1
                    };
                    if (bound.end > bound.start) {
                        offsets.push(bound);
                    }
                });
            }
        });
        if (offsets.length) {
            return offsets;
        }
    },
    getEmbeds: function () {
        return !this.isPending() && (this.get('entities') || this.areEmbedsAllowed());
    },
    getEntities: function () {
        return this.get('entities') || {};
    },
    getClientTags: function () {
        return this.getEntities().client_tags || {};
    },
    getKnownClientTags: function () {
        return this.getEntities().known_client_tags || {};
    },
    getTwitchTags: function () {
        return this.getEntities().twitch_tags;
    },
    getRawHostmask: function () {
        return this.get('hostmask') || this.get('usermask');
    },
    getRawIdent: function () {
        return this.get('from_user');
    },
    getRawHost: function () {
        return this.get('from_host');
    },
    getAccount: function () {
        return this.fallbackValue('target_account', 'from_account', 'account');
    },
    getRealname: function () {
        return this.fallbackValue('target_realname', 'from_realname', 'realname');
    },
    fallbackValue: function (key, fallback1, fallback2) {
        var value = this.get(key);
        if (!value && !this.isUserChannelMode()) {
            var fallback = this.get(fallback1);
            if (!fallback && fallback2) {
                fallback = this.get(fallback2);
            }
            return fallback || value;
        }
        return value;
    },
    isIgnored: function (options) {
        if (!this.isIgnorable()) {
            return false;
        }
        return this.connection.isIgnored(this.getNick(), this.getHostMask(), options);
    },
    isInCollapsedThread: function () {
        var reply = this.getReply();
        if (reply) {
            return this.buffer.isThreadCollapsed(reply);
        }
        return false;
    },
    isImportant: function () {
        // Self messages aren't important
        if (this.isSelf()) {
            return false;
        }
        if (this.isEmpty()) {
            return false;
        }
        if (this.isNotice() || this.isChannelInvite()) {
            // Notices sent from the server (with no nick sender) aren't important
            // e.g. *** Looking up your hostname...
            if (!this.get('from')) {
                return false;
            }
            // Notices or channel invites sent to a buffer aren't important in the server buffer
            if (this.buffer.isServerLog() && (this.get('to_chan') || this.get('to_buffer'))) {
                return false;
            }
        }
        return _.include(Message.important, this.get('type'));
    },
    isNotice: function () {
        return this.get('type') == 'notice';
    },
    isChannelInvite: function () {
        return this.get('type') == 'channel_invite';
    },
    isNotableExempt: function () {
        return this.isSelf() || !this.isImportant() || this.isIgnored();
    },
    isNotable: function () {
        // Don't notify on self, unimportant messages or ignored messages
        if (this.isNotableExempt()) {
            return false;
        }
        if (this.buffer.shouldMuteNotifications()) {
            return false;
        }
        return this.isHighlightable() ||
               (this.buffer.isChannel() && this.buffer.shouldNotifyAll() && !this.isNotice());
    },
    isHighlightable: function () {
        // Don't notify on self, unimportant messages or ignored messages
        if (this.isNotableExempt()) {
            return false;
        }
        if (this.buffer.shouldMuteNotifications()) {
            return false;
        }
        return this.isHighlight() ||
            (
                (
                    this.buffer.isConversation() || 
                    (this.buffer.isChannel() && this.buffer.isSlackMultiPersonDm())
                ) &&
                this.buffer.isTrackingUnread() &&
                !this.isNotice()
            ) ||
            this.isChannelInvite() ||
            this.get('type') == 'callerid' ||
            this.get('type') == 'wallops';
    },
    equals: function (eid) {
        if (eid instanceof Message) {
            eid = eid.id;
        }
        return this.id == eid;
    },
    isSelf: function () {
        return !!this.get('self');
    },
    isThrottlable: function () {
        return this.isSelf() &&
            !this.isThrottled() &&
            _.include(Message.throttlable, this.get('type'));
    },
    isThrottled: function () {
        return !!this.get('throttled');
    },
    markAsThrottled: function () {
        this.set('throttled', true);
    },
    isPending: function () {
        return !!this.get('_pendingreqid');
    },
    isEphemeral: function () {
        return !!this.get('ephemeral');
    },
    isJoinPart: function () {
        return _.include(Message.joinPart, this.get('type')) ||
            this.isNickModeListChange();
    },
    isHideableJoinPart: function () {
        return _.include(Message.hideableJoinPart, this.get('type'));
    },
    isUserChannelMode: function () {
        return this.get('type') == 'user_channel_mode';
    },
    isChannelMode: function () {
        return this.get('type') == 'channel_mode';
    },
    isNickModeListChange: function () {
        if (this.get('type') != 'channel_mode_list_change') {
            return false;
        }
        var opList = this.get('ops').add.length ? this.get('ops').add : this.get('ops').remove;
        if (opList.length) {
            var op = opList[0];
            if (op.mode == 'a') {
                // protected
                return true;
            }
            if (op.mode == 'q' && op.param.indexOf('@') === -1 && op.param.indexOf('$') === -1) {
                // If just a nick then this is an owner
                // quiet masks always have @
                // extbans always have $
                return true;
            }
        }
        return false;
    },

    makeUser: function (nick) {
        if (nick === undefined) {
            nick = this.getNick();
        }
        return new User({
            nick: nick,
            usermask: this.fallbackValue('target_hostmask', 'hostmask', 'usermask'),
            ident_prefix: this.fallbackValue('target_ident_prefix', 'ident_prefix'),
            user: this.fallbackValue('target_name', 'from_name'),
            userhost: this.fallbackValue('target_host', 'from_host'),
            mode: this.isChannelMode() ? this.get('from_mode') : this.fallbackValue('newmode', 'from_mode'),
            account: this.getAccount(),
            realname: this.getRealname(),
            avatar: this.fallbackValue('target_avatar', 'avatar'),
            avatar_url: this.fallbackValue('target_avatar_url', 'avatar_url'),
            display_name: this.fallbackValue('target_display_name', 'display_name'),
            bot_url: this.fallbackValue('target_bot_url', 'bot_url')
        }, {
            session: this.buffer.session,
            connection: this.connection,
            buffer: this.buffer,
            message: this
        });
    },
    isDisconnect: function () {
        return _.include(Message.disconnect, this.get('type'));
    },
    getDisconnectMessage: function () {
        var msg = '';
        var reason = this.get('reason');
        switch (this.get('type')) {
        case 'socket_closed':
            if (this.get('timedout')) {
                msg = "Connection timed out";
            } else if (this.get('pool_lost')) {
                msg = "Connection pool lost";
            } else if (this.get('crash')) {
                msg = "Connection crashed";
            } else if (this.get('abnormal')) {
                msg = "Connection closed unexpectedly";
            } else if (this.get('limited')) {
                msg = "Connection restricted";
            }
            if (reason) {
                if (msg) {
                    msg += ': ';
                }
                msg += RenderReasons.render(reason);
            }
            break;
        case 'connecting_failed':
            if (reason == 'ssl_verify_error') {
                msg = 'Strict transport security error';
                var verifyError = RenderReasons.renderSSLVerify(this.get('ssl_verify_error'));
                if (verifyError) {
                    msg += ': ' + verifyError;
                }
            } else {
                msg = 'Failed to connect: ' + RenderReasons.render(reason);
            }
            break;
        case 'connecting_cancelled':
            if (this.get('sts')) {
                msg = 'Upgrading connection security';
            } else {
                msg = 'Cancelled';
            }
            break;
        }
        if (this.get('limited')) {
            msg += ' (' + RenderReasons.renderRestrictedShort(this.get('limited')) + ')';
        }
        if (this.get('give_up')) {
            msg += ' (gave up)';
        }
        return msg;
    },
    getTime: function () {
        if (this.get('server_time')) {
            return this.get('server_time');
        }
        if (this.id) {
            return this.buffer.session.backend.tsOffset(this.id / 1000);
        }
    },
    getDate: function () {
        var time = this.getTime();
        if (time) {
            return new Date(time);
        }
    },
    index: function () {
        if (this.collection) {
            return this.collection.indexOf(this);
        }
    },
    areBothJoinPart: function (message) {
        if (message) {
            return this.isJoinPart() && message.isJoinPart();
        }
    },
    areBothDisconnect: function (message) {
        if (message) {
            return this.isDisconnect() && message.isDisconnect();
        }
    },
    previousReplyable: function (differentThread) {
        var replyId = this.getReplyId();
        var prev = this.previousMessage();
        while (prev && (
            !prev.isReplyable() ||
            (differentThread && this.isSameThread(prev, replyId))
        )) {
            prev = prev.previousMessage();
        }
        return prev;
    },
    nextReplyable: function (differentThread) {
        var replyId = this.getReplyId();
        var next = this.nextMessage();
        while (next && (
            !next.isReplyable() ||
            (differentThread && this.isSameThread(next, replyId))
        )) {
            next = next.nextMessage();
        }
        return next;
    },
    previousVisible: function () {
        if (this._previousMessage) {
            return this._previousMessage;
        }
        var prev = this.previousMessage();
        while (prev && prev.isEmpty()) {
            prev = prev.previousMessage();
        }
        return prev;
    },
    nextVisible: function () {
        if (this._nextMessage) {
            return this._nextMessage;
        }
        var next = this.nextMessage();
        while (next && next.isEmpty()) {
            next = next.nextMessage();
        }
        return next;
    },
    previousMessage: function () {
        if (this._previousMessage) {
            return this._previousMessage;
        }
        if (this.collection) {
            return this.collection.previous(this);
        }
    },
    nextMessage: function () {
        if (this._nextMessage) {
            return this._nextMessage;
        }
        if (this.collection) {
            return this.collection.next(this);
        }
    },
    hasSlackBlocks: function () {
        return this.getSlackBlocks().length > 0;
    },
    getSlackBlocks: function () {
        var blocks = this.getEntities().slack_blocks || [];
        return _.filter(blocks, function (b) {
            return b.type !== 'rich_text';
        });
    },
    getAttachmentsTag: function (editFallback) {
        return this.getEntities().attachments ||
            this.getClientTags()['+draft/attachments'] ||
            (editFallback && this.getClientTags()['+draft/edit-attachments']);
    },
    hasAttachment: function () {
        return this.getAttachmentsJson().length > 0;
    },
    getAttachmentsJson: function () {
        var attachTag = this.getAttachmentsTag();
        if (!_.isArray(attachTag)) {
            var attach = [];
            try {
                attach = JSON.parse(attachTag);
            } catch (exc) {
                attach = [];
            }
            if (!_.isArray(attach)) {
                attach = [];
            }
            var entities = this.getEntities();
            entities.attachments = attach;
            this.set('entities', entities);
            attachTag = attach;
        }
        var suppress = false;
        return _.filter(attachTag, function (att) {
            if (!att || suppress) {
                return false;
            }
            switch (att.service_name) {
            case 'twitter':
            case 'X (formerly Twitter)':
                suppress = true;
                return false;
            case 'Imgur':
            case 'Gfycat':
                return false;
            default:
                return true;
            }
        });
    },
    isAttachmentFallback: function () {
        return !!this.getEntities().attachment_fallback ||
            ('+draft/attachment-fallback' in this.getClientTags());
    },
    getAvatar: function () {
        return UserMixins.getAvatar.call(this, {
            avatar_url: this.getEntities().icon,
            noGravatar: !!this.getTagDisplayName() && !!this.parseDisplayAuthor()
        });
    },
    hasSameAuthor: function (message) {
        return !!(
            message &&
            message.get('type') == this.get('type') &&
            message.get('from') == this.get('from') &&
            message.get('target') == this.get('target') &&
            message.channelContext() == this.channelContext() &&
            _.isEqual(message.getRealname(), this.getRealname()) &&
            _.isEqual(message.getAvatar(), this.getAvatar()) &&
            message.getDisplayAuthor() == this.getDisplayAuthor() &&
            this.hasSameDate(message)
        );
    },
    hasSameAccount: function (message) {
        var account = this.getAccount();
        if (account && account != '*') {
            return account === message.getAccount();
        }
        return false;
    },
    getRedact: function () {
        if (this.get('type') == 'redact') {
            return this.get('redact_msgid');
        }
    },
    getDelete: function () {
        return this.getEntities()['delete'] || this.getClientTags()['+draft/delete'];
    },
    delete: function () {
        if (this.collection) {
            this.collection.remove(this);
        } else {
            this.trigger('remove');
        }
    },
    canDelete: function (message) {
        return this.getEntities()['server_delete'] || this.hasSameAccount(message) || !!this.getRedact();
    },
    getEdit: function () {
        return this.getEntities().edit || this.getClientTags()['+draft/edit'];
    },
    getEditOrig: function () {
        var edits = this.get('edits');
        return _.find(this.get('edits'), function (m, eid) {
            return m.get('previous_msg');
        });
    },
    getEditText: function () {
        return this.getEntities().edit_text || this.getClientTags()['+draft/edit-text'];
    },
    redact: function (message) {
        this.set('redacted', message);
        return true;
    },
    isRedacted: function () {
        return !!this.getRedacted();
    },
    getRedacted: function () {
        return this.get('redacted');
    },
    remove: function (message) {
        this.set('deleted', message);
        return true;
    },
    getDeletion: function () {
        return this.get('deleted');
    },
    isDeleted: function () {
        return !!this.get('deleted');
    },
    isDeletedOrRedacted: function () {
        return this.isDeleted() || this.isRedacted();
    },
    edit: function (message) {
        var edits = this.get('edits') || {};
        if (message.id in edits) {
            return false;
        }
        edits[message.id] = message;
        var props = {
            edits: edits
        };
        var editClientTags = message.getClientTags();
        var editEntities = message.getEntities();
        var editText = message.getEditText();
        var entities = this.getEntities();
        if (editText) {
            message.set('previous_msg', this.get('msg'));
            props.msg = editText;
            entities.attachment_fallback = false;
        }
        var editAttach = message.getAttachmentsTag(true);
        entities.attachments = editAttach;

        var editEmoji = message.getEmojiTag();
        if (this.mentionConcats && (editText || editEmoji)) {
            delete this.mentionConcats;
        }
        var editMentions = message.getEntities().mentions;
        if (editMentions || entities.mentions || editEmoji) {
            // Reset mentions from edit message
            if (editText || editEmoji) {
                entities.mentions = editMentions;
            }
            if (editEmoji) {
                entities.emoji = editEmoji;
            }
            props.entities = entities;
        }
        if (!_.isEmpty(props)) {
            this.set(props);
        }
        return true;
    },
    getUserDisplayName: function () {
        return this.get('display_name');
    },
    isBot: function () {
        return !!this.getEntities().bot || this.isRelayBot();
    },
    isRelayBot: function () {
        return this.connection.isRelayBot(this.getNick());
    },
    channelContext: function () {
        return this.get('channel_context');
    },
    relayMsgRelay: function () {
        return this.getEntities().relaymsg;
    },
    relayMsgParts: function (name) {
        var parts = {
            nick: name
        };
        var relay = this.relayMsgRelay();
        if (relay) {
            parts.relay = relay;
            if (this.connection) {
                var separator = this.connection.getRelayMsgSeparator();
                if (separator) {
                    var splitParts = name.split(separator);
                    parts.nick = splitParts[0];
                    parts.server = splitParts[1];
                }
            }
        }
        return parts;
    },
    getTagDisplayName: function () {
        var ent = this.getEntities().displayname;
        if (ent) {
            return ent;
        }
        var ct = this.getClientTags()['+draft/displayname'];
        if (ct) {
            return ct;
        }
    },
    parseDisplayAuthor: function () {
        if (!this.isRelayBot()) {
            return;
        }
        var match = this.matchRelayBot();
        if (match) {
            return match[1];
        }
    },
    matchRelayBot: function () {
        if (!this.isPrivmsg() && !this.isMeMsg() && !this.isNotice()) {
            return;
        }
        if (!this.get('msg')) {
            return;
        }
        var stripped = IRCFormatter.strip(IRCFormatter.stripZWSP(this.get('msg')));
        return stripped.match(/^<([^>]+)>:? /) || stripped.match(/^`([^`]+)`:? /) || stripped.match(/^\[([^\]]+)\]:? /);
    },
    getMessageDisplayName: function () {
        var dn = this.getTagDisplayName();
        if (dn) {
            return dn;
        }
        var twitchTags = this.getTwitchTags();
        if (twitchTags) {
            return twitchTags['display-name'];
        }
        if (this.isRelayBot()) {
            return this.parseDisplayAuthor();
        }
    },
    getDisplayAuthor: function () {
        var dn = this.getMessageDisplayName();
        if (dn) {
            return dn;
        }
        return this.getUserDisplayName();
    },
    getDisplayName: function () {
        return this.getDisplayAuthor() || this.getNick() || this.get('server');
    },
    hasSameDate: function (date) {
        if (date) {
            if (date instanceof Message) {
                date = date.getDate();
            }
            return this.getDate().isSameDay(date);
        }
    },
    hasSameDateAsNext: function () {
        return this.hasSameDate(this.nextMessage());
    },
    hasSameDateAsPrevious: function () {
        return this.hasSameDate(this.previousMessage());
    },
    isAfter: function (message) {
        return this.id > message.id;
    },
    isBefore: function (message) {
        return this.id < message.id;
    },
    isLastSeen: function () {
        return this.id == this.buffer.getLastSeen();
    },
    isNetSplit: function () {
        if (this.get('type') !== 'quit') {
            return false;
        }
        return Message.isNetSplit(this.get('msg'));
    },
    isOnlyEmojiNative: function () {
        return this.isOnlyEmoji(true);
    },
    isOnlyEmoji: function (nativeOnly) {
        var customEmoji = this.getCustomEmoji() || [];
        var msg = this.get('msg');
        var value = msg;
        var index = 0;
        var stripped = '';
        _.each(customEmoji, function (replacement) {
            var rStart = replacement.start;
            var rEnd = replacement.end;
            if (
                rStart >= 0 &&
                rStart <= msg.length &&
                rEnd <= msg.length
            ) {
                stripped += util.stringSlice(msg, index, rStart);
                value = util.stringSlice(msg, rEnd);
                index = rEnd;
            }
        });
        stripped += value;
        stripped = stripped.trim();
        if (!nativeOnly) {
            stripped = emoji.replace_colons(stripped, true);
        }
        return emoji.strip_unified(stripped) === '';
    }
}), {
    LONG_MESSAGE_LIMIT: 7200,
    THROTTLE_RE: /\*\*\* Message to (#[^\s]+) throttled due to flooding/,
    NETSPLIT_RE: /^(?:[^\s:\/.]+\.)+[a-z]{2,} (?:[^\s:\/.]+\.)+[a-z]{2,}$/i,
    checkThrottleChan: function (msg) {
        var match = msg.match(Message.THROTTLE_RE);
        if (match) {
            return match[1];
        }
    },
    isNetSplit: function (msg) {
        // From irssi 0.8.15
    /* NOTE: there used to be some paranoia checks (some older IRC
       clients have even more), but they're pretty useless nowadays,
       since IRC server prefixes the quit message with a space if it
       looks like a netsplit message.

       So, the check is currently just:
             - host1.domain1 host2.domain2
             - top-level domains have to be 2+ characters long,
           containing only alphabets
         - only 1 space
         - no double-dots (".." - probably useless check)
         - hosts/domains can't start or end with a dot
             - the two hosts can't be identical (probably useless check)
         - can't contain ':' or '/' chars (some servers allow URLs) */
        if ((Message.NETSPLIT_RE).test(msg)) {
            var parts = msg.split(' ');
            if (parts[0] !== parts[1]) {
                return true;
            }
        }
        return false;
    },
    isIgnorable: function (type) {
        return _.include(Message.ignorable, type);
    },
    isEmpty: function (type) {
        return _.include(Message.empty, type);
    },
    isReactable: function (type) {
        return _.include(Message.reactable, type);
    },
    isEditable: function (type) {
        return _.include(Message.editable, type);
    },
    isDeletable: function (type) {
        return _.include(Message.deletable, type);
    },
    isReplyable: function (type) {
        return _.include(Message.replyable, type);
    },
    isClientTaggable: function (type) {
        return _.include(Message.client_tag_types, type);
    },
    areEmbedsAllowed: function (type) {
        return _.include(Message.embeds_allowed, type);
    },

    getCustomEmoji: function (customEmojiJson) {
        if (!customEmojiJson || !_.isArray(customEmojiJson)) {
            return;
        }
        var offsets = [];
        // [{
        //     url: 'https://example.com/emoji.png',
        //     idx: [
        //         [0,4],
        //         [5,4]
        //     ]
        // }]
        _.each(customEmojiJson, function (json) {
            if (!json.url || !json.url.match(/https:\/\/.+/)) {
                return;
            }
            if (!json.idx || !_.isArray(json.idx)) {
                return;
            }
            _.each(json.idx, function (jsonOffset) {
                if (!jsonOffset || !_.isArray(jsonOffset) || jsonOffset.length !== 2) {
                    return;
                }
                var start = jsonOffset[0]-0;
                var length = jsonOffset[1]-0;
                offsets.push({
                    type: 'emoji',
                    url: json.url,
                    start: start,
                    end: start + length
                });
            });
        });
        if (offsets.length) {
            offsets.sort(function (a, b) {
                return a.start - b.start;
            });
            return offsets;
        }
    },
    hideableJoinPart: [
        'joined_channel',
        'parted_channel',
        'quit',
        'user_channel_mode',
        'nickchange'
    ],
    joinPart: [
        'you_joined_channel',
        'joined_channel',
        'parted_channel',
        'quit',
        'user_channel_mode',
        'nickchange',
        'channel_mode_is',
        'channel_url',
        'user_chghost'
    ],
    disconnect: [
        'socket_closed',
        'connecting_failed',
        'connecting_cancelled'
    ],
    ignorable: [
        'buffer_msg',
        'buffer_me_msg',
        'notice',
        'channel_invite',
        'callerid',
        'wallops'
    ],
    important: [
        'buffer_msg',
        'buffer_me_msg',
        'notice',
        'channel_invite',
        'callerid',
        'wallops'
    ],
    empty: [
        'redact',
        'empty_msg',
        'empty_notice',
        'backlog_cache_init'
    ],
    throttlable: [
        'buffer_msg',
        'buffer_me_msg'
    ],
    editable: [
        'buffer_msg',
        'notice'
    ],
    deletable: [
        'buffer_msg',
        'buffer_me_msg',
        'notice'
    ],
    replyable: [
        'buffer_msg',
        'buffer_me_msg',
        'notice'
    ],
    reactable: [
        'buffer_msg',
        'buffer_me_msg',
        'notice',
        'you_joined_channel',
        'joined_channel',
        'you_parted_channel',
        'parted_channel',
        'quit',
        'nickchange'
    ],
    client_tag_types: [
        'redact',
        'empty_msg',
        'empty_notice',
        'buffer_msg',
        'buffer_me_msg',
        'notice'
    ],
    embeds_allowed: [
        'buffer_msg',
        'buffer_me_msg',
        'twitch_usernotice',
        'notice'
    ]
});


module.exports = Message;


/***/ }),

/***/ "j9rr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jDU1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _keyboard = __webpack_require__("fDhS");

var _keyboard2 = _interopRequireDefault(_keyboard);

var _selectionCopy = __webpack_require__("YQlf");

var _selectionCopy2 = _interopRequireDefault(_selectionCopy);

var _selectionCopy3 = __webpack_require__("64IP");

var _selectionCopy4 = _interopRequireDefault(_selectionCopy3);

var _overlay = __webpack_require__("jcM0");

var _overlay2 = _interopRequireDefault(_overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-env es6 */
var INIT_STATE = {
    success: false,
    insert: false,
    hide: false,
    show: false,
    fail: false
};

exports.default = Backbone.View.extend({
    template: _selectionCopy2.default,
    tagName: 'button',
    className: 'clipboardTrigger',
    initialize: function initialize(options, bufferView) {
        this.bufferView = bufferView;
    },

    events: {
        'buttonClick': 'onClick'
    },
    setState: function setState(state) {
        this.state = state;
        this.update();
    },
    extendState: function extendState(updates) {
        this.setState(_.extend({}, this.state, updates));
    },
    setInitState: function setInitState() {
        this.setState(INIT_STATE);
    },
    showTextareaOverlay: function showTextareaOverlay() {
        var overlayTextarea = $('<textarea class="clipboardOverlayTextarea">').val(this.textarea.value);
        var overlay = new _overlay2.default(overlayTextarea, {
            prompt: true,
            head: 'Selected lines <span class="explanation">— automatic copying unavailable</span>',
            keepFocus: true,
            afterAppend: _.bind(function () {
                overlayTextarea.focus().select();
            }, this)
        });
        this.bufferView.trigger('addOverlay', overlay);
    },
    update: function update() {
        if (this.state.success || this.state.fail) {
            this.state.hide = true;
        }

        if (this.state.fail) {
            this.showTextareaOverlay();
        }

        this.$el.toggleClass('clipboardTrigger--success', this.state.success);
        this.copyAction.toggleClass('clipboardTriggerAction--hide', this.state.insert);
        this.insertAction.toggleClass('clipboardTriggerAction--hide', !this.state.insert);

        if (this.state.hide || this.state.show) {
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
            }
            this.$el.stop(true, true);
        }

        if (this.state.hide) {
            // Blur and clear the textarea
            this.textarea.value = '';

            if (this.state.success && !this.state.insert) {
                this.hideTimeout = setTimeout(_.bind(function () {
                    this.hideTimeout = null;
                    this.$el.fadeOut('fast', _.bind(function () {
                        this.setInitState();
                    }, this));
                }, this), 1000);
            } else {
                this.$el.hide();
                this.setInitState();
            }
        } else if (this.state.show) {
            this.$el.show();
        }
    },
    render: function render() {
        // This has a significant cost if done at initialisation time
        this.textarea = $('.clipboardHelper')[0];
        this.$el.html(this.template());
        this.copyAction = this.$('.clipboardTriggerAction--copy');
        this.insertAction = this.$('.clipboardTriggerAction--insert');

        this.setInitState();

        // Setup selection change
        this.bufferView.on('textSelectionChange', this.onSelectionChange, this);
        this.bufferView.on('docKeyUp', this.onKeyUp, this);
        this.bufferView.on('docKeyDown', this.onKeyDown, this);
    },
    setInsert: function setInsert(val) {
        this.extendState({ insert: val });
    },
    onKeyDown: function onKeyDown(e) {
        if (!this.state.hide) {
            this.setInsert(_keyboard2.default.isModifier(e));
        }
    },
    onKeyUp: function onKeyUp(e) {
        if (!this.state.success) {
            this.setInsert(false);
        }
    },
    onClick: function onClick(e) {
        var _this = this;

        this.gatherText();

        if (this.state.insert) {
            var insertVal = this.textarea.value;
            this.success(true);
            if (insertVal) {
                this.model.trigger('insertAtCursor', insertVal, true);
            }
        } else {
            this.copy().then(function (success) {
                _this.success(success);
            });
        }
    },
    success: function success(_success) {
        if (_success) {
            this.extendState({ success: true });
        } else {
            this.extendState({ fail: true });
        }
    },
    copy: function copy() {
        var _this2 = this;

        this.textarea.select();
        var val = this.textarea.value;
        var promise = new _promise2.default(function (resolve, reject) {
            // Async clipboard access, available with chrome 66 (~april 17 2018)
            // https://developers.google.com/web/updates/2018/03/clipboardapi
            if (navigator.clipboard) {
                navigator.clipboard.writeText(val).then(function () {
                    resolve(true);
                }).catch(function (err) {
                    debug.warn('Clipboard readText error', err);
                    resolve(false);
                });
            } else {
                try {
                    resolve(document.execCommand('copy'));
                } catch (err) {
                    debug.warn('Clipboard copy error', err);
                    resolve(false);
                }
            }
        });
        promise.then(function () {
            _this2.textarea.blur();
        });
        return promise;
    },
    getBounds: function getBounds() {
        var selection = window.getSelection();
        if (selection && selection.isCollapsed === false && selection.rangeCount > 0) {
            var startRange = selection.getRangeAt(0);
            var start = $(startRange.startContainer);
            var endRange = selection.getRangeAt(selection.rangeCount - 1);
            var end = $(endRange.endContainer);

            var startRow, endRow;
            if (start.closest(this.bufferView.el).length && end.is('body')) {
                // select all
                startRow = this.bufferView.scroll.log.$('.messageRow:first');
                endRow = this.bufferView.scroll.log.$('.messageRow:last');
                if (startRow.length && endRow.length) {
                    return [startRow, endRow];
                }
                return [];
            }

            // Make sure at least one end is in the log,
            // falling back to the viewport and catching it later on
            startRow = start.closest('.groupedLines__line, .log .row, .viewport');
            endRow = end.closest('.groupedLines__line, .log .row, .viewport');
            var startIsLine = startRow.is('.groupedLines__line, .row');
            var endIsLine = endRow.is('.groupedLines__line, .row');
            if (startIsLine || endIsLine) {
                if (startRow.is('.row')) {
                    // Walk forward to the nearest message row
                    if (!startRow.is('.messageRow')) {
                        startRow = startRow.nextAll('.messageRow:first');
                    }
                } else if (!startRow.is('.groupedLines__line')) {
                    // Default to the first message row
                    startRow = this.bufferView.scroll.log.$('.messageRow:first');
                }

                if (endRow.is('.row')) {
                    // Walk back to the nearest message row
                    if (!endRow.is('.messageRow')) {
                        endRow = endRow.prevAll('.messageRow:first');
                    }
                } else if (!endRow.is('.groupedLines__line')) {
                    // Default to the last message row
                    endRow = this.bufferView.scroll.log.$('.messageRow:last');
                }
                if (startRow.length && endRow.length) {
                    return [startRow, endRow];
                }
            }
        }
        return [];
    },
    rowsFromBounds: function rowsFromBounds(startRow, endRow) {
        if (startRow.is(endRow)) {
            return startRow;
        }
        // Ungroup start and end
        var ungroupedStart = startRow;
        var startRowParent = startRow;
        var ungroupedEnd = endRow;
        var endRowParent = endRow;
        if (startRow.is('.collapseGroup .messageRow')) {
            ungroupedStart = startRow.add(startRow.nextUntil(endRow, '.messageRow'));
            startRowParent = startRow.closest('.collapseGroup');
        }
        if (endRow.is('.collapseGroup .messageRow')) {
            ungroupedEnd = endRow.prevUntil(startRow, '.messageRow').add(endRow);
            endRowParent = endRow.closest('.collapseGroup');
        }
        if (startRow.is('.groupedLines__line')) {
            ungroupedStart = startRow.add(startRow.nextUntil(endRow, '.groupedLines__line'));
            startRowParent = startRow.closest('.messageRow');
        }
        if (endRow.is('.groupedLines__line')) {
            ungroupedEnd = endRow.add(endRow.prevUntil(startRow, '.groupedLines__line'));
            endRowParent = endRow.closest('.messageRow');
        }

        var rows;
        if (startRowParent.is(endRowParent)) {
            // Check again, we reassigned these and need to check if
            // start and end are both within the same collapseGroup
            rows = ungroupedStart.add(ungroupedEnd);
        } else {
            rows = ungroupedStart.add(startRowParent.nextUntil(endRowParent, '.messageRow, .collapseGroup.expanded, .expandJoinPart .joinPartGroup, .dateChange')).add(ungroupedEnd);
        }
        var flattened = [];
        rows.each(function (i, row) {
            var $row = $(row);
            if ($row.is('.collapseGroup')) {
                // Ungroup any expanded collapseGroups in range
                flattened = flattened.concat($row.find('.messageRow').toArray());
            } else if ($row.find('.groupedLines').length) {
                // Ungroup any grouped lines in range
                flattened = flattened.concat($row.find('.groupedLines__line').toArray());
            } else {
                flattened.push(row);
            }
        });
        return $(flattened);
    },
    hide: function hide(immediate) {
        var state = { hide: true };
        if (immediate) {
            state.success = false;
        }
        this.extendState(state);
    },
    onSelectionChange: function onSelectionChange(e) {
        var _getBounds = this.getBounds(),
            _getBounds2 = (0, _slicedToArray3.default)(_getBounds, 2),
            startRow = _getBounds2[0],
            endRow = _getBounds2[1];

        if (!startRow || !endRow) {
            this.hide();
            return;
        }

        // Show the prompt for the user to click to copy
        this.setState(_.extend({}, INIT_STATE, { show: true, startRow: startRow, endRow: endRow }));
    },
    gatherText: function gatherText() {
        var full = this.rowsFromBounds(this.state.startRow, this.state.endRow);
        // Remove elements we don't want to copy
        var toExclude = ['.ignored'];
        if (!this.model.isShowingJoinPart()) {
            toExclude.push('.joinPart');
        }
        if (!this.model.isCollapsingJoinPart()) {
            toExclude.push('.groupedJoinPart');
        }
        var excluded = full.not(toExclude.join(', ')).toArray();
        var rows = $(excluded.map(function (row) {
            return row.cloneNode(true);
        }));

        var toRemove = ['.avatar', '.author-realname', '.author-bot', '.channel-context', '.actualName', '.multiline-break', '.mode_pill', '.entityWrap', '.fileWrap', '.gistwrap', '.attachWrap', '.reactions', '.messageActions', '.reply__tooltip', '.reply__summary', '.reply__quote'];
        if (this.model.session.getPref('emoji-disableconvert')) {
            toRemove.push('.emoconverted');
        } else {
            toRemove.push('.emocode:not(tt .emocode, pre.monoblock .emocode)');
        }
        toRemove.push('tt .emoconverted, pre.monoblock .emoconverted');
        rows.find(toRemove.join(', ')).remove();

        // Build up lines and set the textarea
        var lines = _.map(rows, function (row) {
            // Replace nbsp with space
            return $(row).text().replace(/\u00a0/g, ' ') + '\n';
        });

        this.textarea.value = lines.join('');
    }
});

/***/ }),

/***/ "jGPP":
/***/ (function(module, exports, __webpack_require__) {

var User = __webpack_require__("Xgjh");


var UserList = Backbone.Collection.extend({
    model: User
});


module.exports = UserList;


/***/ }),

/***/ "jcM0":
/***/ (function(module, exports) {

var Overlay = function (content, options) {
    options = options || {};
    this.content = content;
    this.head = options.head;
    this.timeout = options.timeout;
    this.doneText = options.doneText;
    this.keepFocus = options.keepFocus;
    this.afterAppend = options.afterAppend;
    this.onCancel = options.onCancel;
    this.prompt = options.prompt;
    this.className = options.className;
    
    this.message = options.message;
    
    _.bindAll(this, 'clear');
};
_.extend(Overlay.prototype, Backbone.Events, {
    makeHead: function () {
        var container = $('<div class="overlayHead">');
        container.append(this.head);
        return container;
    },
    makeContent: function () {
        var container = $('<div class="overlay">');
        container.append(this.content);
        return container;
    },
    clear: function () {
        this.trigger('clear');
    },
    cancel: function () {
        this.trigger('cancel');
    },
    hide: function () {
        this.trigger('hide');
    },
    shouldClearPrevious: function (previousOverlay) {
        if (!previousOverlay) {
            // No previous, no need
            return false;
        }
        if (previousOverlay.prompt) {
            // Previous was a prompt, don't clear
            return false;
        }
        // 1: Prompts
        if (this.prompt) {
            if (
                this.message && previousOverlay.message &&
                this.message.type == 'no_such_server' &&
                previousOverlay.message.type == 'whois_response'
            ) {
                // no_such_server doesn't clear whois
                return false;
            } else {
                // all other prompts always clear
                return true;
            }
        }
        if (!previousOverlay.message) {
            // Non-prompt, previous had no message, don't clear
            return false;
        }

        // 2: Non prompts
        if (!this.message) {
            // No message, clear
            return true;
        }
        if (this.message.type != previousOverlay.message.type) {
            // Message of a different type, clear
            return true;
        }
        if (this.message.type == 'whois_response' && this.message.user_nick == previousOverlay.message.user_nick) {
            // Whois nick matches, replace existing whois
            return true;
        }
        if (!_.contains(Overlay.allowMultiple, this.message.type)) {
            // Overlay can't show multiple
            return true;
        }
        return false;
    }
});
Overlay.allowMultiple = [
    'notice',
    'time',
    'watch_status',
    'channel_query',
    'export_finished',
    'whois_response',
    'remote_isupport_params',
    'text',
    'help',
    'stats',
    'list_usage',
    'fail',
    'warn',
    'note'
];
Overlay.alwaysShowHead = [
    'whois_response'
];


module.exports = Overlay;


/***/ }),

/***/ "kiyR":
/***/ (function(module, exports, __webpack_require__) {

var BufferLogView = __webpack_require__("KgJn");
var InputInfoView = __webpack_require__("vMiC");
var ScrollClockView = __webpack_require__("ZBd7");
var twitch = __webpack_require__("/7tV");


var BufferScrollView = Backbone.View.extend({
    tagName: 'div',
    className: 'scroll',
    batchSize: 200,
    initialize: function (options) {
        this.setScrolledToBottom(true);
        this.resizing = false;
        
        this.fetching = false;
        
        this.log = new BufferLogView(options, this);
        this.clock = new ScrollClockView(options);
        this.inputInfo = new InputInfoView(options);
        
        this.model.bind('fetched', this.fetched, this);
        this.model.bind('fetchFailed', this.fetchFailed, this);
        this.model.bind('remove', this.remove, this);
        this.model.bind('selectedChange', this.renderSelected, this);
        
        this.model.messages.bind('show', this.showMessage, this);
        this.model.bind('showPending', this.scrollToPending, this);
        
        this.log.bind('scrollChange', this.onChange, this);
    },
    events: {
        'scroll': 'onScroll',
        'buttonClick .loadMore button': 'clickLoadMore'
    },
    setScrolledToBottom: function (value) {
        if (this.scrolledToBottom != value) {
            this.scrolledToBottom = value;
            if (this.recentlyScrolledTimeout) {
                clearTimeout(this.recentlyScrolledTimeout);
            }
            if (this.scrolledToBottom) {
                this.wasRecentlyScrolledToBottom = true;
            } else {
                this.recentlyScrolledTimeout = setTimeout(_.bind(function () {
                    this.wasRecentlyScrolledToBottom = false;
                }, this), 100);
            }
        }
    },
    onScroll: function (e, pinBottom) {
        if (this.isResizing()) {
            return;
        }
        var scrollTop    = this.el.scrollTop;
        var scrollHeight = this.el.scrollHeight;
        if (this.lastScrollTop != scrollTop || this.lastScrollHeight != scrollHeight) {
            this.lastScrollTop    = scrollTop;
            this.lastScrollHeight = scrollHeight;
            if (this.model.isSelected()) {
                this.trigger('scroll', e, pinBottom);
            }
        }
    },
    clickLoadMore: function (e) {
        e.preventDefault();
        this.scrollToTop();
        this.setScrolledToBottom(false);
        this.loadOrRenderBacklog();
    },
    // Called from BufferView
    updateScroll: function () {
        // Update cached value
        if (!this.isResizing()) {
            this.updateScrolledToBottom();
        }
    },
    renderSelected: function () {
        // Unlock focus seen on deselect, in case we deselect while unfocused
        if (!this.model.isSelected()) {
            delete this.lastScrollHeight;
            delete this.lastScrollTop;
            this.unlockFocusSeen();
        }
    },
    unlockFocusSeen: function () {
        this.model.unlockFocusSeen();
        if (!this.log.focusSeenVisible) {
            this.log.removeFocusSeen();
        }
    },
    lockFocusSeen: function () {
        if (this.model.lockFocusSeen()) {
            this.log.renderFocusSeen();
        }
    },
    unlockBottomSeen: function () {
        this.model.unlockBottomSeen();
        if (!this.log.bottomSeenVisible) {
            this.log.removeBottomSeen();
        }
    },
    lockBottomSeen: function () {
        if (this.model.lockBottomSeen()) {
            this.log.renderBottomSeen();
        }
    },
    checkInfiniscroll: function () {
        if (!this.isScrolledToBottom() &&
            !this.isFullyRendered() &&
            this.isScrolledToTop()
        ) {
            this.loadOrRenderBacklog();
        }
    },

    fixScroll: function (pinBottom, animate) {
        if (pinBottom) {
            this.scrollToBottom({
                animate: animate
            });
        } else {
            this.updateScrolledToBottom();
        }
    },
    onChange: function (pinBottom, animate) {
        if (this.model.isSelected() && !this.log.batchRendering) {
            if (this.model.getBottomSeen()) {
                pinBottom = false;
            } else if (pinBottom === undefined) {
                pinBottom = this.isScrolledToBottom();
            }
            // Need to run this first so chatter bar is updated correctly
            if (pinBottom) {
                this.scrollToBottom({
                    animate: animate,
                    silent: true
                });
            }
            this.trigger('change', pinBottom);
            if (this.updateScrollWidth()) {
                this.trigger('widthChange', pinBottom); // if there was a scroll before and isn't now
            }
        }
    },
    // Backlog loading
    isFetching: function () {
        return this.fetching;
    },
    
    getFirstRendered: function () {
        return this.firstRendered;
    },
    setFirstRendered: function (message) {
        if (message) {
            this.firstRendered = message;
            this.log.lineRenderer.firstRender = this.firstRendered;
        }
    },
    clearFirstRendered: function () {
        this.firstRendered = null;
        this.log.lineRenderer.firstRender = this.firstRendered;
    },
    isFullyRendered: function () {
        if (this.model.isDeferred()) {
            return false;
        }
        var firstId = this.model.getFirst();
        if (firstId === 0) {
            // No events
            return true;
        }
        var firstRendered = this.getFirstRendered();
        if (firstRendered) {
            return firstRendered.id == firstId || firstRendered.getMsgId() == firstId;
        }
        return false;
    },
    isFirstMessageRendered: function () {
        var first = this.model.getFirstMessage();
        if (!first || first.equals(this.getFirstRendered())) {
            return true;
        } else {
            return false;
        }
    },
    isLastSeenMessageRendered: function () {
        var lastSeen = this.model.getLastSeenMessage();
        var firstRendered = this.getFirstRendered();
        if (firstRendered && lastSeen && lastSeen.id >= firstRendered.id) {
            return true;
        } else {
            return false;
        }
    },
    
    loadOrRenderBacklog: function () {
        if (this.model.getFirst() !== 0) {
            if (this.isFirstMessageRendered() || this.model.discontinuity) {
                this.loadBacklog();
            } else {
                var firstRendered = this.getFirstRendered();
                var batch;
                if (firstRendered) {
                    batch = this.model.messages.filterBeforeEid(firstRendered.id, this.batchSize);
                    this.log.removeLoadMore();
                    this.fetched(batch, firstRendered.id);
                } else {
                    batch = this.model.messages.last(this.batchSize);
                    this.fetched(batch);
                }
            }
        }
    },
    loadDiscontinuity: function () {
        if (this.isFetching()) {
            return;
        }
        this.fetching = true;
        this.model.loadBacklog(true);
    },
    loadBacklog: function () {
        if (this.isFetching()) {
            return;
        }
        this.fetching = true;
        // Render loading line
        this.log.renderFetching(this.model.isDeferred());
        // Delay fetch to handle scrolling jumpiness
        setTimeout(
            _.bind(this.model.loadBacklog, this.model),
            200
        );
    },
    fetchFailed: function (discontinuity) {
        this.log.renderFetchFailed(discontinuity);
        
        // Set state
        this.fetching = false;
    },
    fetchDone: function (change, pinBottom) {
        this.fetching = false;
        if (change) {
            this.onChange(pinBottom);
        }
        this.trigger('fetched');
    },
    fetched: function (messages, prevEarliest, discontinuity) {
        var atTop, pinBottom;
        if (this.model.isSelected()) {
            if (prevEarliest) {
                atTop = this.isScrolledToTop();
                pinBottom = this.isScrolledToBottom();
            }
        }
        
        var divider = this.log.renderFetched(messages, prevEarliest, discontinuity);

        // Scroll to divider
        if (this.model.isSelected()) {
            if (!prevEarliest) {
                this.fetchDone(true, true);
            } else if (atTop) {
                if (discontinuity || pinBottom) {
                    this.fetchDone(true, pinBottom);
                } else if (divider && divider.length) {
                    var pos = Math.round(divider.position().top);
                    this.scrollTo(pos - 31);
                    this.scrollTo(Math.max(pos - 152, 48), {
                        animate: true,
                        afterAnimate: _.bind(function () {
                            // Recalculate top and scroll to it again, might have moved
                            var pos = Math.round(divider.position().top);
                            this.scrollTo(Math.max(pos - 152, 48));
                            this.fetchDone(true, false);
                        }, this)
                    });
                } else {
                    this.fetchDone(true, false);
                }
            } else {
                this.fetchDone(true, pinBottom);
            }
        } else {
            this.fetchDone();
        }
    },
    // Layout triggers
    onAnimate: function (duration, callback, after) {
        this.isAnimating = true;
        setTimeout(_.bind(function onAnimateTimeout () {
            this.isAnimating = false;
            if (after) {
                after();
            }
        }, this), duration);
        this.checkPinBottom(function (pinBottom) {
            this.onAnimateLoop(pinBottom, callback);
        }, this);
    },
    onAnimateLoop: function (pinBottom, callback) {
        this.setResizing();
        requestAnimationFrame(_.bind(function onAnimateLoopRaf () {
            if (this.isAnimating) {
                this.onAnimateLoop(pinBottom, callback);
            }
            callback(pinBottom);
        }, this));
    },
    // Resizing
    isResizing: function () {
        return this.resizing;
    },
    setResizing: function () {
        this.resizing = true;
        if (this.resizingTimeout) {
            clearTimeout(this.resizingTimeout);
        }
        this.resizingTimeout = setTimeout(_.bind(function () {
            this.resizing = false;
            this.resizingTimeout = null;
            this.checkPinBottom(function (pinBottom) {
                this.onScroll(false, pinBottom);
                this.trigger('resizeEnd');
            }, this);
        }, this), 100);
    },
    render: function () {
        this.stickyAvatarContainer = $('<div class="stickyAvatar authorWrap">');
        if (this.model.connection.isTwitch() && this.model.isChannel()) {
            twitch.bitsAction(this.model.session, this.model.normalise()).then(_.bind(function () {
                this.log.render();
            }, this));
        } else {
            this.log.render();
        }
        $(this.el).append(this.log.el);
        this.clock.render();
        
        this.inputInfo.bubble('makeInputChoice', this);
        this.inputInfo.bubble('makeInputOriginalChoice', this);
        
        return this;
    },
    uncacheRect: function () {
        delete this._rectCache;
    },
    getRect: function () {
        if (this._rectCache) {
            return this._rectCache;
        }
        try {
            this._rectCache = this.el.getBoundingClientRect();
            return this._rectCache;
        } catch (exc) {
            // Crashes in IE11 if element is not in DOM
            return {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                width: 0,
                height: 0
            };
        }
    },
    setStickyAuthor: function (rows) {
        if (this.model.isSelected()) {
            var ret = this.log.setStickyAuthor(rows);
            if (ret) {
                var avatar = ret[0];
                var top = ret[1];
                var eid = ret[2];
                if (this.stickyAvatar != eid)  {
                    var sticky = avatar.clone().css('top', 0);
                    var parent = avatar.closest('.userParent');
                    var parentData = parent.data();
                    for (var k in parentData) {
                        sticky.attr('data-' + k, parentData[k]);
                    }
                    sticky.removeClass('hasUserParent');
                    sticky.find('.imageAvatar')
                        .addClass('imageAvatar--loading')
                        .removeClass('imageAvatar--error')
                        .removeClass('imageAvatar--loaded');
                    sticky.find('.letterAvatar')
                        .removeClass('letterAvatar--internal_fallback')
                        .removeClass('letterAvatar--external_fallback');
                    this.stickyAvatarContainer.html(sticky);
                    this.stickyAvatar = eid;
                }
                this.stickyAvatarContainer.css({
                    top: top
                });
            } else {
                this.stickyAvatarContainer.empty();
                this.stickyAvatar = null;
            }
        }
    },
    widthChange: function (pinBottom) {
        if (this.updateScrollWidth()) {
            this.uncacheRect();
            if (!this.isResizing()) {
                this.log.resetEmbedClosePositions();
            } else {
                this.unbind('resizeEnd', this.log.resetEmbedClosePositions, this.log);
                this.once('resizeEnd', this.log.resetEmbedClosePositions, this.log);
            }
            this.fixScroll(pinBottom);
        }
    },
    updateScrollWidth: function () {
        var sw = this.el.scrollWidth;
        if (this.scrollWidth != sw) {
            this.scrollWidth = sw;
            return true;
        } else {
            return false;
        }
    },
    updateClock: function (upperMessage) {
        return this.clock.update(upperMessage, this.isScrolledToBottom());
    },
    getMessageForRow: function (row) {
        return this.model.getMessage(row.data('eid'));
    },
    getMessageAtTopOfScroll: function () {
        return this.getMessageForRow(this.log.getRowAtTopOfScroll()[0]);
    },
    rowPositionOffsets: function () {
        return {
            x: 1, // account for left border
            y: 2 + this.clock.getHeight() // account for clock and padding on dates,
        };
    },
    getMessageAtBottomOfScroll: function () {
        return this.getMessageForRow(this.log.getRowAtBottomOfScroll()[0]);
    },
    
    updateScrolledToBottom: function () {
        this.setScrolledToBottom(this.isScrolledToBottom(true));
        return this;
    },
    isScrolledToTop: function () {
        return this.el.scrollTop === 0;
    },
    shouldPinBottom: function () {
        return this.isScrolledToBottom() || this.wasRecentlyScrolledToBottom;
    },
    isScrolledToBottom: function (force) {
        if (force) {
            if (!this.model.isSelected()) {
                return;
            }
            var scrollBottom = this.el.offsetHeight + Math.ceil(this.el.scrollTop); // rounded up cos of browser scaling issues
            return (this.el.scrollHeight - scrollBottom) <= 1; // 1 pixel slop cos of browser scaling issues
        } else {
            return this.scrolledToBottom;
        }
    },
    scrollTo: function (scrollTo, options) {
        options = options || {};
        if (options.animate) {
            $(this.el).animate({
                'scrollTop': scrollTo
            }, {
                duration: 100,
                complete: _.bind(function () {
                    if (options.afterAnimate) {
                        options.afterAnimate();
                    }
                    this.onScroll();
                }, this),
                queue: false
            });
        } else {
            $(this.el).scrollTop(scrollTo);
            if (!options.silent) {
                this.onScroll(false, options.pinBottom);
            }
        }
        return this;
    },
    scrollToTop: function () {
        this.scrollTo(0);
        return this;
    },
    checkPinBottom: function (callback, context, options) {
        options = options || {};
        var pinBottom;
        if (options.checkRecent) {
            pinBottom = this.shouldPinBottom(options);
        } else {
            pinBottom = this.isScrolledToBottom();
        }
        context = context || this;
        callback.call(context, pinBottom);
    },
    scrollToBottom: function (options) {
        options = options || {};
        options.pinBottom = true;
        options.afterAnimate = _.bind(function () {
            // Call it again when we're done in case scroll height changed while animating
            options.animate = false;
            this.scrollToBottom(options);
        }, this);
        this.setScrolledToBottom(true);
        var scrollPos = Math.ceil(this.el.scrollTop); // rounded up cos of browser scaling issues
        var scrollHeight = this.el.scrollHeight;
        var offsetHeight = this.el.offsetHeight;
        var bottom = (scrollHeight - offsetHeight) + 1; // 1px slop for zoomed out browsers
        var atBottom = (bottom - scrollPos) <= 1;

        if (!atBottom) {
            this.scrollTo(bottom, options);
        }
        return this;
    },
    scrollDown: function () {
        if (!this.isScrolledToBottom()) {
            this.scrollTo(this.el.scrollTop + this.el.offsetHeight);
        }
        return this;
    },
    scrollUp: function () {
        if (!this.isScrolledToTop()) {
            this.scrollTo(this.el.scrollTop - this.el.offsetHeight);
        }
        return this;
    },
    showMessage: function (message, options) {
        this.scrollToMessage(message, _.extend({}, options, {strict: true}));
    },
    scrollToMessage: function (message, options) {
        options = options || {};
        var line;
        if (options.strict) {
            line = this.log.getLine(message);
        } else {
            line = this.log.getVisibleLine(message);
        }
        if (line.length && line.is(':visible')) {
            if (options.highlight) {
                line.highlightFlash();
            }
            this.scrollTo(line.position().top - this.clock.getHeight(true));
            return true;
        }
        return false;
    },
    scrollToPending: function (reqId) {
        var row = this.log.getPendingRow(reqId);
        if (row.length) {
            this.scrollTo(row.position().top - this.clock.getHeight(true));
        }
    },
    scrollToLastSeenOrTop: function () {
        var lastSeen = this.model.getLastSeenMessage();
        if (lastSeen && lastSeen.isEmpty()) {
            lastSeen = lastSeen.previousVisible();
        }
        return this.scrollToMessage(lastSeen) || this.scrollToTop();
    },
    scrollToBottomSeenOrBottom: function () {
        var bottomSeen = this.log.getBottomSeen();
        if (bottomSeen.length) {
            var newScrollPos = bottomSeen.position().top - this.clock.getHeight(true);
            var scrollTop = this.el.scrollTop;
            if (newScrollPos - scrollTop <= 1) {
                this.scrollToBottom();
            } else {
                this.scrollTo(newScrollPos);
            }
        } else {
            this.scrollToBottom();
        }
        return this;
    }
});


module.exports = BufferScrollView;


/***/ }),

/***/ "lKP6":
/***/ (function(module, exports, __webpack_require__) {

var FileWrapper = __webpack_require__("JHsc");
var Session = __webpack_require__("+9Dv");
var Connection = __webpack_require__("LLdI");
var Org = __webpack_require__("5gbS");
var uriTemplates = __webpack_require__("0a14");

var Avatar = FileWrapper.extend({
    triggerBubble: function () {
        var args = _.toArray(arguments);
        // Prefix event name
        var event = 'avatar-' + args.shift();
        args.unshift(event);
        this.trigger.apply(this, args);
        // Send this as second arg
        args.shift();
        args.unshift(event, this);
        this.session.trigger.apply(this.session, args);
    },
    getTemplateUri: function () {
        return Avatar.TEMPLATE_URI;
    },
    getTemplateUriParams: function () {
        return this.getBaseTemplateUriParams();
    },
    uploadPath: function () {
        return this.session.backend.buildRawUrl(Avatar.UPLOAD_PATH);
    },
    matchesModel: function (model) {
        if (model instanceof Session) {
            return this.isPrimary();
        } else if (model instanceof Org) {
            return this.get('org') == model.id;
        } else if (model instanceof Connection) {
            return this.get('cid') == model.id;
        } else {
            return false;
        }
    },
    isPrimary: function () {
        return this.get('is_primary');
    },
    finaliseParams: function () {
        var params = FileWrapper.prototype.finaliseParams.call(this);
        params.type = 'avatar';
        if (this.isPrimary()) {
            params.primary = "1";
        }
        params.cid = this.get('cid');
        params.org = this.get('org');
        return params;
    },
    getCachedSquareUrl: function (width) {
        return FileWrapper.cachedDataUrl(this.id) || this.getSquareUrl(width);
    },
    isAcceptableType: function () {
        return Avatar.isAcceptableType(this.getType());
    }
}, {
    UPLOAD_PATH: '/chat/upload-avatar',
    TEMPLATE_URI: window.IRCConfig.avatar_uri_template,
    REDIRECT_TEMPLATE_URI: window.IRCConfig.avatar_redirect_uri_template,
    fromFile: function (file, session) {
        return FileWrapper.fromFile(file, session, Avatar);
    },
    isAcceptableType: function (type) {
        return type === 'image/png'
            || type === 'image/gif'
            || type === 'image/jpeg';
    },
    isExternalSecure: function (avatar) {
        return !!avatar.match(/^https:\/\/.+/);
    },
    redirectTemplate: function (uid, modifiers) {
        var data = {
            id: uid
        };
        if (modifiers !== '') {
            data.modifiers = modifiers || 's{size}';
        }
        return decodeURIComponent(uriTemplates(Avatar.REDIRECT_TEMPLATE_URI).fill(data));
    },
    idToTemplate: function (avatarId) {
        return decodeURIComponent(uriTemplates(Avatar.TEMPLATE_URI).fill({
            modifiers: 's{size}',
            id: avatarId
        }));
    }
});

module.exports = Avatar;


/***/ }),

/***/ "luaz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m+fz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mMVu":
/***/ (function(module, exports) {

var OnlineChecker = function (session) {
    this.session = session;
    this.state = true;
};
OnlineChecker.prototype = $.extend({
    checkOnline: function (poll) {
        if (poll) {
            debug.debug('onLine status poll');
        }
        // Change reported, ping server to verify, navigator.onLine can report false negatives
        // https://code.google.com/p/chromium/issues/detail?id=124069
        // Also, wifi can be off but dev VM still available
        this.pingServer().fail(_.bind(function (request, errorString, errorThrown) {
            if (this.onlineStatusSupport() && navigator.onLine) {
                debug.warn('online false positive');
            }
            this.setOnline(false);
        }, this)).done(_.bind(function (response, statusText, request) {
            if (this.onlineStatusSupport() && !navigator.onLine) {
                debug.warn('offline false negative');
            }
            this.setOnline(true);
        }, this));
    },
    setOnline: function (value) {
        if (this.state != value) {
            this.state = value;
            this.trigger('onlineChange');
        }
    },
    pingServer: function () {
        return this.session.ajax({
            url: this.session.backend.buildRawUrl('/ping'),
            type: 'head',
            dataType: 'text'
        });
    },
    isOnline: function () {
        return this.state;
    },
    onlineEventSupport: function () {
        return 'ononline' in window;
    },
    onlineStatusSupport: function () {
        return 'onLine' in navigator;
    },
    onlinePoll: function () {
        if (!this.onlineEventSupport() || !this.isOnline()) {
            this.checkOnline(true);
        }
    },
    start: function () {
        if (this.onlineEventSupport()) {
            $(window).on('online', _.bind(function () {
                debug.log('ononline');
                this.checkOnline();
            }, this));
            $(window).on('offline', _.bind(function () {
                debug.log('onoffline');
                this.checkOnline();
            }, this));
        }
        this.onlinePollInterval = setInterval(_.bind(this.onlinePoll, this), 30000);
    },
}, Backbone.Events);


module.exports = OnlineChecker;


/***/ }),

/***/ "mysc":
/***/ (function(module, exports, __webpack_require__) {

var ChildStatusView = __webpack_require__("4PFu");


var ConversationStatusView = ChildStatusView.extend({
    events: $.extend({}, ChildStatusView.prototype.events, {
        'buttonClick button.nickserv': 'clickNickserv',
        'buttonClick button.unarchive': 'clickUnarchive',
        'buttonClick button.archive': 'clickArchive',
        'buttonClick button.whois': 'clickWhois'
    }),
    clickNickserv: function (e) {
        this.model.connection.trigger('nickServPrompt', this.model.connection);
        return false;
    },
    clickUnarchive: function (e) {
        this.model.unarchive();
        return false;
    },
    clickArchive: function (e) {
        this.model.archive();
        return false;
    },
    clickWhois: function (e) {
        this.model.getRecipient().whois();
        return false;
    },
    render: function () {
        ChildStatusView.prototype.render.apply(this, arguments);
        this.avatar = $('<span class="conversation__avatar avatars-on">');
        this.realname = $('<span class="realname">');
        this.hostmask = $('<span class="hostmask">');
        this.ignored = $('<p class="conversation__ignored userInfo">');
        this.account = $('<span class="account">');
        this.awayMarker = $('<span class="away">');
        this.accountAway = $('<p class="conversation__account-away">');
        this.accountAway.append(this.account);
        this.accountAway.append(' ');
        this.accountAway.append(this.awayMarker);
        this.renderAvatar();
        this.renderRealname();
        this.renderHostmask();
        this.renderIgnored();
        this.renderAccountAway();
        this.avatar.insertBefore(this.title);
        this.title.append(' ');
        this.title.append(this.realname);
        this.title.append(' ');
        this.title.append(this.hostmask);
        this.title.append(this.accountAway);
        this.title.append(this.ignored);
        this.model.recipient.bind('change:away', this.renderAccountAway, this);
        this.model.recipient.bind('change:account', this.renderAccountAway, this);
        this.model.recipient.bind('change:realname', this.renderRealname, this);
        this.model.recipient.bind('change:nick', this.renderIgnored, this);
        this.model.recipient.bind('change:user', this.renderHostmask, this);
        this.model.recipient.bind('change:user', this.renderIgnored, this);
        this.model.recipient.bind('change:userhost', this.renderIgnored, this);
        this.model.recipient.bind('change:userhost', this.renderHostmask, this);
        this.model.recipient.bind('change:ident_prefix', this.renderIgnored, this);
        this.model.recipient.bind('change:ident_prefix', this.renderHostmask, this);
        this.listenTo(this.model.connection, 'ignoresChange', this.renderIgnored);
        this.model.recipient.bind('change:nick change:display_name', this.renderLabel, this);
        this.model.recipient.bind('change:realname change:avatar change:avatar_url', this.renderAvatar, this);
        this.listenTo(this.model, 'prefChange:avatars-off', this.renderAvatar);
        this.listenTo(this.model, 'prefChange:avatars-image-off', this.renderAvatar);
        this.listenTo(this.model, 'prefChange:inlineimages', this.renderAvatar);

        return this;
    },
    renderAvatarExternal: function () {
        var external = this.model.embedExternalAvatars();
        this.$el.toggleClass('avatars-external', !!external);
        this.$el.toggleClass('avatars-noexternal', !external);
    },
    renderAvatar: function () {
        this.renderAvatarExternal();
        var img = '';
        if (this.model.avatarsEnabled()) {
            var external = false;
            var avatar;
            if (this.model.imageAvatarsEnabled()) {
                avatar = this.model.recipient.getAvatar();
                if (!avatar) {
                    var lastIndex = this.model.messages.findLastIndex(function (m) {
                        return !m.isSelf() && m.isImportant();
                    });
                    if (lastIndex !== -1) {
                        avatar = this.model.messages.at(lastIndex).getAvatar();
                    }
                }
                if (avatar) {
                    external = avatar.external;
                    img += this.formatter.imageAvatar(avatar.src, this.model.isSelf(), {
                        size: 32,
                        external: external
                    });
                }
            }

            img += this.formatter.avatar(this.model.recipient.getName(), this.model.isSelf(), {
                fallback: !!avatar,
                name: this.model.recipient.getDisplayAuthor(),
                external: external
            });
        }
        this.avatar.html(img);
    },
    renderLabel: function () {
        var label;
        if (this.model.connection.isSlack()) {
            var url = this.model.getSlackUrl();
            label = this.formatter.linker.makeLinkFromUrl(url, this.formatter.escapeText(this.model.getDisplayName()));
            label = 'Direct message with ' + label;
        } else {
            label = this.formatter.render(this.model.getTitle());
        }
        this.label.html(label);
    },
    renderButtons: function () {
        ChildStatusView.prototype.renderButtons.apply(this);
        if (this.model.isNickserv()) {
            this.appendButton('nickserv', 'Identify Nickname');
        }
        this.appendButton('unarchive', 'Unarchive');
        this.appendButton('archive', 'Archive');
        this.appendButton('whois', 'Whois');
        
        this.appendOptionsButton();
    },
    renderAccountAway: function () {
        this.renderAway();
        this.renderAccount();
        var show = !!(this.model.getAway() || this.model.getAccount());
        this.accountAway.toggleClass('conversation__account-away--show', show);
        this.trigger('topChange');
    },
    renderAway: function () {
        if (this.model.isAway()) {
            var away = this.model.getAway();
            var msg = 'away';
            if (away !== true) {
                msg += ': ' + away;
            }
            this.$el.addClass('away');
            this.awayMarker.html(this.formatter.render(msg));
        } else {
            this.$el.removeClass('away');
            this.awayMarker.empty();
        }
        return this;
    },
    renderIgnored: function () {
        var ignored = this.model.isIgnored({returnMap: true});
        this.ignored.toggleClass('conversation__ignored--undo', !ignored.match);
        if (ignored.match) {
            this.ignored.addClass('conversation__ignored--show');
            var unignore = $('<button class="conversation__ignored-button conversation__ignored-unignore">').append('<span>unignore</span>').on('click', _.bind(function (e) {
                e.preventDefault();
                _.each(ignored.masks, function (m) {
                    this.model.connection.unignore(m);
                }, this);
            }, this));
            var undo = $('<button class="conversation__ignored-button conversation__ignored-undounignore">').append('<span>undo</span>').on('click', _.bind(function (e) {
                e.preventDefault();
                this.model.connection.ignore(ignored.masks[0]);
            }, this));
            var dismiss = $('<button class="conversation__ignored-button conversation__ignored-dismiss">').append('<span>dismiss</span>').on('click', _.bind(function (e) {
                e.preventDefault();
                this.ignored.empty().removeClass('conversation__ignored--show');
            }, this));
            this.ignored.empty()
                .append(unignore)
                .append(undo)
                .append(dismiss)
                .append('Ignoring: <b>' + this.formatter.escapeText(ignored.masks[0]) + '</b> ')
                .append($('<span class="explanation">').text('This hides channel messages and prevents private message notifications. Archive to hide completely.'));
        }
    },
    renderHostmask: function () {
        this.hostmask.toggle(this.model.connection.hasMeaningfulHostnames());
        var mask = this.model.recipient.getHostMask();
        if (mask) {
            this.hostmask.html('(' + this.formatter.renderNoEmoji(mask) + ')');
        } else {
            this.hostmask.empty();
        }
    },
    renderRealname: function () {
        var realname = this.model.recipient.getRealname();
        if (realname) {
            this.realname.html(this.formatter.renderLinkify(realname));
        } else {
            this.realname.empty();
        }
    },
    renderAccount: function () {
        var account = this.model.getAccount();
        if (account) {
            this.$el.addClass('authed');
            this.account.html('Logged in as: <b>' + this.formatter.renderLinkify(account) + '</b>');
        } else {
            this.$el.removeClass('authed');
            this.account.empty();
        }
    },
});


module.exports = ConversationStatusView;


/***/ }),

/***/ "nR5u":
/***/ (function(module, exports) {

var JoinDefaultView = Backbone.View.extend({
    el: '#joinDefaultContainer',
    initialize: function (options) {
        this.form = $('#joinDefaultForm');
        this.nick = $('#joinDefaultNick');
        this.name = $('#joinDefaultName');
        this.error = $('p#joinDefaultError');
        
        _.bindAll(this, 'focusNick');
        
        this.visible = false;
        this.disabled = false;
    },
    events: {
        'submit #joinDefaultForm': 'submitForm'
    },
    submitForm: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }
        this.hideError();
        var nick = this.nick.val();
        var realname = this.name.val();
        this.disableForm();
        this.model.joinDefault(nick, realname, _.bind(function (response) {
            this.enableForm();
            if (response.success) {
                this.hideError();
                this.model.setFocusOnMakeServer(response.cid);
            } else {
                var message;
                switch (response.message) {
                case 'nickname':
                    message = 'Invalid nickname';
                    break;
                default:
                    message = 'Error joining #feedback: ' + response.message;
                    break;
                }
                this.showError(message);
            }
        }, this));
    },
    hideError: function () {
        this.error.hide();
    },
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.form.find('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.form.find('input, button, textarea').prop('disabled', false);
        }
    },
    showError: function (message) {
        this.error.text(message).fadeIn('fast');
    },
    isVisible: function () {
        return this.visible;
    },
    show: function () {
        if (this.isVisible()) {
            return;
        }
        this.name.val(this.model.get('name'));
        var nick = this.model.getNick();
        this.nick.val(nick);
        $(this.el).show();
        this.focusNick();
        this.visible = true;
    },
    hide: function () {
        if (!this.isVisible()) {
            return;
        }
        $(this.el).hide();
        this.hideError();
        this.visible = false;
    },
    focusNick: function () {
        this.nick.focus().select();
    }
});


module.exports = JoinDefaultView;


/***/ }),

/***/ "o1Zz":
/***/ (function(module, exports, __webpack_require__) {

var Pastebin = __webpack_require__("RvJ1");
var FileWrapper = __webpack_require__("JHsc");
var FileInlineView = __webpack_require__("G5kp");
var FileTreeView = __webpack_require__("8SYU");


var BufferUploadView = Backbone.View.extend({
    tagName: 'form',
    className: 'upload',
    input: null,
    events: {
        'submit': 'submit',
        'click input[type=file]': 'inputClick',
        'change input': 'inputChange'
    },
    initialize: function (options, input) {
        this.input = input;
        this.model.bind('uploadPrompt', this.prompt, this);
        this.model.bind('upload', this.upload, this);
        this.model.bind('finaliseFileFromPromise', this.finaliseFileFromPromise, this);
        this.listenTo(this.model.session, 'uploadStart', this.uploadStart);
        this.listenTo(this.model.session, 'uploadConfirmed', this.uploadConfirmed);
        this.listenTo(this.model.session, 'uploadProgress', this.uploadProgress);
        this.listenTo(this.model.session, 'uploadFinalise', this.uploadFinalise);
        this.listenTo(this.model.session, 'uploadSuccess', this.uploadSuccess);
        this.listenTo(this.model.session, 'uploadCancelled', this.uploadCancelled);
        this.listenTo(this.model.session, 'uploadError', this.uploadError);

        this.filesProgress = {};
        this.filesDoneClass = {};
        this.totalProgress = 0;
        this.currentProgress = 0;
    },
    inputClick: function (e) {
        e.stopPropagation();
    },
    upload: function (options) {
        this.doUpload(options);
    },
    doUpload: function (options) {
        var files = options.files;
        if (files) {
            var origInput = this.input.val();
            var dataUriMatch = FileWrapper.detectDataURI(origInput);
            if (dataUriMatch) {
                var before = dataUriMatch.input.slice(0, dataUriMatch.index);
                var after = dataUriMatch.input.slice(dataUriMatch.index + dataUriMatch[0].length);
                origInput = before + after;
            }
            options.message = origInput;
            FileWrapper.collectFileTree(options.entries, options.files).done(_.bind(function (fileTree, truncated) {
                if (fileTree.length == 1 && !fileTree[0].dir) {
                    // single file
                    var file = fileTree[0];
                    if (window.FileReader && file.size <= Pastebin.MAX_LENGTH_BYTES && FileWrapper.isText(file.type)) {
                        var reader = new window.FileReader();
                        reader.onload = _.bind(function (e) {
                            options.contents = e.target.result;
                            options.file = file;
                            this.model.session.trigger(
                                'pasteConfirm',
                                this.model,
                                options
                            );
                        }, this);
                        reader.readAsText(file);
                    } else {
                        var fileWrap = FileWrapper.fromFile(file, this.model.session);
                        var fileView = new FileInlineView({
                            model: fileWrap
                        });
                        if (options.dataURI) {
                            fileView.localFileData = options.dataURI;
                        }
                        if (fileWrap.isTooLarge()) {
                            this.model.trigger('postError', {
                                message: 'file_too_large',
                                size: fileWrap.get('size')
                            });
                        } else {
                            // Background upload
                            options.reqid = this.model.session.backend._getRequestId();

                            var promise = fileWrap.upload();

                            if (options.immediate) {
                                delete options.message;
                                this.finaliseFileFromPromise(promise, fileView, options);
                            } else {
                                this.input.clear();
                                this.model.session.trigger(
                                    'uploadConfirm',
                                    fileView,
                                    this.model,
                                    options,
                                    _.bind(function (data) {
                                        fileWrap.desiredFilename = data.name;
                                        options.message = data.message;
                                        this.finaliseFileFromPromise(promise, fileView, options);
                                    }, this),
                                    _.bind(function () {
                                        fileWrap.cancelUpload();
                                        this.input.setVal(origInput);
                                        this.input.onInput();
                                        if (options.onCancel) {
                                            options.onCancel();
                                        }
                                    }, this)
                                );
                            }
                        }
                    }
                } else {
                    if (FileWrapper.flattenTree(fileTree).length) {
                        options.fileTree = fileTree;
                        options.truncated = truncated;

                        // Background upload
                        options.reqid = this.model.session.backend._getRequestId();
                        options.session = this.model.session;

                        var fileTreeView = new FileTreeView(options);
                        fileTreeView.uploadFiles();

                        if (options.immediate) {
                            delete options.message;
                            this.finaliseFileTree(fileTreeView, options);
                        } else {
                            this.input.clear();
                            this.model.session.trigger(
                                'batchUploadConfirm',
                                fileTreeView.treeRender,
                                this.model,
                                options,
                                _.bind(function (data) {
                                    options.filenames = data;
                                    options.message = data.message;
                                    this.finaliseFileTree(fileTreeView, options);
                                }, this),
                                _.bind(function () {
                                    fileTreeView.cancelUpload();
                                    this.input.setVal(origInput);
                                    this.input.onInput();
                                    if (options.onCancel) {
                                        options.onCancel();
                                    }
                                }, this)
                            );
                        }
                    }
                }
                this.clear();
            }, this));
        }
    },
    addProgressClass: function (className) {
        $(this.el).closest('.uploadcell').addClass(className);
        $(this.el).closest('.uploadcell').addClass('engaged');
    },
    removeProgressClass: function (className) {
        $(this.el).closest('.uploadcell').removeClass(className);
    },
    uploadStart: function (fileWrap) {
        this.totalProgress += 100;
        if (_.isEmpty(this.filesProgress)) {
            this.removeProgressClass('confirmed');
            this.radialProgress.removeClass('gt50');
            this.currentRadialDeg = 0;
            this.radialProgress.find('.part').css({
                transform: 'none'
            });
        }
        this.filesProgress[fileWrap.getUploadId()] = 0;
    },
    uploadConfirmed: function (fileWrap) {
        $(this.el).closest('.uploadcell').addClass('confirmed');
    },
    uploadProgress: function (fileWrap, evt, percentComplete) {
        this.currentProgress += (percentComplete - this.filesProgress[fileWrap.getUploadId()]);
        this.filesProgress[fileWrap.getUploadId()] = percentComplete;
        var totalPercent = this.currentProgress / this.totalProgress * 100;
        this.removeProgressClass('busy active cancelled error success done');
        this.addProgressClass('active');
        if (this.currentRadialAnimation) {
            this.currentRadialAnimation.stop();
        }
        var targetDeg = totalPercent * 360/100;
        var stepDeg;
        $('<div>').animate({'opacity': 0}, {
            duration: 200,
            progress: _.bind(function (animation, value, remain) {
                this.currentRadialAnimation = animation;
                var diff = targetDeg - this.currentRadialDeg;
                var delta = diff * value;
                stepDeg = this.currentRadialDeg + delta;
                if (stepDeg > 180) {
                    this.radialProgress.addClass('gt50');
                    this.radialProgress.find('.first').css({transform: 'rotate(180deg)'});
                    this.radialProgress.find('.rest').show().css({transform: 'rotate('+stepDeg+'deg)'});
                } else {
                    this.radialProgress.removeClass('gt50');
                    this.radialProgress.find('.first').css({transform: 'rotate('+stepDeg+'deg)'});
                    this.radialProgress.find('.rest').hide();
                }
            }, this),
            always: _.bind(function (animation, jumpedToEnd) {
                this.currentRadialAnimation = null;
                this.currentRadialDeg = stepDeg;
            }, this)
        });
    },
    uploadFinalise: function (fileWrap) {
        if (this.currentProgress) {
            this.removeProgressClass('busy active cancelled error success done');
            this.addProgressClass('busy');
        }
    },
    uploadDone: function (className, fileWrap) {
        this.totalProgress -= 100;
        this.currentProgress -= this.filesProgress[fileWrap.getUploadId()];
        this.filesDoneClass[fileWrap.getUploadId()] = className;
        delete this.filesProgress[fileWrap.getUploadId()];
        if (_.isEmpty(this.filesProgress)) {
            var aggregateClass;
            if (_.contains(this.filesDoneClass, 'error')) {
                aggregateClass = 'error';
            } else if (_.contains(this.filesDoneClass, 'cancelled')) {
                aggregateClass = 'cancelled';
            } else {
                aggregateClass = 'success';
            }
            this.filesDoneClass = {};
            this.removeProgressClass('busy active cancelled error success');
            this.addProgressClass('done');
            this.addProgressClass(aggregateClass);
            setTimeout(_.bind(function () {
                this.addProgressClass('disengaging');
                this.removeProgressClass('busy active cancelled error success done engaged confirmed');
                setTimeout(_.bind(function () {
                    this.removeProgressClass('disengaging');
                }, this), 200);
            }, this), 1000);
        }
    },
    uploadCancelled: function (fileWrap) {
        this.uploadDone('cancelled', fileWrap);
    },
    uploadError: function (fileWrap) {
        this.uploadDone('error', fileWrap);
    },
    uploadSuccess: function (fileWrap) {
        this.uploadDone('success', fileWrap);
    },
    inputChange: function (e) {
        var files = this.file[0].files;
        this.doUpload({
            files: files
        });
    },
    prompt: function () {
        this.file.click();
    },
    submit: function (e) {
        e.preventDefault();
    },
    render: function () {
        this.radialProgress = $('<span class="radialProgress"><span class="part first"></span><span class="part rest"></span></span>');
        var labelId = 'bufferUploadView' + this.model.bid();
        if (this.model.isThread()) {
            labelId += 'Thead';
        }
        this.label = $('<label class="g">').text('Upload a file').attr('for', labelId);
        this.file = $('<input class="g" name="file" type="file" multiple tabindex="-1" aria-hidden="true">').attr('id', labelId);
        $(this.el).append(this.label);
        $(this.el).append(this.file);
        
        this.model.bind('remove', this.remove, this);
        
        return this;
    },
    clear: function () {
        this.file.val('');
    },
    val: function () {
        return this.file.val();
    },
    joinLink: function (message, link) {
        var sep = (_.last(message) == ' ') ? '' : ' ';
        return message + sep + link;
    },
    finaliseFileFromPromise: function (promise, fileView, options) {
        options = options || {};
        fileView.model.triggerBubble('uploadConfirmed');
        var progress = fileView.renderLocalInlineProgress(promise, options);
        if (options.progress) {
            options.progress.replaceWith(progress);
        }
        options.progress = progress;
        fileView.once('finalise', function (retryPromise) {
            options.retry = true;
            this.model.trigger('retryPending', options.reqid);
            this.finaliseFileFromPromise(retryPromise, fileView, options);
        }, this);

        var finalised = new $.Deferred().fail(_.bind(function (errorResponse, msg) {
            fileView.bind('collapsed', function () {
                this.model.trigger('rewriteSayRequest', options.reqid);
            }, this);
            if (errorResponse) {
                this.model.trigger('sayError', errorResponse, msg);
            }
        }, this));

        if (!options.retry) {
            fileView.renderLocalInlinePreview().done(_.bind(function (preview) {
                if (finalised.state() == 'pending') {
                    var localProgress = $('<span class="fileProgress">')
                        .append(options.progress)
                        .append(preview);
                    var extraHtml = $('<span class="fileWrap">').append(localProgress);
                    fileView.setElement(extraHtml);
                    var dummyMessage = fileView.model.dummyUrl();
                    if (options.message) {
                        dummyMessage = this.joinLink(options.message, dummyMessage);
                    }
                    this.model.trigger('sayRequest', dummyMessage, options.reqid, extraHtml);
                    fileView.model.setReqId(this.model, options.reqid);
                }
            }, this));
        }
        promise.done(_.bind(function (uploadResponse) {
            fileView.model.finalise(options, _.bind(function (finaliseResponse) {
                if (finaliseResponse.success) {
                    var msg = fileView.model.getUrl();
                    if (options.message) {
                        msg = this.joinLink(options.message, msg);
                    }
                    this.post(msg, options, _.bind(function (response) {
                        if (response.success) {
                            finalised.resolve();
                        } else {
                            finalised.reject(response, msg);
                        }
                    }, this));
                    this.model.pushInputHistory(msg);
                } else {
                    options.progress.removeClass('busy');
                    options.progress.css('height', 0);
                    finaliseResponse._reqid = options.reqid;
                    finalised.reject(finaliseResponse, true);
                }
            }, this));
        }, this)).fail(_.bind(function (errorString, errorResponse) {
            if (errorString != 'abort') {
                // Can be missing a response if an error was returned before all data was uploaded
                errorResponse = errorResponse || {message: 'upload_error'};
                errorResponse._reqid = options.reqid;
                finalised.reject(errorResponse, true);
            } else {
                finalised.reject();
            }
        }, this));
    },
    post: function (msg, options, callback) {
        return this.model.say(msg, {
            reqid: options.reqid,
            callback: callback,
            silent: true
        });
    },
    finaliseFileTree: function (fileTreeView, options) {
        var finalPromise = fileTreeView.finaliseFiles(options).done(_.bind(function () {
            var finalisedFiles = fileTreeView.processFinalised();
            _.each(fileTreeView.fileViews, function (fileView) {
                fileView.once('finalise', function (retryPromise, thisFileView) {
                    var opts = {
                        reqid: this.model.session.backend._getRequestId()
                    };
                    fileTreeView.removeFile(thisFileView);
                    var newDummyMessage = fileTreeView.dummyMessage(options);
                    this.model.trigger('rewriteSayRequest', options.reqid, newDummyMessage);
                    this.finaliseFileFromPromise(retryPromise, thisFileView, opts);
                }, this);
            }, this);
            if (finalisedFiles.length) {
                var msg = _.map(finalisedFiles, function (file) {
                    return file.getUrl();
                }).join(' ');
                if (options.message) {
                    msg = this.joinLink(options.message, msg);
                }
                this.post(msg, options, _.bind(function (response) {
                    if (!response.success) {
                        this.model.trigger('sayError', response, msg);
                    }
                }, this));
                this.model.pushInputHistory(msg);
            } else {
                this.model.trigger('sayError', {
                    _reqid: options.reqid,
                    message: 'batch_upload_failed'
                }, true);
            }
        }, this));

        fileTreeView.renderLocalInlinePreview(this.model, options).done(_.bind(function (extraHtml) {
            if (finalPromise.state() == 'pending') {
                var dummyMessage = fileTreeView.dummyMessage(options);
                this.model.trigger('sayRequest', dummyMessage, options.reqid, extraHtml);
            }
        }, this));
    }
});

module.exports = BufferUploadView;


/***/ }),

/***/ "o4N7":
/***/ (function(module, exports, __webpack_require__) {

var Buf = __webpack_require__("t9zO");


var BufferList = Backbone.Collection.extend({
    model: Buf
});


module.exports = BufferList;


/***/ }),

/***/ "o6PP":
/***/ (function(module, exports, __webpack_require__) {

var DialogView = __webpack_require__("EjYC");


var HashDialogView = DialogView.extend({
    initialize: function (options) {
        DialogView.prototype.initialize.apply(this, arguments);
        
        this.router = options.router;
    },
    show: function () {
        this.wrapper.fadeIn('fast', _.bind(function () {
            this.afterShow();
        }, this));
        
        this.opened();
    },
    afterShow: function () {
        this.focusFirst();
    },
    focusFirst: function () {
        this.$('[tabindex=0]:visible:first').first().focus();
    },
    doHide: function () {
        this.wrapper.fadeOut(200);
        this.closed();
        HashDialogView.current = null;
    },
    hide: function () {
        this.doHide();
        this.model.trigger('hashDialogHide');
    },
    opened: function () {
        if (HashDialogView.current != this) {
            HashDialogView.closeCurrent();
            HashDialogView.current = this;
        }
        DialogView.prototype.opened.call(this);
    },
    closed: function () {
        DialogView.prototype.closed.call(this);
    }
}, {
    closeCurrent: function () {
        if (HashDialogView.current) {
            HashDialogView.current.doHide();
        }
        DialogView.closeCurrent();
    }
});


module.exports = HashDialogView;


/***/ }),

/***/ "oABZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _channelLinks = __webpack_require__("xAe2");

var _channelLinks2 = _interopRequireDefault(_channelLinks);

var _bufferformatter = __webpack_require__("gfb+");

var _bufferformatter2 = _interopRequireDefault(_bufferformatter);

var _dialogview = __webpack_require__("EjYC");

var _dialogview2 = _interopRequireDefault(_dialogview);

var _keyboard = __webpack_require__("fDhS");

var _keyboard2 = _interopRequireDefault(_keyboard);

var _channelSwitchDialog = __webpack_require__("3fPi");

var _channelSwitchDialog2 = _interopRequireDefault(_channelSwitchDialog);

var _fuzzaldrinPlus = __webpack_require__("yPLO");

var _unorm = __webpack_require__("9EmB");

var _unorm2 = _interopRequireDefault(_unorm);

var _util = __webpack_require__("GmLC");

__webpack_require__("gcT9");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Super = _dialogview2.default.prototype;

var INIT_STATE = { filtered: [], current: 0 };

exports.default = _dialogview2.default.extend({

    showInstant: true,
    hideInstant: true,

    template: _channelSwitchDialog2.default,

    className: 'channelSwitchDialog accountContainer form',

    events: $.extend({}, Super.events, {
        'keyup .channelSwitchDialog__input': onInput
    }),

    initialize: function initialize(options) {
        var _this = this;

        Super.initialize.apply(this, arguments);
        this.selectBuffer = selectBuffer.bind(this);
        this.channelLinks = new _channelLinks2.default({
            select: this.selectBuffer
        });
        this.setInitialState();

        // cmd + k 
        $(window).on('keydown', function (e) {
            if (_keyboard2.default.isModifier(e) && e.which === _keyboard2.default.KEYS.K) {
                e.preventDefault();
                _this.toggle();
            }
        });
    },
    setInitialState: function setInitialState() {
        this.setState(INIT_STATE);
    },
    setState: function setState(state) {
        this.channelLinks.setState(state);
    },
    render: function render() {
        // right now we only render this dialog once, but if we would render 
        // it more than once, we'd need to re-delegate events on the subviews 
        // as `.html` calls `.empty` internally on all the element’s descendants 
        this.$el.html(this.template());
        this.afterRender();
        return this;
    },
    afterRender: function afterRender() {
        this.$input = this.$el.find('.channelSwitchDialog__input');
        this.$channelLinks = this.$el.find('.channelSwitchDialog__channelLinks');
        this.$channelLinks.append(this.channelLinks.el);
    },
    filter: function filter(query, force) {
        query = query.replace(/\s/g, '');
        query = (0, _util.normaliseChan)(query);

        if (!force && query === this.prevQuery) {
            return;
        }

        if (query && this.fuzzyFilter) {
            var filtered = this.fuzzyFilter(query);
            var currentBuffer = void 0;
            var currentBufferKey = void 0;

            if (this.model.currentBuffer) {
                currentBufferKey = this.model.currentBuffer.bid();
            }

            filtered = filtered.filter(function (candidate) {
                // filter current buffer out to push it to the end of the list
                if (candidate.bid === currentBufferKey) {
                    currentBuffer = candidate;
                    return false;
                } else {
                    return true;
                }
            });
            if (currentBuffer) {
                filtered.push(currentBuffer);
            }
            // debug.table(filtered);
            this.setState({ filtered: filtered, current: 0 });
        } else {
            this.setInitialState();
        }

        this.prevQuery = query;
    },
    opened: function opened() {
        Super.opened.apply(this, arguments);
        this.$input.val('');
        this.setFilter();
        this.channelLinks.setup();
        this.$input.focus();
    },
    setFilter: function setFilter() {
        this.data = getData.call(this);
        this.fuzzyFilter = getFuzzyFilter(getConnections(this.model), this.data.buffers);
    },
    runFilter: function runFilter(force) {
        this.filter(this.$input.val(), force);
    },
    closed: function closed() {
        this.$input.val('');
        this.setInitialState();
        this.data = null;
        this.fuzzyFilter = null;
        this.channelLinks.teardown();
        Super.closed.apply(this, arguments);
    }
});


function onInput(e) {
    if (e.which === _keyboard2.default.KEYS.UP || e.which === _keyboard2.default.KEYS.DOWN) {
        return;
    }

    this.runFilter();
}

function selectBuffer(selection) {
    if (selection.bid) {
        var buffer = selection.connection.getBuffer(selection.bid);
        if (buffer) {
            buffer.select();
        }
    } else {
        selection.connection.openBuffer(selection.name);
    }
    this.hide();
}

var _archiveNames = null;
var _fetchingArchives = false;
function fetchArchiveNames() {
    var _this2 = this;

    if (_archiveNames || _fetchingArchives) {
        return;
    }
    this.$el.addClass('loading');
    _fetchingArchives = true;
    this.model.backend.get('archive-names', {}, function (response) {
        if (!response.error && response.success !== false) {
            _archiveNames = response;
            _this2.setFilter();
            _this2.runFilter(true);
        }
        _this2.$el.removeClass('loading');
        _fetchingArchives = false;
    });
}

function getData() {
    var _this3 = this;

    var buffers = [];
    this.model.connections.forEach(function (connection) {
        var connectionName = connection.getDisplayName();
        var bufferUrls = {}; // dupe checking
        connection.buffers.channels.models.concat(connection.buffers.conversations.models).forEach(function (buffer) {
            var displayName = buffer.getDisplayName();
            if (buffer.isChannel()) {
                var safeChanSuffix = buffer.safeChanSuffix();
                if (safeChanSuffix) {
                    displayName += ' ' + safeChanSuffix;
                }
            }
            var bufferUrl = buffer.url();
            bufferUrls[bufferUrl] = true;
            buffers.push({
                connection: connection,
                bid: buffer.bid(),
                type: buffer.getType(),
                name: buffer.getName(),
                displayName: displayName,
                href: bufferUrl,
                archived: buffer.isArchived(),
                active: buffer.isActive(),
                searchKey: prepareSearchKey(buffer.normalise() + connectionName),
                serverName: connectionName
            });
        });
        if (connection.hasDeferredArchives()) {
            fetchArchiveNames.call(_this3);
        }
        if (_archiveNames && _archiveNames[connection.id]) {
            var formatter = new _bufferformatter2.default(connection.serverLog);
            _archiveNames[connection.id].forEach(function (name) {
                var isChannel = formatter.linker.isChannelName(name);
                var urlNamespace = isChannel ? 'channel' : 'messages';
                var type = isChannel ? 'channel' : 'conversation';
                var urlName = isChannel ? connection.channelSlug(name) : name;
                var bufferUrl = connection.buildUrl([urlNamespace, urlName]);
                if (bufferUrls[bufferUrl]) {
                    return;
                }
                var displayName = name;
                if (isChannel) {
                    var dummyChannel = connection.makeChannel({ name: name });
                    displayName = dummyChannel.getDisplayName();
                    var safeChanSuffix = dummyChannel.safeChanSuffix();
                    if (safeChanSuffix) {
                        displayName += ' ' + safeChanSuffix;
                    }
                }
                buffers.push({
                    connection: connection,
                    type: type,
                    name: name,
                    displayName: displayName,
                    href: bufferUrl,
                    archived: true,
                    active: false,
                    searchKey: prepareSearchKey(connection.normaliseBufferName(name) + connectionName),
                    serverName: connectionName
                });
            });
        }
    });

    return { buffers: buffers };
}

function indexOfScorer(term, query) {
    var position = term.indexOf(query);
    if (position === -1) {
        return 0;
    }
    return 1 / (position + 1);
}

function getFuzzyFilter(connections, buffers) {
    return function fuzzyFilter(query) {
        return buffers.concat().map(function (b, i) {
            b.score = (0, _fuzzaldrinPlus.score)(b.searchKey, query);
            b.indexOfScore = indexOfScorer(b.searchKey, query);
            b.connectionOrder = connections[b.connection.id];
            return b;
        }).filter(function (b) {
            return b.score > 0;
        }).sort(function (a, b) {
            var archiveSort = a.archived - b.archived;
            var activeSort = b.active - a.active;
            var indexOfSort = b.indexOfScore - a.indexOfScore;
            var scoreSort = b.score - a.score;
            var orderSort = a.connectionOrder - b.connectionOrder;

            if (archiveSort !== 0) {
                return archiveSort;
            }

            if (activeSort !== 0) {
                return activeSort;
            }

            if (indexOfSort !== 0) {
                return indexOfSort;
            }

            if (scoreSort !== 0) {
                return scoreSort;
            }

            return orderSort;
        });
    };
}

function getConnections(session) {
    return session.connections.reduce(function (connections, conn, i) {
        connections[conn.id] = i;
        return connections;
    }, {});
}

function prepareSearchKey(searchKey) {
    // convert emoji to text
    // decompose the string to ascii + diacritic mark and remove the mark
    // i.e. é = U+0065 U+0301 = e ´
    // `String::normalize('NFKD')` is not available in Safari and IE
    return _unorm2.default.nfkd(emoji.unified_to_text(searchKey)).replace(/[\u0300-\u036F]/g, '');
}

/***/ }),

/***/ "oMKX":
/***/ (function(module, exports, __webpack_require__) {

var urlUtil = __webpack_require__("Dn1P");
var Autogrow = __webpack_require__("ZGvr");
var Connection = __webpack_require__("LLdI");
var HashDialogView = __webpack_require__("o6PP");
var NetworkEditor = __webpack_require__("0xAE");
var OrgMember = __webpack_require__("w2pc");
var OrgMemberView = __webpack_require__("PQdE");
var PayViewMixins = __webpack_require__("eIfS");


var OrgDetailView = HashDialogView.extend($.extend({}, PayViewMixins, {
    el: '#orgDetailScreen',
    initialize: function (options) {
        this.session = options.session;
        this.dialog = options.dialog;
        this.formatter = this.dialog.formatter;
        this.dialog.bind('close', this.hide, this);

        this.visible = false;
        this.billingShown = false;

        this.returnLines = $('#orgDetailScreenReturn');

        this.billingInfo = $('#orgBillingInfo');
        this.billingLink = this.$('a.orgBilling');
        this.billingBackLink = this.$('.orgBillingBack');
        this.billingDetails = $('#orgBillingDetails');

        this.details = $('#orgDetails');

        this.detailVitals = $('#orgDetailVitals');
        this.detailName = this.$('.orgDetailName');
        this.detailBorn = $('#orgDetailBorn');
        this.detailBillingEmail = $('#orgDetailBillingEmail');
        this.detailBillingEmailRow = $('#orgDetailBillingEmailRow');
        this.detailVatCountry = $('#orgDetailVatCountry');
        this.detailVatNumber = $('#orgDetailVatNumber');
        this.detailVatRow = $('#orgDetailVatRow');
        this.detailVatExplanation = $('#orgDetailVatExplanation');

        this.manageLinks = $('#orgManageLinks');
        this.deleteLink = $('#orgDeleteLink');
        this.editLinks = $('#orgEditLinks');
        this.editForm = $('#orgEditForm');
        this.editName = $('#orgEditName');
        this.editBillingEmail = $('#orgEditBillingEmail');
        this.editVatCountries = $('#orgEditVatCountries');
        this.editVatNumber = $('#orgEditVatNumber');
        this.editError = $('#orgEditError');

        this.deleteConfirm = $('#orgDeleteConfirm');
        this.deleteForm = $('#orgDeleteForm');
        this.deleteError = $('#orgDeleteError');

        this.leaveConfirm = $('#orgLeaveConfirm');
        this.leaveConfirmOnlyAdmin = $('#orgLeaveConfirmOnlyAdmin');
        this.leaveLastFree = $('#orgLeaveLastFree');
        this.leaveForm = $('#orgLeaveForm');
        this.leaveError = $('#orgLeaveError');

        this.connectionsWrapper = $('#orgConnections');
        this.networkDetails = $('#orgDetailConnections');
        this.networkDetailsHead = $('#orgDetailConnectionsHead');
        this.addConnectionsLink = $('#orgAddMoreConnections');
        this.addConnectionsHead = $('#orgAddConnectionsHead');
        this.addConnections = $('#orgAddConnections');
        this.addIrcd = $('#orgAddIrcd');
        this.addMoreLink = $('#orgAddMoreLink');
        this.networkJoinForm = $('#orgJoinConnectionsForm');
        this.networkJoinExplanation = $('#orgConnectionsJoinExplanation');
        this.networkJoinAlready = $('#orgConnectionsJoinAlready');
        this.networkJoinRealName = $('#orgJoinConnectionsRealName');
        this.networkExplanation  = $('.orgConnectionsExplanation');
        this.ircdEditorContainer = $('#orgIrcdEditor');
        this.networkEditorContainer = $('#orgNetworkEditor');
        this.addWithMembers = $('#orgAddWithMembers');

        this.memberManage = $('#orgMembersManage');

        this.addMembersForm = $('form#orgAddMembers');
        this.addMemberError = $('#orgAddMemberError');
        this.addMembersEmail = $('#orgAddMembersEmail');
        new Autogrow({
            el: this.addMembersEmail,
            minHeight: 76
        });
        this.addMemberExplanation = $('#orgAddMemberExplanation');

        this.inviteesTable = $('table#orgInvitees');
        this.inviteesSend = $('#orgInviteesSend');
        this.inviteeViews = [];

        this.membersWrapper = $('#orgMembersWrapper');
        this.membersForm = $('form#orgMembers');
        this.membersSave = $('#orgMembersSave');
        this.membersTable = this.membersForm.find('table.joined');
        this.pendingMembersTable = this.membersForm.find('table.pending');
        this.membersViews = [];

        this.paymentBusinessDetails = $('form#orgPaymentBusinessDetails');
        this.paymentBillingEmail = $('#orgPaymentBillingEmail');
        this.paymentVatHidden = $('#orgPaymentVatHidden');
        this.paymentVatWrapper = $('#orgPaymentVatWrapper');
        this.paymentVatCountries = $('#orgPaymentVatCountries');
        this.paymentVatNumber = $('#orgPaymentVatNumber');
        this.paymentBusinessDetailsError = $('#orgPaymentBusinessDetailsError');
        this.paymentBusinessDetailsButton = $('#orgPaymentBillingConfirm');
    },
    events: _.extend({}, HashDialogView.prototype.events, PayViewMixins.events, {
        'submit #orgAddMembers': 'submitAddMembers',
        'submit #orgMembers': 'submitEditMembers',
        'click .deleteOrg': 'clickDelete',
        'click .leaveOrg': 'clickLeave',
        'click .editOrg': 'clickEdit',
        'submit #orgDeleteForm': 'submitDelete',
        'submit #orgLeaveForm': 'submitLeave',
        'buttonClick #orgDeleteForm .cancel': 'clickCancelDelete',
        'buttonClick #orgLeaveForm .cancel': 'clickCancelLeave',
        'buttonClick #orgLeaveConfirmOnlyAdmin .cancel': 'clickCancelLeave',
        'submit #orgEditForm': 'submitEditForm',
        'buttonClick #orgEditForm .cancel': 'clickCancelEdit',
        'click #orgAddMoreConnections a': 'clickAddMoreConnections',
        'click #orgAddMoreLink a': 'clickAddMoreConnections',
        'click #orgUseCustomConnection a.custom': 'clickUseCustomConnection',
        'click #orgDetailConnections div.networks a.delete': 'clickRemoveConnection',
        'buttonClick #orgRemoveIrcdConfirm .delete': 'clickRemoveIrcd',
        'buttonClick #orgRemoveIrcdConfirm .cancel': 'clickCancelRemoveIrcd',
        'buttonClick #orgInviteesSend': 'clickInviteesSend',
        'submit #orgJoinConnectionsForm': 'submitJoinMissingForm',
        'submit #orgPaymentBusinessDetails': 'submitPaymentBusinessDetails',
        'buttonClick #orgPaymentBillingConfirm': 'submitPaymentBusinessDetails',
        'click #orgPaymentVatHidden a': 'clickPaymentVatShow'
    }),
    render: function (org, billing) {
        if (this.model != org) {
            if (this.model) {
                this.model.members.unbind(null, null, this);
                this.model.invitees.unbind(null, null, this);
                this.model.unbind(null, null, this);
                this.session.unbind(null, null, this);

                this.hideAddMemberError();
                this.editMode(false);
                this.hideEditError();
                this.hideDeleteConfirm();
                this.hideLeaveConfirm();
                $(this.el).removeSpin();
                this.hideDeleteError();
                this.hideLeaveError();
                this.resetPay();
                this.renderPay();
                this.addMembersEmail.val('');
            }

            this.model = org;
            this.model.bind('change', this.renderDetails, this);
            
            this.model.members.bind('reset saved', this.resetMembers, this);
            this.model.members.bind('change removedChange saved', this.renderMembersChanged, this);
            
            this.model.bind('connectionsChange billingUpdate', this.resetConnections, this);
            
            this.model.bind('change connectionsChange billingUpdate', this.updateProgression, this);
            this.model.members.bind('reset saved', this.updateProgression, this);

            this.model.bind('change connectionsChange', this.renderPay, this);

            PayViewMixins.initialize.call(this);

            this.model.invitees.bind('add', this.addMemberToAdd, this);
            this.model.invitees.bind('remove', this.removeInvitees, this);
            this.model.invitees.bind('reset', this.resetInvitees, this);

            this.model.invitees.bind('add remove reset', this.updateAmount, this);
            this.model.members.bind('add remove reset', this.updateAmount, this);
            this.listenTo(this.session, 'plansChange', this.plansChange);

            this.model.invitees.bind('add remove reset', this.renderPay, this);
            this.model.members.bind('add remove reset', this.renderPay, this);

            this.billingLink.attr('href', '/?/team-billing=' + this.model.id);
            this.billingBackLink.attr('href', '/?/team=' + this.model.id);
            this.networkEditor = this.makeEditor();
            this.ircdEditor = this.makeIrcdEditor();
            this.ircdEditorContainer.html(this.ircdEditor.render().el);
            this.networkEditorContainer.html(this.networkEditor.render().el);
            this.networkEditor.renderSelectComplete($(this.dialog.el)); // needs to happen after it's appended to the DOM cos of the shitty plugin
            this.networkEditor.triggerLoad();
        }

        this.renderDetails();
        this.resetConnections();
        this.resetMembers();
        this.resetInvitees();
        this.updateProgression();
        this.updateAmount();
        this.toggleBillingInfo(billing);
        this.renderBackLinks();
        if (this.model.isAdmin()) {
            this.model.getMembers();
        }
    },
    renderBackLinks: function () {
        var onlyOne = this.session.hasOneOrg();
        $('#orgDetailCreateLink').toggle(onlyOne);
        $('#orgDetailListLink').toggle(!onlyOne);
        this.returnLines.show();
    },
    renderDetails: function () {
        this.editLinks.toggle(this.model.isAdmin());
        this.detailVitals.show();
        this.manageLinks.show();
        this.deleteLink.hide();
        this.detailBillingEmailRow.toggle(this.model.isAdmin());
        this.detailName.text(this.model.get('name'));
        this.editName.val(this.model.get('name'));
        this.detailBorn.text(new Date(this.model.get('creation_time') * 1000).toString('dd MMM yyyy'));

        this.detailBillingEmail.text(this.model.get('billing_email'));
        this.editBillingEmail.val(this.model.get('billing_email'));
        this.paymentBillingEmail.val(this.model.get('billing_email'));
        this.detailVatRow.toggleClass('edit', !this.model.get('vat_number'));
        this.detailVatExplanation.toggleClass('edit', !this.model.get('vat_number'));
        this.detailVatCountry.text(this.model.get('vat_country'));
        this.renderVatCountries();
        this.detailVatNumber.text(this.model.get('vat_number'));
        this.editVatNumber.val(this.model.get('vat_number'));
        this.paymentVatNumber.val(this.model.get('vat_number'));
        this.renderBillingDetails();
    },
    clickAddMoreConnections: function (e) {
        e.preventDefault();
        if (this.addConnections.is(':visible') || this.addIrcd.is(':visible')) {
            this.networkExplanation.hide();
            this.addConnections.slideUp('fast');
            this.addIrcd.slideUp('fast');
        } else {
            if (this.model.hasIrcd()) {
                this.clickUseCustomConnection(e);
            } else {
                this.cancelConnections();
            }
        }
    },
    clickUseCustomConnection: function (e) {
        e.preventDefault();
        this.addIrcd.slideUp('fast');
        this.networkExplanation.show();
        this.addConnections.slideDown('fast', _.bind(function () {
            this.networkEditor.focusNetwork();
        }, this));
    },
    clickRemoveConnection: function (e) {
        e.preventDefault();
        var net = $(e.target).closest('div.network');
        var index = net.data('index');
        if (index == 'ircd') {
            $('#orgRemoveIrcdConfirm').slideDown('fast');
        } else {
            net.addClass('removedNetwork');
            this.model.removeNetwork(index, function (response) {
                if (!response.success) {
                    net.removeClass('removedNetwork');
                }
            });
        }
    },
    clickCancelRemoveIrcd: function (e) {
        e.preventDefault();
        $('#orgRemoveIrcdConfirm').slideUp('fast');
    },
    clickRemoveIrcd: function (e) {
        e.preventDefault();
        var net = $(e.target).closest('div.network.ircd');
        net.addClass('removedNetwork');
        $('#orgRemoveIrcdConfirm button.delete').addSpin();
        this.model.removeIrcd(function (response) {
            $('#orgRemoveIrcdConfirm button.delete').removeSpin();
            if (response.success) {
                $('#orgRemoveIrcdConfirm').slideUp('fast');
            } else {
                net.removeClass('removedNetwork');
            }
        });
    },
    submitAddMembers: function (e) {
        e.preventDefault();
        this.hideAddMemberError();
        var data = this.addMembersForm.serializeForm();
        var emails = _.unique(_.filter(data.emails.trim().split(/[\s,]+/), _.identity));
        var toAdd = [];
        var invalids = [];
        _.each(emails, function (email) {
            if (urlUtil.isEmail(email)) {
                var exists = this.model.invitees.find(function (m) {
                    return m.get('email') == email;
                });
                if (exists) {
                    if (exists.isRemoved()) {
                        exists.set(data);
                        exists.setRemoved(false);
                    }
                } else {
                    toAdd.push({email: email});
                }
            } else {
                invalids.push(email);
            }
        }, this);
        if (_.isEmpty(invalids)) {
            this.model.invitees.add(toAdd);
            this.addMembersEmail.val('').trigger('update');
        } else {
            var msg = '<b>Invalid email address';
            if (invalids.length != 1) {
                msg += 'es';
            }
            msg += ':</b><br>';
            msg += _.map(invalids, this.formatter.escapeText).join('<br>');
            this.addMemberError.html(msg).fadeIn('fast');
        }
    },
    hideAddMemberError: function () {
        this.addMemberError.hide();
    },

    resetInvitees: function () {
        _.each(this.inviteeViews, function (memberView) {
            memberView.remove();
        }, this);
        this.inviteeViews = [];
        this.model.invitees.each(function (m) {
            this.addMemberToAdd(m);
        }, this);
        this.inviteesSend.hide();
        if (this.model.invitees.length) {
            this.inviteesTable.fadeIn('fast');
            if (this.model.hasSubscribed()) {
                this.inviteesSend.show();
            }
        } else {
            this.inviteesTable.hide();
        }
    },
    removeInvitees: function () {
        if (!this.model.invitees.length) {
            this.inviteesTable.hide();
            this.inviteesSend.hide();
        }
    },
    addMemberToAdd: function (member) {
        if (this.model.hasSubscribed()) {
            this.inviteesSend.show();
        }
        this.membersTable.show();

        var prevLength = this.inviteeViews.length;
        var view = new OrgMemberView({
            model: member,
            collection: this.model.invitees,
            undoable: false
        });
        this.inviteeViews.push(view);
        this.inviteesTable.append(view.render().el).fadeIn('fast', _.bind(function () {
            if (!prevLength) {
                this.addMembersEmail[0].scrollIntoView();
            }
        }, this));
    },

    plansChange: function () {
        this.updateAmount();
        this.renderVatCountries();
    },
    renderVatVisible: function () {
        var show = this.session.plans.eu_vat.applicable || !!this.model.get('vat_number');
        this.paymentVatHidden.toggle(!show);
        this.paymentVatWrapper.toggle(show);
    },
    renderVatCountries: function () {
        this.paymentVatCountries.html('<option>');
        this.editVatCountries.html('<option>');
        if (this.session.plans.eu_vat) {
            this.renderVatVisible();
            _.each(this.session.plans.eu_vat.countries, function (c) {
                var option = $('<option>').val(c.code).text(c.code + ' - ' + c.name);
                var editOption = option.clone();
                if (c.code === (this.model.get('vat_country') || this.session.plans.vat_country || this.session.plans.country)) {
                    option.prop('selected', true);
                    editOption.prop('selected', true);
                }
                this.paymentVatCountries.append(option);
                this.editVatCountries.append(editOption);
            }, this);
        }
    },
    getUserCount: function () {
        return this.model.invitees.length + this.model.members.length + 1;
    },
    getAmount: function () {
        var userCount = this.getUserCount();
        return userCount * this.dialog.getPerSeat();
    },
    updateAmount: function () {
        var userCount = this.getUserCount();
        this.$('.pay .userCount').text(userCount);
        this.$('.pay .userCountPlural').toggle(userCount != 1);
        this.$('.pay .perUser').text(this.formatter.amount(this.session.getCurrency(), this.dialog.getPerSeat()));
        this.$('.pay .amount').text(this.formatter.amount(this.session.getCurrency(), this.getAmount()));
    },
    clickInviteesSend: function (e) {
        e.preventDefault();
        this.model.inviteMembers();
    },

    updateProgression: function () {
        if (this.model.hasSubscribed()) {
            this.dialog.hideProgression();
        } else if (this.model.hasFetchedMembers()) {
            if (this.model.areConnectionsChosen() || this.model.hasIrcd()) {
                this.dialog.showMembersProgression();
            } else {
                this.dialog.showConnectionsProgression();
            }
        }
    },

    resetMembers: function () {
        _.each(this.membersViews, function (memberView) {
            memberView.remove();
        }, this);
        this.membersViews = [];
        this.membersTable.hide();
        this.pendingMembersTable.hide();
        this.membersWrapper.hide();
        this.addMember(new OrgMember({
            email: this.session.get('email'),
            uid: this.session.id,
            admin: true,
            self: true
        }, {
            org: this.model
        }));
        if (this.model.members.length) {
            this.model.members.each(this.addMember, this);
            this.detailVitals.show();
            this.manageLinks.show();
            this.deleteLink.hide();
        }
        this.membersWrapper.show();
    },
    renderMembersChanged: function () {
        this.membersSave.toggle(this.model.membersNeedSaving());
    },
    addMember: function (member) {
        var view = new OrgMemberView({
            model: member,
            collection: this.model.members
        });
        this.membersViews.push(view);
        if (member.isJoined()) {
            this.membersTable.find('tbody').append(view.render().el);
        } else {
            this.pendingMembersTable.find('tbody').append(view.render().el);
            this.pendingMembersTable.show();
        }
        if (this.membersViews.length > 1) {
            this.membersTable.show();
        }
    },

    submitEditMembers: function (e) {
        e.preventDefault();
        this.membersForm.addSpin();
        this.model.saveMembers(_.bind(function (response) {
            this.membersForm.removeSpin();
        }, this));
    },
    focusAddMemberEmail: function () {
        this.addMembersEmail.focus().select();
    },
    focusEditName: function () {
        this.editName.focus().select();
    },

    // PayViewMixins
    billingCancelSureText: 'Are you sure you want to cancel this team subscription? All your members will revert to personal account limits.',
    formatPlan: function (b) {
        var s = b.quantity != 1 ? 's' : '';
        return this.formatter.escapeText(b.quantity) + ' seat' + s + ' — ' + this.formatter.amount(b.currency, b.amount * b.quantity) + '/month';
    },
    formatSubscriptionInvoiceItem: function (sub) {
        var s = sub.quantity != 1 ? 's' : '';
        return 'Subscription (' + this.formatter.escapeText(sub.quantity) + ' seat' + s + ')';
    },
    stripeCheckout: function (label, callback, options) {
        return PayViewMixins.stripeCheckout.call(this, label, callback, $.extend(true, {}, {
            email: this.model.get('billing_email'),
            currency: this.session.getCurrency(),
            amount: this.getAmount(),
            description: 'Team subscription for ' + this.model.get('name'),
            closed: _.bind(this.updateProgression, this),
            org: this.model.id,
            subscription: true
        }, options));
    },
    doPayment: function () {
        var currency = this.session.getCurrency();
        this.stripeCheckout(
            'Setup subscription',
            _.bind(function (data, mixinCallback) {
                if (data) {
                    data.currency = currency;
                    data.seats = 1;
                    this.model.subscribe(data, _.bind(function (response) {
                        if (response.success) {
                            this.model.inviteMembers();
                            this.connectionsWrapper.slideUp('fast');
                            this.memberManage.slideUp('fast');
                        }
                        mixinCallback(response);
                    }, this));
                }
            }, this)
        );
    },
    clickPayButton: function (e) {
        e.preventDefault();
        this.doPayment();
    },

    renderPayNoActiveSub: function () {
        if (this.model.hasSubscribed() || this.model.areConnectionsChosen() || this.model.hasIrcd()) {
            PayViewMixins.renderPayNoActiveSub.call(this);
            this.paymentBusinessDetails.show();
            this.dialog.benefits.show();
        }
    },
    renderPayCanSeeSubscription: function () {
        this.addMemberExplanation.toggle(!this.model.hasSubscribed());
        PayViewMixins.renderPayCanSeeSubscription.call(this);
    },
    resetPay: function () {
        this.hidePayError();
        this.$('.payStatus').hide();
        this.$('.payComplete').hide();
    },
    renderPay: function () {
        this.paymentBusinessDetails.hide();
        this.dialog.benefits.hide();
        this.renderBackLinks();
        PayViewMixins.renderPay.call(this);
    },
    renderBillingDetails: function () {
        var contents = this.formatBillingDetails();
        contents.find('.subscriptionStatus').append($('#tpl-org-billing-pay-status').html());
        contents.find('.payMonthlyNew .payButtonWrapper').append($('#tpl-org-billing-pay-footer').html());
        this.billingDetails.html(contents);
        this.updateAmount();
    },

    resetConnections: function (options) {
        var chosen = this.model.areConnectionsChosen();
        var peeps = this.model.hasMembersOrInvitees();
        var subbed = this.model.hasSubscribed();
        var hasIrcd = this.model.hasIrcd();

        // Only show members if connections have been chosen or skipped
        this.connectionsWrapper.show();
        this.addConnections.hide();
        if (!this.model.isAdmin()) {
            this.memberManage.hide();
            this.addIrcd.hide();
            this.addConnectionsHead.hide();
            this.networkExplanation.hide();
            this.addMoreLink.hide();
        } else {
            this.detailVitals.toggle(chosen && (subbed || peeps));
            this.manageLinks.toggle(chosen && (subbed || peeps));
            this.deleteLink.toggle(chosen && !(subbed || peeps));
            this.memberManage.toggle(chosen);
            this.addWithMembers.toggle(subbed);
            this.addConnectionsHead.toggle(!chosen);
            if (chosen) {
                this.ircdEditor.setCancelLabel('Cancel');
                this.networkEditor.setSubmitLabel("Add Channels");
            }

            this.networkExplanation.toggle(!chosen || hasIrcd || this.model.hasConnections());
            this.addMoreLink.toggle(hasIrcd || this.model.hasConnections());

            this.addIrcd.toggle(!chosen);

            // Reset editors
            this.ircdEditor.setAutoChannels('');
            this.networkEditor.setHostname('');
            this.networkEditor.setPort(Connection.defaultPort);
            this.networkEditor.setSSL();
            this.networkEditor.setAutoChannels('');
            this.networkEditor.setServerPassword('');
        }
        this.networkJoinAlready.hide();
        this.networkJoinExplanation.hide();
        this.networkJoinForm.data('org', this.model.id);
        if (this.model.hasConnections() || hasIrcd) {
            var nets = this.networkDetails.find('div.networks');
            var lines = _.map(this.model.connections, function (c, i) {
                return this.dialog.renderConnection(c, i, this.model.isAdmin(), this.model);
            }, this);
            if (hasIrcd) {
                lines.unshift(this.dialog.renderConnection(this.model.getIrcdConnection(), 'ircd', this.model.isAdmin(), this.model));
            }
            nets.html('').append(lines);

            this.networkJoinRealName.val(this.model.session.get('name'));
            if (nets.find('a.chan, .matchConnChoiceExplanation').length) {
                this.networkJoinExplanation.show();
                this.networkJoinExplanation.find('.connections').hide();
                this.networkJoinExplanation.find('.passwords').hide();
                this.networkJoinExplanation.find('.both').hide();
                this.networkJoinExplanation.find('.update').hide();
                if (nets.find('a.chan').length) {
                    this.networkJoinExplanation.find('.connections').show();
                }
                if (nets.find('.matchConnChoiceExplanation').length) {
                    if (nets.find('.matchConnChoiceExplanation.password').length) {
                        this.networkJoinExplanation.find('.passwords').show();
                        if (nets.find('a.chan').length) {
                            this.networkJoinExplanation.find('button span.connections').hide();
                            this.networkJoinExplanation.find('button span.passwords').hide();
                            this.networkJoinExplanation.find('button span.both').show();
                        }
                    } else {
                        this.networkJoinExplanation.find('.connections').show();
                    }
                }
                if (nets.find('strong.chan').length) {
                    this.networkJoinAlready.show();
                }
            }

            this.networkDetails.find('.edit').show();
            this.networkDetails.show();
            this.networkDetailsHead.show();
            this.addConnectionsLink.hide();
        } else {
            this.networkDetails.hide();
            this.networkDetailsHead.hide();
            this.addConnectionsLink.toggle(this.model.isAdmin() && chosen);
        }
    },
    cancelConnections: function () {
        if (!this.model.hasIrcd()) {
            this.networkExplanation.show();
            this.addMoreLink.hide();
            this.addIrcd.slideDown('fast', _.bind(function () {
                this.ircdEditor.focusChannels();
            }, this));
        }
        this.addConnections.slideUp('fast');
    },
    skipConnections: function () {
        if (!this.model.areConnectionsChosen()) {
            this.model.saveConnections();
        }
        this.addConnectionsHead.hide();
        this.addIrcd.slideUp('fast', _.bind(function () {
            this.addMoreLink.show();
        }, this));
        this.addConnections.slideUp('fast', _.bind(function () {
            if (!this.model.hasConnections()) {
                this.addConnectionsLink.show();
                this.networkExplanation.hide();
            }
            this.ircdEditor.setCancelLabel('Cancel');
            this.networkEditor.setSubmitLabel("Add Channels");
        }, this));
    },
    makeIrcdEditor: function () {
        var idPrefix = "orgAddIrcdChannel";
        return new NetworkEditor({
            model: this.model,
            session: this.session,
            action: _.bind(this.model.addIrcd, this.model),
            callback: _.bind(function (response) {
                if (response.success) {
                    if (this.model.hasSubscribed() && !response.cid) {
                        this.dialog.hide();
                    }
                }
            }, this),
            className: 'addNetworkForm orgAddChannel',
            classPrefix: "addNetwork",
            id: idPrefix + 'Form',
            idPrefix: idPrefix,
            submitLabel: "Continue",
            cancelLabel: "Skip",
            tabFocus: 'Channels',
            cancel: _.bind(this.skipConnections, this),
            cellGroups: [
                {
                    heading: false,
                    cells: [{
                        row: true,
                        optional: true,
                        inputElement: "textarea",
                        inputClass: "Channels",
                        inputAttrs: {
                            name: "channels",
                            rows: 4,
                            placeholder: "e.g. #general, #offtopic (comma, space, or line separated)"
                        }
                    }]
                }
            ]
        }, this);
    },
    makeEditor: function () {
        var idPrefix = "orgAddChannel";
        return new NetworkEditor({
            model: this.model,
            session: this.session,
            action: _.bind(this.model.addNetwork, this.model),
            callback: _.bind(function (response) {
                if (response.success) {
                    if (this.model.hasSubscribed() && (!response.cids || !response.cids[0])) {
                        this.dialog.hide();
                    }
                }
            }, this),
            className: 'addNetworkForm orgAddChannel',
            classPrefix: "addNetwork",
            id: idPrefix + 'Form',
            idPrefix: idPrefix,
            submitLabel: "Continue",
            cancelLabel: "Cancel",
            tabFocus: 'Channels',
            cancel: _.bind(this.cancelConnections, this),
            cellGroups: [
                NetworkEditor.CELL_GROUPS.network,
                {
                    heading: false,
                    cells: [NetworkEditor.CELLS.channels, NetworkEditor.CELLS.serverPass]
                }
            ]
        }, this);
    },

    show: function (org, billing) {
        billing = !!billing;
        this.render(org, billing);
        if (!this.visible) {
            $(this.el).show();
            this.returnLines.show();
            this.visible = true;
        }
        return this;
    },
    hide: function () {
        if (this.visible) {
            $(this.el).hide();
            this.returnLines.hide();
            this.visible = false;
        }
        return this;
    },
    isVisible: function () {
        return this.visible;
    },
    isBillingShown: function () {
        return this.billingShown;
    },
    clickDelete: function (e) {
        e.preventDefault();
        this.showDeleteConfirm();
    },
    clickLeave: function (e) {
        e.preventDefault();
        this.showLeaveConfirm();
    },
    clickCancelDelete: function (e) {
        e.preventDefault();
        this.hideDeleteError();
        this.hideDeleteConfirm();
    },
    clickCancelLeave: function (e) {
        e.preventDefault();
        this.hideLeaveError();
        this.hideLeaveConfirm();
    },
    showDeleteConfirm: function () {
        this.deleteConfirm.fadeIn('fast');
    },
    showLeaveConfirm: function () {
        this.leaveLastFree.toggle(this.session.hasOneOrg() && !this.session.hasActiveSubscription());
        if (this.model.isOnlyAdmin()) {
            this.leaveConfirmOnlyAdmin.fadeIn('fast');
        } else {
            this.leaveConfirm.fadeIn('fast');
        }
    },
    hideDeleteConfirm: function () {
        this.deleteConfirm.hide();
    },
    hideLeaveConfirm: function () {
        this.leaveConfirmOnlyAdmin.hide();
        this.leaveConfirm.hide();
    },
    showDeleteError: function (text) {
        this.deleteError.text(text).fadeIn('fast');
    },
    showLeaveError: function (text) {
        this.leaveError.text(text).fadeIn('fast');
    },
    hideDeleteError: function () {
        this.deleteError.hide();
    },
    hideLeaveError: function () {
        this.leaveError.hide();
    },
    submitDelete: function (e) {
        e.preventDefault();
        this.deleteForm.addSpin();
        this.model.remove(_.bind(function (response) {
            this.deleteForm.removeSpin();
            if (!response.success) {
                this.showDeleteError('There was a problem deleting this team: ' + response.message);
            }
        }, this));
    },
    submitLeave: function (e) {
        e.preventDefault();
        this.leaveForm.addSpin();
        this.model.leave(_.bind(function (response) {
            this.leaveForm.removeSpin();
            if (!response.success) {
                var msg;
                switch (response.message) {
                case 'last_admin_cant_leave':
                    msg = 'You can’t leave this team as the last admin. Did you mean to delete it instead?';
                    break;
                default:
                    msg = 'There was a problem leaving this team: ' + response.message;
                }
                this.showLeaveError(msg);
            }
        }, this));
    },
    toggleBillingInfo: function (show) {
        // TODO rely on fetch working to show
        this.billingInfo.addClass('isLoadingBilling');
        // TODO hide previous billing errors
        if (this.model.isAdmin()) {
            this.model.getBillingInfo(_.bind(function () {
                this.billingInfo.removeClass('isLoadingBilling');
            }, this));
        }
        this.billingInfo.toggle(show);
        this.details.toggle(!show);
        this.billingShown = show;
    },
    editMode: function (toggle) {
        if (toggle === undefined) {
            this.$('.edit').toggle();
            this.$('.editDetail').toggle();
        } else {
            this.$('.edit').toggle(toggle);
            this.$('.editDetail').toggle(!toggle);
        }
        if (this.$('.edit').is(':visible')) {
            this.focusEditName();
        }
    },
    hideEditError: function () {
        this.editError.hide();
    },
    showEditError: function (text) {
        this.editError.text(text).fadeIn('fast');
    },
    hidePaymentBusinessDetailsError: function () {
        this.paymentBusinessDetailsError.hide();
    },
    showPaymentBusinessDetailsError: function (text) {
        this.paymentBusinessDetailsError.text(text).fadeIn('fast');
    },
    clickEdit: function (e) {
        e.preventDefault();
        this.editMode();
    },
    clickCancelEdit: function (e) {
        e.preventDefault();
        this.editMode(false);
    },
    clickPaymentVatShow: function (e) {
        e.preventDefault();
        this.paymentVatHidden.hide();
        this.paymentVatWrapper.slideDown('fast', _.bind(function () {
            this.paymentVatNumber.select().focus();
        }, this));
    },
    submitEditForm: function (e) {
        e.preventDefault();
        var data = this.editForm.serializeForm();
        this.hideEditError();
        this.doEdit(data, _.bind(function (response, errorMessage) {
            if (response.success) {
                this.editMode(false);
            } else {
                this.showEditError(errorMessage);
            }
        }, this));
    },
    submitPaymentBusinessDetails: function (e) {
        this.paymentBusinessDetailsButton.addSpin();
        e.preventDefault();
        var data = this.paymentBusinessDetails.serializeForm();
        this.hidePaymentBusinessDetailsError();
        this.doEdit(data, _.bind(function (response, errorMessage) {
            this.paymentBusinessDetailsButton.removeSpin();
            if (response.success) {
                if (!this.model.hasSubscribed()) {
                    this.dialog.showPaymentProgression();
                }
                this.doPayment();
            } else {
                this.showPaymentBusinessDetailsError(errorMessage);
            }
        }, this));

    },
    doEdit: function (data, callback) {
        this.model.edit(data, _.bind(function (response) {
            if (response.success) {
                callback(response);
            } else {
                var message = "";
                switch (response.message) {
                case "missing_name":
                    message = "Missing team name";
                    break;
                case "missing_billing_email":
                    message = "Missing billing email";
                    break;
                case 'invalid_billing_email':
                    message = 'Invalid billing email';
                    break;
                case 'server_error':
                    message = 'There was a problem editing this team';
                    break;
                case 'invalid_vat_country':
                    message = 'Invalid VAT number country';
                    break;
                case 'invalid_vat_number':
                    message = 'Invalid VAT number — you must be registered for VAT in the European union';
                    break;
                case 'error_verifying_vat':
                    message = 'Error validating your VAT number, please try again';
                    break;
                default:
                    message = 'There was a problem editing this team: ' + response.message;
                    break;
                }
                callback(response, message);
            }
        }, this));
    },
    submitJoinMissingForm: function (e) {
        e.preventDefault();
        var form = $(e.currentTarget);
        var data = form.serializeForm();
        var chosen = this.dialog.getChosenConns(this.networkJoinForm, this.model, data);
        data.connections = JSON.stringify(chosen);
        form.find('.userError').hide();
        form.addSpin();
        this.model.joinConnections(data, _.bind(function (response) {
            form.removeSpin();
            if (response.success) {
                if (response.cids && response.cids[0]) {
                    this.session.setFocusOnMakeServer(response.cids[0]);
                } else {
                    this.dialog.hide();
                }
            } else {
                this.showJoinConnectionError(form, response);
            }
        }, this));
    },
    showJoinConnectionError: function (form, response) {
        var msg;
        switch (response.message) {
        case "missing_nickname":
            msg = "Missing nickname";
            break;
        case "invalid_nickname":
            msg = "Invalid nickname";
            break;
        default:
            msg = "Error: " + response.message;
            break;
        }
        form.find('.userError').html(msg).fadeIn('fast');
    }
}));

module.exports = OrgDetailView;


/***/ }),

/***/ "oPQz":
/***/ (function(module, exports) {

var StreamHandler = function () {
    this.failCount = 0;
    this.msgCount = 0;
    this.queryParams = {
        exclude_archives: '1'
    };
};
StreamHandler.prototype = $.extend({
    reset: function () {
        // Reset in 10 seconds, gives us time to clear it onError
        if (this.failCount) {
            this.clearResetTimeout();
            this.resetTimeout = setTimeout(_.bind(function () {
                debug.log('Handler', 'reset', '(failCount: ' + this.failCount + ')');
                this.failCount = 0;
                this.resetTimeout = null;
            }, this), 10000);
        }
    },
    clearResetTimeout: function () {
        if (this.resetTimeout) {
            clearTimeout(this.resetTimeout);
            this.resetTimeout = null;
        }
    },
    getQueryString: function () {
        var qs = $.param(this.queryParams);
        return qs ? '?' + qs : '';
    },
    setQueryParam: function (key, value) {
        var params;
        // Single arg means full pref object
        if (arguments.length === 2) {
            params = {};
            params[key] = value;
        } else {
            params = key;
        }
        var previousValue;
        var v;
        var newParams = $.extend(true, {}, this.queryParams);
        for (var k in params) {
            v = params[k];
            previousValue = newParams[k];
            if (v) {
                if (!_.isEqual(v, previousValue)) {
                    newParams[k] = v;
                }
            } else {
                if (previousValue) {
                    delete newParams[k];
                }
            }
        }
        this.queryParams = newParams;
    },
    onDisconnect: function () {
        if (this.msgCount === 0) {
            this.onNoData();
        } else {
            // Connection closed
            this.trigger('disconnect', this.failCount);
        }
    },
    onConnectionError: function () {
        if (this.msgCount === 0) {
            this.onNoData();
        } else {
            this.trigger('connectionError');
        }
    },
    onNoData: function () {
        debug.log('Handler', 'onNoData');
        // Connection closed with no data
        this.trigger('noData', this.failCount);
    },
    onError: function () {
        // Bump the error count
        this.failCount++;
        this.clearResetTimeout();
        debug.warn('Handler', 'onError', '(failCount: ' + this.failCount + ')');
    },
    onMessage: function (message) {
        this.msgCount++;
        this.trigger('message', message);
    },
    start: function () {
        debug.group('handler start');
        if (this.isSocket()) {
            debug.warn('Handler', 'exists', this.getHandler(), '(readystate: ' + this._getReadyState() + ')');
            this.close();
        } else {
            debug.group('open stream');
            this.connect();
            debug.groupEnd();
        }
        debug.groupEnd();
    },
    stop: function () {
        debug.group('handler stop');
        this.trigger('stop');
        if (this.isSocket()) {
            this.close();
        } else {
            this.trigger('disconnect');
        }
        debug.groupEnd();
    },
    error: function () {
        debug.group('handler error');
        this.trigger('stop');
        this.close(true);
        debug.groupEnd();
    },
    connect: function () {
        debug.warn('connect() called on abstract StreamHandler instance');
    },
    getHandler: function () {
        debug.warn('getHandler() called on abstract StreamHandler instance');
    },
    isOpen: function () {
        debug.warn('isOpen() called on abstract StreamHandler instance');
    },
    isConnecting: function () {
        debug.warn('isConnecting() called on abstract StreamHandler instance');
    },
    close: function () {
        debug.warn('close() called on abstract StreamHandler instance');
    },
    parseJsonMessage: function (json) {
        // Throws exception on parse error, caught higher up
        var message = JSON.parse(json);
        if (message._reqid) {
            if (message.success) {
                debug.log('<- [' + message._reqid + ' SOCK]', 'success', message);
            } else {
                debug.warn('<- [' + message._reqid + ' SOCK]', 'failed', message);
            }
        } else if (message.bid > 0) {
            debug.log('[' + message.cid + ' ' + message.bid + ' ' + message.type + ']', message);
        } else if (message.cid) {
            debug.log('[' + message.cid + ' ' + message.type + ']', message);
        } else if (message.type) {
            debug.log('[' + message.type + ']', message);
        } else {
            debug.log(message);
        }
        return message;
    }
}, Backbone.Events);


module.exports = StreamHandler;


/***/ }),

/***/ "pRb+":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h2 class=\"avatarUploadDialog__title\">Crop your avatar</h2>\n\n<div class=\"avatarChooser__connection\">\n    For\n    <span class=\"avatarChooser__nick\"></span>\n    on\n    <span class=\"avatarChooser__network\"></span>\n</div>\n\n<form class=\"avatarUploadDialog__form\">\n    <div class=\"avatarEditor\">\n        <div class=\"avatarPreviews\">\n            <div class=\"avatarPreview__previewThumb avatarPreview__previewThumb--main\"></div>\n            <div class=\"avatarPreview__previewThumb avatarPreview__previewThumb--small avatarPreview__previewThumb--64\"></div>\n            <div class=\"avatarPreview__previewThumb avatarPreview__previewThumb--small avatarPreview__previewThumb--32\"></div>\n            <div class=\"avatarPreview__previewThumb avatarPreview__previewThumb--small avatarPreview__previewThumb--16\"></div>\n    \n            <div class=\"avatarEditor__controls\">\n                <button type=\"button\" class=\"close avatarUploadDialog__close\"><span>Cancel</span></button>\n                <button type=\"submit\" class=\"action\"><span>Save</span></button>\n\n                <div class=\"avatarUploadDialog__set-default\">\n                    <input type=\"checkbox\" name=\"primary\" value=\"1\" id=\"avatarUploadDialog__set-default\">\n                    <label for=\"avatarUploadDialog__set-default\" class=\"avatarUploadDialog__set-default-label\">Set as default</label>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"avatarCropper__wrapper\">\n            <img class=\"avatarCropper__image\">\n        </div>\n    </div>\n</form>";
},"useData":true});

/***/ }),

/***/ "pVJg":
/***/ (function(module, exports, __webpack_require__) {

var sko = __webpack_require__("pyif").default;

function check (hostmask, mapping) {
    hostmask = hostmask.toLowerCase();
    var hostParts = hostmask.split('@');
    var userParts = hostParts[0].split('!');

    var nick, user, host;
    if (hostParts[1]) {
        host = hostParts[1];
        if (userParts[1]) {
            user = userParts[1].replace(/^~/, '');
            nick = userParts[0];
        } else {
            user = userParts[0].replace(/^~/, '');
            nick = '*';
        }
    } else {
        // No username
        host = userParts[1];
        user = '*';
        nick = userParts[0];
    }

    var hostMap = new sko();
    _.each([mapping.get(host), checkWildcard(mapping, host).value, mapping.get('*')], function (uMap) {
        if (uMap) {
            uMap.each(function (u, nickMap) {
                hostMap.set(u, new sko().extend(hostMap.get(u), nickMap));
            });
        }
    });
    var userMap = new sko().extend(
        hostMap.get(user),
        checkWildcard(hostMap, user).value,
        hostMap.get('*')
    );

    return userMap.get(nick) ||
           checkWildcard(userMap, nick).value ||
           userMap.get('*') ||
           {match: false};
}

function checkWildcard (mapping, match) {
    return mapping.find(function (key, value) {
        if (key.length > 1 && key.indexOf('*') != -1) {
            // Swap * wildcards for .+ after escaping everything else for regex
            return match.match('^' + key.replace(/[-\[\]{}()+?.,\\\^$|#\s]/g, "\\$&").replace(/\*/g, '.*') + '$');
        }
    });
}

function parse (list) {
    var mapping = new sko({
        '*': new sko({
            '*': new sko()
        })
    });

    function set (host, user, nick) {
        mapping.get(host.toLowerCase())
            .get(user.toLowerCase())
            .set(nick.toLowerCase(), {
                match: true, host: host, user: user, nick: nick
            });
    }

    _.each(list, function (ignore) {
        var host = '*';
        var user = '*';
        var nick = '*';
        var ignoreParts = ignore.split('@');
        var usernickParts;
        if (ignoreParts.length == 2) {
            host = ignoreParts[1];
            usernickParts = ignoreParts[0].split('!');
            if (usernickParts.length == 2) {
                nick = usernickParts[0];
                user = usernickParts[1];
            } else {
                user = ignoreParts[0];
            }
        } else {
            usernickParts = ignore.split('!');
            if (usernickParts.length == 2) {
                nick = usernickParts[0];
                host = usernickParts[1];
            } else {
                nick = ignore;
            }
        }
        user = user.replace(/^~/, '');

        var userL = user.toLowerCase();
        var hostL = host.toLowerCase();

        if (host == '*') {
            if (user == '*') {
                if (nick == '*') {
                    // *!*@*
                    // unsupported
                } else {
                    // nick!*@*
                    set('*', '*', nick);
                }
            } else {
                if (!mapping.get('*').get(userL)) {
                    mapping.get('*').set(userL, new sko());
                }
                if (nick == '*') {
                    // *!user@*
                    set('*', user, '*');
                } else {
                    // nick!user@*
                    set('*', user, nick);
                }
            }
        } else {
            if (!mapping.get(hostL)) {
                mapping.set(hostL, new sko({
                    '*': new sko()
                }));
            }
            if (user == '*') {
                if (nick == '*') {
                    // *!*@host
                    set(host, '*', '*');
                } else {
                    // nick!*@host
                    set(host, '*', nick);
                }
            } else {
                if (!mapping.get(hostL).get(userL)) {
                    mapping.get(hostL).set(userL, new sko());
                }
                if (nick == '*') {
                    // *!user@host
                    set(host, user, '*');
                } else {
                    // nick!user@host
                    set(host, user, nick);
                }
            }
        }
    });
    return mapping;
}

module.exports = {
    check: check,
    parse: parse
};


/***/ }),

/***/ "plGQ":
/***/ (function(module, exports, __webpack_require__) {

var BufferView = __webpack_require__("uiw5");


var ChildView = BufferView.extend({
    initialize: function (options) {
        this.model.bind('change:archived', this.renderArchived, this);
                
        BufferView.prototype.initialize.apply(this, arguments);
    },
    render: function () {
        BufferView.prototype.render.apply(this, arguments);
        
        this.renderArchived();
        
        this.renderHideJoinPart(true);
        this.renderCollapseJoinPart(true);
        this.renderCollapseReplies(true);
        this.renderQuoteReplies(true);
        // Use wrapper functions so the event args aren't passed along
        this.model.bind('prefChange:hideJoinPart', function () {
            this.renderHideJoinPart();
        }, this);
        this.model.bind('prefChange:expandJoinPart', function () {
            this.renderCollapseJoinPart();
        }, this);
        this.model.bind('prefChange:reply-collapse', function () {
            this.renderCollapseReplies();
        }, this);
        this.listenTo(this.model.connection, 'prefChange:reply-collapse', function () {
            this.renderCollapseReplies();
        });
        this.model.bind('prefChange:reply-quote', function () {
            this.renderQuoteReplies();
        }, this);
        this.listenTo(this.model.connection, 'prefChange:reply-quote', function () {
            this.renderQuoteReplies();
        });
        
        return this;
    },
    renderHideJoinPart: function (initial) {
        $(this.el).toggleClass('hideJoinPart', !this.model.isShowingJoinPart());
        if (!initial) {
            this.scroll.onChange();
        }
        return this;
    },
    renderCollapseJoinPart: function (initial) {
        $(this.el).toggleClass('expandJoinPart', !this.model.isCollapsingJoinPart());
        if (!initial) {
            this.scroll.onChange();
        }
        return this;
    },
    renderCollapseReplies: function (initial) {
        $(this.el).toggleClass('replyCollapse', this.model.isCollapsingReplies());
        if (!initial) {
            this.scroll.onChange();
        }
        return this;
    },
    renderQuoteReplies: function (initial) {
        $(this.el).toggleClass('replyQuote', this.model.isShowingQuoteReplies());
        if (!initial) {
            this.scroll.onChange();
        }
        return this;
    },
    renderArchived: function () {
        $(this.el).toggleClass('archived', this.model.isArchived());
        this.mainTopChange();
        return this;
    }
});


module.exports = ChildView;


/***/ }),

/***/ "ptDp":
/***/ (function(module, exports, __webpack_require__) {

var Buf = __webpack_require__("t9zO");
var Message = __webpack_require__("j9Sh");
var UserList = __webpack_require__("jGPP");


var Thread = Buf.extend({
    idAttribute: 'id',
    initialize: function (data, options) {
        this.buffer = options.buffer;
        Buf.prototype.initialize.apply(this, arguments);
        this.messages.buffer = this.buffer;
        this.messages.thread = this;
        this.selected = true;
    },
    fetchLoaded: function (messages) {
        var earliest = this.getEarliestEid();
        _.each(messages, function (m) {
            this.addMessage(m, {silent: true, fetched: true});
        }, this);
        var added = [];
        if (earliest) {
            added = this.messages.filterBeforeEid(earliest);
        } else {
            added = this.messages.toArray();
        }
        if (added.length) {
            this.setEarliestEid(added[0].id);
        }
        this.trigger('fetched', added, earliest);
    },
    getFirst: function () {
        return this.id;
    },
    loadBacklog: function () {
        return this.buffer.loadBacklog();
    },
    hasFirstMessage: function () {
        var first = this.messages.first();
        if (first && first.getMsgId() === this.id) {
            return true;
        }
        return false;
    },
    isInThread: function (m) {
        if (m.isSameThread(m, this.id)) {
            return true;
        }
        var msgids = {};
        msgids[m.getReply()] = true;
        msgids[m.getConcatTag()] = true;
        msgids[m.getDelete()] = true;
        msgids[m.getEdit()] = true;
        delete msgids[undefined];
        return !!this.messages.find(function (mm) {
            return mm.getMsgId() in msgids;
        });
    },
    say: function (message, options) {
        this.reply(this.id, message, options);
    },
    addMessage: function (message, options) {
        options = options || {};
        if (this.isInThread(message)) {
            if (!options.fetched) {
                if (!this.getEarliestEid()) {
                    this.setEarliestEid(message.id);
                }
            }
            this.messages.add(new Message(message.toJSON(), {
                buffer: this
            }), {silent: options.silent});
            if (!message.isEmpty()) {
                var member = message.makeUser();
                var existing = this.members.findWhere({nick: member.get('nick')});
                if (existing) {
                    existing.set(member.attributes);
                } else {
                    this.members.add(member);
                }
            }
        }
    },
    delete: function () {
        this.stopListening();
        this.trigger('delete');
    },
    init: function () {
        this.messages.reset(_.invoke(this.buffer.messages.getThread(this.id), 'toJSON'));
        var first = this.getFirstMessage();
        if (first) {
            this.setEarliestEid(first.id);
        }
        var memberUsers = this.messages.foldl(function (acc, message) {
            if (!message.isEmpty()) {
                var messageUser = message.makeUser();
                acc[messageUser.get('nick')] = messageUser;
            }
            return acc;
        }, {});
        this.members = new UserList(Object.values(memberUsers));
        this.listenTo(this.buffer.messages, 'add', this.addMessage);
        this.listenTo(this.buffer, 'fetchLoaded', this.fetchLoaded);
    },
    messageHandlers: {},
    bid: function () {
        return this.buffer.bid();
    },
    equals: function (thread) {
        return this.bid() == thread.bid() && this.id == thread.id;
    },
    getName: function () {
        return this.buffer.getName();
    },
    threadId: function () {
        return this.buffer.threadId(this.id);
    },
    urlParts: function () {
        return [this.buffer.idNamespace(), this.buffer.idName(), 'thread', this.threadId()];
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl() + 'messages/' + this.normalise() + '/convo/' + this.id;
    },
    getTitle: function () {
        return 'Thread from ' + this.buffer.getTitle();
    },
    getTarget: function () {
        return this.buffer.getName();
    },
    isThread: function () {
        return true;
    },
    isSelf: function () {
        return this.buffer.isSelf();
    }
});


module.exports = Thread;


/***/ }),

/***/ "pyif":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SafeKeyObject;
/* eslint-env es6 */
// TODO use es6 Map
function SafeKeyObject() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.obj = obj;
    if (this.obj instanceof SafeKeyObject) {
        this.obj = $.extend(true, {}, this.obj.obj);
    } else {
        for (var k in this.obj) {
            this.obj[SafeKeyObject.safe(k)] = this.obj[k];
            delete this.obj[k];
        }
    }
}

SafeKeyObject.extend = function (dest) {
    if (!(dest instanceof SafeKeyObject)) {
        dest = new SafeKeyObject(dest);
    }
    var sources = _.toArray(arguments).slice(1);
    _.each(sources, function (source) {
        if (source) {
            if (source instanceof SafeKeyObject) {
                for (var safeProp in source.obj) {
                    dest.obj[safeProp] = source.obj[safeProp];
                }
            } else {
                for (var prop in source) {
                    dest.set(prop, source[prop]);
                }
            }
        }
    });
    return dest;
};
SafeKeyObject.safe = function (key) {
    return ' ' + key;
};
SafeKeyObject.prototype = {
    get: function get(key) {
        return this.obj[SafeKeyObject.safe(key)];
    },
    set: function set(key, value) {
        this.obj[SafeKeyObject.safe(key)] = value;
        return this;
    },
    unset: function unset(key) {
        delete this.obj[SafeKeyObject.safe(key)];
    },
    move: function move(moveKey, targetKey, conditional, mapFun) {
        if (!conditional || this.has(moveKey)) {
            mapFun = mapFun || _.identity;
            this.set(targetKey, mapFun(this.get(moveKey)));
            this.unset(moveKey);
        }
    },
    decr: function decr(key, value) {
        if (value === undefined) {
            value = 1;
        }
        this.incr(key, -value);
    },
    incr: function incr(key, value) {
        if (value === undefined) {
            value = 1;
        }
        this.set(key, (this.get(key) || 0) + value);
    },
    extend: function extend() {
        SafeKeyObject.extend.apply(this, [this].concat(_.toArray(arguments)));
        return this;
    },
    each: function each(iterator, context) {
        for (var k in this.obj) {
            if (context) {
                iterator = _.bind(iterator, context);
            }
            iterator(k.slice(1), this.obj[k]);
        }
        return this;
    },
    find: function find(comparator, context) {
        for (var k in this.obj) {
            if (context) {
                comparator = _.bind(comparator, context);
            }
            if (comparator(k.slice(1), this.obj[k])) {
                return {
                    key: k.slice(1),
                    value: this.obj[k]
                };
            }
        }
        return {};
    },
    has: function has(key) {
        return SafeKeyObject.safe(key) in this.obj;
    },
    length: function length() {
        return _.size(this.obj);
    },
    values: function values() {
        return _.values(this.obj);
    },
    entries: function entries() {
        var entries = [];
        for (var k in this.obj) {
            entries.push([k.slice(1), this.obj[k]]);
        }
        return entries;
    },
    isEmpty: function isEmpty() {
        return $.isEmptyObject(this.obj);
    }
};

/***/ }),

/***/ "qWv8":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<h2 class=\"avatar-chooser-dialog__title\">Choose a "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasCurrent") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":50},"end":{"line":4,"column":79}}})) != null ? stack1 : "")
    + "public avatar</h2>\n";
},"1":function(container,depth0,helpers,partials,data) {
    return "new ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<h2 class=\"avatar-chooser-dialog__title\">Choose an avatar</h2>\n\n";
  stack1 = ((helper = (helper = lookupProperty(helpers,"connection") || (depth0 != null ? lookupProperty(depth0,"connection") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"connection","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":0},"end":{"line":15,"column":15}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"connection")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"3":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"avatarChooser__connection\">\n    For\n    <span class=\"avatarChooser__nick\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"nick") || (depth0 != null ? lookupProperty(depth0,"nick") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"nick","hash":{},"data":data,"loc":{"start":{"line":11,"column":38},"end":{"line":11,"column":46}}}) : helper)))
    + "</span>\n    on\n    <span class=\"avatarChooser__network\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":13,"column":41},"end":{"line":13,"column":49}}}) : helper)))
    + "</span>\n</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return " avatar-chooser--primary";
},"5":function(container,depth0,helpers,partials,data) {
    return "        <button class=\"avatar-chooser__action avatar-chooser__clear\" type=\"button\">\n            <i class=\"fa fa-minus-circle\"></i>remove\n        </button>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "        <div class=\"avatar-chooser__item"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isCurrent") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":40},"end":{"line":32,"column":94}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isSelected") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":94},"end":{"line":32,"column":150}}})) != null ? stack1 : "")
    + "\" data-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":32,"column":161},"end":{"line":32,"column":167}}}) : helper)))
    + "\">\n            <div class=\"avatar-chooser__avatar\">\n                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"image64") || (depth0 != null ? lookupProperty(depth0,"image64") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"image64","hash":{},"data":data,"loc":{"start":{"line":34,"column":16},"end":{"line":34,"column":29}}}) : helper))) != null ? stack1 : "")
    + "\n            </div>\n            <div class=\"avatar-chooser__details\">\n                \u003C!-- "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isCurrent") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":21},"end":{"line":39,"column":23}}})) != null ? stack1 : "")
    + " -->\n";
  stack1 = ((helper = (helper = lookupProperty(helpers,"connections") || (depth0 != null ? lookupProperty(depth0,"connections") : depth0)) != null ? helper : alias2),(options={"name":"connections","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":16},"end":{"line":46,"column":32}}}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
  if (!lookupProperty(helpers,"connections")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"primary") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":16},"end":{"line":49,"column":23}}})) != null ? stack1 : "")
    + "            </div>\n        </div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return " avatar-chooser__item--current";
},"8":function(container,depth0,helpers,partials,data) {
    return " avatar-chooser__item--selected";
},"9":function(container,depth0,helpers,partials,data) {
    return "\n                    <div class=\"avatar-chooser__current\">Current</div>\n                ";
},"10":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"avatar-chooser__connection\">\n                    <span class=\"avatar-chooser__nick\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"nick") || (depth0 != null ? lookupProperty(depth0,"nick") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"nick","hash":{},"data":data,"loc":{"start":{"line":42,"column":55},"end":{"line":42,"column":63}}}) : helper)))
    + "</span>\n                    on\n                    <span class=\"avatar-chooser__network\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data,"loc":{"start":{"line":44,"column":58},"end":{"line":44,"column":66}}}) : helper)))
    + "</span>\n                </div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    return "                    <div class=\"avatar-chooser__public\">Public avatar</div>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"image256") || (depth0 != null ? lookupProperty(depth0,"image256") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"image256","hash":{},"data":data,"loc":{"start":{"line":57,"column":12},"end":{"line":57,"column":26}}}) : helper))) != null ? stack1 : "")
    + "\n            <input type=\"hidden\" name=\"id\" value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data,"loc":{"start":{"line":58,"column":50},"end":{"line":58,"column":56}}}) : helper)))
    + "\">\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"avatar-chooser__none\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasCurrent") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":61,"column":16},"end":{"line":65,"column":23}}})) != null ? stack1 : "")
    + "            </div>\n            <input type=\"hidden\" name=\"clear\" value=\"1\">\n";
},"14":function(container,depth0,helpers,partials,data) {
    return "                press save to remove\n";
},"15":function(container,depth0,helpers,partials,data) {
    return "                select an avatar and save\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <input type=\"checkbox\" name=\"primary\" value=\"1\" id=\"avatar-chooser__set-default\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isPrimaryChecked") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":73,"column":92},"end":{"line":73,"column":131}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isDefaultDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":73,"column":131},"end":{"line":73,"column":172}}})) != null ? stack1 : "")
    + ">\n            <label for=\"avatar-chooser__set-default\" class=\"avatar-chooser__set-default-label"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isDefaultDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":74,"column":93},"end":{"line":74,"column":169}}})) != null ? stack1 : "")
    + "\">\n            Set as default\n            </label>\n";
},"17":function(container,depth0,helpers,partials,data) {
    return " checked";
},"18":function(container,depth0,helpers,partials,data) {
    return " disabled";
},"19":function(container,depth0,helpers,partials,data) {
    return " avatar-chooser__set-default-label--disabled";
},"20":function(container,depth0,helpers,partials,data) {
    return "            <input type=\"hidden\" name=\"primary\" value=\"1\">\n";
},"21":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"userError showUserError\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"error") || (depth0 != null ? lookupProperty(depth0,"error") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"error","hash":{},"data":data,"loc":{"start":{"line":83,"column":53},"end":{"line":83,"column":62}}}) : helper)))
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.hooks.blockHelperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<button type=\"button\" class=\"close avatar-chooser-dialog__close\"><span>Close</span></button>\n\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"primary") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(2, data, 0),"data":data,"loc":{"start":{"line":3,"column":0},"end":{"line":16,"column":7}}})) != null ? stack1 : "")
    + "\n\n<div class=\"avatar-chooser"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"primary") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":26},"end":{"line":19,"column":72}}})) != null ? stack1 : "")
    + "\">\n    <div class=\"avatar-chooser__list\">\n        <button class=\"avatar-chooser__action avatar-chooser__add\" type=\"button\">\n            <i class=\"fa fa-plus-circle\"></i>upload new\n        </button>\n\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"selected") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":8},"end":{"line":29,"column":15}}})) != null ? stack1 : "")
    + "\n";
  stack1 = ((helper = (helper = lookupProperty(helpers,"avatars") || (depth0 != null ? lookupProperty(depth0,"avatars") : depth0)) != null ? helper : alias2),(options={"name":"avatars","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":8},"end":{"line":52,"column":20}}}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
  if (!lookupProperty(helpers,"avatars")) { stack1 = alias4.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  buffer += "    </div>\n\n    <form class=\"avatar-chooser__selected\">\n";
  stack1 = ((helper = (helper = lookupProperty(helpers,"selected") || (depth0 != null ? lookupProperty(depth0,"selected") : depth0)) != null ? helper : alias2),(options={"name":"selected","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(13, data, 0),"data":data,"loc":{"start":{"line":56,"column":8},"end":{"line":68,"column":21}}}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
  if (!lookupProperty(helpers,"selected")) { stack1 = alias4.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "        <div>\n            <button class=\"action avatar-chooser__save\" type=\"submit\"><span>Save</span></button>\n\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"primary") : depth0),{"name":"unless","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":72,"column":12},"end":{"line":77,"column":23}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isPrimaryChecked") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":78,"column":12},"end":{"line":80,"column":19}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"error") : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":82,"column":12},"end":{"line":84,"column":19}}})) != null ? stack1 : "")
    + "        </div>\n    </form>\n</div>";
},"useData":true});

/***/ }),

/***/ "rEXR":
/***/ (function(module, exports) {

var ViewState = Backbone.Model.extend({
    initialize: function (data, options) {
        this.session = options.session;
        this.session.bind('change:last_selected_bid', this.setCurrentBuffer, this);
        
        this.timeout = null;
    },
    updateSeenEid: function (buffer) {
        var seenEids = this.get('seenEids') || {};
        if (!seenEids[buffer.getCid()]) {
            seenEids[buffer.getCid()] = {};
        }
        seenEids[buffer.getCid()][buffer.bid()] = buffer.getLastSeen();
        this.set({'seenEids': seenEids});
    },
    setCurrentBuffer: function (session) {
        this.set({'selectedBuffer': session.get('last_selected_bid')});
    },
    scheduleSendState: function () {
        var self = this;
        this.timeout = setTimeout(function () {
            self.sendState();
        }, 2000);
    },
    sendState: function () {
        if (this.has('selectedBuffer') || this.has('seenEids')) {
            this.session.post("heartbeat", {
                selectedBuffer: this.get('selectedBuffer'),
                seenEids: JSON.stringify(this.get('seenEids'))
            });
            this.clear();
        }
        this.scheduleSendState();
    },
    
    startHeartbeat: function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.scheduleSendState();
    }
});

module.exports = ViewState;


/***/ }),

/***/ "rPHv":
/***/ (function(module, exports, __webpack_require__) {

var MemberList = __webpack_require__("XZrG");


var MemberHalfOpList = MemberList.extend({
    modeCategory: 'HALFOP'
});


module.exports = MemberHalfOpList;


/***/ }),

/***/ "rUjk":
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__("alZG");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"upgradePayment__payment\">\n    <button class=\"\n    upgradeSchedules__button\n    upgradeSchedules__button--action\n    upgradePayment__button\n    upgradePayment__button--action\n    upgradePayment__payment-button\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"value") : depth0), depth0))
    + "\" type=\"button\">\n    "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"button") : depth0), depth0))
    + "\n    </button>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"img") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(2, data, 0),"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":17,"column":11}}})) != null ? stack1 : "")
    + "</div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"img") : depth0), depth0))
    + "\" width=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"width") : depth0), depth0))
    + "\" height=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"height") : depth0), depth0))
    + "\" alt=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0))
    + "\" class=\"\n        upgradePayment__image\n        upgradePayment__image__"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"value") : depth0), depth0))
    + "\">\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"methods") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":8},"end":{"line":16,"column":105}}})) != null ? stack1 : "")
    + "\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"img") : depth0), depth0))
    + "\" width=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"width") : depth0), depth0))
    + "\" height=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"height") : depth0), depth0))
    + "\" alt=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0))
    + "\">";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__("ZmGF"),depth0,{"name":"upgrade-methods-back","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"only_schedule") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":23,"column":4},"end":{"line":35,"column":11}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(__webpack_require__("ZMMA"),depth0,{"name":"upgrade-info","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "        \n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"state") : depth0)) != null ? lookupProperty(stack1,"upgraded") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":8},"end":{"line":30,"column":15}}})) != null ? stack1 : "")
    + "        \n"
    + ((stack1 = container.invokePartial(__webpack_require__("V125"),depth0,{"name":"upgrade-checklist","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    return "        <button class=\"\n            upgradeSchedules__button\n            upgradeSchedules__cancel-button\" type=\"button\">Cancel</button>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__("ZmGF"),depth0,{"name":"upgrade-methods-back","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"methods") : depth0),{"name":"each","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":19,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"back") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":20,"column":0},"end":{"line":36,"column":7}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),

/***/ "sCU/":
/***/ (function(module, exports, __webpack_require__) {

var Child = __webpack_require__("MN+i");
var UserList = __webpack_require__("jGPP");


var Conversation = Child.extend({
    away: null,
    initialize: function (data, options) {
        this.connection = options.connection;
        this.recipient = this.connection.makeUserFromTarget(this.id, {
            nick: this.getName()
        });
        Child.prototype.initialize.apply(this, arguments);
        if (this.isSelf()) {
            this.members = new UserList(this.getUser());
        } else {
            this.members = new UserList([
                this.recipient,
                this.getUser()
            ]);
        }
        if (this.connection.isInitialized()) {
            this.once('selectedChange', this.onSelectedChange, this);
        }
    },
    onSelectedChange: function () {
        if (this.isSelected()) {
            var props = this.connection.findUserProps(this.getName());
            if (props) {
                this.setRecipientProps(props);
            }
        }
    },
    idNamespace: function () {
        return 'messages';
    },
    getType: function () {
        if (this.connection.isSlack()) {
            return 'direct message';
        } else {
            return 'conversation';
        }
    },
    isConversation: function() {
        return true;
    },
    connectionStateChange: function () {
        if (this.connection.isReady()) {
            this.activate();
        } else {
            this.deactivate();
        }
    },
    rename: function (newName, callback) {
        this.post('rename-conversation', {
            name: newName
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('renameError', newName, response, callback);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    deactivate: function () {
        this.setBack();
        Child.prototype.deactivate.call(this);
    },
    setRecipientProps: function (props) {
        // Don't override an away message we might already have
        var conversationAway = this.getAway();
        if (
            (conversationAway && props.away) ||
            !('away' in props)
        ) {
            props.away = conversationAway;
        }
        this.recipient.set({
            realname: props.realname || this.recipient.getRealname(),
            ircserver: props.ircserver || this.recipient.get('ircserver'),
            user: props.user || this.recipient.get('user'),
            usermask: props.usermask || this.recipient.get('usermask'),
            userhost: props.userhost || this.recipient.get('userhost'),
            ident_prefix: props.ident_prefix || this.recipient.get('ident_prefix'),
            away: props.away,
            // These can be validly empty, check for existence in object
            account: 'account' in props ? props.account : this.recipient.get('account'),
            avatar: 'avatar' in props ? props.avatar : this.recipient.get('avatar'),
            avatar_url: 'avatar_url' in props ? props.avatar_url : this.recipient.get('avatar_url'),
            display_name: 'display_name' in props ? props.display_name : this.recipient.get('display_name'),
            bot_url: 'bot_url' in props ? props.bot_url : this.recipient.get('bot_url')
        });
        this.trigger('recipientChange');
    },
    messageHandlers: $.extend({}, Child.prototype.messageHandlers, {
        rename_conversation: function (message) {
            var newName = message.new_name;
            this.set({name: newName});
            if (this.isSelected()) {
                this.connection.urlChange();
            }
            this.recipient.set({nick: newName});
        },
        user_chghost: function (message) {
            this.recipient.set({
                user: message.from_name,
                userhost: message.from_host,
                usermask: message.hostmask
            });
        }
    }),
    initializedMessageHandlers: $.extend({}, Child.prototype.initializedMessageHandlers, {
        quit: function (message) {
            this.trigger('resetLookup', this);
        }
    }),
    getRecipient: function () {
        return this.recipient;
    },
    isNickserv: function () {
        return this.getName().toLowerCase() == 'nickserv';
    },
    isSelf: function () {
        return this.recipient.getName() == this.getUser().getName();
    },
    isIgnored: function (options) {
        return this.recipient.isIgnored(options);
    },
    getTitle: function () {
        if (this.isNickserv()) {
            return 'NickServ';
        } else {
            var label;
            if (this.connection.isSlack()) {
                label = 'Direct message';
            } else {
                label = 'Conversation';
            }

            var displayName = this.getDisambiguatedDisplayName();
            return label + ' with ' + displayName;
        }
    },
    getName: function () {
        return this.recipient ? this.recipient.getName() : Child.prototype.getName.call(this);
    },
    getDisplayName: function () {
        return this.recipient.getDisplayName();
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl() + 'messages/@' + this.normalise() + '/details/';
    },
    setAway: function (value) {
        if (value === undefined) {
            value = true;
        }
        this.recipient.set('away', value);
    },
    setBack: function () {
        this.setAway(false);
    },
    isAway: function () {
        return !!this.getAway();
    },
    getAway: function () {
        return this.recipient.getAway();
    },
    getAccount: function () {
        var account = this.recipient.get('account');
        if (account && account != '*') {
            return account;
        } else {
            return null;
        }
    },
    // Ignore global setting
    isTrackingUnread: function () {
        return !this.getPref('disableTrackUnread');
    },
    setTrackingUnreadPref: function (enable) {
        this.setPref('disableTrackUnread', !enable);
    }
});


module.exports = Conversation;


/***/ }),

/***/ "sFba":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sZ6Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t2v7":
/***/ (function(module, exports, __webpack_require__) {

var BufferView = __webpack_require__("uiw5");
var ChannelView = __webpack_require__("OzoI");
var ThreadStatusView = __webpack_require__("SiCN");

var ThreadView = BufferView.extend({
    className: 'buffercontainer buffercontainer--thread',
    id: function () {
        return;
    },
    initialize: function (options) {
        this.status = new ThreadStatusView(options);
        this.listenTo(this.model, 'delete', this.remove);
        this.visible = true;
        BufferView.prototype.initialize.apply(this, arguments);
    },
    renderConnectionStatus: function () {
        return this.connectionStatus;
    },
    postrender: function () {
        if (this.buffer.isChannel()) {
            this.renderMode();
            this.buffer.bind('modeChange', this.renderMode, this);
        }
    },
    renderMode: function () {
        if (this.buffer.isChannel()) {
            return ChannelView.prototype.renderMode.apply(this);
        }
    },
    renderUserMember: function () {
        if (this.buffer.isChannel()) {
            return ChannelView.prototype.renderUserMember.apply(this);
        }
    }
});


module.exports = ThreadView;


/***/ }),

/***/ "t9zO":
/***/ (function(module, exports, __webpack_require__) {

// "Buffer" is shimmed in by browserify, and having our own module
// called Buffer is a source of annoying inconsistencies, so we use "Buf"
//
var Message = __webpack_require__("j9Sh");
var MessageList = __webpack_require__("7gVv");
var PrefMixins = __webpack_require__("/1Z1");
var perf = __webpack_require__("fJd+");
var util = __webpack_require__("GmLC");


var Buf = Backbone.Model.extend($.extend({}, PrefMixins, {
    idAttribute: 'bid',
    initialize: function (data, options) {
        this.messages = new MessageList(null, { buffer: this });
        
        this.selected = false;
        this.active = false;
        this.unseen = false;
        this.lastSelected = null;
        this.unseenHighlights = [];
        this.bottomSeen = null;
        this.focusSeen = null;
        this.initialized = false;
        this.unseed = null;
        this.previousUnseen = null;
        this.inputHistory = []; // TODO store and retrieve this on server
        this.typing = [];
        
        this.session = options.session;
        this.connection = options.connection;
        this.user = this.connection.getUser();
        
        this.messageQueue = [];
        
        this.connectionStateChange();
        this.listenTo(this.connection, 'change:status change:fail_info', this.connectionStateChange);
        this.listenTo(this.connection, 'preinit', this.connectionInit);
        this.listenTo(this.session.backend, 'connected', this.startStreamReLoad);
        this.messages.bind('add', this.onAddMessage, this);
        
        PrefMixins.initialize.apply(this, arguments);
    },
    onAddMessage: function (message) {
        if (this.connection.isBacklogLoaded()) {
            var type = message.get('type');
            if (this.initializedMessageHandlers[type]) {
                this.initializedMessageHandlers[type].call(this, message);
            }
        }
    },
    getUser: function () {
        return this.user;
    },
    getNick: function () {
        return this.connection.getNick();
    },
    getCid: function () {
        return this.connection ? this.connection.getCid() : this.get('cid');
    },
    bid: function () {
        return this.get('bid');
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl();
    },
    idName: function () {
        return this.getName();
    },
    idNamespace: function () {
        return '';
    },

    threadId: function (replyId) {
        return this.bid() + '-' + replyId;
    },
    isThreadCollapsed: function (msgId) {
        return false;
    },
    urlParts: function () {
        return [this.idNamespace(), this.idName()];
    },
    urlId: function () {
        return this.connection.joinUrlParts(this.urlParts());
    },
    url: function () {
        return this.connection.buildUrl(this.urlParts());
    },
    getId: function () {
        return this.connection.buildId(this.idNamespace(), this.idName());
    },
    checkFocusOnMakeBufferName: function (focusOnMakeBuffer) {
        return focusOnMakeBuffer === this.getName().toLowerCase();
    },
    getDisplayName: function () {
        return this.getName();
    },
    getDisplayNameWithConnection: function () {
        return this.getDisambiguatedDisplayName() + ' (' + this.connection.getDisplayName() + ')';
    },
    getTarget: function () {
        return this.getName();
    },
    getName: function () {
        return this.get('name') || this.get('chan');
    },
    normalise: function () {
        return this.connection.normaliseBufferName(this.getName());
    },
    normaliseDisplay: function () {
        return this.connection.normaliseBufferName(this.getDisplayName());
    },
    connectionStateChange: function () {
        // Override in sub classes
    },
    connectionInit: function () {
        this.flushMessageQueue();
    },
    isThread: function () {
        return false;
    },
    isChild: function () {
        return this.isChannel() || this.isConversation() || this.isThread();
    },
    isChannel: function () {
        return false;
    },
    isConversation: function () {
        return false;
    },
    isServerLog: function () {
        return false;
    },
    equals: function (buffer) {
        return this.bid() == buffer.bid();
    },
    setUnseen: function (value, message) {
        this.previousUnseen = this.unseen;
        this.unseen = value;

        if (message && message.isHighlightable()) {
            this.unseenHighlights.push(message);
        }
        if (this.previousUnseen != value) {
            this.trigger('unseenChange', this);
        }
        if (message && message.isHighlightable()) {
            this.trigger('unseenHighlightChange', this);
        }
    },
    queueMessage: function (message) {
        this.messageQueue.push(message);
    },
    flushMessageQueue: function () {
        this.messages.reset(this.messageQueue);
        this.messageQueue = [];
    },
    isUnrendered: function (type) {
        return $.inArray(type, Buf.unrendered_messages) !== -1 ||
            this.isConversation() && $.inArray(type, Buf.unrendered_pm_messages) !== -1;
    },
    startStreamReLoad: function (header) {
        if (!header.resumed && this.messages.length) {
            this.trackDiscontinuity = true;
        }
    },
    addMessage: function (data) {
        if (data.eid > 0 && !this.isUnrendered(data.type)) {
            if (this.getMessage(data.eid)) {
                if (this.session.isReloading()) {
                    // Dupe initial message on reload, no discontinuity
                    this.trackDiscontinuity = false;
                }
            } else {
                var message = new Message(data, {
                    buffer: this
                });
                if (this.connection.isInitialized()) {
                    this.messages.add(message);
                } else {
                    this.queueMessage(message);
                }
                
                if (this.session.isReloading() && this.trackDiscontinuity) {
                    // We actually will get one extra message over the max_backlog_size so that
                    // we don't misreport discontinuities at the limit.
                    // So if we've overshot the limit we can be certain there's a discontinuity
                    // but only if we discard the extra message
                    if (data.type == 'backlog_cache_init' || this.get('backlog_size') > this.get('max_backlog_size')) {
                        this.discontinuity = message;
                        // Set earliest eid for backlog loading to this message
                        this.setEarliestEid(message.id);
                    }
                    this.trackDiscontinuity = false;
                }
                if (!this.isDiscontinuity(message)) {
                    if (this.isMessageUnseen(message) && !message.isIgnored()) {
                        if (this.session.isInitialized() && !this.hasUnseen() && message.isSelf()) {
                            // If we're in a read channel, new messages from ourselves shouldn't mark the channel as unread
                            // This is to guard against you sending a message to a channel, then switching to another and
                            // when the server responds the channel will be marked as unread because you're not looking
                            // at it. So only needs to happen if we've had the initial backlog.
                            // We do want the message to bump the last_seen_eid count though
                            this.setLastSeen(message);
                        } else {
                            if (message.isImportant() && !message.isInCollapsedThread()) {
                                this.setUnseen(true, message);
                            }
                        }
                    }
                    
                    // Set earliest eid if we haven't set it yet (i.e. first message on initial backlog)
                    if (!this.getEarliestEid()) {
                        this.setEarliestEid(data.eid);
                    }
                    
                    // Set min_eid if it doesn't exist (i.e. we haven't had messages before)
                    if (!this.getFirst()) {
                        this.setFirst(data.eid);
                    }
                    
                    if (message.isNotable()) {
                        this.trigger('notableMessage:' + message.get('type'), message);
                    }
                }
            }
        }
        if (this.messageHandlers[data.type]) {
            this.messageHandlers[data.type].call(this, data);
        }
        this.triggerInitializedMessageEvent(data);
    },
    triggerInitializedMessageEvent: function (message) {
        if (this.connection.isBacklogLoaded()) {
            this.trigger('message:' + message.type, message);
        }
    },
    getTypers: function () {
        var typers = [];
        _.each(this.typing, function (item) {
            var member = this.getMember(item[0]);
            if (member && !member.isIgnored()) {
                typers.push(member);
            }
        }, this);
        return typers;
    },
    sendTyping: function (value) {
        return this.connection.typing({
            to: this.getTarget(),
            value: value
        });
    },
    setTyping: function (nick) {
        if (!nick) {
            return;
        }
        var timeout = setTimeout(_.bind(function () {
            this.updateTyping(nick);
        }, this), 6500);
        this.updateTyping(nick, {silentStop: true, reset: timeout});
    },
    updateTyping: function (nick, options) {
        if (!nick) {
            return;
        }
        options = options || {};
        var val;
        if (options.reset) {
            val = [nick, options.reset];
        }
        var found = _.find(this.typing, function (item, i) {
            if (item[0] === nick) {
                clearTimeout(item[1]);
                if (val) {
                    this.typing.splice(i, 1, val);
                } else {
                    this.typing.splice(i, 1);
                }
                if (!val && !options.silentStop) {
                    this.trigger('userTyping', nick, false);
                }
                return true;
            }
            return false;
        }, this);
        if (val && !found) {
            this.typing.push(val);
            this.trigger('userTyping', nick, true);
        }
    },
    messageHandlers: {
        buffer_archived: function (message) {
            this.setArchived();
            this.setLastSeen(message.last_seen_eid);
        },
        buffer_unarchived: function (message) {
            this.setUnarchived();
        },
        user_typing: function (message) {
            this.setTyping(message.from);
        },
        buffer_msg: function (message) {
            this.updateTyping(message.from);
        },
        buffer_me_msg: function (message) {
            this.updateTyping(message.from);
        },
    },
    initializedMessageHandlers: {},
    getMessage: function (eid) {
        return this.messages.get(eid);
    },
    eid: function (eid) {
        return (eid instanceof Message) ? eid.id : eid;
    },
    // Only makes sense in the context of an add event on this.messages
    hadUnseen: function () {
        return this.previousUnseen;
    },
    hasUnseen: function () {
        return this.unseen;
    },
    
    // Only makes sense in the context of an add event on this.messages
    getPreviousLastMessage: function () {
        return this.getLastMessage().previousMessage();
    },
    getLastMessage: function () {
        return this.messages.last();
    },
    getLastEditableMessage: function () {
        if (this.connection.hasReliableClientTags()) {
            var idx = this.messages.findLastIndex(function (m) {
                return m.doIsEditable() && m.hasSameAccount(this.user);
            }, this);
            if (idx !== -1) {
                return this.messages.at(idx);
            }
        }
    },
    
    getLastSeen: function () {
        var lastSeen = this.get('last_seen_eid');
        return lastSeen > 0 ? lastSeen : 0;
    },
    hasImportantMessagesAfter: function (start) {
        return !!this.countImportantMessagesBetween(start);
    },
    countMessagesBetween: function (start, end) {
        var endIndex = end ? end.index() : this.messages.length - 1;
        return endIndex - start.index();
    },
    countImportantMessagesBetween: function (start, end) { // exclusive at start, inclusive at end
        return _.filter(this.messages.toArray().slice(start.index() + 1, end && end.index()), function (m) {
            return !m.isIgnored() && m.isImportant() && !m.isInCollapsedThread();
        }, this).length;
    },
    trimmableMessages: function (firstRender, end) {
        var endIndex;
        if (end) {
            endIndex = end.index();
        }
        return _.filter(this.messages.slice(firstRender.index(), endIndex), function (m) {
            return m.isImportant() || m.isSelf();
        });
    },
    resetLastSeen: function () {
        var message = this.getLastSeenMessage();
        this._doSetLastSeen(message);
    },
    _doSetLastSeen: function (message) {
        if (message) {
            this.clearUnseenHighlightsUntil(message);
            this.updateBottomSeen(message);
            this.setUnseen(this.hasImportantMessagesAfter(message));
        }
    },
    setLastSeen: function (message) {
        if (!message) {
            return;
        }
        if (!(message instanceof Message)) {
            var eid = message;
            message = this.getMessage(message);
            // Can happen on heartbeat_echo, only update the value in that case
            if (!message) {
                this.set({'last_seen_eid': eid});
                return;
            }
        }
        this._doSetLastSeen(message);
        this.set({'last_seen_eid': message.id});
    },
    isMessageUnseen: function (eid) {
        eid = this.eid(eid);
        return eid > 0 && (!this.getLastSeen() || eid > this.getLastSeen());
    },
    isMessageLastSeen: function (eid) {
        eid = this.eid(eid);
        return eid > 0 && eid == this.getLastSeen();
    },
    getCreated: function () {
        return this.get('created');
    },
    getFirst: function () {
        // min_eid can be wrong if we have an artificial backlog_cache_init
        // message fetched from the backend
        var minEid = this.get('min_eid');
        var firstMessage = this.getFirstMessage();
        if (firstMessage && (!minEid || firstMessage.id < minEid)) {
            return firstMessage.id;
        } else {
            return minEid || 0;
        }
    },
    setFirst: function (eid) {
        this.set({min_eid: eid});
    },
    isDiscontinuity: function (eid) {
        if (this.discontinuity) {
            return this.discontinuity.id == this.eid(eid);
        }
        return false;
    },
    // Could be a non rendered message
    getEarliestEid: function () {
        if (this.isDiscontinuity(this.earliestEid)) {
            return this.eid(this.discontinuity.nextMessage());
        }
        return this.earliestEid;
    },
    setEarliestEid: function (eid) {
        this.earliestEid = eid;
    },
    // Only rendered messages
    getFirstMessage: function () {
        return this.messages.first();
    },
    isFullyLoaded: function () {
        var firstId = this.getFirst();
        if (firstId === 0) {
            // No events
            return true;
        }
        var firstMessage = this.getFirstMessage();
        return firstMessage.id == firstId || firstMessage.getMsgId() == firstId;
    },
    getLastSeenDate: function () {
        return new Date(this.session.backend.tsOffset(this.getLastSeen() / 1000));
    },
    // Can be undefined, in which case chatter bar won't include line count
    getLastSeenMessage: function () {
        var lastSeen = this.getLastSeen();
        // 1. Lookup the message
        var message = this.getMessage(lastSeen);
        if (!message) {
            var firstMessage = this.getFirstMessage();
            if (firstMessage && lastSeen >= firstMessage.id) {
                // 2. Message was transient and no longer in the backlog
                // Loop back till we find a previous message
                var index = _.sortedIndex(this.messages.pluck('eid'), lastSeen);
                while (!message && index > 0) {
                    message = this.messages.at(--index);
                }
            }
            // 3. If message appeared before the current backlog,
        }
        return message;
    },

    
    lockFocusSeen: function () {
        if (!this.focusSeen) {
            var lastMessage = this.getLastMessage();
            this.focusSeen = lastMessage;
            return true;
        }
    },
    lockBottomSeen: function () {
        if (!this.bottomSeen) {
            var lastMessage = this.getLastMessage();
            this.bottomSeen = lastMessage;
            return true;
        }
    },
    unlockFocusSeen: function () {
        this.focusSeen = null;
    },
    unlockBottomSeen: function () {
        this.bottomSeen = null;
    },
    isBelowBottomSeen: function (message) {
        if (this.bottomSeen) {
            return this.bottomSeen.id < message.id;
        }
    },
    updateBottomSeen: function (message) {
        if (this.session.isFocused() && this.isBelowBottomSeen(message)) {
            var previous = this.bottomSeen;
            if (previous) {
                this.bottomSeen = message;
            }
            if (this.isMessageLastSeen(previous)) {
                this.setLastSeen(this.bottomSeen);
            } else {
                this.clearUnseenHighlightsAfter(previous);
            }
            return true;
        }
    },
    getFocusSeen: function () {
        return this.focusSeen;
    },
    getBottomSeen: function () {
        return this.bottomSeen;
    },
    getLowestSeen: function () {
        return this.getBottomSeen() || this.getFocusSeen() || this.getLastMessage();
    },
    read: function () {
        this.setLastSeen(this.getFocusSeen() || this.getBottomSeen() || this.getLastMessage());
    },
    
    unseenHighlightCount: function () {
        return this.unseenHighlights.length;
    },
    unseenHighlightCountAfter: function (message) {
        return _.filter(this.unseenHighlights, function (highlight) {
            return highlight.id > message.id; // exclusive
        }).length;
    },
    unseenHighlightCountBefore: function (message) {
        return _.filter(this.unseenHighlights, function (highlight) {
            return highlight.id < message.id; // exclusive
        }).length;
    },
    hasUnseenHighlights: function () {
        return this.unseenHighlightCount() > 0;
    },
    spliceUnseenHighlights: function (start, count) {
        if (start !== null) {
            this.unseenHighlights.splice(start, count);
            this.trigger('unseenHighlightChange', this);
        }
    },
    clearUnseenHighlightsUntil: function (until) {
        var splice = null, spliceCount = 0;
        for (var i = 0; i < this.unseenHighlightCount(); i++) {
            if (this.unseenHighlights[i].id <= until.id) { // inclusive
                // Remove these
                if (splice === null) {
                    splice = i;
                }
                spliceCount++;
            } else {
                break;
            }
        }
        this.spliceUnseenHighlights(splice, spliceCount);
    },
    clearUnseenHighlightsAfter: function (start) {
        var splice = null, spliceCount = 0, hlID;
        var count = 0;
        for (var i = 0; i < this.unseenHighlightCount(); i++) {
            hlID = this.unseenHighlights[i].id;
            if (start.id >= hlID) {
                // Count upper remainder, before start point
                count++;
            } else {
                // Only clear until bottom seen, inclusive
                if (hlID <= this.getLowestSeen().id) {
                    // Remove these
                    if (splice === null) {
                        splice = i;
                    }
                    spliceCount++;
                }
            }
        }
        this.spliceUnseenHighlights(splice, spliceCount);
        return count;
    },
    getUnseenHighlights: function () {
        return this.unseenHighlights;
    },
    getTitle: function () {
        return this.getName();
    },
    getFullLabel: function () {
        return this.connection.getFullLabel() + ': ' + this.getTitle();
    },
    isDeferred: function () {
        return !!this.get('deferred');
    },
    isCacheReset: function () {
        var first = this.getFirstMessage();
        if (first && first.get('type') === 'backlog_cache_init' && first.id > this.getCreated()) {
            return true;
        }
        return false;
    },
    isTimeout: function () {
        return !!this.get('timeout');
    },
    getMembers: function () {
        return this.members;
    },
    getMember: function (nick) {
        var nickL = nick.toLowerCase();
        return this.members.find(function (m) {
            return nickL == m.getNick().toLowerCase();
        });
    },
    getMemberByUsermask: function (usermask) {
        return this.members.find(function (member) {
            return member.get('usermask') == usermask;
        });
    },
    setSelected: function (selected) {
        if (selected != this.selected) {
            this.selected = selected;
            return true;
        }
        return false;
    },
    select: function (options) {
        options = options || {};
        if (!options.automatic) {
            this.session.clearFocusOnMakes();
        }
        if (this.setSelected(true)) {
            perf.mark('bufferSelect');

            this.lastSelected = util.ts();

            this.session.bufferSelectedChange(this, {
                replace: options.replace
            });

            this.trigger('selectedChange', this);
            this.trigger('doneSelected', this);
        }

        return this;
    },
    deselect: function () {
        if (this.setSelected(false)) {
            this.trigger('selectedChange', this);
            
            if (this.shouldMarkAsReadOnSelect()) {
                this.read();
            }
        }

        return this;
    },
    isSelected: function () {
        return this.selected;
    },
    setActive: function (active) {
        if (active != this.active) {
            this.active = active;
            this.trigger('activeChange', this);
        }
    },
    activate: function () {
        this.setActive(true);
    },
    deactivate: function () {
        this.setActive(false);
    },
    isActive: function () {
        return this.active;
    },
    setInputHistory: function (inputHistory) {
        this.inputHistory = inputHistory;
    },
    pushInputHistory: function (message, reply) {
        this.inputHistory.push({msg: message, reply: reply});
    },
    // Actions
    connectionPost: function (method, message, callback) {
        return this.connection.post(method, message, callback);
    },
    post: function (method, message, callback) {
        return this.connectionPost(method, $.extend({
            id: this.bid()
        }, message), callback);
    },
    connectionSay: function (message, callback, options) {
        this._connectionSay('say', message, callback, options);
    },
    _connectionSay: function (method, message, callback, options) {
        options = options || {};
        var data = {
            to: this.getTarget(),
            msg: message
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        return this.connection[method](data, callback);
    },
    sayPaste: function (message, options) {
        options = options || {};
        options.silent = true;
        this._say('sayPaste', message, options);
    },
    _doSay: function (message, options) {
        this._say('say', message, options);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    say: function (message, options) {
        options = options || {};
        if (message && message.length > Message.LONG_MESSAGE_LIMIT) {
            this.trigger('longMessageConfirm', _.bind(function () {
                this._doSay(message, options);
            }, this), options.onCancel);
        } else {
            this._doSay(message, options);
        }
    },
    _say: function (method, message, options) {
        options = options || {};
        var reqid = this._connectionSay(method, message, _.bind(function (response) {
            if (!response.success) {
                this.trigger('sayError', response, message);
            }
            if (options.callback) {
                options.callback(response);
            }
        }, this), options);
        if (!options.silent) {
            this.pushInputHistory(message);
            this.trigger('sayRequest', message, reqid);
        }
        return reqid;
    },
    _doReply: function (msgid, message, options) {
        var data = {
            to: this.getTarget(),
            msgid: msgid,
            reply: message
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        var reqid = this.connection.reply(data, options.callback);
        this.trigger('sayRequest', message, reqid);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    reply: function (msgid, message, options) {
        options = options || {};
        if (message && message.length > Message.LONG_MESSAGE_LIMIT) {
            this.trigger('longMessageConfirm', _.bind(function () {
                this._doReply(msgid, message, options);
            }, this), options.onCancel);
        } else {
            this._doReply(msgid, message, options);
        }
    },
    deleteMessage: function (msgid, options) {
        options = options || {};
        var data = {
            to: this.getTarget(),
            msgid: msgid
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        var reqid = this.connection.deleteMessage(data, options.callback);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    redactMessage: function (msgid, reason, options) {
        options = options || {};
        var data = {
            to: this.getTarget(),
            msgid: msgid,
            reason: reason
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        var reqid = this.connection.redactMessage(data, options.callback);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    _doEditMessage: function (msgid, message, options) {
        var data = {
            to: this.getTarget(),
            msgid: msgid,
            edit: message
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        var reqid = this.connection.editMessage(data, options.callback);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    editMessage: function (msgid, message, options) {
        options = options || {};
        if (message && message.length > Message.LONG_MESSAGE_LIMIT) {
            this.trigger('longMessageConfirm', _.bind(function () {
                this._doEditMessage(msgid, message, options);
            }, this), options.onCancel);
        } else {
            this._doEditMessage(msgid, message, options);
        }
    },
    react: function (msgid, reaction) {
        if (this.connection.isSlack()) {
            reaction = emoji.strip_colons_only(emoji.unified_to_text(reaction));
        }
        return this.connection.react({
            to: this.getTarget(),
            msgid: msgid,
            reaction: reaction
        });
    },
    loadBacklog: function (discontinuity) {
        // Fetch backlog
        var data = {
            bid: this.bid(),
            cid: this.getCid(),
            num: 150
        };
        var earliest = this.getEarliestEid();
        if (earliest) {
            data.beforeid = earliest;
        }
        this.session.backend.get('backlog', data, _.bind(function (response) {
            if (response.error === true || response.success === false) {
                this.trigger('fetchFailed', discontinuity);
            } else if (response.length && !response[0].eid) {
                // Simple check for a list of message json objs
                this.trigger('fetchFailed', discontinuity);
            } else {
                // We may have had a new earliest while waiting for the load
                earliest = this.getEarliestEid();
                // Update earliest eid
                if (response.length) {
                    this.setEarliestEid(response[0].eid);
                    // Clear discontinuities
                    this.discontinuity = null;
                }
                
                var messages = _.map(_.filter(response, function (message) {
                    return !this.getMessage(message.eid) && !this.isUnrendered(message.type);
                }, this), function (message) {
                    return new Message(message, {
                        buffer: this
                    });
                }, this);
                
                this.messages.add(messages, {
                    silent: true
                });
                var added = [];
                if (this.isDeferred()) {
                    this.undefer();
                }
                if (earliest) {
                    added = this.messages.filterBeforeEid(earliest);
                } else {
                    added = this.messages.toArray();
                }
                this.trigger('fetchLoaded', messages);
                this.trigger('fetched', added, earliest, discontinuity);
            }
        }, this));
    },
    undefer: function () {
        this.set({
            timeout: false,
            deferred: false
        });
    },
    unarchive: function () {
        this.post('unarchive-buffer');
        this.setUnarchived();
    },
    archive: function () {
        this.post('archive-buffer');
        this.setArchived();
    },
    setArchived: function () {
        this.set({archived: true});
    },
    setUnarchived: function () {
        this.set({archived: false});
    },
    isArchived: function () {
        return !!this.get('archived');
    },
    wasArchived: function () {
        return !!this.previous('archived');
    },
    setPinned: function (enable) {
        this.session.setPinnedBuffer(this, enable);
    },
    canPin: function () {
        return !this.isArchived();
    },
    isPinned: function () {
        return this.session.isPinnedBuffer(this);
    },
    isAmbiguouslyPinned: function () {
        return this.session.isPinnedBufferAmbiguous(this);
    },
    getDisambiguatedListName: function () {
        return this.disambiguateListName(this.getDisplayName(), this.getName());
    },
    getDisambiguatedDisplayName: function () {
        return this.disambiguateDisplayName(this.getDisplayName(), this.getName());
    },
    disambiguateDisplayName: function (displayName, plainName) {
        if (!this.connection.isSlack() && plainName && displayName.toLowerCase() != plainName.toLowerCase()) {
            displayName += ' (' + plainName + ')';
        }
        return displayName;
    },
    disambiguateListName: function (displayName, plainName) {
        displayName = this.disambiguateDisplayName(displayName, plainName);
        if (this.isAmbiguouslyPinned()) {
            displayName += ' (' + this.connection.getDisplayName() + ')';
        }
        return displayName;
    },
    
    // Prefs
    getPrefKey: function (key) {
        return 'buffer-' + key;
    },
    prefKeys: {
        // Key should be the non-default version
        // Val[0] is the opposite setting (needed for buffer level overrides of global settings)
        // Val[1] is the default return value for a non-negative getter,
        // e.g. inlineFilesAllowed checks files-disableinline and returns true
        // if it's not set
        'disableTrackUnread': ['enableTrackUnread', true],
        'enableReadOnSelect': ['disableReadOnSelect', false],
        'notifications-mute': ['notifications-mute-disable', false],
        'files-disableinline': ['files-enableinline', true],
        'attachments-disableinline': ['attachments-enableinline', true],
        'pastebin-disableinline': ['pastebin-enableinline', true],
        'twitter-disableinline': ['twitter-enableinline', true],
        'mastodon-enableinline': ['mastodon-disableinline', false],
        'bsky-enableinline': ['bsky-disableinline', false],
        'reddit-enableinline': ['reddit-disableinline', false],
        'inlineimages': ['inlineimages-disable', false],
        'chat-oneline': ['chat-multiline', true],
        'chat-norealname': ['chat-realname', true],
        'chat-nocolor': ['chat-color', true],
        'chat-nocodespan': ['chat-codespan', true],
        'chat-nocodeblock': ['chat-codeblock', true],
        'chat-noquote': ['chat-quote', true],
        'chat-deleted-show': ['chat-deleted-hide', false],
        'time-left': ['time-right', true],
        'avatars-off': ['avatars-on', true],
        'avatars-image-off': ['avatars-image-on', true]
    },
    setTrackingUnreadPref: function (enable) {
        this.setOverridePref(enable, 'disableTrackUnread');
    },
    setMarkAsReadOnSelectPref: function (enable) {
        this.setOverridePref(enable, 'enableReadOnSelect');
    },
    setMuteNotificationsPref: function (enable) {
        this.setOverridePref(enable, 'notifications-mute');
    },
    setInlineFilesPref: function (enable) {
        this.setOverridePref(enable, 'files-disableinline');
    },
    setInlineAttachmentsPref: function (enable) {
        this.setOverridePref(enable, 'attachments-disableinline');
    },
    setInlinePastesPref: function (enable) {
        this.setOverridePref(enable, 'pastebin-disableinline');
    },
    setInlineSocialMediaPref: function (enable) {
        this.setOverridePref(enable, 'twitter-disableinline');
    },
    setInlineMastodonPref: function (enable) {
        this.setOverridePref(enable, 'mastodon-enableinline');
    },
    setInlineBskyPref: function (enable) {
        this.setOverridePref(enable, 'bsky-enableinline');
    },
    setInlineRedditPref: function (enable) {
        this.setOverridePref(enable, 'reddit-enableinline');
    },
    setInlineImagesPref: function (enable) {
        this.setOverridePref(enable, 'inlineimages');
    },
    setMultilinePref: function (enable) {
        this.setOverridePref(enable, 'chat-oneline');
    },
    setRealnamePref: function (enable) {
        this.setOverridePref(enable, 'chat-norealname');
    },
    setTimeRightPref: function (enable) {
        this.setOverridePref(enable, 'time-left');
    },
    setFormatColorPref: function (enable) {
        this.setOverridePref(enable, 'chat-nocolor');
    },
    enableInlineImages: function () {
        this.setInlineImagesPref(true);
    },
    disableInlineImages: function () {
        this.setInlineImagesPref(false);
    },
    isTrackingUnread: function () {
        return this.checkPref('disableTrackUnread');
    },
    shouldMarkAsReadOnSelect: function () {
        return this.checkPref('enableReadOnSelect');
    },
    shouldMuteNotifications: function () {
        return this.checkPref('notifications-mute');
    },
    inlineFilesAllowed: function () {
        return this.checkPref('files-disableinline');
    },
    inlineAttachmentsAllowed: function () {
        return this.checkPref('attachments-disableinline');
    },
    inlinePastesAllowed: function () {
        return this.checkPref('pastebin-disableinline');
    },
    inlineSocialMediaAllowed: function () {
        return this.checkPref('twitter-disableinline');
    },
    inlineMastodonAllowed: function () {
        return this.checkPref('mastodon-enableinline');
    },
    inlineBskyAllowed: function () {
        return this.checkPref('bsky-enableinline');
    },
    inlineRedditAllowed: function () {
        return this.checkPref('reddit-enableinline');
    },
    inlineImagesAllowed: function () {
        return this.checkPref('inlineimages');
    },
    embedExternalAvatars: function () {
        return this.imageAvatarsEnabled() && this.inlineImagesAllowed();
    },
    multiline: function () {
        return this.checkPref('chat-oneline');
    },
    formatColor: function () {
        return this.checkPref('chat-nocolor');
    },
    formatCodeSpan: function () {
        return this.checkPref('chat-nocodespan');
    },
    formatCodeBlock: function () {
        return this.checkPref('chat-nocodeblock');
    },
    formatQuote: function () {
        return this.checkPref('chat-noquote');
    },
    showRealnames: function () {
        return this.multiline() && this.checkPref('chat-norealname');
    },
    isTimeRight: function () {
        return this.checkPref('time-left') || (this.avatarsEnabled() && this.multiline());
    },
    avatarsEnabled: function () {
        return this.checkPref('avatars-off');
    },
    imageAvatarsEnabled: function () {
        return this.avatarsEnabled() &&
            this.checkPref('avatars-image-off');
    },
    shouldPromptAvatar: function () {
        if (!this.imageAvatarsEnabled()) {
            return false;
        }
        if (this.getUser().getAvatar({
            buffer: this,
            forceExternal: true
        })) {
            return false;
        }
        return this.connection.nativeAvatarUploadsSupported() &&
            this.connection.checkPref('avatars-disableUploadPrompt');
    },
    isShowingDeletedMessages: function () {
        return this.checkPref('chat-deleted-show');
    }
}), {
    unrendered_pm_messages: [
        // No longer sent for PMs
        'connecting_failed',
        'connecting_cancelled',
        'socket_closed',
        'banned',
        'quit_server',
        'kill'
    ],
    unrendered_messages: [
        // Unused connection status
        'connected',
        'connecting_retry',
        'connecting_finished',
        'waiting_to_retry',
        'connecting',
        'joining',
        'doing_nickserv_login',
        'server_isupport',
        'server_myinfo',
        // Unused Backend status unused
        'connected',
        // Unused WHO
        'who_reply_channel',
        'who_end_user',
        'who_end_channel',
        'who_reply',
        'who_reply_user',
        'who_end',
        // Unnused WHOIS
        'whois_server',
        'whois_user',
        'whois_end',
        'whois_channels',
        'whois_idle',
        'whois_ip',
        'whois_info',
        'whois_operator',
        // Channel status
        'user_away',
        'user_back',
        'user_details',
        // Conversation status
        'whois_response',
        'away',
        // Connection status
        'isupport_params',
        'self_away',
        'self_back',
        // Overlay
        'names_reply',
        'query_too_long',
        'input_too_long',
        'try_again',
        'accept_list',
        'ban_list',
        'q_list',
        'a_list',
        'reop_list',
        'ignore_list',
        'ban_exception_list',
        'links_response',
        'silence_list',
        'trace_response',
        'who_response',
        'ison',
        'list_response_toomany',
        'list_response',
        'list_response_fetching',
        'map_list',
        'remote_isupport_params',
        'userhost',
        // Prompt
        'channel_full',
        'too_many_targets',
        'no_messages_from_non_registered',
        'not_registered',
        'already_registered',
        'chan_privs_needed',
        'users_dont_match',
        'need_more_params',
        'unknown_mode',
        'no_such_nick',
        'bad_channel_name',
        'bad_channel_key',
        'banned_from_channel',
        'oper_only',
        'invite_only_chan',
        'need_registered_nick',
        'no_such_channel',
        'too_many_channels',
        'users_disabled',
        'unknown_command',
        'no_such_server',
        'invalid_operator_password',
        'flood_warning',
        'privs_needed',
        'operator_fail',
        'not_on_channel',
        'ban_on_chan',
        'cannot_send_to_chan',
        'user_on_channel',
        'pong',
        'no_nick_given',
        'no_text_to_send',
        'no_origin',
        'only_servers_can_change_mode',
        'not_for_halfops',
        'silence',
        'channel_topic_is',
        'no_channel_topic',
        'channel_timestamp'
    ]
});


module.exports = Buf;


/***/ }),

/***/ "tR0s":
/***/ (function(module, exports, __webpack_require__) {

var MemberList = __webpack_require__("XZrG");


var MemberOpList = MemberList.extend({
    modeCategory: 'OP'
});


module.exports = MemberOpList;


/***/ }),

/***/ "tlSk":
/***/ (function(module, exports, __webpack_require__) {

var ChildContextMenuView = __webpack_require__("SbjP");


var ConversationContextMenuView = ChildContextMenuView.extend({
    el: '#conversationContextMenu',
    events: $.extend({}, ChildContextMenuView.prototype.events, {
        'buttonClick button.delete': 'clickDelete',
        'buttonClick button.whois': 'clickWhois',
        'buttonClick button.rename': 'clickRename'
    }),
    clickDelete: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('deleteConfirm');
        this.clearContext();
    },
    clickWhois: function (e) {
        e.preventDefault();
        if (this.buffer.isActive()) {
            this.hide();
            this.buffer.getRecipient().whois();
            this.clearContext();
        }
    },
    clickRename: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('renamePrompt', this.buffer.getName());
        this.clearContext();
    },
    onShow: function () {
        this.deactivateItem(this.$('li.whois'), !this.buffer.isActive());
        
        ChildContextMenuView.prototype.onShow.call(this);
    },
});


module.exports = ConversationContextMenuView;


/***/ }),

/***/ "uUaF":
/***/ (function(module, exports) {

var BillingMixins = {
    // subscribeUrl (str)
    // billingInfoUrl (str)
    // billingInfoParams (function return obj)
    // updateCustomerUrl (str)
    // reinstateSubscriptionUrl (str)
    // cancelStripeSubscriptionUrl (str)
    // cancelPaypalSubscriptionUrl (str)

    updateCustomer: function (data, callback) {
        return this.post(this.updateCustomerUrl, data, callback);
    },
    reinstateSubscription: function (data, callback) {
        return this.post(this.reinstateSubscriptionUrl, data, callback);
    },
    payDelinquentStripeInvoice: function (data, callback) {
        return this.post('pay-delinquent-stripe-invoice', data, callback);
        
    },
    cancelIncompleteStripeSubscription: function (data, callback) {
        return this.post('cancel-incomplete-stripe-subscription', data, callback);
        
    },
    cancelStripeSubscription: function (data, callback) {
        return this.post(this.cancelStripeSubscriptionUrl, data, callback);
    },
    cancelPaypalSubscription: function (data, callback) {
        return this.post(this.cancelPaypalSubscriptionUrl, data, callback);
    },
    getBillingInfo: function (callback, delay, failCount) {
        this.session.backend.get(this.billingInfoUrl, this.billingInfoParams(), _.bind(function (response) {
            if (response.error || response.success === false) {
                if (
                    failCount >= 10 ||
                    response.message == 'not_found' ||
                    response.message == 'auth' ||
                    response.message == 'database_down'
                ) {
                    this.trigger('billingInfoError', response, {
                        failCount: failCount,
                        gave_up: true
                    });
                    if (callback) {
                        callback(response);
                    }
                } else {
                    if (delay) {
                        delay *= 2;
                        if (delay > 5000) {
                            delay = 5000;
                        }
                    } else {
                        delay = 500;
                    }
                    if (failCount) {
                        failCount++;
                    } else {
                        failCount = 1;
                    }
                    this.trigger('billingInfoError', response, {
                        failCount: failCount,
                        retry_delay: delay
                    });
                    setTimeout(_.bind(function () {
                        this.getBillingInfo(callback, delay, failCount);
                    }, this), delay);
                }
            } else {
                var data = {
                    'billing': response.billing,
                    'paypal_billing': response.paypal_billing,
                    'android_billing': response.android_billing,
                    'subscription_oneoff': response.subscription_oneoff,
                    
                    'charges': response.charges,
                    'invoices': response.invoices,
                    'invoice_items': response.invoice_items,
                    'paypal_charges': response.paypal_charges,
                    'paypal_oneoff_charges': response.paypal_oneoff_charges,
                    'android_charges': response.android_charges,
                    'android_oneoff_charges': response.android_oneoff_charges,
                    
                    'subscriptions': response.subscriptions
                };
                this.set(data, {silent:true});
                this.trigger('billingUpdate');
                if (callback) {
                    callback(response);
                }
            }
        }, this));
    },
    subscribe: function (data, callback) {
        return this.post(this.subscribeUrl, data, callback);
    },
    hasActiveStripeSubscription: function () {
        var b = this.get('billing');
        var sub = b ? b.subscription : this.get('subscription');
        var active = _.include(
            ['active', 'trialing', 'past_due'],
            sub
        );
        if (b) {
            return active && !b.cancel_at_period_end;
        } else {
            return active;
        }
    },
    hasActivePaypalSubscription: function () {
        return this.hasSubscribedPaypal() && this.get('paypal_billing').subscription == 'active';
    },
    hasActiveAndroidSubscription: function () {
        return this.hasSubscribedAndroid() && this.get('android_billing').subscription == 'active';
    },
    hasActiveOneOffSubscription: function () {
        var s = this.get('subscription_oneoff');
        return !!(s && s.active);
    },
    hasActivePaypalMonthlySubscription: function () {
        return this.hasActivePaypalSubscription() && this.get('paypal_billing').interval == 'month';
    },
    hasActiveStripeMonthlySubscription: function () {
        return this.hasActiveStripeSubscription() && this.get('billing').interval == 'month';
    },
    hasActiveAndroidMonthlySubscription: function () {
        return this.hasActiveAndroidSubscription() && this.get('android_billing').interval == 'month';
    },
    hasActiveRecurringSubscription: function () {
        return this.hasActiveStripeSubscription()
            || this.hasActivePaypalSubscription()
            || this.hasActiveAndroidSubscription();
    },
    hasActiveSubscription: function () {
        return this.hasActiveRecurringSubscription()
            || this.hasActiveOneOffSubscription();
    },
    hasActiveMonthlySubscription: function () {
        return this.hasActiveStripeMonthlySubscription()
            || this.hasActivePaypalMonthlySubscription()
            || this.hasActiveAndroidMonthlySubscription();
    },
    isStripeSubscriptionPastDue: function () {
        var b = this.get('billing');
        var sub = b ? b.subscription : this.get('subscription');
        return sub == 'past_due';
    },
    isStripeSubscriptionCanceled: function () {
        if (!this.hasSubscribedStripe()) {
            return false;
        }
        var b = this.get('billing');
        if (b && (_.include(['canceled', 'incomplete_expired'], b.subscription) || b.cancel_at_period_end)) {
            return true;
        }
        return false;
    },
    isStripeSubscriptionUnpaid: function () {
        var b = this.get('billing');
        var sub = b ? b.subscription : this.get('subscriptions');
        return _.include(
            ['unpaid', 'incomplete'],
            sub
        );
    },
    isPaypalSubscriptionCanceled: function () {
        return this.hasSubscribedPaypal() && this.get('paypal_billing').subscription == 'cancelled';
    },
    isPaypalSubscriptionExpired: function () {
        return this.hasSubscribedPaypal() && this.get('paypal_billing').subscription == 'expired';
    },
    isOneOffSubscriptionExpired: function () {
        var s = this.get('subscription_oneoff');
        if (!s) {
            return false;
        }
        return s.active === false;
    },
    isSubscriptionCanceled: function () {
        return this.isStripeSubscriptionCanceled()
            || this.isPaypalSubscriptionCanceled()
            || this.isOneOffSubscriptionExpired();
    },
    isSubscriptionUnpaid: function () {
        return this.isStripeSubscriptionUnpaid()
            || this.isPaypalSubscriptionExpired()
            || this.isOneOffSubscriptionExpired();
    },
    hasSubscribedStripe: function () {
        if (
            this.has('billing') ||
            (
                this.get('subscriptions') &&
                this.get('subscriptions').stripe &&
                this.get('subscriptions').stripe.length
            )
        ) {
            return true;
        }
        return false;
    },
    hasSubscribedPaypal: function () {
        return this.has('paypal_billing');
    },
    hasSubscribedAndroid: function () {
        return this.has('android_billing');
    },
    hasSubscribedOneOff: function () {
        return this.has('subscription_oneoff');
    },
    hasSubscribed: function () {
        return this.hasSubscribedStripe()
            || this.hasSubscribedPaypal()
            || this.hasSubscribedAndroid()
            || this.hasSubscribedOneOff();
    }
};


module.exports = BillingMixins;


/***/ }),

/***/ "udet":
/***/ (function(module, exports) {

var DisconnectGrouper = function (options) {
    this.buffer = options.buffer;
    this.lines = [options.line];
    this.rows = options.rows;
    this.formatter = options.formatter;
    this.index = options.index;
    this.spliceCount = this.rows.length;
    this.sentences = '';
    this.expanded = false;
};
DisconnectGrouper.prototype = {
    setIndex: function (index) {
        this.index = index;
    },
    getFirstLine: function () {
        return this.lines[0];
    },
    addMessage: function (line, rows) {
        if (line.get('match')) {
            this.expanded = true;
        }
        this.lines.push(line);
        this.rows.push.apply(this.rows, rows);
        // Return whether this is the first grouping we've done
        var isFirst = (this.lines.length == 2);
        if (!isFirst) {
            this.spliceCount = 3;
        }
        return isFirst;
    },
    renderMessage: function (line, rows) {
        var isFirst = this.addMessage(line, rows);
        this.render();
        return isFirst;
    },
    render: function () {
        var messages = [];
        var messageCounts = {};
        _.each(this.lines, function (line) {
            var discoMessage = line.getDisconnectMessage();
            if (discoMessage) {
                var msg = this.formatter.renderLinkify(discoMessage);
                if (!messageCounts[msg]) {
                    messageCounts[msg] = 0;
                }
                messageCounts[msg]++;
                if (!_.contains(messages, msg)) {
                    messages.push(msg);
                }
            }
        }, this);
        messages = _.map(messages, function (msg) {
            if (messageCounts[msg] > 1) {
                msg += ' (x' + messageCounts[msg] + ')';
            }
            return msg;
        });
        this.sentences = '<span class="sentence">' + messages.join(', ') + '</span>';
        return this;
    }
};


module.exports = DisconnectGrouper;


/***/ }),

/***/ "uiw5":
/***/ (function(module, exports, __webpack_require__) {

var BufferInputView = __webpack_require__("+laS");
var BufferNickView = __webpack_require__("9PKk");
var BufferScrollView = __webpack_require__("kiyR");
var ConnectionStatusView = __webpack_require__("OC/i");
var LowerChatterBarView = __webpack_require__("wNhE");
var OverlayContainerView = __webpack_require__("f01x");
var UpperChatterBarView = __webpack_require__("9lob");
var BufferUploadView = __webpack_require__("o1Zz");
var BufferFormatter = __webpack_require__("gfb+");
var SelectionCopy = __webpack_require__("jDU1").default;
var perf = __webpack_require__("fJd+");
var Keyboard = __webpack_require__("fDhS").default;


var BufferView = Backbone.View.extend({
    tagName: 'div',
    className: 'buffercontainer buffercontainer--hidden',
    id: function () {
        return 'buffercontainer_' + this.model.bid();
    },
    status: null,
    initialize: function (options) {
        this.buffer = options.buffer || this.model;
        this.visible = false;
        this.formatter = new BufferFormatter(this.model);
        this.model.on('selectedChange', this.renderSelected, this);
        this.model.on('doneSelected', this.doneSelected, this);
        this.buffer.on('remove', this.remove, this);
        this.listenTo(this.model.session, 'buffersShown', this.buffersShown);

        this.upperChatter = new UpperChatterBarView(options);
        this.lowerChatter = new LowerChatterBarView(options);
        this.connectionStatus = new ConnectionStatusView(options);

        // Set in sub views
        this.status.on('topChange', this.mainTopChange, this);

        this.scroll = new BufferScrollView(options);
        this.scroll.on('topChange', this.scrollTopChange, this);
        this.scroll.on('heightChange', this.scrollHeightChange, this);
        this.scroll.on('widthChange', this.scrollWidthChange, this);

        if (!this.model.isThread()) {
            this.nick = new BufferNickView(options);
        }
        this.input = new BufferInputView(options);
        this.input.on('focus', this.inputFocus, this);
        this.input.on('blur', this.inputBlur, this);
        this.input.on('key', this.inputKey, this);
        this.selectionCopy = new SelectionCopy(options, this);
        if (this.model.session.uploadsEnabled()) {
            this.upload = new BufferUploadView(options, this.input);
        }

        this.overlay = new OverlayContainerView({
            model: this.model,
            session: this.model.session
        });

        this.renderInlineFiles(true);
        this.buffer.on('prefChange:files-disableinline', function () {
            this.renderInlineFiles();
        }, this);
        this.renderInlineAttachments(true);
        this.buffer.on('prefChange:attachments-disableinline', function () {
            this.renderInlineAttachments();
        }, this);
        this.renderInlinePastes(true);
        this.buffer.on('prefChange:pastebin-disableinline', function () {
            this.renderInlinePastes();
        }, this);
        this.renderInlineSocialMedia(true);
        this.buffer.on('prefChange:twitter-disableinline', function () {
            this.renderInlineSocialMedia();
        }, this);
        this.renderInlineMastodon(true);
        this.buffer.on('prefChange:mastodon-enableinline', function () {
            this.renderInlineMastodon();
        }, this);
        this.renderInlineBsky(true);
        this.buffer.on('prefChange:bsky-enableinline', function () {
            this.renderInlineBsky();
        }, this);
        this.renderInlineReddit(true);
        this.buffer.on('prefChange:reddit-enableinline', function () {
            this.renderInlineReddit();
        }, this);
        this.renderInlineImages(true);
        this.buffer.on('prefChange:inlineimages', function () {
            this.renderInlineImages();
            this.renderAvatars();
            this.renderShowAvatarPrompt();
        }, this);
        this.renderMultiline(true);
        this.buffer.on('prefChange:chat-oneline', function () {
            this.renderMultiline();
            this.renderRealnames();
            this.renderTimestamp();
        }, this);
        this.renderRealnames(true);
        this.buffer.on('prefChange:chat-norealname', function () {
            this.renderRealnames();
        }, this);
        this.renderColor(true);
        this.buffer.on('prefChange:chat-nocolor', function () {
            this.renderColor();
        }, this);
        this.renderTimestamp(true);
        this.buffer.on('prefChange:time-left', function () {
            this.renderTimestamp();
        }, this);
        this.renderAvatars(true);
        this.buffer.on('prefChange:avatars-off', function () {
            this.renderAvatars();
            this.renderTimestamp();
            this.renderShowAvatarPrompt();
        }, this);
        this.buffer.on('prefChange:avatars-image-off', function () {
            this.renderAvatars();
            this.renderShowAvatarPrompt();
        }, this);
        this.renderShowAvatarPrompt();
        this.listenTo(this.model.connection, 'change:avatars_supported', this.renderShowAvatarPrompt);
        this.listenTo(this.model.connection, 'prefChange:avatars-disableUploadPrompt', this.renderShowAvatarPrompt);
        this.listenTo(this.model.connection, 'change:ircserver', this.renderShowAvatarPrompt);
        this.listenTo(this.model.connection, 'change:hostname', this.renderShowAvatarPrompt);
        this.listenTo(this.model.getUser(), 'change:avatar', this.renderShowAvatarPrompt);
        this.listenTo(this.model.getUser(), 'change:avatar_url', this.renderShowAvatarPrompt);
        this.listenTo(this.model.getUser(), 'change:usermask', this.renderShowAvatarPrompt);
        this.model.on('reactMessageEmoji', this.reactMessageEmoji, this);
        this.model.on('lockReplyHighlight', this.lockReplyHighlight, this);
        this.model.on('clearReplyHighlight', this.clearReplyHighlight, this);
        this.model.on('focusInput', this.focusInput, this);

        this.throttledSendTyping = _.throttle(
            _.bind(this.sendTyping, this), 3000, {trailing: false}
        );
    },
    events: {
        'click .bufferBelowExtras .extrasBar': 'clickLowerChatter',
        'click .bufferAboveExtras .extrasDismiss': 'clickDismiss',
        'click .bufferAboveExtras .extrasBar': 'clickUpperChatter',
        'mouseenter .reply__indicator, .reply__quote': 'hoverReply',
        'mouseleave .reply__indicator, .reply__quote': 'unhoverReply',
        'click .reply__indicator': 'clickReply',
        'buttonClick .reply__add': 'clickReply',
        'click .reply__summary': 'clickReply',
        'click .reply__quote': 'clickReply',
        'autogrow': 'autogrowInput',
        'click .uploadcell': 'clickUpload',
        'buttonClick .uploadcell': 'clickUpload',
        'click .emojicell': 'clickEmoji',
        'buttonClick .emojicell': 'clickEmoji'
    },
    reactMessageEmoji: function (colon, data) {
        this.model.react(data.message.getMsgId(), emoji.replace_colons(colon, true));
    },
    focusInput: function () {
        this.input.focus();
    },
    inputFocus: function () {
        this.$el.addClass('focus');
    },
    inputBlur: function () {
        this.$el.removeClass('focus');
    },
    inputKey: function (e) {
        if (e.which == Keyboard.KEYS.PAGE_UP) {
            if (!e.metaKey && !e.ctrlKey) {
                this.scroll.scrollUp();
            }
            return;
        } else if (e.which == Keyboard.KEYS.PAGE_DOWN) {
            if (!e.metaKey && !e.ctrlKey) {
                this.scroll.scrollDown();
            }
            return;
        } else if (e.which == Keyboard.KEYS.END) {
            if (!this.input.val()) {
                if (!e.metaKey && !e.ctrlKey) {
                    this.scroll.scrollToBottom();
                }
                return;
            }
        } else if (e.which == Keyboard.KEYS.HOME) {
            if (!this.input.val()) {
                if (!e.metaKey && !e.ctrlKey) {
                    this.scroll.scrollToTop();
                }
                return;
            }
        } else if (e.which == Keyboard.KEYS.ENTER) {
            // Never just submit the form on enter
            e.preventDefault();
            this.input.onEnter(e);
        }
        this.input.tabComplete.onKey(e);
    },
    clickDismiss: function (e) {
        e.preventDefault();
        this.model.read();
    },
    clickUpperChatter: function (e) {
        e.preventDefault();
        if (!this.scroll.isLastSeenMessageRendered()) {
            this.scroll.scrollToTop();
            this.scroll.setScrolledToBottom(false);
            this.scroll.loadOrRenderBacklog();
        } else {
            this.scroll.scrollToLastSeenOrTop();
        }
    },
    clickLowerChatter: function (e) {
        e.preventDefault();
        this.scroll.log.renderBelowScroll();
        if (e.altKey) {
            this.scroll.scrollToBottom();
        } else {
            this.scroll.scrollToBottomSeenOrBottom();
        }
    },
    autogrowInput: function (e, css) {
        this.scroll.checkPinBottom(function (pinBottom) {
            $(e.target).css(css);
            this.scroll.onChange(pinBottom);
        }, this, { checkRecent: true });
    },

    fullLayoutChange: function (pinBottom) {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.uncacheRect();
        this.onScrollChange(pinBottom);
        this.scrollTopChange();
        this.scrollWidthChange(pinBottom);
    },
    mainTopChange: function () {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.uncacheRect();
        this.scroll.checkPinBottom(function (pinBottom) {
            this.scrollTopChange();
            this.scroll.fixScroll(pinBottom);
        }, this);
    },
    scrollTopChange: function () {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.uncacheRect();
        this.scrollHeightChange();
    },
    scrollHeightChange: function () {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.uncacheRect();
    },
    scrollWidthChange: function (pinBottom) {
        if (!this.isVisible()) {
            return;
        }
        this.trigger('timeLayoutChange');
        this.scroll.widthChange(pinBottom);
    },

    onScrollChange: function (pinBottom, forceRead) {
        if (!this.isVisible()) {
            return;
        }
        if (this.scroll.isFetching()) {
            return;
        }
        var upperRows = this.scroll.log.getRowAtTopOfScroll();
        if (!this.model.isThread()) {
            var upperMessage = this.scroll.getMessageForRow(upperRows[0]);
            var lowerMessage = this.scroll.getMessageAtBottomOfScroll();

            // Update chatter bars
            var upperVisible = this.upperChatter.isVisible();
            var upperShown = this.upperChatter.update(upperMessage);
            if (upperShown === false) {
                // No chatter bar and focused
                if (forceRead || this.model.session.isFocused()) {
                    this.model.read();
                }
            }

            var lowerVisible = this.lowerChatter.isVisible();
            var bottomSeenRow = this.scroll.log.getBottomSeen();
            var bottomSeenDate = this.lowerChatter.update(lowerMessage, bottomSeenRow);
            if (bottomSeenDate) {
                // Updated
                bottomSeenRow.data('locked-time', bottomSeenDate.getTime());
            }

            var fixScroll = false;
            if (upperVisible != this.upperChatter.isVisible()) {
                // Toggled state
                this.scrollTopChange();
                fixScroll = true;
            } else if (lowerVisible != this.lowerChatter.isVisible()) {
                this.scrollHeightChange();
                fixScroll = true;
            }

            if (fixScroll || this.scroll.isResizing()) {
                // Fix scroll position in case chatter bar toggling shifted scroll
                this.scroll.fixScroll(pinBottom);
            }

            // Update scroll clock
            var clockShown = this.scroll.updateClock(upperMessage);
            this.$el.toggleClass('clockShown', clockShown);
        }
        this.scroll.setStickyAuthor(upperRows);
    },
    // This will get called from MainAreaView
    renderOverlay: function (overlay) {
        this.overlay.append(overlay);

        return this;
    },
    hoverUserRows: function (user) {
        var attr = '[data-usermask="' + this.formatter.escapeQuerySelector(user.getHostMask()) + '"]';
        this.scroll.log.$('div.row .bufferLink' + attr + ', div.row' + attr).addClass('hover');
    },
    unhoverUserRows: function () {
        this.scroll.log.$('div.row, div.row .bufferLink').removeClass('hover');
    },
    renderMultiline: function (initial) {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$el.toggleClass('multiline', this.buffer.multiline());
            this.$el.toggleClass('oneline', !this.buffer.multiline());
            if (!initial) {
                this.scroll.onChange(pinBottom);
            }
        }, this);
    },
    renderRealnames: function (initial) {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$el.toggleClass('realnames-on', this.buffer.showRealnames());
            this.$el.toggleClass('realnames-off', !this.buffer.showRealnames());
            if (!initial) {
                this.scroll.onChange(pinBottom);
            }
        }, this);
    },
    renderColor: function (initial) {
        this.$el.toggleClass('irccolors', this.buffer.formatColor());
    },
    renderTimestamp: function (initial) {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$el.toggleClass('time-right', this.buffer.isTimeRight());
            this.$el.toggleClass('time-left', !this.buffer.isTimeRight());
            if (!initial) {
                this.scroll.onChange(pinBottom);
            }
        }, this);
    },
    renderAvatars: function (initial) {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$el.toggleClass('avatars-on', this.buffer.avatarsEnabled());
            this.$el.toggleClass('avatars-off', !this.buffer.avatarsEnabled());
            this.$el.toggleClass('avatars-image-on', this.buffer.imageAvatarsEnabled());
            this.$el.toggleClass('avatars-image-off', !this.buffer.imageAvatarsEnabled());
            this.$el.toggleClass('avatars-external', this.buffer.embedExternalAvatars());
            this.$el.toggleClass('avatars-noexternal', !this.buffer.embedExternalAvatars());
            if (!initial) {
                this.scroll.onChange(pinBottom);
            }
        }, this);
    },
    renderShowAvatarPrompt: function () {
        this.$el.toggleClass('avatars-uploadssupported', this.model.connection.avatarUploadsSupported());
        this.$el.toggleClass('avatars-showuploadprompt', this.model.shouldPromptAvatar());
    },
    renderInlineFiles: function (initial) {
        this.$el.toggleClass('inlinefiles', this.buffer.inlineFilesAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineFilesAllowed()) {
                    this.scroll.log.loadFiles($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineAttachments: function (initial) {
        this.$el.toggleClass('inlineattachments', this.buffer.inlineAttachmentsAllowed());
        if (!initial) {
            this.scroll.onChange();
        }
    },
    renderInlinePastes: function (initial) {
        this.$el.toggleClass('inlinepastes', this.buffer.inlinePastesAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                this.scroll.log.loadAttachmentSnippets($(this.scroll.log.el));
                if (this.buffer.inlinePastesAllowed()) {
                    this.scroll.log.loadPastes($(this.scroll.log.el));
                    this.scroll.log.loadGists($(this.scroll.log.el));
                    this.$('i.iframeEmbed.pastebincom').each(_.bind(function (i, el) {
                        this.replaceEmbedPlaceholder(el);
                    }, this));
                    this.scroll.log.loadEmbedIframes($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineSocialMedia: function (initial) {
        this.$el.toggleClass('inlineSocialMedia', this.buffer.inlineSocialMediaAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineSocialMediaAllowed()) {
                    this.scroll.log.loadTweets($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineMastodon: function (initial) {
        this.$el.toggleClass('inlineMastodon', this.buffer.inlineMastodonAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineMastodonAllowed()) {
                    this.scroll.log.loadMastodon($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineBsky: function (initial) {
        this.$el.toggleClass('inlineBsky', this.buffer.inlineBskyAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineBskyAllowed()) {
                    this.scroll.log.loadBsky($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineReddit: function (initial) {
        this.$el.toggleClass('inlineReddit', this.buffer.inlineRedditAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineRedditAllowed()) {
                    this.scroll.log.loadReddit($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    replaceEmbedPlaceholder: function (el) {
        var attrs = ['class', 'src', 'width', 'height', 'alt'];
        var tag;
        if ($(el).hasClass('image')) {
            tag = 'img';
        } else {
            tag = 'iframe';
            attrs = attrs.concat(Object.keys(this.formatter.linker.iframeProps()));
        }
        var replacement = $('<' + tag + '>');
        _.each(attrs, function (attr) {
            replacement.attr(attr, $(el).attr(attr));
        });
        $(el).replaceWith(replacement);
    },
    renderInlineImages: function (initial) {
        this.$el.toggleClass('inlineimages', this.buffer.inlineImagesAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineImagesAllowed()) {
                    this.$('i.image, i.iframeEmbed.video, i.iframeEmbed.spotify, i.iframeEmbed.garmin, i.iframeEmbed.tenor').each(_.bind(function (i, el) {
                        this.replaceEmbedPlaceholder(el);
                    }, this));
                    this.scroll.log.inlineImages($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderActive: function () {
        this.$el.toggleClass('active', this.model.isActive());
        if (this.model.isSelected()) {
            this.mainTopChange();
        }
        return this;
    },
    renderAway: function () {
        this.$el.toggleClass('away', this.model.connection.isAway());
    },
    renderSlack: function () {
        this.$el.toggleClass('slack', this.model.connection.isSlack());
        this.$el.toggleClass('slack--oauth', this.model.connection.isSlackOAuth());
    },
    renderSelected: function () {
        if (this.model.isSelected()) {
            this.show();
        } else {
            this.hide();
        }

        return this;
    },
    doneSelected: function () {
        // Timing
        var metadata = {
            messages: this.model.messages.length
        };
        if (this.model.isChannel()) {
            metadata.members = this.model.members.length;
        }
        var baseKey = 'bufferSelect';
        var key = (this.firstRender ? 'init' : '') + baseKey;
        this.model.session.perfMeasure(key, this.model.bid(), metadata, perf.measure(baseKey));
        this.firstRender = false;
    },
    userTyping: function () {
        this.renderInputStatus();
    },
    sendTyping: function (value) {
        this.model.sendTyping(value);
    },
    renderInputStatus: function (event) {
        var val = this.input.val();

        var slash = this.input.isSlashCommand(val);
        if (
            event && event.type == 'input' &&
            val &&
            !slash &&
            this.model.connection.hasClientTags() &&
            !this.model.connection.blocksTyping() &&
            !this.model.isThread() &&
            !this.model.isServerLog() &&
            this.model.isSharingTyping() &&
            this.model.connection.isConnected() &&
            this.model.isActive() &&
            this.model.session.isStreamConnected()
        ) {
            this.throttledSendTyping('active');
        }

        // Toggle nick if slash command
        var showNick = !this.model.isThread() && !slash;
        if (this.nickBoxShown != showNick) {
            this.nickInputBox.toggleClass('hideNick', !showNick);
            this.nickBoxShown = showNick;
        }

        var sentence = '';
        if (val.indexOf('\n') === -1) {
            var charsRemaining = this.input.calculateLineLengthRemaining(val);
            if (charsRemaining < 20) {
                sentence += '<span class="inputstatus_charsLeft">';
                if (charsRemaining < 0) {
                    if (charsRemaining > -20) {
                        sentence += charsRemaining + ' – ';
                    }
                    sentence += 'message will be split';
                } else {
                    sentence += charsRemaining + ' ' +
                        this.formatter.pluralise(charsRemaining, 'character') + ' left';
                }
                sentence += '</span> ';
            }
        }

        var typers = this.model.getTypers();
        if (typers.length) {
            var typersList;
            if (typers.length > 5) {
                typersList = typers.length + ' people';
            } else {
                typersList = this.formatter.escapeText(
                    this.formatter.listSentence(_.invoke(typers, 'getDisplayName'))
                );
            }
            sentence += '<span class="inputstatus_typers">' +
                typersList + ' ' + this.formatter.pluralise(typers.length, 'is', 'are') + ' typing' +
                '</span>';
        }
        this.$('.inputstatuscell').html(sentence);
    },
    renderConnectionStatus: function (initial) {
        if (initial) {
            this.connectionStatus.render();
        } else {
            this.scroll.checkPinBottom(function (pinBottom) {
                this.connectionStatus.render();
                this.scrollHeightChange();
                this.scroll.fixScroll(pinBottom);
            }, this);
        }
        return this.connectionStatus;
    },
    buffersShown: function () {
        if (this.model.isSelected()) {
            this.afterShow(true);
        }
    },
    afterShow: function (force) {
        if (force) {
            $('#bufferPanes').addClass('show');
        } else {
            $('#bufferPanes.canShow').addClass('show');
        }
        this.visible = true;
        this.scroll.checkPinBottom(function (pinBottom) {
            this.fullLayoutChange(pinBottom);
            this.scroll.fixScroll(pinBottom);
        }, this);
        this.model.trigger('afterShow');
    },
    show: function () {
        this.$el.removeClass('buffercontainer--hidden');

        this.render();

        this.afterShow();

        this.onInput();

        return this;
    },
    updateLastSeen: function () {
        if (!this.model.isDeferred() && !this.model.hasUnseen()) {
            this.scroll.log.renderLastSeen();
        }
    },
    isVisible: function () {
        return this.visible;
    },
    hide: function () {
        this.visible = false;
        $('#bufferPanes').removeClass('show');
        this.$el.addClass('buffercontainer--hidden');
        this.updateLastSeen();
        this.unhoverUserRows();

        return this;
    },
    renderLastSeen: function () {
        if (this.model.isSelected()) {
            if (!this.model.hasUnseen()) {
                if (this.upperChatter.hide()) {
                    this.scrollTopChange();
                }
                // Unlock focus and bottom seen if they're lower than this id
                // This can happen when we get a heartbeat from another socket
                var focusSeenId = this.model.eid(this.model.getFocusSeen());
                var change;
                if (focusSeenId && this.model.getLastSeen() > focusSeenId) {
                    this.scroll.unlockFocusSeen();
                    change = true;
                }
                var bottomSeenId = this.model.eid(this.model.getBottomSeen());
                if (bottomSeenId && this.model.getLastSeen() > bottomSeenId) {
                    this.scroll.unlockBottomSeen();
                    change = true;
                }
                if (change) {
                    this.scroll.checkPinBottom(function (pinBottom) {
                        this.onScrollChange(pinBottom);
                    }, this);
                }
            }
        } else {
            // Only set marker if last_seen_eid change happens while deselected
            this.updateLastSeen();
        }
    },
    focusChange: function () {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.checkPinBottom(function (pinBottom) {
            if (this.model.session.isFocused()) {
                // Remove the focus marker
                this.scroll.unlockFocusSeen();
            } else {
                if (pinBottom) {
                    // Set the marker if scrolled to bottom
                    this.updateLastSeen();
                    // Unlock the bottom seen marker so we can take over
                    this.scroll.unlockBottomSeen();
                    this.scroll.log.removeBottomSeen();
                }
                this.scroll.lockFocusSeen();
            }
            this.onScrollChange(pinBottom);
        }, this);
    },
    onInput: function (e) {
        // Hide magic copy button
        this.selectionCopy.hide(true);

        this.renderInputStatus(e);

        // Highlight last message for reactions
        if (!this.initReplyHighlight()) {
            this.clearReplyHighlight();
        }

    },
    activateReplyHighlight: function (lock) {
        if (this.replyHighlight) {
            return true;
        } else {
            var last = this.model.messages.lastReplyable();
            if (last) {
                var lastLine = this.scroll.log.getVisibleLineStrict(last);
                if (!lastLine) {
                    var lastParts = this.previousVisibleReplyable(last);
                    last = lastParts[0];
                    lastLine = lastParts[1];
                }
                if (this.setReplyHighlight(last, lastLine, lock)) {
                    return true;
                }
            }
        }
    },
    initReplyHighlight: function () {
        if (!this.isVisible()) {
            return;
        }
        if (this.blockNextReplyHighlight) {
            this.blockNextReplyHighlight = false;
            return;
        }
        if (this.input.isReactionShortcut()) {
            var ret = this.activateReplyHighlight();
            if (ret !== undefined) {
                return ret;
            }
        } else if (this.input.lockedReplyTarget) {
            return true;
        }
    },
    cycleReplyHighlights: function (key) {
        if (!this.replyHighlightMessage) {
            return false;
        }
        var up = key == Keyboard.KEYS.UP;
        var down = key == Keyboard.KEYS.DOWN;
        this.scroll.inputInfo.hide();
        var message, messageLine, parts;
        if (up) {
            parts = this.previousVisibleReplyable(this.replyHighlightMessage);
        } else if (down) {
            parts = this.nextVisibleReplyable(this.replyHighlightMessage);
        }
        if (parts) {
            message = parts[0];
            messageLine = parts[1];
        }
        if (!message) {
            message = this.replyHighlightMessage;
            messageLine = this.scroll.log.getVisibleLineStrict(message);
        }
        if (this.setReplyHighlight(message, messageLine, true)) {
            this.scroll.scrollToMessage(message);
            return true;
        }
    },
    previousVisibleReplyable: function (message) {
        var m = message.previousReplyable();
        var mLine;
        while (m && !(mLine = this.scroll.log.getVisibleLineStrict(m))) {
            m = m.previousReplyable();
        }
        return [m, mLine];
    },
    nextVisibleReplyable: function (message) {
        var m = message.nextReplyable();
        var mLine;
        while (m && !(mLine = this.scroll.log.getVisibleLineStrict(m))) {
            m = m.nextReplyable();
        }
        return [m, mLine];
    },
    clearReplyHighlight: function (blockNext) {
        if (this.replyHighlight) {
            if (blockNext) {
                this.blockNextReplyHighlight = true;
            }
            this.replyHighlight.removeClass('addReplyHighlight');
            this.replyHighlight = null;
            this.replyHighlightMessage = null;
            this.input.replyTarget = null;
            this.input.lockedReplyTarget = false;
            this.unhoverReply();
        }
    },
    lockReplyHighlight: function (message) {
        if (message.equals(this.replyHighlightMessage)) {
            this.clearReplyHighlight();
        } else {
            this.setReplyHighlight(message, this.scroll.log.getVisibleLine(message), true);
            this.focusInput();
        }
    },
    setReplyHighlight: function (message, messageLine, lock) {
        if (message && messageLine) {
            this.clearReplyHighlight();
            messageLine.addClass('addReplyHighlight');
            this.hoverReply({target: messageLine});
            this.replyHighlightMessage = message;
            this.replyHighlight = messageLine;
            this.input.replyTarget = message;
            if (lock) {
                this.input.lockedReplyTarget = true;
            }
            return true;
        }
        return false;
    },
    getTemplate: function () {
        if (!BufferView._structure) {
            BufferView._structure = $($('#tpl-buffer').html());
        }
        return BufferView._structure.clone();
    },
    clickReply: function (e) {
        var row = $(e.target).closest('.row');
        var bufMessage = this.buffer.getMessage(row.data('eid'));
        if (bufMessage) {
            if (this.model.isThread()) {
                this.buffer.select();
                if (!this.buffer.isDeferred()) {
                    bufMessage.show();
                }
            } else {
                this.model.session.setThreadId(this.model.threadId(bufMessage.getReplyId()));
            }
        }
    },
    clickUpload: function (e) {
        this.model.session.trigger('clickUpload', e, this.model);
        return false;
    },
    clickEmoji: function (e) {
        this.model.session.trigger('clickEmoji', e, this.model);
        return false;
    },
    hoverReply: function (e) {
        var row = $(e.target).closest('.row');
        var reply = row.attr('data-reply');
        this.scroll.log.$('div.row').removeClass('hoverReply');
        if (reply) {
            var attr = '[data-reply="' + this.formatter.escapeQuerySelector(reply) + '"]';
            this.scroll.log.$('div.row' + attr).addClass('hoverReply');
        } else {
            row.addClass('hoverReply');
        }
        this.$el.addClass('hoveringReply');
    },
    unhoverReply: function () {
        if (this.replyHighlight) {
            this.hoverReply(({target: this.replyHighlight}));
        } else {
            this.$el.removeClass('hoveringReply');
            this.scroll.log.$('div.row').removeClass('hoverReply');
        }
    },
    render: function () {
        if (this.rendered) {
            return this;
        }
        this.firstRender = true;
        // This has a significant cost if done at initialisation time
        this.$el.attr({
            'role': 'tabpanel',
            'aria-labelledby': 'bufferlabel_' + this.model.bid()
        });
        debug.timeStamp(this.model.getTitle() + ' [render]');
        var structure = this.getTemplate();

        structure.find('div.viewport')
            .append(this.scroll.render().el)
            .append(this.scroll.stickyAvatarContainer)
            .append(this.scroll.clock.el)
            .append($('<div class="inputInfoWrapper">').append(this.scroll.inputInfo.el))
            .append(this.overlay.render().el);

        structure.find('.bufferstatus').append(this.status.render().el);
        this.status.postrender();

        structure.find('.upperchattercell').append(this.upperChatter.render().el);

        structure.find('.lowerchattercell').append(this.lowerChatter.render().el);

        structure.find('.connectionstatuscell').append(this.renderConnectionStatus(true).el);
        this.listenTo(this.model.connection, 'focusOnMakeBufferChange change:status change:fail_info change:away', function () {
            this.renderConnectionStatus();
        });

        this.timeCell = structure.find('.timecell');

        this.nickInputBox = structure.find('.nickinputcell');

        var lockTitle;
        if (this.model.connection.isSlack()) {
            lockTitle = "Private channel";
        } else {
            lockTitle = "Password protected";
        }
        structure.find('.lockcell .fa-lock').attr('title', lockTitle);

        if (this.nick) {
            this.nickBox = structure.find('.nickcell');
            this.nickBox.append(this.nick.render().el);
            this.nickBox.append('&nbsp;');
        }
        this.nickBoxShown = true;

        this.input.render();
        structure.find('.inputcell').append(this.input.el);

        this.selectionCopy.render();
        structure.find('.clipboardTriggerCell').append(this.selectionCopy.el);

        if (this.model.session.uploadsEnabled()) {
            this.upload.render();
            structure.find('.uploadcell').append(this.upload.radialProgress);
            structure.find('.uploadcell').append(this.upload.el);
        }

        this.input.on('input', this.onInput, this);
        this.input.on('completeCandidates', this.scroll.inputInfo.renderCandidates, this.scroll.inputInfo);

        this.scroll.on('makeInputChoice', function (index) {
            this.input.tabComplete.makeClickedChoice(index);
            this.focusInput();
        }, this);
        this.scroll.on('makeInputOriginalChoice', function () {
            this.input.tabComplete.makeOriginalChoice();
        }, this);

        this.renderActive();
        this.model.on('activeChange', this.renderActive, this);

        this.renderAway();
        this.listenTo(this.model.connection, 'change:away', this.renderAway);

        this.renderSlack();
        this.listenTo(this.model.connection, 'change:ircserver', this.renderSlack);
        this.listenTo(this.model.connection, 'change:hostname', this.renderSlack);

        this.$el.append(structure.children());

        if (this.postrender) {
            this.postrender();
        }

        this.focusInput();

        this.model.on('change:last_seen_eid', this.renderLastSeen, this);
        this.model.on('userTyping', this.userTyping, this);

        this.listenTo(this.model.session, 'prefChange:theme', function () {
            if (this.model.isSelected()) {
                this.onScrollChange();
            }
        });
        this.scroll.on('change', this.onScrollChange, this);
        setTimeout(_.bind(function renderScrollBindTimeout () {
            this.scroll.on('scroll', function bufferViewOnScroll (e, pinBottom) {
                var atBottom = this.scroll.isScrolledToBottom();
                if (pinBottom === undefined) {
                    this.scroll.updateScroll();
                }
                var manual;
                if (e && (!atBottom || !this.scroll.isScrolledToBottom())) {
                    manual = true;
                }
                this.doScroll(manual);
            }, this);
        }, this), 500);

        debug.timeStamp(this.model.getTitle() + ' [rendered]');

        this.model.trigger('rendered', this);

        this.rendered = true;

        return this;
    },
    doScroll: function (manual) {
        this.scroll.checkPinBottom(function (pinBottom) {
            var bottomSeen = this.model.getBottomSeen();
            if (pinBottom) {
                this.scroll.log.checkFlush();
                this.scroll.unlockBottomSeen();
                if (bottomSeen) {
                    pinBottom = false;
                }
            } else {
                this.scroll.lockBottomSeen();
            }

            // Run this first to update seen markers
            // before we get locked in fetch/rendering backlog
            this.onScrollChange(pinBottom, manual);
            
            this.scroll.checkInfiniscroll();
        }, this);
    }
});


module.exports = BufferView;


/***/ }),

/***/ "vMiC":
/***/ (function(module, exports, __webpack_require__) {

var Buf = __webpack_require__("t9zO");
var BufferFormatter = __webpack_require__("gfb+");
var Member = __webpack_require__("abDD");
var User = __webpack_require__("Xgjh");


var InputInfoView = Backbone.View.extend({
    tagName: 'div',
    className: 'inputInfo',
    initialize: function (options) {
        this.visible = false;
        this.formatter = new BufferFormatter(this.model);
        
        this.model.bind('remove', this.remove, this);
    },
    renderTimedelay: 300,
    events: {
        'click a': 'clickItem',
        'click span.item': 'clickItem'
    },
    clickItem: function (e) {
        var item = $(e.currentTarget).closest('span.item');
        if (item.is('.original')) {
            this.makeOriginalChoice();
        } else {
            var index = item.data('index');
            this.makeChoice(index);
        }
        return false;
    },
    makeChoice: function (index) {
        this.trigger('makeInputChoice', index);
        this.hide();
    },
    makeOriginalChoice: function () {
        this.trigger('makeInputOriginalChoice');
        this.hide();
    },
    renderCandidates: function (word, candidates, highlight, emoji) {
        if (highlight !== undefined && candidates[highlight]) {
            return this.show(word, candidates, highlight);
        } else if (emoji && candidates.length) {
            return this.show(word, candidates);
        } else {
            return this.hide();
        }
    },
    isVisible: function () {
        return this.visible;
    },
    show: function (word, candidates, highlight) {
        this.word = word;
        
        var nodes = _.map(candidates, function (c, i) {
            var node = $('<span class="item">');
            if (highlight === i) {
                node.addClass('highlight');
            }
            if (c instanceof Member && c.isAway()) {
                node.addClass('away');
            }
            node.data('index', i);
            var name;
            if (c instanceof User) {
                name = c.getName();
                var displayAuthor = c.getDisplayAuthor();
                if (displayAuthor && displayAuthor != name) {
                    name = displayAuthor + ' (' + name + ')';
                }
                var html = this.formatter.linkUserMode(c, {
                    name: name
                });
                if (c.isAway()) {
                    html += ' (away)';
                }
                node.html(html);
                if (!this.word && c.lastHighlighted) {
                    var hlDate = new Date(c.lastHighlighted);
                    var timeago = $('<span class="hlago">').attr('title', hlDate.toISOString()).text(hlDate.formatFullDate()).timeago();
                    node.append(' ', timeago);
                }
            } else if (c instanceof Buf) {
                name = c.getName();
                if (c.isServerLog()) {
                    name = c.getFullLabel();
                }
                node.html(this.formatter.linkModel(c, {
                    name: name
                }));
            } else if (c.emoji) {
                node.html(emoji.replacement(c.emoji, '', c.title, undefined, undefined, c.skinTone));
            } else {
                node.text(c);
            }
            return node;
        }, this);
        this.$('.hlago').timeago('dispose');
        this.$el.html(nodes);
        
        if (this.word) {
            var orig = $('<span class="original item">').text(this.word);
            if (!candidates[highlight]) {
                orig.addClass('highlight');
            }
            this.$el.prepend(orig);
        }
        
        // Hint text
        var text;
        if (candidates.length == 1) {
            text = 'Press tab or esc to dismiss';
        } else {
            text = 'Press tab to autocomplete (esc to dismiss)';
        }
        this.$el.prepend($('<span class="hint">').text(text));
        
        if (!this.isVisible()) {
            this.$el.show();
            this.visible = true;
        }
        return this;
    },
    hide: function () {
        if (this.isVisible()) {
            this.$el.hide();
            this.visible = false;
        }
        return this;
    }
});


module.exports = InputInfoView;


/***/ }),

/***/ "vxt3":
/***/ (function(module, exports, __webpack_require__) {

var Member = __webpack_require__("abDD");
var MemberAdminList = __webpack_require__("WeW2");
var MemberHalfOpList = __webpack_require__("rPHv");
var MemberList = __webpack_require__("XZrG");
var MemberOpList = __webpack_require__("tR0s");
var MemberOwnerList = __webpack_require__("dFhQ");
var MemberOperList = __webpack_require__("bN3V");
var MemberVoicedList = __webpack_require__("XDey");
var UserList = __webpack_require__("jGPP");


var ChannelMemberList = UserList.extend({
    model: Member,
    initialize: function (models, options) {
        this.connection = options.connection;
        this.channel = options.channel;
        
        this.bind('reset', this.resetMembers, this);
        this.bind('add', this.addMember, this);
        this.bind('remove', this.removeMember, this);
        this.bind('change:mode', this.moveMember, this);
        this.bind('change:nick', this.moveMember, this);
        this.channel.bind('preinit', this.preinit, this);
    },
    preinit: function () {
        this.lists = {};
        _.each(this.connection.getUserModes(), function (mode, category) {
            this.lists[category] = new MemberList([], category, this.connection);
        }, this);
        this.lists.MEMBER = new MemberList([], 'MEMBER', this.connection);
    },
    getList: function (member) {
        return this.lists[member.getModeCategory()];
    },
    getPreviousList: function (member) {
        return this.lists[member.getPreviousModeCategory()];
    },
    resetMembers: function () {
        var toAdd = {};
        var modes = this.connection.getUserModes();
        this.each(function (member) {
            var category = member.getModeCategory(modes);
            if (!toAdd[category]) {
                toAdd[category] = [];
            }
            toAdd[category].push(member);
        }, this);
        _.each(this.lists, function (list, cat) {
            var members = toAdd[cat];
            list.reset(members, {sort: false});
        }, this);
    },
    addMember: function (member, collection, options) {
        var list = this.getList(member);
        list.add(member, options);
    },
    removeMember: function (member, options) {
        var list = this.getList(member);
        list.remove(member, options);
    },
    moveMember: function (member, newMode, options) {
        var prevList = this.getPreviousList(member);
        prevList.remove(member, options);
        this.addMember(member, this, options);
    }
});


module.exports = ChannelMemberList;


/***/ }),

/***/ "w2pc":
/***/ (function(module, exports) {

var OrgMember = Backbone.Model.extend({
    initialize: function (data, options) {
        this.org = options.org;
        this.removed = this._unsavedRemoved = false;
        this.bind('change', this.changeAttribute, this);
    },
    changeAttribute: function () {
        if (!this._unsavedAttributes) {
            this._unsavedAttributes = this.previousAttributes();
        }
    },
    needsRemoving: function () {
        return this._unsavedRemoved !== this.removed;
    },
    needsSaving: function () {
        if (this.needsRemoving()) {
            return true;
        }
        if (this._unsavedAttributes) {
            for (var k in this.attributes) {
                if (this._unsavedAttributes[k] != this.get(k)) {
                    return true;
                }
            }
        }
        return false;
    },
    isAdmin: function () {
        return !!this.get('admin');
    },
    isSelf: function () {
        return !!this.get('self');
    },
    setAdmin: function (value) {
        return this.set({'admin': value});
    },
    isRemoved: function () {
        return this.removed;
    },
    isJoined: function () {
        return !!this.get('uid');
    },
    setRemoved: function (value) {
        if (this.removed !== value) {
            this.removed = value;
            this.trigger('removedChange', this);
            if (this.collection) {
                this.collection.trigger('removedChange', this, this.collection);
            }
        }
        return this;
    },
    reset: function () {
        this._unsavedAttributes = this.toJSON();
        this._unsavedRemoved = this.removed;
    },
    resendInvite: function (callback) {
        this.org.resendInvite(this, callback);
    }
});

module.exports = OrgMember;


/***/ }),

/***/ "wDHD":
/***/ (function(module, exports, __webpack_require__) {

var Formatter = __webpack_require__("5gSh");
var HashDialogView = __webpack_require__("o6PP");
var PayViewMixins = __webpack_require__("eIfS");
var UpgradeSchedules = __webpack_require__("FIf4").default;


var UpgradeView = HashDialogView.extend($.extend({}, PayViewMixins, {
    el: '#upgradeOverlayContent',
    wrapper: $('#upgradeContainer'),
    initialize: function (options) {
        HashDialogView.prototype.initialize.call(this, options);
        PayViewMixins.initialize.call(this, options);

        this.inactiveFor = $('.inactiveFor');
        this.zombieLimit = $('.zombieLimit');
        this.zombifiedAgo = $('.zombifiedAgo');

        this.upgradeSchedules = new UpgradeSchedules(options, this);

        this.upgradeCurrentOrg = this.$('.upgradeCurrentOrg');
        this.annualSwitch = this.$('.annualSwitch');

        this.billingDetails = $('#soloBillingDetails');

        this.renderSessionState();
        this.renderPay();
        this.model.bind('featureChange:upgrades', this.renderSessionState, this);
        this.model.bind('orgsChange', this.renderSessionState, this);
        this.model.bind('change:limits_name', this.renderSessionState, this);
        this.model.bind('setZombie', this.renderZombieLimit, this);
        this.model.bind('plansChange', this.renderPlans, this);
        this.model.bind('billingUpdate', this.renderBilling, this);
        this.model.bind('stat', this.stat, this);

        this.formatter = new Formatter;

        _.bindAll(this, 'show');

        this.router.route('?/upgrade', 'show', this.show);
        this.router.route('?/upgrade=:plan', 'show', this.show);

        this.bind('open', this.onOpen, this);
    },
    events: _.extend({}, HashDialogView.prototype.events, PayViewMixins.events),

    afterPay: function (response) {
        PayViewMixins.afterPay.call(this, response);
        this.upgradeSchedules.afterPay(response);
        this.renderBillingDetails();
    },
    subscribeMonthly: function (afterStripe) {
        this.stripeCheckout(
            'Upgrade',
            _.bind(function (data, mixinCallback) {
                if (afterStripe) {
                    afterStripe(data);
                }
                if (data) {
                    this.model.subscribe(data, _.bind(function (response) {
                        mixinCallback(response);
                    }, this));
                }
            }, this), {
                description: 'Monthly upgrade for ' + this.model.get('name'),
                amount: this.getAmount(),
                subscription: true
            }
        );
    },
    subscribeYearly: function (renew, afterStripe, callback) {
        var description = renew ? 'Yearly upgrade' : 'One time upgrade';
        description += ' for ' + this.model.get('name');
        var plan = 'yearly';
        this.stripeCheckout(
            'Upgrade',
            _.bind(function (data, mixinCallback) {
                if (afterStripe) {
                    afterStripe(data);
                }
                if (data) {
                    if (renew) {
                        data.plan = plan;
                        this.model.subscribe(data, mixinCallback);
                    } else {
                        this.model.subscribeOneOff(data, mixinCallback);
                    }
                }
            }, this), {
                description: description,
                amount: this.getYearlyAmount(),
                plan: plan,
                subscription: !!renew
            }
        );
    },

    payDone: function () {
        this.$('.payInvoice').hide();
        this.$('.payComplete').show();
    },
    fetchBillingInfo: function () {
        this.$el.addClass('isLoadingBilling');
        this.model.getBillingInfo(_.bind(function (billingResponse, failInfo) {
            this.$el.removeClass('isLoadingBilling');
            if (billingResponse.success) {
                this.removeBillingInfoError();
                this.renderBillingDetails();
                this.focusFirst();
            }
        }, this));
    },

    // PayViewMixins
    billingCancelSureText: 'Are you sure you want to cancel this subscription?',
    renderPayActiveSub: function () {
        if (this.model.hasActiveOneOffSubscription() && !this.model.hasActiveRecurringSubscription()) {
            this.$('.payOneOffExtend').show();
        }
    },
    getNewPayButtons: function () {
        var tpl;
        if (this.model.hasActiveSubscription()) {
            if (this.model.hasActiveOneOffSubscription()) {
                tpl = 'billing-pay-extend';
            }
        } else {
            tpl = 'billing-pay-new';
        }
        if (tpl) {
            var payButtons = $($('#tpl-' + tpl).html());
            return $('<div>').append(payButtons).html();
        }
    },
    formatPlan: function (b) {
        return 'Recurring — ' + this.formatter.amount(b.currency, b.amount) + '/' + b.interval;
    },
    formatOneOffPlan: function (oo, charge) {
        var format = 'One off — ';
        if (charge) {
            format += this.formatter.amount(charge.currency, charge.amount) + ' ';
        }
        format += 'for ' + oo.interval_count + ' ' + oo.interval;
        return format;
    },
    formatSubscriptionInvoiceItem: function (sub) {
        var description = 'Subscription payment';
        if (sub.period) {
            description += ' for ' + this.formatter.date(sub.period.start) + ' — ' + this.formatter.date(sub.period.end);
        } else if (sub.created) {
            description += ' for ' + this.formatter.date(sub.created);
        }
        return description;
    },
    formatOneOffSubscriptionInvoiceItem: function (sub) {
        return 'One off subscription for ' + this.formatter.date(sub.start_date) + ' — ' + this.formatter.date(sub.end_date);
    },
    stripeCheckout: function (label, callback, options) {
        PayViewMixins.stripeCheckout.call(this, label, callback, $.extend(true, {}, {
            email: this.model.get('email'),
            currency: this.model.getCurrency()
        }, options));
    },
    clickPayButton: function (e) {
        e.preventDefault();
        this.upgradeRestore();
    },
    upgradeRestore: function () {
        this.billingDetails.hide();
        this.upgradeSchedules.show();
        this.focusFirst();
    },
    cancelUpgrade: function () {
        this.billingDetails.show();
        this.upgradeSchedules.hide();
    },

    renderPlans: function () {
        if (this.model.plans.solo) {
            $('.soloPayPrice').text(this.formatter.amount(
                this.model.plans.currency,
                this.model.plans.solo.amount,
                1,
                0
            ));
        }
    },
    getAmount: function () {
        return this.model.plans.solo.amount;
    },
    getYearlyAmount: function (currency) {
        currency = currency || this.model.getCurrency();
        return this.model.plans.solo_yearly[currency].amount;
    },
    stat: function () {
        if (this.isVisible()) {
            this.model.getBillingInfo();
        }
    },
    renderBillingDetails: function () {
        var contents = this.formatBillingDetails();
        this.billingDetails.html(contents);
        var hasSubscribed = this.model.hasSubscribed();
        this.upgradeSchedules.setUpgradedState(hasSubscribed);
        if (!this.isStripeCheckoutShown() && (
            hasSubscribed || !this.upgradeSchedules.isVisible()
        )) {
            this.billingDetails.toggle(hasSubscribed);
            this.upgradeSchedules.toggle(!hasSubscribed);
        }
        this.renderPlans();
        if (!this.model.hasActiveSubscription()) {
            this.$('.payComplete').hide();
        }
    },
    show: function (upgrade) {
        this.fetchBillingInfo();
        HashDialogView.prototype.show.call(this);
    },
    renderBilling: function () {
        this.renderSessionState();
        this.renderPay();
    },
    renderSessionState: function () {
        this.upgradeCurrentOrg.toggle(this.model.hasActiveOrgs());
        this.annualSwitch.toggle(this.model.hasActiveMonthlySubscription());
        this.upgradeCurrentOrg.toggleClass('subscribed', this.model.hasActiveSubscription());
    },
    renderZombieLimit: function () {
        if (this.model.isZombied()) {
            this.zombieLimit.text(this.model.getLimit('zombiehours') + ' hours');
            var zombieDate = new Date(this.model.getZombieDate());
            this.zombifiedAgo.attr('title', zombieDate.toISOString()).text(zombieDate.formatFullDate()).timeago();
            if (this.model.softZombie && this.model.isZombieLimited()) {
                var inactiveStartDate = new Date(zombieDate);
                inactiveStartDate.addHours(-this.model.getLimit('zombiehours'));
                var strings = $.extend(true, {}, $.timeago.settings.strings);
                strings.prefixAgo = null;
                strings.suffixAgo = null;
                this.inactiveFor.attr('title', inactiveStartDate.toISOString()).text(inactiveStartDate.formatFullDate()).timeago('init', strings);
            }
        }
    }
}));

module.exports = UpgradeView;


/***/ }),

/***/ "wNhE":
/***/ (function(module, exports, __webpack_require__) {

var ChatterBarView = __webpack_require__("hKI7");


var LowerChatterBarView = ChatterBarView.extend({
    buttonText: '↓',
    buttonTitle: 'Scroll to end',
    className: ChatterBarView.prototype.className + ' bufferBelowExtras',
    update: function (lowerMessage, bottomSeenRow) {
        if (!lowerMessage) {
            return false;
        }
        // Update the bottom seen if we've scrolled below
        var updated = this.model.updateBottomSeen(lowerMessage);
        var bottomSeen = this.model.getBottomSeen();
        if (!bottomSeen) {
            this.hide();
            this.hideMentions();
            return false;
        }
        this.renderMentions(this.model.unseenHighlightCountAfter(bottomSeen));
        
        // Get the difference between bottom seen and last message
        var linesAgo;
        if (this.model.countMessagesBetween(bottomSeen) > 100) {
            linesAgo = true;
        } else {
            linesAgo = this.model.countImportantMessagesBetween(bottomSeen);
        }
        var bottomSeenDate;
        if (!updated && bottomSeenRow.length) {
            bottomSeenDate = new Date(bottomSeenRow.data('locked-time'));
        } else {
            bottomSeenDate = new Date();
        }
        this.renderChatter(bottomSeenDate, linesAgo);
        return updated && bottomSeenDate;
    }
});


module.exports = LowerChatterBarView;


/***/ }),

/***/ "x4eI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAe2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _channelLinks = __webpack_require__("0LDK");

var _channelLinks2 = _interopRequireDefault(_channelLinks);

var _keyboard = __webpack_require__("fDhS");

var _keyboard2 = _interopRequireDefault(_keyboard);

var _channelLinks3 = __webpack_require__("/zkE");

var _channelLinks4 = _interopRequireDefault(_channelLinks3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEXT = 'next';
var PREV = 'prev';

exports.default = Backbone.View.extend({

    template: _channelLinks2.default,

    tagName: 'div',

    className: 'channelLinks',

    events: {
        'mouseover .channelLinks__item': onMouseOver
    },

    initialize: function initialize(props) {
        this.actions = {
            select: props.select
        };
        this.mouseEventsEnabled = true;
        this.setInitialState(props);
        this.render(this.state);
        this.onKeyDown = onKeyDown.bind(this);
    },
    setup: function setup() {
        toggleEventHandlers.call(this, 'on');
    },
    teardown: function teardown() {
        toggleEventHandlers.call(this, 'off');
    },
    setInitialState: function setInitialState(props) {
        this.state = props.state;
    },
    setState: function setState(state) {
        this.state = state;
        this.render(this.state);
    },
    render: function render() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.$el.html(this.template(this.getTemplateData(state)));
        this.$links = this.$('.channelLinks__link');
        this.$liveRegion = this.$('.channelLinks__live-region');
        if (this.hasSelection()) {
            this.highlight(this.state.current);
        }
        return this;
    },
    getTemplateData: function getTemplateData(state) {
        return state;
    },
    select: function select(direction) {
        var items = this.state.filtered;
        var current = this.state.current;

        if (!items.length) {
            return;
        }

        current = getNextIndex(direction, items.length, current);
        // boolean argument specifies element alignment relative to the the 
        // scrollable ancestor: true = top, false = bottom
        this.$links[current].scrollIntoView(false);
        this._select(current);
    },
    _select: function _select(current) {
        this.state.current = current;
        this.highlight(current);
    },
    getSelection: function getSelection() {
        if (!this.state || !this.state.filtered.length) {
            return false;
        }
        return this.state.filtered[this.state.current];
    },
    hasSelection: function hasSelection() {
        return Boolean(this.getSelection());
    },


    _setLiveRegionTimeout: null,
    setLiveRegion: function setLiveRegion(current) {
        if (this._setLiveRegionTimeout) {
            clearTimeout(this._setLiveRegionTimeout);
            this._setLiveRegionTimeout = null;
        }
        var item = this.state.filtered[current];
        this._setLiveRegionTimeout = setTimeout(_.bind(function () {
            this.$liveRegion.text(item.displayName + ', ' + item.type + ' on ' + item.serverName);
        }, this), 1000);
    },
    highlight: function highlight(current) {
        this.$links.removeClass('selected');
        $(this.$links[current]).addClass('selected');
        this.setLiveRegion(current);
    }
});


function toggleEventHandlers(fn) {
    $(window)[fn]('keydown', this.onKeyDown);
}

function toggleMouseEvents(bool) {
    this.mouseEventsEnabled = bool;
}

function onMouseOver(e) {
    if (!this.mouseEventsEnabled) {
        return;
    }
    var index = $(e.currentTarget).index();
    this._select(index);
}

function onKeyDown(e) {
    var up = e.which === _keyboard2.default.KEYS.UP;
    var down = e.which === _keyboard2.default.KEYS.DOWN;
    var tab = e.which === _keyboard2.default.KEYS.TAB;
    var shiftTab = tab && e.shiftKey;
    var enter = e.which === _keyboard2.default.KEYS.ENTER;

    if (up || down || tab || shiftTab || enter) {
        e.preventDefault();
        if (this.mouseEventsEnabled) {
            toggleMouseEvents.call(this, false);
            $(window).one('mousemove', toggleMouseEvents.bind(this, true));
        }
    } else {
        return;
    }

    if (up || shiftTab) {
        this.select(PREV);
    }
    if (down || !shiftTab && tab) {
        this.select(NEXT);
    }

    if (enter && this.hasSelection()) {
        var selection = this.getSelection();
        this.actions.select(selection);
    }
}

function getNextIndex(direction, length, current) {
    if (direction === PREV) {
        if (current === 0) {
            current = length - 1;
        } else {
            current--;
        }
    }

    if (direction === NEXT) {
        if (current === length - 1) {
            current = 0;
        } else {
            current++;
        }
    }

    return current;
}

/***/ }),

/***/ "xUgn":
/***/ (function(module, exports, __webpack_require__) {

var BufferListChildView = __webpack_require__("1ka6");


var BufferListConversationView = BufferListChildView.extend({
    className: BufferListChildView.prototype.className + ' conversation',

    render: function () {
        BufferListChildView.prototype.render.call(this);
        
        this.listenTo(this.model.recipient, 'change:nick', this.renderLinkText);
        this.listenTo(this.model.recipient, 'change:display_name', this.renderLinkText);
        this.listenTo(this.model.session.pinnedBuffers, 'recipientChange', this.renderLinkText);
        
        return this;
    }
});


module.exports = BufferListConversationView;


/***/ }),

/***/ "xUqH":
/***/ (function(module, exports, __webpack_require__) {

var BufferList = __webpack_require__("o4N7");


var PinnedBufferList = BufferList.extend({
    comparator: function (buffer) {
        return buffer.pinned;
    },
    addAt: function (buffer, idx, options) {
        buffer.pinned = idx;
        var ret = this.add(buffer, options);
        this.trigger('changed');
        return ret;
    },
    addAtEnd: function (buffer, options) {
        return this.addAt(buffer, this.length, options);
    },
    unpin: function (buffer) {
        delete buffer.pinned;
        var ret = this.remove(buffer, {silent: true});
        this.trigger('changed');
        return ret;
    },
    isAmbiguous: function (buffer) {
        var groups = this.groupBy(function (buf) {
            return buf.getDisplayName();
        });
        var group = groups[buffer.getDisplayName()];
        if (group && group.length > 1) {
            return true;
        } else {
            return false;
        }
    },
    onChange: function () {
        this.trigger('fullChange');
    },
    bids: function () {
        return this.pluck('bid');
    },
    isPinned: function (buffer) {
        return this.contains(buffer);
    },
    isEmpty: function () {
        return !this.length;
    },
});


module.exports = PinnedBufferList;


/***/ }),

/***/ "xgw8":
/***/ (function(module, exports, __webpack_require__) {

var browser = __webpack_require__("2ZbG");

var FaviconView = Backbone.View.extend({
    size: 16,
    initialize: function (options) {
        this.model.buffers.bind('unseenHighlightChange', this.render, this);
        this.model.bind('unseenChange', this.render, this);

        if (browser.isHighDensity()) {
            this.url = '/static/favicon/favicon-32x32.png';
        } else {
            this.url = '/static/favicon/favicon-16x16.png';
        }
        this.img = $('<img>').attr('src', this.url)[0];
        this.canvas = $('<canvas>')[0];
    },
    getUnseenMessageStats: function () {
        if (!this.model.unseenBuffers.length) {
            return false;
        }
        var count = 0;
        this.model.unseenBuffers.each(function (buffer) {
            count += buffer.unseenHighlightCount();
        }, this);
        return count;
    },

    render: function () {
        try {
            var iconUrl = this.getIconUrl();
            this.setFavicon(iconUrl);
        } catch (e) {
            // Can error if the image url fails
        }
    },
    pxr: function (val) {
        return val * browser.getPixelRatio();
    },
    rect: function (ctx, x, y, width, height, radius) {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();    
    },
    getIconUrl: function () {
        var stats = this.getUnseenMessageStats();
        var canvasSize = this.pxr(this.size);
        this.canvas.height = this.canvas.width = canvasSize;
        var ctx = this.canvas.getContext('2d');
        // Base icon
        ctx.drawImage(this.img, 0, 0, canvasSize, canvasSize);
        // stats = false;
        if (stats) {
            // Circle
            ctx.fillStyle = '#ff1f1a';
            var radius = this.pxr(2.5);
            var margin = this.pxr(1);
            var originX = canvasSize - radius - margin;
            var originY = margin + radius;
            ctx.beginPath();
            ctx.arc(originX, originY, radius, 0, 2*Math.PI);
            ctx.fill();
        }
        return this.canvas.toDataURL('image/png');
    },
    setFavicon: function (iconUrl) {
        $('head').find('link[rel=icon]').attr('href', iconUrl);
    }
});


module.exports = FaviconView;


/***/ }),

/***/ "xpYO":
/***/ (function(module, exports, __webpack_require__) {

var sko = __webpack_require__("pyif").default;

window.emoji = {};
// settings
emoji.img_path = 'emoji/';
emoji.img_suffix = '';
emoji.colon_aliases = {};
emoji.text_maps = new sko();
emoji.unified_blacklist = {};
emoji.non_native = {};

emoji.use_css_imgs = false;
emoji.colons_mode = false;
emoji.text_mode = false;
emoji.include_title = false;
emoji.allow_native = true;
emoji.use_sheet = false;
emoji.with_emocodes = true;

emoji.inits = {};
emoji.map = {};
emoji.categories = [
    "Smileys & Emotion",
    "People & Body",
    "Animals & Nature",
    "Food & Drink",
    "Travel & Places",
    "Activities",
    "Objects",
    "Symbols",
    "Flags"
];

emoji.re = {
    colons: /(:[^\s:]+:)(:skin-tone-[2-6]:)?/,
    strip_colons: /^:(:?[^:]+)(::skin-tone-[2-6])?:$/i,
    strip_colons_only: /^:(.+):$/i,
    multi_skin: /(\w+)-(\w+)/,
    ipv6_hex: /^[a-f0-9]+$/,
    ipv6_mask_pre: /([:*?]|(\b[a-f0-9:*?]+))$/,
    ipv6_mask_post: /^([:*?]|([a-f0-9:*?]+\b))/,
    ua_cr_os: /CrOS/i,
    ua_mac_os: /Mac OS X 1[01][_.][0-9]/i,
    ua_windows_os: /Windows NT 10\.\d/i,
};

emoji.strip_colons = function (colon){
    return colon.replace(emoji.re.strip_colons, "$1");
};
emoji.strip_colons_only = function (colon){
    return colon.replace(emoji.re.strip_colons_only, "$1");
};
emoji.replace_colons = function(str, force_unified, skin_tone, options) {
    options = options || {};
    emoji.init_colons();
    var match = str.match(emoji.re.colons);
    if (!match) {
        return str;
    }
    var matchPart = match[0];
    var colon = match[1];
    var skin_colon = match[2];
    var idx = emoji.strip_colons(colon);
    // We use sko to prevent these issues, but might as well
    // just reject already at this stage
    if (idx == '__proto__') {
        return str;
    }
    var first = str.slice(0, match.index);
    var rest = str.slice(match.index+matchPart.length);
    var val = emoji.map.colons.get(idx);
    if (skin_colon) {
        var skin_idx = emoji.strip_colons(skin_colon);
        var skin_val = emoji.map.colons.get(skin_idx);
        if (skin_val) {
            skin_tone = emoji.data[skin_val][0][0];
        }
    }
    var replaced = ':' + idx;
    var colon_rest = ':' + rest;
    var was_replaced = false;

    if (
        // Filter out ipv6 hex masks
        // 1000:1000:100:1000:0
        // *:100:1000:0
        // ?:100:1000:0
        emoji.re.ipv6_hex.test(idx) && (
            (
                first &&
                first != ':' &&
                !/\s$/.test(first) && (
                    emoji.re.ipv6_mask_pre.test(first) ||
                    emoji.re.ipv6_mask_post.test(rest)
                )
            ) || (
                options.prev && (
                    emoji.re.ipv6_mask_pre.test(options.prev)
                )
            )
        )
    ) {
        rest = colon_rest;
    } else if (
        // Filter out Perl modules
        // Dpkg::package::package::package::package
        (!options.prev_replaced && /:$/.test(first))
    ) {
        rest = colon_rest;
    } else {
        if (val) {
            var titleText = idx;
            if (emoji.colon_aliases[val]) {
                var aliasIdx = _.indexOf(emoji.colon_aliases[val], idx);
                if (aliasIdx !== -1) {
                    var smileyAliasIdx = _.indexOf(emoji.colon_aliases[val], ':' + idx);
                    if (smileyAliasIdx !== -1) {
                        aliasIdx = smileyAliasIdx;
                    }
                    titleText = emoji.colon_aliases[val][aliasIdx];
                }
            }
            replaced = emoji.replacement(val, colon, titleText, colon, force_unified, skin_tone);
            was_replaced = true;
        } else if (emoji.text_maps.has(idx)) {
            replaced = emoji.text_maps.get(idx);
        } else {
            rest = colon_rest;
        }
    }
    return first + replaced + emoji.replace_colons(rest, force_unified, undefined, {
        prev_replaced: was_replaced,
        prev: (options.prev || '') + first + replaced
    });
};
emoji.idx_to_title = function (idx) {
    if (emoji.data[idx]) return emoji.data[idx][3][0];
};
emoji.match_unified = function (str) {
    emoji.init_unified();
    return str.match(emoji.rx_unified);
};
emoji.unified_to_text = function (str) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var m = match[1];
        var rest = match[3] + str.slice(match.index+match[0].length);
        var val = emoji.map.unified[m];
        var val_var = emoji.map.unified_vars[m];
        var replaced = m;
        if (val) {
            replaced = emoji.data[val][3][0];
            var skin_idx = emoji.skin_tone_to_idx(match[2]);
            if (skin_idx) {
                replaced += '::' + emoji.data[skin_idx][3][0];
            }
        } else if (val_var) {
            replaced = emoji.data[val_var[0]][3][0];
            replaced += '::' + emoji.data[val_var[1]][3][0];
        }
        return first + replaced + emoji.unified_to_text(rest);
    } else {
        return str;
    }
};
emoji.strip_unified = function (str, single) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var rest = match[3] + str.slice(match.index+match[0].length);
        if (single) {
            return first + rest;
        } else {
            return first + emoji.strip_unified(rest);
        }
    } else {
        return str;
    }
};
emoji.replace_unified = function (str) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var m = match[1];
        var rest = match[3] + str.slice(match.index+match[0].length);
        var val = emoji.map.unified[m];
        var val_var = emoji.map.unified_vars[m];
        var replaced = m;
        if (val) {
            replaced = emoji.replacement(val, m, emoji.idx_to_title(val), undefined, undefined, match[2]);
        } else if (val_var) {
            var skin_tone_idx = val_var[1];
            var skin_tone_data = emoji.data[skin_tone_idx];
            var skin_tone;
            if (skin_tone_data) {
                skin_tone = skin_tone_data[0][0];
            }
            replaced = emoji.replacement(val_var[0], m, emoji.idx_to_title(val_var[0]), undefined, undefined, skin_tone, skin_tone_idx);
        }
        return first + replaced + emoji.replace_unified(rest);
    } else {
        return str;
    }
};
emoji.make_attrs = function (attrs, extraClass) {
    if (attrs.classNames) {
        attrs.classNames = attrs.classNames.concat(extraClass);
        if (attrs.classNames.length) {
            attrs['class'] = attrs.classNames.join(' ');
        }
        delete attrs.classNames;
    }
    var parts = [];
    for (var attr in attrs) {
        if (attrs[attr] != null) {
            parts.push(attr + '="' + attrs[attr] + '"');
        }
    }
    return parts.length ? ' ' + parts.join(' ') : '';
};
emoji.wrap_span = function (val, attrs, extraClass) {
    extraClass = extraClass || [];
    return '<span'+emoji.make_attrs(attrs, extraClass)+'>' + val + '</span>';
};

emoji.skin_tone_to_idx = function (skin_tone) {
    return emoji.map.skin_tone_to_idx[skin_tone];
};
emoji.idx_to_colon = function (idx, skin_tone) {
    var out = ':'+emoji.data[idx][3][0]+':';
    var skin_idx = emoji.skin_tone_to_idx(skin_tone);
    if (skin_idx) {
        if (emoji.variations_data[idx] && emoji.variations_data[idx][skin_idx]) {
            out += ':'+emoji.data[skin_idx][3][0]+':';
        }
    }
    return out;
};

function get_version (idx) {
    return emoji.data[idx][6];
}
function get_variation_version (idx, skin_idx) {
    if (!skin_idx || !emoji.variations_data[idx]) {
        return get_version(idx);
    }
    return emoji.variations_data[idx][skin_idx][4];
}

// Support probe

var probe_config = {
    fonts: '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","Twemoji Mozilla",sans-serif',
    assume_native_up_to: 4.0,
    unknown_is_native: false,
    sentinels: [
        [11.0, '1f970'], // smiling_face_with_3_hearts
        [12.0, '1f971'], // yawning_face
        [12.1, '1f9d1-200d-1f373'], // cook
        [13.0, '1f972'], // smiling_face_with_tear
        [13.1, '1f62e-200d-1f4a8'], // face_exhaling
        [14.0, '1fae0'], // face-smiling
        [15.0, '1fae8'], // shaking_face
        [15.1, '1f34b-200d-1f7e9'], // lime
        [16.0, '1fae9'], // face_with_bags_under_eyes
        [17.0, '1faea'], // distorted_face
    ],
    categories: {
        'country-flag': '1f1fa-1f1f8', // flag-us
        'subdivision-flag': '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f' // flag-england
    },
    special: {
        '1f1fa-1f1f3': true, // flag-un
        '2695-fe0f': true, // medical_symbol
        '2640-fe0f': true, // female_sign
        '2642-fe0f': true, // male_sign
    },
    cache: {},
    ctx: null,
};
emoji.probe_config = probe_config;

function get_probe_ctx () {
    if (!probe_config.ctx) {
        var canvas = document.createElement('canvas');
        canvas.width = 64;
        canvas.height = 48;
        probe_config.ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (probe_config.ctx) {
            probe_config.ctx.textBaseline = 'top';
            probe_config.ctx.font = '28px ' + probe_config.fonts;
        }
    }
    return probe_config.ctx;
}

function run_probe (idx) {
    var ctx = get_probe_ctx();
    if (!ctx) {
        return false;
    }
    try {
        // Unsupported sequences (ZWJ, skin tones, flags) fall back to several
        // separate glyphs, which are much wider than one properly shaped glyph.
        var str = emoji.data[idx][0][0];
        var core = Array.from(str.replace(/\uFE0F/g, ''));
        if (core.length > 1) {
            var base = str.indexOf('\u200D') !== -1 ? str.split('\u200D')[0] : core[0];
            if (ctx.measureText(str).width > ctx.measureText(base).width * 1.5) {
                return false;
            }
        }

        // Tofu and monochrome fallbacks are drawn in the fill color (pure red).
        // A real color glyph contains clearly non-red opaque pixels.
        ctx.clearRect(0, 0, 64, 48);
        ctx.fillStyle = '#f00';
        ctx.fillText(str, 0, 0);
        var d = ctx.getImageData(0, 0, 64, 48).data;
        for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] > 200 && (d[i + 1] > 60 || d[i + 2] > 60)) {
                return true;
            }
        }
    } catch (e) { /* canvas blocked or unreadable */ }
    return false;
}

// Sync, cached. Public so you can also probe an exact emoji yourself.
function probe_supported (idx) {
    if (!idx) {
        return false;
    }
    if (!Object.prototype.hasOwnProperty.call(probe_config.cache, idx)) {
        probe_config.cache[idx] = run_probe(idx);
    }
    return probe_config.cache[idx];
};

function version_native (version) {
    var n = parseFloat(version);
    if (isNaN(n)) {
        return probe_config.unknown_is_native;
    }
    if (n <= probe_config.assume_native_up_to) {
        return true;
    }
    var i;
    // An unsupported sentinel at or below this version means this one fails too.
    for (i = 0; i < probe_config.sentinels.length; i++) {
        if (probe_config.sentinels[i][0] <= n && !probe_supported(probe_config.sentinels[i][1])) {
            return false;
        }
    }
    // A supported sentinel at or above this version means this one works too.
    for (i = 0; i < probe_config.sentinels.length; i++) {
        if (probe_config.sentinels[i][0] >= n && probe_supported(probe_config.sentinels[i][1])) {
            return true;
        }
    }
    return probe_config.unknown_is_native;
}

emoji.check_allow_native = function (idx, skin_idx) {
    if (emoji.non_native[idx]) {
        return false;
    }
    if (!(emoji.allow_native && emoji.replace_mode == 'unified' && emoji.data[idx][0][0])) {
        return false;
    }

    // Special cases: probed directly, no version or category gating.
    if (probe_config.special[idx] && !skin_idx) {
        return probe_supported(idx);
    }

    var version = get_variation_version(idx, skin_idx);
    if (!version_native(version)) {
        return false;
    }

    var cat_sentinel = probe_config.categories[emoji.data[idx][7]];
    if (cat_sentinel && !probe_supported(cat_sentinel)) {
        return false;
    }
    return true;
};

emoji.replacement = function(idx, actual, titleText, colon, force_unified, skin_tone, skin_idx) {
    skin_tone = skin_tone || '';
    skin_idx = skin_idx || emoji.skin_tone_to_idx(skin_tone);
    var full_idx = idx;
    var variation_data;
    if (skin_idx) {
        variation_data = emoji.variations_data[idx] && emoji.variations_data[idx][skin_idx];
        if (variation_data) {
            full_idx = variation_data[0];
        } else {
            skin_idx = '';
            skin_tone = '';
        }
    }

    if (force_unified) {
        if (variation_data) {
            return variation_data[3][0];
        } else {
            return emoji.data[idx][0][0] + skin_tone;
        }
    }
    if (emoji.colons_mode) {
        var out = ':'+emoji.data[idx][3][0]+':';
        if (skin_idx) {
            out += ':'+emoji.data[skin_idx][3][0]+':';
        }
        return out;
    }
    if (emoji.text_mode) {
        var text_name = ':' + titleText + ':';
        return text_name;
    }
    emoji.init_env();
    var attrs = {classNames: []};
    if (emoji.include_title) {
        attrs.title = titleText;
    }
    var extraClass = [];
    var emoCode = '';
    if (emoji.with_emocodes && colon) {
        emoCode = emoji.wrap_span(colon, {
            classNames: ['emocode']
        });
        extraClass.push('emoconverted');
    }

    if (emoji.check_allow_native(idx, skin_idx)) {
        extraClass.push('emojinative');
        if (emoji.is_windows_native()) {
            extraClass.push('emojinative--win');
        }
        if (emoji.is_cr_os_native()) {
            extraClass.push('emojinative--cros');
        }
        if (emoji.is_mac_os_native()) {
            extraClass.push('emojinative--mac');
        }
        var native;
        if (variation_data) {
            native = variation_data[3][0];
        } else {
            native = emoji.data[idx][0][0] + skin_tone;
        }

        return emoji.wrap_span(native, attrs, extraClass) + emoCode;
    }
    attrs.classNames.push('emoji');
    var img = emoji.img_path+idx+'.png' + emoji.img_suffix;
    if (emoji.supports_css) {
        var px = emoji.data[idx][4];
        var py = emoji.data[idx][5];
        if (variation_data) {
            px = variation_data[1];
            py = variation_data[2];
            img = emoji.img_path+full_idx+'.png' + emoji.img_suffix;
        }
        if (emoji.use_sheet && px != null && py != null) {
            var mul = 100 / (emoji.sheet_size - 1);
            attrs.style = 'background-position:'+(mul*px)+'% '+(mul*py)+'%;';
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        } else if (emoji.use_css_imgs){
            attrs.classNames.push('emoji-'+full_idx);
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        } else {
            attrs.classNames.push('emoji-sizer');
            attrs.style = 'background-image:url('+img+')';
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        }
    }
    attrs.src = img;
    return '<img' + emoji.make_attrs(attrs) + '>' + emoCode;
};
emoji.init_colons = function(){
    if (emoji.inits.colons) return;
    emoji.inits.colons = 1;
    emoji.map.colons = new sko();
    var names;
    for (var i in emoji.data){
        names = emoji.data[i][3];
        if (emoji.colon_aliases[i]) {
            names = names.concat(emoji.colon_aliases[i]);
        }
        for (var j=0; j<names.length; j++){
            emoji.map.colons.set(names[j].toLowerCase(), i);
        }
    }
};
emoji.init_unified = function(){
    if (emoji.inits.unified) return;
    emoji.inits.unified = 1;

    var a = [];
    emoji.map.unified = {};
    emoji.map.unified_vars = {};
    emoji.map.category = {};
    emoji.map.skin_tone_to_idx = {};

    for (var i in emoji.data){
        if (!emoji.map.category[emoji.data[i][1]]) {
            emoji.map.category[emoji.data[i][1]] = [];
        }
        emoji.map.category[emoji.data[i][1]].push({key: i, item: emoji.data[i]});
        if (emoji.data[i][1] === 'Component' && emoji.data[i][7] === 'skin-tone') {
            emoji.map.skin_tone_to_idx[emoji.data[i][0][0]] = i;
        }

        var eCodes = emoji.data[i][0];
        for (var j = 0; j < eCodes.length; j++) {
            if (!emoji.unified_blacklist[eCodes[j]]) {
                a.push(eCodes[j].replace('*', '\\*'));
                emoji.map.unified[eCodes[j]] = i;
            }
        }
    }
    for (var vi in emoji.variations_data){
        var toAdd = [];
        var eVars = emoji.variations_data[vi];
        for (var vk in eVars) {
            var vCodes = eVars[vk][3];
            var multi_tone = vk.match(emoji.re.multi_skin);
            if (multi_tone && multi_tone[1] == multi_tone[2] && !emoji.variations_data[multi_tone[1]]) {
                toAdd.push([multi_tone[1], eVars[vk]]);
            }
            for (var vj = 0; vj < vCodes.length; vj++) {
                a.push(vCodes[vj].replace('*', '\\*'));
                emoji.map.unified_vars[vCodes[vj]] = [vi, vk];
            }
        }
        // Add simple form same skin tone variations when missing (e.g. people_holding_hands)
        if (toAdd.length) {
            for (var addI = 0; addI < toAdd.length; addI++) {
                eVars[toAdd[addI][0]] = toAdd[addI][1];
            }
        }
    }

    for (var cat in emoji.map.category) {
        emoji.map.category[cat].sort(function (a, b) {
            return a.item[2] - b.item[2];
        });
    }

    // Sort by length so that combined sequences match first
    a.sort(function (a, b) {
        return b.length - a.length;
    });
    // Escape code points, they get corrupted by uglify otherwise
    emoji.rx_unified = new RegExp('('+a.join('|')+')(\\uD83C[\\uDFFB-\\uDFFF])?([^\\ufe0e]|$)');
};
emoji.init_env = function(){
    if (emoji.inits.env) return;
    emoji.inits.env = 1;
    emoji.replace_mode = 'img';
    emoji.supports_css = false;
    if (window.getComputedStyle){
        var st = window.getComputedStyle(document.body);
        if (st['background-size'] || st['backgroundSize']){
            emoji.supports_css = true;
        }
    }
    if (emoji.supports_css) {
        emoji.replace_mode = 'css';
    }
    if (emoji.is_mac_os_native() || emoji.is_windows_native() || emoji.is_cr_os_native()) {
        emoji.replace_mode = 'unified';
    }
};

var _is_cr_os_native = null;
emoji.is_cr_os_native = function () {
    if (_is_cr_os_native === null) {
        _is_cr_os_native = emoji.re.ua_cr_os.test(navigator.userAgent);
    }
    return _is_cr_os_native;
};

var _is_windows_native = null;
emoji.is_windows_native = function () {
    if (_is_windows_native === null) {
        _is_windows_native = emoji.re.ua_windows_os.test(navigator.userAgent);
    }
    return _is_windows_native;
};

var _is_mac_os_native = null;
emoji.is_mac_os_native = function () {
    if (_is_mac_os_native === null) {
        _is_mac_os_native = emoji.re.ua_mac_os.test(navigator.userAgent);
    }
    return _is_mac_os_native;
};


/***/ }),

/***/ "ycye":
/***/ (function(module, exports, __webpack_require__) {

var MemberContextMenuView = __webpack_require__("zeA3");
var ChannelContextMenuView = __webpack_require__("EAmV");
var ConversationContextMenuView = __webpack_require__("tlSk");
var ServerLogContextMenuView = __webpack_require__("JvxA");
var UploadContextMenuView = __webpack_require__("6Cw2");
var EmojiContextMenuView = __webpack_require__("52EP");
var EnterpriseJoinView = __webpack_require__("aQSZ");
var FaviconView = __webpack_require__("xgw8");
var HashDialogView = __webpack_require__("o6PP");
var StatusView = __webpack_require__("4lyz");
var IRCCloudNotifier = __webpack_require__("9cM4");
var InvitesDialogView = __webpack_require__("M5Sr");
var JoinDefaultView = __webpack_require__("nR5u");
var MainAreaView = __webpack_require__("FHm1");
var NickservView = __webpack_require__("Hg18");
var ConnectionTokenView = __webpack_require__("a2Rs");
var EmailBounceView = __webpack_require__("99PH");
var OrgsDialogView = __webpack_require__("egpX");
var Overlay = __webpack_require__("jcM0");
var PastebinDialogView = __webpack_require__("ER68");
var FileUploadDialogView = __webpack_require__("ET1g");
var LogDownloadDialogView = __webpack_require__("a/KD");
var ShortcutsDialogView = __webpack_require__("UwCA");
var FileWrapper = __webpack_require__("JHsc");
var FilesDialogView = __webpack_require__("Nbol");
var PastebinsDialogView = __webpack_require__("3BDD");
var SidebarView = __webpack_require__("gCfx");
var TitleView = __webpack_require__("XLeX");
var UpgradeView = __webpack_require__("wDHD");
var VerifyNoticeView = __webpack_require__("532c");
var NoAuthDialogView = __webpack_require__("/Wd8");
var Keyboard = __webpack_require__("fDhS").default;
var ChannelSwitcher = __webpack_require__("oABZ").default;
var AvatarUploadDialog = __webpack_require__("/WYa").default;
var AvatarChooserDialog = __webpack_require__("QX5P").default;
var AvatarUploadView = __webpack_require__("ayOX");
var AddSlackView = __webpack_require__("zga+").default;
var util = __webpack_require__("GmLC");
var atPoint = __webpack_require__("88d4");


var SessionView = Backbone.View.extend({
    el: 'body',
    initialize: function (options) {
        _.bindAll(this,
            'windowBlur', 'windowFocus', 'initialWindowFocus',
            'catchAllRoute',
            'showOrgSignup',
            'selectBufferByUrlWithText',
            'addNetwork', 'ircUrl',
            'feedback', 'joinEnterprise', 'openSettings'
        );

        this.router = new Backbone.Router();
        this.router.bind('route', this.model.onRoute, this.model);
        this.router.route('*catchAll', 'catchAllRoute', this.catchAllRoute);
        this.router.route('!/*networkString', 'selectBufferByUrl', _.bind(function (networkString) {
            return this.selectBufferByUrl(networkString, true);
        }, this));
        this.router.route('irc/*networkString', 'selectBufferByUrl', _.bind(this.selectBufferByUrl, this));
        this.router.route('?/irc_url=*ircUrl', 'ircUrl', this.ircUrl);
        this.router.route('?/text=:text&url=*networkString', 'selectBufferByUrlWithText', this.selectBufferByUrlWithText);

        options.router = this.router;

        // make router available on session, since it's already a "general" storage
        this.model.router = this.router;

        this.model.on('prefChange:time-24hr', this.renderDates, this);
        this.model.on('prefChange:time-seconds', this.renderDates, this);
        this.model.on('prefChange:layout-left', this.renderLayoutLeft, this);
        this.model.on('prefChange:theme', this.renderTheme, this);
        this.model.on('prefChange:theme-auto', this.renderTheme, this);
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', _.bind(function (e) {
            this.renderTheme();
        }, this));
        this.model.on('prefChange:font', this.renderFont, this);

        this.title = new TitleView(options);
        this.favicon = new FaviconView(options);

        this.status = new StatusView(options);

        this.mainArea = new MainAreaView(options);
        this.verifyNotice = new VerifyNoticeView(options);

        this.sidebar = new SidebarView(options);
        this.unsupported = $('#unsupported');

        this.pastebin = new PastebinDialogView(options);
        this.fileUploads = new FileUploadDialogView(options);
        this.logDownloads = new LogDownloadDialogView(options);
        this.shortcuts = new ShortcutsDialogView(options);
        this.files = new FilesDialogView(options);
        this.pastebins = new PastebinsDialogView(options);
        this.noAuthDialog = new NoAuthDialogView(options);
        if (this.model.ent()) {
            this.joinDefault = new EnterpriseJoinView(options);
        } else {
            this.joinDefault = new JoinDefaultView(options);
            this.upgrade = new UpgradeView(options);
            this.invites = new InvitesDialogView(options);
            this.orgs = new OrgsDialogView(options);
        }
        this.addSlackView = new AddSlackView(options);

        this.memberContextMenu = new MemberContextMenuView(options);
        this.channelContextMenu = new ChannelContextMenuView(options);
        this.conversationContextMenu = new ConversationContextMenuView(options);
        this.serverLogContextMenu = new ServerLogContextMenuView(options);
        this.uploadContextMenu = new UploadContextMenuView(options);
        this.emojiContextMenu = new EmojiContextMenuView(options);
        this.nickserv = new NickservView(options);
        this.connectionToken = new ConnectionTokenView(options);

        if (window.IRCConfig.postmark_rebound_public_key) {
            this.emailBounce = new EmailBounceView(options);
        }

        this.channelSwitcher = new ChannelSwitcher(options);
        this.$el.append(this.channelSwitcher.render().el);

        this.avatarUploadDialog = new AvatarUploadDialog(options);
        this.$el.append(this.avatarUploadDialog.render().el);

        this.avatarChooser = new AvatarChooserDialog(options);
        this.$el.append(this.avatarChooser.render().el);

        this.avatarUpload = new AvatarUploadView(options);
        this.$el.append(this.avatarUpload.render().el);

        this.model.on('change:session', this.renderAuth, this);
        this.model.on('change:limits', this.renderLimits, this);
        this.model.on('change:database_status', this.renderDbDown, this);
        this.model.on('systemMessage', this.systemMessage, this);
        this.model.on('init', this.init, this);
        this.model.on('currentBufferChange', this.currentBufferChange, this);
        this.model.on('startFallback', this.startFallback, this);
        this.model.on('hashDialogHide', this.hashDialogHide, this);
        this.model.on('navigate', this.navigate, this);
        this.model.on('noAuth', this.noAuth, this);

        this.model.on('sidebarBufferClick', this.sidebarBufferClick, this);
        this.model.on('clickedMessageDate', this.messageDateClick, this);
        this.model.on('clickedMessageReactAdd', this.messageReactAddClick, this);
        this.model.on('playAlert', this.playAlert, this);
        this.model.on('exportConfirm', this.exportConfirm, this);
        this.model.on('pasteConfirm', this.pasteConfirm, this);
        this.model.on('uploadConfirm', this.uploadConfirm, this);
        this.model.on('batchUploadConfirm', this.batchUploadConfirm, this);
        this.model.on('exportFinished', this.exportFinished, this);
        this.model.on('clickUpload', this.clickUpload, this);
        this.model.on('clickEmoji', this.clickEmoji, this);

        this.model.backend.on('stream:starting', this.connecting, this);
        this.model.on('doneLoading', this.doneLoading, this);
        this.model.on('streamConnectedChange', this.streamConnectedChange, this);
        this.model.backend.on('unsupported', this.showUnsupported, this);
        this.model.backend.on('xhrFallback', this.xhrFallback, this);

        this.model.connections.on('nickServPrompt', this.showNickServ, this);
        this.model.connections.on('showConnectionToken', this.showConnectionToken, this);
        this.model.on('currentConnectionUrlChange', this.resetUrl, this);
        this.model.on('threadChange', this.resetUrl, this);
        this.model.buffers.on('scrollMessageChange', this.resetUrl, this);

        this.model.on('bufferOptions', this.bufferOptions, this);

        this.styleSheets = {};
        this.model.on('addStyleSheet', this.addStyleSheet, this);

        // accept irc: and ircs: links
        this.registerProtocolHandlers();

        this.installFirefoxApp();

        // Browser hacks/workarounds/special casing
        this.operaLayoutHack();
        this.renderCmdKey();

        // Track focused state (for setting highlights in title)
        this.trackFocusState();

        // Web Notification, fluid and macgap
        this.notifier = new IRCCloudNotifier(this.model);

        this.trackPostMessages();
    },
    events: {
        'click .bufferLink.irc': 'clickIRCLink',
        'click .bufferLink.user, .avatar': 'clickUser',
        'buttonClick .bufferLink.user, .avatar': 'clickUser',
        'click .bufferLink.channel': 'clickChannel',
        'click .bufferLink.server': 'clickServer',
        'click span.date': 'clickDate',
        'click #xhrWarning a.dismiss': 'clickXhrWarningDismiss',
        'click .log .row .reaction': 'clickReaction',
        'mouseenter .bufferLink.user, .avatar': 'hoverUser',
        'mouseleave .bufferLink.user, .avatar': 'unhoverUser',
        'dragstart': 'dragStart',
        'dragover': 'dragOver',
        'dragleave': 'dragLeave',
        'drop': 'drop'
    },
    catchAllRoute: function () {
        this.startFallback();
    },
    dragStart: function (e) {
        var target = $(e.target);
        if (target.is('a.docLink')) {
            var downloadUrl = target.find('.documentIcon').data('DownloadURL');
            e.originalEvent.dataTransfer.setData('DownloadURL', downloadUrl);
        }
    },
    dragOver: function (e) {
        e.preventDefault();
        var dt = e.originalEvent.dataTransfer;
        if (dt && _.contains(dt.types, 'Files')) {
            dt.dropEffect = 'copy';
            if (!$('#dropTargetContainer').hasClass('visible')) {
                $('#dropTargetContainer').stop().fadeIn(50).addClass('visible');
            }
        }
        if (this.dragOverTimeout) {
            clearTimeout(this.dragOverTimeout);
        }
        this.dragOverTimeout = setTimeout(_.bind(this.fadeDropTarget, this), 1000);
    },
    fadeDropTarget: function (callback) {
        if ($('#dropTargetContainer').hasClass('visible')) {
            if (this.dragOverTimeout) {
                clearTimeout(this.dragOverTimeout);
            }
            this.dragOverTimeout = null;
            $('#dropTargetContainer').stop().fadeOut(200, function () {
                $('#dropTargetContainer').removeClass('visible');
                if (callback) {
                    callback();
                }
            });
        } else {
            if (callback) {
                callback();
            }
        }
    },
    dragLeave: function (e) {
        var dt = e.originalEvent.dataTransfer;
        if (dt && _.contains(dt.types, 'Files')) {
            if (e.originalEvent.pageX <= 0
             || e.originalEvent.pageX >= window.innerWidth
             || e.originalEvent.pageY <= 0
             || e.originalEvent.pageY >= window.innerHeight) {
                this.fadeDropTarget();
            }
        }
    },
    drop: function (e) {
        e.preventDefault();
        var current = this.model.currentBuffer;
        var threadTargets = atPoint(e.clientX, e.clientY, '#threadContainer', '#bufferPanes, div.timecell');
        if (threadTargets[0]) {
            current = this.mainArea.currentThread.model;
        }
        var dt = e.originalEvent.dataTransfer;
        var files, items, entries, url;
        if (dt) {
            url = dt.getData('URL');
            files = dt.files;
            items = dt.items;
            entries = FileWrapper.getEntries(dt);
        }
        if (this.dragOverTimeout) {
            clearTimeout(this.dragOverTimeout);
        }
        this.fadeDropTarget(_.bind(function () {
            if (current) {
                var options = {
                    dropped: true
                };
                if (e.shiftKey || e.altKey) {
                    options.immediate = true;
                }
                if (files && files.length) {
                    options.files = files;
                    options.entries = entries;
                    options.items = items;
                    current.trigger('upload', options);
                } else if (url) {
                    var blob = FileWrapper.blobFromDataURI(url);
                    if (blob) {
                        options.files = [blob];
                        current.trigger('upload', options);
                    } else {
                        current.trigger('insertAtCursor', url, true);
                    }
                } else if (items) {
                    _.each(items, function (item) {
                        if (item.kind == 'string' && item.type == 'text/plain') {
                            item.getAsString(_.bind(function (value) {
                                if (value) {
                                    current.trigger('insertAtCursor', value, true);
                                }
                            }, this));
                        }
                    }, this);
                }
            }
        }, this));
    },
    addStyleSheet: function (stylesheet, callback) {
        if (!this.styleSheets[stylesheet]) {
            debug.log('add stylesheet', stylesheet);
            var link = $('<link rel="stylesheet">').attr('href', stylesheet);
            link.on('load', _.bind(function () {
                if (callback) {
                    callback();
                }
            }, this));
            $('head').append(link);
            this.styleSheets[stylesheet] = true;
        } else {
            if (callback) {
                callback();
            }
        }
    },
    clickIRCLink: function (e) {
        var link = $(e.currentTarget);
        this.navigate(link.attr('data-url'), {trigger: true});
        return false;
    },
    clickChannel: function (e) {
        var link = $(e.currentTarget);
        var connection = this.model.getConnection(link.data('cid'));
        var channel = link.attr('data-name');
        if (link.hasClass('channelInviteLink')) {
            connection.joinChannel(channel);
        } else {
            connection.openBuffer(channel);
        }
        return false;
    },
    clickServer: function (e) {
        var link = $(e.currentTarget);
        var connection = this.model.getConnection(link.data('cid'));
        connection.select();
        return false;
    },
    eventUserEl: function (e) {
        var el = $(e.currentTarget);
        if (el.hasClass('hasUserParent')) {
            return el.closest('.userParent');
        }
        return el;
    },
    clickUser: function (e, options) {
        options = options || {};
        var link = this.eventUserEl(e);
        var connection = this.model.getConnection(link.data('cid'));
        if (connection) {
            var user = this.makeUserFromLink(link, connection);
            var x = e.pageX;
            var y = e.pageY;
            if ('x' in options) {
                x = options.x;
            }
            if ('y' in options) {
                y = options.y;
            }
            this.memberContextMenu.show(user, x, y);
        }
        return false;
    },
    clickReaction: function (e) {
        var reaction = $(e.currentTarget);
        if (!reaction.data('self')) {
            var connection = this.model.getConnection(reaction.data('cid'));
            if (connection) {
                var buffer = connection.getBuffer(reaction.data('bid'));
                if (buffer) {
                    buffer.react(reaction.data('msgid'), reaction.data('reaction'));
                }
            }
        }
        return false;
    },
    clickXhrWarningDismiss: function (e) {
        e.preventDefault();
        $('#xhrWarning').slideUp({
            duration: 'fast',
            progress: _.bind(function () {
                this.mainArea.currentBufferTopChange();
            }, this),
            complete: _.bind(function () {
                this.status.renderVisible();
                this.mainArea.currentBufferTopChange();
            }, this)
        });
    },
    hoverUser: function (e) {
        var link = this.eventUserEl(e);
        if (link.data('usermask')) {
            var connection = this.model.getConnection(link.data('cid'));
            if (connection) {
                var user = this.makeUserFromLink(link, connection);
                this.mainArea.highlightCurrentUserRows(user);
            }
        }
    },
    unhoverUser: function (e) {
        this.mainArea.unhighlightCurrentUserRows();
    },
    bufferOptions: function (button, buffer, e) {
        var menu;
        if (buffer.isChannel()) {
            menu = this.channelContextMenu;
        } else if (buffer.isConversation()) {
            menu = this.conversationContextMenu;
        } else if (buffer.isServerLog()) {
            menu = this.serverLogContextMenu;
        }
        if (menu.isVisible() && buffer.equals(menu.buffer)) {
            menu.hide();
        } else {
            this.channelContextMenu.hide();
            this.conversationContextMenu.hide();
            this.serverLogContextMenu.hide();
            menu.show(buffer, button, {
                keypress: Keyboard.isClickEnter(e)
            });
        }
    },
    clickUpload: function (e, buffer) {
        var menu = this.uploadContextMenu;
        if (menu.isVisible()) {
            menu.hide();
        } else {
            var cell = $(e.currentTarget);
            menu.show(buffer, cell);
        }
    },
    clickEmoji: function (e, buffer) {
        var menu = this.emojiContextMenu;
        var cell = $(e.currentTarget);
        if (cell.is(menu.triggerEl) && menu.isVisible()) {
            menu.hide();
        } else {
            menu.show(buffer, cell);
        }

    },
    pasteConfirm: function (buffer, options, onCancel) {
        this.pastebin.show(buffer, options, onCancel);
    },
    uploadConfirm: function (fileView, buffer, options, onConfirm, onCancel) {
        this.fileUploads.showSingle(fileView, buffer, options, onConfirm, onCancel);
    },
    batchUploadConfirm: function (fileTreeView, buffer, options, onConfirm, onCancel) {
        this.fileUploads.showBatch(fileTreeView, buffer, options, onConfirm, onCancel);
    },
    exportConfirm: function (model) {
        this.logDownloads.show(model);
        return false;
    },
    exportFinished: function (message) {
        if (!this.logDownloads.isVisible()) {
            this.mainArea.renderCurrentOverlay(this.logDownloads.finishedOverlay(message));
        }
    },
    trackFocusState: function () {
        $(window).blur(this.windowBlur);
        $(window).focus(this.windowFocus);
        if ('hasFocus' in document) {
            this.model.setFocused(document.hasFocus());
        } else {
            $(window).on('click mousemove keydown keypress', this.initialWindowFocus);
        }
    },
    trackPostMessages: function () {
        $(window).on('message', _.bind(function (e) {
            this.model.addPostMessage(e.originalEvent);
            this.trigger('postMessage', e.originalEvent);
        }, this));
    },
    registerProtocolHandlers: function () {
        if (window.navigator.registerProtocolHandler) {
            try {
                window.navigator.registerProtocolHandler('irc', '/?/irc_url=%s', 'IRCCloud');
                window.navigator.registerProtocolHandler('ircs', '/?/irc_url=%s', 'IRCCloud');
            } catch (e) {
                // Browser can throw a security error if the protocol isn't allowed
            }
        }
    },
    installFirefoxApp: function () {
        if (this.model.featureCheck('mozApps') && window.navigator.mozApps) {
            // TODO check if already installed
            // TODO check if already prompted
            // https://developer.mozilla.org/en-US/docs/Web/API/Apps.checkInstalled
            try {
                var request = window.navigator.mozApps.install(this.model.getOrigin() + '/manifest.webapp');
                request.onsuccess = function () {
                    debug.log('mozApps install success', this);
                };
                request.onerror = function () {
                    debug.warn('mozApps install error', this.error.name, this.error.message);
                };
            } catch (e) {
                debug.warn('mozApps install exception', e);
            }
        }
    },
    operaLayoutHack: function () {
        if ($.browser.opera) {
            $(this.el).css('overflow', 'visible');
        }
    },
    renderCmdKey: function () {
        $('.kbd__cmd').text(Keyboard.modifierName()).attr('aria-label', Keyboard.modifierLabel());
    },
    sidebarBufferClick: function (buffer) {
        if (buffer.hasUnseenHighlights()) {
            IRCCloudNotifier.requestPermission(_.bind(function (permission) {
                this.trigger('notificationPermissionRequested', permission);
            }, this));
        }
    },
    messageDateClick: function (message) {
        this.lastClickedMessage = message;
        if (this.lastClickedMessage) {
            debug.info(
                'Clicked row: [' +
                this.lastClickedMessage.get('type') +
                '] ' + this.lastClickedMessage.id
            );
        }
    },
    messageReactAddClick: function (message, el) {
        if (message.isReactable()) {
            this.emojiContextMenu.show(message.buffer, el, {
                action: 'reactMessageEmoji',
                actionData: {
                    message: message
                },
                reaction: true
            });
        }
    },
    notify: function (buffer, options) {
        if (!window.CHROME_EXTENSION) {
            this.playAlert();
            this.notifier.notify(options);
        }
    },
    sounds: {},
    setupAudio: function (onReady) {
        if (!this.audioSetup) {
            this.sounds.alert = $('<audio>')
                .append($('<source>').attr({
                    src: '/static/digit.mp3',
                    type: "audio/mpeg"
                }))
                .append($('<source>').attr({
                    src: '/static/digit.ogg',
                    type: 'audio/ogg'
                }))[0];
            this.audioSetup = true;
        }
        if (onReady) {
            onReady();
        }
    },
    play: function (sound, force) {
        if (force || this.alertsEnabled()) {
            this.setupAudio(_.bind(function () {
                this.sounds[sound].play();
            }, this));
        }
    },
    playAlert: function (force) {
        this.play('alert', force);
    },
    alertsEnabled: function () {
        return !this.model.getPref('notifications-disableaudio');
    },
    renderPrefs: function () {
        $(this.el).toggleClass('time-12hr', !this.model.getPref('time-24hr'));
        $(this.el).toggleClass('time-24hr', !!this.model.getPref('time-24hr'));
        $(this.el).toggleClass('time-seconds', !!this.model.getPref('time-seconds'));
        $(this.el).toggleClass('time-noseconds', !this.model.getPref('time-seconds'));
        this.mainArea.timeLayoutChange();
        $(this.el).toggleClass('mode-hidesymbol', !this.model.getPref('mode-showsymbol'));
        $(this.el).toggleClass('nick-colors', !!this.model.getPref('nick-colors'));
        $(this.el).toggleClass('mention-colors', !!this.model.getPref('mention-colors'));
        $(this.el).toggleClass('ascii-compact', !!this.model.getPref('ascii-compact'));
        $(this.el).toggleClass('emoji-convert', !this.model.getPref('emoji-disableconvert'));
        $(this.el).toggleClass('emoji-disableconvert', !!this.model.getPref('emoji-disableconvert'));
        $(this.el).toggleClass('emoji-big', !this.model.getPref('emoji-nobig'));
        this.renderValentine();
        if (this.alertsEnabled()) {
            this.setupAudio();
        }
        this.mainArea.currentBufferTopChange();
    },
    renderedTheme: null,
    renderTheme: function () {
        if (this.renderedTheme) {
            this.$el.removeClass('theme-' + this.renderedTheme);
        }
        this.$el.removeClass('themeShade-light');
        this.$el.removeClass('themeShade-dark');
        var theme = this.model.getTheme();
        this.$el.addClass('theme-' + theme);
        this.renderedTheme = theme;
        if (this.model.isLightTheme()) {
            this.$el.addClass('themeShade-light');
            $('#twitterMetaTheme').attr('content', '');
        } else {
            this.$el.addClass('themeShade-dark');
            $('#twitterMetaTheme').attr('content', 'dark');
        }
    },
    renderFont: function (prevFont) {
        if (prevFont) {
            this.$el.removeClass('font-' + prevFont);
        }
        this.$el.addClass('font-' + this.model.getFont());
    },
    renderDates: function () {
        $('.messageRow').each(function () {
            var row = $(this);
            var date = new Date(row.data('time'));
            var dateSpan = row.find('span.date .timestamp');
            dateSpan.attr('title', date.formatFullDate()).text(date.formatTime());
        });
    },
    renderLayoutLeft: function () {
        $(this.el).toggleClass('left', !!this.model.getPref('layout-left'));
    },
    renderValentine: function () {
        var toggle;
        var today = new Date();
        if (today.getDate() == 14 && today.getMonth() == 1) {
            toggle = true;
        } else {
            toggle = !!this.model.getPref('valentine');
        }
        $(this.el).toggleClass('valentine', toggle);
    },
    showNickServ: function (connection) {
        this.nickserv.show(connection);
    },
    showConnectionToken: function (connection) {
        this.connectionToken.show(connection);
    },
    showOrgSignup: function (inviteKey, email, orgName) {
        if (this.model.isAuthed()) {
            this.orgs.showJoin(inviteKey, orgName);
        } else {
            this.noAuthDialog.fillOrgSignup(inviteKey, email, orgName);
        }
    },
    xhrFallback: function () {
        $(this.el).addClass('xhr');
        if (!this.model.featureCheck('websockets')) {
            $(this.el).addClass('xhrOnly');
        }
    },
    renderDbDown: function () {
        $(this.el).toggleClass('dbDown', this.model.isDbDown());
        this.status.renderVisible();
    },
    showUnsupported: function () {
        this.unsupported.fadeIn('fast');
    },
    initialWindowFocus: function (e) {
        // Force focus on initial mouse/key action
        if (e.type == 'mousemove' && e.pageX === 0 && e.pageY === 0) {
            // Erroneous initial mousemove
            return;
        }
        $(window).off('click mousemove keydown keypress', this.initialWindowFocus);
        this.model.setFocused(true);
    },
    makeUserFromLink: function (link, connection) {
        var buffer = connection.getBuffer(link.attr('data-bid'));
        if (buffer) {
            var message = buffer.getMessage(link.attr('data-eid'));
            if (message) {
                return message.makeUser(link.attr('data-name'));
            }
        }
        var data = link[0].dataset;
        var user = connection.makeUserFromTarget(
            data.bid,
            _.extend({}, data, {
                nick: data.name,
                hostmask: data.usermask,
                from_name: data.user,
                from_host: data.userhost,
                from_mode: data.mode,
                from_account: data.account,
                from_realname: data.realname
            })
        );
        return user;
    },
    navigate: function (url, options) {
        if (url.indexOf('/irc/') === 0 && this.model.threadId) {
            url += '/thread/' + encodeURIComponent(this.model.threadId);
        }
        this.router.navigate(url, options);
    },
    noAuth: function () {
        this.start();
        this.currentBufferChange();
    },
    hashDialogHide: function () {
        if (!this.model.isAuthed()) {
            this.model.back();
            this.noAuthDialog.show();
            return;
        } else {
            this.currentBufferChange();
        }
    },
    resetUrl: function () {
        this.navigate(this.model.currentBuffer.url(), {replace: true});
    },
    currentBufferChange: function (options) {
        options = options || {};
        if (!this.model.isAuthed()) {
            this.noAuthDialog.show();
            return;
        }
        this.hideContextMenus();

        if (this.model.currentBuffer) {
            // Make sure addNetwork is hidden
            HashDialogView.closeCurrent();
            this.hideJoinDefault();
            this.hideAddNetwork();
            this.hideSettings({silent: true});
            try {
                this.navigate(this.model.currentBuffer.url(), {replace: !!options.replace});
            } catch (exc) {
                // pass this can error
                debug.warn('navigation failed', this.model.currentBuffer.url(), exc);
            }
        } else if (options.cleared || !this.selectLastSelectedBuffer()) {
            this.model.clearCurrentBuffer(true); // silent so we don't end up in a loop
            if (this.model.ent() && !this.model.hasConnections() && this.model.hasAutojoin()) {
                this.navigate('?/join');
                this.showJoinDefault();
            } else {
                this.navigate('?/addNetwork');
                this.showAddNetwork();
            }
        }
    },
    start: function () {
        if (this.started) {
            return Backbone.history.loadUrl();
        }

        if (!this.model.ent()) {
            this.router.route('?/team-invite=:key&email=:email&team=*name', 'showOrgSignup', this.showOrgSignup);
        }

        this.started = true;

        var pushState = true;
        if (this.model.featureCheck('disablePushState')) {
            pushState = false;
        }
        return Backbone.history.start({pushState: pushState});
    },
    init: function () {
        this.renderTheme();
        this.renderFont();
        this.renderPrefs();
        this.renderAuth();
        this.renderDbDown();
        this.model.bind('prefChange', this.renderPrefs, this);
        this.model.bind('featureChange', this.renderPrefs, this);
        this.model.bind('notify', this.notify, this);

        this.router.route('?/addNetwork', 'addNetwork', this.addNetwork);
        if (this.model.ent()) {
            this.router.route('?/join', 'joinEnterprise', this.joinEnterprise);
        } else {
            this.router.route('?/feedback', 'feedback', this.feedback);
        }
        this.router.route('?/settings', 'openSettings', this.openSettings);
        this.router.route('?/settings=*section', 'openSettings', this.openSettings);

        this.start();
    },
    startFallback: function () {
        // No route detected, select the last_selected_bid
        if (!this.selectLastSelectedBuffer()) {
            this.currentBufferChange();
        }
    },
    selectLastSelectedBuffer: function () {
        var buffer = this.model.getLastSelectedBuffer();
        if (buffer) {
            buffer.select();
            return true;
        }
        return false;
    },
    connecting: function () {
        $(this.el).addClass('connecting');
    },
    streamConnectedChange: function () {
        if (this.model.isStreamConnected()) {
            this.mainArea.showBuffers();
            $(this.el).removeClass('connecting');
            $(this.el).removeClass('disconnected');
            $(this.el).addClass('loading');
        } else if (!this.model.backend.unloading) {
            $(this.el).removeClass('connecting');
        }
    },
    doneLoading: function () {
        $(this.el).removeClass('loading');
    },

    systemMessage: function (message) {
        var msg = message.msg;
        if (message.system_message_type == 'refresh') {
            msg = $('<span>');
            msg.append("IRCCloud has been updated. ");
            msg.append($('<a href="#">').text('Refresh the page').click(function (e) {
                window.location.reload();
            }));
            msg.append(" to get the latest version.");
        }
        var content = $('<p>').append(msg);
        var head;
        if (message.time && message.time > 0) {
            var date = new Date(message.time * 1000);
            head = date.formatFullDate();
        }
        var overlay = new Overlay(content, {
            doneText: 'Close',
            message: message,
            head: head
        });
        this.mainArea.renderCurrentOverlay(overlay);
    },
    renderAuth: function () {
        $(this.el).toggleClass('authed', this.model.isAuthed());
        if (this.model.isInitialized()) {
            $(this.el).addClass('init');
        }
    },
    renderLimits: function () {
        $(this.el).toggleClass(
            'passwordedServersAllowed',
            this.model.arePasswordedServersAllowed()
        );
    },
    windowBlur: function (e) {
        this.model.setFocused(false);
    },
    windowFocus: function (e) {
        this.model.setFocused(true);
    },
    ircUrl: function (ircUrl, options) {
        options = options || {};
        var navOpts = {};
        if (options.replace !== false) {
            navOpts.replace = true;
        }
        navOpts.trigger = true;
        var parts = util.ircUrlParts(decodeURIComponent(ircUrl));
        if (parts) {
            this.navigate('irc/' + parts.url, navOpts);
        } else {
            this.currentBufferChange();
        }
    },
    hideContextMenus: function () {
        this.memberContextMenu.hide();
        this.emojiContextMenu.hide();
        this.channelContextMenu.hide();
        this.conversationContextMenu.hide();
        this.serverLogContextMenu.hide();
    },
    clearForNonBufferUrl: function () {
        this.hideContextMenus();
        this.model.clearCurrentBuffer(true); // silent so we don't change the url
        this.mainArea.clearCurrent();
    },
    joinEnterprise: function () {
        this.clearForNonBufferUrl();
        this.showJoinDefault();
    },
    openSettings: function (section) {
        if (!section) {
            section = this.mainArea.settings.defaultSection;
            this.router.navigate('?/settings=' + section, {replace: true});
        }
        this.showSettings(section);
    },
    feedback: function () {
        var found, lastC;
        var channelName = '#feedback';
        _.each(this.model.connections.where({'hostname': 'irc.irccloud.com'}), _.bind(function (c) {
            var buffer = c.findChannel(channelName);
            if (buffer) {
                found = true;
                this.navigate(buffer.url(), {replace: true});
                c.joinChannel(channelName);
            }
            lastC = c;
        }, this));
        if (!found) {
            if (lastC) {
                var b = lastC.openBuffer(channelName);
                this.navigate(b.url(), {replace: true});
                lastC.joinChannel(channelName);
            } else {
                this.clearForNonBufferUrl();
                this.showJoinDefault();
            }
        }
    },
    addNetwork: function (networkId) {
        this.clearForNonBufferUrl();
        this.showAddNetwork(util.getBufferParts(networkId));
    },
    selectBufferByUrlWithText: function (text, networkId) {
        var buffer = this.selectBufferByUrl(networkId, true);
        if (buffer && buffer.bid()) {
            buffer.trigger('setInputText', text);
        }
    },
    selectBufferByUrl: function (networkId, forceNavigate) {
        if (this.model.isAuthed()) {
            var bufferParts = util.getBufferParts(networkId);
            var connection;
            if (bufferParts) {
                this.model.setThreadId(bufferParts.thread, {silent: true});
                // Lookup the connection in our fuzzy map
                connection = this.model.getConnectionById(bufferParts.connectionId) || this.model.getConnectionById(bufferParts.hostname);
            }
            if (!connection || !bufferParts.buffer) {
                var legacyBufferParts = util.getBufferPartsLegacy(
                    networkId, Backbone.history.getHash()
                );
                if (legacyBufferParts) {
                    bufferParts = legacyBufferParts;
                    // Lookup the connection in our fuzzy map
                    connection = this.model.getConnectionById(bufferParts.connectionId) || this.model.getConnectionById(bufferParts.hostname);
                }
            }
            if (connection) {
                var buffer;
                var newBuffer;
                if (bufferParts.buffer) {
                    var bufferName = bufferParts.buffer;
                    if (
                        bufferParts.type == 'channel' &&
                        !connection.isChannelName(bufferName)
                    ) {
                        bufferName = '#' + bufferName;
                    }
                    buffer = connection.findBuffer(bufferName);
                    if (!buffer) {
                        newBuffer = bufferName;
                        buffer = connection.serverLog;
                    }
                } else {
                    buffer = connection.serverLog;
                }
                if (buffer) {
                    HashDialogView.closeCurrent();
                    buffer.select({replace: true});
                }
                if (newBuffer) {
                    buffer = connection.openNewBuffer(newBuffer);
                }
                if (buffer && (forceNavigate || (buffer.urlId() != networkId) || this.model.threadId)) {
                    this.navigate(buffer.url(), {replace: true});
                }
                return buffer;
            } else {
                this.hideContextMenus();
                this.navigate('?/addNetwork', {replace: true});
                this.showAddNetwork(bufferParts);
                this.model.clearCurrentBuffer();
            }
        }
    },
    showJoinDefault: function () {
        HashDialogView.closeCurrent();
        this.hideAddNetwork();
        this.hideSettings({silent: true});
        this.joinDefault.show();
    },
    hideJoinDefault: function () {
        this.joinDefault.hide();
    },
    showAddNetwork: function (bufferParts) {
        HashDialogView.closeCurrent();
        this.hideJoinDefault();
        this.hideSettings({silent: true});
        this.mainArea.addNetwork.show(bufferParts);
    },
    hideAddNetwork: function () {
        this.mainArea.addNetwork.hide();
    },
    showSettings: function (section) {
        HashDialogView.closeCurrent();
        this.clearForNonBufferUrl();
        this.hideJoinDefault();
        this.hideAddNetwork();
        this.mainArea.settings.show(section);
    },
    hideSettings: function (options) {
        this.mainArea.settings.hide(options);
    }
});

module.exports = SessionView;


/***/ }),

/***/ "z+V+":
/***/ (function(module, exports, __webpack_require__) {

var BufferPromptHandler = __webpack_require__("JGoS");


var ChannelPromptHandler = BufferPromptHandler.extend({
    bindMessageHandlers: function (options) {
        BufferPromptHandler.prototype.bindMessageHandlers.call(this, options);
        this.model.bind('topicPrompt', this.topicPrompt, this);
        this.model.bind('invitePrompt', this.invitePrompt, this);
        this.model.bind('banPrompt', this.banPrompt, this);
        this.model.bind('kickPrompt', this.kickPrompt, this);
        this.model.bind('renamePrompt', this.renamePrompt, this);
        this.model.bind('renameError', this.renameError, this);
        this.model.bind('deleteConfirm', this.deleteConfirm, this);
    },
    topicPromptText: function (topicLen) {
        var promptText = 'Set the topic for ' + this.model.getDisplayName();
        if (topicLen || topicLen === 0) {
            var s = Math.abs(topicLen) === 1 ? '' : 's';
            promptText += ' (' + topicLen + ' char' + s + ')';
        }
        return promptText;
    },
    topicText: function (text) {
        if (this.model.connection.isSlack()) {
            var prevEmojiTextMode = emoji.text_mode;
            emoji.text_mode = true;
            text = this.formatter.renderEmoji(text);
            emoji.text_mode = prevEmojiTextMode;
            return text;
        } else {
            return text;
        }
    },
    topicPrompt: function (callback) {
        var topicLen = this.model.connection.getISupport('TOPICLEN');
        var topicText = this.model.getTopic().getText();
        var currentTopicLen = topicLen;
        if (topicText) {
            currentTopicLen -= this.topicText(topicText).length;
        }
        var promptText = this.topicPromptText(currentTopicLen);
        var overlay = this.prompt(promptText, _.bind(function (topic) {
            this.model.updateTopic(topic);
            if (callback) {
                callback();
            }
        }, this), topicText, {
            onPromptKey: _.bind(function (e, input, textContainer) {
                textContainer.html(this.formatter.render(this.topicPromptText(topicLen - this.topicText(input.val()).length)));
            }, this)
        });
        overlay.className = 'channel_topic_prompt';
        this.triggerAdd(overlay);
    },
    invitePrompt: function (callback) {
        var badgesUrl = '/badges?' + $.param({
            hostname: this.model.connection.getHostname(),
            port: this.model.connection.getPort(),
            channel: this.model.getName(),
            ssl: this.model.connection.isSSL() ? '1': ''
        });
        var badgesLink = $('<a target="_blank">').attr('href', badgesUrl).text('links and badges');
        var promptHtml = $('<div>')
            .append($('<p>')
                .text("Invite someone to join " + this.model.getDisplayName() + '. To send an invite outside of IRC, try our ')
                .append(badgesLink));
        var overlay = this.htmlConfirm(promptHtml, _.bind(function (nick) {
            var user = this.model.connection.makeUserFromTarget(undefined, {
                nick: nick
            });
            user.invite(this.model.getName());
            if (callback) {
                callback();
            }
        }, this), {
            prompt: true,
            promptHint: 'Nickname'
        });
        overlay.className = 'channel_invite_prompt';
        this.triggerAdd(overlay);
    },
    banPrompt: function (user, callback) {
        var banmask = user.getBanMask(true);
        var overlay = this.prompt("Add a banmask for " + user.getDisplayName(), _.bind(function (newBanmask) {
            this.model.ban(newBanmask);
            if (callback) {
                callback();
            }
        }, this), banmask);
        overlay.className = 'channel_ban_prompt';
        this.triggerAdd(overlay);
    },
    kickPrompt: function (user, callback) {
        var overlay = this.prompt("Give a reason for kicking", _.bind(function (reason) {
            this.model.kick(user, reason);
            if (callback) {
                callback();
            }
        }, this));
        overlay.className = 'channel_kick_prompt';
        this.triggerAdd(overlay);
    },
    renameError: function (newName, response, callback) {
        var msg = '';
        switch (response.message) {
        case 'invalid_name':
            msg = 'You must choose a valid channel name';
            break;
        case 'not_channel':
            msg = 'You can only rename channels';
            break;
        case 'name_exists':
            msg = 'That name is already taken';
            break;
        case 'channel_joined':
            msg = 'You can only rename parted channels';
            break;
        default:
            msg = 'Error renaming: ' + response.message;
        }
        this.renamePrompt(newName, callback, msg);
    },
    renamePrompt: function (promptName, callback, error) {
        var promptText = "Choose a new name for this channel";
        var overlay = this.prompt(promptText, _.bind(function (newName) {
            this.model.rename(newName, callback);
        }, this), promptName, {
            error: error,
            keepFocus: false
        });
        overlay.className = 'channel_rename_prompt';
        this.triggerAdd(overlay);
    },
    deleteConfirm: function (callback) {
        var confirmText = "Are you sure you want to delete your history for " + this.model.getDisplayName();
        var overlay = this.confirm(confirmText, _.bind(function () {
            this.model.remove();
            if (callback) {
                callback();
            }
        }, this), {
            confirmClass: 'delete'
        });
        overlay.className = 'channel_delete_confirm';
        this.triggerAdd(overlay);
    }
});


module.exports = ChannelPromptHandler;


/***/ }),

/***/ "zICk":
/***/ (function(module, exports, __webpack_require__) {

var BufferList = __webpack_require__("o4N7");
var util = __webpack_require__("GmLC");


var OrderedBufferList = BufferList.extend({
    comparator: function (bufferA, bufferB) {
        return util.naturalCompare(
            bufferA.normaliseDisplay(),
            bufferB.normaliseDisplay()
        );
    }
});


module.exports = OrderedBufferList;


/***/ }),

/***/ "zeA3":
/***/ (function(module, exports, __webpack_require__) {

var BufferFormatter = __webpack_require__("gfb+");
var ContextMenuView = __webpack_require__("hI2d");
var Formatter = __webpack_require__("5gSh");
var twitch = __webpack_require__("/7tV");


var MemberContextMenuView = ContextMenuView.extend({
    el: '#memberContextMenu',
    initialize: function (options) {
        _.bindAll(this, 'focusMessage');
        
        ContextMenuView.prototype.initialize.call(this, options);
        
        this.title = this.$('h3.title');
        this.realname = this.$('.realname');
        this.status = this.$('.status');
        this.pronouns = this.$('.pronouns');
        this.bot = this.$('.bot');
        this.account = this.$('.account');
        this.away = this.$('.away');
        this.form = this.$('form.messageForm');
        this.message = this.$('input.message');
        this.hostmask = this.$('.hostmask');
        this.admin = this.$('.admin');
        this.twitchLink = this.$('.twitchLink');
        this.slackLink = this.$('.slackLink');
        this.server = this.$('.server');
        this.modActions = this.$('.modAction');
        this.whois = this.$('.whois');
        this.invite = this.$('.invite');
        this.relayBotEnable = this.$('.relayBotEnable');
        this.relayBotDisable = this.$('.relayBotDisable');
        this.opMember = this.$('.opMember');
        this.deopMember = this.$('.deopMember');
        this.voiceMember = this.$('.voiceMember');
        this.devoiceMember = this.$('.devoiceMember');
        this.kickMember = this.$('.kickMember');
        this.actions = this.$('.actions');
    },
    events: $.extend({}, ContextMenuView.prototype.events, {
        'submit form': 'submitForm',
        'click h3.title a': 'clickOpen',
        'click .memberContextMenu__titleLink': 'clickOpen',
        'buttonClick button.open': 'clickOpen',
        'buttonClick button.whois': 'clickWhois',
        'buttonClick button.invite': 'clickInvite',
        'buttonClick button.ignore': 'clickIgnore',
        'buttonClick button.relayBotEnable': 'clickRelayBotEnable',
        'buttonClick button.relayBotDisable': 'clickRelayBotDisable',
        'buttonClick button.kick': 'clickKick',
        'buttonClick button.op': 'clickOp',
        'buttonClick button.deop': 'clickDeop',
        'buttonClick button.voice': 'clickVoice',
        'buttonClick button.devoice': 'clickDevoice',
        'buttonClick button.ban': 'clickBan'
    }),
    clearContext: function () {
        this.formatter = null;
        this.user = null;
        this.resolved = null;
        this.member = null;
        this.message.val('');
        this.title.empty();
        this.realname.empty();
        this.status.empty();
        this.pronouns.empty();
        this.bot.empty();
        this.account.empty();
        this.account.removeClass('authed');
        this.$el.removeClass(
            'avatars-on avatars-image-on avatars-image-off avatars-noexternal avatars-external'
        );
        this.hostmask.empty();
        this.away.empty();
        this.admin.empty();
        this.twitchLink.empty();
        this.slackLink.empty();
        this.server.empty();
        this.actions.hide();
        this.modActions.hide();
        this.whois.hide();
        this.invite.hide();
        this.relayBotEnable.hide();
        this.relayBotDisable.hide();
        this.opMember.hide();
        this.deopMember.hide();
        this.voiceMember.hide();
        this.devoiceMember.hide();
        this.kickMember.hide();
    },
    getModeString: function () {
        var modeString = '';
        
        if (this.member) {
            var originalMode = this.user.getMode();
            var originalHost = this.user.getHostMask();
            var memberMode = this.member.getMode();
            var modeChange;
            if (this.user.message && (
                (!originalMode && memberMode)
             || (originalMode && !memberMode)
             || (originalMode != memberMode)
            )) {
                modeChange = true;
            }
            
            // Clicked user mode differs from member mode
            if (originalMode || modeChange) {
                modeString += this.user.getModeTitle();
            }
            if (modeChange) {
                // Clicked user mode differs from member mode
                modeString += ' → ';
            }
            
            // Resolved user mode
            if (modeChange || (memberMode && !originalHost && !originalMode)) {
                if (memberMode) {
                    modeString += this.member.getModeTitle();
                } else {
                    modeString += 'demoted';
                }
            }
        }
        return modeString;
    },
    resolveUser: function (user) {
        this.user = user;
        this.resolved = this.user;
        this.buffer = this.user.buffer || this.model.currentBuffer;
        if (this.buffer && this.buffer.isChannel()) {
            this.member = this.buffer.getMember(this.user.getName());
            var originalHostmask = this.user.getHostMask();
            if (this.member) {
                // Check member host
                if (this.buffer.connection.hasMeaningfulHostnames()) {
                    var memberHost = this.member.getHostMask();
                    if (originalHostmask && memberHost && memberHost != originalHostmask) {
                        // hosts don't match, this message is not from the matching nick member
                        this.member = null;
                    } else if (memberHost) {
                        this.resolved = this.member;
                    }
                } else if (this.member && !this.resolved.message) {
                    this.resolved = this.member;
                }
            }
            
            // If no member matches the same nick they might have left or changed nick
            if (!this.member && originalHostmask) {
                this.member = this.buffer.getMemberByUsermask(originalHostmask);
                if (this.member) {
                    // There's a member with this hostmask, they must have changed nick
                    this.resolved = this.member;
                }
            }
        }
    },
    show: function (user, x, y) {
        this.clearContext();
        
        this.message.val('');
        
        this.resolveUser(user);
        
        if (this.buffer) {
            this.formatter = new BufferFormatter(this.buffer);
        } else {
            this.formatter = new Formatter();
        }
        
        // Nickchange
        var nick = this.resolved.getName();
        var originalNick = this.user.getName();
        if (nick.toLowerCase() != originalNick.toLowerCase()) {
            this.title.text(originalNick + ' → ');
        }
        
        var titleLinkOpts = {className: 'memberContextMenu__titleLink', name: nick};
        var titleLink;
        var isRelayMsg = false;
        var relayMsgParts;
        var displayAuthor = this.resolved.getDisplayAuthor();
        if (displayAuthor) {
            titleLinkOpts.name = displayAuthor;
        }
        var isBot, isRelayBot, isRelayBotMatch;
        var userMessage = this.resolved.message || this.user.message;
        if (userMessage) {
            isBot = userMessage.isBot();
            isRelayBotMatch = userMessage.matchRelayBot();
            isRelayBot = userMessage.isRelayBot();
            displayAuthor = userMessage.getDisplayAuthor();
            if (displayAuthor) {
                relayMsgParts = userMessage.relayMsgParts(displayAuthor);
                displayAuthor = relayMsgParts.nick;
                var userDisplayName = userMessage.getUserDisplayName() ||
                    userMessage.getNick();
                var messageDisplayName = userMessage.getMessageDisplayName();
                if (messageDisplayName && messageDisplayName != userDisplayName) {
                    titleLinkOpts.suffix = ' (' + userDisplayName + ')';
                }
            } else {
                relayMsgParts = userMessage.relayMsgParts(
                    this.resolved.getDisplayAuthor() || nick
                );
                displayAuthor = relayMsgParts.nick;
            }
            if (relayMsgParts.relay) {
                isRelayMsg = true;
            }
            titleLinkOpts.name = relayMsgParts.nick;
            var twitchTags = userMessage.getTwitchTags();
            if (twitchTags) {
                titleLinkOpts.title = '';
                titleLinkOpts.prefix = this.formatter.renderTwitchBadges(userMessage);
            }
        }
        if (this.resolved.connection.isTwitch()) {
            this.twitchLink.html($('<a target="_blank">').attr('href', this.resolved.getTwitchUrl()).text('Twitch profile').prepend('<i class="fa fa-twitch">'));
        }

        var botUrl = this.resolved.get('bot_url');
        if (relayMsgParts && relayMsgParts.relay) {
            var botHtml = 'Relayed by:&nbsp;' + this.formatter.escapeText(relayMsgParts.relay);
            if (relayMsgParts && relayMsgParts.server) {
                botHtml += '<br>Relayed from:&nbsp;' + this.formatter.escapeText(relayMsgParts.server);
            }
            this.bot.html(botHtml);
        } else if (botUrl) {
            // Sanitise link
            var cleanLink = this.formatter.linker.makeLinkFromUrl(botUrl);
            if (!cleanLink) {
                cleanLink = this.formatter.escapeText(botUrl);
            }

            this.bot.html('Bot:&nbsp;' + cleanLink);
        } else if (isRelayBot) {
            this.bot.html('Relay Bot');
        } else if (isBot) {
            this.bot.html('Bot');
        }

        var slackBot = false;
        if (this.resolved.connection.isSlack()) {
            titleLinkOpts.title = '';
            if (botUrl || isBot) {
                slackBot = true;
            } else {
                this.slackLink.html($('<a target="_blank">').attr('href', this.resolved.getSlackUrl()).text('Slack profile').prepend('<i class="fa fa-slack">'));
            }
        }
        if (this.member) {
            // Include mode if it's a member
            titleLink = this.formatter.linkUserMode(this.member, titleLinkOpts);
        } else {
            titleLink = this.formatter.linkUser(this.resolved, titleLinkOpts);
        }
        this.title.append(titleLink);
        twitch.loadBadges(this.model, this.buffer.normalise(), this.title);
        
        // Mode
        var modeString = this.getModeString();
        if (modeString) {
            this.title.append(' (' + this.formatter.escapeText(modeString) + ')');
        }
        
        this.$el.addClass('avatars-on');
        if ((this.buffer || this.model).imageAvatarsEnabled()) {
            this.$el.addClass('avatars-image-on');
        } else {
            this.$el.addClass('avatars-image-off');
        }
        if ((this.buffer || this.model).embedExternalAvatars()) {
            this.$el.addClass('avatars-external');
        } else {
            this.$el.addClass('avatars-noexternal');
        }
        this.title.prepend(this.avatar());

        if (this.resolved.connection.hasMeaningfulHostnames()) {
            if (
                this.buffer &&
                this.buffer.isChannel() &&
                this.buffer.userMember &&
                !isRelayMsg &&
                !this.member
            ) {
                // There's no member with this hostmask or nick, and we're still in it they must have parted the channel
                this.title.append(' → left');
            }
            this.whois.show();
            this.invite.show();
            var hostmask = this.resolved.getHostMask();
            if (hostmask) {
                this.hostmask.html(this.formatter.renderNoEmoji(hostmask));
            }
        }

        if (isRelayBot) {
            this.relayBotDisable.show();
        } else if (isRelayBotMatch) {
            this.relayBotEnable.show();
        }
        
        if (this.model.isAdmin()) {
            var uid = this.resolved.irccloudUid() || (this.member ? this.member.irccloudUid() : null);
            if (uid) {
                this.admin.html($('<a target="_blank">').attr('href', this.model.getOrigin() + '/$/user/' + encodeURIComponent(uid)).text('User: ' + uid));
            }
        }
        
        var away = this.resolved.getAway();
        if (away) {
            var awayMsg = '<small>Away';
            if (away !== true && away.toLowerCase() != 'away') {
                awayMsg += ': ' + this.formatter.renderLinkify(away);
            }
            awayMsg += '</small>';
            this.away.html(awayMsg);
        }
        
        var realname = this.resolved.getRealname();
        if (realname) {
            this.realname.html(this.formatter.renderLinkify(realname));
        }

        var pronouns = this.resolved.getPronouns();
        if (pronouns) {
            this.pronouns.html('Pronouns: ' + this.formatter.renderLinkify(pronouns));
        }

        var status = this.resolved.getStatusText();
        if (status) {
            this.status.html('Status: ' + this.formatter.renderLinkify(status));
        }

        var account = this.resolved.get('account');
        if (!slackBot && account && account != '*') {
            this.account.addClass('authed');
            this.account.html('Logged in as: <b>' + this.formatter.renderLinkify(account) + '</b>');
        }
        
        var server = this.resolved.get('ircserver');
        if (server) {
            this.server.text('(' + server + ')');
        }
        
        if (this.buffer && this.buffer.isChannel()) {
            // Mod actions
            if (this.buffer.userMember) {
                if (this.member && this.buffer.userMember.canOp()) {
                    if (this.member.canOp()) {
                        this.deopMember.show();
                    } else {
                        this.opMember.show();
                    }
                }
                if (this.buffer.userMember.isMod()) {
                    this.modActions.show();
                    // Kick
                    if (this.member) {
                        this.kickMember.show();
                        if (this.member.isVoiced()) {
                            this.devoiceMember.show();
                        } else {
                            this.voiceMember.show();
                        }
                    }
                }
            }
        }
        
        this.actions.show();
        
        ContextMenuView.prototype.show.call(this, x + 1, y - 5);
    },
    avatar: function () {
        var img = $();
        if ((this.buffer || this.model).avatarsEnabled()) {
            var nick = this.resolved.getName();
            var avatar;
            if ((this.buffer || this.model).imageAvatarsEnabled()) {
                avatar = this.resolved.getAvatar();
                // TODO overlay message avatar on user avatar
                if (!avatar && this.resolved.message) {
                    var messageAvatar = this.resolved.message.getAvatar();
                    if (messageAvatar) {
                        avatar = messageAvatar;
                    }
                }
            }
            var external = false;
            if (avatar) {
                external = avatar.external;
                img = img.add(this.formatter.imageAvatar(avatar.src, this.resolved.isSelf(), {
                    size: 512,
                    no2x: true,
                    external: external
                }));
            } else if (this.resolved.connection.isTwitch()) {
                avatar = true;
                var idx = this.formatter.getNickColorIndex(nick, {
                    length: twitch.numDefaultAvatars()
                });
                var twitchAvatar = $(this.formatter.imageAvatar(twitch.defaultAvatar({idx: idx}), this.resolved.isSelf(), {
                    size: 300,
                    external: true
                }));
                img = img.add(twitchAvatar);
                twitch.channelsToInfo(
                    this.model, [nick]
                ).then(_.bind(function (channelInfo) {
                    if (channelInfo && channelInfo[nick]) {
                        var logoSrc = channelInfo[nick].logo.replace('300x300.', '{size}x{size}.');
                        var newTwitchAvatar = $(this.formatter.imageAvatar(logoSrc, this.resolved.isSelf(), {
                            size: 300,
                            external: true
                        }));
                        twitchAvatar.replaceWith(newTwitchAvatar);
                    }
                }, this));
            }

            var avatarColor;
            if (this.resolved.message) {
                var twitchTags = this.resolved.message.getTwitchTags();
                if (twitchTags) {
                    if (!this.resolved.isSelf() && twitchTags['color']) {
                        avatarColor = twitchTags['color'];
                    }
                }
            }
 
            var displayAuthor = this.resolved.getDisplayAuthor();
            if (this.resolved.message) {
                var relayMsgParts = this.resolved.message.relayMsgParts(
                    this.resolved.message.getDisplayAuthor() || displayAuthor || nick
                );
                displayAuthor = relayMsgParts.nick;
            }
            img = img.add(this.formatter.avatar(nick, this.resolved.isSelf(), {
                color: avatarColor,
                name: displayAuthor,
                fallback: !!avatar,
                external: external
            }));
        }
        return img;
    },
    afterShow: function () {
        this.focusMessage();
    },
    focusMessage: function () {
        this.message.focus().select();
    },
    submitForm: function (e) {
        e.preventDefault();
        this.$el.hide();
        this.closed();
        this.resolved.say(this.message.val(), {
            onConfirm: _.bind(function () {
                this.opened();
                this.hide();
            }, this),
            onCancel: _.bind(function () {
                this.$el.show();
                this.opened();
                this.focusMessage();
            }, this)
        });
    },
    clickOpen: function (e) {
        this.resolved.openBuffer();
        return false;
    },
    clickInvite: function (e) {
        this.hide();
        this.resolved.connection.trigger('invitePrompt', this.resolved);
        return false;
    },
    clickIgnore: function (e) {
        this.hide();
        this.resolved.connection.trigger('ignorePrompt', this.resolved);
        return false;
    },
    clickRelayBotEnable: function (e) {
        this.hide();
        this.resolved.connection.setRelayBot(this.resolved.getName());
        return false;
    },
    clickRelayBotDisable: function (e) {
        this.hide();
        this.resolved.connection.unsetRelayBot(this.resolved.getName());
        return false;
    },
    // Prefer member so we can use the ircserver field
    clickWhois: function (e) {
        e.preventDefault();
        (this.member || this.resolved).whois();
        this.hide();
    },
    // In channels only (doesn't need to be a current member)
    clickBan: function (e) {
        if (this.buffer && this.buffer.isChannel()) {
            this.hide();
            this.buffer.trigger('banPrompt', this.resolved);
        }
        return false;
    },
    // Current channel members only
    clickKick: function (e) {
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.hide();
            this.buffer.trigger('kickPrompt', this.resolved);
        }
        return false;
    },
    clickOp: function (e) {
        e.preventDefault();
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.buffer.op(this.resolved);
        }
        this.hide();
    },
    clickDeop: function (e) {
        e.preventDefault();
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.buffer.deop(this.resolved);
        }
        this.hide();
    },
    clickVoice: function (e) {
        e.preventDefault();
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.buffer.voice(this.resolved);
        }
        this.hide();
    },
    clickDevoice: function (e) {
        e.preventDefault();
        if (this.member && this.buffer && this.buffer.isChannel()) {
            this.buffer.devoice(this.resolved);
        }
        this.hide();
    }
});


module.exports = MemberContextMenuView;


/***/ }),

/***/ "zga+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slack = __webpack_require__("K0O/");

exports.default = Backbone.View.extend({
    el: '.addSlack',
    initialize: function initialize(options) {
        this.listenTo(this.model, 'featureChange:slack', this.render);
        this.listenTo(this.model, 'stat', this.render);
        this.error = $('.addSlack__error');
        this.render();
    },
    events: {
        'click .addSlack__button': 'clickButton'
    },
    render: function render() {
        this.$el.toggleClass('addSlack--enabled', this.model.isSlackOauthAllowed());
    },
    clickButton: function clickButton(e) {
        this.hideError();
        (0, _slack.startAuth)(this.model, {
            onClose: _.bind(this.hideError, this),
            onSuccess: _.bind(function (response) {
                this.hideError();
                this.model.setFocusOnMakeServer(response.cid);
            }, this),
            onError: _.bind(function (message) {
                if (message) {
                    this.showError(message);
                } else {
                    this.hideError();
                }
            }, this)
        });
    },
    hideError: function hideError() {
        this.error.hide().text('');
    },
    showError: function showError(message) {
        this.error.text(message).show();
    }
});

/***/ })

});


// WEBPACK FOOTER //
// common-c7b74b2b.js